/**
 * @generated by @interxfi/j5-codegen - do not edit */

export type EmptyObject = Record<string, never>;

export interface ExcBanksimV1SandboxServiceCreateInboundAchPushRequest {
    achId: string;
    // format: decimal
    amount: string;
    accountId: string;
    accountNumberId: string;
    entryDescription?: string;
}

export interface ExcBanksimV1SandboxServiceCreateInboundAchPushResponse {
    // format: id62
    achId: string;
}

export interface ExcBanksimV1SandboxServiceCreateInboundWireRequest {
    wireId: string;
    // format: decimal
    amount: string;
    remittanceInfo?: string;
    accountId: string;
    accountNumberId: string;
}

export interface ExcBanksimV1SandboxServiceCreateInboundWireResponse {
    // format: id62
    wireId: string;
}

export interface ExcBanksimV1SandboxServiceRejectRequest {
    // format: id62
    transferId: string;
}

export interface ExcBanksimV1SandboxServiceReturnRequest {
    // format: id62
    transferId: string;
}

export interface ExcBanksimV1SandboxServiceReverseRequest {
    // format: id62
    transferId: string;
}

export interface ExcBanksimV1SandboxServiceSettleRequest {
    // format: id62
    transferId: string;
}

export interface ExcDtcFilesV1FileQueryServiceFileEventsResponse {
    events?: ExcDtcFilesV1FileEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcDtcFilesV1FileQueryServiceFileGetResponse {
    file: ExcDtcFilesV1FileState;
}

export interface ExcDtcFilesV1FileQueryServiceFileListResponse {
    file?: ExcDtcFilesV1FileState[];
    page?: J5ListV1PageResponse;
}

export interface ExcDtcFilesV1FileRequestQueryServiceFileRequestEventsResponse {
    events?: ExcDtcFilesV1FileRequestEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcDtcFilesV1FileRequestQueryServiceFileRequestGetResponse {
    fileRequest: ExcDtcFilesV1FileRequestState;
}

export interface ExcDtcFilesV1FileRequestQueryServiceFileRequestListResponse {
    fileRequest?: ExcDtcFilesV1FileRequestState[];
    page?: J5ListV1PageResponse;
}

export interface ExcDtccUtcV1UtcFixSessionCommandServiceConnectRequest {
    /* Session identifier */
    // format: id62
    sessionId: string;
}

export interface ExcDtccUtcV1UtcFixSessionCommandServiceConnectResponse {
    /* Updated session state */
    session: ExcDtccUtcV1UtcFixSessionState;
}

export interface ExcDtccUtcV1UtcFixSessionCommandServiceDisconnectRequest {
    /* Session identifier */
    // format: id62
    sessionId: string;
}

export interface ExcDtccUtcV1UtcFixSessionCommandServiceDisconnectResponse {
    /* Updated session state */
    session: ExcDtccUtcV1UtcFixSessionState;
}

export interface ExcDtccUtcV1UtcFixSessionCommandServiceRegisterRequest {
    /* FIX SenderCompID (tag 49) - identifies the clearing firm */
    senderCompId: string;
    /* FIX TargetCompID (tag 56) - identifies the DTCC UTC gateway */
    targetCompId: string;
    /* Session configuration including connection details */
    config: ExcDtccUtcV1UtcFixSessionConfig;
}

export interface ExcDtccUtcV1UtcFixSessionCommandServiceRegisterResponse {
    /* Created session state */
    session: ExcDtccUtcV1UtcFixSessionState;
}

export interface ExcDtccUtcV1UtcFixSessionCommandServiceResetSequenceNumbersRequest {
    /* Session identifier */
    // format: id62
    sessionId: string;
}

export interface ExcDtccUtcV1UtcFixSessionCommandServiceResetSequenceNumbersResponse {
    /* Updated session state */
    session: ExcDtccUtcV1UtcFixSessionState;
}

export interface ExcDtccUtcV1UtcFixSessionCommandServiceSetSenderSeqNumRequest {
    /* New sender sequence number to set */
    // format: INT32
    seqNum: number;
    /* Whether to request gap fill from DTCC UTC after setting
    sequence */
    requestGapFill?: boolean;
    /* Session identifier */
    // format: id62
    sessionId: string;
}

export interface ExcDtccUtcV1UtcFixSessionCommandServiceSetSenderSeqNumResponse {
    /* Updated session state */
    session: ExcDtccUtcV1UtcFixSessionState;
}

export interface ExcDtccUtcV1UtcFixSessionCommandServiceSetTargetSeqNumRequest {
    /* New target sequence number to set */
    // format: INT32
    seqNum: number;
    /* Session identifier */
    // format: id62
    sessionId: string;
}

export interface ExcDtccUtcV1UtcFixSessionCommandServiceSetTargetSeqNumResponse {
    /* Updated session state */
    session: ExcDtccUtcV1UtcFixSessionState;
}

export interface ExcDtccUtcV1UtcFixSessionCommandServiceUpdateConfigRequest {
    /* Updated session configuration */
    config: ExcDtccUtcV1UtcFixSessionConfig;
    /* Session identifier */
    // format: id62
    sessionId: string;
}

export interface ExcDtccUtcV1UtcFixSessionCommandServiceUpdateConfigResponse {
    /* Updated session state */
    session: ExcDtccUtcV1UtcFixSessionState;
}

export interface ExcDtccUtcV1UtcFixSessionQueryServiceUtcFixSessionEventsResponse {
    events?: ExcDtccUtcV1UtcFixSessionEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcDtccUtcV1UtcFixSessionQueryServiceUtcFixSessionGetResponse {
    utcFixSession: ExcDtccUtcV1UtcFixSessionState;
}

export interface ExcDtccUtcV1UtcFixSessionQueryServiceUtcFixSessionListResponse {
    utcFixSession?: ExcDtccUtcV1UtcFixSessionState[];
    page?: J5ListV1PageResponse;
}

export interface ExcIceCorpactionsV1ActionQueryServiceActionEventsResponse {
    events?: ExcIceCorpactionsV1ActionEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcIceCorpactionsV1ActionQueryServiceActionGetResponse {
    action: ExcIceCorpactionsV1ActionState;
}

export interface ExcIceCorpactionsV1ActionQueryServiceActionListResponse {
    action?: ExcIceCorpactionsV1ActionState[];
    page?: J5ListV1PageResponse;
}

export interface ExcIceGsmV1InstrumentCommandServiceGetInstrumentXmlResponse {
    /* The raw XML of the instrument element */
    xml: string;
}

export interface ExcIceGsmV1InstrumentCommandServiceLinkAssetRequest {
    /* An existing asset to link to. If not provided, a new asset will be created. */
    // format: id62
    assetId?: string;
    // format: informal
    instrumentId: string;
}

export interface ExcIceGsmV1InstrumentCommandServiceLinkAssetResponse {
    instrument: ExcIceGsmV1InstrumentState;
}

export interface ExcIceGsmV1InstrumentCommandServiceReparseRequest {
    // format: informal
    instrumentId: string;
}

export interface ExcIceGsmV1InstrumentCommandServiceReparseResponse {
    instrument: ExcIceGsmV1InstrumentState;
}

export interface ExcIceGsmV1InstrumentCommandServiceUnlinkAssetRequest {
    // format: informal
    instrumentId: string;
}

export interface ExcIceGsmV1InstrumentCommandServiceUnlinkAssetResponse {
    instrument: ExcIceGsmV1InstrumentState;
}

export interface ExcIceGsmV1InstrumentQueryServiceInstrumentEventsResponse {
    events?: ExcIceGsmV1InstrumentEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcIceGsmV1InstrumentQueryServiceInstrumentGetResponse {
    instrument: ExcIceGsmV1InstrumentState;
}

export interface ExcIceGsmV1InstrumentQueryServiceInstrumentListResponse {
    instrument?: ExcIceGsmV1InstrumentState[];
    page?: J5ListV1PageResponse;
}

export interface ExcIceGsmV1InstrumentSummaryCommandServiceInstrumentRepublishSummariesRequest {
    /* Republish only the named summaries. If empty, all summaries are republished */
    summaries?: ExcIceGsmV1InstrumentSummaryName[];
    /* The number of entities to read at once for republishing */
    // format: UINT64
    batchSize?: string;
}

export interface ExcIceGsmV1InstrumentSummaryCommandServiceInstrumentRepublishSummariesResponse {
    /* The number of states read */
    // format: INT64
    count?: string;
}

export interface ExcIceJobV1JobCommandServiceCancelRequest {
    // format: id62
    jobId: string;
}

export interface ExcIceJobV1JobCommandServiceCancelResponse {
    job: ExcIceJobV1JobState;
}

export interface ExcIceJobV1JobCommandServiceCreateRequest {
    /* Assigned when unset */
    // format: id62
    jobId?: string;
    /* Rejected for a file job, which its upload creates */
    spec: ExcIceJobV1JobSpec;
}

export interface ExcIceJobV1JobCommandServiceCreateResponse {
    job: ExcIceJobV1JobState;
}

export interface ExcIceJobV1JobQueryServiceJobEventsResponse {
    events?: ExcIceJobV1JobEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcIceJobV1JobQueryServiceJobGetResponse {
    job: ExcIceJobV1JobState;
}

export interface ExcIceJobV1JobQueryServiceJobListResponse {
    job?: ExcIceJobV1JobState[];
    page?: J5ListV1PageResponse;
}

export interface ExcIceJobV1TaskCommandServiceGetTaskXmlResponse {
    xml: string;
}

export interface ExcIceJobV1TaskQueryServiceTaskEventsResponse {
    events?: ExcIceJobV1TaskEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcIceJobV1TaskQueryServiceTaskGetResponse {
    task: ExcIceJobV1TaskState;
}

export interface ExcIceJobV1TaskQueryServiceTaskListResponse {
    task?: ExcIceJobV1TaskState[];
    page?: J5ListV1PageResponse;
}

export interface ExcIncreaseV1AccountNumberCommandServiceSyncAccountNumberRequest {
    // format: id62
    accountNumberId: string;
}

export interface ExcIncreaseV1AccountNumberQueryServiceAccountNumberEventsResponse {
    events?: ExcIncreaseV1AccountNumberEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcIncreaseV1AccountNumberQueryServiceAccountNumberGetResponse {
    accountNumber: ExcIncreaseV1AccountNumberState;
}

export interface ExcIncreaseV1AccountNumberQueryServiceAccountNumberListResponse {
    accountNumber?: ExcIncreaseV1AccountNumberState[];
    page?: J5ListV1PageResponse;
}

export interface ExcIncreaseV1AchCommandServiceSyncAchRequest {
    // format: id62
    achId: string;
}

export interface ExcIncreaseV1AchQueryServiceAchEventsResponse {
    events?: ExcIncreaseV1AchEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcIncreaseV1AchQueryServiceAchGetResponse {
    ach: ExcIncreaseV1AchState;
}

export interface ExcIncreaseV1AchQueryServiceAchListResponse {
    ach?: ExcIncreaseV1AchState[];
    page?: J5ListV1PageResponse;
}

export interface ExcIncreaseV1WireCommandServiceSyncWireRequest {
    // format: id62
    wireId: string;
}

export interface ExcIncreaseV1WireQueryServiceWireEventsResponse {
    events?: ExcIncreaseV1WireEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcIncreaseV1WireQueryServiceWireGetResponse {
    wire: ExcIncreaseV1WireState;
}

export interface ExcIncreaseV1WireQueryServiceWireListResponse {
    wire?: ExcIncreaseV1WireState[];
    page?: J5ListV1PageResponse;
}

export interface ExcJaneStreetV1PfofJobQueryServicePfofJobEventsResponse {
    events?: ExcJaneStreetV1PfofJobEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcJaneStreetV1PfofJobQueryServicePfofJobGetResponse {
    pfofJob: ExcJaneStreetV1PfofJobState;
}

export interface ExcJaneStreetV1PfofJobQueryServicePfofJobListResponse {
    pfofJob?: ExcJaneStreetV1PfofJobState[];
    page?: J5ListV1PageResponse;
}

export interface ExcJpmamEmulatorV1PositionServiceGetPositionsResponse {
    positions: ExcJpmamEmulatorV1Position[];
}

export interface ExcJpmamEmulatorV1PositionServiceSetPositionRequest {
    // format: decimal
    shares: string;
    /* The day, before today, whose closing position this is; defaults to now */
    // format: YYYY-MM-DD
    asOfDate?: string;
    /* The JP Morgan account the emulator reports for */
    accountId: string;
    cusip: string;
}

export interface ExcJpmamEmulatorV1PositionServiceSetPositionResponse {
    position: ExcJpmamEmulatorV1Position;
    /* The instant the position takes effect from */
    // format: date-time
    effectiveAt: string;
    /* Reported days whose stats changed */
    // format: YYYY-MM-DD
    restatedDates: string[];
}

export interface ExcJpmamV1DestinationCommandServiceCreateDestinationRequest {
    // format: id62
    destinationId?: string;
    spec: ExcJpmamV1DestinationSpec;
}

export interface ExcJpmamV1DestinationCommandServiceCreateDestinationResponse {
    destination: ExcJpmamV1DestinationState;
}

export interface ExcJpmamV1DestinationCommandServiceUpdateDestinationRequest {
    spec: ExcJpmamV1DestinationSpec;
    // format: id62
    destinationId: string;
}

export interface ExcJpmamV1DestinationCommandServiceUpdateDestinationResponse {
    destination: ExcJpmamV1DestinationState;
}

export interface ExcJpmamV1DestinationQueryServiceDestinationEventsResponse {
    events?: ExcJpmamV1DestinationEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcJpmamV1DestinationQueryServiceDestinationGetResponse {
    destination: ExcJpmamV1DestinationState;
}

export interface ExcJpmamV1DestinationQueryServiceDestinationListResponse {
    destination?: ExcJpmamV1DestinationState[];
    page?: J5ListV1PageResponse;
}

export interface ExcJpmamV1JpmamJobQueryServiceJpmamJobEventsResponse {
    events?: ExcJpmamV1JpmamJobEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcJpmamV1JpmamJobQueryServiceJpmamJobGetResponse {
    jpmamJob: ExcJpmamV1JpmamJobState;
}

export interface ExcJpmamV1JpmamJobQueryServiceJpmamJobListResponse {
    jpmamJob?: ExcJpmamV1JpmamJobState[];
    page?: J5ListV1PageResponse;
}

export interface ExcJpmamV1JpmamOrderCommandServiceCancelRequest {
    /* The reason for canceling the order */
    reason: string;
    // format: id62
    orderId: string;
}

export interface ExcJpmamV1JpmamOrderCommandServiceCancelResponse {
    jpmamOrder: ExcJpmamV1JpmamOrderState;
}

export interface ExcJpmamV1JpmamOrderCommandServiceManuallyRecoverRequest {
    /* The trade date for the order, formatted as YYYY-MM-DD. */
    // pattern: ^[0-9]{4}-[0-9]{2}-[0-9]{2}$
    tradeDate: string;
    /* The confirmed NAV. Defaults to 1 for a fund declared
    stable-NAV; required for any other fund. */
    // format: decimal
    nav?: string;
    /* The share count JPM reported for the net order */
    // format: decimal
    shares?: string;
    /* The dollar amount JPM reported. Required to recover a SHARES
    net order, whose payment reads confirmedAmount. */
    // format: decimal
    amount?: string;
    /* The settlement date; required when the NetOrder still needs
    to be settled. */
    // pattern: ^[0-9]{4}-[0-9]{2}-[0-9]{2}$
    settlementDate?: string;
    /* When true (the default for recovery), the POSTED -> CONFIRMED
    transition will not emit a JpmamSendPaymentMessage, because
    payment was handled out-of-band. */
    skipPayment?: boolean;
    /* The NetOrder to recover. */
    // format: id62, entity: exc.jpmam.v1.NetOrder
    netOrderId: string;
}

export interface ExcJpmamV1JpmamOrderCommandServiceManuallyRecoverResponse {
    /* The recovered NetOrder */
    // format: id62
    netOrderId: string;
}

export interface ExcJpmamV1JpmamOrderCommandServicePendingOrdersProcessRequest {
    type?: ExcJpmamV1ProcessType;
    /* An opaque grouping identifier to select which pending
    NetOrder to process. If not provided and there is only one
    pending NetOrder, that NetOrder will be processed.  If not
    provided and there are multiple pending NetOrders, an error
    will be returned. */
    // format: informal
    groupingId?: string;
    /* The asset to select which pending NetOrder to process. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
}

export interface ExcJpmamV1JpmamOrderCommandServicePendingOrdersProcessResponse {
    /* The ID of the net order that was processed, if any */
    // format: id62
    netOrderId?: string;
    /* The number of orders being processed in the net order */
    // format: UINT32
    totalOrderIds?: number;
    /* The grouping identifier that was processed */
    // format: informal
    groupingId: string;
}

export interface ExcJpmamV1JpmamOrderQueryServiceJpmamOrderEventsResponse {
    events?: ExcJpmamV1JpmamOrderEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcJpmamV1JpmamOrderQueryServiceJpmamOrderGetResponse {
    jpmamOrder: ExcJpmamV1JpmamOrderState;
}

export interface ExcJpmamV1JpmamOrderQueryServiceJpmamOrderListResponse {
    jpmamOrder?: ExcJpmamV1JpmamOrderState[];
    page?: J5ListV1PageResponse;
}

export interface ExcJpmamV1JpmamTaskQueryServiceJpmamTaskEventsResponse {
    events?: ExcJpmamV1JpmamTaskEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcJpmamV1JpmamTaskQueryServiceJpmamTaskGetResponse {
    jpmamTask: ExcJpmamV1JpmamTaskState;
}

export interface ExcJpmamV1JpmamTaskQueryServiceJpmamTaskListResponse {
    jpmamTask?: ExcJpmamV1JpmamTaskState[];
    page?: J5ListV1PageResponse;
}

export interface ExcJpmamV1NetOrderQueryServiceNetOrderEventsResponse {
    events?: ExcJpmamV1NetOrderEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcJpmamV1NetOrderQueryServiceNetOrderGetResponse {
    netOrder: ExcJpmamV1NetOrderState;
}

export interface ExcJpmamV1NetOrderQueryServiceNetOrderListResponse {
    netOrder?: ExcJpmamV1NetOrderState[];
    page?: J5ListV1PageResponse;
}

export interface ExcMarketdataV1MarketDataServiceGetBasicFinancialsBySymbolResponse {
    /* The 5 most recent periods, ascending by endDate. */
    reports: ExcMarketdataV1FinancialReport[];
}

export interface ExcMarketdataV1MarketDataServiceGetCompanyBySymbolResponse {
    company: ExcMarketdataV1CompanyProfile;
}

export interface ExcMarketdataV1MarketDataServiceGetCompanyFilingsResponse {
    /* Newest first. */
    filings: ExcMarketdataV1Filing[];
    /* Total records matching the query across all pages. */
    // format: UINT32
    totalCount?: number;
    page?: J5ListV1PageResponse;
}

export interface ExcMarketdataV1MarketDataServiceGetEnhancedChartDataResponse {
    /* Points in ascending time order. */
    points: ExcMarketdataV1ChartPoint[];
}

export interface ExcMarketdataV1MarketDataServiceGetEnhancedEarningsResponse {
    /* The 4 most recent reported quarters, ascending by quarterEnd. */
    quarters: ExcMarketdataV1EarningsQuarter[];
}

export interface ExcMarketdataV1MarketDataServiceGetEnhancedQuoteResponse {
    quote: ExcMarketdataV1Quote;
}

export interface ExcMarketdataV1MarketDataServiceGetHeadlinesResponse {
    items: ExcMarketdataV1NewsItem[];
}

export interface ExcPlaidV1ProcessorTokenCommandServiceSyncTokenRequest {
    // format: id62
    processorTokenId: string;
}

export interface ExcPlaidV1ProcessorTokenQueryServiceProcessorTokenEventsResponse {
    events?: ExcPlaidV1ProcessorTokenEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcPlaidV1ProcessorTokenQueryServiceProcessorTokenGetResponse {
    processorToken: ExcPlaidV1ProcessorTokenState;
}

export interface ExcPlaidV1ProcessorTokenQueryServiceProcessorTokenListResponse {
    processorToken?: ExcPlaidV1ProcessorTokenState[];
    page?: J5ListV1PageResponse;
}

export interface ExcQuotemediaV1EodPriceJobQueryServiceEodPriceJobEventsResponse {
    events?: ExcQuotemediaV1EodPriceJobEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcQuotemediaV1EodPriceJobQueryServiceEodPriceJobGetResponse {
    eodPriceJob: ExcQuotemediaV1EodPriceJobState;
}

export interface ExcQuotemediaV1EodPriceJobQueryServiceEodPriceJobListResponse {
    eodPriceJob?: ExcQuotemediaV1EodPriceJobState[];
    page?: J5ListV1PageResponse;
}

export interface ExcQuotemediaV1EodPriceTaskQueryServiceEodPriceTaskEventsResponse {
    events?: ExcQuotemediaV1EodPriceTaskEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcQuotemediaV1EodPriceTaskQueryServiceEodPriceTaskGetResponse {
    eodPriceTask: ExcQuotemediaV1EodPriceTaskState;
}

export interface ExcQuotemediaV1EodPriceTaskQueryServiceEodPriceTaskListResponse {
    eodPriceTask?: ExcQuotemediaV1EodPriceTaskState[];
    page?: J5ListV1PageResponse;
}

export interface ExcQuotemediaV1Sp500ListQueryServiceSp500ListEventsResponse {
    events?: ExcQuotemediaV1Sp500ListEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcQuotemediaV1Sp500ListQueryServiceSp500ListGetResponse {
    sp500List: ExcQuotemediaV1Sp500ListState;
}

export interface ExcQuotemediaV1Sp500ListQueryServiceSp500ListListResponse {
    sp500List?: ExcQuotemediaV1Sp500ListState[];
    page?: J5ListV1PageResponse;
}

export interface ExcQuotemediaV1Sp500ListSummaryCommandServiceSp500ListRepublishSummariesRequest {
    /* Republish only the named summaries. If empty, all summaries are republished */
    summaries?: ExcQuotemediaV1Sp500ListSummaryName[];
    /* The number of entities to read at once for republishing */
    // format: UINT64
    batchSize?: string;
}

export interface ExcQuotemediaV1Sp500ListSummaryCommandServiceSp500ListRepublishSummariesResponse {
    /* The number of states read */
    // format: INT64
    count?: string;
}

export interface ExcRouteV1FixMessageQueryServiceFixMessageEventsResponse {
    events?: ExcRouteV1FixMessageEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcRouteV1FixMessageQueryServiceFixMessageGetResponse {
    fixMessage: ExcRouteV1FixMessageState;
}

export interface ExcRouteV1FixMessageQueryServiceFixMessageListResponse {
    fixMessage?: ExcRouteV1FixMessageState[];
    page?: J5ListV1PageResponse;
}

export interface ExcRouteV1FixOrderQueryServiceFixOrderEventsResponse {
    events?: ExcRouteV1FixOrderEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcRouteV1FixOrderQueryServiceFixOrderGetResponse {
    fixOrder: ExcRouteV1FixOrderState;
}

export interface ExcRouteV1FixOrderQueryServiceFixOrderListResponse {
    fixOrder?: ExcRouteV1FixOrderState[];
    page?: J5ListV1PageResponse;
}

export interface ExcRouteV1FixSessionCommandServiceConnectRequest {
    // format: id62
    sessionId: string;
}

export interface ExcRouteV1FixSessionCommandServiceConnectResponse {
    session: ExcRouteV1FixSessionState;
}

export interface ExcRouteV1FixSessionCommandServiceDisconnectRequest {
    // format: id62
    sessionId: string;
}

export interface ExcRouteV1FixSessionCommandServiceDisconnectResponse {
    session: ExcRouteV1FixSessionState;
}

export interface ExcRouteV1FixSessionCommandServiceRegisterRequest {
    senderCompId: string;
    senderSubId?: string;
    targetCompId: string;
    targetSubId?: string;
    config: ExcRouteV1FixSessionConfig;
}

export interface ExcRouteV1FixSessionCommandServiceRegisterResponse {
    session: ExcRouteV1FixSessionState;
}

export interface ExcRouteV1FixSessionCommandServiceResetSequenceNumbersRequest {
    // format: id62
    sessionId: string;
}

export interface ExcRouteV1FixSessionCommandServiceResetSequenceNumbersResponse {
    session: ExcRouteV1FixSessionState;
}

export interface ExcRouteV1FixSessionCommandServiceSetSenderSeqNumRequest {
    // format: INT32
    seqNum: number;
    requestGapFill?: boolean;
    // format: id62
    sessionId: string;
}

export interface ExcRouteV1FixSessionCommandServiceSetSenderSeqNumResponse {
    session: ExcRouteV1FixSessionState;
}

export interface ExcRouteV1FixSessionCommandServiceSetTargetSeqNumRequest {
    // format: INT32
    seqNum: number;
    // format: id62
    sessionId: string;
}

export interface ExcRouteV1FixSessionCommandServiceSetTargetSeqNumResponse {
    session: ExcRouteV1FixSessionState;
}

export interface ExcRouteV1FixSessionCommandServiceUpdateConfigRequest {
    config: ExcRouteV1FixSessionConfig;
    // format: id62
    sessionId: string;
}

export interface ExcRouteV1FixSessionCommandServiceUpdateConfigResponse {
    session: ExcRouteV1FixSessionState;
}

export interface ExcRouteV1FixSessionQueryServiceFixSessionEventsResponse {
    events?: ExcRouteV1FixSessionEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcRouteV1FixSessionQueryServiceFixSessionGetResponse {
    fixSession: ExcRouteV1FixSessionState;
}

export interface ExcRouteV1FixSessionQueryServiceFixSessionListResponse {
    fixSession?: ExcRouteV1FixSessionState[];
    page?: J5ListV1PageResponse;
}

export interface ExcRouteV1RoutingRuleCommandServiceCreateRequest {
    // format: INT32
    priority: number;
    filter: ExcRouteV1RoutingFilter;
    destinations?: ExcRouteV1RoutingDestination[];
    failoverBehavior: ExcRouteV1FailoverBehavior;
}

export interface ExcRouteV1RoutingRuleCommandServiceCreateResponse {
    rule: ExcRouteV1RoutingRuleState;
}

export interface ExcRouteV1RoutingRuleCommandServiceDisableRequest {
    // format: id62
    ruleId: string;
}

export interface ExcRouteV1RoutingRuleCommandServiceDisableResponse {
    rule: ExcRouteV1RoutingRuleState;
}

export interface ExcRouteV1RoutingRuleCommandServiceEnableRequest {
    // format: id62
    ruleId: string;
}

export interface ExcRouteV1RoutingRuleCommandServiceEnableResponse {
    rule: ExcRouteV1RoutingRuleState;
}

export interface ExcRouteV1RoutingRuleCommandServiceUpdateRequest {
    // format: INT32
    priority: number;
    filter: ExcRouteV1RoutingFilter;
    destinations?: ExcRouteV1RoutingDestination[];
    failoverBehavior: ExcRouteV1FailoverBehavior;
    // format: id62
    ruleId: string;
}

export interface ExcRouteV1RoutingRuleCommandServiceUpdateResponse {
    rule: ExcRouteV1RoutingRuleState;
}

export interface ExcRouteV1RoutingRuleQueryServiceRoutingRuleEventsResponse {
    events?: ExcRouteV1RoutingRuleEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExcRouteV1RoutingRuleQueryServiceRoutingRuleGetResponse {
    routingRule: ExcRouteV1RoutingRuleState;
}

export interface ExcRouteV1RoutingRuleQueryServiceRoutingRuleListResponse {
    routingRule?: ExcRouteV1RoutingRuleState[];
    page?: J5ListV1PageResponse;
}

export interface ExfOfacEmulatorV1OfacEmulatorCommandServiceCreateEmulatedOfacRequest {
    // format: id62
    ofacEmulatorId: string;
    spec: ExfOfacEmulatorV1OfacEmulatorSpec;
}

export interface ExfOfacEmulatorV1OfacEmulatorCommandServiceCreateEmulatedOfacResponse {
    ofac?: ExfOfacEmulatorV1OfacEmulatorState;
}

export interface ExfOfacEmulatorV1OfacEmulatorQueryServiceOfacEmulatorEventsResponse {
    events?: ExfOfacEmulatorV1OfacEmulatorEvent[];
    page?: J5ListV1PageResponse;
}

export interface ExfOfacEmulatorV1OfacEmulatorQueryServiceOfacEmulatorGetResponse {
    ofacEmulator: ExfOfacEmulatorV1OfacEmulatorState;
}

export interface ExfOfacEmulatorV1OfacEmulatorQueryServiceOfacEmulatorListResponse {
    ofacEmulator?: ExfOfacEmulatorV1OfacEmulatorState[];
    page?: J5ListV1PageResponse;
}

export interface IxcAssetsClearingV1AssetsServiceAssetBackfillEodPriceRequest {
    /* First date of the range, inclusive. */
    // format: YYYY-MM-DD
    startDate: string;
    /* Last date of the range, inclusive. */
    // format: YYYY-MM-DD
    endDate: string;
    // format: id62
    assetId: string;
}

export interface IxcAssetsClearingV1MoneyMarketInternalStatsQueryServiceMoneyMarketInternalStatsEventsResponse {
    events?: IxcAssetsClearingV1MoneyMarketInternalStatsEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcAssetsClearingV1MoneyMarketInternalStatsQueryServiceMoneyMarketInternalStatsGetResponse {
    moneyMarketInternalStats: IxcAssetsClearingV1MoneyMarketInternalStatsState;
}

export interface IxcAssetsClearingV1MoneyMarketInternalStatsQueryServiceMoneyMarketInternalStatsListResponse {
    moneyMarketInternalStats?: IxcAssetsClearingV1MoneyMarketInternalStatsState[];
    page?: J5ListV1PageResponse;
}

export interface IxcAssetsV1AssetCommandServiceAssetArchiveRequest {
    // format: id62
    assetId: string;
}

export interface IxcAssetsV1AssetCommandServiceAssetArchiveResponse {
    asset: IxcAssetsV1AssetState;
}

export interface IxcAssetsV1AssetCommandServiceAssetCreateRequest {
    /* When provided, used as the asset ID to enable idempotent
    creation. If not provided, one will be generated. */
    // format: id62
    assetId?: string;
    type: IxcAssetsV1AssetType;
    category?: IxcAssetsV1AssetCategory;
    // format: INT32
    decimalPrecision?: number;
    fixedPrecision?: boolean;
}

export interface IxcAssetsV1AssetCommandServiceAssetCreateResponse {
    asset: IxcAssetsV1AssetState;
}

export interface IxcAssetsV1AssetCommandServiceAssetUpdateRequest {
    type: IxcAssetsV1AssetType;
    category?: IxcAssetsV1AssetCategory;
    // format: INT32
    decimalPrecision?: number;
    fixedPrecision?: boolean;
    // format: id62
    assetId: string;
}

export interface IxcAssetsV1AssetCommandServiceAssetUpdateResponse {
    asset: IxcAssetsV1AssetState;
}

export interface IxcAssetsV1AssetCommandServiceUploadLogoRequest {
    /* The base64-encoded SVG file */
    // bytes (base64-encoded)
    file: string;
    /* The asset ID of the logo to upload */
    // format: id62
    assetId: string;
}

export interface IxcAssetsV1AssetCommandServiceUploadLogoResponse {
    /* The asset ID of the logo uploaded */
    // format: id62
    assetId: string;
}

export interface IxcAssetsV1AssetExceptionCommandServiceAssetExceptionArchiveRequest {
    // format: id62
    assetExceptionId: string;
}

export interface IxcAssetsV1AssetExceptionCommandServiceAssetExceptionArchiveResponse {
    /* The archived asset exception state */
    assetException: IxcAssetsV1AssetExceptionState;
}

export interface IxcAssetsV1AssetExceptionCommandServiceAssetExceptionCreateRequest {
    /* When provided, used as the asset exception ID to enable
    idempotent creation. If not provided, one will be generated. */
    // format: id62
    assetExceptionId?: string;
    /* The name of the asset exception */
    name: string;
    /* The date the assets deviate on */
    // format: YYYY-MM-DD
    date: string;
    /* The assets deviating on the date, each with its own day */
    assets: IxcAssetsV1AssetDayException[];
}

export interface IxcAssetsV1AssetExceptionCommandServiceAssetExceptionCreateResponse {
    /* The created asset exception state */
    assetException: IxcAssetsV1AssetExceptionState;
}

export interface IxcAssetsV1AssetExceptionCommandServiceAssetExceptionUpdateRequest {
    /* The name of the asset exception */
    name: string;
    /* The date the assets deviate on */
    // format: YYYY-MM-DD
    date: string;
    /* The assets deviating on the date, each with its own day */
    assets: IxcAssetsV1AssetDayException[];
    // format: id62
    assetExceptionId: string;
}

export interface IxcAssetsV1AssetExceptionCommandServiceAssetExceptionUpdateResponse {
    /* The updated asset exception state */
    assetException: IxcAssetsV1AssetExceptionState;
}

export interface IxcAssetsV1AssetExceptionQueryServiceAssetExceptionEventsResponse {
    events?: IxcAssetsV1AssetExceptionEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcAssetsV1AssetExceptionQueryServiceAssetExceptionGetResponse {
    assetException: IxcAssetsV1AssetExceptionState;
}

export interface IxcAssetsV1AssetExceptionQueryServiceAssetExceptionListResponse {
    assetException?: IxcAssetsV1AssetExceptionState[];
    page?: J5ListV1PageResponse;
}

export interface IxcAssetsV1AssetExceptionSummaryCommandServiceAssetExceptionRepublishSummariesRequest {
    /* Republish only the named summaries. If empty, all summaries are republished */
    summaries?: IxcAssetsV1AssetExceptionSummaryName[];
    /* The number of entities to read at once for republishing */
    // format: UINT64
    batchSize?: string;
}

export interface IxcAssetsV1AssetExceptionSummaryCommandServiceAssetExceptionRepublishSummariesResponse {
    /* The number of states read */
    // format: INT64
    count?: string;
}

export interface IxcAssetsV1AssetQueryServiceAssetEventsResponse {
    events?: IxcAssetsV1AssetEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcAssetsV1AssetQueryServiceAssetGetResponse {
    asset: IxcAssetsV1AssetState;
}

export interface IxcAssetsV1AssetQueryServiceAssetListResponse {
    asset?: IxcAssetsV1AssetState[];
    page?: J5ListV1PageResponse;
}

export interface IxcAssetsV1EodPriceQueryServiceEodPriceEventsResponse {
    events?: IxcAssetsV1EodPriceEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcAssetsV1EodPriceQueryServiceEodPriceGetResponse {
    eodPrice: IxcAssetsV1EodPriceState;
}

export interface IxcAssetsV1EodPriceQueryServiceEodPriceListResponse {
    eodPrice?: IxcAssetsV1EodPriceState[];
    page?: J5ListV1PageResponse;
}

export interface IxcAssetsV1MoneyMarketStatsQueryServiceMoneyMarketStatsEventsResponse {
    events?: IxcAssetsV1MoneyMarketStatsEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcAssetsV1MoneyMarketStatsQueryServiceMoneyMarketStatsGetResponse {
    moneyMarketStats: IxcAssetsV1MoneyMarketStatsState;
}

export interface IxcAssetsV1MoneyMarketStatsQueryServiceMoneyMarketStatsListResponse {
    moneyMarketStats?: IxcAssetsV1MoneyMarketStatsState[];
    page?: J5ListV1PageResponse;
}

export interface IxcBillingV1ChargeCommandServiceChargeCreateRequest {
    /* The customer brokerage account to debit */
    // format: id62
    accountId: string;
    spec: IxcBillingV1ChargeSpec;
}

export interface IxcBillingV1ChargeCommandServiceChargeCreateResponse {
    charge: IxcBillingV1ChargeState;
}

export interface IxcBillingV1ChargeQueryServiceChargeEventsResponse {
    events?: IxcBillingV1ChargeEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcBillingV1ChargeQueryServiceChargeGetResponse {
    charge: IxcBillingV1ChargeState;
}

export interface IxcBillingV1ChargeQueryServiceChargeListResponse {
    charge?: IxcBillingV1ChargeState[];
    page?: J5ListV1PageResponse;
}

export interface IxcCasesV1CaseCommandServiceCreateCaseRequest {
    // format: id62
    caseId?: string;
    // format: id62
    groupId?: string;
    // format: id62
    programId?: string;
    subject: IxcCasesV1EntityRef;
    title: string;
    description: string;
    // format: id62
    assignee?: string;
}

export interface IxcCasesV1CaseCommandServiceCreateCaseResponse {
    case: IxcCasesV1CaseState;
}

export interface IxcCasesV1CaseCommandServiceUpdateCaseRequest {
    update: IxcCasesV1CaseUpdate;
    // format: id62
    caseId: string;
}

export interface IxcCasesV1CaseCommandServiceUpdateCaseResponse {
    case: IxcCasesV1CaseState;
}

export interface IxcCasesV1CaseQueryServiceCaseEventsResponse {
    events?: IxcCasesV1CaseEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcCasesV1CaseQueryServiceCaseGetResponse {
    case: IxcCasesV1CaseState;
}

export interface IxcCasesV1CaseQueryServiceCaseListResponse {
    case?: IxcCasesV1CaseState[];
    page?: J5ListV1PageResponse;
}

export interface IxcClearingV1ClosingPositionQueryServiceClosingPositionEventsResponse {
    events?: IxcClearingV1ClosingPositionEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcClearingV1ClosingPositionQueryServiceClosingPositionGetResponse {
    closingPosition: IxcClearingV1ClosingPositionState;
}

export interface IxcClearingV1ClosingPositionQueryServiceClosingPositionListResponse {
    closingPosition?: IxcClearingV1ClosingPositionState[];
    page?: J5ListV1PageResponse;
}

export interface IxcCorpactionsCaadminV1ActionQueryServiceActionEventsResponse {
    events?: IxcCorpactionsCaadminV1ActionEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcCorpactionsCaadminV1ActionQueryServiceActionGetResponse {
    action: IxcCorpactionsCaadminV1ActionState;
}

export interface IxcCorpactionsCaadminV1ActionQueryServiceActionListResponse {
    action?: IxcCorpactionsCaadminV1ActionState[];
    page?: J5ListV1PageResponse;
}

export interface IxcCorpactionsCaadminV1ManualOverrideCommandServiceApproveRequest {
    /* must match candidateVersion.versionId */
    // format: id62
    versionId: string;
    // format: id62
    actionId: string;
}

export interface IxcCorpactionsCaadminV1ManualOverrideCommandServiceApproveResponse {
    action: IxcCorpactionsCaadminV1ActionState;
}

export interface IxcCorpactionsCaadminV1ManualOverrideCommandServiceCreateManualRequest {
    // format: id62
    assetId: string;
    spec?: IxcCorpactionsCaadminV1ManualOverride;
}

export interface IxcCorpactionsCaadminV1ManualOverrideCommandServiceCreateManualResponse {
    action: IxcCorpactionsCaadminV1ActionState;
}

export interface IxcCorpactionsCaadminV1ManualOverrideCommandServiceManualDefaultResponse {
    spec?: IxcCorpactionsCaadminV1ManualOverride;
    // format: id62
    actionId: string;
    // format: id62
    versionId: string;
}

export interface IxcCorpactionsCaadminV1ManualOverrideCommandServiceManualPreviewRequest {
    /* must match candidateVersion.versionId */
    // format: id62
    versionId: string;
    spec?: IxcCorpactionsCaadminV1ManualOverride;
    // format: id62
    actionId: string;
}

export interface IxcCorpactionsCaadminV1ManualOverrideCommandServiceManualPreviewResponse {
    candidate?: IxcCorpactionsCaadminV1VersionCandidate;
}

export interface IxcCorpactionsCaadminV1ManualOverrideCommandServiceRetractRequest {
    // format: id62
    actionId: string;
}

export interface IxcCorpactionsCaadminV1ManualOverrideCommandServiceRetractResponse {
    action: IxcCorpactionsCaadminV1ActionState;
}

export interface IxcCorpactionsCaadminV1ManualOverrideCommandServiceUpdateManualOverrideRequest {
    // format: id62
    assetId: string;
    spec: IxcCorpactionsCaadminV1ManualOverride;
    // format: id62
    actionId: string;
}

export interface IxcCorpactionsCaadminV1ManualOverrideCommandServiceUpdateManualOverrideResponse {
    action: IxcCorpactionsCaadminV1ActionState;
}

export interface IxcCorpactionsCaadminV1PaymentQueryServicePaymentEventsResponse {
    events?: IxcCorpactionsCaadminV1PaymentEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcCorpactionsCaadminV1PaymentQueryServicePaymentGetResponse {
    payment: IxcCorpactionsCaadminV1PaymentState;
}

export interface IxcCorpactionsCaadminV1PaymentQueryServicePaymentListResponse {
    payment?: IxcCorpactionsCaadminV1PaymentState[];
    page?: J5ListV1PageResponse;
}

export interface IxcCostbasisV1RealizationQueryServiceRealizationEventsResponse {
    events?: IxcCostbasisV1RealizationEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcCostbasisV1RealizationQueryServiceRealizationGetResponse {
    realization: IxcCostbasisV1RealizationState;
}

export interface IxcCostbasisV1RealizationQueryServiceRealizationListResponse {
    realization?: IxcCostbasisV1RealizationState[];
    page?: J5ListV1PageResponse;
}

export interface IxcCostbasisV1TaxLotQueryServiceTaxLotEventsResponse {
    events?: IxcCostbasisV1TaxLotEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcCostbasisV1TaxLotQueryServiceTaxLotGetResponse {
    taxLot: IxcCostbasisV1TaxLotState;
}

export interface IxcCostbasisV1TaxLotQueryServiceTaxLotListResponse {
    taxLot?: IxcCostbasisV1TaxLotState[];
    page?: J5ListV1PageResponse;
}

export interface IxcDtccCnsV1AssetDayQueryServiceAssetDayEventsResponse {
    events?: IxcDtccCnsV1AssetDayEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcDtccCnsV1AssetDayQueryServiceAssetDayGetResponse {
    assetDay: IxcDtccCnsV1AssetDayState;
}

export interface IxcDtccCnsV1AssetDayQueryServiceAssetDayListResponse {
    assetDay?: IxcDtccCnsV1AssetDayState[];
    page?: J5ListV1PageResponse;
}

export interface IxcDtccDrecoV1AssetQueryServiceAssetEventsResponse {
    events?: IxcDtccDrecoV1AssetEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcDtccDrecoV1AssetQueryServiceAssetGetResponse {
    asset: IxcDtccDrecoV1AssetState;
}

export interface IxcDtccDrecoV1AssetQueryServiceAssetListResponse {
    asset?: IxcDtccDrecoV1AssetState[];
    page?: J5ListV1PageResponse;
}

export interface IxcDtccDtcV1AssetDayQueryServiceAssetDayEventsResponse {
    events?: IxcDtccDtcV1AssetDayEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcDtccDtcV1AssetDayQueryServiceAssetDayGetResponse {
    assetDay: IxcDtccDtcV1AssetDayState;
}

export interface IxcDtccDtcV1AssetDayQueryServiceAssetDayListResponse {
    assetDay?: IxcDtccDtcV1AssetDayState[];
    page?: J5ListV1PageResponse;
}

export interface IxcFeesV1FeeRateCommandServiceFeeRateCreateRequest {
    feeType: IxcFeesV1FeeType;
    // format: YYYY-MM-DD
    effectiveDate: string;
    // format: decimal
    rate: string;
    // format: decimal
    maximum?: string;
    /* Defaults to fee:<feeType> */
    mapCode?: string;
    /* Defaults to expense:fee:<feeType> */
    firmMapCode?: string;
}

export interface IxcFeesV1FeeRateCommandServiceFeeRateCreateResponse {
    feeRate: IxcFeesV1FeeRateState;
}

export interface IxcFeesV1FeeRateCommandServiceFeeRateUpdateRequest {
    // format: decimal
    rate?: string;
    // format: decimal
    maximum?: string;
    mapCode?: string;
    firmMapCode?: string;
    feeType: IxcFeesV1FeeType;
    // format: YYYY-MM-DD
    effectiveDate: string;
}

export interface IxcFeesV1FeeRateCommandServiceFeeRateUpdateResponse {
    feeRate: IxcFeesV1FeeRateState;
}

export interface IxcFeesV1FeeRateQueryServiceFeeRateEventsResponse {
    events?: IxcFeesV1FeeRateEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcFeesV1FeeRateQueryServiceFeeRateGetResponse {
    feeRate: IxcFeesV1FeeRateState;
}

export interface IxcFeesV1FeeRateQueryServiceFeeRateListResponse {
    feeRate?: IxcFeesV1FeeRateState[];
    page?: J5ListV1PageResponse;
}

export interface IxcFeesV1TafReportServiceTafActivityReportResponse {
    /* Each row represents one line item in the TAF report */
    rows?: IxcFeesV1TafActivityReportResponseTafReportRow[];
}

export interface IxcFundingV1AccountNumberCommandServiceAccountNumberCreateRequest {
    // format: id62
    accountId: string;
    // format: id62
    accountNumberId?: string;
}

export interface IxcFundingV1AccountNumberCommandServiceAccountNumberCreateResponse {
    accountNumber: IxcFundingV1AccountNumberState;
}

export interface IxcFundingV1AccountNumberCommandServiceAccountNumberDisableRequest {
    // format: id62
    accountNumberId: string;
}

export interface IxcFundingV1AccountNumberCommandServiceAccountNumberDisableResponse {
    accountNumber: IxcFundingV1AccountNumberState;
}

export interface IxcFundingV1AccountNumberCommandServiceAccountNumberReenableRequest {
    // format: id62
    accountNumberId: string;
}

export interface IxcFundingV1AccountNumberCommandServiceAccountNumberReenableResponse {
    accountNumber: IxcFundingV1AccountNumberState;
}

export interface IxcFundingV1AccountNumberQueryServiceAccountNumberEventsResponse {
    events?: IxcFundingV1AccountNumberEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcFundingV1AccountNumberQueryServiceAccountNumberGetResponse {
    accountNumber: IxcFundingV1AccountNumberState;
}

export interface IxcFundingV1AccountNumberQueryServiceAccountNumberListResponse {
    accountNumber?: IxcFundingV1AccountNumberState[];
    page?: J5ListV1PageResponse;
}

export interface IxcFundingV1BatchAllocationQueryServiceBatchAllocationEventsResponse {
    events?: IxcFundingV1BatchAllocationEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcFundingV1BatchAllocationQueryServiceBatchAllocationGetResponse {
    batchAllocation: IxcFundingV1BatchAllocationState;
}

export interface IxcFundingV1BatchAllocationQueryServiceBatchAllocationListResponse {
    batchAllocation?: IxcFundingV1BatchAllocationState[];
    page?: J5ListV1PageResponse;
}

export interface IxcFundingV1BatchTransferCommandServiceBatchTransferApproveRequest {
    /* Optional notes on approval */
    notes?: string;
    /* ID of the Batch Transfer to approve */
    batchTransferId: string;
}

export interface IxcFundingV1BatchTransferCommandServiceBatchTransferApproveResponse {
    batchTransfer: IxcFundingV1BatchTransferState;
}

export interface IxcFundingV1BatchTransferCommandServiceBatchTransferCreateRequest {
    /* When provided, used as the batch transfer ID to enable
    idempotent creation. If not provided, one will be generated. */
    // format: id62
    batchTransferId?: string;
    // format: id62
    programId: string;
    spec: IxcFundingV1BatchTransferSpec;
    // format: id62
    platformAccountId?: string;
}

export interface IxcFundingV1BatchTransferCommandServiceBatchTransferCreateResponse {
    batchTransfer: IxcFundingV1BatchTransferState;
}

export interface IxcFundingV1BatchTransferCommandServiceBatchTransferRejectRequest {
    /* Optional reason note on rejection */
    reason?: string;
    /* ID of the Batch Transfer to reject */
    batchTransferId: string;
}

export interface IxcFundingV1BatchTransferCommandServiceBatchTransferRejectResponse {
    batchTransfer: IxcFundingV1BatchTransferState;
}

export interface IxcFundingV1BatchTransferQueryServiceBatchTransferEventsResponse {
    events?: IxcFundingV1BatchTransferEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcFundingV1BatchTransferQueryServiceBatchTransferGetResponse {
    batchTransfer: IxcFundingV1BatchTransferState;
}

export interface IxcFundingV1BatchTransferQueryServiceBatchTransferListResponse {
    batchTransfer?: IxcFundingV1BatchTransferState[];
    page?: J5ListV1PageResponse;
}

export interface IxcFundingV1SourceCommandServiceSourceArchiveRequest {
    // format: id62
    sourceId: string;
}

export interface IxcFundingV1SourceCommandServiceSourceArchiveResponse {
    source: IxcFundingV1SourceState;
}

export interface IxcFundingV1SourceCommandServiceSourceCreateRequest {
    /* When provided, used as the source ID to enable idempotent
    creation. If not provided, one will be generated. */
    // format: id62
    sourceId?: string;
    // format: id62
    accountId: string;
    // format: id62
    programId?: string;
    /* User friendly name for source */
    spec: IxcFundingV1SourceCreateRequestSpec;
}

export interface IxcFundingV1SourceCommandServiceSourceCreateResponse {
    source: IxcFundingV1SourceState;
}

export interface IxcFundingV1SourceCommandServiceSourceUpdateRequest {
    /* User friendly name for source */
    spec: IxcFundingV1SourceUpdateRequestSpec;
    // format: id62
    sourceId: string;
}

export interface IxcFundingV1SourceCommandServiceSourceUpdateResponse {
    source: IxcFundingV1SourceState;
}

export interface IxcFundingV1SourceQueryServiceSourceEventsResponse {
    events?: IxcFundingV1SourceEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcFundingV1SourceQueryServiceSourceGetResponse {
    source: IxcFundingV1SourceState;
}

export interface IxcFundingV1SourceQueryServiceSourceListResponse {
    source?: IxcFundingV1SourceState[];
    page?: J5ListV1PageResponse;
}

export interface IxcFundingV1TransferCommandServiceCheckResultTransferRequest {
    check: IxcFundingV1TransferCheckType;
    // format: id62
    transferId: string;
}

export interface IxcFundingV1TransferCommandServiceCheckResultTransferResponse {
    transfer: IxcFundingV1TransferState;
}

export interface IxcFundingV1TransferCommandServiceTransferCreateRequest {
    /* When provided, used as the transfer ID to enable idempotent
    creation. If not provided, one will be generated. */
    // format: id62
    transferId?: string;
    // format: id62
    sourceId: string;
    /* Transfer amount in USD */
    // format: decimal
    amount: string;
    spec: IxcFundingV1TransferCreateRequestSpec;
    /* Used for batch transfers. Generally not for use directly. */
    // format: id62
    batchId?: string;
}

export interface IxcFundingV1TransferCommandServiceTransferCreateResponse {
    transfer: IxcFundingV1TransferState;
}

export interface IxcFundingV1TransferQueryServiceTransferEventsResponse {
    events?: IxcFundingV1TransferEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcFundingV1TransferQueryServiceTransferGetResponse {
    transfer: IxcFundingV1TransferState;
}

export interface IxcFundingV1TransferQueryServiceTransferListResponse {
    transfer?: IxcFundingV1TransferState[];
    page?: J5ListV1PageResponse;
}

export interface IxcGenerateV1MonthlyStatementsJobCommandServiceRetryMonthlyStatementsJobRequest {
    // format: id62
    jobId: string;
    // format: id62
    newJobId?: string;
}

export interface IxcGenerateV1MonthlyStatementsJobCommandServiceRetryMonthlyStatementsJobResponse {
    // format: id62
    newJobId: string;
}

export interface IxcGenerateV1MonthlyStatementsJobQueryServiceMonthlyStatementsJobEventsResponse {
    events?: IxcGenerateV1MonthlyStatementsJobEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcGenerateV1MonthlyStatementsJobQueryServiceMonthlyStatementsJobGetResponse {
    monthlyStatementsJob: IxcGenerateV1MonthlyStatementsJobState;
}

export interface IxcGenerateV1MonthlyStatementsJobQueryServiceMonthlyStatementsJobListResponse {
    monthlyStatementsJob?: IxcGenerateV1MonthlyStatementsJobState[];
    page?: J5ListV1PageResponse;
}

export interface IxcGenerateV1MonthlyStatementsPreviewServicePreviewMonthlyStatementsRequest {
    // format: id62
    accountId: string;
    /* The start date the monthly statements is generated for, in
    YYYY-MM-DD format. Generally, this is the first day of the month. */
    // format: YYYY-MM-DD
    startDate: string;
    /* The end date the monthly statements is generated for, in
    YYYY-MM-DD format. Generally, this is the last day of the month. */
    // format: YYYY-MM-DD
    endDate: string;
    /* The format of the preview monthly statement If not provided,
    defaults to html */
    format?: IxcGenerateV1PreviewMonthlyStatementFileFormat;
    /* optional revision number. */
    // pattern: ^[0-9]{0,15}$
    revision?: string;
    /* An optional random string to support Content Security Policy
    (CSP) when previewing the monthly statement in HTML format. If
    provided, the nonce will be included in the HTML template to
    allowlist inline scripts. */
    nonce?: string;
}

export interface IxcGenerateV1MonthlyStatementsTaskQueryServiceMonthlyStatementsTaskEventsResponse {
    events?: IxcGenerateV1MonthlyStatementsTaskEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcGenerateV1MonthlyStatementsTaskQueryServiceMonthlyStatementsTaskGetResponse {
    monthlyStatementsTask: IxcGenerateV1MonthlyStatementsTaskState;
}

export interface IxcGenerateV1MonthlyStatementsTaskQueryServiceMonthlyStatementsTaskListResponse {
    monthlyStatementsTask?: IxcGenerateV1MonthlyStatementsTaskState[];
    page?: J5ListV1PageResponse;
}

export interface IxcGenerateV1TradeConfirmationPreviewServicePreviewTradeConfirmationRequest {
    // format: id62
    accountId: string;
    /* The date the preview is generated for, in YYYY-MM-DD format */
    // format: YYYY-MM-DD
    tradeDate: string;
    /* The format of the preview trade confirmations If not provided,
    defaults to html */
    format?: IxcGenerateV1PreviewTradeConfirmationFileFormat;
    /* optional revision number. */
    // pattern: ^[0-9]{0,15}$
    revision?: string;
    /* An optional random string to support Content Security Policy
    (CSP) when previewing the trade confirmation in HTML format. If
    provided, the nonce will be included in the HTML template to
    allowlist inline scripts. */
    nonce?: string;
}

export interface IxcGenerateV1TradeConfirmationsJobCommandServiceRetryTradeConfirmationsJobRequest {
    // format: id62
    jobId: string;
    // format: id62
    newJobId?: string;
}

export interface IxcGenerateV1TradeConfirmationsJobCommandServiceRetryTradeConfirmationsJobResponse {
    // format: id62
    newJobId: string;
}

export interface IxcGenerateV1TradeConfirmationsJobQueryServiceTradeConfirmationsJobEventsResponse {
    events?: IxcGenerateV1TradeConfirmationsJobEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcGenerateV1TradeConfirmationsJobQueryServiceTradeConfirmationsJobGetResponse {
    tradeConfirmationsJob: IxcGenerateV1TradeConfirmationsJobState;
}

export interface IxcGenerateV1TradeConfirmationsJobQueryServiceTradeConfirmationsJobListResponse {
    tradeConfirmationsJob?: IxcGenerateV1TradeConfirmationsJobState[];
    page?: J5ListV1PageResponse;
}

export interface IxcGenerateV1TradeConfirmationsTaskQueryServiceTradeConfirmationsTaskEventsResponse {
    events?: IxcGenerateV1TradeConfirmationsTaskEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcGenerateV1TradeConfirmationsTaskQueryServiceTradeConfirmationsTaskGetResponse {
    tradeConfirmationsTask: IxcGenerateV1TradeConfirmationsTaskState;
}

export interface IxcGenerateV1TradeConfirmationsTaskQueryServiceTradeConfirmationsTaskListResponse {
    tradeConfirmationsTask?: IxcGenerateV1TradeConfirmationsTaskState[];
    page?: J5ListV1PageResponse;
}

export interface IxcInventoryV1BooksOrderQueryServiceBooksOrderEventsResponse {
    events?: IxcInventoryV1BooksOrderEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcInventoryV1BooksOrderQueryServiceBooksOrderGetResponse {
    booksOrder: IxcInventoryV1BooksOrderState;
}

export interface IxcInventoryV1BooksOrderQueryServiceBooksOrderListResponse {
    booksOrder?: IxcInventoryV1BooksOrderState[];
    page?: J5ListV1PageResponse;
}

export interface IxcInventoryV1FirmOrderCommandServiceOrderCancelRequest {
    reason?: string;
    // format: id62
    firmOrderId: string;
}

export interface IxcInventoryV1FirmOrderCommandServiceOrderCancelResponse {
    order: IxcInventoryV1FirmOrderState;
}

export interface IxcInventoryV1FirmOrderCommandServiceOrderSubmitRequest {
    instruction: IxcInventoryV1OrderInstruction;
}

export interface IxcInventoryV1FirmOrderCommandServiceOrderSubmitResponse {
    order: IxcInventoryV1FirmOrderState;
}

export interface IxcInventoryV1FirmOrderQueryServiceFirmOrderEventsResponse {
    events?: IxcInventoryV1FirmOrderEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcInventoryV1FirmOrderQueryServiceFirmOrderGetResponse {
    firmOrder: IxcInventoryV1FirmOrderState;
}

export interface IxcInventoryV1FirmOrderQueryServiceFirmOrderListResponse {
    firmOrder?: IxcInventoryV1FirmOrderState[];
    page?: J5ListV1PageResponse;
}

export interface IxcInventoryV1SecurityDayQueryServiceSecurityDayEventsResponse {
    events?: IxcInventoryV1SecurityDayEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcInventoryV1SecurityDayQueryServiceSecurityDayGetResponse {
    securityDay: IxcInventoryV1SecurityDayState;
}

export interface IxcInventoryV1SecurityDayQueryServiceSecurityDayListResponse {
    securityDay?: IxcInventoryV1SecurityDayState[];
    page?: J5ListV1PageResponse;
}

export interface IxcInventoryV1SellDownServiceSellDownCreateOrdersRequest {
    data?: IxcInventoryV1SellDownRequest;
}

export interface IxcInventoryV1SellDownServiceSellDownCreateOrdersResponse {
    rows?: IxcInventoryV1SellDownRow[];
}

export interface IxcInventoryV1SellDownServiceSellDownPreviewResponse {
    rows?: IxcInventoryV1SellDownRow[];
}

export interface IxcInventoryV1TradingDayQueryServiceTradingDayEventsResponse {
    events?: IxcInventoryV1TradingDayEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcInventoryV1TradingDayQueryServiceTradingDayGetResponse {
    tradingDay: IxcInventoryV1TradingDayState;
}

export interface IxcInventoryV1TradingDayQueryServiceTradingDayListResponse {
    tradingDay?: IxcInventoryV1TradingDayState[];
    page?: J5ListV1PageResponse;
}

export interface IxcMfrecoV1PositionDayQueryServicePositionDayEventsResponse {
    events?: IxcMfrecoV1PositionDayEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcMfrecoV1PositionDayQueryServicePositionDayGetResponse {
    positionDay: IxcMfrecoV1PositionDayState;
}

export interface IxcMfrecoV1PositionDayQueryServicePositionDayListResponse {
    positionDay?: IxcMfrecoV1PositionDayState[];
    page?: J5ListV1PageResponse;
}

export interface IxcMutualfundsV1DividendAccrualQueryServiceDividendAccrualEventsResponse {
    events?: IxcMutualfundsV1DividendAccrualEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcMutualfundsV1DividendAccrualQueryServiceDividendAccrualGetResponse {
    dividendAccrual: IxcMutualfundsV1DividendAccrualState;
}

export interface IxcMutualfundsV1DividendAccrualQueryServiceDividendAccrualListResponse {
    dividendAccrual?: IxcMutualfundsV1DividendAccrualState[];
    page?: J5ListV1PageResponse;
}

export interface IxcMutualfundsV1DividendAccrualSummaryCommandServiceDividendAccrualRepublishSummariesRequest {
    /* Republish only the named summaries. If empty, all summaries are republished */
    summaries?: IxcMutualfundsV1DividendAccrualSummaryName[];
    /* The number of entities to read at once for republishing */
    // format: UINT64
    batchSize?: string;
}

export interface IxcMutualfundsV1DividendAccrualSummaryCommandServiceDividendAccrualRepublishSummariesResponse {
    /* The number of states read */
    // format: INT64
    count?: string;
}

export interface IxcMutualfundsV1FundOrderCommandServiceFundOrderCancelRequest {
    reason?: string;
    // format: id62
    fundOrderId: string;
}

export interface IxcMutualfundsV1FundOrderCommandServiceFundOrderCancelResponse {
    fundOrder: IxcMutualfundsV1FundOrderState;
}

export interface IxcMutualfundsV1FundOrderCommandServiceFundOrderSubmitRequest {
    /* When provided, used as the order ID to enable idempotent
    creation. If not provided, one will be generated. */
    // format: id62
    fundOrderId?: string;
    // format: id62
    accountId: string;
    instruction: IxcMutualfundsV1FundOrderInstruction;
    /* Solicited flag and trailer, as on an equity order. A
    commission is not applied to fund orders. */
    extension?: IxcOrdersV1OrderExtension;
}

export interface IxcMutualfundsV1FundOrderCommandServiceFundOrderSubmitResponse {
    fundOrder: IxcMutualfundsV1FundOrderState;
}

export interface IxcMutualfundsV1FundOrderQueryServiceFundOrderEventsResponse {
    events?: IxcMutualfundsV1FundOrderEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcMutualfundsV1FundOrderQueryServiceFundOrderGetResponse {
    fundOrder: IxcMutualfundsV1FundOrderState;
}

export interface IxcMutualfundsV1FundOrderQueryServiceFundOrderListResponse {
    fundOrder?: IxcMutualfundsV1FundOrderState[];
    page?: J5ListV1PageResponse;
}

export interface IxcMutualfundsV1MutualFundsJobCommandServiceJobCreateRequest {
    /* Optional job ID. If not provided, a new ID will be generated. */
    // format: id62
    mutualFundsJobId?: string;
    spec: IxcMutualfundsV1JobSpec;
}

export interface IxcMutualfundsV1MutualFundsJobCommandServiceJobCreateResponse {
    /* The ID of the created job */
    // format: id62
    mutualFundsJobId: string;
}

export interface IxcMutualfundsV1MutualFundsJobQueryServiceMutualFundsJobEventsResponse {
    events?: IxcMutualfundsV1MutualFundsJobEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcMutualfundsV1MutualFundsJobQueryServiceMutualFundsJobGetResponse {
    mutualFundsJob: IxcMutualfundsV1MutualFundsJobState;
}

export interface IxcMutualfundsV1MutualFundsJobQueryServiceMutualFundsJobListResponse {
    mutualFundsJob?: IxcMutualfundsV1MutualFundsJobState[];
    page?: J5ListV1PageResponse;
}

export interface IxcMutualfundsV1MutualFundsTaskCommandServiceTaskRecoverRequest {
    // format: id62
    mutualFundsTaskId: string;
}

export interface IxcMutualfundsV1MutualFundsTaskCommandServiceTaskRecoverResponse {
    // format: id62
    mutualFundsTaskId: string;
}

export interface IxcMutualfundsV1MutualFundsTaskQueryServiceMutualFundsTaskEventsResponse {
    events?: IxcMutualfundsV1MutualFundsTaskEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcMutualfundsV1MutualFundsTaskQueryServiceMutualFundsTaskGetResponse {
    mutualFundsTask: IxcMutualfundsV1MutualFundsTaskState;
}

export interface IxcMutualfundsV1MutualFundsTaskQueryServiceMutualFundsTaskListResponse {
    mutualFundsTask?: IxcMutualfundsV1MutualFundsTaskState[];
    page?: J5ListV1PageResponse;
}

export interface IxcMutualfundsV1VenueOrderQueryServiceVenueOrderEventsResponse {
    events?: IxcMutualfundsV1VenueOrderEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcMutualfundsV1VenueOrderQueryServiceVenueOrderGetResponse {
    venueOrder: IxcMutualfundsV1VenueOrderState;
}

export interface IxcMutualfundsV1VenueOrderQueryServiceVenueOrderListResponse {
    venueOrder?: IxcMutualfundsV1VenueOrderState[];
    page?: J5ListV1PageResponse;
}

export interface IxcOrdersV1BatchAllocationQueryServiceBatchAllocationEventsResponse {
    events?: IxcOrdersV1BatchAllocationEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcOrdersV1BatchAllocationQueryServiceBatchAllocationGetResponse {
    batchAllocation: IxcOrdersV1BatchAllocationState;
}

export interface IxcOrdersV1BatchAllocationQueryServiceBatchAllocationListResponse {
    batchAllocation?: IxcOrdersV1BatchAllocationState[];
    page?: J5ListV1PageResponse;
}

export interface IxcOrdersV1BatchOrderCommandServiceBatchOrderCancelRequest {
    reason?: string;
    // format: id62
    batchOrderId: string;
}

export interface IxcOrdersV1BatchOrderCommandServiceBatchOrderCancelResponse {
    batchOrder: IxcOrdersV1BatchOrderState;
}

export interface IxcOrdersV1BatchOrderCommandServiceBatchOrderSubmitRequest {
    /* Optional caller-provided batch order ID for idempotency. If
    omitted, a new ID is generated server-side. */
    // format: id62
    batchOrderId?: string;
    /* The program's average price account, on which the aggregated
    order is placed. Program tenants may omit this — the
    calling program's average price account is resolved
    automatically. Clearing tenants must supply it.
    To discover it, list accounts filtered by `programId` and
    `purpose` = `AVERAGE_PRICE` against `GET
    /ixc/registration/v1/account/q`. Each program has one. An
    account with any other purpose is rejected. */
    // format: id62
    accountId?: string;
    instruction: IxcOrdersV1OrderInstruction;
    extension: IxcOrdersV1OrderExtension;
    /* Optional buffer percentage for BUY hold sizing, as a decimal
    fraction (e.g. 0.10 = 10%). When omitted, holds use the raw
    quote price with no buffer. */
    // format: decimal
    holdBufferPercent?: string;
    allocationSpec: IxcOrdersV1BatchAllocationSpec;
}

export interface IxcOrdersV1BatchOrderCommandServiceBatchOrderSubmitResponse {
    batchOrder: IxcOrdersV1BatchOrderState;
}

export interface IxcOrdersV1BatchOrderQueryServiceBatchOrderEventsResponse {
    events?: IxcOrdersV1BatchOrderEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcOrdersV1BatchOrderQueryServiceBatchOrderGetResponse {
    batchOrder: IxcOrdersV1BatchOrderState;
}

export interface IxcOrdersV1BatchOrderQueryServiceBatchOrderListResponse {
    batchOrder?: IxcOrdersV1BatchOrderState[];
    page?: J5ListV1PageResponse;
}

export interface IxcOrdersV1OrderCommandServiceOrderCancelRequest {
    reason?: string;
    // format: id62
    orderId: string;
}

export interface IxcOrdersV1OrderCommandServiceOrderCancelResponse {
    order: IxcOrdersV1OrderState;
}

export interface IxcOrdersV1OrderCommandServiceOrderSubmitRequest {
    /* When provided, used as the order ID to enable idempotent
    creation. If not provided, one will be generated. */
    // format: id62
    orderId?: string;
    // format: id62
    accountId: string;
    instruction: IxcOrdersV1OrderInstruction;
    extension: IxcOrdersV1OrderExtension;
}

export interface IxcOrdersV1OrderCommandServiceOrderSubmitResponse {
    order: IxcOrdersV1OrderState;
}

export interface IxcOrdersV1OrderQueryServiceOrderEventsResponse {
    events?: IxcOrdersV1OrderEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcOrdersV1OrderQueryServiceOrderGetResponse {
    order: IxcOrdersV1OrderState;
}

export interface IxcOrdersV1OrderQueryServiceOrderListResponse {
    order?: IxcOrdersV1OrderState[];
    page?: J5ListV1PageResponse;
}

export interface IxcPaymentsV1AccountNumberQueryServiceAccountNumberEventsResponse {
    events?: IxcPaymentsV1AccountNumberEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcPaymentsV1AccountNumberQueryServiceAccountNumberGetResponse {
    accountNumber: IxcPaymentsV1AccountNumberState;
}

export interface IxcPaymentsV1AccountNumberQueryServiceAccountNumberListResponse {
    accountNumber?: IxcPaymentsV1AccountNumberState[];
    page?: J5ListV1PageResponse;
}

export interface IxcPaymentsV1AchQueryServiceAchEventsResponse {
    events?: IxcPaymentsV1AchEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcPaymentsV1AchQueryServiceAchGetResponse {
    ach: IxcPaymentsV1AchState;
}

export interface IxcPaymentsV1AchQueryServiceAchListResponse {
    ach?: IxcPaymentsV1AchState[];
    page?: J5ListV1PageResponse;
}

export interface IxcPaymentsV1IncomingAchQueryServiceIncomingAchEventsResponse {
    events?: IxcPaymentsV1IncomingAchEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcPaymentsV1IncomingAchQueryServiceIncomingAchGetResponse {
    incomingAch: IxcPaymentsV1IncomingAchState;
}

export interface IxcPaymentsV1IncomingAchQueryServiceIncomingAchListResponse {
    incomingAch?: IxcPaymentsV1IncomingAchState[];
    page?: J5ListV1PageResponse;
}

export interface IxcPaymentsV1IncomingWireQueryServiceIncomingWireEventsResponse {
    events?: IxcPaymentsV1IncomingWireEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcPaymentsV1IncomingWireQueryServiceIncomingWireGetResponse {
    incomingWire: IxcPaymentsV1IncomingWireState;
}

export interface IxcPaymentsV1IncomingWireQueryServiceIncomingWireListResponse {
    incomingWire?: IxcPaymentsV1IncomingWireState[];
    page?: J5ListV1PageResponse;
}

export interface IxcPaymentsV1WireQueryServiceWireEventsResponse {
    events?: IxcPaymentsV1WireEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcPaymentsV1WireQueryServiceWireGetResponse {
    wire: IxcPaymentsV1WireState;
}

export interface IxcPaymentsV1WireQueryServiceWireListResponse {
    wire?: IxcPaymentsV1WireState[];
    page?: J5ListV1PageResponse;
}

export interface IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceEventsResponse {
    events?: IxcPortfolioV1AssetBalanceEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceGetResponse {
    assetBalance: IxcPortfolioV1AssetBalanceState;
}

export interface IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceListResponse {
    assetBalance?: IxcPortfolioV1AssetBalanceState[];
    page?: J5ListV1PageResponse;
}

export interface IxcPortfolioV1BalanceSnapshotQueryServiceBalanceSnapshotEventsResponse {
    events?: IxcPortfolioV1BalanceSnapshotEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcPortfolioV1BalanceSnapshotQueryServiceBalanceSnapshotGetResponse {
    balanceSnapshot: IxcPortfolioV1BalanceSnapshotState;
}

export interface IxcPortfolioV1BalanceSnapshotQueryServiceBalanceSnapshotListResponse {
    balanceSnapshot?: IxcPortfolioV1BalanceSnapshotState[];
    page?: J5ListV1PageResponse;
}

export interface IxcPortfolioV1CashBalanceQueryServiceCashBalanceEventsResponse {
    events?: IxcPortfolioV1CashBalanceEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcPortfolioV1CashBalanceQueryServiceCashBalanceGetResponse {
    cashBalance: IxcPortfolioV1CashBalanceState;
}

export interface IxcPortfolioV1CashBalanceQueryServiceCashBalanceListResponse {
    cashBalance?: IxcPortfolioV1CashBalanceState[];
    page?: J5ListV1PageResponse;
}

export interface IxcPortfolioV1DepositAdvanceQueryServiceDepositAdvanceEventsResponse {
    events?: IxcPortfolioV1DepositAdvanceEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcPortfolioV1DepositAdvanceQueryServiceDepositAdvanceGetResponse {
    depositAdvance: IxcPortfolioV1DepositAdvanceState;
}

export interface IxcPortfolioV1DepositAdvanceQueryServiceDepositAdvanceListResponse {
    depositAdvance?: IxcPortfolioV1DepositAdvanceState[];
    page?: J5ListV1PageResponse;
}

export interface IxcPortfolioV1HoldQueryServiceHoldEventsResponse {
    events?: IxcPortfolioV1HoldEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcPortfolioV1HoldQueryServiceHoldGetResponse {
    hold: IxcPortfolioV1HoldState;
}

export interface IxcPortfolioV1HoldQueryServiceHoldListResponse {
    hold?: IxcPortfolioV1HoldState[];
    page?: J5ListV1PageResponse;
}

export interface IxcPortfolioV1PerformanceServicePerformanceResponse {
    /* The total current value of the portfolio */
    // format: decimal
    portfolioValue: string;
    unrealizedDividends?: IxcPortfolioV1UnrealizedDividendsSummary;
}

export interface IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceEventsResponse {
    events?: IxcPortfolioV1SweepBalanceEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceGetResponse {
    sweepBalance: IxcPortfolioV1SweepBalanceState;
}

export interface IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceListResponse {
    sweepBalance?: IxcPortfolioV1SweepBalanceState[];
    page?: J5ListV1PageResponse;
}

export interface IxcPortfolioV1TransactionQueryServiceTransactionEventsResponse {
    events?: IxcPortfolioV1TransactionEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcPortfolioV1TransactionQueryServiceTransactionGetResponse {
    transaction: IxcPortfolioV1TransactionState;
}

export interface IxcPortfolioV1TransactionQueryServiceTransactionListResponse {
    transaction?: IxcPortfolioV1TransactionState[];
    page?: J5ListV1PageResponse;
}

export interface IxcProspectusV1ProspectusJobQueryServiceProspectusJobEventsResponse {
    events?: IxcProspectusV1ProspectusJobEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcProspectusV1ProspectusJobQueryServiceProspectusJobGetResponse {
    prospectusJob: IxcProspectusV1ProspectusJobState;
}

export interface IxcProspectusV1ProspectusJobQueryServiceProspectusJobListResponse {
    prospectusJob?: IxcProspectusV1ProspectusJobState[];
    page?: J5ListV1PageResponse;
}

export interface IxcProspectusV1ProspectusTaskQueryServiceProspectusTaskEventsResponse {
    events?: IxcProspectusV1ProspectusTaskEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcProspectusV1ProspectusTaskQueryServiceProspectusTaskGetResponse {
    prospectusTask: IxcProspectusV1ProspectusTaskState;
}

export interface IxcProspectusV1ProspectusTaskQueryServiceProspectusTaskListResponse {
    prospectusTask?: IxcProspectusV1ProspectusTaskState[];
    page?: J5ListV1PageResponse;
}

export interface IxcProxyvoteV1ProxyJobQueryServiceProxyJobEventsResponse {
    events?: IxcProxyvoteV1ProxyJobEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcProxyvoteV1ProxyJobQueryServiceProxyJobGetResponse {
    proxyJob: IxcProxyvoteV1ProxyJobState;
}

export interface IxcProxyvoteV1ProxyJobQueryServiceProxyJobListResponse {
    proxyJob?: IxcProxyvoteV1ProxyJobState[];
    page?: J5ListV1PageResponse;
}

export interface IxcProxyvoteV1ProxyTaskQueryServiceProxyTaskEventsResponse {
    events?: IxcProxyvoteV1ProxyTaskEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcProxyvoteV1ProxyTaskQueryServiceProxyTaskGetResponse {
    proxyTask: IxcProxyvoteV1ProxyTaskState;
}

export interface IxcProxyvoteV1ProxyTaskQueryServiceProxyTaskListResponse {
    proxyTask?: IxcProxyvoteV1ProxyTaskState[];
    page?: J5ListV1PageResponse;
}

export interface IxcRaglV1InfoServiceAccountCodesResponse {
    accountCodes: IxcRaglV1AccountCodesResponseAccountCodes[];
}

export interface IxcRaglV1ManualEntryCommandServiceCreateManualEntryRequest {
    // format: id62
    entryId?: string;
    spec: IxcRaglV1ManualEntryInput;
}

export interface IxcRaglV1ManualEntryCommandServiceCreateManualEntryResponse {
    manualEntry: IxcRaglV1ManualEntryState;
}

export interface IxcRaglV1ManualEntryCommandServiceReverseManualEntryRequest {
    // format: date-time
    effectiveAt: string;
    reason?: string;
    // format: id62
    entryId: string;
}

export interface IxcRaglV1ManualEntryCommandServiceReverseManualEntryResponse {
    manualEntry: IxcRaglV1ManualEntryState;
}

export interface IxcRaglV1ManualEntryQueryServiceManualEntryEventsResponse {
    events?: IxcRaglV1ManualEntryEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcRaglV1ManualEntryQueryServiceManualEntryGetResponse {
    manualEntry: IxcRaglV1ManualEntryState;
}

export interface IxcRaglV1ManualEntryQueryServiceManualEntryListResponse {
    manualEntry?: IxcRaglV1ManualEntryState[];
    page?: J5ListV1PageResponse;
}

export interface IxcRaglV1ReportsServiceCashBlotterResponse {
    blotters?: IxcRaglV1DeltaBlotter[];
    page?: J5ListV1PageResponse;
}

export interface IxcRaglV1ReportsServiceClearingCashBalancesResponse {
    cashBalances?: IxcRaglV1CashBalance;
}

export interface IxcRaglV1ReportsServiceCustomerCashBalanceResponse {
    report?: IxcRaglV1CustomerCashBalanceRow[];
    page?: J5ListV1PageResponse;
}

export interface IxcRaglV1ReportsServiceCustomerStockRecordResponse {
    report?: IxcRaglV1CustomerStockRecordRow[];
    page?: J5ListV1PageResponse;
}

export interface IxcRaglV1ReportsServiceCustomerSweepRecordResponse {
    report?: IxcRaglV1CustomerSweepRecordRow[];
    page?: J5ListV1PageResponse;
}

export interface IxcRaglV1ReportsServiceStockBlotterResponse {
    blotters?: IxcRaglV1DeltaBlotter[];
    page?: J5ListV1PageResponse;
}

export interface IxcRaglV1ReportsServiceStockRecordResponse {
    report: IxcRaglV1StockRecord;
}

export interface IxcRaglV1TransactionQueryServiceTransactionEventsResponse {
    events?: IxcRaglV1TransactionEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcRaglV1TransactionQueryServiceTransactionGetResponse {
    transaction: IxcRaglV1TransactionState;
}

export interface IxcRaglV1TransactionQueryServiceTransactionListResponse {
    transaction?: IxcRaglV1TransactionState[];
    page?: J5ListV1PageResponse;
}

export interface IxcRegistrationV1AccountCommandServiceCheckResultAccountRequest {
    // format: id62
    checkId: string;
    evidence: IxcRegistrationV1AccountEvidence;
    // format: id62
    accountId: string;
}

export interface IxcRegistrationV1AccountCommandServiceCheckResultAccountResponse {
    account: IxcRegistrationV1AccountState;
}

export interface IxcRegistrationV1AccountCommandServiceClearingCheckResultAccountRequest {
    // format: id62
    checkId: string;
    evidence: IxcRegistrationV1ClearingAccountEvidence;
    // format: id62
    accountId: string;
}

export interface IxcRegistrationV1AccountCommandServiceClearingCheckResultAccountResponse {
    account: IxcRegistrationV1AccountState;
}

export interface IxcRegistrationV1AccountCommandServiceClearingUpdateAccountRequest {
    update: IxcRegistrationV1ClearingAccountUpdate;
    // format: id62
    accountId: string;
}

export interface IxcRegistrationV1AccountCommandServiceClearingUpdateAccountResponse {
    account: IxcRegistrationV1AccountState;
}

export interface IxcRegistrationV1AccountCommandServiceClearingUpdatePlatformAccountRequest {
    update: IxcRegistrationV1ClearingPlatformUpdate;
    // format: id62
    accountId: string;
}

export interface IxcRegistrationV1AccountCommandServiceClearingUpdatePlatformAccountResponse {
    account: IxcRegistrationV1AccountState;
}

export interface IxcRegistrationV1AccountCommandServiceCloseAccountRequest {
    // format: id62
    accountId: string;
}

export interface IxcRegistrationV1AccountCommandServiceCloseAccountResponse {
    account: IxcRegistrationV1AccountState;
}

export interface IxcRegistrationV1AccountCommandServiceCreateAccountRequest {
    /* When provided, used as the account ID to enable idempotent
    creation. If not provided, one will be generated. */
    // format: id62
    accountId?: string;
    // format: id62
    programId: string;
    registration: IxcRegistrationV1AccountRegistration;
    risk?: IxcRegistrationV1RiskProfile;
    controls: IxcRegistrationV1ProgramControls;
}

export interface IxcRegistrationV1AccountCommandServiceCreateAccountResponse {
    account: IxcRegistrationV1AccountState;
}

export interface IxcRegistrationV1AccountCommandServiceCreateSpecialPurposeAccountRequest {
    /* When provided, used as the account ID for idempotent
    creation. If not provided, one will be generated. */
    // format: id62
    accountId?: string;
    // format: id62
    programId: string;
    /* Organization profile that owns the account. */
    // format: id62
    profileId: string;
    /* Overrides; defaults come from the program SPA template. */
    controls?: IxcRegistrationV1ProgramControls;
    /* Optional display nickname for the account. */
    nickname?: string;
}

export interface IxcRegistrationV1AccountCommandServiceCreateSpecialPurposeAccountResponse {
    account: IxcRegistrationV1AccountState;
}

export interface IxcRegistrationV1AccountCommandServiceUpdateAccountRequest {
    update: IxcRegistrationV1AccountUpdate;
    // format: id62
    accountId: string;
}

export interface IxcRegistrationV1AccountCommandServiceUpdateAccountResponse {
    account: IxcRegistrationV1AccountState;
}

export interface IxcRegistrationV1AccountCommandServiceUpdatePlatformAccountRequest {
    update: IxcRegistrationV1PlatformUpdate;
    // format: id62
    accountId: string;
}

export interface IxcRegistrationV1AccountCommandServiceUpdatePlatformAccountResponse {
    account: IxcRegistrationV1AccountState;
}

export interface IxcRegistrationV1AccountQueryServiceAccountEventsResponse {
    events?: IxcRegistrationV1AccountEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcRegistrationV1AccountQueryServiceAccountGetResponse {
    account: IxcRegistrationV1AccountState;
}

export interface IxcRegistrationV1AccountQueryServiceAccountListResponse {
    account?: IxcRegistrationV1AccountState[];
    page?: J5ListV1PageResponse;
}

export interface IxcRegistrationV1PrincipalQueryServicePrincipalEventsResponse {
    events?: IxcRegistrationV1PrincipalEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcRegistrationV1PrincipalQueryServicePrincipalGetResponse {
    principal: IxcRegistrationV1PrincipalState;
}

export interface IxcRegistrationV1PrincipalQueryServicePrincipalListResponse {
    principal?: IxcRegistrationV1PrincipalState[];
    page?: J5ListV1PageResponse;
}

export interface IxcRegistrationV1ProfileCommandServiceAccountingGroupRequest {
    accountingGroup: IxcRegistrationV1AccountingGroup;
    // format: id62
    profileId: string;
}

export interface IxcRegistrationV1ProfileCommandServiceAccountingGroupResponse {
    profile: IxcRegistrationV1ProfileState;
}

export interface IxcRegistrationV1ProfileCommandServiceCreateProfileRequest {
    /* When provided, used as the profile ID to enable idempotent
    creation. If not provided, one will be generated. */
    // format: id62
    profileId?: string;
    // format: id62
    programId: string;
    spec: IxcRegistrationV1ProfileType;
}

export interface IxcRegistrationV1ProfileCommandServiceCreateProfileResponse {
    profile: IxcRegistrationV1ProfileState;
}

export interface IxcRegistrationV1ProfileCommandServiceRequestProfileScreeningRequest {
    trigger: IxcRegistrationV1ScreeningTrigger;
    // format: id62
    profileId: string;
}

export interface IxcRegistrationV1ProfileCommandServiceUpdateProfileRequest {
    // format: id62
    replacesVersionId: string;
    spec: IxcRegistrationV1ProfileType;
    // format: id62
    profileId: string;
}

export interface IxcRegistrationV1ProfileCommandServiceUpdateProfileResponse {
    profile: IxcRegistrationV1ProfileState;
}

export interface IxcRegistrationV1ProfileQueryServiceProfileEventsResponse {
    events?: IxcRegistrationV1ProfileEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcRegistrationV1ProfileQueryServiceProfileGetResponse {
    profile: IxcRegistrationV1ProfileState;
}

export interface IxcRegistrationV1ProfileQueryServiceProfileListResponse {
    profile?: IxcRegistrationV1ProfileState[];
    page?: J5ListV1PageResponse;
}

export interface IxcRegistrationV1ProfileVersionCommandServiceCheckResultProfileVersionRequest {
    // format: id62
    checkId: string;
    evidence: IxcRegistrationV1ProfileEvidence;
    // format: id62
    profileVersionId: string;
}

export interface IxcRegistrationV1ProfileVersionCommandServiceCheckResultProfileVersionResponse {
    profileVersion: IxcRegistrationV1ProfileVersionState;
}

export interface IxcRegistrationV1ProfileVersionCommandServiceClearingCheckResultProfileVersionRequest {
    // format: id62
    checkId: string;
    evidence: IxcRegistrationV1ClearingProfileEvidence;
    // format: id62
    profileVersionId: string;
}

export interface IxcRegistrationV1ProfileVersionCommandServiceClearingCheckResultProfileVersionResponse {
    profileVersion: IxcRegistrationV1ProfileVersionState;
}

export interface IxcRegistrationV1ProfileVersionQueryServiceProfileVersionEventsResponse {
    events?: IxcRegistrationV1ProfileVersionEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcRegistrationV1ProfileVersionQueryServiceProfileVersionGetResponse {
    profileVersion: IxcRegistrationV1ProfileVersionState;
}

export interface IxcRegistrationV1ProfileVersionQueryServiceProfileVersionListResponse {
    profileVersion?: IxcRegistrationV1ProfileVersionState[];
    page?: J5ListV1PageResponse;
}

export interface IxcSweepsClearingV1SweepOrderQueryServiceSweepOrderEventsResponse {
    events?: IxcSweepsClearingV1SweepOrderEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcSweepsClearingV1SweepOrderQueryServiceSweepOrderGetResponse {
    sweepOrder: IxcSweepsClearingV1SweepOrderState;
}

export interface IxcSweepsClearingV1SweepOrderQueryServiceSweepOrderListResponse {
    sweepOrder?: IxcSweepsClearingV1SweepOrderState[];
    page?: J5ListV1PageResponse;
}

export interface IxcSweepsClearingV1SweepParticipantQueryServiceSweepParticipantEventsResponse {
    events?: IxcSweepsClearingV1SweepParticipantEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcSweepsClearingV1SweepParticipantQueryServiceSweepParticipantGetResponse {
    sweepParticipant: IxcSweepsClearingV1SweepParticipantState;
}

export interface IxcSweepsClearingV1SweepParticipantQueryServiceSweepParticipantListResponse {
    sweepParticipant?: IxcSweepsClearingV1SweepParticipantState[];
    page?: J5ListV1PageResponse;
}

export interface IxcSweepsClearingV1SweepParticipantStatsQueryServiceSweepParticipantStatsEventsResponse {
    events?: IxcSweepsClearingV1SweepParticipantStatsEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcSweepsClearingV1SweepParticipantStatsQueryServiceSweepParticipantStatsGetResponse {
    sweepParticipantStats: IxcSweepsClearingV1SweepParticipantStatsState;
}

export interface IxcSweepsClearingV1SweepParticipantStatsQueryServiceSweepParticipantStatsListResponse {
    sweepParticipantStats?: IxcSweepsClearingV1SweepParticipantStatsState[];
    page?: J5ListV1PageResponse;
}

export interface IxcSweepsClearingV1SweepsJobCommandServiceJobCreateRequest {
    /* Optional job ID. If not provided, a new ID will be generated. */
    // format: id62
    sweepsJobId?: string;
    spec: IxcSweepsClearingV1JobSpec;
}

export interface IxcSweepsClearingV1SweepsJobCommandServiceJobCreateResponse {
    /* The ID of the created job */
    // format: id62
    sweepsJobId: string;
}

export interface IxcSweepsClearingV1SweepsJobQueryServiceSweepsJobEventsResponse {
    events?: IxcSweepsClearingV1SweepsJobEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcSweepsClearingV1SweepsJobQueryServiceSweepsJobGetResponse {
    sweepsJob: IxcSweepsClearingV1SweepsJobState;
}

export interface IxcSweepsClearingV1SweepsJobQueryServiceSweepsJobListResponse {
    sweepsJob?: IxcSweepsClearingV1SweepsJobState[];
    page?: J5ListV1PageResponse;
}

export interface IxcSweepsClearingV1SweepsTaskQueryServiceSweepsTaskEventsResponse {
    events?: IxcSweepsClearingV1SweepsTaskEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcSweepsClearingV1SweepsTaskQueryServiceSweepsTaskGetResponse {
    sweepsTask: IxcSweepsClearingV1SweepsTaskState;
}

export interface IxcSweepsClearingV1SweepsTaskQueryServiceSweepsTaskListResponse {
    sweepsTask?: IxcSweepsClearingV1SweepsTaskState[];
    page?: J5ListV1PageResponse;
}

export interface IxcSweepsClearingV1SweepTargetStatsCommandServiceDividendsPayRequest {
    /* The end date of the period covered by the payment. */
    // format: YYYY-MM-DD
    endDate: string;
    /* The unique ID of the sweep target */
    // format: id62
    sweepTargetId: string;
    /* The first day of the month for which to pay out dividends. */
    // format: YYYY-MM-DD
    firstDayOfMonth: string;
}

export interface IxcSweepsClearingV1SweepTargetStatsCommandServiceDividendsPayResponse {
    /* The total payment amount made as part of the dividends
    payout. */
    payment: IxcSweepsClearingV1SweepPayment;
}

export interface IxcSweepsClearingV1SweepTargetStatsQueryServiceSweepTargetStatsEventsResponse {
    events?: IxcSweepsClearingV1SweepTargetStatsEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcSweepsClearingV1SweepTargetStatsQueryServiceSweepTargetStatsGetResponse {
    sweepTargetStats: IxcSweepsClearingV1SweepTargetStatsState;
}

export interface IxcSweepsClearingV1SweepTargetStatsQueryServiceSweepTargetStatsListResponse {
    sweepTargetStats?: IxcSweepsClearingV1SweepTargetStatsState[];
    page?: J5ListV1PageResponse;
}

export interface IxcSweepsV1SweepPlanCommandServiceSweepPlanArchiveRequest {
    // format: id62
    sweepPlanId: string;
}

export interface IxcSweepsV1SweepPlanCommandServiceSweepPlanArchiveResponse {
    sweepPlan: IxcSweepsV1SweepPlanState;
}

export interface IxcSweepsV1SweepPlanCommandServiceSweepPlanCreateRequest {
    /* When provided, used as the sweep plan ID to enable idempotent
    creation. If not provided, one will be generated. */
    // format: id62
    sweepPlanId?: string;
    /* The display name of the sweep plan. */
    name: string;
    /* The list of sweep plan components. */
    components: IxcSweepsV1SweepPlanComponent[];
}

export interface IxcSweepsV1SweepPlanCommandServiceSweepPlanCreateResponse {
    sweepPlan: IxcSweepsV1SweepPlanState;
}

export interface IxcSweepsV1SweepPlanCommandServiceSweepPlanUpdateRequest {
    /* The new display name. */
    name: string;
    // format: id62
    sweepPlanId: string;
}

export interface IxcSweepsV1SweepPlanCommandServiceSweepPlanUpdateResponse {
    sweepPlan: IxcSweepsV1SweepPlanState;
}

export interface IxcSweepsV1SweepPlanQueryServiceSweepPlanEventsResponse {
    events?: IxcSweepsV1SweepPlanEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcSweepsV1SweepPlanQueryServiceSweepPlanGetResponse {
    sweepPlan: IxcSweepsV1SweepPlanState;
}

export interface IxcSweepsV1SweepPlanQueryServiceSweepPlanListResponse {
    sweepPlan?: IxcSweepsV1SweepPlanState[];
    page?: J5ListV1PageResponse;
}

export interface IxcSweepsV1SweepsCutoffQueryServiceGetSweepsCutoffResponse {
    cutoff: IxcSweepsV1SweepsCutoff;
}

export interface IxcSweepsV1SweepTargetAssetQueryServiceListEligibleAssetsResponse {
    assets: IxcSweepsV1EligibleSweepTargetAsset[];
}

export interface IxcSweepsV1SweepTargetCommandServiceSweepTargetArchiveRequest {
    // format: id62
    sweepTargetId: string;
}

export interface IxcSweepsV1SweepTargetCommandServiceSweepTargetArchiveResponse {
    sweepTarget: IxcSweepsV1SweepTargetState;
}

export interface IxcSweepsV1SweepTargetCommandServiceSweepTargetCreateRequest {
    /* When provided, used as the sweep target ID to enable
    idempotent creation. If not provided, one will be generated. */
    // format: id62
    sweepTargetId?: string;
    /* The ID of the asset to use as a sweep target. Must be an
    active money market fund with stable NAV. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
}

export interface IxcSweepsV1SweepTargetCommandServiceSweepTargetCreateResponse {
    sweepTarget: IxcSweepsV1SweepTargetState;
}

export interface IxcSweepsV1SweepTargetQueryServiceSweepTargetEventsResponse {
    events?: IxcSweepsV1SweepTargetEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcSweepsV1SweepTargetQueryServiceSweepTargetGetResponse {
    sweepTarget: IxcSweepsV1SweepTargetState;
}

export interface IxcSweepsV1SweepTargetQueryServiceSweepTargetListResponse {
    sweepTarget?: IxcSweepsV1SweepTargetState[];
    page?: J5ListV1PageResponse;
}

export interface IxcTradeV1TradeQueryServiceTradeEventsResponse {
    events?: IxcTradeV1TradeEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcTradeV1TradeQueryServiceTradeGetResponse {
    trade: IxcTradeV1TradeState;
}

export interface IxcTradeV1TradeQueryServiceTradeListResponse {
    trade?: IxcTradeV1TradeState[];
    page?: J5ListV1PageResponse;
}

export interface IxcTradereportingV1BlueSheetCommandServiceCreateBlueSheetRequest {
    spec: IxcTradereportingV1BlueSheetSpec;
}

export interface IxcTradereportingV1BlueSheetCommandServiceCreateBlueSheetResponse {
    report: IxcTradereportingV1BlueSheetState;
}

export interface IxcTradereportingV1BlueSheetQueryServiceBlueSheetEventsResponse {
    events?: IxcTradereportingV1BlueSheetEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcTradereportingV1BlueSheetQueryServiceBlueSheetGetResponse {
    blueSheet: IxcTradereportingV1BlueSheetState;
}

export interface IxcTradereportingV1BlueSheetQueryServiceBlueSheetListResponse {
    blueSheet?: IxcTradereportingV1BlueSheetState[];
    page?: J5ListV1PageResponse;
}

export interface IxcTradereportingV1CaisReportCommandServiceCreateCaisReportRequest {
    // format: YYYY-MM-DD
    reportDate: string;
    // format: INT32
    crdNumber: number;
}

export interface IxcTradereportingV1CaisReportCommandServiceCreateCaisReportResponse {
    caisReport: IxcTradereportingV1CaisReportState;
}

export interface IxcTradereportingV1CaisReportQueryServiceCaisReportEventsResponse {
    events?: IxcTradereportingV1CaisReportEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcTradereportingV1CaisReportQueryServiceCaisReportGetResponse {
    caisReport: IxcTradereportingV1CaisReportState;
}

export interface IxcTradereportingV1CaisReportQueryServiceCaisReportListResponse {
    caisReport?: IxcTradereportingV1CaisReportState[];
    page?: J5ListV1PageResponse;
}

export interface IxcTradereportingV1CatReportCommandServiceCreateCatReportRequest {
    // format: YYYY-MM-DD
    reportDate: string;
    mpid: string;
}

export interface IxcTradereportingV1CatReportCommandServiceCreateCatReportResponse {
    catReport: IxcTradereportingV1CatReportState;
}

export interface IxcTradereportingV1CatReportQueryServiceCatReportEventsResponse {
    events?: IxcTradereportingV1CatReportEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcTradereportingV1CatReportQueryServiceCatReportGetResponse {
    catReport: IxcTradereportingV1CatReportState;
}

export interface IxcTradereportingV1CatReportQueryServiceCatReportListResponse {
    catReport?: IxcTradereportingV1CatReportState[];
    page?: J5ListV1PageResponse;
}

export interface IxcTradereportingV1OrderBlotterServiceRecordListResponse {
    records?: IxcTradereportingV1RecordListResponseRecord[];
    page?: J5ListV1PageResponse;
}

export interface IxcTradereportingV1Sec606AReportCommandServiceCreateSec606AReportRequest {
    // format: INT32
    quarter: number;
    // format: INT32
    year: number;
    // format: INT32
    crdNumber: number;
}

export interface IxcTradereportingV1Sec606AReportCommandServiceCreateSec606AReportResponse {
    sec606AReport: IxcTradereportingV1Sec606AReportState;
}

export interface IxcTradereportingV1Sec606AReportQueryServiceSec606AReportEventsResponse {
    events?: IxcTradereportingV1Sec606AReportEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcTradereportingV1Sec606AReportQueryServiceSec606AReportGetResponse {
    sec606AReport: IxcTradereportingV1Sec606AReportState;
}

export interface IxcTradereportingV1Sec606AReportQueryServiceSec606AReportListResponse {
    sec606AReport?: IxcTradereportingV1Sec606AReportState[];
    page?: J5ListV1PageResponse;
}

export interface IxcTrfV1TrfReportQueryServiceTrfReportEventsResponse {
    events?: IxcTrfV1TrfReportEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcTrfV1TrfReportQueryServiceTrfReportGetResponse {
    trfReport: IxcTrfV1TrfReportState;
}

export interface IxcTrfV1TrfReportQueryServiceTrfReportListResponse {
    trfReport?: IxcTrfV1TrfReportState[];
    page?: J5ListV1PageResponse;
}

export interface IxcTrfV1TrfSessionCommandServiceConnectRequest {
    /* Session identifier */
    // format: id62
    sessionId: string;
}

export interface IxcTrfV1TrfSessionCommandServiceConnectResponse {
    /* Updated session state */
    session: IxcTrfV1TrfSessionState;
}

export interface IxcTrfV1TrfSessionCommandServiceDisconnectRequest {
    /* Session identifier */
    // format: id62
    sessionId: string;
}

export interface IxcTrfV1TrfSessionCommandServiceDisconnectResponse {
    /* Updated session state */
    session: IxcTrfV1TrfSessionState;
}

export interface IxcTrfV1TrfSessionCommandServiceRegisterRequest {
    /* FIX SenderCompID (tag 49) - identifies the reporting firm */
    senderCompId: string;
    /* FIX SenderSubID (tag 50) - sub-identifier within the firm */
    senderSubId: string;
    /* FIX TargetCompID (tag 56) - identifies the TRF */
    targetCompId: string;
    /* FIX TargetSubID (tag 57) - sub-identifier for the TRF venue */
    targetSubId: string;
    /* Session configuration including connection details */
    config: IxcTrfV1TrfSessionConfig;
}

export interface IxcTrfV1TrfSessionCommandServiceRegisterResponse {
    /* Created session state */
    session: IxcTrfV1TrfSessionState;
}

export interface IxcTrfV1TrfSessionCommandServiceResetSequenceNumbersRequest {
    /* Session identifier */
    // format: id62
    sessionId: string;
}

export interface IxcTrfV1TrfSessionCommandServiceResetSequenceNumbersResponse {
    /* Updated session state */
    session: IxcTrfV1TrfSessionState;
}

export interface IxcTrfV1TrfSessionCommandServiceSetSenderSeqNumRequest {
    /* New sender sequence number to set */
    // format: INT32
    seqNum: number;
    /* Whether to request gap fill from TRF after setting sequence */
    requestGapFill?: boolean;
    /* Session identifier */
    // format: id62
    sessionId: string;
}

export interface IxcTrfV1TrfSessionCommandServiceSetSenderSeqNumResponse {
    /* Updated session state */
    session: IxcTrfV1TrfSessionState;
}

export interface IxcTrfV1TrfSessionCommandServiceSetTargetSeqNumRequest {
    /* New target sequence number to set */
    // format: INT32
    seqNum: number;
    /* Session identifier */
    // format: id62
    sessionId: string;
}

export interface IxcTrfV1TrfSessionCommandServiceSetTargetSeqNumResponse {
    /* Updated session state */
    session: IxcTrfV1TrfSessionState;
}

export interface IxcTrfV1TrfSessionCommandServiceUpdateConfigRequest {
    /* Updated session configuration */
    config: IxcTrfV1TrfSessionConfig;
    /* Session identifier */
    // format: id62
    sessionId: string;
}

export interface IxcTrfV1TrfSessionCommandServiceUpdateConfigResponse {
    /* Updated session state */
    session: IxcTrfV1TrfSessionState;
}

export interface IxcTrfV1TrfSessionQueryServiceTrfSessionEventsResponse {
    events?: IxcTrfV1TrfSessionEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxcTrfV1TrfSessionQueryServiceTrfSessionGetResponse {
    trfSession: IxcTrfV1TrfSessionState;
}

export interface IxcTrfV1TrfSessionQueryServiceTrfSessionListResponse {
    trfSession?: IxcTrfV1TrfSessionState[];
    page?: J5ListV1PageResponse;
}

export interface IxfAccountingV1AccountQueryServiceAccountEventsResponse {
    events?: IxfAccountingV1AccountEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfAccountingV1AccountQueryServiceAccountGetResponse {
    account: IxfAccountingV1AccountState;
}

export interface IxfAccountingV1AccountQueryServiceAccountListResponse {
    account?: IxfAccountingV1AccountState[];
    page?: J5ListV1PageResponse;
}

export interface IxfAccountingV1AssetServiceDeltasResponse {
    deltas?: IxfAccountingV1DeltasResponseDeltas[];
    totals: IxfAccountingV1DeltasResponseTotals;
    page?: J5ListV1PageResponse;
}

export interface IxfAccountingV1CoaCommandServiceActivateAccountRequest {
    // format: id62
    accountId: string;
}

export interface IxfAccountingV1CoaCommandServiceActivateAccountResponse {
    account: IxfAccountingV1AccountState;
}

export interface IxfAccountingV1CoaCommandServiceCreateAccountRequest {
    classification: IxfAccountingV1AccountClassification;
    spec: IxfAccountingV1AccountSpec;
    mapCodes?: string[];
}

export interface IxfAccountingV1CoaCommandServiceCreateAccountResponse {
    account: IxfAccountingV1AccountState;
}

export interface IxfAccountingV1CoaCommandServiceDeactivateAccountRequest {
    // format: id62
    accountId: string;
}

export interface IxfAccountingV1CoaCommandServiceDeactivateAccountResponse {
    account: IxfAccountingV1AccountState;
}

export interface IxfAccountingV1CoaCommandServiceSetAccountCodesRequest {
    mapCodes: string[];
    // format: id62
    accountId: string;
}

export interface IxfAccountingV1CoaCommandServiceSetAccountCodesResponse {
    account: IxfAccountingV1AccountState;
}

export interface IxfAccountingV1CoaCommandServiceUpdateAccountRequest {
    spec: IxfAccountingV1AccountSpec;
    // format: id62
    accountId: string;
}

export interface IxfAccountingV1CoaCommandServiceUpdateAccountResponse {
    account: IxfAccountingV1AccountState;
}

export interface IxfAccountingV1ConfigCommandServiceSetLockOutDateRequest {
    /* The start date of the period to be closed */
    // format: YYYY-MM-DD
    lockOutDate: string;
}

export interface IxfAccountingV1ConfigCommandServiceSetLockOutDateResponse {
    config: IxfAccountingV1ConfigState;
}

export interface IxfAccountingV1ConfigQueryServiceConfigEventsResponse {
    events?: IxfAccountingV1ConfigEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfAccountingV1ConfigQueryServiceConfigGetResponse {
    config: IxfAccountingV1ConfigState;
}

export interface IxfAccountingV1ConfigQueryServiceConfigListResponse {
    config?: IxfAccountingV1ConfigState[];
    page?: J5ListV1PageResponse;
}

export interface IxfAccountingV1FileServiceUploadFileResponse {
    file: IxfAccountingV1File;
}

export interface IxfAccountingV1ManualEntryCommandServiceAddAttachmentRequest {
    file: IxfAccountingV1File;
    // format: id62
    entryId: string;
}

export interface IxfAccountingV1ManualEntryCommandServiceAddAttachmentResponse {
    manualEntry: IxfAccountingV1ManualEntryState;
}

export interface IxfAccountingV1ManualEntryCommandServiceCancelManualEntryRequest {
    reason?: string;
    // format: id62
    entryId: string;
}

export interface IxfAccountingV1ManualEntryCommandServiceCancelManualEntryResponse {
    manualEntry: IxfAccountingV1ManualEntryState;
}

export interface IxfAccountingV1ManualEntryCommandServiceCreateManualEntryRequest {
    spec: IxfAccountingV1ManualEntrySpec;
}

export interface IxfAccountingV1ManualEntryCommandServiceCreateManualEntryResponse {
    manualEntry: IxfAccountingV1ManualEntryState;
}

export interface IxfAccountingV1ManualEntryCommandServiceRemoveAttachmentRequest {
    // format: id62
    entryId: string;
    // format: id62
    fileId: string;
}

export interface IxfAccountingV1ManualEntryCommandServiceRemoveAttachmentResponse {
    manualEntry: IxfAccountingV1ManualEntryState;
}

export interface IxfAccountingV1ManualEntryCommandServiceReverseManualEntryRequest {
    reason?: string;
    // format: YYYY-MM-DD
    reverseDate: string;
    // format: id62
    entryId: string;
}

export interface IxfAccountingV1ManualEntryCommandServiceReverseManualEntryResponse {
    manualEntry: IxfAccountingV1ManualEntryState;
}

export interface IxfAccountingV1ManualEntryQueryServiceManualEntryEventsResponse {
    events?: IxfAccountingV1ManualEntryEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfAccountingV1ManualEntryQueryServiceManualEntryGetResponse {
    manualEntry: IxfAccountingV1ManualEntryState;
}

export interface IxfAccountingV1ManualEntryQueryServiceManualEntryListResponse {
    manualEntry?: IxfAccountingV1ManualEntryState[];
    page?: J5ListV1PageResponse;
}

export interface IxfAccountingV1MapCodeQueryServiceMapCodesResponse {
    mapCodes?: string[];
    page?: J5ListV1PageResponse;
}

export interface IxfAccountingV1ReportsServiceBalanceSheetResponse {
    report: IxfAccountingV1BalanceSheet;
}

export interface IxfAccountingV1ReportsServiceIncomeStatementResponse {
    report: IxfAccountingV1IncomeStatement;
}

export interface IxfAccountingV1ReportsServiceTrialBalanceResponse {
    trialBalance: IxfAccountingV1TrialBalance;
}

export interface IxfAccountingV1TransactionQueryServiceTransactionEventsResponse {
    events?: IxfAccountingV1TransactionEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfAccountingV1TransactionQueryServiceTransactionGetResponse {
    transaction: IxfAccountingV1TransactionState;
}

export interface IxfAccountingV1TransactionQueryServiceTransactionListResponse {
    transaction?: IxfAccountingV1TransactionState[];
    page?: J5ListV1PageResponse;
}

export interface IxfDocumentsV1DocumentQueryServiceDocumentEventsResponse {
    events?: IxfDocumentsV1DocumentEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfDocumentsV1DocumentQueryServiceDocumentGetResponse {
    document: IxfDocumentsV1DocumentState;
}

export interface IxfDocumentsV1DocumentQueryServiceDocumentListResponse {
    document?: IxfDocumentsV1DocumentState[];
    page?: J5ListV1PageResponse;
}

export interface IxfHoursV1ExceptionCommandServiceExceptionArchiveRequest {
    /* The unique identifier for the exception to be archived */
    // format: id62
    exceptionId: string;
}

export interface IxfHoursV1ExceptionCommandServiceExceptionArchiveResponse {
    /* The archived exception state */
    exception: IxfHoursV1ExceptionState;
}

export interface IxfHoursV1ExceptionCommandServiceExceptionCreateRequest {
    /* When provided, used as the exception ID to enable idempotent
    creation. If not provided, one will be generated. */
    // format: id62
    exceptionId?: string;
    /* The region whose schedules the exception patches */
    region: IxfHoursV1Region;
    /* The name of the exception */
    name: string;
    /* The type of the exception */
    type: IxfHoursV1ExceptionType;
    /* Whether the exception recurs every year */
    repeating?: boolean;
    /* The schedules the exception patches on the exception date */
    patch: IxfHoursV1ExceptionPatch;
    /* The observance rules for the exception */
    observance: IxfHoursV1ExceptionObservance;
    /* The IANA timezone associated with the exception, e.g., "America/New_York" */
    timezone: string;
}

export interface IxfHoursV1ExceptionCommandServiceExceptionCreateResponse {
    /* The created exception state */
    exception: IxfHoursV1ExceptionState;
}

export interface IxfHoursV1ExceptionCommandServiceExceptionUpdateRequest {
    /* The name of the exception */
    name: string;
    /* The type of the exception */
    type: IxfHoursV1ExceptionType;
    /* Whether the exception recurs every year */
    repeating?: boolean;
    /* The schedules the exception patches on the exception date */
    patch: IxfHoursV1ExceptionPatch;
    /* The observance rules for the exception */
    observance: IxfHoursV1ExceptionObservance;
    /* The IANA timezone associated with the exception, e.g., "America/New_York" */
    timezone: string;
    /* The unique identifier for the exception to be updated */
    // format: id62
    exceptionId: string;
}

export interface IxfHoursV1ExceptionCommandServiceExceptionUpdateResponse {
    /* The updated exception state */
    exception: IxfHoursV1ExceptionState;
}

export interface IxfHoursV1ExceptionQueryServiceExceptionEventsResponse {
    events?: IxfHoursV1ExceptionEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfHoursV1ExceptionQueryServiceExceptionGetResponse {
    exception: IxfHoursV1ExceptionState;
}

export interface IxfHoursV1ExceptionQueryServiceExceptionListResponse {
    exception?: IxfHoursV1ExceptionState[];
    page?: J5ListV1PageResponse;
}

export interface IxfHoursV1ExceptionSummaryCommandServiceExceptionRepublishSummariesRequest {
    /* Republish only the named summaries. If empty, all summaries are republished */
    summaries?: IxfHoursV1ExceptionSummaryName[];
    /* The number of entities to read at once for republishing */
    // format: UINT64
    batchSize?: string;
}

export interface IxfHoursV1ExceptionSummaryCommandServiceExceptionRepublishSummariesResponse {
    /* The number of states read */
    // format: INT64
    count?: string;
}

export interface IxfHoursV1MoneyMarketScheduleCommandServiceMoneyMarketScheduleApproveRequest {
    region: IxfHoursV1Region;
    exposure: IxfHoursV1ScheduleExposure;
    /* ID of the version approved as the new active version */
    // format: id62
    replaceWithVersionId: string;
}

export interface IxfHoursV1MoneyMarketScheduleCommandServiceMoneyMarketScheduleApproveResponse {
    /* The approved schedule state */
    moneyMarketSchedule: IxfHoursV1MoneyMarketScheduleState;
}

export interface IxfHoursV1MoneyMarketScheduleCommandServiceMoneyMarketScheduleCreateRequest {
    region: IxfHoursV1Region;
    exposure: IxfHoursV1ScheduleExposure;
    week: IxfHoursV1MoneyMarketWeek;
}

export interface IxfHoursV1MoneyMarketScheduleCommandServiceMoneyMarketScheduleCreateResponse {
    /* The created schedule state with a new pendingVersionId */
    moneyMarketSchedule: IxfHoursV1MoneyMarketScheduleState;
}

export interface IxfHoursV1MoneyMarketScheduleCommandServiceMoneyMarketScheduleRejectRequest {
    region: IxfHoursV1Region;
    exposure: IxfHoursV1ScheduleExposure;
    /* ID of the version to reject */
    // format: id62
    rejectedVersionId: string;
}

export interface IxfHoursV1MoneyMarketScheduleCommandServiceMoneyMarketScheduleRejectResponse {
    /* The resulting schedule state */
    moneyMarketSchedule: IxfHoursV1MoneyMarketScheduleState;
}

export interface IxfHoursV1MoneyMarketScheduleCommandServiceMoneyMarketScheduleUpdateRequest {
    region: IxfHoursV1Region;
    exposure: IxfHoursV1ScheduleExposure;
    /* ID of the version to replace */
    // format: id62
    replacesVersionId: string;
    week: IxfHoursV1MoneyMarketWeek;
}

export interface IxfHoursV1MoneyMarketScheduleCommandServiceMoneyMarketScheduleUpdateResponse {
    /* The updated schedule state with a new pendingVersionId */
    moneyMarketSchedule: IxfHoursV1MoneyMarketScheduleState;
}

export interface IxfHoursV1MoneyMarketScheduleQueryServiceMoneyMarketScheduleEventsResponse {
    events?: IxfHoursV1MoneyMarketScheduleEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfHoursV1MoneyMarketScheduleQueryServiceMoneyMarketScheduleGetResponse {
    moneyMarketSchedule: IxfHoursV1MoneyMarketScheduleState;
}

export interface IxfHoursV1MoneyMarketScheduleQueryServiceMoneyMarketScheduleListResponse {
    moneyMarketSchedule?: IxfHoursV1MoneyMarketScheduleState[];
    page?: J5ListV1PageResponse;
}

export interface IxfHoursV1MoneyMarketScheduleSummaryCommandServiceMoneyMarketScheduleRepublishSummariesRequest {
    /* Republish only the named summaries. If empty, all summaries are republished */
    summaries?: IxfHoursV1MoneyMarketScheduleSummaryName[];
    /* The number of entities to read at once for republishing */
    // format: UINT64
    batchSize?: string;
}

export interface IxfHoursV1MoneyMarketScheduleSummaryCommandServiceMoneyMarketScheduleRepublishSummariesResponse {
    /* The number of states read */
    // format: INT64
    count?: string;
}

export interface IxfHoursV1MoneyMarketScheduleVersionQueryServiceMoneyMarketScheduleVersionEventsResponse {
    events?: IxfHoursV1MoneyMarketScheduleVersionEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfHoursV1MoneyMarketScheduleVersionQueryServiceMoneyMarketScheduleVersionGetResponse {
    moneyMarketScheduleVersion: IxfHoursV1MoneyMarketScheduleVersionState;
}

export interface IxfHoursV1MoneyMarketScheduleVersionQueryServiceMoneyMarketScheduleVersionListResponse {
    moneyMarketScheduleVersion?: IxfHoursV1MoneyMarketScheduleVersionState[];
    page?: J5ListV1PageResponse;
}

export interface IxfHoursV1OperatingHoursServiceGetOperatingHoursResponse {
    /* The requested date */
    today: IxfHoursV1OperatingDay;
    /* The calendar day after the requested date */
    tomorrow: IxfHoursV1OperatingDay;
    /* Each schedule's T+1 after the requested date */
    t1: IxfHoursV1T1OperatingDays;
}

export interface IxfHoursV1TradingScheduleCommandServiceTradingScheduleApproveRequest {
    region: IxfHoursV1Region;
    exposure: IxfHoursV1ScheduleExposure;
    /* ID of the version approved as the new active version */
    // format: id62
    replaceWithVersionId: string;
}

export interface IxfHoursV1TradingScheduleCommandServiceTradingScheduleApproveResponse {
    /* The approved schedule state */
    tradingSchedule: IxfHoursV1TradingScheduleState;
}

export interface IxfHoursV1TradingScheduleCommandServiceTradingScheduleCreateRequest {
    region: IxfHoursV1Region;
    exposure: IxfHoursV1ScheduleExposure;
    week: IxfHoursV1TradingWeek;
}

export interface IxfHoursV1TradingScheduleCommandServiceTradingScheduleCreateResponse {
    /* The created schedule state with a new pendingVersionId */
    tradingSchedule: IxfHoursV1TradingScheduleState;
}

export interface IxfHoursV1TradingScheduleCommandServiceTradingScheduleRejectRequest {
    region: IxfHoursV1Region;
    exposure: IxfHoursV1ScheduleExposure;
    /* ID of the version to reject */
    // format: id62
    rejectedVersionId: string;
}

export interface IxfHoursV1TradingScheduleCommandServiceTradingScheduleRejectResponse {
    /* The resulting schedule state */
    tradingSchedule: IxfHoursV1TradingScheduleState;
}

export interface IxfHoursV1TradingScheduleCommandServiceTradingScheduleUpdateRequest {
    region: IxfHoursV1Region;
    exposure: IxfHoursV1ScheduleExposure;
    /* ID of the version to replace */
    // format: id62
    replacesVersionId: string;
    week: IxfHoursV1TradingWeek;
}

export interface IxfHoursV1TradingScheduleCommandServiceTradingScheduleUpdateResponse {
    /* The updated schedule state with a new pendingVersionId */
    tradingSchedule: IxfHoursV1TradingScheduleState;
}

export interface IxfHoursV1TradingScheduleQueryServiceTradingScheduleEventsResponse {
    events?: IxfHoursV1TradingScheduleEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfHoursV1TradingScheduleQueryServiceTradingScheduleGetResponse {
    tradingSchedule: IxfHoursV1TradingScheduleState;
}

export interface IxfHoursV1TradingScheduleQueryServiceTradingScheduleListResponse {
    tradingSchedule?: IxfHoursV1TradingScheduleState[];
    page?: J5ListV1PageResponse;
}

export interface IxfHoursV1TradingScheduleSummaryCommandServiceTradingScheduleRepublishSummariesRequest {
    /* Republish only the named summaries. If empty, all summaries are republished */
    summaries?: IxfHoursV1TradingScheduleSummaryName[];
    /* The number of entities to read at once for republishing */
    // format: UINT64
    batchSize?: string;
}

export interface IxfHoursV1TradingScheduleSummaryCommandServiceTradingScheduleRepublishSummariesResponse {
    /* The number of states read */
    // format: INT64
    count?: string;
}

export interface IxfHoursV1TradingScheduleVersionQueryServiceTradingScheduleVersionEventsResponse {
    events?: IxfHoursV1TradingScheduleVersionEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfHoursV1TradingScheduleVersionQueryServiceTradingScheduleVersionGetResponse {
    tradingScheduleVersion: IxfHoursV1TradingScheduleVersionState;
}

export interface IxfHoursV1TradingScheduleVersionQueryServiceTradingScheduleVersionListResponse {
    tradingScheduleVersion?: IxfHoursV1TradingScheduleVersionState[];
    page?: J5ListV1PageResponse;
}

export interface IxfHoursV1TransfersScheduleCommandServiceTransfersScheduleApproveRequest {
    region: IxfHoursV1Region;
    exposure: IxfHoursV1ScheduleExposure;
    /* ID of the version approved as the new active version */
    // format: id62
    replaceWithVersionId: string;
}

export interface IxfHoursV1TransfersScheduleCommandServiceTransfersScheduleApproveResponse {
    /* The approved schedule state */
    transfersSchedule: IxfHoursV1TransfersScheduleState;
}

export interface IxfHoursV1TransfersScheduleCommandServiceTransfersScheduleCreateRequest {
    region: IxfHoursV1Region;
    exposure: IxfHoursV1ScheduleExposure;
    week: IxfHoursV1TransfersWeek;
}

export interface IxfHoursV1TransfersScheduleCommandServiceTransfersScheduleCreateResponse {
    /* The created schedule state with a new pendingVersionId */
    transfersSchedule: IxfHoursV1TransfersScheduleState;
}

export interface IxfHoursV1TransfersScheduleCommandServiceTransfersScheduleRejectRequest {
    region: IxfHoursV1Region;
    exposure: IxfHoursV1ScheduleExposure;
    /* ID of the version to reject */
    // format: id62
    rejectedVersionId: string;
}

export interface IxfHoursV1TransfersScheduleCommandServiceTransfersScheduleRejectResponse {
    /* The resulting schedule state */
    transfersSchedule: IxfHoursV1TransfersScheduleState;
}

export interface IxfHoursV1TransfersScheduleCommandServiceTransfersScheduleUpdateRequest {
    region: IxfHoursV1Region;
    exposure: IxfHoursV1ScheduleExposure;
    /* ID of the version to replace */
    // format: id62
    replacesVersionId: string;
    week: IxfHoursV1TransfersWeek;
}

export interface IxfHoursV1TransfersScheduleCommandServiceTransfersScheduleUpdateResponse {
    /* The updated schedule state with a new pendingVersionId */
    transfersSchedule: IxfHoursV1TransfersScheduleState;
}

export interface IxfHoursV1TransfersScheduleQueryServiceTransfersScheduleEventsResponse {
    events?: IxfHoursV1TransfersScheduleEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfHoursV1TransfersScheduleQueryServiceTransfersScheduleGetResponse {
    transfersSchedule: IxfHoursV1TransfersScheduleState;
}

export interface IxfHoursV1TransfersScheduleQueryServiceTransfersScheduleListResponse {
    transfersSchedule?: IxfHoursV1TransfersScheduleState[];
    page?: J5ListV1PageResponse;
}

export interface IxfHoursV1TransfersScheduleSummaryCommandServiceTransfersScheduleRepublishSummariesRequest {
    /* Republish only the named summaries. If empty, all summaries are republished */
    summaries?: IxfHoursV1TransfersScheduleSummaryName[];
    /* The number of entities to read at once for republishing */
    // format: UINT64
    batchSize?: string;
}

export interface IxfHoursV1TransfersScheduleSummaryCommandServiceTransfersScheduleRepublishSummariesResponse {
    /* The number of states read */
    // format: INT64
    count?: string;
}

export interface IxfHoursV1TransfersScheduleVersionQueryServiceTransfersScheduleVersionEventsResponse {
    events?: IxfHoursV1TransfersScheduleVersionEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfHoursV1TransfersScheduleVersionQueryServiceTransfersScheduleVersionGetResponse {
    transfersScheduleVersion: IxfHoursV1TransfersScheduleVersionState;
}

export interface IxfHoursV1TransfersScheduleVersionQueryServiceTransfersScheduleVersionListResponse {
    transfersScheduleVersion?: IxfHoursV1TransfersScheduleVersionState[];
    page?: J5ListV1PageResponse;
}

export interface IxfReportsV1ReportCommandServiceReportDownloadResponse {
    /* The URL to download the report */
    url?: string;
}

export interface IxfReportsV1ReportQueryServiceReportEventsResponse {
    events?: IxfReportsV1ReportEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfReportsV1ReportQueryServiceReportGetResponse {
    report: IxfReportsV1ReportState;
}

export interface IxfReportsV1ReportQueryServiceReportListResponse {
    report?: IxfReportsV1ReportState[];
    page?: J5ListV1PageResponse;
}

export interface IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryEventsResponse {
    events?: IxfWatchlistV1Fincen314EntryEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryGetResponse {
    fincen314Entry: IxfWatchlistV1Fincen314EntryState;
}

export interface IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryListResponse {
    fincen314Entry?: IxfWatchlistV1Fincen314EntryState[];
    page?: J5ListV1PageResponse;
}

export interface IxfWatchlistV1Fincen314FileQueryServiceFincen314FileEventsResponse {
    events?: IxfWatchlistV1Fincen314FileEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfWatchlistV1Fincen314FileQueryServiceFincen314FileGetResponse {
    fincen314File: IxfWatchlistV1Fincen314FileState;
}

export interface IxfWatchlistV1Fincen314FileQueryServiceFincen314FileListResponse {
    fincen314File?: IxfWatchlistV1Fincen314FileState[];
    page?: J5ListV1PageResponse;
}

export interface IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchEventsResponse {
    events?: IxfWatchlistV1Fincen314MatchEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchGetResponse {
    fincen314Match: IxfWatchlistV1Fincen314MatchState;
}

export interface IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchListResponse {
    fincen314Match?: IxfWatchlistV1Fincen314MatchState[];
    page?: J5ListV1PageResponse;
}

export interface IxfWatchlistV1Fincen314UploadServiceUploadFincen314FileRequest {
    /* The FinCEN CSV file to ingest */
    // bytes (base64-encoded)
    file: string;
}

export interface IxfWatchlistV1Fincen314UploadServiceUploadFincen314FileResponse {
    /* The ID of the created FinCEN file */
    // format: id62
    fincen314FileId: string;
}

export interface IxfWatchlistV1MatchServiceCloseRequest {
    // format: id62
    matchId: string;
    // format: id62
    closedByUserId: string;
    listType: IxfWatchlistV1ListType;
}

export interface IxfWatchlistV1OfacFileQueryServiceOfacFileEventsResponse {
    events?: IxfWatchlistV1OfacFileEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfWatchlistV1OfacFileQueryServiceOfacFileGetResponse {
    ofacFile: IxfWatchlistV1OfacFileState;
}

export interface IxfWatchlistV1OfacFileQueryServiceOfacFileListResponse {
    ofacFile?: IxfWatchlistV1OfacFileState[];
    page?: J5ListV1PageResponse;
}

export interface IxfWatchlistV1OfacMatchQueryServiceOfacMatchEventsResponse {
    events?: IxfWatchlistV1OfacMatchEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfWatchlistV1OfacMatchQueryServiceOfacMatchGetResponse {
    ofacMatch: IxfWatchlistV1OfacMatchState;
}

export interface IxfWatchlistV1OfacMatchQueryServiceOfacMatchListResponse {
    ofacMatch?: IxfWatchlistV1OfacMatchState[];
    page?: J5ListV1PageResponse;
}

export interface IxfWatchlistV1OfacSdnQueryServiceOfacSdnEventsResponse {
    events?: IxfWatchlistV1OfacSdnEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxfWatchlistV1OfacSdnQueryServiceOfacSdnGetResponse {
    ofacSdn: IxfWatchlistV1OfacSdnState;
}

export interface IxfWatchlistV1OfacSdnQueryServiceOfacSdnListResponse {
    ofacSdn?: IxfWatchlistV1OfacSdnState[];
    page?: J5ListV1PageResponse;
}

export interface IxmAgentauthOauthV1AgentAuthServiceApproveAuthorizationRequestRequest {
    request?: string;
    // format: id62
    agentId?: string;
}

export interface IxmAgentauthOauthV1AgentAuthServiceApproveAuthorizationRequestResponse {
    /* The client's redirect_uri with code, state and iss */
    redirectTo: string;
}

export interface IxmAgentauthOauthV1AgentAuthServiceDenyAuthorizationRequestRequest {
    request?: string;
}

export interface IxmAgentauthOauthV1AgentAuthServiceDenyAuthorizationRequestResponse {
    redirectTo: string;
}

export interface IxmAgentauthOauthV1AgentAuthServiceInspectAuthorizationRequestRequest {
    /* The signed request from the consent URL fragment. */
    request?: string;
}

export interface IxmAgentauthOauthV1AgentAuthServiceInspectAuthorizationRequestResponse {
    clientName: string;
    /* https URL of the Client ID Metadata Document. */
    clientId: string;
    /* Exactly as requested, including a loopback port. */
    redirectUri: string;
    /* Canonical RFC 8707 resource. */
    resource: string;
    /* After this, the request can no longer be approved. */
    // format: date-time
    expiresAt: string;
}

export interface IxmAgentauthV1AgentKeyCommandServiceArchiveAgentKeyRequest {
    // format: id62
    clientId: string;
}

export interface IxmAgentauthV1AgentKeyCommandServiceArchiveAgentKeyResponse {
    agentKey: IxmAgentauthV1AgentKeyState;
}

export interface IxmAgentauthV1AgentKeyCommandServiceCreateAgentKeyRequest {
    spec: IxmAgentauthV1AgentKeySpec;
}

export interface IxmAgentauthV1AgentKeyCommandServiceCreateAgentKeyResponse {
    agentKey: IxmAgentauthV1AgentKeyState;
}

export interface IxmAgentauthV1AgentKeyCommandServiceUpdateAgentKeyRequest {
    name?: string;
    // format: id62
    clientId: string;
}

export interface IxmAgentauthV1AgentKeyCommandServiceUpdateAgentKeyResponse {
    agentKey: IxmAgentauthV1AgentKeyState;
}

export interface IxmAgentauthV1AgentKeyQueryServiceAgentKeyEventsResponse {
    events?: IxmAgentauthV1AgentKeyEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxmAgentauthV1AgentKeyQueryServiceAgentKeyGetResponse {
    agentKey: IxmAgentauthV1AgentKeyState;
}

export interface IxmAgentauthV1AgentKeyQueryServiceAgentKeyListResponse {
    agentKey?: IxmAgentauthV1AgentKeyState[];
    page?: J5ListV1PageResponse;
}

export interface IxmAuthV1ApiAuthServiceGetTokenRequest {
    // format: id62
    clientId: string;
    clientSecret: string;
}

export interface IxmAuthV1ApiAuthServiceGetTokenResponse {
    jwt: string;
}

export interface IxmAuthV1ApiAuthServiceWhoamiResponse {
    actor?: J5AuthV1Actor;
}

export interface IxmAuthV1ApiKeyCommandServiceArchiveApiKeyRequest {
    // format: id62
    clientId: string;
}

export interface IxmAuthV1ApiKeyCommandServiceArchiveApiKeyResponse {
    apiKey: IxmAuthV1ApiKeyState;
}

export interface IxmAuthV1ApiKeyCommandServiceCreateApiKeyRequest {
    spec: IxmAuthV1ApiKeySpec;
}

export interface IxmAuthV1ApiKeyCommandServiceCreateApiKeyResponse {
    apiKey: IxmAuthV1ApiKeyState;
    clientSecret: string;
}

export interface IxmAuthV1ApiKeyCommandServiceUpdateApiKeyRequest {
    spec: IxmAuthV1ApiKeySpec;
    // format: id62
    clientId: string;
}

export interface IxmAuthV1ApiKeyCommandServiceUpdateApiKeyResponse {
    apiKey: IxmAuthV1ApiKeyState;
}

export interface IxmAuthV1ApiKeyQueryServiceApiKeyEventsResponse {
    events?: IxmAuthV1ApiKeyEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxmAuthV1ApiKeyQueryServiceApiKeyGetResponse {
    apiKey: IxmAuthV1ApiKeyState;
}

export interface IxmAuthV1ApiKeyQueryServiceApiKeyListResponse {
    apiKey?: IxmAuthV1ApiKeyState[];
    page?: J5ListV1PageResponse;
}

export interface IxmEmailV1EmailSandboxServiceGetEmailResponse {
    email: IxmEmailV1Email;
}

export interface IxmEmailV1EmailSandboxServiceListEmailsResponse {
    emails?: IxmEmailV1Email[];
    page?: J5ListV1PageResponse;
}

export interface IxmEventsV1PollServiceReceiveResponse {
    page?: J5ListV1PageResponse;
    events?: IxmEventsV1Event[];
}

export interface IxmEventsV1TargetCommandServiceArchiveTargetRequest {
    // format: id62
    targetId: string;
}

export interface IxmEventsV1TargetCommandServiceArchiveTargetResponse {
    target: IxmEventsV1TargetState;
}

export interface IxmEventsV1TargetCommandServiceCreateTargetRequest {
    /* When provided, used as the target ID to enable idempotent
    creation. If not provided, one will be generated. */
    // format: id62
    targetId?: string;
    // format: id62
    programId?: string;
    spec: IxmEventsV1TargetSpec;
}

export interface IxmEventsV1TargetCommandServiceCreateTargetResponse {
    target: IxmEventsV1TargetState;
}

export interface IxmEventsV1TargetCommandServiceTestTargetRequest {
    // format: id62
    targetId: string;
}

export interface IxmEventsV1TargetCommandServiceTestTargetResponse {
    targetResponse: IxmEventsV1DestinationResponse;
}

export interface IxmEventsV1TargetQueryServiceTargetEventsResponse {
    events?: IxmEventsV1TargetEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxmEventsV1TargetQueryServiceTargetGetResponse {
    target: IxmEventsV1TargetState;
}

export interface IxmEventsV1TargetQueryServiceTargetListResponse {
    target?: IxmEventsV1TargetState[];
    page?: J5ListV1PageResponse;
}

export interface IxmMcpV1McpServiceGetCapabilitiesResponse {
    /* api_command and generate_id62 are available to agent keys with write scopes. */
    commandsEnabled?: boolean;
}

export interface IxmTriggerV1TriggerCommandServiceManualTriggerRequest {
    /* The time the trigger is for */
    // format: date-time
    triggerTime: string;
    // format: id62
    triggerId: string;
}

export interface IxmTriggerV1TriggerCommandServiceManualTriggerResponse {
    trigger: IxmTriggerV1TriggerState;
}

export interface IxmTriggerV1TriggerCommandServicePauseTriggerRequest {
    // format: id62
    triggerId: string;
}

export interface IxmTriggerV1TriggerCommandServicePauseTriggerResponse {
    trigger: IxmTriggerV1TriggerState;
}

export interface IxmTriggerV1TriggerCommandServiceResumeTriggerRequest {
    // format: id62
    triggerId: string;
}

export interface IxmTriggerV1TriggerCommandServiceResumeTriggerResponse {
    trigger: IxmTriggerV1TriggerState;
}

export interface IxmTriggerV1TriggerQueryServiceTriggerEventsResponse {
    events?: IxmTriggerV1TriggerEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxmTriggerV1TriggerQueryServiceTriggerGetResponse {
    trigger: IxmTriggerV1TriggerState;
}

export interface IxmTriggerV1TriggerQueryServiceTriggerListResponse {
    trigger?: IxmTriggerV1TriggerState[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1AccessRequestAdminCommandServiceApproveAccessRequestRequest {
    spec: IxmUserauthV1ApproveAccessRequestSpec;
    // format: id62
    accessRequestId: string;
}

export interface IxmUserauthV1AccessRequestAdminCommandServiceApproveAccessRequestResponse {
    accessRequest: IxmUserauthV1AccessRequestState;
}

export interface IxmUserauthV1AccessRequestAdminCommandServiceRejectAccessRequestRequest {
    reason?: string;
    // format: id62
    accessRequestId: string;
}

export interface IxmUserauthV1AccessRequestAdminCommandServiceRejectAccessRequestResponse {
    accessRequest: IxmUserauthV1AccessRequestState;
}

export interface IxmUserauthV1AccessRequestCommandServiceCreateAccessRequestRequest {
    spec: IxmUserauthV1AccessRequestSpec;
}

export interface IxmUserauthV1AccessRequestQueryServiceAccessRequestEventsResponse {
    events?: IxmUserauthV1AccessRequestEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1AccessRequestQueryServiceAccessRequestGetResponse {
    accessRequest: IxmUserauthV1AccessRequestState;
}

export interface IxmUserauthV1AccessRequestQueryServiceAccessRequestListResponse {
    accessRequest?: IxmUserauthV1AccessRequestState[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1ArtifactCommandServiceArchiveArtifactRequest {
    // format: id62
    artifactId: string;
}

export interface IxmUserauthV1ArtifactCommandServiceArchiveArtifactResponse {
    artifact: IxmUserauthV1ArtifactState;
}

export interface IxmUserauthV1ArtifactCommandServiceCreateArtifactRequest {
    // format: id62
    programId: string;
    type: IxmUserauthV1ArtifactType;
    /* The file to be uploaded, sent as base64-encoded bytes */
    // bytes (base64-encoded)
    file: string;
    name?: string;
    description?: string;
}

export interface IxmUserauthV1ArtifactCommandServiceCreateArtifactResponse {
    artifact: IxmUserauthV1ArtifactState;
}

export interface IxmUserauthV1ArtifactDownloadServiceDownloadArtifactBundleRequest {
    // format: id62
    programId: string;
    // format: id62
    artifactIds: string[];
}

export interface IxmUserauthV1ArtifactDownloadServiceDownloadArtifactBundleResponse {
    artifacts?: IxmUserauthV1DownloadArtifactBundleResponseArtifacts[];
}

export interface IxmUserauthV1ArtifactQueryServiceArtifactEventsResponse {
    events?: IxmUserauthV1ArtifactEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1ArtifactQueryServiceArtifactGetResponse {
    artifact: IxmUserauthV1ArtifactState;
}

export interface IxmUserauthV1ArtifactQueryServiceArtifactListResponse {
    artifact?: IxmUserauthV1ArtifactState[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1BrandingVersionCommandServiceCancelBrandingVersionRequest {
    reason?: string;
    // format: id62
    brandingVersionId: string;
}

export interface IxmUserauthV1BrandingVersionCommandServiceCancelBrandingVersionResponse {
    brandingVersion: IxmUserauthV1BrandingVersionState;
}

export interface IxmUserauthV1BrandingVersionCommandServiceCheckResultBrandingVersionRequest {
    checkType: string;
    outcome: IxmUserauthV1BrandingVersionCheckOutcome;
    // format: id62
    brandingVersionId: string;
}

export interface IxmUserauthV1BrandingVersionCommandServiceCheckResultBrandingVersionResponse {
    brandingVersion: IxmUserauthV1BrandingVersionState;
}

export interface IxmUserauthV1BrandingVersionQueryServiceBrandingVersionEventsResponse {
    events?: IxmUserauthV1BrandingVersionEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1BrandingVersionQueryServiceBrandingVersionGetResponse {
    brandingVersion: IxmUserauthV1BrandingVersionState;
}

export interface IxmUserauthV1BrandingVersionQueryServiceBrandingVersionListResponse {
    brandingVersion?: IxmUserauthV1BrandingVersionState[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1InvitationServiceAcceptOrganizationMemberInvitationRequest {
    token: IxmUserauthV1Token;
}

export interface IxmUserauthV1InvitationServiceCheckOrganizationMemberInvitationResponse {
    invitation: IxmUserauthV1OrganizationMemberInvitationState;
}

export interface IxmUserauthV1InvitationServiceDeclineOrganizationMemberInvitationRequest {
    token: IxmUserauthV1Token;
}

export interface IxmUserauthV1OrganizationCommandServiceCreateOrganizationRequest {
    // format: id62
    id?: string;
    name: string;
}

export interface IxmUserauthV1OrganizationCommandServiceCreateOrganizationResponse {
    organization: IxmUserauthV1OrganizationState;
}

export interface IxmUserauthV1OrganizationCommandServiceUpdateOrganizationRequest {
    update: IxmUserauthV1OrganizationUpdate;
    // format: id62
    organizationId: string;
}

export interface IxmUserauthV1OrganizationCommandServiceUpdateOrganizationResponse {
    organization: IxmUserauthV1OrganizationState;
}

export interface IxmUserauthV1OrganizationMemberCommandServiceRemoveOrganizationMemberRequest {
    // format: id62
    organizationId: string;
    // format: id62
    userId: string;
}

export interface IxmUserauthV1OrganizationMemberCommandServiceSetOrganizationMemberDesignationsRequest {
    designations: IxmUserauthV1OrganizationMemberDesignations;
    // format: id62
    userId: string;
    // format: id62
    organizationId: string;
}

export interface IxmUserauthV1OrganizationMemberCommandServiceSetOrganizationMemberDesignationsResponse {
    designations: IxmUserauthV1OrganizationMemberDesignations;
}

export interface IxmUserauthV1OrganizationMemberCommandServiceSetOrganizationMemberPermissionsRequest {
    permissions?: IxmUserauthV1OrganizationMemberPermissions;
    // format: id62
    organizationId: string;
    // format: id62
    userId: string;
}

export interface IxmUserauthV1OrganizationMemberCommandServiceSetOrganizationMemberPermissionsResponse {
    member: IxmUserauthV1OrganizationMemberState;
}

export interface IxmUserauthV1OrganizationMemberInvitationCommandServiceCreateOrganizationMemberInvitationRequest {
    // format: id62
    invitationId?: string;
    // format: id62
    organizationId: string;
    /* When set, an invitation will be sent to the specified email
    address, otherwise the response will contain a link to accept
    the invitation The invitation will be valid for
    AcceptInvitation here, and RegisterRequest in the session
    service, when the system is configured for invite-only. The
    email address which the user actually uses to register may be
    different. */
    email?: string;
    /* When set, will populate email template (if email is provided)
    and pre-fill the fields in the portal's registration form */
    profile?: IxmUserauthV1UserProfile;
    /* The initial permissions for the user in this role */
    permissions: IxmUserauthV1OrganizationMemberPermissions;
    /* The number of days before the invitation expires, and will
    default to 30 days if not set */
    // format: INT32
    expiresInDays?: number;
}

export interface IxmUserauthV1OrganizationMemberInvitationCommandServiceCreateOrganizationMemberInvitationResponse {
    invitation: IxmUserauthV1OrganizationMemberInvitationState;
}

export interface IxmUserauthV1OrganizationMemberInvitationCommandServiceRevokeOrganizationMemberInvitationRequest {
    // format: id62
    organizationId: string;
    // format: id62
    invitationId: string;
}

export interface IxmUserauthV1OrganizationMemberInvitationCommandServiceRevokeOrganizationMemberInvitationResponse {
    invitation: IxmUserauthV1OrganizationMemberInvitationState;
}

export interface IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationEventsResponse {
    events?: IxmUserauthV1OrganizationMemberInvitationEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationGetResponse {
    organizationMemberInvitation: IxmUserauthV1OrganizationMemberInvitationState;
}

export interface IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationListResponse {
    organizationMemberInvitation?: IxmUserauthV1OrganizationMemberInvitationState[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberEventsResponse {
    events?: IxmUserauthV1OrganizationMemberEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberGetResponse {
    organizationMember: IxmUserauthV1OrganizationMemberState;
}

export interface IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberListResponse {
    organizationMember?: IxmUserauthV1OrganizationMemberState[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1OrganizationQueryServiceOrganizationEventsResponse {
    events?: IxmUserauthV1OrganizationEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1OrganizationQueryServiceOrganizationGetResponse {
    organization: IxmUserauthV1OrganizationState;
}

export interface IxmUserauthV1OrganizationQueryServiceOrganizationListResponse {
    organization?: IxmUserauthV1OrganizationState[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1ProgramCommandServiceUpdateBrandingRequest {
    /* Required if a branding version is being updated instead of created */
    // format: id62
    replacesVersionId?: string;
    logo?: IxmUserauthV1SetArtifact;
    logoMark?: IxmUserauthV1SetArtifact;
    colors?: IxmUserauthV1Colors;
    mainFont?: IxmUserauthV1SetFontType;
    monoFont?: IxmUserauthV1SetFontType;
    // format: id62
    programId: string;
}

export interface IxmUserauthV1ProgramCommandServiceUpdateBrandingResponse {
    program: IxmUserauthV1ProgramState;
}

export interface IxmUserauthV1ProgramCommandServiceUpdateProgramRequest {
    update: IxmUserauthV1UpdateProgramRequestUpdate;
    // format: id62
    programId: string;
}

export interface IxmUserauthV1ProgramCommandServiceUpdateProgramResponse {
    program: IxmUserauthV1ProgramState;
}

export interface IxmUserauthV1ProgramQueryServiceProgramEventsResponse {
    events?: IxmUserauthV1ProgramEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1ProgramQueryServiceProgramGetResponse {
    program: IxmUserauthV1ProgramState;
}

export interface IxmUserauthV1ProgramQueryServiceProgramListResponse {
    program?: IxmUserauthV1ProgramState[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1ProgramTenantServiceCreateProgramTenantRequest {
    // format: id62
    programId?: string;
    realmId: string;
    // format: id62
    organizationId: string;
    // format: custom - pattern: ^[A-Z]{4}$
    programCode: string;
    programSpec: IxmUserauthV1ProgramSpec;
    tenantSpec: IxmUserauthV1TenantSpec;
}

export interface IxmUserauthV1ProgramTenantServiceCreateProgramTenantResponse {
    // format: id62
    programId: string;
    realmId: string;
    programSpec: IxmUserauthV1ProgramSpec;
    tenantSpec: IxmUserauthV1TenantSpec;
}

export interface IxmUserauthV1RealmAccessCommandServiceSetRealmAccessRequest {
    // format: id62
    realmAccessId?: string;
    // format: id62
    organizationId: string;
    // format: id62
    tenantId: string;
    spec: IxmUserauthV1RealmAccessSpec;
    // format: id62
    realmId: string;
}

export interface IxmUserauthV1RealmAccessCommandServiceSetRealmAccessResponse {
    access: IxmUserauthV1RealmAccessState;
}

export interface IxmUserauthV1RealmAccessQueryServiceRealmAccessEventsResponse {
    events?: IxmUserauthV1RealmAccessEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1RealmAccessQueryServiceRealmAccessGetResponse {
    realmAccess: IxmUserauthV1RealmAccessState;
}

export interface IxmUserauthV1RealmAccessQueryServiceRealmAccessListResponse {
    realmAccess?: IxmUserauthV1RealmAccessState[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1RealmAccessTokenServiceGetRealmAccessTokenResponse {
    token: string;
}

export interface IxmUserauthV1RealmQueryServiceRealmEventsResponse {
    events?: IxmUserauthV1RealmEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1RealmQueryServiceRealmGetResponse {
    realm: IxmUserauthV1RealmState;
}

export interface IxmUserauthV1RealmQueryServiceRealmListResponse {
    realm?: IxmUserauthV1RealmState[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1RoleCommandServiceArchiveRoleRequest {
    // format: id62
    roleId: string;
}

export interface IxmUserauthV1RoleCommandServiceCreateRoleRequest {
    // format: id62
    roleId?: string;
    // format: id62
    organizationId: string;
    spec: IxmUserauthV1RoleSpec;
}

export interface IxmUserauthV1RoleCommandServiceCreateRoleResponse {
    role: IxmUserauthV1RoleState;
}

export interface IxmUserauthV1RoleCommandServiceUpdateRoleRequest {
    spec: IxmUserauthV1RoleSpec;
    // format: id62
    roleId: string;
}

export interface IxmUserauthV1RoleCommandServiceUpdateRoleResponse {
    role: IxmUserauthV1RoleState;
}

export interface IxmUserauthV1RoleQueryServiceRoleEventsResponse {
    events?: IxmUserauthV1RoleEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1RoleQueryServiceRoleGetResponse {
    role: IxmUserauthV1RoleState;
}

export interface IxmUserauthV1RoleQueryServiceRoleListResponse {
    role?: IxmUserauthV1RoleState[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1SessionServiceConfirmMfaRequest {
    otp?: string;
    secret?: string;
}

export interface IxmUserauthV1SessionServiceConfirmMfaResponse {
    recoveryCode?: string;
}

export interface IxmUserauthV1SessionServiceForgotPasswordRequest {
    email: string;
    /* This is the token generated by the recaptcha-v3 widget, will be
    validated with google. */
    recaptchaToken?: string;
}

export interface IxmUserauthV1SessionServiceForgotPasswordResponse {
    emailId?: string;
}

export interface IxmUserauthV1SessionServiceGetMfaSecretResponse {
    secret?: string;
    url?: string;
}

export interface IxmUserauthV1SessionServiceLoginRequest {
    credentials: IxmUserauthV1LoginRequestCredentials;
}

export interface IxmUserauthV1SessionServiceLoginResponse {
    user?: IxmUserauthV1UserState;
    newRecoveryCode?: string;
}

export interface IxmUserauthV1SessionServiceRegisterRequest {
    email?: string;
    password?: string;
    profile?: IxmUserauthV1UserProfile;
    /* When this is required, the service is by-invite-only, but when
    optional, not setting it just creates a new empty user. The
    service settings will determine which is active. */
    acceptInvitation?: IxmUserauthV1Token;
}

export interface IxmUserauthV1SessionServiceRegisterResponse {
    user?: IxmUserauthV1UserState;
}

export interface IxmUserauthV1SessionServiceRemoveMfaRequest {
    password?: string;
    otp?: string;
}

export interface IxmUserauthV1SessionServiceResetMfaRecoveryCodeRequest {
    password?: string;
    otp?: string;
}

export interface IxmUserauthV1SessionServiceResetMfaRecoveryCodeResponse {
    recoveryCode?: string;
}

export interface IxmUserauthV1SessionServiceSetPasswordRequest {
    /* Should be specified twice in the UI, but the API isn't going to
    check. */
    newPassword?: string;
    method: IxmUserauthV1SetPasswordRequestMethod;
}

export interface IxmUserauthV1SessionServiceUpdateMfaRequest {
    password?: string;
    currentFactorOtp?: string;
    secret?: string;
    newFactorOtp?: string;
}

export interface IxmUserauthV1SessionServiceUpdateMfaResponse {
    recoveryCode?: string;
}

export interface IxmUserauthV1SessionServiceWhoamiResponse {
    user?: IxmUserauthV1UserState;
    hasMfa?: boolean;
    organizations?: IxmUserauthV1JoinedOrganizationMember[];
    realms?: IxmUserauthV1JoinedRealmAccess[];
    // format: date-time
    sessionExpiry?: string;
    // format: id62
    sessionId?: string;
}

export interface IxmUserauthV1TenantQueryServiceTenantEventsResponse {
    events?: IxmUserauthV1TenantEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1TenantQueryServiceTenantGetResponse {
    tenant: IxmUserauthV1TenantState;
}

export interface IxmUserauthV1TenantQueryServiceTenantListResponse {
    tenant?: IxmUserauthV1TenantState[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1UserCommandServiceSetUserPreferencesRequest {
    preferences: IxmUserauthV1UserPreferences;
    // format: id62
    userId: string;
}

export interface IxmUserauthV1UserCommandServiceSetUserPreferencesResponse {
    preferences: IxmUserauthV1UserPreferences;
}

export interface IxmUserauthV1UserCommandServiceSetUserProfileRequest {
    profile: IxmUserauthV1UserProfile;
    // format: id62
    userId: string;
}

export interface IxmUserauthV1UserCommandServiceSetUserProfileResponse {
    profile: IxmUserauthV1UserProfile;
}

export interface IxmUserauthV1UserQueryServiceUserEventsResponse {
    events?: IxmUserauthV1UserEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1UserQueryServiceUserGetResponse {
    user: IxmUserauthV1UserState;
}

export interface IxmUserauthV1UserQueryServiceUserListResponse {
    user?: IxmUserauthV1UserState[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1UserSessionCommandServiceEndSessionRequest {
    // format: id62
    sessionId: string;
}

export interface IxmUserauthV1UserSessionCommandServiceRefreshSessionRequest {
    // format: id62
    sessionId: string;
}

export interface IxmUserauthV1UserSessionCommandServiceRefreshSessionResponse {
    // format: date-time
    expiresAt: string;
}

export interface IxmUserauthV1UserSessionQueryServiceUserSessionEventsResponse {
    events?: IxmUserauthV1UserSessionEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxmUserauthV1UserSessionQueryServiceUserSessionGetResponse {
    userSession: IxmUserauthV1UserSessionState;
}

export interface IxmUserauthV1UserSessionQueryServiceUserSessionListResponse {
    userSession?: IxmUserauthV1UserSessionState[];
    page?: J5ListV1PageResponse;
}

export interface IxtBuildsV1RepoCommandServiceConfigureRepoRequest {
    checksEnabled?: boolean;
    hooks?: IxtBuildsV1Hook[];
    latest?: string;
    // format: informal
    owner: string;
    // format: informal
    name: string;
}

export interface IxtBuildsV1RepoCommandServiceConfigureRepoResponse {
    repo: IxtBuildsV1RepoState;
}

export interface IxtBuildsV1RepoCommandServiceTriggerRequest {
    commit: string;
    action: IxtBuildsV1Action;
    owner: string;
    repo: string;
}

export interface IxtBuildsV1RepoCommandServiceTriggerResponse {
    targets: string[];
}

export interface IxtBuildsV1RepoQueryServiceRepoEventsResponse {
    events?: IxtBuildsV1RepoEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxtBuildsV1RepoQueryServiceRepoGetResponse {
    repo: IxtBuildsV1RepoState;
}

export interface IxtBuildsV1RepoQueryServiceRepoListResponse {
    repo?: IxtBuildsV1RepoState[];
    page?: J5ListV1PageResponse;
}

export interface IxtE2eV1EnvironmentsServiceListEnvironmentsResponse {
    environments: string[];
}

export interface IxtE2eV1TestRunCommandServiceTestRunCancelRequest {
    /* The environment that testRunId is associated with */
    environment: string;
    /* Optional reason for canceling the test run */
    reason?: string;
    /* The unique identifier for the test run to cancel */
    // format: id62
    testRunId: string;
}

export interface IxtE2eV1TestRunCommandServiceTestRunCancelResponse {
    /* The state of the canceled test run */
    testRunState: IxtE2eV1TestRunState;
}

export interface IxtE2eV1TestRunCommandServiceTestRunMarkFailedRequest {
    /* The environment that testRunId is associated with */
    environment: string;
    /* Optional reason for marking the test run as a failure */
    reason?: string;
    /* The unique identifier for the test run to cancel */
    // format: id62
    testRunId: string;
}

export interface IxtE2eV1TestRunCommandServiceTestRunMarkFailedResponse {
    /* The state of the updated test run */
    testRunState: IxtE2eV1TestRunState;
}

export interface IxtE2eV1TestRunCommandServiceTestRunSubmitRequest {
    /* The unique identifier for the test run */
    // format: id62
    testRunId?: string;
    /* The environment in which to run the test */
    environment: string;
}

export interface IxtE2eV1TestRunCommandServiceTestRunSubmitResponse {
    /* The state of the canceled test run */
    testRun: IxtE2eV1TestRunState;
}

export interface IxtE2eV1TestRunQueryServiceTestRunEventsResponse {
    events?: IxtE2eV1TestRunEvent[];
    page?: J5ListV1PageResponse;
}

export interface IxtE2eV1TestRunQueryServiceTestRunGetResponse {
    testRun: IxtE2eV1TestRunState;
}

export interface IxtE2eV1TestRunQueryServiceTestRunListResponse {
    testRun?: IxtE2eV1TestRunState[];
    page?: J5ListV1PageResponse;
}

export interface J5RegistryV1ArtifactQueryServiceArtifactEventsResponse {
    events?: J5RegistryV1ArtifactEvent[];
    page?: J5ListV1PageResponse;
}

export interface J5RegistryV1ArtifactQueryServiceArtifactGetResponse {
    artifact: J5RegistryV1ArtifactState;
}

export interface J5RegistryV1ArtifactQueryServiceArtifactListResponse {
    artifact?: J5RegistryV1ArtifactState[];
    page?: J5ListV1PageResponse;
}

export interface J5RegistryV1DownloadServiceDownloadClientApiPackageResponse {
    version?: string;
    api?: J5ClientV1Api;
}

export interface J5RegistryV1DownloadServiceDownloadClientApiResponse {
    version?: string;
    api?: J5ClientV1Api;
}

export interface J5RegistryV1DownloadServiceListPackagesResponse {
    version?: string;
    packages?: J5ClientV1ApiSummary;
}

export interface O5AwsDeployerV1ClusterCommandServiceSetClusterOverrideRequest {
    overrides?: O5AwsDeployerV1ParameterOverride[];
    /* ID or name */
    clusterId: string;
}

export interface O5AwsDeployerV1ClusterCommandServiceSetClusterOverrideResponse {
    state: O5AwsDeployerV1ClusterState;
}

export interface O5AwsDeployerV1ClusterCommandServiceUpsertClusterRequest {
    /* Either a UUID, or the cluster's full name */
    clusterId?: string;
    /* if combined contains environments, they will also be
    upserted. */
    src?: O5AwsDeployerV1UpsertClusterRequestSrc;
}

export interface O5AwsDeployerV1ClusterCommandServiceUpsertClusterResponse {
    state: O5AwsDeployerV1ClusterState;
}

export interface O5AwsDeployerV1ClusterQueryServiceClusterEventsResponse {
    events?: O5AwsDeployerV1ClusterEvent[];
    page?: J5ListV1PageResponse;
}

export interface O5AwsDeployerV1ClusterQueryServiceClusterGetResponse {
    cluster: O5AwsDeployerV1ClusterState;
}

export interface O5AwsDeployerV1ClusterQueryServiceClusterListResponse {
    cluster?: O5AwsDeployerV1ClusterState[];
    page?: J5ListV1PageResponse;
}

export interface O5AwsDeployerV1DeploymentCommandServiceTerminateDeploymentRequest {
    // format: uuid
    deploymentId: string;
}

export interface O5AwsDeployerV1DeploymentCommandServiceTriggerDeploymentRequest {
    /* Should be either a UUID, or the environment's full name */
    environment?: string;
    source?: O5AwsDeployerV1Source;
    /* Name of the application to deploy when the source repo
    defines more than one (multiple files in ext/o5/). Optional
    for single-app repos. */
    application?: string;
    flags?: O5AwsDeployerV1DeploymentFlags;
    /* PIN for deleting/recreating/wiping the database */
    databasePin?: string;
    // format: uuid
    deploymentId: string;
}

export interface O5AwsDeployerV1DeploymentCommandServiceTriggerDeploymentResponse {
    // format: uuid
    deploymentId?: string;
    // format: uuid
    environmentId?: string;
    // format: uuid
    clusterId?: string;
}

export interface O5AwsDeployerV1DeploymentQueryServiceDeploymentEventsResponse {
    events?: O5AwsDeployerV1DeploymentEvent[];
    page?: J5ListV1PageResponse;
}

export interface O5AwsDeployerV1DeploymentQueryServiceDeploymentGetResponse {
    deployment: O5AwsDeployerV1DeploymentState;
}

export interface O5AwsDeployerV1DeploymentQueryServiceDeploymentListResponse {
    deployment?: O5AwsDeployerV1DeploymentState[];
    page?: J5ListV1PageResponse;
}

export interface O5AwsDeployerV1EnvironmentCommandServiceUpsertEnvironmentRequest {
    /* Either a UUID or the cluster's name */
    clusterId?: string;
    src?: O5AwsDeployerV1UpsertEnvironmentRequestSrc;
    /* Either a UUID, or the environment's full name */
    environmentId: string;
}

export interface O5AwsDeployerV1EnvironmentCommandServiceUpsertEnvironmentResponse {
    state: O5AwsDeployerV1EnvironmentState;
}

export interface O5AwsDeployerV1EnvironmentQueryServiceEnvironmentEventsResponse {
    events?: O5AwsDeployerV1EnvironmentEvent[];
    page?: J5ListV1PageResponse;
}

export interface O5AwsDeployerV1EnvironmentQueryServiceEnvironmentGetResponse {
    environment: O5AwsDeployerV1EnvironmentState;
}

export interface O5AwsDeployerV1EnvironmentQueryServiceEnvironmentListResponse {
    environment?: O5AwsDeployerV1EnvironmentState[];
    page?: J5ListV1PageResponse;
}

export interface O5AwsDeployerV1StackCommandServiceUpsertStackRequest {
    /* Should be either a UUID, or the env-app style name for the stack. */
    stackId: string;
}

export interface O5AwsDeployerV1StackCommandServiceUpsertStackResponse {
    state: O5AwsDeployerV1StackState;
}

export interface O5AwsDeployerV1StackQueryServiceStackEventsResponse {
    events?: O5AwsDeployerV1StackEvent[];
    page?: J5ListV1PageResponse;
}

export interface O5AwsDeployerV1StackQueryServiceStackGetResponse {
    stack: O5AwsDeployerV1StackState;
}

export interface O5AwsDeployerV1StackQueryServiceStackListResponse {
    stack?: O5AwsDeployerV1StackState[];
    page?: J5ListV1PageResponse;
}

export interface O5DanteV1DeadMessageCommandServiceRejectDeadMessageRequest {
    reason?: string;
    // format: uuid
    messageId: string;
}

export interface O5DanteV1DeadMessageCommandServiceRejectDeadMessageResponse {
    message: O5DanteV1DeadMessageState;
}

export interface O5DanteV1DeadMessageCommandServiceReplayDeadMessageRequest {
    // format: uuid
    messageId: string;
}

export interface O5DanteV1DeadMessageCommandServiceReplayDeadMessageResponse {
    message: O5DanteV1DeadMessageState;
}

export interface O5DanteV1DeadMessageCommandServiceUpdateDeadMessageRequest {
    // format: uuid
    replacesVersionId: string;
    // format: uuid
    versionId?: string;
    message: O5DanteV1DeadMessageVersion;
    // format: uuid
    messageId: string;
}

export interface O5DanteV1DeadMessageCommandServiceUpdateDeadMessageResponse {
    message: O5DanteV1DeadMessageState;
}

export interface O5DanteV1DeadMessageQueryServiceDeadMessageEventsResponse {
    events?: O5DanteV1DeadMessageEvent[];
    page?: J5ListV1PageResponse;
}

export interface O5DanteV1DeadMessageQueryServiceDeadMessageGetResponse {
    deadMessage: O5DanteV1DeadMessageState;
}

export interface O5DanteV1DeadMessageQueryServiceDeadMessageListResponse {
    deadMessage?: O5DanteV1DeadMessageState[];
    page?: J5ListV1PageResponse;
}

export interface ExcDtcDtccaV1ActionHeader {
    /* Underlying security CUSIP from CorpActnGnlInf > UndrlygScty */
    cusip: string;
    /* Resolved asset for the underlying CUSIP */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* DTC corporate action event identifier (CorpActnEvtId) */
    eventId: string;
    /* ISO official event ID, typically US-prefixed (OffclCorpActnEvtId) */
    officialEventId?: string;
    processingStatus: ExcDtcDtccaV1ProcessingStatus;
    /* ISO 20022 event type code (EvtTp > Cd) */
    eventType: ExcDtcDtccaV1EventType;
    /* Distribution vs Reorganization (EvtPrcgTp > Cd) */
    processingType?: ExcDtcDtccaV1ProcessingType;
    /* SD sub-event type, pass-through (e.g. DRPD, OPTO, PREQ) */
    subEventType?: string;
    /* When DTC last changed the event (SD NtfctnGnlInf > UpdDtAndTm). */
    // format: date-time
    modifiedTimestamp?: string;
}

export interface ExcDtcDtccaV1Cancellation {
    header: ExcDtcDtccaV1ActionHeader;
    /* PROC (processing) or WITH (withdrawal) */
    cancellationReasonCode: string;
    // format: YYYY-MM-DD
    recordDate?: string;
    // format: YYYY-MM-DD
    exDividendDate?: string;
    // format: YYYY-MM-DD
    effectiveDate?: string;
}

export interface ExcDtcDtccaV1CashMovement {
    creditDebit: ExcDtcDtccaV1CreditDebit;
    // format: YYYY-MM-DD
    paymentDate?: string;
    /* Income type code (IncmTp > Id), e.g. 0006, 0001 */
    incomeType?: string;
    /* Income type issuer (IncmTp > Issr), e.g. IRSX, CRAX */
    incomeTypeIssuer?: string;
    /* Gross distribution rate amount */
    // format: decimal
    grossRate?: string;
    /* Rate type code from GrssDstrbtnRate > RateTp > Cd (e.g. INCO, LTCG) */
    grossRateType?: string;
    /* Currency of the gross rate (e.g. USD) */
    grossRateCurrency?: string;
    /* Net distribution rate amount */
    // format: decimal
    netRate?: string;
    /* Currency of the net rate */
    netRateCurrency?: string;
    /* Withholding tax rate as a percentage (raw from XML, e.g. 15 = 15%) */
    // format: decimal
    withholdingTaxRate?: string;
    /* Cash price received per unit, from PricDtls > GncCshPricRcvdPerPdct >
    AmtPricPerFinInstrmQty > PricVal */
    // format: decimal
    priceValue?: string;
    /* Currency of the price (e.g. USD) */
    priceCurrency?: string;
    /* Price type code from AmtPricTp (e.g. ACTU for an actual price) */
    priceType?: string;
    /* How many units the price is per, from FinInstrmQty > Unit. Normally 1. */
    // format: decimal
    priceQuantity?: string;
    /* SD payout type (PyoutTp), e.g. DIVI, CASH, INTR, PRPL */
    sdPayoutType?: string;
    /* SD estimated rate flag (EstmtdRateFlg) */
    sdEstimatedRate?: boolean;
}

export enum ExcDtcDtccaV1CreditDebit {
    Unspecified = 'UNSPECIFIED',
    Credit = 'CREDIT',
    Debit = 'DEBIT'
}

export enum ExcDtcDtccaV1EventCompletenessStatus {
    Unspecified = 'UNSPECIFIED',
    Complete = 'COMPLETE',
    Incomplete = 'INCOMPLETE'
}

export enum ExcDtcDtccaV1EventConfirmationStatus {
    Unspecified = 'UNSPECIFIED',
    Confirmed = 'CONFIRMED',
    Unconfirmed = 'UNCONFIRMED'
}

export enum ExcDtcDtccaV1EventType {
    Unspecified = 'UNSPECIFIED',
    Bankruptcy = 'BANKRUPTCY',
    BondDefault = 'BOND_DEFAULT',
    CallOnIntermediateSecurities = 'CALL_ON_INTERMEDIATE_SECURITIES',
    CapitalDistribution = 'CAPITAL_DISTRIBUTION',
    CapitalGains = 'CAPITAL_GAINS',
    Capitalisation = 'CAPITALISATION',
    CashDistributionFromNonEligibleSecurities = 'CASH_DISTRIBUTION_FROM_NON_ELIGIBLE_SECURITIES',
    CashDividend = 'CASH_DIVIDEND',
    CertificateOfDepositEarlyRedemption = 'CERTIFICATE_OF_DEPOSIT_EARLY_REDEMPTION',
    Change = 'CHANGE',
    ClassAction = 'CLASS_ACTION',
    Consent = 'CONSENT',
    Conversion = 'CONVERSION',
    Detachment = 'DETACHMENT',
    DividendOption = 'DIVIDEND_OPTION',
    DividendReinvestment = 'DIVIDEND_REINVESTMENT',
    Drawing = 'DRAWING',
    DutchAuction = 'DUTCH_AUCTION',
    Exchange = 'EXCHANGE',
    FinalMaturity = 'FINAL_MATURITY',
    FinalPaydown = 'FINAL_PAYDOWN',
    FullCall = 'FULL_CALL',
    Information = 'INFORMATION',
    InterestPayment = 'INTEREST_PAYMENT',
    IntermediateSecuritiesDistribution = 'INTERMEDIATE_SECURITIES_DISTRIBUTION',
    LiquidationDividend = 'LIQUIDATION_DIVIDEND',
    Merger = 'MERGER',
    NonOfficialOffer = 'NON_OFFICIAL_OFFER',
    OddLotSalePurchase = 'ODD_LOT_SALE_PURCHASE',
    Other = 'OTHER',
    PartialRedemption = 'PARTIAL_REDEMPTION',
    PayInKind = 'PAY_IN_KIND',
    PlaceOfIncorporation = 'PLACE_OF_INCORPORATION',
    Prefunding = 'PREFUNDING',
    PutRedemption = 'PUT_REDEMPTION',
    RedemptionOfWarrant = 'REDEMPTION_OF_WARRANT',
    RepurchaseOffer = 'REPURCHASE_OFFER',
    ReverseStockSplit = 'REVERSE_STOCK_SPLIT',
    Spinoff = 'SPINOFF',
    StockDividend = 'STOCK_DIVIDEND',
    StockSplit = 'STOCK_SPLIT',
    TaxOnNonDistributedProceeds = 'TAX_ON_NON_DISTRIBUTED_PROCEEDS',
    TaxReclaim = 'TAX_RECLAIM',
    Tender = 'TENDER',
    Termination = 'TERMINATION',
    WarrantExercise = 'WARRANT_EXERCISE',
    Worthless = 'WORTHLESS'
}

export enum ExcDtcDtccaV1FractionDisposition {
    Unspecified = 'UNSPECIFIED',
    Unknown = 'UNKNOWN',
    CashInLieu = 'CASH_IN_LIEU',
    RoundDown = 'ROUND_DOWN',
    RoundUp = 'ROUND_UP',
    RoundToNearest = 'ROUND_TO_NEAREST',
    IssueFraction = 'ISSUE_FRACTION'
}

export interface ExcDtcDtccaV1Notification {
    header?: ExcDtcDtccaV1ActionHeader;
    // format: YYYY-MM-DD
    recordDate?: string;
    // format: YYYY-MM-DD
    exDividendDate?: string;
    /* For reorgs, this is the key date (mergers, splits, spinoffs) */
    // format: YYYY-MM-DD
    effectiveDate?: string;
    /* SD DTCPosCaptrDt — when DTC captures positions. Not present for reorgs;
    falls back to recordDate or effectiveDate. */
    // format: YYYY-MM-DD
    dtcCaptureDate?: string;
    /* Dividend type code (DvddTp > Cd), e.g. REIN, FINL, SPEC */
    dividendType?: string;
    /* Offer type code (OfferTp > Cd), e.g. DISS, NDIS */
    offerType?: string;
    /* Number of accrued interest days (IntrstAcrdNbOfDays) */
    // format: INT32
    interestAccruedDays?: number;
    /* SD asset class (DTCAsstClss), e.g. CRPE, CRPB, MUNB */
    dtcAssetClass?: string;
    /* SD asset type (DTCAsstTp), e.g. S010, S117 */
    dtcAssetType?: string;
    /* SD ticker symbol (TckrSymb) */
    ticker?: string;
    /* Narrative text from AddtlInf > AddtlTxt */
    additionalInfo?: string;
    cashMovements?: ExcDtcDtccaV1CashMovement[];
    securityMovements?: ExcDtcDtccaV1SecurityMovement[];
}

export interface ExcDtcDtccaV1ParseInfo {
    /* Bucket is the S3 bucket name where the source file is stored. This is
    used to determine which parser to use for the file. */
    bucket: IxcCorpactionsCadataV1SourceBucket;
    /* Filename of the source feed file */
    // format: custom - pattern: ^[a-zA-Z0-9_\.-]+(\/[a-zA-Z0-9_\.-]+)*$
    filename: string;
    /* Must be unique within the file (pk=sourceFile,recordNumber), may be the
    line number or the index within the file */
    // format: INT32
    recordNumber?: number;
    /* Byte offset of the start of the data element in the source file. 0 is the
    first byte of the file, and start is inclusive. */
    // format: INT64
    startOffset?: string;
    /* Byte offset of the end of the data element in the source file. Inclusive
    of the desired offset, start=0 end=2 will return bytes 0,1,2 */
    // format: INT64
    endOffset?: string;
    /* Where the source file has a file-level timestamp rather than
    per-message, this is needed to reconstruct the record from the partial
    byte range. Where timestamps are included in the byte range, this should
    be null */
    // format: date-time
    fileTimestamp?: string;
    /* CreDt from the ISO AppHdr */
    // format: date-time
    isoCreationDate?: string;
    /* XML elements present in the source but not captured by the parser. Empty
    when all elements are handled. */
    unknownElements?: ExcDtcDtccaV1UnknownElement[];
}

export interface ExcDtcDtccaV1ProcessingStatus {
    eventCompletenessStatus: ExcDtcDtccaV1EventCompletenessStatus;
    eventConfirmationStatus: ExcDtcDtccaV1EventConfirmationStatus;
}

export enum ExcDtcDtccaV1ProcessingType {
    Unspecified = 'UNSPECIFIED',
    General = 'GENERAL',
    Distribution = 'DISTRIBUTION',
    Reorganization = 'REORGANIZATION'
}

export type ExcDtcDtccaV1RateOrUnknown = {
    '!type'?: 'rate';
    // format: decimal
    rate: string;
} | {
    '!type'?: 'unknown';
    unknown: boolean;
};

export const EXC_DTC_DTCCA_V1_RATE_OR_UNKNOWN_ONE_OF_VALUES = ['rate', 'unknown'] as const;

export type ExcDtcDtccaV1RateOrUnknownOneOfValue = (typeof EXC_DTC_DTCCA_V1_RATE_OR_UNKNOWN_ONE_OF_VALUES)[number];

export interface ExcDtcDtccaV1SecurityMovement {
    creditDebit: ExcDtcDtccaV1CreditDebit;
    // format: YYYY-MM-DD
    paymentDate?: string;
    /* CUSIP of the security being credited or debited */
    cusip?: string;
    /* Resolved asset ID, if the CUSIP is in our security master */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
    /* Security description from FinInstrmId > Desc */
    description?: string;
    /* The quantity ratio (Qty1 / Qty2), from AdditionalQuantityForExisting or
    NewToOld. Positive for credits, negative for debits. */
    rate?: ExcDtcDtccaV1RateOrUnknown;
    /* Whether the rate came from AdditionalQuantityForExisting or NewToOld */
    rateType?: ExcDtcDtccaV1SecurityRateType;
    /* How fractional shares are handled (FrctnDspstn > Cd) */
    fractionDisposition?: ExcDtcDtccaV1FractionDisposition;
    /* Cash-in-lieu price per fractional share (CshInLieuOfShrPric). Only
    present when fractionDisposition is CASH_IN_LIEU and the price has been
    determined. */
    // format: decimal
    cashInLieuRate?: string;
    /* Cash received per unit (GncCshPricRcvdPerPdct) — the price the
    securities are valued at, as on a dividend option reinvestment. */
    // format: decimal
    cashPriceReceived?: string;
    /* Cash paid per unit (GncCshPricPdPerPdct) — the price the holder pays,
    as on a subscription. */
    // format: decimal
    cashPricePaid?: string;
}

export enum ExcDtcDtccaV1SecurityRateType {
    Unspecified = 'UNSPECIFIED',
    AdditionalQuantity = 'ADDITIONAL_QUANTITY',
    NewToOld = 'NEW_TO_OLD'
}

export interface ExcDtcDtccaV1UnknownElement {
    /* XPath-like location of the unknown element */
    path?: string;
    /* Truncated inner content of the unknown element */
    content?: string;
}

export interface ExcDtcFilesV1FileData {
    spec: ExcDtcFilesV1FileSpec;
}

export interface ExcDtcFilesV1FileEvent extends ExcDtcFilesV1FileKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcDtcFilesV1FileEventType;
}

export type ExcDtcFilesV1FileEventType = {
    '!type'?: 'created';
    created: ExcDtcFilesV1FileEventTypeCreated;
} | {
    '!type'?: 'validationPassed';
    validationPassed: EmptyObject;
} | {
    '!type'?: 'validationFailed';
    validationFailed: ExcDtcFilesV1FileEventTypeValidationFailed;
} | {
    '!type'?: 'errored';
    errored: ExcDtcFilesV1FileEventTypeErrored;
};

export interface ExcDtcFilesV1FileEventTypeCreated {
    spec: ExcDtcFilesV1FileSpec;
}

export interface ExcDtcFilesV1FileEventTypeErrored {
    reason: string;
}

export interface ExcDtcFilesV1FileEventTypeValidationFailed {
    reason: string;
}

export const EXC_DTC_FILES_V1_FILE_EVENT_TYPE_ONE_OF_VALUES = ['created', 'validationPassed', 'validationFailed', 'errored'] as const;

export type ExcDtcFilesV1FileEventTypeOneOfValue = (typeof EXC_DTC_FILES_V1_FILE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcDtcFilesV1FileKeys {
    // format: id62
    fileId: string;
}

export interface ExcDtcFilesV1FileQueryServiceFileEventsFileEventsRequest {
    // format: id62
    fileId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcDtcFilesV1FileQueryServiceFileEventsSortableFields, ExcDtcFilesV1FileQueryServiceFileEventsFilterableFields>;
}

export enum ExcDtcFilesV1FileQueryServiceFileEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    FileId = 'fileId',
    EventType = 'event.!type'
}

export enum ExcDtcFilesV1FileQueryServiceFileEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcDtcFilesV1FileQueryServiceFileGetFileGetRequest {
    // format: id62
    fileId: string;
}

export interface ExcDtcFilesV1FileQueryServiceFileListFileListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcDtcFilesV1FileQueryServiceFileListSortableFields, ExcDtcFilesV1FileQueryServiceFileListFilterableFields>;
}

export enum ExcDtcFilesV1FileQueryServiceFileListFilterableFields {
    FileId = 'fileId',
    Status = 'status'
}

export enum ExcDtcFilesV1FileQueryServiceFileListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcDtcFilesV1FileRequestData {
    spec: ExcDtcFilesV1FileRequestSpec;
}

export interface ExcDtcFilesV1FileRequestEvent extends ExcDtcFilesV1FileRequestKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcDtcFilesV1FileRequestEventType;
}

export type ExcDtcFilesV1FileRequestEventType = {
    '!type'?: 'created';
    created: ExcDtcFilesV1FileRequestEventTypeCreated;
} | {
    '!type'?: 'polled';
    polled: EmptyObject;
} | {
    '!type'?: 'fulfilled';
    fulfilled: EmptyObject;
} | {
    '!type'?: 'errored';
    errored: ExcDtcFilesV1FileRequestEventTypeErrored;
};

export interface ExcDtcFilesV1FileRequestEventTypeCreated {
    spec: ExcDtcFilesV1FileRequestSpec;
}

export interface ExcDtcFilesV1FileRequestEventTypeErrored {
    reason: string;
}

export const EXC_DTC_FILES_V1_FILE_REQUEST_EVENT_TYPE_ONE_OF_VALUES = ['created', 'polled', 'fulfilled', 'errored'] as const;

export type ExcDtcFilesV1FileRequestEventTypeOneOfValue = (typeof EXC_DTC_FILES_V1_FILE_REQUEST_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcDtcFilesV1FileRequestKeys {
    // format: id62
    fileRequestId: string;
}

export interface ExcDtcFilesV1FileRequestQueryServiceFileRequestEventsFileRequestEventsRequest {
    // format: id62
    fileRequestId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcDtcFilesV1FileRequestQueryServiceFileRequestEventsSortableFields, ExcDtcFilesV1FileRequestQueryServiceFileRequestEventsFilterableFields>;
}

export enum ExcDtcFilesV1FileRequestQueryServiceFileRequestEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    FileRequestId = 'fileRequestId',
    EventType = 'event.!type'
}

export enum ExcDtcFilesV1FileRequestQueryServiceFileRequestEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcDtcFilesV1FileRequestQueryServiceFileRequestGetFileRequestGetRequest {
    // format: id62
    fileRequestId: string;
}

export interface ExcDtcFilesV1FileRequestQueryServiceFileRequestListFileRequestListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcDtcFilesV1FileRequestQueryServiceFileRequestListSortableFields, ExcDtcFilesV1FileRequestQueryServiceFileRequestListFilterableFields>;
}

export enum ExcDtcFilesV1FileRequestQueryServiceFileRequestListFilterableFields {
    FileRequestId = 'fileRequestId',
    Status = 'status'
}

export enum ExcDtcFilesV1FileRequestQueryServiceFileRequestListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcDtcFilesV1FileRequestSpec {
    fileId: string;
    requestFilePath: string;
    responseFilePath: string;
    // format: date-time
    deadline?: string;
}

export interface ExcDtcFilesV1FileRequestState extends ExcDtcFilesV1FileRequestKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcDtcFilesV1FileRequestData;
    status: ExcDtcFilesV1FileRequestStatus;
}

export enum ExcDtcFilesV1FileRequestStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Fulfilled = 'FULFILLED',
    Errored = 'ERRORED'
}

export interface ExcDtcFilesV1FileSpec {
    path: string;
    fileRequestId: string;
}

export interface ExcDtcFilesV1FileState extends ExcDtcFilesV1FileKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcDtcFilesV1FileData;
    status: ExcDtcFilesV1FileStatus;
}

export enum ExcDtcFilesV1FileStatus {
    Unspecified = 'UNSPECIFIED',
    Expected = 'EXPECTED',
    Errored = 'ERRORED',
    Validated = 'VALIDATED',
    Invalid = 'INVALID'
}

export enum ExcDtccUtcV1NettingIndicator {
    Unspecified = 'UNSPECIFIED',
    ExcludedFromNetting = 'EXCLUDED_FROM_NETTING',
    ForeignBo = 'FOREIGN_BO',
    ExcludedFromClearing = 'EXCLUDED_FROM_CLEARING',
    SpecialTrade = 'SPECIAL_TRADE',
    MultilateralNetting = 'MULTILATERAL_NETTING',
    Cns = 'CNS'
}

export const EXC_DTCC_UTC_V1_NETTING_INDICATOR_INFO_EXTENSION_CODE_MAP = {
    [ExcDtccUtcV1NettingIndicator.ExcludedFromNetting]: '1',
    [ExcDtccUtcV1NettingIndicator.ForeignBo]: '2',
    [ExcDtccUtcV1NettingIndicator.ExcludedFromClearing]: '3',
    [ExcDtccUtcV1NettingIndicator.SpecialTrade]: '4',
    [ExcDtccUtcV1NettingIndicator.MultilateralNetting]: '5',
    [ExcDtccUtcV1NettingIndicator.Cns]: '6'
} as const;

export enum ExcDtccUtcV1SecurityType {
    Unspecified = 'UNSPECIFIED',
    Corporate = 'CORPORATE',
    Equity = 'EQUITY',
    Municipal = 'MUNICIPAL',
    Other = 'OTHER',
    Uit = 'UIT',
    Call = 'CALL',
    Put = 'PUT',
    Future = 'FUTURE',
    NarrowBasedFuture = 'NARROW_BASED_FUTURE',
    Etf = 'ETF'
}

export const EXC_DTCC_UTC_V1_SECURITY_TYPE_INFO_EXTENSION_CODE_MAP = {
    [ExcDtccUtcV1SecurityType.Corporate]: '3',
    [ExcDtccUtcV1SecurityType.Equity]: '5',
    [ExcDtccUtcV1SecurityType.Municipal]: '11',
    [ExcDtccUtcV1SecurityType.Other]: '12',
    [ExcDtccUtcV1SecurityType.Uit]: '14',
    [ExcDtccUtcV1SecurityType.Call]: '15',
    [ExcDtccUtcV1SecurityType.Put]: '16',
    [ExcDtccUtcV1SecurityType.Future]: '17',
    [ExcDtccUtcV1SecurityType.NarrowBasedFuture]: '18',
    [ExcDtccUtcV1SecurityType.Etf]: '19'
} as const;

export enum ExcDtccUtcV1SettlementType {
    Unspecified = 'UNSPECIFIED',
    Regular = 'REGULAR',
    Cash = 'CASH',
    SellersOption = 'SELLERS_OPTION',
    WhenIssued = 'WHEN_ISSUED'
}

export const EXC_DTCC_UTC_V1_SETTLEMENT_TYPE_INFO_EXTENSION_CODE_MAP = {
    [ExcDtccUtcV1SettlementType.Regular]: '0',
    [ExcDtccUtcV1SettlementType.Cash]: '1',
    [ExcDtccUtcV1SettlementType.SellersOption]: '6',
    [ExcDtccUtcV1SettlementType.WhenIssued]: '7'
} as const;

export enum ExcDtccUtcV1Side {
    Unspecified = 'UNSPECIFIED',
    Buy = 'BUY',
    Sell = 'SELL'
}

export const EXC_DTCC_UTC_V1_SIDE_INFO_EXTENSION_CODE_MAP = {
    [ExcDtccUtcV1Side.Buy]: '1',
    [ExcDtccUtcV1Side.Sell]: '2'
} as const;

export interface ExcDtccUtcV1Trade {
    orderId?: string;
    clientOrderId?: string;
    executionId?: string;
    marketControlNumber?: string;
    symbol?: string;
    cusip: string;
    // format: UINT32
    quantity: number;
    // format: decimal
    unitPrice: string;
    // format: decimal
    grossAmount: string;
    // format: decimal
    netSettlementAmount: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: date-time
    tradeTime: string;
    /* Netting Indicator (Clearing Instruction) */
    nettingIndicator?: ExcDtccUtcV1NettingIndicator;
    securityType: ExcDtccUtcV1SecurityType;
    settlementType: ExcDtccUtcV1SettlementType;
    // format: YYYY-MM-DD
    settlementDate?: string;
    side: ExcDtccUtcV1Side;
}

export interface ExcDtccUtcV1UtcFixSessionConfig {
    /* Hostname or IP address of the DTCC UTC FIX gateway */
    targetHost: string;
    /* Port number for the FIX connection */
    // format: INT32
    targetPort: number;
    /* FIX heartbeat interval in seconds (default: 30) */
    // format: INT32
    heartbeatInterval?: number;
}

export interface ExcDtccUtcV1UtcFixSessionData {
    /* Next outgoing sequence number */
    // format: INT32
    senderSeq: number;
    /* Next expected incoming sequence number */
    // format: INT32
    targetSeq: number;
    /* Whether the FIX initiator process is currently started */
    initiatorRunning?: boolean;
    /* Whether the session is currently logged on to DTCC UTC */
    isLoggedOn?: boolean;
    /* Session configuration including connection details */
    config: ExcDtccUtcV1UtcFixSessionConfig;
}

export interface ExcDtccUtcV1UtcFixSessionEvent extends ExcDtccUtcV1UtcFixSessionKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcDtccUtcV1UtcFixSessionEventType;
}

export type ExcDtccUtcV1UtcFixSessionEventType = {
    '!type'?: 'registered';
    registered: ExcDtccUtcV1UtcFixSessionEventTypeRegistered;
} | {
    '!type'?: 'connected';
    connected: ExcDtccUtcV1UtcFixSessionEventTypeConnected;
} | {
    '!type'?: 'disconnected';
    disconnected: ExcDtccUtcV1UtcFixSessionEventTypeDisconnected;
} | {
    '!type'?: 'initiatorStarted';
    initiatorStarted: EmptyObject;
} | {
    '!type'?: 'initiatorStopped';
    initiatorStopped: EmptyObject;
} | {
    '!type'?: 'sequenceNumbersUpdated';
    sequenceNumbersUpdated: ExcDtccUtcV1UtcFixSessionEventTypeSequenceNumbersUpdated;
} | {
    '!type'?: 'sequenceNumbersReset';
    sequenceNumbersReset: EmptyObject;
} | {
    '!type'?: 'resendRequested';
    resendRequested: ExcDtccUtcV1UtcFixSessionEventTypeResendRequested;
} | {
    '!type'?: 'configUpdated';
    configUpdated: ExcDtccUtcV1UtcFixSessionEventTypeConfigUpdated;
};

export interface ExcDtccUtcV1UtcFixSessionEventTypeConfigUpdated {
    /* The new configuration */
    config: ExcDtccUtcV1UtcFixSessionConfig;
}

export interface ExcDtccUtcV1UtcFixSessionEventTypeConnected {
    /* Sender sequence number at time of connection */
    // format: INT32
    senderSeq: number;
    /* Target sequence number at time of connection */
    // format: INT32
    targetSeq: number;
}

export interface ExcDtccUtcV1UtcFixSessionEventTypeDisconnected {
    /* Reason for disconnection if available */
    reason?: string;
    /* Whether the disconnect was initiated gracefully via logout */
    graceful: boolean;
}

export interface ExcDtccUtcV1UtcFixSessionEventTypeRegistered {
    /* FIX SenderCompID (tag 49) */
    senderCompId: string;
    /* FIX TargetCompID (tag 56) */
    targetCompId: string;
    /* Initial session configuration */
    config: ExcDtccUtcV1UtcFixSessionConfig;
}

export interface ExcDtccUtcV1UtcFixSessionEventTypeResendRequested {
    /* Beginning sequence number of the requested range */
    // format: INT32
    beginSeqNo: number;
    /* Ending sequence number of the requested range (0 for open-ended) */
    // format: INT32
    endSeqNo: number;
}

export interface ExcDtccUtcV1UtcFixSessionEventTypeSequenceNumbersUpdated {
    /* New sender sequence number */
    // format: INT32
    senderSeq: number;
    /* New target sequence number */
    // format: INT32
    targetSeq: number;
    /* Reason for the update */
    reason: ExcDtccUtcV1UtcSequenceUpdateReason;
}

export const EXC_DTCC_UTC_V1_UTC_FIX_SESSION_EVENT_TYPE_ONE_OF_VALUES = ['registered', 'connected', 'disconnected', 'initiatorStarted', 'initiatorStopped', 'sequenceNumbersUpdated', 'sequenceNumbersReset', 'resendRequested', 'configUpdated'] as const;

export type ExcDtccUtcV1UtcFixSessionEventTypeOneOfValue = (typeof EXC_DTCC_UTC_V1_UTC_FIX_SESSION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcDtccUtcV1UtcFixSessionKeys {
    /* Unique identifier for the UTC FIX session */
    // format: id62
    sessionId: string;
    /* FIX SenderCompID (tag 49) - identifies the clearing firm */
    senderCompId?: string;
    /* FIX TargetCompID (tag 56) - identifies the DTCC UTC gateway */
    targetCompId?: string;
}

export interface ExcDtccUtcV1UtcFixSessionQueryServiceUtcFixSessionEventsUtcFixSessionEventsRequest {
    /* Unique identifier for the UTC FIX session */
    // format: id62
    sessionId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcDtccUtcV1UtcFixSessionQueryServiceUtcFixSessionEventsSortableFields, ExcDtccUtcV1UtcFixSessionQueryServiceUtcFixSessionEventsFilterableFields>;
}

export enum ExcDtccUtcV1UtcFixSessionQueryServiceUtcFixSessionEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    SessionId = 'sessionId',
    EventType = 'event.!type'
}

export enum ExcDtccUtcV1UtcFixSessionQueryServiceUtcFixSessionEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcDtccUtcV1UtcFixSessionQueryServiceUtcFixSessionGetUtcFixSessionGetRequest {
    /* Unique identifier for the UTC FIX session */
    // format: id62
    sessionId: string;
}

export interface ExcDtccUtcV1UtcFixSessionQueryServiceUtcFixSessionListUtcFixSessionListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcDtccUtcV1UtcFixSessionQueryServiceUtcFixSessionListSortableFields, ExcDtccUtcV1UtcFixSessionQueryServiceUtcFixSessionListFilterableFields>;
}

export enum ExcDtccUtcV1UtcFixSessionQueryServiceUtcFixSessionListFilterableFields {
    SessionId = 'sessionId',
    Status = 'status'
}

export enum ExcDtccUtcV1UtcFixSessionQueryServiceUtcFixSessionListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcDtccUtcV1UtcFixSessionState extends ExcDtccUtcV1UtcFixSessionKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcDtccUtcV1UtcFixSessionData;
    status: ExcDtccUtcV1UtcFixSessionStatus;
}

export enum ExcDtccUtcV1UtcFixSessionStatus {
    Unspecified = 'UNSPECIFIED',
    Stopped = 'STOPPED',
    Connecting = 'CONNECTING',
    Disconnected = 'DISCONNECTED',
    LoggedOn = 'LOGGED_ON'
}

export enum ExcDtccUtcV1UtcSequenceUpdateReason {
    Unspecified = 'UNSPECIFIED',
    ManualSet = 'MANUAL_SET',
    Bump = 'BUMP',
    GapFill = 'GAP_FILL',
    Resync = 'RESYNC'
}

export enum ExcFixV1MessageType {
    Unspecified = 'UNSPECIFIED',
    NewOrderSingle = 'NEW_ORDER_SINGLE',
    OrderCancelRequest = 'ORDER_CANCEL_REQUEST',
    OrderCancelReplaceRequest = 'ORDER_CANCEL_REPLACE_REQUEST',
    ExecutionReport = 'EXECUTION_REPORT',
    OrderCancelReject = 'ORDER_CANCEL_REJECT',
    OrderStatusRequest = 'ORDER_STATUS_REQUEST',
    BusinessMessageReject = 'BUSINESS_MESSAGE_REJECT',
    Unknown = 'UNKNOWN'
}

export const EXC_FIX_V1_MESSAGE_TYPE_INFO_EXTENSION_CODE_MAP = {
    [ExcFixV1MessageType.NewOrderSingle]: 'D',
    [ExcFixV1MessageType.OrderCancelRequest]: 'F',
    [ExcFixV1MessageType.OrderCancelReplaceRequest]: 'G',
    [ExcFixV1MessageType.ExecutionReport]: '8',
    [ExcFixV1MessageType.OrderCancelReject]: '9',
    [ExcFixV1MessageType.OrderStatusRequest]: 'H',
    [ExcFixV1MessageType.BusinessMessageReject]: 'j'
} as const;

export interface ExcIceCorpactionsV1ActionData {
    record?: ExcIceCorpactionsV1Record;
    lastSource?: ExcIceCorpactionsV1RecordSource;
}

export interface ExcIceCorpactionsV1ActionEvent extends IxcCorpactionsCaadminV1ActionKeys {
    metadata: J5StateV1EventMetadata;
    // format: custom - pattern: ^[0-9]+$
    eventId: string;
    event: ExcIceCorpactionsV1ActionEventType;
}

export type ExcIceCorpactionsV1ActionEventType = {
    '!type'?: 'newOrUpdated';
    newOrUpdated: ExcIceCorpactionsV1ActionEventTypeNewOrUpdated;
} | {
    '!type'?: 'deleted';
    deleted: ExcIceCorpactionsV1ActionEventTypeDeleted;
};

export interface ExcIceCorpactionsV1ActionEventTypeDeleted {
    source?: ExcIceCorpactionsV1RecordSource;
    record?: ExcIceCorpactionsV1Record;
}

export interface ExcIceCorpactionsV1ActionEventTypeNewOrUpdated {
    source?: ExcIceCorpactionsV1RecordSource;
    record?: ExcIceCorpactionsV1Record;
}

export const EXC_ICE_CORPACTIONS_V1_ACTION_EVENT_TYPE_ONE_OF_VALUES = ['newOrUpdated', 'deleted'] as const;

export type ExcIceCorpactionsV1ActionEventTypeOneOfValue = (typeof EXC_ICE_CORPACTIONS_V1_ACTION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcIceCorpactionsV1ActionKeys {
    // format: custom - pattern: ^[0-9]+$
    eventId: string;
}

export interface ExcIceCorpactionsV1ActionQueryServiceActionEventsActionEventsRequest {
    // format: custom - pattern: ^[0-9]+$
    eventId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcIceCorpactionsV1ActionQueryServiceActionEventsSortableFields, ExcIceCorpactionsV1ActionQueryServiceActionEventsFilterableFields>;
}

export enum ExcIceCorpactionsV1ActionQueryServiceActionEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventId = 'eventId',
    EventType = 'event.!type'
}

export enum ExcIceCorpactionsV1ActionQueryServiceActionEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcIceCorpactionsV1ActionQueryServiceActionGetActionGetRequest {
    // format: custom - pattern: ^[0-9]+$
    eventId: string;
}

export interface ExcIceCorpactionsV1ActionQueryServiceActionListActionListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcIceCorpactionsV1ActionQueryServiceActionListSortableFields, ExcIceCorpactionsV1ActionQueryServiceActionListFilterableFields>;
}

export enum ExcIceCorpactionsV1ActionQueryServiceActionListFilterableFields {
    EventId = 'eventId',
    Status = 'status'
}

export enum ExcIceCorpactionsV1ActionQueryServiceActionListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcIceCorpactionsV1ActionState extends ExcIceCorpactionsV1ActionKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcIceCorpactionsV1ActionData;
    status: ExcIceCorpactionsV1ActionStatus;
}

export enum ExcIceCorpactionsV1ActionStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Deleted = 'DELETED'
}

export enum ExcIceCorpactionsV1ActionType {
    Unspecified = 'UNSPECIFIED',
    Mandatory = 'MANDATORY',
    MandatoryWithChoice = 'MANDATORY_WITH_CHOICE',
    Voluntary = 'VOLUNTARY'
}

export const EXC_ICE_CORPACTIONS_V1_ACTION_TYPE_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceCorpactionsV1ActionType.Mandatory]: 'Mandatory',
    [ExcIceCorpactionsV1ActionType.MandatoryWithChoice]: 'Mandatory with choice',
    [ExcIceCorpactionsV1ActionType.Voluntary]: 'Voluntary'
} as const;

export enum ExcIceCorpactionsV1AnnouncementStatus {
    Unspecified = 'UNSPECIFIED',
    Approval = 'APPROVAL',
    CompletedDeal = 'COMPLETED_DEAL',
    DoesNotApply = 'DOES_NOT_APPLY',
    Expiration = 'EXPIRATION',
    Expired = 'EXPIRED',
    Extended = 'EXTENDED',
    Extension = 'EXTENSION',
    Final = 'FINAL',
    Preliminary = 'PRELIMINARY',
    Rejected = 'REJECTED',
    RevisedOffer = 'REVISED_OFFER',
    Terminated = 'TERMINATED'
}

export const EXC_ICE_CORPACTIONS_V1_ANNOUNCEMENT_STATUS_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceCorpactionsV1AnnouncementStatus.Approval]: 'Approval',
    [ExcIceCorpactionsV1AnnouncementStatus.CompletedDeal]: 'Completed Deal',
    [ExcIceCorpactionsV1AnnouncementStatus.DoesNotApply]: 'Does Not Apply',
    [ExcIceCorpactionsV1AnnouncementStatus.Expiration]: 'Expiration',
    [ExcIceCorpactionsV1AnnouncementStatus.Expired]: 'Expired',
    [ExcIceCorpactionsV1AnnouncementStatus.Extended]: 'Extended',
    [ExcIceCorpactionsV1AnnouncementStatus.Extension]: 'Extension',
    [ExcIceCorpactionsV1AnnouncementStatus.Final]: 'Final',
    [ExcIceCorpactionsV1AnnouncementStatus.Preliminary]: 'Preliminary',
    [ExcIceCorpactionsV1AnnouncementStatus.Rejected]: 'Rejected',
    [ExcIceCorpactionsV1AnnouncementStatus.RevisedOffer]: 'Revised Offer',
    [ExcIceCorpactionsV1AnnouncementStatus.Terminated]: 'Terminated'
} as const;

export interface ExcIceCorpactionsV1CapitalChange {
    type?: string;
    // format: decimal
    adjustmentFactor?: string;
    capitalEventMarker?: string;
    capitalEventMarker2?: string;
    // format: YYYY-MM-DD
    finalSplitDate?: string;
    // format: YYYY-MM-DD
    lastRenunciationDate?: string;
    // format: YYYY-MM-DD
    finalTradeDate?: string;
    specialSituationType?: string;
    // format: YYYY-MM-DD
    specialSituationDate?: string;
    rankingBasis?: string;
    // format: YYYY-MM-DD
    rankingDate?: string;
    capitalBasis?: string;
    // format: YYYY-MM-DD
    dueBillRedemptionDate?: string;
    noOfOptions?: string;
    details?: ExcIceCorpactionsV1CapitalChangeCapitalChangeDetails[];
    costBasisDetails?: ExcIceCorpactionsV1CapitalChangeCapitalChangeCostBasisDetails[];
}

export interface ExcIceCorpactionsV1CapitalChangeCapitalChangeCostBasisDetails {
    paymentInstrument?: ExcIceCorpactionsV1Instrument;
    taxStatus?: string;
    // format: decimal
    taxMarketValue?: string;
    taxMarketValueCurrency?: string;
    taxMarketValueMethod?: string;
    // format: decimal
    paymentAdjustmentFactor?: string;
}

export interface ExcIceCorpactionsV1CapitalChangeCapitalChangeDetails {
    // format: UINT64
    optionNumber?: string;
    type?: string;
    subtype?: string;
    paymentInstrument?: ExcIceCorpactionsV1Instrument;
    newSecurityType?: ExcIceCorpactionsV1SecurityType;
    // format: decimal
    noNewSecurities?: string;
    // format: decimal
    noOldSecurities?: string;
    // format: decimal
    issuePrice?: string;
    issuePriceCurrency?: string;
    // format: decimal
    paymentAmount?: string;
    paymentAmountCurrency?: string;
    // format: decimal
    paymentValue?: string;
    paymentValueCurrency?: string;
    // format: decimal
    newParValue?: string;
    newParValueCurrency?: string;
    // format: decimal
    oldParValue?: string;
    oldParValueCurrency?: string;
    // format: decimal
    newIssueMinPrice?: string;
    newIssueMinPriceCurrency?: string;
    // format: decimal
    newIssueMaxPrice?: string;
    newIssueMaxPriceCurrency?: string;
    roundingRule?: string;
    // format: decimal
    cashingOutRate?: string;
}

export interface ExcIceCorpactionsV1ConversionList {
    conversionItems?: ExcIceCorpactionsV1ConversionListConversionItem[];
}

export interface ExcIceCorpactionsV1ConversionListConversionItem {
    // format: UINT64
    optionNumber?: string;
    type?: string;
    units?: string;
    resultantInstrument?: ExcIceCorpactionsV1Instrument;
    resultantSecurityType?: ExcIceCorpactionsV1SecurityType;
    // format: YYYY-MM-DD
    date?: string;
    opportunitiesIndicator?: string;
    capitalMarker?: string;
    // format: decimal
    cost?: string;
    costCurrency?: string;
    // format: YYYY-MM-DD
    finalOpportunityDate?: string;
    // format: decimal
    partialConversionPercent?: string;
    // format: YYYY-MM-DD
    firstElectionDate?: string;
    // format: YYYY-MM-DD
    lastElectionDate?: string;
    // format: UINT64
    noOfOptions?: string;
    // format: decimal
    paymentAmount?: string;
    paymentAmountCurrency?: string;
    // format: decimal
    offeredSecurityAmount?: string;
}

export interface ExcIceCorpactionsV1Dividend {
    type?: string;
    subType?: string;
    reportingBasis?: string;
    // format: decimal
    amount?: string;
    currency?: string;
    // format: decimal
    rate?: string;
    frequency?: string;
    // format: decimal
    adjustedAmount?: string;
    adjustedAmountCurrency?: string;
    approvalCode?: string;
    // format: UINT64
    couponNumber?: string;
    details?: string;
    forecastType?: string;
    forecastRule?: string;
    // format: decimal
    periodTotalForecast?: string;
    periodTotalForecastCurrency?: string;
    // format: decimal
    periodTotalForecastRate?: string;
    // format: decimal
    totalForecastIncome?: string;
    totalForecastIncomeCurrency?: string;
    // format: decimal
    totalForecastIncomeRate?: string;
    // format: YYYY-MM-DD
    dueBillOnDate?: string;
    // format: YYYY-MM-DD
    dueBillOffDate?: string;
    paymentInstrument?: ExcIceCorpactionsV1Instrument;
    // format: decimal
    securityPaymentRate?: string;
    securityPaymentRatio?: ExcIceCorpactionsV1Ratio;
    // format: decimal
    grossIncomeEquivalent?: string;
    grossIncomeEquivalentCurrency?: string;
    closeOfBusinessCode?: string;
    supplementalPaymentType1?: string;
    supplementalPaymentType2?: string;
    paymentBasis?: string;
    status?: string;
    // format: YYYY-MM-DD
    statusDate?: string;
    // format: UINT64
    optionNumber?: string;
    amountDetails?: ExcIceCorpactionsV1DividendDividendAmountDetails[];
    taxationDetails?: ExcIceCorpactionsV1TaxationDetails;
    reinvestmentDetails?: ExcIceCorpactionsV1ReinvestmentDetails;
}

export interface ExcIceCorpactionsV1DividendDividendAmountDetails {
    amountType?: string;
    // format: decimal
    paymentAmount?: string;
    paymentAmountCurrency?: string;
    // format: decimal
    feeAmount?: string;
    feeAmountCurrency?: string;
}

export interface ExcIceCorpactionsV1EarningsList {
    earningsItems?: ExcIceCorpactionsV1EarningsListEarningsItem[];
}

export interface ExcIceCorpactionsV1EarningsListEarningsItem {
    basis?: string;
    // format: decimal
    amount?: string;
    currency?: string;
    gainOrLoss?: string;
    netOrGross?: string;
    type?: string;
    subtype?: string;
    // format: YYYY-MM-DD
    companyYearEnd?: string;
    note?: string;
    // format: YYYY-MM-DD
    quarterEndDate?: string;
}

export enum ExcIceCorpactionsV1EventStatus {
    Unspecified = 'UNSPECIFIED',
    New = 'NEW',
    Updated = 'UPDATED',
    Deleted = 'DELETED'
}

export const EXC_ICE_CORPACTIONS_V1_EVENT_STATUS_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceCorpactionsV1EventStatus.New]: 'New Announcement',
    [ExcIceCorpactionsV1EventStatus.Updated]: 'Updated Announcement',
    [ExcIceCorpactionsV1EventStatus.Deleted]: 'Deleted Announcement'
} as const;

export type ExcIceCorpactionsV1EventType = {
    '!type'?: 'dividend';
    dividend: ExcIceCorpactionsV1Dividend;
} | {
    '!type'?: 'payment';
    payment: ExcIceCorpactionsV1Payment;
} | {
    '!type'?: 'capitalChange';
    capitalChange: ExcIceCorpactionsV1CapitalChange;
} | {
    '!type'?: 'earningsList';
    earningsList: ExcIceCorpactionsV1EarningsList;
} | {
    '!type'?: 'redemptionList';
    redemptionList: ExcIceCorpactionsV1RedemptionList;
} | {
    '!type'?: 'repurchaseList';
    repurchaseList: ExcIceCorpactionsV1RepurchaseList;
} | {
    '!type'?: 'mergerAcquisitionList';
    mergerAcquisitionList: ExcIceCorpactionsV1MergerAcquisitionList;
} | {
    '!type'?: 'informationAnnouncement';
    informationAnnouncement: ExcIceCorpactionsV1InformationAnnouncement;
} | {
    '!type'?: 'shareholderMeeting';
    shareholderMeeting: ExcIceCorpactionsV1ShareholderMeeting;
} | {
    '!type'?: 'conversionList';
    conversionList: ExcIceCorpactionsV1ConversionList;
} | {
    '!type'?: 'identifierChangeList';
    identifierChangeList: ExcIceCorpactionsV1IdentifierChangeList;
} | {
    '!type'?: 'listingList';
    listingList: ExcIceCorpactionsV1ListingList;
} | {
    '!type'?: 'outstandingSharesList';
    outstandingSharesList: ExcIceCorpactionsV1OutstandingSharesList;
};

export const EXC_ICE_CORPACTIONS_V1_EVENT_TYPE_ONE_OF_VALUES = ['dividend', 'payment', 'capitalChange', 'earningsList', 'redemptionList', 'repurchaseList', 'mergerAcquisitionList', 'informationAnnouncement', 'shareholderMeeting', 'conversionList', 'identifierChangeList', 'listingList', 'outstandingSharesList'] as const;

export type ExcIceCorpactionsV1EventTypeOneOfValue = (typeof EXC_ICE_CORPACTIONS_V1_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcIceCorpactionsV1IdentifierChangeList {
    identifierChangeItems?: ExcIceCorpactionsV1IdentifierChangeListIdentifierChangeItem[];
}

export interface ExcIceCorpactionsV1IdentifierChangeListIdentifierChangeItem {
    identifier?: string;
    type?: string;
    value?: string;
    newIdentifierValue?: string;
    market?: string;
    comments?: string;
}

export interface ExcIceCorpactionsV1InformationAnnouncement {
    type?: string;
    text?: string;
    newInstrument?: ExcIceCorpactionsV1Instrument;
    newCompanyName?: string;
}

export interface ExcIceCorpactionsV1Instrument {
    // format: UINT64
    id?: string;
    cusip?: string;
    symbol?: string;
    name?: string;
    homeMarket?: string;
    countryOfIncorp?: string;
    primaryExchange?: string;
    securityType?: ExcIceCorpactionsV1SecurityType;
}

export interface ExcIceCorpactionsV1ListingList {
    listingItems?: ExcIceCorpactionsV1ListingListListingItem[];
}

export interface ExcIceCorpactionsV1ListingListListingItem {
    type?: string;
    marketCode?: string;
    marketDescription?: string;
    // format: YYYY-MM-DD
    date?: string;
    primaryMarketCode?: string;
    primaryMarketDescription?: string;
    currency?: string;
    marketIdCode?: string;
    marketIdDescription?: string;
    newMarketCode?: string;
    newMarketDescription?: string;
    note?: string;
    ipoDetails?: ExcIceCorpactionsV1ListingListListingItemIpoDetails;
}

export interface ExcIceCorpactionsV1ListingListListingItemIpoDetails {
    // format: YYYY-MM-DD
    date?: string;
    // format: decimal
    price?: string;
    priceCurrency?: string;
    // format: decimal
    ipoMinimumPrice?: string;
    ipoMinimumPriceCurrency?: string;
    // format: decimal
    ipoMaximumPrice?: string;
    ipoMaximumPriceCurrency?: string;
    // format: YYYY-MM-DD
    subscriptionPeriodStart?: string;
    // format: YYYY-MM-DD
    subscriptionPeriodEnd?: string;
    capitalEventMarker?: string;
    capitalEventMarker2?: string;
}

export interface ExcIceCorpactionsV1MarketDetails {
    market?: ExcIceCorpactionsV1MarketDetailsMarketDetailsMarket;
    // format: YYYY-MM-DD
    exDate?: string;
    // format: YYYY-MM-DD
    paymentDate?: string;
    // format: YYYY-MM-DD
    dealingDate?: string;
    // format: YYYY-MM-DD
    marketEffectiveDate?: string;
    // format: UINT64
    optionNumber?: string;
}

export interface ExcIceCorpactionsV1MarketDetailsMarketDetailsMarket {
    code?: string;
    description?: string;
    country?: string;
}

export interface ExcIceCorpactionsV1MergerAcquisitionList {
    mergersAcquisitionsItems?: ExcIceCorpactionsV1MergerAcquisitionListMergerAcquisitionItem[];
}

export interface ExcIceCorpactionsV1MergerAcquisitionListMergerAcquisitionItem {
    // format: UINT64
    optionNumber?: string;
    type?: string;
    subtype?: string;
    offeringCompany?: string;
    offeringCompanyInstrument?: ExcIceCorpactionsV1Instrument;
    // format: decimal
    offerCashAmount?: string;
    offerCashAmountCurrency?: string;
    // format: decimal
    unitOfOffer?: string;
    unitOfOfferCurrency?: string;
    // format: decimal
    unitOfOfferAmount?: string;
    takeoverType?: string;
    // format: decimal
    takeoverPercent?: string;
    // format: decimal
    acceptancePercent?: string;
    // format: YYYY-MM-DD
    startDate?: string;
    regulatoryWatchlist?: string;
    details?: string;
    // format: YYYY-MM-DD
    detailsDate?: string;
    terms?: string;
    approvalCode?: string;
    // format: UINT64
    noOfOptions?: string;
    // format: decimal
    prorationRate?: string;
    // format: decimal
    earlyPremium?: string;
    earlyPremiumCurrency?: string;
    offeredSecurityDetails?: ExcIceCorpactionsV1MergerAcquisitionListMergerAcquisitionItemMergerAcquisitionOfferedSecurityDetails[];
}

export interface ExcIceCorpactionsV1MergerAcquisitionListMergerAcquisitionItemMergerAcquisitionOfferedSecurityDetails {
    // format: UINT64
    optionNumber?: string;
    // format: UINT64
    offeredSecuritySequenceNumber?: string;
    offeredInstrument?: ExcIceCorpactionsV1Instrument;
    // format: decimal
    offeredSecurityAmount?: string;
    securityType?: ExcIceCorpactionsV1SecurityType;
    // format: decimal
    offeredSecurityValue?: string;
    offeredSecurityValueCurrency?: string;
}

export interface ExcIceCorpactionsV1OutstandingSharesList {
    outstandingSharesItems?: ExcIceCorpactionsV1OutstandingSharesListOutstandingSharesItem[];
}

export interface ExcIceCorpactionsV1OutstandingSharesListOutstandingSharesItem {
    // format: decimal
    previousSharesOutstanding?: string;
    // format: decimal
    newSharesOutstanding?: string;
    reportingBasis?: string;
    // format: decimal
    provisionalCapital?: string;
    provisionalCapitalCurrency?: string;
    comments?: string;
}

export interface ExcIceCorpactionsV1Payment {
    type?: string;
    subtype?: string;
    // format: decimal
    amount?: string;
    amountCurrency?: string;
    // format: decimal
    rate?: string;
    supplementalType?: string;
    reportingBasis?: string;
    status?: string;
    // format: YYYY-MM-DD
    statusDate?: string;
    notes?: string;
    // format: decimal
    grossIncomeEquivalent?: string;
    grossIncomeEquivalentCurrency?: string;
    frequency?: string;
    // format: decimal
    adjustedAmount?: string;
    adjustedAmountCurrency?: string;
    // format: UINT64
    couponNumber?: string;
    instrument?: ExcIceCorpactionsV1Instrument;
    // format: decimal
    securityPaymentRate?: string;
    securityRatio?: ExcIceCorpactionsV1Ratio;
    forecastType?: string;
    forecastRule?: string;
    // format: decimal
    periodTotalForecast?: string;
    periodTotalForecastCurrency?: string;
    // format: decimal
    periodTotalForecastRate?: string;
    // format: decimal
    totalForecastIncome?: string;
    totalForecastIncomeCurrency?: string;
    // format: decimal
    totalForecastIncomeRate?: string;
    paymentBasis?: string;
    taxationDetails?: ExcIceCorpactionsV1TaxationDetails;
    reinvestmentDetails?: ExcIceCorpactionsV1ReinvestmentDetails;
}

export interface ExcIceCorpactionsV1Ratio {
    numerator?: string;
    denominator?: string;
}

export interface ExcIceCorpactionsV1Record {
    instrument?: ExcIceCorpactionsV1Instrument;
    // format: YYYY-MM-DD
    announcementDate?: string;
    actionType?: ExcIceCorpactionsV1ActionType;
    // format: YYYY-MM-DD
    entryDate?: string;
    marketDetails?: ExcIceCorpactionsV1MarketDetails[];
    // format: YYYY-MM-DD
    recordDate?: string;
    announcementStatus?: ExcIceCorpactionsV1AnnouncementStatus;
    eventType?: ExcIceCorpactionsV1EventType;
    eventStatus?: ExcIceCorpactionsV1EventStatus;
    // format: YYYY-MM-DD
    effectiveDate?: string;
}

export interface ExcIceCorpactionsV1RecordSource {
    source?: IxcCorpactionsCadataV1SourceInfo;
    // format: date-time
    updated?: string;
    /* ICE's identifier for the event, which every revision of it shares. */
    // format: custom - pattern: ^[0-9]+$
    eventId?: string;
    // format: custom - pattern: ^[0-9]+$
    eventRevision?: string;
}

export interface ExcIceCorpactionsV1RedemptionList {
    redemptionItems?: ExcIceCorpactionsV1RedemptionListRedemptionItem[];
}

export interface ExcIceCorpactionsV1RedemptionListRedemptionItem {
    type?: string;
    // format: YYYY-MM-DD
    date?: string;
    // format: decimal
    price?: string;
    priceCurrency?: string;
    // format: decimal
    value?: string;
    valueCurrency?: string;
    status?: string;
    note?: string;
    // format: UINT64
    callsTotal?: string;
    // format: decimal
    amount?: string;
    // format: decimal
    accruedInterest?: string;
    accruedInterestMarker?: string;
    refundedInstrument?: ExcIceCorpactionsV1Instrument;
    nonrefundedInstrument?: ExcIceCorpactionsV1Instrument;
    agent?: string;
    state?: string;
    // format: decimal
    callAmount?: string;
    // format: decimal
    pricePercent?: string;
}

export interface ExcIceCorpactionsV1ReinvestmentDetails {
    dripIndicator?: boolean;
    // format: YYYY-MM-DD
    electionStartDate?: string;
    // format: YYYY-MM-DD
    electionEndDate?: string;
    // format: decimal
    reinvestmentPrice?: string;
    reinvestmentPriceCurrency?: string;
}

export interface ExcIceCorpactionsV1RepurchaseList {
    repurchaseItems?: ExcIceCorpactionsV1RepurchaseListRepurchaseItem[];
}

export interface ExcIceCorpactionsV1RepurchaseListRepurchaseItem {
    // format: UINT64
    optionNumber?: string;
    type?: string;
    // format: YYYY-MM-DD
    date?: string;
    // format: decimal
    amount?: string;
    // format: decimal
    paymentAmount?: string;
    paymentAmountCurrency?: string;
    // format: decimal
    paymentRate?: string;
    // format: decimal
    prorationRate?: string;
    // format: YYYY-MM-DD
    prorationDate?: string;
    // format: YYYY-MM-DD
    putDate?: string;
    // format: decimal
    putPrice?: string;
    putPriceCurrency?: string;
    // format: decimal
    putFee?: string;
    putFeeCurrency?: string;
    terms?: string;
    agent?: string;
    specialSituationType?: string;
    // format: YYYY-MM-DD
    withdrawalDate?: string;
    // format: decimal
    oddLotRange?: string;
    // format: decimal
    bidIncrement?: string;
    bidIncrementCurrency?: string;
    // format: decimal
    bidPriceMinimum?: string;
    bidPriceMinimumCurrency?: string;
    // format: decimal
    bidPriceMaximum?: string;
    bidPriceMaximumCurrency?: string;
    ratio?: ExcIceCorpactionsV1Ratio;
    // format: UINT64
    noOfOptions?: string;
    approvalCode?: string;
    // format: decimal
    capitalRepurchasePercent?: string;
    // format: decimal
    unitOfOfferAmount?: string;
    // format: decimal
    unitOfOffer?: string;
    unitOfOfferCurrency?: string;
    // format: decimal
    earlyPremium?: string;
    earlyPremiumCurrency?: string;
    details?: ExcIceCorpactionsV1RepurchaseListRepurchaseItemRepurchaseItemDetails[];
}

export interface ExcIceCorpactionsV1RepurchaseListRepurchaseItemRepurchaseItemDetails {
    // format: UINT64
    optionNumber?: string;
    // format: UINT64
    offeredSecuritySequenceNumber?: string;
    offeredInstrument?: ExcIceCorpactionsV1Instrument;
    offeredSecurityType?: ExcIceCorpactionsV1SecurityType;
    // format: decimal
    offeredSecurityAmount?: string;
    // format: decimal
    offeredSecurityValue?: string;
    offeredSecurityValueCurrency?: string;
}

export interface ExcIceCorpactionsV1SecurityType {
    description?: string;
    subtype?: string;
}

export interface ExcIceCorpactionsV1ShareholderMeeting {
    meetingType?: string;
    // format: YYYY-MM-DD
    meetingDate?: string;
    // format: YYYY-MM-DD
    recordDate?: string;
    meetingDescription?: string;
}

export interface ExcIceCorpactionsV1TaxationDetails {
    taxCode?: string;
    // format: decimal
    taxRate?: string;
    taxStatus?: string;
    // format: decimal
    taxAmountPayable?: string;
    taxAmountPayableCurrency?: string;
    dividendTaxMarker?: string;
    taxAmountUnits?: string;
    taxableAmountDetails?: ExcIceCorpactionsV1TaxationDetailsTaxableAmountDetails[];
}

export interface ExcIceCorpactionsV1TaxationDetailsTaxableAmountDetails {
    // format: UINT64
    taxSequenceNumber?: string;
    countryCode?: string;
    // format: decimal
    taxPaymentAmount?: string;
    taxPaymentAmountCurrency?: string;
    taxAmountType?: string;
    taxAmountUnits?: string;
}

export enum ExcIceGsmV1ApexAssetType {
    Unspecified = 'UNSPECIFIED',
    Other = 'OTHER',
    CorporateBond = 'CORPORATE_BOND',
    GovernmentAgencyBond = 'GOVERNMENT_AGENCY_BOND',
    UsMunicipalBond = 'US_MUNICIPAL_BOND',
    CollateralizedMortgageObligationAssetBackedSecurity = 'COLLATERALIZED_MORTGAGE_OBLIGATION_ASSET_BACKED_SECURITY',
    MortgageBackedSecurity = 'MORTGAGE_BACKED_SECURITY',
    MoneyMarket = 'MONEY_MARKET',
    CommonEquity = 'COMMON_EQUITY',
    PreferredEquity = 'PREFERRED_EQUITY',
    Right = 'RIGHT',
    Warrant = 'WARRANT',
    Option = 'OPTION',
    Future = 'FUTURE',
    Swap = 'SWAP',
    Currency = 'CURRENCY',
    Commodity = 'COMMODITY',
    Index = 'INDEX',
    MutualFundUnitInvestmentTrust = 'MUTUAL_FUND_UNIT_INVESTMENT_TRUST',
    MoneyMarketFund = 'MONEY_MARKET_FUND',
    ExchangeTradedFund = 'EXCHANGE_TRADED_FUND',
    Hybrid = 'HYBRID',
    NonUsMortgageBackedSecurity = 'NON_US_MORTGAGE_BACKED_SECURITY',
    CompositeUnit = 'COMPOSITE_UNIT',
    DebtEquityHybrid = 'DEBT_EQUITY_HYBRID',
    Strategy = 'STRATEGY',
    OverTheCounterOtc = 'OVER_THE_COUNTER_OTC',
    BankLoan = 'BANK_LOAN',
    MbsGeneric = 'MBS_GENERIC'
}

export const EXC_ICE_GSM_V1_APEX_ASSET_TYPE_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1ApexAssetType.Other]: 'Other',
    [ExcIceGsmV1ApexAssetType.CorporateBond]: 'Corporate Bond',
    [ExcIceGsmV1ApexAssetType.GovernmentAgencyBond]: 'Government/Agency Bond',
    [ExcIceGsmV1ApexAssetType.UsMunicipalBond]: 'US Municipal Bond',
    [ExcIceGsmV1ApexAssetType.CollateralizedMortgageObligationAssetBackedSecurity]: 'Collateralized Mortgage Obligation/Asset-Backed Security',
    [ExcIceGsmV1ApexAssetType.MortgageBackedSecurity]: 'Mortgage-Backed Security',
    [ExcIceGsmV1ApexAssetType.MoneyMarket]: 'Money Market',
    [ExcIceGsmV1ApexAssetType.CommonEquity]: 'Common Equity',
    [ExcIceGsmV1ApexAssetType.PreferredEquity]: 'Preferred Equity',
    [ExcIceGsmV1ApexAssetType.Right]: 'Right',
    [ExcIceGsmV1ApexAssetType.Warrant]: 'Warrant',
    [ExcIceGsmV1ApexAssetType.Option]: 'Option',
    [ExcIceGsmV1ApexAssetType.Future]: 'Future',
    [ExcIceGsmV1ApexAssetType.Swap]: 'Swap',
    [ExcIceGsmV1ApexAssetType.Currency]: 'Currency',
    [ExcIceGsmV1ApexAssetType.Commodity]: 'Commodity',
    [ExcIceGsmV1ApexAssetType.Index]: 'Index',
    [ExcIceGsmV1ApexAssetType.MutualFundUnitInvestmentTrust]: 'Mutual Fund/Unit Investment Trust',
    [ExcIceGsmV1ApexAssetType.MoneyMarketFund]: 'Money Market Fund',
    [ExcIceGsmV1ApexAssetType.ExchangeTradedFund]: 'Exchange Traded Fund',
    [ExcIceGsmV1ApexAssetType.Hybrid]: 'Hybrid',
    [ExcIceGsmV1ApexAssetType.NonUsMortgageBackedSecurity]: 'Non-US Mortgage-Backed Security',
    [ExcIceGsmV1ApexAssetType.CompositeUnit]: 'Composite Unit',
    [ExcIceGsmV1ApexAssetType.DebtEquityHybrid]: 'Debt/Equity Hybrid',
    [ExcIceGsmV1ApexAssetType.Strategy]: 'Strategy',
    [ExcIceGsmV1ApexAssetType.OverTheCounterOtc]: 'Over-the-counter (OTC)',
    [ExcIceGsmV1ApexAssetType.BankLoan]: 'Bank Loan',
    [ExcIceGsmV1ApexAssetType.MbsGeneric]: 'MBS Generic'
} as const;

export const EXC_ICE_GSM_V1_APEX_ASSET_TYPE_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1ApexAssetType.Other]: '0',
    [ExcIceGsmV1ApexAssetType.CorporateBond]: '1',
    [ExcIceGsmV1ApexAssetType.GovernmentAgencyBond]: '2',
    [ExcIceGsmV1ApexAssetType.UsMunicipalBond]: '3',
    [ExcIceGsmV1ApexAssetType.CollateralizedMortgageObligationAssetBackedSecurity]: '4',
    [ExcIceGsmV1ApexAssetType.MortgageBackedSecurity]: '5',
    [ExcIceGsmV1ApexAssetType.MoneyMarket]: '6',
    [ExcIceGsmV1ApexAssetType.CommonEquity]: '7',
    [ExcIceGsmV1ApexAssetType.PreferredEquity]: '8',
    [ExcIceGsmV1ApexAssetType.Right]: '9',
    [ExcIceGsmV1ApexAssetType.Warrant]: '10',
    [ExcIceGsmV1ApexAssetType.Option]: '11',
    [ExcIceGsmV1ApexAssetType.Future]: '12',
    [ExcIceGsmV1ApexAssetType.Swap]: '13',
    [ExcIceGsmV1ApexAssetType.Currency]: '14',
    [ExcIceGsmV1ApexAssetType.Commodity]: '15',
    [ExcIceGsmV1ApexAssetType.Index]: '16',
    [ExcIceGsmV1ApexAssetType.MutualFundUnitInvestmentTrust]: '17',
    [ExcIceGsmV1ApexAssetType.MoneyMarketFund]: '18',
    [ExcIceGsmV1ApexAssetType.ExchangeTradedFund]: '19',
    [ExcIceGsmV1ApexAssetType.Hybrid]: '20',
    [ExcIceGsmV1ApexAssetType.NonUsMortgageBackedSecurity]: '21',
    [ExcIceGsmV1ApexAssetType.CompositeUnit]: '22',
    [ExcIceGsmV1ApexAssetType.DebtEquityHybrid]: '23',
    [ExcIceGsmV1ApexAssetType.Strategy]: '24',
    [ExcIceGsmV1ApexAssetType.OverTheCounterOtc]: '25',
    [ExcIceGsmV1ApexAssetType.BankLoan]: '26',
    [ExcIceGsmV1ApexAssetType.MbsGeneric]: '27'
} as const;

export enum ExcIceGsmV1ApexBroadNarrowIndicator {
    Unspecified = 'UNSPECIFIED',
    Broad = 'BROAD',
    Narrow = 'NARROW'
}

export const EXC_ICE_GSM_V1_APEX_BROAD_NARROW_INDICATOR_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1ApexBroadNarrowIndicator.Broad]: 'Broad',
    [ExcIceGsmV1ApexBroadNarrowIndicator.Narrow]: 'Narrow'
} as const;

export const EXC_ICE_GSM_V1_APEX_BROAD_NARROW_INDICATOR_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1ApexBroadNarrowIndicator.Broad]: '1',
    [ExcIceGsmV1ApexBroadNarrowIndicator.Narrow]: '2'
} as const;

export enum ExcIceGsmV1ApexFundSource {
    Unspecified = 'UNSPECIFIED',
    Nasdaq = 'NASDAQ',
    NewYorkStockExchange = 'NEW_YORK_STOCK_EXCHANGE',
    Bats = 'BATS'
}

export const EXC_ICE_GSM_V1_APEX_FUND_SOURCE_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1ApexFundSource.Nasdaq]: 'NASDAQ',
    [ExcIceGsmV1ApexFundSource.NewYorkStockExchange]: 'New York Stock Exchange',
    [ExcIceGsmV1ApexFundSource.Bats]: 'BATS'
} as const;

export const EXC_ICE_GSM_V1_APEX_FUND_SOURCE_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1ApexFundSource.Nasdaq]: '1',
    [ExcIceGsmV1ApexFundSource.NewYorkStockExchange]: '2',
    [ExcIceGsmV1ApexFundSource.Bats]: '3'
} as const;

export enum ExcIceGsmV1BondIssueStatus {
    Unspecified = 'UNSPECIFIED',
    Live = 'LIVE',
    Dead = 'DEAD'
}

export const EXC_ICE_GSM_V1_BOND_ISSUE_STATUS_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1BondIssueStatus.Live]: 'Live',
    [ExcIceGsmV1BondIssueStatus.Dead]: 'Dead'
} as const;

export const EXC_ICE_GSM_V1_BOND_ISSUE_STATUS_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1BondIssueStatus.Live]: '1',
    [ExcIceGsmV1BondIssueStatus.Dead]: '2'
} as const;

export enum ExcIceGsmV1EntitlementType {
    Unspecified = 'UNSPECIFIED',
    None = 'NONE',
    CallWarrant = 'CALL_WARRANT',
    ExoticWarrant = 'EXOTIC_WARRANT',
    PutWarrant = 'PUT_WARRANT',
    Right = 'RIGHT',
    WarrantDeprecated = 'WARRANT_DEPRECATED'
}

export const EXC_ICE_GSM_V1_ENTITLEMENT_TYPE_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1EntitlementType.None]: 'None',
    [ExcIceGsmV1EntitlementType.CallWarrant]: 'Call Warrant',
    [ExcIceGsmV1EntitlementType.ExoticWarrant]: 'Exotic Warrant',
    [ExcIceGsmV1EntitlementType.PutWarrant]: 'Put Warrant',
    [ExcIceGsmV1EntitlementType.Right]: 'Right',
    [ExcIceGsmV1EntitlementType.WarrantDeprecated]: 'Warrant (deprecated)'
} as const;

export const EXC_ICE_GSM_V1_ENTITLEMENT_TYPE_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1EntitlementType.None]: '0',
    [ExcIceGsmV1EntitlementType.CallWarrant]: '1',
    [ExcIceGsmV1EntitlementType.ExoticWarrant]: '2',
    [ExcIceGsmV1EntitlementType.PutWarrant]: '3',
    [ExcIceGsmV1EntitlementType.Right]: '4',
    [ExcIceGsmV1EntitlementType.WarrantDeprecated]: '5'
} as const;

export interface ExcIceGsmV1EquityDetails {
    /* Whether this instrument is eligible for clearing by the Depository Trust Company (DTC) */
    dtcEligible?: boolean;
    /* The type of entitlement */
    entitlementType?: ExcIceGsmV1EntitlementType;
    /* The type of equity, if this instrument is an equity */
    equityType?: ExcIceGsmV1EquityType;
    /* Whether this instrument is eligible for margin trading */
    marginEligible?: boolean;
    /* Whether this instrument is eligible for clearing via the National Securities Clearing Corporation (NSCC) */
    nsccEligible?: boolean;
    preferredType?: ExcIceGsmV1PreferredType;
    /* Whether this instrument is a registered investment company (RIC) */
    isRegisteredInvestmentCompany?: boolean;
    /* The type of warrant, if this instrument is a warrant */
    warrantType?: ExcIceGsmV1WarrantType;
    /* Whether this instrument is eligible for TRACE reporting */
    traceEligible?: boolean;
}

export enum ExcIceGsmV1EquityType {
    Unspecified = 'UNSPECIFIED',
    None = 'NONE',
    CommonOrdinaryStock = 'COMMON_ORDINARY_STOCK',
    PreferredPreference = 'PREFERRED_PREFERENCE',
    ShareOfBeneficialInterest = 'SHARE_OF_BENEFICIAL_INTEREST'
}

export const EXC_ICE_GSM_V1_EQUITY_TYPE_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1EquityType.None]: 'None',
    [ExcIceGsmV1EquityType.CommonOrdinaryStock]: 'Common/Ordinary Stock',
    [ExcIceGsmV1EquityType.PreferredPreference]: 'Preferred/Preference',
    [ExcIceGsmV1EquityType.ShareOfBeneficialInterest]: 'Share of Beneficial Interest'
} as const;

export const EXC_ICE_GSM_V1_EQUITY_TYPE_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1EquityType.None]: '0',
    [ExcIceGsmV1EquityType.CommonOrdinaryStock]: '1',
    [ExcIceGsmV1EquityType.PreferredPreference]: '2',
    [ExcIceGsmV1EquityType.ShareOfBeneficialInterest]: '3'
} as const;

export enum ExcIceGsmV1EtfDbFundType {
    Unspecified = 'UNSPECIFIED',
    Passive = 'PASSIVE',
    Active = 'ACTIVE',
    Leveraged = 'LEVERAGED',
    Short = 'SHORT',
    Quantitative = 'QUANTITATIVE'
}

export const EXC_ICE_GSM_V1_ETF_DB_FUND_TYPE_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1EtfDbFundType.Passive]: 'Passive',
    [ExcIceGsmV1EtfDbFundType.Active]: 'Active',
    [ExcIceGsmV1EtfDbFundType.Leveraged]: 'Leveraged',
    [ExcIceGsmV1EtfDbFundType.Short]: 'Short',
    [ExcIceGsmV1EtfDbFundType.Quantitative]: 'Quantitative'
} as const;

export const EXC_ICE_GSM_V1_ETF_DB_FUND_TYPE_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1EtfDbFundType.Passive]: '1',
    [ExcIceGsmV1EtfDbFundType.Active]: '2',
    [ExcIceGsmV1EtfDbFundType.Leveraged]: '3',
    [ExcIceGsmV1EtfDbFundType.Short]: '4',
    [ExcIceGsmV1EtfDbFundType.Quantitative]: '5'
} as const;

export enum ExcIceGsmV1EtfDbSectorType {
    Unspecified = 'UNSPECIFIED',
    Commodity = 'COMMODITY',
    Currency = 'CURRENCY',
    Equity = 'EQUITY',
    FixedIncome = 'FIXED_INCOME',
    GlobalEquity = 'GLOBAL_EQUITY',
    GlobalFixedIncome = 'GLOBAL_FIXED_INCOME',
    Blended = 'BLENDED',
    AssetAllocation = 'ASSET_ALLOCATION',
    Alternatives = 'ALTERNATIVES'
}

export const EXC_ICE_GSM_V1_ETF_DB_SECTOR_TYPE_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1EtfDbSectorType.Commodity]: 'Commodity',
    [ExcIceGsmV1EtfDbSectorType.Currency]: 'Currency',
    [ExcIceGsmV1EtfDbSectorType.Equity]: 'Equity',
    [ExcIceGsmV1EtfDbSectorType.FixedIncome]: 'Fixed Income',
    [ExcIceGsmV1EtfDbSectorType.GlobalEquity]: 'Global Equity',
    [ExcIceGsmV1EtfDbSectorType.GlobalFixedIncome]: 'Global Fixed Income',
    [ExcIceGsmV1EtfDbSectorType.Blended]: 'Blended',
    [ExcIceGsmV1EtfDbSectorType.AssetAllocation]: 'Asset Allocation',
    [ExcIceGsmV1EtfDbSectorType.Alternatives]: 'Alternatives'
} as const;

export const EXC_ICE_GSM_V1_ETF_DB_SECTOR_TYPE_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1EtfDbSectorType.Commodity]: '1',
    [ExcIceGsmV1EtfDbSectorType.Currency]: '2',
    [ExcIceGsmV1EtfDbSectorType.Equity]: '3',
    [ExcIceGsmV1EtfDbSectorType.FixedIncome]: '4',
    [ExcIceGsmV1EtfDbSectorType.GlobalEquity]: '5',
    [ExcIceGsmV1EtfDbSectorType.GlobalFixedIncome]: '6',
    [ExcIceGsmV1EtfDbSectorType.Blended]: '7',
    [ExcIceGsmV1EtfDbSectorType.AssetAllocation]: '8',
    [ExcIceGsmV1EtfDbSectorType.Alternatives]: '9'
} as const;

export enum ExcIceGsmV1EtfDbStructureType {
    Unspecified = 'UNSPECIFIED',
    Etf = 'ETF',
    Etn = 'ETN',
    Etp = 'ETP',
    Etmf = 'ETMF'
}

export const EXC_ICE_GSM_V1_ETF_DB_STRUCTURE_TYPE_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1EtfDbStructureType.Etf]: 'ETF',
    [ExcIceGsmV1EtfDbStructureType.Etn]: 'ETN',
    [ExcIceGsmV1EtfDbStructureType.Etp]: 'ETP',
    [ExcIceGsmV1EtfDbStructureType.Etmf]: 'ETMF'
} as const;

export const EXC_ICE_GSM_V1_ETF_DB_STRUCTURE_TYPE_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1EtfDbStructureType.Etf]: '1',
    [ExcIceGsmV1EtfDbStructureType.Etn]: '2',
    [ExcIceGsmV1EtfDbStructureType.Etp]: '3',
    [ExcIceGsmV1EtfDbStructureType.Etmf]: '4'
} as const;

export enum ExcIceGsmV1EtfDbSubSectorType {
    Unspecified = 'UNSPECIFIED',
    BasicMaterialsFunds = 'BASIC_MATERIALS_FUNDS',
    CapitalAppreciationFunds = 'CAPITAL_APPRECIATION_FUNDS',
    ChinaRegionFunds = 'CHINA_REGION_FUNDS',
    BroadMarket = 'BROAD_MARKET',
    ConsumerGoodsFunds = 'CONSUMER_GOODS_FUNDS',
    ConsumerServicesFunds = 'CONSUMER_SERVICES_FUNDS',
    CorporateDebtFunds = 'CORPORATE_DEBT_FUNDS',
    DiversifiedLeverageFunds = 'DIVERSIFIED_LEVERAGE_FUNDS',
    EmergingMarketsDebtFunds = 'EMERGING_MARKETS_DEBT_FUNDS',
    EmergingMarketsFunds = 'EMERGING_MARKETS_FUNDS',
    EuropeanRegionFunds = 'EUROPEAN_REGION_FUNDS',
    FinancialServicesFunds = 'FINANCIAL_SERVICES_FUNDS',
    FlexiblePortfolioFunds = 'FLEXIBLE_PORTFOLIO_FUNDS',
    BroadCredit = 'BROAD_CREDIT',
    USTreasuryFunds = 'U_S_TREASURY_FUNDS',
    GlobalFunds = 'GLOBAL_FUNDS',
    InfrastructureFunds = 'INFRASTRUCTURE_FUNDS',
    GoldOrientedFunds = 'GOLD_ORIENTED_FUNDS',
    GrowthAndIncomeFunds = 'GROWTH_AND_INCOME_FUNDS',
    GrowthFunds = 'GROWTH_FUNDS',
    HealthBiotechnologyFunds = 'HEALTH_BIOTECHNOLOGY_FUNDS',
    IncomeFunds = 'INCOME_FUNDS',
    IndustrialsFunds = 'INDUSTRIALS_FUNDS',
    InternationalFunds = 'INTERNATIONAL_FUNDS',
    InternationalIncomeFunds = 'INTERNATIONAL_INCOME_FUNDS',
    InternationalRealEstateFunds = 'INTERNATIONAL_REAL_ESTATE_FUNDS',
    JapaneseFunds = 'JAPANESE_FUNDS',
    LatinAmericanFunds = 'LATIN_AMERICAN_FUNDS',
    LongShortEquityFunds = 'LONG_SHORT_EQUITY_FUNDS',
    MicroCapFunds = 'MICRO_CAP_FUNDS',
    MidCapFunds = 'MID_CAP_FUNDS',
    MoneyMarketFunds = 'MONEY_MARKET_FUNDS',
    MunicipalDebtFunds = 'MUNICIPAL_DEBT_FUNDS',
    Energy = 'ENERGY',
    PacificRegionFunds = 'PACIFIC_REGION_FUNDS',
    RealEstateFunds = 'REAL_ESTATE_FUNDS',
    ScienceAndTechnologyFunds = 'SCIENCE_AND_TECHNOLOGY_FUNDS',
    SmallCapFunds = 'SMALL_CAP_FUNDS',
    SpecialtyCurrencyFund = 'SPECIALTY_CURRENCY_FUND',
    SpecialtyEquityFunds = 'SPECIALTY_EQUITY_FUNDS',
    SpecialtyFixedIncomeFunds = 'SPECIALTY_FIXED_INCOME_FUNDS',
    TelecommunicationFunds = 'TELECOMMUNICATION_FUNDS',
    TreasuryInflationProtectedSecurities = 'TREASURY_INFLATION_PROTECTED_SECURITIES',
    USGovernmentFunds = 'U_S_GOVERNMENT_FUNDS',
    USMortgageFunds = 'U_S_MORTGAGE_FUNDS',
    UltraShortObligationsFunds = 'ULTRA_SHORT_OBLIGATIONS_FUNDS',
    UtilityFunds = 'UTILITY_FUNDS',
    LargeCapFunds = 'LARGE_CAP_FUNDS',
    AgricultureFunds = 'AGRICULTURE_FUNDS',
    BetaFocusedFunds = 'BETA_FOCUSED_FUNDS',
    DevelopedMarketsFunds = 'DEVELOPED_MARKETS_FUNDS',
    FrontierMarketsFunds = 'FRONTIER_MARKETS_FUNDS',
    MultiCapFunds = 'MULTI_CAP_FUNDS',
    NonPreciousMetalsFunds = 'NON_PRECIOUS_METALS_FUNDS',
    PreciousMetalsFunds = 'PRECIOUS_METALS_FUNDS',
    ValueFunds = 'VALUE_FUNDS',
    VolatilityFocusedFund = 'VOLATILITY_FOCUSED_FUND',
    TargetDate = 'TARGET_DATE',
    TargetRisk = 'TARGET_RISK',
    TargetOutcome = 'TARGET_OUTCOME',
    GlobalMacro = 'GLOBAL_MACRO',
    Spreads = 'SPREADS',
    SpecialtyAsset = 'SPECIALTY_ASSET',
    Cryptocurrency = 'CRYPTOCURRENCY',
    HighYield = 'HIGH_YIELD',
    InvestmentGrade = 'INVESTMENT_GRADE',
    ConsumerDiscretionary = 'CONSUMER_DISCRETIONARY',
    ConsumerStaples = 'CONSUMER_STAPLES',
    ExtendedMarket = 'EXTENDED_MARKET',
    HighDividendYield = 'HIGH_DIVIDEND_YIELD',
    Theme = 'THEME',
    TotalMarket = 'TOTAL_MARKET',
    MultiStrategy = 'MULTI_STRATEGY'
}

export const EXC_ICE_GSM_V1_ETF_DB_SUB_SECTOR_TYPE_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1EtfDbSubSectorType.BasicMaterialsFunds]: 'Basic materials funds',
    [ExcIceGsmV1EtfDbSubSectorType.CapitalAppreciationFunds]: 'Capital appreciation funds',
    [ExcIceGsmV1EtfDbSubSectorType.ChinaRegionFunds]: 'China region funds',
    [ExcIceGsmV1EtfDbSubSectorType.BroadMarket]: 'Broad Market',
    [ExcIceGsmV1EtfDbSubSectorType.ConsumerGoodsFunds]: 'Consumer goods funds',
    [ExcIceGsmV1EtfDbSubSectorType.ConsumerServicesFunds]: 'Consumer services funds',
    [ExcIceGsmV1EtfDbSubSectorType.CorporateDebtFunds]: 'Corporate debt funds',
    [ExcIceGsmV1EtfDbSubSectorType.DiversifiedLeverageFunds]: 'Diversified leverage funds',
    [ExcIceGsmV1EtfDbSubSectorType.EmergingMarketsDebtFunds]: 'Emerging markets debt funds',
    [ExcIceGsmV1EtfDbSubSectorType.EmergingMarketsFunds]: 'Emerging markets funds',
    [ExcIceGsmV1EtfDbSubSectorType.EuropeanRegionFunds]: 'European region funds',
    [ExcIceGsmV1EtfDbSubSectorType.FinancialServicesFunds]: 'Financial services funds',
    [ExcIceGsmV1EtfDbSubSectorType.FlexiblePortfolioFunds]: 'Flexible portfolio funds',
    [ExcIceGsmV1EtfDbSubSectorType.BroadCredit]: 'Broad Credit',
    [ExcIceGsmV1EtfDbSubSectorType.USTreasuryFunds]: 'U.S. Treasury funds',
    [ExcIceGsmV1EtfDbSubSectorType.GlobalFunds]: 'Global funds',
    [ExcIceGsmV1EtfDbSubSectorType.InfrastructureFunds]: 'Infrastructure Funds',
    [ExcIceGsmV1EtfDbSubSectorType.GoldOrientedFunds]: 'Gold oriented funds',
    [ExcIceGsmV1EtfDbSubSectorType.GrowthAndIncomeFunds]: 'Growth and income funds',
    [ExcIceGsmV1EtfDbSubSectorType.GrowthFunds]: 'Growth funds',
    [ExcIceGsmV1EtfDbSubSectorType.HealthBiotechnologyFunds]: 'Health/biotechnology funds',
    [ExcIceGsmV1EtfDbSubSectorType.IncomeFunds]: 'Income funds',
    [ExcIceGsmV1EtfDbSubSectorType.IndustrialsFunds]: 'Industrials funds',
    [ExcIceGsmV1EtfDbSubSectorType.InternationalFunds]: 'International funds',
    [ExcIceGsmV1EtfDbSubSectorType.InternationalIncomeFunds]: 'International income funds',
    [ExcIceGsmV1EtfDbSubSectorType.InternationalRealEstateFunds]: 'International real estate funds',
    [ExcIceGsmV1EtfDbSubSectorType.JapaneseFunds]: 'Japanese funds',
    [ExcIceGsmV1EtfDbSubSectorType.LatinAmericanFunds]: 'Latin American funds',
    [ExcIceGsmV1EtfDbSubSectorType.LongShortEquityFunds]: 'Long/short equity funds',
    [ExcIceGsmV1EtfDbSubSectorType.MicroCapFunds]: 'Micro-cap funds',
    [ExcIceGsmV1EtfDbSubSectorType.MidCapFunds]: 'Mid-cap funds',
    [ExcIceGsmV1EtfDbSubSectorType.MoneyMarketFunds]: 'Money market funds',
    [ExcIceGsmV1EtfDbSubSectorType.MunicipalDebtFunds]: 'Municipal debt funds',
    [ExcIceGsmV1EtfDbSubSectorType.Energy]: 'Energy',
    [ExcIceGsmV1EtfDbSubSectorType.PacificRegionFunds]: 'Pacific region funds',
    [ExcIceGsmV1EtfDbSubSectorType.RealEstateFunds]: 'Real estate funds',
    [ExcIceGsmV1EtfDbSubSectorType.ScienceAndTechnologyFunds]: 'Science and technology funds',
    [ExcIceGsmV1EtfDbSubSectorType.SmallCapFunds]: 'Small-cap funds',
    [ExcIceGsmV1EtfDbSubSectorType.SpecialtyCurrencyFund]: 'Specialty: currency fund',
    [ExcIceGsmV1EtfDbSubSectorType.SpecialtyEquityFunds]: 'Specialty: equity funds',
    [ExcIceGsmV1EtfDbSubSectorType.SpecialtyFixedIncomeFunds]: 'Specialty: fixed income funds',
    [ExcIceGsmV1EtfDbSubSectorType.TelecommunicationFunds]: 'Telecommunication funds',
    [ExcIceGsmV1EtfDbSubSectorType.TreasuryInflationProtectedSecurities]: 'Treasury inflation protected securities',
    [ExcIceGsmV1EtfDbSubSectorType.USGovernmentFunds]: 'U.S. Government funds',
    [ExcIceGsmV1EtfDbSubSectorType.USMortgageFunds]: 'U.S. Mortgage funds',
    [ExcIceGsmV1EtfDbSubSectorType.UltraShortObligationsFunds]: 'Ultra-short obligations funds',
    [ExcIceGsmV1EtfDbSubSectorType.UtilityFunds]: 'Utility funds',
    [ExcIceGsmV1EtfDbSubSectorType.LargeCapFunds]: 'Large-cap funds',
    [ExcIceGsmV1EtfDbSubSectorType.AgricultureFunds]: 'Agriculture funds',
    [ExcIceGsmV1EtfDbSubSectorType.BetaFocusedFunds]: 'Beta focused funds',
    [ExcIceGsmV1EtfDbSubSectorType.DevelopedMarketsFunds]: 'Developed markets funds',
    [ExcIceGsmV1EtfDbSubSectorType.FrontierMarketsFunds]: 'Frontier markets funds',
    [ExcIceGsmV1EtfDbSubSectorType.MultiCapFunds]: 'Multi-cap funds',
    [ExcIceGsmV1EtfDbSubSectorType.NonPreciousMetalsFunds]: 'Non-precious metals funds',
    [ExcIceGsmV1EtfDbSubSectorType.PreciousMetalsFunds]: 'Precious metals funds',
    [ExcIceGsmV1EtfDbSubSectorType.ValueFunds]: 'Value funds',
    [ExcIceGsmV1EtfDbSubSectorType.VolatilityFocusedFund]: 'Volatility focused fund',
    [ExcIceGsmV1EtfDbSubSectorType.TargetDate]: 'Target Date',
    [ExcIceGsmV1EtfDbSubSectorType.TargetRisk]: 'Target Risk',
    [ExcIceGsmV1EtfDbSubSectorType.TargetOutcome]: 'Target Outcome',
    [ExcIceGsmV1EtfDbSubSectorType.GlobalMacro]: 'Global Macro',
    [ExcIceGsmV1EtfDbSubSectorType.Spreads]: 'Spreads',
    [ExcIceGsmV1EtfDbSubSectorType.SpecialtyAsset]: 'Specialty Asset',
    [ExcIceGsmV1EtfDbSubSectorType.Cryptocurrency]: 'Cryptocurrency',
    [ExcIceGsmV1EtfDbSubSectorType.HighYield]: 'High Yield',
    [ExcIceGsmV1EtfDbSubSectorType.InvestmentGrade]: 'Investment Grade',
    [ExcIceGsmV1EtfDbSubSectorType.ConsumerDiscretionary]: 'Consumer Discretionary',
    [ExcIceGsmV1EtfDbSubSectorType.ConsumerStaples]: 'Consumer Staples',
    [ExcIceGsmV1EtfDbSubSectorType.ExtendedMarket]: 'Extended Market',
    [ExcIceGsmV1EtfDbSubSectorType.HighDividendYield]: 'High Dividend Yield',
    [ExcIceGsmV1EtfDbSubSectorType.Theme]: 'Theme',
    [ExcIceGsmV1EtfDbSubSectorType.TotalMarket]: 'Total Market',
    [ExcIceGsmV1EtfDbSubSectorType.MultiStrategy]: 'Multi Strategy'
} as const;

export const EXC_ICE_GSM_V1_ETF_DB_SUB_SECTOR_TYPE_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1EtfDbSubSectorType.BasicMaterialsFunds]: '1',
    [ExcIceGsmV1EtfDbSubSectorType.CapitalAppreciationFunds]: '2',
    [ExcIceGsmV1EtfDbSubSectorType.ChinaRegionFunds]: '3',
    [ExcIceGsmV1EtfDbSubSectorType.BroadMarket]: '4',
    [ExcIceGsmV1EtfDbSubSectorType.ConsumerGoodsFunds]: '5',
    [ExcIceGsmV1EtfDbSubSectorType.ConsumerServicesFunds]: '6',
    [ExcIceGsmV1EtfDbSubSectorType.CorporateDebtFunds]: '7',
    [ExcIceGsmV1EtfDbSubSectorType.DiversifiedLeverageFunds]: '8',
    [ExcIceGsmV1EtfDbSubSectorType.EmergingMarketsDebtFunds]: '9',
    [ExcIceGsmV1EtfDbSubSectorType.EmergingMarketsFunds]: '10',
    [ExcIceGsmV1EtfDbSubSectorType.EuropeanRegionFunds]: '11',
    [ExcIceGsmV1EtfDbSubSectorType.FinancialServicesFunds]: '12',
    [ExcIceGsmV1EtfDbSubSectorType.FlexiblePortfolioFunds]: '13',
    [ExcIceGsmV1EtfDbSubSectorType.BroadCredit]: '14',
    [ExcIceGsmV1EtfDbSubSectorType.USTreasuryFunds]: '15',
    [ExcIceGsmV1EtfDbSubSectorType.GlobalFunds]: '16',
    [ExcIceGsmV1EtfDbSubSectorType.InfrastructureFunds]: '17',
    [ExcIceGsmV1EtfDbSubSectorType.GoldOrientedFunds]: '18',
    [ExcIceGsmV1EtfDbSubSectorType.GrowthAndIncomeFunds]: '19',
    [ExcIceGsmV1EtfDbSubSectorType.GrowthFunds]: '20',
    [ExcIceGsmV1EtfDbSubSectorType.HealthBiotechnologyFunds]: '21',
    [ExcIceGsmV1EtfDbSubSectorType.IncomeFunds]: '22',
    [ExcIceGsmV1EtfDbSubSectorType.IndustrialsFunds]: '23',
    [ExcIceGsmV1EtfDbSubSectorType.InternationalFunds]: '24',
    [ExcIceGsmV1EtfDbSubSectorType.InternationalIncomeFunds]: '25',
    [ExcIceGsmV1EtfDbSubSectorType.InternationalRealEstateFunds]: '26',
    [ExcIceGsmV1EtfDbSubSectorType.JapaneseFunds]: '27',
    [ExcIceGsmV1EtfDbSubSectorType.LatinAmericanFunds]: '28',
    [ExcIceGsmV1EtfDbSubSectorType.LongShortEquityFunds]: '29',
    [ExcIceGsmV1EtfDbSubSectorType.MicroCapFunds]: '30',
    [ExcIceGsmV1EtfDbSubSectorType.MidCapFunds]: '31',
    [ExcIceGsmV1EtfDbSubSectorType.MoneyMarketFunds]: '32',
    [ExcIceGsmV1EtfDbSubSectorType.MunicipalDebtFunds]: '33',
    [ExcIceGsmV1EtfDbSubSectorType.Energy]: '34',
    [ExcIceGsmV1EtfDbSubSectorType.PacificRegionFunds]: '35',
    [ExcIceGsmV1EtfDbSubSectorType.RealEstateFunds]: '36',
    [ExcIceGsmV1EtfDbSubSectorType.ScienceAndTechnologyFunds]: '37',
    [ExcIceGsmV1EtfDbSubSectorType.SmallCapFunds]: '38',
    [ExcIceGsmV1EtfDbSubSectorType.SpecialtyCurrencyFund]: '39',
    [ExcIceGsmV1EtfDbSubSectorType.SpecialtyEquityFunds]: '40',
    [ExcIceGsmV1EtfDbSubSectorType.SpecialtyFixedIncomeFunds]: '41',
    [ExcIceGsmV1EtfDbSubSectorType.TelecommunicationFunds]: '42',
    [ExcIceGsmV1EtfDbSubSectorType.TreasuryInflationProtectedSecurities]: '43',
    [ExcIceGsmV1EtfDbSubSectorType.USGovernmentFunds]: '44',
    [ExcIceGsmV1EtfDbSubSectorType.USMortgageFunds]: '45',
    [ExcIceGsmV1EtfDbSubSectorType.UltraShortObligationsFunds]: '46',
    [ExcIceGsmV1EtfDbSubSectorType.UtilityFunds]: '47',
    [ExcIceGsmV1EtfDbSubSectorType.LargeCapFunds]: '48',
    [ExcIceGsmV1EtfDbSubSectorType.AgricultureFunds]: '49',
    [ExcIceGsmV1EtfDbSubSectorType.BetaFocusedFunds]: '50',
    [ExcIceGsmV1EtfDbSubSectorType.DevelopedMarketsFunds]: '51',
    [ExcIceGsmV1EtfDbSubSectorType.FrontierMarketsFunds]: '52',
    [ExcIceGsmV1EtfDbSubSectorType.MultiCapFunds]: '53',
    [ExcIceGsmV1EtfDbSubSectorType.NonPreciousMetalsFunds]: '54',
    [ExcIceGsmV1EtfDbSubSectorType.PreciousMetalsFunds]: '55',
    [ExcIceGsmV1EtfDbSubSectorType.ValueFunds]: '56',
    [ExcIceGsmV1EtfDbSubSectorType.VolatilityFocusedFund]: '57',
    [ExcIceGsmV1EtfDbSubSectorType.TargetDate]: '58',
    [ExcIceGsmV1EtfDbSubSectorType.TargetRisk]: '59',
    [ExcIceGsmV1EtfDbSubSectorType.TargetOutcome]: '60',
    [ExcIceGsmV1EtfDbSubSectorType.GlobalMacro]: '61',
    [ExcIceGsmV1EtfDbSubSectorType.Spreads]: '62',
    [ExcIceGsmV1EtfDbSubSectorType.SpecialtyAsset]: '63',
    [ExcIceGsmV1EtfDbSubSectorType.Cryptocurrency]: '64',
    [ExcIceGsmV1EtfDbSubSectorType.HighYield]: '65',
    [ExcIceGsmV1EtfDbSubSectorType.InvestmentGrade]: '66',
    [ExcIceGsmV1EtfDbSubSectorType.ConsumerDiscretionary]: '67',
    [ExcIceGsmV1EtfDbSubSectorType.ConsumerStaples]: '68',
    [ExcIceGsmV1EtfDbSubSectorType.ExtendedMarket]: '69',
    [ExcIceGsmV1EtfDbSubSectorType.HighDividendYield]: '70',
    [ExcIceGsmV1EtfDbSubSectorType.Theme]: '71',
    [ExcIceGsmV1EtfDbSubSectorType.TotalMarket]: '72',
    [ExcIceGsmV1EtfDbSubSectorType.MultiStrategy]: '73'
} as const;

export enum ExcIceGsmV1FundAssetType {
    Unspecified = 'UNSPECIFIED',
    Balanced = 'BALANCED',
    BalancedIncome = 'BALANCED_INCOME',
    BlueChip = 'BLUE_CHIP',
    Bond = 'BOND',
    Commodity = 'COMMODITY',
    Convertible = 'CONVERTIBLE',
    CorporateBond = 'CORPORATE_BOND',
    Derivative = 'DERIVATIVE',
    DistressedSecurities = 'DISTRESSED_SECURITIES',
    Equity = 'EQUITY',
    EquityGrowth = 'EQUITY_GROWTH',
    EquityIncome = 'EQUITY_INCOME',
    EquityBear = 'EQUITY_BEAR',
    Feeder = 'FEEDER',
    FundOfFunds = 'FUND_OF_FUNDS',
    Futures = 'FUTURES',
    GovernmentSecurities = 'GOVERNMENT_SECURITIES',
    Guaranteed = 'GUARANTEED',
    HighYieldBond = 'HIGH_YIELD_BOND',
    Index = 'INDEX',
    LargeCapStocks = 'LARGE_CAP_STOCKS',
    LongTermBond = 'LONG_TERM_BOND',
    MediumTermBond = 'MEDIUM_TERM_BOND',
    MicroCapStocks = 'MICRO_CAP_STOCKS',
    MidCapStocks = 'MID_CAP_STOCKS',
    MoneyMarket = 'MONEY_MARKET',
    Options = 'OPTIONS',
    RealEstate = 'REAL_ESTATE',
    SecuritiesAndRealEstate = 'SECURITIES_AND_REAL_ESTATE',
    ShortTermBond = 'SHORT_TERM_BOND',
    SmallCapStocks = 'SMALL_CAP_STOCKS',
    TradedEndowmentPolicy = 'TRADED_ENDOWMENT_POLICY',
    VentureCapital = 'VENTURE_CAPITAL',
    Warrants = 'WARRANTS',
    ZeroCouponBond = 'ZERO_COUPON_BOND',
    SmallMiddleCapStock = 'SMALL_MIDDLE_CAP_STOCK',
    BalancedEquity = 'BALANCED_EQUITY',
    BalancedBond = 'BALANCED_BOND',
    MixedAssets = 'MIXED_ASSETS',
    AfricanEquityIndex = 'AFRICAN_EQUITY_INDEX',
    AreaEuroBondIndex = 'AREA_EURO_BOND_INDEX',
    AsianEquityIndex = 'ASIAN_EQUITY_INDEX',
    AustralianEquityIndex = 'AUSTRALIAN_EQUITY_INDEX',
    BondsCurrency = 'BONDS_CURRENCY',
    BondsGeographicArea = 'BONDS_GEOGRAPHIC_AREA',
    BondsGovernments = 'BONDS_GOVERNMENTS',
    BondsHighYield = 'BONDS_HIGH_YIELD',
    BondsInternational = 'BONDS_INTERNATIONAL',
    BondsInvestmentGrade = 'BONDS_INVESTMENT_GRADE',
    BondsNotSpecialist = 'BONDS_NOT_SPECIALIST',
    CommodityIndex = 'COMMODITY_INDEX',
    CountryBondsIndex = 'COUNTRY_BONDS_INDEX',
    CountrySharesIndex = 'COUNTRY_SHARES_INDEX',
    CurrenciesIndex = 'CURRENCIES_INDEX',
    DerivativesIndex = 'DERIVATIVES_INDEX',
    DerivativesIndexRawMaterials = 'DERIVATIVES_INDEX_RAW_MATERIALS',
    DiversifiedFlexible = 'DIVERSIFIED_FLEXIBLE',
    EquityBasket = 'EQUITY_BASKET',
    EquityIndexEmergingCountries = 'EQUITY_INDEX_EMERGING_COUNTRIES',
    EquityIndexGeographicArea = 'EQUITY_INDEX_GEOGRAPHIC_AREA',
    EthicalEquityIndex = 'ETHICAL_EQUITY_INDEX',
    EuroAreaEquityIndex = 'EURO_AREA_EQUITY_INDEX',
    EuropeBondIndex = 'EUROPE_BOND_INDEX',
    EuropeEquityIndex = 'EUROPE_EQUITY_INDEX',
    Funds = 'FUNDS',
    Goods = 'GOODS',
    IndexOfEtFsBalanced = 'INDEX_OF_ET_FS_BALANCED',
    IndexOfEtFsBonds = 'INDEX_OF_ET_FS_BONDS',
    IndexOfEtFsFlexible = 'INDEX_OF_ET_FS_FLEXIBLE',
    IndexOfEtFsShares = 'INDEX_OF_ET_FS_SHARES',
    IndexOfFundsBonds = 'INDEX_OF_FUNDS_BONDS',
    InternationalBondIndex = 'INTERNATIONAL_BOND_INDEX',
    InternationalEquityIndex = 'INTERNATIONAL_EQUITY_INDEX',
    NonUsaAmericanBondIndex = 'NON_USA_AMERICAN_BOND_INDEX',
    NonUsaAmericanEquityIndex = 'NON_USA_AMERICAN_EQUITY_INDEX',
    SectorEquityIndex = 'SECTOR_EQUITY_INDEX',
    SharesGeographicArea = 'SHARES_GEOGRAPHIC_AREA',
    SharesOthers = 'SHARES_OTHERS',
    SharesSector = 'SHARES_SECTOR',
    SharesSpecialist = 'SHARES_SPECIALIST',
    SharesGlobal = 'SHARES_GLOBAL',
    UsaBondIndex = 'USA_BOND_INDEX',
    UsaEquityIndex = 'USA_EQUITY_INDEX',
    Cryptocurrencies = 'CRYPTOCURRENCIES',
    IndexCryptocurrencies = 'INDEX_CRYPTOCURRENCIES'
}

export const EXC_ICE_GSM_V1_FUND_ASSET_TYPE_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1FundAssetType.Balanced]: 'Balanced',
    [ExcIceGsmV1FundAssetType.BalancedIncome]: 'Balanced Income',
    [ExcIceGsmV1FundAssetType.BlueChip]: 'Blue Chip',
    [ExcIceGsmV1FundAssetType.Bond]: 'Bond',
    [ExcIceGsmV1FundAssetType.Commodity]: 'Commodity',
    [ExcIceGsmV1FundAssetType.Convertible]: 'Convertible',
    [ExcIceGsmV1FundAssetType.CorporateBond]: 'Corporate Bond',
    [ExcIceGsmV1FundAssetType.Derivative]: 'Derivative',
    [ExcIceGsmV1FundAssetType.DistressedSecurities]: 'Distressed Securities',
    [ExcIceGsmV1FundAssetType.Equity]: 'Equity',
    [ExcIceGsmV1FundAssetType.EquityGrowth]: 'Equity Growth',
    [ExcIceGsmV1FundAssetType.EquityIncome]: 'Equity Income',
    [ExcIceGsmV1FundAssetType.EquityBear]: 'Equity Bear',
    [ExcIceGsmV1FundAssetType.Feeder]: 'Feeder',
    [ExcIceGsmV1FundAssetType.FundOfFunds]: 'Fund of Funds',
    [ExcIceGsmV1FundAssetType.Futures]: 'Futures',
    [ExcIceGsmV1FundAssetType.GovernmentSecurities]: 'Government Securities',
    [ExcIceGsmV1FundAssetType.Guaranteed]: 'Guaranteed',
    [ExcIceGsmV1FundAssetType.HighYieldBond]: 'High Yield Bond',
    [ExcIceGsmV1FundAssetType.Index]: 'Index',
    [ExcIceGsmV1FundAssetType.LargeCapStocks]: 'Large-Cap Stocks',
    [ExcIceGsmV1FundAssetType.LongTermBond]: 'Long-Term Bond',
    [ExcIceGsmV1FundAssetType.MediumTermBond]: 'Medium-Term Bond',
    [ExcIceGsmV1FundAssetType.MicroCapStocks]: 'Micro-Cap Stocks',
    [ExcIceGsmV1FundAssetType.MidCapStocks]: 'Mid-Cap Stocks',
    [ExcIceGsmV1FundAssetType.MoneyMarket]: 'Money Market',
    [ExcIceGsmV1FundAssetType.Options]: 'Options',
    [ExcIceGsmV1FundAssetType.RealEstate]: 'Real Estate',
    [ExcIceGsmV1FundAssetType.SecuritiesAndRealEstate]: 'Securities and Real Estate',
    [ExcIceGsmV1FundAssetType.ShortTermBond]: 'Short Term Bond',
    [ExcIceGsmV1FundAssetType.SmallCapStocks]: 'Small-Cap Stocks',
    [ExcIceGsmV1FundAssetType.TradedEndowmentPolicy]: 'Traded Endowment Policy',
    [ExcIceGsmV1FundAssetType.VentureCapital]: 'Venture Capital',
    [ExcIceGsmV1FundAssetType.Warrants]: 'Warrants',
    [ExcIceGsmV1FundAssetType.ZeroCouponBond]: 'Zero-Coupon Bond',
    [ExcIceGsmV1FundAssetType.SmallMiddleCapStock]: 'Small/Middle Cap Stock',
    [ExcIceGsmV1FundAssetType.BalancedEquity]: 'Balanced Equity',
    [ExcIceGsmV1FundAssetType.BalancedBond]: 'Balanced Bond',
    [ExcIceGsmV1FundAssetType.MixedAssets]: 'Mixed Assets',
    [ExcIceGsmV1FundAssetType.AfricanEquityIndex]: 'African Equity Index',
    [ExcIceGsmV1FundAssetType.AreaEuroBondIndex]: 'Area Euro Bond Index',
    [ExcIceGsmV1FundAssetType.AsianEquityIndex]: 'Asian Equity Index',
    [ExcIceGsmV1FundAssetType.AustralianEquityIndex]: 'Australian Equity Index',
    [ExcIceGsmV1FundAssetType.BondsCurrency]: 'Bonds - Currency',
    [ExcIceGsmV1FundAssetType.BondsGeographicArea]: 'Bonds - Geographic Area',
    [ExcIceGsmV1FundAssetType.BondsGovernments]: 'Bonds - Governments',
    [ExcIceGsmV1FundAssetType.BondsHighYield]: 'Bonds - High Yield',
    [ExcIceGsmV1FundAssetType.BondsInternational]: 'Bonds - International',
    [ExcIceGsmV1FundAssetType.BondsInvestmentGrade]: 'Bonds - Investment Grade',
    [ExcIceGsmV1FundAssetType.BondsNotSpecialist]: 'Bonds - Not Specialist',
    [ExcIceGsmV1FundAssetType.CommodityIndex]: 'Commodity Index',
    [ExcIceGsmV1FundAssetType.CountryBondsIndex]: 'Country Bonds Index',
    [ExcIceGsmV1FundAssetType.CountrySharesIndex]: 'Country Shares Index',
    [ExcIceGsmV1FundAssetType.CurrenciesIndex]: 'Currencies Index',
    [ExcIceGsmV1FundAssetType.DerivativesIndex]: 'Derivatives Index',
    [ExcIceGsmV1FundAssetType.DerivativesIndexRawMaterials]: 'Derivatives Index - Raw Materials',
    [ExcIceGsmV1FundAssetType.DiversifiedFlexible]: 'Diversified/Flexible',
    [ExcIceGsmV1FundAssetType.EquityBasket]: 'Equity Basket',
    [ExcIceGsmV1FundAssetType.EquityIndexEmergingCountries]: 'Equity Index - Emerging Countries',
    [ExcIceGsmV1FundAssetType.EquityIndexGeographicArea]: 'Equity Index - Geographic Area',
    [ExcIceGsmV1FundAssetType.EthicalEquityIndex]: 'Ethical Equity Index',
    [ExcIceGsmV1FundAssetType.EuroAreaEquityIndex]: 'Euro Area Equity Index',
    [ExcIceGsmV1FundAssetType.EuropeBondIndex]: 'Europe Bond Index',
    [ExcIceGsmV1FundAssetType.EuropeEquityIndex]: 'Europe Equity Index',
    [ExcIceGsmV1FundAssetType.Funds]: 'Funds',
    [ExcIceGsmV1FundAssetType.Goods]: 'Goods',
    [ExcIceGsmV1FundAssetType.IndexOfEtFsBalanced]: 'Index Of ETFs - Balanced',
    [ExcIceGsmV1FundAssetType.IndexOfEtFsBonds]: 'Index Of ETFs - Bonds',
    [ExcIceGsmV1FundAssetType.IndexOfEtFsFlexible]: 'Index Of ETFs - Flexible',
    [ExcIceGsmV1FundAssetType.IndexOfEtFsShares]: 'Index Of ETFs - Shares',
    [ExcIceGsmV1FundAssetType.IndexOfFundsBonds]: 'Index Of Funds - Bonds',
    [ExcIceGsmV1FundAssetType.InternationalBondIndex]: 'International Bond Index',
    [ExcIceGsmV1FundAssetType.InternationalEquityIndex]: 'International Equity Index',
    [ExcIceGsmV1FundAssetType.NonUsaAmericanBondIndex]: 'Non-USA American Bond Index',
    [ExcIceGsmV1FundAssetType.NonUsaAmericanEquityIndex]: 'Non-USA American Equity Index',
    [ExcIceGsmV1FundAssetType.SectorEquityIndex]: 'Sector Equity Index',
    [ExcIceGsmV1FundAssetType.SharesGeographicArea]: 'Shares - Geographic Area',
    [ExcIceGsmV1FundAssetType.SharesOthers]: 'Shares - Others',
    [ExcIceGsmV1FundAssetType.SharesSector]: 'Shares - Sector',
    [ExcIceGsmV1FundAssetType.SharesSpecialist]: 'Shares - Specialist',
    [ExcIceGsmV1FundAssetType.SharesGlobal]: 'Shares Global',
    [ExcIceGsmV1FundAssetType.UsaBondIndex]: 'USA Bond Index',
    [ExcIceGsmV1FundAssetType.UsaEquityIndex]: 'USA Equity Index',
    [ExcIceGsmV1FundAssetType.Cryptocurrencies]: 'Cryptocurrencies',
    [ExcIceGsmV1FundAssetType.IndexCryptocurrencies]: 'Index - Cryptocurrencies'
} as const;

export const EXC_ICE_GSM_V1_FUND_ASSET_TYPE_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1FundAssetType.Balanced]: '1',
    [ExcIceGsmV1FundAssetType.BalancedIncome]: '2',
    [ExcIceGsmV1FundAssetType.BlueChip]: '3',
    [ExcIceGsmV1FundAssetType.Bond]: '4',
    [ExcIceGsmV1FundAssetType.Commodity]: '5',
    [ExcIceGsmV1FundAssetType.Convertible]: '6',
    [ExcIceGsmV1FundAssetType.CorporateBond]: '7',
    [ExcIceGsmV1FundAssetType.Derivative]: '8',
    [ExcIceGsmV1FundAssetType.DistressedSecurities]: '9',
    [ExcIceGsmV1FundAssetType.Equity]: '10',
    [ExcIceGsmV1FundAssetType.EquityGrowth]: '11',
    [ExcIceGsmV1FundAssetType.EquityIncome]: '12',
    [ExcIceGsmV1FundAssetType.EquityBear]: '13',
    [ExcIceGsmV1FundAssetType.Feeder]: '14',
    [ExcIceGsmV1FundAssetType.FundOfFunds]: '15',
    [ExcIceGsmV1FundAssetType.Futures]: '16',
    [ExcIceGsmV1FundAssetType.GovernmentSecurities]: '17',
    [ExcIceGsmV1FundAssetType.Guaranteed]: '18',
    [ExcIceGsmV1FundAssetType.HighYieldBond]: '19',
    [ExcIceGsmV1FundAssetType.Index]: '20',
    [ExcIceGsmV1FundAssetType.LargeCapStocks]: '21',
    [ExcIceGsmV1FundAssetType.LongTermBond]: '22',
    [ExcIceGsmV1FundAssetType.MediumTermBond]: '23',
    [ExcIceGsmV1FundAssetType.MicroCapStocks]: '24',
    [ExcIceGsmV1FundAssetType.MidCapStocks]: '25',
    [ExcIceGsmV1FundAssetType.MoneyMarket]: '26',
    [ExcIceGsmV1FundAssetType.Options]: '27',
    [ExcIceGsmV1FundAssetType.RealEstate]: '28',
    [ExcIceGsmV1FundAssetType.SecuritiesAndRealEstate]: '29',
    [ExcIceGsmV1FundAssetType.ShortTermBond]: '30',
    [ExcIceGsmV1FundAssetType.SmallCapStocks]: '31',
    [ExcIceGsmV1FundAssetType.TradedEndowmentPolicy]: '32',
    [ExcIceGsmV1FundAssetType.VentureCapital]: '33',
    [ExcIceGsmV1FundAssetType.Warrants]: '34',
    [ExcIceGsmV1FundAssetType.ZeroCouponBond]: '35',
    [ExcIceGsmV1FundAssetType.SmallMiddleCapStock]: '36',
    [ExcIceGsmV1FundAssetType.BalancedEquity]: '37',
    [ExcIceGsmV1FundAssetType.BalancedBond]: '38',
    [ExcIceGsmV1FundAssetType.MixedAssets]: '39',
    [ExcIceGsmV1FundAssetType.AfricanEquityIndex]: '40',
    [ExcIceGsmV1FundAssetType.AreaEuroBondIndex]: '41',
    [ExcIceGsmV1FundAssetType.AsianEquityIndex]: '42',
    [ExcIceGsmV1FundAssetType.AustralianEquityIndex]: '43',
    [ExcIceGsmV1FundAssetType.BondsCurrency]: '44',
    [ExcIceGsmV1FundAssetType.BondsGeographicArea]: '45',
    [ExcIceGsmV1FundAssetType.BondsGovernments]: '46',
    [ExcIceGsmV1FundAssetType.BondsHighYield]: '47',
    [ExcIceGsmV1FundAssetType.BondsInternational]: '48',
    [ExcIceGsmV1FundAssetType.BondsInvestmentGrade]: '49',
    [ExcIceGsmV1FundAssetType.BondsNotSpecialist]: '50',
    [ExcIceGsmV1FundAssetType.CommodityIndex]: '51',
    [ExcIceGsmV1FundAssetType.CountryBondsIndex]: '52',
    [ExcIceGsmV1FundAssetType.CountrySharesIndex]: '53',
    [ExcIceGsmV1FundAssetType.CurrenciesIndex]: '54',
    [ExcIceGsmV1FundAssetType.DerivativesIndex]: '55',
    [ExcIceGsmV1FundAssetType.DerivativesIndexRawMaterials]: '56',
    [ExcIceGsmV1FundAssetType.DiversifiedFlexible]: '57',
    [ExcIceGsmV1FundAssetType.EquityBasket]: '58',
    [ExcIceGsmV1FundAssetType.EquityIndexEmergingCountries]: '59',
    [ExcIceGsmV1FundAssetType.EquityIndexGeographicArea]: '60',
    [ExcIceGsmV1FundAssetType.EthicalEquityIndex]: '61',
    [ExcIceGsmV1FundAssetType.EuroAreaEquityIndex]: '62',
    [ExcIceGsmV1FundAssetType.EuropeBondIndex]: '63',
    [ExcIceGsmV1FundAssetType.EuropeEquityIndex]: '64',
    [ExcIceGsmV1FundAssetType.Funds]: '65',
    [ExcIceGsmV1FundAssetType.Goods]: '66',
    [ExcIceGsmV1FundAssetType.IndexOfEtFsBalanced]: '67',
    [ExcIceGsmV1FundAssetType.IndexOfEtFsBonds]: '68',
    [ExcIceGsmV1FundAssetType.IndexOfEtFsFlexible]: '69',
    [ExcIceGsmV1FundAssetType.IndexOfEtFsShares]: '70',
    [ExcIceGsmV1FundAssetType.IndexOfFundsBonds]: '71',
    [ExcIceGsmV1FundAssetType.InternationalBondIndex]: '72',
    [ExcIceGsmV1FundAssetType.InternationalEquityIndex]: '73',
    [ExcIceGsmV1FundAssetType.NonUsaAmericanBondIndex]: '74',
    [ExcIceGsmV1FundAssetType.NonUsaAmericanEquityIndex]: '75',
    [ExcIceGsmV1FundAssetType.SectorEquityIndex]: '76',
    [ExcIceGsmV1FundAssetType.SharesGeographicArea]: '77',
    [ExcIceGsmV1FundAssetType.SharesOthers]: '78',
    [ExcIceGsmV1FundAssetType.SharesSector]: '79',
    [ExcIceGsmV1FundAssetType.SharesSpecialist]: '80',
    [ExcIceGsmV1FundAssetType.SharesGlobal]: '81',
    [ExcIceGsmV1FundAssetType.UsaBondIndex]: '82',
    [ExcIceGsmV1FundAssetType.UsaEquityIndex]: '83',
    [ExcIceGsmV1FundAssetType.Cryptocurrencies]: '84',
    [ExcIceGsmV1FundAssetType.IndexCryptocurrencies]: '85'
} as const;

export interface ExcIceGsmV1FundDetails {
    /* The name of the fund */
    name?: string;
    type?: ExcIceGsmV1EtfDbFundType;
    /* Indicates whether the fund is based on a broad-based index or benchmark or narrow-based index or benchmark */
    broadOrNarrow?: ExcIceGsmV1ApexBroadNarrowIndicator;
    /* The amount of leverage of the fund against the underlying index or benchmark */
    // format: decimal
    leverageFactor?: string;
    /* The type of instruments this fund invests in */
    primarySector?: ExcIceGsmV1EtfDbSectorType;
    /* Provides more detail about the investment objective of the fund */
    secondarySector?: ExcIceGsmV1EtfDbSubSectorType;
    /* The PlusFeed Source ID (SRCID) used as the source of the fund data */
    source?: ExcIceGsmV1ApexFundSource;
    /* Name of the fund sponsor (from the prospetus) */
    sponsor?: string;
    /* Whether an instrument is an exchange traded fund or note */
    fundStructure?: ExcIceGsmV1EtfDbStructureType;
    /* The PlusFeed symbol of the fund */
    symbol?: string;
    /* Classifies the fund at a detailed level */
    fundType?: ExcIceGsmV1FundType;
    /* The major asset type in which the fund invests, generally only populated for non-US funds */
    fundAssetType?: ExcIceGsmV1FundAssetType;
}

export enum ExcIceGsmV1FundType {
    Unspecified = 'UNSPECIFIED',
    None = 'NONE',
    ExchangeTradedManagedFunds = 'EXCHANGE_TRADED_MANAGED_FUNDS',
    ClosedEnded = 'CLOSED_ENDED',
    Etf = 'ETF',
    MoneyMarketFund = 'MONEY_MARKET_FUND',
    OpenEnded = 'OPEN_ENDED',
    Opals = 'OPALS',
    UltraShortFund = 'ULTRA_SHORT_FUND',
    UnitInvestmentTrust = 'UNIT_INVESTMENT_TRUST',
    Other = 'OTHER',
    ExchangeTradedCommodityEtc = 'EXCHANGE_TRADED_COMMODITY_ETC'
}

export const EXC_ICE_GSM_V1_FUND_TYPE_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1FundType.None]: 'None',
    [ExcIceGsmV1FundType.ExchangeTradedManagedFunds]: 'Exchange Traded Managed Funds',
    [ExcIceGsmV1FundType.ClosedEnded]: 'Closed Ended',
    [ExcIceGsmV1FundType.Etf]: 'ETF',
    [ExcIceGsmV1FundType.MoneyMarketFund]: 'Money Market Fund',
    [ExcIceGsmV1FundType.OpenEnded]: 'Open Ended',
    [ExcIceGsmV1FundType.Opals]: 'Opals',
    [ExcIceGsmV1FundType.UltraShortFund]: 'Ultra Short Fund',
    [ExcIceGsmV1FundType.UnitInvestmentTrust]: 'Unit Investment Trust',
    [ExcIceGsmV1FundType.Other]: 'Other',
    [ExcIceGsmV1FundType.ExchangeTradedCommodityEtc]: 'Exchange Traded Commodity (ETC)'
} as const;

export const EXC_ICE_GSM_V1_FUND_TYPE_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1FundType.None]: '0',
    [ExcIceGsmV1FundType.ExchangeTradedManagedFunds]: '5',
    [ExcIceGsmV1FundType.ClosedEnded]: '67',
    [ExcIceGsmV1FundType.Etf]: '69',
    [ExcIceGsmV1FundType.MoneyMarketFund]: '77',
    [ExcIceGsmV1FundType.OpenEnded]: '79',
    [ExcIceGsmV1FundType.Opals]: '80',
    [ExcIceGsmV1FundType.UltraShortFund]: '83',
    [ExcIceGsmV1FundType.UnitInvestmentTrust]: '85',
    [ExcIceGsmV1FundType.Other]: '88',
    [ExcIceGsmV1FundType.ExchangeTradedCommodityEtc]: '90'
} as const;

export enum ExcIceGsmV1GsmIndustrySector {
    Unspecified = 'UNSPECIFIED',
    AbsAutomobile = 'ABS_AUTOMOBILE',
    AbsAirlineLeases = 'ABS_AIRLINE_LEASES',
    AbsConsumerLoans = 'ABS_CONSUMER_LOANS',
    AbsEquipmentLeases = 'ABS_EQUIPMENT_LEASES',
    AbsWholeBusinessFranchiseLoans = 'ABS_WHOLE_BUSINESS_FRANCHISE_LOANS',
    AbsStudentLoans = 'ABS_STUDENT_LOANS',
    AbsTimeshares = 'ABS_TIMESHARES',
    AgencyCmbs = 'AGENCY_CMBS',
    NonAgencyCmbs = 'NON_AGENCY_CMBS',
    Other = 'OTHER',
    AerospaceDefense = 'AEROSPACE_DEFENSE',
    Agency = 'AGENCY',
    AutoLoans = 'AUTO_LOANS',
    AutoPartsEquipment = 'AUTO_PARTS_EQUIPMENT',
    Banking = 'BANKING',
    Beverage = 'BEVERAGE',
    Brokerage = 'BROKERAGE',
    BuildingConstruction = 'BUILDING_CONSTRUCTION',
    BuildingMaterials = 'BUILDING_MATERIALS',
    Chemicals = 'CHEMICALS',
    ConsCommLeaseFinancing = 'CONS_COMM_LEASE_FINANCING',
    DiversifiedCapitalGoods = 'DIVERSIFIED_CAPITAL_GOODS',
    ElectricDistrTrans = 'ELECTRIC_DISTR_TRANS',
    ElectricGeneration = 'ELECTRIC_GENERATION',
    ElectricIntegrated = 'ELECTRIC_INTEGRATED',
    Electronics = 'ELECTRONICS',
    EnergyExplorationProduction = 'ENERGY_EXPLORATION_PRODUCTION',
    Environmental = 'ENVIRONMENTAL',
    FoodDrugRetailers = 'FOOD_DRUG_RETAILERS',
    ForestryPaper = 'FORESTRY_PAPER',
    Gaming = 'GAMING',
    GasDistribution = 'GAS_DISTRIBUTION',
    GovernmentGuaranteed = 'GOVERNMENT_GUARANTEED',
    HealthServices = 'HEALTH_SERVICES',
    Hotels = 'HOTELS',
    HousingAssociation = 'HOUSING_ASSOCIATION',
    IntegratedEnergy = 'INTEGRATED_ENERGY',
    InvestmentsMiscFinancialServices = 'INVESTMENTS_MISC_FINANCIAL_SERVICES',
    LocalAuthority = 'LOCAL_AUTHORITY',
    Machinery = 'MACHINERY',
    MediaDiversified = 'MEDIA_DIVERSIFIED',
    MortgageBacked = 'MORTGAGE_BACKED',
    MultiLineInsurance = 'MULTI_LINE_INSURANCE',
    NonElectricUtilities = 'NON_ELECTRIC_UTILITIES',
    OilFieldEquipmentServices = 'OIL_FIELD_EQUIPMENT_SERVICES',
    OilRefiningMarketing = 'OIL_REFINING_MARKETING',
    PC = 'P_C',
    Packaging = 'PACKAGING',
    Pharmaceuticals = 'PHARMACEUTICALS',
    PrintingPublishing = 'PRINTING_PUBLISHING',
    RealEstateDevMgt = 'REAL_ESTATE_DEV_MGT',
    ReiTs = 'REI_TS',
    SoftwareServices = 'SOFTWARE_SERVICES',
    Sovereign = 'SOVEREIGN',
    SupportServices = 'SUPPORT_SERVICES',
    Supranational = 'SUPRANATIONAL',
    TheatersEntertainment = 'THEATERS_ENTERTAINMENT',
    Tobacco = 'TOBACCO',
    ForeignSovereign = 'FOREIGN_SOVEREIGN',
    Restaurants = 'RESTAURANTS',
    SteelProducersProducts = 'STEEL_PRODUCERS_PRODUCTS',
    FoodWholesale = 'FOOD_WHOLESALE',
    AbsCreditCards = 'ABS_CREDIT_CARDS',
    AbsManufacturedHousing = 'ABS_MANUFACTURED_HOUSING',
    AbsAutomobile_2 = 'ABS_AUTOMOBILE_2',
    AbsHomeEquityLoans = 'ABS_HOME_EQUITY_LOANS',
    AbsUtilities = 'ABS_UTILITIES',
    AbsMiscellaneous = 'ABS_MISCELLANEOUS',
    MetalsMiningExcludingSteel = 'METALS_MINING_EXCLUDING_STEEL',
    TelecomWireless = 'TELECOM_WIRELESS',
    CommercialMortgageBacked = 'COMMERCIAL_MORTGAGE_BACKED',
    StructuredIo = 'STRUCTURED_IO',
    TrustIo = 'TRUST_IO',
    StructuredPo = 'STRUCTURED_PO',
    TrustPo = 'TRUST_PO',
    Sequential = 'SEQUENTIAL',
    Others = 'OTHERS',
    SupportZ = 'SUPPORT_Z',
    SequentialZ = 'SEQUENTIAL_Z',
    Pac = 'PAC',
    CmoOther = 'CMO_OTHER',
    PacZ = 'PAC_Z',
    GoState = 'GO_STATE',
    GoLocal = 'GO_LOCAL',
    RevenueAirport = 'REVENUE_AIRPORT',
    RevenueHealth = 'REVENUE_HEALTH',
    RevenueEducation = 'REVENUE_EDUCATION',
    RevenueHospitals = 'REVENUE_HOSPITALS',
    RevenueIndustrialDevelopmentRevenue = 'REVENUE_INDUSTRIAL_DEVELOPMENT_REVENUE',
    RevenueLeasingCopsAppropriations = 'REVENUE_LEASING_COPS_APPROPRIATIONS',
    RevenueMisc = 'REVENUE_MISC',
    RevenueMultiFamilyHousing = 'REVENUE_MULTI_FAMILY_HOUSING',
    RevenuePollutionControl = 'REVENUE_POLLUTION_CONTROL',
    RevenuePower = 'REVENUE_POWER',
    RevenueSingleFamilyHousing = 'REVENUE_SINGLE_FAMILY_HOUSING',
    RevenueTax = 'REVENUE_TAX',
    RevenueTobacco = 'REVENUE_TOBACCO',
    RevenueTollTurnpike = 'REVENUE_TOLL_TURNPIKE',
    RevenueTransportation = 'REVENUE_TRANSPORTATION',
    RevenueUtilitiesOther = 'REVENUE_UTILITIES_OTHER',
    RevenueWaterSewer = 'REVENUE_WATER_SEWER',
    Etm = 'ETM',
    PreRefunded = 'PRE_REFUNDED',
    PfdQuasiGovernment = 'PFD_QUASI_GOVERNMENT',
    PfdBanking = 'PFD_BANKING',
    PfdInsurance = 'PFD_INSURANCE',
    PfdBasicIndustry = 'PFD_BASIC_INDUSTRY',
    PfdCapitalGoods = 'PFD_CAPITAL_GOODS',
    PfdEnergy = 'PFD_ENERGY',
    PfdMedia = 'PFD_MEDIA',
    PfdRealEstate = 'PFD_REAL_ESTATE',
    PfdTelecommunications = 'PFD_TELECOMMUNICATIONS',
    PfdTechnologyElectronics = 'PFD_TECHNOLOGY_ELECTRONICS',
    PfdUtility = 'PFD_UTILITY',
    TaxablePreRefunded = 'TAXABLE_PRE_REFUNDED',
    TaxableEtm = 'TAXABLE_ETM',
    TaxableGoState = 'TAXABLE_GO_STATE',
    TaxableGoLocal = 'TAXABLE_GO_LOCAL',
    TaxableRevenueAirport = 'TAXABLE_REVENUE_AIRPORT',
    TaxableRevenueEducation = 'TAXABLE_REVENUE_EDUCATION',
    TaxableRevenueHealth = 'TAXABLE_REVENUE_HEALTH',
    TaxableRevenueHospitals = 'TAXABLE_REVENUE_HOSPITALS',
    TaxableRevenuePollutionControl = 'TAXABLE_REVENUE_POLLUTION_CONTROL',
    TaxableRevenueIndustrialDevelopmentRevenue = 'TAXABLE_REVENUE_INDUSTRIAL_DEVELOPMENT_REVENUE',
    TaxableRevenueLeasingCopsAppropriations = 'TAXABLE_REVENUE_LEASING_COPS_APPROPRIATIONS',
    TaxableRevenueSingleFamilyHousing = 'TAXABLE_REVENUE_SINGLE_FAMILY_HOUSING',
    TaxableRevenueMultiFamilyHousing = 'TAXABLE_REVENUE_MULTI_FAMILY_HOUSING',
    TaxableRevenueTax = 'TAXABLE_REVENUE_TAX',
    TaxableRevenueTobacco = 'TAXABLE_REVENUE_TOBACCO',
    TaxableRevenueTollTurnpike = 'TAXABLE_REVENUE_TOLL_TURNPIKE',
    TaxableRevenueTransportation = 'TAXABLE_REVENUE_TRANSPORTATION',
    TaxableRevenuePower = 'TAXABLE_REVENUE_POWER',
    TaxableRevenueUtilitiesOther = 'TAXABLE_REVENUE_UTILITIES_OTHER',
    TaxableRevenueWaterSewer = 'TAXABLE_REVENUE_WATER_SEWER',
    TaxableRevenueMisc = 'TAXABLE_REVENUE_MISC',
    Automakers = 'AUTOMAKERS',
    DiscountStores = 'DISCOUNT_STORES',
    MedicalProducts = 'MEDICAL_PRODUCTS',
    HealthFacilities = 'HEALTH_FACILITIES',
    InsuranceBrokerage = 'INSURANCE_BROKERAGE',
    MonolineInsurance = 'MONOLINE_INSURANCE',
    InterestRateSwap = 'INTEREST_RATE_SWAP',
    ManagedCare = 'MANAGED_CARE',
    SpecialtyRetail = 'SPECIALTY_RETAIL',
    PfdAutomotive = 'PFD_AUTOMOTIVE',
    PfdHealthcare = 'PFD_HEALTHCARE',
    PfdLeisure = 'PFD_LEISURE',
    LifeInsurance = 'LIFE_INSURANCE',
    PfdFinancialServices = 'PFD_FINANCIAL_SERVICES',
    DepartmentStores = 'DEPARTMENT_STORES',
    TransportInfrastructureServices = 'TRANSPORT_INFRASTRUCTURE_SERVICES',
    TruckingDelivery = 'TRUCKING_DELIVERY',
    Reinsurance = 'REINSURANCE',
    TelecomSatellite = 'TELECOM_SATELLITE',
    PublicLoanCoveredBonds = 'PUBLIC_LOAN_COVERED_BONDS',
    MortgageCoveredBonds = 'MORTGAGE_COVERED_BONDS',
    OtherCoveredBonds = 'OTHER_COVERED_BONDS',
    AirTransportation = 'AIR_TRANSPORTATION',
    TechHardwareEquipment = 'TECH_HARDWARE_EQUIPMENT',
    PersonalHouseholdProducts = 'PERSONAL_HOUSEHOLD_PRODUCTS',
    RecreationTravel = 'RECREATION_TRAVEL',
    MediaContent = 'MEDIA_CONTENT',
    Advertising = 'ADVERTISING',
    CableSatelliteTv = 'CABLE_SATELLITE_TV',
    Rail = 'RAIL',
    TelecomWirelineIntegratedServices = 'TELECOM_WIRELINE_INTEGRATED_SERVICES',
    PfdConsumerGoods = 'PFD_CONSUMER_GOODS',
    PfdRetail = 'PFD_RETAIL',
    PfdServices = 'PFD_SERVICES',
    PfdTransportation = 'PFD_TRANSPORTATION',
    CvtBanking = 'CVT_BANKING',
    CvtBrokerage = 'CVT_BROKERAGE',
    CvtConsCommLeaseFinancing = 'CVT_CONS_COMM_LEASE_FINANCING',
    CvtInvestmentsMiscFinancialServices = 'CVT_INVESTMENTS_MISC_FINANCIAL_SERVICES',
    CvtInsuranceBrokerage = 'CVT_INSURANCE_BROKERAGE',
    CvtLifeInsurance = 'CVT_LIFE_INSURANCE',
    CvtMonolineInsurance = 'CVT_MONOLINE_INSURANCE',
    CvtMultiLineInsurance = 'CVT_MULTI_LINE_INSURANCE',
    CvtPC = 'CVT_P_C',
    CvtReinsurance = 'CVT_REINSURANCE',
    CvtAutoLoans = 'CVT_AUTO_LOANS',
    CvtAutoPartsEquipment = 'CVT_AUTO_PARTS_EQUIPMENT',
    CvtAutomakers = 'CVT_AUTOMAKERS',
    CvtBuildingConstruction = 'CVT_BUILDING_CONSTRUCTION',
    CvtBuildingMaterials = 'CVT_BUILDING_MATERIALS',
    CvtChemicals = 'CVT_CHEMICALS',
    CvtForestryPaper = 'CVT_FORESTRY_PAPER',
    CvtMetalsMiningExcludingSteel = 'CVT_METALS_MINING_EXCLUDING_STEEL',
    CvtSteelProducersProducts = 'CVT_STEEL_PRODUCERS_PRODUCTS',
    CvtAerospaceDefense = 'CVT_AEROSPACE_DEFENSE',
    CvtDiversifiedCapitalGoods = 'CVT_DIVERSIFIED_CAPITAL_GOODS',
    CvtMachinery = 'CVT_MACHINERY',
    CvtPackaging = 'CVT_PACKAGING',
    CvtBeverage = 'CVT_BEVERAGE',
    CvtFoodWholesale = 'CVT_FOOD_WHOLESALE',
    CvtPersonalHouseholdProducts = 'CVT_PERSONAL_HOUSEHOLD_PRODUCTS',
    CvtTobacco = 'CVT_TOBACCO',
    CvtEnergyExplorationProduction = 'CVT_ENERGY_EXPLORATION_PRODUCTION',
    CvtGasDistribution = 'CVT_GAS_DISTRIBUTION',
    CvtIntegratedEnergy = 'CVT_INTEGRATED_ENERGY',
    CvtOilFieldEquipmentServices = 'CVT_OIL_FIELD_EQUIPMENT_SERVICES',
    CvtOilRefiningMarketing = 'CVT_OIL_REFINING_MARKETING',
    CvtHealthFacilities = 'CVT_HEALTH_FACILITIES',
    CvtHealthServices = 'CVT_HEALTH_SERVICES',
    CvtManagedCare = 'CVT_MANAGED_CARE',
    CvtMedicalProducts = 'CVT_MEDICAL_PRODUCTS',
    CvtPharmaceuticals = 'CVT_PHARMACEUTICALS',
    CvtGaming = 'CVT_GAMING',
    CvtHotels = 'CVT_HOTELS',
    CvtRecreationTravel = 'CVT_RECREATION_TRAVEL',
    CvtTheatersEntertainment = 'CVT_THEATERS_ENTERTAINMENT',
    CvtAdvertising = 'CVT_ADVERTISING',
    CvtCableSatelliteTv = 'CVT_CABLE_SATELLITE_TV',
    CvtMediaDiversified = 'CVT_MEDIA_DIVERSIFIED',
    CvtMediaContent = 'CVT_MEDIA_CONTENT',
    CvtPrintingPublishing = 'CVT_PRINTING_PUBLISHING',
    CvtHousingAssociation = 'CVT_HOUSING_ASSOCIATION',
    CvtRealEstateDevMgt = 'CVT_REAL_ESTATE_DEV_MGT',
    CvtReiTs = 'CVT_REI_TS',
    CvtDepartmentStores = 'CVT_DEPARTMENT_STORES',
    CvtDiscountStores = 'CVT_DISCOUNT_STORES',
    CvtFoodDrugRetailers = 'CVT_FOOD_DRUG_RETAILERS',
    CvtRestaurants = 'CVT_RESTAURANTS',
    CvtSpecialtyRetail = 'CVT_SPECIALTY_RETAIL',
    CvtEnvironmental = 'CVT_ENVIRONMENTAL',
    CvtSupportServices = 'CVT_SUPPORT_SERVICES',
    CvtElectronics = 'CVT_ELECTRONICS',
    CvtSoftwareServices = 'CVT_SOFTWARE_SERVICES',
    CvtTechHardwareEquipment = 'CVT_TECH_HARDWARE_EQUIPMENT',
    CvtTelecomSatellite = 'CVT_TELECOM_SATELLITE',
    CvtTelecomWireless = 'CVT_TELECOM_WIRELESS',
    CvtTelecomWirelineIntegratedServices = 'CVT_TELECOM_WIRELINE_INTEGRATED_SERVICES',
    CvtAirTransportation = 'CVT_AIR_TRANSPORTATION',
    CvtRail = 'CVT_RAIL',
    CvtTransportInfrastructureServices = 'CVT_TRANSPORT_INFRASTRUCTURE_SERVICES',
    CvtTruckingDelivery = 'CVT_TRUCKING_DELIVERY',
    CvtElectricDistrTrans = 'CVT_ELECTRIC_DISTR_TRANS',
    CvtElectricGeneration = 'CVT_ELECTRIC_GENERATION',
    CvtElectricIntegrated = 'CVT_ELECTRIC_INTEGRATED',
    CvtNonElectricUtilities = 'CVT_NON_ELECTRIC_UTILITIES',
    PfdAgency = 'PFD_AGENCY',
    PfdAdvertising = 'PFD_ADVERTISING',
    PfdAerospaceDefense = 'PFD_AEROSPACE_DEFENSE',
    PfdAirTransportation = 'PFD_AIR_TRANSPORTATION',
    PfdAutoLoans = 'PFD_AUTO_LOANS',
    PfdAutoPartsEquipment = 'PFD_AUTO_PARTS_EQUIPMENT',
    PfdAutomakers = 'PFD_AUTOMAKERS',
    PfdBeverage = 'PFD_BEVERAGE',
    PfdBrokerage = 'PFD_BROKERAGE',
    PfdBuildingConstruction = 'PFD_BUILDING_CONSTRUCTION',
    PfdBuildingMaterials = 'PFD_BUILDING_MATERIALS',
    PfdCableSatelliteTv = 'PFD_CABLE_SATELLITE_TV',
    PfdChemicals = 'PFD_CHEMICALS',
    PfdConsCommLeaseFinancing = 'PFD_CONS_COMM_LEASE_FINANCING',
    PfdDepartmentStores = 'PFD_DEPARTMENT_STORES',
    PfdDiscountStores = 'PFD_DISCOUNT_STORES',
    PfdDiversifiedCapitalGoods = 'PFD_DIVERSIFIED_CAPITAL_GOODS',
    PfdElectricDistrTrans = 'PFD_ELECTRIC_DISTR_TRANS',
    PfdElectricGeneration = 'PFD_ELECTRIC_GENERATION',
    PfdElectricIntegrated = 'PFD_ELECTRIC_INTEGRATED',
    PfdElectronics = 'PFD_ELECTRONICS',
    PfdEnergyExplorationProduction = 'PFD_ENERGY_EXPLORATION_PRODUCTION',
    PfdEnvironmental = 'PFD_ENVIRONMENTAL',
    PfdFoodWholesale = 'PFD_FOOD_WHOLESALE',
    PfdFoodDrugRetailers = 'PFD_FOOD_DRUG_RETAILERS',
    PfdForestryPaper = 'PFD_FORESTRY_PAPER',
    PfdGaming = 'PFD_GAMING',
    PfdGasDistribution = 'PFD_GAS_DISTRIBUTION',
    PfdHealthFacilities = 'PFD_HEALTH_FACILITIES',
    PfdHealthServices = 'PFD_HEALTH_SERVICES',
    PfdHotels = 'PFD_HOTELS',
    PfdHousingAssociation = 'PFD_HOUSING_ASSOCIATION',
    PfdInsuranceBrokerage = 'PFD_INSURANCE_BROKERAGE',
    PfdIntegratedEnergy = 'PFD_INTEGRATED_ENERGY',
    PfdInvestmentsMiscFinancialServices = 'PFD_INVESTMENTS_MISC_FINANCIAL_SERVICES',
    PfdLifeInsurance = 'PFD_LIFE_INSURANCE',
    PfdMachinery = 'PFD_MACHINERY',
    PfdManagedCare = 'PFD_MANAGED_CARE',
    PfdMediaDiversified = 'PFD_MEDIA_DIVERSIFIED',
    PfdMediaContent = 'PFD_MEDIA_CONTENT',
    PfdMedicalProducts = 'PFD_MEDICAL_PRODUCTS',
    PfdMetalsMiningExcludingSteel = 'PFD_METALS_MINING_EXCLUDING_STEEL',
    PfdMonolineInsurance = 'PFD_MONOLINE_INSURANCE',
    PfdMultiLineInsurance = 'PFD_MULTI_LINE_INSURANCE',
    PfdNonElectricUtilities = 'PFD_NON_ELECTRIC_UTILITIES',
    PfdOilFieldEquipmentServices = 'PFD_OIL_FIELD_EQUIPMENT_SERVICES',
    PfdOilRefiningMarketing = 'PFD_OIL_REFINING_MARKETING',
    PfdPC = 'PFD_P_C',
    PfdPackaging = 'PFD_PACKAGING',
    PfdPersonalHouseholdProducts = 'PFD_PERSONAL_HOUSEHOLD_PRODUCTS',
    PfdPharmaceuticals = 'PFD_PHARMACEUTICALS',
    PfdPrintingPublishing = 'PFD_PRINTING_PUBLISHING',
    PfdRail = 'PFD_RAIL',
    PfdRealEstateDevMgt = 'PFD_REAL_ESTATE_DEV_MGT',
    PfdRecreationTravel = 'PFD_RECREATION_TRAVEL',
    PfdReinsurance = 'PFD_REINSURANCE',
    PfdReiTs = 'PFD_REI_TS',
    PfdRestaurants = 'PFD_RESTAURANTS',
    PfdSoftwareServices = 'PFD_SOFTWARE_SERVICES',
    PfdSpecialtyRetail = 'PFD_SPECIALTY_RETAIL',
    PfdSteelProducersProducts = 'PFD_STEEL_PRODUCERS_PRODUCTS',
    PfdSupportServices = 'PFD_SUPPORT_SERVICES',
    PfdTechHardwareEquipment = 'PFD_TECH_HARDWARE_EQUIPMENT',
    PfdTelecomSatellite = 'PFD_TELECOM_SATELLITE',
    PfdTelecomWireless = 'PFD_TELECOM_WIRELESS',
    PfdTelecomWirelineIntegratedServices = 'PFD_TELECOM_WIRELINE_INTEGRATED_SERVICES',
    PfdTheatersEntertainment = 'PFD_THEATERS_ENTERTAINMENT',
    PfdTobacco = 'PFD_TOBACCO',
    PfdTransportInfrastructureServices = 'PFD_TRANSPORT_INFRASTRUCTURE_SERVICES',
    PfdTruckingDelivery = 'PFD_TRUCKING_DELIVERY'
}

export const EXC_ICE_GSM_V1_GSM_INDUSTRY_SECTOR_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1GsmIndustrySector.AbsAutomobile]: 'ABS Automobile',
    [ExcIceGsmV1GsmIndustrySector.AbsAirlineLeases]: 'ABS Airline Leases',
    [ExcIceGsmV1GsmIndustrySector.AbsConsumerLoans]: 'ABS Consumer Loans',
    [ExcIceGsmV1GsmIndustrySector.AbsEquipmentLeases]: 'ABS Equipment Leases',
    [ExcIceGsmV1GsmIndustrySector.AbsWholeBusinessFranchiseLoans]: 'ABS Whole Business & Franchise Loans',
    [ExcIceGsmV1GsmIndustrySector.AbsStudentLoans]: 'ABS Student Loans',
    [ExcIceGsmV1GsmIndustrySector.AbsTimeshares]: 'ABS Timeshares',
    [ExcIceGsmV1GsmIndustrySector.AgencyCmbs]: 'Agency CMBS',
    [ExcIceGsmV1GsmIndustrySector.NonAgencyCmbs]: 'Non-Agency CMBS',
    [ExcIceGsmV1GsmIndustrySector.Other]: 'Other',
    [ExcIceGsmV1GsmIndustrySector.AerospaceDefense]: 'Aerospace/Defense',
    [ExcIceGsmV1GsmIndustrySector.Agency]: 'Agency',
    [ExcIceGsmV1GsmIndustrySector.AutoLoans]: 'Auto Loans',
    [ExcIceGsmV1GsmIndustrySector.AutoPartsEquipment]: 'Auto Parts & Equipment',
    [ExcIceGsmV1GsmIndustrySector.Banking]: 'Banking',
    [ExcIceGsmV1GsmIndustrySector.Beverage]: 'Beverage',
    [ExcIceGsmV1GsmIndustrySector.Brokerage]: 'Brokerage',
    [ExcIceGsmV1GsmIndustrySector.BuildingConstruction]: 'Building & Construction',
    [ExcIceGsmV1GsmIndustrySector.BuildingMaterials]: 'Building Materials',
    [ExcIceGsmV1GsmIndustrySector.Chemicals]: 'Chemicals',
    [ExcIceGsmV1GsmIndustrySector.ConsCommLeaseFinancing]: 'Cons/Comm/Lease Financing',
    [ExcIceGsmV1GsmIndustrySector.DiversifiedCapitalGoods]: 'Diversified Capital Goods',
    [ExcIceGsmV1GsmIndustrySector.ElectricDistrTrans]: 'Electric-Distr/Trans',
    [ExcIceGsmV1GsmIndustrySector.ElectricGeneration]: 'Electric-Generation',
    [ExcIceGsmV1GsmIndustrySector.ElectricIntegrated]: 'Electric-Integrated',
    [ExcIceGsmV1GsmIndustrySector.Electronics]: 'Electronics',
    [ExcIceGsmV1GsmIndustrySector.EnergyExplorationProduction]: 'Energy - Exploration & Production',
    [ExcIceGsmV1GsmIndustrySector.Environmental]: 'Environmental',
    [ExcIceGsmV1GsmIndustrySector.FoodDrugRetailers]: 'Food & Drug Retailers',
    [ExcIceGsmV1GsmIndustrySector.ForestryPaper]: 'Forestry/Paper',
    [ExcIceGsmV1GsmIndustrySector.Gaming]: 'Gaming',
    [ExcIceGsmV1GsmIndustrySector.GasDistribution]: 'Gas Distribution',
    [ExcIceGsmV1GsmIndustrySector.GovernmentGuaranteed]: 'Government Guaranteed',
    [ExcIceGsmV1GsmIndustrySector.HealthServices]: 'Health Services',
    [ExcIceGsmV1GsmIndustrySector.Hotels]: 'Hotels',
    [ExcIceGsmV1GsmIndustrySector.HousingAssociation]: 'Housing Association',
    [ExcIceGsmV1GsmIndustrySector.IntegratedEnergy]: 'Integrated Energy',
    [ExcIceGsmV1GsmIndustrySector.InvestmentsMiscFinancialServices]: 'Investments & Misc Financial Services',
    [ExcIceGsmV1GsmIndustrySector.LocalAuthority]: 'Local-Authority',
    [ExcIceGsmV1GsmIndustrySector.Machinery]: 'Machinery',
    [ExcIceGsmV1GsmIndustrySector.MediaDiversified]: 'Media - Diversified',
    [ExcIceGsmV1GsmIndustrySector.MortgageBacked]: 'Mortgage Backed',
    [ExcIceGsmV1GsmIndustrySector.MultiLineInsurance]: 'Multi-Line Insurance',
    [ExcIceGsmV1GsmIndustrySector.NonElectricUtilities]: 'Non-Electric Utilities',
    [ExcIceGsmV1GsmIndustrySector.OilFieldEquipmentServices]: 'Oil Field Equipment & Services',
    [ExcIceGsmV1GsmIndustrySector.OilRefiningMarketing]: 'Oil Refining & Marketing',
    [ExcIceGsmV1GsmIndustrySector.PC]: 'P&C',
    [ExcIceGsmV1GsmIndustrySector.Packaging]: 'Packaging',
    [ExcIceGsmV1GsmIndustrySector.Pharmaceuticals]: 'Pharmaceuticals',
    [ExcIceGsmV1GsmIndustrySector.PrintingPublishing]: 'Printing & Publishing',
    [ExcIceGsmV1GsmIndustrySector.RealEstateDevMgt]: 'RealEstate Dev & Mgt',
    [ExcIceGsmV1GsmIndustrySector.ReiTs]: 'REITs',
    [ExcIceGsmV1GsmIndustrySector.SoftwareServices]: 'Software/Services',
    [ExcIceGsmV1GsmIndustrySector.Sovereign]: 'Sovereign',
    [ExcIceGsmV1GsmIndustrySector.SupportServices]: 'Support-Services',
    [ExcIceGsmV1GsmIndustrySector.Supranational]: 'Supranational',
    [ExcIceGsmV1GsmIndustrySector.TheatersEntertainment]: 'Theaters & Entertainment',
    [ExcIceGsmV1GsmIndustrySector.Tobacco]: 'Tobacco',
    [ExcIceGsmV1GsmIndustrySector.ForeignSovereign]: 'Foreign Sovereign',
    [ExcIceGsmV1GsmIndustrySector.Restaurants]: 'Restaurants',
    [ExcIceGsmV1GsmIndustrySector.SteelProducersProducts]: 'Steel Producers/Products',
    [ExcIceGsmV1GsmIndustrySector.FoodWholesale]: 'Food - Wholesale',
    [ExcIceGsmV1GsmIndustrySector.AbsCreditCards]: 'ABS Credit Cards',
    [ExcIceGsmV1GsmIndustrySector.AbsManufacturedHousing]: 'ABS Manufactured Housing',
    [ExcIceGsmV1GsmIndustrySector.AbsAutomobile_2]: 'ABS Automobile',
    [ExcIceGsmV1GsmIndustrySector.AbsHomeEquityLoans]: 'ABS Home Equity Loans',
    [ExcIceGsmV1GsmIndustrySector.AbsUtilities]: 'ABS Utilities',
    [ExcIceGsmV1GsmIndustrySector.AbsMiscellaneous]: 'ABS Miscellaneous',
    [ExcIceGsmV1GsmIndustrySector.MetalsMiningExcludingSteel]: 'Metals/Mining Excluding Steel',
    [ExcIceGsmV1GsmIndustrySector.TelecomWireless]: 'Telecom - Wireless',
    [ExcIceGsmV1GsmIndustrySector.CommercialMortgageBacked]: 'Commercial Mortgage Backed',
    [ExcIceGsmV1GsmIndustrySector.StructuredIo]: 'Structured IO',
    [ExcIceGsmV1GsmIndustrySector.TrustIo]: 'Trust IO',
    [ExcIceGsmV1GsmIndustrySector.StructuredPo]: 'Structured PO',
    [ExcIceGsmV1GsmIndustrySector.TrustPo]: 'Trust PO',
    [ExcIceGsmV1GsmIndustrySector.Sequential]: 'Sequential',
    [ExcIceGsmV1GsmIndustrySector.Others]: 'Others',
    [ExcIceGsmV1GsmIndustrySector.SupportZ]: 'Support Z',
    [ExcIceGsmV1GsmIndustrySector.SequentialZ]: 'Sequential Z',
    [ExcIceGsmV1GsmIndustrySector.Pac]: 'PAC',
    [ExcIceGsmV1GsmIndustrySector.CmoOther]: 'CMO Other',
    [ExcIceGsmV1GsmIndustrySector.PacZ]: 'PAC Z',
    [ExcIceGsmV1GsmIndustrySector.GoState]: 'GO - State',
    [ExcIceGsmV1GsmIndustrySector.GoLocal]: 'GO - Local',
    [ExcIceGsmV1GsmIndustrySector.RevenueAirport]: 'Revenue - Airport',
    [ExcIceGsmV1GsmIndustrySector.RevenueHealth]: 'Revenue - Health',
    [ExcIceGsmV1GsmIndustrySector.RevenueEducation]: 'Revenue - Education',
    [ExcIceGsmV1GsmIndustrySector.RevenueHospitals]: 'Revenue - Hospitals',
    [ExcIceGsmV1GsmIndustrySector.RevenueIndustrialDevelopmentRevenue]: 'Revenue - Industrial Development Revenue',
    [ExcIceGsmV1GsmIndustrySector.RevenueLeasingCopsAppropriations]: 'Revenue - Leasing COPS & Appropriations',
    [ExcIceGsmV1GsmIndustrySector.RevenueMisc]: 'Revenue - Misc',
    [ExcIceGsmV1GsmIndustrySector.RevenueMultiFamilyHousing]: 'Revenue - Multi-Family Housing',
    [ExcIceGsmV1GsmIndustrySector.RevenuePollutionControl]: 'Revenue - Pollution Control',
    [ExcIceGsmV1GsmIndustrySector.RevenuePower]: 'Revenue - Power',
    [ExcIceGsmV1GsmIndustrySector.RevenueSingleFamilyHousing]: 'Revenue - Single Family Housing',
    [ExcIceGsmV1GsmIndustrySector.RevenueTax]: 'Revenue - Tax',
    [ExcIceGsmV1GsmIndustrySector.RevenueTobacco]: 'Revenue - Tobacco',
    [ExcIceGsmV1GsmIndustrySector.RevenueTollTurnpike]: 'Revenue - Toll & Turnpike',
    [ExcIceGsmV1GsmIndustrySector.RevenueTransportation]: 'Revenue - Transportation',
    [ExcIceGsmV1GsmIndustrySector.RevenueUtilitiesOther]: 'Revenue - Utilities - Other',
    [ExcIceGsmV1GsmIndustrySector.RevenueWaterSewer]: 'Revenue - Water & Sewer',
    [ExcIceGsmV1GsmIndustrySector.Etm]: 'ETM',
    [ExcIceGsmV1GsmIndustrySector.PreRefunded]: 'Pre-Refunded',
    [ExcIceGsmV1GsmIndustrySector.PfdQuasiGovernment]: 'Pfd-Quasi Government',
    [ExcIceGsmV1GsmIndustrySector.PfdBanking]: 'Pfd-Banking',
    [ExcIceGsmV1GsmIndustrySector.PfdInsurance]: 'Pfd-Insurance',
    [ExcIceGsmV1GsmIndustrySector.PfdBasicIndustry]: 'Pfd-Basic Industry',
    [ExcIceGsmV1GsmIndustrySector.PfdCapitalGoods]: 'Pfd-Capital Goods',
    [ExcIceGsmV1GsmIndustrySector.PfdEnergy]: 'Pfd-Energy',
    [ExcIceGsmV1GsmIndustrySector.PfdMedia]: 'Pfd-Media',
    [ExcIceGsmV1GsmIndustrySector.PfdRealEstate]: 'Pfd-Real Estate',
    [ExcIceGsmV1GsmIndustrySector.PfdTelecommunications]: 'Pfd-Telecommunications',
    [ExcIceGsmV1GsmIndustrySector.PfdTechnologyElectronics]: 'Pfd-Technology & Electronics',
    [ExcIceGsmV1GsmIndustrySector.PfdUtility]: 'Pfd-Utility',
    [ExcIceGsmV1GsmIndustrySector.TaxablePreRefunded]: 'Taxable Pre-Refunded',
    [ExcIceGsmV1GsmIndustrySector.TaxableEtm]: 'Taxable ETM',
    [ExcIceGsmV1GsmIndustrySector.TaxableGoState]: 'Taxable GO - State',
    [ExcIceGsmV1GsmIndustrySector.TaxableGoLocal]: 'Taxable GO - Local',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueAirport]: 'Taxable Revenue - Airport',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueEducation]: 'Taxable Revenue - Education',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueHealth]: 'Taxable Revenue - Health',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueHospitals]: 'Taxable Revenue - Hospitals',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenuePollutionControl]: 'Taxable Revenue - Pollution Control',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueIndustrialDevelopmentRevenue]: 'Taxable Revenue - Industrial Development Revenue',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueLeasingCopsAppropriations]: 'Taxable Revenue - Leasing COPS & Appropriations',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueSingleFamilyHousing]: 'Taxable Revenue - Single Family Housing',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueMultiFamilyHousing]: 'Taxable Revenue - Multi-Family Housing',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueTax]: 'Taxable Revenue - Tax',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueTobacco]: 'Taxable Revenue - Tobacco',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueTollTurnpike]: 'Taxable Revenue - Toll & Turnpike',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueTransportation]: 'Taxable Revenue - Transportation',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenuePower]: 'Taxable Revenue - Power',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueUtilitiesOther]: 'Taxable Revenue - Utilities - Other',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueWaterSewer]: 'Taxable Revenue - Water & Sewer',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueMisc]: 'Taxable Revenue - Misc',
    [ExcIceGsmV1GsmIndustrySector.Automakers]: 'Automakers',
    [ExcIceGsmV1GsmIndustrySector.DiscountStores]: 'Discount Stores',
    [ExcIceGsmV1GsmIndustrySector.MedicalProducts]: 'Medical Products',
    [ExcIceGsmV1GsmIndustrySector.HealthFacilities]: 'Health Facilities',
    [ExcIceGsmV1GsmIndustrySector.InsuranceBrokerage]: 'Insurance Brokerage',
    [ExcIceGsmV1GsmIndustrySector.MonolineInsurance]: 'Monoline Insurance',
    [ExcIceGsmV1GsmIndustrySector.InterestRateSwap]: 'Interest rate Swap',
    [ExcIceGsmV1GsmIndustrySector.ManagedCare]: 'Managed Care',
    [ExcIceGsmV1GsmIndustrySector.SpecialtyRetail]: 'Specialty Retail',
    [ExcIceGsmV1GsmIndustrySector.PfdAutomotive]: 'Pfd-Automotive',
    [ExcIceGsmV1GsmIndustrySector.PfdHealthcare]: 'Pfd-Healthcare',
    [ExcIceGsmV1GsmIndustrySector.PfdLeisure]: 'Pfd-Leisure',
    [ExcIceGsmV1GsmIndustrySector.LifeInsurance]: 'Life Insurance',
    [ExcIceGsmV1GsmIndustrySector.PfdFinancialServices]: 'Pfd-Financial Services',
    [ExcIceGsmV1GsmIndustrySector.DepartmentStores]: 'Department Stores',
    [ExcIceGsmV1GsmIndustrySector.TransportInfrastructureServices]: 'Transport Infrastructure/Services',
    [ExcIceGsmV1GsmIndustrySector.TruckingDelivery]: 'Trucking & Delivery',
    [ExcIceGsmV1GsmIndustrySector.Reinsurance]: 'Reinsurance',
    [ExcIceGsmV1GsmIndustrySector.TelecomSatellite]: 'Telecom - Satellite',
    [ExcIceGsmV1GsmIndustrySector.PublicLoanCoveredBonds]: 'Public Loan Covered Bonds',
    [ExcIceGsmV1GsmIndustrySector.MortgageCoveredBonds]: 'Mortgage Covered Bonds',
    [ExcIceGsmV1GsmIndustrySector.OtherCoveredBonds]: 'Other Covered Bonds',
    [ExcIceGsmV1GsmIndustrySector.AirTransportation]: 'Air Transportation',
    [ExcIceGsmV1GsmIndustrySector.TechHardwareEquipment]: 'Tech Hardware & Equipment',
    [ExcIceGsmV1GsmIndustrySector.PersonalHouseholdProducts]: 'Personal & Household Products',
    [ExcIceGsmV1GsmIndustrySector.RecreationTravel]: 'Recreation & Travel',
    [ExcIceGsmV1GsmIndustrySector.MediaContent]: 'Media Content',
    [ExcIceGsmV1GsmIndustrySector.Advertising]: 'Advertising',
    [ExcIceGsmV1GsmIndustrySector.CableSatelliteTv]: 'Cable & Satellite TV',
    [ExcIceGsmV1GsmIndustrySector.Rail]: 'Rail',
    [ExcIceGsmV1GsmIndustrySector.TelecomWirelineIntegratedServices]: 'Telecom - Wireline Integrated & Services',
    [ExcIceGsmV1GsmIndustrySector.PfdConsumerGoods]: 'Pfd-Consumer Goods',
    [ExcIceGsmV1GsmIndustrySector.PfdRetail]: 'Pfd-Retail',
    [ExcIceGsmV1GsmIndustrySector.PfdServices]: 'Pfd-Services',
    [ExcIceGsmV1GsmIndustrySector.PfdTransportation]: 'Pfd-Transportation',
    [ExcIceGsmV1GsmIndustrySector.CvtBanking]: 'Cvt-Banking',
    [ExcIceGsmV1GsmIndustrySector.CvtBrokerage]: 'Cvt-Brokerage',
    [ExcIceGsmV1GsmIndustrySector.CvtConsCommLeaseFinancing]: 'Cvt-Cons/Comm/Lease Financing',
    [ExcIceGsmV1GsmIndustrySector.CvtInvestmentsMiscFinancialServices]: 'Cvt-Investments & Misc Financial Services',
    [ExcIceGsmV1GsmIndustrySector.CvtInsuranceBrokerage]: 'Cvt-Insurance Brokerage',
    [ExcIceGsmV1GsmIndustrySector.CvtLifeInsurance]: 'Cvt-Life Insurance',
    [ExcIceGsmV1GsmIndustrySector.CvtMonolineInsurance]: 'Cvt-Monoline Insurance',
    [ExcIceGsmV1GsmIndustrySector.CvtMultiLineInsurance]: 'Cvt-Multi-Line Insurance',
    [ExcIceGsmV1GsmIndustrySector.CvtPC]: 'Cvt-P&C',
    [ExcIceGsmV1GsmIndustrySector.CvtReinsurance]: 'Cvt-Reinsurance',
    [ExcIceGsmV1GsmIndustrySector.CvtAutoLoans]: 'Cvt-Auto Loans',
    [ExcIceGsmV1GsmIndustrySector.CvtAutoPartsEquipment]: 'Cvt-Auto Parts & Equipment',
    [ExcIceGsmV1GsmIndustrySector.CvtAutomakers]: 'Cvt-Automakers',
    [ExcIceGsmV1GsmIndustrySector.CvtBuildingConstruction]: 'Cvt-Building & Construction',
    [ExcIceGsmV1GsmIndustrySector.CvtBuildingMaterials]: 'Cvt-Building Materials',
    [ExcIceGsmV1GsmIndustrySector.CvtChemicals]: 'Cvt-Chemicals',
    [ExcIceGsmV1GsmIndustrySector.CvtForestryPaper]: 'Cvt-Forestry/Paper',
    [ExcIceGsmV1GsmIndustrySector.CvtMetalsMiningExcludingSteel]: 'Cvt-Metals/Mining Excluding Steel',
    [ExcIceGsmV1GsmIndustrySector.CvtSteelProducersProducts]: 'Cvt-Steel Producers/Products',
    [ExcIceGsmV1GsmIndustrySector.CvtAerospaceDefense]: 'Cvt-Aerospace/Defense',
    [ExcIceGsmV1GsmIndustrySector.CvtDiversifiedCapitalGoods]: 'Cvt-Diversified Capital Goods',
    [ExcIceGsmV1GsmIndustrySector.CvtMachinery]: 'Cvt-Machinery',
    [ExcIceGsmV1GsmIndustrySector.CvtPackaging]: 'Cvt-Packaging',
    [ExcIceGsmV1GsmIndustrySector.CvtBeverage]: 'Cvt-Beverage',
    [ExcIceGsmV1GsmIndustrySector.CvtFoodWholesale]: 'Cvt-Food - Wholesale',
    [ExcIceGsmV1GsmIndustrySector.CvtPersonalHouseholdProducts]: 'Cvt-Personal & Household Products',
    [ExcIceGsmV1GsmIndustrySector.CvtTobacco]: 'Cvt-Tobacco',
    [ExcIceGsmV1GsmIndustrySector.CvtEnergyExplorationProduction]: 'Cvt-Energy - Exploration & Production',
    [ExcIceGsmV1GsmIndustrySector.CvtGasDistribution]: 'Cvt-Gas Distribution',
    [ExcIceGsmV1GsmIndustrySector.CvtIntegratedEnergy]: 'Cvt-Integrated Energy',
    [ExcIceGsmV1GsmIndustrySector.CvtOilFieldEquipmentServices]: 'Cvt-Oil Field Equipment & Services',
    [ExcIceGsmV1GsmIndustrySector.CvtOilRefiningMarketing]: 'Cvt-Oil Refining & Marketing',
    [ExcIceGsmV1GsmIndustrySector.CvtHealthFacilities]: 'Cvt-Health Facilities',
    [ExcIceGsmV1GsmIndustrySector.CvtHealthServices]: 'Cvt-Health Services',
    [ExcIceGsmV1GsmIndustrySector.CvtManagedCare]: 'Cvt-Managed Care',
    [ExcIceGsmV1GsmIndustrySector.CvtMedicalProducts]: 'Cvt-Medical Products',
    [ExcIceGsmV1GsmIndustrySector.CvtPharmaceuticals]: 'Cvt-Pharmaceuticals',
    [ExcIceGsmV1GsmIndustrySector.CvtGaming]: 'Cvt-Gaming',
    [ExcIceGsmV1GsmIndustrySector.CvtHotels]: 'Cvt-Hotels',
    [ExcIceGsmV1GsmIndustrySector.CvtRecreationTravel]: 'Cvt-Recreation & Travel',
    [ExcIceGsmV1GsmIndustrySector.CvtTheatersEntertainment]: 'Cvt-Theaters & Entertainment',
    [ExcIceGsmV1GsmIndustrySector.CvtAdvertising]: 'Cvt-Advertising',
    [ExcIceGsmV1GsmIndustrySector.CvtCableSatelliteTv]: 'Cvt-Cable & Satellite TV',
    [ExcIceGsmV1GsmIndustrySector.CvtMediaDiversified]: 'Cvt-Media - Diversified',
    [ExcIceGsmV1GsmIndustrySector.CvtMediaContent]: 'Cvt-Media Content',
    [ExcIceGsmV1GsmIndustrySector.CvtPrintingPublishing]: 'Cvt-Printing & Publishing',
    [ExcIceGsmV1GsmIndustrySector.CvtHousingAssociation]: 'Cvt-Housing Association',
    [ExcIceGsmV1GsmIndustrySector.CvtRealEstateDevMgt]: 'Cvt-RealEstate Dev & Mgt',
    [ExcIceGsmV1GsmIndustrySector.CvtReiTs]: 'Cvt-REITs',
    [ExcIceGsmV1GsmIndustrySector.CvtDepartmentStores]: 'Cvt-Department Stores',
    [ExcIceGsmV1GsmIndustrySector.CvtDiscountStores]: 'Cvt-Discount Stores',
    [ExcIceGsmV1GsmIndustrySector.CvtFoodDrugRetailers]: 'Cvt-Food & Drug Retailers',
    [ExcIceGsmV1GsmIndustrySector.CvtRestaurants]: 'Cvt-Restaurants',
    [ExcIceGsmV1GsmIndustrySector.CvtSpecialtyRetail]: 'Cvt-Specialty Retail',
    [ExcIceGsmV1GsmIndustrySector.CvtEnvironmental]: 'Cvt-Environmental',
    [ExcIceGsmV1GsmIndustrySector.CvtSupportServices]: 'Cvt-Support-Services',
    [ExcIceGsmV1GsmIndustrySector.CvtElectronics]: 'Cvt-Electronics',
    [ExcIceGsmV1GsmIndustrySector.CvtSoftwareServices]: 'Cvt-Software/Services',
    [ExcIceGsmV1GsmIndustrySector.CvtTechHardwareEquipment]: 'Cvt-Tech Hardware & Equipment',
    [ExcIceGsmV1GsmIndustrySector.CvtTelecomSatellite]: 'Cvt-Telecom - Satellite',
    [ExcIceGsmV1GsmIndustrySector.CvtTelecomWireless]: 'Cvt-Telecom - Wireless',
    [ExcIceGsmV1GsmIndustrySector.CvtTelecomWirelineIntegratedServices]: 'Cvt-Telecom - Wireline Integrated & Services',
    [ExcIceGsmV1GsmIndustrySector.CvtAirTransportation]: 'Cvt-Air Transportation',
    [ExcIceGsmV1GsmIndustrySector.CvtRail]: 'Cvt-Rail',
    [ExcIceGsmV1GsmIndustrySector.CvtTransportInfrastructureServices]: 'Cvt-Transport Infrastructure/Services',
    [ExcIceGsmV1GsmIndustrySector.CvtTruckingDelivery]: 'Cvt-Trucking & Delivery',
    [ExcIceGsmV1GsmIndustrySector.CvtElectricDistrTrans]: 'Cvt-Electric-Distr/Trans',
    [ExcIceGsmV1GsmIndustrySector.CvtElectricGeneration]: 'Cvt-Electric-Generation',
    [ExcIceGsmV1GsmIndustrySector.CvtElectricIntegrated]: 'Cvt-Electric-Integrated',
    [ExcIceGsmV1GsmIndustrySector.CvtNonElectricUtilities]: 'Cvt-Non-Electric Utilities',
    [ExcIceGsmV1GsmIndustrySector.PfdAgency]: 'Pfd-Agency',
    [ExcIceGsmV1GsmIndustrySector.PfdAdvertising]: 'Pfd-Advertising',
    [ExcIceGsmV1GsmIndustrySector.PfdAerospaceDefense]: 'Pfd-Aerospace/Defense',
    [ExcIceGsmV1GsmIndustrySector.PfdAirTransportation]: 'Pfd-Air Transportation',
    [ExcIceGsmV1GsmIndustrySector.PfdAutoLoans]: 'Pfd-Auto Loans',
    [ExcIceGsmV1GsmIndustrySector.PfdAutoPartsEquipment]: 'Pfd-Auto Parts & Equipment',
    [ExcIceGsmV1GsmIndustrySector.PfdAutomakers]: 'Pfd-Automakers',
    [ExcIceGsmV1GsmIndustrySector.PfdBeverage]: 'Pfd-Beverage',
    [ExcIceGsmV1GsmIndustrySector.PfdBrokerage]: 'Pfd-Brokerage',
    [ExcIceGsmV1GsmIndustrySector.PfdBuildingConstruction]: 'Pfd-Building & Construction',
    [ExcIceGsmV1GsmIndustrySector.PfdBuildingMaterials]: 'Pfd-Building Materials',
    [ExcIceGsmV1GsmIndustrySector.PfdCableSatelliteTv]: 'Pfd-Cable & Satellite TV',
    [ExcIceGsmV1GsmIndustrySector.PfdChemicals]: 'Pfd-Chemicals',
    [ExcIceGsmV1GsmIndustrySector.PfdConsCommLeaseFinancing]: 'Pfd-Cons/Comm/Lease Financing',
    [ExcIceGsmV1GsmIndustrySector.PfdDepartmentStores]: 'Pfd-Department Stores',
    [ExcIceGsmV1GsmIndustrySector.PfdDiscountStores]: 'Pfd-Discount Stores',
    [ExcIceGsmV1GsmIndustrySector.PfdDiversifiedCapitalGoods]: 'Pfd-Diversified Capital Goods',
    [ExcIceGsmV1GsmIndustrySector.PfdElectricDistrTrans]: 'Pfd-Electric-Distr/Trans',
    [ExcIceGsmV1GsmIndustrySector.PfdElectricGeneration]: 'Pfd-Electric-Generation',
    [ExcIceGsmV1GsmIndustrySector.PfdElectricIntegrated]: 'Pfd-Electric-Integrated',
    [ExcIceGsmV1GsmIndustrySector.PfdElectronics]: 'Pfd-Electronics',
    [ExcIceGsmV1GsmIndustrySector.PfdEnergyExplorationProduction]: 'Pfd-Energy - Exploration & Production',
    [ExcIceGsmV1GsmIndustrySector.PfdEnvironmental]: 'Pfd-Environmental',
    [ExcIceGsmV1GsmIndustrySector.PfdFoodWholesale]: 'Pfd-Food - Wholesale',
    [ExcIceGsmV1GsmIndustrySector.PfdFoodDrugRetailers]: 'Pfd-Food & Drug Retailers',
    [ExcIceGsmV1GsmIndustrySector.PfdForestryPaper]: 'Pfd-Forestry/Paper',
    [ExcIceGsmV1GsmIndustrySector.PfdGaming]: 'Pfd-Gaming',
    [ExcIceGsmV1GsmIndustrySector.PfdGasDistribution]: 'Pfd-Gas Distribution',
    [ExcIceGsmV1GsmIndustrySector.PfdHealthFacilities]: 'Pfd-Health Facilities',
    [ExcIceGsmV1GsmIndustrySector.PfdHealthServices]: 'Pfd-Health Services',
    [ExcIceGsmV1GsmIndustrySector.PfdHotels]: 'Pfd-Hotels',
    [ExcIceGsmV1GsmIndustrySector.PfdHousingAssociation]: 'Pfd-Housing Association',
    [ExcIceGsmV1GsmIndustrySector.PfdInsuranceBrokerage]: 'Pfd-Insurance Brokerage',
    [ExcIceGsmV1GsmIndustrySector.PfdIntegratedEnergy]: 'Pfd-Integrated Energy',
    [ExcIceGsmV1GsmIndustrySector.PfdInvestmentsMiscFinancialServices]: 'Pfd-Investments & Misc Financial Services',
    [ExcIceGsmV1GsmIndustrySector.PfdLifeInsurance]: 'Pfd-Life Insurance',
    [ExcIceGsmV1GsmIndustrySector.PfdMachinery]: 'Pfd-Machinery',
    [ExcIceGsmV1GsmIndustrySector.PfdManagedCare]: 'Pfd-Managed Care',
    [ExcIceGsmV1GsmIndustrySector.PfdMediaDiversified]: 'Pfd-Media - Diversified',
    [ExcIceGsmV1GsmIndustrySector.PfdMediaContent]: 'Pfd-Media Content',
    [ExcIceGsmV1GsmIndustrySector.PfdMedicalProducts]: 'Pfd-Medical Products',
    [ExcIceGsmV1GsmIndustrySector.PfdMetalsMiningExcludingSteel]: 'Pfd-Metals/Mining Excluding Steel',
    [ExcIceGsmV1GsmIndustrySector.PfdMonolineInsurance]: 'Pfd-Monoline Insurance',
    [ExcIceGsmV1GsmIndustrySector.PfdMultiLineInsurance]: 'Pfd-Multi-Line Insurance',
    [ExcIceGsmV1GsmIndustrySector.PfdNonElectricUtilities]: 'Pfd-Non-Electric Utilities',
    [ExcIceGsmV1GsmIndustrySector.PfdOilFieldEquipmentServices]: 'Pfd-Oil Field Equipment & Services',
    [ExcIceGsmV1GsmIndustrySector.PfdOilRefiningMarketing]: 'Pfd-Oil Refining & Marketing',
    [ExcIceGsmV1GsmIndustrySector.PfdPC]: 'Pfd-P&C',
    [ExcIceGsmV1GsmIndustrySector.PfdPackaging]: 'Pfd-Packaging',
    [ExcIceGsmV1GsmIndustrySector.PfdPersonalHouseholdProducts]: 'Pfd-Personal & Household Products',
    [ExcIceGsmV1GsmIndustrySector.PfdPharmaceuticals]: 'Pfd-Pharmaceuticals',
    [ExcIceGsmV1GsmIndustrySector.PfdPrintingPublishing]: 'Pfd-Printing & Publishing',
    [ExcIceGsmV1GsmIndustrySector.PfdRail]: 'Pfd-Rail',
    [ExcIceGsmV1GsmIndustrySector.PfdRealEstateDevMgt]: 'Pfd-RealEstate Dev & Mgt',
    [ExcIceGsmV1GsmIndustrySector.PfdRecreationTravel]: 'Pfd-Recreation & Travel',
    [ExcIceGsmV1GsmIndustrySector.PfdReinsurance]: 'Pfd-Reinsurance',
    [ExcIceGsmV1GsmIndustrySector.PfdReiTs]: 'Pfd-REITs',
    [ExcIceGsmV1GsmIndustrySector.PfdRestaurants]: 'Pfd-Restaurants',
    [ExcIceGsmV1GsmIndustrySector.PfdSoftwareServices]: 'Pfd-Software/Services',
    [ExcIceGsmV1GsmIndustrySector.PfdSpecialtyRetail]: 'Pfd-Specialty Retail',
    [ExcIceGsmV1GsmIndustrySector.PfdSteelProducersProducts]: 'Pfd-Steel Producers/Products',
    [ExcIceGsmV1GsmIndustrySector.PfdSupportServices]: 'Pfd-Support-Services',
    [ExcIceGsmV1GsmIndustrySector.PfdTechHardwareEquipment]: 'Pfd-Tech Hardware & Equipment',
    [ExcIceGsmV1GsmIndustrySector.PfdTelecomSatellite]: 'Pfd-Telecom - Satellite',
    [ExcIceGsmV1GsmIndustrySector.PfdTelecomWireless]: 'Pfd-Telecom - Wireless',
    [ExcIceGsmV1GsmIndustrySector.PfdTelecomWirelineIntegratedServices]: 'Pfd-Telecom - Wireline Integrated & Services',
    [ExcIceGsmV1GsmIndustrySector.PfdTheatersEntertainment]: 'Pfd-Theaters & Entertainment',
    [ExcIceGsmV1GsmIndustrySector.PfdTobacco]: 'Pfd-Tobacco',
    [ExcIceGsmV1GsmIndustrySector.PfdTransportInfrastructureServices]: 'Pfd-Transport Infrastructure/Services',
    [ExcIceGsmV1GsmIndustrySector.PfdTruckingDelivery]: 'Pfd-Trucking & Delivery'
} as const;

export const EXC_ICE_GSM_V1_GSM_INDUSTRY_SECTOR_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1GsmIndustrySector.AbsAutomobile]: 'ABau',
    [ExcIceGsmV1GsmIndustrySector.AbsAirlineLeases]: 'ABal',
    [ExcIceGsmV1GsmIndustrySector.AbsConsumerLoans]: 'ABcl',
    [ExcIceGsmV1GsmIndustrySector.AbsEquipmentLeases]: 'ABel',
    [ExcIceGsmV1GsmIndustrySector.AbsWholeBusinessFranchiseLoans]: 'ABwl',
    [ExcIceGsmV1GsmIndustrySector.AbsStudentLoans]: 'ABsl',
    [ExcIceGsmV1GsmIndustrySector.AbsTimeshares]: 'ABts',
    [ExcIceGsmV1GsmIndustrySector.AgencyCmbs]: 'CMBa',
    [ExcIceGsmV1GsmIndustrySector.NonAgencyCmbs]: 'CMBn',
    [ExcIceGsmV1GsmIndustrySector.Other]: '0',
    [ExcIceGsmV1GsmIndustrySector.AerospaceDefense]: '1',
    [ExcIceGsmV1GsmIndustrySector.Agency]: '2',
    [ExcIceGsmV1GsmIndustrySector.AutoLoans]: '7',
    [ExcIceGsmV1GsmIndustrySector.AutoPartsEquipment]: '8',
    [ExcIceGsmV1GsmIndustrySector.Banking]: '10',
    [ExcIceGsmV1GsmIndustrySector.Beverage]: '11',
    [ExcIceGsmV1GsmIndustrySector.Brokerage]: '12',
    [ExcIceGsmV1GsmIndustrySector.BuildingConstruction]: '13',
    [ExcIceGsmV1GsmIndustrySector.BuildingMaterials]: '14',
    [ExcIceGsmV1GsmIndustrySector.Chemicals]: '16',
    [ExcIceGsmV1GsmIndustrySector.ConsCommLeaseFinancing]: '18',
    [ExcIceGsmV1GsmIndustrySector.DiversifiedCapitalGoods]: '20',
    [ExcIceGsmV1GsmIndustrySector.ElectricDistrTrans]: '21',
    [ExcIceGsmV1GsmIndustrySector.ElectricGeneration]: '22',
    [ExcIceGsmV1GsmIndustrySector.ElectricIntegrated]: '23',
    [ExcIceGsmV1GsmIndustrySector.Electronics]: '24',
    [ExcIceGsmV1GsmIndustrySector.EnergyExplorationProduction]: '25',
    [ExcIceGsmV1GsmIndustrySector.Environmental]: '26',
    [ExcIceGsmV1GsmIndustrySector.FoodDrugRetailers]: '28',
    [ExcIceGsmV1GsmIndustrySector.ForestryPaper]: '29',
    [ExcIceGsmV1GsmIndustrySector.Gaming]: '30',
    [ExcIceGsmV1GsmIndustrySector.GasDistribution]: '31',
    [ExcIceGsmV1GsmIndustrySector.GovernmentGuaranteed]: '32',
    [ExcIceGsmV1GsmIndustrySector.HealthServices]: '33',
    [ExcIceGsmV1GsmIndustrySector.Hotels]: '34',
    [ExcIceGsmV1GsmIndustrySector.HousingAssociation]: '36',
    [ExcIceGsmV1GsmIndustrySector.IntegratedEnergy]: '37',
    [ExcIceGsmV1GsmIndustrySector.InvestmentsMiscFinancialServices]: '38',
    [ExcIceGsmV1GsmIndustrySector.LocalAuthority]: '42',
    [ExcIceGsmV1GsmIndustrySector.Machinery]: '43',
    [ExcIceGsmV1GsmIndustrySector.MediaDiversified]: '45',
    [ExcIceGsmV1GsmIndustrySector.MortgageBacked]: '49',
    [ExcIceGsmV1GsmIndustrySector.MultiLineInsurance]: '51',
    [ExcIceGsmV1GsmIndustrySector.NonElectricUtilities]: '52',
    [ExcIceGsmV1GsmIndustrySector.OilFieldEquipmentServices]: '55',
    [ExcIceGsmV1GsmIndustrySector.OilRefiningMarketing]: '56',
    [ExcIceGsmV1GsmIndustrySector.PC]: '57',
    [ExcIceGsmV1GsmIndustrySector.Packaging]: '58',
    [ExcIceGsmV1GsmIndustrySector.Pharmaceuticals]: '60',
    [ExcIceGsmV1GsmIndustrySector.PrintingPublishing]: '61',
    [ExcIceGsmV1GsmIndustrySector.RealEstateDevMgt]: '63',
    [ExcIceGsmV1GsmIndustrySector.ReiTs]: '64',
    [ExcIceGsmV1GsmIndustrySector.SoftwareServices]: '65',
    [ExcIceGsmV1GsmIndustrySector.Sovereign]: '66',
    [ExcIceGsmV1GsmIndustrySector.SupportServices]: '67',
    [ExcIceGsmV1GsmIndustrySector.Supranational]: '68',
    [ExcIceGsmV1GsmIndustrySector.TheatersEntertainment]: '71',
    [ExcIceGsmV1GsmIndustrySector.Tobacco]: '72',
    [ExcIceGsmV1GsmIndustrySector.ForeignSovereign]: '74',
    [ExcIceGsmV1GsmIndustrySector.Restaurants]: '75',
    [ExcIceGsmV1GsmIndustrySector.SteelProducersProducts]: '77',
    [ExcIceGsmV1GsmIndustrySector.FoodWholesale]: '79',
    [ExcIceGsmV1GsmIndustrySector.AbsCreditCards]: '81',
    [ExcIceGsmV1GsmIndustrySector.AbsManufacturedHousing]: '82',
    [ExcIceGsmV1GsmIndustrySector.AbsAutomobile_2]: '83',
    [ExcIceGsmV1GsmIndustrySector.AbsHomeEquityLoans]: '84',
    [ExcIceGsmV1GsmIndustrySector.AbsUtilities]: '85',
    [ExcIceGsmV1GsmIndustrySector.AbsMiscellaneous]: '86',
    [ExcIceGsmV1GsmIndustrySector.MetalsMiningExcludingSteel]: '87',
    [ExcIceGsmV1GsmIndustrySector.TelecomWireless]: '90',
    [ExcIceGsmV1GsmIndustrySector.CommercialMortgageBacked]: '92',
    [ExcIceGsmV1GsmIndustrySector.StructuredIo]: '94',
    [ExcIceGsmV1GsmIndustrySector.TrustIo]: '95',
    [ExcIceGsmV1GsmIndustrySector.StructuredPo]: '96',
    [ExcIceGsmV1GsmIndustrySector.TrustPo]: '97',
    [ExcIceGsmV1GsmIndustrySector.Sequential]: '98',
    [ExcIceGsmV1GsmIndustrySector.Others]: '99',
    [ExcIceGsmV1GsmIndustrySector.SupportZ]: '100',
    [ExcIceGsmV1GsmIndustrySector.SequentialZ]: '101',
    [ExcIceGsmV1GsmIndustrySector.Pac]: '102',
    [ExcIceGsmV1GsmIndustrySector.CmoOther]: '103',
    [ExcIceGsmV1GsmIndustrySector.PacZ]: '104',
    [ExcIceGsmV1GsmIndustrySector.GoState]: '105',
    [ExcIceGsmV1GsmIndustrySector.GoLocal]: '106',
    [ExcIceGsmV1GsmIndustrySector.RevenueAirport]: '107',
    [ExcIceGsmV1GsmIndustrySector.RevenueHealth]: '108',
    [ExcIceGsmV1GsmIndustrySector.RevenueEducation]: '109',
    [ExcIceGsmV1GsmIndustrySector.RevenueHospitals]: '110',
    [ExcIceGsmV1GsmIndustrySector.RevenueIndustrialDevelopmentRevenue]: '111',
    [ExcIceGsmV1GsmIndustrySector.RevenueLeasingCopsAppropriations]: '112',
    [ExcIceGsmV1GsmIndustrySector.RevenueMisc]: '113',
    [ExcIceGsmV1GsmIndustrySector.RevenueMultiFamilyHousing]: '114',
    [ExcIceGsmV1GsmIndustrySector.RevenuePollutionControl]: '115',
    [ExcIceGsmV1GsmIndustrySector.RevenuePower]: '116',
    [ExcIceGsmV1GsmIndustrySector.RevenueSingleFamilyHousing]: '117',
    [ExcIceGsmV1GsmIndustrySector.RevenueTax]: '118',
    [ExcIceGsmV1GsmIndustrySector.RevenueTobacco]: '119',
    [ExcIceGsmV1GsmIndustrySector.RevenueTollTurnpike]: '120',
    [ExcIceGsmV1GsmIndustrySector.RevenueTransportation]: '121',
    [ExcIceGsmV1GsmIndustrySector.RevenueUtilitiesOther]: '122',
    [ExcIceGsmV1GsmIndustrySector.RevenueWaterSewer]: '123',
    [ExcIceGsmV1GsmIndustrySector.Etm]: '125',
    [ExcIceGsmV1GsmIndustrySector.PreRefunded]: '126',
    [ExcIceGsmV1GsmIndustrySector.PfdQuasiGovernment]: '127',
    [ExcIceGsmV1GsmIndustrySector.PfdBanking]: '128',
    [ExcIceGsmV1GsmIndustrySector.PfdInsurance]: '131',
    [ExcIceGsmV1GsmIndustrySector.PfdBasicIndustry]: '132',
    [ExcIceGsmV1GsmIndustrySector.PfdCapitalGoods]: '133',
    [ExcIceGsmV1GsmIndustrySector.PfdEnergy]: '136',
    [ExcIceGsmV1GsmIndustrySector.PfdMedia]: '137',
    [ExcIceGsmV1GsmIndustrySector.PfdRealEstate]: '138',
    [ExcIceGsmV1GsmIndustrySector.PfdTelecommunications]: '141',
    [ExcIceGsmV1GsmIndustrySector.PfdTechnologyElectronics]: '142',
    [ExcIceGsmV1GsmIndustrySector.PfdUtility]: '143',
    [ExcIceGsmV1GsmIndustrySector.TaxablePreRefunded]: '144',
    [ExcIceGsmV1GsmIndustrySector.TaxableEtm]: '145',
    [ExcIceGsmV1GsmIndustrySector.TaxableGoState]: '147',
    [ExcIceGsmV1GsmIndustrySector.TaxableGoLocal]: '148',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueAirport]: '149',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueEducation]: '150',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueHealth]: '151',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueHospitals]: '152',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenuePollutionControl]: '153',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueIndustrialDevelopmentRevenue]: '154',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueLeasingCopsAppropriations]: '155',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueSingleFamilyHousing]: '156',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueMultiFamilyHousing]: '157',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueTax]: '158',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueTobacco]: '159',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueTollTurnpike]: '160',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueTransportation]: '161',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenuePower]: '162',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueUtilitiesOther]: '163',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueWaterSewer]: '164',
    [ExcIceGsmV1GsmIndustrySector.TaxableRevenueMisc]: '165',
    [ExcIceGsmV1GsmIndustrySector.Automakers]: '166',
    [ExcIceGsmV1GsmIndustrySector.DiscountStores]: '167',
    [ExcIceGsmV1GsmIndustrySector.MedicalProducts]: '168',
    [ExcIceGsmV1GsmIndustrySector.HealthFacilities]: '169',
    [ExcIceGsmV1GsmIndustrySector.InsuranceBrokerage]: '171',
    [ExcIceGsmV1GsmIndustrySector.MonolineInsurance]: '172',
    [ExcIceGsmV1GsmIndustrySector.InterestRateSwap]: '173',
    [ExcIceGsmV1GsmIndustrySector.ManagedCare]: '174',
    [ExcIceGsmV1GsmIndustrySector.SpecialtyRetail]: '175',
    [ExcIceGsmV1GsmIndustrySector.PfdAutomotive]: '176',
    [ExcIceGsmV1GsmIndustrySector.PfdHealthcare]: '177',
    [ExcIceGsmV1GsmIndustrySector.PfdLeisure]: '178',
    [ExcIceGsmV1GsmIndustrySector.LifeInsurance]: '179',
    [ExcIceGsmV1GsmIndustrySector.PfdFinancialServices]: '180',
    [ExcIceGsmV1GsmIndustrySector.DepartmentStores]: '181',
    [ExcIceGsmV1GsmIndustrySector.TransportInfrastructureServices]: '186',
    [ExcIceGsmV1GsmIndustrySector.TruckingDelivery]: '187',
    [ExcIceGsmV1GsmIndustrySector.Reinsurance]: '188',
    [ExcIceGsmV1GsmIndustrySector.TelecomSatellite]: '189',
    [ExcIceGsmV1GsmIndustrySector.PublicLoanCoveredBonds]: '190',
    [ExcIceGsmV1GsmIndustrySector.MortgageCoveredBonds]: '191',
    [ExcIceGsmV1GsmIndustrySector.OtherCoveredBonds]: '192',
    [ExcIceGsmV1GsmIndustrySector.AirTransportation]: '193',
    [ExcIceGsmV1GsmIndustrySector.TechHardwareEquipment]: '194',
    [ExcIceGsmV1GsmIndustrySector.PersonalHouseholdProducts]: '195',
    [ExcIceGsmV1GsmIndustrySector.RecreationTravel]: '196',
    [ExcIceGsmV1GsmIndustrySector.MediaContent]: '197',
    [ExcIceGsmV1GsmIndustrySector.Advertising]: '198',
    [ExcIceGsmV1GsmIndustrySector.CableSatelliteTv]: '199',
    [ExcIceGsmV1GsmIndustrySector.Rail]: '200',
    [ExcIceGsmV1GsmIndustrySector.TelecomWirelineIntegratedServices]: '201',
    [ExcIceGsmV1GsmIndustrySector.PfdConsumerGoods]: '202',
    [ExcIceGsmV1GsmIndustrySector.PfdRetail]: '203',
    [ExcIceGsmV1GsmIndustrySector.PfdServices]: '204',
    [ExcIceGsmV1GsmIndustrySector.PfdTransportation]: '205',
    [ExcIceGsmV1GsmIndustrySector.CvtBanking]: '208',
    [ExcIceGsmV1GsmIndustrySector.CvtBrokerage]: '209',
    [ExcIceGsmV1GsmIndustrySector.CvtConsCommLeaseFinancing]: '210',
    [ExcIceGsmV1GsmIndustrySector.CvtInvestmentsMiscFinancialServices]: '211',
    [ExcIceGsmV1GsmIndustrySector.CvtInsuranceBrokerage]: '212',
    [ExcIceGsmV1GsmIndustrySector.CvtLifeInsurance]: '213',
    [ExcIceGsmV1GsmIndustrySector.CvtMonolineInsurance]: '214',
    [ExcIceGsmV1GsmIndustrySector.CvtMultiLineInsurance]: '215',
    [ExcIceGsmV1GsmIndustrySector.CvtPC]: '216',
    [ExcIceGsmV1GsmIndustrySector.CvtReinsurance]: '217',
    [ExcIceGsmV1GsmIndustrySector.CvtAutoLoans]: '218',
    [ExcIceGsmV1GsmIndustrySector.CvtAutoPartsEquipment]: '219',
    [ExcIceGsmV1GsmIndustrySector.CvtAutomakers]: '220',
    [ExcIceGsmV1GsmIndustrySector.CvtBuildingConstruction]: '221',
    [ExcIceGsmV1GsmIndustrySector.CvtBuildingMaterials]: '222',
    [ExcIceGsmV1GsmIndustrySector.CvtChemicals]: '223',
    [ExcIceGsmV1GsmIndustrySector.CvtForestryPaper]: '224',
    [ExcIceGsmV1GsmIndustrySector.CvtMetalsMiningExcludingSteel]: '225',
    [ExcIceGsmV1GsmIndustrySector.CvtSteelProducersProducts]: '226',
    [ExcIceGsmV1GsmIndustrySector.CvtAerospaceDefense]: '227',
    [ExcIceGsmV1GsmIndustrySector.CvtDiversifiedCapitalGoods]: '228',
    [ExcIceGsmV1GsmIndustrySector.CvtMachinery]: '229',
    [ExcIceGsmV1GsmIndustrySector.CvtPackaging]: '230',
    [ExcIceGsmV1GsmIndustrySector.CvtBeverage]: '231',
    [ExcIceGsmV1GsmIndustrySector.CvtFoodWholesale]: '232',
    [ExcIceGsmV1GsmIndustrySector.CvtPersonalHouseholdProducts]: '233',
    [ExcIceGsmV1GsmIndustrySector.CvtTobacco]: '234',
    [ExcIceGsmV1GsmIndustrySector.CvtEnergyExplorationProduction]: '235',
    [ExcIceGsmV1GsmIndustrySector.CvtGasDistribution]: '236',
    [ExcIceGsmV1GsmIndustrySector.CvtIntegratedEnergy]: '237',
    [ExcIceGsmV1GsmIndustrySector.CvtOilFieldEquipmentServices]: '238',
    [ExcIceGsmV1GsmIndustrySector.CvtOilRefiningMarketing]: '239',
    [ExcIceGsmV1GsmIndustrySector.CvtHealthFacilities]: '240',
    [ExcIceGsmV1GsmIndustrySector.CvtHealthServices]: '241',
    [ExcIceGsmV1GsmIndustrySector.CvtManagedCare]: '242',
    [ExcIceGsmV1GsmIndustrySector.CvtMedicalProducts]: '243',
    [ExcIceGsmV1GsmIndustrySector.CvtPharmaceuticals]: '244',
    [ExcIceGsmV1GsmIndustrySector.CvtGaming]: '245',
    [ExcIceGsmV1GsmIndustrySector.CvtHotels]: '246',
    [ExcIceGsmV1GsmIndustrySector.CvtRecreationTravel]: '247',
    [ExcIceGsmV1GsmIndustrySector.CvtTheatersEntertainment]: '248',
    [ExcIceGsmV1GsmIndustrySector.CvtAdvertising]: '249',
    [ExcIceGsmV1GsmIndustrySector.CvtCableSatelliteTv]: '250',
    [ExcIceGsmV1GsmIndustrySector.CvtMediaDiversified]: '251',
    [ExcIceGsmV1GsmIndustrySector.CvtMediaContent]: '252',
    [ExcIceGsmV1GsmIndustrySector.CvtPrintingPublishing]: '253',
    [ExcIceGsmV1GsmIndustrySector.CvtHousingAssociation]: '254',
    [ExcIceGsmV1GsmIndustrySector.CvtRealEstateDevMgt]: '255',
    [ExcIceGsmV1GsmIndustrySector.CvtReiTs]: '256',
    [ExcIceGsmV1GsmIndustrySector.CvtDepartmentStores]: '257',
    [ExcIceGsmV1GsmIndustrySector.CvtDiscountStores]: '258',
    [ExcIceGsmV1GsmIndustrySector.CvtFoodDrugRetailers]: '259',
    [ExcIceGsmV1GsmIndustrySector.CvtRestaurants]: '260',
    [ExcIceGsmV1GsmIndustrySector.CvtSpecialtyRetail]: '261',
    [ExcIceGsmV1GsmIndustrySector.CvtEnvironmental]: '262',
    [ExcIceGsmV1GsmIndustrySector.CvtSupportServices]: '263',
    [ExcIceGsmV1GsmIndustrySector.CvtElectronics]: '264',
    [ExcIceGsmV1GsmIndustrySector.CvtSoftwareServices]: '265',
    [ExcIceGsmV1GsmIndustrySector.CvtTechHardwareEquipment]: '266',
    [ExcIceGsmV1GsmIndustrySector.CvtTelecomSatellite]: '267',
    [ExcIceGsmV1GsmIndustrySector.CvtTelecomWireless]: '268',
    [ExcIceGsmV1GsmIndustrySector.CvtTelecomWirelineIntegratedServices]: '269',
    [ExcIceGsmV1GsmIndustrySector.CvtAirTransportation]: '270',
    [ExcIceGsmV1GsmIndustrySector.CvtRail]: '271',
    [ExcIceGsmV1GsmIndustrySector.CvtTransportInfrastructureServices]: '272',
    [ExcIceGsmV1GsmIndustrySector.CvtTruckingDelivery]: '273',
    [ExcIceGsmV1GsmIndustrySector.CvtElectricDistrTrans]: '274',
    [ExcIceGsmV1GsmIndustrySector.CvtElectricGeneration]: '275',
    [ExcIceGsmV1GsmIndustrySector.CvtElectricIntegrated]: '276',
    [ExcIceGsmV1GsmIndustrySector.CvtNonElectricUtilities]: '277',
    [ExcIceGsmV1GsmIndustrySector.PfdAgency]: '278',
    [ExcIceGsmV1GsmIndustrySector.PfdAdvertising]: '279',
    [ExcIceGsmV1GsmIndustrySector.PfdAerospaceDefense]: '280',
    [ExcIceGsmV1GsmIndustrySector.PfdAirTransportation]: '281',
    [ExcIceGsmV1GsmIndustrySector.PfdAutoLoans]: '282',
    [ExcIceGsmV1GsmIndustrySector.PfdAutoPartsEquipment]: '283',
    [ExcIceGsmV1GsmIndustrySector.PfdAutomakers]: '284',
    [ExcIceGsmV1GsmIndustrySector.PfdBeverage]: '285',
    [ExcIceGsmV1GsmIndustrySector.PfdBrokerage]: '286',
    [ExcIceGsmV1GsmIndustrySector.PfdBuildingConstruction]: '287',
    [ExcIceGsmV1GsmIndustrySector.PfdBuildingMaterials]: '288',
    [ExcIceGsmV1GsmIndustrySector.PfdCableSatelliteTv]: '289',
    [ExcIceGsmV1GsmIndustrySector.PfdChemicals]: '290',
    [ExcIceGsmV1GsmIndustrySector.PfdConsCommLeaseFinancing]: '291',
    [ExcIceGsmV1GsmIndustrySector.PfdDepartmentStores]: '292',
    [ExcIceGsmV1GsmIndustrySector.PfdDiscountStores]: '293',
    [ExcIceGsmV1GsmIndustrySector.PfdDiversifiedCapitalGoods]: '294',
    [ExcIceGsmV1GsmIndustrySector.PfdElectricDistrTrans]: '295',
    [ExcIceGsmV1GsmIndustrySector.PfdElectricGeneration]: '296',
    [ExcIceGsmV1GsmIndustrySector.PfdElectricIntegrated]: '297',
    [ExcIceGsmV1GsmIndustrySector.PfdElectronics]: '298',
    [ExcIceGsmV1GsmIndustrySector.PfdEnergyExplorationProduction]: '299',
    [ExcIceGsmV1GsmIndustrySector.PfdEnvironmental]: '300',
    [ExcIceGsmV1GsmIndustrySector.PfdFoodWholesale]: '301',
    [ExcIceGsmV1GsmIndustrySector.PfdFoodDrugRetailers]: '302',
    [ExcIceGsmV1GsmIndustrySector.PfdForestryPaper]: '303',
    [ExcIceGsmV1GsmIndustrySector.PfdGaming]: '304',
    [ExcIceGsmV1GsmIndustrySector.PfdGasDistribution]: '305',
    [ExcIceGsmV1GsmIndustrySector.PfdHealthFacilities]: '306',
    [ExcIceGsmV1GsmIndustrySector.PfdHealthServices]: '307',
    [ExcIceGsmV1GsmIndustrySector.PfdHotels]: '308',
    [ExcIceGsmV1GsmIndustrySector.PfdHousingAssociation]: '309',
    [ExcIceGsmV1GsmIndustrySector.PfdInsuranceBrokerage]: '310',
    [ExcIceGsmV1GsmIndustrySector.PfdIntegratedEnergy]: '311',
    [ExcIceGsmV1GsmIndustrySector.PfdInvestmentsMiscFinancialServices]: '312',
    [ExcIceGsmV1GsmIndustrySector.PfdLifeInsurance]: '313',
    [ExcIceGsmV1GsmIndustrySector.PfdMachinery]: '314',
    [ExcIceGsmV1GsmIndustrySector.PfdManagedCare]: '315',
    [ExcIceGsmV1GsmIndustrySector.PfdMediaDiversified]: '316',
    [ExcIceGsmV1GsmIndustrySector.PfdMediaContent]: '317',
    [ExcIceGsmV1GsmIndustrySector.PfdMedicalProducts]: '318',
    [ExcIceGsmV1GsmIndustrySector.PfdMetalsMiningExcludingSteel]: '319',
    [ExcIceGsmV1GsmIndustrySector.PfdMonolineInsurance]: '320',
    [ExcIceGsmV1GsmIndustrySector.PfdMultiLineInsurance]: '321',
    [ExcIceGsmV1GsmIndustrySector.PfdNonElectricUtilities]: '322',
    [ExcIceGsmV1GsmIndustrySector.PfdOilFieldEquipmentServices]: '323',
    [ExcIceGsmV1GsmIndustrySector.PfdOilRefiningMarketing]: '324',
    [ExcIceGsmV1GsmIndustrySector.PfdPC]: '325',
    [ExcIceGsmV1GsmIndustrySector.PfdPackaging]: '326',
    [ExcIceGsmV1GsmIndustrySector.PfdPersonalHouseholdProducts]: '327',
    [ExcIceGsmV1GsmIndustrySector.PfdPharmaceuticals]: '328',
    [ExcIceGsmV1GsmIndustrySector.PfdPrintingPublishing]: '329',
    [ExcIceGsmV1GsmIndustrySector.PfdRail]: '330',
    [ExcIceGsmV1GsmIndustrySector.PfdRealEstateDevMgt]: '331',
    [ExcIceGsmV1GsmIndustrySector.PfdRecreationTravel]: '332',
    [ExcIceGsmV1GsmIndustrySector.PfdReinsurance]: '333',
    [ExcIceGsmV1GsmIndustrySector.PfdReiTs]: '334',
    [ExcIceGsmV1GsmIndustrySector.PfdRestaurants]: '335',
    [ExcIceGsmV1GsmIndustrySector.PfdSoftwareServices]: '336',
    [ExcIceGsmV1GsmIndustrySector.PfdSpecialtyRetail]: '337',
    [ExcIceGsmV1GsmIndustrySector.PfdSteelProducersProducts]: '338',
    [ExcIceGsmV1GsmIndustrySector.PfdSupportServices]: '339',
    [ExcIceGsmV1GsmIndustrySector.PfdTechHardwareEquipment]: '340',
    [ExcIceGsmV1GsmIndustrySector.PfdTelecomSatellite]: '341',
    [ExcIceGsmV1GsmIndustrySector.PfdTelecomWireless]: '342',
    [ExcIceGsmV1GsmIndustrySector.PfdTelecomWirelineIntegratedServices]: '343',
    [ExcIceGsmV1GsmIndustrySector.PfdTheatersEntertainment]: '344',
    [ExcIceGsmV1GsmIndustrySector.PfdTobacco]: '345',
    [ExcIceGsmV1GsmIndustrySector.PfdTransportInfrastructureServices]: '346',
    [ExcIceGsmV1GsmIndustrySector.PfdTruckingDelivery]: '347'
} as const;

export enum ExcIceGsmV1IceAssetClass {
    Unspecified = 'UNSPECIFIED',
    SecuritizedCollateralized = 'SECURITIZED_COLLATERALIZED',
    Corporate = 'CORPORATE',
    Convertible = 'CONVERTIBLE',
    USTaxExemptMunicipals = 'U_S_TAX_EXEMPT_MUNICIPALS',
    PreferredSecurities = 'PREFERRED_SECURITIES',
    QuasiForeignGovernment = 'QUASI_FOREIGN_GOVERNMENT',
    Sovereign = 'SOVEREIGN',
    BankLoans = 'BANK_LOANS'
}

export const EXC_ICE_GSM_V1_ICE_ASSET_CLASS_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1IceAssetClass.SecuritizedCollateralized]: 'Securitized/Collateralized',
    [ExcIceGsmV1IceAssetClass.Corporate]: 'Corporate',
    [ExcIceGsmV1IceAssetClass.Convertible]: 'Convertible',
    [ExcIceGsmV1IceAssetClass.USTaxExemptMunicipals]: 'U.S. Tax-Exempt Municipals',
    [ExcIceGsmV1IceAssetClass.PreferredSecurities]: 'Preferred Securities',
    [ExcIceGsmV1IceAssetClass.QuasiForeignGovernment]: 'Quasi & Foreign Government',
    [ExcIceGsmV1IceAssetClass.Sovereign]: 'Sovereign',
    [ExcIceGsmV1IceAssetClass.BankLoans]: 'Bank Loans'
} as const;

export const EXC_ICE_GSM_V1_ICE_ASSET_CLASS_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1IceAssetClass.SecuritizedCollateralized]: 'COLL',
    [ExcIceGsmV1IceAssetClass.Corporate]: 'CORP',
    [ExcIceGsmV1IceAssetClass.Convertible]: 'CVT',
    [ExcIceGsmV1IceAssetClass.USTaxExemptMunicipals]: 'MUNI',
    [ExcIceGsmV1IceAssetClass.PreferredSecurities]: 'PFD',
    [ExcIceGsmV1IceAssetClass.QuasiForeignGovernment]: 'QGVT',
    [ExcIceGsmV1IceAssetClass.Sovereign]: 'SOV',
    [ExcIceGsmV1IceAssetClass.BankLoans]: 'LOAN'
} as const;

export enum ExcIceGsmV1IceCategory {
    Unspecified = 'UNSPECIFIED',
    AssetBacked = 'ASSET_BACKED',
    Agency = 'AGENCY',
    RevenueAirport = 'REVENUE_AIRPORT',
    Automotive = 'AUTOMOTIVE',
    Banking = 'BANKING',
    BasicIndustry = 'BASIC_INDUSTRY',
    CapitalGoods = 'CAPITAL_GOODS',
    CvtAutomotive = 'CVT_AUTOMOTIVE',
    CvtAutomotive_2 = 'CVT_AUTOMOTIVE_2',
    CvtBanking = 'CVT_BANKING',
    CvtBasicIndustry = 'CVT_BASIC_INDUSTRY',
    CvtCapitalGoods = 'CVT_CAPITAL_GOODS',
    CvtCapitalGoods_2 = 'CVT_CAPITAL_GOODS_2',
    CvtConsumerGoods = 'CVT_CONSUMER_GOODS',
    CvtEnergy = 'CVT_ENERGY',
    CvtFinancialServices = 'CVT_FINANCIAL_SERVICES',
    CvtHealthcare = 'CVT_HEALTHCARE',
    CvtInsurance = 'CVT_INSURANCE',
    CvtInsurance_2 = 'CVT_INSURANCE_2',
    CommercialMortgageBacked = 'COMMERCIAL_MORTGAGE_BACKED',
    CvtMedia = 'CVT_MEDIA',
    CollateralizedMortgageObligation = 'COLLATERALIZED_MORTGAGE_OBLIGATION',
    CvtTransportation = 'CVT_TRANSPORTATION',
    ConsumerGoods = 'CONSUMER_GOODS',
    CvtRealEstate = 'CVT_REAL_ESTATE',
    CvtRetail = 'CVT_RETAIL',
    CvtLeisure = 'CVT_LEISURE',
    CvtServices = 'CVT_SERVICES',
    CvtTelecommunications = 'CVT_TELECOMMUNICATIONS',
    CvtTechnologyElectronics = 'CVT_TECHNOLOGY_ELECTRONICS',
    CvtUtility = 'CVT_UTILITY',
    CoveredBonds = 'COVERED_BONDS',
    RevenueEducation = 'REVENUE_EDUCATION',
    Energy = 'ENERGY',
    FinancialServices = 'FINANCIAL_SERVICES',
    ForeignSovereign = 'FOREIGN_SOVEREIGN',
    GoLocal = 'GO_LOCAL',
    GoState = 'GO_STATE',
    GovernmentGuaranteed = 'GOVERNMENT_GUARANTEED',
    Healthcare = 'HEALTHCARE',
    RevenueHealth = 'REVENUE_HEALTH',
    RevenueHospitals = 'REVENUE_HOSPITALS',
    RevenueIndustrialDevelopmentRevenue = 'REVENUE_INDUSTRIAL_DEVELOPMENT_REVENUE',
    Insurance = 'INSURANCE',
    RevenueLeasingCopsAppropriations = 'REVENUE_LEASING_COPS_APPROPRIATIONS',
    LocalAuthority = 'LOCAL_AUTHORITY',
    LoanBanking = 'LOAN_BANKING',
    LoanFinancialServices = 'LOAN_FINANCIAL_SERVICES',
    LoanInsurance = 'LOAN_INSURANCE',
    LoanAutomotive = 'LOAN_AUTOMOTIVE',
    LoanBasicIndustry = 'LOAN_BASIC_INDUSTRY',
    LoanCapitalGoods = 'LOAN_CAPITAL_GOODS',
    LoanConsumerGoods = 'LOAN_CONSUMER_GOODS',
    LoanEnergy = 'LOAN_ENERGY',
    LoanHealthcare = 'LOAN_HEALTHCARE',
    LoanLeisure = 'LOAN_LEISURE',
    LoanMedia = 'LOAN_MEDIA',
    LoanRealEstate = 'LOAN_REAL_ESTATE',
    LoanRetail = 'LOAN_RETAIL',
    LoanServices = 'LOAN_SERVICES',
    LoanTechnologyElectronics = 'LOAN_TECHNOLOGY_ELECTRONICS',
    LoanTelecommunications = 'LOAN_TELECOMMUNICATIONS',
    LoanTransportation = 'LOAN_TRANSPORTATION',
    LoanUtility = 'LOAN_UTILITY',
    MortgageBacked = 'MORTGAGE_BACKED',
    Media = 'MEDIA',
    RevenueMultiFamilyHousing = 'REVENUE_MULTI_FAMILY_HOUSING',
    RevenueMisc = 'REVENUE_MISC',
    Transportation = 'TRANSPORTATION',
    PfdAutomotive = 'PFD_AUTOMOTIVE',
    PfdBanking = 'PFD_BANKING',
    PfdBasicIndustry = 'PFD_BASIC_INDUSTRY',
    PfdCapitalGoods = 'PFD_CAPITAL_GOODS',
    PfdConsumerGoods = 'PFD_CONSUMER_GOODS',
    RevenuePollutionControl = 'REVENUE_POLLUTION_CONTROL',
    PfdEnergy = 'PFD_ENERGY',
    PfdFinancialServices = 'PFD_FINANCIAL_SERVICES',
    PfdHealthcare = 'PFD_HEALTHCARE',
    PfdInsurance = 'PFD_INSURANCE',
    PfdLeisure = 'PFD_LEISURE',
    PfdMedia = 'PFD_MEDIA',
    RevenuePower = 'REVENUE_POWER',
    PfdAgency = 'PFD_AGENCY',
    PfdRealEstate = 'PFD_REAL_ESTATE',
    PfdRetail = 'PFD_RETAIL',
    PfdServices = 'PFD_SERVICES',
    PfdTelecommunications = 'PFD_TELECOMMUNICATIONS',
    PfdTechnologyElectronics = 'PFD_TECHNOLOGY_ELECTRONICS',
    PfdTransportation = 'PFD_TRANSPORTATION',
    PfdUtility = 'PFD_UTILITY',
    Refunded = 'REFUNDED',
    RealEstate = 'REAL_ESTATE',
    Retail = 'RETAIL',
    Leisure = 'LEISURE',
    Services = 'SERVICES',
    RevenueSingleFamilyHousing = 'REVENUE_SINGLE_FAMILY_HOUSING',
    Sovereign = 'SOVEREIGN',
    Supranational = 'SUPRANATIONAL',
    USTaxableMunicipal = 'U_S_TAXABLE_MUNICIPAL',
    RevenueTax = 'REVENUE_TAX',
    Telecommunications = 'TELECOMMUNICATIONS',
    TechnologyElectronics = 'TECHNOLOGY_ELECTRONICS',
    RevenueTobacco = 'REVENUE_TOBACCO',
    RevenueTollTurnpike = 'REVENUE_TOLL_TURNPIKE',
    RevenueTransportation = 'REVENUE_TRANSPORTATION',
    Utility = 'UTILITY',
    RevenueUtilitiesOther = 'REVENUE_UTILITIES_OTHER',
    RevenueWaterSewer = 'REVENUE_WATER_SEWER'
}

export const EXC_ICE_GSM_V1_ICE_CATEGORY_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1IceCategory.AssetBacked]: 'Asset Backed',
    [ExcIceGsmV1IceCategory.Agency]: 'Agency',
    [ExcIceGsmV1IceCategory.RevenueAirport]: 'Revenue - Airport',
    [ExcIceGsmV1IceCategory.Automotive]: 'Automotive',
    [ExcIceGsmV1IceCategory.Banking]: 'Banking',
    [ExcIceGsmV1IceCategory.BasicIndustry]: 'Basic Industry',
    [ExcIceGsmV1IceCategory.CapitalGoods]: 'Capital Goods',
    [ExcIceGsmV1IceCategory.CvtAutomotive]: 'Cvt-Automotive',
    [ExcIceGsmV1IceCategory.CvtAutomotive_2]: 'Cvt-Automotive',
    [ExcIceGsmV1IceCategory.CvtBanking]: 'Cvt-Banking',
    [ExcIceGsmV1IceCategory.CvtBasicIndustry]: 'Cvt-Basic Industry',
    [ExcIceGsmV1IceCategory.CvtCapitalGoods]: 'Cvt-Capital Goods',
    [ExcIceGsmV1IceCategory.CvtCapitalGoods_2]: 'Cvt-Capital Goods',
    [ExcIceGsmV1IceCategory.CvtConsumerGoods]: 'Cvt-Consumer Goods',
    [ExcIceGsmV1IceCategory.CvtEnergy]: 'Cvt-Energy',
    [ExcIceGsmV1IceCategory.CvtFinancialServices]: 'Cvt-Financial Services',
    [ExcIceGsmV1IceCategory.CvtHealthcare]: 'Cvt-Healthcare',
    [ExcIceGsmV1IceCategory.CvtInsurance]: 'Cvt-Insurance',
    [ExcIceGsmV1IceCategory.CvtInsurance_2]: 'Cvt-Insurance',
    [ExcIceGsmV1IceCategory.CommercialMortgageBacked]: 'Commercial Mortgage Backed',
    [ExcIceGsmV1IceCategory.CvtMedia]: 'Cvt-Media',
    [ExcIceGsmV1IceCategory.CollateralizedMortgageObligation]: 'Collateralized Mortgage Obligation',
    [ExcIceGsmV1IceCategory.CvtTransportation]: 'Cvt-Transportation',
    [ExcIceGsmV1IceCategory.ConsumerGoods]: 'Consumer Goods',
    [ExcIceGsmV1IceCategory.CvtRealEstate]: 'Cvt-Real Estate',
    [ExcIceGsmV1IceCategory.CvtRetail]: 'Cvt-Retail',
    [ExcIceGsmV1IceCategory.CvtLeisure]: 'Cvt-Leisure',
    [ExcIceGsmV1IceCategory.CvtServices]: 'Cvt-Services',
    [ExcIceGsmV1IceCategory.CvtTelecommunications]: 'Cvt-Telecommunications',
    [ExcIceGsmV1IceCategory.CvtTechnologyElectronics]: 'Cvt-Technology & Electronics',
    [ExcIceGsmV1IceCategory.CvtUtility]: 'Cvt-Utility',
    [ExcIceGsmV1IceCategory.CoveredBonds]: 'Covered Bonds',
    [ExcIceGsmV1IceCategory.RevenueEducation]: 'Revenue - Education',
    [ExcIceGsmV1IceCategory.Energy]: 'Energy',
    [ExcIceGsmV1IceCategory.FinancialServices]: 'Financial Services',
    [ExcIceGsmV1IceCategory.ForeignSovereign]: 'Foreign Sovereign',
    [ExcIceGsmV1IceCategory.GoLocal]: 'GO - Local',
    [ExcIceGsmV1IceCategory.GoState]: 'GO - State',
    [ExcIceGsmV1IceCategory.GovernmentGuaranteed]: 'Government Guaranteed',
    [ExcIceGsmV1IceCategory.Healthcare]: 'Healthcare',
    [ExcIceGsmV1IceCategory.RevenueHealth]: 'Revenue - Health',
    [ExcIceGsmV1IceCategory.RevenueHospitals]: 'Revenue - Hospitals',
    [ExcIceGsmV1IceCategory.RevenueIndustrialDevelopmentRevenue]: 'Revenue - Industrial Development Revenue',
    [ExcIceGsmV1IceCategory.Insurance]: 'Insurance',
    [ExcIceGsmV1IceCategory.RevenueLeasingCopsAppropriations]: 'Revenue - Leasing COPS & Appropriations',
    [ExcIceGsmV1IceCategory.LocalAuthority]: 'Local-Authority',
    [ExcIceGsmV1IceCategory.LoanBanking]: 'Loan-Banking',
    [ExcIceGsmV1IceCategory.LoanFinancialServices]: 'Loan-Financial Services',
    [ExcIceGsmV1IceCategory.LoanInsurance]: 'Loan-Insurance',
    [ExcIceGsmV1IceCategory.LoanAutomotive]: 'Loan-Automotive',
    [ExcIceGsmV1IceCategory.LoanBasicIndustry]: 'Loan-Basic Industry',
    [ExcIceGsmV1IceCategory.LoanCapitalGoods]: 'Loan-Capital Goods',
    [ExcIceGsmV1IceCategory.LoanConsumerGoods]: 'Loan-Consumer Goods',
    [ExcIceGsmV1IceCategory.LoanEnergy]: 'Loan-Energy',
    [ExcIceGsmV1IceCategory.LoanHealthcare]: 'Loan-Healthcare',
    [ExcIceGsmV1IceCategory.LoanLeisure]: 'Loan-Leisure',
    [ExcIceGsmV1IceCategory.LoanMedia]: 'Loan-Media',
    [ExcIceGsmV1IceCategory.LoanRealEstate]: 'Loan-Real Estate',
    [ExcIceGsmV1IceCategory.LoanRetail]: 'Loan-Retail',
    [ExcIceGsmV1IceCategory.LoanServices]: 'Loan-Services',
    [ExcIceGsmV1IceCategory.LoanTechnologyElectronics]: 'Loan-Technology & Electronics',
    [ExcIceGsmV1IceCategory.LoanTelecommunications]: 'Loan-Telecommunications',
    [ExcIceGsmV1IceCategory.LoanTransportation]: 'Loan-Transportation',
    [ExcIceGsmV1IceCategory.LoanUtility]: 'Loan-Utility',
    [ExcIceGsmV1IceCategory.MortgageBacked]: 'Mortgage Backed',
    [ExcIceGsmV1IceCategory.Media]: 'Media',
    [ExcIceGsmV1IceCategory.RevenueMultiFamilyHousing]: 'Revenue - Multi-Family Housing',
    [ExcIceGsmV1IceCategory.RevenueMisc]: 'Revenue - Misc',
    [ExcIceGsmV1IceCategory.Transportation]: 'Transportation',
    [ExcIceGsmV1IceCategory.PfdAutomotive]: 'Pfd-Automotive',
    [ExcIceGsmV1IceCategory.PfdBanking]: 'Pfd-Banking',
    [ExcIceGsmV1IceCategory.PfdBasicIndustry]: 'Pfd-Basic Industry',
    [ExcIceGsmV1IceCategory.PfdCapitalGoods]: 'Pfd-Capital Goods',
    [ExcIceGsmV1IceCategory.PfdConsumerGoods]: 'Pfd-Consumer Goods',
    [ExcIceGsmV1IceCategory.RevenuePollutionControl]: 'Revenue - Pollution Control',
    [ExcIceGsmV1IceCategory.PfdEnergy]: 'Pfd-Energy',
    [ExcIceGsmV1IceCategory.PfdFinancialServices]: 'Pfd-Financial Services',
    [ExcIceGsmV1IceCategory.PfdHealthcare]: 'Pfd-Healthcare',
    [ExcIceGsmV1IceCategory.PfdInsurance]: 'Pfd-Insurance',
    [ExcIceGsmV1IceCategory.PfdLeisure]: 'Pfd-Leisure',
    [ExcIceGsmV1IceCategory.PfdMedia]: 'Pfd-Media',
    [ExcIceGsmV1IceCategory.RevenuePower]: 'Revenue - Power',
    [ExcIceGsmV1IceCategory.PfdAgency]: 'Pfd-Agency',
    [ExcIceGsmV1IceCategory.PfdRealEstate]: 'Pfd-Real Estate',
    [ExcIceGsmV1IceCategory.PfdRetail]: 'Pfd-Retail',
    [ExcIceGsmV1IceCategory.PfdServices]: 'Pfd-Services',
    [ExcIceGsmV1IceCategory.PfdTelecommunications]: 'Pfd-Telecommunications',
    [ExcIceGsmV1IceCategory.PfdTechnologyElectronics]: 'Pfd-Technology & Electronics',
    [ExcIceGsmV1IceCategory.PfdTransportation]: 'Pfd-Transportation',
    [ExcIceGsmV1IceCategory.PfdUtility]: 'Pfd-Utility',
    [ExcIceGsmV1IceCategory.Refunded]: 'Refunded',
    [ExcIceGsmV1IceCategory.RealEstate]: 'Real Estate',
    [ExcIceGsmV1IceCategory.Retail]: 'Retail',
    [ExcIceGsmV1IceCategory.Leisure]: 'Leisure',
    [ExcIceGsmV1IceCategory.Services]: 'Services',
    [ExcIceGsmV1IceCategory.RevenueSingleFamilyHousing]: 'Revenue - Single Family Housing',
    [ExcIceGsmV1IceCategory.Sovereign]: 'Sovereign',
    [ExcIceGsmV1IceCategory.Supranational]: 'Supranational',
    [ExcIceGsmV1IceCategory.USTaxableMunicipal]: 'U.S. Taxable Municipal',
    [ExcIceGsmV1IceCategory.RevenueTax]: 'Revenue - Tax',
    [ExcIceGsmV1IceCategory.Telecommunications]: 'Telecommunications',
    [ExcIceGsmV1IceCategory.TechnologyElectronics]: 'Technology & Electronics',
    [ExcIceGsmV1IceCategory.RevenueTobacco]: 'Revenue - Tobacco',
    [ExcIceGsmV1IceCategory.RevenueTollTurnpike]: 'Revenue - Toll & Turnpike',
    [ExcIceGsmV1IceCategory.RevenueTransportation]: 'Revenue - Transportation',
    [ExcIceGsmV1IceCategory.Utility]: 'Utility',
    [ExcIceGsmV1IceCategory.RevenueUtilitiesOther]: 'Revenue - Utilities - Other',
    [ExcIceGsmV1IceCategory.RevenueWaterSewer]: 'Revenue - Water & Sewer'
} as const;

export const EXC_ICE_GSM_V1_ICE_CATEGORY_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1IceCategory.AssetBacked]: 'ABS',
    [ExcIceGsmV1IceCategory.Agency]: 'Agcy',
    [ExcIceGsmV1IceCategory.RevenueAirport]: 'Airp',
    [ExcIceGsmV1IceCategory.Automotive]: 'Auto',
    [ExcIceGsmV1IceCategory.Banking]: 'Bank',
    [ExcIceGsmV1IceCategory.BasicIndustry]: 'Basc',
    [ExcIceGsmV1IceCategory.CapitalGoods]: 'CapG',
    [ExcIceGsmV1IceCategory.CvtAutomotive]: 'CAut',
    [ExcIceGsmV1IceCategory.CvtAutomotive_2]: 'Caut',
    [ExcIceGsmV1IceCategory.CvtBanking]: 'CBan',
    [ExcIceGsmV1IceCategory.CvtBasicIndustry]: 'CBas',
    [ExcIceGsmV1IceCategory.CvtCapitalGoods]: 'CCap',
    [ExcIceGsmV1IceCategory.CvtCapitalGoods_2]: 'Ccap',
    [ExcIceGsmV1IceCategory.CvtConsumerGoods]: 'CCon',
    [ExcIceGsmV1IceCategory.CvtEnergy]: 'CEnr',
    [ExcIceGsmV1IceCategory.CvtFinancialServices]: 'CFin',
    [ExcIceGsmV1IceCategory.CvtHealthcare]: 'CHca',
    [ExcIceGsmV1IceCategory.CvtInsurance]: 'CIns',
    [ExcIceGsmV1IceCategory.CvtInsurance_2]: 'Cins',
    [ExcIceGsmV1IceCategory.CommercialMortgageBacked]: 'CMBS',
    [ExcIceGsmV1IceCategory.CvtMedia]: 'CMed',
    [ExcIceGsmV1IceCategory.CollateralizedMortgageObligation]: 'CMO',
    [ExcIceGsmV1IceCategory.CvtTransportation]: 'CMov',
    [ExcIceGsmV1IceCategory.ConsumerGoods]: 'Cons',
    [ExcIceGsmV1IceCategory.CvtRealEstate]: 'CRes',
    [ExcIceGsmV1IceCategory.CvtRetail]: 'CRet',
    [ExcIceGsmV1IceCategory.CvtLeisure]: 'CRnR',
    [ExcIceGsmV1IceCategory.CvtServices]: 'CSer',
    [ExcIceGsmV1IceCategory.CvtTelecommunications]: 'CTCo',
    [ExcIceGsmV1IceCategory.CvtTechnologyElectronics]: 'CTec',
    [ExcIceGsmV1IceCategory.CvtUtility]: 'CUti',
    [ExcIceGsmV1IceCategory.CoveredBonds]: 'Cvrd',
    [ExcIceGsmV1IceCategory.RevenueEducation]: 'Edu',
    [ExcIceGsmV1IceCategory.Energy]: 'Enrg',
    [ExcIceGsmV1IceCategory.FinancialServices]: 'FinS',
    [ExcIceGsmV1IceCategory.ForeignSovereign]: 'FSov',
    [ExcIceGsmV1IceCategory.GoLocal]: 'Golo',
    [ExcIceGsmV1IceCategory.GoState]: 'Gost',
    [ExcIceGsmV1IceCategory.GovernmentGuaranteed]: 'Guar',
    [ExcIceGsmV1IceCategory.Healthcare]: 'Hcar',
    [ExcIceGsmV1IceCategory.RevenueHealth]: 'Heal',
    [ExcIceGsmV1IceCategory.RevenueHospitals]: 'Hosp',
    [ExcIceGsmV1IceCategory.RevenueIndustrialDevelopmentRevenue]: 'Idr',
    [ExcIceGsmV1IceCategory.Insurance]: 'Insr',
    [ExcIceGsmV1IceCategory.RevenueLeasingCopsAppropriations]: 'Leas',
    [ExcIceGsmV1IceCategory.LocalAuthority]: 'LGvt',
    [ExcIceGsmV1IceCategory.LoanBanking]: 'Lban',
    [ExcIceGsmV1IceCategory.LoanFinancialServices]: 'Lfin',
    [ExcIceGsmV1IceCategory.LoanInsurance]: 'Lins',
    [ExcIceGsmV1IceCategory.LoanAutomotive]: 'Laut',
    [ExcIceGsmV1IceCategory.LoanBasicIndustry]: 'Lbas',
    [ExcIceGsmV1IceCategory.LoanCapitalGoods]: 'Lcap',
    [ExcIceGsmV1IceCategory.LoanConsumerGoods]: 'Lcon',
    [ExcIceGsmV1IceCategory.LoanEnergy]: 'Lenr',
    [ExcIceGsmV1IceCategory.LoanHealthcare]: 'Lhca',
    [ExcIceGsmV1IceCategory.LoanLeisure]: 'Lrnr',
    [ExcIceGsmV1IceCategory.LoanMedia]: 'Lmed',
    [ExcIceGsmV1IceCategory.LoanRealEstate]: 'Lres',
    [ExcIceGsmV1IceCategory.LoanRetail]: 'Lret',
    [ExcIceGsmV1IceCategory.LoanServices]: 'Lser',
    [ExcIceGsmV1IceCategory.LoanTechnologyElectronics]: 'Ltec',
    [ExcIceGsmV1IceCategory.LoanTelecommunications]: 'Ltco',
    [ExcIceGsmV1IceCategory.LoanTransportation]: 'Lmov',
    [ExcIceGsmV1IceCategory.LoanUtility]: 'Luti',
    [ExcIceGsmV1IceCategory.MortgageBacked]: 'MBS',
    [ExcIceGsmV1IceCategory.Media]: 'Medi',
    [ExcIceGsmV1IceCategory.RevenueMultiFamilyHousing]: 'Mhng',
    [ExcIceGsmV1IceCategory.RevenueMisc]: 'Misc',
    [ExcIceGsmV1IceCategory.Transportation]: 'Move',
    [ExcIceGsmV1IceCategory.PfdAutomotive]: 'Paut',
    [ExcIceGsmV1IceCategory.PfdBanking]: 'Pban',
    [ExcIceGsmV1IceCategory.PfdBasicIndustry]: 'Pbas',
    [ExcIceGsmV1IceCategory.PfdCapitalGoods]: 'Pcap',
    [ExcIceGsmV1IceCategory.PfdConsumerGoods]: 'Pcon',
    [ExcIceGsmV1IceCategory.RevenuePollutionControl]: 'Pcr',
    [ExcIceGsmV1IceCategory.PfdEnergy]: 'Penr',
    [ExcIceGsmV1IceCategory.PfdFinancialServices]: 'Pfin',
    [ExcIceGsmV1IceCategory.PfdHealthcare]: 'Phca',
    [ExcIceGsmV1IceCategory.PfdInsurance]: 'Pins',
    [ExcIceGsmV1IceCategory.PfdLeisure]: 'Plei',
    [ExcIceGsmV1IceCategory.PfdMedia]: 'Pmed',
    [ExcIceGsmV1IceCategory.RevenuePower]: 'Powr',
    [ExcIceGsmV1IceCategory.PfdAgency]: 'Pqgv',
    [ExcIceGsmV1IceCategory.PfdRealEstate]: 'Pres',
    [ExcIceGsmV1IceCategory.PfdRetail]: 'Prtl',
    [ExcIceGsmV1IceCategory.PfdServices]: 'Psrv',
    [ExcIceGsmV1IceCategory.PfdTelecommunications]: 'Ptco',
    [ExcIceGsmV1IceCategory.PfdTechnologyElectronics]: 'Ptec',
    [ExcIceGsmV1IceCategory.PfdTransportation]: 'Ptra',
    [ExcIceGsmV1IceCategory.PfdUtility]: 'Puti',
    [ExcIceGsmV1IceCategory.Refunded]: 'Refd',
    [ExcIceGsmV1IceCategory.RealEstate]: 'REst',
    [ExcIceGsmV1IceCategory.Retail]: 'Retl',
    [ExcIceGsmV1IceCategory.Leisure]: 'RnR',
    [ExcIceGsmV1IceCategory.Services]: 'Serv',
    [ExcIceGsmV1IceCategory.RevenueSingleFamilyHousing]: 'Shng',
    [ExcIceGsmV1IceCategory.Sovereign]: 'Sov',
    [ExcIceGsmV1IceCategory.Supranational]: 'Supr',
    [ExcIceGsmV1IceCategory.USTaxableMunicipal]: 'TaxM',
    [ExcIceGsmV1IceCategory.RevenueTax]: 'Taxr',
    [ExcIceGsmV1IceCategory.Telecommunications]: 'TCom',
    [ExcIceGsmV1IceCategory.TechnologyElectronics]: 'Tech',
    [ExcIceGsmV1IceCategory.RevenueTobacco]: 'Tob',
    [ExcIceGsmV1IceCategory.RevenueTollTurnpike]: 'Toll',
    [ExcIceGsmV1IceCategory.RevenueTransportation]: 'Trns',
    [ExcIceGsmV1IceCategory.Utility]: 'Util',
    [ExcIceGsmV1IceCategory.RevenueUtilitiesOther]: 'Utly',
    [ExcIceGsmV1IceCategory.RevenueWaterSewer]: 'Watr'
} as const;

export enum ExcIceGsmV1IceGroup {
    Unspecified = 'UNSPECIFIED',
    CvtFinancial = 'CVT_FINANCIAL',
    CvtIndustrials = 'CVT_INDUSTRIALS',
    Covered = 'COVERED',
    CvtUtility = 'CVT_UTILITY',
    Financial = 'FINANCIAL',
    Go = 'GO',
    Industrials = 'INDUSTRIALS',
    PfdFinancial = 'PFD_FINANCIAL',
    PfdIndustrials = 'PFD_INDUSTRIALS',
    PfdQuasiGovernment = 'PFD_QUASI_GOVERNMENT',
    PfdUtility = 'PFD_UTILITY',
    QuasiForeignGovernment = 'QUASI_FOREIGN_GOVERNMENT',
    Refunded = 'REFUNDED',
    Revenue = 'REVENUE',
    Securitized = 'SECURITIZED',
    Sovereign = 'SOVEREIGN',
    Utility = 'UTILITY',
    LoanFinancial = 'LOAN_FINANCIAL',
    LoanIndustrials = 'LOAN_INDUSTRIALS',
    LoanUtility = 'LOAN_UTILITY'
}

export const EXC_ICE_GSM_V1_ICE_GROUP_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1IceGroup.CvtFinancial]: 'Cvt-Financial',
    [ExcIceGsmV1IceGroup.CvtIndustrials]: 'Cvt-Industrials',
    [ExcIceGsmV1IceGroup.Covered]: 'Covered',
    [ExcIceGsmV1IceGroup.CvtUtility]: 'Cvt-Utility',
    [ExcIceGsmV1IceGroup.Financial]: 'Financial',
    [ExcIceGsmV1IceGroup.Go]: 'GO',
    [ExcIceGsmV1IceGroup.Industrials]: 'Industrials',
    [ExcIceGsmV1IceGroup.PfdFinancial]: 'Pfd-Financial',
    [ExcIceGsmV1IceGroup.PfdIndustrials]: 'Pfd-Industrials',
    [ExcIceGsmV1IceGroup.PfdQuasiGovernment]: 'Pfd-Quasi Government',
    [ExcIceGsmV1IceGroup.PfdUtility]: 'Pfd-Utility',
    [ExcIceGsmV1IceGroup.QuasiForeignGovernment]: 'Quasi & Foreign Government',
    [ExcIceGsmV1IceGroup.Refunded]: 'Refunded',
    [ExcIceGsmV1IceGroup.Revenue]: 'Revenue',
    [ExcIceGsmV1IceGroup.Securitized]: 'Securitized',
    [ExcIceGsmV1IceGroup.Sovereign]: 'Sovereign',
    [ExcIceGsmV1IceGroup.Utility]: 'Utility',
    [ExcIceGsmV1IceGroup.LoanFinancial]: 'Loan-Financial',
    [ExcIceGsmV1IceGroup.LoanIndustrials]: 'Loan-Industrials',
    [ExcIceGsmV1IceGroup.LoanUtility]: 'Loan-Utility'
} as const;

export const EXC_ICE_GSM_V1_ICE_GROUP_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1IceGroup.CvtFinancial]: 'CFNC',
    [ExcIceGsmV1IceGroup.CvtIndustrials]: 'CIND',
    [ExcIceGsmV1IceGroup.Covered]: 'COVR',
    [ExcIceGsmV1IceGroup.CvtUtility]: 'CUTI',
    [ExcIceGsmV1IceGroup.Financial]: 'FNCL',
    [ExcIceGsmV1IceGroup.Go]: 'GO',
    [ExcIceGsmV1IceGroup.Industrials]: 'INDU',
    [ExcIceGsmV1IceGroup.PfdFinancial]: 'PFNC',
    [ExcIceGsmV1IceGroup.PfdIndustrials]: 'PIND',
    [ExcIceGsmV1IceGroup.PfdQuasiGovernment]: 'PQGV',
    [ExcIceGsmV1IceGroup.PfdUtility]: 'PUTI',
    [ExcIceGsmV1IceGroup.QuasiForeignGovernment]: 'QGVT',
    [ExcIceGsmV1IceGroup.Refunded]: 'REFD',
    [ExcIceGsmV1IceGroup.Revenue]: 'REV',
    [ExcIceGsmV1IceGroup.Securitized]: 'SEC',
    [ExcIceGsmV1IceGroup.Sovereign]: 'SOV',
    [ExcIceGsmV1IceGroup.Utility]: 'UTIL',
    [ExcIceGsmV1IceGroup.LoanFinancial]: 'LFNC',
    [ExcIceGsmV1IceGroup.LoanIndustrials]: 'LIND',
    [ExcIceGsmV1IceGroup.LoanUtility]: 'LUTI'
} as const;

export enum ExcIceGsmV1IceSubcategory {
    Unspecified = 'UNSPECIFIED',
    AbsAutomobile = 'ABS_AUTOMOBILE',
    AbsAirlineLeases = 'ABS_AIRLINE_LEASES',
    AbsConsumerLoans = 'ABS_CONSUMER_LOANS',
    AbsEquipmentLeases = 'ABS_EQUIPMENT_LEASES',
    AbsWholeBusinessFranchiseLoans = 'ABS_WHOLE_BUSINESS_FRANCHISE_LOANS',
    AbsStudentLoans = 'ABS_STUDENT_LOANS',
    AbsTimeshares = 'ABS_TIMESHARES',
    AgencyCmbs = 'AGENCY_CMBS',
    NonAgencyCmbs = 'NON_AGENCY_CMBS',
    AbsCreditCards = 'ABS_CREDIT_CARDS',
    AbsHomeEquityLoans = 'ABS_HOME_EQUITY_LOANS',
    AbsManufacturedHousing = 'ABS_MANUFACTURED_HOUSING',
    AbsMiscellaneousAbs = 'ABS_MISCELLANEOUS_ABS',
    AbsUtilities = 'ABS_UTILITIES',
    AerospaceDefense = 'AEROSPACE_DEFENSE',
    Agency = 'AGENCY',
    AirTransportation = 'AIR_TRANSPORTATION',
    RevenueAirport = 'REVENUE_AIRPORT',
    AutoLoans = 'AUTO_LOANS',
    AutoPartsEquipment = 'AUTO_PARTS_EQUIPMENT',
    Automakers = 'AUTOMAKERS',
    Banking = 'BANKING',
    Beverage = 'BEVERAGE',
    BuildingConstruction = 'BUILDING_CONSTRUCTION',
    BuildingMaterials = 'BUILDING_MATERIALS',
    Brokerage = 'BROKERAGE',
    CvtAdvertising = 'CVT_ADVERTISING',
    CvtAerospaceDefense = 'CVT_AEROSPACE_DEFENSE',
    CvtAirTransportation = 'CVT_AIR_TRANSPORTATION',
    CvtAutomakers = 'CVT_AUTOMAKERS',
    CvtAutoLoans = 'CVT_AUTO_LOANS',
    CvtAutoPartsEquipment = 'CVT_AUTO_PARTS_EQUIPMENT',
    CvtBeverage = 'CVT_BEVERAGE',
    CvtBuildingConstruction = 'CVT_BUILDING_CONSTRUCTION',
    CvtBuildingMaterials = 'CVT_BUILDING_MATERIALS',
    CvtBanking = 'CVT_BANKING',
    CvtBrokerage = 'CVT_BROKERAGE',
    CvtConsCommLeaseFinancing = 'CVT_CONS_COMM_LEASE_FINANCING',
    CvtChemicals = 'CVT_CHEMICALS',
    CvtCableSatelliteTv = 'CVT_CABLE_SATELLITE_TV',
    CvtDiversifiedCapitalGoods = 'CVT_DIVERSIFIED_CAPITAL_GOODS',
    CvtDiscountStores = 'CVT_DISCOUNT_STORES',
    CvtDepartmentStores = 'CVT_DEPARTMENT_STORES',
    CvtEnergyExplorationProduction = 'CVT_ENERGY_EXPLORATION_PRODUCTION',
    CvtElectricDistrTrans = 'CVT_ELECTRIC_DISTR_TRANS',
    CvtElectronics = 'CVT_ELECTRONICS',
    CvtElectricGeneration = 'CVT_ELECTRIC_GENERATION',
    CvtElectricIntegrated = 'CVT_ELECTRIC_INTEGRATED',
    CvtNonElectricUtilities = 'CVT_NON_ELECTRIC_UTILITIES',
    CvtIntegratedEnergy = 'CVT_INTEGRATED_ENERGY',
    CvtTheatersEntertainment = 'CVT_THEATERS_ENTERTAINMENT',
    CvtEnvironmental = 'CVT_ENVIRONMENTAL',
    ConsCommLeaseFinancing = 'CONS_COMM_LEASE_FINANCING',
    CvtFoodWholesale = 'CVT_FOOD_WHOLESALE',
    CvtFoodDrugRetailers = 'CVT_FOOD_DRUG_RETAILERS',
    CvtGaming = 'CVT_GAMING',
    Chemicals = 'CHEMICALS',
    CvtHealthFacilities = 'CVT_HEALTH_FACILITIES',
    CvtHotels = 'CVT_HOTELS',
    CvtHousingAssociation = 'CVT_HOUSING_ASSOCIATION',
    CvtHealthServices = 'CVT_HEALTH_SERVICES',
    CvtTechHardwareEquipment = 'CVT_TECH_HARDWARE_EQUIPMENT',
    CvtInsuranceBrokerage = 'CVT_INSURANCE_BROKERAGE',
    CvtMonolineInsurance = 'CVT_MONOLINE_INSURANCE',
    CvtLifeInsurance = 'CVT_LIFE_INSURANCE',
    CvtMultiLineInsurance = 'CVT_MULTI_LINE_INSURANCE',
    CvtPC = 'CVT_P_C',
    CvtReinsurance = 'CVT_REINSURANCE',
    CvtInvestmentsMiscFinancialServices = 'CVT_INVESTMENTS_MISC_FINANCIAL_SERVICES',
    CvtMachinery = 'CVT_MACHINERY',
    CommercialMortgageBacked = 'COMMERCIAL_MORTGAGE_BACKED',
    CvtManagedCare = 'CVT_MANAGED_CARE',
    CvtMediaContent = 'CVT_MEDIA_CONTENT',
    CvtMediaDiversified = 'CVT_MEDIA_DIVERSIFIED',
    CvtMetalsMiningExcludingSteel = 'CVT_METALS_MINING_EXCLUDING_STEEL',
    CmoOther = 'CMO_OTHER',
    CvtMedicalProducts = 'CVT_MEDICAL_PRODUCTS',
    TechHardwareEquipment = 'TECH_HARDWARE_EQUIPMENT',
    PersonalHouseholdProducts = 'PERSONAL_HOUSEHOLD_PRODUCTS',
    CvtOilRefiningMarketing = 'CVT_OIL_REFINING_MARKETING',
    CvtOilFieldEquipmentServices = 'CVT_OIL_FIELD_EQUIPMENT_SERVICES',
    MortgageCoveredBonds = 'MORTGAGE_COVERED_BONDS',
    OtherCoveredBonds = 'OTHER_COVERED_BONDS',
    PublicLoanCoveredBonds = 'PUBLIC_LOAN_COVERED_BONDS',
    CvtPackaging = 'CVT_PACKAGING',
    CvtForestryPaper = 'CVT_FORESTRY_PAPER',
    CvtPharmaceuticals = 'CVT_PHARMACEUTICALS',
    CvtGasDistribution = 'CVT_GAS_DISTRIBUTION',
    CvtPersonalHouseholdProducts = 'CVT_PERSONAL_HOUSEHOLD_PRODUCTS',
    CvtPrintingPublishing = 'CVT_PRINTING_PUBLISHING',
    CvtRail = 'CVT_RAIL',
    CvtRecreationTravel = 'CVT_RECREATION_TRAVEL',
    CvtRealEstateDevMgt = 'CVT_REAL_ESTATE_DEV_MGT',
    CvtReiTs = 'CVT_REI_TS',
    CvtRestaurants = 'CVT_RESTAURANTS',
    CvtSpecialtyRetail = 'CVT_SPECIALTY_RETAIL',
    CvtSteelProducersProducts = 'CVT_STEEL_PRODUCERS_PRODUCTS',
    CvtSupportServices = 'CVT_SUPPORT_SERVICES',
    CvtSoftwareServices = 'CVT_SOFTWARE_SERVICES',
    CvtTelecomWirelineIntegratedServices = 'CVT_TELECOM_WIRELINE_INTEGRATED_SERVICES',
    CvtTobacco = 'CVT_TOBACCO',
    CvtTransportInfrastructureServices = 'CVT_TRANSPORT_INFRASTRUCTURE_SERVICES',
    CvtTruckingDelivery = 'CVT_TRUCKING_DELIVERY',
    CvtTelecomSatellite = 'CVT_TELECOM_SATELLITE',
    CvtTelecomWireless = 'CVT_TELECOM_WIRELESS',
    DiversifiedCapitalGoods = 'DIVERSIFIED_CAPITAL_GOODS',
    DepartmentStores = 'DEPARTMENT_STORES',
    DiscountStores = 'DISCOUNT_STORES',
    RevenueEducation = 'REVENUE_EDUCATION',
    Electronics = 'ELECTRONICS',
    ElectricDistrTrans = 'ELECTRIC_DISTR_TRANS',
    ElectricGeneration = 'ELECTRIC_GENERATION',
    ElectricIntegrated = 'ELECTRIC_INTEGRATED',
    EnergyExplorationProduction = 'ENERGY_EXPLORATION_PRODUCTION',
    IntegratedEnergy = 'INTEGRATED_ENERGY',
    Etm = 'ETM',
    Environmental = 'ENVIRONMENTAL',
    FoodDrugRetailers = 'FOOD_DRUG_RETAILERS',
    ForeignSovereign = 'FOREIGN_SOVEREIGN',
    FoodWholesale = 'FOOD_WHOLESALE',
    Gaming = 'GAMING',
    GasDistribution = 'GAS_DISTRIBUTION',
    GoLocal = 'GO_LOCAL',
    GoState = 'GO_STATE',
    GovernmentGuaranteed = 'GOVERNMENT_GUARANTEED',
    MedicalProducts = 'MEDICAL_PRODUCTS',
    RevenueHealth = 'REVENUE_HEALTH',
    HealthFacilities = 'HEALTH_FACILITIES',
    HealthServices = 'HEALTH_SERVICES',
    RevenueHospitals = 'REVENUE_HOSPITALS',
    Hotels = 'HOTELS',
    HousingAssociation = 'HOUSING_ASSOCIATION',
    RevenueIndustrialDevelopmentRevenue = 'REVENUE_INDUSTRIAL_DEVELOPMENT_REVENUE',
    InsuranceBrokerage = 'INSURANCE_BROKERAGE',
    MonolineInsurance = 'MONOLINE_INSURANCE',
    LifeInsurance = 'LIFE_INSURANCE',
    MultiLineInsurance = 'MULTI_LINE_INSURANCE',
    PC = 'P_C',
    Reinsurance = 'REINSURANCE',
    InvestmentsMiscFinancialServices = 'INVESTMENTS_MISC_FINANCIAL_SERVICES',
    RevenueLeasingCopsAppropriations = 'REVENUE_LEASING_COPS_APPROPRIATIONS',
    RecreationTravel = 'RECREATION_TRAVEL',
    LocalAuthority = 'LOCAL_AUTHORITY',
    LoanBanking = 'LOAN_BANKING',
    LoanBrokerage = 'LOAN_BROKERAGE',
    LoanConsCommLeaseFinancing = 'LOAN_CONS_COMM_LEASE_FINANCING',
    LoanInvestmentsMiscFinancialServices = 'LOAN_INVESTMENTS_MISC_FINANCIAL_SERVICES',
    LoanInsuranceBrokerage = 'LOAN_INSURANCE_BROKERAGE',
    LoanLifeInsurance = 'LOAN_LIFE_INSURANCE',
    LoanMonolineInsurance = 'LOAN_MONOLINE_INSURANCE',
    LoanMultiLineInsurance = 'LOAN_MULTI_LINE_INSURANCE',
    LoanPC = 'LOAN_P_C',
    LoanReinsurance = 'LOAN_REINSURANCE',
    LoanAutoLoans = 'LOAN_AUTO_LOANS',
    LoanAutoPartsEquipment = 'LOAN_AUTO_PARTS_EQUIPMENT',
    LoanAutomakers = 'LOAN_AUTOMAKERS',
    LoanBuildingConstruction = 'LOAN_BUILDING_CONSTRUCTION',
    LoanBuildingMaterials = 'LOAN_BUILDING_MATERIALS',
    LoanChemicals = 'LOAN_CHEMICALS',
    LoanForestryPaper = 'LOAN_FORESTRY_PAPER',
    LoanMetalsMiningExcludingSteel = 'LOAN_METALS_MINING_EXCLUDING_STEEL',
    LoanSteelProducersProducts = 'LOAN_STEEL_PRODUCERS_PRODUCTS',
    LoanAerospaceDefense = 'LOAN_AEROSPACE_DEFENSE',
    LoanDiversifiedCapitalGoods = 'LOAN_DIVERSIFIED_CAPITAL_GOODS',
    LoanMachinery = 'LOAN_MACHINERY',
    LoanPackaging = 'LOAN_PACKAGING',
    LoanBeverage = 'LOAN_BEVERAGE',
    LoanFoodWholesale = 'LOAN_FOOD_WHOLESALE',
    LoanPersonalHouseholdProducts = 'LOAN_PERSONAL_HOUSEHOLD_PRODUCTS',
    LoanTobacco = 'LOAN_TOBACCO',
    LoanEnergyExplorationProduction = 'LOAN_ENERGY_EXPLORATION_PRODUCTION',
    LoanGasDistribution = 'LOAN_GAS_DISTRIBUTION',
    LoanIntegratedEnergy = 'LOAN_INTEGRATED_ENERGY',
    LoanOilFieldEquipmentServices = 'LOAN_OIL_FIELD_EQUIPMENT_SERVICES',
    LoanOilRefiningMarketing = 'LOAN_OIL_REFINING_MARKETING',
    LoanHealthFacilities = 'LOAN_HEALTH_FACILITIES',
    LoanHealthServices = 'LOAN_HEALTH_SERVICES',
    LoanManagedCare = 'LOAN_MANAGED_CARE',
    LoanMedicalProducts = 'LOAN_MEDICAL_PRODUCTS',
    LoanPharmaceuticals = 'LOAN_PHARMACEUTICALS',
    LoanGaming = 'LOAN_GAMING',
    LoanHotels = 'LOAN_HOTELS',
    LoanRecreationTravel = 'LOAN_RECREATION_TRAVEL',
    LoanTheatersEntertainment = 'LOAN_THEATERS_ENTERTAINMENT',
    LoanAdvertising = 'LOAN_ADVERTISING',
    LoanCableSatelliteTv = 'LOAN_CABLE_SATELLITE_TV',
    LoanMediaDiversified = 'LOAN_MEDIA_DIVERSIFIED',
    LoanMediaContent = 'LOAN_MEDIA_CONTENT',
    LoanPrintingPublishing = 'LOAN_PRINTING_PUBLISHING',
    LoanHousingAssociation = 'LOAN_HOUSING_ASSOCIATION',
    LoanRealEstateDevMgt = 'LOAN_REAL_ESTATE_DEV_MGT',
    LoanReiTs = 'LOAN_REI_TS',
    LoanDepartmentStores = 'LOAN_DEPARTMENT_STORES',
    LoanDiscountStores = 'LOAN_DISCOUNT_STORES',
    LoanFoodDrugRetailers = 'LOAN_FOOD_DRUG_RETAILERS',
    LoanRestaurants = 'LOAN_RESTAURANTS',
    LoanSpecialtyRetail = 'LOAN_SPECIALTY_RETAIL',
    LoanEnvironmental = 'LOAN_ENVIRONMENTAL',
    LoanSupportServices = 'LOAN_SUPPORT_SERVICES',
    LoanElectronics = 'LOAN_ELECTRONICS',
    LoanSoftwareServices = 'LOAN_SOFTWARE_SERVICES',
    LoanTechHardwareEquipment = 'LOAN_TECH_HARDWARE_EQUIPMENT',
    LoanTelecomSatellite = 'LOAN_TELECOM_SATELLITE',
    LoanTelecomWireless = 'LOAN_TELECOM_WIRELESS',
    LoanTelecomWirelineIntegratedServices = 'LOAN_TELECOM_WIRELINE_INTEGRATED_SERVICES',
    LoanAirTransportation = 'LOAN_AIR_TRANSPORTATION',
    LoanRail = 'LOAN_RAIL',
    LoanTransportInfrastructureServices = 'LOAN_TRANSPORT_INFRASTRUCTURE_SERVICES',
    LoanTruckingDelivery = 'LOAN_TRUCKING_DELIVERY',
    LoanElectricDistrTrans = 'LOAN_ELECTRIC_DISTR_TRANS',
    LoanElectricGeneration = 'LOAN_ELECTRIC_GENERATION',
    LoanElectricIntegrated = 'LOAN_ELECTRIC_INTEGRATED',
    LoanNonElectricUtilities = 'LOAN_NON_ELECTRIC_UTILITIES',
    Machinery = 'MACHINERY',
    MortgageBacked = 'MORTGAGE_BACKED',
    ManagedCare = 'MANAGED_CARE',
    MediaContent = 'MEDIA_CONTENT',
    CableSatelliteTv = 'CABLE_SATELLITE_TV',
    MediaDiversified = 'MEDIA_DIVERSIFIED',
    Advertising = 'ADVERTISING',
    MetalsMiningExcludingSteel = 'METALS_MINING_EXCLUDING_STEEL',
    RevenueMultiFamilyHousing = 'REVENUE_MULTI_FAMILY_HOUSING',
    RevenueMisc = 'REVENUE_MISC',
    OilFieldEquipmentServices = 'OIL_FIELD_EQUIPMENT_SERVICES',
    OilRefiningMarketing = 'OIL_REFINING_MARKETING',
    Pac = 'PAC',
    Packaging = 'PACKAGING',
    PacZ = 'PAC_Z',
    PfdAdvertising = 'PFD_ADVERTISING',
    PfdAerospaceDefense = 'PFD_AEROSPACE_DEFENSE',
    PfdAgency = 'PFD_AGENCY',
    PfdAirTransportation = 'PFD_AIR_TRANSPORTATION',
    ForestryPaper = 'FORESTRY_PAPER',
    PfdAutomakers = 'PFD_AUTOMAKERS',
    PfdAutoLoans = 'PFD_AUTO_LOANS',
    PfdAutoPartsEquipment = 'PFD_AUTO_PARTS_EQUIPMENT',
    PfdBanking = 'PFD_BANKING',
    PfdBeverage = 'PFD_BEVERAGE',
    PfdBuildingConstruction = 'PFD_BUILDING_CONSTRUCTION',
    PfdBuildingMaterials = 'PFD_BUILDING_MATERIALS',
    PfdBrokerage = 'PFD_BROKERAGE',
    PfdConsCommLeaseFinancing = 'PFD_CONS_COMM_LEASE_FINANCING',
    PfdChemicals = 'PFD_CHEMICALS',
    RevenuePollutionControl = 'REVENUE_POLLUTION_CONTROL',
    PfdCableSatelliteTv = 'PFD_CABLE_SATELLITE_TV',
    PfdDiversifiedCapitalGoods = 'PFD_DIVERSIFIED_CAPITAL_GOODS',
    PfdDiscountStores = 'PFD_DISCOUNT_STORES',
    PfdDepartmentStores = 'PFD_DEPARTMENT_STORES',
    PfdEnergyExplorationProduction = 'PFD_ENERGY_EXPLORATION_PRODUCTION',
    PfdElectricDistrTrans = 'PFD_ELECTRIC_DISTR_TRANS',
    PfdElectronics = 'PFD_ELECTRONICS',
    PfdElectricGeneration = 'PFD_ELECTRIC_GENERATION',
    PfdElectricIntegrated = 'PFD_ELECTRIC_INTEGRATED',
    PfdNonElectricUtilities = 'PFD_NON_ELECTRIC_UTILITIES',
    PfdIntegratedEnergy = 'PFD_INTEGRATED_ENERGY',
    PfdTheatersEntertainment = 'PFD_THEATERS_ENTERTAINMENT',
    PfdEnvironmental = 'PFD_ENVIRONMENTAL',
    PfdFoodWholesale = 'PFD_FOOD_WHOLESALE',
    PfdFoodDrugRetailers = 'PFD_FOOD_DRUG_RETAILERS',
    PfdGaming = 'PFD_GAMING',
    Pharmaceuticals = 'PHARMACEUTICALS',
    PfdHealthFacilities = 'PFD_HEALTH_FACILITIES',
    PfdHotels = 'PFD_HOTELS',
    PfdHousingAssociation = 'PFD_HOUSING_ASSOCIATION',
    PfdHealthServices = 'PFD_HEALTH_SERVICES',
    PfdTechHardwareEquipment = 'PFD_TECH_HARDWARE_EQUIPMENT',
    PfdInsuranceBrokerage = 'PFD_INSURANCE_BROKERAGE',
    PfdMonolineInsurance = 'PFD_MONOLINE_INSURANCE',
    PfdLifeInsurance = 'PFD_LIFE_INSURANCE',
    PfdMultiLineInsurance = 'PFD_MULTI_LINE_INSURANCE',
    PfdPC = 'PFD_P_C',
    PfdReinsurance = 'PFD_REINSURANCE',
    PfdInvestmentsMiscFinancialServices = 'PFD_INVESTMENTS_MISC_FINANCIAL_SERVICES',
    PfdMachinery = 'PFD_MACHINERY',
    PfdManagedCare = 'PFD_MANAGED_CARE',
    PfdMediaContent = 'PFD_MEDIA_CONTENT',
    PfdMediaDiversified = 'PFD_MEDIA_DIVERSIFIED',
    PfdMetalsMiningExcludingSteel = 'PFD_METALS_MINING_EXCLUDING_STEEL',
    PfdMedicalProducts = 'PFD_MEDICAL_PRODUCTS',
    PfdOilRefiningMarketing = 'PFD_OIL_REFINING_MARKETING',
    PfdOilFieldEquipmentServices = 'PFD_OIL_FIELD_EQUIPMENT_SERVICES',
    RevenuePower = 'REVENUE_POWER',
    PfdPackaging = 'PFD_PACKAGING',
    PfdForestryPaper = 'PFD_FORESTRY_PAPER',
    PfdPharmaceuticals = 'PFD_PHARMACEUTICALS',
    PfdGasDistribution = 'PFD_GAS_DISTRIBUTION',
    PfdPersonalHouseholdProducts = 'PFD_PERSONAL_HOUSEHOLD_PRODUCTS',
    PfdPrintingPublishing = 'PFD_PRINTING_PUBLISHING',
    PfdRail = 'PFD_RAIL',
    PfdRecreationTravel = 'PFD_RECREATION_TRAVEL',
    PfdRealEstateDevMgt = 'PFD_REAL_ESTATE_DEV_MGT',
    PreRefunded = 'PRE_REFUNDED',
    PfdReiTs = 'PFD_REI_TS',
    PrintingPublishing = 'PRINTING_PUBLISHING',
    PfdRestaurants = 'PFD_RESTAURANTS',
    PfdSpecialtyRetail = 'PFD_SPECIALTY_RETAIL',
    PfdSteelProducersProducts = 'PFD_STEEL_PRODUCERS_PRODUCTS',
    PfdSupportServices = 'PFD_SUPPORT_SERVICES',
    PfdSoftwareServices = 'PFD_SOFTWARE_SERVICES',
    PfdTelecomWirelineIntegratedServices = 'PFD_TELECOM_WIRELINE_INTEGRATED_SERVICES',
    PfdTobacco = 'PFD_TOBACCO',
    PfdTransportInfrastructureServices = 'PFD_TRANSPORT_INFRASTRUCTURE_SERVICES',
    PfdTruckingDelivery = 'PFD_TRUCKING_DELIVERY',
    PfdTelecomSatellite = 'PFD_TELECOM_SATELLITE',
    PfdTelecomWireless = 'PFD_TELECOM_WIRELESS',
    Rail = 'RAIL',
    RealEstateDevMgt = 'REAL_ESTATE_DEV_MGT',
    ReiTs = 'REI_TS',
    Restaurants = 'RESTAURANTS',
    Sequential = 'SEQUENTIAL',
    SequentialZ = 'SEQUENTIAL_Z',
    RevenueSingleFamilyHousing = 'REVENUE_SINGLE_FAMILY_HOUSING',
    Sovereign = 'SOVEREIGN',
    SpecialtyRetail = 'SPECIALTY_RETAIL',
    SteelProducersProducts = 'STEEL_PRODUCERS_PRODUCTS',
    StructuredIo = 'STRUCTURED_IO',
    StructuredPo = 'STRUCTURED_PO',
    SupportServices = 'SUPPORT_SERVICES',
    Supranational = 'SUPRANATIONAL',
    SupportZ = 'SUPPORT_Z',
    SoftwareServices = 'SOFTWARE_SERVICES',
    TaxableRevenueAirport = 'TAXABLE_REVENUE_AIRPORT',
    RevenueTax = 'REVENUE_TAX',
    TaxableRevenueEducation = 'TAXABLE_REVENUE_EDUCATION',
    TaxableEtm = 'TAXABLE_ETM',
    TaxableGoLocal = 'TAXABLE_GO_LOCAL',
    TaxableGoState = 'TAXABLE_GO_STATE',
    TheatersEntertainment = 'THEATERS_ENTERTAINMENT',
    TaxableRevenueHealth = 'TAXABLE_REVENUE_HEALTH',
    TaxableRevenueHospitals = 'TAXABLE_REVENUE_HOSPITALS',
    TaxableRevenueIndustrialDevelopmentRevenue = 'TAXABLE_REVENUE_INDUSTRIAL_DEVELOPMENT_REVENUE',
    TelecomWirelineIntegratedServices = 'TELECOM_WIRELINE_INTEGRATED_SERVICES',
    TaxableRevenueLeasingCopsAppropriations = 'TAXABLE_REVENUE_LEASING_COPS_APPROPRIATIONS',
    TaxableRevenueMultiFamilyHousing = 'TAXABLE_REVENUE_MULTI_FAMILY_HOUSING',
    TaxableRevenueMisc = 'TAXABLE_REVENUE_MISC',
    RevenueTobacco = 'REVENUE_TOBACCO',
    Tobacco = 'TOBACCO',
    RevenueTollTurnpike = 'REVENUE_TOLL_TURNPIKE',
    TaxableRevenuePollutionControl = 'TAXABLE_REVENUE_POLLUTION_CONTROL',
    TaxableRevenuePower = 'TAXABLE_REVENUE_POWER',
    PreRefunded_2 = 'PRE_REFUNDED_2',
    TransportInfrastructureServices = 'TRANSPORT_INFRASTRUCTURE_SERVICES',
    TrustIo = 'TRUST_IO',
    RevenueTransportation = 'REVENUE_TRANSPORTATION',
    TrustPo = 'TRUST_PO',
    TruckingDelivery = 'TRUCKING_DELIVERY',
    TelecomSatellite = 'TELECOM_SATELLITE',
    TaxableRevenueSingleFamilyHousing = 'TAXABLE_REVENUE_SINGLE_FAMILY_HOUSING',
    TaxableRevenueTax = 'TAXABLE_REVENUE_TAX',
    TaxableRevenueTobacco = 'TAXABLE_REVENUE_TOBACCO',
    TaxableRevenueTollTurnpike = 'TAXABLE_REVENUE_TOLL_TURNPIKE',
    TaxableRevenueTransportation = 'TAXABLE_REVENUE_TRANSPORTATION',
    TaxableRevenueUtilitiesOther = 'TAXABLE_REVENUE_UTILITIES_OTHER',
    TelecomWireless = 'TELECOM_WIRELESS',
    TaxableRevenueWaterSewer = 'TAXABLE_REVENUE_WATER_SEWER',
    NonElectricUtilities = 'NON_ELECTRIC_UTILITIES',
    RevenueUtilitiesOther = 'REVENUE_UTILITIES_OTHER',
    RevenueWaterSewer = 'REVENUE_WATER_SEWER'
}

export const EXC_ICE_GSM_V1_ICE_SUBCATEGORY_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1IceSubcategory.AbsAutomobile]: 'ABS Automobile',
    [ExcIceGsmV1IceSubcategory.AbsAirlineLeases]: 'ABS Airline Leases',
    [ExcIceGsmV1IceSubcategory.AbsConsumerLoans]: 'ABS Consumer Loans',
    [ExcIceGsmV1IceSubcategory.AbsEquipmentLeases]: 'ABS Equipment Leases',
    [ExcIceGsmV1IceSubcategory.AbsWholeBusinessFranchiseLoans]: 'ABS Whole Business & Franchise Loans',
    [ExcIceGsmV1IceSubcategory.AbsStudentLoans]: 'ABS Student Loans',
    [ExcIceGsmV1IceSubcategory.AbsTimeshares]: 'ABS Timeshares',
    [ExcIceGsmV1IceSubcategory.AgencyCmbs]: 'Agency CMBS',
    [ExcIceGsmV1IceSubcategory.NonAgencyCmbs]: 'Non-Agency CMBS',
    [ExcIceGsmV1IceSubcategory.AbsCreditCards]: 'ABS Credit Cards',
    [ExcIceGsmV1IceSubcategory.AbsHomeEquityLoans]: 'ABS Home Equity Loans',
    [ExcIceGsmV1IceSubcategory.AbsManufacturedHousing]: 'ABS Manufactured Housing',
    [ExcIceGsmV1IceSubcategory.AbsMiscellaneousAbs]: 'ABS Miscellaneous ABS',
    [ExcIceGsmV1IceSubcategory.AbsUtilities]: 'ABS Utilities',
    [ExcIceGsmV1IceSubcategory.AerospaceDefense]: 'Aerospace/Defense',
    [ExcIceGsmV1IceSubcategory.Agency]: 'Agency',
    [ExcIceGsmV1IceSubcategory.AirTransportation]: 'Air Transportation',
    [ExcIceGsmV1IceSubcategory.RevenueAirport]: 'Revenue - Airport',
    [ExcIceGsmV1IceSubcategory.AutoLoans]: 'Auto Loans',
    [ExcIceGsmV1IceSubcategory.AutoPartsEquipment]: 'Auto Parts & Equipment',
    [ExcIceGsmV1IceSubcategory.Automakers]: 'Automakers',
    [ExcIceGsmV1IceSubcategory.Banking]: 'Banking',
    [ExcIceGsmV1IceSubcategory.Beverage]: 'Beverage',
    [ExcIceGsmV1IceSubcategory.BuildingConstruction]: 'Building & Construction',
    [ExcIceGsmV1IceSubcategory.BuildingMaterials]: 'Building Materials',
    [ExcIceGsmV1IceSubcategory.Brokerage]: 'Brokerage',
    [ExcIceGsmV1IceSubcategory.CvtAdvertising]: 'Cvt-Advertising',
    [ExcIceGsmV1IceSubcategory.CvtAerospaceDefense]: 'Cvt-Aerospace/Defense',
    [ExcIceGsmV1IceSubcategory.CvtAirTransportation]: 'Cvt-Air Transportation',
    [ExcIceGsmV1IceSubcategory.CvtAutomakers]: 'Cvt-Automakers',
    [ExcIceGsmV1IceSubcategory.CvtAutoLoans]: 'Cvt-Auto Loans',
    [ExcIceGsmV1IceSubcategory.CvtAutoPartsEquipment]: 'Cvt-Auto Parts & Equipment',
    [ExcIceGsmV1IceSubcategory.CvtBeverage]: 'Cvt-Beverage',
    [ExcIceGsmV1IceSubcategory.CvtBuildingConstruction]: 'Cvt-Building & Construction',
    [ExcIceGsmV1IceSubcategory.CvtBuildingMaterials]: 'Cvt-Building Materials',
    [ExcIceGsmV1IceSubcategory.CvtBanking]: 'Cvt-Banking',
    [ExcIceGsmV1IceSubcategory.CvtBrokerage]: 'Cvt-Brokerage',
    [ExcIceGsmV1IceSubcategory.CvtConsCommLeaseFinancing]: 'Cvt-Cons/Comm/Lease Financing',
    [ExcIceGsmV1IceSubcategory.CvtChemicals]: 'Cvt-Chemicals',
    [ExcIceGsmV1IceSubcategory.CvtCableSatelliteTv]: 'Cvt-Cable & Satellite TV',
    [ExcIceGsmV1IceSubcategory.CvtDiversifiedCapitalGoods]: 'Cvt-Diversified Capital Goods',
    [ExcIceGsmV1IceSubcategory.CvtDiscountStores]: 'Cvt-Discount Stores',
    [ExcIceGsmV1IceSubcategory.CvtDepartmentStores]: 'Cvt-Department Stores',
    [ExcIceGsmV1IceSubcategory.CvtEnergyExplorationProduction]: 'Cvt-Energy - Exploration & Production',
    [ExcIceGsmV1IceSubcategory.CvtElectricDistrTrans]: 'Cvt-Electric-Distr/Trans',
    [ExcIceGsmV1IceSubcategory.CvtElectronics]: 'Cvt-Electronics',
    [ExcIceGsmV1IceSubcategory.CvtElectricGeneration]: 'Cvt-Electric-Generation',
    [ExcIceGsmV1IceSubcategory.CvtElectricIntegrated]: 'Cvt-Electric-Integrated',
    [ExcIceGsmV1IceSubcategory.CvtNonElectricUtilities]: 'Cvt-Non-Electric Utilities',
    [ExcIceGsmV1IceSubcategory.CvtIntegratedEnergy]: 'Cvt-Integrated Energy',
    [ExcIceGsmV1IceSubcategory.CvtTheatersEntertainment]: 'Cvt-Theaters & Entertainment',
    [ExcIceGsmV1IceSubcategory.CvtEnvironmental]: 'Cvt-Environmental',
    [ExcIceGsmV1IceSubcategory.ConsCommLeaseFinancing]: 'Cons/Comm/Lease Financing',
    [ExcIceGsmV1IceSubcategory.CvtFoodWholesale]: 'Cvt-Food - Wholesale',
    [ExcIceGsmV1IceSubcategory.CvtFoodDrugRetailers]: 'Cvt-Food & Drug Retailers',
    [ExcIceGsmV1IceSubcategory.CvtGaming]: 'Cvt-Gaming',
    [ExcIceGsmV1IceSubcategory.Chemicals]: 'Chemicals',
    [ExcIceGsmV1IceSubcategory.CvtHealthFacilities]: 'Cvt-Health Facilities',
    [ExcIceGsmV1IceSubcategory.CvtHotels]: 'Cvt-Hotels',
    [ExcIceGsmV1IceSubcategory.CvtHousingAssociation]: 'Cvt-Housing Association',
    [ExcIceGsmV1IceSubcategory.CvtHealthServices]: 'Cvt-Health Services',
    [ExcIceGsmV1IceSubcategory.CvtTechHardwareEquipment]: 'Cvt-Tech Hardware & Equipment',
    [ExcIceGsmV1IceSubcategory.CvtInsuranceBrokerage]: 'Cvt-Insurance Brokerage',
    [ExcIceGsmV1IceSubcategory.CvtMonolineInsurance]: 'Cvt-Monoline Insurance',
    [ExcIceGsmV1IceSubcategory.CvtLifeInsurance]: 'Cvt-Life Insurance',
    [ExcIceGsmV1IceSubcategory.CvtMultiLineInsurance]: 'Cvt-Multi-Line Insurance',
    [ExcIceGsmV1IceSubcategory.CvtPC]: 'Cvt-P&C',
    [ExcIceGsmV1IceSubcategory.CvtReinsurance]: 'Cvt-Reinsurance',
    [ExcIceGsmV1IceSubcategory.CvtInvestmentsMiscFinancialServices]: 'Cvt-Investments & Misc Financial Services',
    [ExcIceGsmV1IceSubcategory.CvtMachinery]: 'Cvt-Machinery',
    [ExcIceGsmV1IceSubcategory.CommercialMortgageBacked]: 'Commercial Mortgage Backed',
    [ExcIceGsmV1IceSubcategory.CvtManagedCare]: 'Cvt-Managed Care',
    [ExcIceGsmV1IceSubcategory.CvtMediaContent]: 'Cvt-Media Content',
    [ExcIceGsmV1IceSubcategory.CvtMediaDiversified]: 'Cvt-Media - Diversified',
    [ExcIceGsmV1IceSubcategory.CvtMetalsMiningExcludingSteel]: 'Cvt-Metals/Mining Excluding Steel',
    [ExcIceGsmV1IceSubcategory.CmoOther]: 'CMO Other',
    [ExcIceGsmV1IceSubcategory.CvtMedicalProducts]: 'Cvt-Medical Products',
    [ExcIceGsmV1IceSubcategory.TechHardwareEquipment]: 'Tech Hardware & Equipment',
    [ExcIceGsmV1IceSubcategory.PersonalHouseholdProducts]: 'Personal & Household Products',
    [ExcIceGsmV1IceSubcategory.CvtOilRefiningMarketing]: 'Cvt-Oil Refining & Marketing',
    [ExcIceGsmV1IceSubcategory.CvtOilFieldEquipmentServices]: 'Cvt-Oil Field Equipment & Services',
    [ExcIceGsmV1IceSubcategory.MortgageCoveredBonds]: 'Mortgage Covered Bonds',
    [ExcIceGsmV1IceSubcategory.OtherCoveredBonds]: 'Other Covered Bonds',
    [ExcIceGsmV1IceSubcategory.PublicLoanCoveredBonds]: 'Public Loan Covered Bonds',
    [ExcIceGsmV1IceSubcategory.CvtPackaging]: 'Cvt-Packaging',
    [ExcIceGsmV1IceSubcategory.CvtForestryPaper]: 'Cvt-Forestry/Paper',
    [ExcIceGsmV1IceSubcategory.CvtPharmaceuticals]: 'Cvt-Pharmaceuticals',
    [ExcIceGsmV1IceSubcategory.CvtGasDistribution]: 'Cvt-Gas Distribution',
    [ExcIceGsmV1IceSubcategory.CvtPersonalHouseholdProducts]: 'Cvt-Personal & Household Products',
    [ExcIceGsmV1IceSubcategory.CvtPrintingPublishing]: 'Cvt-Printing & Publishing',
    [ExcIceGsmV1IceSubcategory.CvtRail]: 'Cvt-Rail',
    [ExcIceGsmV1IceSubcategory.CvtRecreationTravel]: 'Cvt-Recreation & Travel',
    [ExcIceGsmV1IceSubcategory.CvtRealEstateDevMgt]: 'Cvt-RealEstate Dev & Mgt',
    [ExcIceGsmV1IceSubcategory.CvtReiTs]: 'Cvt-REITs',
    [ExcIceGsmV1IceSubcategory.CvtRestaurants]: 'Cvt-Restaurants',
    [ExcIceGsmV1IceSubcategory.CvtSpecialtyRetail]: 'Cvt-Specialty Retail',
    [ExcIceGsmV1IceSubcategory.CvtSteelProducersProducts]: 'Cvt-Steel Producers/Products',
    [ExcIceGsmV1IceSubcategory.CvtSupportServices]: 'Cvt-Support-Services',
    [ExcIceGsmV1IceSubcategory.CvtSoftwareServices]: 'Cvt-Software/Services',
    [ExcIceGsmV1IceSubcategory.CvtTelecomWirelineIntegratedServices]: 'Cvt-Telecom - Wireline Integrated & Services',
    [ExcIceGsmV1IceSubcategory.CvtTobacco]: 'Cvt-Tobacco',
    [ExcIceGsmV1IceSubcategory.CvtTransportInfrastructureServices]: 'Cvt-Transport Infrastructure/Services',
    [ExcIceGsmV1IceSubcategory.CvtTruckingDelivery]: 'Cvt-Trucking & Delivery',
    [ExcIceGsmV1IceSubcategory.CvtTelecomSatellite]: 'Cvt-Telecom - Satellite',
    [ExcIceGsmV1IceSubcategory.CvtTelecomWireless]: 'Cvt-Telecom - Wireless',
    [ExcIceGsmV1IceSubcategory.DiversifiedCapitalGoods]: 'Diversified Capital Goods',
    [ExcIceGsmV1IceSubcategory.DepartmentStores]: 'Department Stores',
    [ExcIceGsmV1IceSubcategory.DiscountStores]: 'Discount Stores',
    [ExcIceGsmV1IceSubcategory.RevenueEducation]: 'Revenue - Education',
    [ExcIceGsmV1IceSubcategory.Electronics]: 'Electronics',
    [ExcIceGsmV1IceSubcategory.ElectricDistrTrans]: 'Electric-Distr/Trans',
    [ExcIceGsmV1IceSubcategory.ElectricGeneration]: 'Electric-Generation',
    [ExcIceGsmV1IceSubcategory.ElectricIntegrated]: 'Electric-Integrated',
    [ExcIceGsmV1IceSubcategory.EnergyExplorationProduction]: 'Energy - Exploration & Production',
    [ExcIceGsmV1IceSubcategory.IntegratedEnergy]: 'Integrated Energy',
    [ExcIceGsmV1IceSubcategory.Etm]: 'ETM',
    [ExcIceGsmV1IceSubcategory.Environmental]: 'Environmental',
    [ExcIceGsmV1IceSubcategory.FoodDrugRetailers]: 'Food & Drug Retailers',
    [ExcIceGsmV1IceSubcategory.ForeignSovereign]: 'Foreign Sovereign',
    [ExcIceGsmV1IceSubcategory.FoodWholesale]: 'Food - Wholesale',
    [ExcIceGsmV1IceSubcategory.Gaming]: 'Gaming',
    [ExcIceGsmV1IceSubcategory.GasDistribution]: 'Gas Distribution',
    [ExcIceGsmV1IceSubcategory.GoLocal]: 'GO - Local',
    [ExcIceGsmV1IceSubcategory.GoState]: 'GO - State',
    [ExcIceGsmV1IceSubcategory.GovernmentGuaranteed]: 'Government Guaranteed',
    [ExcIceGsmV1IceSubcategory.MedicalProducts]: 'Medical Products',
    [ExcIceGsmV1IceSubcategory.RevenueHealth]: 'Revenue - Health',
    [ExcIceGsmV1IceSubcategory.HealthFacilities]: 'Health Facilities',
    [ExcIceGsmV1IceSubcategory.HealthServices]: 'Health Services',
    [ExcIceGsmV1IceSubcategory.RevenueHospitals]: 'Revenue - Hospitals',
    [ExcIceGsmV1IceSubcategory.Hotels]: 'Hotels',
    [ExcIceGsmV1IceSubcategory.HousingAssociation]: 'Housing Association',
    [ExcIceGsmV1IceSubcategory.RevenueIndustrialDevelopmentRevenue]: 'Revenue - Industrial Development Revenue',
    [ExcIceGsmV1IceSubcategory.InsuranceBrokerage]: 'Insurance Brokerage',
    [ExcIceGsmV1IceSubcategory.MonolineInsurance]: 'Monoline Insurance',
    [ExcIceGsmV1IceSubcategory.LifeInsurance]: 'Life Insurance',
    [ExcIceGsmV1IceSubcategory.MultiLineInsurance]: 'Multi-Line Insurance',
    [ExcIceGsmV1IceSubcategory.PC]: 'P&C',
    [ExcIceGsmV1IceSubcategory.Reinsurance]: 'Reinsurance',
    [ExcIceGsmV1IceSubcategory.InvestmentsMiscFinancialServices]: 'Investments & Misc Financial Services',
    [ExcIceGsmV1IceSubcategory.RevenueLeasingCopsAppropriations]: 'Revenue - Leasing COPS & Appropriations',
    [ExcIceGsmV1IceSubcategory.RecreationTravel]: 'Recreation & Travel',
    [ExcIceGsmV1IceSubcategory.LocalAuthority]: 'Local-Authority',
    [ExcIceGsmV1IceSubcategory.LoanBanking]: 'Loan-Banking',
    [ExcIceGsmV1IceSubcategory.LoanBrokerage]: 'Loan-Brokerage',
    [ExcIceGsmV1IceSubcategory.LoanConsCommLeaseFinancing]: 'Loan-Cons/Comm/LeaseFinancing',
    [ExcIceGsmV1IceSubcategory.LoanInvestmentsMiscFinancialServices]: 'Loan-Investments&MiscFinancialServices',
    [ExcIceGsmV1IceSubcategory.LoanInsuranceBrokerage]: 'Loan-InsuranceBrokerage',
    [ExcIceGsmV1IceSubcategory.LoanLifeInsurance]: 'Loan-LifeInsurance',
    [ExcIceGsmV1IceSubcategory.LoanMonolineInsurance]: 'Loan-MonolineInsurance',
    [ExcIceGsmV1IceSubcategory.LoanMultiLineInsurance]: 'Loan-Multi-LineInsurance',
    [ExcIceGsmV1IceSubcategory.LoanPC]: 'Loan-P&C',
    [ExcIceGsmV1IceSubcategory.LoanReinsurance]: 'Loan-Reinsurance',
    [ExcIceGsmV1IceSubcategory.LoanAutoLoans]: 'Loan-AutoLoans',
    [ExcIceGsmV1IceSubcategory.LoanAutoPartsEquipment]: 'Loan-AutoParts&Equipment',
    [ExcIceGsmV1IceSubcategory.LoanAutomakers]: 'Loan-Automakers',
    [ExcIceGsmV1IceSubcategory.LoanBuildingConstruction]: 'Loan-Building&Construction',
    [ExcIceGsmV1IceSubcategory.LoanBuildingMaterials]: 'Loan-BuildingMaterials',
    [ExcIceGsmV1IceSubcategory.LoanChemicals]: 'Loan-Chemicals',
    [ExcIceGsmV1IceSubcategory.LoanForestryPaper]: 'Loan-Forestry/Paper',
    [ExcIceGsmV1IceSubcategory.LoanMetalsMiningExcludingSteel]: 'Loan-Metals/MiningExcludingSteel',
    [ExcIceGsmV1IceSubcategory.LoanSteelProducersProducts]: 'Loan-SteelProducers/Products',
    [ExcIceGsmV1IceSubcategory.LoanAerospaceDefense]: 'Loan-Aerospace/Defense',
    [ExcIceGsmV1IceSubcategory.LoanDiversifiedCapitalGoods]: 'Loan-DiversifiedCapitalGoods',
    [ExcIceGsmV1IceSubcategory.LoanMachinery]: 'Loan-Machinery',
    [ExcIceGsmV1IceSubcategory.LoanPackaging]: 'Loan-Packaging',
    [ExcIceGsmV1IceSubcategory.LoanBeverage]: 'Loan-Beverage',
    [ExcIceGsmV1IceSubcategory.LoanFoodWholesale]: 'Loan-Food-Wholesale',
    [ExcIceGsmV1IceSubcategory.LoanPersonalHouseholdProducts]: 'Loan-Personal&HouseholdProducts',
    [ExcIceGsmV1IceSubcategory.LoanTobacco]: 'Loan-Tobacco',
    [ExcIceGsmV1IceSubcategory.LoanEnergyExplorationProduction]: 'Loan-Energy-Exploration&Production',
    [ExcIceGsmV1IceSubcategory.LoanGasDistribution]: 'Loan-GasDistribution',
    [ExcIceGsmV1IceSubcategory.LoanIntegratedEnergy]: 'Loan-IntegratedEnergy',
    [ExcIceGsmV1IceSubcategory.LoanOilFieldEquipmentServices]: 'Loan-OilFieldEquipment&Services',
    [ExcIceGsmV1IceSubcategory.LoanOilRefiningMarketing]: 'Loan-OilRefining&Marketing',
    [ExcIceGsmV1IceSubcategory.LoanHealthFacilities]: 'Loan-HealthFacilities',
    [ExcIceGsmV1IceSubcategory.LoanHealthServices]: 'Loan-HealthServices',
    [ExcIceGsmV1IceSubcategory.LoanManagedCare]: 'Loan-ManagedCare',
    [ExcIceGsmV1IceSubcategory.LoanMedicalProducts]: 'Loan-MedicalProducts',
    [ExcIceGsmV1IceSubcategory.LoanPharmaceuticals]: 'Loan-Pharmaceuticals',
    [ExcIceGsmV1IceSubcategory.LoanGaming]: 'Loan-Gaming',
    [ExcIceGsmV1IceSubcategory.LoanHotels]: 'Loan-Hotels',
    [ExcIceGsmV1IceSubcategory.LoanRecreationTravel]: 'Loan-Recreation&Travel',
    [ExcIceGsmV1IceSubcategory.LoanTheatersEntertainment]: 'Loan-Theaters&Entertainment',
    [ExcIceGsmV1IceSubcategory.LoanAdvertising]: 'Loan-Advertising',
    [ExcIceGsmV1IceSubcategory.LoanCableSatelliteTv]: 'Loan-Cable&SatelliteTV',
    [ExcIceGsmV1IceSubcategory.LoanMediaDiversified]: 'Loan-Media-Diversified',
    [ExcIceGsmV1IceSubcategory.LoanMediaContent]: 'Loan-MediaContent',
    [ExcIceGsmV1IceSubcategory.LoanPrintingPublishing]: 'Loan-Printing&Publishing',
    [ExcIceGsmV1IceSubcategory.LoanHousingAssociation]: 'Loan-HousingAssociation',
    [ExcIceGsmV1IceSubcategory.LoanRealEstateDevMgt]: 'Loan-RealEstateDev&Mgt',
    [ExcIceGsmV1IceSubcategory.LoanReiTs]: 'Loan-REITs',
    [ExcIceGsmV1IceSubcategory.LoanDepartmentStores]: 'Loan-DepartmentStores',
    [ExcIceGsmV1IceSubcategory.LoanDiscountStores]: 'Loan-DiscountStores',
    [ExcIceGsmV1IceSubcategory.LoanFoodDrugRetailers]: 'Loan-Food&DrugRetailers',
    [ExcIceGsmV1IceSubcategory.LoanRestaurants]: 'Loan-Restaurants',
    [ExcIceGsmV1IceSubcategory.LoanSpecialtyRetail]: 'Loan-SpecialtyRetail',
    [ExcIceGsmV1IceSubcategory.LoanEnvironmental]: 'Loan-Environmental',
    [ExcIceGsmV1IceSubcategory.LoanSupportServices]: 'Loan-Support-Services',
    [ExcIceGsmV1IceSubcategory.LoanElectronics]: 'Loan-Electronics',
    [ExcIceGsmV1IceSubcategory.LoanSoftwareServices]: 'Loan-Software/Services',
    [ExcIceGsmV1IceSubcategory.LoanTechHardwareEquipment]: 'Loan-TechHardware&Equipment',
    [ExcIceGsmV1IceSubcategory.LoanTelecomSatellite]: 'Loan-Telecom-Satellite',
    [ExcIceGsmV1IceSubcategory.LoanTelecomWireless]: 'Loan-Telecom-Wireless',
    [ExcIceGsmV1IceSubcategory.LoanTelecomWirelineIntegratedServices]: 'Loan-Telecom-WirelineIntegrated&Services',
    [ExcIceGsmV1IceSubcategory.LoanAirTransportation]: 'Loan-AirTransportation',
    [ExcIceGsmV1IceSubcategory.LoanRail]: 'Loan-Rail',
    [ExcIceGsmV1IceSubcategory.LoanTransportInfrastructureServices]: 'Loan-TransportInfrastructure/Services',
    [ExcIceGsmV1IceSubcategory.LoanTruckingDelivery]: 'Loan-Trucking&Delivery',
    [ExcIceGsmV1IceSubcategory.LoanElectricDistrTrans]: 'Loan-Electric-Distr/Trans',
    [ExcIceGsmV1IceSubcategory.LoanElectricGeneration]: 'Loan-Electric-Generation',
    [ExcIceGsmV1IceSubcategory.LoanElectricIntegrated]: 'Loan-Electric-Integrated',
    [ExcIceGsmV1IceSubcategory.LoanNonElectricUtilities]: 'Loan-Non-ElectricUtilities',
    [ExcIceGsmV1IceSubcategory.Machinery]: 'Machinery',
    [ExcIceGsmV1IceSubcategory.MortgageBacked]: 'Mortgage Backed',
    [ExcIceGsmV1IceSubcategory.ManagedCare]: 'Managed Care',
    [ExcIceGsmV1IceSubcategory.MediaContent]: 'Media Content',
    [ExcIceGsmV1IceSubcategory.CableSatelliteTv]: 'Cable & Satellite TV',
    [ExcIceGsmV1IceSubcategory.MediaDiversified]: 'Media - Diversified',
    [ExcIceGsmV1IceSubcategory.Advertising]: 'Advertising',
    [ExcIceGsmV1IceSubcategory.MetalsMiningExcludingSteel]: 'Metals/Mining Excluding Steel',
    [ExcIceGsmV1IceSubcategory.RevenueMultiFamilyHousing]: 'Revenue - Multi-Family Housing',
    [ExcIceGsmV1IceSubcategory.RevenueMisc]: 'Revenue - Misc',
    [ExcIceGsmV1IceSubcategory.OilFieldEquipmentServices]: 'Oil Field Equipment & Services',
    [ExcIceGsmV1IceSubcategory.OilRefiningMarketing]: 'Oil Refining & Marketing',
    [ExcIceGsmV1IceSubcategory.Pac]: 'PAC',
    [ExcIceGsmV1IceSubcategory.Packaging]: 'Packaging',
    [ExcIceGsmV1IceSubcategory.PacZ]: 'PAC Z',
    [ExcIceGsmV1IceSubcategory.PfdAdvertising]: 'Pfd-Advertising',
    [ExcIceGsmV1IceSubcategory.PfdAerospaceDefense]: 'Pfd-Aerospace/Defense',
    [ExcIceGsmV1IceSubcategory.PfdAgency]: 'Pfd-Agency',
    [ExcIceGsmV1IceSubcategory.PfdAirTransportation]: 'Pfd-Air Transportation',
    [ExcIceGsmV1IceSubcategory.ForestryPaper]: 'Forestry/Paper',
    [ExcIceGsmV1IceSubcategory.PfdAutomakers]: 'Pfd-Automakers',
    [ExcIceGsmV1IceSubcategory.PfdAutoLoans]: 'Pfd-Auto Loans',
    [ExcIceGsmV1IceSubcategory.PfdAutoPartsEquipment]: 'Pfd-Auto Parts & Equipment',
    [ExcIceGsmV1IceSubcategory.PfdBanking]: 'Pfd-Banking',
    [ExcIceGsmV1IceSubcategory.PfdBeverage]: 'Pfd-Beverage',
    [ExcIceGsmV1IceSubcategory.PfdBuildingConstruction]: 'Pfd-Building & Construction',
    [ExcIceGsmV1IceSubcategory.PfdBuildingMaterials]: 'Pfd-Building Materials',
    [ExcIceGsmV1IceSubcategory.PfdBrokerage]: 'Pfd-Brokerage',
    [ExcIceGsmV1IceSubcategory.PfdConsCommLeaseFinancing]: 'Pfd-Cons/Comm/Lease Financing',
    [ExcIceGsmV1IceSubcategory.PfdChemicals]: 'Pfd-Chemicals',
    [ExcIceGsmV1IceSubcategory.RevenuePollutionControl]: 'Revenue - Pollution Control',
    [ExcIceGsmV1IceSubcategory.PfdCableSatelliteTv]: 'Pfd-Cable & Satellite TV',
    [ExcIceGsmV1IceSubcategory.PfdDiversifiedCapitalGoods]: 'Pfd-Diversified Capital Goods',
    [ExcIceGsmV1IceSubcategory.PfdDiscountStores]: 'Pfd-Discount Stores',
    [ExcIceGsmV1IceSubcategory.PfdDepartmentStores]: 'Pfd-Department Stores',
    [ExcIceGsmV1IceSubcategory.PfdEnergyExplorationProduction]: 'Pfd-Energy - Exploration & Production',
    [ExcIceGsmV1IceSubcategory.PfdElectricDistrTrans]: 'Pfd-Electric-Distr/Trans',
    [ExcIceGsmV1IceSubcategory.PfdElectronics]: 'Pfd-Electronics',
    [ExcIceGsmV1IceSubcategory.PfdElectricGeneration]: 'Pfd-Electric-Generation',
    [ExcIceGsmV1IceSubcategory.PfdElectricIntegrated]: 'Pfd-Electric-Integrated',
    [ExcIceGsmV1IceSubcategory.PfdNonElectricUtilities]: 'Pfd-Non-Electric Utilities',
    [ExcIceGsmV1IceSubcategory.PfdIntegratedEnergy]: 'Pfd-Integrated Energy',
    [ExcIceGsmV1IceSubcategory.PfdTheatersEntertainment]: 'Pfd-Theaters & Entertainment',
    [ExcIceGsmV1IceSubcategory.PfdEnvironmental]: 'Pfd-Environmental',
    [ExcIceGsmV1IceSubcategory.PfdFoodWholesale]: 'Pfd-Food - Wholesale',
    [ExcIceGsmV1IceSubcategory.PfdFoodDrugRetailers]: 'Pfd-Food & Drug Retailers',
    [ExcIceGsmV1IceSubcategory.PfdGaming]: 'Pfd-Gaming',
    [ExcIceGsmV1IceSubcategory.Pharmaceuticals]: 'Pharmaceuticals',
    [ExcIceGsmV1IceSubcategory.PfdHealthFacilities]: 'Pfd-Health Facilities',
    [ExcIceGsmV1IceSubcategory.PfdHotels]: 'Pfd-Hotels',
    [ExcIceGsmV1IceSubcategory.PfdHousingAssociation]: 'Pfd-Housing Association',
    [ExcIceGsmV1IceSubcategory.PfdHealthServices]: 'Pfd-Health Services',
    [ExcIceGsmV1IceSubcategory.PfdTechHardwareEquipment]: 'Pfd-Tech Hardware & Equipment',
    [ExcIceGsmV1IceSubcategory.PfdInsuranceBrokerage]: 'Pfd-Insurance Brokerage',
    [ExcIceGsmV1IceSubcategory.PfdMonolineInsurance]: 'Pfd-Monoline Insurance',
    [ExcIceGsmV1IceSubcategory.PfdLifeInsurance]: 'Pfd-Life Insurance',
    [ExcIceGsmV1IceSubcategory.PfdMultiLineInsurance]: 'Pfd-Multi-Line Insurance',
    [ExcIceGsmV1IceSubcategory.PfdPC]: 'Pfd-P&C',
    [ExcIceGsmV1IceSubcategory.PfdReinsurance]: 'Pfd-Reinsurance',
    [ExcIceGsmV1IceSubcategory.PfdInvestmentsMiscFinancialServices]: 'Pfd-Investments & Misc Financial Services',
    [ExcIceGsmV1IceSubcategory.PfdMachinery]: 'Pfd-Machinery',
    [ExcIceGsmV1IceSubcategory.PfdManagedCare]: 'Pfd-Managed Care',
    [ExcIceGsmV1IceSubcategory.PfdMediaContent]: 'Pfd-Media Content',
    [ExcIceGsmV1IceSubcategory.PfdMediaDiversified]: 'Pfd-Media - Diversified',
    [ExcIceGsmV1IceSubcategory.PfdMetalsMiningExcludingSteel]: 'Pfd-Metals/Mining Excluding Steel',
    [ExcIceGsmV1IceSubcategory.PfdMedicalProducts]: 'Pfd-Medical Products',
    [ExcIceGsmV1IceSubcategory.PfdOilRefiningMarketing]: 'Pfd-Oil Refining & Marketing',
    [ExcIceGsmV1IceSubcategory.PfdOilFieldEquipmentServices]: 'Pfd-Oil Field Equipment & Services',
    [ExcIceGsmV1IceSubcategory.RevenuePower]: 'Revenue - Power',
    [ExcIceGsmV1IceSubcategory.PfdPackaging]: 'Pfd-Packaging',
    [ExcIceGsmV1IceSubcategory.PfdForestryPaper]: 'Pfd-Forestry/Paper',
    [ExcIceGsmV1IceSubcategory.PfdPharmaceuticals]: 'Pfd-Pharmaceuticals',
    [ExcIceGsmV1IceSubcategory.PfdGasDistribution]: 'Pfd-Gas Distribution',
    [ExcIceGsmV1IceSubcategory.PfdPersonalHouseholdProducts]: 'Pfd-Personal & Household Products',
    [ExcIceGsmV1IceSubcategory.PfdPrintingPublishing]: 'Pfd-Printing & Publishing',
    [ExcIceGsmV1IceSubcategory.PfdRail]: 'Pfd-Rail',
    [ExcIceGsmV1IceSubcategory.PfdRecreationTravel]: 'Pfd-Recreation & Travel',
    [ExcIceGsmV1IceSubcategory.PfdRealEstateDevMgt]: 'Pfd-RealEstate Dev & Mgt',
    [ExcIceGsmV1IceSubcategory.PreRefunded]: 'Pre-Refunded',
    [ExcIceGsmV1IceSubcategory.PfdReiTs]: 'Pfd-REITs',
    [ExcIceGsmV1IceSubcategory.PrintingPublishing]: 'Printing & Publishing',
    [ExcIceGsmV1IceSubcategory.PfdRestaurants]: 'Pfd-Restaurants',
    [ExcIceGsmV1IceSubcategory.PfdSpecialtyRetail]: 'Pfd-Specialty Retail',
    [ExcIceGsmV1IceSubcategory.PfdSteelProducersProducts]: 'Pfd-Steel Producers/Products',
    [ExcIceGsmV1IceSubcategory.PfdSupportServices]: 'Pfd-Support-Services',
    [ExcIceGsmV1IceSubcategory.PfdSoftwareServices]: 'Pfd-Software/Services',
    [ExcIceGsmV1IceSubcategory.PfdTelecomWirelineIntegratedServices]: 'Pfd-Telecom - Wireline Integrated & Services',
    [ExcIceGsmV1IceSubcategory.PfdTobacco]: 'Pfd-Tobacco',
    [ExcIceGsmV1IceSubcategory.PfdTransportInfrastructureServices]: 'Pfd-Transport Infrastructure/Services',
    [ExcIceGsmV1IceSubcategory.PfdTruckingDelivery]: 'Pfd-Trucking & Delivery',
    [ExcIceGsmV1IceSubcategory.PfdTelecomSatellite]: 'Pfd-Telecom - Satellite',
    [ExcIceGsmV1IceSubcategory.PfdTelecomWireless]: 'Pfd-Telecom - Wireless',
    [ExcIceGsmV1IceSubcategory.Rail]: 'Rail',
    [ExcIceGsmV1IceSubcategory.RealEstateDevMgt]: 'RealEstate Dev & Mgt',
    [ExcIceGsmV1IceSubcategory.ReiTs]: 'REITs',
    [ExcIceGsmV1IceSubcategory.Restaurants]: 'Restaurants',
    [ExcIceGsmV1IceSubcategory.Sequential]: 'Sequential',
    [ExcIceGsmV1IceSubcategory.SequentialZ]: 'Sequential Z',
    [ExcIceGsmV1IceSubcategory.RevenueSingleFamilyHousing]: 'Revenue - Single Family Housing',
    [ExcIceGsmV1IceSubcategory.Sovereign]: 'Sovereign',
    [ExcIceGsmV1IceSubcategory.SpecialtyRetail]: 'Specialty Retail',
    [ExcIceGsmV1IceSubcategory.SteelProducersProducts]: 'Steel Producers/Products',
    [ExcIceGsmV1IceSubcategory.StructuredIo]: 'Structured IO',
    [ExcIceGsmV1IceSubcategory.StructuredPo]: 'Structured PO',
    [ExcIceGsmV1IceSubcategory.SupportServices]: 'Support-Services',
    [ExcIceGsmV1IceSubcategory.Supranational]: 'Supranational',
    [ExcIceGsmV1IceSubcategory.SupportZ]: 'Support Z',
    [ExcIceGsmV1IceSubcategory.SoftwareServices]: 'Software/Services',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueAirport]: 'Taxable Revenue - Airport',
    [ExcIceGsmV1IceSubcategory.RevenueTax]: 'Revenue - Tax',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueEducation]: 'Taxable Revenue - Education',
    [ExcIceGsmV1IceSubcategory.TaxableEtm]: 'Taxable ETM',
    [ExcIceGsmV1IceSubcategory.TaxableGoLocal]: 'Taxable GO - Local',
    [ExcIceGsmV1IceSubcategory.TaxableGoState]: 'Taxable GO - State',
    [ExcIceGsmV1IceSubcategory.TheatersEntertainment]: 'Theaters & Entertainment',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueHealth]: 'Taxable Revenue - Health',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueHospitals]: 'Taxable Revenue - Hospitals',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueIndustrialDevelopmentRevenue]: 'Taxable Revenue - Industrial Development Revenue',
    [ExcIceGsmV1IceSubcategory.TelecomWirelineIntegratedServices]: 'Telecom - Wireline Integrated & Services',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueLeasingCopsAppropriations]: 'Taxable Revenue - Leasing COPS & Appropriations',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueMultiFamilyHousing]: 'Taxable Revenue - Multi-Family Housing',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueMisc]: 'Taxable Revenue - Misc',
    [ExcIceGsmV1IceSubcategory.RevenueTobacco]: 'Revenue - Tobacco',
    [ExcIceGsmV1IceSubcategory.Tobacco]: 'Tobacco',
    [ExcIceGsmV1IceSubcategory.RevenueTollTurnpike]: 'Revenue - Toll & Turnpike',
    [ExcIceGsmV1IceSubcategory.TaxableRevenuePollutionControl]: 'Taxable Revenue - Pollution Control',
    [ExcIceGsmV1IceSubcategory.TaxableRevenuePower]: 'Taxable Revenue - Power',
    [ExcIceGsmV1IceSubcategory.PreRefunded_2]: 'Pre-Refunded',
    [ExcIceGsmV1IceSubcategory.TransportInfrastructureServices]: 'Transport Infrastructure/Services',
    [ExcIceGsmV1IceSubcategory.TrustIo]: 'Trust IO',
    [ExcIceGsmV1IceSubcategory.RevenueTransportation]: 'Revenue - Transportation',
    [ExcIceGsmV1IceSubcategory.TrustPo]: 'Trust PO',
    [ExcIceGsmV1IceSubcategory.TruckingDelivery]: 'Trucking & Delivery',
    [ExcIceGsmV1IceSubcategory.TelecomSatellite]: 'Telecom - Satellite',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueSingleFamilyHousing]: 'Taxable Revenue - Single Family Housing',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueTax]: 'Taxable Revenue - Tax',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueTobacco]: 'Taxable Revenue - Tobacco',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueTollTurnpike]: 'Taxable Revenue - Toll & Turnpike',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueTransportation]: 'Taxable Revenue - Transportation',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueUtilitiesOther]: 'Taxable Revenue - Utilities - Other',
    [ExcIceGsmV1IceSubcategory.TelecomWireless]: 'Telecom - Wireless',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueWaterSewer]: 'Taxable Revenue - Water & Sewer',
    [ExcIceGsmV1IceSubcategory.NonElectricUtilities]: 'Non-Electric Utilities',
    [ExcIceGsmV1IceSubcategory.RevenueUtilitiesOther]: 'Revenue - Utilities - Other',
    [ExcIceGsmV1IceSubcategory.RevenueWaterSewer]: 'Revenue - Water & Sewer'
} as const;

export const EXC_ICE_GSM_V1_ICE_SUBCATEGORY_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1IceSubcategory.AbsAutomobile]: 'ABau',
    [ExcIceGsmV1IceSubcategory.AbsAirlineLeases]: 'ABal',
    [ExcIceGsmV1IceSubcategory.AbsConsumerLoans]: 'ABcl',
    [ExcIceGsmV1IceSubcategory.AbsEquipmentLeases]: 'ABel',
    [ExcIceGsmV1IceSubcategory.AbsWholeBusinessFranchiseLoans]: 'ABwl',
    [ExcIceGsmV1IceSubcategory.AbsStudentLoans]: 'ABsl',
    [ExcIceGsmV1IceSubcategory.AbsTimeshares]: 'ABts',
    [ExcIceGsmV1IceSubcategory.AgencyCmbs]: 'CMBa',
    [ExcIceGsmV1IceSubcategory.NonAgencyCmbs]: 'CMBn',
    [ExcIceGsmV1IceSubcategory.AbsCreditCards]: 'ABcc',
    [ExcIceGsmV1IceSubcategory.AbsHomeEquityLoans]: 'ABhe',
    [ExcIceGsmV1IceSubcategory.AbsManufacturedHousing]: 'ABmh',
    [ExcIceGsmV1IceSubcategory.AbsMiscellaneousAbs]: 'ABmi',
    [ExcIceGsmV1IceSubcategory.AbsUtilities]: 'ABut',
    [ExcIceGsmV1IceSubcategory.AerospaceDefense]: 'Aero',
    [ExcIceGsmV1IceSubcategory.Agency]: 'Agcy',
    [ExcIceGsmV1IceSubcategory.AirTransportation]: 'Airl',
    [ExcIceGsmV1IceSubcategory.RevenueAirport]: 'Airp',
    [ExcIceGsmV1IceSubcategory.AutoLoans]: 'AuLn',
    [ExcIceGsmV1IceSubcategory.AutoPartsEquipment]: 'AuPt',
    [ExcIceGsmV1IceSubcategory.Automakers]: 'Autm',
    [ExcIceGsmV1IceSubcategory.Banking]: 'Bank',
    [ExcIceGsmV1IceSubcategory.Beverage]: 'Bevg',
    [ExcIceGsmV1IceSubcategory.BuildingConstruction]: 'Bldg',
    [ExcIceGsmV1IceSubcategory.BuildingMaterials]: 'BldM',
    [ExcIceGsmV1IceSubcategory.Brokerage]: 'Brkg',
    [ExcIceGsmV1IceSubcategory.CvtAdvertising]: 'Cadv',
    [ExcIceGsmV1IceSubcategory.CvtAerospaceDefense]: 'Caer',
    [ExcIceGsmV1IceSubcategory.CvtAirTransportation]: 'Cair',
    [ExcIceGsmV1IceSubcategory.CvtAutomakers]: 'Catm',
    [ExcIceGsmV1IceSubcategory.CvtAutoLoans]: 'Caul',
    [ExcIceGsmV1IceSubcategory.CvtAutoPartsEquipment]: 'Caup',
    [ExcIceGsmV1IceSubcategory.CvtBeverage]: 'Cbev',
    [ExcIceGsmV1IceSubcategory.CvtBuildingConstruction]: 'Cbld',
    [ExcIceGsmV1IceSubcategory.CvtBuildingMaterials]: 'Cblm',
    [ExcIceGsmV1IceSubcategory.CvtBanking]: 'Cbnk',
    [ExcIceGsmV1IceSubcategory.CvtBrokerage]: 'Cbrk',
    [ExcIceGsmV1IceSubcategory.CvtConsCommLeaseFinancing]: 'Cccl',
    [ExcIceGsmV1IceSubcategory.CvtChemicals]: 'Cchm',
    [ExcIceGsmV1IceSubcategory.CvtCableSatelliteTv]: 'Cctv',
    [ExcIceGsmV1IceSubcategory.CvtDiversifiedCapitalGoods]: 'Cdcp',
    [ExcIceGsmV1IceSubcategory.CvtDiscountStores]: 'Cdis',
    [ExcIceGsmV1IceSubcategory.CvtDepartmentStores]: 'Cdpt',
    [ExcIceGsmV1IceSubcategory.CvtEnergyExplorationProduction]: 'Ceap',
    [ExcIceGsmV1IceSubcategory.CvtElectricDistrTrans]: 'Celd',
    [ExcIceGsmV1IceSubcategory.CvtElectronics]: 'Cele',
    [ExcIceGsmV1IceSubcategory.CvtElectricGeneration]: 'Celg',
    [ExcIceGsmV1IceSubcategory.CvtElectricIntegrated]: 'Celi',
    [ExcIceGsmV1IceSubcategory.CvtNonElectricUtilities]: 'Celn',
    [ExcIceGsmV1IceSubcategory.CvtIntegratedEnergy]: 'Ceni',
    [ExcIceGsmV1IceSubcategory.CvtTheatersEntertainment]: 'Cent',
    [ExcIceGsmV1IceSubcategory.CvtEnvironmental]: 'Cenv',
    [ExcIceGsmV1IceSubcategory.ConsCommLeaseFinancing]: 'CFin',
    [ExcIceGsmV1IceSubcategory.CvtFoodWholesale]: 'Cfoo',
    [ExcIceGsmV1IceSubcategory.CvtFoodDrugRetailers]: 'Cfre',
    [ExcIceGsmV1IceSubcategory.CvtGaming]: 'Cgam',
    [ExcIceGsmV1IceSubcategory.Chemicals]: 'Chem',
    [ExcIceGsmV1IceSubcategory.CvtHealthFacilities]: 'Chfc',
    [ExcIceGsmV1IceSubcategory.CvtHotels]: 'Chot',
    [ExcIceGsmV1IceSubcategory.CvtHousingAssociation]: 'Chou',
    [ExcIceGsmV1IceSubcategory.CvtHealthServices]: 'Chsr',
    [ExcIceGsmV1IceSubcategory.CvtTechHardwareEquipment]: 'Chwa',
    [ExcIceGsmV1IceSubcategory.CvtInsuranceBrokerage]: 'Cinb',
    [ExcIceGsmV1IceSubcategory.CvtMonolineInsurance]: 'Cing',
    [ExcIceGsmV1IceSubcategory.CvtLifeInsurance]: 'Cinl',
    [ExcIceGsmV1IceSubcategory.CvtMultiLineInsurance]: 'Cinm',
    [ExcIceGsmV1IceSubcategory.CvtPC]: 'Cinp',
    [ExcIceGsmV1IceSubcategory.CvtReinsurance]: 'Cinr',
    [ExcIceGsmV1IceSubcategory.CvtInvestmentsMiscFinancialServices]: 'Cinv',
    [ExcIceGsmV1IceSubcategory.CvtMachinery]: 'Cmac',
    [ExcIceGsmV1IceSubcategory.CommercialMortgageBacked]: 'CMBS',
    [ExcIceGsmV1IceSubcategory.CvtManagedCare]: 'Cmca',
    [ExcIceGsmV1IceSubcategory.CvtMediaContent]: 'Cmco',
    [ExcIceGsmV1IceSubcategory.CvtMediaDiversified]: 'Cmdd',
    [ExcIceGsmV1IceSubcategory.CvtMetalsMiningExcludingSteel]: 'Cmet',
    [ExcIceGsmV1IceSubcategory.CmoOther]: 'CMOT',
    [ExcIceGsmV1IceSubcategory.CvtMedicalProducts]: 'Cmpr',
    [ExcIceGsmV1IceSubcategory.TechHardwareEquipment]: 'Comp',
    [ExcIceGsmV1IceSubcategory.PersonalHouseholdProducts]: 'ConP',
    [ExcIceGsmV1IceSubcategory.CvtOilRefiningMarketing]: 'Corm',
    [ExcIceGsmV1IceSubcategory.CvtOilFieldEquipmentServices]: 'Cosr',
    [ExcIceGsmV1IceSubcategory.MortgageCoveredBonds]: 'CovM',
    [ExcIceGsmV1IceSubcategory.OtherCoveredBonds]: 'CovO',
    [ExcIceGsmV1IceSubcategory.PublicLoanCoveredBonds]: 'CovP',
    [ExcIceGsmV1IceSubcategory.CvtPackaging]: 'Cpac',
    [ExcIceGsmV1IceSubcategory.CvtForestryPaper]: 'Cpap',
    [ExcIceGsmV1IceSubcategory.CvtPharmaceuticals]: 'Cpha',
    [ExcIceGsmV1IceSubcategory.CvtGasDistribution]: 'Cpip',
    [ExcIceGsmV1IceSubcategory.CvtPersonalHouseholdProducts]: 'Cprd',
    [ExcIceGsmV1IceSubcategory.CvtPrintingPublishing]: 'Cpub',
    [ExcIceGsmV1IceSubcategory.CvtRail]: 'Crai',
    [ExcIceGsmV1IceSubcategory.CvtRecreationTravel]: 'Crec',
    [ExcIceGsmV1IceSubcategory.CvtRealEstateDevMgt]: 'Cred',
    [ExcIceGsmV1IceSubcategory.CvtReiTs]: 'Crei',
    [ExcIceGsmV1IceSubcategory.CvtRestaurants]: 'Crst',
    [ExcIceGsmV1IceSubcategory.CvtSpecialtyRetail]: 'Cspr',
    [ExcIceGsmV1IceSubcategory.CvtSteelProducersProducts]: 'Cstl',
    [ExcIceGsmV1IceSubcategory.CvtSupportServices]: 'Csup',
    [ExcIceGsmV1IceSubcategory.CvtSoftwareServices]: 'Cswa',
    [ExcIceGsmV1IceSubcategory.CvtTelecomWirelineIntegratedServices]: 'Ctin',
    [ExcIceGsmV1IceSubcategory.CvtTobacco]: 'Ctob',
    [ExcIceGsmV1IceSubcategory.CvtTransportInfrastructureServices]: 'Ctra',
    [ExcIceGsmV1IceSubcategory.CvtTruckingDelivery]: 'Ctrk',
    [ExcIceGsmV1IceSubcategory.CvtTelecomSatellite]: 'Ctsa',
    [ExcIceGsmV1IceSubcategory.CvtTelecomWireless]: 'Ctwi',
    [ExcIceGsmV1IceSubcategory.DiversifiedCapitalGoods]: 'DCap',
    [ExcIceGsmV1IceSubcategory.DepartmentStores]: 'Dept',
    [ExcIceGsmV1IceSubcategory.DiscountStores]: 'Disc',
    [ExcIceGsmV1IceSubcategory.RevenueEducation]: 'Edu',
    [ExcIceGsmV1IceSubcategory.Electronics]: 'Elec',
    [ExcIceGsmV1IceSubcategory.ElectricDistrTrans]: 'EleD',
    [ExcIceGsmV1IceSubcategory.ElectricGeneration]: 'EleG',
    [ExcIceGsmV1IceSubcategory.ElectricIntegrated]: 'EleI',
    [ExcIceGsmV1IceSubcategory.EnergyExplorationProduction]: 'EnEx',
    [ExcIceGsmV1IceSubcategory.IntegratedEnergy]: 'EngI',
    [ExcIceGsmV1IceSubcategory.Etm]: 'Etm',
    [ExcIceGsmV1IceSubcategory.Environmental]: 'Evir',
    [ExcIceGsmV1IceSubcategory.FoodDrugRetailers]: 'FRet',
    [ExcIceGsmV1IceSubcategory.ForeignSovereign]: 'FSov',
    [ExcIceGsmV1IceSubcategory.FoodWholesale]: 'FWhl',
    [ExcIceGsmV1IceSubcategory.Gaming]: 'Game',
    [ExcIceGsmV1IceSubcategory.GasDistribution]: 'GasD',
    [ExcIceGsmV1IceSubcategory.GoLocal]: 'Golo',
    [ExcIceGsmV1IceSubcategory.GoState]: 'Gost',
    [ExcIceGsmV1IceSubcategory.GovernmentGuaranteed]: 'Guar',
    [ExcIceGsmV1IceSubcategory.MedicalProducts]: 'HDev',
    [ExcIceGsmV1IceSubcategory.RevenueHealth]: 'Heal',
    [ExcIceGsmV1IceSubcategory.HealthFacilities]: 'HFac',
    [ExcIceGsmV1IceSubcategory.HealthServices]: 'Hlth',
    [ExcIceGsmV1IceSubcategory.RevenueHospitals]: 'Hosp',
    [ExcIceGsmV1IceSubcategory.Hotels]: 'Hotl',
    [ExcIceGsmV1IceSubcategory.HousingAssociation]: 'Hous',
    [ExcIceGsmV1IceSubcategory.RevenueIndustrialDevelopmentRevenue]: 'Idr',
    [ExcIceGsmV1IceSubcategory.InsuranceBrokerage]: 'InsB',
    [ExcIceGsmV1IceSubcategory.MonolineInsurance]: 'InsG',
    [ExcIceGsmV1IceSubcategory.LifeInsurance]: 'InsL',
    [ExcIceGsmV1IceSubcategory.MultiLineInsurance]: 'InsM',
    [ExcIceGsmV1IceSubcategory.PC]: 'InsP',
    [ExcIceGsmV1IceSubcategory.Reinsurance]: 'InsR',
    [ExcIceGsmV1IceSubcategory.InvestmentsMiscFinancialServices]: 'Invs',
    [ExcIceGsmV1IceSubcategory.RevenueLeasingCopsAppropriations]: 'Leas',
    [ExcIceGsmV1IceSubcategory.RecreationTravel]: 'Leis',
    [ExcIceGsmV1IceSubcategory.LocalAuthority]: 'LGvt',
    [ExcIceGsmV1IceSubcategory.LoanBanking]: 'Lban',
    [ExcIceGsmV1IceSubcategory.LoanBrokerage]: 'Lbrk',
    [ExcIceGsmV1IceSubcategory.LoanConsCommLeaseFinancing]: 'Lcfi',
    [ExcIceGsmV1IceSubcategory.LoanInvestmentsMiscFinancialServices]: 'Linv',
    [ExcIceGsmV1IceSubcategory.LoanInsuranceBrokerage]: 'Lins',
    [ExcIceGsmV1IceSubcategory.LoanLifeInsurance]: 'Llif',
    [ExcIceGsmV1IceSubcategory.LoanMonolineInsurance]: 'Lmon',
    [ExcIceGsmV1IceSubcategory.LoanMultiLineInsurance]: 'Lmul',
    [ExcIceGsmV1IceSubcategory.LoanPC]: 'Lpnc',
    [ExcIceGsmV1IceSubcategory.LoanReinsurance]: 'Lren',
    [ExcIceGsmV1IceSubcategory.LoanAutoLoans]: 'Laul',
    [ExcIceGsmV1IceSubcategory.LoanAutoPartsEquipment]: 'Laup',
    [ExcIceGsmV1IceSubcategory.LoanAutomakers]: 'Laut',
    [ExcIceGsmV1IceSubcategory.LoanBuildingConstruction]: 'Lbld',
    [ExcIceGsmV1IceSubcategory.LoanBuildingMaterials]: 'Lbdm',
    [ExcIceGsmV1IceSubcategory.LoanChemicals]: 'Lche',
    [ExcIceGsmV1IceSubcategory.LoanForestryPaper]: 'Lpap',
    [ExcIceGsmV1IceSubcategory.LoanMetalsMiningExcludingSteel]: 'Lmet',
    [ExcIceGsmV1IceSubcategory.LoanSteelProducersProducts]: 'Lste',
    [ExcIceGsmV1IceSubcategory.LoanAerospaceDefense]: 'Laer',
    [ExcIceGsmV1IceSubcategory.LoanDiversifiedCapitalGoods]: 'Ldca',
    [ExcIceGsmV1IceSubcategory.LoanMachinery]: 'Lmac',
    [ExcIceGsmV1IceSubcategory.LoanPackaging]: 'Lpac',
    [ExcIceGsmV1IceSubcategory.LoanBeverage]: 'Lbev',
    [ExcIceGsmV1IceSubcategory.LoanFoodWholesale]: 'Lfwh',
    [ExcIceGsmV1IceSubcategory.LoanPersonalHouseholdProducts]: 'Lcon',
    [ExcIceGsmV1IceSubcategory.LoanTobacco]: 'Ltob',
    [ExcIceGsmV1IceSubcategory.LoanEnergyExplorationProduction]: 'Lene',
    [ExcIceGsmV1IceSubcategory.LoanGasDistribution]: 'Lgas',
    [ExcIceGsmV1IceSubcategory.LoanIntegratedEnergy]: 'Leng',
    [ExcIceGsmV1IceSubcategory.LoanOilFieldEquipmentServices]: 'Loil',
    [ExcIceGsmV1IceSubcategory.LoanOilRefiningMarketing]: 'Lorm',
    [ExcIceGsmV1IceSubcategory.LoanHealthFacilities]: 'Lhfa',
    [ExcIceGsmV1IceSubcategory.LoanHealthServices]: 'Lhlt',
    [ExcIceGsmV1IceSubcategory.LoanManagedCare]: 'Lmca',
    [ExcIceGsmV1IceSubcategory.LoanMedicalProducts]: 'Lhde',
    [ExcIceGsmV1IceSubcategory.LoanPharmaceuticals]: 'Lpha',
    [ExcIceGsmV1IceSubcategory.LoanGaming]: 'Lgam',
    [ExcIceGsmV1IceSubcategory.LoanHotels]: 'Lhot',
    [ExcIceGsmV1IceSubcategory.LoanRecreationTravel]: 'Llei',
    [ExcIceGsmV1IceSubcategory.LoanTheatersEntertainment]: 'Lthe',
    [ExcIceGsmV1IceSubcategory.LoanAdvertising]: 'Ladv',
    [ExcIceGsmV1IceSubcategory.LoanCableSatelliteTv]: 'Lcst',
    [ExcIceGsmV1IceSubcategory.LoanMediaDiversified]: 'Lmdv',
    [ExcIceGsmV1IceSubcategory.LoanMediaContent]: 'Lmed',
    [ExcIceGsmV1IceSubcategory.LoanPrintingPublishing]: 'Lprn',
    [ExcIceGsmV1IceSubcategory.LoanHousingAssociation]: 'Lhou',
    [ExcIceGsmV1IceSubcategory.LoanRealEstateDevMgt]: 'Lred',
    [ExcIceGsmV1IceSubcategory.LoanReiTs]: 'Lrei',
    [ExcIceGsmV1IceSubcategory.LoanDepartmentStores]: 'Ldep',
    [ExcIceGsmV1IceSubcategory.LoanDiscountStores]: 'Ldis',
    [ExcIceGsmV1IceSubcategory.LoanFoodDrugRetailers]: 'Lfre',
    [ExcIceGsmV1IceSubcategory.LoanRestaurants]: 'Lres',
    [ExcIceGsmV1IceSubcategory.LoanSpecialtyRetail]: 'Lspe',
    [ExcIceGsmV1IceSubcategory.LoanEnvironmental]: 'Levi',
    [ExcIceGsmV1IceSubcategory.LoanSupportServices]: 'Lsup',
    [ExcIceGsmV1IceSubcategory.LoanElectronics]: 'Lele',
    [ExcIceGsmV1IceSubcategory.LoanSoftwareServices]: 'Lswa',
    [ExcIceGsmV1IceSubcategory.LoanTechHardwareEquipment]: 'Lcom',
    [ExcIceGsmV1IceSubcategory.LoanTelecomSatellite]: 'Ltsa',
    [ExcIceGsmV1IceSubcategory.LoanTelecomWireless]: 'Ltwi',
    [ExcIceGsmV1IceSubcategory.LoanTelecomWirelineIntegratedServices]: 'Ltin',
    [ExcIceGsmV1IceSubcategory.LoanAirTransportation]: 'Lair',
    [ExcIceGsmV1IceSubcategory.LoanRail]: 'Lrai',
    [ExcIceGsmV1IceSubcategory.LoanTransportInfrastructureServices]: 'Ltri',
    [ExcIceGsmV1IceSubcategory.LoanTruckingDelivery]: 'Ltru',
    [ExcIceGsmV1IceSubcategory.LoanElectricDistrTrans]: 'Leld',
    [ExcIceGsmV1IceSubcategory.LoanElectricGeneration]: 'Lelg',
    [ExcIceGsmV1IceSubcategory.LoanElectricIntegrated]: 'Leli',
    [ExcIceGsmV1IceSubcategory.LoanNonElectricUtilities]: 'Lutl',
    [ExcIceGsmV1IceSubcategory.Machinery]: 'Mach',
    [ExcIceGsmV1IceSubcategory.MortgageBacked]: 'MBS',
    [ExcIceGsmV1IceSubcategory.ManagedCare]: 'MCar',
    [ExcIceGsmV1IceSubcategory.MediaContent]: 'MedB',
    [ExcIceGsmV1IceSubcategory.CableSatelliteTv]: 'MedC',
    [ExcIceGsmV1IceSubcategory.MediaDiversified]: 'MedD',
    [ExcIceGsmV1IceSubcategory.Advertising]: 'MedS',
    [ExcIceGsmV1IceSubcategory.MetalsMiningExcludingSteel]: 'Metl',
    [ExcIceGsmV1IceSubcategory.RevenueMultiFamilyHousing]: 'Mhng',
    [ExcIceGsmV1IceSubcategory.RevenueMisc]: 'Misc',
    [ExcIceGsmV1IceSubcategory.OilFieldEquipmentServices]: 'OilE',
    [ExcIceGsmV1IceSubcategory.OilRefiningMarketing]: 'OilR',
    [ExcIceGsmV1IceSubcategory.Pac]: 'PAC',
    [ExcIceGsmV1IceSubcategory.Packaging]: 'Pack',
    [ExcIceGsmV1IceSubcategory.PacZ]: 'PACZ',
    [ExcIceGsmV1IceSubcategory.PfdAdvertising]: 'Padv',
    [ExcIceGsmV1IceSubcategory.PfdAerospaceDefense]: 'Paer',
    [ExcIceGsmV1IceSubcategory.PfdAgency]: 'Pagy',
    [ExcIceGsmV1IceSubcategory.PfdAirTransportation]: 'Pair',
    [ExcIceGsmV1IceSubcategory.ForestryPaper]: 'Papr',
    [ExcIceGsmV1IceSubcategory.PfdAutomakers]: 'Patm',
    [ExcIceGsmV1IceSubcategory.PfdAutoLoans]: 'Paul',
    [ExcIceGsmV1IceSubcategory.PfdAutoPartsEquipment]: 'Paup',
    [ExcIceGsmV1IceSubcategory.PfdBanking]: 'Pban',
    [ExcIceGsmV1IceSubcategory.PfdBeverage]: 'Pbev',
    [ExcIceGsmV1IceSubcategory.PfdBuildingConstruction]: 'Pbld',
    [ExcIceGsmV1IceSubcategory.PfdBuildingMaterials]: 'Pblm',
    [ExcIceGsmV1IceSubcategory.PfdBrokerage]: 'Pbrk',
    [ExcIceGsmV1IceSubcategory.PfdConsCommLeaseFinancing]: 'Pccl',
    [ExcIceGsmV1IceSubcategory.PfdChemicals]: 'Pchm',
    [ExcIceGsmV1IceSubcategory.RevenuePollutionControl]: 'Pcr',
    [ExcIceGsmV1IceSubcategory.PfdCableSatelliteTv]: 'Pctv',
    [ExcIceGsmV1IceSubcategory.PfdDiversifiedCapitalGoods]: 'Pdcp',
    [ExcIceGsmV1IceSubcategory.PfdDiscountStores]: 'Pdis',
    [ExcIceGsmV1IceSubcategory.PfdDepartmentStores]: 'Pdpt',
    [ExcIceGsmV1IceSubcategory.PfdEnergyExplorationProduction]: 'Peap',
    [ExcIceGsmV1IceSubcategory.PfdElectricDistrTrans]: 'Peld',
    [ExcIceGsmV1IceSubcategory.PfdElectronics]: 'Pele',
    [ExcIceGsmV1IceSubcategory.PfdElectricGeneration]: 'Pelg',
    [ExcIceGsmV1IceSubcategory.PfdElectricIntegrated]: 'Peli',
    [ExcIceGsmV1IceSubcategory.PfdNonElectricUtilities]: 'Peln',
    [ExcIceGsmV1IceSubcategory.PfdIntegratedEnergy]: 'Peni',
    [ExcIceGsmV1IceSubcategory.PfdTheatersEntertainment]: 'Pent',
    [ExcIceGsmV1IceSubcategory.PfdEnvironmental]: 'Penv',
    [ExcIceGsmV1IceSubcategory.PfdFoodWholesale]: 'Pfoo',
    [ExcIceGsmV1IceSubcategory.PfdFoodDrugRetailers]: 'Pfre',
    [ExcIceGsmV1IceSubcategory.PfdGaming]: 'Pgam',
    [ExcIceGsmV1IceSubcategory.Pharmaceuticals]: 'Phar',
    [ExcIceGsmV1IceSubcategory.PfdHealthFacilities]: 'Phfc',
    [ExcIceGsmV1IceSubcategory.PfdHotels]: 'Phot',
    [ExcIceGsmV1IceSubcategory.PfdHousingAssociation]: 'Phou',
    [ExcIceGsmV1IceSubcategory.PfdHealthServices]: 'Phsr',
    [ExcIceGsmV1IceSubcategory.PfdTechHardwareEquipment]: 'Phwa',
    [ExcIceGsmV1IceSubcategory.PfdInsuranceBrokerage]: 'Pinb',
    [ExcIceGsmV1IceSubcategory.PfdMonolineInsurance]: 'Ping',
    [ExcIceGsmV1IceSubcategory.PfdLifeInsurance]: 'Pinl',
    [ExcIceGsmV1IceSubcategory.PfdMultiLineInsurance]: 'Pinm',
    [ExcIceGsmV1IceSubcategory.PfdPC]: 'Pinp',
    [ExcIceGsmV1IceSubcategory.PfdReinsurance]: 'Pinr',
    [ExcIceGsmV1IceSubcategory.PfdInvestmentsMiscFinancialServices]: 'Pinv',
    [ExcIceGsmV1IceSubcategory.PfdMachinery]: 'Pmac',
    [ExcIceGsmV1IceSubcategory.PfdManagedCare]: 'Pmca',
    [ExcIceGsmV1IceSubcategory.PfdMediaContent]: 'Pmco',
    [ExcIceGsmV1IceSubcategory.PfdMediaDiversified]: 'Pmdd',
    [ExcIceGsmV1IceSubcategory.PfdMetalsMiningExcludingSteel]: 'Pmet',
    [ExcIceGsmV1IceSubcategory.PfdMedicalProducts]: 'Pmpr',
    [ExcIceGsmV1IceSubcategory.PfdOilRefiningMarketing]: 'Porm',
    [ExcIceGsmV1IceSubcategory.PfdOilFieldEquipmentServices]: 'Posr',
    [ExcIceGsmV1IceSubcategory.RevenuePower]: 'Powr',
    [ExcIceGsmV1IceSubcategory.PfdPackaging]: 'Ppac',
    [ExcIceGsmV1IceSubcategory.PfdForestryPaper]: 'Ppap',
    [ExcIceGsmV1IceSubcategory.PfdPharmaceuticals]: 'Ppha',
    [ExcIceGsmV1IceSubcategory.PfdGasDistribution]: 'Ppip',
    [ExcIceGsmV1IceSubcategory.PfdPersonalHouseholdProducts]: 'Pprd',
    [ExcIceGsmV1IceSubcategory.PfdPrintingPublishing]: 'Ppub',
    [ExcIceGsmV1IceSubcategory.PfdRail]: 'Prai',
    [ExcIceGsmV1IceSubcategory.PfdRecreationTravel]: 'Prec',
    [ExcIceGsmV1IceSubcategory.PfdRealEstateDevMgt]: 'Pred',
    [ExcIceGsmV1IceSubcategory.PreRefunded]: 'Pref',
    [ExcIceGsmV1IceSubcategory.PfdReiTs]: 'Prei',
    [ExcIceGsmV1IceSubcategory.PrintingPublishing]: 'Prnt',
    [ExcIceGsmV1IceSubcategory.PfdRestaurants]: 'Prst',
    [ExcIceGsmV1IceSubcategory.PfdSpecialtyRetail]: 'Pspr',
    [ExcIceGsmV1IceSubcategory.PfdSteelProducersProducts]: 'Pstl',
    [ExcIceGsmV1IceSubcategory.PfdSupportServices]: 'Psup',
    [ExcIceGsmV1IceSubcategory.PfdSoftwareServices]: 'Pswa',
    [ExcIceGsmV1IceSubcategory.PfdTelecomWirelineIntegratedServices]: 'Ptin',
    [ExcIceGsmV1IceSubcategory.PfdTobacco]: 'Ptob',
    [ExcIceGsmV1IceSubcategory.PfdTransportInfrastructureServices]: 'Ptra',
    [ExcIceGsmV1IceSubcategory.PfdTruckingDelivery]: 'Ptrk',
    [ExcIceGsmV1IceSubcategory.PfdTelecomSatellite]: 'Ptsa',
    [ExcIceGsmV1IceSubcategory.PfdTelecomWireless]: 'Ptwi',
    [ExcIceGsmV1IceSubcategory.Rail]: 'Rail',
    [ExcIceGsmV1IceSubcategory.RealEstateDevMgt]: 'ReDM',
    [ExcIceGsmV1IceSubcategory.ReiTs]: 'REIT',
    [ExcIceGsmV1IceSubcategory.Restaurants]: 'Rest',
    [ExcIceGsmV1IceSubcategory.Sequential]: 'SEQL',
    [ExcIceGsmV1IceSubcategory.SequentialZ]: 'SEQZ',
    [ExcIceGsmV1IceSubcategory.RevenueSingleFamilyHousing]: 'Shng',
    [ExcIceGsmV1IceSubcategory.Sovereign]: 'Sov',
    [ExcIceGsmV1IceSubcategory.SpecialtyRetail]: 'Spec',
    [ExcIceGsmV1IceSubcategory.SteelProducersProducts]: 'Stee',
    [ExcIceGsmV1IceSubcategory.StructuredIo]: 'STIO',
    [ExcIceGsmV1IceSubcategory.StructuredPo]: 'STPO',
    [ExcIceGsmV1IceSubcategory.SupportServices]: 'Supp',
    [ExcIceGsmV1IceSubcategory.Supranational]: 'Supr',
    [ExcIceGsmV1IceSubcategory.SupportZ]: 'SUPZ',
    [ExcIceGsmV1IceSubcategory.SoftwareServices]: 'SWar',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueAirport]: 'TAir',
    [ExcIceGsmV1IceSubcategory.RevenueTax]: 'Taxr',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueEducation]: 'TEdu',
    [ExcIceGsmV1IceSubcategory.TaxableEtm]: 'TEtm',
    [ExcIceGsmV1IceSubcategory.TaxableGoLocal]: 'TGol',
    [ExcIceGsmV1IceSubcategory.TaxableGoState]: 'TGos',
    [ExcIceGsmV1IceSubcategory.TheatersEntertainment]: 'Thea',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueHealth]: 'THlt',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueHospitals]: 'THos',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueIndustrialDevelopmentRevenue]: 'TIdr',
    [ExcIceGsmV1IceSubcategory.TelecomWirelineIntegratedServices]: 'TInt',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueLeasingCopsAppropriations]: 'TLea',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueMultiFamilyHousing]: 'TMhn',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueMisc]: 'TMis',
    [ExcIceGsmV1IceSubcategory.RevenueTobacco]: 'Tob',
    [ExcIceGsmV1IceSubcategory.Tobacco]: 'Toba',
    [ExcIceGsmV1IceSubcategory.RevenueTollTurnpike]: 'Toll',
    [ExcIceGsmV1IceSubcategory.TaxableRevenuePollutionControl]: 'TPcr',
    [ExcIceGsmV1IceSubcategory.TaxableRevenuePower]: 'TPow',
    [ExcIceGsmV1IceSubcategory.PreRefunded_2]: 'TPre',
    [ExcIceGsmV1IceSubcategory.TransportInfrastructureServices]: 'Trin',
    [ExcIceGsmV1IceSubcategory.TrustIo]: 'TRIO',
    [ExcIceGsmV1IceSubcategory.RevenueTransportation]: 'Trns',
    [ExcIceGsmV1IceSubcategory.TrustPo]: 'TRPO',
    [ExcIceGsmV1IceSubcategory.TruckingDelivery]: 'Truc',
    [ExcIceGsmV1IceSubcategory.TelecomSatellite]: 'TSat',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueSingleFamilyHousing]: 'TShn',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueTax]: 'TTax',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueTobacco]: 'TTob',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueTollTurnpike]: 'TTol',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueTransportation]: 'TTrn',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueUtilitiesOther]: 'TUtl',
    [ExcIceGsmV1IceSubcategory.TelecomWireless]: 'TWis',
    [ExcIceGsmV1IceSubcategory.TaxableRevenueWaterSewer]: 'TWtr',
    [ExcIceGsmV1IceSubcategory.NonElectricUtilities]: 'UtlN',
    [ExcIceGsmV1IceSubcategory.RevenueUtilitiesOther]: 'Utly',
    [ExcIceGsmV1IceSubcategory.RevenueWaterSewer]: 'Watr'
} as const;

export interface ExcIceGsmV1Identifiers {
    /* The CUSIP identifier */
    // format: informal
    cusip?: string;
    /* The ISIN identifier */
    // format: informal
    isin?: string;
    /* The ticker symbol */
    symbol?: string;
}

export interface ExcIceGsmV1InstrumentCommandServiceGetInstrumentXmlGetInstrumentXmlRequest {
    // format: informal
    instrumentId: string;
    /* Return the XML from the newest ingest on or before this date. Defaults to the current XML. */
    // format: YYYY-MM-DD
    date?: string;
}

export interface ExcIceGsmV1InstrumentData {
    /* Preferred name for the instrument */
    name: string;
    identifiers?: ExcIceGsmV1Identifiers;
    instrument?: ExcIceGsmV1InstrumentDetails;
    equity?: ExcIceGsmV1EquityDetails;
    fund?: ExcIceGsmV1FundDetails;
    organization?: ExcIceGsmV1Organization;
    /* Best available market */
    market?: ExcIceGsmV1Market;
    otherMarkets?: ExcIceGsmV1Market[];
    /* Trading status, taken from the best available market */
    trading?: ExcIceGsmV1Trading;
    /* The Interchange Asset this instrument is linked to, if any. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
    /* Timestamp from the most recently ingested GSM file for this instrument */
    // format: date-time
    ingestedAt?: string;
    /* Location of this instrument's raw XML */
    xmlLocation: ExcIceGsmV1XmlLocation;
    /* Hash of this instrument's current raw XML */
    xmlHash?: string;
}

export interface ExcIceGsmV1InstrumentDetails {
    /* The primary name of the instrument */
    name?: string;
    /* Asset type */
    assetType: ExcIceGsmV1ApexAssetType;
    /* Sector classification */
    sector?: ExcIceGsmV1Sector;
    /* Federal tax status */
    federalTaxStatus?: ExcIceGsmV1MuniFedTaxType;
    /* Country whose financial transaction tax applies to this instrument */
    financialTransactionTax?: IsoV1Country;
    /* Current status */
    status: ExcIceGsmV1BondIssueStatus;
    /* Reason for current */
    statusReason?: ExcIceGsmV1IssueStatusReasonType;
    /* The general asset classification */
    type?: ExcIceGsmV1InstrumentType;
    /* The currency associated with the face value of the instrument */
    primaryCurrencyCode?: IsoV1Currency;
    /* The market code for the primary trading venue */
    primaryExchange?: string;
    /* The country of the instrument */
    country?: IsoV1Country;
}

export interface ExcIceGsmV1InstrumentEvent extends ExcIceGsmV1InstrumentKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcIceGsmV1InstrumentEventType;
}

export type ExcIceGsmV1InstrumentEventType = {
    '!type'?: 'ingested';
    ingested: ExcIceGsmV1InstrumentEventTypeIngested;
} | {
    '!type'?: 'linked';
    linked: ExcIceGsmV1InstrumentEventTypeLinked;
} | {
    '!type'?: 'unlinked';
    unlinked: EmptyObject;
};

export interface ExcIceGsmV1InstrumentEventTypeIngested {
    /* Timestamp from the GSM file's header */
    // format: date-time
    timestamp: string;
    /* Preferred name for the instrument */
    name: string;
    identifiers?: ExcIceGsmV1Identifiers;
    instrument?: ExcIceGsmV1InstrumentDetails;
    equity?: ExcIceGsmV1EquityDetails;
    fund?: ExcIceGsmV1FundDetails;
    organization?: ExcIceGsmV1Organization;
    /* Best available market */
    market?: ExcIceGsmV1Market;
    otherMarkets?: ExcIceGsmV1Market[];
    /* Trading status, taken from the best available market */
    trading?: ExcIceGsmV1Trading;
    /* Location of the instrument's raw XML */
    xmlLocation: ExcIceGsmV1XmlLocation;
    /* Hash of the instrument's raw XML */
    xmlHash?: string;
}

export interface ExcIceGsmV1InstrumentEventTypeLinked {
    // format: id62
    assetId: string;
}

export const EXC_ICE_GSM_V1_INSTRUMENT_EVENT_TYPE_ONE_OF_VALUES = ['ingested', 'linked', 'unlinked'] as const;

export type ExcIceGsmV1InstrumentEventTypeOneOfValue = (typeof EXC_ICE_GSM_V1_INSTRUMENT_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcIceGsmV1InstrumentExportServiceDownloadInstrumentExportDownloadInstrumentExportRequest {
    /* The date of the export to download, or the latest export if unset */
    // format: YYYY-MM-DD
    date?: string;
}

export interface ExcIceGsmV1InstrumentKeys {
    /* The unique identifier, taken from ice's instrument_id field */
    // format: informal
    instrumentId: string;
}

export interface ExcIceGsmV1InstrumentQueryServiceInstrumentEventsInstrumentEventsRequest {
    /* The unique identifier, taken from ice's instrument_id field */
    // format: informal
    instrumentId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<ExcIceGsmV1InstrumentQueryServiceInstrumentEventsSearchableFields, ExcIceGsmV1InstrumentQueryServiceInstrumentEventsSortableFields, ExcIceGsmV1InstrumentQueryServiceInstrumentEventsFilterableFields>;
}

export enum ExcIceGsmV1InstrumentQueryServiceInstrumentEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    InstrumentId = 'instrumentId',
    EventIngestedIdentifiersCusip = 'event.ingested.identifiers.cusip',
    EventIngestedIdentifiersIsin = 'event.ingested.identifiers.isin',
    EventIngestedInstrumentType = 'event.ingested.instrument.type',
    EventType = 'event.!type'
}

export enum ExcIceGsmV1InstrumentQueryServiceInstrumentEventsSearchableFields {
    EventIngestedName = 'event.ingested.name',
    EventIngestedIdentifiersSymbol = 'event.ingested.identifiers.symbol'
}

export enum ExcIceGsmV1InstrumentQueryServiceInstrumentEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcIceGsmV1InstrumentQueryServiceInstrumentGetInstrumentGetRequest {
    /* The unique identifier, taken from ice's instrument_id field */
    // format: informal
    instrumentId: string;
}

export interface ExcIceGsmV1InstrumentQueryServiceInstrumentListInstrumentListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<ExcIceGsmV1InstrumentQueryServiceInstrumentListSearchableFields, ExcIceGsmV1InstrumentQueryServiceInstrumentListSortableFields, ExcIceGsmV1InstrumentQueryServiceInstrumentListFilterableFields>;
}

export enum ExcIceGsmV1InstrumentQueryServiceInstrumentListFilterableFields {
    InstrumentId = 'instrumentId',
    DataIdentifiersCusip = 'data.identifiers.cusip',
    DataIdentifiersIsin = 'data.identifiers.isin',
    DataInstrumentType = 'data.instrument.type',
    DataAssetId = 'data.assetId',
    Status = 'status'
}

export enum ExcIceGsmV1InstrumentQueryServiceInstrumentListSearchableFields {
    DataName = 'data.name',
    DataIdentifiersSymbol = 'data.identifiers.symbol'
}

export enum ExcIceGsmV1InstrumentQueryServiceInstrumentListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcIceGsmV1InstrumentState extends ExcIceGsmV1InstrumentKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcIceGsmV1InstrumentData;
    status: ExcIceGsmV1InstrumentStatus;
}

export enum ExcIceGsmV1InstrumentStatus {
    Unspecified = 'UNSPECIFIED',
    Unlinked = 'UNLINKED',
    Linked = 'LINKED'
}

export enum ExcIceGsmV1InstrumentSummaryName {
    Unspecified = 'UNSPECIFIED',
    InstrumentSummary = 'InstrumentSummary'
}

export enum ExcIceGsmV1InstrumentType {
    Unspecified = 'UNSPECIFIED',
    None = 'NONE',
    DepositoryReceipt = 'DEPOSITORY_RECEIPT',
    CommoditySpotRate = 'COMMODITY_SPOT_RATE',
    Debt = 'DEBT',
    Equity = 'EQUITY',
    Future = 'FUTURE',
    Hybrid = 'HYBRID',
    InterestRate = 'INTEREST_RATE',
    Unknown = 'UNKNOWN',
    Option = 'OPTION',
    ExchangeRate = 'EXCHANGE_RATE',
    CompositeUnit = 'COMPOSITE_UNIT',
    Fund = 'FUND',
    OtherDerivatives = 'OTHER_DERIVATIVES',
    Entitlement = 'ENTITLEMENT',
    Index = 'INDEX',
    Strategy = 'STRATEGY'
}

export const EXC_ICE_GSM_V1_INSTRUMENT_TYPE_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1InstrumentType.None]: 'None',
    [ExcIceGsmV1InstrumentType.DepositoryReceipt]: 'Depository Receipt',
    [ExcIceGsmV1InstrumentType.CommoditySpotRate]: 'Commodity Spot Rate',
    [ExcIceGsmV1InstrumentType.Debt]: 'Debt',
    [ExcIceGsmV1InstrumentType.Equity]: 'Equity',
    [ExcIceGsmV1InstrumentType.Future]: 'Future',
    [ExcIceGsmV1InstrumentType.Hybrid]: 'Hybrid',
    [ExcIceGsmV1InstrumentType.InterestRate]: 'Interest Rate',
    [ExcIceGsmV1InstrumentType.Unknown]: 'Unknown',
    [ExcIceGsmV1InstrumentType.Option]: 'Option',
    [ExcIceGsmV1InstrumentType.ExchangeRate]: 'Exchange Rate',
    [ExcIceGsmV1InstrumentType.CompositeUnit]: 'Composite Unit',
    [ExcIceGsmV1InstrumentType.Fund]: 'Fund',
    [ExcIceGsmV1InstrumentType.OtherDerivatives]: 'Other Derivatives',
    [ExcIceGsmV1InstrumentType.Entitlement]: 'Entitlement',
    [ExcIceGsmV1InstrumentType.Index]: 'Index',
    [ExcIceGsmV1InstrumentType.Strategy]: 'Strategy'
} as const;

export const EXC_ICE_GSM_V1_INSTRUMENT_TYPE_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1InstrumentType.None]: '0',
    [ExcIceGsmV1InstrumentType.DepositoryReceipt]: '1',
    [ExcIceGsmV1InstrumentType.CommoditySpotRate]: '2',
    [ExcIceGsmV1InstrumentType.Debt]: '3',
    [ExcIceGsmV1InstrumentType.Equity]: '4',
    [ExcIceGsmV1InstrumentType.Future]: '5',
    [ExcIceGsmV1InstrumentType.Hybrid]: '6',
    [ExcIceGsmV1InstrumentType.InterestRate]: '7',
    [ExcIceGsmV1InstrumentType.Unknown]: '8',
    [ExcIceGsmV1InstrumentType.Option]: '9',
    [ExcIceGsmV1InstrumentType.ExchangeRate]: '10',
    [ExcIceGsmV1InstrumentType.CompositeUnit]: '11',
    [ExcIceGsmV1InstrumentType.Fund]: '12',
    [ExcIceGsmV1InstrumentType.OtherDerivatives]: '13',
    [ExcIceGsmV1InstrumentType.Entitlement]: '14',
    [ExcIceGsmV1InstrumentType.Index]: '15',
    [ExcIceGsmV1InstrumentType.Strategy]: '16'
} as const;

export enum ExcIceGsmV1IssueStatusReasonType {
    Unspecified = 'UNSPECIFIED',
    None = 'NONE',
    CallAnnounced = 'CALL_ANNOUNCED',
    CeasedTrading = 'CEASED_TRADING',
    Delisted = 'DELISTED',
    CallEffective = 'CALL_EFFECTIVE',
    PutEffective = 'PUT_EFFECTIVE',
    Exchanged = 'EXCHANGED',
    IssueConsolidationWithAnotherSeries = 'ISSUE_CONSOLIDATION_WITH_ANOTHER_SERIES',
    Unknown = 'UNKNOWN',
    Live = 'LIVE',
    Matured = 'MATURED',
    PutAnnounced = 'PUT_ANNOUNCED',
    Liquidated = 'LIQUIDATED',
    Reorganization = 'REORGANIZATION',
    IssuedInError = 'ISSUED_IN_ERROR',
    RepurchasedTendered = 'REPURCHASED_TENDERED',
    Suspended = 'SUSPENDED',
    Converted = 'CONVERTED',
    WarrantsDetachedOrExercised = 'WARRANTS_DETACHED_OR_EXERCISED',
    WarrantsExpired = 'WARRANTS_EXPIRED',
    FullyPrepaid = 'FULLY_PREPAID',
    DuplicateIssuedInError = 'DUPLICATE_ISSUED_IN_ERROR',
    MaturityAnnounced = 'MATURITY_ANNOUNCED',
    MergerAndAcquisition = 'MERGER_AND_ACQUISITION',
    AlsoTradingWhenIssuedWhenDistributed = 'ALSO_TRADING_WHEN_ISSUED_WHEN_DISTRIBUTED',
    Terminated = 'TERMINATED'
}

export const EXC_ICE_GSM_V1_ISSUE_STATUS_REASON_TYPE_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1IssueStatusReasonType.None]: 'None',
    [ExcIceGsmV1IssueStatusReasonType.CallAnnounced]: 'Call Announced',
    [ExcIceGsmV1IssueStatusReasonType.CeasedTrading]: 'Ceased Trading',
    [ExcIceGsmV1IssueStatusReasonType.Delisted]: 'Delisted',
    [ExcIceGsmV1IssueStatusReasonType.CallEffective]: 'Call Effective',
    [ExcIceGsmV1IssueStatusReasonType.PutEffective]: 'Put Effective',
    [ExcIceGsmV1IssueStatusReasonType.Exchanged]: 'Exchanged',
    [ExcIceGsmV1IssueStatusReasonType.IssueConsolidationWithAnotherSeries]: 'Issue Consolidation with another series',
    [ExcIceGsmV1IssueStatusReasonType.Unknown]: 'Unknown',
    [ExcIceGsmV1IssueStatusReasonType.Live]: 'Live',
    [ExcIceGsmV1IssueStatusReasonType.Matured]: 'Matured',
    [ExcIceGsmV1IssueStatusReasonType.PutAnnounced]: 'Put Announced',
    [ExcIceGsmV1IssueStatusReasonType.Liquidated]: 'Liquidated',
    [ExcIceGsmV1IssueStatusReasonType.Reorganization]: 'Reorganization',
    [ExcIceGsmV1IssueStatusReasonType.IssuedInError]: 'Issued in Error',
    [ExcIceGsmV1IssueStatusReasonType.RepurchasedTendered]: 'Repurchased/Tendered',
    [ExcIceGsmV1IssueStatusReasonType.Suspended]: 'Suspended',
    [ExcIceGsmV1IssueStatusReasonType.Converted]: 'Converted',
    [ExcIceGsmV1IssueStatusReasonType.WarrantsDetachedOrExercised]: 'Warrants Detached or Exercised',
    [ExcIceGsmV1IssueStatusReasonType.WarrantsExpired]: 'Warrants Expired',
    [ExcIceGsmV1IssueStatusReasonType.FullyPrepaid]: 'Fully Prepaid',
    [ExcIceGsmV1IssueStatusReasonType.DuplicateIssuedInError]: 'Duplicate Issued In Error',
    [ExcIceGsmV1IssueStatusReasonType.MaturityAnnounced]: 'Maturity Announced',
    [ExcIceGsmV1IssueStatusReasonType.MergerAndAcquisition]: 'Merger and Acquisition',
    [ExcIceGsmV1IssueStatusReasonType.AlsoTradingWhenIssuedWhenDistributed]: 'Also Trading When Issued/When Distributed',
    [ExcIceGsmV1IssueStatusReasonType.Terminated]: 'Terminated'
} as const;

export const EXC_ICE_GSM_V1_ISSUE_STATUS_REASON_TYPE_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1IssueStatusReasonType.None]: '0',
    [ExcIceGsmV1IssueStatusReasonType.CallAnnounced]: '1',
    [ExcIceGsmV1IssueStatusReasonType.CeasedTrading]: '2',
    [ExcIceGsmV1IssueStatusReasonType.Delisted]: '3',
    [ExcIceGsmV1IssueStatusReasonType.CallEffective]: '4',
    [ExcIceGsmV1IssueStatusReasonType.PutEffective]: '5',
    [ExcIceGsmV1IssueStatusReasonType.Exchanged]: '6',
    [ExcIceGsmV1IssueStatusReasonType.IssueConsolidationWithAnotherSeries]: '7',
    [ExcIceGsmV1IssueStatusReasonType.Unknown]: '8',
    [ExcIceGsmV1IssueStatusReasonType.Live]: '9',
    [ExcIceGsmV1IssueStatusReasonType.Matured]: '10',
    [ExcIceGsmV1IssueStatusReasonType.PutAnnounced]: '11',
    [ExcIceGsmV1IssueStatusReasonType.Liquidated]: '12',
    [ExcIceGsmV1IssueStatusReasonType.Reorganization]: '13',
    [ExcIceGsmV1IssueStatusReasonType.IssuedInError]: '14',
    [ExcIceGsmV1IssueStatusReasonType.RepurchasedTendered]: '15',
    [ExcIceGsmV1IssueStatusReasonType.Suspended]: '16',
    [ExcIceGsmV1IssueStatusReasonType.Converted]: '17',
    [ExcIceGsmV1IssueStatusReasonType.WarrantsDetachedOrExercised]: '18',
    [ExcIceGsmV1IssueStatusReasonType.WarrantsExpired]: '19',
    [ExcIceGsmV1IssueStatusReasonType.FullyPrepaid]: '20',
    [ExcIceGsmV1IssueStatusReasonType.DuplicateIssuedInError]: '21',
    [ExcIceGsmV1IssueStatusReasonType.MaturityAnnounced]: '22',
    [ExcIceGsmV1IssueStatusReasonType.MergerAndAcquisition]: '23',
    [ExcIceGsmV1IssueStatusReasonType.AlsoTradingWhenIssuedWhenDistributed]: '24',
    [ExcIceGsmV1IssueStatusReasonType.Terminated]: '25'
} as const;

export enum ExcIceGsmV1ListingStatusDetailType {
    Unspecified = 'UNSPECIFIED',
    Reinstated = 'REINSTATED',
    FutureDeletion = 'FUTURE_DELETION',
    SpecialSituation = 'SPECIAL_SITUATION',
    Replaced = 'REPLACED',
    NotTradable = 'NOT_TRADABLE',
    Deleted = 'DELETED',
    NotYetPricing = 'NOT_YET_PRICING',
    New = 'NEW',
    AfterSuspension = 'AFTER_SUSPENSION'
}

export const EXC_ICE_GSM_V1_LISTING_STATUS_DETAIL_TYPE_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1ListingStatusDetailType.Reinstated]: 'Reinstated',
    [ExcIceGsmV1ListingStatusDetailType.FutureDeletion]: 'Future Deletion',
    [ExcIceGsmV1ListingStatusDetailType.SpecialSituation]: 'Special Situation',
    [ExcIceGsmV1ListingStatusDetailType.Replaced]: 'Replaced',
    [ExcIceGsmV1ListingStatusDetailType.NotTradable]: 'Not Tradable',
    [ExcIceGsmV1ListingStatusDetailType.Deleted]: 'Deleted',
    [ExcIceGsmV1ListingStatusDetailType.NotYetPricing]: 'Not Yet Pricing',
    [ExcIceGsmV1ListingStatusDetailType.New]: 'New',
    [ExcIceGsmV1ListingStatusDetailType.AfterSuspension]: 'After Suspension'
} as const;

export const EXC_ICE_GSM_V1_LISTING_STATUS_DETAIL_TYPE_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1ListingStatusDetailType.Reinstated]: '1',
    [ExcIceGsmV1ListingStatusDetailType.FutureDeletion]: '2',
    [ExcIceGsmV1ListingStatusDetailType.SpecialSituation]: '3',
    [ExcIceGsmV1ListingStatusDetailType.Replaced]: '4',
    [ExcIceGsmV1ListingStatusDetailType.NotTradable]: '5',
    [ExcIceGsmV1ListingStatusDetailType.Deleted]: '6',
    [ExcIceGsmV1ListingStatusDetailType.NotYetPricing]: '7',
    [ExcIceGsmV1ListingStatusDetailType.New]: '8',
    [ExcIceGsmV1ListingStatusDetailType.AfterSuspension]: '9'
} as const;

export enum ExcIceGsmV1ListingTradingStatusType {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Suspension = 'SUSPENSION',
    AlsoTradingWhenIssued = 'ALSO_TRADING_WHEN_ISSUED',
    Delisted = 'DELISTED',
    Inactive = 'INACTIVE',
    WhenIssuedLine = 'WHEN_ISSUED_LINE'
}

export const EXC_ICE_GSM_V1_LISTING_TRADING_STATUS_TYPE_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1ListingTradingStatusType.Active]: 'Active',
    [ExcIceGsmV1ListingTradingStatusType.Suspension]: 'Suspension',
    [ExcIceGsmV1ListingTradingStatusType.AlsoTradingWhenIssued]: 'Also Trading When Issued',
    [ExcIceGsmV1ListingTradingStatusType.Delisted]: 'Delisted',
    [ExcIceGsmV1ListingTradingStatusType.Inactive]: 'Inactive',
    [ExcIceGsmV1ListingTradingStatusType.WhenIssuedLine]: 'When Issued Line'
} as const;

export const EXC_ICE_GSM_V1_LISTING_TRADING_STATUS_TYPE_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1ListingTradingStatusType.Active]: '1',
    [ExcIceGsmV1ListingTradingStatusType.Suspension]: '2',
    [ExcIceGsmV1ListingTradingStatusType.AlsoTradingWhenIssued]: '3',
    [ExcIceGsmV1ListingTradingStatusType.Delisted]: '4',
    [ExcIceGsmV1ListingTradingStatusType.Inactive]: '5',
    [ExcIceGsmV1ListingTradingStatusType.WhenIssuedLine]: '6'
} as const;

export interface ExcIceGsmV1Market {
    /* MIC code */
    marketCode?: string;
    /* Whether the instrument is currently listed on this market */
    status?: ExcIceGsmV1ListingTradingStatusType;
    /* Additional detail on the listing status */
    statusDetail?: ExcIceGsmV1ListingStatusDetailType;
    /* Listing date */
    // format: YYYY-MM-DD
    listingDate?: string;
    /* Delisting date */
    // format: YYYY-MM-DD
    delistingDate?: string;
    /* Country of quotation */
    country?: IsoV1Country;
}

export enum ExcIceGsmV1MuniFedTaxType {
    Unspecified = 'UNSPECIFIED',
    Unknown = 'UNKNOWN',
    SubjectToAmt = 'SUBJECT_TO_AMT',
    TaxExempt = 'TAX_EXEMPT',
    Taxable = 'TAXABLE'
}

export const EXC_ICE_GSM_V1_MUNI_FED_TAX_TYPE_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1MuniFedTaxType.Unknown]: 'Unknown',
    [ExcIceGsmV1MuniFedTaxType.SubjectToAmt]: 'Subject to AMT',
    [ExcIceGsmV1MuniFedTaxType.TaxExempt]: 'Tax-exempt',
    [ExcIceGsmV1MuniFedTaxType.Taxable]: 'Taxable'
} as const;

export const EXC_ICE_GSM_V1_MUNI_FED_TAX_TYPE_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1MuniFedTaxType.Unknown]: '0',
    [ExcIceGsmV1MuniFedTaxType.SubjectToAmt]: '1',
    [ExcIceGsmV1MuniFedTaxType.TaxExempt]: '2',
    [ExcIceGsmV1MuniFedTaxType.Taxable]: '3'
} as const;

export interface ExcIceGsmV1Organization {
    /* The primary name of the issuer */
    name: string;
    /* The abbreviated name of the issuer */
    abbreviatedName?: string;
    /* The country of the issuer */
    country?: IsoV1Country;
}

export enum ExcIceGsmV1PreferredType {
    Unspecified = 'UNSPECIFIED',
    None = 'NONE',
    AuctionRatePreferred = 'AUCTION_RATE_PREFERRED',
    PibsPermanentInterestBearingShares = 'PIBS_PERMANENT_INTEREST_BEARING_SHARES',
    Genusschein = 'GENUSSCHEIN',
    OtherParticipatingShares = 'OTHER_PARTICIPATING_SHARES',
    Risparmio = 'RISPARMIO'
}

export const EXC_ICE_GSM_V1_PREFERRED_TYPE_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1PreferredType.None]: 'None',
    [ExcIceGsmV1PreferredType.AuctionRatePreferred]: 'Auction Rate Preferred',
    [ExcIceGsmV1PreferredType.PibsPermanentInterestBearingShares]: 'PIBS (Permanent Interest Bearing Shares)',
    [ExcIceGsmV1PreferredType.Genusschein]: 'Genusschein',
    [ExcIceGsmV1PreferredType.OtherParticipatingShares]: 'Other Participating Shares',
    [ExcIceGsmV1PreferredType.Risparmio]: 'Risparmio'
} as const;

export const EXC_ICE_GSM_V1_PREFERRED_TYPE_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1PreferredType.None]: '0',
    [ExcIceGsmV1PreferredType.AuctionRatePreferred]: '1',
    [ExcIceGsmV1PreferredType.PibsPermanentInterestBearingShares]: '2',
    [ExcIceGsmV1PreferredType.Genusschein]: '3',
    [ExcIceGsmV1PreferredType.OtherParticipatingShares]: '4',
    [ExcIceGsmV1PreferredType.Risparmio]: '5'
} as const;

export interface ExcIceGsmV1Sector {
    /* Cross-asset sector classification */
    sector?: ExcIceGsmV1GsmIndustrySector;
    detail?: ExcIceGsmV1SectorSectorDetail;
}

export interface ExcIceGsmV1SectorSectorDetail {
    /* Level 1 sector classification */
    class?: ExcIceGsmV1IceAssetClass;
    /* Level 2 sector classification */
    group?: ExcIceGsmV1IceGroup;
    /* Level 3 sector classification */
    category?: ExcIceGsmV1IceCategory;
    /* Level 4 sector classification */
    subCategory?: ExcIceGsmV1IceSubcategory;
}

export interface ExcIceGsmV1Trading {
    /* Whether the instrument is currently listed */
    listingStatus?: ExcIceGsmV1ListingTradingStatusType;
    /* Additional detail on the listing status */
    listingStatusDetail?: ExcIceGsmV1ListingStatusDetailType;
    /* Listing effective date */
    // format: YYYY-MM-DD
    listingDate?: string;
    /* Delisting effective date */
    // format: YYYY-MM-DD
    delistingDate?: string;
}

export enum ExcIceGsmV1WarrantType {
    Unspecified = 'UNSPECIFIED',
    None = 'NONE',
    Covered = 'COVERED',
    Equity = 'EQUITY'
}

export const EXC_ICE_GSM_V1_WARRANT_TYPE_INFO_EXTENSION_LABEL_MAP = {
    [ExcIceGsmV1WarrantType.None]: 'None',
    [ExcIceGsmV1WarrantType.Covered]: 'Covered',
    [ExcIceGsmV1WarrantType.Equity]: 'Equity'
} as const;

export const EXC_ICE_GSM_V1_WARRANT_TYPE_INFO_EXTENSION_TEXT_MAP = {
    [ExcIceGsmV1WarrantType.None]: '0',
    [ExcIceGsmV1WarrantType.Covered]: '1',
    [ExcIceGsmV1WarrantType.Equity]: '2'
} as const;

export interface ExcIceGsmV1XmlLocation {
    bucket: string;
    key: string;
    /* Byte offset of the element within the file */
    // format: UINT64
    offset: string;
    /* Length of the element in bytes */
    // format: UINT64
    length: string;
}

export type ExcIceJobV1BatchToken = {
    '!type'?: 'fileOffset';
    /* A position in a file */
    fileOffset: ExcIceJobV1BatchTokenFileOffset;
} | {
    '!type'?: 'afterInstrument';
    /* A position in the instrument table, ordered by instrument ID */
    afterInstrument: ExcIceJobV1BatchTokenAfterInstrument;
};

export interface ExcIceJobV1BatchTokenAfterInstrument {
    /* The last instrument ID of the previous batch */
    instrumentId: string;
}

export interface ExcIceJobV1BatchTokenFileOffset {
    /* Byte offset in the file */
    // format: UINT64
    offset: string;
}

export const EXC_ICE_JOB_V1_BATCH_TOKEN_ONE_OF_VALUES = ['fileOffset', 'afterInstrument'] as const;

export type ExcIceJobV1BatchTokenOneOfValue = (typeof EXC_ICE_JOB_V1_BATCH_TOKEN_ONE_OF_VALUES)[number];

export interface ExcIceJobV1CorpActionFileJobSpec {
    /* The Corporate Actions file being ingested */
    file: ExcIceJobV1IceFile;
}

export interface ExcIceJobV1CorpActionTaskSpec {
    /* The event ID of the corporate action being processed */
    eventId: string;
    /* The timestamp of the file being processed */
    // format: date-time
    timestamp: string;
    /* Location of the corporate action's raw XML */
    xmlLocation: ExcIceGsmV1XmlLocation;
}

export interface ExcIceJobV1ExportInstrumentsJobSpec {
    /* The date the export is for, which names its file. An export of the same date replaces the earlier one */
    // format: YYYY-MM-DD
    date: string;
}

export interface ExcIceJobV1IceFile {
    bucket: string;
    key: string;
    /* Timestamp from the file's header */
    // format: date-time
    timestamp: string;
    /* Size of the file in bytes, when known */
    // format: UINT64
    size?: string;
}

export interface ExcIceJobV1InstrumentFileJobSpec {
    /* The Global Security Master file being ingested */
    file: ExcIceJobV1IceFile;
}

export interface ExcIceJobV1InstrumentTaskSpec {
    /* The ID of the instrument being processed */
    instrumentId: string;
    /* The timestamp of the file being processed */
    // format: date-time
    timestamp: string;
    /* Location of the instrument's raw XML */
    xmlLocation: ExcIceGsmV1XmlLocation;
}

export interface ExcIceJobV1JobData {
    /* What the job works through, by its type */
    spec: ExcIceJobV1JobSpec;
    /* Where the next batch starts */
    cursor?: ExcIceJobV1BatchToken;
    metrics: ExcIceJobV1Metrics;
    /* What the job produced, when its type produces something */
    result?: ExcIceJobV1JobResult;
    /* Why the job failed */
    failure?: string;
}

export interface ExcIceJobV1JobEvent extends ExcIceJobV1JobKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcIceJobV1JobEventType;
}

export type ExcIceJobV1JobEventType = {
    '!type'?: 'created';
    created: ExcIceJobV1JobEventTypeCreated;
} | {
    '!type'?: 'batchDone';
    batchDone: ExcIceJobV1JobEventTypeBatchDone;
} | {
    '!type'?: 'metricsUpdated';
    metricsUpdated: ExcIceJobV1JobEventTypeMetricsUpdated;
} | {
    '!type'?: 'allCreated';
    allCreated: EmptyObject;
} | {
    '!type'?: 'allFinished';
    allFinished: EmptyObject;
} | {
    '!type'?: 'failed';
    failed: ExcIceJobV1JobEventTypeFailed;
} | {
    '!type'?: 'canceled';
    canceled: EmptyObject;
};

export interface ExcIceJobV1JobEventTypeBatchDone {
    /* Where the next batch starts, unset when this was the last batch */
    next?: ExcIceJobV1BatchToken;
    /* Tasks created by the batch, or items it did inline. Zero when everything in the batch was skipped */
    // format: UINT32
    count?: number;
    /* The batch did its work itself, rather than creating tasks */
    inline?: boolean;
    /* Estimated percentage of the job's batches which have been processed, when known */
    // format: FLOAT64
    percentCreated?: number;
    /* What the job produced, usually set by its last batch */
    result?: ExcIceJobV1JobResult;
}

export interface ExcIceJobV1JobEventTypeCreated {
    spec: ExcIceJobV1JobSpec;
}

export interface ExcIceJobV1JobEventTypeFailed {
    message: string;
}

export interface ExcIceJobV1JobEventTypeMetricsUpdated {
    // format: UINT32
    pending?: number;
    // format: UINT32
    succeeded?: number;
    // format: UINT32
    errored?: number;
    // format: UINT32
    failed?: number;
}

export const EXC_ICE_JOB_V1_JOB_EVENT_TYPE_ONE_OF_VALUES = ['created', 'batchDone', 'metricsUpdated', 'allCreated', 'allFinished', 'failed', 'canceled'] as const;

export type ExcIceJobV1JobEventTypeOneOfValue = (typeof EXC_ICE_JOB_V1_JOB_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcIceJobV1JobKeys {
    // format: id62
    jobId: string;
}

export interface ExcIceJobV1JobQueryServiceJobEventsJobEventsRequest {
    // format: id62
    jobId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcIceJobV1JobQueryServiceJobEventsSortableFields, ExcIceJobV1JobQueryServiceJobEventsFilterableFields>;
}

export enum ExcIceJobV1JobQueryServiceJobEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    JobId = 'jobId',
    EventType = 'event.!type'
}

export enum ExcIceJobV1JobQueryServiceJobEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcIceJobV1JobQueryServiceJobGetJobGetRequest {
    // format: id62
    jobId: string;
}

export interface ExcIceJobV1JobQueryServiceJobListJobListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcIceJobV1JobQueryServiceJobListSortableFields, ExcIceJobV1JobQueryServiceJobListFilterableFields>;
}

export enum ExcIceJobV1JobQueryServiceJobListFilterableFields {
    JobId = 'jobId',
    DataSpecType = 'data.spec.!type',
    Status = 'status'
}

export enum ExcIceJobV1JobQueryServiceJobListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export type ExcIceJobV1JobResult = {
    '!type'?: 'file';
    file: ExcIceJobV1OutputFile;
};

export const EXC_ICE_JOB_V1_JOB_RESULT_ONE_OF_VALUES = ['file'] as const;

export type ExcIceJobV1JobResultOneOfValue = (typeof EXC_ICE_JOB_V1_JOB_RESULT_ONE_OF_VALUES)[number];

export type ExcIceJobV1JobSpec = {
    '!type'?: 'instrumentFile';
    instrumentFile: ExcIceJobV1InstrumentFileJobSpec;
} | {
    '!type'?: 'corpActionFile';
    corpActionFile: ExcIceJobV1CorpActionFileJobSpec;
} | {
    '!type'?: 'reparseInstruments';
    reparseInstruments: ExcIceJobV1ReparseInstrumentsJobSpec;
} | {
    '!type'?: 'exportInstruments';
    exportInstruments: ExcIceJobV1ExportInstrumentsJobSpec;
};

export const EXC_ICE_JOB_V1_JOB_SPEC_ONE_OF_VALUES = ['instrumentFile', 'corpActionFile', 'reparseInstruments', 'exportInstruments'] as const;

export type ExcIceJobV1JobSpecOneOfValue = (typeof EXC_ICE_JOB_V1_JOB_SPEC_ONE_OF_VALUES)[number];

export interface ExcIceJobV1JobState extends ExcIceJobV1JobKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcIceJobV1JobData;
    status: ExcIceJobV1JobStatus;
}

export enum ExcIceJobV1JobStatus {
    Unspecified = 'UNSPECIFIED',
    Creating = 'CREATING',
    Processing = 'PROCESSING',
    Done = 'DONE',
    Failed = 'FAILED',
    Canceled = 'CANCELED'
}

export interface ExcIceJobV1Metrics {
    /* Batches processed so far */
    // format: UINT32
    batches?: number;
    /* Items of work found so far: tasks created, or items done inline */
    // format: UINT32
    total?: number;
    /* Tasks created but not yet finished */
    // format: UINT32
    pending?: number;
    /* Items finished successfully */
    // format: UINT32
    succeeded?: number;
    /* Tasks which hit an error in their own record */
    // format: UINT32
    errored?: number;
    /* Tasks which hit an error at an upstream vendor */
    // format: UINT32
    failed?: number;
    /* Estimated percentage of the job's batches which have been processed */
    // format: FLOAT64
    percentCreated?: number;
    /* Estimated percentage of the job's work which has finished */
    // format: FLOAT64
    percentCompleted?: number;
}

export interface ExcIceJobV1OutputFile {
    bucket: string;
    key: string;
    /* Size of the file in bytes, when known */
    // format: UINT64
    size?: string;
}

export interface ExcIceJobV1ReparseInstrumentsJobSpec {
    /* Why the reparse was run, e.g. the parser change it picks up */
    reason?: string;
}

export interface ExcIceJobV1TaskCommandServiceGetTaskXmlGetTaskXmlRequest {
    // format: id62
    taskId: string;
}

export interface ExcIceJobV1TaskData {
    /* What the task processes */
    spec: ExcIceJobV1TaskSpec;
}

export interface ExcIceJobV1TaskEvent extends ExcIceJobV1TaskKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcIceJobV1TaskEventType;
}

export type ExcIceJobV1TaskEventType = {
    '!type'?: 'created';
    created: ExcIceJobV1TaskEventTypeCreated;
} | {
    '!type'?: 'processing';
    processing: EmptyObject;
} | {
    '!type'?: 'finished';
    finished: EmptyObject;
} | {
    '!type'?: 'errored';
    errored: ExcIceJobV1TaskEventTypeErrored;
} | {
    '!type'?: 'failed';
    failed: ExcIceJobV1TaskEventTypeFailed;
};

export interface ExcIceJobV1TaskEventTypeCreated {
    spec: ExcIceJobV1TaskSpec;
}

export interface ExcIceJobV1TaskEventTypeErrored {
    /* Optional error message */
    message?: string;
}

export interface ExcIceJobV1TaskEventTypeFailed {
    /* Optional error message */
    message?: string;
}

export const EXC_ICE_JOB_V1_TASK_EVENT_TYPE_ONE_OF_VALUES = ['created', 'processing', 'finished', 'errored', 'failed'] as const;

export type ExcIceJobV1TaskEventTypeOneOfValue = (typeof EXC_ICE_JOB_V1_TASK_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcIceJobV1TaskKeys {
    // format: id62
    taskId: string;
    // format: id62, entity: exc.ice.job.v1.Job
    jobId: string;
}

export interface ExcIceJobV1TaskQueryServiceTaskEventsTaskEventsRequest {
    // format: id62
    taskId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcIceJobV1TaskQueryServiceTaskEventsSortableFields, ExcIceJobV1TaskQueryServiceTaskEventsFilterableFields>;
}

export enum ExcIceJobV1TaskQueryServiceTaskEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    TaskId = 'taskId',
    JobId = 'jobId',
    EventType = 'event.!type'
}

export enum ExcIceJobV1TaskQueryServiceTaskEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcIceJobV1TaskQueryServiceTaskGetTaskGetRequest {
    // format: id62
    taskId: string;
}

export interface ExcIceJobV1TaskQueryServiceTaskListTaskListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcIceJobV1TaskQueryServiceTaskListSortableFields, ExcIceJobV1TaskQueryServiceTaskListFilterableFields>;
}

export enum ExcIceJobV1TaskQueryServiceTaskListFilterableFields {
    TaskId = 'taskId',
    JobId = 'jobId',
    Status = 'status'
}

export enum ExcIceJobV1TaskQueryServiceTaskListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export type ExcIceJobV1TaskSpec = {
    '!type'?: 'instrument';
    instrument: ExcIceJobV1InstrumentTaskSpec;
} | {
    '!type'?: 'corpAction';
    corpAction: ExcIceJobV1CorpActionTaskSpec;
};

export const EXC_ICE_JOB_V1_TASK_SPEC_ONE_OF_VALUES = ['instrument', 'corpAction'] as const;

export type ExcIceJobV1TaskSpecOneOfValue = (typeof EXC_ICE_JOB_V1_TASK_SPEC_ONE_OF_VALUES)[number];

export interface ExcIceJobV1TaskState extends ExcIceJobV1TaskKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcIceJobV1TaskData;
    status: ExcIceJobV1TaskStatus;
}

export enum ExcIceJobV1TaskStatus {
    Unspecified = 'UNSPECIFIED',
    Created = 'CREATED',
    Processing = 'PROCESSING',
    Succeeded = 'SUCCEEDED',
    Errored = 'ERRORED',
    Failed = 'FAILED'
}

export interface ExcIncreaseV1AccountNumberData {
    spec: ExcIncreaseV1AccountNumberSpec;
    routingNumber?: string;
    accountNumber?: string;
    // format: custom - pattern: ^.*$
    increaseId?: string;
}

export interface ExcIncreaseV1AccountNumberEvent extends IxcFundingV1AccountNumberKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcIncreaseV1AccountNumberEventType;
}

export type ExcIncreaseV1AccountNumberEventType = {
    '!type'?: 'requested';
    requested: ExcIncreaseV1AccountNumberEventTypeRequested;
} | {
    '!type'?: 'created';
    created: ExcIncreaseV1AccountNumberEventTypeCreated;
} | {
    '!type'?: 'disabled';
    disabled: EmptyObject;
} | {
    '!type'?: 'reenabled';
    reenabled: EmptyObject;
};

export interface ExcIncreaseV1AccountNumberEventTypeCreated {
    increaseId: string;
    // pattern: ^[0-9]{9}$
    routingNumber: string;
    // pattern: ^[0-9]{4,17}$
    accountNumber: string;
    name: string;
}

export interface ExcIncreaseV1AccountNumberEventTypeRequested {
    spec: ExcIncreaseV1AccountNumberSpec;
}

export const EXC_INCREASE_V1_ACCOUNT_NUMBER_EVENT_TYPE_ONE_OF_VALUES = ['requested', 'created', 'disabled', 'reenabled'] as const;

export type ExcIncreaseV1AccountNumberEventTypeOneOfValue = (typeof EXC_INCREASE_V1_ACCOUNT_NUMBER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcIncreaseV1AccountNumberKeys {
    /* Our system's unique identifier for the account number at Increase. */
    // format: id62
    accountNumberId: string;
}

export interface ExcIncreaseV1AccountNumberQueryServiceAccountNumberEventsAccountNumberEventsRequest {
    /* Our system's unique identifier for the account number at Increase. */
    // format: id62
    accountNumberId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcIncreaseV1AccountNumberQueryServiceAccountNumberEventsSortableFields, ExcIncreaseV1AccountNumberQueryServiceAccountNumberEventsFilterableFields>;
}

export enum ExcIncreaseV1AccountNumberQueryServiceAccountNumberEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AccountNumberId = 'accountNumberId',
    EventRequestedSpecAccountId = 'event.requested.spec.accountId',
    EventRequestedSpecProgramId = 'event.requested.spec.programId',
    EventType = 'event.!type'
}

export enum ExcIncreaseV1AccountNumberQueryServiceAccountNumberEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcIncreaseV1AccountNumberQueryServiceAccountNumberGetAccountNumberGetRequest {
    /* Our system's unique identifier for the account number at Increase. */
    // format: id62
    accountNumberId: string;
}

export interface ExcIncreaseV1AccountNumberQueryServiceAccountNumberListAccountNumberListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcIncreaseV1AccountNumberQueryServiceAccountNumberListSortableFields, ExcIncreaseV1AccountNumberQueryServiceAccountNumberListFilterableFields>;
}

export enum ExcIncreaseV1AccountNumberQueryServiceAccountNumberListFilterableFields {
    AccountNumberId = 'accountNumberId',
    DataSpecAccountId = 'data.spec.accountId',
    DataSpecProgramId = 'data.spec.programId',
    DataIncreaseId = 'data.increaseId',
    Status = 'status'
}

export enum ExcIncreaseV1AccountNumberQueryServiceAccountNumberListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcIncreaseV1AccountNumberSpec {
    /* The Increase account ID this account number will route to. */
    parentIncreaseAccountId?: string;
    inboundAchDebitAllowed?: boolean;
    name: string;
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
}

export interface ExcIncreaseV1AccountNumberState extends ExcIncreaseV1AccountNumberKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcIncreaseV1AccountNumberData;
    status: ExcIncreaseV1AccountNumberStatus;
}

export enum ExcIncreaseV1AccountNumberStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Active = 'ACTIVE',
    Disabled = 'DISABLED'
}

export interface ExcIncreaseV1AchData {
    spec: ExcIncreaseV1AchSpec;
    // format: custom - pattern: ^.*$
    increaseId?: string;
    notificationOfChange?: ExcIncreaseV1NotificationOfChange[];
}

export interface ExcIncreaseV1AchEvent extends IxcPaymentsV1AchKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcIncreaseV1AchEventType;
}

export type ExcIncreaseV1AchEventType = {
    '!type'?: 'posted';
    posted: ExcIncreaseV1AchEventTypePosted;
} | {
    '!type'?: 'accepted';
    accepted: ExcIncreaseV1AchEventTypeAccepted;
} | {
    '!type'?: 'submitted';
    submitted: ExcIncreaseV1AchEventTypeSubmitted;
} | {
    '!type'?: 'rejected';
    rejected: ExcIncreaseV1AchEventTypeRejected;
} | {
    '!type'?: 'returned';
    returned: ExcIncreaseV1AchEventTypeReturned;
} | {
    '!type'?: 'settled';
    settled: EmptyObject;
} | {
    '!type'?: 'noC';
    noC: ExcIncreaseV1AchEventTypeNoC;
};

export interface ExcIncreaseV1AchEventTypeAccepted {
    spec: ExcIncreaseV1AchSpec;
    increaseId: string;
    // format: id62, entity: ixc.increase.v1.AccountNumber
    accountNumberId?: string;
}

export interface ExcIncreaseV1AchEventTypeNoC {
    noc: ExcIncreaseV1NotificationOfChange;
}

export interface ExcIncreaseV1AchEventTypePosted {
    spec: ExcIncreaseV1AchSpec;
}

export interface ExcIncreaseV1AchEventTypeRejected {
    reason?: string;
}

export interface ExcIncreaseV1AchEventTypeReturned {
    reason: string;
}

export interface ExcIncreaseV1AchEventTypeSubmitted {
    increaseId: string;
}

export const EXC_INCREASE_V1_ACH_EVENT_TYPE_ONE_OF_VALUES = ['posted', 'accepted', 'submitted', 'rejected', 'returned', 'settled', 'noC'] as const;

export type ExcIncreaseV1AchEventTypeOneOfValue = (typeof EXC_INCREASE_V1_ACH_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcIncreaseV1AchKeys {
    // format: id62
    achId: string;
}

export interface ExcIncreaseV1AchQueryServiceAchEventsAchEventsRequest {
    // format: id62
    achId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<ExcIncreaseV1AchQueryServiceAchEventsSearchableFields, ExcIncreaseV1AchQueryServiceAchEventsSortableFields, ExcIncreaseV1AchQueryServiceAchEventsFilterableFields>;
}

export enum ExcIncreaseV1AchQueryServiceAchEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AchId = 'achId',
    EventPostedSpecAccountId = 'event.posted.spec.accountId',
    EventPostedSpecProgramId = 'event.posted.spec.programId',
    EventPostedSpecSourceId = 'event.posted.spec.sourceId',
    EventPostedSpecTransferId = 'event.posted.spec.transferId',
    EventAcceptedSpecAccountId = 'event.accepted.spec.accountId',
    EventAcceptedSpecProgramId = 'event.accepted.spec.programId',
    EventAcceptedSpecSourceId = 'event.accepted.spec.sourceId',
    EventAcceptedSpecTransferId = 'event.accepted.spec.transferId',
    EventType = 'event.!type'
}

export enum ExcIncreaseV1AchQueryServiceAchEventsSearchableFields {
    EventPostedSpecBankDetailsAccountNumber = 'event.posted.spec.bankDetails.accountNumber',
    EventAcceptedSpecBankDetailsAccountNumber = 'event.accepted.spec.bankDetails.accountNumber'
}

export enum ExcIncreaseV1AchQueryServiceAchEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcIncreaseV1AchQueryServiceAchGetAchGetRequest {
    // format: id62
    achId: string;
}

export interface ExcIncreaseV1AchQueryServiceAchListAchListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<ExcIncreaseV1AchQueryServiceAchListSearchableFields, ExcIncreaseV1AchQueryServiceAchListSortableFields, ExcIncreaseV1AchQueryServiceAchListFilterableFields>;
}

export enum ExcIncreaseV1AchQueryServiceAchListFilterableFields {
    AchId = 'achId',
    DataSpecAccountId = 'data.spec.accountId',
    DataSpecProgramId = 'data.spec.programId',
    DataSpecSourceId = 'data.spec.sourceId',
    DataSpecTransferId = 'data.spec.transferId',
    DataIncreaseId = 'data.increaseId',
    Status = 'status'
}

export enum ExcIncreaseV1AchQueryServiceAchListSearchableFields {
    DataSpecBankDetailsAccountNumber = 'data.spec.bankDetails.accountNumber'
}

export enum ExcIncreaseV1AchQueryServiceAchListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcIncreaseV1AchSpec {
    // format: id62
    achId?: string;
    /* Negative amount is a pull from the Interchange account, positive is a
    push to the account */
    // format: decimal
    amount?: string;
    bankDetails?: IxcFundingV1UsBankDetails;
    companyName?: string;
    companyDescriptiveDate?: string;
    sameDay?: boolean;
    /* True if Interchange systems didn't initiate the transfer */
    isInbound?: boolean;
    ownerType: IxcFundingV1BankAccountOwnerType;
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
    // format: id62, entity: ixc.funding.v1.Source
    sourceId?: string;
    // format: id62
    transferId?: string;
}

export interface ExcIncreaseV1AchState extends ExcIncreaseV1AchKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcIncreaseV1AchData;
    status: ExcIncreaseV1AchStatus;
}

export enum ExcIncreaseV1AchStatus {
    Unspecified = 'UNSPECIFIED',
    Posted = 'POSTED',
    Settled = 'SETTLED',
    Returned = 'RETURNED',
    Rejected = 'REJECTED'
}

export interface ExcIncreaseV1NotificationOfChange {
    changeCode?: string;
    correctedData?: string;
    // format: YYYY-MM-DD
    createdAt?: string;
}

export interface ExcIncreaseV1WireData {
    spec: ExcIncreaseV1WireSpec;
    // format: custom - pattern: ^.*$
    increaseId?: string;
}

export interface ExcIncreaseV1WireEvent extends IxcPaymentsV1WireKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcIncreaseV1WireEventType;
}

export type ExcIncreaseV1WireEventType = {
    '!type'?: 'posted';
    posted: ExcIncreaseV1WireEventTypePosted;
} | {
    '!type'?: 'submitted';
    submitted: ExcIncreaseV1WireEventTypeSubmitted;
} | {
    '!type'?: 'rejected';
    rejected: EmptyObject;
} | {
    '!type'?: 'reversed';
    reversed: EmptyObject;
} | {
    '!type'?: 'settled';
    settled: ExcIncreaseV1WireEventTypeSettled;
} | {
    '!type'?: 'accepted';
    accepted: ExcIncreaseV1WireEventTypeAccepted;
};

export interface ExcIncreaseV1WireEventTypeAccepted {
    spec: ExcIncreaseV1WireSpec;
    increaseId: string;
    inputMessageAccountabilityData?: string;
    // format: id62, entity: ixc.increase.v1.AccountNumber
    accountNumberId?: string;
}

export interface ExcIncreaseV1WireEventTypePosted {
    spec: ExcIncreaseV1WireSpec;
}

export interface ExcIncreaseV1WireEventTypeSettled {
    // format: YYYY-MM-DD
    fedwireSubmission?: string;
    inputMessageAccountabilityData?: string;
}

export interface ExcIncreaseV1WireEventTypeSubmitted {
    increaseId: string;
}

export const EXC_INCREASE_V1_WIRE_EVENT_TYPE_ONE_OF_VALUES = ['posted', 'submitted', 'rejected', 'reversed', 'settled', 'accepted'] as const;

export type ExcIncreaseV1WireEventTypeOneOfValue = (typeof EXC_INCREASE_V1_WIRE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcIncreaseV1WireKeys {
    // format: id62
    wireId: string;
}

export interface ExcIncreaseV1WireQueryServiceWireEventsWireEventsRequest {
    // format: id62
    wireId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<ExcIncreaseV1WireQueryServiceWireEventsSearchableFields, ExcIncreaseV1WireQueryServiceWireEventsSortableFields, ExcIncreaseV1WireQueryServiceWireEventsFilterableFields>;
}

export enum ExcIncreaseV1WireQueryServiceWireEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    WireId = 'wireId',
    EventPostedSpecAccountId = 'event.posted.spec.accountId',
    EventPostedSpecProgramId = 'event.posted.spec.programId',
    EventPostedSpecSourceId = 'event.posted.spec.sourceId',
    EventPostedSpecTransferId = 'event.posted.spec.transferId',
    EventAcceptedSpecAccountId = 'event.accepted.spec.accountId',
    EventAcceptedSpecProgramId = 'event.accepted.spec.programId',
    EventAcceptedSpecSourceId = 'event.accepted.spec.sourceId',
    EventAcceptedSpecTransferId = 'event.accepted.spec.transferId',
    EventType = 'event.!type'
}

export enum ExcIncreaseV1WireQueryServiceWireEventsSearchableFields {
    EventPostedSpecBankDetailsAccountNumber = 'event.posted.spec.bankDetails.accountNumber',
    EventAcceptedSpecBankDetailsAccountNumber = 'event.accepted.spec.bankDetails.accountNumber'
}

export enum ExcIncreaseV1WireQueryServiceWireEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcIncreaseV1WireQueryServiceWireGetWireGetRequest {
    // format: id62
    wireId: string;
}

export interface ExcIncreaseV1WireQueryServiceWireListWireListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<ExcIncreaseV1WireQueryServiceWireListSearchableFields, ExcIncreaseV1WireQueryServiceWireListSortableFields, ExcIncreaseV1WireQueryServiceWireListFilterableFields>;
}

export enum ExcIncreaseV1WireQueryServiceWireListFilterableFields {
    WireId = 'wireId',
    DataSpecAccountId = 'data.spec.accountId',
    DataSpecProgramId = 'data.spec.programId',
    DataSpecSourceId = 'data.spec.sourceId',
    DataSpecTransferId = 'data.spec.transferId',
    DataIncreaseId = 'data.increaseId',
    Status = 'status'
}

export enum ExcIncreaseV1WireQueryServiceWireListSearchableFields {
    DataSpecBankDetailsAccountNumber = 'data.spec.bankDetails.accountNumber'
}

export enum ExcIncreaseV1WireQueryServiceWireListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcIncreaseV1WireSpec {
    // format: id62
    wireId?: string;
    /* Negative amount is a pull from the Interchange account, positive is a
    push to the account */
    // format: decimal
    amount?: string;
    bankDetails: IxcFundingV1UsBankDetails;
    beneficiary?: IxcFundingV1NameAndAddress;
    originator?: IxcFundingV1NameAndAddress;
    messageToRecipient?: string;
    /* True if Interchange systems didn't initiate the transfer */
    isInbound?: boolean;
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
    // format: id62, entity: ixc.funding.v1.Source
    sourceId?: string;
    // format: id62, entity: ixc.funding.v1.Transfer
    transferId?: string;
    // format: YYYY-MM-DD
    fedwireSubmission?: string;
    inputMessageAccountabilityData?: string;
}

export interface ExcIncreaseV1WireState extends ExcIncreaseV1WireKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcIncreaseV1WireData;
    status: ExcIncreaseV1WireStatus;
}

export enum ExcIncreaseV1WireStatus {
    Unspecified = 'UNSPECIFIED',
    Posted = 'POSTED',
    Settled = 'SETTLED',
    Reversed = 'REVERSED',
    Rejected = 'REJECTED'
}

export interface ExcJaneStreetV1PfofCounts {
    // format: UINT32
    rowsParsed?: number;
    // format: UINT32
    rowsAffected?: number;
}

export interface ExcJaneStreetV1PfofFile {
    bucket: string;
    key: string;
}

export interface ExcJaneStreetV1PfofJobData {
    file: ExcJaneStreetV1PfofFile;
}

export interface ExcJaneStreetV1PfofJobEvent extends ExcJaneStreetV1PfofJobKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcJaneStreetV1PfofJobEventType;
}

export type ExcJaneStreetV1PfofJobEventType = {
    '!type'?: 'received';
    received: ExcJaneStreetV1PfofJobEventTypeReceived;
} | {
    '!type'?: 'processed';
    processed: ExcJaneStreetV1PfofJobEventTypeProcessed;
} | {
    '!type'?: 'failed';
    failed: ExcJaneStreetV1PfofJobEventTypeFailed;
};

export interface ExcJaneStreetV1PfofJobEventTypeFailed {
    message: string;
}

export interface ExcJaneStreetV1PfofJobEventTypeProcessed {
    counts?: ExcJaneStreetV1PfofCounts;
}

export interface ExcJaneStreetV1PfofJobEventTypeReceived {
    file: ExcJaneStreetV1PfofFile;
}

export const EXC_JANE_STREET_V1_PFOF_JOB_EVENT_TYPE_ONE_OF_VALUES = ['received', 'processed', 'failed'] as const;

export type ExcJaneStreetV1PfofJobEventTypeOneOfValue = (typeof EXC_JANE_STREET_V1_PFOF_JOB_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcJaneStreetV1PfofJobKeys {
    // format: id62
    jobId: string;
}

export interface ExcJaneStreetV1PfofJobQueryServicePfofJobEventsPfofJobEventsRequest {
    // format: id62
    jobId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcJaneStreetV1PfofJobQueryServicePfofJobEventsSortableFields, ExcJaneStreetV1PfofJobQueryServicePfofJobEventsFilterableFields>;
}

export enum ExcJaneStreetV1PfofJobQueryServicePfofJobEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    JobId = 'jobId',
    EventType = 'event.!type'
}

export enum ExcJaneStreetV1PfofJobQueryServicePfofJobEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcJaneStreetV1PfofJobQueryServicePfofJobGetPfofJobGetRequest {
    // format: id62
    jobId: string;
}

export interface ExcJaneStreetV1PfofJobQueryServicePfofJobListPfofJobListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcJaneStreetV1PfofJobQueryServicePfofJobListSortableFields, ExcJaneStreetV1PfofJobQueryServicePfofJobListFilterableFields>;
}

export enum ExcJaneStreetV1PfofJobQueryServicePfofJobListFilterableFields {
    JobId = 'jobId',
    Status = 'status'
}

export enum ExcJaneStreetV1PfofJobQueryServicePfofJobListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcJaneStreetV1PfofJobState extends ExcJaneStreetV1PfofJobKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcJaneStreetV1PfofJobData;
    status: ExcJaneStreetV1PfofJobStatus;
}

export enum ExcJaneStreetV1PfofJobStatus {
    Unspecified = 'UNSPECIFIED',
    Received = 'RECEIVED',
    Processed = 'PROCESSED',
    Failed = 'FAILED'
}

export interface ExcJpmamEmulatorV1Position {
    accountId: string;
    cusip: string;
    // format: decimal
    shares: string;
}

export interface ExcJpmamEmulatorV1PositionServiceGetPositionsGetPositionsRequest {
    accountId: string;
}

export enum ExcJpmamV1Action {
    Unspecified = 'UNSPECIFIED',
    Purchase = 'PURCHASE',
    Redeem = 'REDEEM',
    FullRedemption = 'FULL_REDEMPTION'
}

export interface ExcJpmamV1CustomerOrderRef {
    /* The originating mutual funds order. */
    // format: id62, entity: ixc.mutualfunds.v1.FundOrder
    orderId: string;
    /* The customer account the order was placed for */
    // format: id62
    accountId: string;
    /* The program the account belongs to */
    // format: id62
    programId: string;
}

export interface ExcJpmamV1DestinationData {
    spec: ExcJpmamV1DestinationSpec;
}

export interface ExcJpmamV1DestinationEvent extends ExcJpmamV1DestinationKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcJpmamV1DestinationEventType;
}

export type ExcJpmamV1DestinationEventType = {
    '!type'?: 'created';
    created: ExcJpmamV1DestinationEventTypeCreated;
} | {
    '!type'?: 'updated';
    updated: ExcJpmamV1DestinationEventTypeUpdated;
};

export interface ExcJpmamV1DestinationEventTypeCreated {
    spec: ExcJpmamV1DestinationSpec;
}

export interface ExcJpmamV1DestinationEventTypeUpdated {
    spec: ExcJpmamV1DestinationSpec;
}

export const EXC_JPMAM_V1_DESTINATION_EVENT_TYPE_ONE_OF_VALUES = ['created', 'updated'] as const;

export type ExcJpmamV1DestinationEventTypeOneOfValue = (typeof EXC_JPMAM_V1_DESTINATION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcJpmamV1DestinationKeys {
    // format: id62
    destinationId: string;
}

export interface ExcJpmamV1DestinationQueryServiceDestinationEventsDestinationEventsRequest {
    // format: id62
    destinationId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<ExcJpmamV1DestinationQueryServiceDestinationEventsSearchableFields, ExcJpmamV1DestinationQueryServiceDestinationEventsSortableFields, ExcJpmamV1DestinationQueryServiceDestinationEventsFilterableFields>;
}

export enum ExcJpmamV1DestinationQueryServiceDestinationEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    DestinationId = 'destinationId',
    EventCreatedSpecAssetId = 'event.created.spec.assetId',
    EventUpdatedSpecAssetId = 'event.updated.spec.assetId',
    EventType = 'event.!type'
}

export enum ExcJpmamV1DestinationQueryServiceDestinationEventsSearchableFields {
    EventCreatedSpecBankDetailsAccountNumber = 'event.created.spec.bankDetails.accountNumber',
    EventUpdatedSpecBankDetailsAccountNumber = 'event.updated.spec.bankDetails.accountNumber'
}

export enum ExcJpmamV1DestinationQueryServiceDestinationEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcJpmamV1DestinationQueryServiceDestinationGetDestinationGetRequest {
    // format: id62
    destinationId: string;
}

export interface ExcJpmamV1DestinationQueryServiceDestinationListDestinationListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<ExcJpmamV1DestinationQueryServiceDestinationListSearchableFields, ExcJpmamV1DestinationQueryServiceDestinationListSortableFields, ExcJpmamV1DestinationQueryServiceDestinationListFilterableFields>;
}

export enum ExcJpmamV1DestinationQueryServiceDestinationListFilterableFields {
    DestinationId = 'destinationId',
    DataSpecAssetId = 'data.spec.assetId',
    Status = 'status'
}

export enum ExcJpmamV1DestinationQueryServiceDestinationListSearchableFields {
    DataSpecBankDetailsAccountNumber = 'data.spec.bankDetails.accountNumber'
}

export enum ExcJpmamV1DestinationQueryServiceDestinationListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcJpmamV1DestinationSpec {
    bankDetails: IxcFundingV1UsBankDetails;
    beneficiary: IxcFundingV1NameAndAddress;
    /* JPMAM internal fund, such as "3918" */
    fundNumber: string;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    transferType: ExcJpmamV1TransferType;
}

export interface ExcJpmamV1DestinationState extends ExcJpmamV1DestinationKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcJpmamV1DestinationData;
    status: ExcJpmamV1DestinationStatus;
}

export enum ExcJpmamV1DestinationStatus {
    Unspecified = 'UNSPECIFIED',
    Available = 'AVAILABLE'
}

export type ExcJpmamV1JobCreatedInfo = {
    '!type'?: 'orderStatusNotify';
    orderStatusNotify: ExcJpmamV1OrderStatusNotifyJobCreatedInfo;
} | {
    '!type'?: 'orderReassign';
    orderReassign: ExcJpmamV1OrderReassignJobCreatedInfo;
} | {
    '!type'?: 'orderStatePropagate';
    orderStatePropagate: ExcJpmamV1OrderStatePropagateJobCreatedInfo;
};

export const EXC_JPMAM_V1_JOB_CREATED_INFO_ONE_OF_VALUES = ['orderStatusNotify', 'orderReassign', 'orderStatePropagate'] as const;

export type ExcJpmamV1JobCreatedInfoOneOfValue = (typeof EXC_JPMAM_V1_JOB_CREATED_INFO_ONE_OF_VALUES)[number];

export type ExcJpmamV1JobSpec = {
    '!type'?: 'orderStatusNotify';
    orderStatusNotify: ExcJpmamV1OrderStatusNotifyJobSpec;
} | {
    '!type'?: 'orderReassign';
    orderReassign: ExcJpmamV1OrderReassignJobSpec;
} | {
    '!type'?: 'orderStatePropagate';
    orderStatePropagate: ExcJpmamV1OrderStatePropagateJobSpec;
};

export const EXC_JPMAM_V1_JOB_SPEC_ONE_OF_VALUES = ['orderStatusNotify', 'orderReassign', 'orderStatePropagate'] as const;

export type ExcJpmamV1JobSpecOneOfValue = (typeof EXC_JPMAM_V1_JOB_SPEC_ONE_OF_VALUES)[number];

export type ExcJpmamV1JobStats = {
    '!type'?: 'orderStatusNotify';
    orderStatusNotify: EmptyObject;
} | {
    '!type'?: 'orderReassign';
    orderReassign: EmptyObject;
} | {
    '!type'?: 'orderStatePropagate';
    orderStatePropagate: EmptyObject;
};

export const EXC_JPMAM_V1_JOB_STATS_ONE_OF_VALUES = ['orderStatusNotify', 'orderReassign', 'orderStatePropagate'] as const;

export type ExcJpmamV1JobStatsOneOfValue = (typeof EXC_JPMAM_V1_JOB_STATS_ONE_OF_VALUES)[number];

export type ExcJpmamV1JobTasksAddInfo = {
    '!type'?: 'orderStatusNotify';
    orderStatusNotify: ExcJpmamV1OrderStatusNotifyJobTasksAddInfo;
} | {
    '!type'?: 'orderReassign';
    orderReassign: ExcJpmamV1OrderReassignJobTasksAddInfo;
} | {
    '!type'?: 'orderStatePropagate';
    orderStatePropagate: ExcJpmamV1OrderStatePropagateJobTasksAddInfo;
};

export const EXC_JPMAM_V1_JOB_TASKS_ADD_INFO_ONE_OF_VALUES = ['orderStatusNotify', 'orderReassign', 'orderStatePropagate'] as const;

export type ExcJpmamV1JobTasksAddInfoOneOfValue = (typeof EXC_JPMAM_V1_JOB_TASKS_ADD_INFO_ONE_OF_VALUES)[number];

export interface ExcJpmamV1JpmamJobData {
    operationType: ExcJpmamV1OperationType;
    spec: ExcJpmamV1JobSpec;
    metrics: ExcJpmamV1Metrics;
    stats: ExcJpmamV1JobStats;
}

export interface ExcJpmamV1JpmamJobEvent extends ExcJpmamV1JpmamJobKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcJpmamV1JpmamJobEventType;
}

export type ExcJpmamV1JpmamJobEventType = {
    '!type'?: 'created';
    created: ExcJpmamV1JpmamJobEventTypeCreated;
} | {
    '!type'?: 'closed';
    closed: EmptyObject;
} | {
    '!type'?: 'tasksAdd';
    tasksAdd: ExcJpmamV1JpmamJobEventTypeTasksAdd;
} | {
    '!type'?: 'taskUpdated';
    taskUpdated: ExcJpmamV1JpmamJobEventTypeTaskUpdated;
} | {
    '!type'?: 'allFinished';
    allFinished: ExcJpmamV1JpmamJobEventTypeAllFinished;
};

export interface ExcJpmamV1JpmamJobEventTypeAllFinished {
    message?: string;
}

export interface ExcJpmamV1JpmamJobEventTypeCreated {
    info: ExcJpmamV1JobCreatedInfo;
    /* Indicates if the job is to be closed to new tasks */
    closeJob?: boolean;
    operationType: ExcJpmamV1OperationType;
}

export interface ExcJpmamV1JpmamJobEventTypeTasksAdd {
    info: ExcJpmamV1JobTasksAddInfo;
    /* Indicates if the job is to be closed to new tasks */
    closeJob?: boolean;
}

export interface ExcJpmamV1JpmamJobEventTypeTaskUpdated {
    /* ID of the task that completed */
    // format: id62
    jpmamTaskId: string;
    taskStatus: ExcJpmamV1TaskUpdatedStatus;
    /* Data associated with the task update */
    data?: ExcJpmamV1TaskUpdatedData;
}

export const EXC_JPMAM_V1_JPMAM_JOB_EVENT_TYPE_ONE_OF_VALUES = ['created', 'closed', 'tasksAdd', 'taskUpdated', 'allFinished'] as const;

export type ExcJpmamV1JpmamJobEventTypeOneOfValue = (typeof EXC_JPMAM_V1_JPMAM_JOB_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcJpmamV1JpmamJobKeys {
    /* Primary identifier */
    // format: id62
    jpmamJobId: string;
}

export interface ExcJpmamV1JpmamJobQueryServiceJpmamJobEventsJpmamJobEventsRequest {
    /* Primary identifier */
    // format: id62
    jpmamJobId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcJpmamV1JpmamJobQueryServiceJpmamJobEventsSortableFields, ExcJpmamV1JpmamJobQueryServiceJpmamJobEventsFilterableFields>;
}

export enum ExcJpmamV1JpmamJobQueryServiceJpmamJobEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    JpmamJobId = 'jpmamJobId',
    EventType = 'event.!type'
}

export enum ExcJpmamV1JpmamJobQueryServiceJpmamJobEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcJpmamV1JpmamJobQueryServiceJpmamJobGetJpmamJobGetRequest {
    /* Primary identifier */
    // format: id62
    jpmamJobId: string;
}

export interface ExcJpmamV1JpmamJobQueryServiceJpmamJobListJpmamJobListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcJpmamV1JpmamJobQueryServiceJpmamJobListSortableFields, ExcJpmamV1JpmamJobQueryServiceJpmamJobListFilterableFields>;
}

export enum ExcJpmamV1JpmamJobQueryServiceJpmamJobListFilterableFields {
    JpmamJobId = 'jpmamJobId',
    Status = 'status'
}

export enum ExcJpmamV1JpmamJobQueryServiceJpmamJobListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcJpmamV1JpmamJobState extends ExcJpmamV1JpmamJobKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcJpmamV1JpmamJobData;
    status: ExcJpmamV1JpmamJobStatus;
}

export enum ExcJpmamV1JpmamJobStatus {
    Unspecified = 'UNSPECIFIED',
    Open = 'OPEN',
    Processing = 'PROCESSING',
    Done = 'DONE'
}

export interface ExcJpmamV1JpmamOrderData {
    /* The order specification */
    spec: ExcJpmamV1OrderSpec;
    requestMetadata: J5MessagingV1RequestMetadata;
    /* An opaque grouping identifier for the order, e.g. sweep cutoff timestamp */
    // format: informal
    groupingId: string;
    /* The NetOrder this order is currently assigned to. */
    // format: id62, entity: exc.jpmam.v1.NetOrder
    netOrderId?: string;
    /* The date the order was settled, formatted as YYYY-MM-DD. */
    // pattern: ^[0-9]{4}-[0-9]{2}-[0-9]{2}$
    settlementDate?: string;
    /* The reason the order failed, if applicable */
    failureReason?: string;
    /* The time the order was completed */
    // format: date-time
    completeTimestamp?: string;
}

export interface ExcJpmamV1JpmamOrderEvent extends ExcJpmamV1JpmamOrderKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcJpmamV1JpmamOrderEventType;
}

export type ExcJpmamV1JpmamOrderEventType = {
    '!type'?: 'posted';
    posted: ExcJpmamV1JpmamOrderEventTypePosted;
} | {
    '!type'?: 'reassigned';
    reassigned: ExcJpmamV1JpmamOrderEventTypeReassigned;
} | {
    '!type'?: 'settled';
    settled: ExcJpmamV1JpmamOrderEventTypeSettled;
} | {
    '!type'?: 'rejected';
    rejected: ExcJpmamV1JpmamOrderEventTypeRejected;
} | {
    '!type'?: 'canceled';
    canceled: ExcJpmamV1JpmamOrderEventTypeCanceled;
} | {
    '!type'?: 'assigned';
    assigned: ExcJpmamV1JpmamOrderEventTypeAssigned;
};

export interface ExcJpmamV1JpmamOrderEventTypeAssigned {
    /* The NetOrder this order is now assigned to. */
    // format: id62, entity: exc.jpmam.v1.NetOrder
    netOrderId: string;
}

export interface ExcJpmamV1JpmamOrderEventTypeCanceled {
    /* The reason the order was canceled */
    reason?: string;
}

export interface ExcJpmamV1JpmamOrderEventTypePosted {
    spec: ExcJpmamV1OrderSpec;
    requestMetadata: J5MessagingV1RequestMetadata;
    /* An opaque grouping identifier for the order, e.g. sweep cutoff timestamp */
    // format: informal
    groupingId: string;
    /* The NetOrder this order is assigned to, if known at Posted time. Left
    unset on the JpmamOrderCreate path; populated later via an Assigned
    event. */
    // format: id62, entity: exc.jpmam.v1.NetOrder
    netOrderId?: string;
}

export interface ExcJpmamV1JpmamOrderEventTypeReassigned {
    /* The new NetOrder this order is assigned to. */
    // format: id62, entity: exc.jpmam.v1.NetOrder
    netOrderId: string;
}

export interface ExcJpmamV1JpmamOrderEventTypeRejected {
    /* The reason the order was rejected */
    reason?: string;
}

export interface ExcJpmamV1JpmamOrderEventTypeSettled {
    /* The date the order was settled, formatted as YYYY-MM-DD. */
    // pattern: ^[0-9]{4}-[0-9]{2}-[0-9]{2}$
    settlementDate: string;
}

export const EXC_JPMAM_V1_JPMAM_ORDER_EVENT_TYPE_ONE_OF_VALUES = ['posted', 'reassigned', 'settled', 'rejected', 'canceled', 'assigned'] as const;

export type ExcJpmamV1JpmamOrderEventTypeOneOfValue = (typeof EXC_JPMAM_V1_JPMAM_ORDER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcJpmamV1JpmamOrderKeys {
    // format: id62
    orderId: string;
}

export interface ExcJpmamV1JpmamOrderQueryServiceJpmamOrderEventsJpmamOrderEventsRequest {
    // format: id62
    orderId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcJpmamV1JpmamOrderQueryServiceJpmamOrderEventsSortableFields, ExcJpmamV1JpmamOrderQueryServiceJpmamOrderEventsFilterableFields>;
}

export enum ExcJpmamV1JpmamOrderQueryServiceJpmamOrderEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    OrderId = 'orderId',
    EventPostedSpecAction = 'event.posted.spec.action',
    EventPostedSpecUnit = 'event.posted.spec.unit',
    EventPostedSpecAssetId = 'event.posted.spec.assetId',
    EventPostedSpecSourceType = 'event.posted.spec.source.!type',
    EventType = 'event.!type'
}

export enum ExcJpmamV1JpmamOrderQueryServiceJpmamOrderEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcJpmamV1JpmamOrderQueryServiceJpmamOrderGetJpmamOrderGetRequest {
    // format: id62
    orderId: string;
}

export interface ExcJpmamV1JpmamOrderQueryServiceJpmamOrderListJpmamOrderListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcJpmamV1JpmamOrderQueryServiceJpmamOrderListSortableFields, ExcJpmamV1JpmamOrderQueryServiceJpmamOrderListFilterableFields>;
}

export enum ExcJpmamV1JpmamOrderQueryServiceJpmamOrderListFilterableFields {
    OrderId = 'orderId',
    DataSpecAction = 'data.spec.action',
    DataSpecUnit = 'data.spec.unit',
    DataSpecAssetId = 'data.spec.assetId',
    DataSpecSourceType = 'data.spec.source.!type',
    Status = 'status'
}

export enum ExcJpmamV1JpmamOrderQueryServiceJpmamOrderListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcJpmamV1JpmamOrderState extends ExcJpmamV1JpmamOrderKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcJpmamV1JpmamOrderData;
    status: ExcJpmamV1JpmamOrderStatus;
}

export enum ExcJpmamV1JpmamOrderStatus {
    Unspecified = 'UNSPECIFIED',
    Posted = 'POSTED',
    Settled = 'SETTLED',
    Rejected = 'REJECTED',
    Canceled = 'CANCELED'
}

export interface ExcJpmamV1JpmamTaskData {
    operationType: ExcJpmamV1OperationType;
    spec: ExcJpmamV1TaskSpec;
}

export interface ExcJpmamV1JpmamTaskEvent extends ExcJpmamV1JpmamTaskKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcJpmamV1JpmamTaskEventType;
}

export type ExcJpmamV1JpmamTaskEventType = {
    '!type'?: 'created';
    created: ExcJpmamV1JpmamTaskEventTypeCreated;
} | {
    '!type'?: 'started';
    started: ExcJpmamV1JpmamTaskEventTypeStarted;
} | {
    '!type'?: 'finished';
    finished: ExcJpmamV1JpmamTaskEventTypeFinished;
} | {
    '!type'?: 'errored';
    errored: ExcJpmamV1JpmamTaskEventTypeErrored;
} | {
    '!type'?: 'failed';
    failed: ExcJpmamV1JpmamTaskEventTypeFailed;
};

export interface ExcJpmamV1JpmamTaskEventTypeCreated {
    // format: id62
    jpmamJobId: string;
    // format: id62
    referenceId: string;
    operationType: ExcJpmamV1OperationType;
    info: ExcJpmamV1TaskCreatedInfo;
}

export interface ExcJpmamV1JpmamTaskEventTypeErrored {
    /* Optional error message */
    message?: string;
}

export interface ExcJpmamV1JpmamTaskEventTypeFailed {
    /* Optional error message */
    message?: string;
}

export interface ExcJpmamV1JpmamTaskEventTypeFinished {
    info: ExcJpmamV1TaskFinishedInfo;
}

export interface ExcJpmamV1JpmamTaskEventTypeStarted {
    info: ExcJpmamV1TaskStartedInfo;
}

export const EXC_JPMAM_V1_JPMAM_TASK_EVENT_TYPE_ONE_OF_VALUES = ['created', 'started', 'finished', 'errored', 'failed'] as const;

export type ExcJpmamV1JpmamTaskEventTypeOneOfValue = (typeof EXC_JPMAM_V1_JPMAM_TASK_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcJpmamV1JpmamTaskKeys {
    /* Primary identifier */
    // format: id62
    jpmamTaskId: string;
    /* Identifies the job this task belongs to */
    // format: id62, entity: exc.jpmam.v1.JpmamJob
    jpmamJobId?: string;
    /* Reference identifier for the entity this task operates on */
    // format: id62
    referenceId?: string;
}

export interface ExcJpmamV1JpmamTaskQueryServiceJpmamTaskEventsJpmamTaskEventsRequest {
    /* Primary identifier */
    // format: id62
    jpmamTaskId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcJpmamV1JpmamTaskQueryServiceJpmamTaskEventsSortableFields, ExcJpmamV1JpmamTaskQueryServiceJpmamTaskEventsFilterableFields>;
}

export enum ExcJpmamV1JpmamTaskQueryServiceJpmamTaskEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    JpmamTaskId = 'jpmamTaskId',
    JpmamJobId = 'jpmamJobId',
    ReferenceId = 'referenceId',
    EventType = 'event.!type'
}

export enum ExcJpmamV1JpmamTaskQueryServiceJpmamTaskEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcJpmamV1JpmamTaskQueryServiceJpmamTaskGetJpmamTaskGetRequest {
    /* Primary identifier */
    // format: id62
    jpmamTaskId: string;
}

export interface ExcJpmamV1JpmamTaskQueryServiceJpmamTaskListJpmamTaskListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcJpmamV1JpmamTaskQueryServiceJpmamTaskListSortableFields, ExcJpmamV1JpmamTaskQueryServiceJpmamTaskListFilterableFields>;
}

export enum ExcJpmamV1JpmamTaskQueryServiceJpmamTaskListFilterableFields {
    JpmamTaskId = 'jpmamTaskId',
    JpmamJobId = 'jpmamJobId',
    ReferenceId = 'referenceId',
    Status = 'status'
}

export enum ExcJpmamV1JpmamTaskQueryServiceJpmamTaskListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcJpmamV1JpmamTaskState extends ExcJpmamV1JpmamTaskKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcJpmamV1JpmamTaskData;
    status: ExcJpmamV1JpmamTaskStatus;
}

export enum ExcJpmamV1JpmamTaskStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Succeeded = 'SUCCEEDED',
    Errored = 'ERRORED',
    Failed = 'FAILED'
}

export interface ExcJpmamV1Metrics {
    /* Total number of tasks in this job */
    // format: UINT32
    total?: number;
    /* Number of tasks waiting to be processed */
    // format: UINT32
    pending?: number;
    /* Number of tasks that have completed */
    // format: UINT32
    succeeded?: number;
    /* Number of tasks that encountered an error */
    // format: UINT32
    errored?: number;
    /* Number of tasks that failed for job termination */
    // format: UINT32
    failed?: number;
    /* Expected total number of items to receive across all chunks */
    // format: UINT32
    expectedTotal?: number;
    /* Number of items received so far across all chunks */
    // format: UINT32
    receivedCount?: number;
}

export interface ExcJpmamV1MoneyMarketTransaction {
    /* The ID of the net order */
    // format: id62, entity: exc.jpmam.v1.NetOrder
    netOrderId: string;
    description?: string;
}

export interface ExcJpmamV1NetOrderBatchEntry {
    /* OrderId of the source JpmamOrder. */
    // format: id62, entity: exc.jpmam.v1.JpmamOrder
    sourceOrderId: string;
    action: ExcJpmamV1Action;
    // format: decimal
    quantity: string;
    /* The contribution's denomination, absent meaning CASH. Carried so a
    contribution disagreeing with the NetOrder's unit can be rejected. */
    unit?: ExcJpmamV1OrderUnit;
    requestMetadata: J5MessagingV1RequestMetadata;
}

export interface ExcJpmamV1NetOrderData {
    /* All orders in a NetOrder share the same requestMetadata ReplyTo. Orders
    from different submitting services never mix: each source uses its own
    groupingId namespace, so they net into separate NetOrders. */
    requestMetadata: J5MessagingV1RequestMetadata;
    /* The CUSIP identifier for the asset, used when submitting orders to JPMAM */
    cusip: string;
    /* The share class number for the fund */
    shareClassNumber?: string;
    /* The fund's ticker symbol. Absent on rows that predate it. */
    symbol?: string;
    /* What the quantities below are denominated in. Absent means CASH. One unit
    per NetOrder: dollars and shares cannot offset, so each nets under its
    own grouping id. */
    unit?: ExcJpmamV1OrderUnit;
    /* The number of redemption orders */
    // format: UINT32
    redemptionCount?: number;
    /* The total quantity of redemptions */
    // format: decimal
    redemptionQuantity?: string;
    /* The number of purchase orders */
    // format: UINT32
    purchaseCount?: number;
    /* The total quantity of purchases */
    // format: decimal
    purchaseQuantity?: string;
    /* An opaque grouping identifier, e.g. sweep cutoff timestamp. Only one
    PENDING or ASSEMBLING NetOrder per grouping_id is allowed. */
    // format: informal
    groupingId: string;
    /* The time the net order was submitted to JPM */
    // format: date-time
    submittedTimestamp?: string;
    /* When payment was sent for a Purchase net order */
    // format: date-time
    paymentSentTimestamp?: string;
    /* The reference number returned by JP Morgan upon posting the order */
    jpmReferenceNumber?: string;
    /* The trade date for the order, formatted as YYYY-MM-DD. */
    // pattern: ^[0-9]{4}-[0-9]{2}-[0-9]{2}$
    tradeDate?: string;
    /* The date the order was settled, formatted as YYYY-MM-DD. */
    // pattern: ^[0-9]{4}-[0-9]{2}-[0-9]{2}$
    settlementDate?: string;
    /* How the orders in this NetOrder were initiated. All orders in a NetOrder
    share one source. Absent means sweep for rows that predate this field. */
    source?: ExcJpmamV1NetOrderSource;
    /* The Net Asset Value JPM confirmed the net order at. Absent until
    confirmed, and on rows confirmed before it was recorded. */
    // format: decimal
    confirmedNav?: string;
    /* The share count JPM reported at confirmation. The submission names
    dollars, so this is the figure to reconcile the summed per-order fills
    against. Absent when JPM did not report one. */
    // format: decimal
    confirmedShares?: string;
    /* The dollar amount JPM reported at confirmation. Absent when JPM did not
    report one. */
    // format: decimal
    confirmedAmount?: string;
}

export interface ExcJpmamV1NetOrderEvent extends ExcJpmamV1NetOrderKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcJpmamV1NetOrderEventType;
}

export type ExcJpmamV1NetOrderEventType = {
    '!type'?: 'updated';
    updated: ExcJpmamV1NetOrderEventTypeUpdated;
} | {
    '!type'?: 'deferralStarted';
    deferralStarted: ExcJpmamV1NetOrderEventTypeDeferralStarted;
} | {
    '!type'?: 'assembled';
    assembled: EmptyObject;
} | {
    '!type'?: 'posted';
    posted: ExcJpmamV1NetOrderEventTypePosted;
} | {
    '!type'?: 'manuallyPosted';
    manuallyPosted: ExcJpmamV1NetOrderEventTypeManuallyPosted;
} | {
    '!type'?: 'paymentSent';
    paymentSent: ExcJpmamV1NetOrderEventTypePaymentSent;
} | {
    '!type'?: 'confirmed';
    confirmed: ExcJpmamV1NetOrderEventTypeConfirmed;
} | {
    '!type'?: 'settled';
    settled: ExcJpmamV1NetOrderEventTypeSettled;
} | {
    '!type'?: 'rejected';
    rejected: ExcJpmamV1NetOrderEventTypeRejected;
} | {
    '!type'?: 'canceled';
    canceled: ExcJpmamV1NetOrderEventTypeCanceled;
} | {
    '!type'?: 'orderCanceled';
    orderCanceled: ExcJpmamV1NetOrderEventTypeOrderCanceled;
} | {
    '!type'?: 'created';
    created: ExcJpmamV1NetOrderEventTypeCreated;
} | {
    '!type'?: 'batchUpdated';
    batchUpdated: ExcJpmamV1NetOrderEventTypeBatchUpdated;
};

export interface ExcJpmamV1NetOrderEventTypeBatchUpdated {
    entries: ExcJpmamV1NetOrderBatchEntry[];
}

export interface ExcJpmamV1NetOrderEventTypeCanceled {
    /* The reason the order was canceled */
    reason?: string;
}

export interface ExcJpmamV1NetOrderEventTypeConfirmed {
    /* The Net Asset Value at which the orders were confirmed. */
    // format: decimal
    nav?: string;
    /* When true, the POSTED -> CONFIRMED transition will not emit a
    JpmamSendPaymentMessage. Used when payment was already handled
    out-of-band for a manually-recovered NetOrder. */
    skipPayment?: boolean;
    /* The share count JPM reported for the net order, when it reported one. */
    // format: decimal
    shares?: string;
    /* The dollar amount JPM reported for the net order, when it reported
    one. */
    // format: decimal
    amount?: string;
}

export interface ExcJpmamV1NetOrderEventTypeCreated {
    /* The CUSIP identifier for the asset */
    cusip: string;
    /* The share class number for the asset */
    shareClassNumber: string;
    /* An opaque grouping identifier, e.g. sweep cutoff timestamp */
    // format: informal
    groupingId: string;
    requestMetadata: J5MessagingV1RequestMetadata;
    /* How the orders in this NetOrder were initiated; absent means sweep */
    source?: ExcJpmamV1NetOrderSource;
    /* The fund's ticker symbol */
    symbol?: string;
}

export interface ExcJpmamV1NetOrderEventTypeDeferralStarted {
    /* The NetOrder the orders are being deferred from. */
    // format: id62, entity: exc.jpmam.v1.NetOrder
    sourceNetOrderId: string;
    requestMetadata: J5MessagingV1RequestMetadata;
    /* The CUSIP identifier for the asset */
    cusip: string;
    /* The share class number for the asset */
    shareClassNumber: string;
    /* An opaque grouping identifier copied from the source NetOrder */
    // format: informal
    groupingId: string;
    /* Copied from the source NetOrder; absent means sweep */
    source?: ExcJpmamV1NetOrderSource;
    /* The fund's ticker symbol */
    symbol?: string;
}

export interface ExcJpmamV1NetOrderEventTypeManuallyPosted {
    /* The type of processing that was done (FULL, REDEEM, PURCHASE) */
    type: ExcJpmamV1ProcessType;
    /* The reference number returned by JP Morgan upon posting the order */
    jpmReferenceNumber: string;
    /* The trade date for the order, formatted as YYYY-MM-DD. */
    // pattern: ^[0-9]{4}-[0-9]{2}-[0-9]{2}$
    tradeDate: string;
}

export interface ExcJpmamV1NetOrderEventTypeOrderCanceled {
    /* The JpmamOrder that was canceled. */
    // format: id62, entity: exc.jpmam.v1.JpmamOrder
    orderId: string;
    /* The order specification, used to decrement counts */
    spec: ExcJpmamV1OrderSpec;
    /* The reason the order was canceled */
    reason: string;
}

export interface ExcJpmamV1NetOrderEventTypePaymentSent {
    // format: date-time
    paymentSentTimestamp: string;
    transferType: ExcJpmamV1PaymentTransferType;
}

export interface ExcJpmamV1NetOrderEventTypePosted {
    /* The type of processing that was done (FULL, REDEEM, PURCHASE) */
    type: ExcJpmamV1ProcessType;
    /* The reference number returned by JP Morgan upon posting the order */
    jpmReferenceNumber?: string;
    /* The trade date for the order, returned from JPM, formatted as
    YYYY-MM-DD. */
    // pattern: ^[0-9]{4}-[0-9]{2}-[0-9]{2}$
    tradeDate?: string;
}

export interface ExcJpmamV1NetOrderEventTypeRejected {
    /* The reason the net order was rejected */
    reason?: string;
}

export interface ExcJpmamV1NetOrderEventTypeSettled {
    /* The type of processing that was done (FULL, REDEEM, PURCHASE) */
    type?: ExcJpmamV1ProcessType;
    /* The date the order was settled, formatted as YYYY-MM-DD. */
    // pattern: ^[0-9]{4}-[0-9]{2}-[0-9]{2}$
    settlementDate: string;
}

export interface ExcJpmamV1NetOrderEventTypeUpdated {
    /* The JpmamOrder being added to this NetOrder. */
    // format: id62, entity: exc.jpmam.v1.JpmamOrder
    orderId: string;
    /* The order specification */
    spec: ExcJpmamV1OrderSpec;
    requestMetadata: J5MessagingV1RequestMetadata;
    /* The CUSIP identifier for the asset */
    cusip: string;
    /* The share class number for the asset */
    shareClassNumber: string;
    /* An opaque grouping identifier, e.g. sweep cutoff timestamp */
    // format: informal
    groupingId: string;
    /* The fund's ticker symbol */
    symbol?: string;
}

export const EXC_JPMAM_V1_NET_ORDER_EVENT_TYPE_ONE_OF_VALUES = ['updated', 'deferralStarted', 'assembled', 'posted', 'manuallyPosted', 'paymentSent', 'confirmed', 'settled', 'rejected', 'canceled', 'orderCanceled', 'created', 'batchUpdated'] as const;

export type ExcJpmamV1NetOrderEventTypeOneOfValue = (typeof EXC_JPMAM_V1_NET_ORDER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcJpmamV1NetOrderKeys {
    // format: id62
    netOrderId: string;
    /* The asset this net order is for. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
}

export interface ExcJpmamV1NetOrderQueryServiceNetOrderEventsNetOrderEventsRequest {
    // format: id62
    netOrderId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcJpmamV1NetOrderQueryServiceNetOrderEventsSortableFields, ExcJpmamV1NetOrderQueryServiceNetOrderEventsFilterableFields>;
}

export enum ExcJpmamV1NetOrderQueryServiceNetOrderEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    NetOrderId = 'netOrderId',
    AssetId = 'assetId',
    EventUpdatedSpecAction = 'event.updated.spec.action',
    EventUpdatedSpecUnit = 'event.updated.spec.unit',
    EventUpdatedSpecAssetId = 'event.updated.spec.assetId',
    EventUpdatedSpecSourceType = 'event.updated.spec.source.!type',
    EventOrderCanceledSpecAction = 'event.orderCanceled.spec.action',
    EventOrderCanceledSpecUnit = 'event.orderCanceled.spec.unit',
    EventOrderCanceledSpecAssetId = 'event.orderCanceled.spec.assetId',
    EventOrderCanceledSpecSourceType = 'event.orderCanceled.spec.source.!type',
    EventType = 'event.!type'
}

export enum ExcJpmamV1NetOrderQueryServiceNetOrderEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcJpmamV1NetOrderQueryServiceNetOrderGetNetOrderGetRequest {
    // format: id62
    netOrderId: string;
}

export interface ExcJpmamV1NetOrderQueryServiceNetOrderListNetOrderListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcJpmamV1NetOrderQueryServiceNetOrderListSortableFields, ExcJpmamV1NetOrderQueryServiceNetOrderListFilterableFields>;
}

export enum ExcJpmamV1NetOrderQueryServiceNetOrderListFilterableFields {
    NetOrderId = 'netOrderId',
    AssetId = 'assetId',
    DataUnit = 'data.unit',
    DataGroupingId = 'data.groupingId',
    DataSourceType = 'data.source.!type',
    Status = 'status'
}

export enum ExcJpmamV1NetOrderQueryServiceNetOrderListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export type ExcJpmamV1NetOrderSource = {
    '!type'?: 'sweep';
    sweep: EmptyObject;
} | {
    '!type'?: 'customer';
    customer: EmptyObject;
};

export const EXC_JPMAM_V1_NET_ORDER_SOURCE_ONE_OF_VALUES = ['sweep', 'customer'] as const;

export type ExcJpmamV1NetOrderSourceOneOfValue = (typeof EXC_JPMAM_V1_NET_ORDER_SOURCE_ONE_OF_VALUES)[number];

export interface ExcJpmamV1NetOrderState extends ExcJpmamV1NetOrderKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcJpmamV1NetOrderData;
    status: ExcJpmamV1NetOrderStatus;
}

export enum ExcJpmamV1NetOrderStatus {
    Unspecified = 'UNSPECIFIED',
    Assembling = 'ASSEMBLING',
    Pending = 'PENDING',
    Posted = 'POSTED',
    Confirmed = 'CONFIRMED',
    Settled = 'SETTLED',
    Rejected = 'REJECTED',
    Canceled = 'CANCELED'
}

export enum ExcJpmamV1OperationType {
    Unspecified = 'UNSPECIFIED',
    OrderStatusNotify = 'ORDER_STATUS_NOTIFY',
    OrderReassign = 'ORDER_REASSIGN',
    OrderStatePropagate = 'ORDER_STATE_PROPAGATE'
}

export interface ExcJpmamV1OrderFill {
    // format: id62, entity: exc.jpmam.v1.JpmamOrder
    orderId: string;
    /* The order's share of the confirmed share count. */
    // format: decimal
    shares: string;
    /* The order's share of the confirmed dollar amount. */
    // format: decimal
    amount: string;
}

export interface ExcJpmamV1OrderReassignJobCreatedInfo {
    /* The NetOrder the orders are being reassigned from. */
    // format: id62, entity: exc.jpmam.v1.NetOrder
    sourceNetOrderId: string;
    /* The NetOrder the orders are being reassigned to. */
    // format: id62, entity: exc.jpmam.v1.NetOrder
    targetNetOrderId: string;
    /* First chunk of order IDs to reassign */
    // format: id62
    orderIds: string[];
    /* Total number of order IDs to reassign */
    // format: UINT32
    totalOrderIds: number;
}

export interface ExcJpmamV1OrderReassignJobSpec {
    // format: id62, entity: exc.jpmam.v1.NetOrder
    sourceNetOrderId: string;
    // format: id62, entity: exc.jpmam.v1.NetOrder
    targetNetOrderId: string;
    // format: UINT32
    totalOrderIds: number;
}

export interface ExcJpmamV1OrderReassignJobTasksAddInfo {
    /* Additional order IDs to reassign */
    // format: id62
    orderIds: string[];
}

export interface ExcJpmamV1OrderReassignTaskCreatedInfo {
    // format: id62, entity: exc.jpmam.v1.NetOrder
    targetNetOrderId: string;
    /* The chunk of order IDs for this task */
    // format: id62
    orderIds: string[];
}

export interface ExcJpmamV1OrderReassignTaskSpec {
    // format: id62, entity: exc.jpmam.v1.NetOrder
    targetNetOrderId: string;
    /* The chunk of order IDs for this task */
    // format: id62
    orderIds: string[];
}

export type ExcJpmamV1OrderSource = {
    '!type'?: 'sweep';
    sweep: EmptyObject;
} | {
    '!type'?: 'customer';
    customer: ExcJpmamV1CustomerOrderRef;
};

export const EXC_JPMAM_V1_ORDER_SOURCE_ONE_OF_VALUES = ['sweep', 'customer'] as const;

export type ExcJpmamV1OrderSourceOneOfValue = (typeof EXC_JPMAM_V1_ORDER_SOURCE_ONE_OF_VALUES)[number];

export interface ExcJpmamV1OrderSpec {
    /* The time the order was created */
    // format: date-time
    timestamp: string;
    /* The order action (purchase, redeem, full_redemption) */
    action: ExcJpmamV1Action;
    /* The amount to be purchased or redeemed: dollars for CASH, shares for
    SHARES. The minimum is the smallest any unit accepts; per-unit precision
    is enforced at intake. */
    // format: decimal
    quantity: string;
    /* What quantity is denominated in. Absent means CASH. */
    unit?: ExcJpmamV1OrderUnit;
    /* The asset to be purchased or redeemed */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* How the order was initiated. Absent means sweep for rows and messages
    that predate this field. */
    source?: ExcJpmamV1OrderSource;
}

export interface ExcJpmamV1OrderStatePropagateJobCreatedInfo {
    /* The NetOrder whose state change is being propagated. */
    // format: id62, entity: exc.jpmam.v1.NetOrder
    netOrderId: string;
    /* The target status for the JpmamOrders (SETTLED, REJECTED, CANCELED). */
    targetOrderStatus: ExcJpmamV1JpmamOrderStatus;
    statusData: ExcJpmamV1StatusData;
    requestMetadata: J5MessagingV1RequestMetadata;
    // format: informal
    groupingId: string;
    /* First chunk of order IDs to propagate to */
    // format: id62
    orderIds: string[];
    /* Total number of order IDs */
    // format: UINT32
    totalOrderIds: number;
}

export interface ExcJpmamV1OrderStatePropagateJobSpec {
    // format: id62, entity: exc.jpmam.v1.NetOrder
    netOrderId: string;
    targetOrderStatus: ExcJpmamV1JpmamOrderStatus;
    statusData: ExcJpmamV1StatusData;
    requestMetadata: J5MessagingV1RequestMetadata;
    // format: informal
    groupingId: string;
    // format: UINT32
    totalOrderIds: number;
}

export interface ExcJpmamV1OrderStatePropagateJobTasksAddInfo {
    /* Additional order IDs to propagate to */
    // format: id62
    orderIds: string[];
}

export interface ExcJpmamV1OrderStatePropagateTaskCreatedInfo {
    // format: id62, entity: exc.jpmam.v1.NetOrder
    netOrderId: string;
    targetOrderStatus: ExcJpmamV1JpmamOrderStatus;
    statusData: ExcJpmamV1StatusData;
    requestMetadata: J5MessagingV1RequestMetadata;
    // format: informal
    groupingId: string;
    /* The chunk of order IDs for this task */
    // format: id62
    orderIds: string[];
}

export interface ExcJpmamV1OrderStatePropagateTaskSpec {
    // format: id62, entity: exc.jpmam.v1.NetOrder
    netOrderId: string;
    targetOrderStatus: ExcJpmamV1JpmamOrderStatus;
    statusData: ExcJpmamV1StatusData;
    /* The chunk of order IDs for this task */
    // format: id62
    orderIds: string[];
}

export interface ExcJpmamV1OrderStatusNotifyJobCreatedInfo {
    // format: id62
    netOrderId: string;
    targetNetOrderStatus: ExcJpmamV1NetOrderStatus;
    statusData: ExcJpmamV1StatusData;
    requestMetadata: J5MessagingV1RequestMetadata;
    // format: informal
    groupingId: string;
    /* All order IDs in this net order */
    // format: id62
    orderIds: string[];
    /* Total number of order IDs in this net order */
    // format: UINT32
    totalOrderIds: number;
    /* What each of this chunk's orders received of the confirmed totals,
    allocated once when the provider reported them. Only a confirm has any. */
    fills?: ExcJpmamV1OrderFill[];
}

export interface ExcJpmamV1OrderStatusNotifyJobSpec {
    // format: id62
    netOrderId: string;
    targetNetOrderStatus: ExcJpmamV1NetOrderStatus;
    statusData: ExcJpmamV1StatusData;
    requestMetadata: J5MessagingV1RequestMetadata;
    // format: informal
    groupingId: string;
    /* Total number of order IDs in this net order */
    // format: UINT32
    totalOrderIds: number;
}

export interface ExcJpmamV1OrderStatusNotifyJobTasksAddInfo {
    /* Additional order IDs to add to the job */
    // format: id62
    orderIds: string[];
    /* The allocation for those orders */
    fills?: ExcJpmamV1OrderFill[];
}

export interface ExcJpmamV1OrderStatusNotifyTaskCreatedInfo {
    /* The chunk of order IDs for this task */
    // format: id62
    orderIds: string[];
    targetNetOrderStatus: ExcJpmamV1NetOrderStatus;
    statusData: ExcJpmamV1StatusData;
    requestMetadata: J5MessagingV1RequestMetadata;
    // format: informal
    groupingId: string;
    /* The allocation for this chunk */
    fills?: ExcJpmamV1OrderFill[];
}

export interface ExcJpmamV1OrderStatusNotifyTaskSpec {
    /* The chunk of order IDs for this task */
    // format: id62
    orderIds: string[];
    targetNetOrderStatus: ExcJpmamV1NetOrderStatus;
    statusData: ExcJpmamV1StatusData;
    requestMetadata: J5MessagingV1RequestMetadata;
    // format: informal
    groupingId: string;
    /* The allocation for this chunk */
    fills?: ExcJpmamV1OrderFill[];
}

export enum ExcJpmamV1OrderUnit {
    Unspecified = 'UNSPECIFIED',
    Cash = 'CASH',
    Shares = 'SHARES'
}

export type ExcJpmamV1PaymentTransferType = {
    '!type'?: 'wirePush';
    wirePush: ExcJpmamV1PaymentWirePush;
};

export const EXC_JPMAM_V1_PAYMENT_TRANSFER_TYPE_ONE_OF_VALUES = ['wirePush'] as const;

export type ExcJpmamV1PaymentTransferTypeOneOfValue = (typeof EXC_JPMAM_V1_PAYMENT_TRANSFER_TYPE_ONE_OF_VALUES)[number];

export interface ExcJpmamV1PaymentWirePush {
    // format: id62
    wireId: string;
}

export enum ExcJpmamV1ProcessType {
    Unspecified = 'UNSPECIFIED',
    Full = 'FULL',
    Redeem = 'REDEEM',
    Purchase = 'PURCHASE'
}

export interface ExcJpmamV1StatusData {
    /* The Net Asset Value at which the orders were confirmed. */
    // format: decimal
    nav?: string;
    /* The date the order was settled, formatted as YYYY-MM-DD. */
    // pattern: ^[0-9]{4}-[0-9]{2}-[0-9]{2}$
    settlementDate?: string;
    /* The reason for rejection or cancellation */
    reason?: string;
    /* When the orders are expected to complete settlement, derived from the
    settlement date the provider reports at confirmation. */
    // format: date-time
    settlementTime?: string;
    /* The share count the provider reports for the confirmed net order. Absent
    when the provider did not report one. */
    // format: decimal
    shares?: string;
    /* The dollar amount the provider reports for the confirmed net order.
    Absent when the provider did not report one. */
    // format: decimal
    amount?: string;
}

export type ExcJpmamV1TaskCreatedInfo = {
    '!type'?: 'orderStatusNotify';
    orderStatusNotify: ExcJpmamV1OrderStatusNotifyTaskCreatedInfo;
} | {
    '!type'?: 'orderReassign';
    orderReassign: ExcJpmamV1OrderReassignTaskCreatedInfo;
} | {
    '!type'?: 'orderStatePropagate';
    orderStatePropagate: ExcJpmamV1OrderStatePropagateTaskCreatedInfo;
};

export const EXC_JPMAM_V1_TASK_CREATED_INFO_ONE_OF_VALUES = ['orderStatusNotify', 'orderReassign', 'orderStatePropagate'] as const;

export type ExcJpmamV1TaskCreatedInfoOneOfValue = (typeof EXC_JPMAM_V1_TASK_CREATED_INFO_ONE_OF_VALUES)[number];

export type ExcJpmamV1TaskFinishedInfo = {
    '!type'?: 'orderStatusNotify';
    orderStatusNotify: EmptyObject;
} | {
    '!type'?: 'orderReassign';
    orderReassign: EmptyObject;
} | {
    '!type'?: 'orderStatePropagate';
    orderStatePropagate: EmptyObject;
};

export const EXC_JPMAM_V1_TASK_FINISHED_INFO_ONE_OF_VALUES = ['orderStatusNotify', 'orderReassign', 'orderStatePropagate'] as const;

export type ExcJpmamV1TaskFinishedInfoOneOfValue = (typeof EXC_JPMAM_V1_TASK_FINISHED_INFO_ONE_OF_VALUES)[number];

export type ExcJpmamV1TaskSpec = {
    '!type'?: 'orderStatusNotify';
    orderStatusNotify: ExcJpmamV1OrderStatusNotifyTaskSpec;
} | {
    '!type'?: 'orderReassign';
    orderReassign: ExcJpmamV1OrderReassignTaskSpec;
} | {
    '!type'?: 'orderStatePropagate';
    orderStatePropagate: ExcJpmamV1OrderStatePropagateTaskSpec;
};

export const EXC_JPMAM_V1_TASK_SPEC_ONE_OF_VALUES = ['orderStatusNotify', 'orderReassign', 'orderStatePropagate'] as const;

export type ExcJpmamV1TaskSpecOneOfValue = (typeof EXC_JPMAM_V1_TASK_SPEC_ONE_OF_VALUES)[number];

export type ExcJpmamV1TaskStartedInfo = {
    '!type'?: 'orderStatusNotify';
    orderStatusNotify: EmptyObject;
} | {
    '!type'?: 'orderReassign';
    orderReassign: EmptyObject;
} | {
    '!type'?: 'orderStatePropagate';
    orderStatePropagate: EmptyObject;
};

export const EXC_JPMAM_V1_TASK_STARTED_INFO_ONE_OF_VALUES = ['orderStatusNotify', 'orderReassign', 'orderStatePropagate'] as const;

export type ExcJpmamV1TaskStartedInfoOneOfValue = (typeof EXC_JPMAM_V1_TASK_STARTED_INFO_ONE_OF_VALUES)[number];

export type ExcJpmamV1TaskUpdatedData = {
    '!type'?: 'orderStatusNotify';
    orderStatusNotify: EmptyObject;
} | {
    '!type'?: 'orderReassign';
    orderReassign: EmptyObject;
} | {
    '!type'?: 'orderStatePropagate';
    orderStatePropagate: EmptyObject;
};

export const EXC_JPMAM_V1_TASK_UPDATED_DATA_ONE_OF_VALUES = ['orderStatusNotify', 'orderReassign', 'orderStatePropagate'] as const;

export type ExcJpmamV1TaskUpdatedDataOneOfValue = (typeof EXC_JPMAM_V1_TASK_UPDATED_DATA_ONE_OF_VALUES)[number];

export enum ExcJpmamV1TaskUpdatedStatus {
    Unspecified = 'UNSPECIFIED',
    Processing = 'PROCESSING',
    Succeeded = 'SUCCEEDED',
    Errored = 'ERRORED',
    Failed = 'FAILED'
}

export type ExcJpmamV1TransferType = {
    '!type'?: 'wirePush';
    wirePush: EmptyObject;
};

export const EXC_JPMAM_V1_TRANSFER_TYPE_ONE_OF_VALUES = ['wirePush'] as const;

export type ExcJpmamV1TransferTypeOneOfValue = (typeof EXC_JPMAM_V1_TRANSFER_TYPE_ONE_OF_VALUES)[number];

export enum ExcMarketdataV1ChartPeriod {
    Unspecified = 'UNSPECIFIED',
    OneDay = 'ONE_DAY',
    OneWeek = 'ONE_WEEK',
    OneMonth = 'ONE_MONTH',
    ThreeMonths = 'THREE_MONTHS',
    YearToDate = 'YEAR_TO_DATE',
    OneYear = 'ONE_YEAR',
    FiveYears = 'FIVE_YEARS',
    TenYears = 'TEN_YEARS'
}

export interface ExcMarketdataV1ChartPoint {
    // format: date-time
    time: string;
    /* Close for the interval or day. */
    // format: decimal
    price: string;
}

export interface ExcMarketdataV1CompanyProfile {
    symbol: string;
    /* Long name of the company. */
    name?: string;
    /* Company description. */
    description?: string;
    ceo?: string;
    // format: UINT32
    employees?: number;
    /* Headquarters city. */
    city?: string;
    /* Headquarters state or region. */
    state?: string;
    /* Headquarters country. */
    country?: string;
    website?: string;
    sector?: string;
    industry?: string;
    // format: decimal
    sharesOutstanding?: string;
    keyRatios?: ExcMarketdataV1KeyRatios;
}

export interface ExcMarketdataV1EarningsQuarter {
    /* Company fiscal quarter end. */
    // format: YYYY-MM-DD
    quarterEnd: string;
    /* Fiscal quarter label, e.g. "Q2 2025". */
    period?: string;
    /* Date the earnings were reported. */
    // format: YYYY-MM-DD
    reportDate?: string;
    // format: UINT32
    numberOfEstimates?: number;
    // format: decimal
    estimatedEps?: string;
    // format: decimal
    actualEps?: string;
    /* Dollar EPS surprise. */
    // format: decimal
    surpriseAmount?: string;
    /* Percent EPS surprise. */
    // format: FLOAT64
    surprisePercent?: number;
}

export interface ExcMarketdataV1Filing {
    /* SEC form type, e.g. "10-K". */
    formType: string;
    /* Description of the form type. */
    description?: string;
    /* Category derived from the vendor's form group; unset for ungrouped forms. */
    category?: ExcMarketdataV1FilingCategory;
    // format: YYYY-MM-DD
    dateFiled: string;
    pdfLink?: string;
    htmlLink?: string;
    docLink?: string;
    xlsLink?: string;
}

export enum ExcMarketdataV1FilingCategory {
    Unspecified = 'UNSPECIFIED',
    AnnualReports = 'ANNUAL_REPORTS',
    QuarterlyReports = 'QUARTERLY_REPORTS',
    InsiderTransactions = 'INSIDER_TRANSACTIONS',
    EightKRelated = 'EIGHT_K_RELATED',
    ProxiesAndInfoStatements = 'PROXIES_AND_INFO_STATEMENTS'
}

export interface ExcMarketdataV1FinancialReport {
    /* Fiscal period end. */
    // format: YYYY-MM-DD
    endDate: string;
    // format: decimal
    revenue?: string;
    // format: decimal
    operatingExpense?: string;
    // format: decimal
    netIncome?: string;
    /* Percent. */
    // format: FLOAT64
    netProfitMargin?: number;
    /* Diluted EPS, total operations. */
    // format: decimal
    eps?: string;
    // format: decimal
    ebitda?: string;
    /* Percent. */
    // format: FLOAT64
    effectiveTaxRate?: number;
    // format: decimal
    cashAndShortTermInvestments?: string;
    // format: decimal
    totalAssets?: string;
    // format: decimal
    totalLiabilities?: string;
    // format: decimal
    totalEquity?: string;
    // format: decimal
    cashFromOperations?: string;
    // format: decimal
    cashFromInvesting?: string;
    // format: decimal
    cashFromFinancing?: string;
    // format: decimal
    netChangeInCash?: string;
    // format: decimal
    freeCashFlow?: string;
}

export enum ExcMarketdataV1FinancialReportType {
    Unspecified = 'UNSPECIFIED',
    Quarterly = 'QUARTERLY',
    Annual = 'ANNUAL'
}

export interface ExcMarketdataV1KeyRatios {
    // format: FLOAT64
    priceToBook?: number;
    /* Return on assets (TTM), percent. */
    // format: FLOAT64
    returnOnAssets?: number;
    /* Return on capital (TTM), percent. */
    // format: FLOAT64
    returnOnCapital?: number;
}

export interface ExcMarketdataV1MarketDataServiceGetBasicFinancialsBySymbolGetBasicFinancialsBySymbolRequest {
    /* Symbol to fetch financial reports for. */
    symbol: string;
    reportType: ExcMarketdataV1FinancialReportType;
}

export interface ExcMarketdataV1MarketDataServiceGetCompanyBySymbolGetCompanyBySymbolRequest {
    /* Symbol to fetch company data for. */
    symbol: string;
}

export interface ExcMarketdataV1MarketDataServiceGetCompanyFilingsGetCompanyFilingsRequest {
    /* Symbol to fetch filings for. */
    symbol: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, never, ExcMarketdataV1MarketDataServiceGetCompanyFilingsFilterableFields>;
}

export enum ExcMarketdataV1MarketDataServiceGetCompanyFilingsFilterableFields {
    Category = 'category',
    DateFiled = 'dateFiled'
}

export interface ExcMarketdataV1MarketDataServiceGetEnhancedChartDataGetEnhancedChartDataRequest {
    /* Symbol to fetch chart data for. */
    symbol: string;
    /* Time range of the series; also determines intraday vs end-of-day granularity. */
    period: ExcMarketdataV1ChartPeriod;
    /* Whether to downsample the number of points returned in the response. */
    downsample?: boolean;
}

export interface ExcMarketdataV1MarketDataServiceGetEnhancedEarningsGetEnhancedEarningsRequest {
    /* Symbol to fetch earnings for. */
    symbol: string;
}

export interface ExcMarketdataV1MarketDataServiceGetEnhancedQuoteGetEnhancedQuoteRequest {
    /* Symbol to fetch quotes for. */
    symbol: string;
}

export interface ExcMarketdataV1MarketDataServiceGetHeadlinesGetHeadlinesRequest {
    /* Symbol to fetch headlines for. */
    symbol: string;
    /* Maximum number of headlines to return. */
    // format: UINT32
    limit?: number;
}

export interface ExcMarketdataV1NewsItem {
    newsId: string;
    headline: string;
    /* News source name. */
    source: string;
    /* When the story was released. */
    // format: date-time
    publishedAt: string;
    /* Excerpt from the first line of the article. */
    summary?: string;
    /* Link to the vendor-hosted article. */
    storyUrl?: string;
    /* Direct link to the original news source, where available. */
    permalink?: string;
    /* Cover image, where available. */
    thumbnailUrl?: string;
}

export interface ExcMarketdataV1Quote {
    /* Symbol as requested, including any internal test suffix. */
    symbol: string;
    /* Long name of the security. */
    name?: string;
    /* Listing exchange code. */
    exchange?: string;
    /* Listing exchange long name. */
    exchangeName?: string;
    /* Date/time of the quote snap. */
    // format: date-time
    asOf?: string;
    /* Whether the exchange is currently open. */
    isCurrentlyOpen?: boolean;
    /* Last trade price. */
    // format: decimal
    last?: string;
    /* Dollar change since previous close. */
    // format: decimal
    change?: string;
    /* Percent change since previous close. */
    // format: FLOAT64
    changePercent?: number;
    /* Opening price of the session. */
    // format: decimal
    open?: string;
    /* Session high. */
    // format: decimal
    high?: string;
    /* Session low. */
    // format: decimal
    low?: string;
    /* Closing price of the previous session. */
    // format: decimal
    previousClose?: string;
    /* 52-week high price. */
    // format: decimal
    week52High?: string;
    /* Date of the 52-week high. */
    // format: YYYY-MM-DD
    week52HighDate?: string;
    /* 52-week low price. */
    // format: decimal
    week52Low?: string;
    /* Date of the 52-week low. */
    // format: YYYY-MM-DD
    week52LowDate?: string;
    /* Market capitalization. */
    // format: decimal
    marketCap?: string;
    /* Session share volume. */
    // format: decimal
    volume?: string;
    /* 30-day average volume. */
    // format: decimal
    averageVolume?: string;
    /* Shares outstanding. */
    // format: decimal
    sharesOutstanding?: string;
    /* Earnings per share (TTM). */
    // format: decimal
    eps?: string;
    /* Price-earnings ratio. */
    // format: FLOAT64
    peRatio?: number;
    /* Price-to-book ratio. */
    // format: FLOAT64
    pbRatio?: number;
    /* Dividend yield, percent. */
    // format: FLOAT64
    dividendYield?: number;
    // format: FLOAT64
    beta?: number;
    sector?: string;
    industry?: string;
}

export interface ExcPlaidV1ProcessorTokenData {
    spec: IxcFundingV1PlaidProcessorTokenSource;
    // format: id62, entity: ixc.funding.v1.Source
    sourceId?: string;
    /* last time the token was verified */
    // format: YYYY-MM-DD
    lastVerified?: string;
}

export interface ExcPlaidV1ProcessorTokenEvent extends ExcPlaidV1ProcessorTokenKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcPlaidV1ProcessorTokenEventType;
}

export type ExcPlaidV1ProcessorTokenEventType = {
    '!type'?: 'requested';
    requested: ExcPlaidV1ProcessorTokenEventTypeRequested;
} | {
    '!type'?: 'updated';
    updated: ExcPlaidV1ProcessorTokenEventTypeUpdated;
} | {
    '!type'?: 'activated';
    activated: ExcPlaidV1ProcessorTokenEventTypeActivated;
} | {
    '!type'?: 'expired';
    expired: EmptyObject;
} | {
    '!type'?: 'retired';
    retired: EmptyObject;
};

export interface ExcPlaidV1ProcessorTokenEventTypeActivated {
    plaidDetails: IxcFundingV1PlaidAccountDetails;
}

export interface ExcPlaidV1ProcessorTokenEventTypeRequested {
    processorToken: string;
    // format: id62
    sourceId: string;
}

export interface ExcPlaidV1ProcessorTokenEventTypeUpdated {
    processorToken: string;
}

export const EXC_PLAID_V1_PROCESSOR_TOKEN_EVENT_TYPE_ONE_OF_VALUES = ['requested', 'updated', 'activated', 'expired', 'retired'] as const;

export type ExcPlaidV1ProcessorTokenEventTypeOneOfValue = (typeof EXC_PLAID_V1_PROCESSOR_TOKEN_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcPlaidV1ProcessorTokenKeys {
    /* Interchage's unique identifier for this processor token */
    // format: id62
    processorTokenId: string;
    /* Account ID */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    /* Program ID */
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
}

export interface ExcPlaidV1ProcessorTokenQueryServiceProcessorTokenEventsProcessorTokenEventsRequest {
    /* Interchage's unique identifier for this processor token */
    // format: id62
    processorTokenId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcPlaidV1ProcessorTokenQueryServiceProcessorTokenEventsSortableFields, ExcPlaidV1ProcessorTokenQueryServiceProcessorTokenEventsFilterableFields>;
}

export enum ExcPlaidV1ProcessorTokenQueryServiceProcessorTokenEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    ProcessorTokenId = 'processorTokenId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    EventType = 'event.!type'
}

export enum ExcPlaidV1ProcessorTokenQueryServiceProcessorTokenEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcPlaidV1ProcessorTokenQueryServiceProcessorTokenGetProcessorTokenGetRequest {
    /* Interchage's unique identifier for this processor token */
    // format: id62
    processorTokenId: string;
}

export interface ExcPlaidV1ProcessorTokenQueryServiceProcessorTokenListProcessorTokenListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcPlaidV1ProcessorTokenQueryServiceProcessorTokenListSortableFields, ExcPlaidV1ProcessorTokenQueryServiceProcessorTokenListFilterableFields>;
}

export enum ExcPlaidV1ProcessorTokenQueryServiceProcessorTokenListFilterableFields {
    ProcessorTokenId = 'processorTokenId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    DataSourceId = 'data.sourceId',
    Status = 'status'
}

export enum ExcPlaidV1ProcessorTokenQueryServiceProcessorTokenListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcPlaidV1ProcessorTokenState extends ExcPlaidV1ProcessorTokenKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcPlaidV1ProcessorTokenData;
    status: ExcPlaidV1ProcessorTokenStatus;
}

export enum ExcPlaidV1ProcessorTokenStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Active = 'ACTIVE',
    Expired = 'EXPIRED',
    Retired = 'RETIRED'
}

export interface ExcQuotemediaV1EodPriceJobData {
    spec: ExcQuotemediaV1EodPriceJobSpec;
    metrics: ExcQuotemediaV1Metrics;
}

export interface ExcQuotemediaV1EodPriceJobEvent extends ExcQuotemediaV1EodPriceJobKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcQuotemediaV1EodPriceJobEventType;
}

export type ExcQuotemediaV1EodPriceJobEventType = {
    '!type'?: 'created';
    created: ExcQuotemediaV1EodPriceJobEventTypeCreated;
} | {
    '!type'?: 'taskUpdated';
    taskUpdated: ExcQuotemediaV1EodPriceJobEventTypeTaskUpdated;
} | {
    '!type'?: 'allFinished';
    allFinished: EmptyObject;
};

export interface ExcQuotemediaV1EodPriceJobEventTypeCreated {
    spec: ExcQuotemediaV1EodPriceJobSpec;
}

export interface ExcQuotemediaV1EodPriceJobEventTypeTaskUpdated {
    /* ID of the task that was updated */
    // format: id62
    taskId: string;
    taskStatus: ExcQuotemediaV1EodPriceTaskStatus;
}

export const EXC_QUOTEMEDIA_V1_EOD_PRICE_JOB_EVENT_TYPE_ONE_OF_VALUES = ['created', 'taskUpdated', 'allFinished'] as const;

export type ExcQuotemediaV1EodPriceJobEventTypeOneOfValue = (typeof EXC_QUOTEMEDIA_V1_EOD_PRICE_JOB_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcQuotemediaV1EodPriceJobKeys {
    /* Primary identifier */
    // format: id62
    jobId: string;
}

export interface ExcQuotemediaV1EodPriceJobQueryServiceEodPriceJobEventsEodPriceJobEventsRequest {
    /* Primary identifier */
    // format: id62
    jobId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcQuotemediaV1EodPriceJobQueryServiceEodPriceJobEventsSortableFields, ExcQuotemediaV1EodPriceJobQueryServiceEodPriceJobEventsFilterableFields>;
}

export enum ExcQuotemediaV1EodPriceJobQueryServiceEodPriceJobEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    JobId = 'jobId',
    EventType = 'event.!type'
}

export enum ExcQuotemediaV1EodPriceJobQueryServiceEodPriceJobEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcQuotemediaV1EodPriceJobQueryServiceEodPriceJobGetEodPriceJobGetRequest {
    /* Primary identifier */
    // format: id62
    jobId: string;
}

export interface ExcQuotemediaV1EodPriceJobQueryServiceEodPriceJobListEodPriceJobListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcQuotemediaV1EodPriceJobQueryServiceEodPriceJobListSortableFields, ExcQuotemediaV1EodPriceJobQueryServiceEodPriceJobListFilterableFields>;
}

export enum ExcQuotemediaV1EodPriceJobQueryServiceEodPriceJobListFilterableFields {
    JobId = 'jobId',
    Status = 'status'
}

export enum ExcQuotemediaV1EodPriceJobQueryServiceEodPriceJobListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcQuotemediaV1EodPriceJobSpec {
    /* The date that end-of-day prices are generated for */
    // format: YYYY-MM-DD
    date: string;
    /* List of assets to generate end-of-day prices for. If not provided,
    defaults to all active assets */
    // format: id62
    assetIds?: string[];
}

export interface ExcQuotemediaV1EodPriceJobState extends ExcQuotemediaV1EodPriceJobKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcQuotemediaV1EodPriceJobData;
    status: ExcQuotemediaV1EodPriceJobStatus;
}

export enum ExcQuotemediaV1EodPriceJobStatus {
    Unspecified = 'UNSPECIFIED',
    Processing = 'PROCESSING',
    Done = 'DONE'
}

export interface ExcQuotemediaV1EodPriceTaskData {
    spec: ExcQuotemediaV1EodPriceTaskSpec;
}

export interface ExcQuotemediaV1EodPriceTaskEvent extends ExcQuotemediaV1EodPriceTaskKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcQuotemediaV1EodPriceTaskEventType;
}

export type ExcQuotemediaV1EodPriceTaskEventType = {
    '!type'?: 'created';
    created: ExcQuotemediaV1EodPriceTaskEventTypeCreated;
} | {
    '!type'?: 'finished';
    finished: ExcQuotemediaV1EodPriceTaskEventTypeFinished;
} | {
    '!type'?: 'errored';
    errored: ExcQuotemediaV1EodPriceTaskEventTypeErrored;
} | {
    '!type'?: 'failed';
    failed: ExcQuotemediaV1EodPriceTaskEventTypeFailed;
};

export interface ExcQuotemediaV1EodPriceTaskEventTypeCreated {
    spec: ExcQuotemediaV1EodPriceTaskSpec;
}

export interface ExcQuotemediaV1EodPriceTaskEventTypeErrored {
    /* Optional error message */
    message?: string;
}

export interface ExcQuotemediaV1EodPriceTaskEventTypeFailed {
    /* Optional error message */
    message?: string;
}

export interface ExcQuotemediaV1EodPriceTaskEventTypeFinished {
    // format: decimal
    price: string;
}

export const EXC_QUOTEMEDIA_V1_EOD_PRICE_TASK_EVENT_TYPE_ONE_OF_VALUES = ['created', 'finished', 'errored', 'failed'] as const;

export type ExcQuotemediaV1EodPriceTaskEventTypeOneOfValue = (typeof EXC_QUOTEMEDIA_V1_EOD_PRICE_TASK_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcQuotemediaV1EodPriceTaskKeys {
    /* Primary identifier */
    // format: id62
    taskId: string;
    // format: id62, entity: exc.quotemedia.v1.EodPriceJob
    jobId: string;
}

export interface ExcQuotemediaV1EodPriceTaskQueryServiceEodPriceTaskEventsEodPriceTaskEventsRequest {
    /* Primary identifier */
    // format: id62
    taskId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcQuotemediaV1EodPriceTaskQueryServiceEodPriceTaskEventsSortableFields, ExcQuotemediaV1EodPriceTaskQueryServiceEodPriceTaskEventsFilterableFields>;
}

export enum ExcQuotemediaV1EodPriceTaskQueryServiceEodPriceTaskEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    TaskId = 'taskId',
    JobId = 'jobId',
    EventType = 'event.!type'
}

export enum ExcQuotemediaV1EodPriceTaskQueryServiceEodPriceTaskEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcQuotemediaV1EodPriceTaskQueryServiceEodPriceTaskGetEodPriceTaskGetRequest {
    /* Primary identifier */
    // format: id62
    taskId: string;
}

export interface ExcQuotemediaV1EodPriceTaskQueryServiceEodPriceTaskListEodPriceTaskListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcQuotemediaV1EodPriceTaskQueryServiceEodPriceTaskListSortableFields, ExcQuotemediaV1EodPriceTaskQueryServiceEodPriceTaskListFilterableFields>;
}

export enum ExcQuotemediaV1EodPriceTaskQueryServiceEodPriceTaskListFilterableFields {
    TaskId = 'taskId',
    JobId = 'jobId',
    Status = 'status'
}

export enum ExcQuotemediaV1EodPriceTaskQueryServiceEodPriceTaskListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcQuotemediaV1EodPriceTaskSpec {
    /* The date that the end-of-day price is generated for */
    // format: YYYY-MM-DD
    date: string;
    /* Asset ID to generate the end-of-day price for */
    // format: id62
    assetId: string;
    /* Symbol to generate the end-of-day price for */
    symbol: string;
}

export interface ExcQuotemediaV1EodPriceTaskState extends ExcQuotemediaV1EodPriceTaskKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcQuotemediaV1EodPriceTaskData;
    status: ExcQuotemediaV1EodPriceTaskStatus;
}

export enum ExcQuotemediaV1EodPriceTaskStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Succeeded = 'SUCCEEDED',
    Errored = 'ERRORED',
    Failed = 'FAILED'
}

export interface ExcQuotemediaV1Metrics {
    // format: UINT32
    total?: number;
    // format: UINT32
    pending?: number;
    // format: UINT32
    processing?: number;
    // format: UINT32
    succeeded?: number;
    // format: UINT32
    errored?: number;
    // format: UINT32
    failed?: number;
}

export interface ExcQuotemediaV1Sp500Constituent {
    /* Ticker symbol as reported by QuoteMedia */
    symbol: string;
    /* The asset for this symbol. Unset until an asset with a matching symbol is
    known */
    // format: id62
    assetId?: string;
}

export interface ExcQuotemediaV1Sp500ListData {
    constituents: ExcQuotemediaV1Sp500Constituent[];
}

export interface ExcQuotemediaV1Sp500ListEvent extends ExcQuotemediaV1Sp500ListKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcQuotemediaV1Sp500ListEventType;
}

export type ExcQuotemediaV1Sp500ListEventType = {
    '!type'?: 'created';
    created: ExcQuotemediaV1Sp500ListEventTypeCreated;
} | {
    '!type'?: 'assetLinked';
    assetLinked: ExcQuotemediaV1Sp500ListEventTypeAssetLinked;
};

export interface ExcQuotemediaV1Sp500ListEventTypeAssetLinked {
    symbol: string;
    // format: id62
    assetId: string;
}

export interface ExcQuotemediaV1Sp500ListEventTypeCreated {
    constituents: ExcQuotemediaV1Sp500Constituent[];
}

export const EXC_QUOTEMEDIA_V1_SP500_LIST_EVENT_TYPE_ONE_OF_VALUES = ['created', 'assetLinked'] as const;

export type ExcQuotemediaV1Sp500ListEventTypeOneOfValue = (typeof EXC_QUOTEMEDIA_V1_SP500_LIST_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcQuotemediaV1Sp500ListKeys {
    /* The calendar quarter that the list is reported for, e.g. 2026Q1 */
    // format: custom - pattern: \d{4}Q[1-4]
    quarter: string;
}

export interface ExcQuotemediaV1Sp500ListQueryServiceSp500ListEventsSp500ListEventsRequest {
    /* The calendar quarter that the list is reported for, e.g. 2026Q1 */
    // format: custom - pattern: \d{4}Q[1-4]
    quarter: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcQuotemediaV1Sp500ListQueryServiceSp500ListEventsSortableFields, ExcQuotemediaV1Sp500ListQueryServiceSp500ListEventsFilterableFields>;
}

export enum ExcQuotemediaV1Sp500ListQueryServiceSp500ListEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    Quarter = 'quarter',
    EventType = 'event.!type'
}

export enum ExcQuotemediaV1Sp500ListQueryServiceSp500ListEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcQuotemediaV1Sp500ListQueryServiceSp500ListGetSp500ListGetRequest {
    /* The calendar quarter that the list is reported for, e.g. 2026Q1 */
    // format: custom - pattern: \d{4}Q[1-4]
    quarter: string;
}

export interface ExcQuotemediaV1Sp500ListQueryServiceSp500ListListSp500ListListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcQuotemediaV1Sp500ListQueryServiceSp500ListListSortableFields, ExcQuotemediaV1Sp500ListQueryServiceSp500ListListFilterableFields>;
}

export enum ExcQuotemediaV1Sp500ListQueryServiceSp500ListListFilterableFields {
    Quarter = 'quarter',
    Status = 'status'
}

export enum ExcQuotemediaV1Sp500ListQueryServiceSp500ListListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcQuotemediaV1Sp500ListState extends ExcQuotemediaV1Sp500ListKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcQuotemediaV1Sp500ListData;
    status: ExcQuotemediaV1Sp500ListStatus;
}

export enum ExcQuotemediaV1Sp500ListStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE'
}

export enum ExcQuotemediaV1Sp500ListSummaryName {
    Unspecified = 'UNSPECIFIED',
    Sp500ListSummary = 'Sp500ListSummary'
}

export enum ExcRouteV1FailoverBehavior {
    Unspecified = 'UNSPECIFIED',
    NextDestination = 'NEXT_DESTINATION',
    Reject = 'REJECT',
    Queue = 'QUEUE'
}

export interface ExcRouteV1FixMessageData {
    /* Whether the message was sent to or received from the venue. */
    direction: ExcRouteV1MessageDirection;
    /* FIX MsgType (tag 35). */
    messageType: ExcFixV1MessageType;
    sessionId: string;
    /* Message sequence number (tag 34). */
    // format: INT64
    sequenceNumber: string;
    /* Client order ID (tag 11). */
    clientOrderId?: string;
    /* Original client order ID (tag 41). */
    originalClientOrderId?: string;
    /* Venue retransmit flag (tag 43). */
    possibleDuplicate?: boolean;
    /* Message sending time (tag 52). */
    // format: date-time
    sent?: string;
    /* The complete message exactly as it crossed the wire. */
    // bytes (base64-encoded)
    raw: string;
}

export interface ExcRouteV1FixMessageEvent extends ExcRouteV1FixMessageKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcRouteV1FixMessageEventType;
}

export type ExcRouteV1FixMessageEventType = {
    '!type'?: 'recorded';
    recorded: ExcRouteV1FixMessageEventTypeRecorded;
};

export interface ExcRouteV1FixMessageEventTypeRecorded {
    direction: ExcRouteV1MessageDirection;
    messageType: ExcFixV1MessageType;
    sessionId: string;
    // format: INT64
    sequenceNumber: string;
    clientOrderId?: string;
    originalClientOrderId?: string;
    possibleDuplicate?: boolean;
    // format: date-time
    sent?: string;
    // bytes (base64-encoded)
    raw: string;
}

export const EXC_ROUTE_V1_FIX_MESSAGE_EVENT_TYPE_ONE_OF_VALUES = ['recorded'] as const;

export type ExcRouteV1FixMessageEventTypeOneOfValue = (typeof EXC_ROUTE_V1_FIX_MESSAGE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcRouteV1FixMessageKeys {
    // format: id62
    fixMessageId: string;
    /* The order this message belongs to. Unset when the message could not be
    matched to an order. */
    // format: id62, entity: exc.route.v1.FixOrder
    fixOrderId?: string;
}

export interface ExcRouteV1FixMessageQueryServiceFixMessageEventsFixMessageEventsRequest {
    // format: id62
    fixMessageId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcRouteV1FixMessageQueryServiceFixMessageEventsSortableFields, ExcRouteV1FixMessageQueryServiceFixMessageEventsFilterableFields>;
}

export enum ExcRouteV1FixMessageQueryServiceFixMessageEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    FixMessageId = 'fixMessageId',
    FixOrderId = 'fixOrderId',
    EventType = 'event.!type'
}

export enum ExcRouteV1FixMessageQueryServiceFixMessageEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcRouteV1FixMessageQueryServiceFixMessageGetFixMessageGetRequest {
    // format: id62
    fixMessageId: string;
}

export interface ExcRouteV1FixMessageQueryServiceFixMessageListFixMessageListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcRouteV1FixMessageQueryServiceFixMessageListSortableFields, ExcRouteV1FixMessageQueryServiceFixMessageListFilterableFields>;
}

export enum ExcRouteV1FixMessageQueryServiceFixMessageListFilterableFields {
    FixMessageId = 'fixMessageId',
    FixOrderId = 'fixOrderId',
    Status = 'status'
}

export enum ExcRouteV1FixMessageQueryServiceFixMessageListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataSent = 'data.sent'
}

export interface ExcRouteV1FixMessageState extends ExcRouteV1FixMessageKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcRouteV1FixMessageData;
    status: ExcRouteV1FixMessageStatus;
}

export enum ExcRouteV1FixMessageStatus {
    Unspecified = 'UNSPECIFIED',
    Recorded = 'RECORDED'
}

export interface ExcRouteV1FixOrderData {
    parentOrder: ExcRouteV1ParentOrder;
    remoteOrderId?: string;
    spec?: IxcOrdersV1OrderInstruction;
    requestMetadata: J5MessagingV1RequestMetadata;
    /* The remaining quantity of the order */
    // format: UINT32
    remainingQuantity?: number;
    /* Records which routing rule and destination were used for this order */
    routingDecision?: ExcRouteV1RoutingDecision;
}

export interface ExcRouteV1FixOrderEvent extends ExcRouteV1FixOrderKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcRouteV1FixOrderEventType;
}

export type ExcRouteV1FixOrderEventType = {
    '!type'?: 'created';
    created: ExcRouteV1FixOrderEventTypeCreated;
} | {
    '!type'?: 'accepted';
    accepted: ExcRouteV1FixOrderEventTypeAccepted;
} | {
    '!type'?: 'rejected';
    rejected: ExcRouteV1FixOrderEventTypeRejected;
} | {
    '!type'?: 'requestCancel';
    requestCancel: ExcRouteV1FixOrderEventTypeRequestCancel;
} | {
    '!type'?: 'canceled';
    canceled: ExcRouteV1FixOrderEventTypeCanceled;
} | {
    '!type'?: 'cancelRejected';
    cancelRejected: EmptyObject;
} | {
    '!type'?: 'fill';
    fill: ExcRouteV1FixOrderEventTypeFill;
} | {
    '!type'?: 'done';
    done: EmptyObject;
};

export interface ExcRouteV1FixOrderEventTypeAccepted {
    remoteOrderId: string;
}

export interface ExcRouteV1FixOrderEventTypeCanceled {
    /* ClOrdId of the Cancel or Replace message */
    // format: id62
    clCancelId: string;
    /* OrdId from the fix remote. */
    remoteCancelId: string;
}

export interface ExcRouteV1FixOrderEventTypeCreated {
    instruction: IxcOrdersV1OrderInstruction;
    requestMetadata: J5MessagingV1RequestMetadata;
    parentOrder: ExcRouteV1ParentOrder;
    /* Foreign key to oms.Asset */
    // format: id62, entity: ixc.orders.v1.Asset
    assetId: string;
    /* Records which routing rule and destination were used for this order */
    routingDecision?: ExcRouteV1RoutingDecision;
    /* Trading-hours authorization the order was sent to the venue with. */
    tradingHours?: ExcRouteV1TradingHours;
}

export interface ExcRouteV1FixOrderEventTypeFill {
    detail: ExcRouteV1FixOrderFill;
}

export interface ExcRouteV1FixOrderEventTypeRejected {
    code: ExcRouteV1RejectCode;
    /* Optional text field for additional information */
    text?: string;
}

export interface ExcRouteV1FixOrderEventTypeRequestCancel {
    /* ClOrdId of the Cancel or Replace message */
    // format: id62
    clCancelId: string;
}

export const EXC_ROUTE_V1_FIX_ORDER_EVENT_TYPE_ONE_OF_VALUES = ['created', 'accepted', 'rejected', 'requestCancel', 'canceled', 'cancelRejected', 'fill', 'done'] as const;

export type ExcRouteV1FixOrderEventTypeOneOfValue = (typeof EXC_ROUTE_V1_FIX_ORDER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcRouteV1FixOrderFill {
    /* FIX Tag 17 ExecId */
    executionId: string;
    /* FIX Tag 32 LastShares */
    // format: UINT32
    quantity: number;
    /* FIX Tag 31 LastPx */
    // format: decimal
    price: string;
    /* FIX Tag 60 TransactTime */
    // format: date-time
    executionTime: string;
    /* FIX Tag 375 ContraBroker Identifies the Exchange. */
    contraBroker: string;
}

export interface ExcRouteV1FixOrderKeys {
    // format: id62
    clOrderId: string;
}

export interface ExcRouteV1FixOrderQueryServiceFixOrderEventsFixOrderEventsRequest {
    // format: id62
    clOrderId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcRouteV1FixOrderQueryServiceFixOrderEventsSortableFields, ExcRouteV1FixOrderQueryServiceFixOrderEventsFilterableFields>;
}

export enum ExcRouteV1FixOrderQueryServiceFixOrderEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    ClOrderId = 'clOrderId',
    EventCreatedInstructionSide = 'event.created.instruction.side',
    EventType = 'event.!type'
}

export enum ExcRouteV1FixOrderQueryServiceFixOrderEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcRouteV1FixOrderQueryServiceFixOrderGetFixOrderGetRequest {
    // format: id62
    clOrderId: string;
}

export interface ExcRouteV1FixOrderQueryServiceFixOrderListFixOrderListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcRouteV1FixOrderQueryServiceFixOrderListSortableFields, ExcRouteV1FixOrderQueryServiceFixOrderListFilterableFields>;
}

export enum ExcRouteV1FixOrderQueryServiceFixOrderListFilterableFields {
    ClOrderId = 'clOrderId',
    DataSpecSide = 'data.spec.side',
    Status = 'status'
}

export enum ExcRouteV1FixOrderQueryServiceFixOrderListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcRouteV1FixOrderState extends ExcRouteV1FixOrderKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcRouteV1FixOrderData;
    status: ExcRouteV1FixOrderStatus;
}

export enum ExcRouteV1FixOrderStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Active = 'ACTIVE',
    ActiveC = 'ACTIVE_C',
    Rejected = 'REJECTED',
    Cancelled = 'CANCELLED',
    Done = 'DONE'
}

export interface ExcRouteV1FixSessionConfig {
    /* Hostname or IP address of the FIX venue */
    targetHost: string;
    /* Port number for FIX connection */
    // format: INT32
    targetPort: number;
    /* FIX protocol version (e.g., "4.2", "4.4") */
    fixVersion: string;
    /* Whether to reset sequences on logon */
    resetOnLogon?: boolean;
    /* Heartbeat interval in seconds (default: 30) */
    // format: INT32
    heartbeatInterval?: number;
    /* Socket timeout in seconds (default: 30) */
    // format: INT32
    socketTimeout?: number;
    /* Reconnect interval in seconds (default: 30) */
    // format: INT32
    reconnectInterval?: number;
    /* Venue adapter type for FIX message construction and validation */
    venueType?: ExcRouteV1VenueType;
    /* 24-hour HH:MM:SS, leading zeros required */
    // pattern: ^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$
    startTime: string;
    // pattern: ^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$
    endTime: string;
}

export interface ExcRouteV1FixSessionData {
    /* Next outgoing sequence number */
    // format: INT32
    senderSeq: number;
    /* Next expected incoming sequence number */
    // format: INT32
    targetSeq: number;
    /* Whether QuickFIX initiator process is started */
    initiatorRunning?: boolean;
    /* Whether session is logged on to venue */
    isLoggedOn?: boolean;
    config: ExcRouteV1FixSessionConfig;
}

export interface ExcRouteV1FixSessionEvent extends ExcRouteV1FixSessionKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcRouteV1FixSessionEventType;
}

export type ExcRouteV1FixSessionEventType = {
    '!type'?: 'registered';
    registered: ExcRouteV1FixSessionEventTypeRegistered;
} | {
    '!type'?: 'connected';
    connected: ExcRouteV1FixSessionEventTypeConnected;
} | {
    '!type'?: 'disconnected';
    disconnected: EmptyObject;
} | {
    '!type'?: 'initiatorStopped';
    initiatorStopped: EmptyObject;
} | {
    '!type'?: 'sequenceNumbersUpdated';
    sequenceNumbersUpdated: ExcRouteV1FixSessionEventTypeSequenceNumbersUpdated;
} | {
    '!type'?: 'initiatorStarted';
    initiatorStarted: EmptyObject;
} | {
    '!type'?: 'sequenceNumbersReset';
    sequenceNumbersReset: EmptyObject;
} | {
    '!type'?: 'resendRequested';
    resendRequested: ExcRouteV1FixSessionEventTypeResendRequested;
} | {
    '!type'?: 'configUpdated';
    configUpdated: ExcRouteV1FixSessionEventTypeConfigUpdated;
};

export interface ExcRouteV1FixSessionEventTypeConfigUpdated {
    config: ExcRouteV1FixSessionConfig;
}

export interface ExcRouteV1FixSessionEventTypeConnected {
    // format: INT32
    senderSeq: number;
    // format: INT32
    targetSeq: number;
}

export interface ExcRouteV1FixSessionEventTypeRegistered {
    /* FIX SenderCompID (tag 49) */
    senderCompId: string;
    /* FIX SenderSubID (tag 50) */
    senderSubId?: string;
    /* FIX TargetCompID (tag 56) */
    targetCompId: string;
    /* FIX TargetSubID (tag 57) */
    targetSubId?: string;
    /* Initial session configuration */
    config: ExcRouteV1FixSessionConfig;
}

export interface ExcRouteV1FixSessionEventTypeResendRequested {
    /* Beginning sequence number of the requested range */
    // format: INT32
    beginSeqNo: number;
    /* Ending sequence number of the requested range (0 for open-ended) */
    // format: INT32
    endSeqNo: number;
}

export interface ExcRouteV1FixSessionEventTypeSequenceNumbersUpdated {
    // format: INT32
    senderSeq: number;
    // format: INT32
    targetSeq: number;
    reason: ExcRouteV1SequenceUpdateReason;
}

export const EXC_ROUTE_V1_FIX_SESSION_EVENT_TYPE_ONE_OF_VALUES = ['registered', 'connected', 'disconnected', 'initiatorStopped', 'sequenceNumbersUpdated', 'initiatorStarted', 'sequenceNumbersReset', 'resendRequested', 'configUpdated'] as const;

export type ExcRouteV1FixSessionEventTypeOneOfValue = (typeof EXC_ROUTE_V1_FIX_SESSION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcRouteV1FixSessionKeys {
    // format: id62
    sessionId: string;
    /* FIX SenderCompID - identifies this application */
    senderCompId?: string;
    /* FIX SenderSubID */
    senderSubId?: string;
    /* FIX TargetCompID - identifies counterparty */
    targetCompId?: string;
    /* FIX TargetSubID */
    targetSubId?: string;
}

export interface ExcRouteV1FixSessionQueryServiceFixSessionEventsFixSessionEventsRequest {
    // format: id62
    sessionId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcRouteV1FixSessionQueryServiceFixSessionEventsSortableFields, ExcRouteV1FixSessionQueryServiceFixSessionEventsFilterableFields>;
}

export enum ExcRouteV1FixSessionQueryServiceFixSessionEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    SessionId = 'sessionId',
    EventType = 'event.!type'
}

export enum ExcRouteV1FixSessionQueryServiceFixSessionEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcRouteV1FixSessionQueryServiceFixSessionGetFixSessionGetRequest {
    // format: id62
    sessionId: string;
}

export interface ExcRouteV1FixSessionQueryServiceFixSessionListFixSessionListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcRouteV1FixSessionQueryServiceFixSessionListSortableFields, ExcRouteV1FixSessionQueryServiceFixSessionListFilterableFields>;
}

export enum ExcRouteV1FixSessionQueryServiceFixSessionListFilterableFields {
    SessionId = 'sessionId',
    Status = 'status'
}

export enum ExcRouteV1FixSessionQueryServiceFixSessionListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExcRouteV1FixSessionState extends ExcRouteV1FixSessionKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcRouteV1FixSessionData;
    status: ExcRouteV1FixSessionStatus;
}

export enum ExcRouteV1FixSessionStatus {
    Unspecified = 'UNSPECIFIED',
    Stopped = 'STOPPED',
    Connecting = 'CONNECTING',
    Disconnected = 'DISCONNECTED',
    LoggedOn = 'LOGGED_ON'
}

export enum ExcRouteV1MessageDirection {
    Unspecified = 'UNSPECIFIED',
    Outbound = 'OUTBOUND',
    Inbound = 'INBOUND'
}

export type ExcRouteV1ParentOrder = {
    '!type'?: 'customer';
    /* The order belongs to a single customer */
    customer: ExcRouteV1ParentOrderCustomer;
} | {
    '!type'?: 'firm';
    firm: ExcRouteV1ParentOrderFirm;
};

export interface ExcRouteV1ParentOrderCustomer {
    /* Foreign key to oms.Order */
    // format: id62, entity: ixc.orders.v1.Order
    orderId: string;
    // format: id62
    accountId: string;
    // format: id62
    programId: string;
}

export interface ExcRouteV1ParentOrderFirm {
    /* Foreign key to inventory.Order */
    // format: id62, entity: ixc.inventory.v1.FirmOrder
    firmOrderId: string;
}

export const EXC_ROUTE_V1_PARENT_ORDER_ONE_OF_VALUES = ['customer', 'firm'] as const;

export type ExcRouteV1ParentOrderOneOfValue = (typeof EXC_ROUTE_V1_PARENT_ORDER_ONE_OF_VALUES)[number];

export enum ExcRouteV1RejectCode {
    Unspecified = 'UNSPECIFIED',
    LocateReqdNotSetN = 'LOCATE_REQD_NOT_SET_N',
    RashNotOpen = 'RASH_NOT_OPEN',
    InvalidSide = 'INVALID_SIDE',
    InvalidPegType = 'INVALID_PEG_TYPE',
    InvalidFirm = 'INVALID_FIRM',
    UnknownError = 'UNKNOWN_ERROR',
    OrderSizeTooLarge = 'ORDER_SIZE_TOO_LARGE',
    QuoteNotAvailableForPegged = 'QUOTE_NOT_AVAILABLE_FOR_PEGGED',
    PeggingNotAllowed = 'PEGGING_NOT_ALLOWED',
    InvalidPrice = 'INVALID_PRICE',
    RoutingNotEnabled = 'ROUTING_NOT_ENABLED',
    RoutingDestinationDown = 'ROUTING_DESTINATION_DOWN',
    InternalNasdaqError = 'INTERNAL_NASDAQ_ERROR',
    UnsupportedOrderAttribute = 'UNSUPPORTED_ORDER_ATTRIBUTE',
    BadReserveValue = 'BAD_RESERVE_VALUE',
    PortInTestMode = 'PORT_IN_TEST_MODE',
    Halted = 'HALTED',
    InvalidStock = 'INVALID_STOCK',
    InvalidOrderQty = 'INVALID_ORDER_QTY',
    InvalidMinQty = 'INVALID_MIN_QTY',
    RoutingDestinationNotSupported = 'ROUTING_DESTINATION_NOT_SUPPORTED',
    AdvancedFunctionalityNotSupported = 'ADVANCED_FUNCTIONALITY_NOT_SUPPORTED',
    ResentOrderRejected = 'RESENT_ORDER_REJECTED',
    InvalidOrderType = 'INVALID_ORDER_TYPE',
    RiskRestrictedStock = 'RISK_RESTRICTED_STOCK',
    RiskShortSellRestricted = 'RISK_SHORT_SELL_RESTRICTED',
    RiskExceedsAdvLimit = 'RISK_EXCEEDS_ADV_LIMIT',
    RiskFatFinger = 'RISK_FAT_FINGER',
    RiskLocateRequired = 'RISK_LOCATE_REQUIRED',
    RiskMaxNotionalExceeded = 'RISK_MAX_NOTIONAL_EXCEEDED',
    RiskOrderTypeRestricted = 'RISK_ORDER_TYPE_RESTRICTED',
    RiskMaxSharesExceeded = 'RISK_MAX_SHARES_EXCEEDED',
    MidpointPegCrossedMarket = 'MIDPOINT_PEG_CROSSED_MARKET',
    RiskMarketImpact = 'RISK_MARKET_IMPACT',
    RiskOpenExposureExceeded = 'RISK_OPEN_EXPOSURE_EXCEEDED',
    RiskPortMessageRateExceeded = 'RISK_PORT_MESSAGE_RATE_EXCEEDED',
    RiskSymbolMessageRateExceeded = 'RISK_SYMBOL_MESSAGE_RATE_EXCEEDED',
    RiskDuplicateMessageRateExceeded = 'RISK_DUPLICATE_MESSAGE_RATE_EXCEEDED',
    RiskExecutedExposureExceeded = 'RISK_EXECUTED_EXPOSURE_EXCEEDED',
    RiskNotionalExposureExceeded = 'RISK_NOTIONAL_EXPOSURE_EXCEEDED'
}

export const EXC_ROUTE_V1_REJECT_CODE_INFO_EXTENSION_CODE_MAP = {
    [ExcRouteV1RejectCode.LocateReqdNotSetN]: 'Y',
    [ExcRouteV1RejectCode.RashNotOpen]: 'C',
    [ExcRouteV1RejectCode.InvalidSide]: 'I',
    [ExcRouteV1RejectCode.InvalidPegType]: 'E',
    [ExcRouteV1RejectCode.InvalidFirm]: 'L',
    [ExcRouteV1RejectCode.UnknownError]: 'O',
    [ExcRouteV1RejectCode.OrderSizeTooLarge]: 'Z',
    [ExcRouteV1RejectCode.QuoteNotAvailableForPegged]: 'B',
    [ExcRouteV1RejectCode.PeggingNotAllowed]: 'P',
    [ExcRouteV1RejectCode.InvalidPrice]: 'X',
    [ExcRouteV1RejectCode.RoutingNotEnabled]: 'R',
    [ExcRouteV1RejectCode.RoutingDestinationDown]: 'G',
    [ExcRouteV1RejectCode.InternalNasdaqError]: 'J',
    [ExcRouteV1RejectCode.UnsupportedOrderAttribute]: 'N',
    [ExcRouteV1RejectCode.BadReserveValue]: 'D',
    [ExcRouteV1RejectCode.PortInTestMode]: 'T',
    [ExcRouteV1RejectCode.Halted]: 'H',
    [ExcRouteV1RejectCode.InvalidStock]: 'S',
    [ExcRouteV1RejectCode.InvalidOrderQty]: 'Q',
    [ExcRouteV1RejectCode.InvalidMinQty]: 'K',
    [ExcRouteV1RejectCode.RoutingDestinationNotSupported]: 'W',
    [ExcRouteV1RejectCode.AdvancedFunctionalityNotSupported]: 'A',
    [ExcRouteV1RejectCode.ResentOrderRejected]: 'U',
    [ExcRouteV1RejectCode.InvalidOrderType]: 'V',
    [ExcRouteV1RejectCode.RiskRestrictedStock]: 'a',
    [ExcRouteV1RejectCode.RiskShortSellRestricted]: 'b',
    [ExcRouteV1RejectCode.RiskExceedsAdvLimit]: 'd',
    [ExcRouteV1RejectCode.RiskFatFinger]: 'e',
    [ExcRouteV1RejectCode.RiskLocateRequired]: 'l',
    [ExcRouteV1RejectCode.RiskMaxNotionalExceeded]: 'n',
    [ExcRouteV1RejectCode.RiskOrderTypeRestricted]: 'o',
    [ExcRouteV1RejectCode.RiskMaxSharesExceeded]: 'p',
    [ExcRouteV1RejectCode.MidpointPegCrossedMarket]: 'q',
    [ExcRouteV1RejectCode.RiskMarketImpact]: 'r',
    [ExcRouteV1RejectCode.RiskOpenExposureExceeded]: 's',
    [ExcRouteV1RejectCode.RiskPortMessageRateExceeded]: 'u',
    [ExcRouteV1RejectCode.RiskSymbolMessageRateExceeded]: 'v',
    [ExcRouteV1RejectCode.RiskDuplicateMessageRateExceeded]: 'w',
    [ExcRouteV1RejectCode.RiskExecutedExposureExceeded]: 'x',
    [ExcRouteV1RejectCode.RiskNotionalExposureExceeded]: 'y'
} as const;

export const EXC_ROUTE_V1_REJECT_CODE_INFO_EXTENSION_LABEL_MAP = {
    [ExcRouteV1RejectCode.LocateReqdNotSetN]: 'The LocateReqd tag was not set to \'N\'',
    [ExcRouteV1RejectCode.RashNotOpen]: 'Rash is not yet open',
    [ExcRouteV1RejectCode.InvalidSide]: 'Invalid side',
    [ExcRouteV1RejectCode.InvalidPegType]: 'Invalid peg type',
    [ExcRouteV1RejectCode.InvalidFirm]: 'Invalid Firm',
    [ExcRouteV1RejectCode.UnknownError]: 'Unknown Error',
    [ExcRouteV1RejectCode.OrderSizeTooLarge]: 'Order Size is more than maximum shares allowed',
    [ExcRouteV1RejectCode.QuoteNotAvailableForPegged]: 'Quote not available for pegged order',
    [ExcRouteV1RejectCode.PeggingNotAllowed]: 'Pegging is not allowed',
    [ExcRouteV1RejectCode.InvalidPrice]: 'The order does not have a valid price',
    [ExcRouteV1RejectCode.RoutingNotEnabled]: 'Routing not enabled',
    [ExcRouteV1RejectCode.RoutingDestinationDown]: 'Specified routing destination is temporarily down',
    [ExcRouteV1RejectCode.InternalNasdaqError]: 'Internal NASDAQ error',
    [ExcRouteV1RejectCode.UnsupportedOrderAttribute]: 'Order attribute specified that the routing destination does not support',
    [ExcRouteV1RejectCode.BadReserveValue]: 'Bad reserve value',
    [ExcRouteV1RejectCode.PortInTestMode]: 'Port is in Test Only mode',
    [ExcRouteV1RejectCode.Halted]: 'The stock is halted',
    [ExcRouteV1RejectCode.InvalidStock]: 'Invalid stock',
    [ExcRouteV1RejectCode.InvalidOrderQty]: 'Invalid order qty',
    [ExcRouteV1RejectCode.InvalidMinQty]: 'Invalid Min Qty',
    [ExcRouteV1RejectCode.RoutingDestinationNotSupported]: 'Routing destination is not supported',
    [ExcRouteV1RejectCode.AdvancedFunctionalityNotSupported]: 'Advanced functionality not supported',
    [ExcRouteV1RejectCode.ResentOrderRejected]: 'NASDAQ was asked to reject resent orders and this order was resent',
    [ExcRouteV1RejectCode.InvalidOrderType]: 'Invalid Order Type',
    [ExcRouteV1RejectCode.RiskRestrictedStock]: 'Risk: Restricted Stock',
    [ExcRouteV1RejectCode.RiskShortSellRestricted]: 'Risk: Short Sell Restricted',
    [ExcRouteV1RejectCode.RiskExceedsAdvLimit]: 'Risk: Exceeds ADVLimit',
    [ExcRouteV1RejectCode.RiskFatFinger]: 'Risk: Fat Finger',
    [ExcRouteV1RejectCode.RiskLocateRequired]: 'Risk: Locate Required',
    [ExcRouteV1RejectCode.RiskMaxNotionalExceeded]: 'Risk: Max Notional Exceeded',
    [ExcRouteV1RejectCode.RiskOrderTypeRestricted]: 'Risk: Order Type Restricted',
    [ExcRouteV1RejectCode.RiskMaxSharesExceeded]: 'Risk: Max Shares Exceeded',
    [ExcRouteV1RejectCode.MidpointPegCrossedMarket]: 'Midpoint Peg orders are not accepted in a crossed market',
    [ExcRouteV1RejectCode.RiskMarketImpact]: 'Risk: Market Impact',
    [ExcRouteV1RejectCode.RiskOpenExposureExceeded]: 'Risk: Open Exposure Exceeded',
    [ExcRouteV1RejectCode.RiskPortMessageRateExceeded]: 'Risk: Port Message Rate Exceeded',
    [ExcRouteV1RejectCode.RiskSymbolMessageRateExceeded]: 'Risk: Symbol Message Rate Exceeded',
    [ExcRouteV1RejectCode.RiskDuplicateMessageRateExceeded]: 'Risk: Duplicate Message Rate Exceeded',
    [ExcRouteV1RejectCode.RiskExecutedExposureExceeded]: 'Risk: Executed Exposure Exceeded',
    [ExcRouteV1RejectCode.RiskNotionalExposureExceeded]: 'Risk: Notional Exposure Exceeded'
} as const;

export interface ExcRouteV1RoutingDecision {
    /* The routing rule that matched this order */
    // format: id62, entity: exc.route.v1.RoutingRule
    ruleId?: string;
    /* The FIX session the order was routed to */
    // format: id62, entity: exc.route.v1.FixSession
    destinationSessionId?: string;
    /* Human-readable description of the routing decision e.g. "rule 'default'
    (priority 100), weighted 60%" */
    reason?: string;
    /* Whether the primary destination was unavailable and failover was used */
    usedFailover?: boolean;
    /* If failover occurred, the session that was originally selected */
    // format: id62, entity: exc.route.v1.FixSession
    originalSessionId?: string;
    /* The venue adapter type of the destination session, denormalized from
    FixSessionConfig for downstream consumers (e.g., tradereporting MEOR). */
    venueType?: ExcRouteV1VenueType;
}

export interface ExcRouteV1RoutingDestination {
    /* References a FixSession.sessionId */
    // format: id62, entity: exc.route.v1.FixSession
    sessionId: string;
    /* Percentage weight (0-100). All weights in a rule must sum to 100. */
    // format: UINT32
    weight: number;
}

export interface ExcRouteV1RoutingFilter {
    type: ExcRouteV1RoutingFilterType;
}

export type ExcRouteV1RoutingFilterType = {
    '!type'?: 'matchAll';
    /* Matches all orders unconditionally */
    matchAll: EmptyObject;
} | {
    '!type'?: 'symbolFilter';
    /* Matches orders for specific symbols (future) */
    symbolFilter: ExcRouteV1SymbolFilter;
} | {
    '!type'?: 'priceFilter';
    /* Matches orders based on price thresholds (future) */
    priceFilter: EmptyObject;
} | {
    '!type'?: 'timeWindow';
    /* Matches orders arriving within a daily wall-clock window in
    America/New_York */
    timeWindow: ExcRouteV1TimeWindowFilter;
};

export const EXC_ROUTE_V1_ROUTING_FILTER_TYPE_ONE_OF_VALUES = ['matchAll', 'symbolFilter', 'priceFilter', 'timeWindow'] as const;

export type ExcRouteV1RoutingFilterTypeOneOfValue = (typeof EXC_ROUTE_V1_ROUTING_FILTER_TYPE_ONE_OF_VALUES)[number];

export interface ExcRouteV1RoutingRuleData {
    /* Lower number = higher priority. Must be unique among enabled rules. */
    // format: INT32
    priority: number;
    /* Criteria for matching orders to this rule */
    filter: ExcRouteV1RoutingFilter;
    /* Weighted list of venues to route to. Weights must sum to 100. */
    destinations?: ExcRouteV1RoutingDestination[];
    /* What to do when all destinations in this rule are unavailable */
    failoverBehavior: ExcRouteV1FailoverBehavior;
}

export interface ExcRouteV1RoutingRuleEvent extends ExcRouteV1RoutingRuleKeys {
    metadata: J5StateV1EventMetadata;
    event: ExcRouteV1RoutingRuleEventType;
}

export type ExcRouteV1RoutingRuleEventType = {
    '!type'?: 'created';
    created: ExcRouteV1RoutingRuleEventTypeCreated;
} | {
    '!type'?: 'updated';
    updated: ExcRouteV1RoutingRuleEventTypeUpdated;
} | {
    '!type'?: 'enabled';
    enabled: EmptyObject;
} | {
    '!type'?: 'disabled';
    disabled: EmptyObject;
};

export interface ExcRouteV1RoutingRuleEventTypeCreated {
    // format: INT32
    priority: number;
    filter: ExcRouteV1RoutingFilter;
    destinations?: ExcRouteV1RoutingDestination[];
    failoverBehavior: ExcRouteV1FailoverBehavior;
}

export interface ExcRouteV1RoutingRuleEventTypeUpdated {
    // format: INT32
    priority: number;
    filter: ExcRouteV1RoutingFilter;
    destinations?: ExcRouteV1RoutingDestination[];
    failoverBehavior: ExcRouteV1FailoverBehavior;
}

export const EXC_ROUTE_V1_ROUTING_RULE_EVENT_TYPE_ONE_OF_VALUES = ['created', 'updated', 'enabled', 'disabled'] as const;

export type ExcRouteV1RoutingRuleEventTypeOneOfValue = (typeof EXC_ROUTE_V1_ROUTING_RULE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExcRouteV1RoutingRuleKeys {
    // format: id62
    ruleId: string;
}

export interface ExcRouteV1RoutingRuleQueryServiceRoutingRuleEventsRoutingRuleEventsRequest {
    // format: id62
    ruleId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcRouteV1RoutingRuleQueryServiceRoutingRuleEventsSortableFields, ExcRouteV1RoutingRuleQueryServiceRoutingRuleEventsFilterableFields>;
}

export enum ExcRouteV1RoutingRuleQueryServiceRoutingRuleEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    RuleId = 'ruleId',
    EventType = 'event.!type'
}

export enum ExcRouteV1RoutingRuleQueryServiceRoutingRuleEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExcRouteV1RoutingRuleQueryServiceRoutingRuleGetRoutingRuleGetRequest {
    // format: id62
    ruleId: string;
}

export interface ExcRouteV1RoutingRuleQueryServiceRoutingRuleListRoutingRuleListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExcRouteV1RoutingRuleQueryServiceRoutingRuleListSortableFields, ExcRouteV1RoutingRuleQueryServiceRoutingRuleListFilterableFields>;
}

export enum ExcRouteV1RoutingRuleQueryServiceRoutingRuleListFilterableFields {
    RuleId = 'ruleId',
    Status = 'status'
}

export enum ExcRouteV1RoutingRuleQueryServiceRoutingRuleListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataPriority = 'data.priority'
}

export interface ExcRouteV1RoutingRuleState extends ExcRouteV1RoutingRuleKeys {
    metadata: J5StateV1StateMetadata;
    data: ExcRouteV1RoutingRuleData;
    status: ExcRouteV1RoutingRuleStatus;
}

export enum ExcRouteV1RoutingRuleStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Disabled = 'DISABLED'
}

export enum ExcRouteV1SequenceUpdateReason {
    Unspecified = 'UNSPECIFIED',
    ManualSet = 'MANUAL_SET',
    Bump = 'BUMP',
    GapFill = 'GAP_FILL',
    Resync = 'RESYNC'
}

export interface ExcRouteV1SymbolFilter {
    /* List of ticker symbols to match */
    symbols?: string[];
}

export interface ExcRouteV1TimeWindowFilter {
    /* Window start, 24-hour HH:MM, leading zeros required. Inclusive. */
    from: string;
    /* Window end, 24-hour HH:MM, leading zeros required. Exclusive. */
    until: string;
}

export enum ExcRouteV1TradingHours {
    Unspecified = 'UNSPECIFIED',
    Regular = 'REGULAR',
    Extended = 'EXTENDED'
}

export enum ExcRouteV1VenueType {
    Unspecified = 'UNSPECIFIED',
    Nasdaq = 'NASDAQ',
    Janestreet = 'JANESTREET'
}

export interface ExfOfacEmulatorV1AkaIndividual {
    type?: ExfOfacEmulatorV1OfacAkaType;
    category?: ExfOfacEmulatorV1OfacAkaCategory;
    lastName: string;
    firstName?: string;
}

export interface ExfOfacEmulatorV1AkaOrganization {
    type?: ExfOfacEmulatorV1OfacAkaType;
    category?: ExfOfacEmulatorV1OfacAkaCategory;
    name: string;
}

export interface ExfOfacEmulatorV1Birthdate {
    /* Date of birth in the format of YYYY-MM-DD, YYYY-MM, or YYYY */
    startDate: string;
    /* Date of birth in the format of YYYY-MM-DD, YYYY-MM, or YYYY Not required
    if the date is circa or if the date is a single date, month and year, or
    year. Examples where not required is starting date is: 2024-01-2,
    2024-01, or 2024 */
    endDate?: string;
    /* Set to true if this is the main entry for the date. If more than one date
    is set to main entry, the remaining will be set to false. */
    mainEntry?: boolean;
    /* Set to true if the date is circa. End Date will be ignored if entered. */
    circa?: boolean;
}

export interface ExfOfacEmulatorV1Citizenship {
    country: string;
    /* Set to true if this is the main entry for the nationalities. If more than
    one citizenship is set to main entry, the remaining will be set to false. */
    mainEntry?: boolean;
}

export interface ExfOfacEmulatorV1Id {
    type?: ExfOfacEmulatorV1OfacIdType;
    number?: string;
    country?: string;
}

export interface ExfOfacEmulatorV1Nationality {
    country: string;
    /* Set to true if this is the main entry for the nationalities. If more than
    one nationality is set to main entry, the remaining will be set to false. */
    mainEntry?: boolean;
}

export enum ExfOfacEmulatorV1OfacAkaCategory {
    Unspecified = 'UNSPECIFIED',
    Strong = 'STRONG',
    Weak = 'WEAK'
}

export enum ExfOfacEmulatorV1OfacAkaType {
    Unspecified = 'UNSPECIFIED',
    Aka = 'AKA',
    Fka = 'FKA'
}

export interface ExfOfacEmulatorV1OfacEmulatorData {
    spec: ExfOfacEmulatorV1OfacEmulatorSpec;
}

export interface ExfOfacEmulatorV1OfacEmulatorEvent extends ExfOfacEmulatorV1OfacEmulatorKeys {
    metadata: J5StateV1EventMetadata;
    event: ExfOfacEmulatorV1OfacEmulatorEventType;
}

export type ExfOfacEmulatorV1OfacEmulatorEventType = {
    '!type'?: 'created';
    created: ExfOfacEmulatorV1OfacEmulatorEventTypeCreated;
} | {
    '!type'?: 'process';
    process: EmptyObject;
} | {
    '!type'?: 'uploaded';
    uploaded: ExfOfacEmulatorV1OfacEmulatorEventTypeUploaded;
} | {
    '!type'?: 'errored';
    errored: ExfOfacEmulatorV1OfacEmulatorEventTypeErrored;
};

export interface ExfOfacEmulatorV1OfacEmulatorEventTypeCreated {
    spec: ExfOfacEmulatorV1OfacEmulatorSpec;
}

export interface ExfOfacEmulatorV1OfacEmulatorEventTypeErrored {
    error: string;
}

export interface ExfOfacEmulatorV1OfacEmulatorEventTypeUploaded {
    documentUrl: string;
}

export const EXF_OFAC_EMULATOR_V1_OFAC_EMULATOR_EVENT_TYPE_ONE_OF_VALUES = ['created', 'process', 'uploaded', 'errored'] as const;

export type ExfOfacEmulatorV1OfacEmulatorEventTypeOneOfValue = (typeof EXF_OFAC_EMULATOR_V1_OFAC_EMULATOR_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface ExfOfacEmulatorV1OfacEmulatorKeys {
    // format: id62
    ofacEmulatorId: string;
}

export interface ExfOfacEmulatorV1OfacEmulatorQueryServiceOfacEmulatorEventsOfacEmulatorEventsRequest {
    // format: id62
    ofacEmulatorId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExfOfacEmulatorV1OfacEmulatorQueryServiceOfacEmulatorEventsSortableFields, ExfOfacEmulatorV1OfacEmulatorQueryServiceOfacEmulatorEventsFilterableFields>;
}

export enum ExfOfacEmulatorV1OfacEmulatorQueryServiceOfacEmulatorEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    OfacEmulatorId = 'ofacEmulatorId',
    EventType = 'event.!type'
}

export enum ExfOfacEmulatorV1OfacEmulatorQueryServiceOfacEmulatorEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface ExfOfacEmulatorV1OfacEmulatorQueryServiceOfacEmulatorGetOfacEmulatorGetRequest {
    // format: id62
    ofacEmulatorId: string;
}

export interface ExfOfacEmulatorV1OfacEmulatorQueryServiceOfacEmulatorListOfacEmulatorListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, ExfOfacEmulatorV1OfacEmulatorQueryServiceOfacEmulatorListSortableFields, ExfOfacEmulatorV1OfacEmulatorQueryServiceOfacEmulatorListFilterableFields>;
}

export enum ExfOfacEmulatorV1OfacEmulatorQueryServiceOfacEmulatorListFilterableFields {
    OfacEmulatorId = 'ofacEmulatorId',
    Status = 'status'
}

export enum ExfOfacEmulatorV1OfacEmulatorQueryServiceOfacEmulatorListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface ExfOfacEmulatorV1OfacEmulatorSpec {
    // format: YYYY-MM-DD
    publishDate?: string;
    sdns?: ExfOfacEmulatorV1OfacSdn[];
}

export interface ExfOfacEmulatorV1OfacEmulatorState extends ExfOfacEmulatorV1OfacEmulatorKeys {
    metadata: J5StateV1StateMetadata;
    data: ExfOfacEmulatorV1OfacEmulatorData;
    status: ExfOfacEmulatorV1OfacEmulatorStatus;
}

export enum ExfOfacEmulatorV1OfacEmulatorStatus {
    Unspecified = 'UNSPECIFIED',
    Created = 'CREATED',
    Processing = 'PROCESSING',
    Failed = 'FAILED',
    Done = 'DONE'
}

export enum ExfOfacEmulatorV1OfacIdType {
    Unspecified = 'UNSPECIFIED',
    Emulator = 'EMULATOR',
    Passport = 'PASSPORT',
    NationalIdNo = 'NATIONAL_ID_NO'
}

export enum ExfOfacEmulatorV1OfacProgram {
    Unspecified = 'UNSPECIFIED',
    Emulator = 'EMULATOR',
    Balkans = 'BALKANS',
    Cuba = 'CUBA',
    Iraq2 = 'IRAQ2',
    Sdgt = 'SDGT'
}

export interface ExfOfacEmulatorV1OfacSdn {
    uid: string;
    sdn: ExfOfacEmulatorV1SdnType;
}

export type ExfOfacEmulatorV1SdnType = {
    '!type'?: 'individual';
    individual: ExfOfacEmulatorV1SdnTypeIndividual;
} | {
    '!type'?: 'organization';
    organization: ExfOfacEmulatorV1SdnTypeOrganization;
};

export interface ExfOfacEmulatorV1SdnTypeIndividual {
    firstName: string;
    lastName: string;
    birthDates?: ExfOfacEmulatorV1Birthdate[];
    addresses?: IxfWatchlistV1Address[];
    programs?: ExfOfacEmulatorV1OfacProgram[];
    akas?: ExfOfacEmulatorV1AkaIndividual[];
    nationalities?: ExfOfacEmulatorV1Nationality[];
    citizenships?: ExfOfacEmulatorV1Citizenship[];
    ids?: ExfOfacEmulatorV1Id[];
}

export interface ExfOfacEmulatorV1SdnTypeOrganization {
    name: string;
    addresses?: IxfWatchlistV1Address[];
    programs?: ExfOfacEmulatorV1OfacProgram[];
    akas?: ExfOfacEmulatorV1AkaOrganization[];
    ids?: ExfOfacEmulatorV1Id[];
}

export const EXF_OFAC_EMULATOR_V1_SDN_TYPE_ONE_OF_VALUES = ['individual', 'organization'] as const;

export type ExfOfacEmulatorV1SdnTypeOneOfValue = (typeof EXF_OFAC_EMULATOR_V1_SDN_TYPE_ONE_OF_VALUES)[number];

export enum IsoV1Country {
    Unspecified = 'UNSPECIFIED',
    Ad = 'AD',
    Ae = 'AE',
    Af = 'AF',
    Ag = 'AG',
    Ai = 'AI',
    Al = 'AL',
    Am = 'AM',
    Ao = 'AO',
    Aq = 'AQ',
    Ar = 'AR',
    As = 'AS',
    At = 'AT',
    Au = 'AU',
    Aw = 'AW',
    Ax = 'AX',
    Az = 'AZ',
    Ba = 'BA',
    Bb = 'BB',
    Bd = 'BD',
    Be = 'BE',
    Bf = 'BF',
    Bg = 'BG',
    Bh = 'BH',
    Bi = 'BI',
    Bj = 'BJ',
    Bl = 'BL',
    Bm = 'BM',
    Bn = 'BN',
    Bo = 'BO',
    Bq = 'BQ',
    Br = 'BR',
    Bs = 'BS',
    Bt = 'BT',
    Bv = 'BV',
    Bw = 'BW',
    By = 'BY',
    Bz = 'BZ',
    Ca = 'CA',
    Cc = 'CC',
    Cd = 'CD',
    Cf = 'CF',
    Cg = 'CG',
    Ch = 'CH',
    Ci = 'CI',
    Ck = 'CK',
    Cl = 'CL',
    Cm = 'CM',
    Cn = 'CN',
    Co = 'CO',
    Cr = 'CR',
    Cu = 'CU',
    Cv = 'CV',
    Cw = 'CW',
    Cx = 'CX',
    Cy = 'CY',
    Cz = 'CZ',
    De = 'DE',
    Dj = 'DJ',
    Dk = 'DK',
    Dm = 'DM',
    Do = 'DO',
    Dz = 'DZ',
    Ec = 'EC',
    Ee = 'EE',
    Eg = 'EG',
    Eh = 'EH',
    Er = 'ER',
    Es = 'ES',
    Et = 'ET',
    Fi = 'FI',
    Fj = 'FJ',
    Fk = 'FK',
    Fm = 'FM',
    Fo = 'FO',
    Fr = 'FR',
    Ga = 'GA',
    Gb = 'GB',
    Gd = 'GD',
    Ge = 'GE',
    Gf = 'GF',
    Gg = 'GG',
    Gh = 'GH',
    Gi = 'GI',
    Gl = 'GL',
    Gm = 'GM',
    Gn = 'GN',
    Gp = 'GP',
    Gq = 'GQ',
    Gr = 'GR',
    Gs = 'GS',
    Gt = 'GT',
    Gu = 'GU',
    Gw = 'GW',
    Gy = 'GY',
    Hk = 'HK',
    Hm = 'HM',
    Hn = 'HN',
    Hr = 'HR',
    Ht = 'HT',
    Hu = 'HU',
    Id = 'ID',
    Ie = 'IE',
    Il = 'IL',
    Im = 'IM',
    In = 'IN',
    Io = 'IO',
    Iq = 'IQ',
    Ir = 'IR',
    Is = 'IS',
    It = 'IT',
    Je = 'JE',
    Jm = 'JM',
    Jo = 'JO',
    Jp = 'JP',
    Ke = 'KE',
    Kg = 'KG',
    Kh = 'KH',
    Ki = 'KI',
    Km = 'KM',
    Kn = 'KN',
    Kp = 'KP',
    Kr = 'KR',
    Kw = 'KW',
    Ky = 'KY',
    Kz = 'KZ',
    La = 'LA',
    Lb = 'LB',
    Lc = 'LC',
    Li = 'LI',
    Lk = 'LK',
    Lr = 'LR',
    Ls = 'LS',
    Lt = 'LT',
    Lu = 'LU',
    Lv = 'LV',
    Ly = 'LY',
    Ma = 'MA',
    Mc = 'MC',
    Md = 'MD',
    Me = 'ME',
    Mf = 'MF',
    Mg = 'MG',
    Mh = 'MH',
    Mk = 'MK',
    Ml = 'ML',
    Mm = 'MM',
    Mn = 'MN',
    Mo = 'MO',
    Mp = 'MP',
    Mq = 'MQ',
    Mr = 'MR',
    Ms = 'MS',
    Mt = 'MT',
    Mu = 'MU',
    Mv = 'MV',
    Mw = 'MW',
    Mx = 'MX',
    My = 'MY',
    Mz = 'MZ',
    Na = 'NA',
    Nc = 'NC',
    Ne = 'NE',
    Nf = 'NF',
    Ng = 'NG',
    Ni = 'NI',
    Nl = 'NL',
    No = 'NO',
    Np = 'NP',
    Nr = 'NR',
    Nu = 'NU',
    Nz = 'NZ',
    Om = 'OM',
    Pa = 'PA',
    Pe = 'PE',
    Pf = 'PF',
    Pg = 'PG',
    Ph = 'PH',
    Pk = 'PK',
    Pl = 'PL',
    Pm = 'PM',
    Pn = 'PN',
    Pr = 'PR',
    Ps = 'PS',
    Pt = 'PT',
    Pw = 'PW',
    Py = 'PY',
    Qa = 'QA',
    Re = 'RE',
    Ro = 'RO',
    Rs = 'RS',
    Ru = 'RU',
    Rw = 'RW',
    Sa = 'SA',
    Sb = 'SB',
    Sc = 'SC',
    Sd = 'SD',
    Se = 'SE',
    Sg = 'SG',
    Sh = 'SH',
    Si = 'SI',
    Sj = 'SJ',
    Sk = 'SK',
    Sl = 'SL',
    Sm = 'SM',
    Sn = 'SN',
    So = 'SO',
    Sr = 'SR',
    Ss = 'SS',
    St = 'ST',
    Sv = 'SV',
    Sx = 'SX',
    Sy = 'SY',
    Sz = 'SZ',
    Tc = 'TC',
    Td = 'TD',
    Tf = 'TF',
    Tg = 'TG',
    Th = 'TH',
    Tj = 'TJ',
    Tk = 'TK',
    Tl = 'TL',
    Tm = 'TM',
    Tn = 'TN',
    To = 'TO',
    Tr = 'TR',
    Tt = 'TT',
    Tv = 'TV',
    Tw = 'TW',
    Tz = 'TZ',
    Ua = 'UA',
    Ug = 'UG',
    Um = 'UM',
    Us = 'US',
    Uy = 'UY',
    Uz = 'UZ',
    Va = 'VA',
    Vc = 'VC',
    Ve = 'VE',
    Vg = 'VG',
    Vi = 'VI',
    Vn = 'VN',
    Vu = 'VU',
    Wf = 'WF',
    Ws = 'WS',
    Ye = 'YE',
    Yt = 'YT',
    Za = 'ZA',
    Zm = 'ZM',
    Zw = 'ZW'
}

export enum IsoV1Currency {
    Unspecified = 'UNSPECIFIED',
    Aed = 'AED',
    Afn = 'AFN',
    All = 'ALL',
    Amd = 'AMD',
    Aoa = 'AOA',
    Ars = 'ARS',
    Aud = 'AUD',
    Awg = 'AWG',
    Azn = 'AZN',
    Bam = 'BAM',
    Bbd = 'BBD',
    Bdt = 'BDT',
    Bhd = 'BHD',
    Bif = 'BIF',
    Bmd = 'BMD',
    Bnd = 'BND',
    Bob = 'BOB',
    Bov = 'BOV',
    Brl = 'BRL',
    Bsd = 'BSD',
    Btn = 'BTN',
    Bwp = 'BWP',
    Byn = 'BYN',
    Bzd = 'BZD',
    Cad = 'CAD',
    Cdf = 'CDF',
    Che = 'CHE',
    Chf = 'CHF',
    Chw = 'CHW',
    Clf = 'CLF',
    Clp = 'CLP',
    Cny = 'CNY',
    Cop = 'COP',
    Cou = 'COU',
    Crc = 'CRC',
    Cup = 'CUP',
    Cve = 'CVE',
    Czk = 'CZK',
    Djf = 'DJF',
    Dkk = 'DKK',
    Dop = 'DOP',
    Dzd = 'DZD',
    Egp = 'EGP',
    Ern = 'ERN',
    Etb = 'ETB',
    Eur = 'EUR',
    Fjd = 'FJD',
    Fkp = 'FKP',
    Gbp = 'GBP',
    Gel = 'GEL',
    Ghs = 'GHS',
    Gip = 'GIP',
    Gmd = 'GMD',
    Gnf = 'GNF',
    Gtq = 'GTQ',
    Gyd = 'GYD',
    Hkd = 'HKD',
    Hnl = 'HNL',
    Htg = 'HTG',
    Huf = 'HUF',
    Idr = 'IDR',
    Ils = 'ILS',
    Inr = 'INR',
    Iqd = 'IQD',
    Irr = 'IRR',
    Isk = 'ISK',
    Jmd = 'JMD',
    Jod = 'JOD',
    Jpy = 'JPY',
    Kes = 'KES',
    Kgs = 'KGS',
    Khr = 'KHR',
    Kmf = 'KMF',
    Kpw = 'KPW',
    Krw = 'KRW',
    Kwd = 'KWD',
    Kyd = 'KYD',
    Kzt = 'KZT',
    Lak = 'LAK',
    Lbp = 'LBP',
    Lkr = 'LKR',
    Lrd = 'LRD',
    Lsl = 'LSL',
    Lyd = 'LYD',
    Mad = 'MAD',
    Mdl = 'MDL',
    Mga = 'MGA',
    Mkd = 'MKD',
    Mmk = 'MMK',
    Mnt = 'MNT',
    Mop = 'MOP',
    Mru = 'MRU',
    Mur = 'MUR',
    Mvr = 'MVR',
    Mwk = 'MWK',
    Mxn = 'MXN',
    Mxv = 'MXV',
    Myr = 'MYR',
    Mzn = 'MZN',
    Nad = 'NAD',
    Ngn = 'NGN',
    Nio = 'NIO',
    Nok = 'NOK',
    Npr = 'NPR',
    Nzd = 'NZD',
    Omr = 'OMR',
    Pab = 'PAB',
    Pen = 'PEN',
    Pgk = 'PGK',
    Php = 'PHP',
    Pkr = 'PKR',
    Pln = 'PLN',
    Pyg = 'PYG',
    Qar = 'QAR',
    Ron = 'RON',
    Rsd = 'RSD',
    Rub = 'RUB',
    Rwf = 'RWF',
    Sar = 'SAR',
    Sbd = 'SBD',
    Scr = 'SCR',
    Sdg = 'SDG',
    Sek = 'SEK',
    Sgd = 'SGD',
    Shp = 'SHP',
    Sle = 'SLE',
    Sos = 'SOS',
    Srd = 'SRD',
    Ssp = 'SSP',
    Stn = 'STN',
    Svc = 'SVC',
    Syp = 'SYP',
    Szl = 'SZL',
    Thb = 'THB',
    Tjs = 'TJS',
    Tmt = 'TMT',
    Tnd = 'TND',
    Top = 'TOP',
    Try = 'TRY',
    Ttd = 'TTD',
    Twd = 'TWD',
    Tzs = 'TZS',
    Uah = 'UAH',
    Ugx = 'UGX',
    Usd = 'USD',
    Usn = 'USN',
    Uyi = 'UYI',
    Uyu = 'UYU',
    Uyw = 'UYW',
    Uzs = 'UZS',
    Ved = 'VED',
    Ves = 'VES',
    Vnd = 'VND',
    Vuv = 'VUV',
    Wst = 'WST',
    Xad = 'XAD',
    Xaf = 'XAF',
    Xag = 'XAG',
    Xau = 'XAU',
    Xba = 'XBA',
    Xbb = 'XBB',
    Xbc = 'XBC',
    Xbd = 'XBD',
    Xcd = 'XCD',
    Xcg = 'XCG',
    Xdr = 'XDR',
    Xof = 'XOF',
    Xpd = 'XPD',
    Xpf = 'XPF',
    Xpt = 'XPT',
    Xsu = 'XSU',
    Xts = 'XTS',
    Xua = 'XUA',
    Xxx = 'XXX',
    Yer = 'YER',
    Zar = 'ZAR',
    Zmw = 'ZMW',
    Zwg = 'ZWG'
}

export interface IxcAssetsClearingV1MoneyMarketInternalStatsData {
    /* The dividend rate of the money market fund. */
    // format: decimal
    dividendRate?: string;
    /* The month-to-date dividend of the money market fund. */
    // format: decimal
    monthToDateDividend?: string;
    /* The daily dividend of the money market fund. */
    // format: decimal
    dailyDividend?: string;
    /* The number of shares in the money market fund. */
    // format: decimal
    shares?: string;
}

export interface IxcAssetsClearingV1MoneyMarketInternalStatsEvent extends IxcAssetsClearingV1MoneyMarketInternalStatsKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcAssetsClearingV1MoneyMarketInternalStatsEventType;
}

export type IxcAssetsClearingV1MoneyMarketInternalStatsEventType = {
    '!type'?: 'upserted';
    upserted: IxcAssetsClearingV1MoneyMarketInternalStatsEventTypeUpserted;
};

export interface IxcAssetsClearingV1MoneyMarketInternalStatsEventTypeUpserted {
    // format: YYYY-MM-DD
    date: string;
    data: IxcAssetsClearingV1MoneyMarketInternalStatsData;
}

export const IXC_ASSETS_CLEARING_V1_MONEY_MARKET_INTERNAL_STATS_EVENT_TYPE_ONE_OF_VALUES = ['upserted'] as const;

export type IxcAssetsClearingV1MoneyMarketInternalStatsEventTypeOneOfValue = (typeof IXC_ASSETS_CLEARING_V1_MONEY_MARKET_INTERNAL_STATS_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcAssetsClearingV1MoneyMarketInternalStatsKeys {
    /* The ID of the money market fund these statistics belong to */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The date of these money market stats. */
    // format: YYYY-MM-DD
    date: string;
    /* A hash of the data fields to detect changes. */
    // format: id62
    dataHash: string;
}

export interface IxcAssetsClearingV1MoneyMarketInternalStatsQueryServiceMoneyMarketInternalStatsEventsMoneyMarketInternalStatsEventsRequest {
    /* The ID of the money market fund these statistics belong to */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The date of these money market stats. */
    // format: YYYY-MM-DD
    date: string;
    /* A hash of the data fields to detect changes. */
    // format: id62
    dataHash: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcAssetsClearingV1MoneyMarketInternalStatsQueryServiceMoneyMarketInternalStatsEventsSortableFields, IxcAssetsClearingV1MoneyMarketInternalStatsQueryServiceMoneyMarketInternalStatsEventsFilterableFields>;
}

export enum IxcAssetsClearingV1MoneyMarketInternalStatsQueryServiceMoneyMarketInternalStatsEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AssetId = 'assetId',
    Date = 'date',
    DataHash = 'dataHash',
    EventType = 'event.!type'
}

export enum IxcAssetsClearingV1MoneyMarketInternalStatsQueryServiceMoneyMarketInternalStatsEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcAssetsClearingV1MoneyMarketInternalStatsQueryServiceMoneyMarketInternalStatsGetMoneyMarketInternalStatsGetRequest {
    /* The ID of the money market fund these statistics belong to */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The date of these money market stats. */
    // format: YYYY-MM-DD
    date: string;
    /* A hash of the data fields to detect changes. */
    // format: id62
    dataHash: string;
}

export interface IxcAssetsClearingV1MoneyMarketInternalStatsQueryServiceMoneyMarketInternalStatsListMoneyMarketInternalStatsListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcAssetsClearingV1MoneyMarketInternalStatsQueryServiceMoneyMarketInternalStatsListSortableFields, IxcAssetsClearingV1MoneyMarketInternalStatsQueryServiceMoneyMarketInternalStatsListFilterableFields>;
}

export enum IxcAssetsClearingV1MoneyMarketInternalStatsQueryServiceMoneyMarketInternalStatsListFilterableFields {
    AssetId = 'assetId',
    Date = 'date',
    DataHash = 'dataHash',
    Status = 'status'
}

export enum IxcAssetsClearingV1MoneyMarketInternalStatsQueryServiceMoneyMarketInternalStatsListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcAssetsClearingV1MoneyMarketInternalStatsState extends IxcAssetsClearingV1MoneyMarketInternalStatsKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcAssetsClearingV1MoneyMarketInternalStatsData;
    status: IxcAssetsClearingV1MoneyMarketInternalStatsStatus;
}

export enum IxcAssetsClearingV1MoneyMarketInternalStatsStatus {
    Unspecified = 'UNSPECIFIED',
    Completed = 'COMPLETED'
}

export enum IxcAssetsV1AccrualPeriod {
    Unspecified = 'UNSPECIFIED',
    CalendarMonth = 'CALENDAR_MONTH'
}

export enum IxcAssetsV1AssetCategory {
    Unspecified = 'UNSPECIFIED',
    CommonEquity = 'COMMON_EQUITY',
    PreferredEquity = 'PREFERRED_EQUITY',
    ExchangeTradedFund = 'EXCHANGE_TRADED_FUND',
    MoneyMarketFund = 'MONEY_MARKET_FUND'
}

export interface IxcAssetsV1AssetCommandServiceGetLogoGetLogoRequest {
    /* The asset ID of the logo to download */
    // format: id62
    assetId: string;
}

export interface IxcAssetsV1AssetData {
    type: IxcAssetsV1AssetType;
    /* The categorization of the asset */
    category?: IxcAssetsV1AssetCategory;
    /* The maximum allowable precision for amounts in this asset.
    Amounts are transmitted and stored using the Decimal type in the
    'natural' | whole number format for the asset, e.g. the US Dollar uses
    'dollar' as the whole | number, not cents, $1.23 is represented as 1.23
    and has '2' set here. One satoshi is 0.00000001 */
    // format: INT32
    decimalPrecision?: number;
    /* If true, the asset value should be displayed with the full precision,
    e.g. for dollars, decimalPrecision = 2, fixedPrecision = true, so display
    as 1.00, not 1.0 or 1. 1.00000 is well out. */
    fixedPrecision?: boolean;
}

export interface IxcAssetsV1AssetDayException {
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The asset's explicit day on this date. Its times are in the US money
    market schedule's timezone, America/New_York. */
    day: IxfHoursV1MoneyMarketDay;
}

export interface IxcAssetsV1AssetEvent extends IxcAssetsV1AssetKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcAssetsV1AssetEventType;
}

export type IxcAssetsV1AssetEventType = {
    '!type'?: 'created';
    created: IxcAssetsV1AssetEventTypeCreated;
} | {
    '!type'?: 'updated';
    updated: IxcAssetsV1AssetEventTypeUpdated;
} | {
    '!type'?: 'archived';
    archived: EmptyObject;
};

export interface IxcAssetsV1AssetEventTypeCreated {
    type: IxcAssetsV1AssetType;
    category?: IxcAssetsV1AssetCategory;
    // format: INT32
    decimalPrecision?: number;
    fixedPrecision?: boolean;
}

export interface IxcAssetsV1AssetEventTypeUpdated {
    type?: IxcAssetsV1AssetType;
    category?: IxcAssetsV1AssetCategory;
    // format: INT32
    decimalPrecision?: number;
    fixedPrecision?: boolean;
}

export const IXC_ASSETS_V1_ASSET_EVENT_TYPE_ONE_OF_VALUES = ['created', 'updated', 'archived'] as const;

export type IxcAssetsV1AssetEventTypeOneOfValue = (typeof IXC_ASSETS_V1_ASSET_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcAssetsV1AssetExceptionData {
    /* The date and assets in effect */
    spec: IxcAssetsV1AssetExceptionSpec;
    /* The date this exception falls on. Copied from the spec today; derived
    from a recurrence rule when one is added. */
    // format: YYYY-MM-DD
    observedDate: string;
}

export interface IxcAssetsV1AssetExceptionEvent extends IxcAssetsV1AssetExceptionKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcAssetsV1AssetExceptionEventType;
}

export type IxcAssetsV1AssetExceptionEventType = {
    '!type'?: 'created';
    created: IxcAssetsV1AssetExceptionEventTypeCreated;
} | {
    '!type'?: 'updated';
    updated: IxcAssetsV1AssetExceptionEventTypeUpdated;
} | {
    '!type'?: 'archived';
    archived: EmptyObject;
};

export interface IxcAssetsV1AssetExceptionEventTypeCreated {
    spec: IxcAssetsV1AssetExceptionSpec;
}

export interface IxcAssetsV1AssetExceptionEventTypeUpdated {
    spec: IxcAssetsV1AssetExceptionSpec;
}

export const IXC_ASSETS_V1_ASSET_EXCEPTION_EVENT_TYPE_ONE_OF_VALUES = ['created', 'updated', 'archived'] as const;

export type IxcAssetsV1AssetExceptionEventTypeOneOfValue = (typeof IXC_ASSETS_V1_ASSET_EXCEPTION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcAssetsV1AssetExceptionKeys {
    // format: id62
    assetExceptionId: string;
}

export interface IxcAssetsV1AssetExceptionQueryServiceAssetExceptionEventsAssetExceptionEventsRequest {
    // format: id62
    assetExceptionId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcAssetsV1AssetExceptionQueryServiceAssetExceptionEventsSortableFields, IxcAssetsV1AssetExceptionQueryServiceAssetExceptionEventsFilterableFields>;
}

export enum IxcAssetsV1AssetExceptionQueryServiceAssetExceptionEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AssetExceptionId = 'assetExceptionId',
    EventCreatedSpecAssetsAssetId = 'event.created.spec.assets.assetId',
    EventUpdatedSpecAssetsAssetId = 'event.updated.spec.assets.assetId',
    EventType = 'event.!type'
}

export enum IxcAssetsV1AssetExceptionQueryServiceAssetExceptionEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcAssetsV1AssetExceptionQueryServiceAssetExceptionGetAssetExceptionGetRequest {
    // format: id62
    assetExceptionId: string;
}

export interface IxcAssetsV1AssetExceptionQueryServiceAssetExceptionListAssetExceptionListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcAssetsV1AssetExceptionQueryServiceAssetExceptionListSortableFields, IxcAssetsV1AssetExceptionQueryServiceAssetExceptionListFilterableFields>;
}

export enum IxcAssetsV1AssetExceptionQueryServiceAssetExceptionListFilterableFields {
    AssetExceptionId = 'assetExceptionId',
    DataSpecAssetsAssetId = 'data.spec.assets.assetId',
    DataObservedDate = 'data.observedDate',
    Status = 'status'
}

export enum IxcAssetsV1AssetExceptionQueryServiceAssetExceptionListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataObservedDate = 'data.observedDate'
}

export interface IxcAssetsV1AssetExceptionSpec {
    /* e.g. "Early close - day after Thanksgiving 2026" */
    name: string;
    /* The explicit date; one-off for now */
    // format: YYYY-MM-DD
    date: string;
    /* The assets deviating on this date, each with its own day. At least one.
    An asset not listed keeps its regular hours. */
    assets: IxcAssetsV1AssetDayException[];
}

export interface IxcAssetsV1AssetExceptionState extends IxcAssetsV1AssetExceptionKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcAssetsV1AssetExceptionData;
    status: IxcAssetsV1AssetExceptionStatus;
}

export enum IxcAssetsV1AssetExceptionStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Archived = 'ARCHIVED'
}

export enum IxcAssetsV1AssetExceptionSummaryName {
    Unspecified = 'UNSPECIFIED',
    AssetExceptionSummary = 'AssetExceptionSummary'
}

export interface IxcAssetsV1AssetKeys {
    // format: id62
    assetId: string;
}

export interface IxcAssetsV1AssetQueryServiceAssetEventsAssetEventsRequest {
    // format: id62
    assetId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcAssetsV1AssetQueryServiceAssetEventsSearchableFields, IxcAssetsV1AssetQueryServiceAssetEventsSortableFields, IxcAssetsV1AssetQueryServiceAssetEventsFilterableFields>;
}

export enum IxcAssetsV1AssetQueryServiceAssetEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AssetId = 'assetId',
    EventCreatedTypeEquityCusip = 'event.created.type.equity.cusip',
    EventCreatedTypeEquityControlsCanBuy = 'event.created.type.equity.controls.canBuy',
    EventCreatedTypeEquityControlsCanSell = 'event.created.type.equity.controls.canSell',
    EventCreatedTypeEquityControlsCanEnterFractions = 'event.created.type.equity.controls.canEnterFractions',
    EventCreatedTypeMoneyMarketCusip = 'event.created.type.moneyMarket.cusip',
    EventCreatedTypeMoneyMarketControlsCanBuy = 'event.created.type.moneyMarket.controls.canBuy',
    EventCreatedTypeMoneyMarketControlsCanSell = 'event.created.type.moneyMarket.controls.canSell',
    EventCreatedTypeMoneyMarketControlsCanEnterFractions = 'event.created.type.moneyMarket.controls.canEnterFractions',
    EventCreatedTypeMoneyMarketClassification = 'event.created.type.moneyMarket.classification',
    EventCreatedTypeMoneyMarketNavType = 'event.created.type.moneyMarket.navType',
    EventUpdatedTypeEquityCusip = 'event.updated.type.equity.cusip',
    EventUpdatedTypeEquityControlsCanBuy = 'event.updated.type.equity.controls.canBuy',
    EventUpdatedTypeEquityControlsCanSell = 'event.updated.type.equity.controls.canSell',
    EventUpdatedTypeEquityControlsCanEnterFractions = 'event.updated.type.equity.controls.canEnterFractions',
    EventUpdatedTypeMoneyMarketCusip = 'event.updated.type.moneyMarket.cusip',
    EventUpdatedTypeMoneyMarketControlsCanBuy = 'event.updated.type.moneyMarket.controls.canBuy',
    EventUpdatedTypeMoneyMarketControlsCanSell = 'event.updated.type.moneyMarket.controls.canSell',
    EventUpdatedTypeMoneyMarketControlsCanEnterFractions = 'event.updated.type.moneyMarket.controls.canEnterFractions',
    EventUpdatedTypeMoneyMarketClassification = 'event.updated.type.moneyMarket.classification',
    EventUpdatedTypeMoneyMarketNavType = 'event.updated.type.moneyMarket.navType',
    EventType = 'event.!type'
}

export enum IxcAssetsV1AssetQueryServiceAssetEventsSearchableFields {
    EventCreatedTypeEquitySymbolBase = 'event.created.type.equity.symbol.base',
    EventCreatedTypeEquityName = 'event.created.type.equity.name',
    EventCreatedTypeMoneyMarketSymbolBase = 'event.created.type.moneyMarket.symbol.base',
    EventCreatedTypeMoneyMarketName = 'event.created.type.moneyMarket.name',
    EventUpdatedTypeEquitySymbolBase = 'event.updated.type.equity.symbol.base',
    EventUpdatedTypeEquityName = 'event.updated.type.equity.name',
    EventUpdatedTypeMoneyMarketSymbolBase = 'event.updated.type.moneyMarket.symbol.base',
    EventUpdatedTypeMoneyMarketName = 'event.updated.type.moneyMarket.name'
}

export enum IxcAssetsV1AssetQueryServiceAssetEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcAssetsV1AssetQueryServiceAssetGetAssetGetRequest {
    // format: id62
    assetId: string;
}

export interface IxcAssetsV1AssetQueryServiceAssetListAssetListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcAssetsV1AssetQueryServiceAssetListSearchableFields, IxcAssetsV1AssetQueryServiceAssetListSortableFields, IxcAssetsV1AssetQueryServiceAssetListFilterableFields>;
}

export enum IxcAssetsV1AssetQueryServiceAssetListFilterableFields {
    AssetId = 'assetId',
    DataTypeEquityCusip = 'data.type.equity.cusip',
    DataTypeEquityControlsCanBuy = 'data.type.equity.controls.canBuy',
    DataTypeEquityControlsCanSell = 'data.type.equity.controls.canSell',
    DataTypeEquityControlsCanEnterFractions = 'data.type.equity.controls.canEnterFractions',
    DataTypeMoneyMarketCusip = 'data.type.moneyMarket.cusip',
    DataTypeMoneyMarketControlsCanBuy = 'data.type.moneyMarket.controls.canBuy',
    DataTypeMoneyMarketControlsCanSell = 'data.type.moneyMarket.controls.canSell',
    DataTypeMoneyMarketControlsCanEnterFractions = 'data.type.moneyMarket.controls.canEnterFractions',
    DataTypeMoneyMarketClassification = 'data.type.moneyMarket.classification',
    DataTypeMoneyMarketNavType = 'data.type.moneyMarket.navType',
    DataTypeType = 'data.type.!type',
    DataCategory = 'data.category',
    Status = 'status'
}

export enum IxcAssetsV1AssetQueryServiceAssetListSearchableFields {
    DataTypeEquitySymbolBase = 'data.type.equity.symbol.base',
    DataTypeEquityName = 'data.type.equity.name',
    DataTypeMoneyMarketSymbolBase = 'data.type.moneyMarket.symbol.base',
    DataTypeMoneyMarketName = 'data.type.moneyMarket.name'
}

export enum IxcAssetsV1AssetQueryServiceAssetListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcAssetsV1AssetState extends IxcAssetsV1AssetKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcAssetsV1AssetData;
    status: IxcAssetsV1AssetStatus;
}

export enum IxcAssetsV1AssetStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Inactive = 'INACTIVE'
}

export type IxcAssetsV1AssetType = {
    '!type'?: 'cash';
    cash: IxcAssetsV1AssetTypeCash;
} | {
    '!type'?: 'equity';
    equity: IxcAssetsV1AssetTypeEquity;
} | {
    '!type'?: 'moneyMarket';
    moneyMarket: IxcAssetsV1MoneyMarket;
};

export interface IxcAssetsV1AssetTypeCash {
    currency?: IsoV1Currency;
    /* Indicates the 'default' currency for the account, used in cost
    calculations and comparisons */
    homeCurrency?: boolean;
}

export interface IxcAssetsV1AssetTypeEquity {
    // format: custom - pattern: ^[0-9A-Z]{9}$
    cusip: string;
    symbol?: IxcAssetsV1Symbol;
    name: string;
    controls?: IxcAssetsV1Controls;
}

export const IXC_ASSETS_V1_ASSET_TYPE_ONE_OF_VALUES = ['cash', 'equity', 'moneyMarket'] as const;

export type IxcAssetsV1AssetTypeOneOfValue = (typeof IXC_ASSETS_V1_ASSET_TYPE_ONE_OF_VALUES)[number];

export interface IxcAssetsV1Controls {
    canBuy?: boolean;
    canSell?: boolean;
    /* New fractional positions can be created using either buy or sell. If
    false, only existing fractional positions can be traded. Does not
    override canBuy or canSell if either are false. */
    canEnterFractions?: boolean;
}

export enum IxcAssetsV1DividendPayableDate {
    Unspecified = 'UNSPECIFIED',
    FirstBusinessDayOfNextMonth = 'FIRST_BUSINESS_DAY_OF_NEXT_MONTH'
}

export interface IxcAssetsV1EodPriceData {
    /* The closing price for the asset on this date */
    // format: decimal
    price: string;
}

export interface IxcAssetsV1EodPriceEvent extends IxcAssetsV1EodPriceKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcAssetsV1EodPriceEventType;
}

export type IxcAssetsV1EodPriceEventType = {
    '!type'?: 'upserted';
    upserted: IxcAssetsV1EodPriceEventTypeUpserted;
};

export interface IxcAssetsV1EodPriceEventTypeUpserted {
    // format: YYYY-MM-DD
    date: string;
    // format: decimal
    price: string;
}

export const IXC_ASSETS_V1_EOD_PRICE_EVENT_TYPE_ONE_OF_VALUES = ['upserted'] as const;

export type IxcAssetsV1EodPriceEventTypeOneOfValue = (typeof IXC_ASSETS_V1_EOD_PRICE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcAssetsV1EodPriceKeys {
    /* The asset ID this price is for */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The date of this end-of-day price */
    // format: YYYY-MM-DD
    date: string;
}

export interface IxcAssetsV1EodPriceQueryServiceEodPriceEventsEodPriceEventsRequest {
    /* The asset ID this price is for */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The date of this end-of-day price */
    // format: YYYY-MM-DD
    date: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcAssetsV1EodPriceQueryServiceEodPriceEventsSortableFields, IxcAssetsV1EodPriceQueryServiceEodPriceEventsFilterableFields>;
}

export enum IxcAssetsV1EodPriceQueryServiceEodPriceEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AssetId = 'assetId',
    Date = 'date',
    EventType = 'event.!type'
}

export enum IxcAssetsV1EodPriceQueryServiceEodPriceEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcAssetsV1EodPriceQueryServiceEodPriceGetEodPriceGetRequest {
    /* The asset ID this price is for */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The date of this end-of-day price */
    // format: YYYY-MM-DD
    date: string;
}

export interface IxcAssetsV1EodPriceQueryServiceEodPriceListEodPriceListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcAssetsV1EodPriceQueryServiceEodPriceListSortableFields, IxcAssetsV1EodPriceQueryServiceEodPriceListFilterableFields>;
}

export enum IxcAssetsV1EodPriceQueryServiceEodPriceListFilterableFields {
    AssetId = 'assetId',
    Date = 'date',
    Status = 'status'
}

export enum IxcAssetsV1EodPriceQueryServiceEodPriceListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcAssetsV1EodPriceState extends IxcAssetsV1EodPriceKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcAssetsV1EodPriceData;
    status: IxcAssetsV1EodPriceStatus;
}

export enum IxcAssetsV1EodPriceStatus {
    Unspecified = 'UNSPECIFIED',
    Completed = 'COMPLETED'
}

export enum IxcAssetsV1FundFamily {
    Unspecified = 'UNSPECIFIED',
    Jpmam = 'JPMAM'
}

export const IXC_ASSETS_V1_FUND_FAMILY_INFO_EXTENSION_CODE_MAP = {
    [IxcAssetsV1FundFamily.Jpmam]: 'JPMAM'
} as const;

export const IXC_ASSETS_V1_FUND_FAMILY_INFO_EXTENSION_LABEL_MAP = {
    [IxcAssetsV1FundFamily.Jpmam]: 'JP Morgan Asset Management'
} as const;

export interface IxcAssetsV1FundNav {
    /* The date the strikes are for */
    // format: YYYY-MM-DD
    navDate: string;
    /* Every strike of the day, in the order the source reports them. A
    stable-NAV fund strikes once; a floating-NAV fund may strike more than
    once, and the last strike is the day's closing NAV. */
    strikes: IxcAssetsV1NavStrike[];
}

export interface IxcAssetsV1MoneyMarket {
    // format: custom - pattern: ^[0-9A-Z]{9}$
    cusip: string;
    symbol?: IxcAssetsV1Symbol;
    name: string;
    controls?: IxcAssetsV1Controls;
    /* The fund family for the money market fund */
    fundFamily: IxcAssetsV1FundFamily;
    /* The daily open and close times for the fund. They narrow the orders
    session on the US money market schedule and must be in America/New_York. */
    fundHours?: IxcAssetsV1MoneyMarketFundHours;
    /* Three or four digit share class number */
    // pattern: ^[0-9]{3,4}$
    shareClassNumber?: string;
    /* Fund's accrual period */
    accrualPeriod?: IxcAssetsV1AccrualPeriod;
    /* Fund's dividend payable date */
    dividendPayableDate?: IxcAssetsV1DividendPayableDate;
    /* Fund's classification */
    classification?: IxcAssetsV1MoneyMarketClassification;
    /* Fund's NAV type */
    navType?: IxcAssetsV1MoneyMarketNavType;
}

export enum IxcAssetsV1MoneyMarketClassification {
    Unspecified = 'UNSPECIFIED',
    Government = 'GOVERNMENT',
    Retail = 'RETAIL',
    Other = 'OTHER'
}

export interface IxcAssetsV1MoneyMarketFundHours {
    /* The time the entity opens, in the format HH:MM. This is the time
    it opens on the date specified in the Day object. */
    // pattern: ^[0-9]{2}:[0-9]{2}$
    opens: string;
    /* The time the entity closes, in the format HH:MM. This is the time
    it closes on the date specified in the Day object. */
    // pattern: ^[0-9]{2}:[0-9]{2}$
    closes: string;
    /* IANA timezone; must be America/New_York */
    timezone: string;
}

export enum IxcAssetsV1MoneyMarketNavType {
    Unspecified = 'UNSPECIFIED',
    Floating = 'FLOATING',
    Stable = 'STABLE'
}

export interface IxcAssetsV1MoneyMarketStatsData {
    /* The 7-day yield of the money market fund. */
    // format: decimal
    sevenDayYield?: string;
    /* The NAV the fund most recently struck, as the upstream source reports it.
    Absent until the source supplies one. */
    nav?: IxcAssetsV1FundNav;
}

export interface IxcAssetsV1MoneyMarketStatsEvent extends IxcAssetsV1MoneyMarketStatsKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcAssetsV1MoneyMarketStatsEventType;
}

export type IxcAssetsV1MoneyMarketStatsEventType = {
    '!type'?: 'upserted';
    upserted: IxcAssetsV1MoneyMarketStatsEventTypeUpserted;
};

export interface IxcAssetsV1MoneyMarketStatsEventTypeUpserted {
    // format: YYYY-MM-DD
    date: string;
    data: IxcAssetsV1MoneyMarketStatsData;
}

export const IXC_ASSETS_V1_MONEY_MARKET_STATS_EVENT_TYPE_ONE_OF_VALUES = ['upserted'] as const;

export type IxcAssetsV1MoneyMarketStatsEventTypeOneOfValue = (typeof IXC_ASSETS_V1_MONEY_MARKET_STATS_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcAssetsV1MoneyMarketStatsKeys {
    /* The ID of the money market fund these statistics belong to. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The date of these money market stats. */
    // format: YYYY-MM-DD
    date: string;
}

export interface IxcAssetsV1MoneyMarketStatsQueryServiceMoneyMarketStatsEventsMoneyMarketStatsEventsRequest {
    /* The ID of the money market fund these statistics belong to. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The date of these money market stats. */
    // format: YYYY-MM-DD
    date: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcAssetsV1MoneyMarketStatsQueryServiceMoneyMarketStatsEventsSortableFields, IxcAssetsV1MoneyMarketStatsQueryServiceMoneyMarketStatsEventsFilterableFields>;
}

export enum IxcAssetsV1MoneyMarketStatsQueryServiceMoneyMarketStatsEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AssetId = 'assetId',
    Date = 'date',
    EventType = 'event.!type'
}

export enum IxcAssetsV1MoneyMarketStatsQueryServiceMoneyMarketStatsEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcAssetsV1MoneyMarketStatsQueryServiceMoneyMarketStatsGetMoneyMarketStatsGetRequest {
    /* The ID of the money market fund these statistics belong to. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The date of these money market stats. */
    // format: YYYY-MM-DD
    date: string;
}

export interface IxcAssetsV1MoneyMarketStatsQueryServiceMoneyMarketStatsListMoneyMarketStatsListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcAssetsV1MoneyMarketStatsQueryServiceMoneyMarketStatsListSortableFields, IxcAssetsV1MoneyMarketStatsQueryServiceMoneyMarketStatsListFilterableFields>;
}

export enum IxcAssetsV1MoneyMarketStatsQueryServiceMoneyMarketStatsListFilterableFields {
    AssetId = 'assetId',
    Date = 'date',
    Status = 'status'
}

export enum IxcAssetsV1MoneyMarketStatsQueryServiceMoneyMarketStatsListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcAssetsV1MoneyMarketStatsState extends IxcAssetsV1MoneyMarketStatsKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcAssetsV1MoneyMarketStatsData;
    status: IxcAssetsV1MoneyMarketStatsStatus;
}

export enum IxcAssetsV1MoneyMarketStatsStatus {
    Unspecified = 'UNSPECIFIED',
    Completed = 'COMPLETED'
}

export interface IxcAssetsV1NavStrike {
    /* Wall-clock time the NAV was struck, "HH:MM:SS", in the fund's own
    timezone. Neither the source nor this field carries an offset. Absent for
    a stable-NAV fund, for which the source reports no strike time. */
    // pattern: ^([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$
    strikeTime?: string;
    /* The net asset value per share */
    // format: decimal
    amount: string;
}

export interface IxcAssetsV1Security {
    // format: custom - pattern: ^[0-9A-Z]{9}$
    cusip: string;
    symbol?: IxcAssetsV1Symbol;
    name: string;
}

export interface IxcAssetsV1Symbol {
    /* The common part of the symbol before qualifiers. e.g. BRK in BRK.A */
    // pattern: ^[A-Z]+$
    base: string;
    /* The qualifier on the symbol. Various trading platforms have different
    ways to mark qualifiers such as 'Class A' etc. */
    suffix: IxcAssetsV1SymbolSuffix;
}

export enum IxcAssetsV1SymbolSuffix {
    Unspecified = 'UNSPECIFIED',
    None = 'NONE',
    Preferred = 'PREFERRED',
    PreferredClassA = 'PREFERRED_CLASS_A',
    PreferredClassB = 'PREFERRED_CLASS_B',
    ClassA = 'CLASS_A',
    ClassB = 'CLASS_B',
    PreferredWhenDistributed = 'PREFERRED_WHEN_DISTRIBUTED',
    WhenDistributed = 'WHEN_DISTRIBUTED',
    Warrants = 'WARRANTS',
    WarrantsClassA = 'WARRANTS_CLASS_A',
    WarrantsClassB = 'WARRANTS_CLASS_B',
    Called = 'CALLED',
    ClassACalled = 'CLASS_A_CALLED',
    PreferredCalled = 'PREFERRED_CALLED',
    PreferredACalled = 'PREFERRED_A_CALLED',
    PreferredAWhenIssued = 'PREFERRED_A_WHEN_ISSUED',
    EmergingCompanyMarketplace = 'EMERGING_COMPANY_MARKETPLACE',
    PartialPaid = 'PARTIAL_PAID',
    Convertible = 'CONVERTIBLE',
    ConvertibleCalled = 'CONVERTIBLE_CALLED',
    ClassConvertible = 'CLASS_CONVERTIBLE',
    PreferredAConvertible = 'PREFERRED_A_CONVERTIBLE',
    PreferredAWhenDistributed = 'PREFERRED_A_WHEN_DISTRIBUTED',
    Rights = 'RIGHTS',
    Units = 'UNITS',
    WhenIssued = 'WHEN_ISSUED',
    RightsWhenIssued = 'RIGHTS_WHEN_ISSUED',
    PreferredWhenIssued = 'PREFERRED_WHEN_ISSUED',
    ClassAWhenIssued = 'CLASS_A_WHEN_ISSUED',
    WarrantWhenIssued = 'WARRANT_WHEN_ISSUED',
    TestSymbol = 'TEST_SYMBOL'
}

export const IXC_ASSETS_V1_SYMBOL_SUFFIX_INFO_EXTENSION_SUFFIX_MAP = {
    [IxcAssetsV1SymbolSuffix.None]: '',
    [IxcAssetsV1SymbolSuffix.Preferred]: '-',
    [IxcAssetsV1SymbolSuffix.PreferredClassA]: '-A',
    [IxcAssetsV1SymbolSuffix.PreferredClassB]: '-B',
    [IxcAssetsV1SymbolSuffix.ClassA]: '.A',
    [IxcAssetsV1SymbolSuffix.ClassB]: '.B',
    [IxcAssetsV1SymbolSuffix.PreferredWhenDistributed]: '-$',
    [IxcAssetsV1SymbolSuffix.WhenDistributed]: '$',
    [IxcAssetsV1SymbolSuffix.Warrants]: '+',
    [IxcAssetsV1SymbolSuffix.WarrantsClassA]: '+A',
    [IxcAssetsV1SymbolSuffix.WarrantsClassB]: '+B',
    [IxcAssetsV1SymbolSuffix.Called]: '*',
    [IxcAssetsV1SymbolSuffix.ClassACalled]: '.A*',
    [IxcAssetsV1SymbolSuffix.PreferredCalled]: '-*',
    [IxcAssetsV1SymbolSuffix.PreferredACalled]: '-A*',
    [IxcAssetsV1SymbolSuffix.PreferredAWhenIssued]: '-A#',
    [IxcAssetsV1SymbolSuffix.EmergingCompanyMarketplace]: '!',
    [IxcAssetsV1SymbolSuffix.PartialPaid]: '@',
    [IxcAssetsV1SymbolSuffix.Convertible]: '%',
    [IxcAssetsV1SymbolSuffix.ConvertibleCalled]: '%*',
    [IxcAssetsV1SymbolSuffix.ClassConvertible]: '.A%',
    [IxcAssetsV1SymbolSuffix.PreferredAConvertible]: '-A%',
    [IxcAssetsV1SymbolSuffix.PreferredAWhenDistributed]: '-A$',
    [IxcAssetsV1SymbolSuffix.Rights]: '^',
    [IxcAssetsV1SymbolSuffix.Units]: '=',
    [IxcAssetsV1SymbolSuffix.WhenIssued]: '#',
    [IxcAssetsV1SymbolSuffix.RightsWhenIssued]: '^#',
    [IxcAssetsV1SymbolSuffix.PreferredWhenIssued]: '-#',
    [IxcAssetsV1SymbolSuffix.ClassAWhenIssued]: '.A#',
    [IxcAssetsV1SymbolSuffix.WarrantWhenIssued]: '+#',
    [IxcAssetsV1SymbolSuffix.TestSymbol]: '~'
} as const;

export interface IxcBillingV1ChargeData {
    spec: IxcBillingV1ChargeSpec;
    contra: IxcBillingV1CorrespondentAccount;
    /* The unique identifier for the transaction which debits the customer's
    brokerage account */
    // format: id62, entity: ixc.portfolio.v1.Transaction
    customerTransactionId?: string;
    /* The unique identifier for the transaction which credits the
    correspondent's billing account */
    // format: id62, entity: ixc.portfolio.v1.Transaction
    correspondentTransactionId?: string;
    /* The unique identifier for the hold placed on the customer's brokerage
    account */
    // format: id62, entity: ixc.portfolio.v1.Hold
    holdId?: string;
}

export interface IxcBillingV1ChargeEvent extends IxcBillingV1ChargeKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcBillingV1ChargeEventType;
}

export type IxcBillingV1ChargeEventType = {
    '!type'?: 'requested';
    requested: IxcBillingV1ChargeEventTypeRequested;
} | {
    '!type'?: 'approvalReply';
    approvalReply: IxcBillingV1ChargeEventTypeApprovalReply;
} | {
    '!type'?: 'rejected';
    rejected: IxcBillingV1ChargeEventTypeRejected;
} | {
    '!type'?: 'accepted';
    accepted: IxcBillingV1ChargeEventTypeAccepted;
};

export interface IxcBillingV1ChargeEventTypeAccepted {
    /* The unique identifier for the transaction which debits the customer's
    brokerage account */
    // format: id62, entity: ixc.portfolio.v1.Transaction
    customerTransactionId: string;
    /* The unique identifier for the transaction which credits the
    correspondent's billing account */
    // format: id62, entity: ixc.portfolio.v1.Transaction
    correspondentTransactionId: string;
}

export interface IxcBillingV1ChargeEventTypeApprovalReply {
    reply?: IxcBillingV1ChargeEventTypeApprovalReplyType;
}

export type IxcBillingV1ChargeEventTypeApprovalReplyType = {
    '!type'?: 'reservation';
    reservation: IxcBillingV1ChargeEventTypeApprovalReplyTypeReservation;
};

export interface IxcBillingV1ChargeEventTypeApprovalReplyTypeReservation {
    outcome: IxcPortfolioV1HoldOutcome;
}

export const IXC_BILLING_V1_CHARGE_EVENT_TYPE_APPROVAL_REPLY_TYPE_ONE_OF_VALUES = ['reservation'] as const;

export type IxcBillingV1ChargeEventTypeApprovalReplyTypeOneOfValue = (typeof IXC_BILLING_V1_CHARGE_EVENT_TYPE_APPROVAL_REPLY_TYPE_ONE_OF_VALUES)[number];

export interface IxcBillingV1ChargeEventTypeRejected {
    reasonText: string;
    reasonCode: IxcBillingV1ChargeRejectionCode;
}

export interface IxcBillingV1ChargeEventTypeRequested {
    spec: IxcBillingV1ChargeSpec;
    contra: IxcBillingV1CorrespondentAccount;
}

export const IXC_BILLING_V1_CHARGE_EVENT_TYPE_ONE_OF_VALUES = ['requested', 'approvalReply', 'rejected', 'accepted'] as const;

export type IxcBillingV1ChargeEventTypeOneOfValue = (typeof IXC_BILLING_V1_CHARGE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcBillingV1ChargeKeys {
    /* Unique identifier for the charge */
    // format: id62
    chargeId: string;
    /* Account ID */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    /* Program ID */
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
}

export interface IxcBillingV1ChargeQueryServiceChargeEventsChargeEventsRequest {
    /* Unique identifier for the charge */
    // format: id62
    chargeId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcBillingV1ChargeQueryServiceChargeEventsSortableFields, IxcBillingV1ChargeQueryServiceChargeEventsFilterableFields>;
}

export enum IxcBillingV1ChargeQueryServiceChargeEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    ChargeId = 'chargeId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    EventRequestedSpecCategory = 'event.requested.spec.category',
    EventRequestedContraAccountId = 'event.requested.contra.accountId',
    EventType = 'event.!type'
}

export enum IxcBillingV1ChargeQueryServiceChargeEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcBillingV1ChargeQueryServiceChargeGetChargeGetRequest {
    /* Unique identifier for the charge */
    // format: id62
    chargeId: string;
}

export interface IxcBillingV1ChargeQueryServiceChargeListChargeListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcBillingV1ChargeQueryServiceChargeListSortableFields, IxcBillingV1ChargeQueryServiceChargeListFilterableFields>;
}

export enum IxcBillingV1ChargeQueryServiceChargeListFilterableFields {
    ChargeId = 'chargeId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    DataSpecCategory = 'data.spec.category',
    DataContraAccountId = 'data.contra.accountId',
    DataCustomerTransactionId = 'data.customerTransactionId',
    DataCorrespondentTransactionId = 'data.correspondentTransactionId',
    DataHoldId = 'data.holdId',
    Status = 'status'
}

export enum IxcBillingV1ChargeQueryServiceChargeListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export enum IxcBillingV1ChargeRejectionCode {
    Unspecified = 'UNSPECIFIED',
    BalanceHoldRejected = 'BALANCE_HOLD_REJECTED'
}

export interface IxcBillingV1ChargeSpec {
    /* The amount, in dollars, to debit the brokerage account */
    // format: decimal
    amount: string;
    /* A customer focused text description which will appear on statements and
    transaction lists */
    description?: string;
    /* Free text for correspondent use only, this will not appear on brokerage
    account statements, and no backoffice system relies on this field. */
    // format: custom - pattern: .*
    category?: string;
}

export interface IxcBillingV1ChargeState extends IxcBillingV1ChargeKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcBillingV1ChargeData;
    status: IxcBillingV1ChargeStatus;
}

export enum IxcBillingV1ChargeStatus {
    Unspecified = 'UNSPECIFIED',
    Approval = 'APPROVAL',
    Rejected = 'REJECTED',
    Done = 'DONE'
}

export interface IxcBillingV1ChargeTransaction {
    /* The unique identifier for the charge */
    // format: id62
    chargeId: string;
    /* The unique identifier for the brokerage account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    /* The unique identifier for the program */
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
    /* The amount, in dollars, to debit the brokerage account */
    // format: decimal
    amount: string;
    /* A customer focused text description which will appear on statements and
    transaction lists */
    description?: string;
    /* Free text for correspondent use only, this will not appear on brokerage
    account statements, and no backoffice system relies on this field. */
    // format: custom - pattern: .*
    category?: string;
}

export interface IxcBillingV1CorrespondentAccount {
    /* The unique identifier for the correspondent's billing brokerage account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
}

export interface IxcBillingV1CustomerChargeTransaction {
    /* The unique identifier for the charge */
    // format: id62
    chargeId: string;
    /* The unique identifier for the customer brokerage account */
    // format: id62, entity: ixc.registration.v1.Account
    customerAccountId: string;
    /* The unique identifier for the correspondent billing account */
    // format: id62, entity: ixc.registration.v1.Account
    billingAccountId: string;
    /* The unique identifier for the program */
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
    /* The amount, in dollars, to debit the brokerage account */
    // format: decimal
    amount: string;
    /* A customer focused text description which will appear on statements and
    transaction lists */
    description?: string;
    /* Free text for correspondent use only, this will not appear on brokerage
    account statements, and no backoffice system relies on this field. */
    // format: custom - pattern: .*
    category?: string;
}

export interface IxcCasesV1CaseData {
    subject: IxcCasesV1EntityRef;
    title: string;
    description: string;
    // format: id62, entity: ixm.userauth.v1.User
    assignee?: string;
    comments?: IxcCasesV1Comment[];
}

export interface IxcCasesV1CaseEvent extends IxcCasesV1CaseKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcCasesV1CaseEventType;
}

export type IxcCasesV1CaseEventType = {
    '!type'?: 'created';
    created: IxcCasesV1CaseEventTypeCreated;
} | {
    '!type'?: 'started';
    started: IxcCasesV1CaseEventTypeStarted;
} | {
    '!type'?: 'reassigned';
    reassigned: IxcCasesV1CaseEventTypeReassigned;
} | {
    '!type'?: 'commented';
    commented: IxcCasesV1CaseEventTypeCommented;
} | {
    '!type'?: 'resolved';
    resolved: IxcCasesV1CaseEventTypeResolved;
} | {
    '!type'?: 'closed';
    closed: IxcCasesV1CaseEventTypeClosed;
};

export interface IxcCasesV1CaseEventTypeClosed {
    reason: IxcCasesV1Comment;
}

export interface IxcCasesV1CaseEventTypeCommented {
    newComment: IxcCasesV1Comment;
}

export interface IxcCasesV1CaseEventTypeCreated {
    // format: id62
    caseId?: string;
    // format: id62
    groupId?: string;
    // format: id62
    programId?: string;
    subject: IxcCasesV1EntityRef;
    title: string;
    description: string;
    // format: id62
    assignee?: string;
}

export interface IxcCasesV1CaseEventTypeReassigned {
    // format: id62
    assignee: string;
}

export interface IxcCasesV1CaseEventTypeResolved {
    reason?: IxcCasesV1Comment;
}

export interface IxcCasesV1CaseEventTypeStarted {
    // format: id62
    assignee: string;
}

export const IXC_CASES_V1_CASE_EVENT_TYPE_ONE_OF_VALUES = ['created', 'started', 'reassigned', 'commented', 'resolved', 'closed'] as const;

export type IxcCasesV1CaseEventTypeOneOfValue = (typeof IXC_CASES_V1_CASE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcCasesV1CaseKeys {
    // format: id62
    caseId: string;
    /* The program the case belongs to. When absent, the case spans multiple
    programs and is targeted at clearing operations rather than a single
    program. */
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
    // format: id62
    groupId?: string;
}

export interface IxcCasesV1CaseQueryServiceCaseEventsCaseEventsRequest {
    // format: id62
    caseId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcCasesV1CaseQueryServiceCaseEventsSearchableFields, IxcCasesV1CaseQueryServiceCaseEventsSortableFields, IxcCasesV1CaseQueryServiceCaseEventsFilterableFields>;
}

export enum IxcCasesV1CaseQueryServiceCaseEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    CaseId = 'caseId',
    ProgramId = 'programId',
    GroupId = 'groupId',
    EventType = 'event.!type'
}

export enum IxcCasesV1CaseQueryServiceCaseEventsSearchableFields {
    EventCreatedSubjectFullName = 'event.created.subject.fullName'
}

export enum IxcCasesV1CaseQueryServiceCaseEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcCasesV1CaseQueryServiceCaseGetCaseGetRequest {
    // format: id62
    caseId: string;
}

export interface IxcCasesV1CaseQueryServiceCaseListCaseListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcCasesV1CaseQueryServiceCaseListSearchableFields, IxcCasesV1CaseQueryServiceCaseListSortableFields, IxcCasesV1CaseQueryServiceCaseListFilterableFields>;
}

export enum IxcCasesV1CaseQueryServiceCaseListFilterableFields {
    CaseId = 'caseId',
    ProgramId = 'programId',
    GroupId = 'groupId',
    DataAssignee = 'data.assignee',
    Status = 'status'
}

export enum IxcCasesV1CaseQueryServiceCaseListSearchableFields {
    DataSubjectFullName = 'data.subject.fullName',
    DataTitle = 'data.title',
    DataDescription = 'data.description'
}

export enum IxcCasesV1CaseQueryServiceCaseListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcCasesV1CaseState extends IxcCasesV1CaseKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcCasesV1CaseData;
    status: IxcCasesV1CaseStatus;
}

export enum IxcCasesV1CaseStatus {
    Unspecified = 'UNSPECIFIED',
    Open = 'OPEN',
    InProgress = 'IN_PROGRESS',
    Resolved = 'RESOLVED',
    Closed = 'CLOSED'
}

export type IxcCasesV1CaseUpdate = {
    '!type'?: 'start';
    start: IxcCasesV1CaseUpdateStart;
} | {
    '!type'?: 'reassign';
    reassign: IxcCasesV1CaseUpdateReassign;
} | {
    '!type'?: 'comment';
    comment: IxcCasesV1CaseUpdateComment;
} | {
    '!type'?: 'resolve';
    resolve: IxcCasesV1CaseUpdateResolve;
} | {
    '!type'?: 'close';
    close: IxcCasesV1CaseUpdateClose;
};

export interface IxcCasesV1CaseUpdateClose {
    comment: string;
}

export interface IxcCasesV1CaseUpdateComment {
    comment: string;
}

export interface IxcCasesV1CaseUpdateReassign {
    // format: id62
    assignee: string;
}

export interface IxcCasesV1CaseUpdateResolve {
    comment?: string;
}

export interface IxcCasesV1CaseUpdateStart {
    // format: id62
    assignee: string;
}

export const IXC_CASES_V1_CASE_UPDATE_ONE_OF_VALUES = ['start', 'reassign', 'comment', 'resolve', 'close'] as const;

export type IxcCasesV1CaseUpdateOneOfValue = (typeof IXC_CASES_V1_CASE_UPDATE_ONE_OF_VALUES)[number];

export interface IxcCasesV1Comment {
    // format: id62
    eventId: string;
    actor: J5AuthV1Actor;
    // format: date-time
    timestamp: string;
    text: string;
}

export interface IxcCasesV1EntityRef {
    primaryKeys: IxcCasesV1EntityRefPrimaryKeys[];
    fullName: string;
}

export interface IxcCasesV1EntityRefPrimaryKeys {
    keyName: string;
    keyId: string;
}

export interface IxcClearingV1ClosingPositionData {
    asset?: IxcAssetsV1AssetState;
    /* Sum of all balances in brokerage accounts, including inventory and
    correspondent PAB. */
    // format: decimal
    portfolioTotal: string;
    /* Total in inventory accounts of the clearing fim */
    // format: decimal
    inventoryTotal: string;
    /* Sum of all balances in brokerage Customer-coded accounts 15c3-3(a)(1) -
    this includes balances which are not fully_paid. */
    // format: decimal
    customerTotal: string;
    /* Sum of all balances in brokerage accounts marked Non-Customer type
    according to 15c3-3, excludes the firm's own inventory. */
    // format: decimal
    nonCustomerTotal: string;
    /* Sum of paid for balance in Customer-coded portfolio accounts which meet
    the fully-paid-for requirement of 15c3-3(a)(3). */
    // format: decimal
    fullyPaidCustomerTotal: string;
    /* The balance reported in the APIBal file from DTC. */
    // format: decimal
    dtcTotal: string;
    /* The confirmed seg balance from DTC */
    // format: decimal
    dtcSeg: string;
}

export interface IxcClearingV1ClosingPositionEvent extends IxcClearingV1ClosingPositionKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcClearingV1ClosingPositionEventType;
}

export type IxcClearingV1ClosingPositionEventType = {
    '!type'?: 'dtcbal';
    dtcbal: IxcClearingV1ClosingPositionEventTypeDtcBal;
} | {
    '!type'?: 'memoSegBalance';
    memoSegBalance: IxcClearingV1ClosingPositionEventTypeMemoSegBalance;
} | {
    '!type'?: 'portfolioTotals';
    portfolioTotals: IxcClearingV1ClosingPositionEventTypePortfolioTotals;
};

export interface IxcClearingV1ClosingPositionEventTypeDtcBal {
    // format: YYYY-MM-DD
    lastActivityDate: string;
    // format: decimal
    shareQuantity: string;
}

export interface IxcClearingV1ClosingPositionEventTypeMemoSegBalance {
    // format: decimal
    closingSharePosition: string;
}

export interface IxcClearingV1ClosingPositionEventTypePortfolioTotals {
    // format: decimal
    inventoryTotal: string;
    // format: decimal
    customerTotal: string;
    // format: decimal
    nonCustomerTotal: string;
    // format: decimal
    fullyPaidCustomerTotal: string;
}

export const IXC_CLEARING_V1_CLOSING_POSITION_EVENT_TYPE_ONE_OF_VALUES = ['dtcbal', 'memoSegBalance', 'portfolioTotals'] as const;

export type IxcClearingV1ClosingPositionEventTypeOneOfValue = (typeof IXC_CLEARING_V1_CLOSING_POSITION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcClearingV1ClosingPositionKeys {
    // format: id62
    assetId: string;
    // format: custom - pattern: (\d{4})-(\d{2})-(\d{2})
    date: string;
}

export interface IxcClearingV1ClosingPositionQueryServiceClosingPositionEventsClosingPositionEventsRequest {
    // format: id62
    assetId: string;
    // format: custom - pattern: (\d{4})-(\d{2})-(\d{2})
    date: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcClearingV1ClosingPositionQueryServiceClosingPositionEventsSortableFields, IxcClearingV1ClosingPositionQueryServiceClosingPositionEventsFilterableFields>;
}

export enum IxcClearingV1ClosingPositionQueryServiceClosingPositionEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AssetId = 'assetId',
    Date = 'date',
    EventType = 'event.!type'
}

export enum IxcClearingV1ClosingPositionQueryServiceClosingPositionEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcClearingV1ClosingPositionQueryServiceClosingPositionGetClosingPositionGetRequest {
    // format: id62
    assetId: string;
    // format: custom - pattern: (\d{4})-(\d{2})-(\d{2})
    date: string;
}

export interface IxcClearingV1ClosingPositionQueryServiceClosingPositionListClosingPositionListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcClearingV1ClosingPositionQueryServiceClosingPositionListSearchableFields, IxcClearingV1ClosingPositionQueryServiceClosingPositionListSortableFields, IxcClearingV1ClosingPositionQueryServiceClosingPositionListFilterableFields>;
}

export enum IxcClearingV1ClosingPositionQueryServiceClosingPositionListFilterableFields {
    AssetId = 'assetId',
    Date = 'date',
    DataAssetAssetId = 'data.asset.assetId',
    DataAssetDataTypeEquityCusip = 'data.asset.data.type.equity.cusip',
    DataAssetDataTypeEquityControlsCanBuy = 'data.asset.data.type.equity.controls.canBuy',
    DataAssetDataTypeEquityControlsCanSell = 'data.asset.data.type.equity.controls.canSell',
    DataAssetDataTypeEquityControlsCanEnterFractions = 'data.asset.data.type.equity.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketCusip = 'data.asset.data.type.moneyMarket.cusip',
    DataAssetDataTypeMoneyMarketControlsCanBuy = 'data.asset.data.type.moneyMarket.controls.canBuy',
    DataAssetDataTypeMoneyMarketControlsCanSell = 'data.asset.data.type.moneyMarket.controls.canSell',
    DataAssetDataTypeMoneyMarketControlsCanEnterFractions = 'data.asset.data.type.moneyMarket.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketClassification = 'data.asset.data.type.moneyMarket.classification',
    DataAssetDataTypeMoneyMarketNavType = 'data.asset.data.type.moneyMarket.navType',
    DataAssetDataTypeType = 'data.asset.data.type.!type',
    DataAssetDataCategory = 'data.asset.data.category',
    DataAssetStatus = 'data.asset.status',
    Status = 'status'
}

export enum IxcClearingV1ClosingPositionQueryServiceClosingPositionListSearchableFields {
    DataAssetDataTypeEquitySymbolBase = 'data.asset.data.type.equity.symbol.base',
    DataAssetDataTypeEquityName = 'data.asset.data.type.equity.name',
    DataAssetDataTypeMoneyMarketSymbolBase = 'data.asset.data.type.moneyMarket.symbol.base',
    DataAssetDataTypeMoneyMarketName = 'data.asset.data.type.moneyMarket.name'
}

export enum IxcClearingV1ClosingPositionQueryServiceClosingPositionListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataAssetMetadataCreatedAt = 'data.asset.metadata.createdAt',
    DataAssetMetadataUpdatedAt = 'data.asset.metadata.updatedAt'
}

export interface IxcClearingV1ClosingPositionState extends IxcClearingV1ClosingPositionKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcClearingV1ClosingPositionData;
    status: IxcClearingV1ClosingPositionStatus;
}

export enum IxcClearingV1ClosingPositionStatus {
    Unspecified = 'UNSPECIFIED',
    Open = 'OPEN'
}

export interface IxcCorpactionsCaadminV1ActionData {
    dtc?: IxcCorpactionsCaadminV1ActionDataDtc;
    calendar?: IxcCorpactionsCaadminV1CalendarData;
    /* The underlying asset for this corporate action event */
    underlyingSecurity: IxcAssetsV1AssetState;
    /* Securities referenced by deltas, other than the underlying */
    referencedSecurities?: IxcAssetsV1AssetState[];
    manualOverride?: IxcCorpactionsCaadminV1ManualOverride;
    candidateVersion: IxcCorpactionsCaadminV1VersionCandidate;
    /* The latest version which has been approved. When approved prior to the
    trigger timestamp, triggered will be false and will update at the trigger
    time. Any update after that will be automatically triggered, so there
    will never be a diff between the approved and triggered versions */
    approvedVersion?: IxcCorpactionsCaadminV1ActionDataApprovedVersion;
    /* contains each version which is referenced other than approvedVersion */
    referencedVersions?: IxcCorpactionsCaadminV1ActionDataReferencedVersions[];
}

export interface IxcCorpactionsCaadminV1ActionDataApprovedVersion {
    /* a hash of the content */
    // format: id62
    versionId: string;
    /* time when this version was approved */
    // format: date-time
    timestamp: string;
    /* time when this version will be / was triggered */
    // format: date-time
    triggerTimestamp: string;
    /* true if this version has been sent to other services */
    triggered?: boolean;
    data: IxcCorpactionsV1CustomerAction;
}

export interface IxcCorpactionsCaadminV1ActionDataDtc {
    notification?: IxcCorpactionsCaadminV1ActionDataDtcNotification;
    cancellation?: IxcCorpactionsCaadminV1ActionDataDtcCancellation;
}

export interface IxcCorpactionsCaadminV1ActionDataDtcCancellation {
    // format: date-time
    timestamp: string;
    header: ExcDtcDtccaV1ActionHeader;
    /* PROC (processing) or WITH (withdrawal) */
    cancellationReasonCode: string;
    // format: YYYY-MM-DD
    recordDate?: string;
    // format: YYYY-MM-DD
    exDividendDate?: string;
    // format: YYYY-MM-DD
    effectiveDate?: string;
}

export interface IxcCorpactionsCaadminV1ActionDataDtcNotification {
    // format: date-time
    timestamp: string;
    header?: ExcDtcDtccaV1ActionHeader;
    // format: YYYY-MM-DD
    recordDate?: string;
    // format: YYYY-MM-DD
    exDividendDate?: string;
    /* For reorgs, this is the key date (mergers, splits, spinoffs) */
    // format: YYYY-MM-DD
    effectiveDate?: string;
    /* SD DTCPosCaptrDt — when DTC captures positions. Not present for reorgs;
    falls back to recordDate or effectiveDate. */
    // format: YYYY-MM-DD
    dtcCaptureDate?: string;
    /* Dividend type code (DvddTp > Cd), e.g. REIN, FINL, SPEC */
    dividendType?: string;
    /* Offer type code (OfferTp > Cd), e.g. DISS, NDIS */
    offerType?: string;
    /* Number of accrued interest days (IntrstAcrdNbOfDays) */
    // format: INT32
    interestAccruedDays?: number;
    /* SD asset class (DTCAsstClss), e.g. CRPE, CRPB, MUNB */
    dtcAssetClass?: string;
    /* SD asset type (DTCAsstTp), e.g. S010, S117 */
    dtcAssetType?: string;
    /* SD ticker symbol (TckrSymb) */
    ticker?: string;
    /* Narrative text from AddtlInf > AddtlTxt */
    additionalInfo?: string;
    cashMovements?: ExcDtcDtccaV1CashMovement[];
    securityMovements?: ExcDtcDtccaV1SecurityMovement[];
}

export interface IxcCorpactionsCaadminV1ActionDataReferencedVersions {
    // format: id62
    versionId: string;
    // format: date-time
    timestamp: string;
    data: IxcCorpactionsV1CustomerAction;
}

export interface IxcCorpactionsCaadminV1ActionEvent extends IxcCorpactionsCaadminV1ActionKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcCorpactionsCaadminV1ActionEventType;
}

export type IxcCorpactionsCaadminV1ActionEventType = {
    '!type'?: 'manualCreate';
    manualCreate: IxcCorpactionsCaadminV1ActionEventTypeManualCreate;
} | {
    '!type'?: 'manualUpdate';
    manualUpdate: IxcCorpactionsCaadminV1ActionEventTypeManualUpdate;
} | {
    '!type'?: 'updateCalendar';
    updateCalendar: IxcCorpactionsCaadminV1ActionEventTypeUpdateCalendar;
} | {
    '!type'?: 'dataUpdated';
    dataUpdated: IxcCorpactionsCaadminV1ActionEventTypeDataUpdated;
} | {
    '!type'?: 'dtcNotification';
    dtcNotification: IxcCorpactionsCaadminV1ActionEventTypeDtcNotification;
} | {
    '!type'?: 'dtcCancellation';
    dtcCancellation: IxcCorpactionsCaadminV1ActionEventTypeDtcCancellation;
} | {
    '!type'?: 'canceled';
    canceled: EmptyObject;
} | {
    '!type'?: 'approved';
    approved: IxcCorpactionsCaadminV1ActionEventTypeApproved;
} | {
    '!type'?: 'retracted';
    retracted: EmptyObject;
} | {
    '!type'?: 'trigger';
    trigger: IxcCorpactionsCaadminV1ActionEventTypeTrigger;
} | {
    '!type'?: 'deferredWait';
    deferredWait: EmptyObject;
} | {
    '!type'?: 'done';
    done: EmptyObject;
} | {
    '!type'?: 'securityUpdate';
    securityUpdate: IxcCorpactionsCaadminV1ActionEventTypeSecurityUpdate;
};

export interface IxcCorpactionsCaadminV1ActionEventTypeApproved {
    /* must match candidateVersion.versionId */
    // format: id62
    versionId: string;
}

export interface IxcCorpactionsCaadminV1ActionEventTypeDataUpdated {
    candidate?: IxcCorpactionsCaadminV1VersionCandidate;
}

export interface IxcCorpactionsCaadminV1ActionEventTypeDtcCancellation {
    parseInfo: ExcDtcDtccaV1ParseInfo;
    cancellation: ExcDtcDtccaV1Cancellation;
}

export interface IxcCorpactionsCaadminV1ActionEventTypeDtcNotification {
    parseInfo: ExcDtcDtccaV1ParseInfo;
    notification: ExcDtcDtccaV1Notification;
    securities?: IxcAssetsV1AssetState[];
}

export interface IxcCorpactionsCaadminV1ActionEventTypeManualCreate {
    spec?: IxcCorpactionsCaadminV1ManualOverride;
    // format: id62
    underlyingAssetId: string;
    securities: IxcAssetsV1AssetState[];
}

export interface IxcCorpactionsCaadminV1ActionEventTypeManualUpdate {
    spec?: IxcCorpactionsCaadminV1ManualOverride;
    securities: IxcAssetsV1AssetState[];
}

export interface IxcCorpactionsCaadminV1ActionEventTypeSecurityUpdate {
    security?: IxcAssetsV1AssetState;
}

export interface IxcCorpactionsCaadminV1ActionEventTypeTrigger {
    /* must match candidateVersion.versionId */
    // format: id62
    versionId: string;
}

export interface IxcCorpactionsCaadminV1ActionEventTypeUpdateCalendar {
    // format: YYYY-MM-DD
    cumDate: string;
    // format: YYYY-MM-DD
    exDate: string;
}

export const IXC_CORPACTIONS_CAADMIN_V1_ACTION_EVENT_TYPE_ONE_OF_VALUES = ['manualCreate', 'manualUpdate', 'updateCalendar', 'dataUpdated', 'dtcNotification', 'dtcCancellation', 'canceled', 'approved', 'retracted', 'trigger', 'deferredWait', 'done', 'securityUpdate'] as const;

export type IxcCorpactionsCaadminV1ActionEventTypeOneOfValue = (typeof IXC_CORPACTIONS_CAADMIN_V1_ACTION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcCorpactionsCaadminV1ActionKeys {
    // format: id62
    actionId: string;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
}

export interface IxcCorpactionsCaadminV1ActionQueryServiceActionEventsActionEventsRequest {
    // format: id62
    actionId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcCorpactionsCaadminV1ActionQueryServiceActionEventsSearchableFields, IxcCorpactionsCaadminV1ActionQueryServiceActionEventsSortableFields, IxcCorpactionsCaadminV1ActionQueryServiceActionEventsFilterableFields>;
}

export enum IxcCorpactionsCaadminV1ActionQueryServiceActionEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    ActionId = 'actionId',
    AssetId = 'assetId',
    EventManualCreateSecuritiesAssetId = 'event.manualCreate.securities.assetId',
    EventManualCreateSecuritiesDataTypeEquityCusip = 'event.manualCreate.securities.data.type.equity.cusip',
    EventManualCreateSecuritiesDataTypeEquityControlsCanBuy = 'event.manualCreate.securities.data.type.equity.controls.canBuy',
    EventManualCreateSecuritiesDataTypeEquityControlsCanSell = 'event.manualCreate.securities.data.type.equity.controls.canSell',
    EventManualCreateSecuritiesDataTypeEquityControlsCanEnterFractions = 'event.manualCreate.securities.data.type.equity.controls.canEnterFractions',
    EventManualCreateSecuritiesDataTypeMoneyMarketCusip = 'event.manualCreate.securities.data.type.moneyMarket.cusip',
    EventManualCreateSecuritiesDataTypeMoneyMarketControlsCanBuy = 'event.manualCreate.securities.data.type.moneyMarket.controls.canBuy',
    EventManualCreateSecuritiesDataTypeMoneyMarketControlsCanSell = 'event.manualCreate.securities.data.type.moneyMarket.controls.canSell',
    EventManualCreateSecuritiesDataTypeMoneyMarketControlsCanEnterFractions = 'event.manualCreate.securities.data.type.moneyMarket.controls.canEnterFractions',
    EventManualCreateSecuritiesDataTypeMoneyMarketClassification = 'event.manualCreate.securities.data.type.moneyMarket.classification',
    EventManualCreateSecuritiesDataTypeMoneyMarketNavType = 'event.manualCreate.securities.data.type.moneyMarket.navType',
    EventManualCreateSecuritiesDataTypeType = 'event.manualCreate.securities.data.type.!type',
    EventManualCreateSecuritiesDataCategory = 'event.manualCreate.securities.data.category',
    EventManualCreateSecuritiesStatus = 'event.manualCreate.securities.status',
    EventManualUpdateSecuritiesAssetId = 'event.manualUpdate.securities.assetId',
    EventManualUpdateSecuritiesDataTypeEquityCusip = 'event.manualUpdate.securities.data.type.equity.cusip',
    EventManualUpdateSecuritiesDataTypeEquityControlsCanBuy = 'event.manualUpdate.securities.data.type.equity.controls.canBuy',
    EventManualUpdateSecuritiesDataTypeEquityControlsCanSell = 'event.manualUpdate.securities.data.type.equity.controls.canSell',
    EventManualUpdateSecuritiesDataTypeEquityControlsCanEnterFractions = 'event.manualUpdate.securities.data.type.equity.controls.canEnterFractions',
    EventManualUpdateSecuritiesDataTypeMoneyMarketCusip = 'event.manualUpdate.securities.data.type.moneyMarket.cusip',
    EventManualUpdateSecuritiesDataTypeMoneyMarketControlsCanBuy = 'event.manualUpdate.securities.data.type.moneyMarket.controls.canBuy',
    EventManualUpdateSecuritiesDataTypeMoneyMarketControlsCanSell = 'event.manualUpdate.securities.data.type.moneyMarket.controls.canSell',
    EventManualUpdateSecuritiesDataTypeMoneyMarketControlsCanEnterFractions = 'event.manualUpdate.securities.data.type.moneyMarket.controls.canEnterFractions',
    EventManualUpdateSecuritiesDataTypeMoneyMarketClassification = 'event.manualUpdate.securities.data.type.moneyMarket.classification',
    EventManualUpdateSecuritiesDataTypeMoneyMarketNavType = 'event.manualUpdate.securities.data.type.moneyMarket.navType',
    EventManualUpdateSecuritiesDataTypeType = 'event.manualUpdate.securities.data.type.!type',
    EventManualUpdateSecuritiesDataCategory = 'event.manualUpdate.securities.data.category',
    EventManualUpdateSecuritiesStatus = 'event.manualUpdate.securities.status',
    EventDataUpdatedCandidateDataHeaderCusip = 'event.dataUpdated.candidate.data.header.cusip',
    EventDataUpdatedCandidateDataHeaderRecordDate = 'event.dataUpdated.candidate.data.header.recordDate',
    EventDataUpdatedCandidateDataHeaderExDate = 'event.dataUpdated.candidate.data.header.exDate',
    EventDataUpdatedCandidateDataHeaderEffectiveDate = 'event.dataUpdated.candidate.data.header.effectiveDate',
    EventDataUpdatedCandidateDataHeaderPaymentDate = 'event.dataUpdated.candidate.data.header.paymentDate',
    EventDataUpdatedCandidateDataHeaderCumDate = 'event.dataUpdated.candidate.data.header.cumDate',
    EventDataUpdatedCandidateDataHeaderTimeApplicable = 'event.dataUpdated.candidate.data.header.timeApplicable',
    EventDataUpdatedCandidateDataHeaderActionType = 'event.dataUpdated.candidate.data.header.actionType',
    EventDtcNotificationSecuritiesAssetId = 'event.dtcNotification.securities.assetId',
    EventDtcNotificationSecuritiesDataTypeEquityCusip = 'event.dtcNotification.securities.data.type.equity.cusip',
    EventDtcNotificationSecuritiesDataTypeEquityControlsCanBuy = 'event.dtcNotification.securities.data.type.equity.controls.canBuy',
    EventDtcNotificationSecuritiesDataTypeEquityControlsCanSell = 'event.dtcNotification.securities.data.type.equity.controls.canSell',
    EventDtcNotificationSecuritiesDataTypeEquityControlsCanEnterFractions = 'event.dtcNotification.securities.data.type.equity.controls.canEnterFractions',
    EventDtcNotificationSecuritiesDataTypeMoneyMarketCusip = 'event.dtcNotification.securities.data.type.moneyMarket.cusip',
    EventDtcNotificationSecuritiesDataTypeMoneyMarketControlsCanBuy = 'event.dtcNotification.securities.data.type.moneyMarket.controls.canBuy',
    EventDtcNotificationSecuritiesDataTypeMoneyMarketControlsCanSell = 'event.dtcNotification.securities.data.type.moneyMarket.controls.canSell',
    EventDtcNotificationSecuritiesDataTypeMoneyMarketControlsCanEnterFractions = 'event.dtcNotification.securities.data.type.moneyMarket.controls.canEnterFractions',
    EventDtcNotificationSecuritiesDataTypeMoneyMarketClassification = 'event.dtcNotification.securities.data.type.moneyMarket.classification',
    EventDtcNotificationSecuritiesDataTypeMoneyMarketNavType = 'event.dtcNotification.securities.data.type.moneyMarket.navType',
    EventDtcNotificationSecuritiesDataTypeType = 'event.dtcNotification.securities.data.type.!type',
    EventDtcNotificationSecuritiesDataCategory = 'event.dtcNotification.securities.data.category',
    EventDtcNotificationSecuritiesStatus = 'event.dtcNotification.securities.status',
    EventSecurityUpdateSecurityAssetId = 'event.securityUpdate.security.assetId',
    EventSecurityUpdateSecurityDataTypeEquityCusip = 'event.securityUpdate.security.data.type.equity.cusip',
    EventSecurityUpdateSecurityDataTypeEquityControlsCanBuy = 'event.securityUpdate.security.data.type.equity.controls.canBuy',
    EventSecurityUpdateSecurityDataTypeEquityControlsCanSell = 'event.securityUpdate.security.data.type.equity.controls.canSell',
    EventSecurityUpdateSecurityDataTypeEquityControlsCanEnterFractions = 'event.securityUpdate.security.data.type.equity.controls.canEnterFractions',
    EventSecurityUpdateSecurityDataTypeMoneyMarketCusip = 'event.securityUpdate.security.data.type.moneyMarket.cusip',
    EventSecurityUpdateSecurityDataTypeMoneyMarketControlsCanBuy = 'event.securityUpdate.security.data.type.moneyMarket.controls.canBuy',
    EventSecurityUpdateSecurityDataTypeMoneyMarketControlsCanSell = 'event.securityUpdate.security.data.type.moneyMarket.controls.canSell',
    EventSecurityUpdateSecurityDataTypeMoneyMarketControlsCanEnterFractions = 'event.securityUpdate.security.data.type.moneyMarket.controls.canEnterFractions',
    EventSecurityUpdateSecurityDataTypeMoneyMarketClassification = 'event.securityUpdate.security.data.type.moneyMarket.classification',
    EventSecurityUpdateSecurityDataTypeMoneyMarketNavType = 'event.securityUpdate.security.data.type.moneyMarket.navType',
    EventSecurityUpdateSecurityDataTypeType = 'event.securityUpdate.security.data.type.!type',
    EventSecurityUpdateSecurityDataCategory = 'event.securityUpdate.security.data.category',
    EventSecurityUpdateSecurityStatus = 'event.securityUpdate.security.status',
    EventType = 'event.!type'
}

export enum IxcCorpactionsCaadminV1ActionQueryServiceActionEventsSearchableFields {
    EventManualCreateSecuritiesDataTypeEquitySymbolBase = 'event.manualCreate.securities.data.type.equity.symbol.base',
    EventManualCreateSecuritiesDataTypeEquityName = 'event.manualCreate.securities.data.type.equity.name',
    EventManualCreateSecuritiesDataTypeMoneyMarketSymbolBase = 'event.manualCreate.securities.data.type.moneyMarket.symbol.base',
    EventManualCreateSecuritiesDataTypeMoneyMarketName = 'event.manualCreate.securities.data.type.moneyMarket.name',
    EventManualUpdateSecuritiesDataTypeEquitySymbolBase = 'event.manualUpdate.securities.data.type.equity.symbol.base',
    EventManualUpdateSecuritiesDataTypeEquityName = 'event.manualUpdate.securities.data.type.equity.name',
    EventManualUpdateSecuritiesDataTypeMoneyMarketSymbolBase = 'event.manualUpdate.securities.data.type.moneyMarket.symbol.base',
    EventManualUpdateSecuritiesDataTypeMoneyMarketName = 'event.manualUpdate.securities.data.type.moneyMarket.name',
    EventDtcNotificationSecuritiesDataTypeEquitySymbolBase = 'event.dtcNotification.securities.data.type.equity.symbol.base',
    EventDtcNotificationSecuritiesDataTypeEquityName = 'event.dtcNotification.securities.data.type.equity.name',
    EventDtcNotificationSecuritiesDataTypeMoneyMarketSymbolBase = 'event.dtcNotification.securities.data.type.moneyMarket.symbol.base',
    EventDtcNotificationSecuritiesDataTypeMoneyMarketName = 'event.dtcNotification.securities.data.type.moneyMarket.name',
    EventSecurityUpdateSecurityDataTypeEquitySymbolBase = 'event.securityUpdate.security.data.type.equity.symbol.base',
    EventSecurityUpdateSecurityDataTypeEquityName = 'event.securityUpdate.security.data.type.equity.name',
    EventSecurityUpdateSecurityDataTypeMoneyMarketSymbolBase = 'event.securityUpdate.security.data.type.moneyMarket.symbol.base',
    EventSecurityUpdateSecurityDataTypeMoneyMarketName = 'event.securityUpdate.security.data.type.moneyMarket.name'
}

export enum IxcCorpactionsCaadminV1ActionQueryServiceActionEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventDataUpdatedCandidateDataHeaderRecordDate = 'event.dataUpdated.candidate.data.header.recordDate',
    EventDataUpdatedCandidateDataHeaderExDate = 'event.dataUpdated.candidate.data.header.exDate',
    EventDataUpdatedCandidateDataHeaderEffectiveDate = 'event.dataUpdated.candidate.data.header.effectiveDate',
    EventDataUpdatedCandidateDataHeaderPaymentDate = 'event.dataUpdated.candidate.data.header.paymentDate',
    EventDataUpdatedCandidateDataHeaderCumDate = 'event.dataUpdated.candidate.data.header.cumDate',
    EventDataUpdatedCandidateDataHeaderTimeApplicable = 'event.dataUpdated.candidate.data.header.timeApplicable',
    EventSecurityUpdateSecurityMetadataCreatedAt = 'event.securityUpdate.security.metadata.createdAt',
    EventSecurityUpdateSecurityMetadataUpdatedAt = 'event.securityUpdate.security.metadata.updatedAt'
}

export interface IxcCorpactionsCaadminV1ActionQueryServiceActionGetActionGetRequest {
    // format: id62
    actionId: string;
}

export interface IxcCorpactionsCaadminV1ActionQueryServiceActionListActionListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcCorpactionsCaadminV1ActionQueryServiceActionListSearchableFields, IxcCorpactionsCaadminV1ActionQueryServiceActionListSortableFields, IxcCorpactionsCaadminV1ActionQueryServiceActionListFilterableFields>;
}

export enum IxcCorpactionsCaadminV1ActionQueryServiceActionListFilterableFields {
    ActionId = 'actionId',
    AssetId = 'assetId',
    DataUnderlyingSecurityAssetId = 'data.underlyingSecurity.assetId',
    DataUnderlyingSecurityDataTypeEquityCusip = 'data.underlyingSecurity.data.type.equity.cusip',
    DataUnderlyingSecurityDataTypeEquityControlsCanBuy = 'data.underlyingSecurity.data.type.equity.controls.canBuy',
    DataUnderlyingSecurityDataTypeEquityControlsCanSell = 'data.underlyingSecurity.data.type.equity.controls.canSell',
    DataUnderlyingSecurityDataTypeEquityControlsCanEnterFractions = 'data.underlyingSecurity.data.type.equity.controls.canEnterFractions',
    DataUnderlyingSecurityDataTypeMoneyMarketCusip = 'data.underlyingSecurity.data.type.moneyMarket.cusip',
    DataUnderlyingSecurityDataTypeMoneyMarketControlsCanBuy = 'data.underlyingSecurity.data.type.moneyMarket.controls.canBuy',
    DataUnderlyingSecurityDataTypeMoneyMarketControlsCanSell = 'data.underlyingSecurity.data.type.moneyMarket.controls.canSell',
    DataUnderlyingSecurityDataTypeMoneyMarketControlsCanEnterFractions = 'data.underlyingSecurity.data.type.moneyMarket.controls.canEnterFractions',
    DataUnderlyingSecurityDataTypeMoneyMarketClassification = 'data.underlyingSecurity.data.type.moneyMarket.classification',
    DataUnderlyingSecurityDataTypeMoneyMarketNavType = 'data.underlyingSecurity.data.type.moneyMarket.navType',
    DataUnderlyingSecurityDataTypeType = 'data.underlyingSecurity.data.type.!type',
    DataUnderlyingSecurityDataCategory = 'data.underlyingSecurity.data.category',
    DataUnderlyingSecurityStatus = 'data.underlyingSecurity.status',
    DataReferencedSecuritiesAssetId = 'data.referencedSecurities.assetId',
    DataReferencedSecuritiesDataTypeEquityCusip = 'data.referencedSecurities.data.type.equity.cusip',
    DataReferencedSecuritiesDataTypeEquityControlsCanBuy = 'data.referencedSecurities.data.type.equity.controls.canBuy',
    DataReferencedSecuritiesDataTypeEquityControlsCanSell = 'data.referencedSecurities.data.type.equity.controls.canSell',
    DataReferencedSecuritiesDataTypeEquityControlsCanEnterFractions = 'data.referencedSecurities.data.type.equity.controls.canEnterFractions',
    DataReferencedSecuritiesDataTypeMoneyMarketCusip = 'data.referencedSecurities.data.type.moneyMarket.cusip',
    DataReferencedSecuritiesDataTypeMoneyMarketControlsCanBuy = 'data.referencedSecurities.data.type.moneyMarket.controls.canBuy',
    DataReferencedSecuritiesDataTypeMoneyMarketControlsCanSell = 'data.referencedSecurities.data.type.moneyMarket.controls.canSell',
    DataReferencedSecuritiesDataTypeMoneyMarketControlsCanEnterFractions = 'data.referencedSecurities.data.type.moneyMarket.controls.canEnterFractions',
    DataReferencedSecuritiesDataTypeMoneyMarketClassification = 'data.referencedSecurities.data.type.moneyMarket.classification',
    DataReferencedSecuritiesDataTypeMoneyMarketNavType = 'data.referencedSecurities.data.type.moneyMarket.navType',
    DataReferencedSecuritiesDataTypeType = 'data.referencedSecurities.data.type.!type',
    DataReferencedSecuritiesDataCategory = 'data.referencedSecurities.data.category',
    DataReferencedSecuritiesStatus = 'data.referencedSecurities.status',
    DataCandidateVersionDataHeaderCusip = 'data.candidateVersion.data.header.cusip',
    DataCandidateVersionDataHeaderRecordDate = 'data.candidateVersion.data.header.recordDate',
    DataCandidateVersionDataHeaderExDate = 'data.candidateVersion.data.header.exDate',
    DataCandidateVersionDataHeaderEffectiveDate = 'data.candidateVersion.data.header.effectiveDate',
    DataCandidateVersionDataHeaderPaymentDate = 'data.candidateVersion.data.header.paymentDate',
    DataCandidateVersionDataHeaderCumDate = 'data.candidateVersion.data.header.cumDate',
    DataCandidateVersionDataHeaderTimeApplicable = 'data.candidateVersion.data.header.timeApplicable',
    DataCandidateVersionDataHeaderActionType = 'data.candidateVersion.data.header.actionType',
    DataApprovedVersionDataHeaderCusip = 'data.approvedVersion.data.header.cusip',
    DataApprovedVersionDataHeaderRecordDate = 'data.approvedVersion.data.header.recordDate',
    DataApprovedVersionDataHeaderExDate = 'data.approvedVersion.data.header.exDate',
    DataApprovedVersionDataHeaderEffectiveDate = 'data.approvedVersion.data.header.effectiveDate',
    DataApprovedVersionDataHeaderPaymentDate = 'data.approvedVersion.data.header.paymentDate',
    DataApprovedVersionDataHeaderCumDate = 'data.approvedVersion.data.header.cumDate',
    DataApprovedVersionDataHeaderTimeApplicable = 'data.approvedVersion.data.header.timeApplicable',
    DataApprovedVersionDataHeaderActionType = 'data.approvedVersion.data.header.actionType',
    DataReferencedVersionsDataHeaderCusip = 'data.referencedVersions.data.header.cusip',
    DataReferencedVersionsDataHeaderRecordDate = 'data.referencedVersions.data.header.recordDate',
    DataReferencedVersionsDataHeaderExDate = 'data.referencedVersions.data.header.exDate',
    DataReferencedVersionsDataHeaderEffectiveDate = 'data.referencedVersions.data.header.effectiveDate',
    DataReferencedVersionsDataHeaderPaymentDate = 'data.referencedVersions.data.header.paymentDate',
    DataReferencedVersionsDataHeaderCumDate = 'data.referencedVersions.data.header.cumDate',
    DataReferencedVersionsDataHeaderTimeApplicable = 'data.referencedVersions.data.header.timeApplicable',
    DataReferencedVersionsDataHeaderActionType = 'data.referencedVersions.data.header.actionType',
    Status = 'status'
}

export enum IxcCorpactionsCaadminV1ActionQueryServiceActionListSearchableFields {
    DataUnderlyingSecurityDataTypeEquitySymbolBase = 'data.underlyingSecurity.data.type.equity.symbol.base',
    DataUnderlyingSecurityDataTypeEquityName = 'data.underlyingSecurity.data.type.equity.name',
    DataUnderlyingSecurityDataTypeMoneyMarketSymbolBase = 'data.underlyingSecurity.data.type.moneyMarket.symbol.base',
    DataUnderlyingSecurityDataTypeMoneyMarketName = 'data.underlyingSecurity.data.type.moneyMarket.name',
    DataReferencedSecuritiesDataTypeEquitySymbolBase = 'data.referencedSecurities.data.type.equity.symbol.base',
    DataReferencedSecuritiesDataTypeEquityName = 'data.referencedSecurities.data.type.equity.name',
    DataReferencedSecuritiesDataTypeMoneyMarketSymbolBase = 'data.referencedSecurities.data.type.moneyMarket.symbol.base',
    DataReferencedSecuritiesDataTypeMoneyMarketName = 'data.referencedSecurities.data.type.moneyMarket.name'
}

export enum IxcCorpactionsCaadminV1ActionQueryServiceActionListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataUnderlyingSecurityMetadataCreatedAt = 'data.underlyingSecurity.metadata.createdAt',
    DataUnderlyingSecurityMetadataUpdatedAt = 'data.underlyingSecurity.metadata.updatedAt',
    DataCandidateVersionDataHeaderRecordDate = 'data.candidateVersion.data.header.recordDate',
    DataCandidateVersionDataHeaderExDate = 'data.candidateVersion.data.header.exDate',
    DataCandidateVersionDataHeaderEffectiveDate = 'data.candidateVersion.data.header.effectiveDate',
    DataCandidateVersionDataHeaderPaymentDate = 'data.candidateVersion.data.header.paymentDate',
    DataCandidateVersionDataHeaderCumDate = 'data.candidateVersion.data.header.cumDate',
    DataCandidateVersionDataHeaderTimeApplicable = 'data.candidateVersion.data.header.timeApplicable',
    DataApprovedVersionDataHeaderRecordDate = 'data.approvedVersion.data.header.recordDate',
    DataApprovedVersionDataHeaderExDate = 'data.approvedVersion.data.header.exDate',
    DataApprovedVersionDataHeaderEffectiveDate = 'data.approvedVersion.data.header.effectiveDate',
    DataApprovedVersionDataHeaderPaymentDate = 'data.approvedVersion.data.header.paymentDate',
    DataApprovedVersionDataHeaderCumDate = 'data.approvedVersion.data.header.cumDate',
    DataApprovedVersionDataHeaderTimeApplicable = 'data.approvedVersion.data.header.timeApplicable'
}

export interface IxcCorpactionsCaadminV1ActionState extends IxcCorpactionsCaadminV1ActionKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcCorpactionsCaadminV1ActionData;
    status: IxcCorpactionsCaadminV1ActionStatus;
}

export enum IxcCorpactionsCaadminV1ActionStatus {
    Unspecified = 'UNSPECIFIED',
    Draft = 'DRAFT',
    Approved = 'APPROVED',
    Partial = 'PARTIAL',
    Complete = 'COMPLETE',
    UpdateDraft = 'UPDATE_DRAFT',
    Canceled = 'CANCELED',
    Reversed = 'REVERSED'
}

export interface IxcCorpactionsCaadminV1BuildingCustomerAction {
    header?: IxcCorpactionsCaadminV1BuildingHeader;
    /* A list of cash credit/debits to account balance, applied proportionally
    to the held position */
    cashDeltas?: IxcCorpactionsCaadminV1BuildingCustomerCashDelta[];
    /* A list of security credit/debits to account balance, applied
    proportionally to the held position */
    securityDeltas?: IxcCorpactionsCaadminV1BuildingCustomerActionSecurityDeltas[];
}

export interface IxcCorpactionsCaadminV1BuildingCustomerActionSecurityDeltas {
    // format: id62
    assetId?: string;
    /* Per held security, the amount which this payout pays Paid = Held * Rate
    This is the net dividend rate on distribution types This the stock or
    cash rate for REORG types
    debit (-) outgoing; credit (+) incoming; */
    // format: decimal
    rate?: string;
    /* For security payouts, This is the portion of the cost of the held
    position to bring forward to this new position, for cash payouts, this is
    the portion of the cost which is used as the cost basis used to calculate
    the realized gain or loss from the cash.
    When not set, the rate is unknown and cost basis calculation should be
    deferred. */
    costCalculation?: IxcCorpactionsV1CostCalculationType;
    /* The rules for how to round the payout amount when calculating the amount
    to credit or debit to the account. */
    rounding?: IxcCorpactionsV1RoundingRule;
    cashInLieu?: IxcCorpactionsCaadminV1BuildingCustomerActionSecurityDeltasCashInLieu;
}

export interface IxcCorpactionsCaadminV1BuildingCustomerActionSecurityDeltasCashInLieu {
    status?: IxcCorpactionsV1DeferredStatus;
    /* Per held security, the amount which this payout pays Paid = Held * Rate
    This is the net dividend rate on distribution types This the stock or
    cash rate for REORG types
    debit (-) outgoing; credit (+) incoming; */
    // format: decimal
    rate?: string;
    /* copies directly to journal entry time_applicable - i.e. the time the
    brokerage account is credited */
    // format: date-time
    timeApplicable?: string;
}

export interface IxcCorpactionsCaadminV1BuildingCustomerCashDelta {
    /* Per held security, the amount which this payout pays Paid = Held * Rate
    This is the net dividend rate on distribution types This the stock or
    cash rate for REORG types
    debit (-) outgoing; credit (+) incoming; */
    // format: decimal
    rate?: string;
    /* For security payouts, This is the portion of the cost of the held
    position to bring forward to this new position, for cash payouts, this is
    the portion of the cost which is used as the cost basis used to calculate
    the realized gain or loss from the cash.
    When not set, the rate is unknown and cost basis calculation should be
    deferred. */
    costCalculation?: IxcCorpactionsV1CostCalculationType;
}

export interface IxcCorpactionsCaadminV1BuildingHeader {
    /* The cusip which an account-holder must hold for this action to apply */
    // format: custom - pattern: ^[0-9A-Z]{9}$
    cusip?: string;
    /* The issuer's official record date. Needed for compliance and reporting,
    not used for processing. */
    // format: YYYY-MM-DD
    recordDate?: string;
    /* The cum/ex boundary, evaluated against a trade's trade date: a trade with
    a trade date is on or after exDate is 'ex' (excluded from the action);
    before exDate it is 'cum' (entitled). */
    // format: YYYY-MM-DD
    exDate?: string;
    /* For reorgs only, at close on effective date the positions are modified,
    and will trade with the new quantities the next trading day. */
    // format: YYYY-MM-DD
    effectiveDate?: string;
    /* The date that the issuer pays DTC. Ratios based on the settled position
    at recordDate. */
    // format: YYYY-MM-DD
    paymentDate?: string;
    /* The trade date prior to exDate, the closing trade balance for this date
    is used for calculating the entitled position for the action. Derived
    from effectiveDate for reorgs, otherwise the trading day prior to exDate
    for distributions. */
    // format: YYYY-MM-DD
    cumDate?: string;
    /* copies directly to journal entry time_applicable - i.e. the time the
    brokerage account is credited
    By default derived from paymentDate */
    // format: date-time
    timeApplicable?: string;
    /* The type of corporate action, this is used to determine how the action
    should be processed and what data is required. */
    actionType?: IxcCorpactionsV1ActionType;
    /* Derived from the actionType */
    paymentType?: IxcCorpactionsV1PaymentType;
    /* A string description of the type of action. The values provided in these
    strings are subject to change as new types are supported, code logic
    should not rely on specific values. */
    actionTypeLabel?: string;
    /* A qualifier for some actionTypeLabel values. The values provided in these
    strings are subject to change as new types are supported, code logic
    should not rely on specific values. */
    actionTypeSubLabel?: string;
    /* A human readable short description of the corporate action, this should
    be passed through to the user as-is */
    description?: string;
    /* Tax year for all payments in this action. */
    // pattern: [0-9]{4}
    taxYear?: string;
}

export interface IxcCorpactionsCaadminV1CalendarData {
    // format: YYYY-MM-DD
    cumDate: string;
    // format: YYYY-MM-DD
    exDate: string;
}

export enum IxcCorpactionsCaadminV1CancelOverride {
    Unspecified = 'UNSPECIFIED',
    Canceled = 'CANCELED',
    NotCanceled = 'NOT_CANCELED'
}

export interface IxcCorpactionsCaadminV1CashDeltaOverride {
    /* The 0 based array index of the cash deltas, default is 0, the first and
    usually only element. */
    // format: UINT32
    mergeIndex?: number;
    // format: decimal
    rate?: string;
    costCalculation?: IxcCorpactionsV1CostCalculationType;
}

export interface IxcCorpactionsCaadminV1CashInLieuOverride {
    rate?: IxcCorpactionsCaadminV1CashInLieuOverrideRate;
    timeApplicable?: IxcCorpactionsCaadminV1CashInLieuOverrideTimeApplicable;
}

export type IxcCorpactionsCaadminV1CashInLieuOverrideRate = {
    '!type'?: 'value';
    // format: decimal
    value: string;
} | {
    '!type'?: 'unknown';
    unknown: boolean;
};

export const IXC_CORPACTIONS_CAADMIN_V1_CASH_IN_LIEU_OVERRIDE_RATE_ONE_OF_VALUES = ['value', 'unknown'] as const;

export type IxcCorpactionsCaadminV1CashInLieuOverrideRateOneOfValue = (typeof IXC_CORPACTIONS_CAADMIN_V1_CASH_IN_LIEU_OVERRIDE_RATE_ONE_OF_VALUES)[number];

export type IxcCorpactionsCaadminV1CashInLieuOverrideTimeApplicable = {
    '!type'?: 'value';
    // format: date-time
    value: string;
} | {
    '!type'?: 'unknown';
    unknown: boolean;
};

export const IXC_CORPACTIONS_CAADMIN_V1_CASH_IN_LIEU_OVERRIDE_TIME_APPLICABLE_ONE_OF_VALUES = ['value', 'unknown'] as const;

export type IxcCorpactionsCaadminV1CashInLieuOverrideTimeApplicableOneOfValue = (typeof IXC_CORPACTIONS_CAADMIN_V1_CASH_IN_LIEU_OVERRIDE_TIME_APPLICABLE_ONE_OF_VALUES)[number];

export interface IxcCorpactionsCaadminV1ConversionError {
    type: string;
    message: string;
}

export interface IxcCorpactionsCaadminV1CustomerActionDiff {
    /* changes to the dates, type, payout assets */
    critical?: boolean;
    /* changes to non-critical data such as description */
    metadata?: boolean;
    /* adds rates which were previously missing */
    addRates?: boolean;
    /* changes to the payout rates or rounding rules previously provided */
    changeRates?: boolean;
    /* adds cost basis information which was previously missing */
    addCost?: boolean;
    /* changes to the cost basis information previously provided */
    changeCost?: boolean;
}

export interface IxcCorpactionsCaadminV1DtcPaymentHeader {
    // format: custom - pattern: ^[0-9]{9}$
    eventId?: string;
    // format: custom - pattern: ^[0-9A-Z]{9}$
    underlyingCusip?: string;
    // format: custom - pattern: ^[0-9]{10}$
    paymentId?: string;
}

export interface IxcCorpactionsCaadminV1DtcPaymentTransaction {
    // format: id62
    actionId: string;
    header: IxcCorpactionsV1Header;
    paymentAdviceId: string;
}

export interface IxcCorpactionsCaadminV1EventProcessingStatusPayload {
    corporateActionEventIdentification?: string;
    officialCorporateActionEventIdentification?: string;
    // format: YYYY-MM-DD
    expectedPaymentDate?: string;
    // format: date-time
    modifiedAt?: string;
}

export interface IxcCorpactionsCaadminV1HeaderOverride {
    // pattern: ^[0-9A-Z]{9}$
    cusip?: string;
    // format: YYYY-MM-DD
    recordDate?: string;
    // format: YYYY-MM-DD
    exDate?: string;
    // format: YYYY-MM-DD
    paymentDate?: string;
    /* default: derived from paymentDate */
    // format: date-time
    timeApplicable?: string;
    actionType?: IxcCorpactionsV1ActionType;
    actionTypeLabel?: string;
    actionTypeSubLabel?: string;
    description?: string;
    /* default: year of paymentDate */
    // pattern: [0-9]{4}
    taxYear?: string;
}

export interface IxcCorpactionsCaadminV1ManualOverride {
    /* If true, the action will be forced in to draft mode, even if there is
    sufficient data from other sources. Must remove this flag with a new
    manual update to trigger. */
    draft?: boolean;
    cancel?: IxcCorpactionsCaadminV1CancelOverride;
    header?: IxcCorpactionsCaadminV1HeaderOverride;
    cashDeltas?: IxcCorpactionsCaadminV1CashDeltaOverride[];
    securityDeltas?: IxcCorpactionsCaadminV1SecurityDeltaOverride[];
    /* deltas are matched on the asset. */
    deltaMerge: IxcCorpactionsCaadminV1MergeType;
}

export interface IxcCorpactionsCaadminV1ManualOverrideCommandServiceManualDefaultManualDefaultRequest {
    // format: id62
    actionId: string;
}

export enum IxcCorpactionsCaadminV1MergeType {
    Unspecified = 'UNSPECIFIED',
    Append = 'APPEND',
    Replace = 'REPLACE'
}

export interface IxcCorpactionsCaadminV1MovementConfirmationPayload {
    corporateActionEventIdentification?: string;
    officialCorporateActionEventIdentification?: string;
    previousMovementPreliminaryAdviceIdentification?: string;
    previousMovementConfirmationIdentification?: string;
    movementConfirmationIdentification?: string;
    amount?: IxcCorpactionsCaadminV1PaymentAmount;
    // format: YYYY-MM-DD
    expectedPaymentDate?: string;
    // format: date-time
    postedAt?: string;
}

export interface IxcCorpactionsCaadminV1MovementReversalPayload {
    corporateActionEventIdentification?: string;
    officialCorporateActionEventIdentification?: string;
    previousMovementPreliminaryAdviceIdentification?: string;
    previousMovementConfirmationIdentification?: string;
    movementConfirmationIdentification?: string;
    amount?: IxcCorpactionsCaadminV1PaymentAmount;
    // format: date-time
    postedAt?: string;
}

export interface IxcCorpactionsCaadminV1PaymentAdvicePayload {
    corporateActionEventIdentification?: string;
    officialCorporateActionEventIdentification?: string;
    previousMovementPreliminaryAdviceIdentification?: string;
    previousMovementConfirmationIdentification?: string;
    movementConfirmationIdentification?: string;
    amount?: IxcCorpactionsCaadminV1PaymentAmount;
    // format: YYYY-MM-DD
    expectedPaymentDate?: string;
}

export interface IxcCorpactionsCaadminV1PaymentAmount {
    // format: decimal
    value?: string;
    currency?: string;
}

export interface IxcCorpactionsCaadminV1PaymentCancelAdvicePayload {
    corporateActionEventIdentification?: string;
    officialCorporateActionEventIdentification?: string;
}

export interface IxcCorpactionsCaadminV1PaymentData {
    amount?: IxcCorpactionsCaadminV1PaymentAmount;
    // format: YYYY-MM-DD
    expectedPaymentDate?: string;
    dtc?: IxcCorpactionsCaadminV1PaymentDtc;
}

export interface IxcCorpactionsCaadminV1PaymentDtc {
    dtcHeader?: IxcCorpactionsCaadminV1DtcPaymentHeader;
    corporateActionEventIdentification?: string;
    officialCorporateActionEventIdentification?: string;
    previousMovementPreliminaryAdviceIdentification?: string;
    previousMovementConfirmationIdentification?: string;
    movementConfirmationIdentification?: string;
    // format: date-time
    lastProcessingStatusAt?: string;
}

export interface IxcCorpactionsCaadminV1PaymentEvent extends IxcCorpactionsCaadminV1PaymentKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcCorpactionsCaadminV1PaymentEventType;
}

export type IxcCorpactionsCaadminV1PaymentEventType = {
    '!type'?: 'paymentAdvice';
    paymentAdvice: IxcCorpactionsCaadminV1PaymentEventTypePaymentAdvice;
} | {
    '!type'?: 'movementConfirmation';
    movementConfirmation: IxcCorpactionsCaadminV1PaymentEventTypeMovementConfirmation;
} | {
    '!type'?: 'movementReversal';
    movementReversal: IxcCorpactionsCaadminV1PaymentEventTypeMovementReversal;
} | {
    '!type'?: 'paymentCancelAdvice';
    paymentCancelAdvice: IxcCorpactionsCaadminV1PaymentEventTypePaymentCancelAdvice;
} | {
    '!type'?: 'eventProcessingStatus';
    eventProcessingStatus: IxcCorpactionsCaadminV1PaymentEventTypeEventProcessingStatus;
};

export interface IxcCorpactionsCaadminV1PaymentEventTypeEventProcessingStatus {
    payload: IxcCorpactionsCaadminV1EventProcessingStatusPayload;
}

export interface IxcCorpactionsCaadminV1PaymentEventTypeMovementConfirmation {
    payload: IxcCorpactionsCaadminV1MovementConfirmationPayload;
}

export interface IxcCorpactionsCaadminV1PaymentEventTypeMovementReversal {
    payload: IxcCorpactionsCaadminV1MovementReversalPayload;
}

export interface IxcCorpactionsCaadminV1PaymentEventTypePaymentAdvice {
    payload: IxcCorpactionsCaadminV1PaymentAdvicePayload;
}

export interface IxcCorpactionsCaadminV1PaymentEventTypePaymentCancelAdvice {
    payload: IxcCorpactionsCaadminV1PaymentCancelAdvicePayload;
}

export const IXC_CORPACTIONS_CAADMIN_V1_PAYMENT_EVENT_TYPE_ONE_OF_VALUES = ['paymentAdvice', 'movementConfirmation', 'movementReversal', 'paymentCancelAdvice', 'eventProcessingStatus'] as const;

export type IxcCorpactionsCaadminV1PaymentEventTypeOneOfValue = (typeof IXC_CORPACTIONS_CAADMIN_V1_PAYMENT_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcCorpactionsCaadminV1PaymentKeys {
    // format: id62
    paymentId: string;
    // format: id62, entity: ixc.corpactions.caadmin.v1.Action
    actionId?: string;
    /* The asset being paid, not the corporate action underlying asset. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
}

export interface IxcCorpactionsCaadminV1PaymentQueryServicePaymentEventsPaymentEventsRequest {
    // format: id62
    paymentId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcCorpactionsCaadminV1PaymentQueryServicePaymentEventsSortableFields, IxcCorpactionsCaadminV1PaymentQueryServicePaymentEventsFilterableFields>;
}

export enum IxcCorpactionsCaadminV1PaymentQueryServicePaymentEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    PaymentId = 'paymentId',
    ActionId = 'actionId',
    AssetId = 'assetId',
    EventType = 'event.!type'
}

export enum IxcCorpactionsCaadminV1PaymentQueryServicePaymentEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcCorpactionsCaadminV1PaymentQueryServicePaymentGetPaymentGetRequest {
    // format: id62
    paymentId: string;
}

export interface IxcCorpactionsCaadminV1PaymentQueryServicePaymentListPaymentListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcCorpactionsCaadminV1PaymentQueryServicePaymentListSortableFields, IxcCorpactionsCaadminV1PaymentQueryServicePaymentListFilterableFields>;
}

export enum IxcCorpactionsCaadminV1PaymentQueryServicePaymentListFilterableFields {
    PaymentId = 'paymentId',
    ActionId = 'actionId',
    AssetId = 'assetId',
    DataExpectedPaymentDate = 'data.expectedPaymentDate',
    DataDtcDtcHeaderEventId = 'data.dtc.dtcHeader.eventId',
    DataDtcDtcHeaderUnderlyingCusip = 'data.dtc.dtcHeader.underlyingCusip',
    DataDtcDtcHeaderPaymentId = 'data.dtc.dtcHeader.paymentId',
    Status = 'status'
}

export enum IxcCorpactionsCaadminV1PaymentQueryServicePaymentListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcCorpactionsCaadminV1PaymentState extends IxcCorpactionsCaadminV1PaymentKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcCorpactionsCaadminV1PaymentData;
    status: IxcCorpactionsCaadminV1PaymentStatus;
}

export enum IxcCorpactionsCaadminV1PaymentStatus {
    Unspecified = 'UNSPECIFIED',
    Expected = 'EXPECTED',
    Confirmed = 'CONFIRMED',
    Reversed = 'REVERSED',
    Canceled = 'CANCELED'
}

export interface IxcCorpactionsCaadminV1SecurityDeltaOverride {
    /* Used as the merge key on APPEND */
    // format: id62
    assetId: string;
    // format: decimal
    rate?: string;
    costCalculation?: IxcCorpactionsV1CostCalculationType;
    rounding?: IxcCorpactionsV1RoundingRule;
    cashInLieu?: IxcCorpactionsCaadminV1CashInLieuOverride;
}

export interface IxcCorpactionsCaadminV1ValidationError {
    /* dot notated JSON field */
    field: string;
    message: string;
}

export interface IxcCorpactionsCaadminV1VersionCandidate {
    /* a hash of the content when valid and approve-able */
    // format: id62
    versionId?: string;
    /* will be nil if there is insufficient data */
    data?: IxcCorpactionsCaadminV1BuildingCustomerAction;
    conversionErrors?: IxcCorpactionsCaadminV1ConversionError[];
    validationErrors?: IxcCorpactionsCaadminV1ValidationError[];
    /* true if manualOverride.draft is set */
    draft?: boolean;
    /* true if the announcement has been canceled, approving this version marks the action as canceled, or reversed if it has already been triggered */
    canceled?: boolean;
    diffFromApproved?: IxcCorpactionsCaadminV1CustomerActionDiff;
}

export enum IxcCorpactionsCadataV1SourceBucket {
    Unspecified = 'UNSPECIFIED',
    Dtc = 'DTC',
    Ice = 'ICE'
}

export interface IxcCorpactionsCadataV1SourceInfo {
    /* Bucket is the S3 bucket name where the source file is stored. This is
    used to determine which parser to use for the file. */
    bucket: IxcCorpactionsCadataV1SourceBucket;
    /* Filename of the source feed file */
    // format: custom - pattern: ^[a-zA-Z0-9_\.-]+(\/[a-zA-Z0-9_\.-]+)*$
    filename: string;
    /* Must be unique within the file (pk=sourceFile,recordNumber), may be the
    line number or the index within the file */
    // format: INT32
    recordNumber?: number;
    /* Byte offset of the start of the data element in the source file. 0 is the
    first byte of the file, and start is inclusive. */
    // format: INT64
    startOffset?: string;
    /* Byte offset of the end of the data element in the source file. Inclusive
    of the desired offset, start=0 end=2 will return bytes 0,1,2 */
    // format: INT64
    endOffset?: string;
    /* Where the source file has a file-level timestamp rather than
    per-message, this is needed to reconstruct the record from the partial
    byte range. Where timestamps are included in the byte range, this should
    be null */
    // format: date-time
    fileTimestamp?: string;
}

export enum IxcCorpactionsV1ActionType {
    Unspecified = 'UNSPECIFIED',
    Dividend = 'DIVIDEND',
    StockDividend = 'STOCK_DIVIDEND',
    StockSplit = 'STOCK_SPLIT',
    ReverseStockSplit = 'REVERSE_STOCK_SPLIT',
    Spinoff = 'SPINOFF',
    Merger = 'MERGER'
}

export interface IxcCorpactionsV1CashInLieuAssignment {
    // format: id62
    assignmentId: string;
    detail?: IxcCorpactionsV1CashInLieuDetail;
    inLieuOf?: IxcCorpactionsV1DeltaRates;
    rounding?: IxcCorpactionsV1RoundingRule;
}

export interface IxcCorpactionsV1CashInLieuDetail {
    /* Per held security, the amount which this payout pays Paid = Held * Rate
    This is the net dividend rate on distribution types This the stock or
    cash rate for REORG types
    debit (-) outgoing; credit (+) incoming; */
    // format: decimal
    rate: string;
    /* copies directly to journal entry time_applicable - i.e. the time the
    brokerage account is credited */
    // format: date-time
    timeApplicable: string;
}

export interface IxcCorpactionsV1CorpactionTransaction {
    // format: id62
    actionId: string;
    header: IxcCorpactionsV1Header;
    assignment: IxcCorpactionsV1CustomerAssignment;
    // format: decimal
    balance: string;
    // format: id62
    accountId?: string;
    // format: id62
    snapshotGroup?: string;
    /* The security the action is announced on, which the account holds: a
    spinoff's parent, a merger's target. */
    // format: id62
    assetId?: string;
}

export type IxcCorpactionsV1CostCalculationType = {
    '!type'?: 'noCostTransfer';
    /* No cost transfer, the held position is kept and the new position is
    created with no cost basis */
    noCostTransfer: IxcCorpactionsV1CostCalculationTypeNoCostTransfer;
} | {
    '!type'?: 'quantityAdjustment';
    /* Adjustment of quantity with constant cost, e.g. a stock split */
    quantityAdjustment: IxcCorpactionsV1CostCalculationTypeQuantityAdjustment;
} | {
    '!type'?: 'costTransfer';
    /* Rate of the cost of the held position / held lot's quantity
    - Negative reduces cost of an existing position
    - Positive increases cost of existing or sets the cost of a new position
    Sum of all costTransfer rates across the action must equal 0 */
    costTransfer: IxcCorpactionsV1CostCalculationTypeCostTransfer;
} | {
    '!type'?: 'fixedRate';
    /* A fixed rate of cost per resulting share */
    fixedRate: IxcCorpactionsV1CostCalculationTypeFixedRate;
} | {
    '!type'?: 'cashToBoot';
    /* Marks the cash delta of a mixed stock-and-cash (boot) merger. Each
    received security's delta carries its per-share fair market value as a
    fixedRate cost. Per lot, the gain realized against the cash is the
    economic gain (received value + cash − basis) capped at the cash and
    floored at zero — losses are not recognized — and the unrecognized
    remainder adjusts the received securities' cost in proportion to their
    value. */
    cashToBoot: boolean;
};

export interface IxcCorpactionsV1CostCalculationTypeCostTransfer {
    // format: decimal
    rate: string;
}

export interface IxcCorpactionsV1CostCalculationTypeFixedRate {
    // format: decimal
    perShareCost: string;
}

export interface IxcCorpactionsV1CostCalculationTypeNoCostTransfer {
    noCostTransfer?: boolean;
}

export interface IxcCorpactionsV1CostCalculationTypeQuantityAdjustment {
    quantityAdjustment?: boolean;
}

export const IXC_CORPACTIONS_V1_COST_CALCULATION_TYPE_ONE_OF_VALUES = ['noCostTransfer', 'quantityAdjustment', 'costTransfer', 'fixedRate', 'cashToBoot'] as const;

export type IxcCorpactionsV1CostCalculationTypeOneOfValue = (typeof IXC_CORPACTIONS_V1_COST_CALCULATION_TYPE_ONE_OF_VALUES)[number];

export interface IxcCorpactionsV1CustomerAction {
    header?: IxcCorpactionsV1Header;
    /* A list of cash credit/debits to account balance, applied proportionally
    to the held position */
    cashDeltas?: IxcCorpactionsV1CustomerCashDelta[];
    /* A list of security credit/debits to account balance, applied
    proportionally to the held position */
    securityDeltas?: IxcCorpactionsV1CustomerActionSecurityDeltas[];
}

export interface IxcCorpactionsV1CustomerActionSecurityDeltas {
    // format: id62
    assetId: string;
    /* Per held security, the amount which this payout pays Paid = Held * Rate
    This is the net dividend rate on distribution types This the stock or
    cash rate for REORG types
    debit (-) outgoing; credit (+) incoming; */
    // format: decimal
    rate: string;
    /* For security payouts, This is the portion of the cost of the held
    position to bring forward to this new position, for cash payouts, this is
    the portion of the cost which is used as the cost basis used to calculate
    the realized gain or loss from the cash.
    When not set, the rate is unknown and cost basis calculation should be
    deferred. */
    costCalculation?: IxcCorpactionsV1CostCalculationType;
    /* The rules for how to round the payout amount when calculating the amount
    to credit or debit to the account. */
    rounding?: IxcCorpactionsV1RoundingRule;
    cashInLieu?: IxcCorpactionsV1CustomerActionSecurityDeltasCashInLieu;
}

export interface IxcCorpactionsV1CustomerActionSecurityDeltasCashInLieu {
    status?: IxcCorpactionsV1DeferredStatus;
    /* Per held security, the amount which this payout pays Paid = Held * Rate
    This is the net dividend rate on distribution types This the stock or
    cash rate for REORG types
    debit (-) outgoing; credit (+) incoming; */
    // format: decimal
    rate: string;
    /* copies directly to journal entry time_applicable - i.e. the time the
    brokerage account is credited */
    // format: date-time
    timeApplicable: string;
}

export type IxcCorpactionsV1CustomerAssignment = {
    '!type'?: 'main';
    main: IxcCorpactionsV1MainAssignment;
} | {
    '!type'?: 'cashInLieu';
    cashInLieu: IxcCorpactionsV1CashInLieuAssignment;
};

export const IXC_CORPACTIONS_V1_CUSTOMER_ASSIGNMENT_ONE_OF_VALUES = ['main', 'cashInLieu'] as const;

export type IxcCorpactionsV1CustomerAssignmentOneOfValue = (typeof IXC_CORPACTIONS_V1_CUSTOMER_ASSIGNMENT_ONE_OF_VALUES)[number];

export interface IxcCorpactionsV1CustomerCashDelta {
    /* Per held security, the amount which this payout pays Paid = Held * Rate
    This is the net dividend rate on distribution types This the stock or
    cash rate for REORG types
    debit (-) outgoing; credit (+) incoming; */
    // format: decimal
    rate: string;
    /* For security payouts, This is the portion of the cost of the held
    position to bring forward to this new position, for cash payouts, this is
    the portion of the cost which is used as the cost basis used to calculate
    the realized gain or loss from the cash.
    When not set, the rate is unknown and cost basis calculation should be
    deferred. */
    costCalculation?: IxcCorpactionsV1CostCalculationType;
}

export interface IxcCorpactionsV1CustomerSecurityDelta {
    // format: id62
    assetId: string;
    /* Per held security, the amount which this payout pays Paid = Held * Rate
    This is the net dividend rate on distribution types This the stock or
    cash rate for REORG types
    debit (-) outgoing; credit (+) incoming; */
    // format: decimal
    rate: string;
    /* For security payouts, This is the portion of the cost of the held
    position to bring forward to this new position, for cash payouts, this is
    the portion of the cost which is used as the cost basis used to calculate
    the realized gain or loss from the cash.
    When not set, the rate is unknown and cost basis calculation should be
    deferred. */
    costCalculation?: IxcCorpactionsV1CostCalculationType;
    /* The rules for how to round the payout amount when calculating the amount
    to credit or debit to the account. */
    rounding?: IxcCorpactionsV1RoundingRule;
}

export enum IxcCorpactionsV1DeferredStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Known = 'KNOWN',
    Paid = 'PAID'
}

export interface IxcCorpactionsV1DeltaRates {
    /* Per held security, the amount which this payout pays Paid = Held * Rate
    This is the net dividend rate on distribution types This the stock or
    cash rate for REORG types
    debit (-) outgoing; credit (+) incoming; */
    // format: decimal
    rate: string;
    /* For security payouts, This is the portion of the cost of the held
    position to bring forward to this new position, for cash payouts, this is
    the portion of the cost which is used as the cost basis used to calculate
    the realized gain or loss from the cash.
    When not set, the rate is unknown and cost basis calculation should be
    deferred. */
    costCalculation?: IxcCorpactionsV1CostCalculationType;
}

export interface IxcCorpactionsV1Header {
    /* The cusip which an account-holder must hold for this action to apply */
    // format: custom - pattern: ^[0-9A-Z]{9}$
    cusip: string;
    /* The issuer's official record date. Needed for compliance and reporting,
    not used for processing. */
    // format: YYYY-MM-DD
    recordDate: string;
    /* The cum/ex boundary, evaluated against a trade's trade date: a trade with
    a trade date is on or after exDate is 'ex' (excluded from the action);
    before exDate it is 'cum' (entitled). */
    // format: YYYY-MM-DD
    exDate: string;
    /* For reorgs only, at close on effective date the positions are modified,
    and will trade with the new quantities the next trading day. */
    // format: YYYY-MM-DD
    effectiveDate?: string;
    /* The date that the issuer pays DTC. Ratios based on the settled position
    at recordDate. */
    // format: YYYY-MM-DD
    paymentDate: string;
    /* The trade date prior to exDate, the closing trade balance for this date
    is used for calculating the entitled position for the action. Derived
    from effectiveDate for reorgs, otherwise the trading day prior to exDate
    for distributions. */
    // format: YYYY-MM-DD
    cumDate: string;
    /* copies directly to journal entry time_applicable - i.e. the time the
    brokerage account is credited
    By default derived from paymentDate */
    // format: date-time
    timeApplicable: string;
    /* The type of corporate action, this is used to determine how the action
    should be processed and what data is required. */
    actionType: IxcCorpactionsV1ActionType;
    /* Derived from the actionType */
    paymentType: IxcCorpactionsV1PaymentType;
    /* A string description of the type of action. The values provided in these
    strings are subject to change as new types are supported, code logic
    should not rely on specific values. */
    actionTypeLabel: string;
    /* A qualifier for some actionTypeLabel values. The values provided in these
    strings are subject to change as new types are supported, code logic
    should not rely on specific values. */
    actionTypeSubLabel?: string;
    /* A human readable short description of the corporate action, this should
    be passed through to the user as-is */
    description: string;
    /* Tax year for all payments in this action. */
    // pattern: [0-9]{4}
    taxYear: string;
}

export interface IxcCorpactionsV1MainAssignment {
    /* A list of cash credit/debits to account balance, applied proportionally
    to the held position */
    cashDeltas?: IxcCorpactionsV1CustomerCashDelta[];
    /* A list of security credit/debits to account balance, applied
    proportionally to the held position */
    securityDeltas?: IxcCorpactionsV1CustomerSecurityDelta[];
}

export enum IxcCorpactionsV1PaymentType {
    Unspecified = 'UNSPECIFIED',
    Dividend = 'DIVIDEND',
    Reorg = 'REORG'
}

export const IXC_CORPACTIONS_V1_PAYMENT_TYPE_INFO_EXTENSION_WASH_CODE_MAP = {
    [IxcCorpactionsV1PaymentType.Dividend]: 'wash:ca:dividend',
    [IxcCorpactionsV1PaymentType.Reorg]: 'wash:ca:reorg'
} as const;

export enum IxcCorpactionsV1RoundingMethod {
    Unspecified = 'UNSPECIFIED',
    HalfUp = 'HALF_UP',
    AlwaysUp = 'ALWAYS_UP',
    AlwaysDown = 'ALWAYS_DOWN'
}

export interface IxcCorpactionsV1RoundingRule {
    /* Determines the method used to round fractional remainders */
    method: IxcCorpactionsV1RoundingMethod;
    /* The number of decimal places to round to. */
    // format: INT32
    places?: number;
}

export interface IxcCostbasisV1AdjustmentTransaction {
    // format: decimal
    quantityDelta: string;
    // format: decimal
    costDelta: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settleDate: string;
    transactionType: IxcCostbasisV1AdjustmentTransactionTransactionType;
}

export type IxcCostbasisV1AdjustmentTransactionTransactionType = {
    '!type'?: 'portfolioTransaction';
    portfolioTransaction: IxcCostbasisV1AdjustmentTransactionTransactionTypePortfolioTransaction;
};

export interface IxcCostbasisV1AdjustmentTransactionTransactionTypePortfolioTransaction {
    // format: id62, entity: ixc.portfolio.v1.Transaction
    transactionId: string;
}

export const IXC_COSTBASIS_V1_ADJUSTMENT_TRANSACTION_TRANSACTION_TYPE_ONE_OF_VALUES = ['portfolioTransaction'] as const;

export type IxcCostbasisV1AdjustmentTransactionTransactionTypeOneOfValue = (typeof IXC_COSTBASIS_V1_ADJUSTMENT_TRANSACTION_TRANSACTION_TYPE_ONE_OF_VALUES)[number];

export interface IxcCostbasisV1ClosingTransaction {
    /* The total quantity of the asset sold in the transaction */
    // format: decimal
    totalQuantity: string;
    /* The quantity of the transaction which applies to this event */
    // format: decimal
    applicableQuantity: string;
    /* The proceeds from the sale / close */
    // format: decimal
    totalProceeds: string;
    /* The proceeds from the sale / close which apply to this event */
    // format: decimal
    applicableProceeds: string;
    // format: date-time
    tradeTimestamp: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settleDate: string;
    transactionType: IxcCostbasisV1ClosingTransactionTransactionType;
}

export type IxcCostbasisV1ClosingTransactionTransactionType = {
    '!type'?: 'portfolioTransaction';
    portfolioTransaction: IxcCostbasisV1ClosingTransactionTransactionTypePortfolioTransaction;
};

export interface IxcCostbasisV1ClosingTransactionTransactionTypePortfolioTransaction {
    // format: id62, entity: ixc.portfolio.v1.Transaction
    transactionId: string;
}

export const IXC_COSTBASIS_V1_CLOSING_TRANSACTION_TRANSACTION_TYPE_ONE_OF_VALUES = ['portfolioTransaction'] as const;

export type IxcCostbasisV1ClosingTransactionTransactionTypeOneOfValue = (typeof IXC_COSTBASIS_V1_CLOSING_TRANSACTION_TRANSACTION_TYPE_ONE_OF_VALUES)[number];

export interface IxcCostbasisV1OpeningTransaction {
    /* The quantity of the asset in the tax lot */
    // format: decimal
    quantity: string;
    /* The cost of the buy / open, becoming the cost basis of the tax lot */
    // format: decimal
    cost: string;
    // format: date-time
    tradeTimestamp: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settleDate: string;
    transactionType: IxcCostbasisV1OpeningTransactionTransactionType;
}

export type IxcCostbasisV1OpeningTransactionTransactionType = {
    '!type'?: 'portfolioTransaction';
    portfolioTransaction: IxcCostbasisV1OpeningTransactionTransactionTypePortfolioTransaction;
} | {
    '!type'?: 'lotSplit';
    lotSplit: IxcCostbasisV1OpeningTransactionTransactionTypeLotSplit;
} | {
    '!type'?: 'reorganization';
    /* The lot was created by a basis-carryover reorganization (e.g. an
    all-stock merger), exchanging the source lot for shares of a new
    security. Basis carries over and the holding period tacks. */
    reorganization: IxcCostbasisV1OpeningTransactionTransactionTypeReorganization;
};

export interface IxcCostbasisV1OpeningTransactionTransactionTypeLotSplit {
    // format: id62, entity: ixc.costbasis.v1.TaxLot
    fromTaxLot: string;
}

export interface IxcCostbasisV1OpeningTransactionTransactionTypePortfolioTransaction {
    // format: id62, entity: ixc.portfolio.v1.Transaction
    transactionId: string;
}

export interface IxcCostbasisV1OpeningTransactionTransactionTypeReorganization {
    // format: id62, entity: ixc.costbasis.v1.TaxLot
    fromTaxLot: string;
    // format: id62
    fromAssetId: string;
}

export const IXC_COSTBASIS_V1_OPENING_TRANSACTION_TRANSACTION_TYPE_ONE_OF_VALUES = ['portfolioTransaction', 'lotSplit', 'reorganization'] as const;

export type IxcCostbasisV1OpeningTransactionTransactionTypeOneOfValue = (typeof IXC_COSTBASIS_V1_OPENING_TRANSACTION_TRANSACTION_TYPE_ONE_OF_VALUES)[number];

export interface IxcCostbasisV1RealizationData {
    closingTransaction: IxcCostbasisV1ClosingTransaction;
    /* The cost of the tax lot */
    // format: decimal
    adjustedCost: string;
    /* The realized gain or loss from the sale, Gain is positive. This is not
    adjusted for wash sales. */
    // format: decimal
    realized: string;
    /* The quantity of the realization which has been included in wash sales /
    deferred losses */
    // format: decimal
    washedQuantity: string;
    /* The date on which the holding period began for the tax lot being sold. */
    // format: YYYY-MM-DD
    holdingPeriodStartDate?: string;
}

export interface IxcCostbasisV1RealizationEvent extends IxcCostbasisV1RealizationKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcCostbasisV1RealizationEventType;
}

export type IxcCostbasisV1RealizationEventType = {
    '!type'?: 'created';
    created: IxcCostbasisV1RealizationEventTypeCreated;
} | {
    '!type'?: 'deferLoss';
    deferLoss: IxcCostbasisV1RealizationEventTypeDeferLoss;
};

export interface IxcCostbasisV1RealizationEventTypeCreated {
    closingTransaction: IxcCostbasisV1ClosingTransaction;
    /* The cost of the tax lot */
    // format: decimal
    calculatedCost: string;
    /* The date on which the holding period began for the tax lot being
    sold. */
    // format: YYYY-MM-DD
    holdingPeriodStartDate?: string;
}

export interface IxcCostbasisV1RealizationEventTypeDeferLoss {
    /* The quantity to defer */
    // format: decimal
    quantity: string;
    /* The loss deferred to the tax lot, positive number representing a loss */
    // format: decimal
    deferredLoss: string;
    // format: id62, entity: ixc.costbasis.v1.TaxLot
    deferredTo: string;
    /* The start date of the holding period for the tax lot. This will be
    passed along so that the deferredTo lot can use this start date for
    its holding period. */
    // format: YYYY-MM-DD
    holdingPeriodStartDate: string;
}

export const IXC_COSTBASIS_V1_REALIZATION_EVENT_TYPE_ONE_OF_VALUES = ['created', 'deferLoss'] as const;

export type IxcCostbasisV1RealizationEventTypeOneOfValue = (typeof IXC_COSTBASIS_V1_REALIZATION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcCostbasisV1RealizationKeys {
    // format: id62
    realizationId: string;
    /* Identifies the brokerage account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    /* The unique identifier of the program */
    // format: id62
    programId?: string;
    // format: id62
    assetId?: string;
    /* The unique identifier of the tax lot which was sold */
    // format: id62, entity: ixc.costbasis.v1.TaxLot
    taxLotId: string;
    /* The unique identifier of the transaction which created this realization */
    // format: id62, entity: ixc.portfolio.v1.Transaction
    transactionId?: string;
}

export interface IxcCostbasisV1RealizationQueryServiceRealizationEventsRealizationEventsRequest {
    // format: id62
    realizationId: string;
    /* Identifies the brokerage account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcCostbasisV1RealizationQueryServiceRealizationEventsSortableFields, IxcCostbasisV1RealizationQueryServiceRealizationEventsFilterableFields>;
}

export enum IxcCostbasisV1RealizationQueryServiceRealizationEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    RealizationId = 'realizationId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    AssetId = 'assetId',
    TaxLotId = 'taxLotId',
    TransactionId = 'transactionId',
    EventType = 'event.!type'
}

export enum IxcCostbasisV1RealizationQueryServiceRealizationEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcCostbasisV1RealizationQueryServiceRealizationGetRealizationGetRequest {
    // format: id62
    realizationId: string;
    /* Identifies the brokerage account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
}

export interface IxcCostbasisV1RealizationQueryServiceRealizationListRealizationListRequest {
    /* Identifies the brokerage account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcCostbasisV1RealizationQueryServiceRealizationListSortableFields, IxcCostbasisV1RealizationQueryServiceRealizationListFilterableFields>;
}

export enum IxcCostbasisV1RealizationQueryServiceRealizationListFilterableFields {
    RealizationId = 'realizationId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    AssetId = 'assetId',
    TaxLotId = 'taxLotId',
    TransactionId = 'transactionId',
    Status = 'status'
}

export enum IxcCostbasisV1RealizationQueryServiceRealizationListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcCostbasisV1RealizationState extends IxcCostbasisV1RealizationKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcCostbasisV1RealizationData;
    status: IxcCostbasisV1RealizationStatus;
}

export enum IxcCostbasisV1RealizationStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE'
}

export interface IxcCostbasisV1TaxLotData {
    /* The total quantity of the lot, adjusted for corporate actions, not
    including any closing transactions. */
    // format: decimal
    totalAdjustedQuantity: string;
    /* The total cost basis of the lot, adjusted for any corporate actions, for
    the entire totalQuantity, i.e., not reduced by closing transactions. */
    // format: decimal
    totalAdjustedCost: string;
    /* The remaining quantity held in the lot */
    // format: decimal
    openQuantity: string;
    /* The transaction which opened the tax lot */
    openingTransaction: IxcCostbasisV1OpeningTransaction;
    /* The date on which the holding period for this tax lot began. If this is
    not defined, it is equal to the trade date of the opening transaction.
    This will be set when deferring losses from wash sales. */
    // format: YYYY-MM-DD
    holdingPeriodStartDate?: string;
}

export interface IxcCostbasisV1TaxLotEvent extends IxcCostbasisV1TaxLotKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcCostbasisV1TaxLotEventType;
}

export type IxcCostbasisV1TaxLotEventType = {
    '!type'?: 'opened';
    opened: IxcCostbasisV1TaxLotEventTypeOpened;
} | {
    '!type'?: 'adjusted';
    adjusted: IxcCostbasisV1TaxLotEventTypeAdjusted;
} | {
    '!type'?: 'deferLoss';
    deferLoss: IxcCostbasisV1TaxLotEventTypeDeferLoss;
} | {
    '!type'?: 'closed';
    closed: IxcCostbasisV1TaxLotEventTypeClosed;
} | {
    '!type'?: 'split';
    split: IxcCostbasisV1TaxLotEventTypeSplit;
} | {
    '!type'?: 'exchanged';
    exchanged: IxcCostbasisV1TaxLotEventTypeExchanged;
};

export interface IxcCostbasisV1TaxLotEventTypeAdjusted {
    transaction: IxcCostbasisV1AdjustmentTransaction;
}

export interface IxcCostbasisV1TaxLotEventTypeClosed {
    transaction: IxcCostbasisV1ClosingTransaction;
    /* The realization created by the close */
    // format: id62
    realizationId: string;
    /* The washable open tax lot that this closing transaction has been
    matched against for wash sale purposes. Depending on lot sizes, we
    might have multiple closed events for the same tax lot and closing
    transaction. */
    washableOpen?: IxcCostbasisV1TaxLotEventTypeClosedWashableOpen;
    /* If there are still shares left to sell in the initiating transaction
    after the ClosingTransaction in this event is processed, this object
    provides the details of what remains to be closed out and from which
    specified tax lots. */
    remaining?: IxcCostbasisV1TaxLotEventTypeClosedRemaining;
}

export interface IxcCostbasisV1TaxLotEventTypeClosedRemaining {
    // format: decimal
    quantity: string;
    // format: id62
    accountId: string;
    // format: id62
    programId: string;
    // format: id62
    transactionId: string;
    // format: id62
    assetId: string;
    specifiedTaxLot?: IxcPortfolioV1TaxLotAllocation[];
    /* The method used to select tax lots, carried through
    continuations. */
    taxLotMethod?: IxcPortfolioV1TaxLotMethod;
}

export interface IxcCostbasisV1TaxLotEventTypeClosedWashableOpen {
    // format: id62
    taxLotId: string;
    // format: decimal
    useQuantity: string;
    /* Amount remaining in the washable open */
    // format: decimal
    remainingQuantity: string;
}

export interface IxcCostbasisV1TaxLotEventTypeDeferLoss {
    /* The quantity to defer. This may result in splitting the tax lot if
    the entire lot is not deferred. */
    // format: decimal
    quantity: string;
    /* The loss deferred from the realization, positive number representing
    a loss */
    // format: decimal
    deferredLoss: string;
    // format: id62, entity: ixc.costbasis.v1.Realization
    deferredFrom: string;
    /* The date on which the holding period for this tax lot begins due to
    the loss deferral. */
    // format: YYYY-MM-DD
    holdingPeriodStartDate: string;
}

export interface IxcCostbasisV1TaxLotEventTypeExchanged {
    /* The new tax lot opened in the acquirer security. */
    // format: id62
    newLotId: string;
    /* The acquirer security the shares are exchanged into. */
    // format: id62
    newAssetId: string;
    /* The opening transaction for the new lot: carried-over basis, the
    exchanged quantity, and the source lot's trade date so the holding
    period tacks. */
    openingTransaction: IxcCostbasisV1OpeningTransaction;
}

export interface IxcCostbasisV1TaxLotEventTypeOpened {
    transaction: IxcCostbasisV1OpeningTransaction;
}

export interface IxcCostbasisV1TaxLotEventTypeSplit {
    /* The quantity moving to the new lot. */
    // format: decimal
    quantity: string;
    /* The new tax lot created by the split */
    // format: id62
    newLotId: string;
    /* The basis moving to the new lot; this lot's total adjusted cost is
    reduced by exactly this amount. */
    // format: decimal
    cost: string;
}

export const IXC_COSTBASIS_V1_TAX_LOT_EVENT_TYPE_ONE_OF_VALUES = ['opened', 'adjusted', 'deferLoss', 'closed', 'split', 'exchanged'] as const;

export type IxcCostbasisV1TaxLotEventTypeOneOfValue = (typeof IXC_COSTBASIS_V1_TAX_LOT_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcCostbasisV1TaxLotKeys {
    // format: id62
    taxLotId: string;
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    // format: id62
    programId?: string;
    // format: id62
    assetId?: string;
}

export interface IxcCostbasisV1TaxLotQueryServiceTaxLotEventsTaxLotEventsRequest {
    // format: id62
    taxLotId: string;
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcCostbasisV1TaxLotQueryServiceTaxLotEventsSortableFields, IxcCostbasisV1TaxLotQueryServiceTaxLotEventsFilterableFields>;
}

export enum IxcCostbasisV1TaxLotQueryServiceTaxLotEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    TaxLotId = 'taxLotId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    AssetId = 'assetId',
    EventType = 'event.!type'
}

export enum IxcCostbasisV1TaxLotQueryServiceTaxLotEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcCostbasisV1TaxLotQueryServiceTaxLotGetTaxLotGetRequest {
    // format: id62
    taxLotId: string;
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
}

export interface IxcCostbasisV1TaxLotQueryServiceTaxLotListTaxLotListRequest {
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcCostbasisV1TaxLotQueryServiceTaxLotListSortableFields, IxcCostbasisV1TaxLotQueryServiceTaxLotListFilterableFields>;
}

export enum IxcCostbasisV1TaxLotQueryServiceTaxLotListFilterableFields {
    TaxLotId = 'taxLotId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    AssetId = 'assetId',
    Status = 'status'
}

export enum IxcCostbasisV1TaxLotQueryServiceTaxLotListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcCostbasisV1TaxLotState extends IxcCostbasisV1TaxLotKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcCostbasisV1TaxLotData;
    status: IxcCostbasisV1TaxLotStatus;
}

export enum IxcCostbasisV1TaxLotStatus {
    Unspecified = 'UNSPECIFIED',
    Open = 'OPEN',
    Closed = 'CLOSED'
}

export interface IxcDtccCnsV1AssetDayData {
    /* Previous Settlement date */
    // format: YYYY-MM-DD
    previous?: string;
    /* Next Settlement date */
    // format: YYYY-MM-DD
    next: string;
    security?: IxcAssetsV1Security;
    opening?: IxcDtccCnsV1OpeningAssetData;
    reconciledTotals?: IxcDtccCnsV1ReconciledTotals;
    cnsMessage?: IxcDtccCnsV1SecurityRecordData;
    tradeTotals?: IxcTradeV1TradeTotalsData;
    caPayments?: IxcDtccCnsV1CaPaymentData[];
}

export interface IxcDtccCnsV1AssetDayEvent extends IxcDtccCnsV1AssetDayKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcDtccCnsV1AssetDayEventType;
}

export type IxcDtccCnsV1AssetDayEventType = {
    '!type'?: 'open';
    open: IxcDtccCnsV1AssetDayEventTypeOpen;
} | {
    '!type'?: 'openingFigures';
    openingFigures: IxcDtccCnsV1AssetDayEventTypeOpeningFigures;
} | {
    '!type'?: 'tradeTotals';
    tradeTotals: IxcDtccCnsV1AssetDayEventTypeTradeTotals;
} | {
    '!type'?: 'cnsCorporateActionPayment';
    cnsCorporateActionPayment: IxcDtccCnsV1AssetDayEventTypeCnsCorporateActionPayment;
} | {
    '!type'?: 'cnsMessage';
    cnsMessage: IxcDtccCnsV1AssetDayEventTypeCnsMessage;
} | {
    '!type'?: 'noActivityClose';
    noActivityClose: EmptyObject;
} | {
    '!type'?: 'reconcile';
    reconcile: EmptyObject;
} | {
    '!type'?: 'reconciled';
    reconciled: IxcDtccCnsV1AssetDayEventTypeReconciled;
} | {
    '!type'?: 'break';
    break: EmptyObject;
};

export interface IxcDtccCnsV1AssetDayEventTypeCnsCorporateActionPayment {
    data?: IxcDtccCnsV1CaPaymentData[];
}

export interface IxcDtccCnsV1AssetDayEventTypeCnsMessage {
    data?: IxcDtccCnsV1SecurityRecordData;
}

export interface IxcDtccCnsV1AssetDayEventTypeOpen {
    // format: YYYY-MM-DD
    previous?: string;
    // format: YYYY-MM-DD
    nextOpen: string;
    security: IxcAssetsV1Security;
}

export interface IxcDtccCnsV1AssetDayEventTypeOpeningFigures {
    opening: IxcDtccCnsV1OpeningAssetData;
}

export interface IxcDtccCnsV1AssetDayEventTypeReconciled {
    reconciledTotals: IxcDtccCnsV1ReconciledTotals;
    // format: id62, entity: ixc.decl.v1.Transaction
    transactionId?: string;
}

export interface IxcDtccCnsV1AssetDayEventTypeTradeTotals {
    data?: IxcTradeV1TradeTotalsData;
}

export const IXC_DTCC_CNS_V1_ASSET_DAY_EVENT_TYPE_ONE_OF_VALUES = ['open', 'openingFigures', 'tradeTotals', 'cnsCorporateActionPayment', 'cnsMessage', 'noActivityClose', 'reconcile', 'reconciled', 'break'] as const;

export type IxcDtccCnsV1AssetDayEventTypeOneOfValue = (typeof IXC_DTCC_CNS_V1_ASSET_DAY_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcDtccCnsV1AssetDayKeys {
    // format: id62
    assetId: string;
    /* the Settlement date for this day */
    // format: YYYY-MM-DD
    date: string;
}

export interface IxcDtccCnsV1AssetDayQueryServiceAssetDayEventsAssetDayEventsRequest {
    // format: id62
    assetId: string;
    /* the Settlement date for this day */
    // format: YYYY-MM-DD
    date: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcDtccCnsV1AssetDayQueryServiceAssetDayEventsSearchableFields, IxcDtccCnsV1AssetDayQueryServiceAssetDayEventsSortableFields, IxcDtccCnsV1AssetDayQueryServiceAssetDayEventsFilterableFields>;
}

export enum IxcDtccCnsV1AssetDayQueryServiceAssetDayEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AssetId = 'assetId',
    Date = 'date',
    EventOpenSecurityCusip = 'event.open.security.cusip',
    EventOpeningFiguresOpeningOpeningFailQuantity = 'event.openingFigures.opening.openingFail.quantity',
    EventOpeningFiguresOpeningOpeningFailDaysOpen = 'event.openingFigures.opening.openingFail.daysOpen',
    EventReconciledReconciledTotalsOpeningFailQuantity = 'event.reconciled.reconciledTotals.openingFail.quantity',
    EventReconciledReconciledTotalsOpeningFailDaysOpen = 'event.reconciled.reconciledTotals.openingFail.daysOpen',
    EventReconciledReconciledTotalsClosingFailQuantity = 'event.reconciled.reconciledTotals.closingFail.quantity',
    EventReconciledReconciledTotalsClosingFailDaysOpen = 'event.reconciled.reconciledTotals.closingFail.daysOpen',
    EventType = 'event.!type'
}

export enum IxcDtccCnsV1AssetDayQueryServiceAssetDayEventsSearchableFields {
    EventOpenSecuritySymbolBase = 'event.open.security.symbol.base',
    EventOpenSecurityName = 'event.open.security.name'
}

export enum IxcDtccCnsV1AssetDayQueryServiceAssetDayEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    Date = 'date',
    EventOpeningFiguresOpeningOpeningFailQuantity = 'event.openingFigures.opening.openingFail.quantity',
    EventOpeningFiguresOpeningOpeningFailDaysOpen = 'event.openingFigures.opening.openingFail.daysOpen',
    EventReconciledReconciledTotalsOpeningFailQuantity = 'event.reconciled.reconciledTotals.openingFail.quantity',
    EventReconciledReconciledTotalsOpeningFailDaysOpen = 'event.reconciled.reconciledTotals.openingFail.daysOpen',
    EventReconciledReconciledTotalsClosingFailQuantity = 'event.reconciled.reconciledTotals.closingFail.quantity',
    EventReconciledReconciledTotalsClosingFailDaysOpen = 'event.reconciled.reconciledTotals.closingFail.daysOpen'
}

export interface IxcDtccCnsV1AssetDayQueryServiceAssetDayGetAssetDayGetRequest {
    // format: id62
    assetId: string;
    /* the Settlement date for this day */
    // format: YYYY-MM-DD
    date: string;
}

export interface IxcDtccCnsV1AssetDayQueryServiceAssetDayListAssetDayListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcDtccCnsV1AssetDayQueryServiceAssetDayListSearchableFields, IxcDtccCnsV1AssetDayQueryServiceAssetDayListSortableFields, IxcDtccCnsV1AssetDayQueryServiceAssetDayListFilterableFields>;
}

export enum IxcDtccCnsV1AssetDayQueryServiceAssetDayListFilterableFields {
    AssetId = 'assetId',
    Date = 'date',
    DataSecurityCusip = 'data.security.cusip',
    DataOpeningOpeningFailQuantity = 'data.opening.openingFail.quantity',
    DataOpeningOpeningFailDaysOpen = 'data.opening.openingFail.daysOpen',
    DataReconciledTotalsOpeningFailQuantity = 'data.reconciledTotals.openingFail.quantity',
    DataReconciledTotalsOpeningFailDaysOpen = 'data.reconciledTotals.openingFail.daysOpen',
    DataReconciledTotalsClosingFailQuantity = 'data.reconciledTotals.closingFail.quantity',
    DataReconciledTotalsClosingFailDaysOpen = 'data.reconciledTotals.closingFail.daysOpen',
    Status = 'status'
}

export enum IxcDtccCnsV1AssetDayQueryServiceAssetDayListSearchableFields {
    DataSecuritySymbolBase = 'data.security.symbol.base',
    DataSecurityName = 'data.security.name'
}

export enum IxcDtccCnsV1AssetDayQueryServiceAssetDayListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    Date = 'date',
    DataOpeningOpeningFailQuantity = 'data.opening.openingFail.quantity',
    DataOpeningOpeningFailDaysOpen = 'data.opening.openingFail.daysOpen',
    DataReconciledTotalsOpeningFailQuantity = 'data.reconciledTotals.openingFail.quantity',
    DataReconciledTotalsOpeningFailDaysOpen = 'data.reconciledTotals.openingFail.daysOpen',
    DataReconciledTotalsClosingFailQuantity = 'data.reconciledTotals.closingFail.quantity',
    DataReconciledTotalsClosingFailDaysOpen = 'data.reconciledTotals.closingFail.daysOpen'
}

export interface IxcDtccCnsV1AssetDayState extends IxcDtccCnsV1AssetDayKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcDtccCnsV1AssetDayData;
    status: IxcDtccCnsV1AssetDayStatus;
}

export enum IxcDtccCnsV1AssetDayStatus {
    Unspecified = 'UNSPECIFIED',
    Blocked = 'BLOCKED',
    Current = 'CURRENT',
    Reconciled = 'RECONCILED',
    Break = 'BREAK'
}

export interface IxcDtccCnsV1CaPaymentData {
    // format: decimal
    quantityReceived?: string;
    // format: decimal
    quantityDelivered?: string;
    // format: decimal
    creditAmount?: string;
    // format: decimal
    debitAmount?: string;
}

export interface IxcDtccCnsV1Fail {
    // format: decimal
    quantity?: string;
    /* Set by CNS, the closing price of the failing quantity */
    // format: decimal
    marketValue?: string;
    /* The average trade price multiplied by the failing quantity, this effects
    the trade:cns account directly */
    // format: decimal
    tradeValue?: string;
    /* The number of days this fail has been open, incremented at each
    settlement (not calendar) day end. Resets when the fail flips from
    receive to deliver or vice versa. Starts at 0 when the fail is created. */
    // format: UINT32
    daysOpen?: number;
}

export interface IxcDtccCnsV1OpeningAssetData {
    openingFail?: IxcDtccCnsV1Fail;
}

export interface IxcDtccCnsV1QvPair {
    // format: decimal
    quantity?: string;
    // format: decimal
    value?: string;
}

export interface IxcDtccCnsV1ReconciledTotals {
    openingFail?: IxcDtccCnsV1Fail;
    netTrade?: IxcDtccCnsV1QvPair;
    settlingTrade?: IxcDtccCnsV1QvPair;
    // format: decimal
    stockDividendsAndMiscQuantity?: string;
    // format: decimal
    netSettlingQuantity?: string;
    closingFail?: IxcDtccCnsV1Fail;
}

export interface IxcDtccCnsV1SecurityRecordData {
    // format: decimal
    netSettlingTrades: string;
    // format: decimal
    netDepositorySettlements: string;
    // format: decimal
    stockDividendsAndMisc: string;
    /* Open fail position */
    // format: decimal
    netClosingPosition: string;
    // format: decimal
    price: string;
    /* Value of the open fail position */
    // format: decimal
    marketValue?: string;
}

export interface IxcDtccCnsV1SettlementTransaction {
    // format: YYYY-MM-DD
    settlementDate: string;
    // format: id62
    assetId: string;
    security: IxcAssetsV1Security;
    openingFail?: IxcDtccCnsV1Fail;
    netTrade?: IxcDtccCnsV1QvPair;
    settlingTrade?: IxcDtccCnsV1QvPair;
    // format: decimal
    stockDividendsAndMiscQuantity?: string;
    // format: decimal
    netSettlingQuantity?: string;
    closingFail?: IxcDtccCnsV1Fail;
}

export interface IxcDtccDrecoV1AssetData {
    security?: IxcAssetsV1Security;
    /* the date we began tracking this asset, opening with zero balance at both
    DTC and CNS */
    // format: YYYY-MM-DD
    zeroDate: string;
    /* the last opened settlement date for this asset */
    // format: YYYY-MM-DD
    currentSettlementDate?: string;
}

export interface IxcDtccDrecoV1AssetEvent extends IxcAssetsV1AssetKeys {
    metadata: J5StateV1EventMetadata;
    // format: custom - pattern: [0-9A-Z]{9}
    cusip?: string;
    event: IxcDtccDrecoV1AssetEventType;
}

export type IxcDtccDrecoV1AssetEventType = {
    '!type'?: 'assetInfo';
    assetInfo: IxcDtccDrecoV1AssetEventTypeAssetInfo;
} | {
    '!type'?: 'openDay';
    openDay: IxcDtccDrecoV1AssetEventTypeOpenDay;
} | {
    '!type'?: 'dayOpened';
    dayOpened: IxcDtccDrecoV1AssetEventTypeDayOpened;
};

export interface IxcDtccDrecoV1AssetEventTypeAssetInfo {
    security: IxcAssetsV1Security;
    /* Date to add as the first trading date for the new asset on create */
    // format: YYYY-MM-DD
    zeroDate: string;
}

export interface IxcDtccDrecoV1AssetEventTypeDayOpened {
    // format: YYYY-MM-DD
    previousSettlementDate?: string;
    // format: YYYY-MM-DD
    settlementDate: string;
    // format: YYYY-MM-DD
    nextSettlementDate: string;
}

export interface IxcDtccDrecoV1AssetEventTypeOpenDay {
    // format: YYYY-MM-DD
    settlementDate: string;
}

export const IXC_DTCC_DRECO_V1_ASSET_EVENT_TYPE_ONE_OF_VALUES = ['assetInfo', 'openDay', 'dayOpened'] as const;

export type IxcDtccDrecoV1AssetEventTypeOneOfValue = (typeof IXC_DTCC_DRECO_V1_ASSET_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcDtccDrecoV1AssetKeys {
    // format: id62
    assetId: string;
    // format: custom - pattern: [0-9A-Z]{9}
    cusip?: string;
}

export interface IxcDtccDrecoV1AssetQueryServiceAssetEventsAssetEventsRequest {
    // format: id62
    assetId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcDtccDrecoV1AssetQueryServiceAssetEventsSearchableFields, IxcDtccDrecoV1AssetQueryServiceAssetEventsSortableFields, IxcDtccDrecoV1AssetQueryServiceAssetEventsFilterableFields>;
}

export enum IxcDtccDrecoV1AssetQueryServiceAssetEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AssetId = 'assetId',
    Cusip = 'cusip',
    EventAssetInfoSecurityCusip = 'event.assetInfo.security.cusip',
    EventType = 'event.!type'
}

export enum IxcDtccDrecoV1AssetQueryServiceAssetEventsSearchableFields {
    EventAssetInfoSecuritySymbolBase = 'event.assetInfo.security.symbol.base',
    EventAssetInfoSecurityName = 'event.assetInfo.security.name'
}

export enum IxcDtccDrecoV1AssetQueryServiceAssetEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcDtccDrecoV1AssetQueryServiceAssetGetAssetGetRequest {
    // format: id62
    assetId: string;
}

export interface IxcDtccDrecoV1AssetQueryServiceAssetListAssetListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcDtccDrecoV1AssetQueryServiceAssetListSearchableFields, IxcDtccDrecoV1AssetQueryServiceAssetListSortableFields, IxcDtccDrecoV1AssetQueryServiceAssetListFilterableFields>;
}

export enum IxcDtccDrecoV1AssetQueryServiceAssetListFilterableFields {
    AssetId = 'assetId',
    Cusip = 'cusip',
    DataSecurityCusip = 'data.security.cusip',
    Status = 'status'
}

export enum IxcDtccDrecoV1AssetQueryServiceAssetListSearchableFields {
    DataSecuritySymbolBase = 'data.security.symbol.base',
    DataSecurityName = 'data.security.name'
}

export enum IxcDtccDrecoV1AssetQueryServiceAssetListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcDtccDrecoV1AssetState extends IxcDtccDrecoV1AssetKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcDtccDrecoV1AssetData;
    status: IxcDtccDrecoV1AssetStatus;
}

export enum IxcDtccDrecoV1AssetStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE'
}

export interface IxcDtccDtcV1ApiBalData {
    // format: YYYY-MM-DD
    date: string;
    // format: decimal
    balance: string;
    /* Set when an asset is not reported in the APIBAL file, implicitly 0. */
    implicit?: boolean;
}

export interface IxcDtccDtcV1AssetDayData {
    /* Previous Settlement date */
    // format: YYYY-MM-DD
    previous?: string;
    /* Next Settlement date */
    // format: YYYY-MM-DD
    next: string;
    security?: IxcAssetsV1Security;
    opening?: IxcDtccDtcV1OpeningAssetData;
    cnsInput?: IxcDtccDtcV1CnsInput;
    dtcCaPayments?: IxcDtccDtcV1DtcCaPaymentData[];
    apiBal?: IxcDtccDtcV1ApiBalData;
    ragl?: IxcDtccDtcV1RaglData;
}

export interface IxcDtccDtcV1AssetDayEvent extends IxcDtccCnsV1AssetDayKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcDtccDtcV1AssetDayEventType;
}

export type IxcDtccDtcV1AssetDayEventType = {
    '!type'?: 'open';
    open: IxcDtccDtcV1AssetDayEventTypeOpen;
} | {
    '!type'?: 'openingFigures';
    openingFigures: IxcDtccDtcV1AssetDayEventTypeOpeningFigures;
} | {
    '!type'?: 'cnsPosted';
    cnsPosted: IxcDtccDtcV1AssetDayEventTypeCnsPosted;
} | {
    '!type'?: 'dtcCorporateActionPayment';
    dtcCorporateActionPayment: IxcDtccDtcV1AssetDayEventTypeDtcCorporateActionPayment;
} | {
    '!type'?: 'apiBal';
    apiBal: IxcDtccDtcV1AssetDayEventTypeApiBal;
} | {
    '!type'?: 'ragl';
    ragl: IxcDtccDtcV1AssetDayEventTypeRagl;
} | {
    '!type'?: 'reconcile';
    reconcile: EmptyObject;
} | {
    '!type'?: 'reconciled';
    reconciled: IxcDtccDtcV1AssetDayEventTypeReconciled;
} | {
    '!type'?: 'break';
    break: EmptyObject;
};

export interface IxcDtccDtcV1AssetDayEventTypeApiBal {
    data?: IxcDtccDtcV1ApiBalData;
}

export interface IxcDtccDtcV1AssetDayEventTypeCnsPosted {
    // format: decimal
    netSettlingQuantity?: string;
}

export interface IxcDtccDtcV1AssetDayEventTypeDtcCorporateActionPayment {
    data?: IxcDtccDtcV1DtcCaPaymentData;
}

export interface IxcDtccDtcV1AssetDayEventTypeOpen {
    // format: YYYY-MM-DD
    previous?: string;
    // format: YYYY-MM-DD
    nextOpen: string;
    security: IxcAssetsV1Security;
}

export interface IxcDtccDtcV1AssetDayEventTypeOpeningFigures {
    opening: IxcDtccDtcV1OpeningAssetData;
}

export interface IxcDtccDtcV1AssetDayEventTypeRagl {
    data?: IxcDtccDtcV1RaglData;
}

export interface IxcDtccDtcV1AssetDayEventTypeReconciled {
    // format: decimal
    dtcParticipantBalance?: string;
}

export const IXC_DTCC_DTC_V1_ASSET_DAY_EVENT_TYPE_ONE_OF_VALUES = ['open', 'openingFigures', 'cnsPosted', 'dtcCorporateActionPayment', 'apiBal', 'ragl', 'reconcile', 'reconciled', 'break'] as const;

export type IxcDtccDtcV1AssetDayEventTypeOneOfValue = (typeof IXC_DTCC_DTC_V1_ASSET_DAY_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcDtccDtcV1AssetDayKeys {
    // format: id62
    assetId: string;
    /* the Settlement date for this day */
    // format: YYYY-MM-DD
    date: string;
}

export interface IxcDtccDtcV1AssetDayQueryServiceAssetDayEventsAssetDayEventsRequest {
    // format: id62
    assetId: string;
    /* the Settlement date for this day */
    // format: YYYY-MM-DD
    date: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcDtccDtcV1AssetDayQueryServiceAssetDayEventsSearchableFields, IxcDtccDtcV1AssetDayQueryServiceAssetDayEventsSortableFields, IxcDtccDtcV1AssetDayQueryServiceAssetDayEventsFilterableFields>;
}

export enum IxcDtccDtcV1AssetDayQueryServiceAssetDayEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AssetId = 'assetId',
    Date = 'date',
    EventOpenSecurityCusip = 'event.open.security.cusip',
    EventType = 'event.!type'
}

export enum IxcDtccDtcV1AssetDayQueryServiceAssetDayEventsSearchableFields {
    EventOpenSecuritySymbolBase = 'event.open.security.symbol.base',
    EventOpenSecurityName = 'event.open.security.name'
}

export enum IxcDtccDtcV1AssetDayQueryServiceAssetDayEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    Date = 'date'
}

export interface IxcDtccDtcV1AssetDayQueryServiceAssetDayGetAssetDayGetRequest {
    // format: id62
    assetId: string;
    /* the Settlement date for this day */
    // format: YYYY-MM-DD
    date: string;
}

export interface IxcDtccDtcV1AssetDayQueryServiceAssetDayListAssetDayListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcDtccDtcV1AssetDayQueryServiceAssetDayListSearchableFields, IxcDtccDtcV1AssetDayQueryServiceAssetDayListSortableFields, IxcDtccDtcV1AssetDayQueryServiceAssetDayListFilterableFields>;
}

export enum IxcDtccDtcV1AssetDayQueryServiceAssetDayListFilterableFields {
    AssetId = 'assetId',
    Date = 'date',
    DataSecurityCusip = 'data.security.cusip',
    Status = 'status'
}

export enum IxcDtccDtcV1AssetDayQueryServiceAssetDayListSearchableFields {
    DataSecuritySymbolBase = 'data.security.symbol.base',
    DataSecurityName = 'data.security.name'
}

export enum IxcDtccDtcV1AssetDayQueryServiceAssetDayListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    Date = 'date'
}

export interface IxcDtccDtcV1AssetDayState extends IxcDtccDtcV1AssetDayKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcDtccDtcV1AssetDayData;
    status: IxcDtccDtcV1AssetDayStatus;
}

export enum IxcDtccDtcV1AssetDayStatus {
    Unspecified = 'UNSPECIFIED',
    Blocked = 'BLOCKED',
    Current = 'CURRENT',
    Break = 'BREAK',
    Reconciled = 'RECONCILED'
}

export interface IxcDtccDtcV1CnsInput {
    // format: decimal
    netSettlingQuantity?: string;
}

export interface IxcDtccDtcV1DtcCaPaymentData {
    dtcEventId?: string;
    // format: YYYY-MM-DD
    recordDate?: string;
    // format: YYYY-MM-DD
    paymentDate?: string;
    // format: YYYY-MM-DD
    exDividendDate?: string;
    // format: YYYY-MM-DD
    postedDate?: string;
    // format: decimal
    quantity?: string;
}

export interface IxcDtccDtcV1OpeningAssetData {
    // format: decimal
    dtcParticipantBalance?: string;
}

export interface IxcDtccDtcV1RaglData {
    // format: date-time
    asOf?: string;
    // format: decimal
    dtcSettled?: string;
}

export interface IxcFeesV1FeeRateData {
    /* The fee rate to apply. The interpretation depends on the fee type, e.g.
    for SEC this is dollars per dollar of sell-side principal, for TAF this
    is dollars per share sold */
    // format: decimal
    rate: string;
    /* When set, the maximum fee amount that can be charged for each charge */
    // format: decimal
    maximum?: string;
    /* The map code for the fee credit */
    mapCode: string;
    /* The map code for the fee debit, when the fee should be debited from a firm account */
    firmMapCode: string;
}

export interface IxcFeesV1FeeRateEvent extends IxcFeesV1FeeRateKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcFeesV1FeeRateEventType;
}

export type IxcFeesV1FeeRateEventType = {
    '!type'?: 'created';
    created: IxcFeesV1FeeRateEventTypeCreated;
} | {
    '!type'?: 'updated';
    updated: IxcFeesV1FeeRateEventTypeUpdated;
};

export interface IxcFeesV1FeeRateEventTypeCreated {
    // format: decimal
    rate: string;
    // format: decimal
    maximum?: string;
    mapCode: string;
    firmMapCode: string;
}

export interface IxcFeesV1FeeRateEventTypeUpdated {
    // format: decimal
    rate?: string;
    // format: decimal
    maximum?: string;
    mapCode?: string;
    firmMapCode?: string;
}

export const IXC_FEES_V1_FEE_RATE_EVENT_TYPE_ONE_OF_VALUES = ['created', 'updated'] as const;

export type IxcFeesV1FeeRateEventTypeOneOfValue = (typeof IXC_FEES_V1_FEE_RATE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcFeesV1FeeRateKeys {
    feeType: IxcFeesV1FeeType;
    /* The date on which this fee rate takes effect */
    // format: YYYY-MM-DD
    effectiveDate: string;
}

export interface IxcFeesV1FeeRateQueryServiceFeeRateEventsFeeRateEventsRequest {
    feeType: IxcFeesV1FeeType;
    /* The date on which this fee rate takes effect */
    // format: YYYY-MM-DD
    effectiveDate: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcFeesV1FeeRateQueryServiceFeeRateEventsSortableFields, IxcFeesV1FeeRateQueryServiceFeeRateEventsFilterableFields>;
}

export enum IxcFeesV1FeeRateQueryServiceFeeRateEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    FeeType = 'feeType',
    EffectiveDate = 'effectiveDate',
    EventType = 'event.!type'
}

export enum IxcFeesV1FeeRateQueryServiceFeeRateEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EffectiveDate = 'effectiveDate'
}

export interface IxcFeesV1FeeRateQueryServiceFeeRateGetFeeRateGetRequest {
    feeType: IxcFeesV1FeeType;
    /* The date on which this fee rate takes effect */
    // format: YYYY-MM-DD
    effectiveDate: string;
}

export interface IxcFeesV1FeeRateQueryServiceFeeRateListFeeRateListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcFeesV1FeeRateQueryServiceFeeRateListSortableFields, IxcFeesV1FeeRateQueryServiceFeeRateListFilterableFields>;
}

export enum IxcFeesV1FeeRateQueryServiceFeeRateListFilterableFields {
    FeeType = 'feeType',
    EffectiveDate = 'effectiveDate',
    Status = 'status'
}

export enum IxcFeesV1FeeRateQueryServiceFeeRateListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    EffectiveDate = 'effectiveDate'
}

export interface IxcFeesV1FeeRateState extends IxcFeesV1FeeRateKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcFeesV1FeeRateData;
    status: IxcFeesV1FeeRateStatus;
}

export enum IxcFeesV1FeeRateStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE'
}

export enum IxcFeesV1FeeType {
    Unspecified = 'UNSPECIFIED',
    Taf = 'TAF',
    Sec = 'SEC',
    Cat = 'CAT'
}

export interface IxcFeesV1TafActivityReportResponseTafReportRow {
    /* e.g. "Covered Equity Securities (Under Maximum)" */
    transactionType: string;
    /* e.g. "Shares" or "Trades" */
    unit: string;
    /* Count of shares or trades */
    // format: decimal
    aggregateVolume: string;
    /* The per-unit rate applied */
    // format: decimal
    rate: string;
    /* Total assessment for this row */
    // format: decimal
    assessmentAmount: string;
}

export interface IxcFeesV1TafReportServiceTafActivityReportTafActivityReportRequest {
    // format: INT32
    year: number;
    // format: INT32
    month: number;
}

export interface IxcFundingV1AccountNumberData {
    spec: IxcFundingV1AccountNumberSpec;
    /* External ID for the account number */
    // format: informal
    externalId?: string;
    /* The source ID for this account number, if created */
    // format: id62, entity: ixc.funding.v1.Source
    sourceId?: string;
}

export interface IxcFundingV1AccountNumberEvent extends IxcFundingV1AccountNumberKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcFundingV1AccountNumberEventType;
}

export type IxcFundingV1AccountNumberEventType = {
    '!type'?: 'requested';
    requested: IxcFundingV1AccountNumberEventTypeRequested;
} | {
    '!type'?: 'created';
    created: IxcFundingV1AccountNumberEventTypeCreated;
} | {
    '!type'?: 'sourceCreated';
    sourceCreated: IxcFundingV1AccountNumberEventTypeSourceCreated;
} | {
    '!type'?: 'disabled';
    disabled: EmptyObject;
} | {
    '!type'?: 'reenabled';
    reenabled: EmptyObject;
};

export interface IxcFundingV1AccountNumberEventTypeCreated {
    // format: informal
    externalId: string;
    bankDetails: IxcFundingV1UsBankDetails;
}

export interface IxcFundingV1AccountNumberEventTypeRequested {
    spec: IxcFundingV1AccountNumberSpec;
}

export interface IxcFundingV1AccountNumberEventTypeSourceCreated {
    // format: id62
    sourceId: string;
}

export const IXC_FUNDING_V1_ACCOUNT_NUMBER_EVENT_TYPE_ONE_OF_VALUES = ['requested', 'created', 'sourceCreated', 'disabled', 'reenabled'] as const;

export type IxcFundingV1AccountNumberEventTypeOneOfValue = (typeof IXC_FUNDING_V1_ACCOUNT_NUMBER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcFundingV1AccountNumberKeys {
    /* Unique identifier for account number */
    // format: id62
    accountNumberId: string;
    /* Account ID */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    /* Program ID */
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
}

export interface IxcFundingV1AccountNumberQueryServiceAccountNumberEventsAccountNumberEventsRequest {
    /* Unique identifier for account number */
    // format: id62
    accountNumberId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcFundingV1AccountNumberQueryServiceAccountNumberEventsSearchableFields, IxcFundingV1AccountNumberQueryServiceAccountNumberEventsSortableFields, IxcFundingV1AccountNumberQueryServiceAccountNumberEventsFilterableFields>;
}

export enum IxcFundingV1AccountNumberQueryServiceAccountNumberEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AccountNumberId = 'accountNumberId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    EventType = 'event.!type'
}

export enum IxcFundingV1AccountNumberQueryServiceAccountNumberEventsSearchableFields {
    EventRequestedSpecSourceTypeBankDetailsAccountNumber = 'event.requested.spec.sourceType.bankDetails.accountNumber',
    EventCreatedBankDetailsAccountNumber = 'event.created.bankDetails.accountNumber'
}

export enum IxcFundingV1AccountNumberQueryServiceAccountNumberEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcFundingV1AccountNumberQueryServiceAccountNumberGetAccountNumberGetRequest {
    /* Unique identifier for account number */
    // format: id62
    accountNumberId: string;
}

export interface IxcFundingV1AccountNumberQueryServiceAccountNumberListAccountNumberListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcFundingV1AccountNumberQueryServiceAccountNumberListSearchableFields, IxcFundingV1AccountNumberQueryServiceAccountNumberListSortableFields, IxcFundingV1AccountNumberQueryServiceAccountNumberListFilterableFields>;
}

export enum IxcFundingV1AccountNumberQueryServiceAccountNumberListFilterableFields {
    AccountNumberId = 'accountNumberId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    DataExternalId = 'data.externalId',
    DataSourceId = 'data.sourceId',
    Status = 'status'
}

export enum IxcFundingV1AccountNumberQueryServiceAccountNumberListSearchableFields {
    DataSpecSourceTypeBankDetailsAccountNumber = 'data.spec.sourceType.bankDetails.accountNumber'
}

export enum IxcFundingV1AccountNumberQueryServiceAccountNumberListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcFundingV1AccountNumbersControls {
    limits?: EmptyObject;
    settings?: IxcFundingV1AccountNumbersControlsSettings;
}

export interface IxcFundingV1AccountNumbersControlsSettings {
    /* If true, accounts are able to create an Account Number */
    canCreate?: boolean;
}

export interface IxcFundingV1AccountNumberSource {
    /* If true, the account is able to create and use an Account Number */
    enabled?: boolean;
    bankDetails?: IxcFundingV1UsBankDetails;
}

export interface IxcFundingV1AccountNumberSpec {
    nickname: string;
    sourceType: IxcFundingV1AccountNumberSource;
    validation: IxcFundingV1SourceValidation;
    /* Field populated by the system: if the account the source is attached to
    is Organization account, assume the bank account is a corporate account. */
    ownerType: IxcFundingV1BankAccountOwnerType;
}

export interface IxcFundingV1AccountNumberState extends IxcFundingV1AccountNumberKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcFundingV1AccountNumberData;
    status: IxcFundingV1AccountNumberStatus;
}

export enum IxcFundingV1AccountNumberStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Active = 'ACTIVE',
    Disabled = 'DISABLED'
}

export interface IxcFundingV1AchPull {
    /* An attestation that the user has authorized the debit to their account.
    Must be set true for the transfer to be accepted. */
    debitAuthorization?: boolean;
    /* If the source is same-day eligible, this field indicates whether the
    transfer should be processed as same-day. If the transfer is made after
    the cut-off time, it will be processed during the next possible ACH
    processing day. */
    isSameDayRequested?: boolean;
}

export interface IxcFundingV1AchPush {
    /* If the source is same-day eligible, this field indicates whether the
    transfer should be processed as same-day. If the transfer is made after
    the cut-off time, it will be processed during the next possible ACH
    processing day. */
    isSameDayRequested?: boolean;
}

export interface IxcFundingV1AchSource {
    bankDetails: IxcFundingV1UsBankDetails;
    sameDayEnabled?: boolean;
}

export interface IxcFundingV1Approval {
    outcome: IxcFundingV1CheckOutcome;
}

export enum IxcFundingV1BankAccountOwnerType {
    Unspecified = 'UNSPECIFIED',
    Person = 'PERSON',
    Business = 'BUSINESS'
}

export enum IxcFundingV1BankAccountType {
    Unspecified = 'UNSPECIFIED',
    Checking = 'CHECKING',
    Savings = 'SAVINGS'
}

export interface IxcFundingV1BatchAllocationData {
    /* Amount to transfer. Positive is deposit to Interchange account. */
    // format: decimal
    amount: string;
    /* Hold approval for the transfer */
    holdApproval?: IxcFundingV1FundingHoldApproval;
}

export interface IxcFundingV1BatchAllocationEvent extends IxcFundingV1BatchAllocationKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcFundingV1BatchAllocationEventType;
}

export type IxcFundingV1BatchAllocationEventType = {
    '!type'?: 'created';
    created: IxcFundingV1BatchAllocationEventTypeCreated;
} | {
    '!type'?: 'holdUpdated';
    holdUpdated: IxcFundingV1BatchAllocationEventTypeHoldUpdated;
} | {
    '!type'?: 'completed';
    completed: EmptyObject;
} | {
    '!type'?: 'canceled';
    canceled: EmptyObject;
} | {
    '!type'?: 'errored';
    errored: IxcFundingV1BatchAllocationEventTypeErrored;
};

export interface IxcFundingV1BatchAllocationEventTypeCreated {
    // format: id62
    batchAllocationId: string;
    // format: id62
    batchTransferId: string;
    // format: id62
    srcAccountId: string;
    // format: id62
    dstAccountId: string;
    // format: id62
    programId: string;
    // format: decimal
    amount: string;
}

export interface IxcFundingV1BatchAllocationEventTypeErrored {
    error: string;
}

export interface IxcFundingV1BatchAllocationEventTypeHoldUpdated {
    /* Hold approval for the transfer */
    holdApproval: IxcFundingV1FundingHoldApproval;
}

export const IXC_FUNDING_V1_BATCH_ALLOCATION_EVENT_TYPE_ONE_OF_VALUES = ['created', 'holdUpdated', 'completed', 'canceled', 'errored'] as const;

export type IxcFundingV1BatchAllocationEventTypeOneOfValue = (typeof IXC_FUNDING_V1_BATCH_ALLOCATION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcFundingV1BatchAllocationKeys {
    // format: id62
    batchAllocationId: string;
    // format: id62, entity: ixc.funding.v1.BatchTransfer
    batchTransferId?: string;
    // format: id62, entity: ixc.registration.v1.Account
    srcAccountId?: string;
    // format: id62, entity: ixc.registration.v1.Account
    dstAccountId?: string;
    /* Program ID */
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
}

export interface IxcFundingV1BatchAllocationQueryServiceBatchAllocationEventsBatchAllocationEventsRequest {
    // format: id62
    batchAllocationId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcFundingV1BatchAllocationQueryServiceBatchAllocationEventsSortableFields, IxcFundingV1BatchAllocationQueryServiceBatchAllocationEventsFilterableFields>;
}

export enum IxcFundingV1BatchAllocationQueryServiceBatchAllocationEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    BatchAllocationId = 'batchAllocationId',
    BatchTransferId = 'batchTransferId',
    SrcAccountId = 'srcAccountId',
    DstAccountId = 'dstAccountId',
    ProgramId = 'programId',
    EventType = 'event.!type'
}

export enum IxcFundingV1BatchAllocationQueryServiceBatchAllocationEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcFundingV1BatchAllocationQueryServiceBatchAllocationGetBatchAllocationGetRequest {
    // format: id62
    batchAllocationId: string;
}

export interface IxcFundingV1BatchAllocationQueryServiceBatchAllocationListBatchAllocationListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcFundingV1BatchAllocationQueryServiceBatchAllocationListSortableFields, IxcFundingV1BatchAllocationQueryServiceBatchAllocationListFilterableFields>;
}

export enum IxcFundingV1BatchAllocationQueryServiceBatchAllocationListFilterableFields {
    BatchAllocationId = 'batchAllocationId',
    BatchTransferId = 'batchTransferId',
    SrcAccountId = 'srcAccountId',
    DstAccountId = 'dstAccountId',
    ProgramId = 'programId',
    Status = 'status'
}

export enum IxcFundingV1BatchAllocationQueryServiceBatchAllocationListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcFundingV1BatchAllocationState extends IxcFundingV1BatchAllocationKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcFundingV1BatchAllocationData;
    status: IxcFundingV1BatchAllocationStatus;
}

export enum IxcFundingV1BatchAllocationStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Completed = 'COMPLETED',
    Canceled = 'CANCELED',
    Errored = 'ERRORED'
}

export interface IxcFundingV1BatchFundingControls {
    limits?: IxcFundingV1BatchFundingControlsLimits;
    settings?: IxcFundingV1BatchFundingControlsSettings;
}

export interface IxcFundingV1BatchFundingControlsLimits {
    perBatchMaximums?: IxcFundingV1BatchFundingControlsLimitsPerBatchMaximums;
    autoApproveUnder?: IxcFundingV1BatchFundingControlsLimitsAutoApproveUnder;
}

export interface IxcFundingV1BatchFundingControlsLimitsAutoApproveUnder {
    /* If unset, the program requires clearing approval for all batch deposit funds */
    // format: decimal
    deposit?: string;
    /* If unset, the program requires clearing approval for all batch withdrawal funds */
    // format: decimal
    withdrawal?: string;
}

export interface IxcFundingV1BatchFundingControlsLimitsPerBatchMaximums {
    /* If unset, no limit for batch deposit of funds */
    // format: decimal
    deposit?: string;
    /* If unset, no limit for batch withdrawal of funds */
    // format: decimal
    withdrawal?: string;
}

export interface IxcFundingV1BatchFundingControlsSettings {
    ach?: IxcFundingV1BatchFundingControlsSettingsAch;
    sameDayAch?: IxcFundingV1BatchFundingControlsSettingsSameDayAch;
}

export interface IxcFundingV1BatchFundingControlsSettingsAch {
    canDeposit?: boolean;
    canWithdraw?: boolean;
}

export interface IxcFundingV1BatchFundingControlsSettingsSameDayAch {
    canDeposit?: boolean;
    canWithdraw?: boolean;
}

export interface IxcFundingV1BatchTransferData {
    spec: IxcFundingV1BatchTransferSpec;
    /* The Funding Transfer ID for this Batch Transfer. */
    // format: id62
    transferId?: string;
    /* If we receive a payment, the external ID to use for this Batch. Example: "wire-12345". */
    externalId?: string;
    /* Account ID used for batch funding internal movement. Must be a net
    settlement account or special purpose account for this program. */
    // format: id62
    platformAccountId: string;
    counts?: IxcFundingV1BatchTransferDataCounts;
}

export interface IxcFundingV1BatchTransferDataCounts {
    // format: UINT32
    totalInternal?: number;
    // format: UINT32
    totalExternal?: number;
    // format: UINT32
    createdInternal?: number;
    // format: UINT32
    createdExternal?: number;
    // format: UINT32
    successInternal?: number;
    // format: UINT32
    successExternal?: number;
    // format: UINT32
    errorInternal?: number;
    // format: UINT32
    errorExternal?: number;
}

export interface IxcFundingV1BatchTransferEvent extends IxcFundingV1BatchTransferKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcFundingV1BatchTransferEventType;
}

export type IxcFundingV1BatchTransferEventType = {
    '!type'?: 'requested';
    requested: IxcFundingV1BatchTransferEventTypeRequested;
} | {
    '!type'?: 'approved';
    approved: IxcFundingV1BatchTransferEventTypeApproved;
} | {
    '!type'?: 'rejected';
    rejected: IxcFundingV1BatchTransferEventTypeRejected;
} | {
    '!type'?: 'externalTransferUpdated';
    externalTransferUpdated: IxcFundingV1BatchTransferEventTypeExternalTransferUpdated;
} | {
    '!type'?: 'internalTransferUpdated';
    internalTransferUpdated: IxcFundingV1BatchTransferEventTypeInternalTransferUpdated;
} | {
    '!type'?: 'completed';
    completed: EmptyObject;
} | {
    '!type'?: 'errored';
    errored: IxcFundingV1BatchTransferEventTypeErrored;
};

export interface IxcFundingV1BatchTransferEventTypeApproved {
    notes?: string;
}

export interface IxcFundingV1BatchTransferEventTypeErrored {
    error: string;
}

export interface IxcFundingV1BatchTransferEventTypeExternalTransferUpdated {
    // format: id62
    transferId: string;
    result: IxcFundingV1TransferTaskOutcome;
}

export interface IxcFundingV1BatchTransferEventTypeInternalTransferUpdated {
    // format: id62
    accountId: string;
    result: IxcFundingV1TransferTaskOutcome;
}

export interface IxcFundingV1BatchTransferEventTypeRejected {
    reason?: string;
}

export interface IxcFundingV1BatchTransferEventTypeRequested {
    spec: IxcFundingV1BatchTransferSpec;
    // format: id62
    platformAccountId?: string;
}

export const IXC_FUNDING_V1_BATCH_TRANSFER_EVENT_TYPE_ONE_OF_VALUES = ['requested', 'approved', 'rejected', 'externalTransferUpdated', 'internalTransferUpdated', 'completed', 'errored'] as const;

export type IxcFundingV1BatchTransferEventTypeOneOfValue = (typeof IXC_FUNDING_V1_BATCH_TRANSFER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcFundingV1BatchTransferKeys {
    /* Unique identifier for batch transfer */
    // format: id62
    batchTransferId: string;
    /* Program ID */
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
}

export interface IxcFundingV1BatchTransferQueryServiceBatchTransferEventsBatchTransferEventsRequest {
    /* Unique identifier for batch transfer */
    // format: id62
    batchTransferId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcFundingV1BatchTransferQueryServiceBatchTransferEventsSortableFields, IxcFundingV1BatchTransferQueryServiceBatchTransferEventsFilterableFields>;
}

export enum IxcFundingV1BatchTransferQueryServiceBatchTransferEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    BatchTransferId = 'batchTransferId',
    ProgramId = 'programId',
    EventType = 'event.!type'
}

export enum IxcFundingV1BatchTransferQueryServiceBatchTransferEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcFundingV1BatchTransferQueryServiceBatchTransferGetBatchTransferGetRequest {
    /* Unique identifier for batch transfer */
    // format: id62
    batchTransferId: string;
}

export interface IxcFundingV1BatchTransferQueryServiceBatchTransferListBatchTransferListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcFundingV1BatchTransferQueryServiceBatchTransferListSortableFields, IxcFundingV1BatchTransferQueryServiceBatchTransferListFilterableFields>;
}

export enum IxcFundingV1BatchTransferQueryServiceBatchTransferListFilterableFields {
    BatchTransferId = 'batchTransferId',
    ProgramId = 'programId',
    Status = 'status'
}

export enum IxcFundingV1BatchTransferQueryServiceBatchTransferListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcFundingV1BatchTransferSpec {
    // format: decimal
    totalAmount: string;
    allocations: IxcFundingV1FundingAllocation[];
    /* Funding source to use for the transfer */
    // format: id62, entity: ixc.funding.v1.Source
    sourceId?: string;
    /* Method of transfer to use */
    batchTransferType: IxcFundingV1BatchTransferType;
}

export interface IxcFundingV1BatchTransferState extends IxcFundingV1BatchTransferKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcFundingV1BatchTransferData;
    status: IxcFundingV1BatchTransferStatus;
}

export enum IxcFundingV1BatchTransferStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
    Applying = 'APPLYING',
    Done = 'DONE',
    Error = 'ERROR'
}

export type IxcFundingV1BatchTransferType = {
    '!type'?: 'achPush';
    /* An ACH Push to the source account */
    achPush: IxcFundingV1AchPush;
} | {
    '!type'?: 'achPull';
    /* An ACH Pull from the source account */
    achPull: IxcFundingV1AchPull;
};

export const IXC_FUNDING_V1_BATCH_TRANSFER_TYPE_ONE_OF_VALUES = ['achPush', 'achPull'] as const;

export type IxcFundingV1BatchTransferTypeOneOfValue = (typeof IXC_FUNDING_V1_BATCH_TRANSFER_TYPE_ONE_OF_VALUES)[number];

export enum IxcFundingV1CheckOutcome {
    Unspecified = 'UNSPECIFIED',
    Passed = 'PASSED',
    Failed = 'FAILED'
}

export type IxcFundingV1CreatableSourceType = {
    '!type'?: 'achSource';
    achSource: IxcFundingV1AchSource;
} | {
    '!type'?: 'domesticWireSource';
    domesticWireSource: IxcFundingV1DomesticWireSource;
} | {
    '!type'?: 'plaidProcessorTokenSource';
    plaidProcessorTokenSource: IxcFundingV1PlaidProcessorTokenSource;
};

export const IXC_FUNDING_V1_CREATABLE_SOURCE_TYPE_ONE_OF_VALUES = ['achSource', 'domesticWireSource', 'plaidProcessorTokenSource'] as const;

export type IxcFundingV1CreatableSourceTypeOneOfValue = (typeof IXC_FUNDING_V1_CREATABLE_SOURCE_TYPE_ONE_OF_VALUES)[number];

export interface IxcFundingV1DomesticWireSource {
    bankDetails: IxcFundingV1UsBankDetails;
}

export type IxcFundingV1ExternallyManaged = {
    '!type'?: 'plaidSource';
    plaidSource: IxcFundingV1PlaidProcessorTokenSource;
};

export const IXC_FUNDING_V1_EXTERNALLY_MANAGED_ONE_OF_VALUES = ['plaidSource'] as const;

export type IxcFundingV1ExternallyManagedOneOfValue = (typeof IXC_FUNDING_V1_EXTERNALLY_MANAGED_ONE_OF_VALUES)[number];

export interface IxcFundingV1FundingAllocation {
    /* Interchange account id */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    /* Amount to transfer. Positive is deposit to Interchange account. */
    // format: decimal
    amount: string;
}

export interface IxcFundingV1FundingAmountLimits {
    /* If no minimum is set, the minimum is 0. */
    // format: decimal
    minAmount?: string;
    /* If no maximum is set, the maximum is unlimited. */
    // format: decimal
    maxAmount?: string;
}

export interface IxcFundingV1FundingBatchTransaction {
    // format: id62
    batchId: string;
    // format: id62
    batchAllocationId: string;
    fundingAllocation: IxcFundingV1FundingAllocation;
    // format: id62
    accountId: string;
    // format: id62
    programId: string;
    // format: date-time
    timestamp: string;
}

export interface IxcFundingV1FundingControls {
    limits?: IxcFundingV1FundingControlsLimits;
    settings?: IxcFundingV1FundingControlsSettings;
}

export interface IxcFundingV1FundingControlsLimits {
    /* The maximum number of funding sources that can be added to a single brokerage account. If unset, the program's accounts can add unlimited funding sources. */
    // format: UINT32
    maxSourcesPerAccount?: number;
    /* Limits whether the program's accounts can use ACH to deposit or
    withdraw funds, the USD-denoted quantities for each transfer, and
    access to other features (e.g., whether transfers can be scheduled). */
    ach?: IxcFundingV1FundingControlsLimitsAch;
    /* Limits whether the account can use same-day ACH to deposit or
    withdraw funds, the USD-denoted quantities for each transfer. */
    sameDayAch?: IxcFundingV1FundingControlsLimitsSameDayAch;
    /* Limits whether the program's accounts can use wires to withdraw
    funds, the USD-denoted quantities for each transfer, and access to
    other features. */
    wire?: IxcFundingV1FundingControlsLimitsWire;
}

export interface IxcFundingV1FundingControlsLimitsAch {
    /* If unset, the program's accounts cannot deposit funds via ACH. */
    depositPerTransaction?: IxcFundingV1FundingAmountLimits;
    /* If unset, the program's accounts cannot withdraw funds via ACH. */
    withdrawalPerTransaction?: IxcFundingV1FundingAmountLimits;
}

export interface IxcFundingV1FundingControlsLimitsSameDayAch {
    /* If unset, the account cannot deposit funds via same-day ACH. */
    depositPerTransaction?: IxcFundingV1FundingAmountLimits;
    /* If unset, the account cannot withdraw funds via same-day ACH. */
    withdrawalPerTransaction?: IxcFundingV1FundingAmountLimits;
}

export interface IxcFundingV1FundingControlsLimitsWire {
    /* If unset, the program's accounts cannot withdraw funds via wire. */
    withdrawalPerTransaction?: IxcFundingV1FundingAmountLimits;
}

export interface IxcFundingV1FundingControlsSettings {
    ach?: IxcFundingV1FundingControlsSettingsAch;
    sameDayAch?: IxcFundingV1FundingControlsSettingsSameDayAch;
    wire?: IxcFundingV1FundingControlsSettingsWire;
}

export interface IxcFundingV1FundingControlsSettingsAch {
    canDeposit?: boolean;
    canWithdraw?: boolean;
}

export interface IxcFundingV1FundingControlsSettingsSameDayAch {
    canDeposit?: boolean;
    canWithdraw?: boolean;
}

export interface IxcFundingV1FundingControlsSettingsWire {
    canWithdraw?: boolean;
}

export interface IxcFundingV1FundingHoldApproval {
    // format: id62
    holdId?: string;
    outcome: IxcFundingV1CheckOutcome;
}

export interface IxcFundingV1FundingTransaction {
    // format: id62
    fundingId: string;
    // format: id62
    accountId: string;
    // format: id62
    programId: string;
    // format: date-time
    timestamp: string;
    transfer: IxcFundingV1TransferSpec;
    // format: id62, entity: ixc.portfolio.v1.Hold
    holdId?: string;
}

export interface IxcFundingV1IncomingTransfer {
    /* Account number ID of the incoming payment */
    // format: id62
    accountNumberId: string;
}

export interface IxcFundingV1NameAndAddress {
    address: IxcRegistrationV1Address;
    name: string;
}

export interface IxcFundingV1PlaidAccountDetails {
    /* Plaid's account_id */
    accountId: string;
    /* The account mask, used for display by correspondent */
    mask?: string;
    name: string;
    officialName?: string;
    accountType: string;
    subtype?: string;
    ach?: IxcFundingV1PlaidAccountDetailsAch;
}

export interface IxcFundingV1PlaidAccountDetailsAch {
    /* Plaid's account_id */
    accountId: string;
    /* Account number */
    accountNumber: string;
    /* Routing number */
    routingNumber: string;
    /* Wire routing number */
    wireRoutingNumber?: string;
}

export interface IxcFundingV1PlaidProcessorTokenSource {
    /* Required for creating or updating a Plaid processor token source */
    processorToken: string;
    /* The name on the account, as known by the bank. If not supplied, the account's registration name is used. */
    nameOnAccount?: string;
    /* The system fills in this information after a successful Plaid processor token verification */
    accountFromPlaid?: IxcFundingV1PlaidAccountDetails;
}

export interface IxcFundingV1SourceCreateRequestSpec {
    isPrimary?: boolean;
    nickname: string;
    sourceType: IxcFundingV1CreatableSourceType;
    validation: IxcFundingV1SourceValidation;
}

export interface IxcFundingV1SourceUpdateRequestSpec {
    isPrimary?: boolean;
    nickname: string;
    sourceType: IxcFundingV1SourceType;
    validation: IxcFundingV1SourceValidation;
}

export type IxcFundingV1TransferCreateRequestSpec = {
    '!type'?: 'wirePush';
    wirePush: EmptyObject;
} | {
    '!type'?: 'achPush';
    achPush: IxcFundingV1AchPush;
} | {
    '!type'?: 'achPull';
    achPull: IxcFundingV1AchPull;
};

export const IXC_FUNDING_V1_TRANSFER_CREATE_REQUEST_SPEC_ONE_OF_VALUES = ['wirePush', 'achPush', 'achPull'] as const;

export type IxcFundingV1TransferCreateRequestSpecOneOfValue = (typeof IXC_FUNDING_V1_TRANSFER_CREATE_REQUEST_SPEC_ONE_OF_VALUES)[number];

export interface IxcFundingV1SourceData {
    spec: IxcFundingV1SourceSpec;
    /* If this source is for incoming payments via an account number, the
    account number ID */
    // format: id62, entity: ixc.funding.v1.AccountNumber
    accountNumberId?: string;
}

export interface IxcFundingV1SourceEvent extends IxcFundingV1SourceKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcFundingV1SourceEventType;
}

export type IxcFundingV1SourceEventType = {
    '!type'?: 'requested';
    requested: IxcFundingV1SourceEventTypeRequested;
} | {
    '!type'?: 'invalidExternalToken';
    invalidExternalToken: IxcFundingV1SourceEventTypeInvalidExternalToken;
} | {
    '!type'?: 'created';
    created: IxcFundingV1SourceEventTypeCreated;
} | {
    '!type'?: 'updated';
    updated: IxcFundingV1SourceEventTypeUpdated;
} | {
    '!type'?: 'archived';
    archived: EmptyObject;
};

export interface IxcFundingV1SourceEventTypeCreated {
    spec: IxcFundingV1SourceSpec;
    // format: id62
    accountNumberId?: string;
}

export interface IxcFundingV1SourceEventTypeInvalidExternalToken {
    error?: string;
}

export interface IxcFundingV1SourceEventTypeRequested {
    /* optional idempotency key */
    // format: id62
    sourceId?: string;
    type: IxcFundingV1ExternallyManaged;
}

export interface IxcFundingV1SourceEventTypeUpdated {
    spec: IxcFundingV1SourceSpec;
    // format: id62
    accountNumberId?: string;
}

export const IXC_FUNDING_V1_SOURCE_EVENT_TYPE_ONE_OF_VALUES = ['requested', 'invalidExternalToken', 'created', 'updated', 'archived'] as const;

export type IxcFundingV1SourceEventTypeOneOfValue = (typeof IXC_FUNDING_V1_SOURCE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcFundingV1SourceKeys {
    /* Unique identifier for source */
    // format: id62
    sourceId: string;
    /* Account ID */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    /* Program ID */
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
}

export interface IxcFundingV1SourceQueryServiceSourceEventsSourceEventsRequest {
    /* Unique identifier for source */
    // format: id62
    sourceId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcFundingV1SourceQueryServiceSourceEventsSearchableFields, IxcFundingV1SourceQueryServiceSourceEventsSortableFields, IxcFundingV1SourceQueryServiceSourceEventsFilterableFields>;
}

export enum IxcFundingV1SourceQueryServiceSourceEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    SourceId = 'sourceId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    EventCreatedSpecIsPrimary = 'event.created.spec.isPrimary',
    EventCreatedSpecSourceTypeType = 'event.created.spec.sourceType.!type',
    EventUpdatedSpecIsPrimary = 'event.updated.spec.isPrimary',
    EventUpdatedSpecSourceTypeType = 'event.updated.spec.sourceType.!type',
    EventType = 'event.!type'
}

export enum IxcFundingV1SourceQueryServiceSourceEventsSearchableFields {
    EventCreatedSpecSourceTypeAchSourceBankDetailsAccountNumber = 'event.created.spec.sourceType.achSource.bankDetails.accountNumber',
    EventCreatedSpecSourceTypeDomesticWireSourceBankDetailsAccountNumber = 'event.created.spec.sourceType.domesticWireSource.bankDetails.accountNumber',
    EventCreatedSpecSourceTypeAccountNumberSourceBankDetailsAccountNumber = 'event.created.spec.sourceType.accountNumberSource.bankDetails.accountNumber',
    EventUpdatedSpecSourceTypeAchSourceBankDetailsAccountNumber = 'event.updated.spec.sourceType.achSource.bankDetails.accountNumber',
    EventUpdatedSpecSourceTypeDomesticWireSourceBankDetailsAccountNumber = 'event.updated.spec.sourceType.domesticWireSource.bankDetails.accountNumber',
    EventUpdatedSpecSourceTypeAccountNumberSourceBankDetailsAccountNumber = 'event.updated.spec.sourceType.accountNumberSource.bankDetails.accountNumber'
}

export enum IxcFundingV1SourceQueryServiceSourceEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcFundingV1SourceQueryServiceSourceGetSourceGetRequest {
    /* Unique identifier for source */
    // format: id62
    sourceId: string;
}

export interface IxcFundingV1SourceQueryServiceSourceListSourceListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcFundingV1SourceQueryServiceSourceListSearchableFields, IxcFundingV1SourceQueryServiceSourceListSortableFields, IxcFundingV1SourceQueryServiceSourceListFilterableFields>;
}

export enum IxcFundingV1SourceQueryServiceSourceListFilterableFields {
    SourceId = 'sourceId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    DataSpecIsPrimary = 'data.spec.isPrimary',
    DataSpecSourceTypeType = 'data.spec.sourceType.!type',
    DataAccountNumberId = 'data.accountNumberId',
    Status = 'status'
}

export enum IxcFundingV1SourceQueryServiceSourceListSearchableFields {
    DataSpecSourceTypeAchSourceBankDetailsAccountNumber = 'data.spec.sourceType.achSource.bankDetails.accountNumber',
    DataSpecSourceTypeDomesticWireSourceBankDetailsAccountNumber = 'data.spec.sourceType.domesticWireSource.bankDetails.accountNumber',
    DataSpecSourceTypeAccountNumberSourceBankDetailsAccountNumber = 'data.spec.sourceType.accountNumberSource.bankDetails.accountNumber'
}

export enum IxcFundingV1SourceQueryServiceSourceListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcFundingV1SourceSpec {
    isPrimary?: boolean;
    nickname: string;
    sourceType: IxcFundingV1SourceType;
    validation: IxcFundingV1SourceValidation;
    /* Field populated by Funding: if the account the source is attached to is
    Organization account, assume the bank account is a corporate account. */
    ownerType: IxcFundingV1BankAccountOwnerType;
}

export interface IxcFundingV1SourceState extends IxcFundingV1SourceKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcFundingV1SourceData;
    status: IxcFundingV1SourceStatus;
}

export enum IxcFundingV1SourceStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Active = 'ACTIVE',
    Archived = 'ARCHIVED',
    Invalid = 'INVALID'
}

export type IxcFundingV1SourceType = {
    '!type'?: 'achSource';
    achSource: IxcFundingV1AchSource;
} | {
    '!type'?: 'domesticWireSource';
    domesticWireSource: IxcFundingV1DomesticWireSource;
} | {
    '!type'?: 'accountNumberSource';
    /* Can only be created by the system */
    accountNumberSource: IxcFundingV1AccountNumberSource;
} | {
    '!type'?: 'plaidProcessorTokenSource';
    plaidProcessorTokenSource: IxcFundingV1PlaidProcessorTokenSource;
};

export const IXC_FUNDING_V1_SOURCE_TYPE_ONE_OF_VALUES = ['achSource', 'domesticWireSource', 'accountNumberSource', 'plaidProcessorTokenSource'] as const;

export type IxcFundingV1SourceTypeOneOfValue = (typeof IXC_FUNDING_V1_SOURCE_TYPE_ONE_OF_VALUES)[number];

export type IxcFundingV1SourceValidation = {
    '!type'?: 'external';
    external: EmptyObject;
};

export const IXC_FUNDING_V1_SOURCE_VALIDATION_ONE_OF_VALUES = ['external'] as const;

export type IxcFundingV1SourceValidationOneOfValue = (typeof IXC_FUNDING_V1_SOURCE_VALIDATION_ONE_OF_VALUES)[number];

export interface IxcFundingV1TransferCheck {
    // format: id62
    checkId: string;
    checkType: IxcFundingV1TransferCheckType;
}

export type IxcFundingV1TransferCheckType = {
    '!type'?: 'fundingHold';
    /* Ensures sufficient funds available */
    fundingHold: IxcFundingV1TransferCheckTypeFundingHold;
} | {
    '!type'?: 'clearingApproval';
    /* Risk management review (automated or manual) */
    clearingApproval: IxcFundingV1TransferCheckTypeClearingApproval;
} | {
    '!type'?: 'programApproval';
    /* Custom business logic validation */
    programApproval: IxcFundingV1TransferCheckTypeProgramApproval;
};

export interface IxcFundingV1TransferCheckTypeClearingApproval {
    approval?: IxcFundingV1Approval;
}

export interface IxcFundingV1TransferCheckTypeFundingHold {
    hold?: IxcFundingV1FundingHoldApproval;
}

export interface IxcFundingV1TransferCheckTypeProgramApproval {
    approval?: IxcFundingV1Approval;
}

export const IXC_FUNDING_V1_TRANSFER_CHECK_TYPE_ONE_OF_VALUES = ['fundingHold', 'clearingApproval', 'programApproval'] as const;

export type IxcFundingV1TransferCheckTypeOneOfValue = (typeof IXC_FUNDING_V1_TRANSFER_CHECK_TYPE_ONE_OF_VALUES)[number];

export interface IxcFundingV1TransferData {
    spec: IxcFundingV1TransferSpec;
    source: IxcFundingV1SourceSpec;
    /* Expected settlement date */
    // format: YYYY-MM-DD
    estimatedSettleDate: string;
    checks?: IxcFundingV1TransferCheck[];
    programBankingName: string;
    /* If this transfer is for a batch, the batch ID */
    // format: id62, entity: ixc.funding.v1.BatchTransfer
    batchId?: string;
}

export interface IxcFundingV1TransferEvent extends IxcFundingV1TransferKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcFundingV1TransferEventType;
}

export type IxcFundingV1TransferEventType = {
    '!type'?: 'created';
    created: IxcFundingV1TransferEventTypeCreated;
} | {
    '!type'?: 'submitted';
    submitted: IxcFundingV1TransferEventTypeSubmitted;
} | {
    '!type'?: 'checkResult';
    checkResult: IxcFundingV1TransferEventTypeCheckResult;
} | {
    '!type'?: 'denied';
    denied: EmptyObject;
} | {
    '!type'?: 'checksPassed';
    checksPassed: EmptyObject;
} | {
    '!type'?: 'approved';
    approved: EmptyObject;
} | {
    '!type'?: 'rejected';
    rejected: IxcFundingV1TransferEventTypeRejected;
} | {
    '!type'?: 'canceled';
    canceled: EmptyObject;
} | {
    '!type'?: 'returned';
    returned: IxcFundingV1TransferEventTypeReturned;
} | {
    '!type'?: 'incomingPaymentSettled';
    incomingPaymentSettled: IxcFundingV1TransferEventTypeIncomingPaymentSettled;
};

export interface IxcFundingV1TransferEventTypeCheckResult {
    check?: IxcFundingV1TransferCheckType;
}

export interface IxcFundingV1TransferEventTypeCreated {
    spec: IxcFundingV1TransferSpec;
    // format: YYYY-MM-DD
    estimatedSettleDate: string;
    source: IxcFundingV1SourceSpec;
    programBankingName: string;
    /* If this transfer is for a batch, the batch ID */
    // format: id62, entity: ixc.funding.v1.BatchTransfer
    batchId?: string;
}

export interface IxcFundingV1TransferEventTypeIncomingPaymentSettled {
    spec: IxcFundingV1TransferSpec;
    // format: YYYY-MM-DD
    estimatedSettleDate: string;
    source: IxcFundingV1SourceSpec;
    programBankingName: string;
    /* If this transfer is for a batch, the batch ID */
    // format: id62, entity: ixc.funding.v1.BatchTransfer
    batchId?: string;
}

export interface IxcFundingV1TransferEventTypeRejected {
    reason: string;
}

export interface IxcFundingV1TransferEventTypeReturned {
    reason: string;
}

export interface IxcFundingV1TransferEventTypeSubmitted {
    requiredChecks?: IxcFundingV1TransferCheckType[];
}

export const IXC_FUNDING_V1_TRANSFER_EVENT_TYPE_ONE_OF_VALUES = ['created', 'submitted', 'checkResult', 'denied', 'checksPassed', 'approved', 'rejected', 'canceled', 'returned', 'incomingPaymentSettled'] as const;

export type IxcFundingV1TransferEventTypeOneOfValue = (typeof IXC_FUNDING_V1_TRANSFER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcFundingV1TransferKeys {
    /* Unique identifier for transfer */
    // format: id62
    transferId: string;
    /* Reference to the funding source */
    // format: id62, entity: ixc.funding.v1.Source
    sourceId: string;
    /* Account ID */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    /* Program ID */
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
}

export interface IxcFundingV1TransferQueryServiceTransferEventsTransferEventsRequest {
    /* Unique identifier for transfer */
    // format: id62
    transferId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcFundingV1TransferQueryServiceTransferEventsSearchableFields, IxcFundingV1TransferQueryServiceTransferEventsSortableFields, IxcFundingV1TransferQueryServiceTransferEventsFilterableFields>;
}

export enum IxcFundingV1TransferQueryServiceTransferEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    TransferId = 'transferId',
    SourceId = 'sourceId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    EventCreatedSpecTransferTypeType = 'event.created.spec.transferType.!type',
    EventCreatedSourceIsPrimary = 'event.created.source.isPrimary',
    EventCreatedSourceSourceTypeType = 'event.created.source.sourceType.!type',
    EventIncomingPaymentSettledSpecTransferTypeType = 'event.incomingPaymentSettled.spec.transferType.!type',
    EventIncomingPaymentSettledSourceIsPrimary = 'event.incomingPaymentSettled.source.isPrimary',
    EventIncomingPaymentSettledSourceSourceTypeType = 'event.incomingPaymentSettled.source.sourceType.!type',
    EventType = 'event.!type'
}

export enum IxcFundingV1TransferQueryServiceTransferEventsSearchableFields {
    EventCreatedSourceSourceTypeAchSourceBankDetailsAccountNumber = 'event.created.source.sourceType.achSource.bankDetails.accountNumber',
    EventCreatedSourceSourceTypeDomesticWireSourceBankDetailsAccountNumber = 'event.created.source.sourceType.domesticWireSource.bankDetails.accountNumber',
    EventCreatedSourceSourceTypeAccountNumberSourceBankDetailsAccountNumber = 'event.created.source.sourceType.accountNumberSource.bankDetails.accountNumber',
    EventIncomingPaymentSettledSourceSourceTypeAchSourceBankDetailsAccountNumber = 'event.incomingPaymentSettled.source.sourceType.achSource.bankDetails.accountNumber',
    EventIncomingPaymentSettledSourceSourceTypeDomesticWireSourceBankDetailsAccountNumber = 'event.incomingPaymentSettled.source.sourceType.domesticWireSource.bankDetails.accountNumber',
    EventIncomingPaymentSettledSourceSourceTypeAccountNumberSourceBankDetailsAccountNumber = 'event.incomingPaymentSettled.source.sourceType.accountNumberSource.bankDetails.accountNumber'
}

export enum IxcFundingV1TransferQueryServiceTransferEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcFundingV1TransferQueryServiceTransferGetTransferGetRequest {
    /* Unique identifier for transfer */
    // format: id62
    transferId: string;
}

export interface IxcFundingV1TransferQueryServiceTransferListTransferListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcFundingV1TransferQueryServiceTransferListSearchableFields, IxcFundingV1TransferQueryServiceTransferListSortableFields, IxcFundingV1TransferQueryServiceTransferListFilterableFields>;
}

export enum IxcFundingV1TransferQueryServiceTransferListFilterableFields {
    TransferId = 'transferId',
    SourceId = 'sourceId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    DataSpecTransferTypeType = 'data.spec.transferType.!type',
    DataSourceIsPrimary = 'data.source.isPrimary',
    DataSourceSourceTypeType = 'data.source.sourceType.!type',
    Status = 'status'
}

export enum IxcFundingV1TransferQueryServiceTransferListSearchableFields {
    DataSourceSourceTypeAchSourceBankDetailsAccountNumber = 'data.source.sourceType.achSource.bankDetails.accountNumber',
    DataSourceSourceTypeDomesticWireSourceBankDetailsAccountNumber = 'data.source.sourceType.domesticWireSource.bankDetails.accountNumber',
    DataSourceSourceTypeAccountNumberSourceBankDetailsAccountNumber = 'data.source.sourceType.accountNumberSource.bankDetails.accountNumber'
}

export enum IxcFundingV1TransferQueryServiceTransferListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcFundingV1TransferSpec {
    /* Transfer amount in USD */
    // format: decimal
    amount: string;
    /* ACH Push (withdrawal), ACH Pull (deposit), wire push (withdrawal),
    incoming ACH credit (deposit) or incoming wire (deposit) */
    transferType: IxcFundingV1TransferType;
}

export interface IxcFundingV1TransferState extends IxcFundingV1TransferKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcFundingV1TransferData;
    status: IxcFundingV1TransferStatus;
}

export enum IxcFundingV1TransferStatus {
    Unspecified = 'UNSPECIFIED',
    Created = 'CREATED',
    Pending = 'PENDING',
    Processing = 'PROCESSING',
    Canceled = 'CANCELED',
    Rejected = 'REJECTED',
    Success = 'SUCCESS',
    Returned = 'RETURNED'
}

export enum IxcFundingV1TransferTaskOutcome {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Held = 'HELD',
    Success = 'SUCCESS',
    Error = 'ERROR'
}

export type IxcFundingV1TransferType = {
    '!type'?: 'achPush';
    /* An ACH Push to the source account */
    achPush: IxcFundingV1AchPush;
} | {
    '!type'?: 'achPull';
    /* An ACH Pull from the source account */
    achPull: IxcFundingV1AchPull;
} | {
    '!type'?: 'wirePush';
    /* A wire push to source account */
    wirePush: IxcFundingV1WirePush;
} | {
    '!type'?: 'incomingTransfer';
    /* An incoming transfer */
    incomingTransfer: IxcFundingV1IncomingTransfer;
};

export const IXC_FUNDING_V1_TRANSFER_TYPE_ONE_OF_VALUES = ['achPush', 'achPull', 'wirePush', 'incomingTransfer'] as const;

export type IxcFundingV1TransferTypeOneOfValue = (typeof IXC_FUNDING_V1_TRANSFER_TYPE_ONE_OF_VALUES)[number];

export interface IxcFundingV1UsBankDetails {
    // pattern: ^[0-9]{4,17}$
    accountNumber: string;
    /* The ABA routing number for the bank account. This is a 9-digit number
    that identifies the financial institution in the United States. */
    // pattern: ^[0-9]{9}$
    routingNumber: string;
    /* The name on the account, as known by the bank. */
    accountHolderName: string;
    accountType: IxcFundingV1BankAccountType;
}

export interface IxcFundingV1WirePush {
    beneficiary: IxcFundingV1NameAndAddress;
    /* Originator information required for customer wires but not clearing wires */
    originator?: IxcFundingV1NameAndAddress;
    messageToRecipient?: string;
}

export interface IxcGenerateV1DocumentDetails {
    /* Document ID of the generated monthly statement task */
    // format: id62
    documentId: string;
    /* Bucket the document was stored in */
    bucket: string;
    /* Key of the document */
    key: string;
    /* original documentID that is being replaced */
    // format: id62
    replacesId?: string;
}

export interface IxcGenerateV1Metrics {
    /* Total number of tasks in this job */
    // format: UINT32
    total?: number;
    /* Number of tasks waiting to be processed */
    // format: UINT32
    pending?: number;
    /* Number of tasks that have completed */
    // format: UINT32
    succeeded?: number;
    /* Number of tasks that encountered an error */
    // format: UINT32
    errored?: number;
    /* Number of tasks that failed for job termination */
    // format: UINT32
    failed?: number;
}

export interface IxcGenerateV1MonthlyStatementsJobData {
    spec: IxcGenerateV1MonthlyStatementsJobSpec;
    metrics: IxcGenerateV1Metrics;
}

export interface IxcGenerateV1MonthlyStatementsJobEvent extends IxcGenerateV1MonthlyStatementsJobKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcGenerateV1MonthlyStatementsJobEventType;
}

export type IxcGenerateV1MonthlyStatementsJobEventType = {
    '!type'?: 'created';
    created: IxcGenerateV1MonthlyStatementsJobEventTypeCreated;
} | {
    '!type'?: 'tasksCreated';
    tasksCreated: IxcGenerateV1MonthlyStatementsJobEventTypeTasksCreated;
} | {
    '!type'?: 'allCreated';
    allCreated: EmptyObject;
} | {
    '!type'?: 'metricsUpdated';
    metricsUpdated: IxcGenerateV1MonthlyStatementsJobEventTypeMetricsUpdated;
} | {
    '!type'?: 'allFinished';
    allFinished: IxcGenerateV1MonthlyStatementsJobEventTypeAllFinished;
} | {
    '!type'?: 'errored';
    errored: IxcGenerateV1MonthlyStatementsJobEventTypeErrored;
};

export interface IxcGenerateV1MonthlyStatementsJobEventTypeAllFinished {
    message?: string;
    /* Final task metrics at job completion */
    metrics?: IxcGenerateV1Metrics;
}

export interface IxcGenerateV1MonthlyStatementsJobEventTypeCreated {
    spec: IxcGenerateV1MonthlyStatementsJobSpec;
}

export interface IxcGenerateV1MonthlyStatementsJobEventTypeErrored {
    message?: string;
    /* Final task metrics at job completion */
    metrics?: IxcGenerateV1Metrics;
}

export interface IxcGenerateV1MonthlyStatementsJobEventTypeMetricsUpdated {
    // format: UINT32
    pending?: number;
    // format: UINT32
    succeeded?: number;
    // format: UINT32
    errored?: number;
    // format: UINT32
    failed?: number;
}

export interface IxcGenerateV1MonthlyStatementsJobEventTypeTasksCreated {
    // format: UINT32
    count: number;
}

export const IXC_GENERATE_V1_MONTHLY_STATEMENTS_JOB_EVENT_TYPE_ONE_OF_VALUES = ['created', 'tasksCreated', 'allCreated', 'metricsUpdated', 'allFinished', 'errored'] as const;

export type IxcGenerateV1MonthlyStatementsJobEventTypeOneOfValue = (typeof IXC_GENERATE_V1_MONTHLY_STATEMENTS_JOB_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcGenerateV1MonthlyStatementsJobKeys {
    /* Primary identifier */
    // format: id62
    jobId: string;
}

export interface IxcGenerateV1MonthlyStatementsJobQueryServiceMonthlyStatementsJobEventsMonthlyStatementsJobEventsRequest {
    /* Primary identifier */
    // format: id62
    jobId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcGenerateV1MonthlyStatementsJobQueryServiceMonthlyStatementsJobEventsSortableFields, IxcGenerateV1MonthlyStatementsJobQueryServiceMonthlyStatementsJobEventsFilterableFields>;
}

export enum IxcGenerateV1MonthlyStatementsJobQueryServiceMonthlyStatementsJobEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    JobId = 'jobId',
    EventType = 'event.!type'
}

export enum IxcGenerateV1MonthlyStatementsJobQueryServiceMonthlyStatementsJobEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcGenerateV1MonthlyStatementsJobQueryServiceMonthlyStatementsJobGetMonthlyStatementsJobGetRequest {
    /* Primary identifier */
    // format: id62
    jobId: string;
}

export interface IxcGenerateV1MonthlyStatementsJobQueryServiceMonthlyStatementsJobListMonthlyStatementsJobListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcGenerateV1MonthlyStatementsJobQueryServiceMonthlyStatementsJobListSortableFields, IxcGenerateV1MonthlyStatementsJobQueryServiceMonthlyStatementsJobListFilterableFields>;
}

export enum IxcGenerateV1MonthlyStatementsJobQueryServiceMonthlyStatementsJobListFilterableFields {
    JobId = 'jobId',
    Status = 'status'
}

export enum IxcGenerateV1MonthlyStatementsJobQueryServiceMonthlyStatementsJobListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcGenerateV1MonthlyStatementsJobSpec {
    /* The start date the monthly statements is generated for, in YYYY-MM-DD
    format. Generally, this is the first day of the month. */
    // format: YYYY-MM-DD
    startDate: string;
    /* The end date the monthly statements is generated for, in YYYY-MM-DD
    format. Generally, this is the last day of the month. */
    // format: YYYY-MM-DD
    endDate: string;
    /* revision number. A revision of 0 will be assigned for the first time a
    job is created. */
    // pattern: ^[0-9]{0,15}$
    revision?: string;
    /* When set, this job is a retry; tasks are created for the referenced job's non-succeeded accounts instead of the period's accounts. */
    // format: id62
    retryOfJobId?: string;
}

export interface IxcGenerateV1MonthlyStatementsJobState extends IxcGenerateV1MonthlyStatementsJobKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcGenerateV1MonthlyStatementsJobData;
    status: IxcGenerateV1MonthlyStatementsJobStatus;
}

export enum IxcGenerateV1MonthlyStatementsJobStatus {
    Unspecified = 'UNSPECIFIED',
    Processing = 'PROCESSING',
    Done = 'DONE',
    Failed = 'FAILED',
    Creating = 'CREATING'
}

export interface IxcGenerateV1MonthlyStatementsTaskData {
    spec: IxcGenerateV1MonthlyStatementsTaskSpec;
    /* When completed, this is the details of where the document is stored */
    documentDetails?: IxcGenerateV1DocumentDetails;
}

export interface IxcGenerateV1MonthlyStatementsTaskEvent extends IxcGenerateV1MonthlyStatementsTaskKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcGenerateV1MonthlyStatementsTaskEventType;
}

export type IxcGenerateV1MonthlyStatementsTaskEventType = {
    '!type'?: 'created';
    created: IxcGenerateV1MonthlyStatementsTaskEventTypeCreated;
} | {
    '!type'?: 'finished';
    finished: IxcGenerateV1MonthlyStatementsTaskEventTypeFinished;
} | {
    '!type'?: 'errored';
    errored: IxcGenerateV1MonthlyStatementsTaskEventTypeErrored;
} | {
    '!type'?: 'failed';
    failed: IxcGenerateV1MonthlyStatementsTaskEventTypeFailed;
};

export interface IxcGenerateV1MonthlyStatementsTaskEventTypeCreated {
    // format: id62
    jobId: string;
    spec: IxcGenerateV1MonthlyStatementsTaskSpec;
}

export interface IxcGenerateV1MonthlyStatementsTaskEventTypeErrored {
    /* Optional error message */
    message?: string;
}

export interface IxcGenerateV1MonthlyStatementsTaskEventTypeFailed {
    /* Optional error message */
    message?: string;
}

export interface IxcGenerateV1MonthlyStatementsTaskEventTypeFinished {
    /* When completed, this is the details of where the document is stored */
    details: IxcGenerateV1DocumentDetails;
    /* Document was created and uploaded to S3. It will be false if the
    document had already been generated in a previous job. */
    documentCreated?: boolean;
}

export const IXC_GENERATE_V1_MONTHLY_STATEMENTS_TASK_EVENT_TYPE_ONE_OF_VALUES = ['created', 'finished', 'errored', 'failed'] as const;

export type IxcGenerateV1MonthlyStatementsTaskEventTypeOneOfValue = (typeof IXC_GENERATE_V1_MONTHLY_STATEMENTS_TASK_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcGenerateV1MonthlyStatementsTaskKeys {
    /* Primary identifier */
    // format: id62
    taskId: string;
    /* Identifies the job this task belongs to */
    // format: id62, entity: ixc.generate.v1.MonthlyStatementsJob
    jobId: string;
    /* Identifies the program account */
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
    /* Identifies the brokerage account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
}

export interface IxcGenerateV1MonthlyStatementsTaskQueryServiceMonthlyStatementsTaskEventsMonthlyStatementsTaskEventsRequest {
    /* Primary identifier */
    // format: id62
    taskId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcGenerateV1MonthlyStatementsTaskQueryServiceMonthlyStatementsTaskEventsSortableFields, IxcGenerateV1MonthlyStatementsTaskQueryServiceMonthlyStatementsTaskEventsFilterableFields>;
}

export enum IxcGenerateV1MonthlyStatementsTaskQueryServiceMonthlyStatementsTaskEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    TaskId = 'taskId',
    JobId = 'jobId',
    ProgramId = 'programId',
    AccountId = 'accountId',
    EventType = 'event.!type'
}

export enum IxcGenerateV1MonthlyStatementsTaskQueryServiceMonthlyStatementsTaskEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcGenerateV1MonthlyStatementsTaskQueryServiceMonthlyStatementsTaskGetMonthlyStatementsTaskGetRequest {
    /* Primary identifier */
    // format: id62
    taskId: string;
}

export interface IxcGenerateV1MonthlyStatementsTaskQueryServiceMonthlyStatementsTaskListMonthlyStatementsTaskListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcGenerateV1MonthlyStatementsTaskQueryServiceMonthlyStatementsTaskListSortableFields, IxcGenerateV1MonthlyStatementsTaskQueryServiceMonthlyStatementsTaskListFilterableFields>;
}

export enum IxcGenerateV1MonthlyStatementsTaskQueryServiceMonthlyStatementsTaskListFilterableFields {
    TaskId = 'taskId',
    JobId = 'jobId',
    ProgramId = 'programId',
    AccountId = 'accountId',
    Status = 'status'
}

export enum IxcGenerateV1MonthlyStatementsTaskQueryServiceMonthlyStatementsTaskListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcGenerateV1MonthlyStatementsTaskSpec {
    /* The start date the monthly statement is generated for */
    // format: YYYY-MM-DD
    startDate: string;
    /* The end date the monthly statement is generated for. */
    // format: YYYY-MM-DD
    endDate: string;
    /* optional revision number. */
    // pattern: ^[0-9]{0,15}$
    revision?: string;
}

export interface IxcGenerateV1MonthlyStatementsTaskState extends IxcGenerateV1MonthlyStatementsTaskKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcGenerateV1MonthlyStatementsTaskData;
    status: IxcGenerateV1MonthlyStatementsTaskStatus;
}

export enum IxcGenerateV1MonthlyStatementsTaskStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Succeeded = 'SUCCEEDED',
    Errored = 'ERRORED',
    Failed = 'FAILED'
}

export enum IxcGenerateV1PreviewMonthlyStatementFileFormat {
    Unspecified = 'UNSPECIFIED',
    Html = 'HTML',
    Pdf = 'PDF'
}

export enum IxcGenerateV1PreviewTradeConfirmationFileFormat {
    Unspecified = 'UNSPECIFIED',
    Html = 'HTML',
    Pdf = 'PDF'
}

export interface IxcGenerateV1TradeConfirmationsJobData {
    spec: IxcGenerateV1TradeConfirmationsJobSpec;
    metrics: IxcGenerateV1Metrics;
}

export interface IxcGenerateV1TradeConfirmationsJobEvent extends IxcGenerateV1TradeConfirmationsJobKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcGenerateV1TradeConfirmationsJobEventType;
}

export type IxcGenerateV1TradeConfirmationsJobEventType = {
    '!type'?: 'created';
    created: IxcGenerateV1TradeConfirmationsJobEventTypeCreated;
} | {
    '!type'?: 'tasksCreated';
    tasksCreated: IxcGenerateV1TradeConfirmationsJobEventTypeTasksCreated;
} | {
    '!type'?: 'allCreated';
    allCreated: EmptyObject;
} | {
    '!type'?: 'metricsUpdated';
    metricsUpdated: IxcGenerateV1TradeConfirmationsJobEventTypeMetricsUpdated;
} | {
    '!type'?: 'allFinished';
    allFinished: IxcGenerateV1TradeConfirmationsJobEventTypeAllFinished;
} | {
    '!type'?: 'errored';
    errored: IxcGenerateV1TradeConfirmationsJobEventTypeErrored;
};

export interface IxcGenerateV1TradeConfirmationsJobEventTypeAllFinished {
    message?: string;
    /* Final task metrics at job completion */
    metrics?: IxcGenerateV1Metrics;
}

export interface IxcGenerateV1TradeConfirmationsJobEventTypeCreated {
    spec: IxcGenerateV1TradeConfirmationsJobSpec;
}

export interface IxcGenerateV1TradeConfirmationsJobEventTypeErrored {
    message?: string;
    /* Final task metrics at job completion */
    metrics?: IxcGenerateV1Metrics;
}

export interface IxcGenerateV1TradeConfirmationsJobEventTypeMetricsUpdated {
    // format: UINT32
    pending?: number;
    // format: UINT32
    succeeded?: number;
    // format: UINT32
    errored?: number;
    // format: UINT32
    failed?: number;
}

export interface IxcGenerateV1TradeConfirmationsJobEventTypeTasksCreated {
    // format: UINT32
    count: number;
}

export const IXC_GENERATE_V1_TRADE_CONFIRMATIONS_JOB_EVENT_TYPE_ONE_OF_VALUES = ['created', 'tasksCreated', 'allCreated', 'metricsUpdated', 'allFinished', 'errored'] as const;

export type IxcGenerateV1TradeConfirmationsJobEventTypeOneOfValue = (typeof IXC_GENERATE_V1_TRADE_CONFIRMATIONS_JOB_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcGenerateV1TradeConfirmationsJobKeys {
    /* Primary identifier */
    // format: id62
    jobId: string;
}

export interface IxcGenerateV1TradeConfirmationsJobQueryServiceTradeConfirmationsJobEventsTradeConfirmationsJobEventsRequest {
    /* Primary identifier */
    // format: id62
    jobId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcGenerateV1TradeConfirmationsJobQueryServiceTradeConfirmationsJobEventsSortableFields, IxcGenerateV1TradeConfirmationsJobQueryServiceTradeConfirmationsJobEventsFilterableFields>;
}

export enum IxcGenerateV1TradeConfirmationsJobQueryServiceTradeConfirmationsJobEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    JobId = 'jobId',
    EventType = 'event.!type'
}

export enum IxcGenerateV1TradeConfirmationsJobQueryServiceTradeConfirmationsJobEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcGenerateV1TradeConfirmationsJobQueryServiceTradeConfirmationsJobGetTradeConfirmationsJobGetRequest {
    /* Primary identifier */
    // format: id62
    jobId: string;
}

export interface IxcGenerateV1TradeConfirmationsJobQueryServiceTradeConfirmationsJobListTradeConfirmationsJobListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcGenerateV1TradeConfirmationsJobQueryServiceTradeConfirmationsJobListSortableFields, IxcGenerateV1TradeConfirmationsJobQueryServiceTradeConfirmationsJobListFilterableFields>;
}

export enum IxcGenerateV1TradeConfirmationsJobQueryServiceTradeConfirmationsJobListFilterableFields {
    JobId = 'jobId',
    Status = 'status'
}

export enum IxcGenerateV1TradeConfirmationsJobQueryServiceTradeConfirmationsJobListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcGenerateV1TradeConfirmationsJobSpec {
    /* The date the trade confirms is generated for, in YYYY-MM-DD format */
    // format: YYYY-MM-DD
    forDate: string;
    /* revision number. A revision of 0 will be assigned for the first time a
    job is created. */
    // pattern: ^[0-9]{0,15}$
    revision?: string;
    /* When set, this job is a retry; tasks are created for the referenced job's non-succeeded accounts instead of the day's trades. */
    // format: id62
    retryOfJobId?: string;
}

export interface IxcGenerateV1TradeConfirmationsJobState extends IxcGenerateV1TradeConfirmationsJobKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcGenerateV1TradeConfirmationsJobData;
    status: IxcGenerateV1TradeConfirmationsJobStatus;
}

export enum IxcGenerateV1TradeConfirmationsJobStatus {
    Unspecified = 'UNSPECIFIED',
    Processing = 'PROCESSING',
    Done = 'DONE',
    Failed = 'FAILED',
    Creating = 'CREATING'
}

export interface IxcGenerateV1TradeConfirmationsTaskData {
    spec: IxcGenerateV1TradeConfirmationsTaskSpec;
    /* When completed, this is the details of where the document is stored */
    documentDetails?: IxcGenerateV1DocumentDetails;
    /* When completed, total number of transactions for the day */
    // format: UINT32
    totalTransactions?: number;
}

export interface IxcGenerateV1TradeConfirmationsTaskEvent extends IxcGenerateV1TradeConfirmationsTaskKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcGenerateV1TradeConfirmationsTaskEventType;
}

export type IxcGenerateV1TradeConfirmationsTaskEventType = {
    '!type'?: 'created';
    created: IxcGenerateV1TradeConfirmationsTaskEventTypeCreated;
} | {
    '!type'?: 'finished';
    finished: IxcGenerateV1TradeConfirmationsTaskEventTypeFinished;
} | {
    '!type'?: 'errored';
    errored: IxcGenerateV1TradeConfirmationsTaskEventTypeErrored;
} | {
    '!type'?: 'failed';
    failed: IxcGenerateV1TradeConfirmationsTaskEventTypeFailed;
};

export interface IxcGenerateV1TradeConfirmationsTaskEventTypeCreated {
    // format: id62
    jobId: string;
    spec: IxcGenerateV1TradeConfirmationsTaskSpec;
}

export interface IxcGenerateV1TradeConfirmationsTaskEventTypeErrored {
    /* Optional error message */
    message?: string;
}

export interface IxcGenerateV1TradeConfirmationsTaskEventTypeFailed {
    /* Optional error message */
    message?: string;
}

export interface IxcGenerateV1TradeConfirmationsTaskEventTypeFinished {
    /* When completed, this is the details of where the document is stored */
    details: IxcGenerateV1DocumentDetails;
    /* Total number of transactions in the generated trade confirms task */
    // format: UINT32
    totalTransactions?: number;
    /* Document was created and uploaded to S3. It will be false if the
    document had already been generated in a previous job. */
    documentCreated?: boolean;
}

export const IXC_GENERATE_V1_TRADE_CONFIRMATIONS_TASK_EVENT_TYPE_ONE_OF_VALUES = ['created', 'finished', 'errored', 'failed'] as const;

export type IxcGenerateV1TradeConfirmationsTaskEventTypeOneOfValue = (typeof IXC_GENERATE_V1_TRADE_CONFIRMATIONS_TASK_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcGenerateV1TradeConfirmationsTaskKeys {
    /* Primary identifier */
    // format: id62
    taskId: string;
    /* Identifies the job this task belongs to */
    // format: id62, entity: ixc.generate.v1.TradeConfirmationsJob
    jobId: string;
    /* Identifies the program account */
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
    /* Identifies the brokerage account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
}

export interface IxcGenerateV1TradeConfirmationsTaskQueryServiceTradeConfirmationsTaskEventsTradeConfirmationsTaskEventsRequest {
    /* Primary identifier */
    // format: id62
    taskId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcGenerateV1TradeConfirmationsTaskQueryServiceTradeConfirmationsTaskEventsSortableFields, IxcGenerateV1TradeConfirmationsTaskQueryServiceTradeConfirmationsTaskEventsFilterableFields>;
}

export enum IxcGenerateV1TradeConfirmationsTaskQueryServiceTradeConfirmationsTaskEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    TaskId = 'taskId',
    JobId = 'jobId',
    ProgramId = 'programId',
    AccountId = 'accountId',
    EventType = 'event.!type'
}

export enum IxcGenerateV1TradeConfirmationsTaskQueryServiceTradeConfirmationsTaskEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcGenerateV1TradeConfirmationsTaskQueryServiceTradeConfirmationsTaskGetTradeConfirmationsTaskGetRequest {
    /* Primary identifier */
    // format: id62
    taskId: string;
}

export interface IxcGenerateV1TradeConfirmationsTaskQueryServiceTradeConfirmationsTaskListTradeConfirmationsTaskListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcGenerateV1TradeConfirmationsTaskQueryServiceTradeConfirmationsTaskListSortableFields, IxcGenerateV1TradeConfirmationsTaskQueryServiceTradeConfirmationsTaskListFilterableFields>;
}

export enum IxcGenerateV1TradeConfirmationsTaskQueryServiceTradeConfirmationsTaskListFilterableFields {
    TaskId = 'taskId',
    JobId = 'jobId',
    ProgramId = 'programId',
    AccountId = 'accountId',
    Status = 'status'
}

export enum IxcGenerateV1TradeConfirmationsTaskQueryServiceTradeConfirmationsTaskListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcGenerateV1TradeConfirmationsTaskSpec {
    /* The date the trade confirms is generated for, in YYYY-MM-DD format */
    // format: YYYY-MM-DD
    tradeDate: string;
    /* revision number of the job this task belongs to */
    // pattern: ^[0-9]{0,15}$
    revision?: string;
}

export interface IxcGenerateV1TradeConfirmationsTaskState extends IxcGenerateV1TradeConfirmationsTaskKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcGenerateV1TradeConfirmationsTaskData;
    status: IxcGenerateV1TradeConfirmationsTaskStatus;
}

export enum IxcGenerateV1TradeConfirmationsTaskStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Succeeded = 'SUCCEEDED',
    Errored = 'ERRORED',
    Failed = 'FAILED'
}

export interface IxcInventoryV1Balance {
    /* Total cumulative quantity */
    // format: decimal
    quantity: string;
    /* Total cumulative cost/proceed */
    // format: decimal
    value: string;
}

export type IxcInventoryV1BooksOrderAmount = {
    '!type'?: 'quantity';
    // format: decimal
    quantity: string;
} | {
    '!type'?: 'notional';
    // format: decimal
    notional: string;
};

export const IXC_INVENTORY_V1_BOOKS_ORDER_AMOUNT_ONE_OF_VALUES = ['quantity', 'notional'] as const;

export type IxcInventoryV1BooksOrderAmountOneOfValue = (typeof IXC_INVENTORY_V1_BOOKS_ORDER_AMOUNT_ONE_OF_VALUES)[number];

export interface IxcInventoryV1BooksOrderData {
    asset: IxcAssetsV1AssetState;
    spec: IxcInventoryV1BooksOrderSpec;
    principalExecution?: IxcInventoryV1Execution;
    risklessPrincipalExecution?: IxcInventoryV1Execution;
    request?: J5MessagingV1RequestMetadata;
    /* Dollar amount of the total order (quantity * price), no fees considered */
    // format: decimal
    grossAmount?: string;
    kind?: IxcInventoryV1BooksOrderKind;
    /* Populated for mixed capacity orders */
    // format: id62
    firmOrderId?: string;
    /* The amount for this order that's filled principally */
    principalAmount?: IxcInventoryV1BooksOrderAmount;
    /* time this order was queued */
    // format: date-time
    queuedAt?: string;
    firmOrderOutcome?: IxcInventoryV1FirmOrderOutcome;
    symbol?: string;
}

export interface IxcInventoryV1BooksOrderEvent extends IxcInventoryV1BooksOrderKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcInventoryV1BooksOrderEventType;
}

export type IxcInventoryV1BooksOrderEventType = {
    '!type'?: 'requested';
    requested: IxcInventoryV1BooksOrderEventTypeRequested;
} | {
    '!type'?: 'purePrincipalRequested';
    purePrincipalRequested: IxcInventoryV1BooksOrderEventTypePurePrincipalRequested;
} | {
    '!type'?: 'mixedCapacityRequested';
    mixedCapacityRequested: IxcInventoryV1BooksOrderEventTypeMixedCapacityRequested;
} | {
    '!type'?: 'firmNotFilled';
    firmNotFilled: IxcInventoryV1BooksOrderEventTypeFirmNotFilled;
} | {
    '!type'?: 'firmFilled';
    firmFilled: IxcInventoryV1BooksOrderEventTypeFirmFilled;
} | {
    '!type'?: 'mixedCapacityExecuted';
    mixedCapacityExecuted: IxcInventoryV1BooksOrderEventTypeMixedCapacityExecuted;
} | {
    '!type'?: 'executed';
    executed: IxcInventoryV1BooksOrderEventTypeExecuted;
} | {
    '!type'?: 'quoteReceived';
    quoteReceived: IxcInventoryV1BooksOrderEventTypeQuoteReceived;
} | {
    '!type'?: 'cancel';
    cancel: EmptyObject;
} | {
    '!type'?: 'canceled';
    canceled: EmptyObject;
} | {
    '!type'?: 'quoteRequested';
    quoteRequested: EmptyObject;
} | {
    '!type'?: 'queued';
    queued: IxcInventoryV1BooksOrderEventTypeQueued;
} | {
    '!type'?: 'dequeued';
    dequeued: IxcInventoryV1BooksOrderEventTypeDequeued;
};

export interface IxcInventoryV1BooksOrderEventTypeDequeued {
    // format: decimal
    price: string;
    priceSource: IxcInventoryV1PriceSource;
}

export interface IxcInventoryV1BooksOrderEventTypeExecuted {
    execution: IxcInventoryV1Execution;
}

export interface IxcInventoryV1BooksOrderEventTypeFirmFilled {
    outcome: IxcInventoryV1FirmOrderOutcome;
    // format: id62
    firmOrderId: string;
}

export interface IxcInventoryV1BooksOrderEventTypeFirmNotFilled {
    outcome: IxcInventoryV1FirmOrderOutcome;
    // format: id62
    firmOrderId: string;
}

export interface IxcInventoryV1BooksOrderEventTypeMixedCapacityExecuted {
    principalLeg?: IxcInventoryV1BooksOrderEventTypeMixedCapacityExecutedPrincipalLeg;
    remainderLeg?: IxcInventoryV1BooksOrderEventTypeMixedCapacityExecutedRemainderLeg;
    risklessLeg?: IxcInventoryV1BooksOrderEventTypeMixedCapacityExecutedRisklessLeg;
    /* Customer-level fill outcome carried from the firm order's allocation,
    echoed on the BooksOrderReply. */
    outcome: IxcInventoryV1BooksOrderOutcome;
}

export interface IxcInventoryV1BooksOrderEventTypeMixedCapacityExecutedPrincipalLeg {
    execution: IxcInventoryV1Execution;
    customer: IxcInventoryV1CustomerTrade;
}

export interface IxcInventoryV1BooksOrderEventTypeMixedCapacityExecutedRemainderLeg {
    execution: IxcInventoryV1Execution;
    inventory: IxcInventoryV1InventoryTrade;
}

export interface IxcInventoryV1BooksOrderEventTypeMixedCapacityExecutedRisklessLeg {
    execution: IxcInventoryV1Execution;
    inventory: IxcInventoryV1InventoryTrade;
    customer: IxcInventoryV1CustomerTrade;
}

export interface IxcInventoryV1BooksOrderEventTypeMixedCapacityRequested {
    request: J5MessagingV1RequestMetadata;
    spec: IxcInventoryV1BooksOrderSpec;
    asset: IxcAssetsV1AssetState;
}

export interface IxcInventoryV1BooksOrderEventTypePurePrincipalRequested {
    request: J5MessagingV1RequestMetadata;
    spec: IxcInventoryV1BooksOrderSpec;
    asset: IxcAssetsV1AssetState;
}

export interface IxcInventoryV1BooksOrderEventTypeQueued {
    /* Inventory available at queue time */
    // format: decimal
    available?: string;
}

export interface IxcInventoryV1BooksOrderEventTypeQuoteReceived {
    /* Absent when the quote lookup failed */
    quote?: IxcQuoteV1Quote;
    /* Quote service outcome, recorded for audit of the price source */
    outcome?: IxcQuoteV1QuoteOutcome;
    // format: decimal
    available?: string;
    /* other orders are queued for this asset, drives requeuing */
    assetHasQueuedOrders?: boolean;
}

export interface IxcInventoryV1BooksOrderEventTypeRequested {
    request: J5MessagingV1RequestMetadata;
    spec: IxcInventoryV1BooksOrderSpec;
    asset: IxcAssetsV1AssetState;
}

export const IXC_INVENTORY_V1_BOOKS_ORDER_EVENT_TYPE_ONE_OF_VALUES = ['requested', 'purePrincipalRequested', 'mixedCapacityRequested', 'firmNotFilled', 'firmFilled', 'mixedCapacityExecuted', 'executed', 'quoteReceived', 'cancel', 'canceled', 'quoteRequested', 'queued', 'dequeued'] as const;

export type IxcInventoryV1BooksOrderEventTypeOneOfValue = (typeof IXC_INVENTORY_V1_BOOKS_ORDER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcInventoryV1BooksOrderKeys {
    // format: id62
    booksOrderId: string;
    // format: id62, entity: ixc.orders.v1.Order
    orderId?: string;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
}

export enum IxcInventoryV1BooksOrderKind {
    Unspecified = 'UNSPECIFIED',
    Principal = 'PRINCIPAL',
    MixedCapacity = 'MIXED_CAPACITY'
}

export enum IxcInventoryV1BooksOrderOutcome {
    Unspecified = 'UNSPECIFIED',
    Success = 'SUCCESS',
    NotFilled = 'NOT_FILLED',
    PartiallyFilled = 'PARTIALLY_FILLED'
}

export interface IxcInventoryV1BooksOrderQueryServiceBooksOrderEventsBooksOrderEventsRequest {
    // format: id62
    booksOrderId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcInventoryV1BooksOrderQueryServiceBooksOrderEventsSearchableFields, IxcInventoryV1BooksOrderQueryServiceBooksOrderEventsSortableFields, IxcInventoryV1BooksOrderQueryServiceBooksOrderEventsFilterableFields>;
}

export enum IxcInventoryV1BooksOrderQueryServiceBooksOrderEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    BooksOrderId = 'booksOrderId',
    OrderId = 'orderId',
    AssetId = 'assetId',
    EventRequestedSpecSide = 'event.requested.spec.side',
    EventRequestedSpecPriceSource = 'event.requested.spec.priceSource',
    EventRequestedAssetAssetId = 'event.requested.asset.assetId',
    EventRequestedAssetDataTypeEquityCusip = 'event.requested.asset.data.type.equity.cusip',
    EventRequestedAssetDataTypeEquityControlsCanBuy = 'event.requested.asset.data.type.equity.controls.canBuy',
    EventRequestedAssetDataTypeEquityControlsCanSell = 'event.requested.asset.data.type.equity.controls.canSell',
    EventRequestedAssetDataTypeEquityControlsCanEnterFractions = 'event.requested.asset.data.type.equity.controls.canEnterFractions',
    EventRequestedAssetDataTypeMoneyMarketCusip = 'event.requested.asset.data.type.moneyMarket.cusip',
    EventRequestedAssetDataTypeMoneyMarketControlsCanBuy = 'event.requested.asset.data.type.moneyMarket.controls.canBuy',
    EventRequestedAssetDataTypeMoneyMarketControlsCanSell = 'event.requested.asset.data.type.moneyMarket.controls.canSell',
    EventRequestedAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.requested.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventRequestedAssetDataTypeMoneyMarketClassification = 'event.requested.asset.data.type.moneyMarket.classification',
    EventRequestedAssetDataTypeMoneyMarketNavType = 'event.requested.asset.data.type.moneyMarket.navType',
    EventRequestedAssetDataTypeType = 'event.requested.asset.data.type.!type',
    EventRequestedAssetDataCategory = 'event.requested.asset.data.category',
    EventRequestedAssetStatus = 'event.requested.asset.status',
    EventPurePrincipalRequestedSpecSide = 'event.purePrincipalRequested.spec.side',
    EventPurePrincipalRequestedSpecPriceSource = 'event.purePrincipalRequested.spec.priceSource',
    EventPurePrincipalRequestedAssetAssetId = 'event.purePrincipalRequested.asset.assetId',
    EventPurePrincipalRequestedAssetDataTypeEquityCusip = 'event.purePrincipalRequested.asset.data.type.equity.cusip',
    EventPurePrincipalRequestedAssetDataTypeEquityControlsCanBuy = 'event.purePrincipalRequested.asset.data.type.equity.controls.canBuy',
    EventPurePrincipalRequestedAssetDataTypeEquityControlsCanSell = 'event.purePrincipalRequested.asset.data.type.equity.controls.canSell',
    EventPurePrincipalRequestedAssetDataTypeEquityControlsCanEnterFractions = 'event.purePrincipalRequested.asset.data.type.equity.controls.canEnterFractions',
    EventPurePrincipalRequestedAssetDataTypeMoneyMarketCusip = 'event.purePrincipalRequested.asset.data.type.moneyMarket.cusip',
    EventPurePrincipalRequestedAssetDataTypeMoneyMarketControlsCanBuy = 'event.purePrincipalRequested.asset.data.type.moneyMarket.controls.canBuy',
    EventPurePrincipalRequestedAssetDataTypeMoneyMarketControlsCanSell = 'event.purePrincipalRequested.asset.data.type.moneyMarket.controls.canSell',
    EventPurePrincipalRequestedAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.purePrincipalRequested.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventPurePrincipalRequestedAssetDataTypeMoneyMarketClassification = 'event.purePrincipalRequested.asset.data.type.moneyMarket.classification',
    EventPurePrincipalRequestedAssetDataTypeMoneyMarketNavType = 'event.purePrincipalRequested.asset.data.type.moneyMarket.navType',
    EventPurePrincipalRequestedAssetDataTypeType = 'event.purePrincipalRequested.asset.data.type.!type',
    EventPurePrincipalRequestedAssetDataCategory = 'event.purePrincipalRequested.asset.data.category',
    EventPurePrincipalRequestedAssetStatus = 'event.purePrincipalRequested.asset.status',
    EventMixedCapacityRequestedSpecSide = 'event.mixedCapacityRequested.spec.side',
    EventMixedCapacityRequestedSpecPriceSource = 'event.mixedCapacityRequested.spec.priceSource',
    EventMixedCapacityRequestedAssetAssetId = 'event.mixedCapacityRequested.asset.assetId',
    EventMixedCapacityRequestedAssetDataTypeEquityCusip = 'event.mixedCapacityRequested.asset.data.type.equity.cusip',
    EventMixedCapacityRequestedAssetDataTypeEquityControlsCanBuy = 'event.mixedCapacityRequested.asset.data.type.equity.controls.canBuy',
    EventMixedCapacityRequestedAssetDataTypeEquityControlsCanSell = 'event.mixedCapacityRequested.asset.data.type.equity.controls.canSell',
    EventMixedCapacityRequestedAssetDataTypeEquityControlsCanEnterFractions = 'event.mixedCapacityRequested.asset.data.type.equity.controls.canEnterFractions',
    EventMixedCapacityRequestedAssetDataTypeMoneyMarketCusip = 'event.mixedCapacityRequested.asset.data.type.moneyMarket.cusip',
    EventMixedCapacityRequestedAssetDataTypeMoneyMarketControlsCanBuy = 'event.mixedCapacityRequested.asset.data.type.moneyMarket.controls.canBuy',
    EventMixedCapacityRequestedAssetDataTypeMoneyMarketControlsCanSell = 'event.mixedCapacityRequested.asset.data.type.moneyMarket.controls.canSell',
    EventMixedCapacityRequestedAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.mixedCapacityRequested.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventMixedCapacityRequestedAssetDataTypeMoneyMarketClassification = 'event.mixedCapacityRequested.asset.data.type.moneyMarket.classification',
    EventMixedCapacityRequestedAssetDataTypeMoneyMarketNavType = 'event.mixedCapacityRequested.asset.data.type.moneyMarket.navType',
    EventMixedCapacityRequestedAssetDataTypeType = 'event.mixedCapacityRequested.asset.data.type.!type',
    EventMixedCapacityRequestedAssetDataCategory = 'event.mixedCapacityRequested.asset.data.category',
    EventMixedCapacityRequestedAssetStatus = 'event.mixedCapacityRequested.asset.status',
    EventType = 'event.!type'
}

export enum IxcInventoryV1BooksOrderQueryServiceBooksOrderEventsSearchableFields {
    EventRequestedAssetDataTypeEquitySymbolBase = 'event.requested.asset.data.type.equity.symbol.base',
    EventRequestedAssetDataTypeEquityName = 'event.requested.asset.data.type.equity.name',
    EventRequestedAssetDataTypeMoneyMarketSymbolBase = 'event.requested.asset.data.type.moneyMarket.symbol.base',
    EventRequestedAssetDataTypeMoneyMarketName = 'event.requested.asset.data.type.moneyMarket.name',
    EventPurePrincipalRequestedAssetDataTypeEquitySymbolBase = 'event.purePrincipalRequested.asset.data.type.equity.symbol.base',
    EventPurePrincipalRequestedAssetDataTypeEquityName = 'event.purePrincipalRequested.asset.data.type.equity.name',
    EventPurePrincipalRequestedAssetDataTypeMoneyMarketSymbolBase = 'event.purePrincipalRequested.asset.data.type.moneyMarket.symbol.base',
    EventPurePrincipalRequestedAssetDataTypeMoneyMarketName = 'event.purePrincipalRequested.asset.data.type.moneyMarket.name',
    EventMixedCapacityRequestedAssetDataTypeEquitySymbolBase = 'event.mixedCapacityRequested.asset.data.type.equity.symbol.base',
    EventMixedCapacityRequestedAssetDataTypeEquityName = 'event.mixedCapacityRequested.asset.data.type.equity.name',
    EventMixedCapacityRequestedAssetDataTypeMoneyMarketSymbolBase = 'event.mixedCapacityRequested.asset.data.type.moneyMarket.symbol.base',
    EventMixedCapacityRequestedAssetDataTypeMoneyMarketName = 'event.mixedCapacityRequested.asset.data.type.moneyMarket.name'
}

export enum IxcInventoryV1BooksOrderQueryServiceBooksOrderEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventRequestedAssetMetadataCreatedAt = 'event.requested.asset.metadata.createdAt',
    EventRequestedAssetMetadataUpdatedAt = 'event.requested.asset.metadata.updatedAt',
    EventPurePrincipalRequestedAssetMetadataCreatedAt = 'event.purePrincipalRequested.asset.metadata.createdAt',
    EventPurePrincipalRequestedAssetMetadataUpdatedAt = 'event.purePrincipalRequested.asset.metadata.updatedAt',
    EventMixedCapacityRequestedAssetMetadataCreatedAt = 'event.mixedCapacityRequested.asset.metadata.createdAt',
    EventMixedCapacityRequestedAssetMetadataUpdatedAt = 'event.mixedCapacityRequested.asset.metadata.updatedAt'
}

export interface IxcInventoryV1BooksOrderQueryServiceBooksOrderGetBooksOrderGetRequest {
    // format: id62
    booksOrderId: string;
}

export interface IxcInventoryV1BooksOrderQueryServiceBooksOrderListBooksOrderListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcInventoryV1BooksOrderQueryServiceBooksOrderListSearchableFields, IxcInventoryV1BooksOrderQueryServiceBooksOrderListSortableFields, IxcInventoryV1BooksOrderQueryServiceBooksOrderListFilterableFields>;
}

export enum IxcInventoryV1BooksOrderQueryServiceBooksOrderListFilterableFields {
    BooksOrderId = 'booksOrderId',
    OrderId = 'orderId',
    AssetId = 'assetId',
    DataAssetAssetId = 'data.asset.assetId',
    DataAssetDataTypeEquityCusip = 'data.asset.data.type.equity.cusip',
    DataAssetDataTypeEquityControlsCanBuy = 'data.asset.data.type.equity.controls.canBuy',
    DataAssetDataTypeEquityControlsCanSell = 'data.asset.data.type.equity.controls.canSell',
    DataAssetDataTypeEquityControlsCanEnterFractions = 'data.asset.data.type.equity.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketCusip = 'data.asset.data.type.moneyMarket.cusip',
    DataAssetDataTypeMoneyMarketControlsCanBuy = 'data.asset.data.type.moneyMarket.controls.canBuy',
    DataAssetDataTypeMoneyMarketControlsCanSell = 'data.asset.data.type.moneyMarket.controls.canSell',
    DataAssetDataTypeMoneyMarketControlsCanEnterFractions = 'data.asset.data.type.moneyMarket.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketClassification = 'data.asset.data.type.moneyMarket.classification',
    DataAssetDataTypeMoneyMarketNavType = 'data.asset.data.type.moneyMarket.navType',
    DataAssetDataTypeType = 'data.asset.data.type.!type',
    DataAssetDataCategory = 'data.asset.data.category',
    DataAssetStatus = 'data.asset.status',
    DataSpecSide = 'data.spec.side',
    DataSpecPriceSource = 'data.spec.priceSource',
    Status = 'status'
}

export enum IxcInventoryV1BooksOrderQueryServiceBooksOrderListSearchableFields {
    DataAssetDataTypeEquitySymbolBase = 'data.asset.data.type.equity.symbol.base',
    DataAssetDataTypeEquityName = 'data.asset.data.type.equity.name',
    DataAssetDataTypeMoneyMarketSymbolBase = 'data.asset.data.type.moneyMarket.symbol.base',
    DataAssetDataTypeMoneyMarketName = 'data.asset.data.type.moneyMarket.name'
}

export enum IxcInventoryV1BooksOrderQueryServiceBooksOrderListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataAssetMetadataCreatedAt = 'data.asset.metadata.createdAt',
    DataAssetMetadataUpdatedAt = 'data.asset.metadata.updatedAt'
}

export interface IxcInventoryV1BooksOrderSpec {
    // format: id62
    accountId: string;
    side: IxcOrdersV1Side;
    amount: IxcInventoryV1BooksOrderAmount;
    /* Per-share price */
    // format: decimal
    price: string;
    priceSource: IxcInventoryV1PriceSource;
}

export interface IxcInventoryV1BooksOrderState extends IxcInventoryV1BooksOrderKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcInventoryV1BooksOrderData;
    status: IxcInventoryV1BooksOrderStatus;
}

export enum IxcInventoryV1BooksOrderStatus {
    Unspecified = 'UNSPECIFIED',
    Requested = 'REQUESTED',
    AwaitingFirmFill = 'AWAITING_FIRM_FILL',
    Executed = 'EXECUTED',
    AwaitingQuote = 'AWAITING_QUOTE',
    AwaitingInventory = 'AWAITING_INVENTORY',
    Canceling = 'CANCELING',
    Canceled = 'CANCELED',
    NotFilled = 'NOT_FILLED'
}

export interface IxcInventoryV1CloseTradingDayTransaction {
    // format: YYYY-MM-DD
    tradingDate: string;
    // format: YYYY-MM-DD
    settlementDate: string;
    // format: informal
    symbol: string;
    // format: informal
    cusip: string;
    // format: id62
    assetId: string;
    tradeTotals: IxcInventoryV1TradeTotals;
    dailyTotals: IxcInventoryV1FullDayTotals;
    /* If true, the transaction is recognising P&L for a trading day which is
    already settled, i.e. a SettleTradingDayTransaction with
    ProvisionalTotals has been posted */
    settledWhenPosted?: boolean;
}

export interface IxcInventoryV1CorporateActionAdjustmentData {
    // format: id62
    actionId: string;
    /* set on non-main assignment only */
    // format: id62
    assignmentId?: string;
    /* Positive increases the position balance */
    // format: decimal
    balanceDelta: string;
    /* Positive increases the cost */
    // format: decimal
    costDelta?: string;
}

export interface IxcInventoryV1CustomerOrder {
    // format: id62, entity: ixc.orders.v1.Order
    orderId: string;
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    capacity: IxcInventoryV1FirmOrderCapacity;
}

export interface IxcInventoryV1CustomerTrade {
    // format: id62, entity: ixc.orders.v1.Order
    customerOrderId: string;
    /* generated by the Firm order, or from the books order where it is
    initiating. */
    // format: id62, entity: ixc.inventory.v1.BooksOrder
    booksOrderId: string;
    /* Trade details from the customer's perspective, e.g. a buy trade is
    inventory selling to match the customer's buy */
    trade: IxcInventoryV1TradeDetail;
}

export interface IxcInventoryV1Execution {
    // format: id62
    executionId: string;
    // format: date-time
    executionTime: string;
    // format: decimal
    quantity: string;
    /* Per-share price */
    // format: decimal
    price: string;
    /* Dollar amount of the total execution */
    // format: decimal
    amount: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settlementDate: string;
    priceSource?: IxcInventoryV1PriceSource;
}

export enum IxcInventoryV1FirmOrderCapacity {
    Unspecified = 'UNSPECIFIED',
    RisklessPrincipal = 'RISKLESS_PRINCIPAL',
    Principal = 'PRINCIPAL'
}

export interface IxcInventoryV1FirmOrderData {
    // format: id62
    parentBooksOrderId?: string;
    instruction: IxcInventoryV1OrderInstruction;
    // format: id62
    fixOrderId?: string;
    asset?: IxcAssetsV1AssetState;
    // format: decimal
    totalQuantity?: string;
    // format: decimal
    totalPrice?: string;
    // format: decimal
    averagePrice?: string;
    /* When set, links to a customer order in the orders service. Fix orders
    will use the given capacity, otherwise uses PRINCIPAL, i.e., order is for
    the firm's own account when this field is null. */
    customerOrder?: IxcInventoryV1CustomerOrder;
    canceled?: IxcInventoryV1FirmOrderDataCanceled;
    fills?: IxcInventoryV1FirmOrderFill[];
    kind?: IxcInventoryV1FirmOrderKind;
}

export interface IxcInventoryV1FirmOrderDataCanceled {
    // format: decimal
    cumulativeQuantity?: string;
    solicited?: boolean;
}

export interface IxcInventoryV1FirmOrderEvent extends IxcInventoryV1FirmOrderKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcInventoryV1FirmOrderEventType;
}

export type IxcInventoryV1FirmOrderEventType = {
    '!type'?: 'submitted';
    submitted: IxcInventoryV1FirmOrderEventTypeSubmitted;
} | {
    '!type'?: 'routeExternal';
    routeExternal: IxcInventoryV1FirmOrderEventTypeRouteExternal;
} | {
    '!type'?: 'cancelRequested';
    cancelRequested: IxcInventoryV1FirmOrderEventTypeCancelRequested;
} | {
    '!type'?: 'routeCanceled';
    routeCanceled: IxcInventoryV1FirmOrderEventTypeRouteCanceled;
} | {
    '!type'?: 'rejected';
    rejected: IxcInventoryV1FirmOrderEventTypeRejected;
} | {
    '!type'?: 'fill';
    fill: IxcInventoryV1FirmOrderEventTypeFill;
} | {
    '!type'?: 'done';
    done: IxcInventoryV1FirmOrderEventTypeDone;
} | {
    '!type'?: 'allocationExpected';
    allocationExpected: EmptyObject;
} | {
    '!type'?: 'allocationRequested';
    allocationRequested: IxcInventoryV1FirmOrderEventTypeAllocationRequested;
} | {
    '!type'?: 'allocated';
    allocated: IxcInventoryV1FirmOrderEventTypeAllocated;
};

export interface IxcInventoryV1FirmOrderEventTypeAllocated {
    /* The reqres request metadata for the originating BooksOrderRequest, so
    this machine can reply on BooksOrderReply once the allocation posts. */
    request: J5MessagingV1RequestMetadata;
    spec: IxcInventoryV1BooksOrderSpec;
    principalLeg?: IxcInventoryV1FirmOrderEventTypeAllocatedPrincipalLeg;
    risklessLeg?: IxcInventoryV1FirmOrderEventTypeAllocatedRisklessLeg;
    remainderLeg?: IxcInventoryV1FirmOrderEventTypeAllocatedRemainderLeg;
    /* Customer-level fill outcome decided at allocation time. SUCCESS when
    the legs cover the customer's full requested amount; PARTIALLY_FILLED
    when the street order partially filled and the
    >=1-share residual is not covered from inventory, so the legs fall
    short of the request. */
    outcome: IxcInventoryV1BooksOrderOutcome;
}

export interface IxcInventoryV1FirmOrderEventTypeAllocatedPrincipalLeg {
    execution: IxcInventoryV1Execution;
    customer: IxcInventoryV1CustomerTrade;
}

export interface IxcInventoryV1FirmOrderEventTypeAllocatedRemainderLeg {
    execution: IxcInventoryV1Execution;
    inventory: IxcInventoryV1InventoryTrade;
}

export interface IxcInventoryV1FirmOrderEventTypeAllocatedRisklessLeg {
    execution: IxcInventoryV1Execution;
    inventory: IxcInventoryV1InventoryTrade;
    customer: IxcInventoryV1CustomerTrade;
}

export interface IxcInventoryV1FirmOrderEventTypeAllocationRequested {
    /* The reqres request metadata for the originating BooksOrderRequest, so
    this machine can reply on BooksOrderReply once the allocation posts. */
    request: J5MessagingV1RequestMetadata;
    spec: IxcInventoryV1BooksOrderSpec;
}

export interface IxcInventoryV1FirmOrderEventTypeCancelRequested {
    reason?: string;
}

export interface IxcInventoryV1FirmOrderEventTypeDone {
    // format: decimal
    averagePrice: string;
    // format: decimal
    totalQuantity: string;
    outcome?: IxcInventoryV1FirmOrderOutcomeOutcome;
}

export interface IxcInventoryV1FirmOrderEventTypeFill {
    /* From the fix and UTC messages */
    // format: informal
    executionId: string;
    // format: id62
    transactionId: string;
    // format: date-time
    executionTime: string;
    // format: decimal
    quantity: string;
    // format: decimal
    price: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settlementDate: string;
}

export interface IxcInventoryV1FirmOrderEventTypeRejected {
    reasonText: string;
    reasonCode: IxcOrdersV1OrderRejectionCode;
}

export interface IxcInventoryV1FirmOrderEventTypeRouteCanceled {
    // format: decimal
    cumulativeQuantity?: string;
    solicited?: boolean;
}

export interface IxcInventoryV1FirmOrderEventTypeRouteExternal {
    // format: id62
    fixOrderId: string;
    instruction: IxcInventoryV1OrderInstruction;
}

export interface IxcInventoryV1FirmOrderEventTypeSubmitted {
    instruction: IxcInventoryV1OrderInstruction;
    asset: IxcAssetsV1AssetState;
    /* Links this firm order to a customer order for exclusion from balances
    and reporting */
    customerOrder?: IxcInventoryV1CustomerOrder;
    // format: id62
    parentBooksOrderId?: string;
    kind?: IxcInventoryV1FirmOrderKind;
}

export const IXC_INVENTORY_V1_FIRM_ORDER_EVENT_TYPE_ONE_OF_VALUES = ['submitted', 'routeExternal', 'cancelRequested', 'routeCanceled', 'rejected', 'fill', 'done', 'allocationExpected', 'allocationRequested', 'allocated'] as const;

export type IxcInventoryV1FirmOrderEventTypeOneOfValue = (typeof IXC_INVENTORY_V1_FIRM_ORDER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcInventoryV1FirmOrderFill {
    /* From the fix and UTC messages */
    // format: informal
    executionId: string;
    // format: id62
    transactionId: string;
    // format: date-time
    executionTime: string;
    // format: decimal
    quantity: string;
    // format: decimal
    price: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settlementDate: string;
}

export interface IxcInventoryV1FirmOrderKeys {
    // format: id62
    firmOrderId: string;
}

export enum IxcInventoryV1FirmOrderKind {
    Unspecified = 'UNSPECIFIED',
    Replenish = 'REPLENISH'
}

export interface IxcInventoryV1FirmOrderOutcome {
    // format: decimal
    averagePrice: string;
    // format: decimal
    totalQuantity: string;
    outcome?: IxcInventoryV1FirmOrderOutcomeOutcome;
}

export enum IxcInventoryV1FirmOrderOutcomeOutcome {
    Unspecified = 'UNSPECIFIED',
    FullyFilled = 'FULLY_FILLED',
    NotFilled = 'NOT_FILLED',
    PartiallyFilled = 'PARTIALLY_FILLED'
}

export interface IxcInventoryV1FirmOrderQueryServiceFirmOrderEventsFirmOrderEventsRequest {
    // format: id62
    firmOrderId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcInventoryV1FirmOrderQueryServiceFirmOrderEventsSearchableFields, IxcInventoryV1FirmOrderQueryServiceFirmOrderEventsSortableFields, IxcInventoryV1FirmOrderQueryServiceFirmOrderEventsFilterableFields>;
}

export enum IxcInventoryV1FirmOrderQueryServiceFirmOrderEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    FirmOrderId = 'firmOrderId',
    EventSubmittedAssetAssetId = 'event.submitted.asset.assetId',
    EventSubmittedAssetDataTypeEquityCusip = 'event.submitted.asset.data.type.equity.cusip',
    EventSubmittedAssetDataTypeEquityControlsCanBuy = 'event.submitted.asset.data.type.equity.controls.canBuy',
    EventSubmittedAssetDataTypeEquityControlsCanSell = 'event.submitted.asset.data.type.equity.controls.canSell',
    EventSubmittedAssetDataTypeEquityControlsCanEnterFractions = 'event.submitted.asset.data.type.equity.controls.canEnterFractions',
    EventSubmittedAssetDataTypeMoneyMarketCusip = 'event.submitted.asset.data.type.moneyMarket.cusip',
    EventSubmittedAssetDataTypeMoneyMarketControlsCanBuy = 'event.submitted.asset.data.type.moneyMarket.controls.canBuy',
    EventSubmittedAssetDataTypeMoneyMarketControlsCanSell = 'event.submitted.asset.data.type.moneyMarket.controls.canSell',
    EventSubmittedAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.submitted.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventSubmittedAssetDataTypeMoneyMarketClassification = 'event.submitted.asset.data.type.moneyMarket.classification',
    EventSubmittedAssetDataTypeMoneyMarketNavType = 'event.submitted.asset.data.type.moneyMarket.navType',
    EventSubmittedAssetDataTypeType = 'event.submitted.asset.data.type.!type',
    EventSubmittedAssetDataCategory = 'event.submitted.asset.data.category',
    EventSubmittedAssetStatus = 'event.submitted.asset.status',
    EventAllocationRequestedSpecSide = 'event.allocationRequested.spec.side',
    EventAllocationRequestedSpecPriceSource = 'event.allocationRequested.spec.priceSource',
    EventAllocatedSpecSide = 'event.allocated.spec.side',
    EventAllocatedSpecPriceSource = 'event.allocated.spec.priceSource',
    EventType = 'event.!type'
}

export enum IxcInventoryV1FirmOrderQueryServiceFirmOrderEventsSearchableFields {
    EventSubmittedAssetDataTypeEquitySymbolBase = 'event.submitted.asset.data.type.equity.symbol.base',
    EventSubmittedAssetDataTypeEquityName = 'event.submitted.asset.data.type.equity.name',
    EventSubmittedAssetDataTypeMoneyMarketSymbolBase = 'event.submitted.asset.data.type.moneyMarket.symbol.base',
    EventSubmittedAssetDataTypeMoneyMarketName = 'event.submitted.asset.data.type.moneyMarket.name'
}

export enum IxcInventoryV1FirmOrderQueryServiceFirmOrderEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventSubmittedAssetMetadataCreatedAt = 'event.submitted.asset.metadata.createdAt',
    EventSubmittedAssetMetadataUpdatedAt = 'event.submitted.asset.metadata.updatedAt'
}

export interface IxcInventoryV1FirmOrderQueryServiceFirmOrderGetFirmOrderGetRequest {
    // format: id62
    firmOrderId: string;
}

export interface IxcInventoryV1FirmOrderQueryServiceFirmOrderListFirmOrderListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcInventoryV1FirmOrderQueryServiceFirmOrderListSearchableFields, IxcInventoryV1FirmOrderQueryServiceFirmOrderListSortableFields, IxcInventoryV1FirmOrderQueryServiceFirmOrderListFilterableFields>;
}

export enum IxcInventoryV1FirmOrderQueryServiceFirmOrderListFilterableFields {
    FirmOrderId = 'firmOrderId',
    DataAssetAssetId = 'data.asset.assetId',
    DataAssetDataTypeEquityCusip = 'data.asset.data.type.equity.cusip',
    DataAssetDataTypeEquityControlsCanBuy = 'data.asset.data.type.equity.controls.canBuy',
    DataAssetDataTypeEquityControlsCanSell = 'data.asset.data.type.equity.controls.canSell',
    DataAssetDataTypeEquityControlsCanEnterFractions = 'data.asset.data.type.equity.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketCusip = 'data.asset.data.type.moneyMarket.cusip',
    DataAssetDataTypeMoneyMarketControlsCanBuy = 'data.asset.data.type.moneyMarket.controls.canBuy',
    DataAssetDataTypeMoneyMarketControlsCanSell = 'data.asset.data.type.moneyMarket.controls.canSell',
    DataAssetDataTypeMoneyMarketControlsCanEnterFractions = 'data.asset.data.type.moneyMarket.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketClassification = 'data.asset.data.type.moneyMarket.classification',
    DataAssetDataTypeMoneyMarketNavType = 'data.asset.data.type.moneyMarket.navType',
    DataAssetDataTypeType = 'data.asset.data.type.!type',
    DataAssetDataCategory = 'data.asset.data.category',
    DataAssetStatus = 'data.asset.status',
    Status = 'status'
}

export enum IxcInventoryV1FirmOrderQueryServiceFirmOrderListSearchableFields {
    DataAssetDataTypeEquitySymbolBase = 'data.asset.data.type.equity.symbol.base',
    DataAssetDataTypeEquityName = 'data.asset.data.type.equity.name',
    DataAssetDataTypeMoneyMarketSymbolBase = 'data.asset.data.type.moneyMarket.symbol.base',
    DataAssetDataTypeMoneyMarketName = 'data.asset.data.type.moneyMarket.name'
}

export enum IxcInventoryV1FirmOrderQueryServiceFirmOrderListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataAssetMetadataCreatedAt = 'data.asset.metadata.createdAt',
    DataAssetMetadataUpdatedAt = 'data.asset.metadata.updatedAt'
}

export interface IxcInventoryV1FirmOrderState extends IxcInventoryV1FirmOrderKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcInventoryV1FirmOrderData;
    status: IxcInventoryV1FirmOrderStatus;
}

export enum IxcInventoryV1FirmOrderStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Rejected = 'REJECTED',
    Cancelling = 'CANCELLING',
    Canceled = 'CANCELED',
    Done = 'DONE',
    AllocationWait = 'ALLOCATION_WAIT',
    Allocated = 'ALLOCATED'
}

export interface IxcInventoryV1FullDayTotals {
    opening: IxcInventoryV1Balance;
    closing: IxcInventoryV1Balance;
    realized?: IxcInventoryV1RealizedGainLoss;
    netTrade: IxcInventoryV1Balance;
}

export interface IxcInventoryV1InventoryTrade {
    // format: id62
    transactionId: string;
    // format: id62, entity: ixc.inventory.v1.FirmOrder
    firmOrderId: string;
    /* Routed trade details from the inventory and routed perspective, a Buy
    increases the inventory balance */
    trade: IxcInventoryV1TradeDetail;
}

export interface IxcInventoryV1InventoryTradeTransaction {
    // format: id62
    firmOrderId: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settlementDate: string;
    // format: id62
    assetId: string;
    trade: IxcInventoryV1TradeDetail;
    /* The total amount of the trade after any fees or commissions */
    // format: decimal
    netAmount: string;
    middleMoney?: IxcOrdersV1MiddleMoney[];
}

export interface IxcInventoryV1OrderInstruction {
    symbol: string;
    // format: decimal
    quantity: string;
    side: IxcOrdersV1Side;
    // format: decimal
    limitPrice?: string;
    timeInForce: IxcInventoryV1OrderInstructionTimeInForce;
}

export enum IxcInventoryV1OrderInstructionTimeInForce {
    Unspecified = 'UNSPECIFIED',
    Day = 'DAY'
}

export enum IxcInventoryV1PriceSource {
    Unspecified = 'UNSPECIFIED',
    Quote = 'QUOTE',
    Average = 'AVERAGE'
}

export interface IxcInventoryV1ProvisionalDayTotals {
    // format: decimal
    openingQuantity: string;
    // format: decimal
    closingQuantity: string;
    netTrade: IxcInventoryV1Balance;
}

export interface IxcInventoryV1RealizedGainLoss {
    // format: decimal
    quantitySold: string;
    // format: decimal
    cost: string;
    // format: decimal
    proceeds: string;
    // format: decimal
    gain: string;
    /* The CloseTradingDayTransaction for the realized gain or loss */
    // format: id62, entity: ixc.ragl.v1.Transaction
    transactionId: string;
}

export interface IxcInventoryV1SecurityDayData {
    asset: IxcAssetsV1AssetState;
    /* Passed as-is form previous day's closing figures */
    // format: decimal
    previousClosingQuantity?: string;
    /* Passed as-is form previous day's closing figures */
    // format: decimal
    previousClosingCost?: string;
    corporateActionAdjustments?: IxcInventoryV1CorporateActionAdjustmentData[];
    /* previousClosingQuantity + sum of corporate action adjustments */
    // format: decimal
    openingQuantity: string;
    /* previousClosingCost + sum of corporate action adjustments. If opening
    cost, or cost delta in any action is unknown, this will be nil until all
    of the above are resolved */
    // format: decimal
    openingCost?: string;
    // format: decimal
    closingQuantity?: string;
    // format: decimal
    closingCost?: string;
    tradeTotals?: IxcInventoryV1TradeTotals;
    netTrade?: IxcInventoryV1Balance;
    realized?: IxcInventoryV1RealizedGainLoss;
}

export interface IxcInventoryV1SecurityDayEvent extends IxcInventoryV1SecurityDayKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcInventoryV1SecurityDayEventType;
}

export type IxcInventoryV1SecurityDayEventType = {
    '!type'?: 'initFirstDay';
    initFirstDay: IxcInventoryV1SecurityDayEventTypeInitFirstDay;
} | {
    '!type'?: 'previousClose';
    previousClose: IxcInventoryV1SecurityDayEventTypePreviousClose;
} | {
    '!type'?: 'corporateActionAdjustment';
    corporateActionAdjustment: IxcInventoryV1SecurityDayEventTypeCorporateActionAdjustment;
} | {
    '!type'?: 'tradingDayOpen';
    tradingDayOpen: IxcInventoryV1SecurityDayEventTypeTradingDayOpen;
} | {
    '!type'?: 'tradingDayClosed';
    tradingDayClosed: IxcInventoryV1SecurityDayEventTypeTradingDayClosed;
} | {
    '!type'?: 'closeBooks';
    closeBooks: EmptyObject;
} | {
    '!type'?: 'closingFigures';
    closingFigures: IxcInventoryV1SecurityDayEventTypeClosingFigures;
} | {
    '!type'?: 'closeUnknownCost';
    closeUnknownCost: IxcInventoryV1SecurityDayEventTypeCloseUnknownCost;
} | {
    '!type'?: 'settle';
    settle: IxcInventoryV1SecurityDayEventTypeSettle;
} | {
    '!type'?: 'corporateActionTrigger';
    corporateActionTrigger: IxcInventoryV1SecurityDayEventTypeCorporateActionTrigger;
} | {
    '!type'?: 'corporateActionCalculated';
    corporateActionCalculated: IxcInventoryV1SecurityDayEventTypeCorporateActionCalculated;
};

export interface IxcInventoryV1SecurityDayEventTypeCloseUnknownCost {
    // format: decimal
    closingQuantity: string;
    netTrade: IxcInventoryV1Balance;
}

export interface IxcInventoryV1SecurityDayEventTypeClosingFigures {
    closing: IxcInventoryV1Balance;
    realized?: IxcInventoryV1RealizedGainLoss;
    netTrade: IxcInventoryV1Balance;
}

export interface IxcInventoryV1SecurityDayEventTypeCorporateActionAdjustment {
    // format: id62
    actionId: string;
    /* set on non-main assignment only */
    // format: id62
    assignmentId?: string;
    /* Positive increases the position balance */
    // format: decimal
    balanceDelta: string;
    /* Positive increases the cost */
    // format: decimal
    costDelta?: string;
}

export interface IxcInventoryV1SecurityDayEventTypeCorporateActionCalculated {
    // format: id62
    actionId: string;
    // format: id62, entity: ixc.ragl.v1.Transaction
    transactionId: string;
    header: IxcCorpactionsV1Header;
    assignment: IxcCorpactionsV1CustomerAssignment;
    // format: decimal
    heldBalance: string;
    // format: decimal
    heldCost?: string;
    // format: decimal
    cashDelta?: string;
    // format: decimal
    costOfCash?: string;
    securityDeltas?: IxcInventoryV1SecurityDayEventTypeCorporateActionCalculatedSecurityDeltas[];
}

export interface IxcInventoryV1SecurityDayEventTypeCorporateActionCalculatedSecurityDeltas {
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    // format: decimal
    balanceDelta: string;
    // format: decimal
    costDelta?: string;
}

export interface IxcInventoryV1SecurityDayEventTypeCorporateActionTrigger {
    // format: id62
    actionId: string;
    header: IxcCorpactionsV1Header;
    assignment: IxcCorpactionsV1CustomerAssignment;
}

export interface IxcInventoryV1SecurityDayEventTypeInitFirstDay {
    asset: IxcAssetsV1AssetState;
}

export interface IxcInventoryV1SecurityDayEventTypePreviousClose {
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: decimal
    closingQuantity: string;
    // format: decimal
    closingCost?: string;
    asset: IxcAssetsV1AssetState;
}

export interface IxcInventoryV1SecurityDayEventTypeSettle {
    /* The transaction for the settlement of this trading day */
    // format: id62, entity: ixc.ragl.v1.Transaction
    transactionId: string;
}

export interface IxcInventoryV1SecurityDayEventTypeTradingDayClosed {
    tradeTotals: IxcInventoryV1TradeTotals;
}

export interface IxcInventoryV1SecurityDayEventTypeTradingDayOpen {
    // format: date-time
    marketOpen: string;
    // format: date-time
    marketClose: string;
    // format: YYYY-MM-DD
    nextTradingDate: string;
}

export const IXC_INVENTORY_V1_SECURITY_DAY_EVENT_TYPE_ONE_OF_VALUES = ['initFirstDay', 'previousClose', 'corporateActionAdjustment', 'tradingDayOpen', 'tradingDayClosed', 'closeBooks', 'closingFigures', 'closeUnknownCost', 'settle', 'corporateActionTrigger', 'corporateActionCalculated'] as const;

export type IxcInventoryV1SecurityDayEventTypeOneOfValue = (typeof IXC_INVENTORY_V1_SECURITY_DAY_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcInventoryV1SecurityDayKeys {
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settleDate: string;
}

export interface IxcInventoryV1SecurityDayQueryServiceSecurityDayEventsSecurityDayEventsRequest {
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcInventoryV1SecurityDayQueryServiceSecurityDayEventsSearchableFields, IxcInventoryV1SecurityDayQueryServiceSecurityDayEventsSortableFields, IxcInventoryV1SecurityDayQueryServiceSecurityDayEventsFilterableFields>;
}

export enum IxcInventoryV1SecurityDayQueryServiceSecurityDayEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AssetId = 'assetId',
    TradeDate = 'tradeDate',
    SettleDate = 'settleDate',
    EventInitFirstDayAssetAssetId = 'event.initFirstDay.asset.assetId',
    EventInitFirstDayAssetDataTypeEquityCusip = 'event.initFirstDay.asset.data.type.equity.cusip',
    EventInitFirstDayAssetDataTypeEquityControlsCanBuy = 'event.initFirstDay.asset.data.type.equity.controls.canBuy',
    EventInitFirstDayAssetDataTypeEquityControlsCanSell = 'event.initFirstDay.asset.data.type.equity.controls.canSell',
    EventInitFirstDayAssetDataTypeEquityControlsCanEnterFractions = 'event.initFirstDay.asset.data.type.equity.controls.canEnterFractions',
    EventInitFirstDayAssetDataTypeMoneyMarketCusip = 'event.initFirstDay.asset.data.type.moneyMarket.cusip',
    EventInitFirstDayAssetDataTypeMoneyMarketControlsCanBuy = 'event.initFirstDay.asset.data.type.moneyMarket.controls.canBuy',
    EventInitFirstDayAssetDataTypeMoneyMarketControlsCanSell = 'event.initFirstDay.asset.data.type.moneyMarket.controls.canSell',
    EventInitFirstDayAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.initFirstDay.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventInitFirstDayAssetDataTypeMoneyMarketClassification = 'event.initFirstDay.asset.data.type.moneyMarket.classification',
    EventInitFirstDayAssetDataTypeMoneyMarketNavType = 'event.initFirstDay.asset.data.type.moneyMarket.navType',
    EventInitFirstDayAssetDataTypeType = 'event.initFirstDay.asset.data.type.!type',
    EventInitFirstDayAssetDataCategory = 'event.initFirstDay.asset.data.category',
    EventInitFirstDayAssetStatus = 'event.initFirstDay.asset.status',
    EventPreviousCloseAssetAssetId = 'event.previousClose.asset.assetId',
    EventPreviousCloseAssetDataTypeEquityCusip = 'event.previousClose.asset.data.type.equity.cusip',
    EventPreviousCloseAssetDataTypeEquityControlsCanBuy = 'event.previousClose.asset.data.type.equity.controls.canBuy',
    EventPreviousCloseAssetDataTypeEquityControlsCanSell = 'event.previousClose.asset.data.type.equity.controls.canSell',
    EventPreviousCloseAssetDataTypeEquityControlsCanEnterFractions = 'event.previousClose.asset.data.type.equity.controls.canEnterFractions',
    EventPreviousCloseAssetDataTypeMoneyMarketCusip = 'event.previousClose.asset.data.type.moneyMarket.cusip',
    EventPreviousCloseAssetDataTypeMoneyMarketControlsCanBuy = 'event.previousClose.asset.data.type.moneyMarket.controls.canBuy',
    EventPreviousCloseAssetDataTypeMoneyMarketControlsCanSell = 'event.previousClose.asset.data.type.moneyMarket.controls.canSell',
    EventPreviousCloseAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.previousClose.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventPreviousCloseAssetDataTypeMoneyMarketClassification = 'event.previousClose.asset.data.type.moneyMarket.classification',
    EventPreviousCloseAssetDataTypeMoneyMarketNavType = 'event.previousClose.asset.data.type.moneyMarket.navType',
    EventPreviousCloseAssetDataTypeType = 'event.previousClose.asset.data.type.!type',
    EventPreviousCloseAssetDataCategory = 'event.previousClose.asset.data.category',
    EventPreviousCloseAssetStatus = 'event.previousClose.asset.status',
    EventCorporateActionTriggerHeaderCusip = 'event.corporateActionTrigger.header.cusip',
    EventCorporateActionTriggerHeaderRecordDate = 'event.corporateActionTrigger.header.recordDate',
    EventCorporateActionTriggerHeaderExDate = 'event.corporateActionTrigger.header.exDate',
    EventCorporateActionTriggerHeaderEffectiveDate = 'event.corporateActionTrigger.header.effectiveDate',
    EventCorporateActionTriggerHeaderPaymentDate = 'event.corporateActionTrigger.header.paymentDate',
    EventCorporateActionTriggerHeaderCumDate = 'event.corporateActionTrigger.header.cumDate',
    EventCorporateActionTriggerHeaderTimeApplicable = 'event.corporateActionTrigger.header.timeApplicable',
    EventCorporateActionTriggerHeaderActionType = 'event.corporateActionTrigger.header.actionType',
    EventCorporateActionCalculatedHeaderCusip = 'event.corporateActionCalculated.header.cusip',
    EventCorporateActionCalculatedHeaderRecordDate = 'event.corporateActionCalculated.header.recordDate',
    EventCorporateActionCalculatedHeaderExDate = 'event.corporateActionCalculated.header.exDate',
    EventCorporateActionCalculatedHeaderEffectiveDate = 'event.corporateActionCalculated.header.effectiveDate',
    EventCorporateActionCalculatedHeaderPaymentDate = 'event.corporateActionCalculated.header.paymentDate',
    EventCorporateActionCalculatedHeaderCumDate = 'event.corporateActionCalculated.header.cumDate',
    EventCorporateActionCalculatedHeaderTimeApplicable = 'event.corporateActionCalculated.header.timeApplicable',
    EventCorporateActionCalculatedHeaderActionType = 'event.corporateActionCalculated.header.actionType',
    EventType = 'event.!type'
}

export enum IxcInventoryV1SecurityDayQueryServiceSecurityDayEventsSearchableFields {
    EventInitFirstDayAssetDataTypeEquitySymbolBase = 'event.initFirstDay.asset.data.type.equity.symbol.base',
    EventInitFirstDayAssetDataTypeEquityName = 'event.initFirstDay.asset.data.type.equity.name',
    EventInitFirstDayAssetDataTypeMoneyMarketSymbolBase = 'event.initFirstDay.asset.data.type.moneyMarket.symbol.base',
    EventInitFirstDayAssetDataTypeMoneyMarketName = 'event.initFirstDay.asset.data.type.moneyMarket.name',
    EventPreviousCloseAssetDataTypeEquitySymbolBase = 'event.previousClose.asset.data.type.equity.symbol.base',
    EventPreviousCloseAssetDataTypeEquityName = 'event.previousClose.asset.data.type.equity.name',
    EventPreviousCloseAssetDataTypeMoneyMarketSymbolBase = 'event.previousClose.asset.data.type.moneyMarket.symbol.base',
    EventPreviousCloseAssetDataTypeMoneyMarketName = 'event.previousClose.asset.data.type.moneyMarket.name'
}

export enum IxcInventoryV1SecurityDayQueryServiceSecurityDayEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventInitFirstDayAssetMetadataCreatedAt = 'event.initFirstDay.asset.metadata.createdAt',
    EventInitFirstDayAssetMetadataUpdatedAt = 'event.initFirstDay.asset.metadata.updatedAt',
    EventPreviousCloseAssetMetadataCreatedAt = 'event.previousClose.asset.metadata.createdAt',
    EventPreviousCloseAssetMetadataUpdatedAt = 'event.previousClose.asset.metadata.updatedAt',
    EventCorporateActionTriggerHeaderRecordDate = 'event.corporateActionTrigger.header.recordDate',
    EventCorporateActionTriggerHeaderExDate = 'event.corporateActionTrigger.header.exDate',
    EventCorporateActionTriggerHeaderEffectiveDate = 'event.corporateActionTrigger.header.effectiveDate',
    EventCorporateActionTriggerHeaderPaymentDate = 'event.corporateActionTrigger.header.paymentDate',
    EventCorporateActionTriggerHeaderCumDate = 'event.corporateActionTrigger.header.cumDate',
    EventCorporateActionTriggerHeaderTimeApplicable = 'event.corporateActionTrigger.header.timeApplicable',
    EventCorporateActionCalculatedHeaderRecordDate = 'event.corporateActionCalculated.header.recordDate',
    EventCorporateActionCalculatedHeaderExDate = 'event.corporateActionCalculated.header.exDate',
    EventCorporateActionCalculatedHeaderEffectiveDate = 'event.corporateActionCalculated.header.effectiveDate',
    EventCorporateActionCalculatedHeaderPaymentDate = 'event.corporateActionCalculated.header.paymentDate',
    EventCorporateActionCalculatedHeaderCumDate = 'event.corporateActionCalculated.header.cumDate',
    EventCorporateActionCalculatedHeaderTimeApplicable = 'event.corporateActionCalculated.header.timeApplicable'
}

export interface IxcInventoryV1SecurityDayQueryServiceSecurityDayGetSecurityDayGetRequest {
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    // format: YYYY-MM-DD
    tradeDate: string;
}

export interface IxcInventoryV1SecurityDayQueryServiceSecurityDayListSecurityDayListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcInventoryV1SecurityDayQueryServiceSecurityDayListSearchableFields, IxcInventoryV1SecurityDayQueryServiceSecurityDayListSortableFields, IxcInventoryV1SecurityDayQueryServiceSecurityDayListFilterableFields>;
}

export enum IxcInventoryV1SecurityDayQueryServiceSecurityDayListFilterableFields {
    AssetId = 'assetId',
    TradeDate = 'tradeDate',
    SettleDate = 'settleDate',
    DataAssetAssetId = 'data.asset.assetId',
    DataAssetDataTypeEquityCusip = 'data.asset.data.type.equity.cusip',
    DataAssetDataTypeEquityControlsCanBuy = 'data.asset.data.type.equity.controls.canBuy',
    DataAssetDataTypeEquityControlsCanSell = 'data.asset.data.type.equity.controls.canSell',
    DataAssetDataTypeEquityControlsCanEnterFractions = 'data.asset.data.type.equity.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketCusip = 'data.asset.data.type.moneyMarket.cusip',
    DataAssetDataTypeMoneyMarketControlsCanBuy = 'data.asset.data.type.moneyMarket.controls.canBuy',
    DataAssetDataTypeMoneyMarketControlsCanSell = 'data.asset.data.type.moneyMarket.controls.canSell',
    DataAssetDataTypeMoneyMarketControlsCanEnterFractions = 'data.asset.data.type.moneyMarket.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketClassification = 'data.asset.data.type.moneyMarket.classification',
    DataAssetDataTypeMoneyMarketNavType = 'data.asset.data.type.moneyMarket.navType',
    DataAssetDataTypeType = 'data.asset.data.type.!type',
    DataAssetDataCategory = 'data.asset.data.category',
    DataAssetStatus = 'data.asset.status',
    Status = 'status'
}

export enum IxcInventoryV1SecurityDayQueryServiceSecurityDayListSearchableFields {
    DataAssetDataTypeEquitySymbolBase = 'data.asset.data.type.equity.symbol.base',
    DataAssetDataTypeEquityName = 'data.asset.data.type.equity.name',
    DataAssetDataTypeMoneyMarketSymbolBase = 'data.asset.data.type.moneyMarket.symbol.base',
    DataAssetDataTypeMoneyMarketName = 'data.asset.data.type.moneyMarket.name'
}

export enum IxcInventoryV1SecurityDayQueryServiceSecurityDayListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataAssetMetadataCreatedAt = 'data.asset.metadata.createdAt',
    DataAssetMetadataUpdatedAt = 'data.asset.metadata.updatedAt'
}

export interface IxcInventoryV1SecurityDayState extends IxcInventoryV1SecurityDayKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcInventoryV1SecurityDayData;
    status: IxcInventoryV1SecurityDayStatus;
}

export enum IxcInventoryV1SecurityDayStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    TradingOpen = 'TRADING_OPEN',
    TradingClosed = 'TRADING_CLOSED',
    UcBooksClosed = 'UC_BOOKS_CLOSED',
    BooksClosed = 'BOOKS_CLOSED',
    UcSettled = 'UC_SETTLED',
    Settled = 'SETTLED'
}

export interface IxcInventoryV1SellDownRequest {
    /* The common whole-share threshold applied to every asset unless
    overridden. Defaults to 0. */
    // format: UINT64
    threshold?: string;
    /* Provide a list of assets to be evaluated. When empty, all assets are
    evaluated. */
    // format: id62
    assetIds?: string[];
    /* Per-asset whole-share threshold overrides; takes precedence over common
    threshold. */
    thresholdOverrides?: IxcInventoryV1SellDownThresholdOverride[];
}

export interface IxcInventoryV1SellDownRow {
    // format: id62
    assetId: string;
    symbol: string;
    // format: decimal
    position: string;
    // format: YYYY-MM-DD
    openDayDate?: string;
    /* Unfilled whole shares. the preview fails rather than render a fractional
    working sell. */
    // format: UINT64
    workingSellQuantity?: string;
    /* position quantity minus workingSellQuantity */
    // format: decimal
    nettedQuantity: string;
    // format: UINT64
    threshold?: string;
    /* Whole shares to sell. */
    // format: UINT64
    sellQuantity?: string;
    /* The estimated netted position that would remain if the preview were
    executed: nettedQuantity - sellQuantity */
    // format: decimal
    resultingQuantity: string;
}

export interface IxcInventoryV1SellDownServiceSellDownPreviewSellDownPreviewRequest {
    data?: IxcInventoryV1SellDownRequest;
}

export interface IxcInventoryV1SellDownThresholdOverride {
    // format: id62
    assetId: string;
    /* Whole-share threshold for this asset; takes precedence over the common
    threshold. */
    // format: UINT64
    threshold: string;
}

export interface IxcInventoryV1SettleTradingDayTransaction {
    // format: YYYY-MM-DD
    tradingDate: string;
    // format: YYYY-MM-DD
    settlementDate: string;
    // format: informal
    symbol: string;
    // format: informal
    cusip: string;
    // format: id62
    assetId: string;
    tradeTotals: IxcInventoryV1TradeTotals;
    totals?: IxcInventoryV1SettleTradingDayTransactionTotals;
}

export type IxcInventoryV1SettleTradingDayTransactionTotals = {
    '!type'?: 'full';
    full: IxcInventoryV1FullDayTotals;
} | {
    '!type'?: 'provisional';
    provisional: IxcInventoryV1ProvisionalDayTotals;
};

export const IXC_INVENTORY_V1_SETTLE_TRADING_DAY_TRANSACTION_TOTALS_ONE_OF_VALUES = ['full', 'provisional'] as const;

export type IxcInventoryV1SettleTradingDayTransactionTotalsOneOfValue = (typeof IXC_INVENTORY_V1_SETTLE_TRADING_DAY_TRANSACTION_TOTALS_ONE_OF_VALUES)[number];

export interface IxcInventoryV1TradeDetail {
    // format: informal
    symbol: string;
    // format: informal
    cusip: string;
    side: IxcOrdersV1Side;
    // format: decimal
    quantity: string;
    /* The price per share */
    // format: decimal
    fillPrice: string;
    /* The total amount of the trade before any fees or commissions */
    // format: decimal
    grossAmount: string;
}

export interface IxcInventoryV1TradeTotals {
    /* Customer buying from inventory, decreases inventory */
    customerBuy: IxcInventoryV1Balance;
    /* Customer selling to inventory, increases inventory */
    customerSell: IxcInventoryV1Balance;
    /* Inventory buying from the market, increases inventory */
    inventoryBuy: IxcInventoryV1Balance;
    /* Inventory selling to the market, decreases inventory */
    inventorySell: IxcInventoryV1Balance;
    /* Riskless principal buy: customer is buying and the firm bought the whole
    shares from the market to pass straight through. Net-zero firm position,
    so excluded from cost-basis and settlement totals; tracked separately for
    reporting. */
    risklessBuy: IxcInventoryV1Balance;
    /* Riskless principal sell: vice versa — customer selling, firm passes the
    whole shares straight to the market. */
    risklessSell: IxcInventoryV1Balance;
}

export interface IxcInventoryV1TradingDayData {
    // format: date-time
    marketOpen: string;
    // format: date-time
    marketClose: string;
    // format: YYYY-MM-DD
    nextTradingDate: string;
    // format: YYYY-MM-DD
    settleDate: string;
    // format: decimal
    openingTradeQuantity: string;
    // format: decimal
    runningTradeQuantity: string;
    totals: IxcInventoryV1TradeTotals;
    asset: IxcAssetsV1AssetState;
}

export interface IxcInventoryV1TradingDayEvent extends IxcInventoryV1TradingDayKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcInventoryV1TradingDayEventType;
}

export type IxcInventoryV1TradingDayEventType = {
    '!type'?: 'open';
    open: IxcInventoryV1TradingDayEventTypeOpen;
} | {
    '!type'?: 'inventoryTradeEntered';
    inventoryTradeEntered: IxcInventoryV1TradingDayEventTypeInventoryTradeEntered;
} | {
    '!type'?: 'customerTradeEntered';
    customerTradeEntered: IxcInventoryV1TradingDayEventTypeCustomerTradeEntered;
} | {
    '!type'?: 'risklessTradeEntered';
    risklessTradeEntered: IxcInventoryV1TradingDayEventTypeRisklessTradeEntered;
} | {
    '!type'?: 'close';
    close: EmptyObject;
} | {
    '!type'?: 'closed';
    closed: IxcInventoryV1TradingDayEventTypeClosed;
};

export interface IxcInventoryV1TradingDayEventTypeClosed {
    tradeTotals: IxcInventoryV1TradeTotals;
}

export interface IxcInventoryV1TradingDayEventTypeCustomerTradeEntered {
    transaction: IxcInventoryV1CustomerTrade;
}

export interface IxcInventoryV1TradingDayEventTypeInventoryTradeEntered {
    transaction: IxcInventoryV1InventoryTrade;
}

export interface IxcInventoryV1TradingDayEventTypeOpen {
    asset: IxcAssetsV1AssetState;
    // format: date-time
    marketOpen: string;
    // format: date-time
    marketClose: string;
    // format: YYYY-MM-DD
    nextTradingDate: string;
    // format: YYYY-MM-DD
    settleDate: string;
    // format: decimal
    openingTradeQuantity: string;
}

export interface IxcInventoryV1TradingDayEventTypeRisklessTradeEntered {
    inventory: IxcInventoryV1InventoryTrade;
    customer: IxcInventoryV1CustomerTrade;
}

export const IXC_INVENTORY_V1_TRADING_DAY_EVENT_TYPE_ONE_OF_VALUES = ['open', 'inventoryTradeEntered', 'customerTradeEntered', 'risklessTradeEntered', 'close', 'closed'] as const;

export type IxcInventoryV1TradingDayEventTypeOneOfValue = (typeof IXC_INVENTORY_V1_TRADING_DAY_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcInventoryV1TradingDayKeys {
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    // format: YYYY-MM-DD
    date: string;
}

export interface IxcInventoryV1TradingDayQueryServiceTradingDayEventsTradingDayEventsRequest {
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    // format: YYYY-MM-DD
    date: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcInventoryV1TradingDayQueryServiceTradingDayEventsSearchableFields, IxcInventoryV1TradingDayQueryServiceTradingDayEventsSortableFields, IxcInventoryV1TradingDayQueryServiceTradingDayEventsFilterableFields>;
}

export enum IxcInventoryV1TradingDayQueryServiceTradingDayEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AssetId = 'assetId',
    Date = 'date',
    EventOpenAssetAssetId = 'event.open.asset.assetId',
    EventOpenAssetDataTypeEquityCusip = 'event.open.asset.data.type.equity.cusip',
    EventOpenAssetDataTypeEquityControlsCanBuy = 'event.open.asset.data.type.equity.controls.canBuy',
    EventOpenAssetDataTypeEquityControlsCanSell = 'event.open.asset.data.type.equity.controls.canSell',
    EventOpenAssetDataTypeEquityControlsCanEnterFractions = 'event.open.asset.data.type.equity.controls.canEnterFractions',
    EventOpenAssetDataTypeMoneyMarketCusip = 'event.open.asset.data.type.moneyMarket.cusip',
    EventOpenAssetDataTypeMoneyMarketControlsCanBuy = 'event.open.asset.data.type.moneyMarket.controls.canBuy',
    EventOpenAssetDataTypeMoneyMarketControlsCanSell = 'event.open.asset.data.type.moneyMarket.controls.canSell',
    EventOpenAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.open.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventOpenAssetDataTypeMoneyMarketClassification = 'event.open.asset.data.type.moneyMarket.classification',
    EventOpenAssetDataTypeMoneyMarketNavType = 'event.open.asset.data.type.moneyMarket.navType',
    EventOpenAssetDataTypeType = 'event.open.asset.data.type.!type',
    EventOpenAssetDataCategory = 'event.open.asset.data.category',
    EventOpenAssetStatus = 'event.open.asset.status',
    EventType = 'event.!type'
}

export enum IxcInventoryV1TradingDayQueryServiceTradingDayEventsSearchableFields {
    EventOpenAssetDataTypeEquitySymbolBase = 'event.open.asset.data.type.equity.symbol.base',
    EventOpenAssetDataTypeEquityName = 'event.open.asset.data.type.equity.name',
    EventOpenAssetDataTypeMoneyMarketSymbolBase = 'event.open.asset.data.type.moneyMarket.symbol.base',
    EventOpenAssetDataTypeMoneyMarketName = 'event.open.asset.data.type.moneyMarket.name'
}

export enum IxcInventoryV1TradingDayQueryServiceTradingDayEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventOpenAssetMetadataCreatedAt = 'event.open.asset.metadata.createdAt',
    EventOpenAssetMetadataUpdatedAt = 'event.open.asset.metadata.updatedAt'
}

export interface IxcInventoryV1TradingDayQueryServiceTradingDayGetTradingDayGetRequest {
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    // format: YYYY-MM-DD
    date: string;
}

export interface IxcInventoryV1TradingDayQueryServiceTradingDayListTradingDayListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcInventoryV1TradingDayQueryServiceTradingDayListSearchableFields, IxcInventoryV1TradingDayQueryServiceTradingDayListSortableFields, IxcInventoryV1TradingDayQueryServiceTradingDayListFilterableFields>;
}

export enum IxcInventoryV1TradingDayQueryServiceTradingDayListFilterableFields {
    AssetId = 'assetId',
    Date = 'date',
    DataAssetAssetId = 'data.asset.assetId',
    DataAssetDataTypeEquityCusip = 'data.asset.data.type.equity.cusip',
    DataAssetDataTypeEquityControlsCanBuy = 'data.asset.data.type.equity.controls.canBuy',
    DataAssetDataTypeEquityControlsCanSell = 'data.asset.data.type.equity.controls.canSell',
    DataAssetDataTypeEquityControlsCanEnterFractions = 'data.asset.data.type.equity.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketCusip = 'data.asset.data.type.moneyMarket.cusip',
    DataAssetDataTypeMoneyMarketControlsCanBuy = 'data.asset.data.type.moneyMarket.controls.canBuy',
    DataAssetDataTypeMoneyMarketControlsCanSell = 'data.asset.data.type.moneyMarket.controls.canSell',
    DataAssetDataTypeMoneyMarketControlsCanEnterFractions = 'data.asset.data.type.moneyMarket.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketClassification = 'data.asset.data.type.moneyMarket.classification',
    DataAssetDataTypeMoneyMarketNavType = 'data.asset.data.type.moneyMarket.navType',
    DataAssetDataTypeType = 'data.asset.data.type.!type',
    DataAssetDataCategory = 'data.asset.data.category',
    DataAssetStatus = 'data.asset.status',
    Status = 'status'
}

export enum IxcInventoryV1TradingDayQueryServiceTradingDayListSearchableFields {
    DataAssetDataTypeEquitySymbolBase = 'data.asset.data.type.equity.symbol.base',
    DataAssetDataTypeEquityName = 'data.asset.data.type.equity.name',
    DataAssetDataTypeMoneyMarketSymbolBase = 'data.asset.data.type.moneyMarket.symbol.base',
    DataAssetDataTypeMoneyMarketName = 'data.asset.data.type.moneyMarket.name'
}

export enum IxcInventoryV1TradingDayQueryServiceTradingDayListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataAssetMetadataCreatedAt = 'data.asset.metadata.createdAt',
    DataAssetMetadataUpdatedAt = 'data.asset.metadata.updatedAt'
}

export interface IxcInventoryV1TradingDayState extends IxcInventoryV1TradingDayKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcInventoryV1TradingDayData;
    status: IxcInventoryV1TradingDayStatus;
}

export enum IxcInventoryV1TradingDayStatus {
    Unspecified = 'UNSPECIFIED',
    Open = 'OPEN',
    Closed = 'CLOSED'
}

export enum IxcMfrecoV1BreakReason {
    Unspecified = 'UNSPECIFIED',
    SharesDiffer = 'SHARES_DIFFER',
    LedgerMissing = 'LEDGER_MISSING',
    VenueMissing = 'VENUE_MISSING'
}

export interface IxcMfrecoV1LedgerPosition {
    /* The venue's omnibus account in RAGL, e.g. omnibus:jpmam. */
    // format: custom - pattern: ^[a-z0-9-]+(:[a-z0-9-]+)*$
    accountCode: string;
    /* Every posting to the account: fund trades, net orders and sweeps. */
    // format: decimal
    shares: string;
    /* The part of shares posted by sweeps. */
    // format: decimal
    swept?: string;
    /* The RAGL balance includes transactions with effectiveAt at or before this
    time. */
    // format: date-time
    asOf: string;
}

export interface IxcMfrecoV1PositionDayData {
    fund?: IxcAssetsV1Security;
    ledger?: IxcMfrecoV1LedgerPosition;
    venueReport?: IxcMfrecoV1VenuePosition;
    /* venueReport.shares - ledger.shares, set once both sides are present. */
    // format: decimal
    difference?: string;
    breakReason?: IxcMfrecoV1BreakReason;
    /* The case opened for the day's latest break. Every break opens its own
    case; earlier ones are in the CaseOpened history. */
    // format: id62
    caseId?: string;
}

export interface IxcMfrecoV1PositionDayEvent extends IxcMfrecoV1PositionDayKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcMfrecoV1PositionDayEventType;
}

export type IxcMfrecoV1PositionDayEventType = {
    '!type'?: 'ledgerReported';
    ledgerReported: IxcMfrecoV1PositionDayEventTypeLedgerReported;
} | {
    '!type'?: 'venueReported';
    venueReported: IxcMfrecoV1PositionDayEventTypeVenueReported;
} | {
    '!type'?: 'matched';
    matched: EmptyObject;
} | {
    '!type'?: 'break';
    break: IxcMfrecoV1PositionDayEventTypeBreak;
} | {
    '!type'?: 'caseOpened';
    caseOpened: IxcMfrecoV1PositionDayEventTypeCaseOpened;
};

export interface IxcMfrecoV1PositionDayEventTypeBreak {
    reason: IxcMfrecoV1BreakReason;
}

export interface IxcMfrecoV1PositionDayEventTypeCaseOpened {
    // format: id62
    caseId: string;
}

export interface IxcMfrecoV1PositionDayEventTypeLedgerReported {
    fund: IxcAssetsV1Security;
    position: IxcMfrecoV1LedgerPosition;
}

export interface IxcMfrecoV1PositionDayEventTypeVenueReported {
    fund: IxcAssetsV1Security;
    position: IxcMfrecoV1VenuePosition;
}

export const IXC_MFRECO_V1_POSITION_DAY_EVENT_TYPE_ONE_OF_VALUES = ['ledgerReported', 'venueReported', 'matched', 'break', 'caseOpened'] as const;

export type IxcMfrecoV1PositionDayEventTypeOneOfValue = (typeof IXC_MFRECO_V1_POSITION_DAY_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcMfrecoV1PositionDayKeys {
    venue: IxcMutualfundsV1FundVenue;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The day both positions are as of. JPM reports every calendar day,
    weekends included. */
    // format: YYYY-MM-DD
    date: string;
}

export interface IxcMfrecoV1PositionDayQueryServicePositionDayEventsPositionDayEventsRequest {
    venue: IxcMutualfundsV1FundVenue;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The day both positions are as of. JPM reports every calendar day,
    weekends included. */
    // format: YYYY-MM-DD
    date: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcMfrecoV1PositionDayQueryServicePositionDayEventsSearchableFields, IxcMfrecoV1PositionDayQueryServicePositionDayEventsSortableFields, IxcMfrecoV1PositionDayQueryServicePositionDayEventsFilterableFields>;
}

export enum IxcMfrecoV1PositionDayQueryServicePositionDayEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    Venue = 'venue',
    AssetId = 'assetId',
    Date = 'date',
    EventLedgerReportedFundCusip = 'event.ledgerReported.fund.cusip',
    EventVenueReportedFundCusip = 'event.venueReported.fund.cusip',
    EventType = 'event.!type'
}

export enum IxcMfrecoV1PositionDayQueryServicePositionDayEventsSearchableFields {
    EventLedgerReportedFundSymbolBase = 'event.ledgerReported.fund.symbol.base',
    EventLedgerReportedFundName = 'event.ledgerReported.fund.name',
    EventVenueReportedFundSymbolBase = 'event.venueReported.fund.symbol.base',
    EventVenueReportedFundName = 'event.venueReported.fund.name'
}

export enum IxcMfrecoV1PositionDayQueryServicePositionDayEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    Date = 'date'
}

export interface IxcMfrecoV1PositionDayQueryServicePositionDayGetPositionDayGetRequest {
    venue: IxcMutualfundsV1FundVenue;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The day both positions are as of. JPM reports every calendar day,
    weekends included. */
    // format: YYYY-MM-DD
    date: string;
}

export interface IxcMfrecoV1PositionDayQueryServicePositionDayListPositionDayListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcMfrecoV1PositionDayQueryServicePositionDayListSearchableFields, IxcMfrecoV1PositionDayQueryServicePositionDayListSortableFields, IxcMfrecoV1PositionDayQueryServicePositionDayListFilterableFields>;
}

export enum IxcMfrecoV1PositionDayQueryServicePositionDayListFilterableFields {
    Venue = 'venue',
    AssetId = 'assetId',
    Date = 'date',
    DataFundCusip = 'data.fund.cusip',
    DataDifference = 'data.difference',
    DataBreakReason = 'data.breakReason',
    Status = 'status'
}

export enum IxcMfrecoV1PositionDayQueryServicePositionDayListSearchableFields {
    DataFundSymbolBase = 'data.fund.symbol.base',
    DataFundName = 'data.fund.name'
}

export enum IxcMfrecoV1PositionDayQueryServicePositionDayListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    Date = 'date',
    DataDifference = 'data.difference'
}

export interface IxcMfrecoV1PositionDayState extends IxcMfrecoV1PositionDayKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcMfrecoV1PositionDayData;
    status: IxcMfrecoV1PositionDayStatus;
}

export enum IxcMfrecoV1PositionDayStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Matched = 'MATCHED',
    Break = 'BREAK'
}

export interface IxcMfrecoV1VenuePosition {
    // format: decimal
    shares: string;
    /* When we first received the venue's figure. */
    // format: date-time
    receivedAt: string;
    source: IxcMfrecoV1VenueSource;
}

export type IxcMfrecoV1VenueSource = {
    '!type'?: 'jpmam';
    jpmam: IxcMfrecoV1VenueSourceJpmam;
};

export interface IxcMfrecoV1VenueSourceJpmam {
    /* The ixc.assets.clearing.v1.MoneyMarketInternalStats version. */
    dataHash: string;
}

export const IXC_MFRECO_V1_VENUE_SOURCE_ONE_OF_VALUES = ['jpmam'] as const;

export type IxcMfrecoV1VenueSourceOneOfValue = (typeof IXC_MFRECO_V1_VENUE_SOURCE_ONE_OF_VALUES)[number];

export interface IxcMutualfundsV1DividendAccrualData {
    /* The settled end-of-day share balance used for the most recent accrual, as
    reported by portfolio's as-of balance reply. */
    // format: decimal
    balance: string;
    /* The dividends accrued for the month to date. */
    // format: decimal
    dividends: string;
    /* The last date for which dividends have been calculated. */
    // format: YYYY-MM-DD
    dividendDate: string;
    /* The expected final payout date for the dividends, if known. Calculated
    from the timetable and passed via the Updated event. */
    // format: YYYY-MM-DD
    expectedPaymentDate?: string;
    /* The list of payments made as part of the dividend payout. */
    payments?: IxcMutualfundsV1DividendAccrualPayment[];
}

export interface IxcMutualfundsV1DividendAccrualEvent extends IxcMutualfundsV1DividendAccrualKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcMutualfundsV1DividendAccrualEventType;
}

export type IxcMutualfundsV1DividendAccrualEventType = {
    '!type'?: 'updated';
    updated: IxcMutualfundsV1DividendAccrualEventTypeUpdated;
} | {
    '!type'?: 'finalized';
    finalized: EmptyObject;
} | {
    '!type'?: 'pay';
    pay: IxcMutualfundsV1DividendAccrualEventTypePay;
} | {
    '!type'?: 'paymentResult';
    paymentResult: IxcMutualfundsV1DividendAccrualEventTypePaymentResult;
} | {
    '!type'?: 'paymentsCompleted';
    paymentsCompleted: EmptyObject;
};

export interface IxcMutualfundsV1DividendAccrualEventTypePay {
    /* The end date of the period covered by the payment. The start date is
    implicit as the beginning of the month or immediately after the
    previous payment's end date. */
    // format: YYYY-MM-DD
    endDate: string;
    /* The dividends calculated up to the end date. Some may have been paid
    in prior payments. */
    // format: decimal
    dividendsOnDate: string;
    /* The ID of the dividends pay task that triggered this payment. */
    // format: id62, entity: ixc.mutualfunds.v1.MutualFundsTask
    mutualFundsTaskId: string;
    /* The ID of the dividends pay job that triggered this payment. */
    // format: id62, entity: ixc.mutualfunds.v1.MutualFundsJob
    mutualFundsJobId: string;
}

export interface IxcMutualfundsV1DividendAccrualEventTypePaymentResult {
    /* The ID of the dividends pay task that triggered this payment. */
    // format: id62, entity: ixc.mutualfunds.v1.MutualFundsTask
    mutualFundsTaskId: string;
    /* The ID of the dividends pay job that triggered this payment. */
    // format: id62, entity: ixc.mutualfunds.v1.MutualFundsJob
    mutualFundsJobId: string;
    /* The ID of the transaction created for this payment, if successful. */
    // format: id62, entity: ixc.portfolio.v1.Transaction
    transactionId?: string;
    /* If the payment failed, the error message describing the failure. */
    errorMessage?: string;
}

export interface IxcMutualfundsV1DividendAccrualEventTypeUpdated {
    /* The deltas to apply to balance and dividends. dividendDate is always
    the absolute date for which these changes apply. */
    changes: IxcMutualfundsV1DividendAccrualSpec;
    /* The expected final payout date for the dividends. Calculated from the
    timetable by the caller. */
    // format: YYYY-MM-DD
    expectedPaymentDate?: string;
}

export const IXC_MUTUALFUNDS_V1_DIVIDEND_ACCRUAL_EVENT_TYPE_ONE_OF_VALUES = ['updated', 'finalized', 'pay', 'paymentResult', 'paymentsCompleted'] as const;

export type IxcMutualfundsV1DividendAccrualEventTypeOneOfValue = (typeof IXC_MUTUALFUNDS_V1_DIVIDEND_ACCRUAL_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcMutualfundsV1DividendAccrualKeys {
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* How the account holds the position the dividends accrue on. An account
    can hold the same fund both ways, so the two accrue separately. */
    source: IxcMutualfundsV1DividendSource;
    /* The first day of the month for which dividends are accrued. */
    // format: YYYY-MM-DD
    firstDayOfMonth: string;
}

export interface IxcMutualfundsV1DividendAccrualPayment {
    /* The end date of the period covered by the payment. */
    // format: YYYY-MM-DD
    endDate: string;
    /* The amount paid. */
    // format: decimal
    amount: string;
    /* When the payment was executed. */
    // format: date-time
    executedAt: string;
    /* The ID of the transaction created for this payment. A $0 payment at the
    end of the month will not have a transaction. */
    // format: id62, entity: ixc.portfolio.v1.Transaction
    transactionId?: string;
}

export interface IxcMutualfundsV1DividendAccrualQueryServiceDividendAccrualEventsDividendAccrualEventsRequest {
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* How the account holds the position the dividends accrue on. An account
    can hold the same fund both ways, so the two accrue separately. */
    source: IxcMutualfundsV1DividendSource;
    /* The first day of the month for which dividends are accrued. */
    // format: YYYY-MM-DD
    firstDayOfMonth: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcMutualfundsV1DividendAccrualQueryServiceDividendAccrualEventsSortableFields, IxcMutualfundsV1DividendAccrualQueryServiceDividendAccrualEventsFilterableFields>;
}

export enum IxcMutualfundsV1DividendAccrualQueryServiceDividendAccrualEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AccountId = 'accountId',
    AssetId = 'assetId',
    Source = 'source',
    FirstDayOfMonth = 'firstDayOfMonth',
    EventType = 'event.!type'
}

export enum IxcMutualfundsV1DividendAccrualQueryServiceDividendAccrualEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcMutualfundsV1DividendAccrualQueryServiceDividendAccrualGetDividendAccrualGetRequest {
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* How the account holds the position the dividends accrue on. An account
    can hold the same fund both ways, so the two accrue separately. */
    source: IxcMutualfundsV1DividendSource;
    /* The first day of the month for which dividends are accrued. */
    // format: YYYY-MM-DD
    firstDayOfMonth: string;
}

export interface IxcMutualfundsV1DividendAccrualQueryServiceDividendAccrualListDividendAccrualListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcMutualfundsV1DividendAccrualQueryServiceDividendAccrualListSortableFields, IxcMutualfundsV1DividendAccrualQueryServiceDividendAccrualListFilterableFields>;
}

export enum IxcMutualfundsV1DividendAccrualQueryServiceDividendAccrualListFilterableFields {
    AccountId = 'accountId',
    AssetId = 'assetId',
    Source = 'source',
    FirstDayOfMonth = 'firstDayOfMonth',
    Status = 'status'
}

export enum IxcMutualfundsV1DividendAccrualQueryServiceDividendAccrualListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcMutualfundsV1DividendAccrualSpec {
    /* The settled end-of-day share balance used for the most recent accrual, as
    reported by portfolio's as-of balance reply. */
    // format: decimal
    balance: string;
    /* The dividends accrued for the month to date. */
    // format: decimal
    dividends: string;
    /* The last date for which dividends have been calculated. */
    // format: YYYY-MM-DD
    dividendDate: string;
}

export interface IxcMutualfundsV1DividendAccrualState extends IxcMutualfundsV1DividendAccrualKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcMutualfundsV1DividendAccrualData;
    status: IxcMutualfundsV1DividendAccrualStatus;
}

export enum IxcMutualfundsV1DividendAccrualStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Finalized = 'FINALIZED',
    Paid = 'PAID'
}

export enum IxcMutualfundsV1DividendAccrualSummaryName {
    Unspecified = 'UNSPECIFIED',
    DividendAccrualSummary = 'DividendAccrualSummary'
}

export interface IxcMutualfundsV1DividendsCalculateJobSpec {
    /* The money market fund the dividends are calculated for. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The date for which dividends are being calculated */
    // format: YYYY-MM-DD
    dividendDate: string;
    /* The dividend rate for this date */
    // format: decimal
    dividendRate: string;
    /* Identifies the published data this run was created from, for tracing a
    run back to it. Opaque and compared only for equality: the money market
    feed supplies a content hash, and another fund family may identify its
    data some other way. Recognising a re-publish is done at ingestion
    against the recorded rates, not from here, and ordering comes from
    rateTimestamp. */
    rateFingerprint?: string;
    /* When the rate this run was created for was published. A day counts
    towards the run once its ledger entry was computed on a rate published at
    or after this, which is what tells a revision's own work apart from the
    work an earlier run already did for the same day. */
    // format: date-time
    rateTimestamp: string;
    /* The expected payment date (first business day of next month) */
    // format: YYYY-MM-DD
    expectedPaymentDate?: string;
    /* Scopes a case raised if this job errors. Left unset by the rate-driven
    path: a fund's dividends span every program holding it, so a case for the
    run as a whole is owned by clearing operations. An operator creating a
    job for one program's investigation can set it. */
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
}

export interface IxcMutualfundsV1DividendsCalculateJobStats {
    /* The largest total reported by a sentinel, unset until one arrives. A
    re-request can report more positions than the last one and never fewer. */
    // format: INT64
    expectedPositions?: string;
    /* Accounts with a ledger entry for the dividend date at the last check. */
    // format: INT64
    applied?: string;
    /* When progress was last checked. */
    // format: date-time
    lastCheckAt?: string;
    /* Consecutive checks that saw no new balances. */
    // format: UINT32
    stallChecks?: number;
    /* As-of balance requests sent, including re-requests. */
    // format: UINT32
    requestsSent?: number;
}

export interface IxcMutualfundsV1DividendsCalculateProgress {
    /* Accounts with a ledger entry computed on this run's rate, counted at
    check time. */
    // format: INT64
    applied?: string;
}

export enum IxcMutualfundsV1DividendSource {
    Unspecified = 'UNSPECIFIED',
    Owned = 'OWNED',
    Sweep = 'SWEEP'
}

export interface IxcMutualfundsV1DividendsPayDetails {
    /* The total amount that was paid out */
    // format: decimal
    amountPaid?: string;
    /* ID of the transaction created for this payment */
    // format: id62, entity: ixc.portfolio.v1.Transaction
    transactionId?: string;
    /* When the payment operation was executed */
    // format: date-time
    executedAt?: string;
}

export interface IxcMutualfundsV1DividendsPayJobSpec {
    /* The money market fund to pay dividends for. One fund per job: the
    month-end tick creates a job for each fund whose terms it can pay, and a
    job without a fund is refused rather than paying all of them. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
    /* The first day of the month for which to pay out dividends. */
    // format: YYYY-MM-DD
    firstDayOfMonth: string;
    /* The end date of the period covered by the payment. endDate must be in the
    same month as firstDayOfMonth. */
    // format: YYYY-MM-DD
    endDate: string;
}

export interface IxcMutualfundsV1DividendsPayTaskCreatedInfo {
    spec: IxcMutualfundsV1DividendsPayTaskSpec;
}

export interface IxcMutualfundsV1DividendsPayTaskFinishedInfo {
    /* Details of the completed dividend payment */
    details: IxcMutualfundsV1DividendsPayDetails;
}

export interface IxcMutualfundsV1DividendsPayTaskSpec {
    /* The date the dividend payment will be calculated for */
    // format: YYYY-MM-DD
    endDate: string;
    /* When completed, this contains the details of the dividend payment */
    details?: IxcMutualfundsV1DividendsPayDetails;
}

export interface IxcMutualfundsV1DividendsPayTaskStartedInfo {
    /* The total amount that is to be paid out */
    // format: decimal
    amount: string;
}

export enum IxcMutualfundsV1FundOrderAction {
    Unspecified = 'UNSPECIFIED',
    Purchase = 'PURCHASE',
    Redeem = 'REDEEM'
}

export type IxcMutualfundsV1FundOrderAmount = {
    '!type'?: 'notional';
    /* Dollars to invest or redeem */
    // format: decimal
    notional: string;
} | {
    '!type'?: 'quantity';
    /* Shares to purchase or redeem */
    // format: decimal
    quantity: string;
};

export interface IxcMutualfundsV1FundOrderAmountConversion {
    /* The amount actually sent to the venue. */
    amount: IxcMutualfundsV1FundOrderAmount;
    reason: IxcMutualfundsV1FundOrderAmountConversionReason;
}

export enum IxcMutualfundsV1FundOrderAmountConversionReason {
    Unspecified = 'UNSPECIFIED',
    FullPositionRedemption = 'FULL_POSITION_REDEMPTION'
}

export const IXC_MUTUALFUNDS_V1_FUND_ORDER_AMOUNT_ONE_OF_VALUES = ['notional', 'quantity'] as const;

export type IxcMutualfundsV1FundOrderAmountOneOfValue = (typeof IXC_MUTUALFUNDS_V1_FUND_ORDER_AMOUNT_ONE_OF_VALUES)[number];

export interface IxcMutualfundsV1FundOrderData {
    /* The order as the customer stated it; never rewritten */
    instruction: IxcMutualfundsV1FundOrderInstruction;
    /* Solicited flag and trailer, as on an equity order. A commission is not
    applied to fund orders. */
    extension?: IxcOrdersV1OrderExtension;
    /* The fund, resolved from the symbol at submission */
    asset: IxcAssetsV1AssetState;
    /* The fund's latest NAV at submission, exact for a stable fund. It sizes
    the reservation and never prices the execution; the venue's struck NAV
    does that. */
    // format: decimal
    estimatedNav: string;
    /* Set when the amount sent to the venue differs from the one the customer
    named. The instruction keeps what was asked for; this records what was
    sent instead, and why. */
    amountConversion?: IxcMutualfundsV1FundOrderAmountConversion;
    /* The portfolio reservation backing the order: cash for a purchase, shares
    for a redemption. */
    // format: id62, entity: ixc.portfolio.v1.Hold
    holdId?: string;
    /* The venue leg, once the order has been handed to a venue adapter. */
    // format: id62, entity: ixc.mutualfunds.v1.VenueOrder
    venueOrderId?: string;
    /* What the order was executed for, once the venue strikes a NAV */
    execution?: IxcMutualfundsV1FundOrderExecution;
    // format: YYYY-MM-DD
    tradeDate?: string;
    // format: YYYY-MM-DD
    settlementDate?: string;
    /* How the order ended; set once DONE */
    outcome?: IxcMutualfundsV1FundOrderOutcome;
    /* Why the reservation was refused, or why the venue refused or canceled the leg */
    failureReason?: string;
}

export interface IxcMutualfundsV1FundOrderEvent extends IxcMutualfundsV1FundOrderKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcMutualfundsV1FundOrderEventType;
}

export type IxcMutualfundsV1FundOrderEventType = {
    '!type'?: 'requested';
    requested: IxcMutualfundsV1FundOrderEventTypeRequested;
} | {
    '!type'?: 'reserved';
    reserved: IxcMutualfundsV1FundOrderEventTypeReserved;
} | {
    '!type'?: 'rejected';
    rejected: IxcMutualfundsV1FundOrderEventTypeRejected;
} | {
    '!type'?: 'submitted';
    submitted: IxcMutualfundsV1FundOrderEventTypeSubmitted;
} | {
    '!type'?: 'cancelRequested';
    cancelRequested: IxcMutualfundsV1FundOrderEventTypeCancelRequested;
} | {
    '!type'?: 'executed';
    executed: IxcMutualfundsV1FundOrderEventTypeExecuted;
} | {
    '!type'?: 'settled';
    settled: IxcMutualfundsV1FundOrderEventTypeSettled;
} | {
    '!type'?: 'canceled';
    canceled: IxcMutualfundsV1FundOrderEventTypeCanceled;
} | {
    '!type'?: 'failed';
    failed: IxcMutualfundsV1FundOrderEventTypeFailed;
};

export interface IxcMutualfundsV1FundOrderEventTypeCanceled {
    reason?: string;
}

export interface IxcMutualfundsV1FundOrderEventTypeCancelRequested {
    reason?: string;
}

export interface IxcMutualfundsV1FundOrderEventTypeExecuted {
    execution: IxcMutualfundsV1FundOrderExecution;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settlementDate: string;
    // format: id62
    transactionId: string;
}

export interface IxcMutualfundsV1FundOrderEventTypeFailed {
    reason: string;
}

export interface IxcMutualfundsV1FundOrderEventTypeRejected {
    reason: string;
    /* The position the refusal was measured against */
    balance?: IxcPortfolioV1BalanceSnapshot;
}

export interface IxcMutualfundsV1FundOrderEventTypeRequested {
    instruction: IxcMutualfundsV1FundOrderInstruction;
    extension?: IxcOrdersV1OrderExtension;
    asset: IxcAssetsV1AssetState;
    // format: decimal
    estimatedNav: string;
}

export interface IxcMutualfundsV1FundOrderEventTypeReserved {
    // format: id62, entity: ixc.portfolio.v1.Hold
    holdId: string;
    /* Set when the portfolio converted a notional redemption into the whole
    position; the instruction keeps what the customer asked for. */
    amountConversion?: IxcMutualfundsV1FundOrderAmountConversion;
}

export interface IxcMutualfundsV1FundOrderEventTypeSettled {
    // format: YYYY-MM-DD
    settlementDate: string;
}

export interface IxcMutualfundsV1FundOrderEventTypeSubmitted {
    // format: id62, entity: ixc.mutualfunds.v1.VenueOrder
    venueOrderId: string;
}

export const IXC_MUTUALFUNDS_V1_FUND_ORDER_EVENT_TYPE_ONE_OF_VALUES = ['requested', 'reserved', 'rejected', 'submitted', 'cancelRequested', 'executed', 'settled', 'canceled', 'failed'] as const;

export type IxcMutualfundsV1FundOrderEventTypeOneOfValue = (typeof IXC_MUTUALFUNDS_V1_FUND_ORDER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcMutualfundsV1FundOrderExecution {
    /* The execution identifier, namespaced by venue so an execution traces to
    the venue that struck it. */
    executionId: string;
    /* The venue that executed the order */
    venue: IxcMutualfundsV1FundVenue;
    /* The net asset value the venue struck */
    // format: decimal
    nav: string;
    /* Shares purchased or redeemed */
    // format: decimal
    quantity: string;
    /* Cost or proceeds in dollars */
    // format: decimal
    amount: string;
    /* When the venue expects settlement, when it reports one at confirmation. */
    // format: date-time
    settlementTime?: string;
}

export interface IxcMutualfundsV1FundOrderInstruction {
    symbol: string;
    action: IxcMutualfundsV1FundOrderAction;
    amount: IxcMutualfundsV1FundOrderAmount;
    /* Tax lot selection strategy for redemptions. Only applicable when action
    is REDEEM. When not specified, defaults to FIFO. */
    taxLotSelection?: IxcMutualfundsV1FundOrderInstructionTaxLotSelection;
}

export type IxcMutualfundsV1FundOrderInstructionTaxLotSelection = {
    '!type'?: 'wellKnown';
    /* Use a standard lot selection method */
    wellKnown: IxcMutualfundsV1FundOrderInstructionTaxLotSelectionWellKnown;
} | {
    '!type'?: 'custom';
    /* Manually select specific tax lots to redeem from. Each allocation
    specifies a tax lot and the quantity to redeem from it. */
    custom: IxcMutualfundsV1FundOrderInstructionTaxLotSelectionCustom;
};

export interface IxcMutualfundsV1FundOrderInstructionTaxLotSelectionCustom {
    allocations: IxcPortfolioV1TaxLotAllocation[];
}

export interface IxcMutualfundsV1FundOrderInstructionTaxLotSelectionWellKnown {
    method: IxcPortfolioV1TaxLotMethod;
}

export const IXC_MUTUALFUNDS_V1_FUND_ORDER_INSTRUCTION_TAX_LOT_SELECTION_ONE_OF_VALUES = ['wellKnown', 'custom'] as const;

export type IxcMutualfundsV1FundOrderInstructionTaxLotSelectionOneOfValue = (typeof IXC_MUTUALFUNDS_V1_FUND_ORDER_INSTRUCTION_TAX_LOT_SELECTION_ONE_OF_VALUES)[number];

export interface IxcMutualfundsV1FundOrderKeys {
    // format: id62
    fundOrderId: string;
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
}

export enum IxcMutualfundsV1FundOrderOutcome {
    Unspecified = 'UNSPECIFIED',
    Executed = 'EXECUTED',
    Canceled = 'CANCELED',
    Rejected = 'REJECTED'
}

export interface IxcMutualfundsV1FundOrderQueryServiceFundOrderEventsFundOrderEventsRequest {
    // format: id62
    fundOrderId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcMutualfundsV1FundOrderQueryServiceFundOrderEventsSearchableFields, IxcMutualfundsV1FundOrderQueryServiceFundOrderEventsSortableFields, IxcMutualfundsV1FundOrderQueryServiceFundOrderEventsFilterableFields>;
}

export enum IxcMutualfundsV1FundOrderQueryServiceFundOrderEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    FundOrderId = 'fundOrderId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    EventRequestedInstructionAction = 'event.requested.instruction.action',
    EventRequestedAssetAssetId = 'event.requested.asset.assetId',
    EventRequestedAssetDataTypeEquityCusip = 'event.requested.asset.data.type.equity.cusip',
    EventRequestedAssetDataTypeEquityControlsCanBuy = 'event.requested.asset.data.type.equity.controls.canBuy',
    EventRequestedAssetDataTypeEquityControlsCanSell = 'event.requested.asset.data.type.equity.controls.canSell',
    EventRequestedAssetDataTypeEquityControlsCanEnterFractions = 'event.requested.asset.data.type.equity.controls.canEnterFractions',
    EventRequestedAssetDataTypeMoneyMarketCusip = 'event.requested.asset.data.type.moneyMarket.cusip',
    EventRequestedAssetDataTypeMoneyMarketControlsCanBuy = 'event.requested.asset.data.type.moneyMarket.controls.canBuy',
    EventRequestedAssetDataTypeMoneyMarketControlsCanSell = 'event.requested.asset.data.type.moneyMarket.controls.canSell',
    EventRequestedAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.requested.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventRequestedAssetDataTypeMoneyMarketClassification = 'event.requested.asset.data.type.moneyMarket.classification',
    EventRequestedAssetDataTypeMoneyMarketNavType = 'event.requested.asset.data.type.moneyMarket.navType',
    EventRequestedAssetDataTypeType = 'event.requested.asset.data.type.!type',
    EventRequestedAssetDataCategory = 'event.requested.asset.data.category',
    EventRequestedAssetStatus = 'event.requested.asset.status',
    EventType = 'event.!type'
}

export enum IxcMutualfundsV1FundOrderQueryServiceFundOrderEventsSearchableFields {
    EventRequestedAssetDataTypeEquitySymbolBase = 'event.requested.asset.data.type.equity.symbol.base',
    EventRequestedAssetDataTypeEquityName = 'event.requested.asset.data.type.equity.name',
    EventRequestedAssetDataTypeMoneyMarketSymbolBase = 'event.requested.asset.data.type.moneyMarket.symbol.base',
    EventRequestedAssetDataTypeMoneyMarketName = 'event.requested.asset.data.type.moneyMarket.name'
}

export enum IxcMutualfundsV1FundOrderQueryServiceFundOrderEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventRequestedAssetMetadataCreatedAt = 'event.requested.asset.metadata.createdAt',
    EventRequestedAssetMetadataUpdatedAt = 'event.requested.asset.metadata.updatedAt'
}

export interface IxcMutualfundsV1FundOrderQueryServiceFundOrderGetFundOrderGetRequest {
    // format: id62
    fundOrderId: string;
}

export interface IxcMutualfundsV1FundOrderQueryServiceFundOrderListFundOrderListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcMutualfundsV1FundOrderQueryServiceFundOrderListSearchableFields, IxcMutualfundsV1FundOrderQueryServiceFundOrderListSortableFields, IxcMutualfundsV1FundOrderQueryServiceFundOrderListFilterableFields>;
}

export enum IxcMutualfundsV1FundOrderQueryServiceFundOrderListFilterableFields {
    FundOrderId = 'fundOrderId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    DataInstructionAction = 'data.instruction.action',
    DataAssetAssetId = 'data.asset.assetId',
    DataAssetDataTypeEquityCusip = 'data.asset.data.type.equity.cusip',
    DataAssetDataTypeEquityControlsCanBuy = 'data.asset.data.type.equity.controls.canBuy',
    DataAssetDataTypeEquityControlsCanSell = 'data.asset.data.type.equity.controls.canSell',
    DataAssetDataTypeEquityControlsCanEnterFractions = 'data.asset.data.type.equity.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketCusip = 'data.asset.data.type.moneyMarket.cusip',
    DataAssetDataTypeMoneyMarketControlsCanBuy = 'data.asset.data.type.moneyMarket.controls.canBuy',
    DataAssetDataTypeMoneyMarketControlsCanSell = 'data.asset.data.type.moneyMarket.controls.canSell',
    DataAssetDataTypeMoneyMarketControlsCanEnterFractions = 'data.asset.data.type.moneyMarket.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketClassification = 'data.asset.data.type.moneyMarket.classification',
    DataAssetDataTypeMoneyMarketNavType = 'data.asset.data.type.moneyMarket.navType',
    DataAssetDataTypeType = 'data.asset.data.type.!type',
    DataAssetDataCategory = 'data.asset.data.category',
    DataAssetStatus = 'data.asset.status',
    Status = 'status'
}

export enum IxcMutualfundsV1FundOrderQueryServiceFundOrderListSearchableFields {
    DataAssetDataTypeEquitySymbolBase = 'data.asset.data.type.equity.symbol.base',
    DataAssetDataTypeEquityName = 'data.asset.data.type.equity.name',
    DataAssetDataTypeMoneyMarketSymbolBase = 'data.asset.data.type.moneyMarket.symbol.base',
    DataAssetDataTypeMoneyMarketName = 'data.asset.data.type.moneyMarket.name'
}

export enum IxcMutualfundsV1FundOrderQueryServiceFundOrderListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataAssetMetadataCreatedAt = 'data.asset.metadata.createdAt',
    DataAssetMetadataUpdatedAt = 'data.asset.metadata.updatedAt'
}

export interface IxcMutualfundsV1FundOrderSpec {
    /* When the order was created */
    // format: date-time
    timestamp: string;
    action: IxcMutualfundsV1FundOrderAction;
    amount: IxcMutualfundsV1FundOrderAmount;
    /* The fund to purchase or redeem. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The customer account the order was placed for. Venue-bound messages carry
    the omnibus account instead; this never leaves the platform. */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    /* The program the account belongs to */
    // format: id62
    programId: string;
}

export interface IxcMutualfundsV1FundOrderState extends IxcMutualfundsV1FundOrderKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcMutualfundsV1FundOrderData;
    status: IxcMutualfundsV1FundOrderStatus;
}

export enum IxcMutualfundsV1FundOrderStatus {
    Unspecified = 'UNSPECIFIED',
    Approval = 'APPROVAL',
    Rejected = 'REJECTED',
    Active = 'ACTIVE',
    Done = 'DONE'
}

export interface IxcMutualfundsV1FundTransaction {
    // format: id62
    fundOrderId: string;
    // format: id62
    accountId: string;
    /* The adapter that executed the order */
    venue: IxcMutualfundsV1FundVenue;
    /* When the venue confirmed the execution */
    // format: date-time
    confirmedAt: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settlementDate: string;
    // format: informal
    symbol: string;
    // format: informal
    cusip: string;
    // format: id62
    assetId: string;
    action: IxcMutualfundsV1FundOrderAction;
    /* The shares purchased or redeemed */
    // format: decimal
    quantity: string;
    /* The NAV the venue struck, the price per share */
    // format: decimal
    nav: string;
    /* The dollars at that NAV, before any fees */
    // format: decimal
    amount: string;
    /* The dollars after any fees; equal to amount while funds carry none */
    // format: decimal
    netAmount: string;
    /* Fees, when a fund charges any */
    middleMoney?: IxcOrdersV1MiddleMoney[];
    solicited?: boolean;
    trailer?: string;
    capacity: IxcOrdersV1Capacity;
}

export enum IxcMutualfundsV1FundVenue {
    Unspecified = 'UNSPECIFIED',
    Jpmam = 'JPMAM',
    FundServ = 'FUND_SERV'
}

export type IxcMutualfundsV1JobProgressData = {
    '!type'?: 'dividendsCalculate';
    dividendsCalculate: IxcMutualfundsV1DividendsCalculateProgress;
};

export const IXC_MUTUALFUNDS_V1_JOB_PROGRESS_DATA_ONE_OF_VALUES = ['dividendsCalculate'] as const;

export type IxcMutualfundsV1JobProgressDataOneOfValue = (typeof IXC_MUTUALFUNDS_V1_JOB_PROGRESS_DATA_ONE_OF_VALUES)[number];

export type IxcMutualfundsV1JobSpec = {
    '!type'?: 'dividendsCalculate';
    dividendsCalculate: IxcMutualfundsV1DividendsCalculateJobSpec;
} | {
    '!type'?: 'dividendsPay';
    dividendsPay: IxcMutualfundsV1DividendsPayJobSpec;
};

export const IXC_MUTUALFUNDS_V1_JOB_SPEC_ONE_OF_VALUES = ['dividendsCalculate', 'dividendsPay'] as const;

export type IxcMutualfundsV1JobSpecOneOfValue = (typeof IXC_MUTUALFUNDS_V1_JOB_SPEC_ONE_OF_VALUES)[number];

export type IxcMutualfundsV1JobStats = {
    '!type'?: 'dividendsCalculate';
    dividendsCalculate: IxcMutualfundsV1DividendsCalculateJobStats;
};

export const IXC_MUTUALFUNDS_V1_JOB_STATS_ONE_OF_VALUES = ['dividendsCalculate'] as const;

export type IxcMutualfundsV1JobStatsOneOfValue = (typeof IXC_MUTUALFUNDS_V1_JOB_STATS_ONE_OF_VALUES)[number];

export interface IxcMutualfundsV1Metrics {
    // format: UINT32
    total?: number;
    // format: UINT32
    pending?: number;
    // format: UINT32
    succeeded?: number;
    // format: UINT32
    errored?: number;
}

export interface IxcMutualfundsV1MutualFundsJobData {
    operationType: IxcMutualfundsV1OperationType;
    spec: IxcMutualfundsV1JobSpec;
    metrics: IxcMutualfundsV1Metrics;
    /* Progress an operation tracks for itself, beyond the task metrics every
    operation shares. Unset for an operation that needs none. */
    stats?: IxcMutualfundsV1JobStats;
}

export interface IxcMutualfundsV1MutualFundsJobEvent extends IxcMutualfundsV1MutualFundsJobKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcMutualfundsV1MutualFundsJobEventType;
}

export type IxcMutualfundsV1MutualFundsJobEventType = {
    '!type'?: 'created';
    created: IxcMutualfundsV1MutualFundsJobEventTypeCreated;
} | {
    '!type'?: 'tasksCreated';
    tasksCreated: IxcMutualfundsV1MutualFundsJobEventTypeTasksCreated;
} | {
    '!type'?: 'allCreated';
    allCreated: EmptyObject;
} | {
    '!type'?: 'metricsUpdated';
    metricsUpdated: IxcMutualfundsV1MutualFundsJobEventTypeMetricsUpdated;
} | {
    '!type'?: 'allFinished';
    allFinished: IxcMutualfundsV1MutualFundsJobEventTypeAllFinished;
} | {
    '!type'?: 'sentinelReceived';
    sentinelReceived: IxcMutualfundsV1MutualFundsJobEventTypeSentinelReceived;
} | {
    '!type'?: 'progressChecked';
    progressChecked: IxcMutualfundsV1MutualFundsJobEventTypeProgressChecked;
} | {
    '!type'?: 'incomplete';
    incomplete: IxcMutualfundsV1MutualFundsJobEventTypeIncomplete;
};

export interface IxcMutualfundsV1MutualFundsJobEventTypeAllFinished {
    message?: string;
}

export interface IxcMutualfundsV1MutualFundsJobEventTypeCreated {
    operationType: IxcMutualfundsV1OperationType;
    spec: IxcMutualfundsV1JobSpec;
}

export interface IxcMutualfundsV1MutualFundsJobEventTypeIncomplete {
    message: string;
}

export interface IxcMutualfundsV1MutualFundsJobEventTypeMetricsUpdated {
    // format: UINT32
    pending?: number;
    // format: UINT32
    succeeded?: number;
    // format: UINT32
    errored?: number;
}

export interface IxcMutualfundsV1MutualFundsJobEventTypeProgressChecked {
    data?: IxcMutualfundsV1JobProgressData;
}

export interface IxcMutualfundsV1MutualFundsJobEventTypeSentinelReceived {
    // format: INT64
    expectedTotal?: string;
}

export interface IxcMutualfundsV1MutualFundsJobEventTypeTasksCreated {
    // format: UINT32
    count: number;
}

export const IXC_MUTUALFUNDS_V1_MUTUAL_FUNDS_JOB_EVENT_TYPE_ONE_OF_VALUES = ['created', 'tasksCreated', 'allCreated', 'metricsUpdated', 'allFinished', 'sentinelReceived', 'progressChecked', 'incomplete'] as const;

export type IxcMutualfundsV1MutualFundsJobEventTypeOneOfValue = (typeof IXC_MUTUALFUNDS_V1_MUTUAL_FUNDS_JOB_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcMutualfundsV1MutualFundsJobKeys {
    /* Primary identifier */
    // format: id62
    mutualFundsJobId: string;
}

export interface IxcMutualfundsV1MutualFundsJobQueryServiceMutualFundsJobEventsMutualFundsJobEventsRequest {
    /* Primary identifier */
    // format: id62
    mutualFundsJobId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcMutualfundsV1MutualFundsJobQueryServiceMutualFundsJobEventsSortableFields, IxcMutualfundsV1MutualFundsJobQueryServiceMutualFundsJobEventsFilterableFields>;
}

export enum IxcMutualfundsV1MutualFundsJobQueryServiceMutualFundsJobEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    MutualFundsJobId = 'mutualFundsJobId',
    EventType = 'event.!type'
}

export enum IxcMutualfundsV1MutualFundsJobQueryServiceMutualFundsJobEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcMutualfundsV1MutualFundsJobQueryServiceMutualFundsJobGetMutualFundsJobGetRequest {
    /* Primary identifier */
    // format: id62
    mutualFundsJobId: string;
}

export interface IxcMutualfundsV1MutualFundsJobQueryServiceMutualFundsJobListMutualFundsJobListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcMutualfundsV1MutualFundsJobQueryServiceMutualFundsJobListSortableFields, IxcMutualfundsV1MutualFundsJobQueryServiceMutualFundsJobListFilterableFields>;
}

export enum IxcMutualfundsV1MutualFundsJobQueryServiceMutualFundsJobListFilterableFields {
    MutualFundsJobId = 'mutualFundsJobId',
    Status = 'status'
}

export enum IxcMutualfundsV1MutualFundsJobQueryServiceMutualFundsJobListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcMutualfundsV1MutualFundsJobState extends IxcMutualfundsV1MutualFundsJobKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcMutualfundsV1MutualFundsJobData;
    status: IxcMutualfundsV1MutualFundsJobStatus;
}

export enum IxcMutualfundsV1MutualFundsJobStatus {
    Unspecified = 'UNSPECIFIED',
    Creating = 'CREATING',
    Processing = 'PROCESSING',
    Done = 'DONE',
    Incomplete = 'INCOMPLETE'
}

export interface IxcMutualfundsV1MutualFundsTaskData {
    operationType: IxcMutualfundsV1OperationType;
    spec: IxcMutualfundsV1TaskSpec;
}

export interface IxcMutualfundsV1MutualFundsTaskEvent extends IxcMutualfundsV1MutualFundsTaskKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcMutualfundsV1MutualFundsTaskEventType;
}

export type IxcMutualfundsV1MutualFundsTaskEventType = {
    '!type'?: 'created';
    created: IxcMutualfundsV1MutualFundsTaskEventTypeCreated;
} | {
    '!type'?: 'started';
    started: IxcMutualfundsV1MutualFundsTaskEventTypeStarted;
} | {
    '!type'?: 'finished';
    finished: IxcMutualfundsV1MutualFundsTaskEventTypeFinished;
} | {
    '!type'?: 'errored';
    errored: IxcMutualfundsV1MutualFundsTaskEventTypeErrored;
} | {
    '!type'?: 'recovered';
    recovered: IxcMutualfundsV1MutualFundsTaskEventTypeRecovered;
};

export interface IxcMutualfundsV1MutualFundsTaskEventTypeCreated {
    operationType: IxcMutualfundsV1OperationType;
    info: IxcMutualfundsV1TaskCreatedInfo;
}

export interface IxcMutualfundsV1MutualFundsTaskEventTypeErrored {
    /* Optional error message */
    message?: string;
}

export interface IxcMutualfundsV1MutualFundsTaskEventTypeFinished {
    info: IxcMutualfundsV1TaskFinishedInfo;
}

export interface IxcMutualfundsV1MutualFundsTaskEventTypeRecovered {
    /* Optional reason for the recovery */
    message?: string;
}

export interface IxcMutualfundsV1MutualFundsTaskEventTypeStarted {
    info: IxcMutualfundsV1TaskStartedInfo;
}

export const IXC_MUTUALFUNDS_V1_MUTUAL_FUNDS_TASK_EVENT_TYPE_ONE_OF_VALUES = ['created', 'started', 'finished', 'errored', 'recovered'] as const;

export type IxcMutualfundsV1MutualFundsTaskEventTypeOneOfValue = (typeof IXC_MUTUALFUNDS_V1_MUTUAL_FUNDS_TASK_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcMutualfundsV1MutualFundsTaskKeys {
    /* Primary identifier */
    // format: id62
    mutualFundsTaskId: string;
    /* Identifies the job this task belongs to */
    // format: id62, entity: ixc.mutualfunds.v1.MutualFundsJob
    mutualFundsJobId?: string;
    /* Identifies the account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    /* Identifies the asset */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
}

export interface IxcMutualfundsV1MutualFundsTaskQueryServiceMutualFundsTaskEventsMutualFundsTaskEventsRequest {
    /* Primary identifier */
    // format: id62
    mutualFundsTaskId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcMutualfundsV1MutualFundsTaskQueryServiceMutualFundsTaskEventsSortableFields, IxcMutualfundsV1MutualFundsTaskQueryServiceMutualFundsTaskEventsFilterableFields>;
}

export enum IxcMutualfundsV1MutualFundsTaskQueryServiceMutualFundsTaskEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    MutualFundsTaskId = 'mutualFundsTaskId',
    MutualFundsJobId = 'mutualFundsJobId',
    AccountId = 'accountId',
    AssetId = 'assetId',
    EventType = 'event.!type'
}

export enum IxcMutualfundsV1MutualFundsTaskQueryServiceMutualFundsTaskEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcMutualfundsV1MutualFundsTaskQueryServiceMutualFundsTaskGetMutualFundsTaskGetRequest {
    /* Primary identifier */
    // format: id62
    mutualFundsTaskId: string;
}

export interface IxcMutualfundsV1MutualFundsTaskQueryServiceMutualFundsTaskListMutualFundsTaskListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcMutualfundsV1MutualFundsTaskQueryServiceMutualFundsTaskListSortableFields, IxcMutualfundsV1MutualFundsTaskQueryServiceMutualFundsTaskListFilterableFields>;
}

export enum IxcMutualfundsV1MutualFundsTaskQueryServiceMutualFundsTaskListFilterableFields {
    MutualFundsTaskId = 'mutualFundsTaskId',
    MutualFundsJobId = 'mutualFundsJobId',
    AccountId = 'accountId',
    AssetId = 'assetId',
    Status = 'status'
}

export enum IxcMutualfundsV1MutualFundsTaskQueryServiceMutualFundsTaskListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcMutualfundsV1MutualFundsTaskState extends IxcMutualfundsV1MutualFundsTaskKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcMutualfundsV1MutualFundsTaskData;
    status: IxcMutualfundsV1MutualFundsTaskStatus;
}

export enum IxcMutualfundsV1MutualFundsTaskStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Processing = 'PROCESSING',
    Succeeded = 'SUCCEEDED',
    Errored = 'ERRORED'
}

export enum IxcMutualfundsV1OperationType {
    Unspecified = 'UNSPECIFIED',
    DividendsCalculate = 'DIVIDENDS_CALCULATE',
    DividendsPay = 'DIVIDENDS_PAY'
}

export type IxcMutualfundsV1TaskCreatedInfo = {
    '!type'?: 'dividendsPay';
    dividendsPay: IxcMutualfundsV1DividendsPayTaskCreatedInfo;
};

export const IXC_MUTUALFUNDS_V1_TASK_CREATED_INFO_ONE_OF_VALUES = ['dividendsPay'] as const;

export type IxcMutualfundsV1TaskCreatedInfoOneOfValue = (typeof IXC_MUTUALFUNDS_V1_TASK_CREATED_INFO_ONE_OF_VALUES)[number];

export type IxcMutualfundsV1TaskFinishedInfo = {
    '!type'?: 'dividendsPay';
    dividendsPay: IxcMutualfundsV1DividendsPayTaskFinishedInfo;
};

export const IXC_MUTUALFUNDS_V1_TASK_FINISHED_INFO_ONE_OF_VALUES = ['dividendsPay'] as const;

export type IxcMutualfundsV1TaskFinishedInfoOneOfValue = (typeof IXC_MUTUALFUNDS_V1_TASK_FINISHED_INFO_ONE_OF_VALUES)[number];

export type IxcMutualfundsV1TaskSpec = {
    '!type'?: 'dividendsPay';
    dividendsPay: IxcMutualfundsV1DividendsPayTaskSpec;
};

export const IXC_MUTUALFUNDS_V1_TASK_SPEC_ONE_OF_VALUES = ['dividendsPay'] as const;

export type IxcMutualfundsV1TaskSpecOneOfValue = (typeof IXC_MUTUALFUNDS_V1_TASK_SPEC_ONE_OF_VALUES)[number];

export type IxcMutualfundsV1TaskStartedInfo = {
    '!type'?: 'dividendsPay';
    dividendsPay: IxcMutualfundsV1DividendsPayTaskStartedInfo;
};

export const IXC_MUTUALFUNDS_V1_TASK_STARTED_INFO_ONE_OF_VALUES = ['dividendsPay'] as const;

export type IxcMutualfundsV1TaskStartedInfoOneOfValue = (typeof IXC_MUTUALFUNDS_V1_TASK_STARTED_INFO_ONE_OF_VALUES)[number];

export interface IxcMutualfundsV1VenueOrderData {
    /* The venue-neutral order as submitted to the adapter */
    spec: IxcMutualfundsV1FundOrderSpec;
    /* The venue the order was routed to, resolved from the asset at submission. */
    venue: IxcMutualfundsV1FundVenue;
    /* The venue-side aggregate this order was submitted in, for venues that
    net. JPMAM's is the net order id. Recorded so the executions published
    for one aggregate can be summed against the totals the venue reports for
    it. */
    // format: informal
    venueBatchId?: string;
    /* What the order was executed for, once the venue strikes a NAV */
    execution?: IxcMutualfundsV1FundOrderExecution;
    /* The date the venue settled the order */
    // format: YYYY-MM-DD
    settlementDate?: string;
    /* Why the venue rejected or canceled the order */
    failureReason?: string;
}

export interface IxcMutualfundsV1VenueOrderEvent extends IxcMutualfundsV1VenueOrderKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcMutualfundsV1VenueOrderEventType;
}

export type IxcMutualfundsV1VenueOrderEventType = {
    '!type'?: 'submitted';
    submitted: IxcMutualfundsV1VenueOrderEventTypeSubmitted;
} | {
    '!type'?: 'confirmed';
    confirmed: IxcMutualfundsV1VenueOrderEventTypeConfirmed;
} | {
    '!type'?: 'settled';
    settled: IxcMutualfundsV1VenueOrderEventTypeSettled;
} | {
    '!type'?: 'rejected';
    rejected: IxcMutualfundsV1VenueOrderEventTypeRejected;
} | {
    '!type'?: 'canceled';
    canceled: IxcMutualfundsV1VenueOrderEventTypeCanceled;
};

export interface IxcMutualfundsV1VenueOrderEventTypeCanceled {
    reason: string;
}

export interface IxcMutualfundsV1VenueOrderEventTypeConfirmed {
    /* The identifier for this execution, supplied by the adapter rather
    than composed here, so a venue that mints its own can pass it
    through. */
    executionId: string;
    /* The aggregate this order was confirmed in, for venues that net */
    // format: informal
    venueBatchId?: string;
    /* The net asset value the venue struck. */
    // format: decimal
    nav: string;
    /* The share count the venue allocated to this order, for a venue that
    divides an aggregate itself. Absent otherwise, where the execution
    follows from the order's own amount at the struck NAV. */
    // format: decimal
    quantity?: string;
    /* The dollar amount the venue allocated to this order, alongside quantity */
    // format: decimal
    amount?: string;
    /* When the venue expects settlement, when it reports one at
    confirmation. Its absence is what defers publishing the execution
    until settlement. */
    // format: date-time
    settlementTime?: string;
}

export interface IxcMutualfundsV1VenueOrderEventTypeRejected {
    reason: string;
}

export interface IxcMutualfundsV1VenueOrderEventTypeSettled {
    // format: YYYY-MM-DD
    settlementDate: string;
}

export interface IxcMutualfundsV1VenueOrderEventTypeSubmitted {
    spec: IxcMutualfundsV1FundOrderSpec;
    venue: IxcMutualfundsV1FundVenue;
}

export const IXC_MUTUALFUNDS_V1_VENUE_ORDER_EVENT_TYPE_ONE_OF_VALUES = ['submitted', 'confirmed', 'settled', 'rejected', 'canceled'] as const;

export type IxcMutualfundsV1VenueOrderEventTypeOneOfValue = (typeof IXC_MUTUALFUNDS_V1_VENUE_ORDER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcMutualfundsV1VenueOrderKeys {
    /* The customer FundOrder this leg was created for; it equals that order's
    id. */
    // format: id62
    venueOrderId: string;
    /* The fund being purchased or redeemed. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
}

export interface IxcMutualfundsV1VenueOrderQueryServiceVenueOrderEventsVenueOrderEventsRequest {
    /* The customer FundOrder this leg was created for; it equals that order's
    id. */
    // format: id62
    venueOrderId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcMutualfundsV1VenueOrderQueryServiceVenueOrderEventsSortableFields, IxcMutualfundsV1VenueOrderQueryServiceVenueOrderEventsFilterableFields>;
}

export enum IxcMutualfundsV1VenueOrderQueryServiceVenueOrderEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    VenueOrderId = 'venueOrderId',
    AssetId = 'assetId',
    EventSubmittedSpecAction = 'event.submitted.spec.action',
    EventType = 'event.!type'
}

export enum IxcMutualfundsV1VenueOrderQueryServiceVenueOrderEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcMutualfundsV1VenueOrderQueryServiceVenueOrderGetVenueOrderGetRequest {
    /* The customer FundOrder this leg was created for; it equals that order's
    id. */
    // format: id62
    venueOrderId: string;
}

export interface IxcMutualfundsV1VenueOrderQueryServiceVenueOrderListVenueOrderListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcMutualfundsV1VenueOrderQueryServiceVenueOrderListSortableFields, IxcMutualfundsV1VenueOrderQueryServiceVenueOrderListFilterableFields>;
}

export enum IxcMutualfundsV1VenueOrderQueryServiceVenueOrderListFilterableFields {
    VenueOrderId = 'venueOrderId',
    AssetId = 'assetId',
    DataSpecAction = 'data.spec.action',
    DataVenue = 'data.venue',
    DataVenueBatchId = 'data.venueBatchId',
    Status = 'status'
}

export enum IxcMutualfundsV1VenueOrderQueryServiceVenueOrderListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcMutualfundsV1VenueOrderState extends IxcMutualfundsV1VenueOrderKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcMutualfundsV1VenueOrderData;
    status: IxcMutualfundsV1VenueOrderStatus;
}

export enum IxcMutualfundsV1VenueOrderStatus {
    Unspecified = 'UNSPECIFIED',
    Submitted = 'SUBMITTED',
    Confirmed = 'CONFIRMED',
    Settled = 'SETTLED',
    Rejected = 'REJECTED',
    Canceled = 'CANCELED'
}

export enum IxcOrdersV1AllocationBasis {
    Unspecified = 'UNSPECIFIED',
    Amount = 'AMOUNT',
    Percentage = 'PERCENTAGE'
}

export type IxcOrdersV1AllocationSource = {
    '!type'?: 'csvFile';
    /* Reserved, not yet implemented. Base64-encoded CSV file with columns:
    accountId, value. */
    csvFile: IxcOrdersV1AllocationSourceCsvFile;
} | {
    '!type'?: 'jsonFile';
    /* Reserved, not yet implemented. Base64-encoded JSON file containing an
    array of allocation entries. */
    jsonFile: IxcOrdersV1AllocationSourceJsonFile;
} | {
    '!type'?: 'fileReference';
    /* Reserved, not yet implemented. Reference to a previously uploaded CSV or
    JSON file. */
    fileReference: IxcOrdersV1AllocationSourceFileReference;
} | {
    '!type'?: 'inline';
    /* List of account/value pairs, up to 100 entries. Account IDs must be
    unique and values must be positive. */
    inline: IxcOrdersV1AllocationSourceInline;
};

export interface IxcOrdersV1AllocationSourceCsvFile {
    // bytes (base64-encoded)
    data: string;
}

export interface IxcOrdersV1AllocationSourceFileReference {
    // format: id62
    fileId: string;
}

export interface IxcOrdersV1AllocationSourceInline {
    allocations: IxcOrdersV1InlineAllocation[];
}

export interface IxcOrdersV1AllocationSourceJsonFile {
    // bytes (base64-encoded)
    data: string;
}

export const IXC_ORDERS_V1_ALLOCATION_SOURCE_ONE_OF_VALUES = ['csvFile', 'jsonFile', 'fileReference', 'inline'] as const;

export type IxcOrdersV1AllocationSourceOneOfValue = (typeof IXC_ORDERS_V1_ALLOCATION_SOURCE_ONE_OF_VALUES)[number];

export interface IxcOrdersV1BatchAllocationAvgPriceTransaction {
    // format: id62
    batchOrderId: string;
    /* Set for a per-customer allocation; unset for the round-up residual */
    // format: id62
    batchAllocationId?: string;
    /* The program order that was filled */
    // format: id62
    orderId: string;
    /* The program's average-price brokerage account */
    // format: id62
    accountId: string;
    // format: informal
    symbol: string;
    // format: informal
    cusip: string;
    // format: id62
    assetId: string;
    side: IxcOrdersV1Side;
    /* Equity quantity for this leg */
    // format: decimal
    quantity: string;
    /* Monetary value for this leg */
    // format: decimal
    amount: string;
    // format: YYYY-MM-DD
    settlementDate: string;
    market?: IxcOrdersV1Market;
    capacity: IxcOrdersV1Capacity;
    middleMoney?: IxcOrdersV1MiddleMoney[];
}

export interface IxcOrdersV1BatchAllocationCustomerTransaction {
    // format: id62
    batchOrderId: string;
    // format: id62
    batchAllocationId: string;
    /* The program order that was filled */
    // format: id62
    orderId: string;
    /* The customer's brokerage account */
    // format: id62
    accountId: string;
    // format: informal
    symbol: string;
    // format: informal
    cusip: string;
    // format: id62
    assetId: string;
    side: IxcOrdersV1Side;
    /* Equity quantity allocated to this customer */
    // format: decimal
    quantity: string;
    /* Monetary value allocated to this customer */
    // format: decimal
    amount: string;
    // format: YYYY-MM-DD
    settlementDate: string;
    market?: IxcOrdersV1Market;
    capacity: IxcOrdersV1Capacity;
    middleMoney?: IxcOrdersV1MiddleMoney[];
}

export interface IxcOrdersV1BatchAllocationData {
    /* Absolute amount requested for this account, in the parent BatchOrder's
    units. When the parent's `instruction.amount` is `quantity`, this is
    share count; when it is `notional`, this is dollars. */
    // format: decimal
    requestedAmount: string;
    /* Set when the hold is successfully placed for this account. */
    // format: id62
    holdId?: string;
    /* Shares + apportioned trade amounts and fees distributed to this account.
    Set on Distributed; nil before. Computed once when the program order
    completes using the lex-last-gets-remainder split rule so
    per-allocation amounts sum exactly to the batch totals. */
    distributed?: IxcOrdersV1BatchDistribution;
    /* Fill outcome of this allocation. Set when the allocation reaches DONE. */
    outcome?: IxcOrdersV1BatchOutcome;
}

export interface IxcOrdersV1BatchAllocationEvent extends IxcFundingV1BatchAllocationKeys {
    metadata: J5StateV1EventMetadata;
    // format: id62, entity: ixc.orders.v1.BatchOrder
    batchOrderId?: string;
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    event: IxcOrdersV1BatchAllocationEventType;
}

export type IxcOrdersV1BatchAllocationEventType = {
    '!type'?: 'created';
    created: IxcOrdersV1BatchAllocationEventTypeCreated;
} | {
    '!type'?: 'validationFailed';
    validationFailed: IxcOrdersV1BatchAllocationEventTypeValidationFailed;
} | {
    '!type'?: 'holdIssued';
    holdIssued: EmptyObject;
} | {
    '!type'?: 'holdPlaced';
    holdPlaced: IxcOrdersV1BatchAllocationEventTypeHoldPlaced;
} | {
    '!type'?: 'holdRejected';
    holdRejected: IxcOrdersV1BatchAllocationEventTypeHoldRejected;
} | {
    '!type'?: 'distributed';
    distributed: IxcOrdersV1BatchAllocationEventTypeDistributed;
} | {
    '!type'?: 'holdReleased';
    holdReleased: EmptyObject;
} | {
    '!type'?: 'canceled';
    canceled: IxcOrdersV1BatchAllocationEventTypeCanceled;
} | {
    '!type'?: 'done';
    done: IxcOrdersV1BatchAllocationEventTypeDone;
};

export interface IxcOrdersV1BatchAllocationEventTypeCanceled {
    reason?: string;
}

export interface IxcOrdersV1BatchAllocationEventTypeCreated {
    // format: decimal
    requestedAmount: string;
}

export interface IxcOrdersV1BatchAllocationEventTypeDistributed {
    distributed: IxcOrdersV1BatchDistribution;
    /* True iff this allocation received exactly its requested amount —
    compared in shares for share-quantity batches or in dollars for
    notional batches. Set upstream in computeBatchDistributions where the
    parent's instruction.amount is in hand, so the post-Distributed logic
    hook can decide whether to chain Done(FULLY_FILLED) without
    re-loading the parent BatchOrder. */
    fullyFilled?: boolean;
}

export interface IxcOrdersV1BatchAllocationEventTypeDone {
    outcome: IxcOrdersV1BatchOutcome;
}

export interface IxcOrdersV1BatchAllocationEventTypeHoldPlaced {
    // format: id62
    holdId: string;
}

export interface IxcOrdersV1BatchAllocationEventTypeHoldRejected {
    reason?: string;
}

export interface IxcOrdersV1BatchAllocationEventTypeValidationFailed {
    reasonText: string;
}

export const IXC_ORDERS_V1_BATCH_ALLOCATION_EVENT_TYPE_ONE_OF_VALUES = ['created', 'validationFailed', 'holdIssued', 'holdPlaced', 'holdRejected', 'distributed', 'holdReleased', 'canceled', 'done'] as const;

export type IxcOrdersV1BatchAllocationEventTypeOneOfValue = (typeof IXC_ORDERS_V1_BATCH_ALLOCATION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcOrdersV1BatchAllocationKeys {
    // format: id62
    batchAllocationId: string;
    // format: id62, entity: ixc.orders.v1.BatchOrder
    batchOrderId?: string;
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
}

export interface IxcOrdersV1BatchAllocationQueryServiceBatchAllocationEventsBatchAllocationEventsRequest {
    // format: id62
    batchAllocationId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcOrdersV1BatchAllocationQueryServiceBatchAllocationEventsSortableFields, IxcOrdersV1BatchAllocationQueryServiceBatchAllocationEventsFilterableFields>;
}

export enum IxcOrdersV1BatchAllocationQueryServiceBatchAllocationEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    BatchAllocationId = 'batchAllocationId',
    BatchOrderId = 'batchOrderId',
    AccountId = 'accountId',
    EventType = 'event.!type'
}

export enum IxcOrdersV1BatchAllocationQueryServiceBatchAllocationEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcOrdersV1BatchAllocationQueryServiceBatchAllocationGetBatchAllocationGetRequest {
    // format: id62
    batchAllocationId: string;
}

export interface IxcOrdersV1BatchAllocationQueryServiceBatchAllocationListBatchAllocationListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcOrdersV1BatchAllocationQueryServiceBatchAllocationListSortableFields, IxcOrdersV1BatchAllocationQueryServiceBatchAllocationListFilterableFields>;
}

export enum IxcOrdersV1BatchAllocationQueryServiceBatchAllocationListFilterableFields {
    BatchAllocationId = 'batchAllocationId',
    BatchOrderId = 'batchOrderId',
    AccountId = 'accountId',
    Status = 'status'
}

export enum IxcOrdersV1BatchAllocationQueryServiceBatchAllocationListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcOrdersV1BatchAllocationSpec {
    basis: IxcOrdersV1AllocationBasis;
    source: IxcOrdersV1AllocationSource;
}

export interface IxcOrdersV1BatchAllocationState extends IxcOrdersV1BatchAllocationKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcOrdersV1BatchAllocationData;
    status: IxcOrdersV1BatchAllocationStatus;
}

export enum IxcOrdersV1BatchAllocationStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Invalid = 'INVALID',
    Holding = 'HOLDING',
    Held = 'HELD',
    Rejected = 'REJECTED',
    Distributed = 'DISTRIBUTED',
    Released = 'RELEASED',
    Canceled = 'CANCELED',
    Done = 'DONE'
}

export interface IxcOrdersV1BatchDistribution {
    /* Shares distributed. */
    // format: decimal
    quantity: string;
    /* Gross trade amount = quantity × avg price. */
    // format: decimal
    grossAmount: string;
    /* Net of fees = grossAmount − sum(middleMoney). */
    // format: decimal
    netAmount: string;
    middleMoney?: IxcOrdersV1MiddleMoney[];
}

export interface IxcOrdersV1BatchExecution {
    /* FIX Tag 17 ExecID for the chosen fill. */
    // format: informal
    id: string;
    /* Execution time of the chosen fill. */
    // format: date-time
    time: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    /* used as the per-allocation distribution future settlemenmt target. */
    // format: YYYY-MM-DD
    settlementDate: string;
    /* FIX Tag 375 ContraBroker, when known. */
    market?: IxcOrdersV1Market;
}

export interface IxcOrdersV1BatchFillTotals {
    /* Total shares filled across all program-order fills. */
    // format: decimal
    filledQuantity: string;
    /* Total monetary value of the program-order fills. */
    // format: decimal
    filledAmount: string;
    /* Sum of per-fill gross trade amounts (quantity * price). */
    // format: decimal
    grossAmount: string;
    /* Sum of per-fill net trade amounts (gross less middleMoney). */
    // format: decimal
    netAmount: string;
    /* Per-class fees summed across all program-order fills. */
    middleMoney?: IxcOrdersV1MiddleMoney[];
}

export interface IxcOrdersV1BatchOrderContext {
    // format: id62, entity: ixc.orders.v1.BatchOrder
    batchOrderId: string;
    // format: decimal
    quotePrice: string;
    asset: IxcAssetsV1AssetState;
}

export interface IxcOrdersV1BatchOrderControls {
    settings?: IxcOrdersV1BatchOrderControlsSettings;
}

export interface IxcOrdersV1BatchOrderControlsSettings {
    usEquities?: IxcOrdersV1BatchOrderControlsSettingsUsEquities;
}

export interface IxcOrdersV1BatchOrderControlsSettingsUsEquities {
    canPlaceBatchOrders?: boolean;
}

export interface IxcOrdersV1BatchOrderData {
    instruction: IxcOrdersV1OrderInstruction;
    extension: IxcOrdersV1OrderExtension;
    /* The program's inventory account, resolved at submit time when the batch
    leaves a residual: a notional batch, whose program order rounds up to a
    whole number of shares at the quote price, or a share BUY batch whose
    allocations sum to less than the instruction quantity. On full fill the
    residual shares (and the corresponding cash) flow from the average price
    account to this account so the AP account nets to zero. This account is
    held for that cash before the program order routes, so it must be funded.
    Both residuals are bounded by one share: the notional round-up by
    construction, the share shortfall by submit-time validation. */
    // format: id62, entity: ixc.registration.v1.Account
    inventoryAccountId?: string;
    /* Reference to the standard Order created on the platform account. */
    // format: id62, entity: ixc.orders.v1.Order
    orderId?: string;
    /* Lifecycle counters for allocation creation, hold placement, and share
    distribution. Used by the state machine to synchronize progression
    through ASSEMBLING / ACTIVE / DISTRIBUTING. */
    counts?: IxcOrdersV1BatchOrderDataCounts;
    /* Execution metadata used as the source of trade-reporting fields for
    per-allocation distributions. Populated from program-order fills;
    consumers should treat this as "the batch's execution context" without
    assuming a particular populating policy (today: last fill). */
    execution?: IxcOrdersV1BatchExecution;
    /* Filled-quantity / amount / fee totals accumulated from program-order
    fills. Apportioned proportionally to allocations on distribution. */
    fillTotals?: IxcOrdersV1BatchFillTotals;
    /* The quote price used to size per-customer holds. Set when the quote reply
    is received. */
    // format: decimal
    quotePrice?: string;
    /* The resolved asset for the batch order symbol. Set when the quote reply
    is received. */
    asset?: IxcAssetsV1AssetState;
    /* Full symbol (base + suffix) extracted from the asset on quote receipt. */
    fullSymbol?: string;
    /* CUSIP identifier extracted from the asset on quote receipt. */
    cusip?: string;
    /* Optional buffer percentage for BUY hold sizing, expressed as a decimal
    fraction (e.g. 0.10 = 10%). When set, the hold multiplier is quotePrice *
    (1 + holdBufferPercent). When unset, holds use the raw quote price. */
    // format: decimal
    holdBufferPercent?: string;
    /* Fill outcome of the batch order. Set when the batch reaches DONE. */
    outcome?: IxcOrdersV1BatchOutcome;
}

export interface IxcOrdersV1BatchOrderDataCounts {
    /* Total number of BatchAllocation entities expected, set from the
    Requested event. */
    // format: UINT32
    total?: number;
    /* Number of BatchAllocation entities created so far. Used to
    synchronize with quote receipt before placing holds. */
    // format: UINT32
    created?: number;
    /* Number of allocations validated and held successfully. */
    // format: UINT32
    ready?: number;
    /* Number of allocations that failed validation or hold placement. */
    // format: UINT32
    failed?: number;
    /* Number of allocations skipped because the batch was canceling. */
    // format: UINT32
    skipped?: number;
    /* Number of allocations that have received their share distribution. */
    // format: UINT32
    distributed?: number;
}

export interface IxcOrdersV1BatchOrderEvent extends IxcOrdersV1BatchOrderKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcOrdersV1BatchOrderEventType;
}

export type IxcOrdersV1BatchOrderEventType = {
    '!type'?: 'requested';
    requested: IxcOrdersV1BatchOrderEventTypeRequested;
} | {
    '!type'?: 'allocationCreated';
    allocationCreated: EmptyObject;
} | {
    '!type'?: 'quoteReceived';
    quoteReceived: IxcOrdersV1BatchOrderEventTypeQuoteReceived;
} | {
    '!type'?: 'allocationReady';
    allocationReady: IxcOrdersV1BatchOrderEventTypeAllocationReady;
} | {
    '!type'?: 'allocationFailed';
    allocationFailed: IxcOrdersV1BatchOrderEventTypeAllocationFailed;
} | {
    '!type'?: 'allocationSkipped';
    allocationSkipped: IxcOrdersV1BatchOrderEventTypeAllocationSkipped;
} | {
    '!type'?: 'rejected';
    rejected: IxcOrdersV1BatchOrderEventTypeRejected;
} | {
    '!type'?: 'orderCreated';
    orderCreated: IxcOrdersV1BatchOrderEventTypeOrderCreated;
} | {
    '!type'?: 'fillReceived';
    fillReceived: IxcOrdersV1BatchOrderEventTypeFillReceived;
} | {
    '!type'?: 'allocationDistributed';
    allocationDistributed: EmptyObject;
} | {
    '!type'?: 'orderCompleted';
    orderCompleted: IxcOrdersV1BatchOrderEventTypeOrderCompleted;
} | {
    '!type'?: 'cancelRequested';
    cancelRequested: IxcOrdersV1BatchOrderEventTypeCancelRequested;
} | {
    '!type'?: 'distributed';
    distributed: EmptyObject;
} | {
    '!type'?: 'done';
    done: IxcOrdersV1BatchOrderEventTypeDone;
};

export interface IxcOrdersV1BatchOrderEventTypeAllocationFailed {
    // format: id62
    batchAllocationId: string;
    reasonText: string;
}

export interface IxcOrdersV1BatchOrderEventTypeAllocationReady {
    // format: id62
    batchAllocationId: string;
}

export interface IxcOrdersV1BatchOrderEventTypeAllocationSkipped {
    /* Number of allocations skipped in this chunk. */
    // format: UINT32
    count: number;
}

export interface IxcOrdersV1BatchOrderEventTypeCancelRequested {
    reason?: string;
}

export interface IxcOrdersV1BatchOrderEventTypeDone {
    outcome: IxcOrdersV1BatchOutcome;
}

export interface IxcOrdersV1BatchOrderEventTypeFillReceived {
    execution: IxcOrdersV1BatchExecution;
    /* Gross trade amount on this fill (quantity * price). */
    // format: decimal
    grossAmount: string;
    /* Net trade amount on this fill (gross less middleMoney). */
    // format: decimal
    netAmount: string;
    /* Per-class fees calculated for this fill. Accumulated by class into
    BatchOrderData.fillTotals.middleMoney. */
    middleMoney?: IxcOrdersV1MiddleMoney[];
}

export interface IxcOrdersV1BatchOrderEventTypeOrderCompleted {
    /* Total shares filled on the program order. */
    // format: decimal
    filledQuantity: string;
    /* Total monetary value (cost or proceeds) of the program order fills. */
    // format: decimal
    filledAmount: string;
}

export interface IxcOrdersV1BatchOrderEventTypeOrderCreated {
    // format: id62
    orderId: string;
}

export interface IxcOrdersV1BatchOrderEventTypeQuoteReceived {
    quote: IxcQuoteV1Quote;
    asset: IxcAssetsV1AssetState;
}

export interface IxcOrdersV1BatchOrderEventTypeRejected {
    reasonText: string;
}

export interface IxcOrdersV1BatchOrderEventTypeRequested {
    instruction: IxcOrdersV1OrderInstruction;
    extension: IxcOrdersV1OrderExtension;
    /* Program's inventory account ID, set when the batch leaves a residual
    to receive once the program order fills — a notional round-up, or
    the shares a share batch's customers left unsubscribed. */
    // format: id62
    inventoryAccountId?: string;
    /* Total number of allocations parsed from the spec. */
    // format: UINT32
    allocationCount: number;
    /* Optional buffer percentage for BUY hold sizing, as a decimal fraction
    (e.g. 0.10 = 10%). When omitted, holds use the raw quote price. */
    // format: decimal
    holdBufferPercent?: string;
}

export const IXC_ORDERS_V1_BATCH_ORDER_EVENT_TYPE_ONE_OF_VALUES = ['requested', 'allocationCreated', 'quoteReceived', 'allocationReady', 'allocationFailed', 'allocationSkipped', 'rejected', 'orderCreated', 'fillReceived', 'allocationDistributed', 'orderCompleted', 'cancelRequested', 'distributed', 'done'] as const;

export type IxcOrdersV1BatchOrderEventTypeOneOfValue = (typeof IXC_ORDERS_V1_BATCH_ORDER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcOrdersV1BatchOrderKeys {
    // format: id62
    batchOrderId: string;
    /* The program's average price account, on which the aggregated program
    order is placed. The batch's per-customer allocations distribute from
    this account at fill time. */
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
}

export interface IxcOrdersV1BatchOrderQueryServiceBatchOrderEventsBatchOrderEventsRequest {
    // format: id62
    batchOrderId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcOrdersV1BatchOrderQueryServiceBatchOrderEventsSearchableFields, IxcOrdersV1BatchOrderQueryServiceBatchOrderEventsSortableFields, IxcOrdersV1BatchOrderQueryServiceBatchOrderEventsFilterableFields>;
}

export enum IxcOrdersV1BatchOrderQueryServiceBatchOrderEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    BatchOrderId = 'batchOrderId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    EventRequestedInstructionSide = 'event.requested.instruction.side',
    EventQuoteReceivedAssetAssetId = 'event.quoteReceived.asset.assetId',
    EventQuoteReceivedAssetDataTypeEquityCusip = 'event.quoteReceived.asset.data.type.equity.cusip',
    EventQuoteReceivedAssetDataTypeEquityControlsCanBuy = 'event.quoteReceived.asset.data.type.equity.controls.canBuy',
    EventQuoteReceivedAssetDataTypeEquityControlsCanSell = 'event.quoteReceived.asset.data.type.equity.controls.canSell',
    EventQuoteReceivedAssetDataTypeEquityControlsCanEnterFractions = 'event.quoteReceived.asset.data.type.equity.controls.canEnterFractions',
    EventQuoteReceivedAssetDataTypeMoneyMarketCusip = 'event.quoteReceived.asset.data.type.moneyMarket.cusip',
    EventQuoteReceivedAssetDataTypeMoneyMarketControlsCanBuy = 'event.quoteReceived.asset.data.type.moneyMarket.controls.canBuy',
    EventQuoteReceivedAssetDataTypeMoneyMarketControlsCanSell = 'event.quoteReceived.asset.data.type.moneyMarket.controls.canSell',
    EventQuoteReceivedAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.quoteReceived.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventQuoteReceivedAssetDataTypeMoneyMarketClassification = 'event.quoteReceived.asset.data.type.moneyMarket.classification',
    EventQuoteReceivedAssetDataTypeMoneyMarketNavType = 'event.quoteReceived.asset.data.type.moneyMarket.navType',
    EventQuoteReceivedAssetDataTypeType = 'event.quoteReceived.asset.data.type.!type',
    EventQuoteReceivedAssetDataCategory = 'event.quoteReceived.asset.data.category',
    EventQuoteReceivedAssetStatus = 'event.quoteReceived.asset.status',
    EventType = 'event.!type'
}

export enum IxcOrdersV1BatchOrderQueryServiceBatchOrderEventsSearchableFields {
    EventQuoteReceivedAssetDataTypeEquitySymbolBase = 'event.quoteReceived.asset.data.type.equity.symbol.base',
    EventQuoteReceivedAssetDataTypeEquityName = 'event.quoteReceived.asset.data.type.equity.name',
    EventQuoteReceivedAssetDataTypeMoneyMarketSymbolBase = 'event.quoteReceived.asset.data.type.moneyMarket.symbol.base',
    EventQuoteReceivedAssetDataTypeMoneyMarketName = 'event.quoteReceived.asset.data.type.moneyMarket.name'
}

export enum IxcOrdersV1BatchOrderQueryServiceBatchOrderEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventQuoteReceivedAssetMetadataCreatedAt = 'event.quoteReceived.asset.metadata.createdAt',
    EventQuoteReceivedAssetMetadataUpdatedAt = 'event.quoteReceived.asset.metadata.updatedAt'
}

export interface IxcOrdersV1BatchOrderQueryServiceBatchOrderGetBatchOrderGetRequest {
    // format: id62
    batchOrderId: string;
}

export interface IxcOrdersV1BatchOrderQueryServiceBatchOrderListBatchOrderListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcOrdersV1BatchOrderQueryServiceBatchOrderListSearchableFields, IxcOrdersV1BatchOrderQueryServiceBatchOrderListSortableFields, IxcOrdersV1BatchOrderQueryServiceBatchOrderListFilterableFields>;
}

export enum IxcOrdersV1BatchOrderQueryServiceBatchOrderListFilterableFields {
    BatchOrderId = 'batchOrderId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    DataInstructionSide = 'data.instruction.side',
    DataAssetAssetId = 'data.asset.assetId',
    DataAssetDataTypeEquityCusip = 'data.asset.data.type.equity.cusip',
    DataAssetDataTypeEquityControlsCanBuy = 'data.asset.data.type.equity.controls.canBuy',
    DataAssetDataTypeEquityControlsCanSell = 'data.asset.data.type.equity.controls.canSell',
    DataAssetDataTypeEquityControlsCanEnterFractions = 'data.asset.data.type.equity.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketCusip = 'data.asset.data.type.moneyMarket.cusip',
    DataAssetDataTypeMoneyMarketControlsCanBuy = 'data.asset.data.type.moneyMarket.controls.canBuy',
    DataAssetDataTypeMoneyMarketControlsCanSell = 'data.asset.data.type.moneyMarket.controls.canSell',
    DataAssetDataTypeMoneyMarketControlsCanEnterFractions = 'data.asset.data.type.moneyMarket.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketClassification = 'data.asset.data.type.moneyMarket.classification',
    DataAssetDataTypeMoneyMarketNavType = 'data.asset.data.type.moneyMarket.navType',
    DataAssetDataTypeType = 'data.asset.data.type.!type',
    DataAssetDataCategory = 'data.asset.data.category',
    DataAssetStatus = 'data.asset.status',
    Status = 'status'
}

export enum IxcOrdersV1BatchOrderQueryServiceBatchOrderListSearchableFields {
    DataAssetDataTypeEquitySymbolBase = 'data.asset.data.type.equity.symbol.base',
    DataAssetDataTypeEquityName = 'data.asset.data.type.equity.name',
    DataAssetDataTypeMoneyMarketSymbolBase = 'data.asset.data.type.moneyMarket.symbol.base',
    DataAssetDataTypeMoneyMarketName = 'data.asset.data.type.moneyMarket.name'
}

export enum IxcOrdersV1BatchOrderQueryServiceBatchOrderListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataAssetMetadataCreatedAt = 'data.asset.metadata.createdAt',
    DataAssetMetadataUpdatedAt = 'data.asset.metadata.updatedAt'
}

export interface IxcOrdersV1BatchOrderState extends IxcOrdersV1BatchOrderKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcOrdersV1BatchOrderData;
    status: IxcOrdersV1BatchOrderStatus;
}

export enum IxcOrdersV1BatchOrderStatus {
    Unspecified = 'UNSPECIFIED',
    Assembling = 'ASSEMBLING',
    Rejected = 'REJECTED',
    Active = 'ACTIVE',
    Canceling = 'CANCELING',
    Distributing = 'DISTRIBUTING',
    Done = 'DONE'
}

export enum IxcOrdersV1BatchOutcome {
    Unspecified = 'UNSPECIFIED',
    FullyFilled = 'FULLY_FILLED',
    NotFilled = 'NOT_FILLED',
    PartiallyFilled = 'PARTIALLY_FILLED'
}

export interface IxcOrdersV1BatchRemainderInventoryTransaction {
    // format: id62
    batchOrderId: string;
    /* The program order that was filled */
    // format: id62
    orderId: string;
    /* The program's inventory account */
    // format: id62
    accountId: string;
    // format: informal
    symbol: string;
    // format: informal
    cusip: string;
    // format: id62
    assetId: string;
    side: IxcOrdersV1Side;
    /* Residual equity quantity routed to inventory */
    // format: decimal
    quantity: string;
    /* Monetary value of the residual */
    // format: decimal
    amount: string;
    // format: YYYY-MM-DD
    settlementDate: string;
    market?: IxcOrdersV1Market;
    capacity: IxcOrdersV1Capacity;
    middleMoney?: IxcOrdersV1MiddleMoney[];
}

export interface IxcOrdersV1BooksExecution {
    // format: informal
    executionId: string;
    // format: id62
    transactionId: string;
    /* Quantity of shares filled on this leg. May be fractional. */
    // format: decimal
    quantity: string;
    /* Per-share execution price for this leg. */
    // format: decimal
    price: string;
    /* Gross monetary value of the leg, price × quantity rounded to the
    smallest unit of currency. */
    // format: decimal
    amount: string;
    priceSource?: IxcOrdersV1PriceSource;
}

export enum IxcOrdersV1BooksOrderDoneOutcome {
    Unspecified = 'UNSPECIFIED',
    FullyFilled = 'FULLY_FILLED',
    PartiallyFilled = 'PARTIALLY_FILLED'
}

export enum IxcOrdersV1Capacity {
    Unspecified = 'UNSPECIFIED',
    Agent = 'AGENT',
    CorrespondentPrincipal = 'CORRESPONDENT_PRINCIPAL',
    ClearingPrincipal = 'CLEARING_PRINCIPAL',
    RisklessPrincipal = 'RISKLESS_PRINCIPAL',
    Principal = 'PRINCIPAL'
}

export type IxcOrdersV1Commission = {
    '!type'?: 'fixed';
    /* Commission will be charged once on the first execution of the order. */
    fixed: IxcOrdersV1CommissionFixed;
} | {
    '!type'?: 'simpleRate';
    /* Commission will be charged based on the execution price or quantity
    multiplied by the rate. */
    simpleRate: IxcOrdersV1CommissionSimpleRate;
};

export interface IxcOrdersV1CommissionFixed {
    // format: decimal
    amount: string;
}

export interface IxcOrdersV1CommissionSimpleRate {
    basis: IxcOrdersV1CommissionSimpleRateBasis;
    /* Rate in dollars per basis unit (e.g. $0.01 per share = 0.01) */
    // format: decimal
    rate: string;
    /* When set, the commission for the order will be at least this amount
    regardless of the basis calculation or number of fills.
    Minimums are applied on the first execution of a multi-fill order.
    Subsequent fills may not be charged commission if the total
    calculated commission does not exceed the already-charged minimum. */
    // format: decimal
    minimum?: string;
    /* When set, the total commission for the order will be at most this
    amount regardless of the basis calculation or how many fills are
    executed. Maximums are applied at the time of each fill until the
    total is reached. */
    // format: decimal
    maximum?: string;
}

export enum IxcOrdersV1CommissionSimpleRateBasis {
    Unspecified = 'UNSPECIFIED',
    Gross = 'GROSS',
    Net = 'NET',
    Quantity = 'QUANTITY'
}

export const IXC_ORDERS_V1_COMMISSION_ONE_OF_VALUES = ['fixed', 'simpleRate'] as const;

export type IxcOrdersV1CommissionOneOfValue = (typeof IXC_ORDERS_V1_COMMISSION_ONE_OF_VALUES)[number];

export enum IxcOrdersV1Counterparty {
    Unspecified = 'UNSPECIFIED',
    Route = 'ROUTE',
    Books = 'BOOKS',
    MoneyMarket = 'MONEY_MARKET'
}

export enum IxcOrdersV1FirmOrderOutcome {
    Unspecified = 'UNSPECIFIED',
    FullyFilled = 'FULLY_FILLED',
    NotFilled = 'NOT_FILLED',
    PartiallyFilled = 'PARTIALLY_FILLED'
}

export interface IxcOrdersV1InlineAllocation {
    // format: id62
    accountId: string;
    // format: decimal
    value: string;
}

export enum IxcOrdersV1Market {
    Unspecified = 'UNSPECIFIED',
    Arcx = 'ARCX',
    Xase = 'XASE',
    Xbos = 'XBOS',
    Xchi = 'XCHI',
    Xcis = 'XCIS',
    Xnas = 'XNAS',
    Xnys = 'XNYS',
    Xpsx = 'XPSX',
    Iexg = 'IEXG',
    Edga = 'EDGA',
    Edgx = 'EDGX',
    Bats = 'BATS',
    Baty = 'BATY',
    Oth = 'OTH',
    Jnst = 'JNST'
}

export interface IxcOrdersV1MiddleMoney {
    class: IxcOrdersV1MiddleMoneyClass;
    // format: decimal
    amount: string;
}

export enum IxcOrdersV1MiddleMoneyClass {
    Unspecified = 'UNSPECIFIED',
    Taf = 'TAF',
    Sec = 'SEC',
    Cat = 'CAT',
    Fftt = 'FFTT',
    Commission = 'COMMISSION'
}

export type IxcOrdersV1OrderAmount = {
    '!type'?: 'quantity';
    /* Number of shares to trade. */
    // format: decimal
    quantity: string;
} | {
    '!type'?: 'notional';
    /* Dollar amount to trade. The system calculates share quantity from the
    notional amount and the current price. */
    // format: decimal
    notional: string;
};

export interface IxcOrdersV1OrderAmountConversion {
    /* The amount actually routed to the venue. */
    amount: IxcOrdersV1OrderAmount;
    reason: IxcOrdersV1OrderAmountConversionReason;
}

export enum IxcOrdersV1OrderAmountConversionReason {
    Unspecified = 'UNSPECIFIED',
    FullPositionRedemption = 'FULL_POSITION_REDEMPTION'
}

export const IXC_ORDERS_V1_ORDER_AMOUNT_ONE_OF_VALUES = ['quantity', 'notional'] as const;

export type IxcOrdersV1OrderAmountOneOfValue = (typeof IXC_ORDERS_V1_ORDER_AMOUNT_ONE_OF_VALUES)[number];

export interface IxcOrdersV1OrderControls {
    settings?: IxcOrdersV1OrderControlsSettings;
}

export interface IxcOrdersV1OrderControlsSettings {
    usEquities?: IxcOrdersV1OrderControlsSettingsUsEquities;
}

export interface IxcOrdersV1OrderControlsSettingsUsEquities {
    /* Whether the program's accounts can close existing positions (e.g., placing a sell order to close a long position, or a buy order to close a short position). */
    canPlaceClosing?: boolean;
    /* Whether the program's accounts can open new positions (e.g., placing a buy order to open a long position, or a sell order to open a short position). */
    canPlaceOpening?: boolean;
    canTradeFractions?: boolean;
    canChargeCommission?: boolean;
}

export interface IxcOrdersV1OrderData {
    instruction: IxcOrdersV1OrderInstruction;
    /* Set when the server routed an amount other than the one the customer
    named. The instruction keeps what was asked for; this records what was
    sent instead, and why. */
    amountConversion?: IxcOrdersV1OrderAmountConversion;
    extension: IxcOrdersV1OrderExtension;
    /* Links to the Fix order for routed orders */
    // format: id62, entity: exc.route.v1.FixOrder
    fixOrderId?: string;
    /* Links to a books order for fractional or other fills from the firm's
    inventory */
    // format: id62, entity: ixc.inventory.v1.BooksOrder
    booksOrderId?: string;
    /* Links a customer notional order to its firm/inventory order. */
    // format: id62, entity: ixc.inventory.v1.FirmOrder
    firmOrderId?: string;
    asset?: IxcAssetsV1AssetState;
    // format: decimal
    quotePrice?: string;
    /* Sum of the `quantity` field on all fills, representing the total number
    of shares which have been filled on this order so far. */
    // format: decimal
    totalQuantity?: string;
    /* Sum of the `amount` field of all fills, representing the total monetary
    value (cost or proceeds) of the order so far. */
    // format: decimal
    totalAmount?: string;
    /* totalAmount / totalQuantity, representing the average price of all fills
    on this order. */
    // format: decimal
    averagePrice?: string;
    // format: id62, entity: ixc.portfolio.v1.Hold
    holdId?: string;
    // format: id62, entity: ixc.orders.v1.BatchOrder
    batchOrderId?: string;
    /* The trading session during which the order is eligible to execute. */
    tradingHours: IxcOrdersV1TradingHours;
    /* Regulatory reporting status for this order's executions, populated
    asynchronously as trade reporting facilities respond. */
    tradeReporting?: IxcOrdersV1OrderTradeReporting;
}

export interface IxcOrdersV1OrderEvent extends IxcOrdersV1OrderKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcOrdersV1OrderEventType;
}

export type IxcOrdersV1OrderEventType = {
    '!type'?: 'requested';
    requested: IxcOrdersV1OrderEventTypeRequested;
} | {
    '!type'?: 'rejected';
    rejected: IxcOrdersV1OrderEventTypeRejected;
} | {
    '!type'?: 'approvalReply';
    approvalReply: IxcOrdersV1OrderEventTypeApprovalReply;
} | {
    '!type'?: 'accepted';
    accepted: EmptyObject;
} | {
    '!type'?: 'routeExternal';
    routeExternal: IxcOrdersV1OrderEventTypeRouteExternal;
} | {
    '!type'?: 'routeFirm';
    routeFirm: IxcOrdersV1OrderEventTypeRouteFirm;
} | {
    '!type'?: 'routeBooks';
    routeBooks: IxcOrdersV1OrderEventTypeRouteBooks;
} | {
    '!type'?: 'cancelRequested';
    cancelRequested: IxcOrdersV1OrderEventTypeCancelRequested;
} | {
    '!type'?: 'fill';
    fill: IxcOrdersV1OrderEventTypeFill;
} | {
    '!type'?: 'firmOrderDone';
    firmOrderDone: IxcOrdersV1OrderEventTypeFirmOrderDone;
} | {
    '!type'?: 'done';
    done: IxcOrdersV1OrderEventTypeDone;
} | {
    '!type'?: 'trfReportUpdated';
    trfReportUpdated: IxcOrdersV1OrderEventTypeTrfReportUpdated;
} | {
    '!type'?: 'routeMoneyMarket';
    routeMoneyMarket: EmptyObject;
} | {
    '!type'?: 'booksOrderDone';
    booksOrderDone: IxcOrdersV1OrderEventTypeBooksOrderDone;
};

export interface IxcOrdersV1OrderEventTypeApprovalReply {
    reply?: IxcOrdersV1OrderEventTypeApprovalReplyType;
}

export type IxcOrdersV1OrderEventTypeApprovalReplyType = {
    '!type'?: 'symbol';
    /* The symbol and pricing information has been resolved. This
    information is loaded in an event after the order is
    submitted. */
    symbol: IxcOrdersV1OrderEventTypeApprovalReplyTypeSymbol;
} | {
    '!type'?: 'reservation';
    reservation: IxcOrdersV1OrderEventTypeApprovalReplyTypeReservation;
};

export interface IxcOrdersV1OrderEventTypeApprovalReplyTypeReservation {
    outcome: IxcPortfolioV1HoldOutcome;
}

export interface IxcOrdersV1OrderEventTypeApprovalReplyTypeSymbol {
    asset?: IxcAssetsV1AssetState;
    quote?: IxcQuoteV1Quote;
    outcome?: IxcQuoteV1QuoteOutcome;
}

export const IXC_ORDERS_V1_ORDER_EVENT_TYPE_APPROVAL_REPLY_TYPE_ONE_OF_VALUES = ['symbol', 'reservation'] as const;

export type IxcOrdersV1OrderEventTypeApprovalReplyTypeOneOfValue = (typeof IXC_ORDERS_V1_ORDER_EVENT_TYPE_APPROVAL_REPLY_TYPE_ONE_OF_VALUES)[number];

export interface IxcOrdersV1OrderEventTypeBooksOrderDone {
    // format: date-time
    executionTime: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settlementDate: string;
    /* The leg traded against the firm's inventory in principal capacity. */
    principalExecution?: IxcOrdersV1BooksExecution;
    /* The whole-share leg passed through at the firm's street average in
    riskless-principal capacity. */
    risklessPrincipalExecution?: IxcOrdersV1BooksExecution;
    /* Whether the executions cover the full requested amount. On
    PARTIALLY_FILLED the unspent remainder of a notional order's hold
    must be released rather than consumed. */
    outcome: IxcOrdersV1BooksOrderDoneOutcome;
}

export interface IxcOrdersV1OrderEventTypeCancelRequested {
    reason?: string;
}

export interface IxcOrdersV1OrderEventTypeDone {
    // format: decimal
    averagePrice: string;
    // format: decimal
    totalQuantity: string;
    outcome?: IxcOrdersV1OrderEventTypeDoneOutcome;
    /* When true, totalQuantity is equal to the requested quantity of the
    order. This field will be false when orders expire, are cancelled, or
    otherwise pulled back from the execution venue prior to being fully
    filled, but after some quantity has been filled but not all. */
    fullyFilled?: boolean;
}

export enum IxcOrdersV1OrderEventTypeDoneOutcome {
    Unspecified = 'UNSPECIFIED',
    FullyFilled = 'FULLY_FILLED',
    NotFilled = 'NOT_FILLED',
    PartiallyFilled = 'PARTIALLY_FILLED'
}

export interface IxcOrdersV1OrderEventTypeFill {
    /* From the fix and UTC messages */
    // format: informal
    executionId: string;
    // format: id62
    transactionId: string;
    // format: date-time
    executionTime: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settlementDate: string;
    /* Set when time is non-standard, e.g. same day settlement of mutual
    fund orders */
    // format: date-time
    settlementTime?: string;
    /* Quantity of shares filled. May be fractional. */
    // format: decimal
    quantity: string;
    /* Per-share execution price. */
    // format: decimal
    price: string;
    /* Monetary value of the fill, determined by the price of the fill
    multiplied by the quantity, rounded to the smallest unit of currency.
    This rounded figure is used for debiting/crediting the brokerage
    account.
    For buy orders, this is the 'cost' of the fill, for sell orders, this
    is the 'proceeds' of the fill. */
    // format: decimal
    amount: string;
    counterparty: IxcOrdersV1Counterparty;
    /* FIX Tag 375 ContraBroker. Identifies the exchange or venue where the
    fill was executed. For books fills, this will be empty. */
    market?: string;
    /* How the execution price was determined for principal fills from the
    broker's books. Unset for exchange fills. */
    priceSource?: IxcOrdersV1PriceSource;
}

export interface IxcOrdersV1OrderEventTypeFirmOrderDone {
    // format: decimal
    averagePrice: string;
    // format: decimal
    totalQuantity: string;
    outcome: IxcOrdersV1FirmOrderOutcome;
}

export interface IxcOrdersV1OrderEventTypeRejected {
    party?: IxcOrdersV1OrderEventTypeRejectedParty;
    reasonText: string;
    reasonCode: IxcOrdersV1OrderRejectionCode;
}

export enum IxcOrdersV1OrderEventTypeRejectedParty {
    Unspecified = 'UNSPECIFIED',
    System = 'SYSTEM',
    Route = 'ROUTE'
}

export interface IxcOrdersV1OrderEventTypeRequested {
    instruction: IxcOrdersV1OrderInstruction;
    extension: IxcOrdersV1OrderExtension;
    /* When set, this is the program-level order for a batch. The APPROVAL
    flow is skipped; asset and quote data are provided here instead of
    being fetched from the quote service. */
    batchOrderContext?: IxcOrdersV1BatchOrderContext;
    /* The trading session during which the order is eligible to execute. */
    tradingHours: IxcOrdersV1TradingHours;
}

export interface IxcOrdersV1OrderEventTypeRouteBooks {
    // format: id62
    booksOrderId: string;
    /* The amount routed to the books: the exact share quantity for quantity
    orders (pure fractional and mixed remainders), or the dollar amount
    for notional orders, matching what inventory is asked to fill. */
    amount: IxcOrdersV1OrderAmount;
    /* Reference per-share price for the books order: the average price of
    routed fills when the order already has fills, otherwise the quote
    price. */
    // format: decimal
    price: string;
}

export interface IxcOrdersV1OrderEventTypeRouteExternal {
    // format: id62
    fixOrderId: string;
    instruction: IxcOrdersV1OrderInstruction;
}

export interface IxcOrdersV1OrderEventTypeRouteFirm {
    // format: id62
    firmOrderId: string;
    instruction: IxcOrdersV1OrderInstruction;
}

export interface IxcOrdersV1OrderEventTypeTrfReportUpdated {
    // format: id62
    trfReportId: string;
    executionId: string;
    status: IxcOrdersV1TrfStatus;
    errorMessage?: string;
    // format: date-time
    updatedAt: string;
}

export const IXC_ORDERS_V1_ORDER_EVENT_TYPE_ONE_OF_VALUES = ['requested', 'rejected', 'approvalReply', 'accepted', 'routeExternal', 'routeFirm', 'routeBooks', 'cancelRequested', 'fill', 'firmOrderDone', 'done', 'trfReportUpdated', 'routeMoneyMarket', 'booksOrderDone'] as const;

export type IxcOrdersV1OrderEventTypeOneOfValue = (typeof IXC_ORDERS_V1_ORDER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcOrdersV1OrderExtension {
    /* Free text which can be used to store additional information about the
    order, and will appear on the trade confirmation. */
    trailer?: string;
    /* When true, the order was solicited by the customer / account-holder. This
    field is set by the client. */
    solicited?: boolean;
    commission?: IxcOrdersV1Commission;
}

export interface IxcOrdersV1OrderInstruction {
    symbol: string;
    amount: IxcOrdersV1OrderAmount;
    side: IxcOrdersV1Side;
    // format: decimal
    limitPrice?: string;
    timeInForce: IxcOrdersV1OrderInstructionTimeInForce;
    /* Tax lot selection strategy for sell orders. Only applicable when side is
    SELL. When not specified, defaults to FIFO. */
    taxLotSelection?: IxcOrdersV1OrderInstructionTaxLotSelection;
}

export type IxcOrdersV1OrderInstructionTaxLotSelection = {
    '!type'?: 'wellKnown';
    /* Use a standard lot selection method */
    wellKnown: IxcOrdersV1OrderInstructionTaxLotSelectionWellKnown;
} | {
    '!type'?: 'custom';
    /* Manually select specific tax lots to sell from. Each allocation
    specifies a tax lot and the quantity to sell from it. Allocations are
    processed sequentially across fills. */
    custom: IxcOrdersV1OrderInstructionTaxLotSelectionCustom;
};

export interface IxcOrdersV1OrderInstructionTaxLotSelectionCustom {
    allocations: IxcPortfolioV1TaxLotAllocation[];
}

export interface IxcOrdersV1OrderInstructionTaxLotSelectionWellKnown {
    method: IxcPortfolioV1TaxLotMethod;
}

export const IXC_ORDERS_V1_ORDER_INSTRUCTION_TAX_LOT_SELECTION_ONE_OF_VALUES = ['wellKnown', 'custom'] as const;

export type IxcOrdersV1OrderInstructionTaxLotSelectionOneOfValue = (typeof IXC_ORDERS_V1_ORDER_INSTRUCTION_TAX_LOT_SELECTION_ONE_OF_VALUES)[number];

export enum IxcOrdersV1OrderInstructionTimeInForce {
    Unspecified = 'UNSPECIFIED',
    Day = 'DAY'
}

export interface IxcOrdersV1OrderKeys {
    // format: id62
    orderId: string;
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
}

export interface IxcOrdersV1OrderQueryServiceOrderEventsOrderEventsRequest {
    // format: id62
    orderId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcOrdersV1OrderQueryServiceOrderEventsSearchableFields, IxcOrdersV1OrderQueryServiceOrderEventsSortableFields, IxcOrdersV1OrderQueryServiceOrderEventsFilterableFields>;
}

export enum IxcOrdersV1OrderQueryServiceOrderEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    OrderId = 'orderId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    EventRequestedInstructionSide = 'event.requested.instruction.side',
    EventRequestedBatchOrderContextAssetAssetId = 'event.requested.batchOrderContext.asset.assetId',
    EventRequestedBatchOrderContextAssetDataTypeEquityCusip = 'event.requested.batchOrderContext.asset.data.type.equity.cusip',
    EventRequestedBatchOrderContextAssetDataTypeEquityControlsCanBuy = 'event.requested.batchOrderContext.asset.data.type.equity.controls.canBuy',
    EventRequestedBatchOrderContextAssetDataTypeEquityControlsCanSell = 'event.requested.batchOrderContext.asset.data.type.equity.controls.canSell',
    EventRequestedBatchOrderContextAssetDataTypeEquityControlsCanEnterFractions = 'event.requested.batchOrderContext.asset.data.type.equity.controls.canEnterFractions',
    EventRequestedBatchOrderContextAssetDataTypeMoneyMarketCusip = 'event.requested.batchOrderContext.asset.data.type.moneyMarket.cusip',
    EventRequestedBatchOrderContextAssetDataTypeMoneyMarketControlsCanBuy = 'event.requested.batchOrderContext.asset.data.type.moneyMarket.controls.canBuy',
    EventRequestedBatchOrderContextAssetDataTypeMoneyMarketControlsCanSell = 'event.requested.batchOrderContext.asset.data.type.moneyMarket.controls.canSell',
    EventRequestedBatchOrderContextAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.requested.batchOrderContext.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventRequestedBatchOrderContextAssetDataTypeMoneyMarketClassification = 'event.requested.batchOrderContext.asset.data.type.moneyMarket.classification',
    EventRequestedBatchOrderContextAssetDataTypeMoneyMarketNavType = 'event.requested.batchOrderContext.asset.data.type.moneyMarket.navType',
    EventRequestedBatchOrderContextAssetDataTypeType = 'event.requested.batchOrderContext.asset.data.type.!type',
    EventRequestedBatchOrderContextAssetDataCategory = 'event.requested.batchOrderContext.asset.data.category',
    EventRequestedBatchOrderContextAssetStatus = 'event.requested.batchOrderContext.asset.status',
    EventApprovalReplyReplySymbolAssetAssetId = 'event.approvalReply.reply.symbol.asset.assetId',
    EventApprovalReplyReplySymbolAssetDataTypeEquityCusip = 'event.approvalReply.reply.symbol.asset.data.type.equity.cusip',
    EventApprovalReplyReplySymbolAssetDataTypeEquityControlsCanBuy = 'event.approvalReply.reply.symbol.asset.data.type.equity.controls.canBuy',
    EventApprovalReplyReplySymbolAssetDataTypeEquityControlsCanSell = 'event.approvalReply.reply.symbol.asset.data.type.equity.controls.canSell',
    EventApprovalReplyReplySymbolAssetDataTypeEquityControlsCanEnterFractions = 'event.approvalReply.reply.symbol.asset.data.type.equity.controls.canEnterFractions',
    EventApprovalReplyReplySymbolAssetDataTypeMoneyMarketCusip = 'event.approvalReply.reply.symbol.asset.data.type.moneyMarket.cusip',
    EventApprovalReplyReplySymbolAssetDataTypeMoneyMarketControlsCanBuy = 'event.approvalReply.reply.symbol.asset.data.type.moneyMarket.controls.canBuy',
    EventApprovalReplyReplySymbolAssetDataTypeMoneyMarketControlsCanSell = 'event.approvalReply.reply.symbol.asset.data.type.moneyMarket.controls.canSell',
    EventApprovalReplyReplySymbolAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.approvalReply.reply.symbol.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventApprovalReplyReplySymbolAssetDataTypeMoneyMarketClassification = 'event.approvalReply.reply.symbol.asset.data.type.moneyMarket.classification',
    EventApprovalReplyReplySymbolAssetDataTypeMoneyMarketNavType = 'event.approvalReply.reply.symbol.asset.data.type.moneyMarket.navType',
    EventApprovalReplyReplySymbolAssetDataTypeType = 'event.approvalReply.reply.symbol.asset.data.type.!type',
    EventApprovalReplyReplySymbolAssetDataCategory = 'event.approvalReply.reply.symbol.asset.data.category',
    EventApprovalReplyReplySymbolAssetStatus = 'event.approvalReply.reply.symbol.asset.status',
    EventRouteExternalInstructionSide = 'event.routeExternal.instruction.side',
    EventRouteFirmInstructionSide = 'event.routeFirm.instruction.side',
    EventType = 'event.!type'
}

export enum IxcOrdersV1OrderQueryServiceOrderEventsSearchableFields {
    EventRequestedBatchOrderContextAssetDataTypeEquitySymbolBase = 'event.requested.batchOrderContext.asset.data.type.equity.symbol.base',
    EventRequestedBatchOrderContextAssetDataTypeEquityName = 'event.requested.batchOrderContext.asset.data.type.equity.name',
    EventRequestedBatchOrderContextAssetDataTypeMoneyMarketSymbolBase = 'event.requested.batchOrderContext.asset.data.type.moneyMarket.symbol.base',
    EventRequestedBatchOrderContextAssetDataTypeMoneyMarketName = 'event.requested.batchOrderContext.asset.data.type.moneyMarket.name',
    EventApprovalReplyReplySymbolAssetDataTypeEquitySymbolBase = 'event.approvalReply.reply.symbol.asset.data.type.equity.symbol.base',
    EventApprovalReplyReplySymbolAssetDataTypeEquityName = 'event.approvalReply.reply.symbol.asset.data.type.equity.name',
    EventApprovalReplyReplySymbolAssetDataTypeMoneyMarketSymbolBase = 'event.approvalReply.reply.symbol.asset.data.type.moneyMarket.symbol.base',
    EventApprovalReplyReplySymbolAssetDataTypeMoneyMarketName = 'event.approvalReply.reply.symbol.asset.data.type.moneyMarket.name'
}

export enum IxcOrdersV1OrderQueryServiceOrderEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventRequestedBatchOrderContextAssetMetadataCreatedAt = 'event.requested.batchOrderContext.asset.metadata.createdAt',
    EventRequestedBatchOrderContextAssetMetadataUpdatedAt = 'event.requested.batchOrderContext.asset.metadata.updatedAt',
    EventApprovalReplyReplySymbolAssetMetadataCreatedAt = 'event.approvalReply.reply.symbol.asset.metadata.createdAt',
    EventApprovalReplyReplySymbolAssetMetadataUpdatedAt = 'event.approvalReply.reply.symbol.asset.metadata.updatedAt'
}

export interface IxcOrdersV1OrderQueryServiceOrderGetOrderGetRequest {
    // format: id62
    orderId: string;
}

export interface IxcOrdersV1OrderQueryServiceOrderListOrderListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcOrdersV1OrderQueryServiceOrderListSearchableFields, IxcOrdersV1OrderQueryServiceOrderListSortableFields, IxcOrdersV1OrderQueryServiceOrderListFilterableFields>;
}

export enum IxcOrdersV1OrderQueryServiceOrderListFilterableFields {
    OrderId = 'orderId',
    AccountId = 'accountId',
    ProgramId = 'programId',
    DataInstructionSide = 'data.instruction.side',
    DataAssetAssetId = 'data.asset.assetId',
    DataAssetDataTypeEquityCusip = 'data.asset.data.type.equity.cusip',
    DataAssetDataTypeEquityControlsCanBuy = 'data.asset.data.type.equity.controls.canBuy',
    DataAssetDataTypeEquityControlsCanSell = 'data.asset.data.type.equity.controls.canSell',
    DataAssetDataTypeEquityControlsCanEnterFractions = 'data.asset.data.type.equity.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketCusip = 'data.asset.data.type.moneyMarket.cusip',
    DataAssetDataTypeMoneyMarketControlsCanBuy = 'data.asset.data.type.moneyMarket.controls.canBuy',
    DataAssetDataTypeMoneyMarketControlsCanSell = 'data.asset.data.type.moneyMarket.controls.canSell',
    DataAssetDataTypeMoneyMarketControlsCanEnterFractions = 'data.asset.data.type.moneyMarket.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketClassification = 'data.asset.data.type.moneyMarket.classification',
    DataAssetDataTypeMoneyMarketNavType = 'data.asset.data.type.moneyMarket.navType',
    DataAssetDataTypeType = 'data.asset.data.type.!type',
    DataAssetDataCategory = 'data.asset.data.category',
    DataAssetStatus = 'data.asset.status',
    DataHoldId = 'data.holdId',
    DataBatchOrderId = 'data.batchOrderId',
    Status = 'status'
}

export enum IxcOrdersV1OrderQueryServiceOrderListSearchableFields {
    DataAssetDataTypeEquitySymbolBase = 'data.asset.data.type.equity.symbol.base',
    DataAssetDataTypeEquityName = 'data.asset.data.type.equity.name',
    DataAssetDataTypeMoneyMarketSymbolBase = 'data.asset.data.type.moneyMarket.symbol.base',
    DataAssetDataTypeMoneyMarketName = 'data.asset.data.type.moneyMarket.name'
}

export enum IxcOrdersV1OrderQueryServiceOrderListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataAssetMetadataCreatedAt = 'data.asset.metadata.createdAt',
    DataAssetMetadataUpdatedAt = 'data.asset.metadata.updatedAt'
}

export enum IxcOrdersV1OrderRejectionCode {
    Unspecified = 'UNSPECIFIED',
    SymbolBuyNotAllowed = 'SYMBOL_BUY_NOT_ALLOWED',
    SymbolSellNotAllowed = 'SYMBOL_SELL_NOT_ALLOWED',
    SymbolFractionsNotAllowed = 'SYMBOL_FRACTIONS_NOT_ALLOWED',
    SymbolNotFound = 'SYMBOL_NOT_FOUND',
    SymbolNotActive = 'SYMBOL_NOT_ACTIVE',
    SymbolHalted = 'SYMBOL_HALTED',
    MarketClosed = 'MARKET_CLOSED',
    BalanceHoldRejected = 'BALANCE_HOLD_REJECTED',
    QuantityPrecisionExceeded = 'QUANTITY_PRECISION_EXCEEDED',
    RouteRejected = 'ROUTE_REJECTED',
    TaxLotSelectionInvalid = 'TAX_LOT_SELECTION_INVALID',
    SymbolNotSupported = 'SYMBOL_NOT_SUPPORTED',
    EstimatedNotionalZero = 'ESTIMATED_NOTIONAL_ZERO'
}

export interface IxcOrdersV1OrderState extends IxcOrdersV1OrderKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcOrdersV1OrderData;
    status: IxcOrdersV1OrderStatus;
}

export enum IxcOrdersV1OrderStatus {
    Unspecified = 'UNSPECIFIED',
    Approval = 'APPROVAL',
    Rejected = 'REJECTED',
    Active = 'ACTIVE',
    Done = 'DONE'
}

export interface IxcOrdersV1OrderTradeReporting {
    trfReports: IxcOrdersV1TrfReportRef[];
}

export enum IxcOrdersV1PriceSource {
    Unspecified = 'UNSPECIFIED',
    Quote = 'QUOTE',
    Average = 'AVERAGE'
}

export enum IxcOrdersV1Side {
    Unspecified = 'UNSPECIFIED',
    Buy = 'BUY',
    Sell = 'SELL'
}

export interface IxcOrdersV1TradeTransaction {
    // format: id62
    orderId: string;
    // format: id62
    accountId: string;
    /* From the fix and UTC messages */
    // format: informal
    executionId: string;
    // format: date-time
    executionTime: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settlementDate: string;
    // format: informal
    symbol: string;
    // format: informal
    cusip: string;
    // format: id62
    assetId: string;
    side: IxcOrdersV1Side;
    /* The number of shares filled, from fill.quantity */
    // format: decimal
    quantity: string;
    /* The price per share, from fill.price */
    // format: decimal
    price: string;
    /* The total amount of the trade before any fees or commissions */
    // format: decimal
    grossAmount: string;
    /* The total amount of the trade after any fees or commissions */
    // format: decimal
    netAmount: string;
    solicited?: boolean;
    trailer?: string;
    market?: IxcOrdersV1Market;
    capacity: IxcOrdersV1Capacity;
    middleMoney?: IxcOrdersV1MiddleMoney[];
    priceSource?: IxcOrdersV1PriceSource;
    /* Who the trade settled against; MONEY_MARKET fills settle with the fund provider and have no street-side execution */
    counterparty?: IxcOrdersV1Counterparty;
}

export enum IxcOrdersV1TradingHours {
    Unspecified = 'UNSPECIFIED',
    Regular = 'REGULAR',
    Extended = 'EXTENDED'
}

export interface IxcOrdersV1TrfReportRef {
    // format: id62, entity: ixc.trf.v1.TrfReport
    trfReportId: string;
    executionId: string;
    status: IxcOrdersV1TrfStatus;
    errorMessage?: string;
    // format: date-time
    updatedAt: string;
}

export enum IxcOrdersV1TrfStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Accepted = 'ACCEPTED',
    Rejected = 'REJECTED'
}

export interface IxcPaymentsV1AccountNumberData {
    spec: IxcPaymentsV1AccountNumberSpec;
    // format: custom - pattern: ^.*$
    externalId?: string;
    bankDetails?: IxcFundingV1UsBankDetails;
}

export interface IxcPaymentsV1AccountNumberEvent extends IxcFundingV1AccountNumberKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcPaymentsV1AccountNumberEventType;
}

export type IxcPaymentsV1AccountNumberEventType = {
    '!type'?: 'requested';
    requested: IxcPaymentsV1AccountNumberEventTypeRequested;
} | {
    '!type'?: 'created';
    created: IxcPaymentsV1AccountNumberEventTypeCreated;
} | {
    '!type'?: 'disabled';
    disabled: EmptyObject;
} | {
    '!type'?: 'reenabled';
    reenabled: EmptyObject;
};

export interface IxcPaymentsV1AccountNumberEventTypeCreated {
    externalId: string;
    bankDetails: IxcFundingV1UsBankDetails;
}

export interface IxcPaymentsV1AccountNumberEventTypeRequested {
    spec: IxcPaymentsV1AccountNumberSpec;
}

export const IXC_PAYMENTS_V1_ACCOUNT_NUMBER_EVENT_TYPE_ONE_OF_VALUES = ['requested', 'created', 'disabled', 'reenabled'] as const;

export type IxcPaymentsV1AccountNumberEventTypeOneOfValue = (typeof IXC_PAYMENTS_V1_ACCOUNT_NUMBER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcPaymentsV1AccountNumberKeys {
    /* Our system's unique identifier for the account number at Increase or
    other banking provider. */
    // format: id62
    accountNumberId: string;
}

export interface IxcPaymentsV1AccountNumberQueryServiceAccountNumberEventsAccountNumberEventsRequest {
    /* Our system's unique identifier for the account number at Increase or
    other banking provider. */
    // format: id62
    accountNumberId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcPaymentsV1AccountNumberQueryServiceAccountNumberEventsSearchableFields, IxcPaymentsV1AccountNumberQueryServiceAccountNumberEventsSortableFields, IxcPaymentsV1AccountNumberQueryServiceAccountNumberEventsFilterableFields>;
}

export enum IxcPaymentsV1AccountNumberQueryServiceAccountNumberEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AccountNumberId = 'accountNumberId',
    EventRequestedSpecAccountId = 'event.requested.spec.accountId',
    EventRequestedSpecProgramId = 'event.requested.spec.programId',
    EventType = 'event.!type'
}

export enum IxcPaymentsV1AccountNumberQueryServiceAccountNumberEventsSearchableFields {
    EventCreatedBankDetailsAccountNumber = 'event.created.bankDetails.accountNumber'
}

export enum IxcPaymentsV1AccountNumberQueryServiceAccountNumberEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcPaymentsV1AccountNumberQueryServiceAccountNumberGetAccountNumberGetRequest {
    /* Our system's unique identifier for the account number at Increase or
    other banking provider. */
    // format: id62
    accountNumberId: string;
}

export interface IxcPaymentsV1AccountNumberQueryServiceAccountNumberListAccountNumberListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcPaymentsV1AccountNumberQueryServiceAccountNumberListSearchableFields, IxcPaymentsV1AccountNumberQueryServiceAccountNumberListSortableFields, IxcPaymentsV1AccountNumberQueryServiceAccountNumberListFilterableFields>;
}

export enum IxcPaymentsV1AccountNumberQueryServiceAccountNumberListFilterableFields {
    AccountNumberId = 'accountNumberId',
    DataSpecAccountId = 'data.spec.accountId',
    DataSpecProgramId = 'data.spec.programId',
    DataExternalId = 'data.externalId',
    Status = 'status'
}

export enum IxcPaymentsV1AccountNumberQueryServiceAccountNumberListSearchableFields {
    DataBankDetailsAccountNumber = 'data.bankDetails.accountNumber'
}

export enum IxcPaymentsV1AccountNumberQueryServiceAccountNumberListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcPaymentsV1AccountNumberSpec {
    /* The vendor (Increase) account ID this account number will route to.
    Currently not used but will allow multiple Increase accounts to be used
    later. */
    parentAccountId?: string;
    inboundAchDebitAllowed?: boolean;
    // pattern: \w{1,199}
    name: string;
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
}

export interface IxcPaymentsV1AccountNumberState extends IxcPaymentsV1AccountNumberKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcPaymentsV1AccountNumberData;
    status: IxcPaymentsV1AccountNumberStatus;
}

export enum IxcPaymentsV1AccountNumberStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Active = 'ACTIVE',
    Disabled = 'DISABLED'
}

export interface IxcPaymentsV1AchData {
    spec: IxcPaymentsV1AchSpec;
}

export interface IxcPaymentsV1AchEvent extends IxcPaymentsV1AchKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcPaymentsV1AchEventType;
}

export type IxcPaymentsV1AchEventType = {
    '!type'?: 'created';
    created: IxcPaymentsV1AchEventTypeCreated;
} | {
    '!type'?: 'canceled';
    canceled: EmptyObject;
} | {
    '!type'?: 'rejected';
    rejected: IxcPaymentsV1AchEventTypeRejected;
} | {
    '!type'?: 'returned';
    returned: IxcPaymentsV1AchEventTypeReturned;
} | {
    '!type'?: 'settled';
    settled: EmptyObject;
};

export interface IxcPaymentsV1AchEventTypeCreated {
    spec: IxcPaymentsV1AchSpec;
}

export interface IxcPaymentsV1AchEventTypeRejected {
    reason?: string;
}

export interface IxcPaymentsV1AchEventTypeReturned {
    reason: string;
}

export const IXC_PAYMENTS_V1_ACH_EVENT_TYPE_ONE_OF_VALUES = ['created', 'canceled', 'rejected', 'returned', 'settled'] as const;

export type IxcPaymentsV1AchEventTypeOneOfValue = (typeof IXC_PAYMENTS_V1_ACH_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcPaymentsV1AchKeys {
    // format: id62
    achId: string;
}

export interface IxcPaymentsV1AchQueryServiceAchEventsAchEventsRequest {
    // format: id62
    achId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcPaymentsV1AchQueryServiceAchEventsSearchableFields, IxcPaymentsV1AchQueryServiceAchEventsSortableFields, IxcPaymentsV1AchQueryServiceAchEventsFilterableFields>;
}

export enum IxcPaymentsV1AchQueryServiceAchEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AchId = 'achId',
    EventCreatedSpecAccountId = 'event.created.spec.accountId',
    EventCreatedSpecProgramId = 'event.created.spec.programId',
    EventCreatedSpecSourceId = 'event.created.spec.sourceId',
    EventCreatedSpecTransferId = 'event.created.spec.transferId',
    EventType = 'event.!type'
}

export enum IxcPaymentsV1AchQueryServiceAchEventsSearchableFields {
    EventCreatedSpecAchSourceBankDetailsAccountNumber = 'event.created.spec.achSource.bankDetails.accountNumber'
}

export enum IxcPaymentsV1AchQueryServiceAchEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcPaymentsV1AchQueryServiceAchGetAchGetRequest {
    // format: id62
    achId: string;
}

export interface IxcPaymentsV1AchQueryServiceAchListAchListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcPaymentsV1AchQueryServiceAchListSearchableFields, IxcPaymentsV1AchQueryServiceAchListSortableFields, IxcPaymentsV1AchQueryServiceAchListFilterableFields>;
}

export enum IxcPaymentsV1AchQueryServiceAchListFilterableFields {
    AchId = 'achId',
    DataSpecAccountId = 'data.spec.accountId',
    DataSpecProgramId = 'data.spec.programId',
    DataSpecSourceId = 'data.spec.sourceId',
    DataSpecTransferId = 'data.spec.transferId',
    Status = 'status'
}

export enum IxcPaymentsV1AchQueryServiceAchListSearchableFields {
    DataSpecAchSourceBankDetailsAccountNumber = 'data.spec.achSource.bankDetails.accountNumber'
}

export enum IxcPaymentsV1AchQueryServiceAchListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcPaymentsV1AchSpec {
    // format: decimal
    amount?: string;
    transferType?: IxcFundingV1TransferType;
    achSource?: IxcFundingV1AchSource;
    /* Short name that will appear in customer bank accounts */
    programBankingName?: string;
    ownerType: IxcFundingV1BankAccountOwnerType;
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
    // format: id62, entity: ixc.funding.v1.Source
    sourceId?: string;
    // format: id62, entity: ixc.funding.v1.Transfer
    transferId?: string;
}

export interface IxcPaymentsV1AchState extends IxcPaymentsV1AchKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcPaymentsV1AchData;
    status: IxcPaymentsV1AchStatus;
}

export enum IxcPaymentsV1AchStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Canceled = 'CANCELED',
    Rejected = 'REJECTED',
    Returned = 'RETURNED',
    Settled = 'SETTLED'
}

export interface IxcPaymentsV1IncomingAchData {
    spec: IxcPaymentsV1IncomingAchSpec;
}

export interface IxcPaymentsV1IncomingAchEvent extends IxcPaymentsV1IncomingAchKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcPaymentsV1IncomingAchEventType;
}

export type IxcPaymentsV1IncomingAchEventType = {
    '!type'?: 'settled';
    settled: IxcPaymentsV1IncomingAchEventTypeSettled;
} | {
    '!type'?: 'returned';
    returned: IxcPaymentsV1IncomingAchEventTypeReturned;
};

export interface IxcPaymentsV1IncomingAchEventTypeReturned {
    reason: string;
}

export interface IxcPaymentsV1IncomingAchEventTypeSettled {
    spec: IxcPaymentsV1IncomingAchSpec;
}

export const IXC_PAYMENTS_V1_INCOMING_ACH_EVENT_TYPE_ONE_OF_VALUES = ['settled', 'returned'] as const;

export type IxcPaymentsV1IncomingAchEventTypeOneOfValue = (typeof IXC_PAYMENTS_V1_INCOMING_ACH_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcPaymentsV1IncomingAchKeys {
    // format: id62
    achId: string;
}

export interface IxcPaymentsV1IncomingAchQueryServiceIncomingAchEventsIncomingAchEventsRequest {
    // format: id62
    achId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcPaymentsV1IncomingAchQueryServiceIncomingAchEventsSortableFields, IxcPaymentsV1IncomingAchQueryServiceIncomingAchEventsFilterableFields>;
}

export enum IxcPaymentsV1IncomingAchQueryServiceIncomingAchEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AchId = 'achId',
    EventSettledSpecAccountNumberId = 'event.settled.spec.accountNumberId',
    EventSettledSpecAccountId = 'event.settled.spec.accountId',
    EventSettledSpecProgramId = 'event.settled.spec.programId',
    EventSettledSpecTransferId = 'event.settled.spec.transferId',
    EventType = 'event.!type'
}

export enum IxcPaymentsV1IncomingAchQueryServiceIncomingAchEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcPaymentsV1IncomingAchQueryServiceIncomingAchGetIncomingAchGetRequest {
    // format: id62
    achId: string;
}

export interface IxcPaymentsV1IncomingAchQueryServiceIncomingAchListIncomingAchListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcPaymentsV1IncomingAchQueryServiceIncomingAchListSortableFields, IxcPaymentsV1IncomingAchQueryServiceIncomingAchListFilterableFields>;
}

export enum IxcPaymentsV1IncomingAchQueryServiceIncomingAchListFilterableFields {
    AchId = 'achId',
    DataSpecAccountNumberId = 'data.spec.accountNumberId',
    DataSpecAccountId = 'data.spec.accountId',
    DataSpecProgramId = 'data.spec.programId',
    DataSpecTransferId = 'data.spec.transferId',
    Status = 'status'
}

export enum IxcPaymentsV1IncomingAchQueryServiceIncomingAchListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcPaymentsV1IncomingAchSpec {
    // format: decimal
    amount?: string;
    // format: id62, entity: ixc.funding.v1.AccountNumber
    accountNumberId: string;
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
    // format: id62, entity: ixc.funding.v1.Transfer
    transferId: string;
}

export interface IxcPaymentsV1IncomingAchState extends IxcPaymentsV1IncomingAchKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcPaymentsV1IncomingAchData;
    status: IxcPaymentsV1IncomingAchStatus;
}

export enum IxcPaymentsV1IncomingAchStatus {
    Unspecified = 'UNSPECIFIED',
    Settled = 'SETTLED',
    Returned = 'RETURNED'
}

export interface IxcPaymentsV1IncomingWireData {
    spec: IxcPaymentsV1IncomingWireSpec;
}

export interface IxcPaymentsV1IncomingWireEvent extends IxcPaymentsV1IncomingWireKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcPaymentsV1IncomingWireEventType;
}

export type IxcPaymentsV1IncomingWireEventType = {
    '!type'?: 'settled';
    settled: IxcPaymentsV1IncomingWireEventTypeSettled;
} | {
    '!type'?: 'reversed';
    reversed: EmptyObject;
};

export interface IxcPaymentsV1IncomingWireEventTypeSettled {
    spec: IxcPaymentsV1IncomingWireSpec;
}

export const IXC_PAYMENTS_V1_INCOMING_WIRE_EVENT_TYPE_ONE_OF_VALUES = ['settled', 'reversed'] as const;

export type IxcPaymentsV1IncomingWireEventTypeOneOfValue = (typeof IXC_PAYMENTS_V1_INCOMING_WIRE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcPaymentsV1IncomingWireKeys {
    // format: id62
    wireId: string;
}

export interface IxcPaymentsV1IncomingWireQueryServiceIncomingWireEventsIncomingWireEventsRequest {
    // format: id62
    wireId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcPaymentsV1IncomingWireQueryServiceIncomingWireEventsSortableFields, IxcPaymentsV1IncomingWireQueryServiceIncomingWireEventsFilterableFields>;
}

export enum IxcPaymentsV1IncomingWireQueryServiceIncomingWireEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    WireId = 'wireId',
    EventSettledSpecAccountNumberId = 'event.settled.spec.accountNumberId',
    EventSettledSpecAccountId = 'event.settled.spec.accountId',
    EventSettledSpecProgramId = 'event.settled.spec.programId',
    EventSettledSpecTransferId = 'event.settled.spec.transferId',
    EventType = 'event.!type'
}

export enum IxcPaymentsV1IncomingWireQueryServiceIncomingWireEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcPaymentsV1IncomingWireQueryServiceIncomingWireGetIncomingWireGetRequest {
    // format: id62
    wireId: string;
}

export interface IxcPaymentsV1IncomingWireQueryServiceIncomingWireListIncomingWireListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcPaymentsV1IncomingWireQueryServiceIncomingWireListSortableFields, IxcPaymentsV1IncomingWireQueryServiceIncomingWireListFilterableFields>;
}

export enum IxcPaymentsV1IncomingWireQueryServiceIncomingWireListFilterableFields {
    WireId = 'wireId',
    DataSpecAccountNumberId = 'data.spec.accountNumberId',
    DataSpecAccountId = 'data.spec.accountId',
    DataSpecProgramId = 'data.spec.programId',
    DataSpecTransferId = 'data.spec.transferId',
    Status = 'status'
}

export enum IxcPaymentsV1IncomingWireQueryServiceIncomingWireListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcPaymentsV1IncomingWireSpec {
    // format: decimal
    amount?: string;
    // format: id62, entity: ixc.funding.v1.AccountNumber
    accountNumberId: string;
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
    // format: id62, entity: ixc.funding.v1.Transfer
    transferId?: string;
}

export interface IxcPaymentsV1IncomingWireState extends IxcPaymentsV1IncomingWireKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcPaymentsV1IncomingWireData;
    status: IxcPaymentsV1IncomingWireStatus;
}

export enum IxcPaymentsV1IncomingWireStatus {
    Unspecified = 'UNSPECIFIED',
    Settled = 'SETTLED',
    Reversed = 'REVERSED'
}

export interface IxcPaymentsV1WireData {
    spec: IxcPaymentsV1WireSpec;
}

export interface IxcPaymentsV1WireEvent extends IxcPaymentsV1WireKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcPaymentsV1WireEventType;
}

export type IxcPaymentsV1WireEventType = {
    '!type'?: 'created';
    created: IxcPaymentsV1WireEventTypeCreated;
} | {
    '!type'?: 'rejected';
    rejected: EmptyObject;
} | {
    '!type'?: 'reversed';
    reversed: EmptyObject;
} | {
    '!type'?: 'settled';
    settled: EmptyObject;
};

export interface IxcPaymentsV1WireEventTypeCreated {
    spec: IxcPaymentsV1WireSpec;
}

export const IXC_PAYMENTS_V1_WIRE_EVENT_TYPE_ONE_OF_VALUES = ['created', 'rejected', 'reversed', 'settled'] as const;

export type IxcPaymentsV1WireEventTypeOneOfValue = (typeof IXC_PAYMENTS_V1_WIRE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcPaymentsV1WireKeys {
    // format: id62
    wireId: string;
}

export interface IxcPaymentsV1WireQueryServiceWireEventsWireEventsRequest {
    // format: id62
    wireId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcPaymentsV1WireQueryServiceWireEventsSearchableFields, IxcPaymentsV1WireQueryServiceWireEventsSortableFields, IxcPaymentsV1WireQueryServiceWireEventsFilterableFields>;
}

export enum IxcPaymentsV1WireQueryServiceWireEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    WireId = 'wireId',
    EventCreatedSpecAccountId = 'event.created.spec.accountId',
    EventCreatedSpecProgramId = 'event.created.spec.programId',
    EventCreatedSpecSourceId = 'event.created.spec.sourceId',
    EventCreatedSpecTransferId = 'event.created.spec.transferId',
    EventType = 'event.!type'
}

export enum IxcPaymentsV1WireQueryServiceWireEventsSearchableFields {
    EventCreatedSpecDomesticWireSourceBankDetailsAccountNumber = 'event.created.spec.domesticWireSource.bankDetails.accountNumber'
}

export enum IxcPaymentsV1WireQueryServiceWireEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcPaymentsV1WireQueryServiceWireGetWireGetRequest {
    // format: id62
    wireId: string;
}

export interface IxcPaymentsV1WireQueryServiceWireListWireListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcPaymentsV1WireQueryServiceWireListSearchableFields, IxcPaymentsV1WireQueryServiceWireListSortableFields, IxcPaymentsV1WireQueryServiceWireListFilterableFields>;
}

export enum IxcPaymentsV1WireQueryServiceWireListFilterableFields {
    WireId = 'wireId',
    DataSpecAccountId = 'data.spec.accountId',
    DataSpecProgramId = 'data.spec.programId',
    DataSpecSourceId = 'data.spec.sourceId',
    DataSpecTransferId = 'data.spec.transferId',
    Status = 'status'
}

export enum IxcPaymentsV1WireQueryServiceWireListSearchableFields {
    DataSpecDomesticWireSourceBankDetailsAccountNumber = 'data.spec.domesticWireSource.bankDetails.accountNumber'
}

export enum IxcPaymentsV1WireQueryServiceWireListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcPaymentsV1WireSpec {
    // format: decimal
    amount?: string;
    wirePush?: IxcFundingV1WirePush;
    domesticWireSource?: IxcFundingV1DomesticWireSource;
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
    // format: id62, entity: ixc.funding.v1.Source
    sourceId?: string;
    // format: id62, entity: ixc.funding.v1.Transfer
    transferId?: string;
}

export interface IxcPaymentsV1WireState extends IxcPaymentsV1WireKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcPaymentsV1WireData;
    status: IxcPaymentsV1WireStatus;
}

export enum IxcPaymentsV1WireStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
    Settled = 'SETTLED',
    Reversed = 'REVERSED'
}

export interface IxcPortfolioV1AccountConfig {
    marginType: IxcPortfolioV1MarginType;
    /* When true, holds are not rejected for insufficient balance, allowing the
    account to go negative. */
    skipCreditCheck?: boolean;
}

export interface IxcPortfolioV1AccountDelta {
    /* The number of units of the asset being affected Positive numbers increase
    / credit the balacne of the brokerage account */
    // format: decimal
    amount?: string;
    /* If true, this delta reverses a delta in a previous transaction which is
    now in status REVERSED
    Clients may choose to show or hide reversals, but must be consistent in
    doing so. Clients must either hide Transactions in 'REVERED' status, and
    hide Deltas with `is_reverse = true` always or show both. */
    isReverse?: boolean;
    /* The cost basis of the asset being affected, in terms of the home
    currency, when the asset is not itself the home currency. */
    tax?: IxcPortfolioV1DeltaTax;
}

export interface IxcPortfolioV1AssetBalanceData {
    asset: IxcAssetsV1AssetState;
    account: IxcPortfolioV1AccountConfig;
    controls: IxcPortfolioV1BooksControls;
    /* The sum of all settled transactions. */
    // format: decimal
    settledBalance: string;
    /* The balance availble for orders, calculated differently for Securities
    and Cash, and based on the HoldRules for the account. */
    // format: decimal
    availableToTrade: string;
    /* The sum of Settled + PendingIncrease - PendingDecrease */
    // format: decimal
    pendingBalance: string;
    /* The sum of all open Holds on the asset, see the `Hold` entity for details */
    // format: decimal
    heldBalance: string;
    /* The sum of all posted but not-settled	transactions which increase the
    balance. */
    // format: decimal
    pendingIncrease: string;
    /* The sum of all posted but not-settled	transactions which decrease the
    balance. */
    // format: decimal
    pendingDecrease: string;
}

export interface IxcPortfolioV1AssetBalanceEvent extends IxcPortfolioV1AssetBalanceKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcPortfolioV1AssetBalanceEventType;
}

export type IxcPortfolioV1AssetBalanceEventType = {
    '!type'?: 'config';
    config: IxcPortfolioV1AssetBalanceEventTypeConfig;
} | {
    '!type'?: 'transactionSlated';
    transactionSlated: IxcPortfolioV1AssetBalanceEventTypeTransactionSlated;
} | {
    '!type'?: 'transactionSettled';
    transactionSettled: IxcPortfolioV1AssetBalanceEventTypeTransactionSettled;
} | {
    '!type'?: 'transactionPosted';
    transactionPosted: IxcPortfolioV1AssetBalanceEventTypeTransactionPosted;
} | {
    '!type'?: 'holdRequested';
    holdRequested: IxcPortfolioV1AssetBalanceEventTypeHoldRequested;
} | {
    '!type'?: 'holdRejected';
    holdRejected: IxcPortfolioV1AssetBalanceEventTypeHoldRejected;
} | {
    '!type'?: 'holdCreated';
    holdCreated: IxcPortfolioV1AssetBalanceEventTypeHoldCreated;
} | {
    '!type'?: 'holdModified';
    holdModified: IxcPortfolioV1AssetBalanceEventTypeHoldModified;
} | {
    '!type'?: 'balanceSnapshot';
    balanceSnapshot: IxcPortfolioV1AssetBalanceEventTypeBalanceSnapshot;
} | {
    '!type'?: 'sweptBalanceUpdated';
    sweptBalanceUpdated: IxcPortfolioV1AssetBalanceEventTypeSweptBalanceUpdated;
};

export interface IxcPortfolioV1AssetBalanceEventTypeBalanceSnapshot {
    // format: id62
    snapshotId: string;
    // format: YYYY-MM-DD
    cutoff: string;
}

export interface IxcPortfolioV1AssetBalanceEventTypeConfig {
    account?: IxcPortfolioV1AccountConfig;
    asset?: IxcAssetsV1AssetState;
    controls?: IxcPortfolioV1BooksControls;
}

export interface IxcPortfolioV1AssetBalanceEventTypeHoldCreated {
    // format: id62
    holdId?: string;
    // format: decimal
    amount?: string;
    /* The rule applied: `amount` is the whole available position rather
    than the quantity requested. */
    fullPosition?: boolean;
}

export interface IxcPortfolioV1AssetBalanceEventTypeHoldModified {
    previous: IxcPortfolioV1HoldValues;
    updated: IxcPortfolioV1HoldValues;
}

export interface IxcPortfolioV1AssetBalanceEventTypeHoldRejected {
    // format: id62
    holdId?: string;
}

export interface IxcPortfolioV1AssetBalanceEventTypeHoldRequested {
    // format: id62
    holdId: string;
    // format: decimal
    amount: string;
    fullPositionRule?: IxcPortfolioV1FullPositionRule;
    holdType: IxcPortfolioV1HoldType;
}

export interface IxcPortfolioV1AssetBalanceEventTypeSweptBalanceUpdated {
    /* The total swept balance after this update. */
    // format: decimal
    sweptBalance?: string;
    /* The swept component being updated */
    component?: IxcPortfolioV1AssetBalanceEventTypeSweptBalanceUpdatedComponent;
}

export interface IxcPortfolioV1AssetBalanceEventTypeSweptBalanceUpdatedComponent {
    /* The money market asset where cash is swept */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The change in swept amount (positive = increase, negative =
    decrease) */
    // format: decimal
    amount: string;
}

export interface IxcPortfolioV1AssetBalanceEventTypeTransactionPosted {
    // format: id62
    transactionId: string;
    // format: decimal
    amount: string;
    // format: date-time
    settleTimestamp: string;
    // format: YYYY-MM-DD
    date: string;
}

export interface IxcPortfolioV1AssetBalanceEventTypeTransactionSettled {
    // format: id62
    transactionId: string;
    // format: decimal
    amount: string;
    // format: date-time
    effectiveTimestamp: string;
    // format: date-time
    settleTimestamp: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settleDate: string;
}

export interface IxcPortfolioV1AssetBalanceEventTypeTransactionSlated {
    // format: id62
    transactionId: string;
    // format: decimal
    amount: string;
    // format: date-time
    effectiveTimestamp: string;
    // format: date-time
    settleTimestamp: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settleDate: string;
}

export const IXC_PORTFOLIO_V1_ASSET_BALANCE_EVENT_TYPE_ONE_OF_VALUES = ['config', 'transactionSlated', 'transactionSettled', 'transactionPosted', 'holdRequested', 'holdRejected', 'holdCreated', 'holdModified', 'balanceSnapshot', 'sweptBalanceUpdated'] as const;

export type IxcPortfolioV1AssetBalanceEventTypeOneOfValue = (typeof IXC_PORTFOLIO_V1_ASSET_BALANCE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcPortfolioV1AssetBalanceKeys {
    // format: id62
    accountId: string;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
}

export interface IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceEventsAssetBalanceEventsRequest {
    // format: id62
    accountId: string;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceEventsSearchableFields, IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceEventsSortableFields, IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceEventsFilterableFields>;
}

export enum IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AccountId = 'accountId',
    AssetId = 'assetId',
    ProgramId = 'programId',
    EventConfigAssetAssetId = 'event.config.asset.assetId',
    EventConfigAssetDataTypeEquityCusip = 'event.config.asset.data.type.equity.cusip',
    EventConfigAssetDataTypeEquityControlsCanBuy = 'event.config.asset.data.type.equity.controls.canBuy',
    EventConfigAssetDataTypeEquityControlsCanSell = 'event.config.asset.data.type.equity.controls.canSell',
    EventConfigAssetDataTypeEquityControlsCanEnterFractions = 'event.config.asset.data.type.equity.controls.canEnterFractions',
    EventConfigAssetDataTypeMoneyMarketCusip = 'event.config.asset.data.type.moneyMarket.cusip',
    EventConfigAssetDataTypeMoneyMarketControlsCanBuy = 'event.config.asset.data.type.moneyMarket.controls.canBuy',
    EventConfigAssetDataTypeMoneyMarketControlsCanSell = 'event.config.asset.data.type.moneyMarket.controls.canSell',
    EventConfigAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.config.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventConfigAssetDataTypeMoneyMarketClassification = 'event.config.asset.data.type.moneyMarket.classification',
    EventConfigAssetDataTypeMoneyMarketNavType = 'event.config.asset.data.type.moneyMarket.navType',
    EventConfigAssetDataTypeType = 'event.config.asset.data.type.!type',
    EventConfigAssetDataCategory = 'event.config.asset.data.category',
    EventConfigAssetStatus = 'event.config.asset.status',
    EventType = 'event.!type'
}

export enum IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceEventsSearchableFields {
    EventConfigAssetDataTypeEquitySymbolBase = 'event.config.asset.data.type.equity.symbol.base',
    EventConfigAssetDataTypeEquityName = 'event.config.asset.data.type.equity.name',
    EventConfigAssetDataTypeMoneyMarketSymbolBase = 'event.config.asset.data.type.moneyMarket.symbol.base',
    EventConfigAssetDataTypeMoneyMarketName = 'event.config.asset.data.type.moneyMarket.name'
}

export enum IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventConfigAssetMetadataCreatedAt = 'event.config.asset.metadata.createdAt',
    EventConfigAssetMetadataUpdatedAt = 'event.config.asset.metadata.updatedAt'
}

export interface IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceGetAssetBalanceGetRequest {
    // format: id62
    accountId: string;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
}

export interface IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceListAssetBalanceListRequest {
    // format: id62
    accountId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceListSearchableFields, IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceListSortableFields, IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceListFilterableFields>;
}

export enum IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceListFilterableFields {
    AccountId = 'accountId',
    AssetId = 'assetId',
    ProgramId = 'programId',
    DataAssetAssetId = 'data.asset.assetId',
    DataAssetDataTypeEquityCusip = 'data.asset.data.type.equity.cusip',
    DataAssetDataTypeEquityControlsCanBuy = 'data.asset.data.type.equity.controls.canBuy',
    DataAssetDataTypeEquityControlsCanSell = 'data.asset.data.type.equity.controls.canSell',
    DataAssetDataTypeEquityControlsCanEnterFractions = 'data.asset.data.type.equity.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketCusip = 'data.asset.data.type.moneyMarket.cusip',
    DataAssetDataTypeMoneyMarketControlsCanBuy = 'data.asset.data.type.moneyMarket.controls.canBuy',
    DataAssetDataTypeMoneyMarketControlsCanSell = 'data.asset.data.type.moneyMarket.controls.canSell',
    DataAssetDataTypeMoneyMarketControlsCanEnterFractions = 'data.asset.data.type.moneyMarket.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketClassification = 'data.asset.data.type.moneyMarket.classification',
    DataAssetDataTypeMoneyMarketNavType = 'data.asset.data.type.moneyMarket.navType',
    DataAssetDataTypeType = 'data.asset.data.type.!type',
    DataAssetDataCategory = 'data.asset.data.category',
    DataAssetStatus = 'data.asset.status',
    Status = 'status'
}

export enum IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceListSearchableFields {
    DataAssetDataTypeEquitySymbolBase = 'data.asset.data.type.equity.symbol.base',
    DataAssetDataTypeEquityName = 'data.asset.data.type.equity.name',
    DataAssetDataTypeMoneyMarketSymbolBase = 'data.asset.data.type.moneyMarket.symbol.base',
    DataAssetDataTypeMoneyMarketName = 'data.asset.data.type.moneyMarket.name'
}

export enum IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataAssetMetadataCreatedAt = 'data.asset.metadata.createdAt',
    DataAssetMetadataUpdatedAt = 'data.asset.metadata.updatedAt'
}

export interface IxcPortfolioV1AssetBalanceState extends IxcPortfolioV1AssetBalanceKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcPortfolioV1AssetBalanceData;
    status: IxcPortfolioV1AssetBalanceStatus;
}

export enum IxcPortfolioV1AssetBalanceStatus {
    Unspecified = 'UNSPECIFIED',
    Open = 'OPEN'
}

export interface IxcPortfolioV1BalanceSet {
    /* The sum of all settled transactions. */
    // format: decimal
    settledBalance?: string;
    /* The sum of all posted but not-settled	transactions which increase the
    balance. */
    // format: decimal
    pendingIncrease: string;
    /* The sum of all posted but not-settled	transactions which decrease the
    balance. */
    // format: decimal
    pendingDecrease: string;
    /* The sum of Settled + PendingIncrease - PendingDecrease */
    // format: decimal
    pendingBalance: string;
}

export interface IxcPortfolioV1BalanceSnapshot {
    // format: decimal
    settled: string;
    // format: decimal
    pendingDecrease: string;
    // format: decimal
    held: string;
}

export interface IxcPortfolioV1BalanceSnapshotData {
    /* The trade date for transactions to be included in the snapshot balance
    (cumDate) */
    // format: YYYY-MM-DD
    cutoff: string;
    /* The balance as of the current version */
    balance?: IxcPortfolioV1SnapshotBalance;
    /* The version of the balance, starting at 0, incremented with each
    adjustment. */
    // format: INT32
    balanceVersion?: number;
    requestMetadata: J5MessagingV1RequestMetadata;
}

export interface IxcPortfolioV1BalanceSnapshotEvent extends IxcPortfolioV1BalanceSnapshotKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcPortfolioV1BalanceSnapshotEventType;
}

export type IxcPortfolioV1BalanceSnapshotEventType = {
    '!type'?: 'created';
    created: IxcPortfolioV1BalanceSnapshotEventTypeCreated;
} | {
    '!type'?: 'assetBalance';
    assetBalance: IxcPortfolioV1BalanceSnapshotEventTypeAssetBalance;
} | {
    '!type'?: 'lateTransaction';
    lateTransaction: IxcPortfolioV1BalanceSnapshotEventTypeLateTransaction;
} | {
    '!type'?: 'adjustment';
    adjustment: IxcPortfolioV1BalanceSnapshotEventTypeAdjustment;
};

export interface IxcPortfolioV1BalanceSnapshotEventTypeAdjustment {
    /* The balance before the adjustment */
    balanceBefore: IxcPortfolioV1SnapshotBalance;
    /* The balance after the adjustment */
    balanceAfter: IxcPortfolioV1SnapshotBalance;
}

export interface IxcPortfolioV1BalanceSnapshotEventTypeAssetBalance {
    balance: IxcPortfolioV1SnapshotBalance;
}

export interface IxcPortfolioV1BalanceSnapshotEventTypeCreated {
    requestMetadata: J5MessagingV1RequestMetadata;
    // format: YYYY-MM-DD
    cutoff: string;
}

export interface IxcPortfolioV1BalanceSnapshotEventTypeLateTransaction {
    /* The transaction which caused the adjustment */
    // format: id62, entity: ixc.portfolio.v1.Transaction
    transactionId: string;
    /* The trade date of the late transaction */
    // format: YYYY-MM-DD
    tradeDate: string;
    /* The settlement date of the late transaction, may be effectiveAt or
    autoSettleAt when slated, which is required for security balances */
    // format: YYYY-MM-DD
    settleDate: string;
    /* The change in balance, positive or negative. */
    // format: decimal
    delta: string;
}

export const IXC_PORTFOLIO_V1_BALANCE_SNAPSHOT_EVENT_TYPE_ONE_OF_VALUES = ['created', 'assetBalance', 'lateTransaction', 'adjustment'] as const;

export type IxcPortfolioV1BalanceSnapshotEventTypeOneOfValue = (typeof IXC_PORTFOLIO_V1_BALANCE_SNAPSHOT_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcPortfolioV1BalanceSnapshotKeys {
    // format: id62
    accountId: string;
    // format: id62
    snapshotId: string;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    // format: id62
    programId?: string;
    /* If provided, the snapshot is part of a group, allowing for fanout
    processing. This is used internally and not typically exposed to users. */
    // format: id62
    groupId?: string;
}

export interface IxcPortfolioV1BalanceSnapshotQueryServiceBalanceSnapshotEventsBalanceSnapshotEventsRequest {
    // format: id62
    accountId: string;
    // format: id62
    snapshotId: string;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcPortfolioV1BalanceSnapshotQueryServiceBalanceSnapshotEventsSortableFields, IxcPortfolioV1BalanceSnapshotQueryServiceBalanceSnapshotEventsFilterableFields>;
}

export enum IxcPortfolioV1BalanceSnapshotQueryServiceBalanceSnapshotEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AccountId = 'accountId',
    SnapshotId = 'snapshotId',
    AssetId = 'assetId',
    ProgramId = 'programId',
    GroupId = 'groupId',
    EventType = 'event.!type'
}

export enum IxcPortfolioV1BalanceSnapshotQueryServiceBalanceSnapshotEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcPortfolioV1BalanceSnapshotQueryServiceBalanceSnapshotGetBalanceSnapshotGetRequest {
    // format: id62
    accountId: string;
    // format: id62
    snapshotId: string;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
}

export interface IxcPortfolioV1BalanceSnapshotQueryServiceBalanceSnapshotListBalanceSnapshotListRequest {
    // format: id62
    accountId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcPortfolioV1BalanceSnapshotQueryServiceBalanceSnapshotListSortableFields, IxcPortfolioV1BalanceSnapshotQueryServiceBalanceSnapshotListFilterableFields>;
}

export enum IxcPortfolioV1BalanceSnapshotQueryServiceBalanceSnapshotListFilterableFields {
    AccountId = 'accountId',
    SnapshotId = 'snapshotId',
    AssetId = 'assetId',
    ProgramId = 'programId',
    GroupId = 'groupId',
    Status = 'status'
}

export enum IxcPortfolioV1BalanceSnapshotQueryServiceBalanceSnapshotListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcPortfolioV1BalanceSnapshotState extends IxcPortfolioV1BalanceSnapshotKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcPortfolioV1BalanceSnapshotData;
    status: IxcPortfolioV1BalanceSnapshotStatus;
}

export enum IxcPortfolioV1BalanceSnapshotStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Active = 'ACTIVE'
}

export interface IxcPortfolioV1BooksControls {
    settings?: IxcPortfolioV1BooksControlsSettings;
}

export interface IxcPortfolioV1BooksControlsSettings {
    canCreditCustomers?: boolean;
    canDebitCustomers?: boolean;
    /* Whether the program's accounts can trade with unsettled cash (e.g.,
    the proceeds from the execution of a sell trade immediately after the
    trade is executed, but before the proceeds have settled). When true,
    the program's accounts can trade with unsettled cash. When false, the
    program's accounts cannot trade with unsettled cash, and must wait
    for funds to settle before using them to place another order. */
    canTradeUnsettledCash?: boolean;
    /* Whether correspondents can transfer money into this account from one
    of their other platform accounts. */
    canCreditPlatformAccount?: boolean;
    /* Whether correspondents can transfer money out of this account to one
    of their other platform accounts. */
    canDebitPlatformAccounts?: boolean;
}

export interface IxcPortfolioV1CashBalanceData {
    account: IxcPortfolioV1AccountConfig;
    controls: IxcPortfolioV1BooksControls;
    /* The breakdown of cash-equivalent assets */
    components?: IxcPortfolioV1CashBalanceDataComponents[];
    /* The non-swept cash held as standard cash. */
    cashBalance: IxcPortfolioV1BalanceSet;
    /* The balance availble for orders, including all components and
    adjustments, calculated based on the HoldRules for the account. */
    // format: decimal
    availableToTrade: string;
    /* The balance available for withdrawal or other immediate use, calculated
    based on the HoldRules for the account. */
    // format: decimal
    availableToWithdraw: string;
    /* The sum of all open Holds on cash-or-equivalent, see the `Hold` entity
    for details */
    // format: decimal
    heldBalance: string;
    /* The aggregate outstanding Instant Deposit advance balance. Increases on
    AdvanceGranted, decreases on AdvanceSettled or AdvanceReversed. */
    // format: decimal
    advanceBalance: string;
    /* The amount in cash-swept accounts. This amount is not included in
    settledBalance.
    Calculated as SUM(components.settledBalance) */
    // format: decimal
    sweptBalance: string;
    /* The portion of heldBalance from holds of type TRADE. The remainder,
    heldBalance - tradeHeldBalance, is held against transfers.
    An advance funds trading only, so a consumer deciding whether cash must
    be freed can offset the advance against trade-driven demand but must
    leave transfer holds covered by real cash. */
    // format: decimal
    tradeHeldBalance: string;
}

export interface IxcPortfolioV1CashBalanceDataComponents {
    asset: IxcPortfolioV1CashEquivalentAssetSummary;
    /* The sum of all settled transactions. */
    // format: decimal
    settledBalance?: string;
    /* The sum of all posted but not-settled	transactions which increase the
    balance. */
    // format: decimal
    pendingIncrease: string;
    /* The sum of all posted but not-settled	transactions which decrease the
    balance. */
    // format: decimal
    pendingDecrease: string;
    /* The sum of Settled + PendingIncrease - PendingDecrease */
    // format: decimal
    pendingBalance: string;
}

export interface IxcPortfolioV1CashBalanceEvent extends IxcPortfolioV1CashBalanceKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcPortfolioV1CashBalanceEventType;
}

export type IxcPortfolioV1CashBalanceEventType = {
    '!type'?: 'config';
    config: IxcPortfolioV1CashBalanceEventTypeConfig;
} | {
    '!type'?: 'transactionSlated';
    transactionSlated: IxcPortfolioV1CashBalanceEventTypeTransactionSlated;
} | {
    '!type'?: 'transactionSettled';
    transactionSettled: IxcPortfolioV1CashBalanceEventTypeTransactionSettled;
} | {
    '!type'?: 'transactionPosted';
    transactionPosted: IxcPortfolioV1CashBalanceEventTypeTransactionPosted;
} | {
    '!type'?: 'holdRequested';
    holdRequested: IxcPortfolioV1CashBalanceEventTypeHoldRequested;
} | {
    '!type'?: 'holdRejected';
    holdRejected: IxcPortfolioV1CashBalanceEventTypeHoldRejected;
} | {
    '!type'?: 'holdCreated';
    holdCreated: IxcPortfolioV1CashBalanceEventTypeHoldCreated;
} | {
    '!type'?: 'holdModified';
    holdModified: IxcPortfolioV1CashBalanceEventTypeHoldModified;
} | {
    '!type'?: 'advanceGranted';
    advanceGranted: IxcPortfolioV1CashBalanceEventTypeAdvanceGranted;
} | {
    '!type'?: 'advanceSettled';
    advanceSettled: IxcPortfolioV1CashBalanceEventTypeAdvanceSettled;
} | {
    '!type'?: 'advanceReversed';
    advanceReversed: IxcPortfolioV1CashBalanceEventTypeAdvanceReversed;
};

export interface IxcPortfolioV1CashBalanceEventTypeAdvanceGranted {
    // format: id62
    fundingId: string;
    // format: decimal
    amount: string;
}

export interface IxcPortfolioV1CashBalanceEventTypeAdvanceReversed {
    // format: id62
    fundingId: string;
    // format: decimal
    amount: string;
}

export interface IxcPortfolioV1CashBalanceEventTypeAdvanceSettled {
    // format: id62
    fundingId: string;
    // format: decimal
    amount: string;
}

export interface IxcPortfolioV1CashBalanceEventTypeConfig {
    account?: IxcPortfolioV1AccountConfig;
    asset?: IxcAssetsV1AssetState;
    controls?: IxcPortfolioV1BooksControls;
}

export interface IxcPortfolioV1CashBalanceEventTypeHoldCreated {
    // format: id62
    holdId?: string;
    // format: decimal
    amount?: string;
    /* Absent on events written before the field existed; unset is not
    counted toward tradeHeldBalance. */
    holdType?: IxcPortfolioV1HoldType;
}

export interface IxcPortfolioV1CashBalanceEventTypeHoldModified {
    previous: IxcPortfolioV1HoldValues;
    updated: IxcPortfolioV1HoldValues;
    /* Absent on events written before the field existed; unset is not
    counted toward tradeHeldBalance. */
    holdType?: IxcPortfolioV1HoldType;
}

export interface IxcPortfolioV1CashBalanceEventTypeHoldRejected {
    // format: id62
    holdId?: string;
}

export interface IxcPortfolioV1CashBalanceEventTypeHoldRequested {
    // format: id62
    holdId: string;
    // format: decimal
    amount: string;
    holdType: IxcPortfolioV1HoldType;
}

export interface IxcPortfolioV1CashBalanceEventTypeTransactionPosted {
    asset?: IxcPortfolioV1CashEquivalentAssetSummary;
    // format: id62
    transactionId: string;
    // format: decimal
    amount: string;
    // format: date-time
    settleTimestamp: string;
}

export interface IxcPortfolioV1CashBalanceEventTypeTransactionSettled {
    asset?: IxcPortfolioV1CashEquivalentAssetSummary;
    // format: id62
    transactionId: string;
    // format: decimal
    amount: string;
    // format: date-time
    settleTimestamp: string;
}

export interface IxcPortfolioV1CashBalanceEventTypeTransactionSlated {
    asset?: IxcPortfolioV1CashEquivalentAssetSummary;
    // format: id62
    transactionId: string;
    // format: decimal
    amount: string;
}

export const IXC_PORTFOLIO_V1_CASH_BALANCE_EVENT_TYPE_ONE_OF_VALUES = ['config', 'transactionSlated', 'transactionSettled', 'transactionPosted', 'holdRequested', 'holdRejected', 'holdCreated', 'holdModified', 'advanceGranted', 'advanceSettled', 'advanceReversed'] as const;

export type IxcPortfolioV1CashBalanceEventTypeOneOfValue = (typeof IXC_PORTFOLIO_V1_CASH_BALANCE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcPortfolioV1CashBalanceKeys {
    // format: id62
    accountId: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
}

export interface IxcPortfolioV1CashBalanceQueryServiceCashBalanceEventsCashBalanceEventsRequest {
    // format: id62
    accountId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcPortfolioV1CashBalanceQueryServiceCashBalanceEventsSearchableFields, IxcPortfolioV1CashBalanceQueryServiceCashBalanceEventsSortableFields, IxcPortfolioV1CashBalanceQueryServiceCashBalanceEventsFilterableFields>;
}

export enum IxcPortfolioV1CashBalanceQueryServiceCashBalanceEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AccountId = 'accountId',
    ProgramId = 'programId',
    EventConfigAssetAssetId = 'event.config.asset.assetId',
    EventConfigAssetDataTypeEquityCusip = 'event.config.asset.data.type.equity.cusip',
    EventConfigAssetDataTypeEquityControlsCanBuy = 'event.config.asset.data.type.equity.controls.canBuy',
    EventConfigAssetDataTypeEquityControlsCanSell = 'event.config.asset.data.type.equity.controls.canSell',
    EventConfigAssetDataTypeEquityControlsCanEnterFractions = 'event.config.asset.data.type.equity.controls.canEnterFractions',
    EventConfigAssetDataTypeMoneyMarketCusip = 'event.config.asset.data.type.moneyMarket.cusip',
    EventConfigAssetDataTypeMoneyMarketControlsCanBuy = 'event.config.asset.data.type.moneyMarket.controls.canBuy',
    EventConfigAssetDataTypeMoneyMarketControlsCanSell = 'event.config.asset.data.type.moneyMarket.controls.canSell',
    EventConfigAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.config.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventConfigAssetDataTypeMoneyMarketClassification = 'event.config.asset.data.type.moneyMarket.classification',
    EventConfigAssetDataTypeMoneyMarketNavType = 'event.config.asset.data.type.moneyMarket.navType',
    EventConfigAssetDataTypeType = 'event.config.asset.data.type.!type',
    EventConfigAssetDataCategory = 'event.config.asset.data.category',
    EventConfigAssetStatus = 'event.config.asset.status',
    EventType = 'event.!type'
}

export enum IxcPortfolioV1CashBalanceQueryServiceCashBalanceEventsSearchableFields {
    EventConfigAssetDataTypeEquitySymbolBase = 'event.config.asset.data.type.equity.symbol.base',
    EventConfigAssetDataTypeEquityName = 'event.config.asset.data.type.equity.name',
    EventConfigAssetDataTypeMoneyMarketSymbolBase = 'event.config.asset.data.type.moneyMarket.symbol.base',
    EventConfigAssetDataTypeMoneyMarketName = 'event.config.asset.data.type.moneyMarket.name'
}

export enum IxcPortfolioV1CashBalanceQueryServiceCashBalanceEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventConfigAssetMetadataCreatedAt = 'event.config.asset.metadata.createdAt',
    EventConfigAssetMetadataUpdatedAt = 'event.config.asset.metadata.updatedAt'
}

export interface IxcPortfolioV1CashBalanceQueryServiceCashBalanceGetCashBalanceGetRequest {
    // format: id62
    accountId: string;
}

export interface IxcPortfolioV1CashBalanceQueryServiceCashBalanceListCashBalanceListRequest {
    // format: id62
    accountId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcPortfolioV1CashBalanceQueryServiceCashBalanceListSortableFields, IxcPortfolioV1CashBalanceQueryServiceCashBalanceListFilterableFields>;
}

export enum IxcPortfolioV1CashBalanceQueryServiceCashBalanceListFilterableFields {
    AccountId = 'accountId',
    ProgramId = 'programId',
    Status = 'status'
}

export enum IxcPortfolioV1CashBalanceQueryServiceCashBalanceListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcPortfolioV1CashBalanceState extends IxcPortfolioV1CashBalanceKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcPortfolioV1CashBalanceData;
    status: IxcPortfolioV1CashBalanceStatus;
}

export enum IxcPortfolioV1CashBalanceStatus {
    Unspecified = 'UNSPECIFIED',
    Open = 'OPEN'
}

export interface IxcPortfolioV1CashEquivalentAssetSummary {
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
}

export type IxcPortfolioV1DeltaTax = {
    '!type'?: 'open';
    /* The cost basis of an asset in the home currency */
    open: IxcPortfolioV1DeltaTaxOpen;
} | {
    '!type'?: 'close';
    close: IxcPortfolioV1DeltaTaxClose;
};

export interface IxcPortfolioV1DeltaTaxClose {
    specifiedTaxLot?: IxcPortfolioV1TaxLotAllocation[];
    /* The method used to select tax lots for this closing transaction. When
    not specified, defaults to FIFO. When CUSTOM is used, specifiedTaxLot
    should contain the explicit allocations. */
    taxLotMethod?: IxcPortfolioV1TaxLotMethod;
    /* The quantity of the asset which is changing */
    // format: decimal
    quantity: string;
    /* The cash income associated with the closing transaction */
    // format: decimal
    proceeds: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settleDate: string;
}

export interface IxcPortfolioV1DeltaTaxOpen {
    /* The quantity of the asset which is changing */
    // format: decimal
    quantity: string;
    /* The cost of the asset */
    // format: decimal
    cost: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settleDate: string;
}

export const IXC_PORTFOLIO_V1_DELTA_TAX_ONE_OF_VALUES = ['open', 'close'] as const;

export type IxcPortfolioV1DeltaTaxOneOfValue = (typeof IXC_PORTFOLIO_V1_DELTA_TAX_ONE_OF_VALUES)[number];

export interface IxcPortfolioV1DepositAdvanceData {
    /* The full amount of the incoming ACH Pull, in USD. */
    // format: decimal
    transferAmount: string;
    /* The amount advanced to the account, in USD. Always <= transferAmount and
    <= the account's effective maxAdvance at the time of grant. */
    // format: decimal
    advanceAmount: string;
}

export interface IxcPortfolioV1DepositAdvanceEvent extends IxcPortfolioV1DepositAdvanceKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcPortfolioV1DepositAdvanceEventType;
}

export type IxcPortfolioV1DepositAdvanceEventType = {
    '!type'?: 'granted';
    granted: IxcPortfolioV1DepositAdvanceEventTypeGranted;
} | {
    '!type'?: 'settled';
    settled: IxcPortfolioV1DepositAdvanceEventTypeSettled;
} | {
    '!type'?: 'reversed';
    reversed: IxcPortfolioV1DepositAdvanceEventTypeReversed;
};

export interface IxcPortfolioV1DepositAdvanceEventTypeGranted {
    // format: decimal
    transferAmount: string;
    // format: decimal
    advanceAmount: string;
}

export interface IxcPortfolioV1DepositAdvanceEventTypeReversed {
    // format: id62
    returnTransactionId: string;
}

export interface IxcPortfolioV1DepositAdvanceEventTypeSettled {
    // format: id62
    settleTransactionId: string;
}

export const IXC_PORTFOLIO_V1_DEPOSIT_ADVANCE_EVENT_TYPE_ONE_OF_VALUES = ['granted', 'settled', 'reversed'] as const;

export type IxcPortfolioV1DepositAdvanceEventTypeOneOfValue = (typeof IXC_PORTFOLIO_V1_DEPOSIT_ADVANCE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcPortfolioV1DepositAdvanceKeys {
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    /* The transfer this advance was granted against. */
    // format: id62, entity: ixc.funding.v1.Transfer
    fundingId: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
}

export interface IxcPortfolioV1DepositAdvanceQueryServiceDepositAdvanceEventsDepositAdvanceEventsRequest {
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    /* The transfer this advance was granted against. */
    // format: id62, entity: ixc.funding.v1.Transfer
    fundingId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcPortfolioV1DepositAdvanceQueryServiceDepositAdvanceEventsSortableFields, IxcPortfolioV1DepositAdvanceQueryServiceDepositAdvanceEventsFilterableFields>;
}

export enum IxcPortfolioV1DepositAdvanceQueryServiceDepositAdvanceEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AccountId = 'accountId',
    FundingId = 'fundingId',
    ProgramId = 'programId',
    EventType = 'event.!type'
}

export enum IxcPortfolioV1DepositAdvanceQueryServiceDepositAdvanceEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcPortfolioV1DepositAdvanceQueryServiceDepositAdvanceGetDepositAdvanceGetRequest {
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    /* The transfer this advance was granted against. */
    // format: id62, entity: ixc.funding.v1.Transfer
    fundingId: string;
}

export interface IxcPortfolioV1DepositAdvanceQueryServiceDepositAdvanceListDepositAdvanceListRequest {
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcPortfolioV1DepositAdvanceQueryServiceDepositAdvanceListSortableFields, IxcPortfolioV1DepositAdvanceQueryServiceDepositAdvanceListFilterableFields>;
}

export enum IxcPortfolioV1DepositAdvanceQueryServiceDepositAdvanceListFilterableFields {
    AccountId = 'accountId',
    FundingId = 'fundingId',
    ProgramId = 'programId',
    Status = 'status'
}

export enum IxcPortfolioV1DepositAdvanceQueryServiceDepositAdvanceListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcPortfolioV1DepositAdvanceState extends IxcPortfolioV1DepositAdvanceKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcPortfolioV1DepositAdvanceData;
    status: IxcPortfolioV1DepositAdvanceStatus;
}

export enum IxcPortfolioV1DepositAdvanceStatus {
    Unspecified = 'UNSPECIFIED',
    Granted = 'GRANTED',
    Settled = 'SETTLED',
    Reversed = 'REVERSED'
}

export enum IxcPortfolioV1DividendPaymentCategory {
    Unspecified = 'UNSPECIFIED',
    Misc = 'MISC'
}

export interface IxcPortfolioV1DividendPaymentTransaction {
    // format: id62
    dividendPaymentId: string;
    // format: decimal
    amount: string;
    /* Asset ID this dividend payment came from */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* Account ID this dividend payment is associated with */
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    // format: YYYY-MM-DD
    recordDate: string;
    // format: YYYY-MM-DD
    payDate: string;
    category: IxcPortfolioV1DividendPaymentCategory;
    description?: string;
}

export interface IxcPortfolioV1FullPositionRule {
    /* Reserve the whole position when the measured quantity comes within this
    fraction of it, above or below. Between zero and one. */
    // format: decimal
    threshold: string;
    /* The quantity compared against the position. Defaults to `quantity`. Set
    it when `quantity` carries a reservation buffer that should not move the
    threshold. */
    // format: decimal
    measureQuantity?: string;
}

export interface IxcPortfolioV1HoldData {
    asset: IxcAssetsV1AssetState;
    holdType: IxcPortfolioV1HoldType;
    /* When specified by itself, the quantity initially requested to be held.
    Quantity being dollars or shares or whatever the unit of the asset is. */
    // format: decimal
    fullQuantity: string;
    /* After any reductions, this is the quantity still remaining in the hold.
    E.g. in a partial fill order, the quantity is reduced when posting the
    fills but not entirely removed. */
    // format: decimal
    currentQuantity: string;
    /* Default is `1`. The effective hold is the currentQuantity multiplied by
    this. Main use case is the 'price' of a hold, while we could calculate a
    new hold amount in the requesting service (OMS), that opens some race
    conditions. This allows the quantity to be reduced atomically with each
    transaction. */
    // format: decimal
    multiplier: string;
    /* The amount currently held by this hold. currentQuantity * multiplier */
    // format: decimal
    effectiveHold: string;
    requestMetadata?: J5MessagingV1RequestMetadata;
}

export interface IxcPortfolioV1HoldEvent extends IxcPortfolioV1HoldKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcPortfolioV1HoldEventType;
}

export type IxcPortfolioV1HoldEventType = {
    '!type'?: 'requested';
    requested: IxcPortfolioV1HoldEventTypeRequested;
} | {
    '!type'?: 'held';
    held: IxcPortfolioV1HoldEventTypeHeld;
} | {
    '!type'?: 'rejected';
    rejected: IxcPortfolioV1HoldEventTypeRejected;
} | {
    '!type'?: 'canceled';
    canceled: EmptyObject;
} | {
    '!type'?: 'used';
    used: IxcPortfolioV1HoldEventTypeUsed;
} | {
    '!type'?: 'updated';
    updated: IxcPortfolioV1HoldEventTypeUpdated;
} | {
    '!type'?: 'released';
    released: IxcPortfolioV1HoldEventTypeReleased;
};

export interface IxcPortfolioV1HoldEventTypeHeld {
    /* Set when the rule took the whole position. The quantity actually
    held, replacing the quantity requested. */
    // format: decimal
    fullPositionQuantity?: string;
}

export interface IxcPortfolioV1HoldEventTypeRejected {
    balance: IxcPortfolioV1BalanceSnapshot;
}

export interface IxcPortfolioV1HoldEventTypeReleased {
    previous: IxcPortfolioV1HoldValues;
}

export interface IxcPortfolioV1HoldEventTypeRequested {
    /* Quantity to hold. See data.fullQuantity */
    // format: decimal
    quantity: string;
    /* Default is 1. See data.multiplier */
    // format: decimal
    multiplier?: string;
    /* The rule the requester asked to be applied, if any. */
    fullPositionRule?: IxcPortfolioV1FullPositionRule;
    request: J5MessagingV1RequestMetadata;
    asset: IxcAssetsV1AssetState;
    holdType: IxcPortfolioV1HoldType;
}

export interface IxcPortfolioV1HoldEventTypeUpdated {
    previous: IxcPortfolioV1HoldValues;
    updated: IxcPortfolioV1HoldValues;
}

export interface IxcPortfolioV1HoldEventTypeUsed {
    /* The quantity to reduce in the hold. */
    // format: decimal
    reduceQuantityBy: string;
    /* Conversions to a lower quantity may update the multiplier, e.g.
    update the quote price of an asset */
    // format: decimal
    updateMultiplier?: string;
    /* The transaction which used / reduced the hold. */
    // format: id62
    transactionId: string;
}

export const IXC_PORTFOLIO_V1_HOLD_EVENT_TYPE_ONE_OF_VALUES = ['requested', 'held', 'rejected', 'canceled', 'used', 'updated', 'released'] as const;

export type IxcPortfolioV1HoldEventTypeOneOfValue = (typeof IXC_PORTFOLIO_V1_HOLD_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcPortfolioV1HoldKeys {
    /* Identifies the brokerage account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    // format: id62
    holdId: string;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
    // format: id62
    programId?: string;
    // format: id62
    entityId: string;
    // format: informal
    entityType: string;
}

export type IxcPortfolioV1HoldOutcome = {
    '!type'?: 'success';
    success: IxcPortfolioV1HoldOutcomeSuccess;
} | {
    '!type'?: 'fullPosition';
    /* The request came within the rule's threshold of the whole position, so
    the whole position was reserved instead of the quantity asked for. */
    fullPosition: IxcPortfolioV1HoldOutcomeFullPosition;
} | {
    '!type'?: 'rejected';
    rejected: IxcPortfolioV1HoldOutcomeRejected;
};

export interface IxcPortfolioV1HoldOutcomeFullPosition {
    // format: id62
    holdId: string;
    /* The quantity actually held: the whole available position. */
    // format: decimal
    quantity: string;
}

export interface IxcPortfolioV1HoldOutcomeRejected {
    balance: IxcPortfolioV1BalanceSnapshot;
}

export interface IxcPortfolioV1HoldOutcomeSuccess {
    // format: id62
    holdId: string;
}

export const IXC_PORTFOLIO_V1_HOLD_OUTCOME_ONE_OF_VALUES = ['success', 'fullPosition', 'rejected'] as const;

export type IxcPortfolioV1HoldOutcomeOneOfValue = (typeof IXC_PORTFOLIO_V1_HOLD_OUTCOME_ONE_OF_VALUES)[number];

export interface IxcPortfolioV1HoldQueryServiceHoldEventsHoldEventsRequest {
    /* Identifies the brokerage account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    // format: id62
    holdId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcPortfolioV1HoldQueryServiceHoldEventsSearchableFields, IxcPortfolioV1HoldQueryServiceHoldEventsSortableFields, IxcPortfolioV1HoldQueryServiceHoldEventsFilterableFields>;
}

export enum IxcPortfolioV1HoldQueryServiceHoldEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AccountId = 'accountId',
    HoldId = 'holdId',
    AssetId = 'assetId',
    ProgramId = 'programId',
    EntityId = 'entityId',
    EntityType = 'entityType',
    EventRequestedAssetAssetId = 'event.requested.asset.assetId',
    EventRequestedAssetDataTypeEquityCusip = 'event.requested.asset.data.type.equity.cusip',
    EventRequestedAssetDataTypeEquityControlsCanBuy = 'event.requested.asset.data.type.equity.controls.canBuy',
    EventRequestedAssetDataTypeEquityControlsCanSell = 'event.requested.asset.data.type.equity.controls.canSell',
    EventRequestedAssetDataTypeEquityControlsCanEnterFractions = 'event.requested.asset.data.type.equity.controls.canEnterFractions',
    EventRequestedAssetDataTypeMoneyMarketCusip = 'event.requested.asset.data.type.moneyMarket.cusip',
    EventRequestedAssetDataTypeMoneyMarketControlsCanBuy = 'event.requested.asset.data.type.moneyMarket.controls.canBuy',
    EventRequestedAssetDataTypeMoneyMarketControlsCanSell = 'event.requested.asset.data.type.moneyMarket.controls.canSell',
    EventRequestedAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.requested.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventRequestedAssetDataTypeMoneyMarketClassification = 'event.requested.asset.data.type.moneyMarket.classification',
    EventRequestedAssetDataTypeMoneyMarketNavType = 'event.requested.asset.data.type.moneyMarket.navType',
    EventRequestedAssetDataTypeType = 'event.requested.asset.data.type.!type',
    EventRequestedAssetDataCategory = 'event.requested.asset.data.category',
    EventRequestedAssetStatus = 'event.requested.asset.status',
    EventType = 'event.!type'
}

export enum IxcPortfolioV1HoldQueryServiceHoldEventsSearchableFields {
    EventRequestedAssetDataTypeEquitySymbolBase = 'event.requested.asset.data.type.equity.symbol.base',
    EventRequestedAssetDataTypeEquityName = 'event.requested.asset.data.type.equity.name',
    EventRequestedAssetDataTypeMoneyMarketSymbolBase = 'event.requested.asset.data.type.moneyMarket.symbol.base',
    EventRequestedAssetDataTypeMoneyMarketName = 'event.requested.asset.data.type.moneyMarket.name'
}

export enum IxcPortfolioV1HoldQueryServiceHoldEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventRequestedAssetMetadataCreatedAt = 'event.requested.asset.metadata.createdAt',
    EventRequestedAssetMetadataUpdatedAt = 'event.requested.asset.metadata.updatedAt'
}

export interface IxcPortfolioV1HoldQueryServiceHoldGetHoldGetRequest {
    /* Identifies the brokerage account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    // format: id62
    holdId: string;
}

export interface IxcPortfolioV1HoldQueryServiceHoldListHoldListRequest {
    /* Identifies the brokerage account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcPortfolioV1HoldQueryServiceHoldListSearchableFields, IxcPortfolioV1HoldQueryServiceHoldListSortableFields, IxcPortfolioV1HoldQueryServiceHoldListFilterableFields>;
}

export enum IxcPortfolioV1HoldQueryServiceHoldListFilterableFields {
    AccountId = 'accountId',
    HoldId = 'holdId',
    AssetId = 'assetId',
    ProgramId = 'programId',
    EntityId = 'entityId',
    EntityType = 'entityType',
    DataAssetAssetId = 'data.asset.assetId',
    DataAssetDataTypeEquityCusip = 'data.asset.data.type.equity.cusip',
    DataAssetDataTypeEquityControlsCanBuy = 'data.asset.data.type.equity.controls.canBuy',
    DataAssetDataTypeEquityControlsCanSell = 'data.asset.data.type.equity.controls.canSell',
    DataAssetDataTypeEquityControlsCanEnterFractions = 'data.asset.data.type.equity.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketCusip = 'data.asset.data.type.moneyMarket.cusip',
    DataAssetDataTypeMoneyMarketControlsCanBuy = 'data.asset.data.type.moneyMarket.controls.canBuy',
    DataAssetDataTypeMoneyMarketControlsCanSell = 'data.asset.data.type.moneyMarket.controls.canSell',
    DataAssetDataTypeMoneyMarketControlsCanEnterFractions = 'data.asset.data.type.moneyMarket.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketClassification = 'data.asset.data.type.moneyMarket.classification',
    DataAssetDataTypeMoneyMarketNavType = 'data.asset.data.type.moneyMarket.navType',
    DataAssetDataTypeType = 'data.asset.data.type.!type',
    DataAssetDataCategory = 'data.asset.data.category',
    DataAssetStatus = 'data.asset.status',
    Status = 'status'
}

export enum IxcPortfolioV1HoldQueryServiceHoldListSearchableFields {
    DataAssetDataTypeEquitySymbolBase = 'data.asset.data.type.equity.symbol.base',
    DataAssetDataTypeEquityName = 'data.asset.data.type.equity.name',
    DataAssetDataTypeMoneyMarketSymbolBase = 'data.asset.data.type.moneyMarket.symbol.base',
    DataAssetDataTypeMoneyMarketName = 'data.asset.data.type.moneyMarket.name'
}

export enum IxcPortfolioV1HoldQueryServiceHoldListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataAssetMetadataCreatedAt = 'data.asset.metadata.createdAt',
    DataAssetMetadataUpdatedAt = 'data.asset.metadata.updatedAt'
}

export interface IxcPortfolioV1HoldReduction {
    // format: id62
    holdId: string;
    // format: decimal
    reduceQuantity: string;
    // format: decimal
    updateMultiplier?: string;
}

export interface IxcPortfolioV1HoldState extends IxcPortfolioV1HoldKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcPortfolioV1HoldData;
    status: IxcPortfolioV1HoldStatus;
}

export enum IxcPortfolioV1HoldStatus {
    Unspecified = 'UNSPECIFIED',
    Requested = 'REQUESTED',
    Held = 'HELD',
    Rejected = 'REJECTED',
    Released = 'RELEASED'
}

export enum IxcPortfolioV1HoldType {
    Unspecified = 'UNSPECIFIED',
    Trade = 'TRADE',
    Transfer = 'TRANSFER'
}

export interface IxcPortfolioV1HoldValues {
    // format: decimal
    quantity: string;
    // format: decimal
    multiplier: string;
    // format: decimal
    effective: string;
}

export interface IxcPortfolioV1InstantDepositControls {
    settings?: IxcPortfolioV1InstantDepositControlsSettings;
    limits?: IxcPortfolioV1InstantDepositControlsLimits;
}

export interface IxcPortfolioV1InstantDepositControlsLimits {
    /* The maximum, in USD, a program is allowed to set as the advance for a
    given account it the account's settings. */
    // format: decimal
    maxAdvancePerAccount?: string;
}

export interface IxcPortfolioV1InstantDepositControlsSettings {
    /* Whether Instant Deposit advances are enabled for the program.
    allowing the program to enable instant deposit for their customer
    brokerage accounts. The program is then able to set the advance limit
    on a per account basis. */
    canUseAdvance?: boolean;
}

export enum IxcPortfolioV1MarginType {
    Unspecified = 'UNSPECIFIED',
    Cash = 'CASH',
    Lpm = 'LPM'
}

export interface IxcPortfolioV1PerformanceServicePerformancePerformanceRequest {
    // format: id62
    accountId: string;
}

export interface IxcPortfolioV1ReverseLink {
    /* The unique identifier of the transaction which reverses this one */
    // format: id62
    transactionId?: string;
    /* The reason for the reversal */
    reason?: string;
}

export interface IxcPortfolioV1SnapshotBalance {
    /* The settled balance of the asset in the account */
    // format: decimal
    settledBalance: string;
    /* Any pending balance grouped by settlement timestamp */
    pending?: IxcPortfolioV1SnapshotPending[];
}

export interface IxcPortfolioV1SnapshotPending {
    // format: YYYY-MM-DD
    settleDate: string;
    // format: decimal
    pendingAmount: string;
}

export interface IxcPortfolioV1SweepBalanceData {
    asset: IxcAssetsV1AssetState;
    account: IxcPortfolioV1AccountConfig;
    controls: IxcPortfolioV1BooksControls;
    /* The sum of all settled transactions. */
    // format: decimal
    settledBalance: string;
    /* The sum of Settled + PendingIncrease - PendingDecrease */
    // format: decimal
    pendingBalance: string;
    /* The sum of all posted but not-settled	transactions which increase the
    balance. */
    // format: decimal
    pendingIncrease: string;
    /* The sum of all posted but not-settled	transactions which decrease the
    balance. */
    // format: decimal
    pendingDecrease: string;
}

export interface IxcPortfolioV1SweepBalanceEvent extends IxcPortfolioV1SweepBalanceKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcPortfolioV1SweepBalanceEventType;
}

export type IxcPortfolioV1SweepBalanceEventType = {
    '!type'?: 'config';
    config: IxcPortfolioV1SweepBalanceEventTypeConfig;
} | {
    '!type'?: 'transactionSlated';
    transactionSlated: IxcPortfolioV1SweepBalanceEventTypeTransactionSlated;
} | {
    '!type'?: 'transactionSettled';
    transactionSettled: IxcPortfolioV1SweepBalanceEventTypeTransactionSettled;
} | {
    '!type'?: 'transactionPosted';
    transactionPosted: IxcPortfolioV1SweepBalanceEventTypeTransactionPosted;
};

export interface IxcPortfolioV1SweepBalanceEventTypeConfig {
    account?: IxcPortfolioV1AccountConfig;
    asset?: IxcAssetsV1AssetState;
    controls?: IxcPortfolioV1BooksControls;
}

export interface IxcPortfolioV1SweepBalanceEventTypeTransactionPosted {
    asset: IxcPortfolioV1CashEquivalentAssetSummary;
    // format: id62
    transactionId: string;
    // format: decimal
    amount: string;
    // format: date-time
    settleTimestamp: string;
}

export interface IxcPortfolioV1SweepBalanceEventTypeTransactionSettled {
    asset: IxcPortfolioV1CashEquivalentAssetSummary;
    // format: id62
    transactionId: string;
    // format: decimal
    amount: string;
    // format: date-time
    settleTimestamp: string;
}

export interface IxcPortfolioV1SweepBalanceEventTypeTransactionSlated {
    asset: IxcPortfolioV1CashEquivalentAssetSummary;
    // format: id62
    transactionId: string;
    // format: decimal
    amount: string;
}

export const IXC_PORTFOLIO_V1_SWEEP_BALANCE_EVENT_TYPE_ONE_OF_VALUES = ['config', 'transactionSlated', 'transactionSettled', 'transactionPosted'] as const;

export type IxcPortfolioV1SweepBalanceEventTypeOneOfValue = (typeof IXC_PORTFOLIO_V1_SWEEP_BALANCE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcPortfolioV1SweepBalanceKeys {
    // format: id62
    accountId: string;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
}

export interface IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceEventsSweepBalanceEventsRequest {
    // format: id62
    accountId: string;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceEventsSearchableFields, IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceEventsSortableFields, IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceEventsFilterableFields>;
}

export enum IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AccountId = 'accountId',
    AssetId = 'assetId',
    ProgramId = 'programId',
    EventConfigAssetAssetId = 'event.config.asset.assetId',
    EventConfigAssetDataTypeEquityCusip = 'event.config.asset.data.type.equity.cusip',
    EventConfigAssetDataTypeEquityControlsCanBuy = 'event.config.asset.data.type.equity.controls.canBuy',
    EventConfigAssetDataTypeEquityControlsCanSell = 'event.config.asset.data.type.equity.controls.canSell',
    EventConfigAssetDataTypeEquityControlsCanEnterFractions = 'event.config.asset.data.type.equity.controls.canEnterFractions',
    EventConfigAssetDataTypeMoneyMarketCusip = 'event.config.asset.data.type.moneyMarket.cusip',
    EventConfigAssetDataTypeMoneyMarketControlsCanBuy = 'event.config.asset.data.type.moneyMarket.controls.canBuy',
    EventConfigAssetDataTypeMoneyMarketControlsCanSell = 'event.config.asset.data.type.moneyMarket.controls.canSell',
    EventConfigAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.config.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventConfigAssetDataTypeMoneyMarketClassification = 'event.config.asset.data.type.moneyMarket.classification',
    EventConfigAssetDataTypeMoneyMarketNavType = 'event.config.asset.data.type.moneyMarket.navType',
    EventConfigAssetDataTypeType = 'event.config.asset.data.type.!type',
    EventConfigAssetDataCategory = 'event.config.asset.data.category',
    EventConfigAssetStatus = 'event.config.asset.status',
    EventType = 'event.!type'
}

export enum IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceEventsSearchableFields {
    EventConfigAssetDataTypeEquitySymbolBase = 'event.config.asset.data.type.equity.symbol.base',
    EventConfigAssetDataTypeEquityName = 'event.config.asset.data.type.equity.name',
    EventConfigAssetDataTypeMoneyMarketSymbolBase = 'event.config.asset.data.type.moneyMarket.symbol.base',
    EventConfigAssetDataTypeMoneyMarketName = 'event.config.asset.data.type.moneyMarket.name'
}

export enum IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventConfigAssetMetadataCreatedAt = 'event.config.asset.metadata.createdAt',
    EventConfigAssetMetadataUpdatedAt = 'event.config.asset.metadata.updatedAt'
}

export interface IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceGetSweepBalanceGetRequest {
    // format: id62
    accountId: string;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
}

export interface IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceListSweepBalanceListRequest {
    // format: id62
    accountId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceListSearchableFields, IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceListSortableFields, IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceListFilterableFields>;
}

export enum IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceListFilterableFields {
    AccountId = 'accountId',
    AssetId = 'assetId',
    ProgramId = 'programId',
    DataAssetAssetId = 'data.asset.assetId',
    DataAssetDataTypeEquityCusip = 'data.asset.data.type.equity.cusip',
    DataAssetDataTypeEquityControlsCanBuy = 'data.asset.data.type.equity.controls.canBuy',
    DataAssetDataTypeEquityControlsCanSell = 'data.asset.data.type.equity.controls.canSell',
    DataAssetDataTypeEquityControlsCanEnterFractions = 'data.asset.data.type.equity.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketCusip = 'data.asset.data.type.moneyMarket.cusip',
    DataAssetDataTypeMoneyMarketControlsCanBuy = 'data.asset.data.type.moneyMarket.controls.canBuy',
    DataAssetDataTypeMoneyMarketControlsCanSell = 'data.asset.data.type.moneyMarket.controls.canSell',
    DataAssetDataTypeMoneyMarketControlsCanEnterFractions = 'data.asset.data.type.moneyMarket.controls.canEnterFractions',
    DataAssetDataTypeMoneyMarketClassification = 'data.asset.data.type.moneyMarket.classification',
    DataAssetDataTypeMoneyMarketNavType = 'data.asset.data.type.moneyMarket.navType',
    DataAssetDataTypeType = 'data.asset.data.type.!type',
    DataAssetDataCategory = 'data.asset.data.category',
    DataAssetStatus = 'data.asset.status',
    Status = 'status'
}

export enum IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceListSearchableFields {
    DataAssetDataTypeEquitySymbolBase = 'data.asset.data.type.equity.symbol.base',
    DataAssetDataTypeEquityName = 'data.asset.data.type.equity.name',
    DataAssetDataTypeMoneyMarketSymbolBase = 'data.asset.data.type.moneyMarket.symbol.base',
    DataAssetDataTypeMoneyMarketName = 'data.asset.data.type.moneyMarket.name'
}

export enum IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataAssetMetadataCreatedAt = 'data.asset.metadata.createdAt',
    DataAssetMetadataUpdatedAt = 'data.asset.metadata.updatedAt'
}

export interface IxcPortfolioV1SweepBalanceState extends IxcPortfolioV1SweepBalanceKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcPortfolioV1SweepBalanceData;
    status: IxcPortfolioV1SweepBalanceStatus;
}

export enum IxcPortfolioV1SweepBalanceStatus {
    Unspecified = 'UNSPECIFIED',
    Open = 'OPEN'
}

export interface IxcPortfolioV1SweepsControls {
    settings?: IxcPortfolioV1SweepsControlsSettings;
}

export interface IxcPortfolioV1SweepsControlsSettings {
    /* Whether the program's accounts can use sweeps. */
    canSweepAccounts?: boolean;
    /* The sweep plan assigned to new accounts in this program when sweeping
    is enabled. Must be one of the eligible sweep plans. */
    // format: id62, entity: ixc.sweeps.v1.SweepPlan
    defaultSweepPlanId?: string;
    /* The sweep plans that are available for use by accounts in this
    program. */
    // format: id62
    eligibleSweepPlanIds?: string[];
}

export interface IxcPortfolioV1TaxLotAllocation {
    /* The unique identifier of the tax lot to use */
    // format: id62
    taxLotId?: string;
    /* The quantity of the transaction to allocate to this lot before moving to
    the next. */
    // format: decimal
    quantity?: string;
}

export enum IxcPortfolioV1TaxLotMethod {
    Unspecified = 'UNSPECIFIED',
    Fifo = 'FIFO',
    Lifo = 'LIFO',
    Custom = 'CUSTOM'
}

export interface IxcPortfolioV1TransactionAsset {
    /* A record of asset information at the time the transaction was entered.
    This is not updated when, e.g. company names or symbols change. */
    asset?: IxcAssetsV1AssetState;
    /* If true, this delta is Cash in the home currency of the account */
    isHomeCurrency?: boolean;
    /* When true, the asset is held in the portfolio as part of an automated
    sweep program, these assets are segregated from
    directly-traded versions of the same underlying asset.
    This field is only valid for cash-equivalent / sweepable assets, and only
    relevant in the portfolio, not RAGL */
    sweepAsset?: boolean;
    /* The deltas which effect the brokerage account */
    accountDeltas?: IxcPortfolioV1AccountDelta[];
}

export interface IxcPortfolioV1TransactionData {
    /* The date and time the transaction was settled. For direct-posting this is
    the same as `effective_at` */
    // format: date-time
    settledAt?: string;
    /* The unique identifier of the transaction which settles this one */
    // format: id62
    settledByTransactionId?: string;
    /* The changes in the account balance caused by the transaction */
    assets: IxcPortfolioV1TransactionAsset[];
    /* The date and time the transaction is effective. These will always be in
    the past, future-dated transactions use the slated -> settled flow. */
    // format: date-time
    effectiveAt: string;
    /* For slated->settled transactions, the transaction will automatically
    settle at this time. For direct-to-settled, this will equal effectiveAt. */
    // format: date-time
    settlesAt: string;
    /* The date of effectiveAt, for queries running on a date basis, such as US
    Equity trades and corporate actions. */
    // format: YYYY-MM-DD
    tradeDate: string;
    /* The date of settlesAt, for queries running on a date basis, such as US
    Equity trades and corporate actions. */
    // format: YYYY-MM-DD
    settleDate: string;
    /* The extended details causing the transaction */
    detail?: IxcPortfolioV1TransactionDetail;
    /* This transaction reverses another transaction. In cases where the
    reversal is just a cancel, the deltas in this transaction will all be
    marked as `isReverse`
    In cases where the reversal is a correction, the same reversal deltas
    will be present plus a set of corrected deltas, i.e. the deltas will not
    be netted or combined.
    Corrections may further be corrected, leading to a chain of transactions
    which are all reversals of each other. */
    reverses?: IxcPortfolioV1ReverseLink;
    /* Releases quantity from a previous hold. */
    reduceHold?: IxcPortfolioV1HoldReduction;
    /* When transaction is in REVERSED status, this field shows basic
    information about the transaction which corrects or replaces it. */
    reversedBy?: IxcPortfolioV1ReverseLink;
}

export type IxcPortfolioV1TransactionDetail = {
    '!type': 'ixc.orders.v1.TradeTransaction';
    value: IxcOrdersV1TradeTransaction;
} | {
    '!type': 'ixc.orders.v1.BatchAllocationCustomerTransaction';
    value: IxcOrdersV1BatchAllocationCustomerTransaction;
} | {
    '!type': 'ixc.orders.v1.BatchAllocationAvgPriceTransaction';
    value: IxcOrdersV1BatchAllocationAvgPriceTransaction;
} | {
    '!type': 'ixc.portfolio.v1.DividendPaymentTransaction';
    value: IxcPortfolioV1DividendPaymentTransaction;
} | {
    '!type': 'ixc.funding.v1.FundingTransaction';
    value: IxcFundingV1FundingTransaction;
} | {
    '!type': 'ixc.funding.v1.FundingBatchTransaction';
    value: IxcFundingV1FundingBatchTransaction;
} | {
    '!type': 'ixc.sweeps.clearing.v1.SweepsTransaction';
    value: IxcSweepsClearingV1SweepsTransaction;
} | {
    '!type': 'ixc.corpactions.v1.CorpactionTransaction';
    value: IxcCorpactionsV1CorpactionTransaction;
} | {
    '!type': 'ixc.orders.v1.BatchRemainderInventoryTransaction';
    value: IxcOrdersV1BatchRemainderInventoryTransaction;
} | {
    '!type': 'ixc.billing.v1.ChargeTransaction';
    value: IxcBillingV1ChargeTransaction;
} | {
    '!type': 'ixc.billing.v1.CustomerChargeTransaction';
    value: IxcBillingV1CustomerChargeTransaction;
} | {
    '!type': 'ixc.mutualfunds.v1.FundTransaction';
    value: IxcMutualfundsV1FundTransaction;
};

export const IXC_PORTFOLIO_V1_TRANSACTION_DETAIL_MEMBERS = ['ixc.orders.v1.TradeTransaction', 'ixc.orders.v1.BatchAllocationCustomerTransaction', 'ixc.orders.v1.BatchAllocationAvgPriceTransaction', 'ixc.portfolio.v1.DividendPaymentTransaction', 'ixc.funding.v1.FundingTransaction', 'ixc.funding.v1.FundingBatchTransaction', 'ixc.sweeps.clearing.v1.SweepsTransaction', 'ixc.corpactions.v1.CorpactionTransaction', 'ixc.orders.v1.BatchRemainderInventoryTransaction', 'ixc.billing.v1.ChargeTransaction', 'ixc.billing.v1.CustomerChargeTransaction', 'ixc.mutualfunds.v1.FundTransaction'] as const;

export type IxcPortfolioV1TransactionDetailMember = (typeof IXC_PORTFOLIO_V1_TRANSACTION_DETAIL_MEMBERS)[number];

export interface IxcPortfolioV1TransactionEvent extends IxcPortfolioV1TransactionKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcPortfolioV1TransactionEventType;
}

export type IxcPortfolioV1TransactionEventType = {
    '!type'?: 'posted';
    posted: IxcPortfolioV1TransactionEventTypePosted;
} | {
    '!type'?: 'slated';
    slated: IxcPortfolioV1TransactionEventTypeSlated;
} | {
    '!type'?: 'settled';
    settled: IxcPortfolioV1TransactionEventTypeSettled;
};

export interface IxcPortfolioV1TransactionEventTypePosted {
    /* The changes in the account balance caused by the transaction */
    assets: IxcPortfolioV1TransactionAsset[];
    /* The date and time the transaction is effective. These will always be in
    the past, future-dated transactions use the slated -> settled flow. */
    // format: date-time
    effectiveAt: string;
    /* For slated->settled transactions, the transaction will automatically
    settle at this time. For direct-to-settled, this will equal effectiveAt. */
    // format: date-time
    settlesAt: string;
    /* The date of effectiveAt, for queries running on a date basis, such as US
    Equity trades and corporate actions. */
    // format: YYYY-MM-DD
    tradeDate: string;
    /* The date of settlesAt, for queries running on a date basis, such as US
    Equity trades and corporate actions. */
    // format: YYYY-MM-DD
    settleDate: string;
    /* The extended details causing the transaction */
    detail?: IxcPortfolioV1TransactionDetail;
    /* This transaction reverses another transaction. In cases where the
    reversal is just a cancel, the deltas in this transaction will all be
    marked as `isReverse`
    In cases where the reversal is a correction, the same reversal deltas
    will be present plus a set of corrected deltas, i.e. the deltas will not
    be netted or combined.
    Corrections may further be corrected, leading to a chain of transactions
    which are all reversals of each other. */
    reverses?: IxcPortfolioV1ReverseLink;
    /* Releases quantity from a previous hold. */
    reduceHold?: IxcPortfolioV1HoldReduction;
}

export interface IxcPortfolioV1TransactionEventTypeSettled {
    /* The unique identifier of the transaction which settles this one */
    // format: id62
    transactionId: string;
    /* The date and time the transaction was settled */
    // format: date-time
    settledAt: string;
}

export interface IxcPortfolioV1TransactionEventTypeSlated {
    /* The changes in the account balance caused by the transaction */
    assets: IxcPortfolioV1TransactionAsset[];
    /* The date and time the transaction is effective. These will always be in
    the past, future-dated transactions use the slated -> settled flow. */
    // format: date-time
    effectiveAt: string;
    /* For slated->settled transactions, the transaction will automatically
    settle at this time. For direct-to-settled, this will equal effectiveAt. */
    // format: date-time
    settlesAt: string;
    /* The date of effectiveAt, for queries running on a date basis, such as US
    Equity trades and corporate actions. */
    // format: YYYY-MM-DD
    tradeDate: string;
    /* The date of settlesAt, for queries running on a date basis, such as US
    Equity trades and corporate actions. */
    // format: YYYY-MM-DD
    settleDate: string;
    /* The extended details causing the transaction */
    detail?: IxcPortfolioV1TransactionDetail;
    /* This transaction reverses another transaction. In cases where the
    reversal is just a cancel, the deltas in this transaction will all be
    marked as `isReverse`
    In cases where the reversal is a correction, the same reversal deltas
    will be present plus a set of corrected deltas, i.e. the deltas will not
    be netted or combined.
    Corrections may further be corrected, leading to a chain of transactions
    which are all reversals of each other. */
    reverses?: IxcPortfolioV1ReverseLink;
    /* Releases quantity from a previous hold. */
    reduceHold?: IxcPortfolioV1HoldReduction;
}

export const IXC_PORTFOLIO_V1_TRANSACTION_EVENT_TYPE_ONE_OF_VALUES = ['posted', 'slated', 'settled'] as const;

export type IxcPortfolioV1TransactionEventTypeOneOfValue = (typeof IXC_PORTFOLIO_V1_TRANSACTION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcPortfolioV1TransactionKeys {
    /* Identifies the brokerage account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    // format: id62
    programId?: string;
    // format: id62
    transactionId: string;
}

export interface IxcPortfolioV1TransactionQueryServiceTransactionEventsTransactionEventsRequest {
    /* Identifies the brokerage account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    // format: id62
    transactionId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcPortfolioV1TransactionQueryServiceTransactionEventsSearchableFields, IxcPortfolioV1TransactionQueryServiceTransactionEventsSortableFields, IxcPortfolioV1TransactionQueryServiceTransactionEventsFilterableFields>;
}

export enum IxcPortfolioV1TransactionQueryServiceTransactionEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AccountId = 'accountId',
    ProgramId = 'programId',
    TransactionId = 'transactionId',
    EventPostedAssetsAssetAssetId = 'event.posted.assets.asset.assetId',
    EventPostedAssetsAssetDataTypeEquityCusip = 'event.posted.assets.asset.data.type.equity.cusip',
    EventPostedAssetsAssetDataTypeEquityControlsCanBuy = 'event.posted.assets.asset.data.type.equity.controls.canBuy',
    EventPostedAssetsAssetDataTypeEquityControlsCanSell = 'event.posted.assets.asset.data.type.equity.controls.canSell',
    EventPostedAssetsAssetDataTypeEquityControlsCanEnterFractions = 'event.posted.assets.asset.data.type.equity.controls.canEnterFractions',
    EventPostedAssetsAssetDataTypeMoneyMarketCusip = 'event.posted.assets.asset.data.type.moneyMarket.cusip',
    EventPostedAssetsAssetDataTypeMoneyMarketControlsCanBuy = 'event.posted.assets.asset.data.type.moneyMarket.controls.canBuy',
    EventPostedAssetsAssetDataTypeMoneyMarketControlsCanSell = 'event.posted.assets.asset.data.type.moneyMarket.controls.canSell',
    EventPostedAssetsAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.posted.assets.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventPostedAssetsAssetDataTypeMoneyMarketClassification = 'event.posted.assets.asset.data.type.moneyMarket.classification',
    EventPostedAssetsAssetDataTypeMoneyMarketNavType = 'event.posted.assets.asset.data.type.moneyMarket.navType',
    EventPostedAssetsAssetDataTypeType = 'event.posted.assets.asset.data.type.!type',
    EventPostedAssetsAssetDataCategory = 'event.posted.assets.asset.data.category',
    EventPostedAssetsAssetStatus = 'event.posted.assets.asset.status',
    EventPostedDetailType = 'event.posted.detail.!type',
    EventSlatedAssetsAssetAssetId = 'event.slated.assets.asset.assetId',
    EventSlatedAssetsAssetDataTypeEquityCusip = 'event.slated.assets.asset.data.type.equity.cusip',
    EventSlatedAssetsAssetDataTypeEquityControlsCanBuy = 'event.slated.assets.asset.data.type.equity.controls.canBuy',
    EventSlatedAssetsAssetDataTypeEquityControlsCanSell = 'event.slated.assets.asset.data.type.equity.controls.canSell',
    EventSlatedAssetsAssetDataTypeEquityControlsCanEnterFractions = 'event.slated.assets.asset.data.type.equity.controls.canEnterFractions',
    EventSlatedAssetsAssetDataTypeMoneyMarketCusip = 'event.slated.assets.asset.data.type.moneyMarket.cusip',
    EventSlatedAssetsAssetDataTypeMoneyMarketControlsCanBuy = 'event.slated.assets.asset.data.type.moneyMarket.controls.canBuy',
    EventSlatedAssetsAssetDataTypeMoneyMarketControlsCanSell = 'event.slated.assets.asset.data.type.moneyMarket.controls.canSell',
    EventSlatedAssetsAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.slated.assets.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventSlatedAssetsAssetDataTypeMoneyMarketClassification = 'event.slated.assets.asset.data.type.moneyMarket.classification',
    EventSlatedAssetsAssetDataTypeMoneyMarketNavType = 'event.slated.assets.asset.data.type.moneyMarket.navType',
    EventSlatedAssetsAssetDataTypeType = 'event.slated.assets.asset.data.type.!type',
    EventSlatedAssetsAssetDataCategory = 'event.slated.assets.asset.data.category',
    EventSlatedAssetsAssetStatus = 'event.slated.assets.asset.status',
    EventSlatedDetailType = 'event.slated.detail.!type',
    EventType = 'event.!type'
}

export enum IxcPortfolioV1TransactionQueryServiceTransactionEventsSearchableFields {
    EventPostedAssetsAssetDataTypeEquitySymbolBase = 'event.posted.assets.asset.data.type.equity.symbol.base',
    EventPostedAssetsAssetDataTypeEquityName = 'event.posted.assets.asset.data.type.equity.name',
    EventPostedAssetsAssetDataTypeMoneyMarketSymbolBase = 'event.posted.assets.asset.data.type.moneyMarket.symbol.base',
    EventPostedAssetsAssetDataTypeMoneyMarketName = 'event.posted.assets.asset.data.type.moneyMarket.name',
    EventSlatedAssetsAssetDataTypeEquitySymbolBase = 'event.slated.assets.asset.data.type.equity.symbol.base',
    EventSlatedAssetsAssetDataTypeEquityName = 'event.slated.assets.asset.data.type.equity.name',
    EventSlatedAssetsAssetDataTypeMoneyMarketSymbolBase = 'event.slated.assets.asset.data.type.moneyMarket.symbol.base',
    EventSlatedAssetsAssetDataTypeMoneyMarketName = 'event.slated.assets.asset.data.type.moneyMarket.name'
}

export enum IxcPortfolioV1TransactionQueryServiceTransactionEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcPortfolioV1TransactionQueryServiceTransactionGetTransactionGetRequest {
    /* Identifies the brokerage account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    // format: id62
    transactionId: string;
}

export interface IxcPortfolioV1TransactionQueryServiceTransactionListTransactionListRequest {
    /* Identifies the brokerage account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcPortfolioV1TransactionQueryServiceTransactionListSearchableFields, IxcPortfolioV1TransactionQueryServiceTransactionListSortableFields, IxcPortfolioV1TransactionQueryServiceTransactionListFilterableFields>;
}

export enum IxcPortfolioV1TransactionQueryServiceTransactionListFilterableFields {
    AccountId = 'accountId',
    ProgramId = 'programId',
    TransactionId = 'transactionId',
    DataAssetsAssetAssetId = 'data.assets.asset.assetId',
    DataAssetsAssetDataTypeEquityCusip = 'data.assets.asset.data.type.equity.cusip',
    DataAssetsAssetDataTypeEquityControlsCanBuy = 'data.assets.asset.data.type.equity.controls.canBuy',
    DataAssetsAssetDataTypeEquityControlsCanSell = 'data.assets.asset.data.type.equity.controls.canSell',
    DataAssetsAssetDataTypeEquityControlsCanEnterFractions = 'data.assets.asset.data.type.equity.controls.canEnterFractions',
    DataAssetsAssetDataTypeMoneyMarketCusip = 'data.assets.asset.data.type.moneyMarket.cusip',
    DataAssetsAssetDataTypeMoneyMarketControlsCanBuy = 'data.assets.asset.data.type.moneyMarket.controls.canBuy',
    DataAssetsAssetDataTypeMoneyMarketControlsCanSell = 'data.assets.asset.data.type.moneyMarket.controls.canSell',
    DataAssetsAssetDataTypeMoneyMarketControlsCanEnterFractions = 'data.assets.asset.data.type.moneyMarket.controls.canEnterFractions',
    DataAssetsAssetDataTypeMoneyMarketClassification = 'data.assets.asset.data.type.moneyMarket.classification',
    DataAssetsAssetDataTypeMoneyMarketNavType = 'data.assets.asset.data.type.moneyMarket.navType',
    DataAssetsAssetDataTypeType = 'data.assets.asset.data.type.!type',
    DataAssetsAssetDataCategory = 'data.assets.asset.data.category',
    DataAssetsAssetStatus = 'data.assets.asset.status',
    DataDetailType = 'data.detail.!type',
    Status = 'status'
}

export enum IxcPortfolioV1TransactionQueryServiceTransactionListSearchableFields {
    DataAssetsAssetDataTypeEquitySymbolBase = 'data.assets.asset.data.type.equity.symbol.base',
    DataAssetsAssetDataTypeEquityName = 'data.assets.asset.data.type.equity.name',
    DataAssetsAssetDataTypeMoneyMarketSymbolBase = 'data.assets.asset.data.type.moneyMarket.symbol.base',
    DataAssetsAssetDataTypeMoneyMarketName = 'data.assets.asset.data.type.moneyMarket.name'
}

export enum IxcPortfolioV1TransactionQueryServiceTransactionListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataSettledAt = 'data.settledAt'
}

export interface IxcPortfolioV1TransactionState extends IxcPortfolioV1TransactionKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcPortfolioV1TransactionData;
    status: IxcPortfolioV1TransactionStatus;
}

export enum IxcPortfolioV1TransactionStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Settled = 'SETTLED'
}

export interface IxcPortfolioV1UnrealizedDividendsByAsset {
    /* Sum across all sources */
    // format: decimal
    amount: string;
    /* Last dividend calculation date */
    // format: YYYY-MM-DD
    asOfDate: string;
    /* First day of the stats month */
    // format: YYYY-MM-DD
    monthStart: string;
    /* Expected payment date for the dividends, if known */
    // format: YYYY-MM-DD
    expectedPaymentDate?: string;
    /* One entry per source, ordered by source */
    sources?: IxcPortfolioV1UnrealizedDividendsBySource[];
}

export interface IxcPortfolioV1UnrealizedDividendsBySource {
    source: IxcPortfolioV1UnrealizedDividendSource;
    /* Present when source is SWEEP */
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId?: string;
    // format: decimal
    amount: string;
    /* Last dividend calculation date */
    // format: YYYY-MM-DD
    asOfDate: string;
    /* First day of the stats month */
    // format: YYYY-MM-DD
    monthStart: string;
    /* Expected payment date for the dividends, if known */
    // format: YYYY-MM-DD
    expectedPaymentDate?: string;
}

export enum IxcPortfolioV1UnrealizedDividendSource {
    Unspecified = 'UNSPECIFIED',
    Sweep = 'SWEEP',
    Owned = 'OWNED'
}

export interface IxcPortfolioV1UnrealizedDividendsSummary {
    /* Sum of unrealized dividends across all assets */
    // format: decimal
    total: string;
    byAsset?: Record<string, IxcPortfolioV1UnrealizedDividendsByAsset>;
}

export enum IxcProspectusV1MediantSegmentStatus {
    Unspecified = 'UNSPECIFIED',
    New = 'NEW',
    Pending = 'PENDING',
    Committed = 'COMMITTED',
    Processing = 'PROCESSING',
    Failed = 'FAILED',
    Complete = 'COMPLETE'
}

export interface IxcProspectusV1Metrics {
    /* Total number of tasks in this job */
    // format: UINT32
    total?: number;
    /* Tasks awaiting Mediant submission */
    // format: UINT32
    pending?: number;
    /* Tasks submitted to Mediant, awaiting processing */
    // format: UINT32
    committed?: number;
    /* Tasks confirmed COMPLETE by Mediant */
    // format: UINT32
    succeeded?: number;
    /* Tasks that hit a transient failure */
    // format: UINT32
    errored?: number;
    /* Tasks with unrecoverable failures */
    // format: UINT32
    failed?: number;
}

export interface IxcProspectusV1ProspectusJobData {
    spec: IxcProspectusV1ProspectusJobSpec;
    metrics: IxcProspectusV1Metrics;
}

export interface IxcProspectusV1ProspectusJobEvent extends IxcProspectusV1ProspectusJobKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcProspectusV1ProspectusJobEventType;
}

export type IxcProspectusV1ProspectusJobEventType = {
    '!type'?: 'created';
    created: IxcProspectusV1ProspectusJobEventTypeCreated;
} | {
    '!type'?: 'taskUpdated';
    taskUpdated: IxcProspectusV1ProspectusJobEventTypeTaskUpdated;
} | {
    '!type'?: 'allFinished';
    allFinished: IxcProspectusV1ProspectusJobEventTypeAllFinished;
};

export interface IxcProspectusV1ProspectusJobEventTypeAllFinished {
    message?: string;
    /* Final task metrics at job completion */
    metrics?: IxcProspectusV1Metrics;
}

export interface IxcProspectusV1ProspectusJobEventTypeCreated {
    spec: IxcProspectusV1ProspectusJobSpec;
}

export interface IxcProspectusV1ProspectusJobEventTypeTaskUpdated {
    /* ID of the task that transitioned */
    // format: id62
    taskId: string;
    taskStatus: IxcProspectusV1TaskUpdatedStatus;
    /* Current task metrics queried from the database */
    metrics?: IxcProspectusV1Metrics;
}

export const IXC_PROSPECTUS_V1_PROSPECTUS_JOB_EVENT_TYPE_ONE_OF_VALUES = ['created', 'taskUpdated', 'allFinished'] as const;

export type IxcProspectusV1ProspectusJobEventTypeOneOfValue = (typeof IXC_PROSPECTUS_V1_PROSPECTUS_JOB_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcProspectusV1ProspectusJobKeys {
    /* Primary identifier */
    // format: id62
    jobId: string;
}

export interface IxcProspectusV1ProspectusJobQueryServiceProspectusJobEventsProspectusJobEventsRequest {
    /* Primary identifier */
    // format: id62
    jobId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcProspectusV1ProspectusJobQueryServiceProspectusJobEventsSortableFields, IxcProspectusV1ProspectusJobQueryServiceProspectusJobEventsFilterableFields>;
}

export enum IxcProspectusV1ProspectusJobQueryServiceProspectusJobEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    JobId = 'jobId',
    EventType = 'event.!type'
}

export enum IxcProspectusV1ProspectusJobQueryServiceProspectusJobEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcProspectusV1ProspectusJobQueryServiceProspectusJobGetProspectusJobGetRequest {
    /* Primary identifier */
    // format: id62
    jobId: string;
}

export interface IxcProspectusV1ProspectusJobQueryServiceProspectusJobListProspectusJobListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcProspectusV1ProspectusJobQueryServiceProspectusJobListSortableFields, IxcProspectusV1ProspectusJobQueryServiceProspectusJobListFilterableFields>;
}

export enum IxcProspectusV1ProspectusJobQueryServiceProspectusJobListFilterableFields {
    JobId = 'jobId',
    Status = 'status'
}

export enum IxcProspectusV1ProspectusJobQueryServiceProspectusJobListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcProspectusV1ProspectusJobSpec {
    /* Trade date this job covers */
    // format: YYYY-MM-DD
    tradeDate: string;
}

export interface IxcProspectusV1ProspectusJobState extends IxcProspectusV1ProspectusJobKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcProspectusV1ProspectusJobData;
    status: IxcProspectusV1ProspectusJobStatus;
}

export enum IxcProspectusV1ProspectusJobStatus {
    Unspecified = 'UNSPECIFIED',
    Processing = 'PROCESSING',
    Done = 'DONE'
}

export interface IxcProspectusV1ProspectusTaskData {
    spec: IxcProspectusV1ProspectusTaskSpec;
    result?: IxcProspectusV1ProspectusTaskResult;
}

export interface IxcProspectusV1ProspectusTaskEvent extends IxcProspectusV1ProspectusTaskKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcProspectusV1ProspectusTaskEventType;
}

export type IxcProspectusV1ProspectusTaskEventType = {
    '!type'?: 'created';
    created: IxcProspectusV1ProspectusTaskEventTypeCreated;
} | {
    '!type'?: 'committed';
    committed: IxcProspectusV1ProspectusTaskEventTypeCommitted;
} | {
    '!type'?: 'completed';
    completed: IxcProspectusV1ProspectusTaskEventTypeCompleted;
} | {
    '!type'?: 'errored';
    errored: IxcProspectusV1ProspectusTaskEventTypeErrored;
} | {
    '!type'?: 'failed';
    failed: IxcProspectusV1ProspectusTaskEventTypeFailed;
};

export interface IxcProspectusV1ProspectusTaskEventTypeCommitted {
    result: IxcProspectusV1ProspectusTaskResult;
}

export interface IxcProspectusV1ProspectusTaskEventTypeCompleted {
    mediantStatus: IxcProspectusV1MediantSegmentStatus;
    // format: date-time
    completedAt: string;
}

export interface IxcProspectusV1ProspectusTaskEventTypeCreated {
    // format: id62
    jobId: string;
    spec: IxcProspectusV1ProspectusTaskSpec;
}

export interface IxcProspectusV1ProspectusTaskEventTypeErrored {
    message?: string;
}

export interface IxcProspectusV1ProspectusTaskEventTypeFailed {
    message?: string;
}

export const IXC_PROSPECTUS_V1_PROSPECTUS_TASK_EVENT_TYPE_ONE_OF_VALUES = ['created', 'committed', 'completed', 'errored', 'failed'] as const;

export type IxcProspectusV1ProspectusTaskEventTypeOneOfValue = (typeof IXC_PROSPECTUS_V1_PROSPECTUS_TASK_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcProspectusV1ProspectusTaskKeys {
    /* Primary identifier */
    // format: id62
    taskId: string;
    /* Parent job */
    // format: id62, entity: ixc.prospectus.v1.ProspectusJob
    jobId: string;
}

export interface IxcProspectusV1ProspectusTaskQueryServiceProspectusTaskEventsProspectusTaskEventsRequest {
    /* Primary identifier */
    // format: id62
    taskId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcProspectusV1ProspectusTaskQueryServiceProspectusTaskEventsSortableFields, IxcProspectusV1ProspectusTaskQueryServiceProspectusTaskEventsFilterableFields>;
}

export enum IxcProspectusV1ProspectusTaskQueryServiceProspectusTaskEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    TaskId = 'taskId',
    JobId = 'jobId',
    EventType = 'event.!type'
}

export enum IxcProspectusV1ProspectusTaskQueryServiceProspectusTaskEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcProspectusV1ProspectusTaskQueryServiceProspectusTaskGetProspectusTaskGetRequest {
    /* Primary identifier */
    // format: id62
    taskId: string;
}

export interface IxcProspectusV1ProspectusTaskQueryServiceProspectusTaskListProspectusTaskListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcProspectusV1ProspectusTaskQueryServiceProspectusTaskListSortableFields, IxcProspectusV1ProspectusTaskQueryServiceProspectusTaskListFilterableFields>;
}

export enum IxcProspectusV1ProspectusTaskQueryServiceProspectusTaskListFilterableFields {
    TaskId = 'taskId',
    JobId = 'jobId',
    Status = 'status'
}

export enum IxcProspectusV1ProspectusTaskQueryServiceProspectusTaskListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcProspectusV1ProspectusTaskResult {
    /* Load segment token returned by Mediant */
    segmentToken?: string;
    /* Records committed */
    // format: UINT32
    tradeCount?: number;
    // format: decimal
    totalShares?: string;
    /* Wall-clock when our commit returned 202 */
    // format: date-time
    committedAt?: string;
    mediantStatus?: IxcProspectusV1MediantSegmentStatus;
    // format: date-time
    lastPolledAt?: string;
}

export interface IxcProspectusV1ProspectusTaskSpec {
    cusip: string;
    isin?: string;
    /* Max 80; sourced from assets service */
    securityName: string;
    // format: YYYY-MM-DD
    tradeDate: string;
}

export interface IxcProspectusV1ProspectusTaskState extends IxcProspectusV1ProspectusTaskKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcProspectusV1ProspectusTaskData;
    status: IxcProspectusV1ProspectusTaskStatus;
}

export enum IxcProspectusV1ProspectusTaskStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Committed = 'COMMITTED',
    Succeeded = 'SUCCEEDED',
    Errored = 'ERRORED',
    Failed = 'FAILED'
}

export enum IxcProspectusV1TaskUpdatedStatus {
    Unspecified = 'UNSPECIFIED',
    Processing = 'PROCESSING',
    Committed = 'COMMITTED',
    Succeeded = 'SUCCEEDED',
    Errored = 'ERRORED',
    Failed = 'FAILED'
}

export interface IxcProxyvoteV1Metrics {
    /* Total number of tasks in this job */
    // format: UINT32
    total?: number;
    /* Number of tasks waiting to be processed */
    // format: UINT32
    pending?: number;
    /* Number of tasks that have completed */
    // format: UINT32
    succeeded?: number;
    /* Number of tasks that encountered an error */
    // format: UINT32
    errored?: number;
    /* Number of tasks that failed for job termination */
    // format: UINT32
    failed?: number;
}

export interface IxcProxyvoteV1ProxyJobData {
    spec: IxcProxyvoteV1ProxyJobSpec;
    metrics: IxcProxyvoteV1Metrics;
}

export interface IxcProxyvoteV1ProxyJobEvent extends IxcProxyvoteV1ProxyJobKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcProxyvoteV1ProxyJobEventType;
}

export type IxcProxyvoteV1ProxyJobEventType = {
    '!type'?: 'created';
    created: IxcProxyvoteV1ProxyJobEventTypeCreated;
} | {
    '!type'?: 'taskUpdated';
    taskUpdated: IxcProxyvoteV1ProxyJobEventTypeTaskUpdated;
} | {
    '!type'?: 'allFinished';
    allFinished: IxcProxyvoteV1ProxyJobEventTypeAllFinished;
};

export interface IxcProxyvoteV1ProxyJobEventTypeAllFinished {
    message?: string;
}

export interface IxcProxyvoteV1ProxyJobEventTypeCreated {
    spec: IxcProxyvoteV1ProxyJobSpec;
}

export interface IxcProxyvoteV1ProxyJobEventTypeTaskUpdated {
    /* ID of the task that completed */
    // format: id62
    taskId: string;
    taskStatus: IxcProxyvoteV1TaskUpdatedStatus;
}

export const IXC_PROXYVOTE_V1_PROXY_JOB_EVENT_TYPE_ONE_OF_VALUES = ['created', 'taskUpdated', 'allFinished'] as const;

export type IxcProxyvoteV1ProxyJobEventTypeOneOfValue = (typeof IXC_PROXYVOTE_V1_PROXY_JOB_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcProxyvoteV1ProxyJobKeys {
    /* Primary identifier */
    // format: id62
    jobId: string;
}

export interface IxcProxyvoteV1ProxyJobQueryServiceProxyJobEventsProxyJobEventsRequest {
    /* Primary identifier */
    // format: id62
    jobId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcProxyvoteV1ProxyJobQueryServiceProxyJobEventsSortableFields, IxcProxyvoteV1ProxyJobQueryServiceProxyJobEventsFilterableFields>;
}

export enum IxcProxyvoteV1ProxyJobQueryServiceProxyJobEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    JobId = 'jobId',
    EventType = 'event.!type'
}

export enum IxcProxyvoteV1ProxyJobQueryServiceProxyJobEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcProxyvoteV1ProxyJobQueryServiceProxyJobGetProxyJobGetRequest {
    /* Primary identifier */
    // format: id62
    jobId: string;
}

export interface IxcProxyvoteV1ProxyJobQueryServiceProxyJobListProxyJobListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcProxyvoteV1ProxyJobQueryServiceProxyJobListSortableFields, IxcProxyvoteV1ProxyJobQueryServiceProxyJobListFilterableFields>;
}

export enum IxcProxyvoteV1ProxyJobQueryServiceProxyJobListFilterableFields {
    JobId = 'jobId',
    Status = 'status'
}

export enum IxcProxyvoteV1ProxyJobQueryServiceProxyJobListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcProxyvoteV1ProxyJobSpec {
    // format: YYYY-MM-DD
    triggerDate: string;
    securities: IxcProxyvoteV1SecurityRecord[];
}

export interface IxcProxyvoteV1ProxyJobState extends IxcProxyvoteV1ProxyJobKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcProxyvoteV1ProxyJobData;
    status: IxcProxyvoteV1ProxyJobStatus;
}

export enum IxcProxyvoteV1ProxyJobStatus {
    Unspecified = 'UNSPECIFIED',
    Processing = 'PROCESSING',
    Done = 'DONE'
}

export interface IxcProxyvoteV1ProxyTaskData {
    spec: IxcProxyvoteV1ProxyTaskSpec;
    result?: IxcProxyvoteV1ProxyTaskResult;
}

export interface IxcProxyvoteV1ProxyTaskEvent extends IxcProxyvoteV1ProxyTaskKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcProxyvoteV1ProxyTaskEventType;
}

export type IxcProxyvoteV1ProxyTaskEventType = {
    '!type'?: 'created';
    created: IxcProxyvoteV1ProxyTaskEventTypeCreated;
} | {
    '!type'?: 'finished';
    finished: IxcProxyvoteV1ProxyTaskEventTypeFinished;
} | {
    '!type'?: 'errored';
    errored: IxcProxyvoteV1ProxyTaskEventTypeErrored;
} | {
    '!type'?: 'failed';
    failed: IxcProxyvoteV1ProxyTaskEventTypeFailed;
};

export interface IxcProxyvoteV1ProxyTaskEventTypeCreated {
    // format: id62
    jobId: string;
    spec: IxcProxyvoteV1ProxyTaskSpec;
}

export interface IxcProxyvoteV1ProxyTaskEventTypeErrored {
    message?: string;
}

export interface IxcProxyvoteV1ProxyTaskEventTypeFailed {
    message?: string;
}

export interface IxcProxyvoteV1ProxyTaskEventTypeFinished {
    result?: IxcProxyvoteV1ProxyTaskResult;
}

export const IXC_PROXYVOTE_V1_PROXY_TASK_EVENT_TYPE_ONE_OF_VALUES = ['created', 'finished', 'errored', 'failed'] as const;

export type IxcProxyvoteV1ProxyTaskEventTypeOneOfValue = (typeof IXC_PROXYVOTE_V1_PROXY_TASK_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcProxyvoteV1ProxyTaskKeys {
    /* Primary identifier */
    // format: id62
    taskId: string;
    /* Parent job */
    // format: id62, entity: ixc.proxyvote.v1.ProxyJob
    jobId: string;
}

export interface IxcProxyvoteV1ProxyTaskQueryServiceProxyTaskEventsProxyTaskEventsRequest {
    /* Primary identifier */
    // format: id62
    taskId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcProxyvoteV1ProxyTaskQueryServiceProxyTaskEventsSortableFields, IxcProxyvoteV1ProxyTaskQueryServiceProxyTaskEventsFilterableFields>;
}

export enum IxcProxyvoteV1ProxyTaskQueryServiceProxyTaskEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    TaskId = 'taskId',
    JobId = 'jobId',
    EventType = 'event.!type'
}

export enum IxcProxyvoteV1ProxyTaskQueryServiceProxyTaskEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcProxyvoteV1ProxyTaskQueryServiceProxyTaskGetProxyTaskGetRequest {
    /* Primary identifier */
    // format: id62
    taskId: string;
}

export interface IxcProxyvoteV1ProxyTaskQueryServiceProxyTaskListProxyTaskListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcProxyvoteV1ProxyTaskQueryServiceProxyTaskListSortableFields, IxcProxyvoteV1ProxyTaskQueryServiceProxyTaskListFilterableFields>;
}

export enum IxcProxyvoteV1ProxyTaskQueryServiceProxyTaskListFilterableFields {
    TaskId = 'taskId',
    JobId = 'jobId',
    Status = 'status'
}

export enum IxcProxyvoteV1ProxyTaskQueryServiceProxyTaskListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcProxyvoteV1ProxyTaskResult {
    segmentToken?: string;
    // format: INT32
    positionCount?: number;
    // format: decimal
    totalShares?: string;
}

export interface IxcProxyvoteV1ProxyTaskSpec {
    cusip: string;
    // format: YYYY-MM-DD
    recordDate: string;
    triggerId: string;
    issuerName?: string;
    isin?: string;
}

export interface IxcProxyvoteV1ProxyTaskState extends IxcProxyvoteV1ProxyTaskKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcProxyvoteV1ProxyTaskData;
    status: IxcProxyvoteV1ProxyTaskStatus;
}

export enum IxcProxyvoteV1ProxyTaskStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Succeeded = 'SUCCEEDED',
    Errored = 'ERRORED',
    Failed = 'FAILED'
}

export interface IxcProxyvoteV1SecurityRecord {
    triggerId: string;
    cusip: string;
    isin?: string;
    // format: YYYY-MM-DD
    recordDate: string;
    // format: YYYY-MM-DD
    realRecordDate?: string;
    // format: YYYY-MM-DD
    eventDate?: string;
    issuer?: string;
    issuerName?: string;
    jobTypeCode?: string;
    proxyCode?: string;
}

export enum IxcProxyvoteV1TaskUpdatedStatus {
    Unspecified = 'UNSPECIFIED',
    Processing = 'PROCESSING',
    Succeeded = 'SUCCEEDED',
    Errored = 'ERRORED',
    Failed = 'FAILED'
}

export interface IxcQuoteV1Quote {
    // format: date-time
    timestamp: string;
    // format: decimal
    lastPrice: string;
    // format: decimal
    askPrice: string;
    // format: decimal
    askSize: string;
    // format: decimal
    bidPrice: string;
    // format: decimal
    bidSize: string;
}

export enum IxcQuoteV1QuoteOutcome {
    Unspecified = 'UNSPECIFIED',
    Success = 'SUCCESS',
    Inactive = 'INACTIVE',
    NotFound = 'NOT_FOUND',
    MarketClosed = 'MARKET_CLOSED'
}

export interface IxcRaglV1BrokerageAccount {
    // format: id62
    accountId?: string;
    // format: id62
    programId?: string;
    // format: custom - pattern: ^[A-Z]{4}$
    programCode: string;
    status: IxcRegistrationV1SummaryStatus;
    accountingGroup: IxcRegistrationV1AccountingGroup;
    purpose: IxcRegistrationV1Purpose;
    registrationType: IxcRaglV1RegistrationType;
    // pattern: ^[A-Z]{4}[0-9]{9}$
    displayId: string;
    name: string;
    physicalAddress: IxcRegistrationV1Address;
    taxId: string;
    /* The account's current sweep plan, which registration defaults from the
    program. */
    // format: id62, entity: ixc.sweeps.v1.SweepPlan
    sweepPlanId?: string;
}

export interface IxcRaglV1CashBalance {
    rows?: IxcRaglV1CashBalanceRow[];
    // format: decimal
    total?: string;
}

export interface IxcRaglV1CashBalanceRow {
    // format: custom - pattern: ^[a-z0-9-]+(:[a-z0-9-]+)*$
    accountCode: string;
    // format: decimal
    subtotal: string;
}

export interface IxcRaglV1CustomerCashBalanceRow {
    account: IxcRaglV1BrokerageAccount;
    balance: IxcRaglV1CustomerCashBalanceRowBalance;
}

export interface IxcRaglV1CustomerCashBalanceRowBalance {
    // format: decimal
    settled: string;
    // format: decimal
    pending: string;
    // format: decimal
    swept?: string;
}

export interface IxcRaglV1CustomerStockRecordRow {
    account: IxcRaglV1BrokerageAccount;
    asset?: IxcAssetsV1AssetState;
    balance: IxcRaglV1PortfolioBalance;
}

export interface IxcRaglV1CustomerSweepRecordRow {
    account: IxcRaglV1BrokerageAccount;
    asset?: IxcAssetsV1AssetState;
    // format: decimal
    sweptBalance: string;
}

export type IxcRaglV1DateOrTime = {
    '!type'?: 'date';
    // format: YYYY-MM-DD
    date: string;
} | {
    '!type'?: 'time';
    // format: date-time
    time: string;
};

export const IXC_RAGL_V1_DATE_OR_TIME_ONE_OF_VALUES = ['date', 'time'] as const;

export type IxcRaglV1DateOrTimeOneOfValue = (typeof IXC_RAGL_V1_DATE_OR_TIME_ONE_OF_VALUES)[number];

export interface IxcRaglV1Delta {
    /* The sequence number of the delta in the transaction, common across all
    assets. */
    // format: INT32
    seq?: number;
    // format: custom - pattern: ^[a-z0-9-]+(:[a-z0-9-]+)*$
    accountCode: string;
    // format: id62, entity: ixc.registration.v1.Account
    brokerageAccountId?: string;
    /* Marks a delta as being half of a correlated pair against a
    wash:correlation:* account. These are used where one action affects two
    portfolio accounts, which requires two separate transactions, the
    correlation delta on both sides should cancel out. */
    correlation?: IxcRaglV1DeltaCorrelation;
    /* The number of units of the asset being affected. Positive numbers are
    Debits or debit-equivalents in non-cash assets. */
    // format: decimal
    amount: string;
    /* If true, this delta is a reversal of a delta in a previous transaction
    which is now in status REVERSED */
    isReverse?: boolean;
}

export interface IxcRaglV1DeltaCorrelation {
    // format: id62
    otherTransactionId: string;
    // format: id62
    otherBrokerageAccountId?: string;
}

export interface IxcRaglV1DeltaBlotter {
    // format: id62
    transactionId: string;
    // format: INT32
    deltaSeq?: number;
    // format: date-time
    effectiveAt: string;
    // format: decimal
    amount: string;
    asset?: IxcAssetsV1AssetState;
    /* The extended details causing the transaction */
    detail?: IxcRaglV1TransactionDetail;
    isReverse?: boolean;
    // format: custom - pattern: ^[a-z0-9-]+(:[a-z0-9-]+)*$
    accountCode: string;
    brokerageAccount?: IxcRaglV1BrokerageAccount;
}

export interface IxcRaglV1ManualEntryData {
    /* The transaction generated by this manual entry */
    // format: id62, entity: ixc.ragl.v1.Transaction
    transactionId: string;
    reversedDetails?: IxcRaglV1ReversedDetails;
    // format: date-time
    effectiveAt: string;
    description: string;
    /* The assets involved in the manual entry */
    assets: IxcRaglV1TransactionAsset[];
}

export interface IxcRaglV1ManualEntryEvent extends IxcRaglV1ManualEntryKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcRaglV1ManualEntryEventType;
}

export type IxcRaglV1ManualEntryEventType = {
    '!type'?: 'posted';
    posted: IxcRaglV1ManualEntryEventTypePosted;
} | {
    '!type'?: 'reversed';
    reversed: IxcRaglV1ManualEntryEventTypeReversed;
};

export interface IxcRaglV1ManualEntryEventTypePosted {
    // format: date-time
    effectiveAt: string;
    description: string;
    /* The assets involved in the manual entry */
    assets: IxcRaglV1TransactionAsset[];
}

export interface IxcRaglV1ManualEntryEventTypeReversed {
    /* when the event was posted */
    // format: date-time
    reversePostedTimestamp: string;
    /* effective timestamp of reversal */
    // format: date-time
    effectiveAt: string;
    /* transaction ID of the txn that reverses the manual entry */
    // format: id62
    transactionId: string;
    reason?: string;
}

export const IXC_RAGL_V1_MANUAL_ENTRY_EVENT_TYPE_ONE_OF_VALUES = ['posted', 'reversed'] as const;

export type IxcRaglV1ManualEntryEventTypeOneOfValue = (typeof IXC_RAGL_V1_MANUAL_ENTRY_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcRaglV1ManualEntryInput {
    // format: date-time
    effectiveAt: string;
    description: string;
    assets: IxcRaglV1TransactionAssetInput[];
}

export interface IxcRaglV1ManualEntryKeys {
    // format: id62
    entryId: string;
}

export interface IxcRaglV1ManualEntryQueryServiceManualEntryEventsManualEntryEventsRequest {
    // format: id62
    entryId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcRaglV1ManualEntryQueryServiceManualEntryEventsSearchableFields, IxcRaglV1ManualEntryQueryServiceManualEntryEventsSortableFields, IxcRaglV1ManualEntryQueryServiceManualEntryEventsFilterableFields>;
}

export enum IxcRaglV1ManualEntryQueryServiceManualEntryEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EntryId = 'entryId',
    EventPostedEffectiveAt = 'event.posted.effectiveAt',
    EventPostedAssetsAssetAssetId = 'event.posted.assets.asset.assetId',
    EventPostedAssetsAssetDataTypeEquityCusip = 'event.posted.assets.asset.data.type.equity.cusip',
    EventPostedAssetsAssetDataTypeEquityControlsCanBuy = 'event.posted.assets.asset.data.type.equity.controls.canBuy',
    EventPostedAssetsAssetDataTypeEquityControlsCanSell = 'event.posted.assets.asset.data.type.equity.controls.canSell',
    EventPostedAssetsAssetDataTypeEquityControlsCanEnterFractions = 'event.posted.assets.asset.data.type.equity.controls.canEnterFractions',
    EventPostedAssetsAssetDataTypeMoneyMarketCusip = 'event.posted.assets.asset.data.type.moneyMarket.cusip',
    EventPostedAssetsAssetDataTypeMoneyMarketControlsCanBuy = 'event.posted.assets.asset.data.type.moneyMarket.controls.canBuy',
    EventPostedAssetsAssetDataTypeMoneyMarketControlsCanSell = 'event.posted.assets.asset.data.type.moneyMarket.controls.canSell',
    EventPostedAssetsAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.posted.assets.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventPostedAssetsAssetDataTypeMoneyMarketClassification = 'event.posted.assets.asset.data.type.moneyMarket.classification',
    EventPostedAssetsAssetDataTypeMoneyMarketNavType = 'event.posted.assets.asset.data.type.moneyMarket.navType',
    EventPostedAssetsAssetDataTypeType = 'event.posted.assets.asset.data.type.!type',
    EventPostedAssetsAssetDataCategory = 'event.posted.assets.asset.data.category',
    EventPostedAssetsAssetStatus = 'event.posted.assets.asset.status',
    EventType = 'event.!type'
}

export enum IxcRaglV1ManualEntryQueryServiceManualEntryEventsSearchableFields {
    EventPostedAssetsAssetDataTypeEquitySymbolBase = 'event.posted.assets.asset.data.type.equity.symbol.base',
    EventPostedAssetsAssetDataTypeEquityName = 'event.posted.assets.asset.data.type.equity.name',
    EventPostedAssetsAssetDataTypeMoneyMarketSymbolBase = 'event.posted.assets.asset.data.type.moneyMarket.symbol.base',
    EventPostedAssetsAssetDataTypeMoneyMarketName = 'event.posted.assets.asset.data.type.moneyMarket.name'
}

export enum IxcRaglV1ManualEntryQueryServiceManualEntryEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventPostedEffectiveAt = 'event.posted.effectiveAt'
}

export interface IxcRaglV1ManualEntryQueryServiceManualEntryGetManualEntryGetRequest {
    // format: id62
    entryId: string;
}

export interface IxcRaglV1ManualEntryQueryServiceManualEntryListManualEntryListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcRaglV1ManualEntryQueryServiceManualEntryListSearchableFields, IxcRaglV1ManualEntryQueryServiceManualEntryListSortableFields, IxcRaglV1ManualEntryQueryServiceManualEntryListFilterableFields>;
}

export enum IxcRaglV1ManualEntryQueryServiceManualEntryListFilterableFields {
    EntryId = 'entryId',
    DataEffectiveAt = 'data.effectiveAt',
    DataAssetsAssetAssetId = 'data.assets.asset.assetId',
    DataAssetsAssetDataTypeEquityCusip = 'data.assets.asset.data.type.equity.cusip',
    DataAssetsAssetDataTypeEquityControlsCanBuy = 'data.assets.asset.data.type.equity.controls.canBuy',
    DataAssetsAssetDataTypeEquityControlsCanSell = 'data.assets.asset.data.type.equity.controls.canSell',
    DataAssetsAssetDataTypeEquityControlsCanEnterFractions = 'data.assets.asset.data.type.equity.controls.canEnterFractions',
    DataAssetsAssetDataTypeMoneyMarketCusip = 'data.assets.asset.data.type.moneyMarket.cusip',
    DataAssetsAssetDataTypeMoneyMarketControlsCanBuy = 'data.assets.asset.data.type.moneyMarket.controls.canBuy',
    DataAssetsAssetDataTypeMoneyMarketControlsCanSell = 'data.assets.asset.data.type.moneyMarket.controls.canSell',
    DataAssetsAssetDataTypeMoneyMarketControlsCanEnterFractions = 'data.assets.asset.data.type.moneyMarket.controls.canEnterFractions',
    DataAssetsAssetDataTypeMoneyMarketClassification = 'data.assets.asset.data.type.moneyMarket.classification',
    DataAssetsAssetDataTypeMoneyMarketNavType = 'data.assets.asset.data.type.moneyMarket.navType',
    DataAssetsAssetDataTypeType = 'data.assets.asset.data.type.!type',
    DataAssetsAssetDataCategory = 'data.assets.asset.data.category',
    DataAssetsAssetStatus = 'data.assets.asset.status',
    Status = 'status'
}

export enum IxcRaglV1ManualEntryQueryServiceManualEntryListSearchableFields {
    DataAssetsAssetDataTypeEquitySymbolBase = 'data.assets.asset.data.type.equity.symbol.base',
    DataAssetsAssetDataTypeEquityName = 'data.assets.asset.data.type.equity.name',
    DataAssetsAssetDataTypeMoneyMarketSymbolBase = 'data.assets.asset.data.type.moneyMarket.symbol.base',
    DataAssetsAssetDataTypeMoneyMarketName = 'data.assets.asset.data.type.moneyMarket.name'
}

export enum IxcRaglV1ManualEntryQueryServiceManualEntryListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataEffectiveAt = 'data.effectiveAt'
}

export interface IxcRaglV1ManualEntryState extends IxcRaglV1ManualEntryKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcRaglV1ManualEntryData;
    status: IxcRaglV1ManualEntryStatus;
}

export enum IxcRaglV1ManualEntryStatus {
    Unspecified = 'UNSPECIFIED',
    Posted = 'POSTED',
    Reversed = 'REVERSED'
}

export interface IxcRaglV1ManualTransaction {
    /* The ID of the manual entry */
    // format: id62, entity: ixc.ragl.v1.ManualEntry
    entryId: string;
    description?: string;
}

export interface IxcRaglV1NamedBalance {
    // format: custom - pattern: ^[a-z0-9-]+(:[a-z0-9-]+)*$
    accountCode?: string;
    label?: string;
    // format: decimal
    balance?: string;
}

export interface IxcRaglV1PortfolioBalance {
    // format: decimal
    settled: string;
    // format: decimal
    pending: string;
    // format: decimal
    sweep: string;
}

export interface IxcRaglV1PortfolioLink {
    /* Identifies the brokerage account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    /* The unique identifier of the corresponding transaction in the portfolio */
    // format: id62
    transactionId?: string;
    event?: IxcRaglV1PortfolioLinkPortfolioEvent;
}

export enum IxcRaglV1PortfolioLinkPortfolioEvent {
    Unspecified = 'UNSPECIFIED',
    Slated = 'SLATED',
    Settled = 'SETTLED',
    Posted = 'POSTED'
}

export type IxcRaglV1RegistrationType = {
    '!type'?: 'registration';
    registration: IxcRegistrationV1RegistrationType;
} | {
    '!type'?: 'platform';
    platform: IxcRegistrationV1ExemptPayeeCode;
};

export const IXC_RAGL_V1_REGISTRATION_TYPE_ONE_OF_VALUES = ['registration', 'platform'] as const;

export type IxcRaglV1RegistrationTypeOneOfValue = (typeof IXC_RAGL_V1_REGISTRATION_TYPE_ONE_OF_VALUES)[number];

export interface IxcRaglV1ReportsServiceCashBlotterCashBlotterRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcRaglV1ReportsServiceCashBlotterSearchableFields, IxcRaglV1ReportsServiceCashBlotterSortableFields, IxcRaglV1ReportsServiceCashBlotterFilterableFields>;
}

export enum IxcRaglV1ReportsServiceCashBlotterFilterableFields {
    TransactionId = 'transactionId',
    EffectiveAt = 'effectiveAt',
    AssetAssetId = 'asset.assetId',
    AssetDataTypeEquityCusip = 'asset.data.type.equity.cusip',
    AssetDataTypeEquityControlsCanBuy = 'asset.data.type.equity.controls.canBuy',
    AssetDataTypeEquityControlsCanSell = 'asset.data.type.equity.controls.canSell',
    AssetDataTypeEquityControlsCanEnterFractions = 'asset.data.type.equity.controls.canEnterFractions',
    AssetDataTypeMoneyMarketCusip = 'asset.data.type.moneyMarket.cusip',
    AssetDataTypeMoneyMarketControlsCanBuy = 'asset.data.type.moneyMarket.controls.canBuy',
    AssetDataTypeMoneyMarketControlsCanSell = 'asset.data.type.moneyMarket.controls.canSell',
    AssetDataTypeMoneyMarketControlsCanEnterFractions = 'asset.data.type.moneyMarket.controls.canEnterFractions',
    AssetDataTypeMoneyMarketClassification = 'asset.data.type.moneyMarket.classification',
    AssetDataTypeMoneyMarketNavType = 'asset.data.type.moneyMarket.navType',
    AssetDataTypeType = 'asset.data.type.!type',
    AssetDataCategory = 'asset.data.category',
    AssetStatus = 'asset.status',
    AccountCode = 'accountCode',
    BrokerageAccountAccountId = 'brokerageAccount.accountId',
    BrokerageAccountProgramId = 'brokerageAccount.programId',
    BrokerageAccountProgramCode = 'brokerageAccount.programCode',
    BrokerageAccountStatus = 'brokerageAccount.status',
    BrokerageAccountAccountingGroup = 'brokerageAccount.accountingGroup',
    BrokerageAccountPurpose = 'brokerageAccount.purpose',
    BrokerageAccountSweepPlanId = 'brokerageAccount.sweepPlanId'
}

export enum IxcRaglV1ReportsServiceCashBlotterSearchableFields {
    AssetDataTypeEquitySymbolBase = 'asset.data.type.equity.symbol.base',
    AssetDataTypeEquityName = 'asset.data.type.equity.name',
    AssetDataTypeMoneyMarketSymbolBase = 'asset.data.type.moneyMarket.symbol.base',
    AssetDataTypeMoneyMarketName = 'asset.data.type.moneyMarket.name',
    BrokerageAccountDisplayId = 'brokerageAccount.displayId'
}

export enum IxcRaglV1ReportsServiceCashBlotterSortableFields {
    EffectiveAt = 'effectiveAt',
    AssetMetadataCreatedAt = 'asset.metadata.createdAt',
    AssetMetadataUpdatedAt = 'asset.metadata.updatedAt'
}

export interface IxcRaglV1ReportsServiceClearingCashBalancesClearingCashBalancesRequest {
    asOf?: IxcRaglV1DateOrTime;
}

export interface IxcRaglV1ReportsServiceCustomerCashBalanceCustomerCashBalanceRequest {
    asOf?: IxcRaglV1DateOrTime;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcRaglV1ReportsServiceCustomerCashBalanceSearchableFields, never, IxcRaglV1ReportsServiceCustomerCashBalanceFilterableFields>;
}

export enum IxcRaglV1ReportsServiceCustomerCashBalanceFilterableFields {
    AccountAccountId = 'account.accountId',
    AccountProgramId = 'account.programId',
    AccountProgramCode = 'account.programCode',
    AccountStatus = 'account.status',
    AccountAccountingGroup = 'account.accountingGroup',
    AccountPurpose = 'account.purpose',
    AccountSweepPlanId = 'account.sweepPlanId'
}

export enum IxcRaglV1ReportsServiceCustomerCashBalanceSearchableFields {
    AccountDisplayId = 'account.displayId'
}

export interface IxcRaglV1ReportsServiceCustomerStockRecordCustomerStockRecordRequest {
    // format: id62
    assetId?: string;
    asOf?: IxcRaglV1DateOrTime;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcRaglV1ReportsServiceCustomerStockRecordSearchableFields, IxcRaglV1ReportsServiceCustomerStockRecordSortableFields, IxcRaglV1ReportsServiceCustomerStockRecordFilterableFields>;
}

export enum IxcRaglV1ReportsServiceCustomerStockRecordFilterableFields {
    AccountAccountId = 'account.accountId',
    AccountProgramId = 'account.programId',
    AccountProgramCode = 'account.programCode',
    AccountStatus = 'account.status',
    AccountAccountingGroup = 'account.accountingGroup',
    AccountPurpose = 'account.purpose',
    AccountSweepPlanId = 'account.sweepPlanId',
    AssetAssetId = 'asset.assetId',
    AssetDataTypeEquityCusip = 'asset.data.type.equity.cusip',
    AssetDataTypeEquityControlsCanBuy = 'asset.data.type.equity.controls.canBuy',
    AssetDataTypeEquityControlsCanSell = 'asset.data.type.equity.controls.canSell',
    AssetDataTypeEquityControlsCanEnterFractions = 'asset.data.type.equity.controls.canEnterFractions',
    AssetDataTypeMoneyMarketCusip = 'asset.data.type.moneyMarket.cusip',
    AssetDataTypeMoneyMarketControlsCanBuy = 'asset.data.type.moneyMarket.controls.canBuy',
    AssetDataTypeMoneyMarketControlsCanSell = 'asset.data.type.moneyMarket.controls.canSell',
    AssetDataTypeMoneyMarketControlsCanEnterFractions = 'asset.data.type.moneyMarket.controls.canEnterFractions',
    AssetDataTypeMoneyMarketClassification = 'asset.data.type.moneyMarket.classification',
    AssetDataTypeMoneyMarketNavType = 'asset.data.type.moneyMarket.navType',
    AssetDataTypeType = 'asset.data.type.!type',
    AssetDataCategory = 'asset.data.category',
    AssetStatus = 'asset.status'
}

export enum IxcRaglV1ReportsServiceCustomerStockRecordSearchableFields {
    AccountDisplayId = 'account.displayId',
    AssetDataTypeEquitySymbolBase = 'asset.data.type.equity.symbol.base',
    AssetDataTypeEquityName = 'asset.data.type.equity.name',
    AssetDataTypeMoneyMarketSymbolBase = 'asset.data.type.moneyMarket.symbol.base',
    AssetDataTypeMoneyMarketName = 'asset.data.type.moneyMarket.name'
}

export enum IxcRaglV1ReportsServiceCustomerStockRecordSortableFields {
    AssetMetadataCreatedAt = 'asset.metadata.createdAt',
    AssetMetadataUpdatedAt = 'asset.metadata.updatedAt'
}

export interface IxcRaglV1ReportsServiceCustomerSweepRecordCustomerSweepRecordRequest {
    // format: id62
    assetId?: string;
    asOf?: IxcRaglV1DateOrTime;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcRaglV1ReportsServiceCustomerSweepRecordSearchableFields, IxcRaglV1ReportsServiceCustomerSweepRecordSortableFields, IxcRaglV1ReportsServiceCustomerSweepRecordFilterableFields>;
}

export enum IxcRaglV1ReportsServiceCustomerSweepRecordFilterableFields {
    AccountAccountId = 'account.accountId',
    AccountProgramId = 'account.programId',
    AccountProgramCode = 'account.programCode',
    AccountStatus = 'account.status',
    AccountAccountingGroup = 'account.accountingGroup',
    AccountPurpose = 'account.purpose',
    AccountSweepPlanId = 'account.sweepPlanId',
    AssetAssetId = 'asset.assetId',
    AssetDataTypeEquityCusip = 'asset.data.type.equity.cusip',
    AssetDataTypeEquityControlsCanBuy = 'asset.data.type.equity.controls.canBuy',
    AssetDataTypeEquityControlsCanSell = 'asset.data.type.equity.controls.canSell',
    AssetDataTypeEquityControlsCanEnterFractions = 'asset.data.type.equity.controls.canEnterFractions',
    AssetDataTypeMoneyMarketCusip = 'asset.data.type.moneyMarket.cusip',
    AssetDataTypeMoneyMarketControlsCanBuy = 'asset.data.type.moneyMarket.controls.canBuy',
    AssetDataTypeMoneyMarketControlsCanSell = 'asset.data.type.moneyMarket.controls.canSell',
    AssetDataTypeMoneyMarketControlsCanEnterFractions = 'asset.data.type.moneyMarket.controls.canEnterFractions',
    AssetDataTypeMoneyMarketClassification = 'asset.data.type.moneyMarket.classification',
    AssetDataTypeMoneyMarketNavType = 'asset.data.type.moneyMarket.navType',
    AssetDataTypeType = 'asset.data.type.!type',
    AssetDataCategory = 'asset.data.category',
    AssetStatus = 'asset.status'
}

export enum IxcRaglV1ReportsServiceCustomerSweepRecordSearchableFields {
    AccountDisplayId = 'account.displayId',
    AssetDataTypeEquitySymbolBase = 'asset.data.type.equity.symbol.base',
    AssetDataTypeEquityName = 'asset.data.type.equity.name',
    AssetDataTypeMoneyMarketSymbolBase = 'asset.data.type.moneyMarket.symbol.base',
    AssetDataTypeMoneyMarketName = 'asset.data.type.moneyMarket.name'
}

export enum IxcRaglV1ReportsServiceCustomerSweepRecordSortableFields {
    AssetMetadataCreatedAt = 'asset.metadata.createdAt',
    AssetMetadataUpdatedAt = 'asset.metadata.updatedAt'
}

export interface IxcRaglV1ReportsServiceStockBlotterStockBlotterRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcRaglV1ReportsServiceStockBlotterSearchableFields, IxcRaglV1ReportsServiceStockBlotterSortableFields, IxcRaglV1ReportsServiceStockBlotterFilterableFields>;
}

export enum IxcRaglV1ReportsServiceStockBlotterFilterableFields {
    TransactionId = 'transactionId',
    EffectiveAt = 'effectiveAt',
    AssetAssetId = 'asset.assetId',
    AssetDataTypeEquityCusip = 'asset.data.type.equity.cusip',
    AssetDataTypeEquityControlsCanBuy = 'asset.data.type.equity.controls.canBuy',
    AssetDataTypeEquityControlsCanSell = 'asset.data.type.equity.controls.canSell',
    AssetDataTypeEquityControlsCanEnterFractions = 'asset.data.type.equity.controls.canEnterFractions',
    AssetDataTypeMoneyMarketCusip = 'asset.data.type.moneyMarket.cusip',
    AssetDataTypeMoneyMarketControlsCanBuy = 'asset.data.type.moneyMarket.controls.canBuy',
    AssetDataTypeMoneyMarketControlsCanSell = 'asset.data.type.moneyMarket.controls.canSell',
    AssetDataTypeMoneyMarketControlsCanEnterFractions = 'asset.data.type.moneyMarket.controls.canEnterFractions',
    AssetDataTypeMoneyMarketClassification = 'asset.data.type.moneyMarket.classification',
    AssetDataTypeMoneyMarketNavType = 'asset.data.type.moneyMarket.navType',
    AssetDataTypeType = 'asset.data.type.!type',
    AssetDataCategory = 'asset.data.category',
    AssetStatus = 'asset.status',
    AccountCode = 'accountCode',
    BrokerageAccountAccountId = 'brokerageAccount.accountId',
    BrokerageAccountProgramId = 'brokerageAccount.programId',
    BrokerageAccountProgramCode = 'brokerageAccount.programCode',
    BrokerageAccountStatus = 'brokerageAccount.status',
    BrokerageAccountAccountingGroup = 'brokerageAccount.accountingGroup',
    BrokerageAccountPurpose = 'brokerageAccount.purpose',
    BrokerageAccountSweepPlanId = 'brokerageAccount.sweepPlanId'
}

export enum IxcRaglV1ReportsServiceStockBlotterSearchableFields {
    AssetDataTypeEquitySymbolBase = 'asset.data.type.equity.symbol.base',
    AssetDataTypeEquityName = 'asset.data.type.equity.name',
    AssetDataTypeMoneyMarketSymbolBase = 'asset.data.type.moneyMarket.symbol.base',
    AssetDataTypeMoneyMarketName = 'asset.data.type.moneyMarket.name',
    BrokerageAccountDisplayId = 'brokerageAccount.displayId'
}

export enum IxcRaglV1ReportsServiceStockBlotterSortableFields {
    EffectiveAt = 'effectiveAt',
    AssetMetadataCreatedAt = 'asset.metadata.createdAt',
    AssetMetadataUpdatedAt = 'asset.metadata.updatedAt'
}

export interface IxcRaglV1ReportsServiceStockRecordStockRecordRequest {
    asOf?: IxcRaglV1DateOrTime;
}

export interface IxcRaglV1ReversedDetails {
    /* when the event was posted */
    // format: date-time
    reversePostedTimestamp: string;
    /* effective date of reversal */
    // format: date-time
    effectiveAt: string;
    /* The transaction generated by the reversal */
    // format: id62, entity: ixc.ragl.v1.Transaction
    transactionId: string;
    reason?: string;
}

export interface IxcRaglV1ReverseLink {
    /* The unique identifier of the transaction which reverses this one */
    // format: id62
    transactionId?: string;
    /* The reason for the reversal */
    reason?: string;
}

export interface IxcRaglV1AccountCodesResponseAccountCodes {
    /* The code used to identify the account */
    // format: custom - pattern: ^[a-z0-9-]+(:[a-z0-9-]+)*$
    code?: string;
    label?: string;
    /* Allowed for Manual entry */
    manual?: boolean;
    /* Allowed for System entry */
    system?: boolean;
    /* Deprecated codes should not be used for new entries */
    deprecated?: boolean;
}

export interface IxcRaglV1StockRecord {
    rows?: IxcRaglV1StockRecordRow[];
}

export interface IxcRaglV1StockRecordRow {
    asset: IxcAssetsV1AssetState;
    /* deprecated, use asset.assetId instead */
    // format: id62
    assetId: string;
    /* deprecated, use asset details */
    cusip?: string;
    /* deprecated, use asset details */
    symbol?: string;
    /* deprecated, use asset details */
    name?: string;
    // format: decimal
    tradeInitial: string;
    // format: decimal
    tradeCns: string;
    // format: decimal
    failToReceive: string;
    // format: decimal
    failToDeliver: string;
    // format: decimal
    dtcSettled: string;
    /* Shares held in the JPMAM omnibus account. The street side for money
    market funds, as DTC is for equities. */
    // format: decimal
    omnibus: string;
    customer: IxcRaglV1PortfolioBalance;
    nonCustomer: IxcRaglV1PortfolioBalance;
    pab: IxcRaglV1PortfolioBalance;
    inventory: IxcRaglV1PortfolioBalance;
    suspense: IxcRaglV1StockRecordRowSuspense;
    wash: IxcRaglV1StockRecordRowWash;
}

export interface IxcRaglV1StockRecordRowSuspense {
    // format: decimal
    total: string;
    accounts?: IxcRaglV1NamedBalance[];
}

export interface IxcRaglV1StockRecordRowWash {
    // format: decimal
    total: string;
    accounts?: IxcRaglV1NamedBalance[];
}

export interface IxcRaglV1TransactionAsset {
    /* A record of asset information at the time the transaction was entered.
    This is not updated when, e.g. company names or symbols change. */
    asset?: IxcAssetsV1AssetState;
    /* If true, this delta is in the home currency of the account */
    isHomeCurrency?: boolean;
    deltas?: IxcRaglV1Delta[];
}

export interface IxcRaglV1TransactionAssetInput {
    // format: id62
    assetId: string;
    deltas?: IxcRaglV1TransactionDeltaInput[];
}

export interface IxcRaglV1TransactionData {
    /* The changes in the account balance caused by the transaction */
    assets: IxcRaglV1TransactionAsset[];
    /* The date and time the transaction is effective. These will always be in
    the past, future-dated transactions use the slated -> settled flow. */
    // format: date-time
    effectiveAt: string;
    /* The extended details causing the transaction */
    detail?: IxcRaglV1TransactionDetail;
    /* The extended details which remain internal to the clearing firm, not
    visible to correspondents or customers */
    contraDetail?: any;
    /* This transaction reverses another transaction. In cases where the
    reversal is just a cancel, the deltas in this transaction will all be
    marked as `isReverse`
    In cases where the reversal is a correction, the same reversal deltas
    will be present plus a set of corrected deltas, i.e. the deltas will not
    be netted or combined.
    Corrections may further be corrected, leading to a chain of transactions
    which are all reversals of each other. */
    reverses?: IxcRaglV1ReverseLink;
    /* The unique identifier of the transaction which settles this one */
    // format: id62
    settledByTransactionId?: string;
    /* When transaction is in REVERSED status, this field shows basic
    information about the transaction which corrects or replaces it. */
    reversedBy?: IxcRaglV1ReverseLink;
    portfolio?: IxcRaglV1PortfolioLink;
}

export interface IxcRaglV1TransactionDeltaInput {
    // format: custom - pattern: ^[a-z0-9-]+(:[a-z0-9-]+)*$
    accountCode: string;
    /* The number of units of the asset being affected. Positive numbers are
    Debits or debit-equivalents in non-cash assets. */
    // format: decimal
    amount: string;
}

export type IxcRaglV1TransactionDetail = {
    '!type': 'ixc.trade.v1.NettingIndicationTransaction';
    value: IxcTradeV1NettingIndicationTransaction;
} | {
    '!type': 'ixc.sweeps.clearing.v1.SweepsTransaction';
    value: IxcSweepsClearingV1SweepsTransaction;
} | {
    '!type': 'exc.jpmam.v1.MoneyMarketTransaction';
    value: ExcJpmamV1MoneyMarketTransaction;
} | {
    '!type': 'ixc.ragl.v1.ManualTransaction';
    value: IxcRaglV1ManualTransaction;
} | {
    '!type': 'ixc.inventory.v1.SettleTradingDayTransaction';
    value: IxcInventoryV1SettleTradingDayTransaction;
} | {
    '!type': 'ixc.inventory.v1.CloseTradingDayTransaction';
    value: IxcInventoryV1CloseTradingDayTransaction;
} | {
    '!type': 'ixc.inventory.v1.InventoryTradeTransaction';
    value: IxcInventoryV1InventoryTradeTransaction;
} | {
    '!type': 'ixc.dtcc.cns.v1.SettlementTransaction';
    value: IxcDtccCnsV1SettlementTransaction;
} | {
    '!type': 'ixc.corpactions.caadmin.v1.DTCPaymentTransaction';
    value: IxcCorpactionsCaadminV1DtcPaymentTransaction;
} | {
    '!type': 'ixc.orders.v1.TradeTransaction';
    value: IxcOrdersV1TradeTransaction;
} | {
    '!type': 'ixc.orders.v1.BatchAllocationCustomerTransaction';
    value: IxcOrdersV1BatchAllocationCustomerTransaction;
} | {
    '!type': 'ixc.orders.v1.BatchAllocationAvgPriceTransaction';
    value: IxcOrdersV1BatchAllocationAvgPriceTransaction;
} | {
    '!type': 'ixc.portfolio.v1.DividendPaymentTransaction';
    value: IxcPortfolioV1DividendPaymentTransaction;
} | {
    '!type': 'ixc.funding.v1.FundingTransaction';
    value: IxcFundingV1FundingTransaction;
} | {
    '!type': 'ixc.funding.v1.FundingBatchTransaction';
    value: IxcFundingV1FundingBatchTransaction;
} | {
    '!type': 'ixc.corpactions.v1.CorpactionTransaction';
    value: IxcCorpactionsV1CorpactionTransaction;
} | {
    '!type': 'ixc.orders.v1.BatchRemainderInventoryTransaction';
    value: IxcOrdersV1BatchRemainderInventoryTransaction;
} | {
    '!type': 'ixc.billing.v1.ChargeTransaction';
    value: IxcBillingV1ChargeTransaction;
} | {
    '!type': 'ixc.billing.v1.CustomerChargeTransaction';
    value: IxcBillingV1CustomerChargeTransaction;
} | {
    '!type': 'ixc.mutualfunds.v1.FundTransaction';
    value: IxcMutualfundsV1FundTransaction;
};

export const IXC_RAGL_V1_TRANSACTION_DETAIL_MEMBERS = ['ixc.trade.v1.NettingIndicationTransaction', 'ixc.sweeps.clearing.v1.SweepsTransaction', 'exc.jpmam.v1.MoneyMarketTransaction', 'ixc.ragl.v1.ManualTransaction', 'ixc.inventory.v1.SettleTradingDayTransaction', 'ixc.inventory.v1.CloseTradingDayTransaction', 'ixc.inventory.v1.InventoryTradeTransaction', 'ixc.dtcc.cns.v1.SettlementTransaction', 'ixc.corpactions.caadmin.v1.DTCPaymentTransaction', 'ixc.orders.v1.TradeTransaction', 'ixc.orders.v1.BatchAllocationCustomerTransaction', 'ixc.orders.v1.BatchAllocationAvgPriceTransaction', 'ixc.portfolio.v1.DividendPaymentTransaction', 'ixc.funding.v1.FundingTransaction', 'ixc.funding.v1.FundingBatchTransaction', 'ixc.corpactions.v1.CorpactionTransaction', 'ixc.orders.v1.BatchRemainderInventoryTransaction', 'ixc.billing.v1.ChargeTransaction', 'ixc.billing.v1.CustomerChargeTransaction', 'ixc.mutualfunds.v1.FundTransaction'] as const;

export type IxcRaglV1TransactionDetailMember = (typeof IXC_RAGL_V1_TRANSACTION_DETAIL_MEMBERS)[number];

export interface IxcRaglV1TransactionEvent extends IxcPortfolioV1TransactionKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcRaglV1TransactionEventType;
}

export type IxcRaglV1TransactionEventType = {
    '!type'?: 'posted';
    posted: IxcRaglV1TransactionEventTypePosted;
} | {
    '!type'?: 'portfolioPosted';
    portfolioPosted: IxcRaglV1TransactionEventTypePortfolioPosted;
} | {
    '!type'?: 'portfolioSettled';
    portfolioSettled: IxcRaglV1TransactionEventTypePortfolioSettled;
} | {
    '!type'?: 'reversed';
    reversed: IxcRaglV1TransactionEventTypeReversed;
};

export interface IxcRaglV1TransactionEventTypePortfolioPosted {
    /* The changes in the account balance caused by the transaction */
    assets: IxcRaglV1TransactionAsset[];
    /* The date and time the transaction is effective. These will always be in
    the past, future-dated transactions use the slated -> settled flow. */
    // format: date-time
    effectiveAt: string;
    /* The extended details causing the transaction */
    detail?: IxcRaglV1TransactionDetail;
    /* The extended details which remain internal to the clearing firm, not
    visible to correspondents or customers */
    contraDetail?: any;
    /* This transaction reverses another transaction. In cases where the
    reversal is just a cancel, the deltas in this transaction will all be
    marked as `isReverse`
    In cases where the reversal is a correction, the same reversal deltas
    will be present plus a set of corrected deltas, i.e. the deltas will not
    be netted or combined.
    Corrections may further be corrected, leading to a chain of transactions
    which are all reversals of each other. */
    reverses?: IxcRaglV1ReverseLink;
    portfolio: IxcRaglV1PortfolioLink;
}

export interface IxcRaglV1TransactionEventTypePortfolioSettled {
    /* The unique identifier of the transaction which settles this one */
    // format: id62
    transactionId: string;
    /* The date and time the transaction settles (becomes effectiveAt in the
    settling transaction) */
    // format: date-time
    settleAt: string;
}

export interface IxcRaglV1TransactionEventTypePosted {
    /* The changes in the account balance caused by the transaction */
    assets: IxcRaglV1TransactionAsset[];
    /* The date and time the transaction is effective. These will always be in
    the past, future-dated transactions use the slated -> settled flow. */
    // format: date-time
    effectiveAt: string;
    /* The extended details causing the transaction */
    detail?: IxcRaglV1TransactionDetail;
    /* The extended details which remain internal to the clearing firm, not
    visible to correspondents or customers */
    contraDetail?: any;
    /* This transaction reverses another transaction. In cases where the
    reversal is just a cancel, the deltas in this transaction will all be
    marked as `isReverse`
    In cases where the reversal is a correction, the same reversal deltas
    will be present plus a set of corrected deltas, i.e. the deltas will not
    be netted or combined.
    Corrections may further be corrected, leading to a chain of transactions
    which are all reversals of each other. */
    reverses?: IxcRaglV1ReverseLink;
}

export interface IxcRaglV1TransactionEventTypeReversed {
    /* The unique identifier of the transaction which reverses this one */
    // format: id62
    transactionId: string;
    /* The reason for the reversal */
    reason?: string;
}

export const IXC_RAGL_V1_TRANSACTION_EVENT_TYPE_ONE_OF_VALUES = ['posted', 'portfolioPosted', 'portfolioSettled', 'reversed'] as const;

export type IxcRaglV1TransactionEventTypeOneOfValue = (typeof IXC_RAGL_V1_TRANSACTION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcRaglV1TransactionKeys {
    // format: id62
    transactionId: string;
}

export interface IxcRaglV1TransactionQueryServiceTransactionEventsTransactionEventsRequest {
    // format: id62
    transactionId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcRaglV1TransactionQueryServiceTransactionEventsSearchableFields, IxcRaglV1TransactionQueryServiceTransactionEventsSortableFields, IxcRaglV1TransactionQueryServiceTransactionEventsFilterableFields>;
}

export enum IxcRaglV1TransactionQueryServiceTransactionEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    TransactionId = 'transactionId',
    EventPostedAssetsAssetAssetId = 'event.posted.assets.asset.assetId',
    EventPostedAssetsAssetDataTypeEquityCusip = 'event.posted.assets.asset.data.type.equity.cusip',
    EventPostedAssetsAssetDataTypeEquityControlsCanBuy = 'event.posted.assets.asset.data.type.equity.controls.canBuy',
    EventPostedAssetsAssetDataTypeEquityControlsCanSell = 'event.posted.assets.asset.data.type.equity.controls.canSell',
    EventPostedAssetsAssetDataTypeEquityControlsCanEnterFractions = 'event.posted.assets.asset.data.type.equity.controls.canEnterFractions',
    EventPostedAssetsAssetDataTypeMoneyMarketCusip = 'event.posted.assets.asset.data.type.moneyMarket.cusip',
    EventPostedAssetsAssetDataTypeMoneyMarketControlsCanBuy = 'event.posted.assets.asset.data.type.moneyMarket.controls.canBuy',
    EventPostedAssetsAssetDataTypeMoneyMarketControlsCanSell = 'event.posted.assets.asset.data.type.moneyMarket.controls.canSell',
    EventPostedAssetsAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.posted.assets.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventPostedAssetsAssetDataTypeMoneyMarketClassification = 'event.posted.assets.asset.data.type.moneyMarket.classification',
    EventPostedAssetsAssetDataTypeMoneyMarketNavType = 'event.posted.assets.asset.data.type.moneyMarket.navType',
    EventPostedAssetsAssetDataTypeType = 'event.posted.assets.asset.data.type.!type',
    EventPostedAssetsAssetDataCategory = 'event.posted.assets.asset.data.category',
    EventPostedAssetsAssetStatus = 'event.posted.assets.asset.status',
    EventPostedEffectiveAt = 'event.posted.effectiveAt',
    EventPostedDetailType = 'event.posted.detail.!type',
    EventPortfolioPostedAssetsAssetAssetId = 'event.portfolioPosted.assets.asset.assetId',
    EventPortfolioPostedAssetsAssetDataTypeEquityCusip = 'event.portfolioPosted.assets.asset.data.type.equity.cusip',
    EventPortfolioPostedAssetsAssetDataTypeEquityControlsCanBuy = 'event.portfolioPosted.assets.asset.data.type.equity.controls.canBuy',
    EventPortfolioPostedAssetsAssetDataTypeEquityControlsCanSell = 'event.portfolioPosted.assets.asset.data.type.equity.controls.canSell',
    EventPortfolioPostedAssetsAssetDataTypeEquityControlsCanEnterFractions = 'event.portfolioPosted.assets.asset.data.type.equity.controls.canEnterFractions',
    EventPortfolioPostedAssetsAssetDataTypeMoneyMarketCusip = 'event.portfolioPosted.assets.asset.data.type.moneyMarket.cusip',
    EventPortfolioPostedAssetsAssetDataTypeMoneyMarketControlsCanBuy = 'event.portfolioPosted.assets.asset.data.type.moneyMarket.controls.canBuy',
    EventPortfolioPostedAssetsAssetDataTypeMoneyMarketControlsCanSell = 'event.portfolioPosted.assets.asset.data.type.moneyMarket.controls.canSell',
    EventPortfolioPostedAssetsAssetDataTypeMoneyMarketControlsCanEnterFractions = 'event.portfolioPosted.assets.asset.data.type.moneyMarket.controls.canEnterFractions',
    EventPortfolioPostedAssetsAssetDataTypeMoneyMarketClassification = 'event.portfolioPosted.assets.asset.data.type.moneyMarket.classification',
    EventPortfolioPostedAssetsAssetDataTypeMoneyMarketNavType = 'event.portfolioPosted.assets.asset.data.type.moneyMarket.navType',
    EventPortfolioPostedAssetsAssetDataTypeType = 'event.portfolioPosted.assets.asset.data.type.!type',
    EventPortfolioPostedAssetsAssetDataCategory = 'event.portfolioPosted.assets.asset.data.category',
    EventPortfolioPostedAssetsAssetStatus = 'event.portfolioPosted.assets.asset.status',
    EventPortfolioPostedEffectiveAt = 'event.portfolioPosted.effectiveAt',
    EventPortfolioPostedDetailType = 'event.portfolioPosted.detail.!type',
    EventType = 'event.!type'
}

export enum IxcRaglV1TransactionQueryServiceTransactionEventsSearchableFields {
    EventPostedAssetsAssetDataTypeEquitySymbolBase = 'event.posted.assets.asset.data.type.equity.symbol.base',
    EventPostedAssetsAssetDataTypeEquityName = 'event.posted.assets.asset.data.type.equity.name',
    EventPostedAssetsAssetDataTypeMoneyMarketSymbolBase = 'event.posted.assets.asset.data.type.moneyMarket.symbol.base',
    EventPostedAssetsAssetDataTypeMoneyMarketName = 'event.posted.assets.asset.data.type.moneyMarket.name',
    EventPortfolioPostedAssetsAssetDataTypeEquitySymbolBase = 'event.portfolioPosted.assets.asset.data.type.equity.symbol.base',
    EventPortfolioPostedAssetsAssetDataTypeEquityName = 'event.portfolioPosted.assets.asset.data.type.equity.name',
    EventPortfolioPostedAssetsAssetDataTypeMoneyMarketSymbolBase = 'event.portfolioPosted.assets.asset.data.type.moneyMarket.symbol.base',
    EventPortfolioPostedAssetsAssetDataTypeMoneyMarketName = 'event.portfolioPosted.assets.asset.data.type.moneyMarket.name'
}

export enum IxcRaglV1TransactionQueryServiceTransactionEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventPostedEffectiveAt = 'event.posted.effectiveAt',
    EventPortfolioPostedEffectiveAt = 'event.portfolioPosted.effectiveAt'
}

export interface IxcRaglV1TransactionQueryServiceTransactionGetTransactionGetRequest {
    // format: id62
    transactionId: string;
}

export interface IxcRaglV1TransactionQueryServiceTransactionListTransactionListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcRaglV1TransactionQueryServiceTransactionListSearchableFields, IxcRaglV1TransactionQueryServiceTransactionListSortableFields, IxcRaglV1TransactionQueryServiceTransactionListFilterableFields>;
}

export enum IxcRaglV1TransactionQueryServiceTransactionListFilterableFields {
    TransactionId = 'transactionId',
    DataAssetsAssetAssetId = 'data.assets.asset.assetId',
    DataAssetsAssetDataTypeEquityCusip = 'data.assets.asset.data.type.equity.cusip',
    DataAssetsAssetDataTypeEquityControlsCanBuy = 'data.assets.asset.data.type.equity.controls.canBuy',
    DataAssetsAssetDataTypeEquityControlsCanSell = 'data.assets.asset.data.type.equity.controls.canSell',
    DataAssetsAssetDataTypeEquityControlsCanEnterFractions = 'data.assets.asset.data.type.equity.controls.canEnterFractions',
    DataAssetsAssetDataTypeMoneyMarketCusip = 'data.assets.asset.data.type.moneyMarket.cusip',
    DataAssetsAssetDataTypeMoneyMarketControlsCanBuy = 'data.assets.asset.data.type.moneyMarket.controls.canBuy',
    DataAssetsAssetDataTypeMoneyMarketControlsCanSell = 'data.assets.asset.data.type.moneyMarket.controls.canSell',
    DataAssetsAssetDataTypeMoneyMarketControlsCanEnterFractions = 'data.assets.asset.data.type.moneyMarket.controls.canEnterFractions',
    DataAssetsAssetDataTypeMoneyMarketClassification = 'data.assets.asset.data.type.moneyMarket.classification',
    DataAssetsAssetDataTypeMoneyMarketNavType = 'data.assets.asset.data.type.moneyMarket.navType',
    DataAssetsAssetDataTypeType = 'data.assets.asset.data.type.!type',
    DataAssetsAssetDataCategory = 'data.assets.asset.data.category',
    DataAssetsAssetStatus = 'data.assets.asset.status',
    DataEffectiveAt = 'data.effectiveAt',
    DataDetailType = 'data.detail.!type',
    Status = 'status'
}

export enum IxcRaglV1TransactionQueryServiceTransactionListSearchableFields {
    DataAssetsAssetDataTypeEquitySymbolBase = 'data.assets.asset.data.type.equity.symbol.base',
    DataAssetsAssetDataTypeEquityName = 'data.assets.asset.data.type.equity.name',
    DataAssetsAssetDataTypeMoneyMarketSymbolBase = 'data.assets.asset.data.type.moneyMarket.symbol.base',
    DataAssetsAssetDataTypeMoneyMarketName = 'data.assets.asset.data.type.moneyMarket.name'
}

export enum IxcRaglV1TransactionQueryServiceTransactionListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataEffectiveAt = 'data.effectiveAt'
}

export interface IxcRaglV1TransactionState extends IxcRaglV1TransactionKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcRaglV1TransactionData;
    status: IxcRaglV1TransactionStatus;
}

export enum IxcRaglV1TransactionStatus {
    Unspecified = 'UNSPECIFIED',
    Posted = 'POSTED',
    Reversed = 'REVERSED'
}

export interface IxcRegistrationV1AccountBeneficiaries {
    /* Percentages of all beneficiaries must sum to 100. */
    primary: IxcRegistrationV1Beneficiary[];
    /* Percentages of all beneficiaries must sum to 100. */
    contingent?: IxcRegistrationV1Beneficiary[];
}

export interface IxcRegistrationV1AccountCheck {
    // format: id62
    checkId: string;
    checkType: IxcRegistrationV1AccountCheckType;
}

export type IxcRegistrationV1AccountCheckType = {
    '!type'?: 'clearingManualApproval';
    /* Manual Interchange review */
    clearingManualApproval: IxcRegistrationV1AccountCheckTypeClearingManualApproval;
} | {
    '!type'?: 'clearingAutomatedApproval';
    /* Automated Interchange approval system */
    clearingAutomatedApproval: IxcRegistrationV1AccountCheckTypeClearingAutomatedApproval;
} | {
    '!type'?: 'programApproval';
    /* Broker-Dealer approval process */
    programApproval: IxcRegistrationV1AccountCheckTypeProgramApproval;
};

export interface IxcRegistrationV1AccountCheckTypeClearingAutomatedApproval {
    evidence?: IxcRegistrationV1ClearingAutomatedApprovalEvidence;
}

export interface IxcRegistrationV1AccountCheckTypeClearingManualApproval {
    evidence?: IxcRegistrationV1ClearingManualApprovalEvidence;
}

export interface IxcRegistrationV1AccountCheckTypeProgramApproval {
    evidence?: IxcRegistrationV1ProgramApprovalEvidence;
}

export const IXC_REGISTRATION_V1_ACCOUNT_CHECK_TYPE_ONE_OF_VALUES = ['clearingManualApproval', 'clearingAutomatedApproval', 'programApproval'] as const;

export type IxcRegistrationV1AccountCheckTypeOneOfValue = (typeof IXC_REGISTRATION_V1_ACCOUNT_CHECK_TYPE_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1AccountData {
    // pattern: ^[A-Z]{4}[0-9]{9}$
    displayId: string;
    spec?: IxcRegistrationV1PurposeSpec;
    accountingGroup: IxcRegistrationV1AccountingGroup;
    /* What the account is used for. List queries default to `CUSTOMER`; filter
    explicitly on another value to find a program's platform accounts, such
    as the `AVERAGE_PRICE` account a batch order is placed on. */
    purpose: IxcRegistrationV1Purpose;
    controls?: IxcRegistrationV1ProgramControls;
    /* Controls on the account the clearing firm implemented. */
    clearingControls: IxcRegistrationV1ClearingAccountControls;
}

export interface IxcRegistrationV1AccountEnrichedSummary {
    keys: IxcRegistrationV1AccountSummaryKeys;
    status: IxcRegistrationV1SummaryStatus;
    accountingGroup: IxcRegistrationV1AccountingGroup;
    purpose: IxcRegistrationV1Purpose;
    controls?: IxcRegistrationV1ProgramControls;
    platformControls?: IxcRegistrationV1PlatformControls;
    // pattern: ^[A-Z]{4}[0-9]{9}$
    displayId: string;
    name: string;
    email?: string;
    phone?: IxcRegistrationV1Phone[];
    physicalAddress: IxcRegistrationV1Address;
    mailingAddress?: IxcRegistrationV1Address;
    /* Which kind of tax identifier taxId holds. */
    taxIdType: IxcRegistrationV1TaxIdType;
    taxId: string;
    summary?: IxcRegistrationV1PurposeSummary;
}

export interface IxcRegistrationV1AccountEvent extends IxcRegistrationV1AccountKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcRegistrationV1AccountEventType;
}

export type IxcRegistrationV1AccountEventType = {
    '!type'?: 'created';
    created: IxcRegistrationV1AccountEventTypeCreated;
} | {
    '!type'?: 'platformed';
    platformed: IxcRegistrationV1AccountEventTypePlatformed;
} | {
    '!type'?: 'specialPurposeCreated';
    specialPurposeCreated: IxcRegistrationV1AccountEventTypeSpecialPurposeCreated;
} | {
    '!type'?: 'profileUpdated';
    profileUpdated: IxcRegistrationV1AccountEventTypeProfileUpdated;
} | {
    '!type'?: 'checkResult';
    checkResult: IxcRegistrationV1AccountEventTypeCheckResult;
} | {
    '!type'?: 'clearingCheckResult';
    clearingCheckResult: IxcRegistrationV1AccountEventTypeClearingCheckResult;
} | {
    '!type'?: 'checksPassed';
    checksPassed: EmptyObject;
} | {
    '!type'?: 'accountUpdated';
    accountUpdated: IxcRegistrationV1AccountEventTypeAccountUpdated;
} | {
    '!type'?: 'clearingAccountUpdated';
    clearingAccountUpdated: IxcRegistrationV1AccountEventTypeClearingAccountUpdated;
} | {
    '!type'?: 'platformUpdated';
    platformUpdated: IxcRegistrationV1AccountEventTypePlatformUpdated;
} | {
    '!type'?: 'clearingPlatformUpdated';
    clearingPlatformUpdated: IxcRegistrationV1AccountEventTypeClearingPlatformUpdated;
};

export interface IxcRegistrationV1AccountEventTypeAccountUpdated {
    update: IxcRegistrationV1AccountUpdate;
}

export interface IxcRegistrationV1AccountEventTypeCheckResult {
    // format: id62
    checkId: string;
    evidence: IxcRegistrationV1AccountEvidence;
}

export interface IxcRegistrationV1AccountEventTypeClearingAccountUpdated {
    update: IxcRegistrationV1ClearingAccountUpdate;
}

export interface IxcRegistrationV1AccountEventTypeClearingCheckResult {
    // format: id62
    checkId: string;
    evidence: IxcRegistrationV1ClearingAccountEvidence;
}

export interface IxcRegistrationV1AccountEventTypeClearingPlatformUpdated {
    update: IxcRegistrationV1ClearingPlatformUpdate;
}

export interface IxcRegistrationV1AccountEventTypeCreated {
    requiredChecks?: IxcRegistrationV1AccountCheckType[];
    registration: IxcRegistrationV1AccountRegistration;
    accountingGroup: IxcRegistrationV1AccountingGroup;
    risk?: IxcRegistrationV1RiskProfile;
    profiles: IxcRegistrationV1ProfileSummary[];
    controls: IxcRegistrationV1ProgramControls;
    // pattern: ^[A-Z]{4}[0-9]{9}$
    displayId: string;
}

export interface IxcRegistrationV1AccountEventTypePlatformed {
    accountingGroup: IxcRegistrationV1AccountingGroup;
    controls: IxcRegistrationV1ProgramControls;
    purpose: IxcRegistrationV1Purpose;
    platform: IxcRegistrationV1PlatformAccount;
    // pattern: ^[A-Z]{4}[0-9]{9}$
    displayId: string;
}

export interface IxcRegistrationV1AccountEventTypePlatformUpdated {
    update: IxcRegistrationV1PlatformUpdate;
}

export interface IxcRegistrationV1AccountEventTypeProfileUpdated {
    profile: IxcRegistrationV1ProfileSummary;
}

export interface IxcRegistrationV1AccountEventTypeSpecialPurposeCreated {
    requiredChecks?: IxcRegistrationV1AccountCheckType[];
    accountingGroup: IxcRegistrationV1AccountingGroup;
    controls: IxcRegistrationV1ProgramControls;
    platform: IxcRegistrationV1PlatformAccount;
    // pattern: ^[A-Z]{4}[0-9]{9}$
    displayId: string;
}

export const IXC_REGISTRATION_V1_ACCOUNT_EVENT_TYPE_ONE_OF_VALUES = ['created', 'platformed', 'specialPurposeCreated', 'profileUpdated', 'checkResult', 'clearingCheckResult', 'checksPassed', 'accountUpdated', 'clearingAccountUpdated', 'platformUpdated', 'clearingPlatformUpdated'] as const;

export type IxcRegistrationV1AccountEventTypeOneOfValue = (typeof IXC_REGISTRATION_V1_ACCOUNT_EVENT_TYPE_ONE_OF_VALUES)[number];

export type IxcRegistrationV1AccountEvidence = {
    '!type'?: 'programApprovalEvidence';
    programApprovalEvidence: IxcRegistrationV1ProgramApprovalEvidence;
};

export const IXC_REGISTRATION_V1_ACCOUNT_EVIDENCE_ONE_OF_VALUES = ['programApprovalEvidence'] as const;

export type IxcRegistrationV1AccountEvidenceOneOfValue = (typeof IXC_REGISTRATION_V1_ACCOUNT_EVIDENCE_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1AccountFundingAmountLimits {
    /* If no minimum is set, the minimum is 0. */
    // format: decimal
    minAmount?: string;
    /* If no maximum is set, the maximum is unlimited. */
    // format: decimal
    maxAmount?: string;
}

export enum IxcRegistrationV1AccountingGroup {
    Unspecified = 'UNSPECIFIED',
    Customer = 'CUSTOMER',
    NonCustomer = 'NON_CUSTOMER',
    Pab = 'PAB'
}

export interface IxcRegistrationV1AccountKeys {
    // format: id62
    accountId: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
    /* Account code is 9 digit number, used in combination with program code to
    make a display ID. */
    // format: custom - pattern: ^[0-9]{9}$
    accountCode: string;
}

export interface IxcRegistrationV1AccountQueryServiceAccountEventsAccountEventsRequest {
    // format: id62
    accountId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcRegistrationV1AccountQueryServiceAccountEventsSearchableFields, IxcRegistrationV1AccountQueryServiceAccountEventsSortableFields, IxcRegistrationV1AccountQueryServiceAccountEventsFilterableFields>;
}

export enum IxcRegistrationV1AccountQueryServiceAccountEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AccountId = 'accountId',
    ProgramId = 'programId',
    AccountCode = 'accountCode',
    EventCreatedProfilesProfileId = 'event.created.profiles.profileId',
    EventPlatformedPlatformOwnerProfileProfileId = 'event.platformed.platform.owner.profile.profileId',
    EventPlatformedPlatformOwnerProfileW9Signed = 'event.platformed.platform.owner.profile.w9.signed',
    EventPlatformedPlatformOwnerType = 'event.platformed.platform.owner.!type',
    EventPlatformedPlatformProfileSummariesProfileId = 'event.platformed.platform.profileSummaries.profileId',
    EventSpecialPurposeCreatedPlatformOwnerProfileProfileId = 'event.specialPurposeCreated.platform.owner.profile.profileId',
    EventSpecialPurposeCreatedPlatformOwnerProfileW9Signed = 'event.specialPurposeCreated.platform.owner.profile.w9.signed',
    EventSpecialPurposeCreatedPlatformOwnerType = 'event.specialPurposeCreated.platform.owner.!type',
    EventSpecialPurposeCreatedPlatformProfileSummariesProfileId = 'event.specialPurposeCreated.platform.profileSummaries.profileId',
    EventProfileUpdatedProfileProfileId = 'event.profileUpdated.profile.profileId',
    EventType = 'event.!type'
}

export enum IxcRegistrationV1AccountQueryServiceAccountEventsSearchableFields {
    EventCreatedRegistrationIndividualTransferOnDeathBeneficiariesPrimaryTypeIndividualNameFirst = 'event.created.registration.individual.transferOnDeath.beneficiaries.primary.type.individual.name.first',
    EventCreatedRegistrationIndividualTransferOnDeathBeneficiariesPrimaryTypeIndividualNameLast = 'event.created.registration.individual.transferOnDeath.beneficiaries.primary.type.individual.name.last',
    EventCreatedRegistrationIndividualTransferOnDeathBeneficiariesContingentTypeIndividualNameFirst = 'event.created.registration.individual.transferOnDeath.beneficiaries.contingent.type.individual.name.first',
    EventCreatedRegistrationIndividualTransferOnDeathBeneficiariesContingentTypeIndividualNameLast = 'event.created.registration.individual.transferOnDeath.beneficiaries.contingent.type.individual.name.last',
    EventCreatedRegistrationJointRightsJointTenantsWithRightsOfSurvivorshipTransferOnDeathBeneficiariesPrimaryTypeIndividualNameFirst = 'event.created.registration.joint.rights.jointTenantsWithRightsOfSurvivorship.transferOnDeath.beneficiaries.primary.type.individual.name.first',
    EventCreatedRegistrationJointRightsJointTenantsWithRightsOfSurvivorshipTransferOnDeathBeneficiariesPrimaryTypeIndividualNameLast = 'event.created.registration.joint.rights.jointTenantsWithRightsOfSurvivorship.transferOnDeath.beneficiaries.primary.type.individual.name.last',
    EventCreatedRegistrationJointRightsJointTenantsWithRightsOfSurvivorshipTransferOnDeathBeneficiariesContingentTypeIndividualNameFirst = 'event.created.registration.joint.rights.jointTenantsWithRightsOfSurvivorship.transferOnDeath.beneficiaries.contingent.type.individual.name.first',
    EventCreatedRegistrationJointRightsJointTenantsWithRightsOfSurvivorshipTransferOnDeathBeneficiariesContingentTypeIndividualNameLast = 'event.created.registration.joint.rights.jointTenantsWithRightsOfSurvivorship.transferOnDeath.beneficiaries.contingent.type.individual.name.last',
    EventCreatedRegistrationIraBeneficiariesPrimaryTypeIndividualNameFirst = 'event.created.registration.ira.beneficiaries.primary.type.individual.name.first',
    EventCreatedRegistrationIraBeneficiariesPrimaryTypeIndividualNameLast = 'event.created.registration.ira.beneficiaries.primary.type.individual.name.last',
    EventCreatedRegistrationIraBeneficiariesContingentTypeIndividualNameFirst = 'event.created.registration.ira.beneficiaries.contingent.type.individual.name.first',
    EventCreatedRegistrationIraBeneficiariesContingentTypeIndividualNameLast = 'event.created.registration.ira.beneficiaries.contingent.type.individual.name.last',
    EventCreatedRegistrationRothIraBeneficiariesPrimaryTypeIndividualNameFirst = 'event.created.registration.rothIra.beneficiaries.primary.type.individual.name.first',
    EventCreatedRegistrationRothIraBeneficiariesPrimaryTypeIndividualNameLast = 'event.created.registration.rothIra.beneficiaries.primary.type.individual.name.last',
    EventCreatedRegistrationRothIraBeneficiariesContingentTypeIndividualNameFirst = 'event.created.registration.rothIra.beneficiaries.contingent.type.individual.name.first',
    EventCreatedRegistrationRothIraBeneficiariesContingentTypeIndividualNameLast = 'event.created.registration.rothIra.beneficiaries.contingent.type.individual.name.last',
    EventCreatedRegistrationSepIraBeneficiariesPrimaryTypeIndividualNameFirst = 'event.created.registration.sepIra.beneficiaries.primary.type.individual.name.first',
    EventCreatedRegistrationSepIraBeneficiariesPrimaryTypeIndividualNameLast = 'event.created.registration.sepIra.beneficiaries.primary.type.individual.name.last',
    EventCreatedRegistrationSepIraBeneficiariesContingentTypeIndividualNameFirst = 'event.created.registration.sepIra.beneficiaries.contingent.type.individual.name.first',
    EventCreatedRegistrationSepIraBeneficiariesContingentTypeIndividualNameLast = 'event.created.registration.sepIra.beneficiaries.contingent.type.individual.name.last',
    EventCreatedRegistrationSimpleIraBeneficiariesPrimaryTypeIndividualNameFirst = 'event.created.registration.simpleIra.beneficiaries.primary.type.individual.name.first',
    EventCreatedRegistrationSimpleIraBeneficiariesPrimaryTypeIndividualNameLast = 'event.created.registration.simpleIra.beneficiaries.primary.type.individual.name.last',
    EventCreatedRegistrationSimpleIraBeneficiariesContingentTypeIndividualNameFirst = 'event.created.registration.simpleIra.beneficiaries.contingent.type.individual.name.first',
    EventCreatedRegistrationSimpleIraBeneficiariesContingentTypeIndividualNameLast = 'event.created.registration.simpleIra.beneficiaries.contingent.type.individual.name.last',
    EventCreatedProfilesDataIndividualNameFirst = 'event.created.profiles.data.individual.name.first',
    EventCreatedProfilesDataIndividualNameLast = 'event.created.profiles.data.individual.name.last',
    EventCreatedProfilesDataOrganizationLegalName = 'event.created.profiles.data.organization.legalName',
    EventCreatedDisplayId = 'event.created.displayId',
    EventPlatformedPlatformOwnerProgramLegalName = 'event.platformed.platform.owner.program.legalName',
    EventPlatformedPlatformOwnerProfileLegalName = 'event.platformed.platform.owner.profile.legalName',
    EventPlatformedPlatformOwnerProfileDbaName = 'event.platformed.platform.owner.profile.dbaName',
    EventPlatformedPlatformProfileSummariesDataIndividualNameFirst = 'event.platformed.platform.profileSummaries.data.individual.name.first',
    EventPlatformedPlatformProfileSummariesDataIndividualNameLast = 'event.platformed.platform.profileSummaries.data.individual.name.last',
    EventPlatformedPlatformProfileSummariesDataOrganizationLegalName = 'event.platformed.platform.profileSummaries.data.organization.legalName',
    EventPlatformedDisplayId = 'event.platformed.displayId',
    EventSpecialPurposeCreatedPlatformOwnerProgramLegalName = 'event.specialPurposeCreated.platform.owner.program.legalName',
    EventSpecialPurposeCreatedPlatformOwnerProfileLegalName = 'event.specialPurposeCreated.platform.owner.profile.legalName',
    EventSpecialPurposeCreatedPlatformOwnerProfileDbaName = 'event.specialPurposeCreated.platform.owner.profile.dbaName',
    EventSpecialPurposeCreatedPlatformProfileSummariesDataIndividualNameFirst = 'event.specialPurposeCreated.platform.profileSummaries.data.individual.name.first',
    EventSpecialPurposeCreatedPlatformProfileSummariesDataIndividualNameLast = 'event.specialPurposeCreated.platform.profileSummaries.data.individual.name.last',
    EventSpecialPurposeCreatedPlatformProfileSummariesDataOrganizationLegalName = 'event.specialPurposeCreated.platform.profileSummaries.data.organization.legalName',
    EventSpecialPurposeCreatedDisplayId = 'event.specialPurposeCreated.displayId',
    EventProfileUpdatedProfileDataIndividualNameFirst = 'event.profileUpdated.profile.data.individual.name.first',
    EventProfileUpdatedProfileDataIndividualNameLast = 'event.profileUpdated.profile.data.individual.name.last',
    EventProfileUpdatedProfileDataOrganizationLegalName = 'event.profileUpdated.profile.data.organization.legalName',
    EventAccountUpdatedUpdateBeneficiariesPrimaryTypeIndividualNameFirst = 'event.accountUpdated.update.beneficiaries.primary.type.individual.name.first',
    EventAccountUpdatedUpdateBeneficiariesPrimaryTypeIndividualNameLast = 'event.accountUpdated.update.beneficiaries.primary.type.individual.name.last',
    EventAccountUpdatedUpdateBeneficiariesContingentTypeIndividualNameFirst = 'event.accountUpdated.update.beneficiaries.contingent.type.individual.name.first',
    EventAccountUpdatedUpdateBeneficiariesContingentTypeIndividualNameLast = 'event.accountUpdated.update.beneficiaries.contingent.type.individual.name.last',
    EventAccountUpdatedUpdateTransferOnDeathTransferOnDeathBeneficiariesPrimaryTypeIndividualNameFirst = 'event.accountUpdated.update.transferOnDeath.transferOnDeath.beneficiaries.primary.type.individual.name.first',
    EventAccountUpdatedUpdateTransferOnDeathTransferOnDeathBeneficiariesPrimaryTypeIndividualNameLast = 'event.accountUpdated.update.transferOnDeath.transferOnDeath.beneficiaries.primary.type.individual.name.last',
    EventAccountUpdatedUpdateTransferOnDeathTransferOnDeathBeneficiariesContingentTypeIndividualNameFirst = 'event.accountUpdated.update.transferOnDeath.transferOnDeath.beneficiaries.contingent.type.individual.name.first',
    EventAccountUpdatedUpdateTransferOnDeathTransferOnDeathBeneficiariesContingentTypeIndividualNameLast = 'event.accountUpdated.update.transferOnDeath.transferOnDeath.beneficiaries.contingent.type.individual.name.last'
}

export enum IxcRegistrationV1AccountQueryServiceAccountEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcRegistrationV1AccountQueryServiceAccountGetAccountGetRequest {
    // format: id62
    accountId: string;
}

export interface IxcRegistrationV1AccountQueryServiceAccountListAccountListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcRegistrationV1AccountQueryServiceAccountListSearchableFields, IxcRegistrationV1AccountQueryServiceAccountListSortableFields, IxcRegistrationV1AccountQueryServiceAccountListFilterableFields>;
}

export enum IxcRegistrationV1AccountQueryServiceAccountListFilterableFields {
    AccountId = 'accountId',
    ProgramId = 'programId',
    AccountCode = 'accountCode',
    DataSpecCustomerRegistrationType = 'data.spec.customer.registration.!type',
    DataSpecCustomerProfileSummariesProfileId = 'data.spec.customer.profileSummaries.profileId',
    DataSpecPlatformOwnerProfileProfileId = 'data.spec.platform.owner.profile.profileId',
    DataSpecPlatformOwnerProfileW9Signed = 'data.spec.platform.owner.profile.w9.signed',
    DataSpecPlatformOwnerType = 'data.spec.platform.owner.!type',
    DataSpecPlatformProfileSummariesProfileId = 'data.spec.platform.profileSummaries.profileId',
    DataSpecType = 'data.spec.!type',
    DataAccountingGroup = 'data.accountingGroup',
    DataPurpose = 'data.purpose',
    Status = 'status'
}

export enum IxcRegistrationV1AccountQueryServiceAccountListSearchableFields {
    DataDisplayId = 'data.displayId',
    DataSpecCustomerRegistrationIndividualTransferOnDeathBeneficiariesPrimaryTypeIndividualNameFirst = 'data.spec.customer.registration.individual.transferOnDeath.beneficiaries.primary.type.individual.name.first',
    DataSpecCustomerRegistrationIndividualTransferOnDeathBeneficiariesPrimaryTypeIndividualNameLast = 'data.spec.customer.registration.individual.transferOnDeath.beneficiaries.primary.type.individual.name.last',
    DataSpecCustomerRegistrationIndividualTransferOnDeathBeneficiariesContingentTypeIndividualNameFirst = 'data.spec.customer.registration.individual.transferOnDeath.beneficiaries.contingent.type.individual.name.first',
    DataSpecCustomerRegistrationIndividualTransferOnDeathBeneficiariesContingentTypeIndividualNameLast = 'data.spec.customer.registration.individual.transferOnDeath.beneficiaries.contingent.type.individual.name.last',
    DataSpecCustomerRegistrationJointRightsJointTenantsWithRightsOfSurvivorshipTransferOnDeathBeneficiariesPrimaryTypeIndividualNameFirst = 'data.spec.customer.registration.joint.rights.jointTenantsWithRightsOfSurvivorship.transferOnDeath.beneficiaries.primary.type.individual.name.first',
    DataSpecCustomerRegistrationJointRightsJointTenantsWithRightsOfSurvivorshipTransferOnDeathBeneficiariesPrimaryTypeIndividualNameLast = 'data.spec.customer.registration.joint.rights.jointTenantsWithRightsOfSurvivorship.transferOnDeath.beneficiaries.primary.type.individual.name.last',
    DataSpecCustomerRegistrationJointRightsJointTenantsWithRightsOfSurvivorshipTransferOnDeathBeneficiariesContingentTypeIndividualNameFirst = 'data.spec.customer.registration.joint.rights.jointTenantsWithRightsOfSurvivorship.transferOnDeath.beneficiaries.contingent.type.individual.name.first',
    DataSpecCustomerRegistrationJointRightsJointTenantsWithRightsOfSurvivorshipTransferOnDeathBeneficiariesContingentTypeIndividualNameLast = 'data.spec.customer.registration.joint.rights.jointTenantsWithRightsOfSurvivorship.transferOnDeath.beneficiaries.contingent.type.individual.name.last',
    DataSpecCustomerRegistrationIraBeneficiariesPrimaryTypeIndividualNameFirst = 'data.spec.customer.registration.ira.beneficiaries.primary.type.individual.name.first',
    DataSpecCustomerRegistrationIraBeneficiariesPrimaryTypeIndividualNameLast = 'data.spec.customer.registration.ira.beneficiaries.primary.type.individual.name.last',
    DataSpecCustomerRegistrationIraBeneficiariesContingentTypeIndividualNameFirst = 'data.spec.customer.registration.ira.beneficiaries.contingent.type.individual.name.first',
    DataSpecCustomerRegistrationIraBeneficiariesContingentTypeIndividualNameLast = 'data.spec.customer.registration.ira.beneficiaries.contingent.type.individual.name.last',
    DataSpecCustomerRegistrationRothIraBeneficiariesPrimaryTypeIndividualNameFirst = 'data.spec.customer.registration.rothIra.beneficiaries.primary.type.individual.name.first',
    DataSpecCustomerRegistrationRothIraBeneficiariesPrimaryTypeIndividualNameLast = 'data.spec.customer.registration.rothIra.beneficiaries.primary.type.individual.name.last',
    DataSpecCustomerRegistrationRothIraBeneficiariesContingentTypeIndividualNameFirst = 'data.spec.customer.registration.rothIra.beneficiaries.contingent.type.individual.name.first',
    DataSpecCustomerRegistrationRothIraBeneficiariesContingentTypeIndividualNameLast = 'data.spec.customer.registration.rothIra.beneficiaries.contingent.type.individual.name.last',
    DataSpecCustomerRegistrationSepIraBeneficiariesPrimaryTypeIndividualNameFirst = 'data.spec.customer.registration.sepIra.beneficiaries.primary.type.individual.name.first',
    DataSpecCustomerRegistrationSepIraBeneficiariesPrimaryTypeIndividualNameLast = 'data.spec.customer.registration.sepIra.beneficiaries.primary.type.individual.name.last',
    DataSpecCustomerRegistrationSepIraBeneficiariesContingentTypeIndividualNameFirst = 'data.spec.customer.registration.sepIra.beneficiaries.contingent.type.individual.name.first',
    DataSpecCustomerRegistrationSepIraBeneficiariesContingentTypeIndividualNameLast = 'data.spec.customer.registration.sepIra.beneficiaries.contingent.type.individual.name.last',
    DataSpecCustomerRegistrationSimpleIraBeneficiariesPrimaryTypeIndividualNameFirst = 'data.spec.customer.registration.simpleIra.beneficiaries.primary.type.individual.name.first',
    DataSpecCustomerRegistrationSimpleIraBeneficiariesPrimaryTypeIndividualNameLast = 'data.spec.customer.registration.simpleIra.beneficiaries.primary.type.individual.name.last',
    DataSpecCustomerRegistrationSimpleIraBeneficiariesContingentTypeIndividualNameFirst = 'data.spec.customer.registration.simpleIra.beneficiaries.contingent.type.individual.name.first',
    DataSpecCustomerRegistrationSimpleIraBeneficiariesContingentTypeIndividualNameLast = 'data.spec.customer.registration.simpleIra.beneficiaries.contingent.type.individual.name.last',
    DataSpecCustomerProfileSummariesDataIndividualNameFirst = 'data.spec.customer.profileSummaries.data.individual.name.first',
    DataSpecCustomerProfileSummariesDataIndividualNameLast = 'data.spec.customer.profileSummaries.data.individual.name.last',
    DataSpecCustomerProfileSummariesDataOrganizationLegalName = 'data.spec.customer.profileSummaries.data.organization.legalName',
    DataSpecPlatformOwnerProgramLegalName = 'data.spec.platform.owner.program.legalName',
    DataSpecPlatformOwnerProfileLegalName = 'data.spec.platform.owner.profile.legalName',
    DataSpecPlatformOwnerProfileDbaName = 'data.spec.platform.owner.profile.dbaName',
    DataSpecPlatformProfileSummariesDataIndividualNameFirst = 'data.spec.platform.profileSummaries.data.individual.name.first',
    DataSpecPlatformProfileSummariesDataIndividualNameLast = 'data.spec.platform.profileSummaries.data.individual.name.last',
    DataSpecPlatformProfileSummariesDataOrganizationLegalName = 'data.spec.platform.profileSummaries.data.organization.legalName'
}

export enum IxcRegistrationV1AccountQueryServiceAccountListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export type IxcRegistrationV1AccountRegistration = {
    '!type'?: 'individual';
    individual: IxcRegistrationV1AccountRegistrationIndividual;
} | {
    '!type'?: 'organization';
    organization: IxcRegistrationV1AccountRegistrationOrganization;
} | {
    '!type'?: 'joint';
    joint: IxcRegistrationV1AccountRegistrationJoint;
} | {
    '!type'?: 'custodial';
    custodial: IxcRegistrationV1AccountRegistrationCustodial;
} | {
    '!type'?: 'ira';
    ira: IxcRegistrationV1AccountRegistrationIra;
} | {
    '!type'?: 'rothIra';
    rothIra: IxcRegistrationV1AccountRegistrationRothIra;
} | {
    '!type'?: 'sepIra';
    sepIra: IxcRegistrationV1AccountRegistrationSepIra;
} | {
    '!type'?: 'simpleIra';
    simpleIra: IxcRegistrationV1AccountRegistrationSimpleIra;
};

export interface IxcRegistrationV1AccountRegistrationCustodial {
    // format: id62
    profileId: string;
    // format: id62
    custodianProfileId: string;
    governingEntity: IxcRegistrationV1AccountRegistrationCustodialGoverningEntity;
    /* Refer to the applicable state UTMA or UGMA statutes for the age at
    which custodial account assets must transfer from the custodian to
    the beneficiary. */
    // format: INT32
    customizedTerminationAge: number;
    /* Most states have adopted UTMA; the governing act (UTMA or UGMA) and
    age of termination are established when the account is created. */
    rights: IxcRegistrationV1AccountRegistrationCustodialRights;
    consent: IxcRegistrationV1Consent;
}

export type IxcRegistrationV1AccountRegistrationCustodialGoverningEntity = {
    '!type'?: 'usState';
    /* The state of the address. */
    usState: IxcRegistrationV1UsState;
};

export const IXC_REGISTRATION_V1_ACCOUNT_REGISTRATION_CUSTODIAL_GOVERNING_ENTITY_ONE_OF_VALUES = ['usState'] as const;

export type IxcRegistrationV1AccountRegistrationCustodialGoverningEntityOneOfValue = (typeof IXC_REGISTRATION_V1_ACCOUNT_REGISTRATION_CUSTODIAL_GOVERNING_ENTITY_ONE_OF_VALUES)[number];

export type IxcRegistrationV1AccountRegistrationCustodialRights = {
    '!type'?: 'utma';
    utma: EmptyObject;
} | {
    '!type'?: 'ugma';
    ugma: EmptyObject;
};

export const IXC_REGISTRATION_V1_ACCOUNT_REGISTRATION_CUSTODIAL_RIGHTS_ONE_OF_VALUES = ['utma', 'ugma'] as const;

export type IxcRegistrationV1AccountRegistrationCustodialRightsOneOfValue = (typeof IXC_REGISTRATION_V1_ACCOUNT_REGISTRATION_CUSTODIAL_RIGHTS_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1AccountRegistrationIndividual {
    // format: id62
    profileId: string;
    transferOnDeath?: IxcRegistrationV1AccountTransferOnDeath;
    consent: IxcRegistrationV1Consent;
}

export interface IxcRegistrationV1AccountRegistrationIra {
    // format: id62
    profileId: string;
    beneficiaries: IxcRegistrationV1AccountBeneficiaries;
    consent: IxcRegistrationV1Consent;
}

export interface IxcRegistrationV1AccountRegistrationJoint {
    // format: id62
    profileIds: string[];
    // format: id62
    primaryProfileId: string;
    rights: IxcRegistrationV1AccountRegistrationJointRights;
    consent: IxcRegistrationV1Consent;
}

export type IxcRegistrationV1AccountRegistrationJointRights = {
    '!type'?: 'jointTenantsWithRightsOfSurvivorship';
    jointTenantsWithRightsOfSurvivorship: IxcRegistrationV1AccountRegistrationJointRightsJointTenantsWithRightsOfSurvivorship;
} | {
    '!type'?: 'tenantsInCommon';
    tenantsInCommon: IxcRegistrationV1AccountRegistrationJointRightsTenantsInCommon;
};

export interface IxcRegistrationV1AccountRegistrationJointRightsJointTenantsWithRightsOfSurvivorship {
    transferOnDeath?: IxcRegistrationV1AccountTransferOnDeath;
}

export interface IxcRegistrationV1AccountRegistrationJointRightsTenantsInCommon {
    ownership?: IxcRegistrationV1AccountRegistrationJointRightsTenantsInCommonOwnership[];
}

export interface IxcRegistrationV1AccountRegistrationJointRightsTenantsInCommonOwnership {
    // format: id62
    profileId: string;
    /* 0-1 where 1 is 100% */
    // format: FLOAT32
    percentage: number;
}

export const IXC_REGISTRATION_V1_ACCOUNT_REGISTRATION_JOINT_RIGHTS_ONE_OF_VALUES = ['jointTenantsWithRightsOfSurvivorship', 'tenantsInCommon'] as const;

export type IxcRegistrationV1AccountRegistrationJointRightsOneOfValue = (typeof IXC_REGISTRATION_V1_ACCOUNT_REGISTRATION_JOINT_RIGHTS_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1AccountRegistrationOrganization {
    // format: id62
    profileId: string;
    consent: IxcRegistrationV1Consent;
}

export interface IxcRegistrationV1AccountRegistrationRothIra {
    // format: id62
    profileId: string;
    beneficiaries: IxcRegistrationV1AccountBeneficiaries;
    consent: IxcRegistrationV1Consent;
}

export interface IxcRegistrationV1AccountRegistrationSepIra {
    // format: id62
    profileId: string;
    // format: id62
    employerProfileId: string;
    beneficiaries: IxcRegistrationV1AccountBeneficiaries;
    consent: IxcRegistrationV1Consent;
}

export interface IxcRegistrationV1AccountRegistrationSimpleIra {
    // format: id62
    profileId: string;
    // format: id62
    employerProfileId: string;
    beneficiaries: IxcRegistrationV1AccountBeneficiaries;
    consent: IxcRegistrationV1Consent;
}

export const IXC_REGISTRATION_V1_ACCOUNT_REGISTRATION_ONE_OF_VALUES = ['individual', 'organization', 'joint', 'custodial', 'ira', 'rothIra', 'sepIra', 'simpleIra'] as const;

export type IxcRegistrationV1AccountRegistrationOneOfValue = (typeof IXC_REGISTRATION_V1_ACCOUNT_REGISTRATION_ONE_OF_VALUES)[number];

export enum IxcRegistrationV1AccountReviewType {
    Unspecified = 'UNSPECIFIED',
    ClearingManual = 'CLEARING_MANUAL',
    ClearingAutomated = 'CLEARING_AUTOMATED',
    DualManual = 'DUAL_MANUAL',
    DualAutomated = 'DUAL_AUTOMATED'
}

export interface IxcRegistrationV1AccountState extends IxcRegistrationV1AccountKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcRegistrationV1AccountData;
    status: IxcRegistrationV1AccountStatus;
}

export enum IxcRegistrationV1AccountStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Open = 'OPEN'
}

export interface IxcRegistrationV1AccountSummaryKeys {
    // format: id62
    accountId?: string;
    // format: id62
    programId?: string;
}

export interface IxcRegistrationV1AccountTransferOnDeath {
    beneficiaries: IxcRegistrationV1AccountBeneficiaries;
}

export type IxcRegistrationV1AccountUpdate = {
    '!type'?: 'beneficiaries';
    /* If a registration can have Transfer on Death, it must be set first. After
    that, the beneficiaries can be updated as needed. If the Transfer on
    Death is not set, an error will be returned. Eligible account types are:
    Individual, IRAs, Joint with JTWROS. An error will be returned for any
    registration type that does not support beneficiaries. */
    beneficiaries: IxcRegistrationV1AccountBeneficiaries;
} | {
    '!type'?: 'transferOnDeath';
    /* An error will be returned for any registration type that does not support
    Transfer on Death. */
    transferOnDeath: IxcRegistrationV1AccountUpdateTransferOnDeath;
} | {
    '!type'?: 'risk';
    risk: IxcRegistrationV1AccountUpdateRisk;
} | {
    '!type'?: 'controls';
    controls: IxcRegistrationV1ProgramControls;
};

export interface IxcRegistrationV1AccountUpdateRisk {
    /* Set to null to clear existing risk profile. */
    riskProfile?: IxcRegistrationV1RiskProfile;
}

export interface IxcRegistrationV1AccountUpdateTransferOnDeath {
    /* Set to null to clear existing transfer on death settings. */
    transferOnDeath?: IxcRegistrationV1AccountTransferOnDeath;
}

export const IXC_REGISTRATION_V1_ACCOUNT_UPDATE_ONE_OF_VALUES = ['beneficiaries', 'transferOnDeath', 'risk', 'controls'] as const;

export type IxcRegistrationV1AccountUpdateOneOfValue = (typeof IXC_REGISTRATION_V1_ACCOUNT_UPDATE_ONE_OF_VALUES)[number];

export type IxcRegistrationV1Address = {
    '!type'?: 'usAddress';
    usAddress: IxcRegistrationV1AddressUsAddress;
};

export interface IxcRegistrationV1AddressUsAddress {
    /* The first line of the address. */
    street1: string;
    /* The second line of the address. */
    street2?: string;
    /* The city of the address. */
    city: string;
    /* The state of the address. */
    state: IxcRegistrationV1UsState;
    /* The Postal Code can be either the 5 digit ZIP code, or the 9
    digit ZIP+4 code. */
    // pattern: ^[0-9]{5}(-[0-9]{4})?$
    postalCode: string;
}

export const IXC_REGISTRATION_V1_ADDRESS_ONE_OF_VALUES = ['usAddress'] as const;

export type IxcRegistrationV1AddressOneOfValue = (typeof IXC_REGISTRATION_V1_ADDRESS_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1Affiliations {
    /* Individual, household member, or independent works for a broker-dealer,
    exchange, or FINRA. */
    associatedPersons?: IxcRegistrationV1AffiliationsAssociatedPersons[];
    /* Individual is an officer, director, or 10%+ shareholder of a public
    company. */
    corporateInsider?: IxcRegistrationV1AffiliationsCorporateInsider;
    /* Individual holds a key public role in a non-US country. */
    politicallyExposedPerson?: IxcRegistrationV1AffiliationsPoliticallyExposedPerson;
}

export interface IxcRegistrationV1AffiliationsAssociatedPersons {
    name: IxcRegistrationV1Name;
    employer: string;
    complianceOfficer: string;
    complianceOfficerEmail: string;
}

export interface IxcRegistrationV1AffiliationsCorporateInsider {
    companyName: string;
    symbol: string;
}

export interface IxcRegistrationV1AffiliationsPoliticallyExposedPerson {
    country: IsoV1Country;
}

export type IxcRegistrationV1BasicProfile = {
    '!type'?: 'naturalPersons';
    naturalPersons: IxcRegistrationV1NaturalPersonsProfile;
} | {
    '!type'?: 'organization';
    organization: IxcRegistrationV1Organization;
} | {
    '!type'?: 'platform';
    platform: IxcRegistrationV1Platform;
};

export const IXC_REGISTRATION_V1_BASIC_PROFILE_ONE_OF_VALUES = ['naturalPersons', 'organization', 'platform'] as const;

export type IxcRegistrationV1BasicProfileOneOfValue = (typeof IXC_REGISTRATION_V1_BASIC_PROFILE_ONE_OF_VALUES)[number];

export type IxcRegistrationV1BeneficialOwner = {
    '!type'?: 'direct';
    direct: IxcRegistrationV1BeneficialOwnerDirect;
} | {
    '!type'?: 'indirect';
    indirect: IxcRegistrationV1BeneficialOwnerIndirect;
};

export interface IxcRegistrationV1BeneficialOwnerDirect {
    // format: id62
    profileId: string;
    /* 0.25 - 1 where 1 is 100% */
    // format: FLOAT32
    ownership: number;
    /* Indicates whether they are authorized to enter into legal agreements. */
    signer?: boolean;
}

export interface IxcRegistrationV1BeneficialOwnerIndirect {
    // format: id62
    profileId: string;
    beneficialOwnerEntity?: string;
    /* 0.25 - 1 where 1 is 100% */
    // format: FLOAT32
    ownership: number;
    /* These are other entities “looked through” to identify this person. */
    passThroughEntities?: string;
    /* Indicates whether they are authorized to enter into legal agreements. */
    signer?: boolean;
}

export const IXC_REGISTRATION_V1_BENEFICIAL_OWNER_ONE_OF_VALUES = ['direct', 'indirect'] as const;

export type IxcRegistrationV1BeneficialOwnerOneOfValue = (typeof IXC_REGISTRATION_V1_BENEFICIAL_OWNER_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1Beneficiary {
    /* 0-1 where 1 is 100% */
    // format: FLOAT32
    percentage: number;
    type: IxcRegistrationV1BeneficiaryType;
}

export type IxcRegistrationV1BeneficiaryType = {
    '!type'?: 'individual';
    individual: IxcRegistrationV1BeneficiaryTypeIndividual;
} | {
    '!type'?: 'charity';
    charity: IxcRegistrationV1BeneficiaryTypeCharity;
} | {
    '!type'?: 'trust';
    trust: IxcRegistrationV1BeneficiaryTypeTrust;
};

export interface IxcRegistrationV1BeneficiaryTypeCharity {
    legalName: string;
    ein?: string;
}

export interface IxcRegistrationV1BeneficiaryTypeIndividual {
    name: IxcRegistrationV1Name;
    /* Relationship of the beneficiary to the account holder for the
    purpose of when spousal consent is required. */
    relationship: IxcRegistrationV1Relationship;
    /* Birth date in ISO 8601 format, e.g. "1969-04-20". */
    // format: YYYY-MM-DD
    birthDate: string;
    /* Tax identifier of the beneficiary, e.g. SSN or EIN. */
    taxIdentifier: IxcRegistrationV1IndividualTaxIdentifier;
}

export interface IxcRegistrationV1BeneficiaryTypeTrust {
    legalName: string;
    ein?: string;
}

export const IXC_REGISTRATION_V1_BENEFICIARY_TYPE_ONE_OF_VALUES = ['individual', 'charity', 'trust'] as const;

export type IxcRegistrationV1BeneficiaryTypeOneOfValue = (typeof IXC_REGISTRATION_V1_BENEFICIARY_TYPE_ONE_OF_VALUES)[number];

export enum IxcRegistrationV1BusinessClassification {
    Unspecified = 'UNSPECIFIED',
    MoneyServiceBusiness = 'MONEY_SERVICE_BUSINESS',
    MarijuanaRelatedBusiness = 'MARIJUANA_RELATED_BUSINESS',
    VirtualCurrency = 'VIRTUAL_CURRENCY',
    None = 'NONE'
}

export enum IxcRegistrationV1CheckOutcome {
    Unspecified = 'UNSPECIFIED',
    Passed = 'PASSED',
    Failed = 'FAILED',
    Inconclusive = 'INCONCLUSIVE'
}

export interface IxcRegistrationV1CipIdentityEvidence {
    vendorData: IxcRegistrationV1CipIdentityEvidenceVendorData;
    // format: date-time
    timestamp: string;
    outcome: IxcRegistrationV1CheckOutcome;
}

export type IxcRegistrationV1CipIdentityEvidenceVendorData = {
    '!type'?: 'idology';
    idology: IxcRegistrationV1CipIdentityEvidenceVendorDataIdology;
} | {
    '!type'?: 'lexisNexis';
    lexisNexis: IxcRegistrationV1CipIdentityEvidenceVendorDataLexisNexis;
} | {
    '!type'?: 'plaid';
    plaid: IxcRegistrationV1CipIdentityEvidenceVendorDataPlaid;
} | {
    '!type'?: 'equifax';
    equifax: IxcRegistrationV1CipIdentityEvidenceVendorDataEquifax;
} | {
    '!type'?: 'socure';
    socure: IxcRegistrationV1CipIdentityEvidenceVendorDataSocure;
} | {
    '!type'?: 'trulioo';
    trulioo: IxcRegistrationV1CipIdentityEvidenceVendorDataTrulioo;
} | {
    '!type'?: 'jumio';
    jumio: IxcRegistrationV1CipIdentityEvidenceVendorDataJumio;
} | {
    '!type'?: 'onfido';
    onfido: IxcRegistrationV1CipIdentityEvidenceVendorDataOnfido;
} | {
    '!type'?: 'idMe';
    idMe: IxcRegistrationV1CipIdentityEvidenceVendorDataIdMe;
};

export interface IxcRegistrationV1CipIdentityEvidenceVendorDataEquifax {
    id: string;
}

export interface IxcRegistrationV1CipIdentityEvidenceVendorDataIdMe {
    id: string;
}

export interface IxcRegistrationV1CipIdentityEvidenceVendorDataIdology {
    id: string;
}

export interface IxcRegistrationV1CipIdentityEvidenceVendorDataJumio {
    id: string;
}

export interface IxcRegistrationV1CipIdentityEvidenceVendorDataLexisNexis {
    id: string;
}

export interface IxcRegistrationV1CipIdentityEvidenceVendorDataOnfido {
    id: string;
}

export interface IxcRegistrationV1CipIdentityEvidenceVendorDataPlaid {
    id: string;
}

export interface IxcRegistrationV1CipIdentityEvidenceVendorDataSocure {
    id: string;
}

export interface IxcRegistrationV1CipIdentityEvidenceVendorDataTrulioo {
    id: string;
}

export const IXC_REGISTRATION_V1_CIP_IDENTITY_EVIDENCE_VENDOR_DATA_ONE_OF_VALUES = ['idology', 'lexisNexis', 'plaid', 'equifax', 'socure', 'trulioo', 'jumio', 'onfido', 'idMe'] as const;

export type IxcRegistrationV1CipIdentityEvidenceVendorDataOneOfValue = (typeof IXC_REGISTRATION_V1_CIP_IDENTITY_EVIDENCE_VENDOR_DATA_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1CipIdentityMinimalEvidence {
    // format: date-time
    timestamp: string;
}

export enum IxcRegistrationV1CipOfac {
    Unspecified = 'UNSPECIFIED',
    Idology = 'IDOLOGY',
    LexisNexis = 'LEXIS_NEXIS',
    Equifax = 'EQUIFAX',
    Refinitiv = 'REFINITIV',
    DowJones = 'DOW_JONES',
    AmlPartners = 'AML_PARTNERS',
    Plaid = 'PLAID'
}

export interface IxcRegistrationV1CipOfacEvidence {
    vendorData: IxcRegistrationV1CipOfacEvidenceVendorData;
    // format: date-time
    timestamp: string;
    outcome: IxcRegistrationV1CheckOutcome;
}

export type IxcRegistrationV1CipOfacEvidenceVendorData = {
    '!type'?: 'idology';
    idology: IxcRegistrationV1CipOfacEvidenceVendorDataIdology;
} | {
    '!type'?: 'lexisNexis';
    lexisNexis: IxcRegistrationV1CipOfacEvidenceVendorDataLexisNexis;
} | {
    '!type'?: 'interchange';
    interchange: IxcRegistrationV1CipOfacEvidenceVendorDataInterchange;
} | {
    '!type'?: 'plaid';
    plaid: IxcRegistrationV1CipOfacEvidenceVendorDataPlaid;
} | {
    '!type'?: 'equifax';
    equifax: IxcRegistrationV1CipOfacEvidenceVendorDataEquifax;
} | {
    '!type'?: 'refinitiv';
    refinitiv: IxcRegistrationV1CipOfacEvidenceVendorDataRefinitiv;
} | {
    '!type'?: 'dowJones';
    dowJones: IxcRegistrationV1CipOfacEvidenceVendorDataDowJones;
} | {
    '!type'?: 'amlPartners';
    amlPartners: IxcRegistrationV1CipOfacEvidenceVendorDataAmlPartners;
};

export interface IxcRegistrationV1CipOfacEvidenceVendorDataAmlPartners {
    id: string;
}

export interface IxcRegistrationV1CipOfacEvidenceVendorDataDowJones {
    id: string;
}

export interface IxcRegistrationV1CipOfacEvidenceVendorDataEquifax {
    id: string;
}

export interface IxcRegistrationV1CipOfacEvidenceVendorDataIdology {
    id: string;
}

export interface IxcRegistrationV1CipOfacEvidenceVendorDataInterchange {
    // format: UINT32
    matchCount?: number;
    // format: date-time
    screenedAt: string;
}

export interface IxcRegistrationV1CipOfacEvidenceVendorDataLexisNexis {
    id: string;
}

export interface IxcRegistrationV1CipOfacEvidenceVendorDataPlaid {
    id: string;
}

export interface IxcRegistrationV1CipOfacEvidenceVendorDataRefinitiv {
    id: string;
}

export const IXC_REGISTRATION_V1_CIP_OFAC_EVIDENCE_VENDOR_DATA_ONE_OF_VALUES = ['idology', 'lexisNexis', 'interchange', 'plaid', 'equifax', 'refinitiv', 'dowJones', 'amlPartners'] as const;

export type IxcRegistrationV1CipOfacEvidenceVendorDataOneOfValue = (typeof IXC_REGISTRATION_V1_CIP_OFAC_EVIDENCE_VENDOR_DATA_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1CipOfacMinimalEvidence {
    // format: date-time
    timestamp: string;
}

export enum IxcRegistrationV1CipVendor {
    Unspecified = 'UNSPECIFIED',
    Idology = 'IDOLOGY',
    LexisNexis = 'LEXIS_NEXIS',
    Equifax = 'EQUIFAX',
    Socure = 'SOCURE',
    Trulioo = 'TRULIOO',
    Jumio = 'JUMIO',
    Onfido = 'ONFIDO',
    IdMe = 'ID_ME',
    Plaid = 'PLAID'
}

export interface IxcRegistrationV1ClearingAccountControls {
    funding?: IxcRegistrationV1ClearingAccountControlsFunding;
    accountNumbers?: IxcRegistrationV1ClearingAccountControlsAccountNumbers;
    order?: IxcRegistrationV1ClearingAccountControlsOrder;
    sweeps?: IxcRegistrationV1ClearingAccountControlsSweeps;
    instantDeposit?: IxcRegistrationV1ClearingAccountControlsInstantDeposit;
    batchOrder?: IxcRegistrationV1ClearingAccountControlsBatchOrder;
}

export interface IxcRegistrationV1ClearingAccountControlsAccountNumbers {
    settings: IxcRegistrationV1ClearingAccountControlsAccountNumbersSettings;
}

export interface IxcRegistrationV1ClearingAccountControlsAccountNumbersSettings {
    /* If true, accounts are able to create an Account Number */
    canCreate?: boolean;
}

export interface IxcRegistrationV1ClearingAccountControlsBatchOrder {
    canPlaceBatchOrders?: boolean;
}

export interface IxcRegistrationV1ClearingAccountControlsFunding {
    ach?: IxcRegistrationV1ClearingAccountControlsFundingAch;
    sameDayAch?: IxcRegistrationV1ClearingAccountControlsFundingSameDayAch;
    wire?: IxcRegistrationV1ClearingAccountControlsFundingWire;
}

export interface IxcRegistrationV1ClearingAccountControlsFundingAch {
    canDeposit?: boolean;
    canWithdraw?: boolean;
}

export interface IxcRegistrationV1ClearingAccountControlsFundingSameDayAch {
    canDeposit?: boolean;
    canWithdraw?: boolean;
}

export interface IxcRegistrationV1ClearingAccountControlsFundingWire {
    canWithdraw?: boolean;
}

export interface IxcRegistrationV1ClearingAccountControlsInstantDeposit {
    /* When explicitly set to false, disables Instant Deposit advances for
    this account regardless of program settings. */
    canUseAdvance?: boolean;
}

export interface IxcRegistrationV1ClearingAccountControlsOrder {
    canPlaceOpening?: boolean;
    canPlaceClosing?: boolean;
    canTradeFractions?: boolean;
}

export interface IxcRegistrationV1ClearingAccountControlsSweeps {
    canSweepAccount?: boolean;
}

export type IxcRegistrationV1ClearingAccountEvidence = {
    '!type'?: 'clearingManualApprovalEvidence';
    clearingManualApprovalEvidence: IxcRegistrationV1ClearingManualApprovalEvidence;
} | {
    '!type'?: 'clearingAutomatedApprovalEvidence';
    clearingAutomatedApprovalEvidence: IxcRegistrationV1ClearingAutomatedApprovalEvidence;
};

export const IXC_REGISTRATION_V1_CLEARING_ACCOUNT_EVIDENCE_ONE_OF_VALUES = ['clearingManualApprovalEvidence', 'clearingAutomatedApprovalEvidence'] as const;

export type IxcRegistrationV1ClearingAccountEvidenceOneOfValue = (typeof IXC_REGISTRATION_V1_CLEARING_ACCOUNT_EVIDENCE_ONE_OF_VALUES)[number];

export type IxcRegistrationV1ClearingAccountUpdate = {
    '!type'?: 'clearingControls';
    /* Sets or clears this account clearing controls. Clearing only. */
    clearingControls: IxcRegistrationV1ClearingAccountUpdateClearingControls;
};

export interface IxcRegistrationV1ClearingAccountUpdateClearingControls {
    controls?: IxcRegistrationV1ClearingAccountControls;
}

export const IXC_REGISTRATION_V1_CLEARING_ACCOUNT_UPDATE_ONE_OF_VALUES = ['clearingControls'] as const;

export type IxcRegistrationV1ClearingAccountUpdateOneOfValue = (typeof IXC_REGISTRATION_V1_CLEARING_ACCOUNT_UPDATE_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1ClearingAutomatedApprovalEvidence {
    // format: id62
    principalId: string;
    // format: date-time
    timestamp: string;
    outcome: IxcRegistrationV1CheckOutcome;
}

export interface IxcRegistrationV1ClearingControls {
    settings?: IxcRegistrationV1ClearingControlsSettings;
}

export interface IxcRegistrationV1ClearingControlsSettings {
    marginType?: IxcRegistrationV1ControlsMarginType;
    /* Whether the program's accounts can open new accounts. */
    canOpenAccounts?: boolean;
    /* Whether the risk and investment profile is optional when creating or updating an account. */
    optionalSuitabilityQuestions?: boolean;
    /* The types of accounts that can be opened by the program. If the array is empty, no accounts can be opened. */
    accountTypes?: IxcRegistrationV1RegistrationAccountType[];
    /* defines the process for approving new accounts and some changes to
    existing accounts.
    Regardless of the setting here, the clearing firm will continue to
    run spot checks, and automated approval processes. */
    accountReviewType?: IxcRegistrationV1AccountReviewType;
    /* defines the process for approving new special purpose accounts. */
    specialPurposeAccountReviewType?: IxcRegistrationV1AccountReviewType;
    cipProgram?: IxcRegistrationV1ClearingControlsSettingsCipProgram;
    states: IxcRegistrationV1UsState[];
}

export enum IxcRegistrationV1ClearingControlsSettingsCipProgram {
    Unspecified = 'UNSPECIFIED',
    Disclosed = 'DISCLOSED',
    Undisclosed = 'UNDISCLOSED',
    None = 'NONE'
}

export interface IxcRegistrationV1ClearingManualApprovalEvidence {
    // format: id62
    principalId: string;
    // format: date-time
    timestamp: string;
    outcome: IxcRegistrationV1CheckOutcome;
}

export interface IxcRegistrationV1ClearingManualProfileApprovalEvidence {
    // format: date-time
    timestamp: string;
    outcome: IxcRegistrationV1CheckOutcome;
}

export type IxcRegistrationV1ClearingPlatformUpdate = {
    '!type'?: 'accountControls';
    accountControls: IxcRegistrationV1ProgramControls;
} | {
    '!type'?: 'platformControls';
    platformControls: IxcRegistrationV1PlatformControls;
};

export const IXC_REGISTRATION_V1_CLEARING_PLATFORM_UPDATE_ONE_OF_VALUES = ['accountControls', 'platformControls'] as const;

export type IxcRegistrationV1ClearingPlatformUpdateOneOfValue = (typeof IXC_REGISTRATION_V1_CLEARING_PLATFORM_UPDATE_ONE_OF_VALUES)[number];

export type IxcRegistrationV1ClearingProfileEvidence = {
    '!type'?: 'clearingManualProfileApprovalEvidence';
    clearingManualProfileApprovalEvidence: IxcRegistrationV1ClearingManualProfileApprovalEvidence;
};

export const IXC_REGISTRATION_V1_CLEARING_PROFILE_EVIDENCE_ONE_OF_VALUES = ['clearingManualProfileApprovalEvidence'] as const;

export type IxcRegistrationV1ClearingProfileEvidenceOneOfValue = (typeof IXC_REGISTRATION_V1_CLEARING_PROFILE_EVIDENCE_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1Consent {
    /* Confirmation that the customer signed to formally consent  and be bound
    by all applicable account agreement(s) and  related terms and conditions. */
    customerConsent: boolean;
    /* Date of consent e-signature. */
    // format: YYYY-MM-DD
    signed: string;
}

export type IxcRegistrationV1ControlPerson = {
    '!type'?: 'beneficialOwner';
    beneficialOwner: IxcRegistrationV1BeneficialOwner;
} | {
    '!type'?: 'officer';
    /* This person has significant responsibility to control manage, or direct
    the organization (e.g., CEO, CFO, General Partner, Managing Member). */
    officer: IxcRegistrationV1ControlPersonOfficer;
} | {
    '!type'?: 'director';
    director: IxcRegistrationV1ControlPersonDirector;
} | {
    '!type'?: 'other';
    /* This person has decision-making influence or substantial control over the
    organization's operations (e.g., largest single shareholder or board
    chairperson). */
    other: IxcRegistrationV1ControlPersonOther;
};

export interface IxcRegistrationV1ControlPersonDirector {
    // format: id62
    profileId: string;
    /* The title of the officer (e.g., CEO, CFO, etc.) */
    title?: string;
    /* Indicates whether they are authorized to enter into legal agreements. */
    signer?: boolean;
}

export interface IxcRegistrationV1ControlPersonOfficer {
    // format: id62
    profileId: string;
    /* The title of the officer (e.g., CEO, CFO, etc.) */
    title?: string;
    /* Indicates whether they are authorized to enter into legal agreements. */
    signer?: boolean;
}

export interface IxcRegistrationV1ControlPersonOther {
    // format: id62
    profileId: string;
    title?: string;
    /* Indicates whether they are authorized to enter into legal agreements. */
    signer?: boolean;
}

export const IXC_REGISTRATION_V1_CONTROL_PERSON_ONE_OF_VALUES = ['beneficialOwner', 'officer', 'director', 'other'] as const;

export type IxcRegistrationV1ControlPersonOneOfValue = (typeof IXC_REGISTRATION_V1_CONTROL_PERSON_ONE_OF_VALUES)[number];

export enum IxcRegistrationV1ControlsMarginType {
    Unspecified = 'UNSPECIFIED',
    Cash = 'CASH',
    Lpm = 'LPM'
}

export interface IxcRegistrationV1CustomerAccount {
    registration?: IxcRegistrationV1AccountRegistration;
    profileSummaries?: IxcRegistrationV1ProfileSummary[];
    risk?: IxcRegistrationV1RiskProfile;
    checks?: IxcRegistrationV1AccountCheck[];
}

export type IxcRegistrationV1Employment = {
    '!type'?: 'employed';
    employed: IxcRegistrationV1EmploymentEmployed;
} | {
    '!type'?: 'selfEmployed';
    selfEmployed: IxcRegistrationV1EmploymentSelfEmployed;
} | {
    '!type'?: 'partTime';
    partTime: IxcRegistrationV1EmploymentPartTime;
} | {
    '!type'?: 'seasonal';
    seasonal: IxcRegistrationV1EmploymentSeasonal;
} | {
    '!type'?: 'unemployed';
    /* Individual is currently unemployed. */
    unemployed: EmptyObject;
} | {
    '!type'?: 'retired';
    /* Individual is retired. */
    retired: EmptyObject;
} | {
    '!type'?: 'student';
    /* Individual is a student. */
    student: EmptyObject;
} | {
    '!type'?: 'homemaker';
    /* Individual is a homemaker. */
    homemaker: EmptyObject;
};

export interface IxcRegistrationV1EmploymentEmployed {
    /* Occupation of the individual, e.g. "Software Engineer", "Retail
    Worker", "Account Manager", etc. */
    occupation: string;
    /* Name of the institution where employed. */
    institution: string;
}

export interface IxcRegistrationV1EmploymentPartTime {
    /* Occupation of the individual, e.g. "Software Engineer", "Retail
    Worker", "Account Manager", etc. */
    occupation: string;
    /* Name of the institution where employed. */
    institution: string;
}

export interface IxcRegistrationV1EmploymentSeasonal {
    /* Occupation of the individual, e.g. "Software Engineer", "Retail
    Worker", "Account Manager", etc. */
    occupation: string;
    /* Name of the institution where employed. */
    institution: string;
}

export interface IxcRegistrationV1EmploymentSelfEmployed {
    /* Occupation of the individual, e.g. "Software Engineer", "Retail
    Worker", "Account Manager", etc. */
    occupation: string;
    /* Name of the institution where employed. */
    institution: string;
}

export const IXC_REGISTRATION_V1_EMPLOYMENT_ONE_OF_VALUES = ['employed', 'selfEmployed', 'partTime', 'seasonal', 'unemployed', 'retired', 'student', 'homemaker'] as const;

export type IxcRegistrationV1EmploymentOneOfValue = (typeof IXC_REGISTRATION_V1_EMPLOYMENT_ONE_OF_VALUES)[number];

export enum IxcRegistrationV1EntityType {
    Unspecified = 'UNSPECIFIED',
    CCorporation = 'C_CORPORATION',
    SCorporation = 'S_CORPORATION',
    LimitedPartnership = 'LIMITED_PARTNERSHIP',
    LlcCCorporation = 'LLC_C_CORPORATION',
    LlcSCorporation = 'LLC_S_CORPORATION',
    LlcPartnership = 'LLC_PARTNERSHIP',
    LlcSingleMember = 'LLC_SINGLE_MEMBER',
    Partnership = 'PARTNERSHIP',
    SoleProprietorship = 'SOLE_PROPRIETORSHIP',
    TaxExemptCorporation = 'TAX_EXEMPT_CORPORATION',
    TaxExemptUnincorporatedBusiness = 'TAX_EXEMPT_UNINCORPORATED_BUSINESS',
    UnincorporatedBusiness = 'UNINCORPORATED_BUSINESS'
}

export enum IxcRegistrationV1ExemptPayeeCode {
    Unspecified = 'UNSPECIFIED',
    '1ExemptOrg' = '1_EXEMPT_ORG',
    '2UsGvt' = '2_US_GVT',
    '3StateGvt' = '3_STATE_GVT',
    '4FrgnGvt' = '4_FRGN_GVT',
    '5Corp' = '5_CORP',
    '6Dealer' = '6_DEALER',
    '7Fcm' = '7_FCM',
    '8Reit' = '8_REIT',
    '9InvmtCo' = '9_INVMT_CO',
    '10CommonTr' = '10_COMMON_TR',
    '11FinclInst' = '11_FINCL_INST',
    '12Nominee' = '12_NOMINEE',
    '13ExemptTr' = '13_EXEMPT_TR'
}

export interface IxcRegistrationV1Experience {
    // format: UINT32
    years: number;
    // format: UINT32
    transactionsPerYear: number;
}

export interface IxcRegistrationV1IndividualProfile {
    name: IxcRegistrationV1Name;
    email: string;
    phone: IxcRegistrationV1Phone[];
    /* Physical address of the individual. */
    physicalAddress: IxcRegistrationV1Address;
    /* If no mailing address is provided, the physical address will be used. */
    mailingAddress?: IxcRegistrationV1Address;
    /* Birth date in ISO 8601 format, e.g. "1969-04-20". */
    // format: YYYY-MM-DD
    birthDate: string;
    countryOfCitizenship: IsoV1Country;
    taxIdentifier: IxcRegistrationV1IndividualTaxIdentifier;
    maritalStatus?: IxcRegistrationV1MaritalStatus;
    employment: IxcRegistrationV1Employment;
    investmentProfile?: IxcRegistrationV1InvestmentProfile;
    affiliations?: IxcRegistrationV1Affiliations;
    trustedPersons?: IxcRegistrationV1TrustedPerson[];
    /* Individual or a member of their household is a program employee. */
    employee?: boolean;
    w9?: IxcRegistrationV1IndividualW9;
}

export interface IxcRegistrationV1IndividualSummary {
    name: IxcRegistrationV1Name;
}

export type IxcRegistrationV1IndividualTaxIdentifier = {
    '!type'?: 'ssn';
    ssn: IxcRegistrationV1IndividualTaxIdentifierSsn;
} | {
    '!type'?: 'itin';
    itin: IxcRegistrationV1IndividualTaxIdentifierItin;
};

export interface IxcRegistrationV1IndividualTaxIdentifierItin {
    /* Individual Taxpayer Identification Number (ITIN) in the format
    "9##-##-####". */
    // pattern: ^9\d{2}-\d{2}-\d{4}$
    number: string;
}

export interface IxcRegistrationV1IndividualTaxIdentifierSsn {
    /* Social Security Number (SSN) in the format "###-##-####". */
    // pattern: ^\d{3}-\d{2}-\d{4}$
    number: string;
}

export const IXC_REGISTRATION_V1_INDIVIDUAL_TAX_IDENTIFIER_ONE_OF_VALUES = ['ssn', 'itin'] as const;

export type IxcRegistrationV1IndividualTaxIdentifierOneOfValue = (typeof IXC_REGISTRATION_V1_INDIVIDUAL_TAX_IDENTIFIER_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1IndividualW9 {
    /* This individual is subject to withholding. */
    isSubjectToBackupWithholding?: boolean;
    /* Use Form W9 for US persons(including resident aliens). */
    certification: boolean;
    /* Date that Form W9 was signed. */
    // format: YYYY-MM-DD
    signed: string;
}

export interface IxcRegistrationV1InvestmentExperience {
    equities?: IxcRegistrationV1Experience;
    mutualFunds?: IxcRegistrationV1Experience;
    margin?: IxcRegistrationV1Experience;
    options?: IxcRegistrationV1OptionsExperience;
    bonds?: IxcRegistrationV1Experience;
    futures?: IxcRegistrationV1Experience;
}

export interface IxcRegistrationV1InvestmentProfile {
    // format: UINT32
    annualIncome: number;
    /* Net worth excluding value of primary residence. */
    // format: UINT32
    netWorth: number;
    // format: UINT32
    liquidNetWorth?: number;
    // format: UINT32
    usTaxRate?: number;
    investmentExperience?: IxcRegistrationV1InvestmentExperience;
}

export enum IxcRegistrationV1LiquidityNeeds {
    Unspecified = 'UNSPECIFIED',
    VeryImportant = 'VERY_IMPORTANT',
    Important = 'IMPORTANT',
    SomewhatImportant = 'SOMEWHAT_IMPORTANT',
    DoesNotMatter = 'DOES_NOT_MATTER'
}

export enum IxcRegistrationV1MaritalStatus {
    Unspecified = 'UNSPECIFIED',
    Single = 'SINGLE',
    Married = 'MARRIED',
    Divorced = 'DIVORCED',
    Widowed = 'WIDOWED',
    UnmarriedMinor = 'UNMARRIED_MINOR'
}

export interface IxcRegistrationV1Name {
    /* Prefix, e.g. Mx, Mr, Ms, Dr, etc. */
    prefix?: string;
    /* First name or given name. For persons with only one name (e.g. Madonna),
    or other names which do not fit well into this structure, put that name
    here. */
    first: string;
    /* Middle name(s), or initial, if any. */
    middle?: string;
    /* Last name, surname or family name. */
    last: string;
    /* Suffix, e.g. Jr, Sr, III. For multiple suffixes, use a single string with
    strings separated by spaces, e.g. "Jr Sr III". */
    suffix?: string;
    /* Preferred name to be used for display purposes, e.g. in email
    salutations. when not set will use first. */
    preferred?: string;
}

export interface IxcRegistrationV1NaturalPersonsProfile {
    person: IxcRegistrationV1Person;
    others?: IxcRegistrationV1Person[];
}

export enum IxcRegistrationV1Objectives {
    Unspecified = 'UNSPECIFIED',
    AccumulateWealth = 'ACCUMULATE_WEALTH',
    PreserveWealth = 'PRESERVE_WEALTH',
    GenerateIncome = 'GENERATE_INCOME',
    BalancedGrowthIncome = 'BALANCED_GROWTH_INCOME',
    Speculation = 'SPECULATION',
    EducationExpenses = 'EDUCATION_EXPENSES',
    HomePurchase = 'HOME_PURCHASE',
    LongTermCare = 'LONG_TERM_CARE',
    HealthcareExpenses = 'HEALTHCARE_EXPENSES',
    LargeExpense = 'LARGE_EXPENSE',
    CareerTransition = 'CAREER_TRANSITION',
    StartingBusiness = 'STARTING_BUSINESS',
    DebtReduction = 'DEBT_REDUCTION',
    EmergencyFunds = 'EMERGENCY_FUNDS',
    LearningToInvest = 'LEARNING_TO_INVEST',
    TaxEfficientInvesting = 'TAX_EFFICIENT_INVESTING',
    RetirementPlanning = 'RETIREMENT_PLANNING',
    EstatePlanning = 'ESTATE_PLANNING',
    CharitableGiving = 'CHARITABLE_GIVING'
}

export interface IxcRegistrationV1OptionsExperience {
    // format: UINT32
    years: number;
    // format: UINT32
    transactionsPerYear?: number;
    highestOptionStrategy: IxcRegistrationV1OptionsLevel;
}

export enum IxcRegistrationV1OptionsLevel {
    Unspecified = 'UNSPECIFIED',
    None = 'NONE',
    _1 = '1',
    _2 = '2',
    _3 = '3',
    _4 = '4',
    _5 = '5'
}

export interface IxcRegistrationV1Organization {
    countryOfIncorporation: IsoV1Country;
    controlPersons?: IxcRegistrationV1ControlPerson[];
    w9: IxcRegistrationV1OrganizationW9;
}

export interface IxcRegistrationV1OrganizationProfile {
    legalName: string;
    dbaName?: string;
    entityType?: IxcRegistrationV1EntityType;
    countryOfFormation: IsoV1Country;
    stateOfFormation?: IxcRegistrationV1UsState;
    // format: YYYY-MM-DD
    dateOfFormation?: string;
    /* Type of activities the organization is involved in and how revenue is generated. */
    natureOfBusiness: string;
    businessClassification: IxcRegistrationV1BusinessClassification;
    taxIdentifier: IxcRegistrationV1OrganizationTaxIdentifier;
    /* The legal address of the organization. */
    companyAddress: IxcRegistrationV1Address;
    /* If no mailing address is provided, the physical address will be used. */
    mailingAddress?: IxcRegistrationV1Address;
    /* phone_number is the phone number of the organization. */
    phone?: IxcRegistrationV1Phone[];
    /* Email address where account-related documents and notices are received. */
    email: string;
    /* At least 1 officer or director is required. */
    controlPersons?: IxcRegistrationV1ControlPerson[];
    /* Profile ID for the primary contact person of the organization. */
    // format: id62
    primaryContactProfileId?: string;
    w9: IxcRegistrationV1OrganizationW9;
}

export interface IxcRegistrationV1OrganizationSummary {
    legalName: string;
}

export type IxcRegistrationV1OrganizationTaxIdentifier = {
    '!type'?: 'ssn';
    ssn: IxcRegistrationV1OrganizationTaxIdentifierSsn;
} | {
    '!type'?: 'ein';
    ein: IxcRegistrationV1OrganizationTaxIdentifierEin;
};

export interface IxcRegistrationV1OrganizationTaxIdentifierEin {
    /* ein is the Employer Identification Number for the organization. See
    https://www.irs.gov/businesses/small-businesses-self-employed/employer-id-numbers */
    // pattern: ^\d{2}-\d{7}$
    number: string;
}

export interface IxcRegistrationV1OrganizationTaxIdentifierSsn {
    /* Social Security Number (SSN) in the format "###-##-####". */
    // pattern: ^\d{3}-\d{2}-\d{4}$
    number: string;
}

export const IXC_REGISTRATION_V1_ORGANIZATION_TAX_IDENTIFIER_ONE_OF_VALUES = ['ssn', 'ein'] as const;

export type IxcRegistrationV1OrganizationTaxIdentifierOneOfValue = (typeof IXC_REGISTRATION_V1_ORGANIZATION_TAX_IDENTIFIER_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1OrganizationW9 {
    /* This organization is subject to withholding. */
    isSubjectToBackupWithholding?: boolean;
    /* Applies to certain organizations. See Form W9 instructions. */
    exemptPayeeCode?: IxcRegistrationV1ExemptPayeeCode;
    /* Applies to certain partnership organizations. See Form W9 instructions. */
    foreignOwners?: boolean;
    /* Use Form W9 for organizations with US tax residence. */
    certification: boolean;
    /* Date that Form W9 was signed. */
    // format: YYYY-MM-DD
    signed: string;
}

export interface IxcRegistrationV1Person {
    nameDetails: IxcRegistrationV1Name;
    // format: YYYY-MM-DD
    birthDate: string;
    w9: IxcRegistrationV1IndividualW9;
}

export interface IxcRegistrationV1Phone {
    number: string;
    sms?: boolean;
    voice?: boolean;
    label?: string;
}

export interface IxcRegistrationV1Platform {
    exemptPayeeCode?: IxcRegistrationV1ExemptPayeeCode;
}

export interface IxcRegistrationV1PlatformAccount {
    owner: IxcRegistrationV1PlatformAccountOwner;
    profileSummaries?: IxcRegistrationV1ProfileSummary[];
    controls?: IxcRegistrationV1PlatformControls;
    checks?: IxcRegistrationV1AccountCheck[];
    nickname?: string;
}

export type IxcRegistrationV1PlatformAccountOwner = {
    '!type'?: 'program';
    program: IxcRegistrationV1PlatformAccountOwnerProgram;
} | {
    '!type'?: 'profile';
    profile: IxcRegistrationV1PlatformAccountOwnerProfile;
};

export interface IxcRegistrationV1PlatformAccountOwnerProfile {
    // format: id62, entity: ixc.registration.v1.Profile
    profileId: string;
    legalName: string;
    dbaName?: string;
    entityType?: IxcRegistrationV1EntityType;
    countryOfFormation: IsoV1Country;
    stateOfFormation?: IxcRegistrationV1UsState;
    // format: YYYY-MM-DD
    dateOfFormation?: string;
    /* Type of activities the organization is involved in and how revenue is generated. */
    natureOfBusiness: string;
    businessClassification: IxcRegistrationV1BusinessClassification;
    taxIdentifier: IxcRegistrationV1OrganizationTaxIdentifier;
    /* The legal address of the organization. */
    companyAddress: IxcRegistrationV1Address;
    /* If no mailing address is provided, the physical address will be used. */
    mailingAddress?: IxcRegistrationV1Address;
    /* phone_number is the phone number of the organization. */
    phone?: IxcRegistrationV1Phone[];
    /* Email address where account-related documents and notices are received. */
    email: string;
    /* At least 1 officer or director is required. */
    controlPersons?: IxcRegistrationV1ControlPerson[];
    /* Profile ID for the primary contact person of the organization. */
    // format: id62
    primaryContactProfileId?: string;
    w9: IxcRegistrationV1OrganizationW9;
}

export interface IxcRegistrationV1PlatformAccountOwnerProgram {
    legalName: string;
    // pattern: ^\d{2}-\d{7}$
    taxIdentifier: string;
    companyAddress: IxcRegistrationV1Address;
    mailingAddress?: IxcRegistrationV1Address;
    exemptPayeeCode?: IxcRegistrationV1ExemptPayeeCode;
}

export const IXC_REGISTRATION_V1_PLATFORM_ACCOUNT_OWNER_ONE_OF_VALUES = ['program', 'profile'] as const;

export type IxcRegistrationV1PlatformAccountOwnerOneOfValue = (typeof IXC_REGISTRATION_V1_PLATFORM_ACCOUNT_OWNER_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1PlatformControls {
    credit: IxcRegistrationV1PlatformControlsCredit;
}

export interface IxcRegistrationV1PlatformControlsCredit {
    /* Whether or not to skip credit checks when placing orders.
    Particularly for the inventory account. */
    settings?: IxcRegistrationV1PlatformControlsCreditSettings;
}

export interface IxcRegistrationV1PlatformControlsCreditSettings {
    skipCreditCheck?: boolean;
}

export type IxcRegistrationV1PlatformUpdate = {
    '!type'?: 'nickname';
    nickname: IxcRegistrationV1PlatformUpdateNickname;
};

export interface IxcRegistrationV1PlatformUpdateNickname {
    /* New display nickname for the account. */
    value: string;
}

export const IXC_REGISTRATION_V1_PLATFORM_UPDATE_ONE_OF_VALUES = ['nickname'] as const;

export type IxcRegistrationV1PlatformUpdateOneOfValue = (typeof IXC_REGISTRATION_V1_PLATFORM_UPDATE_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1PrincipalData {
    summary?: IxcRegistrationV1PrincipalSummary;
}

export interface IxcRegistrationV1PrincipalEvent extends IxcRegistrationV1PrincipalKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcRegistrationV1PrincipalEventType;
}

export type IxcRegistrationV1PrincipalEventType = {
    '!type'?: 'activated';
    activated: IxcRegistrationV1PrincipalEventTypeActivated;
} | {
    '!type'?: 'deactivated';
    deactivated: IxcRegistrationV1PrincipalEventTypeDeactivated;
};

export interface IxcRegistrationV1PrincipalEventTypeActivated {
    summary?: IxcRegistrationV1PrincipalSummary;
}

export interface IxcRegistrationV1PrincipalEventTypeDeactivated {
    summary?: IxcRegistrationV1PrincipalSummary;
}

export const IXC_REGISTRATION_V1_PRINCIPAL_EVENT_TYPE_ONE_OF_VALUES = ['activated', 'deactivated'] as const;

export type IxcRegistrationV1PrincipalEventTypeOneOfValue = (typeof IXC_REGISTRATION_V1_PRINCIPAL_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1PrincipalKeys {
    /* The user ID of a user designated to be a principal */
    // format: id62
    principalId: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
}

export interface IxcRegistrationV1PrincipalQueryServicePrincipalEventsPrincipalEventsRequest {
    /* The user ID of a user designated to be a principal */
    // format: id62
    principalId: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcRegistrationV1PrincipalQueryServicePrincipalEventsSortableFields, IxcRegistrationV1PrincipalQueryServicePrincipalEventsFilterableFields>;
}

export enum IxcRegistrationV1PrincipalQueryServicePrincipalEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    PrincipalId = 'principalId',
    ProgramId = 'programId',
    EventType = 'event.!type'
}

export enum IxcRegistrationV1PrincipalQueryServicePrincipalEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcRegistrationV1PrincipalQueryServicePrincipalGetPrincipalGetRequest {
    /* The user ID of a user designated to be a principal */
    // format: id62
    principalId: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
}

export interface IxcRegistrationV1PrincipalQueryServicePrincipalListPrincipalListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcRegistrationV1PrincipalQueryServicePrincipalListSortableFields, IxcRegistrationV1PrincipalQueryServicePrincipalListFilterableFields>;
}

export enum IxcRegistrationV1PrincipalQueryServicePrincipalListFilterableFields {
    PrincipalId = 'principalId',
    ProgramId = 'programId',
    Status = 'status'
}

export enum IxcRegistrationV1PrincipalQueryServicePrincipalListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcRegistrationV1PrincipalState extends IxcRegistrationV1PrincipalKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcRegistrationV1PrincipalData;
    status: IxcRegistrationV1PrincipalStatus;
}

export enum IxcRegistrationV1PrincipalStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Inactive = 'INACTIVE'
}

export interface IxcRegistrationV1PrincipalSummary {
    name?: string;
}

export interface IxcRegistrationV1ProfileCheck {
    // format: id62
    checkId: string;
    checkType: IxcRegistrationV1ProfileCheckType;
    screeningTrigger?: IxcRegistrationV1ScreeningTrigger;
}

export type IxcRegistrationV1ProfileCheckType = {
    '!type'?: 'cipIdentityMinimal';
    /* Only need to know when the check was done by program. */
    cipIdentityMinimal: IxcRegistrationV1ProfileCheckTypeCipIdentityMinimal;
} | {
    '!type'?: 'cipIdentity';
    /* Basic identity verification handled by program. */
    cipIdentity: IxcRegistrationV1ProfileCheckTypeCipIdentity;
} | {
    '!type'?: 'cipOfacMinimal';
    /* Only need to know when the check was done by program. */
    cipOfacMinimal: IxcRegistrationV1ProfileCheckTypeCipOfacMinimal;
} | {
    '!type'?: 'cipOfac';
    /* Sanctions screening by program */
    cipOfac: IxcRegistrationV1ProfileCheckTypeCipOfac;
} | {
    '!type'?: 'clearingManualProfileApproval';
    /* Manual Interchange review */
    clearingManualProfileApproval: IxcRegistrationV1ProfileCheckTypeClearingManualProfileApproval;
};

export interface IxcRegistrationV1ProfileCheckTypeCipIdentity {
    evidence?: IxcRegistrationV1CipIdentityEvidence;
}

export interface IxcRegistrationV1ProfileCheckTypeCipIdentityMinimal {
    evidence?: IxcRegistrationV1CipIdentityMinimalEvidence;
}

export interface IxcRegistrationV1ProfileCheckTypeCipOfac {
    evidence?: IxcRegistrationV1CipOfacEvidence;
}

export interface IxcRegistrationV1ProfileCheckTypeCipOfacMinimal {
    evidence?: IxcRegistrationV1CipOfacMinimalEvidence;
}

export interface IxcRegistrationV1ProfileCheckTypeClearingManualProfileApproval {
    evidence?: IxcRegistrationV1ClearingManualProfileApprovalEvidence;
}

export const IXC_REGISTRATION_V1_PROFILE_CHECK_TYPE_ONE_OF_VALUES = ['cipIdentityMinimal', 'cipIdentity', 'cipOfacMinimal', 'cipOfac', 'clearingManualProfileApproval'] as const;

export type IxcRegistrationV1ProfileCheckTypeOneOfValue = (typeof IXC_REGISTRATION_V1_PROFILE_CHECK_TYPE_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1ProfileData {
    /* Active profile data */
    currentVersion?: IxcRegistrationV1ProfileVersion;
    /* Profile data update under review */
    pendingVersion?: IxcRegistrationV1ProfileVersion;
    /* Specific accounting group used when the profile opens an account */
    accountingGroup?: IxcRegistrationV1AccountingGroup;
}

export interface IxcRegistrationV1ProfileEvent extends IxcRegistrationV1ProfileKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcRegistrationV1ProfileEventType;
}

export type IxcRegistrationV1ProfileEventType = {
    '!type'?: 'created';
    created: IxcRegistrationV1ProfileEventTypeCreated;
} | {
    '!type'?: 'updateRequested';
    updateRequested: IxcRegistrationV1ProfileEventTypeUpdateRequested;
} | {
    '!type'?: 'versionApproved';
    versionApproved: IxcRegistrationV1ProfileEventTypeVersionApproved;
} | {
    '!type'?: 'resultUpdated';
    resultUpdated: IxcRegistrationV1ProfileEventTypeResultUpdated;
} | {
    '!type'?: 'versionRejected';
    versionRejected: IxcRegistrationV1ProfileEventTypeVersionRejected;
} | {
    '!type'?: 'accountingGroupSet';
    accountingGroupSet: IxcRegistrationV1ProfileEventTypeAccountingGroupSet;
} | {
    '!type'?: 'updateRolledBack';
    updateRolledBack: EmptyObject;
};

export interface IxcRegistrationV1ProfileEventTypeAccountingGroupSet {
    accountGroup: IxcRegistrationV1AccountingGroup;
}

export interface IxcRegistrationV1ProfileEventTypeCreated {
    version: IxcRegistrationV1ProfileVersion;
    checks?: IxcRegistrationV1ProfileCheck[];
}

export interface IxcRegistrationV1ProfileEventTypeResultUpdated {
    // format: id62
    profileVersionId: string;
    checks?: IxcRegistrationV1ProfileCheck[];
}

export interface IxcRegistrationV1ProfileEventTypeUpdateRequested {
    // format: id62
    replacesProfileVersionId: string;
    newVersion: IxcRegistrationV1ProfileVersion;
    checks?: IxcRegistrationV1ProfileCheck[];
}

export interface IxcRegistrationV1ProfileEventTypeVersionApproved {
    // format: id62
    profileVersionId: string;
}

export interface IxcRegistrationV1ProfileEventTypeVersionRejected {
    // format: id62
    profileVersionId: string;
}

export const IXC_REGISTRATION_V1_PROFILE_EVENT_TYPE_ONE_OF_VALUES = ['created', 'updateRequested', 'versionApproved', 'resultUpdated', 'versionRejected', 'accountingGroupSet', 'updateRolledBack'] as const;

export type IxcRegistrationV1ProfileEventTypeOneOfValue = (typeof IXC_REGISTRATION_V1_PROFILE_EVENT_TYPE_ONE_OF_VALUES)[number];

export type IxcRegistrationV1ProfileEvidence = {
    '!type'?: 'cipIdentityEvidence';
    cipIdentityEvidence: IxcRegistrationV1CipIdentityEvidence;
} | {
    '!type'?: 'cipOfacEvidence';
    cipOfacEvidence: IxcRegistrationV1CipOfacEvidence;
} | {
    '!type'?: 'cipIdentityMinimalEvidence';
    cipIdentityMinimalEvidence: IxcRegistrationV1CipIdentityMinimalEvidence;
} | {
    '!type'?: 'cipOfacMinimalEvidence';
    cipOfacMinimalEvidence: IxcRegistrationV1CipOfacMinimalEvidence;
};

export const IXC_REGISTRATION_V1_PROFILE_EVIDENCE_ONE_OF_VALUES = ['cipIdentityEvidence', 'cipOfacEvidence', 'cipIdentityMinimalEvidence', 'cipOfacMinimalEvidence'] as const;

export type IxcRegistrationV1ProfileEvidenceOneOfValue = (typeof IXC_REGISTRATION_V1_PROFILE_EVIDENCE_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1ProfileKeys {
    /* Primary identifier */
    // format: id62
    profileId: string;
    /* Associated Broker-Dealer program */
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
}

export interface IxcRegistrationV1ProfileQueryServiceProfileEventsProfileEventsRequest {
    /* Primary identifier */
    // format: id62
    profileId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcRegistrationV1ProfileQueryServiceProfileEventsSearchableFields, IxcRegistrationV1ProfileQueryServiceProfileEventsSortableFields, IxcRegistrationV1ProfileQueryServiceProfileEventsFilterableFields>;
}

export enum IxcRegistrationV1ProfileQueryServiceProfileEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    ProfileId = 'profileId',
    ProgramId = 'programId',
    EventCreatedVersionProfileIndividualW9Signed = 'event.created.version.profile.individual.w9.signed',
    EventCreatedVersionProfileOrganizationW9Signed = 'event.created.version.profile.organization.w9.signed',
    EventCreatedVersionProfileType = 'event.created.version.profile.!type',
    EventUpdateRequestedNewVersionProfileIndividualW9Signed = 'event.updateRequested.newVersion.profile.individual.w9.signed',
    EventUpdateRequestedNewVersionProfileOrganizationW9Signed = 'event.updateRequested.newVersion.profile.organization.w9.signed',
    EventUpdateRequestedNewVersionProfileType = 'event.updateRequested.newVersion.profile.!type',
    EventType = 'event.!type'
}

export enum IxcRegistrationV1ProfileQueryServiceProfileEventsSearchableFields {
    EventCreatedVersionProfileIndividualNameFirst = 'event.created.version.profile.individual.name.first',
    EventCreatedVersionProfileIndividualNameLast = 'event.created.version.profile.individual.name.last',
    EventCreatedVersionProfileIndividualAffiliationsAssociatedPersonsNameFirst = 'event.created.version.profile.individual.affiliations.associatedPersons.name.first',
    EventCreatedVersionProfileIndividualAffiliationsAssociatedPersonsNameLast = 'event.created.version.profile.individual.affiliations.associatedPersons.name.last',
    EventCreatedVersionProfileIndividualTrustedPersonsNameFirst = 'event.created.version.profile.individual.trustedPersons.name.first',
    EventCreatedVersionProfileIndividualTrustedPersonsNameLast = 'event.created.version.profile.individual.trustedPersons.name.last',
    EventCreatedVersionProfileOrganizationLegalName = 'event.created.version.profile.organization.legalName',
    EventCreatedVersionProfileOrganizationDbaName = 'event.created.version.profile.organization.dbaName',
    EventUpdateRequestedNewVersionProfileIndividualNameFirst = 'event.updateRequested.newVersion.profile.individual.name.first',
    EventUpdateRequestedNewVersionProfileIndividualNameLast = 'event.updateRequested.newVersion.profile.individual.name.last',
    EventUpdateRequestedNewVersionProfileIndividualAffiliationsAssociatedPersonsNameFirst = 'event.updateRequested.newVersion.profile.individual.affiliations.associatedPersons.name.first',
    EventUpdateRequestedNewVersionProfileIndividualAffiliationsAssociatedPersonsNameLast = 'event.updateRequested.newVersion.profile.individual.affiliations.associatedPersons.name.last',
    EventUpdateRequestedNewVersionProfileIndividualTrustedPersonsNameFirst = 'event.updateRequested.newVersion.profile.individual.trustedPersons.name.first',
    EventUpdateRequestedNewVersionProfileIndividualTrustedPersonsNameLast = 'event.updateRequested.newVersion.profile.individual.trustedPersons.name.last',
    EventUpdateRequestedNewVersionProfileOrganizationLegalName = 'event.updateRequested.newVersion.profile.organization.legalName',
    EventUpdateRequestedNewVersionProfileOrganizationDbaName = 'event.updateRequested.newVersion.profile.organization.dbaName'
}

export enum IxcRegistrationV1ProfileQueryServiceProfileEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcRegistrationV1ProfileQueryServiceProfileGetProfileGetRequest {
    /* Primary identifier */
    // format: id62
    profileId: string;
}

export interface IxcRegistrationV1ProfileQueryServiceProfileListProfileListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcRegistrationV1ProfileQueryServiceProfileListSearchableFields, IxcRegistrationV1ProfileQueryServiceProfileListSortableFields, IxcRegistrationV1ProfileQueryServiceProfileListFilterableFields>;
}

export enum IxcRegistrationV1ProfileQueryServiceProfileListFilterableFields {
    ProfileId = 'profileId',
    ProgramId = 'programId',
    DataCurrentVersionProfileIndividualW9Signed = 'data.currentVersion.profile.individual.w9.signed',
    DataCurrentVersionProfileOrganizationW9Signed = 'data.currentVersion.profile.organization.w9.signed',
    DataCurrentVersionProfileType = 'data.currentVersion.profile.!type',
    DataPendingVersionProfileIndividualW9Signed = 'data.pendingVersion.profile.individual.w9.signed',
    DataPendingVersionProfileOrganizationW9Signed = 'data.pendingVersion.profile.organization.w9.signed',
    DataPendingVersionProfileType = 'data.pendingVersion.profile.!type',
    Status = 'status'
}

export enum IxcRegistrationV1ProfileQueryServiceProfileListSearchableFields {
    DataCurrentVersionProfileIndividualNameFirst = 'data.currentVersion.profile.individual.name.first',
    DataCurrentVersionProfileIndividualNameLast = 'data.currentVersion.profile.individual.name.last',
    DataCurrentVersionProfileIndividualAffiliationsAssociatedPersonsNameFirst = 'data.currentVersion.profile.individual.affiliations.associatedPersons.name.first',
    DataCurrentVersionProfileIndividualAffiliationsAssociatedPersonsNameLast = 'data.currentVersion.profile.individual.affiliations.associatedPersons.name.last',
    DataCurrentVersionProfileIndividualTrustedPersonsNameFirst = 'data.currentVersion.profile.individual.trustedPersons.name.first',
    DataCurrentVersionProfileIndividualTrustedPersonsNameLast = 'data.currentVersion.profile.individual.trustedPersons.name.last',
    DataCurrentVersionProfileOrganizationLegalName = 'data.currentVersion.profile.organization.legalName',
    DataCurrentVersionProfileOrganizationDbaName = 'data.currentVersion.profile.organization.dbaName',
    DataPendingVersionProfileIndividualNameFirst = 'data.pendingVersion.profile.individual.name.first',
    DataPendingVersionProfileIndividualNameLast = 'data.pendingVersion.profile.individual.name.last',
    DataPendingVersionProfileIndividualAffiliationsAssociatedPersonsNameFirst = 'data.pendingVersion.profile.individual.affiliations.associatedPersons.name.first',
    DataPendingVersionProfileIndividualAffiliationsAssociatedPersonsNameLast = 'data.pendingVersion.profile.individual.affiliations.associatedPersons.name.last',
    DataPendingVersionProfileIndividualTrustedPersonsNameFirst = 'data.pendingVersion.profile.individual.trustedPersons.name.first',
    DataPendingVersionProfileIndividualTrustedPersonsNameLast = 'data.pendingVersion.profile.individual.trustedPersons.name.last',
    DataPendingVersionProfileOrganizationLegalName = 'data.pendingVersion.profile.organization.legalName',
    DataPendingVersionProfileOrganizationDbaName = 'data.pendingVersion.profile.organization.dbaName'
}

export enum IxcRegistrationV1ProfileQueryServiceProfileListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcRegistrationV1ProfileState extends IxcRegistrationV1ProfileKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcRegistrationV1ProfileData;
    status: IxcRegistrationV1ProfileStatus;
}

export enum IxcRegistrationV1ProfileStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Active = 'ACTIVE'
}

export interface IxcRegistrationV1ProfileSummary {
    // format: id62
    profileId: string;
    status: IxcRegistrationV1ProfileStatus;
    data: IxcRegistrationV1ProfileSummaryData;
}

export type IxcRegistrationV1ProfileSummaryData = {
    '!type'?: 'individual';
    individual: IxcRegistrationV1IndividualSummary;
} | {
    '!type'?: 'organization';
    organization: IxcRegistrationV1OrganizationSummary;
};

export const IXC_REGISTRATION_V1_PROFILE_SUMMARY_DATA_ONE_OF_VALUES = ['individual', 'organization'] as const;

export type IxcRegistrationV1ProfileSummaryDataOneOfValue = (typeof IXC_REGISTRATION_V1_PROFILE_SUMMARY_DATA_ONE_OF_VALUES)[number];

export type IxcRegistrationV1ProfileType = {
    '!type'?: 'individual';
    individual: IxcRegistrationV1IndividualProfile;
} | {
    '!type'?: 'organization';
    organization: IxcRegistrationV1OrganizationProfile;
};

export const IXC_REGISTRATION_V1_PROFILE_TYPE_ONE_OF_VALUES = ['individual', 'organization'] as const;

export type IxcRegistrationV1ProfileTypeOneOfValue = (typeof IXC_REGISTRATION_V1_PROFILE_TYPE_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1ProfileVersion {
    // format: id62
    profileVersionId: string;
    profile: IxcRegistrationV1ProfileType;
    /* Profile verification requirements vary by program configuration. */
    checks?: IxcRegistrationV1ProfileCheck[];
}

export interface IxcRegistrationV1ProfileVersionData {
    profile: IxcRegistrationV1ProfileType;
    checks?: IxcRegistrationV1ProfileCheck[];
}

export interface IxcRegistrationV1ProfileVersionEvent extends IxcRegistrationV1ProfileVersionKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcRegistrationV1ProfileVersionEventType;
}

export type IxcRegistrationV1ProfileVersionEventType = {
    '!type'?: 'created';
    created: IxcRegistrationV1ProfileVersionEventTypeCreated;
} | {
    '!type'?: 'checkResult';
    checkResult: IxcRegistrationV1ProfileVersionEventTypeCheckResult;
} | {
    '!type'?: 'clearingCheckResult';
    clearingCheckResult: IxcRegistrationV1ProfileVersionEventTypeClearingCheckResult;
} | {
    '!type'?: 'checksPassed';
    checksPassed: EmptyObject;
} | {
    '!type'?: 'rejected';
    rejected: IxcRegistrationV1ProfileVersionEventTypeRejected;
} | {
    '!type'?: 'canceled';
    canceled: IxcRegistrationV1ProfileVersionEventTypeCanceled;
};

export interface IxcRegistrationV1ProfileVersionEventTypeCanceled {
    // format: id62
    replacedBy?: string;
}

export interface IxcRegistrationV1ProfileVersionEventTypeCheckResult {
    // format: id62
    checkId: string;
    evidence: IxcRegistrationV1ProfileEvidence;
    screeningTrigger?: IxcRegistrationV1ScreeningTrigger;
}

export interface IxcRegistrationV1ProfileVersionEventTypeClearingCheckResult {
    // format: id62
    checkId: string;
    evidence: IxcRegistrationV1ClearingProfileEvidence;
}

export interface IxcRegistrationV1ProfileVersionEventTypeCreated {
    profile: IxcRegistrationV1ProfileType;
    requiredChecks?: IxcRegistrationV1ProfileCheck[];
}

export interface IxcRegistrationV1ProfileVersionEventTypeRejected {
    reason?: string;
}

export const IXC_REGISTRATION_V1_PROFILE_VERSION_EVENT_TYPE_ONE_OF_VALUES = ['created', 'checkResult', 'clearingCheckResult', 'checksPassed', 'rejected', 'canceled'] as const;

export type IxcRegistrationV1ProfileVersionEventTypeOneOfValue = (typeof IXC_REGISTRATION_V1_PROFILE_VERSION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1ProfileVersionKeys {
    // format: id62
    profileVersionId: string;
    // format: id62, entity: ixc.registration.v1.Profile
    profileId: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
}

export interface IxcRegistrationV1ProfileVersionQueryServiceProfileVersionEventsProfileVersionEventsRequest {
    // format: id62
    profileVersionId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcRegistrationV1ProfileVersionQueryServiceProfileVersionEventsSearchableFields, IxcRegistrationV1ProfileVersionQueryServiceProfileVersionEventsSortableFields, IxcRegistrationV1ProfileVersionQueryServiceProfileVersionEventsFilterableFields>;
}

export enum IxcRegistrationV1ProfileVersionQueryServiceProfileVersionEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    ProfileVersionId = 'profileVersionId',
    ProfileId = 'profileId',
    ProgramId = 'programId',
    EventCreatedProfileIndividualW9Signed = 'event.created.profile.individual.w9.signed',
    EventCreatedProfileOrganizationW9Signed = 'event.created.profile.organization.w9.signed',
    EventType = 'event.!type'
}

export enum IxcRegistrationV1ProfileVersionQueryServiceProfileVersionEventsSearchableFields {
    EventCreatedProfileIndividualNameFirst = 'event.created.profile.individual.name.first',
    EventCreatedProfileIndividualNameLast = 'event.created.profile.individual.name.last',
    EventCreatedProfileIndividualAffiliationsAssociatedPersonsNameFirst = 'event.created.profile.individual.affiliations.associatedPersons.name.first',
    EventCreatedProfileIndividualAffiliationsAssociatedPersonsNameLast = 'event.created.profile.individual.affiliations.associatedPersons.name.last',
    EventCreatedProfileIndividualTrustedPersonsNameFirst = 'event.created.profile.individual.trustedPersons.name.first',
    EventCreatedProfileIndividualTrustedPersonsNameLast = 'event.created.profile.individual.trustedPersons.name.last',
    EventCreatedProfileOrganizationLegalName = 'event.created.profile.organization.legalName',
    EventCreatedProfileOrganizationDbaName = 'event.created.profile.organization.dbaName'
}

export enum IxcRegistrationV1ProfileVersionQueryServiceProfileVersionEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcRegistrationV1ProfileVersionQueryServiceProfileVersionGetProfileVersionGetRequest {
    // format: id62
    profileVersionId: string;
}

export interface IxcRegistrationV1ProfileVersionQueryServiceProfileVersionListProfileVersionListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcRegistrationV1ProfileVersionQueryServiceProfileVersionListSearchableFields, IxcRegistrationV1ProfileVersionQueryServiceProfileVersionListSortableFields, IxcRegistrationV1ProfileVersionQueryServiceProfileVersionListFilterableFields>;
}

export enum IxcRegistrationV1ProfileVersionQueryServiceProfileVersionListFilterableFields {
    ProfileVersionId = 'profileVersionId',
    ProfileId = 'profileId',
    ProgramId = 'programId',
    DataProfileIndividualW9Signed = 'data.profile.individual.w9.signed',
    DataProfileOrganizationW9Signed = 'data.profile.organization.w9.signed',
    Status = 'status'
}

export enum IxcRegistrationV1ProfileVersionQueryServiceProfileVersionListSearchableFields {
    DataProfileIndividualNameFirst = 'data.profile.individual.name.first',
    DataProfileIndividualNameLast = 'data.profile.individual.name.last',
    DataProfileIndividualAffiliationsAssociatedPersonsNameFirst = 'data.profile.individual.affiliations.associatedPersons.name.first',
    DataProfileIndividualAffiliationsAssociatedPersonsNameLast = 'data.profile.individual.affiliations.associatedPersons.name.last',
    DataProfileIndividualTrustedPersonsNameFirst = 'data.profile.individual.trustedPersons.name.first',
    DataProfileIndividualTrustedPersonsNameLast = 'data.profile.individual.trustedPersons.name.last',
    DataProfileOrganizationLegalName = 'data.profile.organization.legalName',
    DataProfileOrganizationDbaName = 'data.profile.organization.dbaName'
}

export enum IxcRegistrationV1ProfileVersionQueryServiceProfileVersionListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcRegistrationV1ProfileVersionState extends IxcRegistrationV1ProfileVersionKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcRegistrationV1ProfileVersionData;
    status: IxcRegistrationV1ProfileVersionStatus;
}

export enum IxcRegistrationV1ProfileVersionStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
    Canceled = 'CANCELED',
    Approved = 'APPROVED'
}

export interface IxcRegistrationV1ProgramApprovalEvidence {
    // format: id62
    principalId: string;
    // format: date-time
    timestamp: string;
    outcome: IxcRegistrationV1CheckOutcome;
}

export interface IxcRegistrationV1ProgramControls {
    funding: IxcRegistrationV1ProgramControlsFunding;
    accountNumbers?: IxcRegistrationV1ProgramControlsAccountNumbers;
    order: IxcRegistrationV1ProgramControlsOrder;
    registration: IxcRegistrationV1ProgramControlsRegistration;
    sweeps?: IxcRegistrationV1ProgramControlsSweeps;
    /* Controls for Instant Deposit — advancing a portion of an incoming
    Transfer deposit to the account's buying power before the deposit
    settles. When absent, Instant Deposit is disabled for this account. */
    instantDeposit?: IxcRegistrationV1ProgramControlsInstantDeposit;
    batchOrder?: IxcRegistrationV1ProgramControlsBatchOrder;
}

export interface IxcRegistrationV1ProgramControlsAccountNumbers {
    settings: IxcRegistrationV1ProgramControlsAccountNumbersSettings;
}

export interface IxcRegistrationV1ProgramControlsAccountNumbersSettings {
    /* If true, accounts are able to create an Account Number */
    canCreate?: boolean;
}

export interface IxcRegistrationV1ProgramControlsBatchOrder {
    settings: IxcRegistrationV1ProgramControlsBatchOrderSettings;
}

export interface IxcRegistrationV1ProgramControlsBatchOrderSettings {
    usEquities: IxcRegistrationV1ProgramControlsBatchOrderSettingsUsEquities;
}

export interface IxcRegistrationV1ProgramControlsBatchOrderSettingsUsEquities {
    canPlaceBatchOrders?: boolean;
}

export interface IxcRegistrationV1ProgramControlsFunding {
    limits: IxcRegistrationV1ProgramControlsFundingLimits;
    settings: IxcRegistrationV1ProgramControlsFundingSettings;
}

export interface IxcRegistrationV1ProgramControlsFundingLimits {
    /* The maximum number of funding sources that can be added to the account. If unset, the account can add unlimited funding sources. */
    // format: UINT32
    maxSources?: number;
    /* Limits whether the account can use ACH to deposit or withdraw
    funds, the USD-denoted quantities for each transfer. */
    ach?: IxcRegistrationV1ProgramControlsFundingLimitsAch;
    /* Limits whether the account can use same-day ACH to deposit or
    withdraw funds, the USD-denoted quantities for each transfer. */
    sameDayAch?: IxcRegistrationV1ProgramControlsFundingLimitsSameDayAch;
    /* Limits whether the account can use wires to withdraw funds, the
    USD-denoted quantities for each transfer, and access to other
    features. */
    wire?: IxcRegistrationV1ProgramControlsFundingLimitsWire;
}

export interface IxcRegistrationV1ProgramControlsFundingLimitsAch {
    /* If unset, the account cannot deposit funds via ACH. */
    depositPerTransaction?: IxcRegistrationV1AccountFundingAmountLimits;
    /* If unset, the account cannot withdraw funds via ACH. */
    withdrawalPerTransaction?: IxcRegistrationV1AccountFundingAmountLimits;
}

export interface IxcRegistrationV1ProgramControlsFundingLimitsSameDayAch {
    /* If unset, the account cannot deposit funds via same-day ACH. */
    depositPerTransaction?: IxcRegistrationV1AccountFundingAmountLimits;
    /* If unset, the account cannot withdraw funds via same-day ACH. */
    withdrawalPerTransaction?: IxcRegistrationV1AccountFundingAmountLimits;
}

export interface IxcRegistrationV1ProgramControlsFundingLimitsWire {
    /* If unset, the account cannot withdraw funds via wire. */
    withdrawalPerTransaction?: IxcRegistrationV1AccountFundingAmountLimits;
}

export interface IxcRegistrationV1ProgramControlsFundingSettings {
    ach: IxcRegistrationV1ProgramControlsFundingSettingsAch;
    sameDayAch: IxcRegistrationV1ProgramControlsFundingSettingsSameDayAch;
    wire: IxcRegistrationV1ProgramControlsFundingSettingsWire;
}

export interface IxcRegistrationV1ProgramControlsFundingSettingsAch {
    canDeposit?: boolean;
    canWithdraw?: boolean;
}

export interface IxcRegistrationV1ProgramControlsFundingSettingsSameDayAch {
    canDeposit?: boolean;
    canWithdraw?: boolean;
}

export interface IxcRegistrationV1ProgramControlsFundingSettingsWire {
    canWithdraw?: boolean;
}

export interface IxcRegistrationV1ProgramControlsInstantDeposit {
    settings: IxcRegistrationV1ProgramControlsInstantDepositSettings;
    limits?: IxcRegistrationV1ProgramControlsInstantDepositLimits;
}

export interface IxcRegistrationV1ProgramControlsInstantDepositLimits {
    /* The maximum total outstanding advance for this account, in USD,
    across all in-flight ACH deposits at any given time. Cannot be
    set in excess of the program's maxAdvancePerAccount at the time
    it is configured. Changes to the program's limit do not
    automatically cascade to existing account limits. */
    // format: decimal
    maxAdvance?: string;
}

export interface IxcRegistrationV1ProgramControlsInstantDepositSettings {
    /* Whether this account may receive Instant Deposit advances on
    incoming transfer deposits. */
    canUseAdvance?: boolean;
}

export interface IxcRegistrationV1ProgramControlsOrder {
    settings: IxcRegistrationV1ProgramControlsOrderSettings;
}

export interface IxcRegistrationV1ProgramControlsOrderSettings {
    usEquities: IxcRegistrationV1ProgramControlsOrderSettingsUsEquities;
}

export interface IxcRegistrationV1ProgramControlsOrderSettingsUsEquities {
    /* Whether the account can close existing positions (e.g., placing a sell order to close a long position, or a buy order to close a short position). */
    canPlaceClosing?: boolean;
    /* Whether the account can open new positions (e.g., placing a buy order to open a long position, or a sell order to open a short position). */
    canPlaceOpening?: boolean;
    canTradeFractions?: boolean;
}

export interface IxcRegistrationV1ProgramControlsRegistration {
    settings: IxcRegistrationV1ProgramControlsRegistrationSettings;
}

export interface IxcRegistrationV1ProgramControlsRegistrationSettings {
    marginType: IxcRegistrationV1ControlsMarginType;
}

export interface IxcRegistrationV1ProgramControlsSweeps {
    settings: IxcRegistrationV1ProgramControlsSweepsSettings;
}

export interface IxcRegistrationV1ProgramControlsSweepsSettings {
    /* Whether the account can use sweeps. */
    canSweepAccount?: boolean;
    /* Optional override of the program's default sweep plan for this
    account. Must be in the program's eligible sweep plans list. When
    unset, the account uses the program's default sweep plan. */
    // format: id62, entity: ixc.sweeps.v1.SweepPlan
    sweepPlanId?: string;
}

export enum IxcRegistrationV1Purpose {
    Unspecified = 'UNSPECIFIED',
    Customer = 'CUSTOMER',
    Inventory = 'INVENTORY',
    TradeError = 'TRADE_ERROR',
    Billing = 'BILLING',
    Deposit = 'DEPOSIT',
    Settlement = 'SETTLEMENT',
    AveragePrice = 'AVERAGE_PRICE',
    Special = 'SPECIAL'
}

export type IxcRegistrationV1PurposeSpec = {
    '!type'?: 'customer';
    customer: IxcRegistrationV1CustomerAccount;
} | {
    '!type'?: 'platform';
    platform: IxcRegistrationV1PlatformAccount;
};

export const IXC_REGISTRATION_V1_PURPOSE_SPEC_ONE_OF_VALUES = ['customer', 'platform'] as const;

export type IxcRegistrationV1PurposeSpecOneOfValue = (typeof IXC_REGISTRATION_V1_PURPOSE_SPEC_ONE_OF_VALUES)[number];

export type IxcRegistrationV1PurposeSummary = {
    '!type'?: 'registration';
    registration: IxcRegistrationV1RegistrationSummary;
} | {
    '!type'?: 'platform';
    platform: IxcRegistrationV1Platform;
};

export const IXC_REGISTRATION_V1_PURPOSE_SUMMARY_ONE_OF_VALUES = ['registration', 'platform'] as const;

export type IxcRegistrationV1PurposeSummaryOneOfValue = (typeof IXC_REGISTRATION_V1_PURPOSE_SUMMARY_ONE_OF_VALUES)[number];

export enum IxcRegistrationV1RegistrationAccountType {
    Unspecified = 'UNSPECIFIED',
    Individual = 'INDIVIDUAL',
    Organization = 'ORGANIZATION',
    Joint = 'JOINT',
    Custodial = 'CUSTODIAL',
    Ira = 'IRA',
    RothIra = 'ROTH_IRA',
    SepIra = 'SEP_IRA',
    SimpleIra = 'SIMPLE_IRA'
}

export type IxcRegistrationV1RegistrationDetails = {
    '!type'?: 'individual';
    individual: IxcRegistrationV1RegistrationDetailsIndividual;
} | {
    '!type'?: 'custodial';
    custodial: IxcRegistrationV1RegistrationDetailsCustodial;
} | {
    '!type'?: 'joint';
    joint: IxcRegistrationV1RegistrationDetailsJoint;
};

export interface IxcRegistrationV1RegistrationDetailsCustodial {
    governingEntity: IxcRegistrationV1UsState;
    right: IxcRegistrationV1Right;
}

export interface IxcRegistrationV1RegistrationDetailsIndividual {
    transferOnDeath?: boolean;
}

export interface IxcRegistrationV1RegistrationDetailsJoint {
    right: IxcRegistrationV1Right;
    transferOnDeath?: boolean;
}

export const IXC_REGISTRATION_V1_REGISTRATION_DETAILS_ONE_OF_VALUES = ['individual', 'custodial', 'joint'] as const;

export type IxcRegistrationV1RegistrationDetailsOneOfValue = (typeof IXC_REGISTRATION_V1_REGISTRATION_DETAILS_ONE_OF_VALUES)[number];

export interface IxcRegistrationV1RegistrationSummary {
    type: IxcRegistrationV1RegistrationType;
    profile: IxcRegistrationV1BasicProfile;
    details?: IxcRegistrationV1RegistrationDetails;
}

export enum IxcRegistrationV1RegistrationType {
    Unspecified = 'UNSPECIFIED',
    Individual = 'INDIVIDUAL',
    Organization = 'ORGANIZATION',
    Joint = 'JOINT',
    Custodial = 'CUSTODIAL',
    Ira = 'IRA',
    RothIra = 'ROTH_IRA',
    SepIra = 'SEP_IRA',
    SimpleIra = 'SIMPLE_IRA'
}

export enum IxcRegistrationV1Relationship {
    Unspecified = 'UNSPECIFIED',
    Spouse = 'SPOUSE',
    Other = 'OTHER'
}

export enum IxcRegistrationV1Right {
    Unspecified = 'UNSPECIFIED',
    Jtwros = 'JTWROS',
    Tic = 'TIC',
    Utma = 'UTMA',
    Ugma = 'UGMA'
}

export interface IxcRegistrationV1RiskProfile {
    riskTolerance?: IxcRegistrationV1RiskTolerance;
    liquidityNeeds?: IxcRegistrationV1LiquidityNeeds;
    // format: UINT32
    investmentHorizonYears?: number;
    // format: UINT32
    percentageOfAllInvestments?: number;
    objectives: IxcRegistrationV1Objectives;
}

export enum IxcRegistrationV1RiskTolerance {
    Unspecified = 'UNSPECIFIED',
    Conservative = 'CONSERVATIVE',
    ModeratelyConservative = 'MODERATELY_CONSERVATIVE',
    Moderate = 'MODERATE',
    ModeratelyAggressive = 'MODERATELY_AGGRESSIVE',
    SignificantRisk = 'SIGNIFICANT_RISK'
}

export enum IxcRegistrationV1ScreeningTrigger {
    Unspecified = 'UNSPECIFIED',
    ProfileCreated = 'PROFILE_CREATED',
    CipFieldUpdated = 'CIP_FIELD_UPDATED',
    ManualComplianceCheck = 'MANUAL_COMPLIANCE_CHECK'
}

export enum IxcRegistrationV1SummaryStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Closed = 'CLOSED'
}

export enum IxcRegistrationV1TaxIdType {
    Unspecified = 'UNSPECIFIED',
    Ssn = 'SSN',
    Itin = 'ITIN',
    Ein = 'EIN'
}

export interface IxcRegistrationV1TrustedPerson {
    name: IxcRegistrationV1Name;
    email?: string;
    phone?: IxcRegistrationV1Phone[];
    address?: IxcRegistrationV1Address;
    relationship?: string;
}

export enum IxcRegistrationV1UsState {
    Unspecified = 'UNSPECIFIED',
    Al = 'AL',
    Ak = 'AK',
    Az = 'AZ',
    Ar = 'AR',
    Ca = 'CA',
    Co = 'CO',
    Ct = 'CT',
    De = 'DE',
    Fl = 'FL',
    Ga = 'GA',
    Hi = 'HI',
    Id = 'ID',
    Il = 'IL',
    In = 'IN',
    Ia = 'IA',
    Ks = 'KS',
    Ky = 'KY',
    La = 'LA',
    Me = 'ME',
    Md = 'MD',
    Ma = 'MA',
    Mi = 'MI',
    Mn = 'MN',
    Ms = 'MS',
    Mo = 'MO',
    Mt = 'MT',
    Ne = 'NE',
    Nv = 'NV',
    Nh = 'NH',
    Nj = 'NJ',
    Nm = 'NM',
    Ny = 'NY',
    Nc = 'NC',
    Nd = 'ND',
    Oh = 'OH',
    Ok = 'OK',
    Or = 'OR',
    Pa = 'PA',
    Ri = 'RI',
    Sc = 'SC',
    Sd = 'SD',
    Tn = 'TN',
    Tx = 'TX',
    Ut = 'UT',
    Vt = 'VT',
    Va = 'VA',
    Wa = 'WA',
    Wv = 'WV',
    Wi = 'WI',
    Wy = 'WY',
    Dc = 'DC',
    As = 'AS',
    Gu = 'GU',
    Mp = 'MP',
    Pr = 'PR',
    Um = 'UM',
    Vi = 'VI',
    Aa = 'AA',
    Ae = 'AE',
    Ap = 'AP'
}

export interface IxcSweepsClearingV1ActivityReportAccountStats {
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId: string;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    symbol: string;
    cusip: string;
    /* Deprecated, no longer set */
    mapCode?: string;
    /* Accumulated purchase quantity */
    // format: decimal
    purchaseQuantity?: string;
    /* Accumulated redemption quantity */
    // format: decimal
    redemptionQuantity?: string;
}

export interface IxcSweepsClearingV1ActivityReportJobCreatedInfo {
    spec: IxcSweepsClearingV1ActivityReportJobSpec;
    sweepTargetOrders: Record<string, IxcSweepsClearingV1ActivityReportSweepTargetOrders>;
}

export interface IxcSweepsClearingV1ActivityReportJobSpec {
    /* The adapter order ID that generated the activity report */
    // format: id62
    adapterOrderId: string;
    /* The time when the activity report job was started */
    // format: date-time
    confirmTimestamp: string;
    /* The previous cutoff time for the activity report */
    // format: date-time
    previousCutoff: string;
    /* The current cutoff time for the activity report */
    // format: date-time
    currentCutoff: string;
}

export interface IxcSweepsClearingV1ActivityReportJobStats {
    sweepTargetStats?: Record<string, IxcSweepsClearingV1ActivityReportJobStatsSweepTargetStats>;
    /* Per-account accumulated data for consolidated transaction publishing at
    AllFinished. Keyed by account ID. */
    accountStats?: Record<string, IxcSweepsClearingV1ActivityReportAccountStats>;
}

export interface IxcSweepsClearingV1ActivityReportJobStatsSweepTargetStats {
    /* Identifies the asset for which the activity report was generated */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    symbol: string;
    cusip: string;
    /* Deprecated, use orderTypes. Earlier jobs grouped orders by map code. */
    orders?: Record<string, IxcSweepsClearingV1ActivityReportJobStatsSweepTargetStatsOrders>;
    /* Map of order type to total quantity */
    orderTypes?: Record<string, string>;
}

export interface IxcSweepsClearingV1ActivityReportJobStatsSweepTargetStatsOrders {
    /* Map of order type to quantity */
    orderTypes: Record<string, string>;
}

export interface IxcSweepsClearingV1ActivityReportJobTasksAddInfo {
    /* The job spec, included so that sentinel-created jobs can be populated
    when the first chunk arrives. */
    spec?: IxcSweepsClearingV1ActivityReportJobSpec;
    sweepTargetOrders: Record<string, IxcSweepsClearingV1ActivityReportSweepTargetOrders>;
}

export interface IxcSweepsClearingV1ActivityReportSweepTargetOrders {
    /* Identifies the asset for which the activity report was generated */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    symbol: string;
    cusip: string;
    /* Map of account ID to array of sweep order IDs */
    accountOrders: Record<string, IxcSweepsClearingV1ActivityReportSweepTargetOrdersAccountOrders>;
}

export interface IxcSweepsClearingV1ActivityReportSweepTargetOrdersAccountOrders {
    // format: id62
    sweepOrderIds: string[];
}

export interface IxcSweepsClearingV1ActivityReportTaskCreatedInfo {
    /* Identifies the asset for which the activity report was generated */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    spec: IxcSweepsClearingV1ActivityReportTaskSpec;
}

export interface IxcSweepsClearingV1ActivityReportTaskFinishedInfo {
    /* The type of net order (purchase or redeem) */
    orderType?: IxcSweepsClearingV1OrderType;
    /* The total quantity for the net order */
    // format: decimal
    quantity?: string;
}

export interface IxcSweepsClearingV1ActivityReportTaskSpec {
    symbol?: string;
    cusip?: string;
    /* Deprecated, no longer set */
    mapCode?: string;
    /* The adapter order ID from the job, used for portfolio transaction detail.
    This is optional for backwards compatibility with earlier events that
    omitted it. */
    adapterOrderId?: string;
    /* The time for the activity report task */
    // format: date-time
    timestamp: string;
    /* The previous cutoff time for the activity report */
    // format: date-time
    previousCutoff: string;
    /* The current cutoff time for the activity report */
    // format: date-time
    currentCutoff: string;
    /* The sweep order IDs to include in this activity report task */
    // format: id62
    sweepOrderIds: string[];
}

export interface IxcSweepsClearingV1ActivityReportTaskStartedInfo {
    /* The type of sweep order (purchase or redeem) */
    orderType?: IxcSweepsClearingV1OrderType;
    /* The total quantity for the specified order type */
    // format: decimal
    quantity?: string;
    /* Deprecated, no longer set */
    mapCode?: string;
    cusip: string;
    symbol: string;
}

export interface IxcSweepsClearingV1ActivityReportTaskUpdatedData {
    /* Identifies the sweep target */
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId: string;
    /* Identifies the account for this task */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    /* Identifies the asset for which the activity report was generated */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    symbol: string;
    cusip: string;
    /* The type of net order (purchase or redeem) */
    orderType?: IxcSweepsClearingV1OrderType;
    /* The total quantity for the net order */
    // format: decimal
    quantity?: string;
    /* Deprecated, no longer set */
    mapCode?: string;
}

export interface IxcSweepsClearingV1BalancesReconcileDetails {
    /* Persistent baseline shifts found in the expected-vs-stored delta series,
    oldest first. */
    segments?: IxcSweepsClearingV1BalancesReconcileSegment[];
    /* Catch-up sweep orders for the net swept cash change, posted at the
    current cutoff when corrections are applied. */
    orders?: IxcSweepsClearingV1BalancesReconcileOrder[];
    /* Latest cutoff date with no in-flight sweep orders. Persistence of a shift
    is only judged up to this date. */
    // format: YYYY-MM-DD
    settledHorizonDate?: string;
    /* Latest date with dividends already paid out. Steps on or before this date
    refuse correction. */
    // format: YYYY-MM-DD
    paidThroughDate?: string;
    /* Stored available cash at the settled horizon */
    // format: decimal
    storedAvailableCash?: string;
    /* Expected available cash at the settled horizon */
    // format: decimal
    expectedAvailableCash?: string;
    /* Net available cash correction */
    // format: decimal
    availableCashDelta?: string;
    /* Net swept cash correction */
    // format: decimal
    sweptCashDelta?: string;
    /* Running balance rows corrected */
    // format: UINT32
    rowsUpdated?: number;
    correctionApplied?: boolean;
    refused?: boolean;
    /* A still-moving discrepancy, reported only. Corrections require a stable
    level. */
    drift?: IxcSweepsClearingV1BalancesReconcileDrift;
    /* Net correction to settled_swept from re-anchoring to portfolio's
    SweepBalance during a recalculate. The segment/drift, available-cash, and
    stored/expected fields above are retained for wire compatibility but are
    no longer populated. */
    // format: decimal
    settledSweptDelta?: string;
    /* Net correction to pending_swept from re-anchoring to the account's
    outstanding (committed-but-unsettled) orders during a recalculate. */
    // format: decimal
    pendingSweptDelta?: string;
}

export interface IxcSweepsClearingV1BalancesReconcileDrift {
    /* First settled cutoff of the nonzero run */
    // format: YYYY-MM-DD
    startDate: string;
    /* Length of the run in settled cutoffs */
    // format: UINT32
    settledCutoffs: number;
    /* Delta at the settled horizon */
    // format: decimal
    latestDelta: string;
    // format: decimal
    minDelta: string;
    // format: decimal
    maxDelta: string;
}

export interface IxcSweepsClearingV1BalancesReconcileJobCreatedInfo {
    spec: IxcSweepsClearingV1BalancesReconcileJobSpec;
    participants?: IxcSweepsClearingV1BalancesReconcileParticipant[];
}

export interface IxcSweepsClearingV1BalancesReconcileJobSpec {
    /* If true, apply corrections. Default is dry run. */
    applyCorrections?: boolean;
    /* Filter to a specific account. If omitted, reconcile all accounts. */
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    /* Earliest cutoff date to validate. Defaults to the full range covered by
    stored cash balance events. */
    // format: YYYY-MM-DD
    fromDate?: string;
}

export interface IxcSweepsClearingV1BalancesReconcileJobStats {
    /* Accounts checked */
    // format: UINT32
    totalChecked?: number;
    /* Accounts with corrections applied */
    // format: UINT32
    totalCorrected?: number;
    /* Accounts with no persistent discrepancy */
    // format: UINT32
    totalSkipped?: number;
    /* Accounts refused because dividends were already paid out */
    // format: UINT32
    totalRefused?: number;
    /* Sum of all available cash corrections */
    // format: decimal
    totalAvailableCashDiff?: string;
    /* Sum of all swept cash corrections */
    // format: decimal
    totalSweptCashDiff?: string;
    /* Accounts with a drifting (still-moving) discrepancy, reported only */
    // format: UINT32
    totalDrifting?: number;
}

export interface IxcSweepsClearingV1BalancesReconcileJobTasksAddInfo {
    participants: IxcSweepsClearingV1BalancesReconcileParticipant[];
}

export interface IxcSweepsClearingV1BalancesReconcileOrder {
    orderType: IxcSweepsClearingV1OrderType;
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId: string;
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    // format: decimal
    quantity: string;
    // format: date-time
    sweepsCutoffTimestamp: string;
}

export interface IxcSweepsClearingV1BalancesReconcileParticipant {
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
}

export interface IxcSweepsClearingV1BalancesReconcileSegment {
    /* Cutoff date where the delta baseline shifted */
    // format: YYYY-MM-DD
    stepDate: string;
    /* Expected minus stored from this step forward */
    // format: decimal
    availableCashDelta: string;
    /* The shift is the moving edge of a drifting tail — there is no stable
    level to correct to yet. Reported only, never corrected. */
    suspected?: boolean;
}

export interface IxcSweepsClearingV1BalancesReconcileTaskCreatedInfo {
    spec: IxcSweepsClearingV1BalancesReconcileTaskSpec;
}

export interface IxcSweepsClearingV1BalancesReconcileTaskFinishedInfo {
    // format: decimal
    availableCashDelta?: string;
    // format: decimal
    sweptCashDelta?: string;
    hasDiscrepancy?: boolean;
    correctionApplied?: boolean;
    refused?: boolean;
    // format: decimal
    settledSweptDelta?: string;
}

export interface IxcSweepsClearingV1BalancesReconcileTaskSpec {
    applyCorrections?: boolean;
    // format: YYYY-MM-DD
    fromDate?: string;
    details?: IxcSweepsClearingV1BalancesReconcileDetails;
}

export interface IxcSweepsClearingV1BalancesReconcileTaskStartedInfo {
    details: IxcSweepsClearingV1BalancesReconcileDetails;
}

export interface IxcSweepsClearingV1BalancesReconcileTaskUpdatedData {
    // format: decimal
    availableCashDelta?: string;
    // format: decimal
    sweptCashDelta?: string;
    hasDiscrepancy?: boolean;
    refused?: boolean;
    drifting?: boolean;
}

export type IxcSweepsClearingV1CashBalanceEventSource = {
    '!type'?: 'transaction';
    transaction: IxcSweepsClearingV1CashBalanceEventSourceTransaction;
} | {
    '!type'?: 'hold';
    hold: IxcSweepsClearingV1CashBalanceEventSourceHold;
};

export interface IxcSweepsClearingV1CashBalanceEventSourceHold {
    /* Absent for hold modifications and releases: portfolio does not
    identify the hold on those events. */
    // format: id62, entity: ixc.portfolio.v1.Hold
    holdId?: string;
    /* The hold was released (the held value went to zero) */
    released?: boolean;
}

export interface IxcSweepsClearingV1CashBalanceEventSourceTransaction {
    // format: id62, entity: ixc.portfolio.v1.Transaction
    transactionId: string;
}

export const IXC_SWEEPS_CLEARING_V1_CASH_BALANCE_EVENT_SOURCE_ONE_OF_VALUES = ['transaction', 'hold'] as const;

export type IxcSweepsClearingV1CashBalanceEventSourceOneOfValue = (typeof IXC_SWEEPS_CLEARING_V1_CASH_BALANCE_EVENT_SOURCE_ONE_OF_VALUES)[number];

export interface IxcSweepsClearingV1DividendsCalculateDetails {
    // format: decimal
    dividendChange?: string;
    // format: decimal
    sweptBalanceChange?: string;
    // format: date-time
    executedAt?: string;
}

export interface IxcSweepsClearingV1DividendsCalculateJobCreatedInfo {
    spec: IxcSweepsClearingV1DividendsCalculateJobSpec;
    participants?: IxcSweepsClearingV1DividendsCalculateParticipant[];
}

export interface IxcSweepsClearingV1DividendsCalculateJobSpec {
    /* The unique ID of the sweep target */
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId: string;
    /* The asset ID for this sweep target */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The date for which dividends are being calculated */
    // format: YYYY-MM-DD
    dividendDate: string;
    /* The dividend rate for this date */
    // format: decimal
    dividendRate: string;
    /* Hash of the MM stats data for idempotency */
    dataHash?: string;
    /* The expected payment date (first business day of next month) */
    // format: YYYY-MM-DD
    expectedPaymentDate?: string;
    /* The firm program id used to scope a case raised if this job errors. Sweep
    targets are not program-scoped, so the firm program is used for
    routing/visibility. */
    // format: id62, entity: ixm.userauth.v1.Program
    programId?: string;
}

export interface IxcSweepsClearingV1DividendsCalculateJobTasksAddInfo {
    participants: IxcSweepsClearingV1DividendsCalculateParticipant[];
}

export interface IxcSweepsClearingV1DividendsCalculateParticipant {
    /* The account ID for this participant */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    /* The sweep target ID */
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId: string;
    /* First day of the month for stats lookup */
    // format: YYYY-MM-DD
    firstDayOfMonth: string;
}

export interface IxcSweepsClearingV1DividendsCalculateTaskCreatedInfo {
    spec: IxcSweepsClearingV1DividendsCalculateTaskSpec;
}

export interface IxcSweepsClearingV1DividendsCalculateTaskFinishedInfo {
    /* The dividend change calculated */
    // format: decimal
    dividendChange: string;
    /* The swept balance change */
    // format: decimal
    sweptBalanceChange: string;
}

export interface IxcSweepsClearingV1DividendsCalculateTaskSpec {
    // format: YYYY-MM-DD
    dividendDate: string;
    // format: decimal
    dividendRate: string;
    // format: YYYY-MM-DD
    firstDayOfMonth: string;
    // format: YYYY-MM-DD
    expectedPaymentDate?: string;
    details?: IxcSweepsClearingV1DividendsCalculateDetails;
}

export interface IxcSweepsClearingV1DividendsCalculateTaskStartedInfo {
    /* The swept balance at calculation time */
    // format: decimal
    sweptBalance: string;
}

export interface IxcSweepsClearingV1DividendsPayDetails {
    /* The total amount that was paid out */
    // format: decimal
    amountPaid?: string;
    /* ID of the transaction created for this payment */
    // format: id62
    transactionId?: string;
    /* When the payment operation was executed */
    // format: date-time
    executedAt?: string;
}

export interface IxcSweepsClearingV1DividendsPayees {
    /* The unique ID of the sweep target */
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId: string;
    /* id of asset associated with this dividend payment */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* id of account associated with this dividend payment */
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    /* The first day of the month for which to pay out dividends. */
    // format: YYYY-MM-DD
    firstDayOfMonth: string;
    /* The end date of the period covered by the payment. */
    // format: YYYY-MM-DD
    endDate: string;
}

export interface IxcSweepsClearingV1DividendsPayJobCreatedInfo {
    spec: IxcSweepsClearingV1DividendsPayJobSpec;
    payees?: IxcSweepsClearingV1DividendsPayees[];
}

export interface IxcSweepsClearingV1DividendsPayJobSpec {
    /* The unique ID of the sweep target. If omitted, pay out dividends for all
    sweep targets. */
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId?: string;
    /* The first day of the month for which to pay out dividends. */
    // format: YYYY-MM-DD
    firstDayOfMonth: string;
    /* The end date of the period covered by the payment. endDate must be in the
    same month as firstDayOfMonth. */
    // format: YYYY-MM-DD
    endDate: string;
}

export interface IxcSweepsClearingV1DividendsPayJobTasksAddInfo {
    payees: IxcSweepsClearingV1DividendsPayees[];
}

export interface IxcSweepsClearingV1DividendsPayTaskCreatedInfo {
    spec: IxcSweepsClearingV1DividendsPayTaskSpec;
}

export interface IxcSweepsClearingV1DividendsPayTaskFinishedInfo {
    /* Details of the completed dividends payment */
    details: IxcSweepsClearingV1DividendsPayDetails;
}

export interface IxcSweepsClearingV1DividendsPayTaskSpec {
    /* The date the dividend payment will be calculated for */
    // format: YYYY-MM-DD
    endDate: string;
    /* When completed, this contains the details of the dividend payment */
    details?: IxcSweepsClearingV1DividendsPayDetails;
}

export interface IxcSweepsClearingV1DividendsPayTaskStartedInfo {
    /* The total amount that is to be paid out */
    // format: decimal
    amount: string;
}

export interface IxcSweepsClearingV1DividendsRecalculateDetails {
    // format: decimal
    storedDividends?: string;
    // format: decimal
    correctDividends?: string;
    // format: decimal
    storedSweptBalance?: string;
    // format: decimal
    correctSweptBalance?: string;
    // format: decimal
    dividendsDelta?: string;
    // format: decimal
    sweptBalanceDelta?: string;
    correctionApplied?: boolean;
}

export interface IxcSweepsClearingV1DividendsRecalculateJobCreatedInfo {
    spec: IxcSweepsClearingV1DividendsRecalculateJobSpec;
    participants?: IxcSweepsClearingV1DividendsRecalculateParticipant[];
}

export interface IxcSweepsClearingV1DividendsRecalculateJobSpec {
    /* The month to recalculate */
    // format: YYYY-MM-DD
    firstDayOfMonth: string;
    /* If true, apply corrections. Default is dry run. */
    applyCorrections?: boolean;
    /* Filter to a specific sweep target */
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId?: string;
    /* Filter to a specific account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    /* Filter to accounts using a specific sweep plan */
    // format: id62, entity: ixc.sweeps.v1.SweepPlan
    sweepPlanId?: string;
}

export interface IxcSweepsClearingV1DividendsRecalculateJobStats {
    /* Total participant stats records checked */
    // format: UINT32
    totalChecked?: number;
    /* Records that were corrected */
    // format: UINT32
    totalCorrected?: number;
    /* Records with no discrepancy */
    // format: UINT32
    totalSkipped?: number;
    /* Sum of all dividend corrections applied */
    // format: decimal
    totalDividendsDiff?: string;
    /* Sum of all swept balance corrections applied */
    // format: decimal
    totalSweptBalanceDiff?: string;
}

export interface IxcSweepsClearingV1DividendsRecalculateJobTasksAddInfo {
    participants: IxcSweepsClearingV1DividendsRecalculateParticipant[];
}

export interface IxcSweepsClearingV1DividendsRecalculateParticipant {
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId: string;
    // format: YYYY-MM-DD
    firstDayOfMonth: string;
}

export interface IxcSweepsClearingV1DividendsRecalculateTaskCreatedInfo {
    spec: IxcSweepsClearingV1DividendsRecalculateTaskSpec;
}

export interface IxcSweepsClearingV1DividendsRecalculateTaskFinishedInfo {
    // format: decimal
    dividendsDelta?: string;
    // format: decimal
    sweptBalanceDelta?: string;
    hasDiscrepancy?: boolean;
    correctionApplied?: boolean;
}

export interface IxcSweepsClearingV1DividendsRecalculateTaskSpec {
    // format: YYYY-MM-DD
    firstDayOfMonth: string;
    applyCorrections?: boolean;
    details?: IxcSweepsClearingV1DividendsRecalculateDetails;
}

export interface IxcSweepsClearingV1DividendsRecalculateTaskStartedInfo {
    // format: decimal
    storedDividends?: string;
    // format: decimal
    storedSweptBalance?: string;
    // format: decimal
    correctDividends?: string;
    // format: decimal
    correctSweptBalance?: string;
    // format: YYYY-MM-DD
    dividendDate?: string;
}

export interface IxcSweepsClearingV1DividendsRecalculateTaskUpdatedData {
    // format: decimal
    dividendsDelta?: string;
    // format: decimal
    sweptBalanceDelta?: string;
    hasDiscrepancy?: boolean;
}

export type IxcSweepsClearingV1Initiator = {
    '!type'?: 'transaction';
    /* The sweep order was initiated by a transaction. */
    transaction: IxcSweepsClearingV1InitiatorTransaction;
} | {
    '!type'?: 'hold';
    /* The sweep order was initiated by a hold event. */
    hold: IxcSweepsClearingV1InitiatorHold;
} | {
    '!type'?: 'account';
    /* The sweep order was initiated by an account-level control change */
    account: IxcSweepsClearingV1InitiatorAccount;
} | {
    '!type'?: 'program';
    /* The sweep order was initiated by a program-level control change */
    program: IxcSweepsClearingV1InitiatorProgram;
} | {
    '!type'?: 'reconcile';
    /* The sweep order was generated by a balances reconciliation job to correct
    a discrepancy between the running balance and the orders or portfolio
    balances. */
    reconcile: IxcSweepsClearingV1InitiatorReconcile;
} | {
    '!type'?: 'cashBalance';
    /* The sweep order was initiated by a portfolio CashBalance event: the
    account's cash position changed, resulting in a sweep order. The
    underlying transaction or hold is recoverable from the referenced event. */
    cashBalance: IxcSweepsClearingV1InitiatorCashBalance;
} | {
    '!type'?: 'cashBalanceCatchUp';
    /* The sweep order nets CashBalance events that were deferred while a prior
    sweep settlement was being recognized: decisions pause while portfolio's
    reported swept balance disagrees with sweeps' booked position, and resume
    at the event where they agree. */
    cashBalanceCatchUp: IxcSweepsClearingV1InitiatorCashBalanceCatchUp;
};

export interface IxcSweepsClearingV1InitiatorAccount {
    /* The ID of the account that had controls changed */
    // format: id62
    accountId: string;
}

export interface IxcSweepsClearingV1InitiatorCashBalance {
    /* The ID of the CashBalance event that initiated the sweep order */
    // format: uuid
    eventId: string;
    /* The sequence of the CashBalance event on the account */
    // format: UINT64
    sequence?: string;
    /* The portfolio CashBalance event type key, e.g. "transaction_posted",
    "hold_created", "hold_modified" */
    eventKey?: string;
    /* The record that changed the balance, when the event identifies one */
    source?: IxcSweepsClearingV1CashBalanceEventSource;
    /* The signed amount of the underlying event's balance effect */
    // format: decimal
    amount?: string;
}

export interface IxcSweepsClearingV1InitiatorCashBalanceCatchUp {
    /* The CashBalance event at which the deferred window was evaluated */
    // format: uuid
    eventId: string;
    /* The sequence of the CashBalance event on the account */
    // format: UINT64
    sequence?: string;
    /* The events ignored during the deferral window, oldest first, capped */
    deferredEvents?: IxcSweepsClearingV1InitiatorCashBalanceCatchUpDeferredEvents[];
    /* Total deferred events, including any beyond the cap */
    // format: UINT64
    deferredCount?: string;
}

export interface IxcSweepsClearingV1InitiatorCashBalanceCatchUpDeferredEvents {
    // format: uuid
    eventId: string;
    // format: UINT64
    sequence: string;
    eventKey?: string;
    source?: IxcSweepsClearingV1CashBalanceEventSource;
}

export interface IxcSweepsClearingV1InitiatorHold {
    /* The ID of the hold that initiated the sweep order */
    // format: id62
    holdId: string;
    /* The sequence number of the hold event that initiated the sweep order */
    // format: UINT64
    sequence: string;
}

export interface IxcSweepsClearingV1InitiatorProgram {
    /* The ID of the program that had controls changed */
    // format: id62
    programId: string;
}

export interface IxcSweepsClearingV1InitiatorReconcile {
    /* The ID of the reconciliation job that generated the sweep order */
    // format: id62, entity: ixc.sweeps.clearing.v1.SweepsJob
    sweepsJobId: string;
}

export interface IxcSweepsClearingV1InitiatorTransaction {
    /* The ID of the transaction that initiated the sweep order */
    // format: id62
    transactionId: string;
}

export const IXC_SWEEPS_CLEARING_V1_INITIATOR_ONE_OF_VALUES = ['transaction', 'hold', 'account', 'program', 'reconcile', 'cashBalance', 'cashBalanceCatchUp'] as const;

export type IxcSweepsClearingV1InitiatorOneOfValue = (typeof IXC_SWEEPS_CLEARING_V1_INITIATOR_ONE_OF_VALUES)[number];

export type IxcSweepsClearingV1JobCreatedInfo = {
    '!type'?: 'activityReport';
    activityReport: IxcSweepsClearingV1ActivityReportJobCreatedInfo;
} | {
    '!type'?: 'dividendsPay';
    dividendsPay: IxcSweepsClearingV1DividendsPayJobCreatedInfo;
} | {
    '!type'?: 'dividendsCalculate';
    dividendsCalculate: IxcSweepsClearingV1DividendsCalculateJobCreatedInfo;
} | {
    '!type'?: 'dividendsRecalculate';
    dividendsRecalculate: IxcSweepsClearingV1DividendsRecalculateJobCreatedInfo;
} | {
    '!type'?: 'balancesReconcile';
    balancesReconcile: IxcSweepsClearingV1BalancesReconcileJobCreatedInfo;
};

export const IXC_SWEEPS_CLEARING_V1_JOB_CREATED_INFO_ONE_OF_VALUES = ['activityReport', 'dividendsPay', 'dividendsCalculate', 'dividendsRecalculate', 'balancesReconcile'] as const;

export type IxcSweepsClearingV1JobCreatedInfoOneOfValue = (typeof IXC_SWEEPS_CLEARING_V1_JOB_CREATED_INFO_ONE_OF_VALUES)[number];

export type IxcSweepsClearingV1JobSpec = {
    '!type'?: 'activityReport';
    activityReport: IxcSweepsClearingV1ActivityReportJobSpec;
} | {
    '!type'?: 'dividendsPay';
    dividendsPay: IxcSweepsClearingV1DividendsPayJobSpec;
} | {
    '!type'?: 'dividendsCalculate';
    dividendsCalculate: IxcSweepsClearingV1DividendsCalculateJobSpec;
} | {
    '!type'?: 'dividendsRecalculate';
    dividendsRecalculate: IxcSweepsClearingV1DividendsRecalculateJobSpec;
} | {
    '!type'?: 'balancesReconcile';
    balancesReconcile: IxcSweepsClearingV1BalancesReconcileJobSpec;
};

export const IXC_SWEEPS_CLEARING_V1_JOB_SPEC_ONE_OF_VALUES = ['activityReport', 'dividendsPay', 'dividendsCalculate', 'dividendsRecalculate', 'balancesReconcile'] as const;

export type IxcSweepsClearingV1JobSpecOneOfValue = (typeof IXC_SWEEPS_CLEARING_V1_JOB_SPEC_ONE_OF_VALUES)[number];

export type IxcSweepsClearingV1JobStats = {
    '!type'?: 'activityReport';
    activityReport: IxcSweepsClearingV1ActivityReportJobStats;
} | {
    '!type'?: 'dividendsPay';
    dividendsPay: EmptyObject;
} | {
    '!type'?: 'dividendsCalculate';
    dividendsCalculate: EmptyObject;
} | {
    '!type'?: 'dividendsRecalculate';
    dividendsRecalculate: IxcSweepsClearingV1DividendsRecalculateJobStats;
} | {
    '!type'?: 'balancesReconcile';
    balancesReconcile: IxcSweepsClearingV1BalancesReconcileJobStats;
};

export const IXC_SWEEPS_CLEARING_V1_JOB_STATS_ONE_OF_VALUES = ['activityReport', 'dividendsPay', 'dividendsCalculate', 'dividendsRecalculate', 'balancesReconcile'] as const;

export type IxcSweepsClearingV1JobStatsOneOfValue = (typeof IXC_SWEEPS_CLEARING_V1_JOB_STATS_ONE_OF_VALUES)[number];

export type IxcSweepsClearingV1JobTasksAddInfo = {
    '!type'?: 'activityReport';
    activityReport: IxcSweepsClearingV1ActivityReportJobTasksAddInfo;
} | {
    '!type'?: 'dividendsPay';
    dividendsPay: IxcSweepsClearingV1DividendsPayJobTasksAddInfo;
} | {
    '!type'?: 'dividendsCalculate';
    dividendsCalculate: IxcSweepsClearingV1DividendsCalculateJobTasksAddInfo;
} | {
    '!type'?: 'dividendsRecalculate';
    dividendsRecalculate: IxcSweepsClearingV1DividendsRecalculateJobTasksAddInfo;
} | {
    '!type'?: 'balancesReconcile';
    balancesReconcile: IxcSweepsClearingV1BalancesReconcileJobTasksAddInfo;
};

export const IXC_SWEEPS_CLEARING_V1_JOB_TASKS_ADD_INFO_ONE_OF_VALUES = ['activityReport', 'dividendsPay', 'dividendsCalculate', 'dividendsRecalculate', 'balancesReconcile'] as const;

export type IxcSweepsClearingV1JobTasksAddInfoOneOfValue = (typeof IXC_SWEEPS_CLEARING_V1_JOB_TASKS_ADD_INFO_ONE_OF_VALUES)[number];

export interface IxcSweepsClearingV1Metrics {
    /* Total number of tasks in this job */
    // format: UINT32
    total?: number;
    /* Number of tasks waiting to be processed */
    // format: UINT32
    pending?: number;
    /* Number of tasks that have completed */
    // format: UINT32
    succeeded?: number;
    /* Number of tasks that encountered an error */
    // format: UINT32
    errored?: number;
    /* Number of tasks that failed for job termination */
    // format: UINT32
    failed?: number;
    /* Expected total number of items to receive across all chunks */
    // format: UINT32
    expectedTotal?: number;
    /* Number of items received so far across all chunks */
    // format: UINT32
    receivedCount?: number;
}

export enum IxcSweepsClearingV1OperationType {
    Unspecified = 'UNSPECIFIED',
    ActivityReport = 'ACTIVITY_REPORT',
    DividendsPay = 'DIVIDENDS_PAY',
    DividendsCalculate = 'DIVIDENDS_CALCULATE',
    DividendsRecalculate = 'DIVIDENDS_RECALCULATE',
    BalancesReconcile = 'BALANCES_RECONCILE'
}

export enum IxcSweepsClearingV1OrderType {
    Unspecified = 'UNSPECIFIED',
    Purchase = 'PURCHASE',
    Redeem = 'REDEEM'
}

export interface IxcSweepsClearingV1SweepFundsSpec {
    /* The swept balance. */
    // format: decimal
    sweptBalance?: string;
    /* The calculated outgoing dividend payments. Since this is also used for
    changes, this field can be negative. */
    // format: decimal
    dividends?: string;
    /* The date for which we have calculated dividends, for an event, or the
    last date for which dividends have been calculated. */
    // format: YYYY-MM-DD
    dividendDate?: string;
}

export interface IxcSweepsClearingV1SweepOrderData {
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId: string;
    /* The asset to be purchased or redeemed as part of the sweep. This is
    referenced through the sweep target as well, but included here for easier
    access. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The type of sweep order (purchase or redeem) */
    orderType: IxcSweepsClearingV1OrderType;
    /* The dollar amount to be bought or sold in the sweep order */
    // format: decimal
    quantity: string;
    /* The fund family of the money market fund */
    fundFamily: IxcAssetsV1FundFamily;
    /* The initiator of the sweep order */
    initiator: IxcSweepsClearingV1Initiator;
    /* The ID of the order used by the adapter to submit to the external system */
    // format: id62
    adapterOrderId?: string;
    /* The date the order was settled, formatted as YYYY-MM-DD. */
    // pattern: ^[0-9]{4}-[0-9]{2}-[0-9]{2}$
    settlementDate?: string;
    /* The reason the order did not succeed, if applicable */
    reason?: string;
    /* The time the order was completed */
    // format: date-time
    completeTimestamp?: string;
    /* The sweep day cutoff time this order belongs to */
    // format: date-time
    sweepsCutoffTimestamp?: string;
}

export interface IxcSweepsClearingV1SweepOrderEvent extends IxcSweepsClearingV1SweepOrderKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcSweepsClearingV1SweepOrderEventType;
}

export type IxcSweepsClearingV1SweepOrderEventType = {
    '!type'?: 'posted';
    posted: IxcSweepsClearingV1SweepOrderEventTypePosted;
} | {
    '!type'?: 'acked';
    acked: EmptyObject;
} | {
    '!type'?: 'processing';
    processing: IxcSweepsClearingV1SweepOrderEventTypeProcessing;
} | {
    '!type'?: 'settled';
    settled: IxcSweepsClearingV1SweepOrderEventTypeSettled;
} | {
    '!type'?: 'failed';
    failed: IxcSweepsClearingV1SweepOrderEventTypeFailed;
} | {
    '!type'?: 'canceled';
    canceled: IxcSweepsClearingV1SweepOrderEventTypeCanceled;
};

export interface IxcSweepsClearingV1SweepOrderEventTypeCanceled {
    /* The reason the order was canceled */
    reason?: string;
}

export interface IxcSweepsClearingV1SweepOrderEventTypeFailed {
    /* The reason the order did not succeed */
    reason?: string;
}

export interface IxcSweepsClearingV1SweepOrderEventTypePosted {
    /* The specification of the sweep order */
    spec: IxcSweepsClearingV1SweepOrderSpec;
    /* The sweep day cutoff time this order belongs to */
    // format: date-time
    sweepsCutoffTimestamp?: string;
}

export interface IxcSweepsClearingV1SweepOrderEventTypeProcessing {
    /* The ID of the order used by the adapter to submit to the external
    system */
    // format: id62
    adapterOrderId: string;
}

export interface IxcSweepsClearingV1SweepOrderEventTypeSettled {
    /* The date the order was settled, formatted as YYYY-MM-DD. */
    // pattern: ^[0-9]{4}-[0-9]{2}-[0-9]{2}$
    settlementDate: string;
}

export const IXC_SWEEPS_CLEARING_V1_SWEEP_ORDER_EVENT_TYPE_ONE_OF_VALUES = ['posted', 'acked', 'processing', 'settled', 'failed', 'canceled'] as const;

export type IxcSweepsClearingV1SweepOrderEventTypeOneOfValue = (typeof IXC_SWEEPS_CLEARING_V1_SWEEP_ORDER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcSweepsClearingV1SweepOrderKeys {
    /* The unique ID of the sweep order */
    // format: id62
    sweepOrderId: string;
}

export interface IxcSweepsClearingV1SweepOrderQueryServiceSweepOrderEventsSweepOrderEventsRequest {
    /* The unique ID of the sweep order */
    // format: id62
    sweepOrderId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcSweepsClearingV1SweepOrderQueryServiceSweepOrderEventsSortableFields, IxcSweepsClearingV1SweepOrderQueryServiceSweepOrderEventsFilterableFields>;
}

export enum IxcSweepsClearingV1SweepOrderQueryServiceSweepOrderEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    SweepOrderId = 'sweepOrderId',
    EventPostedSpecAccountId = 'event.posted.spec.accountId',
    EventPostedSpecSweepTargetId = 'event.posted.spec.sweepTargetId',
    EventType = 'event.!type'
}

export enum IxcSweepsClearingV1SweepOrderQueryServiceSweepOrderEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcSweepsClearingV1SweepOrderQueryServiceSweepOrderGetSweepOrderGetRequest {
    /* The unique ID of the sweep order */
    // format: id62
    sweepOrderId: string;
}

export interface IxcSweepsClearingV1SweepOrderQueryServiceSweepOrderListSweepOrderListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcSweepsClearingV1SweepOrderQueryServiceSweepOrderListSortableFields, IxcSweepsClearingV1SweepOrderQueryServiceSweepOrderListFilterableFields>;
}

export enum IxcSweepsClearingV1SweepOrderQueryServiceSweepOrderListFilterableFields {
    SweepOrderId = 'sweepOrderId',
    DataAccountId = 'data.accountId',
    DataSweepTargetId = 'data.sweepTargetId',
    Status = 'status'
}

export enum IxcSweepsClearingV1SweepOrderQueryServiceSweepOrderListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcSweepsClearingV1SweepOrderSpec {
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId: string;
    /* The asset to be purchased or redeemed as part of the sweep. This is
    referenced through the sweep target as well, but included here for easier
    access. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The type of sweep order (purchase or redeem) */
    orderType: IxcSweepsClearingV1OrderType;
    /* The dollar amount to be bought or sold in the sweep order */
    // format: decimal
    quantity: string;
    /* The fund family of the money market fund */
    fundFamily: IxcAssetsV1FundFamily;
    /* The initiator of the sweep order */
    initiator: IxcSweepsClearingV1Initiator;
}

export interface IxcSweepsClearingV1SweepOrderState extends IxcSweepsClearingV1SweepOrderKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcSweepsClearingV1SweepOrderData;
    status: IxcSweepsClearingV1SweepOrderStatus;
}

export enum IxcSweepsClearingV1SweepOrderStatus {
    Unspecified = 'UNSPECIFIED',
    Posted = 'POSTED',
    Acked = 'ACKED',
    Processing = 'PROCESSING',
    Settled = 'SETTLED',
    Failed = 'FAILED',
    Canceled = 'CANCELED'
}

export interface IxcSweepsClearingV1SweepParticipantData {
    /* The sweep plan assigned to the participant */
    // format: id62, entity: ixc.sweeps.v1.SweepPlan
    sweepPlanId: string;
    /* The last time the participant was updated */
    // format: date-time
    updateTimestamp: string;
}

export interface IxcSweepsClearingV1SweepParticipantEvent extends IxcSweepsClearingV1SweepParticipantKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcSweepsClearingV1SweepParticipantEventType;
}

export type IxcSweepsClearingV1SweepParticipantEventType = {
    '!type'?: 'enabled';
    enabled: IxcSweepsClearingV1SweepParticipantEventTypeEnabled;
} | {
    '!type'?: 'disabled';
    disabled: EmptyObject;
} | {
    '!type'?: 'planChanged';
    planChanged: IxcSweepsClearingV1SweepParticipantEventTypePlanChanged;
};

export interface IxcSweepsClearingV1SweepParticipantEventTypeEnabled {
    /* The new sweep plan assigned to the participant */
    // format: id62, entity: ixc.sweeps.v1.SweepPlan
    sweepPlanId: string;
}

export interface IxcSweepsClearingV1SweepParticipantEventTypePlanChanged {
    /* The previous sweep plan. */
    // format: id62, entity: ixc.sweeps.v1.SweepPlan
    oldSweepPlanId: string;
    /* The new sweep plan. */
    // format: id62, entity: ixc.sweeps.v1.SweepPlan
    newSweepPlanId: string;
}

export const IXC_SWEEPS_CLEARING_V1_SWEEP_PARTICIPANT_EVENT_TYPE_ONE_OF_VALUES = ['enabled', 'disabled', 'planChanged'] as const;

export type IxcSweepsClearingV1SweepParticipantEventTypeOneOfValue = (typeof IXC_SWEEPS_CLEARING_V1_SWEEP_PARTICIPANT_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcSweepsClearingV1SweepParticipantKeys {
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
}

export interface IxcSweepsClearingV1SweepParticipantPayment {
    /* The end date of the period covered by the payment. The start date is
    implicit as the beginning of the month or immediately after the previous
    payment's end date. */
    // format: YYYY-MM-DD
    endDate: string;
    /* The time the payment was made */
    // format: date-time
    paymentTime: string;
    /* The amount of the payment. We may record a payment of 0 to track payment
    events. */
    // format: decimal
    amount: string;
    /* The ID of the transaction created for this payment. We enter a $0 payment
    at the end of the month, which will not have a transaction. */
    // format: id62, entity: ixc.transactions.v1.Transaction
    transactionId?: string;
}

export interface IxcSweepsClearingV1SweepParticipantQueryServiceSweepParticipantEventsSweepParticipantEventsRequest {
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcSweepsClearingV1SweepParticipantQueryServiceSweepParticipantEventsSortableFields, IxcSweepsClearingV1SweepParticipantQueryServiceSweepParticipantEventsFilterableFields>;
}

export enum IxcSweepsClearingV1SweepParticipantQueryServiceSweepParticipantEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AccountId = 'accountId',
    EventType = 'event.!type'
}

export enum IxcSweepsClearingV1SweepParticipantQueryServiceSweepParticipantEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcSweepsClearingV1SweepParticipantQueryServiceSweepParticipantGetSweepParticipantGetRequest {
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
}

export interface IxcSweepsClearingV1SweepParticipantQueryServiceSweepParticipantListSweepParticipantListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcSweepsClearingV1SweepParticipantQueryServiceSweepParticipantListSortableFields, IxcSweepsClearingV1SweepParticipantQueryServiceSweepParticipantListFilterableFields>;
}

export enum IxcSweepsClearingV1SweepParticipantQueryServiceSweepParticipantListFilterableFields {
    AccountId = 'accountId',
    DataSweepPlanId = 'data.sweepPlanId',
    Status = 'status'
}

export enum IxcSweepsClearingV1SweepParticipantQueryServiceSweepParticipantListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcSweepsClearingV1SweepParticipantState extends IxcSweepsClearingV1SweepParticipantKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcSweepsClearingV1SweepParticipantData;
    status: IxcSweepsClearingV1SweepParticipantStatus;
}

export interface IxcSweepsClearingV1SweepParticipantStatsData {
    /* The swept balance. */
    // format: decimal
    sweptBalance?: string;
    /* The calculated outgoing dividend payments. Since this is also used for
    changes, this field can be negative. */
    // format: decimal
    dividends?: string;
    /* The date for which we have calculated dividends, for an event, or the
    last date for which dividends have been calculated. */
    // format: YYYY-MM-DD
    dividendDate?: string;
    /* The asset associated with this sweep target. Set on first update. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
    /* The expected final payout date for the dividends, if known. Calculated
    from the timetable and passed via the Updated event. */
    // format: YYYY-MM-DD
    expectedPaymentDate?: string;
    /* The list of payments made as part of the sweep dividends payout. */
    payments?: IxcSweepsClearingV1SweepParticipantPayment[];
}

export interface IxcSweepsClearingV1SweepParticipantStatsEvent extends IxcSweepsClearingV1SweepParticipantStatsKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcSweepsClearingV1SweepParticipantStatsEventType;
}

export type IxcSweepsClearingV1SweepParticipantStatsEventType = {
    '!type'?: 'updated';
    updated: IxcSweepsClearingV1SweepParticipantStatsEventTypeUpdated;
} | {
    '!type'?: 'finalized';
    finalized: EmptyObject;
} | {
    '!type'?: 'pay';
    pay: IxcSweepsClearingV1SweepParticipantStatsEventTypePay;
} | {
    '!type'?: 'paymentResult';
    paymentResult: IxcSweepsClearingV1SweepParticipantStatsEventTypePaymentResult;
} | {
    '!type'?: 'paymentsCompleted';
    paymentsCompleted: EmptyObject;
};

export interface IxcSweepsClearingV1SweepParticipantStatsEventTypePay {
    /* The end date of the period covered by the payment. The start date is
    implicit as the beginning of the month or immediately after the
    previous payment's end date. */
    // format: YYYY-MM-DD
    endDate: string;
    /* The dividends calculated up to the end date. Some may have been paid
    in prior payments. */
    // format: decimal
    dividendsOnDate: string;
    /* The asset the payment is associated with. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The ID of the dividends pay task that triggered this payment. */
    // format: id62, entity: ixc.sweeps.clearing.v1.SweepsTask
    sweepsTaskId: string;
    /* The ID of the dividends pay job that triggered this payment. */
    // format: id62, entity: ixc.sweeps.clearing.v1.SweepsJob
    sweepsJobId: string;
}

export interface IxcSweepsClearingV1SweepParticipantStatsEventTypePaymentResult {
    /* The ID of the dividends pay task that triggered this payment. */
    // format: id62, entity: ixc.sweeps.clearing.v1.SweepsTask
    sweepsTaskId: string;
    /* The ID of the dividends pay job that triggered this payment. */
    // format: id62, entity: ixc.sweeps.clearing.v1.SweepsJob
    sweepsJobId: string;
    /* The ID of the transaction created for this payment, if successful. */
    // format: id62, entity: ixc.transactions.v1.Transaction
    transactionId?: string;
    /* If the payment failed, the error message describing the failure. */
    errorMessage?: string;
}

export interface IxcSweepsClearingV1SweepParticipantStatsEventTypeUpdated {
    /* The deltas to apply to swept balance and dividends. dividendDate is
    always the absolute date for which these changes apply. */
    changes: IxcSweepsClearingV1SweepFundsSpec;
    /* The asset associated with this sweep target. Should be provided on
    the first update to set the asset ID on the stats. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
    /* The expected final payout date for the dividends. Calculated from the
    timetable by the caller. */
    // format: YYYY-MM-DD
    expectedPaymentDate?: string;
}

export const IXC_SWEEPS_CLEARING_V1_SWEEP_PARTICIPANT_STATS_EVENT_TYPE_ONE_OF_VALUES = ['updated', 'finalized', 'pay', 'paymentResult', 'paymentsCompleted'] as const;

export type IxcSweepsClearingV1SweepParticipantStatsEventTypeOneOfValue = (typeof IXC_SWEEPS_CLEARING_V1_SWEEP_PARTICIPANT_STATS_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcSweepsClearingV1SweepParticipantStatsKeys {
    /* The unique ID of the sweep participant */
    // format: id62, entity: ixc.sweeps.clearing.v1.SweepParticipant
    accountId: string;
    /* The ID of the sweep target for which the stats are calculated. */
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId: string;
    /* The first day of the month for which the stats are calculated. */
    // format: YYYY-MM-DD
    firstDayOfMonth: string;
}

export interface IxcSweepsClearingV1SweepParticipantStatsQueryServiceSweepParticipantStatsEventsSweepParticipantStatsEventsRequest {
    /* The unique ID of the sweep participant */
    // format: id62, entity: ixc.sweeps.clearing.v1.SweepParticipant
    accountId: string;
    /* The ID of the sweep target for which the stats are calculated. */
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId: string;
    /* The first day of the month for which the stats are calculated. */
    // format: YYYY-MM-DD
    firstDayOfMonth: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcSweepsClearingV1SweepParticipantStatsQueryServiceSweepParticipantStatsEventsSortableFields, IxcSweepsClearingV1SweepParticipantStatsQueryServiceSweepParticipantStatsEventsFilterableFields>;
}

export enum IxcSweepsClearingV1SweepParticipantStatsQueryServiceSweepParticipantStatsEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AccountId = 'accountId',
    SweepTargetId = 'sweepTargetId',
    FirstDayOfMonth = 'firstDayOfMonth',
    EventType = 'event.!type'
}

export enum IxcSweepsClearingV1SweepParticipantStatsQueryServiceSweepParticipantStatsEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcSweepsClearingV1SweepParticipantStatsQueryServiceSweepParticipantStatsGetSweepParticipantStatsGetRequest {
    /* The unique ID of the sweep participant */
    // format: id62, entity: ixc.sweeps.clearing.v1.SweepParticipant
    accountId: string;
    /* The ID of the sweep target for which the stats are calculated. */
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId: string;
    /* The first day of the month for which the stats are calculated. */
    // format: YYYY-MM-DD
    firstDayOfMonth: string;
}

export interface IxcSweepsClearingV1SweepParticipantStatsQueryServiceSweepParticipantStatsListSweepParticipantStatsListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcSweepsClearingV1SweepParticipantStatsQueryServiceSweepParticipantStatsListSortableFields, IxcSweepsClearingV1SweepParticipantStatsQueryServiceSweepParticipantStatsListFilterableFields>;
}

export enum IxcSweepsClearingV1SweepParticipantStatsQueryServiceSweepParticipantStatsListFilterableFields {
    AccountId = 'accountId',
    SweepTargetId = 'sweepTargetId',
    FirstDayOfMonth = 'firstDayOfMonth',
    Status = 'status'
}

export enum IxcSweepsClearingV1SweepParticipantStatsQueryServiceSweepParticipantStatsListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcSweepsClearingV1SweepParticipantStatsState extends IxcSweepsClearingV1SweepParticipantStatsKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcSweepsClearingV1SweepParticipantStatsData;
    status: IxcSweepsClearingV1SweepParticipantStatsStatus;
}

export enum IxcSweepsClearingV1SweepParticipantStatsStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Finalized = 'FINALIZED',
    Paid = 'PAID'
}

export enum IxcSweepsClearingV1SweepParticipantStatus {
    Unspecified = 'UNSPECIFIED',
    Sweeping = 'SWEEPING',
    NotSweeping = 'NOT_SWEEPING'
}

export interface IxcSweepsClearingV1SweepPayment {
    /* The end date of the period covered by the payment. The start date is
    implicit as the beginning of the month or immediately after the previous
    payment's end date. */
    // format: YYYY-MM-DD
    endDate: string;
    /* The time the payment was made */
    // format: date-time
    paymentTime: string;
    /* The amount of the payment. We may record a payment of 0 to track payment
    events. */
    // format: decimal
    amount: string;
}

export interface IxcSweepsClearingV1SweepsJobData {
    operationType: IxcSweepsClearingV1OperationType;
    /* Job specification. May be nil when the job was created by a sentinel
    arriving before any chunk; populated by the first TasksAdd. */
    spec?: IxcSweepsClearingV1JobSpec;
    metrics: IxcSweepsClearingV1Metrics;
    /* Job statistics. May be nil when the job was created by a sentinel;
    populated by the first TasksAdd. */
    stats?: IxcSweepsClearingV1JobStats;
}

export interface IxcSweepsClearingV1SweepsJobEvent extends IxcSweepsClearingV1SweepsJobKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcSweepsClearingV1SweepsJobEventType;
}

export type IxcSweepsClearingV1SweepsJobEventType = {
    '!type'?: 'created';
    created: IxcSweepsClearingV1SweepsJobEventTypeCreated;
} | {
    '!type'?: 'closed';
    closed: EmptyObject;
} | {
    '!type'?: 'tasksAdd';
    tasksAdd: IxcSweepsClearingV1SweepsJobEventTypeTasksAdd;
} | {
    '!type'?: 'taskUpdated';
    taskUpdated: IxcSweepsClearingV1SweepsJobEventTypeTaskUpdated;
} | {
    '!type'?: 'sentinelReceived';
    sentinelReceived: IxcSweepsClearingV1SweepsJobEventTypeSentinelReceived;
} | {
    '!type'?: 'tasksBatchUpdated';
    tasksBatchUpdated: IxcSweepsClearingV1SweepsJobEventTypeTasksBatchUpdated;
} | {
    '!type'?: 'allFinished';
    allFinished: IxcSweepsClearingV1SweepsJobEventTypeAllFinished;
};

export interface IxcSweepsClearingV1SweepsJobEventTypeAllFinished {
    message?: string;
}

export interface IxcSweepsClearingV1SweepsJobEventTypeCreated {
    info: IxcSweepsClearingV1JobCreatedInfo;
    /* Indicates if the job is to be closed to new tasks */
    closeJob?: boolean;
    operationType: IxcSweepsClearingV1OperationType;
}

export interface IxcSweepsClearingV1SweepsJobEventTypeSentinelReceived {
    operationType: IxcSweepsClearingV1OperationType;
    // format: UINT32
    expectedTotal: number;
}

export interface IxcSweepsClearingV1SweepsJobEventTypeTasksAdd {
    info: IxcSweepsClearingV1JobTasksAddInfo;
    /* Indicates if the job is to be closed to new tasks */
    closeJob?: boolean;
}

export interface IxcSweepsClearingV1SweepsJobEventTypeTasksBatchUpdated {
    results: IxcSweepsClearingV1TaskBatchResult[];
}

export interface IxcSweepsClearingV1SweepsJobEventTypeTaskUpdated {
    /* ID of the task that completed */
    // format: id62
    sweepsTaskId: string;
    taskStatus: IxcSweepsClearingV1TaskUpdatedStatus;
    /* Data associated with the task update */
    data?: IxcSweepsClearingV1TaskUpdatedData;
}

export const IXC_SWEEPS_CLEARING_V1_SWEEPS_JOB_EVENT_TYPE_ONE_OF_VALUES = ['created', 'closed', 'tasksAdd', 'taskUpdated', 'sentinelReceived', 'tasksBatchUpdated', 'allFinished'] as const;

export type IxcSweepsClearingV1SweepsJobEventTypeOneOfValue = (typeof IXC_SWEEPS_CLEARING_V1_SWEEPS_JOB_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcSweepsClearingV1SweepsJobKeys {
    /* Primary identifier */
    // format: id62
    sweepsJobId: string;
}

export interface IxcSweepsClearingV1SweepsJobQueryServiceSweepsJobEventsSweepsJobEventsRequest {
    /* Primary identifier */
    // format: id62
    sweepsJobId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcSweepsClearingV1SweepsJobQueryServiceSweepsJobEventsSortableFields, IxcSweepsClearingV1SweepsJobQueryServiceSweepsJobEventsFilterableFields>;
}

export enum IxcSweepsClearingV1SweepsJobQueryServiceSweepsJobEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    SweepsJobId = 'sweepsJobId',
    EventType = 'event.!type'
}

export enum IxcSweepsClearingV1SweepsJobQueryServiceSweepsJobEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcSweepsClearingV1SweepsJobQueryServiceSweepsJobGetSweepsJobGetRequest {
    /* Primary identifier */
    // format: id62
    sweepsJobId: string;
}

export interface IxcSweepsClearingV1SweepsJobQueryServiceSweepsJobListSweepsJobListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcSweepsClearingV1SweepsJobQueryServiceSweepsJobListSortableFields, IxcSweepsClearingV1SweepsJobQueryServiceSweepsJobListFilterableFields>;
}

export enum IxcSweepsClearingV1SweepsJobQueryServiceSweepsJobListFilterableFields {
    SweepsJobId = 'sweepsJobId',
    Status = 'status'
}

export enum IxcSweepsClearingV1SweepsJobQueryServiceSweepsJobListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcSweepsClearingV1SweepsJobState extends IxcSweepsClearingV1SweepsJobKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcSweepsClearingV1SweepsJobData;
    status: IxcSweepsClearingV1SweepsJobStatus;
}

export enum IxcSweepsClearingV1SweepsJobStatus {
    Unspecified = 'UNSPECIFIED',
    Open = 'OPEN',
    Processing = 'PROCESSING',
    Done = 'DONE'
}

export interface IxcSweepsClearingV1SweepsTaskData {
    operationType: IxcSweepsClearingV1OperationType;
    spec: IxcSweepsClearingV1TaskSpec;
    /* Identifies the asset for the sweep target. It needs to be looked up, so
    is optional until the lookup is done and sent via the Started event. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
}

export interface IxcSweepsClearingV1SweepsTaskEvent extends IxcSweepsClearingV1SweepsTaskKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcSweepsClearingV1SweepsTaskEventType;
}

export type IxcSweepsClearingV1SweepsTaskEventType = {
    '!type'?: 'created';
    created: IxcSweepsClearingV1SweepsTaskEventTypeCreated;
} | {
    '!type'?: 'started';
    started: IxcSweepsClearingV1SweepsTaskEventTypeStarted;
} | {
    '!type'?: 'finished';
    finished: IxcSweepsClearingV1SweepsTaskEventTypeFinished;
} | {
    '!type'?: 'errored';
    errored: IxcSweepsClearingV1SweepsTaskEventTypeErrored;
} | {
    '!type'?: 'failed';
    failed: IxcSweepsClearingV1SweepsTaskEventTypeFailed;
};

export interface IxcSweepsClearingV1SweepsTaskEventTypeCreated {
    // format: id62
    sweepsJobId: string;
    operationType: IxcSweepsClearingV1OperationType;
    info: IxcSweepsClearingV1TaskCreatedInfo;
}

export interface IxcSweepsClearingV1SweepsTaskEventTypeErrored {
    /* Optional error message */
    message?: string;
}

export interface IxcSweepsClearingV1SweepsTaskEventTypeFailed {
    /* Optional error message */
    message?: string;
}

export interface IxcSweepsClearingV1SweepsTaskEventTypeFinished {
    info: IxcSweepsClearingV1TaskFinishedInfo;
}

export interface IxcSweepsClearingV1SweepsTaskEventTypeStarted {
    /* The asset ID associated with this sweep target. Unset for
    account-scoped operations. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
    info: IxcSweepsClearingV1TaskStartedInfo;
}

export const IXC_SWEEPS_CLEARING_V1_SWEEPS_TASK_EVENT_TYPE_ONE_OF_VALUES = ['created', 'started', 'finished', 'errored', 'failed'] as const;

export type IxcSweepsClearingV1SweepsTaskEventTypeOneOfValue = (typeof IXC_SWEEPS_CLEARING_V1_SWEEPS_TASK_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcSweepsClearingV1SweepsTaskKeys {
    /* Primary identifier */
    // format: id62
    sweepsTaskId: string;
    /* Identifies the job this task belongs to */
    // format: id62, entity: ixc.sweeps.clearing.v1.SweepsJob
    sweepsJobId?: string;
    /* Identifies the account */
    // format: id62, entity: ixc.registration.v1.Account
    accountId?: string;
    /* Identifies the sweep target. Unset for account-scoped operations. */
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId?: string;
}

export interface IxcSweepsClearingV1SweepsTaskQueryServiceSweepsTaskEventsSweepsTaskEventsRequest {
    /* Primary identifier */
    // format: id62
    sweepsTaskId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcSweepsClearingV1SweepsTaskQueryServiceSweepsTaskEventsSortableFields, IxcSweepsClearingV1SweepsTaskQueryServiceSweepsTaskEventsFilterableFields>;
}

export enum IxcSweepsClearingV1SweepsTaskQueryServiceSweepsTaskEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    SweepsTaskId = 'sweepsTaskId',
    SweepsJobId = 'sweepsJobId',
    AccountId = 'accountId',
    SweepTargetId = 'sweepTargetId',
    EventType = 'event.!type'
}

export enum IxcSweepsClearingV1SweepsTaskQueryServiceSweepsTaskEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcSweepsClearingV1SweepsTaskQueryServiceSweepsTaskGetSweepsTaskGetRequest {
    /* Primary identifier */
    // format: id62
    sweepsTaskId: string;
}

export interface IxcSweepsClearingV1SweepsTaskQueryServiceSweepsTaskListSweepsTaskListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcSweepsClearingV1SweepsTaskQueryServiceSweepsTaskListSortableFields, IxcSweepsClearingV1SweepsTaskQueryServiceSweepsTaskListFilterableFields>;
}

export enum IxcSweepsClearingV1SweepsTaskQueryServiceSweepsTaskListFilterableFields {
    SweepsTaskId = 'sweepsTaskId',
    SweepsJobId = 'sweepsJobId',
    AccountId = 'accountId',
    SweepTargetId = 'sweepTargetId',
    DataAssetId = 'data.assetId',
    Status = 'status'
}

export enum IxcSweepsClearingV1SweepsTaskQueryServiceSweepsTaskListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcSweepsClearingV1SweepsTaskState extends IxcSweepsClearingV1SweepsTaskKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcSweepsClearingV1SweepsTaskData;
    status: IxcSweepsClearingV1SweepsTaskStatus;
}

export enum IxcSweepsClearingV1SweepsTaskStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Succeeded = 'SUCCEEDED',
    Errored = 'ERRORED',
    Failed = 'FAILED'
}

export interface IxcSweepsClearingV1SweepsTransaction {
    /* The unique identifier for the account associated with the transaction,
    which is only used for portfolio.TransactionDetail. */
    // format: id62
    accountId?: string;
    /* The unique identifier for the order submitted by the adapter to the
    vendor system. */
    adapterOrderId: string;
    /* The time the order was confirmed by the vendor system */
    // format: date-time
    confirmTime: string;
    // format: informal
    symbol: string;
    // format: informal
    cusip: string;
    // format: id62
    assetId: string;
    /* The type of order that was handled */
    orderType: IxcSweepsClearingV1OrderType;
    // format: decimal
    quantity: string;
    /* The price per share */
    // format: decimal
    fillPrice: string;
    /* The total amount handled in the transaction */
    // format: decimal
    netAmount: string;
}

export interface IxcSweepsClearingV1SweepTargetStatsBatchEntry {
    /* UUID of the originating participant-stats event that produced this entry. */
    sourceEventId: string;
    /* The semantic equivalent of the single pre-batch event this entry
    replaces. */
    payload: IxcSweepsClearingV1SweepTargetStatsBatchEntryPayload;
}

export type IxcSweepsClearingV1SweepTargetStatsBatchEntryPayload = {
    '!type'?: 'updated';
    /* Entry derived from a participant Updated event; carries the same deltas. */
    updated: IxcSweepsClearingV1SweepFundsSpec;
} | {
    '!type'?: 'paid';
    /* Entry derived from a participant Pay event; carries the same payment. */
    paid: IxcSweepsClearingV1SweepPayment;
};

export const IXC_SWEEPS_CLEARING_V1_SWEEP_TARGET_STATS_BATCH_ENTRY_PAYLOAD_ONE_OF_VALUES = ['updated', 'paid'] as const;

export type IxcSweepsClearingV1SweepTargetStatsBatchEntryPayloadOneOfValue = (typeof IXC_SWEEPS_CLEARING_V1_SWEEP_TARGET_STATS_BATCH_ENTRY_PAYLOAD_ONE_OF_VALUES)[number];

export interface IxcSweepsClearingV1SweepTargetStatsData {
    /* The swept balance. */
    // format: decimal
    sweptBalance?: string;
    /* The calculated outgoing dividend payments. Since this is also used for
    changes, this field can be negative. */
    // format: decimal
    dividends?: string;
    /* The date for which we have calculated dividends, for an event, or the
    last date for which dividends have been calculated. */
    // format: YYYY-MM-DD
    dividendDate?: string;
    /* A summary of payments made to individual participants. */
    paid?: IxcSweepsClearingV1SweepPayment;
}

export interface IxcSweepsClearingV1SweepTargetStatsEvent extends IxcSweepsClearingV1SweepTargetStatsKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcSweepsClearingV1SweepTargetStatsEventType;
}

export type IxcSweepsClearingV1SweepTargetStatsEventType = {
    '!type'?: 'updated';
    updated: IxcSweepsClearingV1SweepTargetStatsEventTypeUpdated;
} | {
    '!type'?: 'paid';
    paid: IxcSweepsClearingV1SweepTargetStatsEventTypePaid;
} | {
    '!type'?: 'batchUpdated';
    batchUpdated: IxcSweepsClearingV1SweepTargetStatsEventTypeBatchUpdated;
};

export interface IxcSweepsClearingV1SweepTargetStatsEventTypeBatchUpdated {
    entries: IxcSweepsClearingV1SweepTargetStatsBatchEntry[];
}

export interface IxcSweepsClearingV1SweepTargetStatsEventTypePaid {
    /* The payment made as part of the sweep dividends payout. */
    payment: IxcSweepsClearingV1SweepPayment;
}

export interface IxcSweepsClearingV1SweepTargetStatsEventTypeUpdated {
    /* The deltas to apply to swept balance and dividends. lastDividendDate
    is always absolute. */
    changes: IxcSweepsClearingV1SweepFundsSpec;
}

export const IXC_SWEEPS_CLEARING_V1_SWEEP_TARGET_STATS_EVENT_TYPE_ONE_OF_VALUES = ['updated', 'paid', 'batchUpdated'] as const;

export type IxcSweepsClearingV1SweepTargetStatsEventTypeOneOfValue = (typeof IXC_SWEEPS_CLEARING_V1_SWEEP_TARGET_STATS_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcSweepsClearingV1SweepTargetStatsKeys {
    /* The unique ID of the sweep target */
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId: string;
    /* The first day of the month for which the stats are calculated. */
    // format: YYYY-MM-DD
    firstDayOfMonth: string;
}

export interface IxcSweepsClearingV1SweepTargetStatsQueryServiceSweepTargetStatsEventsSweepTargetStatsEventsRequest {
    /* The unique ID of the sweep target */
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId: string;
    /* The first day of the month for which the stats are calculated. */
    // format: YYYY-MM-DD
    firstDayOfMonth: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcSweepsClearingV1SweepTargetStatsQueryServiceSweepTargetStatsEventsSortableFields, IxcSweepsClearingV1SweepTargetStatsQueryServiceSweepTargetStatsEventsFilterableFields>;
}

export enum IxcSweepsClearingV1SweepTargetStatsQueryServiceSweepTargetStatsEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    SweepTargetId = 'sweepTargetId',
    FirstDayOfMonth = 'firstDayOfMonth',
    EventType = 'event.!type'
}

export enum IxcSweepsClearingV1SweepTargetStatsQueryServiceSweepTargetStatsEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcSweepsClearingV1SweepTargetStatsQueryServiceSweepTargetStatsGetSweepTargetStatsGetRequest {
    /* The unique ID of the sweep target */
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId: string;
    /* The first day of the month for which the stats are calculated. */
    // format: YYYY-MM-DD
    firstDayOfMonth: string;
}

export interface IxcSweepsClearingV1SweepTargetStatsQueryServiceSweepTargetStatsListSweepTargetStatsListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcSweepsClearingV1SweepTargetStatsQueryServiceSweepTargetStatsListSortableFields, IxcSweepsClearingV1SweepTargetStatsQueryServiceSweepTargetStatsListFilterableFields>;
}

export enum IxcSweepsClearingV1SweepTargetStatsQueryServiceSweepTargetStatsListFilterableFields {
    SweepTargetId = 'sweepTargetId',
    FirstDayOfMonth = 'firstDayOfMonth',
    Status = 'status'
}

export enum IxcSweepsClearingV1SweepTargetStatsQueryServiceSweepTargetStatsListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcSweepsClearingV1SweepTargetStatsState extends IxcSweepsClearingV1SweepTargetStatsKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcSweepsClearingV1SweepTargetStatsData;
    status: IxcSweepsClearingV1SweepTargetStatsStatus;
}

export enum IxcSweepsClearingV1SweepTargetStatsStatus {
    Unspecified = 'UNSPECIFIED',
    Valid = 'VALID'
}

export interface IxcSweepsClearingV1TaskBatchResult {
    /* ID of the task that completed */
    // format: id62
    sweepsTaskId: string;
    taskStatus: IxcSweepsClearingV1TaskUpdatedStatus;
    /* Operation-specific data associated with the task update */
    data?: IxcSweepsClearingV1TaskUpdatedData;
}

export type IxcSweepsClearingV1TaskCreatedInfo = {
    '!type'?: 'activityReport';
    activityReport: IxcSweepsClearingV1ActivityReportTaskCreatedInfo;
} | {
    '!type'?: 'dividendsPay';
    dividendsPay: IxcSweepsClearingV1DividendsPayTaskCreatedInfo;
} | {
    '!type'?: 'dividendsCalculate';
    dividendsCalculate: IxcSweepsClearingV1DividendsCalculateTaskCreatedInfo;
} | {
    '!type'?: 'dividendsRecalculate';
    dividendsRecalculate: IxcSweepsClearingV1DividendsRecalculateTaskCreatedInfo;
} | {
    '!type'?: 'balancesReconcile';
    balancesReconcile: IxcSweepsClearingV1BalancesReconcileTaskCreatedInfo;
};

export const IXC_SWEEPS_CLEARING_V1_TASK_CREATED_INFO_ONE_OF_VALUES = ['activityReport', 'dividendsPay', 'dividendsCalculate', 'dividendsRecalculate', 'balancesReconcile'] as const;

export type IxcSweepsClearingV1TaskCreatedInfoOneOfValue = (typeof IXC_SWEEPS_CLEARING_V1_TASK_CREATED_INFO_ONE_OF_VALUES)[number];

export type IxcSweepsClearingV1TaskFinishedInfo = {
    '!type'?: 'activityReport';
    activityReport: IxcSweepsClearingV1ActivityReportTaskFinishedInfo;
} | {
    '!type'?: 'dividendsPay';
    dividendsPay: IxcSweepsClearingV1DividendsPayTaskFinishedInfo;
} | {
    '!type'?: 'dividendsCalculate';
    dividendsCalculate: IxcSweepsClearingV1DividendsCalculateTaskFinishedInfo;
} | {
    '!type'?: 'dividendsRecalculate';
    dividendsRecalculate: IxcSweepsClearingV1DividendsRecalculateTaskFinishedInfo;
} | {
    '!type'?: 'balancesReconcile';
    balancesReconcile: IxcSweepsClearingV1BalancesReconcileTaskFinishedInfo;
};

export const IXC_SWEEPS_CLEARING_V1_TASK_FINISHED_INFO_ONE_OF_VALUES = ['activityReport', 'dividendsPay', 'dividendsCalculate', 'dividendsRecalculate', 'balancesReconcile'] as const;

export type IxcSweepsClearingV1TaskFinishedInfoOneOfValue = (typeof IXC_SWEEPS_CLEARING_V1_TASK_FINISHED_INFO_ONE_OF_VALUES)[number];

export type IxcSweepsClearingV1TaskSpec = {
    '!type'?: 'activityReport';
    activityReport: IxcSweepsClearingV1ActivityReportTaskSpec;
} | {
    '!type'?: 'dividendsPay';
    dividendsPay: IxcSweepsClearingV1DividendsPayTaskSpec;
} | {
    '!type'?: 'dividendsCalculate';
    dividendsCalculate: IxcSweepsClearingV1DividendsCalculateTaskSpec;
} | {
    '!type'?: 'dividendsRecalculate';
    dividendsRecalculate: IxcSweepsClearingV1DividendsRecalculateTaskSpec;
} | {
    '!type'?: 'balancesReconcile';
    balancesReconcile: IxcSweepsClearingV1BalancesReconcileTaskSpec;
};

export const IXC_SWEEPS_CLEARING_V1_TASK_SPEC_ONE_OF_VALUES = ['activityReport', 'dividendsPay', 'dividendsCalculate', 'dividendsRecalculate', 'balancesReconcile'] as const;

export type IxcSweepsClearingV1TaskSpecOneOfValue = (typeof IXC_SWEEPS_CLEARING_V1_TASK_SPEC_ONE_OF_VALUES)[number];

export type IxcSweepsClearingV1TaskStartedInfo = {
    '!type'?: 'activityReport';
    activityReport: IxcSweepsClearingV1ActivityReportTaskStartedInfo;
} | {
    '!type'?: 'dividendsPay';
    dividendsPay: IxcSweepsClearingV1DividendsPayTaskStartedInfo;
} | {
    '!type'?: 'dividendsCalculate';
    dividendsCalculate: IxcSweepsClearingV1DividendsCalculateTaskStartedInfo;
} | {
    '!type'?: 'dividendsRecalculate';
    dividendsRecalculate: IxcSweepsClearingV1DividendsRecalculateTaskStartedInfo;
} | {
    '!type'?: 'balancesReconcile';
    balancesReconcile: IxcSweepsClearingV1BalancesReconcileTaskStartedInfo;
};

export const IXC_SWEEPS_CLEARING_V1_TASK_STARTED_INFO_ONE_OF_VALUES = ['activityReport', 'dividendsPay', 'dividendsCalculate', 'dividendsRecalculate', 'balancesReconcile'] as const;

export type IxcSweepsClearingV1TaskStartedInfoOneOfValue = (typeof IXC_SWEEPS_CLEARING_V1_TASK_STARTED_INFO_ONE_OF_VALUES)[number];

export type IxcSweepsClearingV1TaskUpdatedData = {
    '!type'?: 'activityReport';
    activityReport: IxcSweepsClearingV1ActivityReportTaskUpdatedData;
} | {
    '!type'?: 'dividendsPay';
    dividendsPay: EmptyObject;
} | {
    '!type'?: 'dividendsCalculate';
    dividendsCalculate: EmptyObject;
} | {
    '!type'?: 'dividendsRecalculate';
    dividendsRecalculate: IxcSweepsClearingV1DividendsRecalculateTaskUpdatedData;
} | {
    '!type'?: 'balancesReconcile';
    balancesReconcile: IxcSweepsClearingV1BalancesReconcileTaskUpdatedData;
};

export const IXC_SWEEPS_CLEARING_V1_TASK_UPDATED_DATA_ONE_OF_VALUES = ['activityReport', 'dividendsPay', 'dividendsCalculate', 'dividendsRecalculate', 'balancesReconcile'] as const;

export type IxcSweepsClearingV1TaskUpdatedDataOneOfValue = (typeof IXC_SWEEPS_CLEARING_V1_TASK_UPDATED_DATA_ONE_OF_VALUES)[number];

export enum IxcSweepsClearingV1TaskUpdatedStatus {
    Unspecified = 'UNSPECIFIED',
    Processing = 'PROCESSING',
    Succeeded = 'SUCCEEDED',
    Errored = 'ERRORED',
    Failed = 'FAILED'
}

export interface IxcSweepsV1CutoffContributor {
    /* Which layer set this close: the funds session's weekly hours, a session
    exception, the fund's own regular hours, or an asset exception. Ties go
    to the session. */
    source: IxcSweepsV1CutoffSource;
    /* The target fund this close belongs to. Empty when the session bound the
    cutoff (a SESSION_DEFAULT or SESSION_EXCEPTION limiting factor). */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
    /* The close time (HH:MM). */
    close: string;
    /* IANA timezone the close is expressed in. */
    timezone: string;
    /* The exception that shaped this close (id + name), set only when source is
    ASSET_EXCEPTION or SESSION_EXCEPTION. */
    exception?: IxcSweepsV1CutoffException;
    /* The target fund's full symbol including any suffix, so consumers can
    label the close without a separate asset lookup. Empty when the session
    bound the cutoff, or when the fund has no symbol. */
    fullSymbol?: string;
}

export interface IxcSweepsV1CutoffException {
    /* An hours exceptionId for SESSION_EXCEPTION; an assetExceptionId for
    ASSET_EXCEPTION. */
    // format: id62
    exceptionId?: string;
    name: string;
}

export enum IxcSweepsV1CutoffSource {
    Unspecified = 'UNSPECIFIED',
    Regular = 'REGULAR',
    AssetException = 'ASSET_EXCEPTION',
    SessionException = 'SESSION_EXCEPTION',
    SessionDefault = 'SESSION_DEFAULT'
}

export interface IxcSweepsV1EligibleSweepTargetAsset {
    // format: id62, entity: ixc.assets.v1.Asset
    assetId: string;
    /* The name of the asset. */
    name: string;
    /* The full symbol of the asset, including any suffixes. */
    fullSymbol?: string;
    /* The CUSIP of the asset. */
    cusip?: string;
    /* The fund family of the money market fund. */
    fundFamily: IxcAssetsV1FundFamily;
}

export interface IxcSweepsV1SweepPlanComponent {
    /* The ID of the sweep target */
    // format: id62, entity: ixc.sweeps.v1.SweepTarget
    sweepTargetId: string;
    /* The percentage of the sweep amount to allocate to this target. Must be
    between 0 and 100. Values are rounded to two decimal places. */
    // format: decimal
    percentage: string;
}

export interface IxcSweepsV1SweepPlanData {
    /* The display name of the sweep plan. */
    name?: string;
    /* The list of sweep plan components, each specifying a target and
    percentage. */
    components?: IxcSweepsV1SweepPlanComponent[];
}

export interface IxcSweepsV1SweepPlanEvent extends IxcSweepsV1SweepPlanKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcSweepsV1SweepPlanEventType;
}

export type IxcSweepsV1SweepPlanEventType = {
    '!type'?: 'created';
    created: IxcSweepsV1SweepPlanEventTypeCreated;
} | {
    '!type'?: 'updated';
    updated: IxcSweepsV1SweepPlanEventTypeUpdated;
} | {
    '!type'?: 'archived';
    archived: EmptyObject;
};

export interface IxcSweepsV1SweepPlanEventTypeCreated {
    /* The display name of the sweep plan. */
    name?: string;
    /* The list of sweep plan components, each specifying a target and
    percentage. */
    components?: IxcSweepsV1SweepPlanComponent[];
}

export interface IxcSweepsV1SweepPlanEventTypeUpdated {
    /* The new display name of the sweep plan. */
    name: string;
}

export const IXC_SWEEPS_V1_SWEEP_PLAN_EVENT_TYPE_ONE_OF_VALUES = ['created', 'updated', 'archived'] as const;

export type IxcSweepsV1SweepPlanEventTypeOneOfValue = (typeof IXC_SWEEPS_V1_SWEEP_PLAN_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcSweepsV1SweepPlanKeys {
    /* The unique ID of the sweep plan */
    // format: id62
    sweepPlanId: string;
}

export interface IxcSweepsV1SweepPlanQueryServiceSweepPlanEventsSweepPlanEventsRequest {
    /* The unique ID of the sweep plan */
    // format: id62
    sweepPlanId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcSweepsV1SweepPlanQueryServiceSweepPlanEventsSortableFields, IxcSweepsV1SweepPlanQueryServiceSweepPlanEventsFilterableFields>;
}

export enum IxcSweepsV1SweepPlanQueryServiceSweepPlanEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    SweepPlanId = 'sweepPlanId',
    EventType = 'event.!type'
}

export enum IxcSweepsV1SweepPlanQueryServiceSweepPlanEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcSweepsV1SweepPlanQueryServiceSweepPlanGetSweepPlanGetRequest {
    /* The unique ID of the sweep plan */
    // format: id62
    sweepPlanId: string;
}

export interface IxcSweepsV1SweepPlanQueryServiceSweepPlanListSweepPlanListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcSweepsV1SweepPlanQueryServiceSweepPlanListSearchableFields, IxcSweepsV1SweepPlanQueryServiceSweepPlanListSortableFields, IxcSweepsV1SweepPlanQueryServiceSweepPlanListFilterableFields>;
}

export enum IxcSweepsV1SweepPlanQueryServiceSweepPlanListFilterableFields {
    SweepPlanId = 'sweepPlanId',
    Status = 'status'
}

export enum IxcSweepsV1SweepPlanQueryServiceSweepPlanListSearchableFields {
    DataName = 'data.name'
}

export enum IxcSweepsV1SweepPlanQueryServiceSweepPlanListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcSweepsV1SweepPlanState extends IxcSweepsV1SweepPlanKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcSweepsV1SweepPlanData;
    status: IxcSweepsV1SweepPlanStatus;
}

export enum IxcSweepsV1SweepPlanStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Inactive = 'INACTIVE'
}

export interface IxcSweepsV1SweepsCutoff {
    /* The fund-session open day the sweep runs on (may be later than the
    requested date when that date is not sweepable). */
    // format: YYYY-MM-DD
    tradingDay: string;
    /* The cutoff instant: the earliest close across the funds session and every
    active target fund, minus the cutoff offset. */
    // format: date-time
    cutoff: string;
    /* Minutes subtracted from the earliest close to arrive at the cutoff. */
    // format: INT32
    offsetMinutes: number;
    /* The funds session's close for the day (HH:MM). */
    sessionClose: string;
    /* IANA timezone the session close is expressed in. */
    sessionTimezone: string;
    /* The earliest close, which determined the cutoff — the answer to "why is
    the cutoff this time". Its assetId is empty when the session bound it. */
    limitingFactor: IxcSweepsV1CutoffContributor;
    /* Each active target fund's effective close on the day. */
    funds: IxcSweepsV1CutoffContributor[];
}

export interface IxcSweepsV1SweepsCutoffQueryServiceGetSweepsCutoffGetSweepsCutoffRequest {
    /* The instant to resolve the cutoff as of; the result is the next
    cutoff at or after it. A full timestamp so the answer is
    unambiguous across time zones. Defaults to now. */
    // format: date-time
    asOf?: string;
}

export interface IxcSweepsV1SweepTargetData {
    // format: custom - pattern: ^[0-9A-Z]{9}$
    cusip: string;
    symbol?: IxcAssetsV1Symbol;
    name: string;
    /* The full symbol of the asset, including any suffixes */
    fullSymbol?: string;
    /* The asset to be purchased or redeemed as part of the sweep. This is
    optional because we might not have the asset ID available at the time of
    creating the sweep target (e.g., at start up for now). */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
    /* The fund family of the money market fund */
    fundFamily?: IxcAssetsV1FundFamily;
}

export interface IxcSweepsV1SweepTargetEvent extends IxcSweepsV1SweepTargetKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcSweepsV1SweepTargetEventType;
}

export type IxcSweepsV1SweepTargetEventType = {
    '!type'?: 'created';
    created: IxcSweepsV1SweepTargetEventTypeCreated;
} | {
    '!type'?: 'updated';
    updated: IxcSweepsV1SweepTargetEventTypeUpdated;
} | {
    '!type'?: 'archived';
    archived: EmptyObject;
};

export interface IxcSweepsV1SweepTargetEventTypeCreated {
    // format: custom - pattern: ^[0-9A-Z]{9}$
    cusip: string;
    symbol?: IxcAssetsV1Symbol;
    name: string;
    /* The full symbol of the asset, including any suffixes */
    fullSymbol?: string;
    /* The asset to be purchased or redeemed as part of the sweep. This is
    optional because we might not have the asset ID available at the time of
    creating the sweep target (e.g., at start up for now). */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
    /* The fund family of the money market fund */
    fundFamily?: IxcAssetsV1FundFamily;
}

export interface IxcSweepsV1SweepTargetEventTypeUpdated {
    /* The new name of the asset */
    name?: string;
    /* The symbol of the asset, if applicable */
    symbol?: IxcAssetsV1Symbol;
    /* The full symbol of the asset, including any suffixes */
    fullSymbol?: string;
    /* The ID of the asset associated with the cusip, which we may not have
    at the time of creating the sweep target. */
    // format: id62, entity: ixc.assets.v1.Asset
    assetId?: string;
}

export const IXC_SWEEPS_V1_SWEEP_TARGET_EVENT_TYPE_ONE_OF_VALUES = ['created', 'updated', 'archived'] as const;

export type IxcSweepsV1SweepTargetEventTypeOneOfValue = (typeof IXC_SWEEPS_V1_SWEEP_TARGET_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcSweepsV1SweepTargetKeys {
    /* The unique ID of the sweep target */
    // format: id62
    sweepTargetId: string;
}

export interface IxcSweepsV1SweepTargetQueryServiceSweepTargetEventsSweepTargetEventsRequest {
    /* The unique ID of the sweep target */
    // format: id62
    sweepTargetId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcSweepsV1SweepTargetQueryServiceSweepTargetEventsSearchableFields, IxcSweepsV1SweepTargetQueryServiceSweepTargetEventsSortableFields, IxcSweepsV1SweepTargetQueryServiceSweepTargetEventsFilterableFields>;
}

export enum IxcSweepsV1SweepTargetQueryServiceSweepTargetEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    SweepTargetId = 'sweepTargetId',
    EventCreatedCusip = 'event.created.cusip',
    EventType = 'event.!type'
}

export enum IxcSweepsV1SweepTargetQueryServiceSweepTargetEventsSearchableFields {
    EventCreatedSymbolBase = 'event.created.symbol.base',
    EventCreatedName = 'event.created.name',
    EventUpdatedSymbolBase = 'event.updated.symbol.base'
}

export enum IxcSweepsV1SweepTargetQueryServiceSweepTargetEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcSweepsV1SweepTargetQueryServiceSweepTargetGetSweepTargetGetRequest {
    /* The unique ID of the sweep target */
    // format: id62
    sweepTargetId: string;
}

export interface IxcSweepsV1SweepTargetQueryServiceSweepTargetListSweepTargetListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcSweepsV1SweepTargetQueryServiceSweepTargetListSearchableFields, IxcSweepsV1SweepTargetQueryServiceSweepTargetListSortableFields, IxcSweepsV1SweepTargetQueryServiceSweepTargetListFilterableFields>;
}

export enum IxcSweepsV1SweepTargetQueryServiceSweepTargetListFilterableFields {
    SweepTargetId = 'sweepTargetId',
    DataCusip = 'data.cusip',
    Status = 'status'
}

export enum IxcSweepsV1SweepTargetQueryServiceSweepTargetListSearchableFields {
    DataSymbolBase = 'data.symbol.base',
    DataName = 'data.name'
}

export enum IxcSweepsV1SweepTargetQueryServiceSweepTargetListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcSweepsV1SweepTargetState extends IxcSweepsV1SweepTargetKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcSweepsV1SweepTargetData;
    status: IxcSweepsV1SweepTargetStatus;
}

export enum IxcSweepsV1SweepTargetStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Inactive = 'INACTIVE'
}

export interface IxcTradeV1FirmTradeTransaction {
    // format: id62
    firmOrderId: string;
    // format: informal
    executionId: string;
    // format: date-time
    executionTime: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settlementDate: string;
    // format: informal
    symbol: string;
    // format: informal
    cusip: string;
    // format: id62
    assetId: string;
    side: IxcOrdersV1Side;
    // format: decimal
    quantity: string;
    // format: decimal
    price: string;
    // format: decimal
    grossAmount: string;
}

export interface IxcTradeV1NettingIndicationTransaction {
    // format: id62
    orderId: string;
    /* From the fix and UTC messages */
    // format: informal
    executionId: string;
    // format: date-time
    executionTime: string;
    // format: YYYY-MM-DD
    tradeDate: string;
    // format: YYYY-MM-DD
    settlementDate: string;
    // format: informal
    symbol: string;
    // format: informal
    cusip: string;
    // format: id62
    assetId: string;
    side: IxcOrdersV1Side;
    // format: decimal
    quantity: string;
    /* The price per share */
    // format: decimal
    fillPrice: string;
    /* The total amount of the trade before any fees or commissions */
    // format: decimal
    grossAmount: string;
    // format: decimal
    netSettlementAmount: string;
    nettingIndicator: ExcDtccUtcV1NettingIndicator;
}

export interface IxcTradeV1TradeData {
    /* When the trade was an OMS order */
    // format: id62
    orderId?: string;
    route?: IxcOrdersV1TradeTransaction;
    firmRoute?: IxcTradeV1FirmTradeTransaction;
    utc?: ExcDtccUtcV1Trade;
}

export interface IxcTradeV1TradeEvent extends IxcTradeV1TradeKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcTradeV1TradeEventType;
}

export type IxcTradeV1TradeEventType = {
    '!type'?: 'routeExecution';
    routeExecution: IxcTradeV1TradeEventTypeRouteExecution;
} | {
    '!type'?: 'firmRouteExecution';
    firmRouteExecution: IxcTradeV1TradeEventTypeFirmRouteExecution;
} | {
    '!type'?: 'utcmessage';
    utcmessage: IxcTradeV1TradeEventTypeUtcMessage;
} | {
    '!type'?: 'enterNetting';
    enterNetting: EmptyObject;
} | {
    '!type'?: 'exitNetting';
    exitNetting: EmptyObject;
};

export interface IxcTradeV1TradeEventTypeFirmRouteExecution {
    trade: IxcTradeV1FirmTradeTransaction;
}

export interface IxcTradeV1TradeEventTypeRouteExecution {
    trade: IxcOrdersV1TradeTransaction;
}

export interface IxcTradeV1TradeEventTypeUtcMessage {
    trade: ExcDtccUtcV1Trade;
}

export const IXC_TRADE_V1_TRADE_EVENT_TYPE_ONE_OF_VALUES = ['routeExecution', 'firmRouteExecution', 'utcmessage', 'enterNetting', 'exitNetting'] as const;

export type IxcTradeV1TradeEventTypeOneOfValue = (typeof IXC_TRADE_V1_TRADE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcTradeV1TradeKeys {
    /* Internal identifier, derived from the execution ID. */
    // format: id62
    tradeId: string;
    /* From the fix and UTC messages */
    // format: informal
    executionId: string;
}

export interface IxcTradeV1TradeQueryServiceTradeEventsTradeEventsRequest {
    /* Internal identifier, derived from the execution ID. */
    // format: id62
    tradeId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcTradeV1TradeQueryServiceTradeEventsSortableFields, IxcTradeV1TradeQueryServiceTradeEventsFilterableFields>;
}

export enum IxcTradeV1TradeQueryServiceTradeEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    TradeId = 'tradeId',
    ExecutionId = 'executionId',
    EventType = 'event.!type'
}

export enum IxcTradeV1TradeQueryServiceTradeEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcTradeV1TradeQueryServiceTradeGetTradeGetRequest {
    /* Internal identifier, derived from the execution ID. */
    // format: id62
    tradeId: string;
}

export interface IxcTradeV1TradeQueryServiceTradeListTradeListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcTradeV1TradeQueryServiceTradeListSortableFields, IxcTradeV1TradeQueryServiceTradeListFilterableFields>;
}

export enum IxcTradeV1TradeQueryServiceTradeListFilterableFields {
    TradeId = 'tradeId',
    ExecutionId = 'executionId',
    Status = 'status'
}

export enum IxcTradeV1TradeQueryServiceTradeListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcTradeV1TradeState extends IxcTradeV1TradeKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcTradeV1TradeData;
    status: IxcTradeV1TradeStatus;
}

export enum IxcTradeV1TradeStatus {
    Unspecified = 'UNSPECIFIED',
    RouteOnly = 'ROUTE_ONLY',
    UtcOnly = 'UTC_ONLY',
    Matched = 'MATCHED',
    Netting = 'NETTING',
    Netted = 'NETTED'
}

export interface IxcTradeV1TradeTotalsData {
    // format: decimal
    buyQuantity?: string;
    // format: decimal
    sellQuantity?: string;
    // format: decimal
    buyValue?: string;
    // format: decimal
    sellValue?: string;
}

export interface IxcTradereportingV1BlueSheetData {
    spec: IxcTradereportingV1BlueSheetSpec;
}

export interface IxcTradereportingV1BlueSheetEvent extends IxcTradereportingV1BlueSheetKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcTradereportingV1BlueSheetEventType;
}

export type IxcTradereportingV1BlueSheetEventType = {
    '!type'?: 'created';
    created: IxcTradereportingV1BlueSheetEventTypeCreated;
} | {
    '!type'?: 'generated';
    generated: EmptyObject;
} | {
    '!type'?: 'reported';
    reported: EmptyObject;
} | {
    '!type'?: 'archived';
    archived: EmptyObject;
};

export interface IxcTradereportingV1BlueSheetEventTypeCreated {
    spec: IxcTradereportingV1BlueSheetSpec;
}

export const IXC_TRADEREPORTING_V1_BLUE_SHEET_EVENT_TYPE_ONE_OF_VALUES = ['created', 'generated', 'reported', 'archived'] as const;

export type IxcTradereportingV1BlueSheetEventTypeOneOfValue = (typeof IXC_TRADEREPORTING_V1_BLUE_SHEET_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcTradereportingV1BlueSheetKeys {
    // format: id62
    reportId: string;
}

export interface IxcTradereportingV1BlueSheetQueryServiceBlueSheetEventsBlueSheetEventsRequest {
    // format: id62
    reportId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcTradereportingV1BlueSheetQueryServiceBlueSheetEventsSortableFields, IxcTradereportingV1BlueSheetQueryServiceBlueSheetEventsFilterableFields>;
}

export enum IxcTradereportingV1BlueSheetQueryServiceBlueSheetEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    ReportId = 'reportId',
    EventType = 'event.!type'
}

export enum IxcTradereportingV1BlueSheetQueryServiceBlueSheetEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcTradereportingV1BlueSheetQueryServiceBlueSheetGetBlueSheetGetRequest {
    // format: id62
    reportId: string;
}

export interface IxcTradereportingV1BlueSheetQueryServiceBlueSheetListBlueSheetListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcTradereportingV1BlueSheetQueryServiceBlueSheetListSortableFields, IxcTradereportingV1BlueSheetQueryServiceBlueSheetListFilterableFields>;
}

export enum IxcTradereportingV1BlueSheetQueryServiceBlueSheetListFilterableFields {
    ReportId = 'reportId',
    Status = 'status'
}

export enum IxcTradereportingV1BlueSheetQueryServiceBlueSheetListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcTradereportingV1BlueSheetSpec {
    // format: YYYY-MM-DD
    inquiryDate: string;
    // format: YYYY-MM-DD
    fromDate: string;
    // format: YYYY-MM-DD
    toDate: string;
    // pattern: ^[0-9A-Z]{9}$
    cusip: string;
    symbol?: string;
    side: IxcOrdersV1Side;
    requester: IxcTradereportingV1BlueSheetSpecRequester;
}

export interface IxcTradereportingV1BlueSheetSpecRequester {
    code?: string;
    orgNumber?: string;
}

export interface IxcTradereportingV1BlueSheetState extends IxcTradereportingV1BlueSheetKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcTradereportingV1BlueSheetData;
    status: IxcTradereportingV1BlueSheetStatus;
}

export enum IxcTradereportingV1BlueSheetStatus {
    Unspecified = 'UNSPECIFIED',
    Requested = 'REQUESTED',
    Generated = 'GENERATED',
    Reported = 'REPORTED',
    Archived = 'ARCHIVED'
}

export interface IxcTradereportingV1CaisReportData {
    // format: YYYY-MM-DD
    reportDate: string;
    // format: INT32
    crdNumber: number;
    // format: INT32
    totalAccounts?: number;
    /* S3 keys for CAIS and TIDS files */
    fileKeys?: string[];
    /* Report ID of the companion TIDS report in the reports service */
    // format: id62
    tidsReportId?: string;
}

export interface IxcTradereportingV1CaisReportEvent extends IxcTradereportingV1CaisReportKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcTradereportingV1CaisReportEventType;
}

export type IxcTradereportingV1CaisReportEventType = {
    '!type'?: 'created';
    created: IxcTradereportingV1CaisReportEventTypeCreated;
} | {
    '!type'?: 'processingStarted';
    processingStarted: EmptyObject;
} | {
    '!type'?: 'generated';
    generated: IxcTradereportingV1CaisReportEventTypeGenerated;
} | {
    '!type'?: 'submitted';
    submitted: IxcTradereportingV1CaisReportEventTypeSubmitted;
} | {
    '!type'?: 'failed';
    failed: IxcTradereportingV1CaisReportEventTypeFailed;
};

export interface IxcTradereportingV1CaisReportEventTypeCreated {
    // format: YYYY-MM-DD
    reportDate: string;
    // format: INT32
    crdNumber: number;
}

export interface IxcTradereportingV1CaisReportEventTypeFailed {
    errorMessage: string;
}

export interface IxcTradereportingV1CaisReportEventTypeGenerated {
    fileKeys?: string[];
    // format: INT32
    totalAccounts: number;
    /* Report ID of the companion TIDS report in the reports service */
    // format: id62
    tidsReportId?: string;
}

export interface IxcTradereportingV1CaisReportEventTypeSubmitted {
    submissionId: string;
}

export const IXC_TRADEREPORTING_V1_CAIS_REPORT_EVENT_TYPE_ONE_OF_VALUES = ['created', 'processingStarted', 'generated', 'submitted', 'failed'] as const;

export type IxcTradereportingV1CaisReportEventTypeOneOfValue = (typeof IXC_TRADEREPORTING_V1_CAIS_REPORT_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcTradereportingV1CaisReportKeys {
    /* Primary identifier */
    // format: id62
    reportId: string;
}

export interface IxcTradereportingV1CaisReportQueryServiceCaisReportEventsCaisReportEventsRequest {
    /* Primary identifier */
    // format: id62
    reportId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcTradereportingV1CaisReportQueryServiceCaisReportEventsSortableFields, IxcTradereportingV1CaisReportQueryServiceCaisReportEventsFilterableFields>;
}

export enum IxcTradereportingV1CaisReportQueryServiceCaisReportEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    ReportId = 'reportId',
    EventType = 'event.!type'
}

export enum IxcTradereportingV1CaisReportQueryServiceCaisReportEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcTradereportingV1CaisReportQueryServiceCaisReportGetCaisReportGetRequest {
    /* Primary identifier */
    // format: id62
    reportId: string;
}

export interface IxcTradereportingV1CaisReportQueryServiceCaisReportListCaisReportListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcTradereportingV1CaisReportQueryServiceCaisReportListSortableFields, IxcTradereportingV1CaisReportQueryServiceCaisReportListFilterableFields>;
}

export enum IxcTradereportingV1CaisReportQueryServiceCaisReportListFilterableFields {
    ReportId = 'reportId',
    Status = 'status'
}

export enum IxcTradereportingV1CaisReportQueryServiceCaisReportListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcTradereportingV1CaisReportState extends IxcTradereportingV1CaisReportKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcTradereportingV1CaisReportData;
    status: IxcTradereportingV1CaisReportStatus;
}

export enum IxcTradereportingV1CaisReportStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Processing = 'PROCESSING',
    Generated = 'GENERATED',
    Submitted = 'SUBMITTED',
    Error = 'ERROR'
}

export interface IxcTradereportingV1CatReportData {
    // format: YYYY-MM-DD
    reportDate: string;
    mpid: string;
    // format: INT32
    totalEvents?: number;
    /* S3 keys for generated CAT files */
    fileKeys?: string[];
}

export interface IxcTradereportingV1CatReportEvent extends IxcTradereportingV1CatReportKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcTradereportingV1CatReportEventType;
}

export type IxcTradereportingV1CatReportEventType = {
    '!type'?: 'created';
    created: IxcTradereportingV1CatReportEventTypeCreated;
} | {
    '!type'?: 'processingStarted';
    processingStarted: EmptyObject;
} | {
    '!type'?: 'generated';
    generated: IxcTradereportingV1CatReportEventTypeGenerated;
} | {
    '!type'?: 'submitted';
    submitted: IxcTradereportingV1CatReportEventTypeSubmitted;
} | {
    '!type'?: 'failed';
    failed: IxcTradereportingV1CatReportEventTypeFailed;
};

export interface IxcTradereportingV1CatReportEventTypeCreated {
    // format: YYYY-MM-DD
    reportDate: string;
    mpid: string;
}

export interface IxcTradereportingV1CatReportEventTypeFailed {
    errorMessage: string;
}

export interface IxcTradereportingV1CatReportEventTypeGenerated {
    fileKeys?: string[];
    // format: INT32
    totalEvents: number;
}

export interface IxcTradereportingV1CatReportEventTypeSubmitted {
    submissionId: string;
}

export const IXC_TRADEREPORTING_V1_CAT_REPORT_EVENT_TYPE_ONE_OF_VALUES = ['created', 'processingStarted', 'generated', 'submitted', 'failed'] as const;

export type IxcTradereportingV1CatReportEventTypeOneOfValue = (typeof IXC_TRADEREPORTING_V1_CAT_REPORT_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcTradereportingV1CatReportKeys {
    /* Primary identifier */
    // format: id62
    reportId: string;
}

export interface IxcTradereportingV1CatReportQueryServiceCatReportEventsCatReportEventsRequest {
    /* Primary identifier */
    // format: id62
    reportId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcTradereportingV1CatReportQueryServiceCatReportEventsSortableFields, IxcTradereportingV1CatReportQueryServiceCatReportEventsFilterableFields>;
}

export enum IxcTradereportingV1CatReportQueryServiceCatReportEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    ReportId = 'reportId',
    EventType = 'event.!type'
}

export enum IxcTradereportingV1CatReportQueryServiceCatReportEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcTradereportingV1CatReportQueryServiceCatReportGetCatReportGetRequest {
    /* Primary identifier */
    // format: id62
    reportId: string;
}

export interface IxcTradereportingV1CatReportQueryServiceCatReportListCatReportListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcTradereportingV1CatReportQueryServiceCatReportListSortableFields, IxcTradereportingV1CatReportQueryServiceCatReportListFilterableFields>;
}

export enum IxcTradereportingV1CatReportQueryServiceCatReportListFilterableFields {
    ReportId = 'reportId',
    Status = 'status'
}

export enum IxcTradereportingV1CatReportQueryServiceCatReportListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcTradereportingV1CatReportState extends IxcTradereportingV1CatReportKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcTradereportingV1CatReportData;
    status: IxcTradereportingV1CatReportStatus;
}

export enum IxcTradereportingV1CatReportStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Processing = 'PROCESSING',
    Generated = 'GENERATED',
    Submitted = 'SUBMITTED',
    Error = 'ERROR'
}

export interface IxcTradereportingV1OrderBlotterServiceRecordListRecordListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxcTradereportingV1OrderBlotterServiceRecordListSearchableFields, IxcTradereportingV1OrderBlotterServiceRecordListSortableFields, IxcTradereportingV1OrderBlotterServiceRecordListFilterableFields>;
}

export enum IxcTradereportingV1OrderBlotterServiceRecordListFilterableFields {
    OrderOrderId = 'order.orderId',
    OrderAccountId = 'order.accountId',
    OrderProgramId = 'order.programId',
    OrderDataInstructionSide = 'order.data.instruction.side',
    OrderDataAssetAssetId = 'order.data.asset.assetId',
    OrderDataAssetDataTypeEquityCusip = 'order.data.asset.data.type.equity.cusip',
    OrderDataAssetDataTypeEquityControlsCanBuy = 'order.data.asset.data.type.equity.controls.canBuy',
    OrderDataAssetDataTypeEquityControlsCanSell = 'order.data.asset.data.type.equity.controls.canSell',
    OrderDataAssetDataTypeEquityControlsCanEnterFractions = 'order.data.asset.data.type.equity.controls.canEnterFractions',
    OrderDataAssetDataTypeMoneyMarketCusip = 'order.data.asset.data.type.moneyMarket.cusip',
    OrderDataAssetDataTypeMoneyMarketControlsCanBuy = 'order.data.asset.data.type.moneyMarket.controls.canBuy',
    OrderDataAssetDataTypeMoneyMarketControlsCanSell = 'order.data.asset.data.type.moneyMarket.controls.canSell',
    OrderDataAssetDataTypeMoneyMarketControlsCanEnterFractions = 'order.data.asset.data.type.moneyMarket.controls.canEnterFractions',
    OrderDataAssetDataTypeMoneyMarketClassification = 'order.data.asset.data.type.moneyMarket.classification',
    OrderDataAssetDataTypeMoneyMarketNavType = 'order.data.asset.data.type.moneyMarket.navType',
    OrderDataAssetDataTypeType = 'order.data.asset.data.type.!type',
    OrderDataAssetDataCategory = 'order.data.asset.data.category',
    OrderDataAssetStatus = 'order.data.asset.status',
    OrderDataHoldId = 'order.data.holdId',
    OrderDataBatchOrderId = 'order.data.batchOrderId',
    OrderStatus = 'order.status',
    AccountSummaryRegistrationProfileNaturalPersonsPersonW9Signed = 'account.summary.registration.profile.naturalPersons.person.w9.signed',
    AccountSummaryRegistrationProfileNaturalPersonsOthersW9Signed = 'account.summary.registration.profile.naturalPersons.others.w9.signed',
    AccountSummaryRegistrationProfileOrganizationW9Signed = 'account.summary.registration.profile.organization.w9.signed'
}

export enum IxcTradereportingV1OrderBlotterServiceRecordListSearchableFields {
    OrderDataAssetDataTypeEquitySymbolBase = 'order.data.asset.data.type.equity.symbol.base',
    OrderDataAssetDataTypeEquityName = 'order.data.asset.data.type.equity.name',
    OrderDataAssetDataTypeMoneyMarketSymbolBase = 'order.data.asset.data.type.moneyMarket.symbol.base',
    OrderDataAssetDataTypeMoneyMarketName = 'order.data.asset.data.type.moneyMarket.name',
    AccountDisplayId = 'account.displayId',
    AccountSummaryRegistrationProfileNaturalPersonsPersonNameDetailsFirst = 'account.summary.registration.profile.naturalPersons.person.nameDetails.first',
    AccountSummaryRegistrationProfileNaturalPersonsPersonNameDetailsLast = 'account.summary.registration.profile.naturalPersons.person.nameDetails.last',
    AccountSummaryRegistrationProfileNaturalPersonsOthersNameDetailsFirst = 'account.summary.registration.profile.naturalPersons.others.nameDetails.first',
    AccountSummaryRegistrationProfileNaturalPersonsOthersNameDetailsLast = 'account.summary.registration.profile.naturalPersons.others.nameDetails.last'
}

export enum IxcTradereportingV1OrderBlotterServiceRecordListSortableFields {
    OrderMetadataCreatedAt = 'order.metadata.createdAt',
    OrderMetadataUpdatedAt = 'order.metadata.updatedAt',
    OrderDataAssetMetadataCreatedAt = 'order.data.asset.metadata.createdAt',
    OrderDataAssetMetadataUpdatedAt = 'order.data.asset.metadata.updatedAt'
}

export interface IxcTradereportingV1Sec606AReportData {
    // format: INT32
    crdNumber: number;
    // format: INT32
    quarter: number;
    // format: INT32
    year: number;
    context?: string;
    pdfSubmissionFileKey?: string;
    xmlSubmissionFileKey?: string;
    // format: date-time
    submissionTime?: string;
    acceptedFileKey?: string;
    rejectedFileKey?: string;
    submissionErrors?: IxcTradereportingV1SubmissionError[];
    /* public FINRA report URL */
    publishUrl?: string;
    // format: id62
    supersededById?: string;
}

export interface IxcTradereportingV1Sec606AReportEvent extends IxcTradereportingV1Sec606AReportKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcTradereportingV1Sec606AReportEventType;
}

export type IxcTradereportingV1Sec606AReportEventType = {
    '!type'?: 'created';
    created: IxcTradereportingV1Sec606AReportEventTypeCreated;
} | {
    '!type'?: 'generated';
    generated: IxcTradereportingV1Sec606AReportEventTypeGenerated;
} | {
    '!type'?: 'submitted';
    submitted: IxcTradereportingV1Sec606AReportEventTypeSubmitted;
} | {
    '!type'?: 'rejected';
    rejected: IxcTradereportingV1Sec606AReportEventTypeRejected;
} | {
    '!type'?: 'accepted';
    accepted: IxcTradereportingV1Sec606AReportEventTypeAccepted;
} | {
    '!type'?: 'published';
    published: IxcTradereportingV1Sec606AReportEventTypePublished;
} | {
    '!type'?: 'superseded';
    superseded: IxcTradereportingV1Sec606AReportEventTypeSuperseded;
} | {
    '!type'?: 'generationFailed';
    generationFailed: IxcTradereportingV1Sec606AReportEventTypeGenerationFailed;
};

export interface IxcTradereportingV1Sec606AReportEventTypeAccepted {
    fileKey: string;
    submission: IxcTradereportingV1SubmissionResponse;
}

export interface IxcTradereportingV1Sec606AReportEventTypeCreated {
    // format: INT32
    year: number;
    // format: INT32
    quarter: number;
    // format: INT32
    crdNumber: number;
}

export interface IxcTradereportingV1Sec606AReportEventTypeGenerated {
    pdfFileKey: string;
    xmlFileKey: string;
}

export interface IxcTradereportingV1Sec606AReportEventTypeGenerationFailed {
    error: string;
}

export interface IxcTradereportingV1Sec606AReportEventTypePublished {
    publishUrl: string;
}

export interface IxcTradereportingV1Sec606AReportEventTypeRejected {
    fileKey: string;
    errors: IxcTradereportingV1SubmissionError[];
}

export interface IxcTradereportingV1Sec606AReportEventTypeSubmitted {
    filename: string;
    fileKey: string;
    // format: date-time
    submissionTime: string;
}

export interface IxcTradereportingV1Sec606AReportEventTypeSuperseded {
    // format: id62
    supersededById: string;
}

export const IXC_TRADEREPORTING_V1_SEC606_A_REPORT_EVENT_TYPE_ONE_OF_VALUES = ['created', 'generated', 'submitted', 'rejected', 'accepted', 'published', 'superseded', 'generationFailed'] as const;

export type IxcTradereportingV1Sec606AReportEventTypeOneOfValue = (typeof IXC_TRADEREPORTING_V1_SEC606_A_REPORT_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcTradereportingV1Sec606AReportKeys {
    // format: id62
    reportId: string;
}

export interface IxcTradereportingV1Sec606AReportQueryServiceSec606AReportEventsSec606AReportEventsRequest {
    // format: id62
    reportId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcTradereportingV1Sec606AReportQueryServiceSec606AReportEventsSortableFields, IxcTradereportingV1Sec606AReportQueryServiceSec606AReportEventsFilterableFields>;
}

export enum IxcTradereportingV1Sec606AReportQueryServiceSec606AReportEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    ReportId = 'reportId',
    EventType = 'event.!type'
}

export enum IxcTradereportingV1Sec606AReportQueryServiceSec606AReportEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcTradereportingV1Sec606AReportQueryServiceSec606AReportGetSec606AReportGetRequest {
    // format: id62
    reportId: string;
}

export interface IxcTradereportingV1Sec606AReportQueryServiceSec606AReportListSec606AReportListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcTradereportingV1Sec606AReportQueryServiceSec606AReportListSortableFields, IxcTradereportingV1Sec606AReportQueryServiceSec606AReportListFilterableFields>;
}

export enum IxcTradereportingV1Sec606AReportQueryServiceSec606AReportListFilterableFields {
    ReportId = 'reportId',
    DataQuarter = 'data.quarter',
    DataYear = 'data.year',
    Status = 'status'
}

export enum IxcTradereportingV1Sec606AReportQueryServiceSec606AReportListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataQuarter = 'data.quarter',
    DataYear = 'data.year'
}

export interface IxcTradereportingV1Sec606AReportState extends IxcTradereportingV1Sec606AReportKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcTradereportingV1Sec606AReportData;
    status: IxcTradereportingV1Sec606AReportStatus;
}

export enum IxcTradereportingV1Sec606AReportStatus {
    Unspecified = 'UNSPECIFIED',
    Processing = 'PROCESSING',
    Generated = 'GENERATED',
    Submitted = 'SUBMITTED',
    Rejected = 'REJECTED',
    Accepted = 'ACCEPTED',
    Superseded = 'SUPERSEDED',
    Published = 'PUBLISHED',
    Errored = 'ERRORED'
}

export interface IxcTradereportingV1RecordListResponseRecord {
    order: IxcOrdersV1OrderState;
    trade: IxcOrdersV1TradeTransaction;
    account: IxcRegistrationV1AccountEnrichedSummary;
}

export interface IxcTradereportingV1SubmissionError {
    name?: string;
    message?: string;
}

export interface IxcTradereportingV1SubmissionResponse {
    message?: string;
}

export enum IxcTrfV1SequenceUpdateReason {
    Unspecified = 'UNSPECIFIED',
    ManualSet = 'MANUAL_SET',
    Bump = 'BUMP',
    GapFill = 'GAP_FILL',
    Resync = 'RESYNC'
}

export interface IxcTrfV1TrfReportData {
    symbol: string;
    mpid?: string;
    // bytes (base64-encoded)
    fixRequest: string;
    // bytes (base64-encoded)
    fixReply?: string;
    errorMessage?: string;
    /* The customer order this report's execution belongs to. Optional because
    reports created before this field do not carry it. */
    // format: id62, entity: ixc.orders.v1.Order
    orderId?: string;
}

export interface IxcTrfV1TrfReportEvent extends IxcTrfV1TrfReportKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcTrfV1TrfReportEventType;
}

export type IxcTrfV1TrfReportEventType = {
    '!type'?: 'created';
    created: IxcTrfV1TrfReportEventTypeCreated;
} | {
    '!type'?: 'acked';
    acked: IxcTrfV1TrfReportEventTypeAcked;
} | {
    '!type'?: 'failed';
    failed: IxcTrfV1TrfReportEventTypeFailed;
};

export interface IxcTrfV1TrfReportEventTypeAcked {
    // bytes (base64-encoded)
    fixReply: string;
}

export interface IxcTrfV1TrfReportEventTypeCreated {
    executionId: string;
    hashedId: string;
    symbol: string;
    mpid?: string;
    // bytes (base64-encoded)
    fixRequest: string;
    // format: id62
    orderId?: string;
}

export interface IxcTrfV1TrfReportEventTypeFailed {
    // bytes (base64-encoded)
    fixReply?: string;
    errorMessage: string;
}

export const IXC_TRF_V1_TRF_REPORT_EVENT_TYPE_ONE_OF_VALUES = ['created', 'acked', 'failed'] as const;

export type IxcTrfV1TrfReportEventTypeOneOfValue = (typeof IXC_TRF_V1_TRF_REPORT_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcTrfV1TrfReportKeys {
    // format: id62
    trfReportId: string;
    /* The execution this TRF report is for */
    // format: informal
    executionId?: string;
    /* 20-char SHA1 hash of executionId. Used for:
    - ACK matching with Nasdaq (ExecID tag 17)
    - tapeTradeId in CAT MEOT events */
    // format: informal
    hashedId?: string;
}

export interface IxcTrfV1TrfReportQueryServiceTrfReportEventsTrfReportEventsRequest {
    // format: id62
    trfReportId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcTrfV1TrfReportQueryServiceTrfReportEventsSortableFields, IxcTrfV1TrfReportQueryServiceTrfReportEventsFilterableFields>;
}

export enum IxcTrfV1TrfReportQueryServiceTrfReportEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    TrfReportId = 'trfReportId',
    ExecutionId = 'executionId',
    HashedId = 'hashedId',
    EventType = 'event.!type'
}

export enum IxcTrfV1TrfReportQueryServiceTrfReportEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcTrfV1TrfReportQueryServiceTrfReportGetTrfReportGetRequest {
    // format: id62
    trfReportId: string;
}

export interface IxcTrfV1TrfReportQueryServiceTrfReportListTrfReportListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcTrfV1TrfReportQueryServiceTrfReportListSortableFields, IxcTrfV1TrfReportQueryServiceTrfReportListFilterableFields>;
}

export enum IxcTrfV1TrfReportQueryServiceTrfReportListFilterableFields {
    TrfReportId = 'trfReportId',
    ExecutionId = 'executionId',
    HashedId = 'hashedId',
    Status = 'status'
}

export enum IxcTrfV1TrfReportQueryServiceTrfReportListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcTrfV1TrfReportState extends IxcTrfV1TrfReportKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcTrfV1TrfReportData;
    status: IxcTrfV1TrfReportStatus;
}

export enum IxcTrfV1TrfReportStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Acked = 'ACKED',
    Failed = 'FAILED'
}

export interface IxcTrfV1TrfSessionConfig {
    /* Hostname or IP address of the TRF FIX gateway */
    targetHost: string;
    /* Port number for the FIX connection */
    // format: INT32
    targetPort: number;
    /* Which TRF venue this session connects to */
    venue: IxcTrfV1TrfVenue;
    /* Market Participant Identifier (MPID) for trade reporting */
    mpid: string;
    /* FIX heartbeat interval in seconds (default: 30) */
    // format: INT32
    heartbeatInterval?: number;
}

export interface IxcTrfV1TrfSessionData {
    /* Next outgoing sequence number */
    // format: INT32
    senderSeq: number;
    /* Next expected incoming sequence number */
    // format: INT32
    targetSeq: number;
    /* Whether the FIX initiator process is currently started */
    initiatorRunning?: boolean;
    /* Whether the session is currently logged on to the TRF */
    isLoggedOn?: boolean;
    /* Session configuration including connection details and TRF settings */
    config: IxcTrfV1TrfSessionConfig;
}

export interface IxcTrfV1TrfSessionEvent extends IxcTrfV1TrfSessionKeys {
    metadata: J5StateV1EventMetadata;
    event: IxcTrfV1TrfSessionEventType;
}

export type IxcTrfV1TrfSessionEventType = {
    '!type'?: 'registered';
    registered: IxcTrfV1TrfSessionEventTypeRegistered;
} | {
    '!type'?: 'connected';
    connected: IxcTrfV1TrfSessionEventTypeConnected;
} | {
    '!type'?: 'disconnected';
    disconnected: IxcTrfV1TrfSessionEventTypeDisconnected;
} | {
    '!type'?: 'restored';
    restored: EmptyObject;
} | {
    '!type'?: 'initiatorStarted';
    initiatorStarted: EmptyObject;
} | {
    '!type'?: 'initiatorStopped';
    initiatorStopped: EmptyObject;
} | {
    '!type'?: 'sequenceNumbersUpdated';
    sequenceNumbersUpdated: IxcTrfV1TrfSessionEventTypeSequenceNumbersUpdated;
} | {
    '!type'?: 'sequenceNumbersReset';
    sequenceNumbersReset: EmptyObject;
} | {
    '!type'?: 'resendRequested';
    resendRequested: IxcTrfV1TrfSessionEventTypeResendRequested;
} | {
    '!type'?: 'configUpdated';
    configUpdated: IxcTrfV1TrfSessionEventTypeConfigUpdated;
};

export interface IxcTrfV1TrfSessionEventTypeConfigUpdated {
    /* The new configuration */
    config: IxcTrfV1TrfSessionConfig;
}

export interface IxcTrfV1TrfSessionEventTypeConnected {
    /* Sender sequence number at time of connection */
    // format: INT32
    senderSeq: number;
    /* Target sequence number at time of connection */
    // format: INT32
    targetSeq: number;
}

export interface IxcTrfV1TrfSessionEventTypeDisconnected {
    /* Reason for disconnection if available */
    reason?: string;
    /* Whether the disconnect was initiated gracefully via logout */
    graceful?: boolean;
}

export interface IxcTrfV1TrfSessionEventTypeRegistered {
    /* FIX SenderCompID (tag 49) */
    senderCompId: string;
    /* FIX SenderSubID (tag 50) */
    senderSubId: string;
    /* FIX TargetCompID (tag 56) */
    targetCompId: string;
    /* FIX TargetSubID (tag 57) */
    targetSubId: string;
    /* Initial session configuration */
    config: IxcTrfV1TrfSessionConfig;
}

export interface IxcTrfV1TrfSessionEventTypeResendRequested {
    /* Beginning sequence number of the requested range */
    // format: INT32
    beginSeqNo: number;
    /* Ending sequence number of the requested range (0 for open-ended) */
    // format: INT32
    endSeqNo: number;
}

export interface IxcTrfV1TrfSessionEventTypeSequenceNumbersUpdated {
    /* New sender sequence number */
    // format: INT32
    senderSeq: number;
    /* New target sequence number */
    // format: INT32
    targetSeq: number;
    /* Reason for the update */
    reason: IxcTrfV1SequenceUpdateReason;
}

export const IXC_TRF_V1_TRF_SESSION_EVENT_TYPE_ONE_OF_VALUES = ['registered', 'connected', 'disconnected', 'restored', 'initiatorStarted', 'initiatorStopped', 'sequenceNumbersUpdated', 'sequenceNumbersReset', 'resendRequested', 'configUpdated'] as const;

export type IxcTrfV1TrfSessionEventTypeOneOfValue = (typeof IXC_TRF_V1_TRF_SESSION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxcTrfV1TrfSessionKeys {
    /* Unique identifier for the TRF session */
    // format: id62
    sessionId: string;
    /* FIX SenderCompID (tag 49) - identifies the reporting firm */
    senderCompId?: string;
    /* FIX SenderSubID (tag 50) - sub-identifier within the firm */
    senderSubId?: string;
    /* FIX TargetCompID (tag 56) - identifies the TRF (e.g., NSDQ for Nasdaq
    TRF) */
    targetCompId?: string;
    /* FIX TargetSubID (tag 57) - sub-identifier for the TRF venue */
    targetSubId?: string;
}

export interface IxcTrfV1TrfSessionQueryServiceTrfSessionEventsTrfSessionEventsRequest {
    /* Unique identifier for the TRF session */
    // format: id62
    sessionId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcTrfV1TrfSessionQueryServiceTrfSessionEventsSortableFields, IxcTrfV1TrfSessionQueryServiceTrfSessionEventsFilterableFields>;
}

export enum IxcTrfV1TrfSessionQueryServiceTrfSessionEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    SessionId = 'sessionId',
    EventType = 'event.!type'
}

export enum IxcTrfV1TrfSessionQueryServiceTrfSessionEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxcTrfV1TrfSessionQueryServiceTrfSessionGetTrfSessionGetRequest {
    /* Unique identifier for the TRF session */
    // format: id62
    sessionId: string;
}

export interface IxcTrfV1TrfSessionQueryServiceTrfSessionListTrfSessionListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxcTrfV1TrfSessionQueryServiceTrfSessionListSortableFields, IxcTrfV1TrfSessionQueryServiceTrfSessionListFilterableFields>;
}

export enum IxcTrfV1TrfSessionQueryServiceTrfSessionListFilterableFields {
    SessionId = 'sessionId',
    Status = 'status'
}

export enum IxcTrfV1TrfSessionQueryServiceTrfSessionListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxcTrfV1TrfSessionState extends IxcTrfV1TrfSessionKeys {
    metadata: J5StateV1StateMetadata;
    data: IxcTrfV1TrfSessionData;
    status: IxcTrfV1TrfSessionStatus;
}

export enum IxcTrfV1TrfSessionStatus {
    Unspecified = 'UNSPECIFIED',
    Stopped = 'STOPPED',
    Connecting = 'CONNECTING',
    Disconnected = 'DISCONNECTED',
    LoggedOn = 'LOGGED_ON'
}

export enum IxcTrfV1TrfVenue {
    Unspecified = 'UNSPECIFIED',
    Carteret = 'CARTERET',
    Chicago = 'CHICAGO'
}

export enum IxfAccountingV1AccountClassification {
    Unspecified = 'UNSPECIFIED',
    Asset = 'ASSET',
    Liability = 'LIABILITY',
    Equity = 'EQUITY',
    Revenue = 'REVENUE',
    Expense = 'EXPENSE'
}

export interface IxfAccountingV1AccountData {
    classification: IxfAccountingV1AccountClassification;
    spec: IxfAccountingV1AccountSpec;
    // format: informal
    mapCodes?: string[];
}

export interface IxfAccountingV1AccountEvent extends IxcRegistrationV1AccountKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfAccountingV1AccountEventType;
}

export type IxfAccountingV1AccountEventType = {
    '!type'?: 'accountCreated';
    accountCreated: IxfAccountingV1AccountEventTypeAccountCreated;
} | {
    '!type'?: 'accountUpdated';
    accountUpdated: IxfAccountingV1AccountEventTypeAccountUpdated;
} | {
    '!type'?: 'setAccountCodes';
    setAccountCodes: IxfAccountingV1AccountEventTypeSetAccountCodes;
} | {
    '!type'?: 'activated';
    activated: EmptyObject;
} | {
    '!type'?: 'deactivated';
    deactivated: EmptyObject;
};

export interface IxfAccountingV1AccountEventTypeAccountCreated {
    classification: IxfAccountingV1AccountClassification;
    spec: IxfAccountingV1AccountSpec;
    mapCodes?: string[];
}

export interface IxfAccountingV1AccountEventTypeAccountUpdated {
    spec: IxfAccountingV1AccountSpec;
}

export interface IxfAccountingV1AccountEventTypeSetAccountCodes {
    mapCodes: string[];
}

export const IXF_ACCOUNTING_V1_ACCOUNT_EVENT_TYPE_ONE_OF_VALUES = ['accountCreated', 'accountUpdated', 'setAccountCodes', 'activated', 'deactivated'] as const;

export type IxfAccountingV1AccountEventTypeOneOfValue = (typeof IXF_ACCOUNTING_V1_ACCOUNT_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfAccountingV1AccountKeys {
    // format: id62
    accountId: string;
}

export interface IxfAccountingV1AccountQueryServiceAccountEventsAccountEventsRequest {
    // format: id62
    accountId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxfAccountingV1AccountQueryServiceAccountEventsSearchableFields, IxfAccountingV1AccountQueryServiceAccountEventsSortableFields, IxfAccountingV1AccountQueryServiceAccountEventsFilterableFields>;
}

export enum IxfAccountingV1AccountQueryServiceAccountEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AccountId = 'accountId',
    EventAccountCreatedSpecNumber = 'event.accountCreated.spec.number',
    EventAccountUpdatedSpecNumber = 'event.accountUpdated.spec.number',
    EventType = 'event.!type'
}

export enum IxfAccountingV1AccountQueryServiceAccountEventsSearchableFields {
    EventAccountCreatedSpecLabel = 'event.accountCreated.spec.label',
    EventAccountUpdatedSpecLabel = 'event.accountUpdated.spec.label'
}

export enum IxfAccountingV1AccountQueryServiceAccountEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxfAccountingV1AccountQueryServiceAccountGetAccountGetRequest {
    // format: id62
    accountId: string;
}

export interface IxfAccountingV1AccountQueryServiceAccountListAccountListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxfAccountingV1AccountQueryServiceAccountListSearchableFields, IxfAccountingV1AccountQueryServiceAccountListSortableFields, IxfAccountingV1AccountQueryServiceAccountListFilterableFields>;
}

export enum IxfAccountingV1AccountQueryServiceAccountListFilterableFields {
    AccountId = 'accountId',
    DataClassification = 'data.classification',
    DataSpecNumber = 'data.spec.number',
    Status = 'status'
}

export enum IxfAccountingV1AccountQueryServiceAccountListSearchableFields {
    DataSpecLabel = 'data.spec.label'
}

export enum IxfAccountingV1AccountQueryServiceAccountListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxfAccountingV1AccountSpec {
    /* Chart Of Accounts Number */
    // format: informal
    number: string;
    /* Short description to show in report views */
    label: string;
    /* Longer description in UIs and in single-account views */
    description?: string;
}

export interface IxfAccountingV1AccountState extends IxfAccountingV1AccountKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfAccountingV1AccountData;
    status: IxfAccountingV1AccountStatus;
}

export enum IxfAccountingV1AccountStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Inactive = 'INACTIVE'
}

export interface IxfAccountingV1AssetServiceDeltasDeltasRequest {
    /* The account to filter deltas by */
    // format: id62
    accountId: string;
    /* The sub-account to filter deltas by */
    // format: id62
    subAccountId?: string;
    // format: YYYY-MM-DD
    fromDate: string;
    // format: YYYY-MM-DD
    toDate: string;
    page?: J5ListV1PageRequest;
}

export interface IxfAccountingV1BalanceSheet {
    columns?: IxfAccountingV1BalanceSheetColumns[];
    assets: IxfAccountingV1BalanceSheetSection;
    liabilities: IxfAccountingV1BalanceSheetSection;
    equity: IxfAccountingV1BalanceSheetSection;
}

export interface IxfAccountingV1BalanceSheetColumns {
    label?: string;
    // format: YYYY-MM-DD
    closeDate?: string;
}

export interface IxfAccountingV1BalanceSheetSection {
    rows?: IxfAccountingV1BalanceSheetSectionRows[];
}

export interface IxfAccountingV1BalanceSheetSectionRows {
    // format: id62
    accountId: string;
    glNumber?: string;
    name?: string;
    // format: decimal
    balances?: string[];
}

export interface IxfAccountingV1ConfigData {
    // format: YYYY-MM-DD
    lockOutDate: string;
}

export interface IxfAccountingV1ConfigEvent extends IxfAccountingV1ConfigKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfAccountingV1ConfigEventType;
}

export type IxfAccountingV1ConfigEventType = {
    '!type'?: 'init';
    init: IxfAccountingV1ConfigEventTypeInit;
} | {
    '!type'?: 'setLockOutDate';
    setLockOutDate: IxfAccountingV1ConfigEventTypeSetLockOutDate;
};

export interface IxfAccountingV1ConfigEventTypeInit {
    // format: YYYY-MM-DD
    lockOutDate: string;
}

export interface IxfAccountingV1ConfigEventTypeSetLockOutDate {
    // format: YYYY-MM-DD
    lockOutDate: string;
}

export const IXF_ACCOUNTING_V1_CONFIG_EVENT_TYPE_ONE_OF_VALUES = ['init', 'setLockOutDate'] as const;

export type IxfAccountingV1ConfigEventTypeOneOfValue = (typeof IXF_ACCOUNTING_V1_CONFIG_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfAccountingV1ConfigKeys {
    global: string;
}

export interface IxfAccountingV1ConfigQueryServiceConfigEventsConfigEventsRequest {
    global: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfAccountingV1ConfigQueryServiceConfigEventsSortableFields, IxfAccountingV1ConfigQueryServiceConfigEventsFilterableFields>;
}

export enum IxfAccountingV1ConfigQueryServiceConfigEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventType = 'event.!type'
}

export enum IxfAccountingV1ConfigQueryServiceConfigEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxfAccountingV1ConfigQueryServiceConfigGetConfigGetRequest {
    global: string;
}

export interface IxfAccountingV1ConfigQueryServiceConfigListConfigListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfAccountingV1ConfigQueryServiceConfigListSortableFields, IxfAccountingV1ConfigQueryServiceConfigListFilterableFields>;
}

export enum IxfAccountingV1ConfigQueryServiceConfigListFilterableFields {
    Status = 'status'
}

export enum IxfAccountingV1ConfigQueryServiceConfigListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxfAccountingV1ConfigState extends IxfAccountingV1ConfigKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfAccountingV1ConfigData;
    status: IxfAccountingV1ConfigStatus;
}

export enum IxfAccountingV1ConfigStatus {
    Unspecified = 'UNSPECIFIED',
    Open = 'OPEN'
}

export interface IxfAccountingV1Delta {
    /* The sequence number of the delta in the transaction, common across all
    assets. */
    // format: INT32
    seq?: number;
    /* The COA Account matched to the delta */
    // format: id62, entity: ixf.accounting.v1.Account
    accountId: string;
    mapped?: IxfAccountingV1DeltaMapped;
    /* The number of units of the asset being affected. Positive numbers are
    Debits or debit-equivalents in non-cash assets. */
    // format: decimal
    amount: string;
    /* If true, this delta is a reversal of a delta in a previous transaction
    which is now in status REVERSED */
    isReverse?: boolean;
    /* Notes on manual or complex entries */
    note?: string;
}

export interface IxfAccountingV1DeltaMapped {
    code: string;
    // format: id62
    subAccountId?: string;
}

export interface IxfAccountingV1File {
    // format: id62
    fileId: string;
    filename: string;
}

export interface IxfAccountingV1FileServiceDownloadFileDownloadFileRequest {
    // format: id62
    fileId: string;
}

export interface IxfAccountingV1IncomeStatement {
    columns?: IxfAccountingV1IncomeStatementColumns[];
    revenue: IxfAccountingV1IncomeStatementSection;
    expenses: IxfAccountingV1IncomeStatementSection;
}

export interface IxfAccountingV1IncomeStatementColumns {
    label?: string;
    // format: YYYY-MM-DD
    openDate?: string;
    // format: YYYY-MM-DD
    closeDate?: string;
}

export interface IxfAccountingV1IncomeStatementSection {
    rows?: IxfAccountingV1IncomeStatementSectionRows[];
}

export interface IxfAccountingV1IncomeStatementSectionRows {
    // format: id62
    accountId: string;
    glNumber?: string;
    name?: string;
    // format: decimal
    balances?: string[];
}

export interface IxfAccountingV1ManualEntryData {
    // format: id62, entity: ixf.accounting.v1.Transaction
    transactionId: string;
    // format: date-time
    postedTimestamp: string;
    // format: id62, entity: ixf.accounting.v1.Transaction
    reversingTransactionId?: string;
    // format: YYYY-MM-DD
    date: string;
    description?: string;
    /* When set, the entry will be automatically reversed on this date */
    // format: YYYY-MM-DD
    autoReverseDate?: string;
    deltas?: IxfAccountingV1ManualEntrySpecDeltas[];
    attachments?: IxfAccountingV1File[];
}

export interface IxfAccountingV1ManualEntryEvent extends IxcRaglV1ManualEntryKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfAccountingV1ManualEntryEventType;
}

export type IxfAccountingV1ManualEntryEventType = {
    '!type'?: 'posted';
    posted: IxfAccountingV1ManualEntryEventTypePosted;
} | {
    '!type'?: 'reversed';
    reversed: IxfAccountingV1ManualEntryEventTypeReversed;
} | {
    '!type'?: 'canceled';
    canceled: IxfAccountingV1ManualEntryEventTypeCanceled;
} | {
    '!type'?: 'attachmentAdded';
    attachmentAdded: IxfAccountingV1ManualEntryEventTypeAttachmentAdded;
} | {
    '!type'?: 'attachmentRemoved';
    attachmentRemoved: IxfAccountingV1ManualEntryEventTypeAttachmentRemoved;
};

export interface IxfAccountingV1ManualEntryEventTypeAttachmentAdded {
    file: IxfAccountingV1File;
}

export interface IxfAccountingV1ManualEntryEventTypeAttachmentRemoved {
    // format: id62
    fileId: string;
}

export interface IxfAccountingV1ManualEntryEventTypeCanceled {
    // format: date-time
    cancelTimestamp: string;
    // format: YYYY-MM-DD
    lockOutDate: string;
    reason?: string;
}

export interface IxfAccountingV1ManualEntryEventTypePosted {
    // format: YYYY-MM-DD
    date: string;
    description?: string;
    /* When set, the entry will be automatically reversed on this date */
    // format: YYYY-MM-DD
    autoReverseDate?: string;
    deltas?: IxfAccountingV1ManualEntrySpecDeltas[];
    // format: id62, entity: ixf.accounting.v1.Transaction
    transactionId: string;
    // format: date-time
    postedTimestamp: string;
    // format: YYYY-MM-DD
    lockOutDate: string;
}

export interface IxfAccountingV1ManualEntryEventTypeReversed {
    // format: date-time
    reversePostedTimestamp: string;
    // format: YYYY-MM-DD
    reverseDate: string;
    // format: id62
    reversingTransactionId: string;
    // format: YYYY-MM-DD
    lockOutDate: string;
    reason?: string;
}

export const IXF_ACCOUNTING_V1_MANUAL_ENTRY_EVENT_TYPE_ONE_OF_VALUES = ['posted', 'reversed', 'canceled', 'attachmentAdded', 'attachmentRemoved'] as const;

export type IxfAccountingV1ManualEntryEventTypeOneOfValue = (typeof IXF_ACCOUNTING_V1_MANUAL_ENTRY_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfAccountingV1ManualEntryKeys {
    // format: id62
    entryId: string;
}

export interface IxfAccountingV1ManualEntryQueryServiceManualEntryEventsManualEntryEventsRequest {
    // format: id62
    entryId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfAccountingV1ManualEntryQueryServiceManualEntryEventsSortableFields, IxfAccountingV1ManualEntryQueryServiceManualEntryEventsFilterableFields>;
}

export enum IxfAccountingV1ManualEntryQueryServiceManualEntryEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EntryId = 'entryId',
    EventType = 'event.!type'
}

export enum IxfAccountingV1ManualEntryQueryServiceManualEntryEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxfAccountingV1ManualEntryQueryServiceManualEntryGetManualEntryGetRequest {
    // format: id62
    entryId: string;
}

export interface IxfAccountingV1ManualEntryQueryServiceManualEntryListManualEntryListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfAccountingV1ManualEntryQueryServiceManualEntryListSortableFields, IxfAccountingV1ManualEntryQueryServiceManualEntryListFilterableFields>;
}

export enum IxfAccountingV1ManualEntryQueryServiceManualEntryListFilterableFields {
    EntryId = 'entryId',
    Status = 'status'
}

export enum IxfAccountingV1ManualEntryQueryServiceManualEntryListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxfAccountingV1ManualEntrySpec {
    // format: YYYY-MM-DD
    date: string;
    description?: string;
    /* When set, the entry will be automatically reversed on this date */
    // format: YYYY-MM-DD
    autoReverseDate?: string;
    deltas?: IxfAccountingV1ManualEntrySpecDeltas[];
}

export interface IxfAccountingV1ManualEntrySpecDeltas {
    /* The COA account matched to the delta */
    // format: id62, entity: ixf.accounting.v1.Account
    accountId: string;
    /* The cash amount of the delta, Debit = Positive, Credit = Negative */
    // format: decimal
    amount: string;
    note?: string;
}

export interface IxfAccountingV1ManualEntryState extends IxfAccountingV1ManualEntryKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfAccountingV1ManualEntryData;
    status: IxfAccountingV1ManualEntryStatus;
}

export enum IxfAccountingV1ManualEntryStatus {
    Unspecified = 'UNSPECIFIED',
    Posted = 'POSTED',
    Reversed = 'REVERSED',
    Canceled = 'CANCELED'
}

export interface IxfAccountingV1ManualEntryTransaction {
    /* The ID of the manual entry */
    // format: id62, entity: ixf.accounting.v1.ManualEntry
    entryId: string;
    description?: string;
}

export interface IxfAccountingV1MapCodeQueryServiceMapCodesMapCodesRequest {
    page?: J5ListV1PageRequest;
}

export interface IxfAccountingV1ReportsServiceBalanceSheetBalanceSheetRequest {
    periods?: IxfAccountingV1BalanceSheetRequestPeriods[];
}

export interface IxfAccountingV1ReportsServiceIncomeStatementIncomeStatementRequest {
    periods?: IxfAccountingV1IncomeStatementRequestPeriods[];
}

export interface IxfAccountingV1ReportsServiceTrialBalanceTrialBalanceRequest {
    /* Balances at the close of the specified date.
    When not specified, defaults to the last day of the current
    calendar year. */
    // format: YYYY-MM-DD
    toDate?: string;
    /* Income and Expense accounts are reset to zero at the opening of
    each period with a 'virtual closing entry'. The default is the
    first day of the calendar year of toDate. */
    // format: YYYY-MM-DD
    fromDate?: string;
}

export interface IxfAccountingV1ReverseLink {
    /* The unique identifier of the transaction which reverses this one */
    // format: id62
    transactionId?: string;
    /* The reason for the reversal */
    reason?: string;
}

export interface IxfAccountingV1BalanceSheetRequestPeriods {
    /* Period ends on the evening of this day (e.g. last day of month) */
    // format: YYYY-MM-DD
    closeDate: string;
    /* Optional label for the period, e.g. "Q1 2023" */
    label?: string;
}

export interface IxfAccountingV1DeltasResponseDeltas {
    transaction: IxfAccountingV1TransactionState;
    delta: IxfAccountingV1Delta;
}

export type IxfAccountingV1DeltasResponseTotals = {
    '!type'?: 'temporary';
    temporary: IxfAccountingV1DeltasResponseTotalsTemporary;
} | {
    '!type'?: 'permanent';
    permanent: IxfAccountingV1DeltasResponseTotalsPermanent;
};

export interface IxfAccountingV1DeltasResponseTotalsPermanent {
    // format: decimal
    openingBalance: string;
    // format: decimal
    closingBalance: string;
}

export interface IxfAccountingV1DeltasResponseTotalsTemporary {
    /* The total of all deltas in the date range */
    // format: decimal
    total: string;
}

export const IXF_ACCOUNTING_V1_DELTAS_RESPONSE_TOTALS_ONE_OF_VALUES = ['temporary', 'permanent'] as const;

export type IxfAccountingV1DeltasResponseTotalsOneOfValue = (typeof IXF_ACCOUNTING_V1_DELTAS_RESPONSE_TOTALS_ONE_OF_VALUES)[number];

export interface IxfAccountingV1IncomeStatementRequestPeriods {
    /* Period starts on the morning of this day (e.g. first day of month) */
    // format: YYYY-MM-DD
    openDate: string;
    /* Period ends on the evening of this day (e.g. last day of month) */
    // format: YYYY-MM-DD
    closeDate: string;
    /* Optional label for the period, e.g. "Q1 2023" */
    label?: string;
}

export interface IxfAccountingV1TransactionData {
    /* The changes in the account balance caused by the transaction */
    deltas: IxfAccountingV1Delta[];
    /* The accounting date, in America/New_York timesone */
    // format: YYYY-MM-DD
    date: string;
    /* The date and time the transaction is effective. This field is optional
    within DECL/Accounting, transactions from Portfolio and RAGL will have
    timestamps */
    // format: date-time
    timestamp?: string;
    /* Timestamp of the entry where it came from Portfolio / RAGL, or the
    current timestamp for manual entries. This creates a consistent sort
    order within a day. Note this may not be within the same date as the
    transaction, entries must be sorted by date first. */
    // format: date-time
    sortTimestamp: string;
    /* The extended details causing the transaction */
    detail?: IxfAccountingV1TransactionDetail;
    /* This transaction reverses another transaction. In cases where the
    reversal is just a cancel, the deltas in this transaction will all be
    marked as `isReverse`
    In cases where the reversal is a correction, the same reversal deltas
    will be present plus a set of corrected deltas, i.e. the deltas will not
    be netted or combined.
    Corrections may further be corrected, leading to a chain of transactions
    which are all reversals of each other. */
    reverses?: IxfAccountingV1ReverseLink;
    /* When transaction is in REVERSED status, this field shows basic
    information about the transaction which corrects or replaces it. */
    reversedBy?: IxfAccountingV1ReverseLink;
    attachments?: IxfAccountingV1File[];
}

export type IxfAccountingV1TransactionDetail = {
    '!type': 'ixf.accounting.v1.ManualEntryTransaction';
    value: IxfAccountingV1ManualEntryTransaction;
} | {
    '!type': 'ixc.trade.v1.NettingIndicationTransaction';
    value: IxcTradeV1NettingIndicationTransaction;
} | {
    '!type': 'ixc.sweeps.clearing.v1.SweepsTransaction';
    value: IxcSweepsClearingV1SweepsTransaction;
} | {
    '!type': 'exc.jpmam.v1.MoneyMarketTransaction';
    value: ExcJpmamV1MoneyMarketTransaction;
} | {
    '!type': 'ixc.ragl.v1.ManualTransaction';
    value: IxcRaglV1ManualTransaction;
} | {
    '!type': 'ixc.inventory.v1.SettleTradingDayTransaction';
    value: IxcInventoryV1SettleTradingDayTransaction;
} | {
    '!type': 'ixc.inventory.v1.CloseTradingDayTransaction';
    value: IxcInventoryV1CloseTradingDayTransaction;
} | {
    '!type': 'ixc.inventory.v1.InventoryTradeTransaction';
    value: IxcInventoryV1InventoryTradeTransaction;
} | {
    '!type': 'ixc.dtcc.cns.v1.SettlementTransaction';
    value: IxcDtccCnsV1SettlementTransaction;
} | {
    '!type': 'ixc.corpactions.caadmin.v1.DTCPaymentTransaction';
    value: IxcCorpactionsCaadminV1DtcPaymentTransaction;
} | {
    '!type': 'ixc.orders.v1.TradeTransaction';
    value: IxcOrdersV1TradeTransaction;
} | {
    '!type': 'ixc.orders.v1.BatchAllocationCustomerTransaction';
    value: IxcOrdersV1BatchAllocationCustomerTransaction;
} | {
    '!type': 'ixc.orders.v1.BatchAllocationAvgPriceTransaction';
    value: IxcOrdersV1BatchAllocationAvgPriceTransaction;
} | {
    '!type': 'ixc.portfolio.v1.DividendPaymentTransaction';
    value: IxcPortfolioV1DividendPaymentTransaction;
} | {
    '!type': 'ixc.funding.v1.FundingTransaction';
    value: IxcFundingV1FundingTransaction;
} | {
    '!type': 'ixc.funding.v1.FundingBatchTransaction';
    value: IxcFundingV1FundingBatchTransaction;
} | {
    '!type': 'ixc.corpactions.v1.CorpactionTransaction';
    value: IxcCorpactionsV1CorpactionTransaction;
} | {
    '!type': 'ixc.orders.v1.BatchRemainderInventoryTransaction';
    value: IxcOrdersV1BatchRemainderInventoryTransaction;
} | {
    '!type': 'ixc.billing.v1.ChargeTransaction';
    value: IxcBillingV1ChargeTransaction;
} | {
    '!type': 'ixc.billing.v1.CustomerChargeTransaction';
    value: IxcBillingV1CustomerChargeTransaction;
} | {
    '!type': 'ixc.mutualfunds.v1.FundTransaction';
    value: IxcMutualfundsV1FundTransaction;
};

export const IXF_ACCOUNTING_V1_TRANSACTION_DETAIL_MEMBERS = ['ixf.accounting.v1.ManualEntryTransaction', 'ixc.trade.v1.NettingIndicationTransaction', 'ixc.sweeps.clearing.v1.SweepsTransaction', 'exc.jpmam.v1.MoneyMarketTransaction', 'ixc.ragl.v1.ManualTransaction', 'ixc.inventory.v1.SettleTradingDayTransaction', 'ixc.inventory.v1.CloseTradingDayTransaction', 'ixc.inventory.v1.InventoryTradeTransaction', 'ixc.dtcc.cns.v1.SettlementTransaction', 'ixc.corpactions.caadmin.v1.DTCPaymentTransaction', 'ixc.orders.v1.TradeTransaction', 'ixc.orders.v1.BatchAllocationCustomerTransaction', 'ixc.orders.v1.BatchAllocationAvgPriceTransaction', 'ixc.portfolio.v1.DividendPaymentTransaction', 'ixc.funding.v1.FundingTransaction', 'ixc.funding.v1.FundingBatchTransaction', 'ixc.corpactions.v1.CorpactionTransaction', 'ixc.orders.v1.BatchRemainderInventoryTransaction', 'ixc.billing.v1.ChargeTransaction', 'ixc.billing.v1.CustomerChargeTransaction', 'ixc.mutualfunds.v1.FundTransaction'] as const;

export type IxfAccountingV1TransactionDetailMember = (typeof IXF_ACCOUNTING_V1_TRANSACTION_DETAIL_MEMBERS)[number];

export interface IxfAccountingV1TransactionEvent extends IxcPortfolioV1TransactionKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfAccountingV1TransactionEventType;
}

export type IxfAccountingV1TransactionEventType = {
    '!type'?: 'posted';
    posted: IxfAccountingV1TransactionEventTypePosted;
} | {
    '!type'?: 'reversed';
    reversed: IxfAccountingV1TransactionEventTypeReversed;
} | {
    '!type'?: 'canceled';
    canceled: IxfAccountingV1TransactionEventTypeCanceled;
};

export interface IxfAccountingV1TransactionEventTypeCanceled {
    reason?: string;
}

export interface IxfAccountingV1TransactionEventTypePosted {
    /* The changes in the account balance caused by the transaction */
    deltas: IxfAccountingV1Delta[];
    /* The accounting date, in America/New_York timesone */
    // format: YYYY-MM-DD
    date: string;
    /* The date and time the transaction is effective. This field is optional
    within DECL/Accounting, transactions from Portfolio and RAGL will have
    timestamps */
    // format: date-time
    timestamp?: string;
    /* Timestamp of the entry where it came from Portfolio / RAGL, or the
    current timestamp for manual entries. This creates a consistent sort
    order within a day. Note this may not be within the same date as the
    transaction, entries must be sorted by date first. */
    // format: date-time
    sortTimestamp: string;
    /* The extended details causing the transaction */
    detail?: IxfAccountingV1TransactionDetail;
    /* This transaction reverses another transaction. In cases where the
    reversal is just a cancel, the deltas in this transaction will all be
    marked as `isReverse`
    In cases where the reversal is a correction, the same reversal deltas
    will be present plus a set of corrected deltas, i.e. the deltas will not
    be netted or combined.
    Corrections may further be corrected, leading to a chain of transactions
    which are all reversals of each other. */
    reverses?: IxfAccountingV1ReverseLink;
}

export interface IxfAccountingV1TransactionEventTypeReversed {
    reason?: string;
    // format: id62
    reversingTransactionId: string;
}

export const IXF_ACCOUNTING_V1_TRANSACTION_EVENT_TYPE_ONE_OF_VALUES = ['posted', 'reversed', 'canceled'] as const;

export type IxfAccountingV1TransactionEventTypeOneOfValue = (typeof IXF_ACCOUNTING_V1_TRANSACTION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfAccountingV1TransactionKeys {
    // format: id62
    transactionId: string;
}

export interface IxfAccountingV1TransactionQueryServiceTransactionEventsTransactionEventsRequest {
    // format: id62
    transactionId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfAccountingV1TransactionQueryServiceTransactionEventsSortableFields, IxfAccountingV1TransactionQueryServiceTransactionEventsFilterableFields>;
}

export enum IxfAccountingV1TransactionQueryServiceTransactionEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    TransactionId = 'transactionId',
    EventPostedDeltasAccountId = 'event.posted.deltas.accountId',
    EventPostedDate = 'event.posted.date',
    EventType = 'event.!type'
}

export enum IxfAccountingV1TransactionQueryServiceTransactionEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventPostedDate = 'event.posted.date'
}

export interface IxfAccountingV1TransactionQueryServiceTransactionGetTransactionGetRequest {
    // format: id62
    transactionId: string;
}

export interface IxfAccountingV1TransactionQueryServiceTransactionListTransactionListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfAccountingV1TransactionQueryServiceTransactionListSortableFields, IxfAccountingV1TransactionQueryServiceTransactionListFilterableFields>;
}

export enum IxfAccountingV1TransactionQueryServiceTransactionListFilterableFields {
    TransactionId = 'transactionId',
    DataDeltasAccountId = 'data.deltas.accountId',
    DataDate = 'data.date',
    Status = 'status'
}

export enum IxfAccountingV1TransactionQueryServiceTransactionListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataDate = 'data.date'
}

export interface IxfAccountingV1TransactionState extends IxfAccountingV1TransactionKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfAccountingV1TransactionData;
    status: IxfAccountingV1TransactionStatus;
}

export enum IxfAccountingV1TransactionStatus {
    Unspecified = 'UNSPECIFIED',
    Posted = 'POSTED',
    Reversed = 'REVERSED',
    Canceled = 'CANCELED'
}

export interface IxfAccountingV1TrialBalance {
    // format: YYYY-MM-DD
    fromDate: string;
    // format: YYYY-MM-DD
    toDate: string;
    rows?: IxfAccountingV1TrialBalanceRows[];
}

export interface IxfAccountingV1TrialBalanceRows {
    // format: id62
    accountId?: string;
    glNumber?: string;
    glClass?: IxfAccountingV1AccountClassification;
    name?: string;
    /* Total balance of the account. Positive is Debit, negative is Credit.
    Displays should show the absolute value split across Debit and Credit
    columns. */
    // format: decimal
    balance: string;
}

export interface IxfDocumentsV1DocumentCommandServiceDownloadDocumentDownloadDocumentRequest {
    // format: id62
    documentId: string;
}

export interface IxfDocumentsV1DocumentData {
    spec: IxfDocumentsV1DocumentSpec;
}

export interface IxfDocumentsV1DocumentEvent extends IxfDocumentsV1DocumentKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfDocumentsV1DocumentEventType;
}

export type IxfDocumentsV1DocumentEventType = {
    '!type'?: 'uploaded';
    uploaded: IxfDocumentsV1DocumentEventTypeUploaded;
} | {
    '!type'?: 'replaced';
    replaced: IxfDocumentsV1DocumentEventTypeReplaced;
};

export interface IxfDocumentsV1DocumentEventTypeReplaced {
    // format: id62
    replacedBy: string;
}

export interface IxfDocumentsV1DocumentEventTypeUploaded {
    spec: IxfDocumentsV1DocumentSpec;
}

export const IXF_DOCUMENTS_V1_DOCUMENT_EVENT_TYPE_ONE_OF_VALUES = ['uploaded', 'replaced'] as const;

export type IxfDocumentsV1DocumentEventTypeOneOfValue = (typeof IXF_DOCUMENTS_V1_DOCUMENT_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfDocumentsV1DocumentKeys {
    // format: id62
    documentId: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
    // format: id62, entity: ixc.registration.v1.Account
    accountId: string;
}

export interface IxfDocumentsV1DocumentQueryServiceDocumentEventsDocumentEventsRequest {
    // format: id62
    documentId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfDocumentsV1DocumentQueryServiceDocumentEventsSortableFields, IxfDocumentsV1DocumentQueryServiceDocumentEventsFilterableFields>;
}

export enum IxfDocumentsV1DocumentQueryServiceDocumentEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    DocumentId = 'documentId',
    ProgramId = 'programId',
    AccountId = 'accountId',
    EventUploadedSpecStartDate = 'event.uploaded.spec.startDate',
    EventUploadedSpecEndDate = 'event.uploaded.spec.endDate',
    EventUploadedSpecCreatedAt = 'event.uploaded.spec.createdAt',
    EventUploadedSpecTypeType = 'event.uploaded.spec.type.!type',
    EventType = 'event.!type'
}

export enum IxfDocumentsV1DocumentQueryServiceDocumentEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventUploadedSpecStartDate = 'event.uploaded.spec.startDate',
    EventUploadedSpecEndDate = 'event.uploaded.spec.endDate',
    EventUploadedSpecCreatedAt = 'event.uploaded.spec.createdAt'
}

export interface IxfDocumentsV1DocumentQueryServiceDocumentGetDocumentGetRequest {
    // format: id62
    documentId: string;
}

export interface IxfDocumentsV1DocumentQueryServiceDocumentListDocumentListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfDocumentsV1DocumentQueryServiceDocumentListSortableFields, IxfDocumentsV1DocumentQueryServiceDocumentListFilterableFields>;
}

export enum IxfDocumentsV1DocumentQueryServiceDocumentListFilterableFields {
    DocumentId = 'documentId',
    ProgramId = 'programId',
    AccountId = 'accountId',
    DataSpecStartDate = 'data.spec.startDate',
    DataSpecEndDate = 'data.spec.endDate',
    DataSpecCreatedAt = 'data.spec.createdAt',
    DataSpecTypeType = 'data.spec.type.!type',
    Status = 'status'
}

export enum IxfDocumentsV1DocumentQueryServiceDocumentListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataSpecStartDate = 'data.spec.startDate',
    DataSpecEndDate = 'data.spec.endDate',
    DataSpecCreatedAt = 'data.spec.createdAt'
}

export interface IxfDocumentsV1DocumentSpec {
    // format: YYYY-MM-DD
    startDate: string;
    // format: YYYY-MM-DD
    endDate: string;
    // format: date-time
    createdAt: string;
    storageBucket: string;
    storageKey: string;
    type: IxfDocumentsV1DocumentType;
    // format: id62
    replacedBy?: string;
}

export interface IxfDocumentsV1DocumentState extends IxfDocumentsV1DocumentKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfDocumentsV1DocumentData;
    status: IxfDocumentsV1DocumentStatus;
}

export enum IxfDocumentsV1DocumentStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Archived = 'ARCHIVED'
}

export type IxfDocumentsV1DocumentType = {
    '!type'?: 'accountStatement';
    accountStatement: EmptyObject;
} | {
    '!type'?: 'tradeConfirmation';
    tradeConfirmation: EmptyObject;
} | {
    '!type'?: 'taxDocument';
    taxDocument: IxfDocumentsV1DocumentTypeTaxDocument;
} | {
    '!type'?: 'directDepositInstructions';
    directDepositInstructions: EmptyObject;
};

export interface IxfDocumentsV1DocumentTypeTaxDocument {
    type: string;
    // pattern: ^[0-9]{4}$
    year: string;
}

export const IXF_DOCUMENTS_V1_DOCUMENT_TYPE_ONE_OF_VALUES = ['accountStatement', 'tradeConfirmation', 'taxDocument', 'directDepositInstructions'] as const;

export type IxfDocumentsV1DocumentTypeOneOfValue = (typeof IXF_DOCUMENTS_V1_DOCUMENT_TYPE_ONE_OF_VALUES)[number];

export enum IxfHoursV1CalculatedType {
    Unspecified = 'UNSPECIFIED',
    GoodFriday = 'GOOD_FRIDAY'
}

export enum IxfHoursV1DayOfWeek {
    Unspecified = 'UNSPECIFIED',
    Sunday = 'SUNDAY',
    Monday = 'MONDAY',
    Tuesday = 'TUESDAY',
    Wednesday = 'WEDNESDAY',
    Thursday = 'THURSDAY',
    Friday = 'FRIDAY',
    Saturday = 'SATURDAY'
}

export interface IxfHoursV1DayTime {
    /* The day of the week the point falls on. */
    day: IxfHoursV1DayOfWeek;
    /* The time of day in HH:MM, in the owning schedule's timezone. */
    // pattern: ^[0-9]{2}:[0-9]{2}$
    time: string;
}

export interface IxfHoursV1DayTimeWindow {
    starts: IxfHoursV1DayTime;
    stops: IxfHoursV1DayTime;
}

export interface IxfHoursV1ExceptionData {
    /* The rule and the schedules it patches */
    spec: IxfHoursV1ExceptionSpec;
    /* The next observed date for this exception, derived from the rule;
    recomputed on create, on update, and by the periodic tick once the date
    passes. */
    // format: YYYY-MM-DD
    nextObservedDate?: string;
}

export interface IxfHoursV1ExceptionEvent extends IxfHoursV1ExceptionKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfHoursV1ExceptionEventType;
}

export type IxfHoursV1ExceptionEventType = {
    '!type'?: 'created';
    created: IxfHoursV1ExceptionEventTypeCreated;
} | {
    '!type'?: 'updated';
    updated: IxfHoursV1ExceptionEventTypeUpdated;
} | {
    '!type'?: 'iterated';
    iterated: IxfHoursV1ExceptionEventTypeIterated;
} | {
    '!type'?: 'calculated';
    calculated: IxfHoursV1ExceptionEventTypeCalculated;
} | {
    '!type'?: 'archived';
    archived: EmptyObject;
};

export interface IxfHoursV1ExceptionEventTypeCalculated {
    /* The next observed date for this exception after calculation */
    // format: YYYY-MM-DD
    nextObservedDate: string;
}

export interface IxfHoursV1ExceptionEventTypeCreated {
    spec: IxfHoursV1ExceptionSpec;
}

export interface IxfHoursV1ExceptionEventTypeIterated {
    /* The tick instant. Converted to the exception's own timezone before
    the observed date is derived, so the calendar date reflects local
    wallclock rather than UTC. */
    // format: date-time
    iterationTime: string;
}

export interface IxfHoursV1ExceptionEventTypeUpdated {
    spec: IxfHoursV1ExceptionSpec;
}

export const IXF_HOURS_V1_EXCEPTION_EVENT_TYPE_ONE_OF_VALUES = ['created', 'updated', 'iterated', 'calculated', 'archived'] as const;

export type IxfHoursV1ExceptionEventTypeOneOfValue = (typeof IXF_HOURS_V1_EXCEPTION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfHoursV1ExceptionKeys {
    // format: id62
    exceptionId: string;
    /* The region whose schedules this exception patches. */
    region: IxfHoursV1Region;
}

export enum IxfHoursV1ExceptionObservance {
    Unspecified = 'UNSPECIFIED',
    ClosestWeekday = 'CLOSEST_WEEKDAY',
    Explicit = 'EXPLICIT',
    SundayToMonday = 'SUNDAY_TO_MONDAY'
}

export interface IxfHoursV1ExceptionPatch {
    trading?: IxfHoursV1TradingDayException;
    transfers?: IxfHoursV1TransferDayException;
    moneyMarket?: IxfHoursV1MoneyMarketDayException;
}

export interface IxfHoursV1ExceptionQueryServiceExceptionEventsExceptionEventsRequest {
    // format: id62
    exceptionId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfHoursV1ExceptionQueryServiceExceptionEventsSortableFields, IxfHoursV1ExceptionQueryServiceExceptionEventsFilterableFields>;
}

export enum IxfHoursV1ExceptionQueryServiceExceptionEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    ExceptionId = 'exceptionId',
    Region = 'region',
    EventType = 'event.!type'
}

export enum IxfHoursV1ExceptionQueryServiceExceptionEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxfHoursV1ExceptionQueryServiceExceptionGetExceptionGetRequest {
    // format: id62
    exceptionId: string;
}

export interface IxfHoursV1ExceptionQueryServiceExceptionListExceptionListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfHoursV1ExceptionQueryServiceExceptionListSortableFields, IxfHoursV1ExceptionQueryServiceExceptionListFilterableFields>;
}

export enum IxfHoursV1ExceptionQueryServiceExceptionListFilterableFields {
    ExceptionId = 'exceptionId',
    Region = 'region',
    DataNextObservedDate = 'data.nextObservedDate',
    Status = 'status'
}

export enum IxfHoursV1ExceptionQueryServiceExceptionListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataNextObservedDate = 'data.nextObservedDate'
}

export interface IxfHoursV1ExceptionRef {
    // format: id62
    exceptionId: string;
    name: string;
}

export interface IxfHoursV1ExceptionSpec {
    /* The name of the exception */
    name: string;
    /* The type of the exception */
    type: IxfHoursV1ExceptionType;
    /* Whether the exception recurs every year */
    repeating?: boolean;
    /* The schedules the exception patches on the exception date. At least one
    slot. Absent slots keep their weekly day. */
    patch: IxfHoursV1ExceptionPatch;
    /* The observance rules for the exception */
    observance: IxfHoursV1ExceptionObservance;
    /* The IANA timezone associated with the exception, e.g., "America/New_York" */
    timezone: string;
}

export interface IxfHoursV1ExceptionState extends IxfHoursV1ExceptionKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfHoursV1ExceptionData;
    status: IxfHoursV1ExceptionStatus;
}

export enum IxfHoursV1ExceptionStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Archived = 'ARCHIVED'
}

export enum IxfHoursV1ExceptionSummaryName {
    Unspecified = 'UNSPECIFIED',
    ExceptionSummary = 'ExceptionSummary'
}

export type IxfHoursV1ExceptionType = {
    '!type'?: 'fixed';
    fixed: IxfHoursV1ExceptionTypeFixed;
} | {
    '!type'?: 'floating';
    floating: IxfHoursV1ExceptionTypeFloating;
} | {
    '!type'?: 'calculated';
    calculated: IxfHoursV1ExceptionTypeCalculated;
};

export interface IxfHoursV1ExceptionTypeCalculated {
    /* The type of the calculated exception, e.g., GOOD_FRIDAY */
    type: IxfHoursV1CalculatedType;
}

export interface IxfHoursV1ExceptionTypeFixed {
    /* The month of the fixed exception, e.g., "01" or "1" for January */
    // pattern: ^(0?[1-9]|1[0-2])$
    month: string;
    /* The day of the fixed exception, e.g., "01" or "1" for the first day
    of the month */
    // pattern: ^([0-2]?[1-9]|[1-3][0-1])$
    day: string;
    /* The year of the fixed exception, allowed only for non-repeating
    exceptions */
    // pattern: ^20?\d{2}$
    year?: string;
}

export interface IxfHoursV1ExceptionTypeFloating {
    /* The month of the floating exception, e.g., "01" or "1" for January */
    // pattern: ^(0?[1-9]|1[0-2])$
    month: string;
    /* The day of the week for the floating exception, e.g., MONDAY */
    dayOfWeek: IxfHoursV1DayOfWeek;
    /* The week of the month for the floating exception, e.g., FIRST, SECOND, LAST, etc. */
    weekOfMonth: IxfHoursV1WeekOfMonth;
}

export const IXF_HOURS_V1_EXCEPTION_TYPE_ONE_OF_VALUES = ['fixed', 'floating', 'calculated'] as const;

export type IxfHoursV1ExceptionTypeOneOfValue = (typeof IXF_HOURS_V1_EXCEPTION_TYPE_ONE_OF_VALUES)[number];

export type IxfHoursV1Hours = {
    '!type'?: 'closed';
    closed: boolean;
} | {
    '!type'?: 'openTime';
    openTime: IxfHoursV1TimeWindow;
} | {
    '!type'?: 'openDayTime';
    openDayTime: IxfHoursV1DayTimeWindow;
};

export type IxfHoursV1HoursException = {
    '!type'?: 'closed';
    closed: boolean;
} | {
    '!type'?: 'openTime';
    openTime: IxfHoursV1TimeWindow;
};

export const IXF_HOURS_V1_HOURS_EXCEPTION_ONE_OF_VALUES = ['closed', 'openTime'] as const;

export type IxfHoursV1HoursExceptionOneOfValue = (typeof IXF_HOURS_V1_HOURS_EXCEPTION_ONE_OF_VALUES)[number];

export const IXF_HOURS_V1_HOURS_ONE_OF_VALUES = ['closed', 'openTime', 'openDayTime'] as const;

export type IxfHoursV1HoursOneOfValue = (typeof IXF_HOURS_V1_HOURS_ONE_OF_VALUES)[number];

export type IxfHoursV1MoneyMarketDay = {
    '!type'?: 'closed';
    closed: boolean;
} | {
    '!type'?: 'open';
    open: IxfHoursV1MoneyMarketSessions;
};

export type IxfHoursV1MoneyMarketDayException = {
    '!type'?: 'closed';
    closed: boolean;
} | {
    '!type'?: 'open';
    open: IxfHoursV1MoneyMarketSessionsException;
};

export const IXF_HOURS_V1_MONEY_MARKET_DAY_EXCEPTION_ONE_OF_VALUES = ['closed', 'open'] as const;

export type IxfHoursV1MoneyMarketDayExceptionOneOfValue = (typeof IXF_HOURS_V1_MONEY_MARKET_DAY_EXCEPTION_ONE_OF_VALUES)[number];

export const IXF_HOURS_V1_MONEY_MARKET_DAY_ONE_OF_VALUES = ['closed', 'open'] as const;

export type IxfHoursV1MoneyMarketDayOneOfValue = (typeof IXF_HOURS_V1_MONEY_MARKET_DAY_ONE_OF_VALUES)[number];

export interface IxfHoursV1MoneyMarketHours {
    orders: IxfHoursV1SessionHours;
}

export interface IxfHoursV1MoneyMarketScheduleData {
    /* ID of the active schedule version */
    // format: id62
    currentVersionId?: string;
    /* ID of the schedule version under review */
    // format: id62
    pendingVersionId?: string;
}

export interface IxfHoursV1MoneyMarketScheduleEvent extends IxfHoursV1MoneyMarketScheduleKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfHoursV1MoneyMarketScheduleEventType;
}

export type IxfHoursV1MoneyMarketScheduleEventType = {
    '!type'?: 'created';
    created: IxfHoursV1MoneyMarketScheduleEventTypeCreated;
} | {
    '!type'?: 'updateRequested';
    updateRequested: IxfHoursV1MoneyMarketScheduleEventTypeUpdateRequested;
} | {
    '!type'?: 'versionApproved';
    versionApproved: IxfHoursV1MoneyMarketScheduleEventTypeVersionApproved;
} | {
    '!type'?: 'versionRejected';
    versionRejected: IxfHoursV1MoneyMarketScheduleEventTypeVersionRejected;
};

export interface IxfHoursV1MoneyMarketScheduleEventTypeCreated {
    // format: id62
    versionId: string;
    week: IxfHoursV1MoneyMarketWeek;
}

export interface IxfHoursV1MoneyMarketScheduleEventTypeUpdateRequested {
    // format: id62
    replacesVersionId: string;
    // format: id62
    newVersionId: string;
    week: IxfHoursV1MoneyMarketWeek;
}

export interface IxfHoursV1MoneyMarketScheduleEventTypeVersionApproved {
    // format: id62
    versionId: string;
    week: IxfHoursV1MoneyMarketWeek;
}

export interface IxfHoursV1MoneyMarketScheduleEventTypeVersionRejected {
    // format: id62
    versionId: string;
}

export const IXF_HOURS_V1_MONEY_MARKET_SCHEDULE_EVENT_TYPE_ONE_OF_VALUES = ['created', 'updateRequested', 'versionApproved', 'versionRejected'] as const;

export type IxfHoursV1MoneyMarketScheduleEventTypeOneOfValue = (typeof IXF_HOURS_V1_MONEY_MARKET_SCHEDULE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfHoursV1MoneyMarketScheduleKeys {
    region: IxfHoursV1Region;
    /* The readers this copy of the schedule is exposed to. One region may carry
    one copy per exposure. */
    exposure: IxfHoursV1ScheduleExposure;
}

export interface IxfHoursV1MoneyMarketScheduleQueryServiceMoneyMarketScheduleEventsMoneyMarketScheduleEventsRequest {
    region: IxfHoursV1Region;
    /* The readers this copy of the schedule is exposed to. One region may carry
    one copy per exposure. */
    exposure: IxfHoursV1ScheduleExposure;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfHoursV1MoneyMarketScheduleQueryServiceMoneyMarketScheduleEventsSortableFields, IxfHoursV1MoneyMarketScheduleQueryServiceMoneyMarketScheduleEventsFilterableFields>;
}

export enum IxfHoursV1MoneyMarketScheduleQueryServiceMoneyMarketScheduleEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    Exposure = 'exposure',
    EventType = 'event.!type'
}

export enum IxfHoursV1MoneyMarketScheduleQueryServiceMoneyMarketScheduleEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxfHoursV1MoneyMarketScheduleQueryServiceMoneyMarketScheduleGetMoneyMarketScheduleGetRequest {
    region: IxfHoursV1Region;
    /* The readers this copy of the schedule is exposed to. One region may carry
    one copy per exposure. */
    exposure: IxfHoursV1ScheduleExposure;
}

export interface IxfHoursV1MoneyMarketScheduleQueryServiceMoneyMarketScheduleListMoneyMarketScheduleListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfHoursV1MoneyMarketScheduleQueryServiceMoneyMarketScheduleListSortableFields, IxfHoursV1MoneyMarketScheduleQueryServiceMoneyMarketScheduleListFilterableFields>;
}

export enum IxfHoursV1MoneyMarketScheduleQueryServiceMoneyMarketScheduleListFilterableFields {
    Exposure = 'exposure',
    Status = 'status'
}

export enum IxfHoursV1MoneyMarketScheduleQueryServiceMoneyMarketScheduleListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxfHoursV1MoneyMarketScheduleState extends IxfHoursV1MoneyMarketScheduleKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfHoursV1MoneyMarketScheduleData;
    status: IxfHoursV1MoneyMarketScheduleStatus;
}

export enum IxfHoursV1MoneyMarketScheduleStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Active = 'ACTIVE'
}

export enum IxfHoursV1MoneyMarketScheduleSummaryName {
    Unspecified = 'UNSPECIFIED',
    MoneyMarketScheduleSummary = 'MoneyMarketScheduleSummary'
}

export interface IxfHoursV1MoneyMarketScheduleVersionData {
    week: IxfHoursV1MoneyMarketWeek;
}

export interface IxfHoursV1MoneyMarketScheduleVersionEvent extends IxfHoursV1MoneyMarketScheduleVersionKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfHoursV1MoneyMarketScheduleVersionEventType;
}

export type IxfHoursV1MoneyMarketScheduleVersionEventType = {
    '!type'?: 'created';
    created: IxfHoursV1MoneyMarketScheduleVersionEventTypeCreated;
} | {
    '!type'?: 'approved';
    approved: EmptyObject;
} | {
    '!type'?: 'rejected';
    rejected: IxfHoursV1MoneyMarketScheduleVersionEventTypeRejected;
};

export interface IxfHoursV1MoneyMarketScheduleVersionEventTypeCreated {
    week: IxfHoursV1MoneyMarketWeek;
}

export interface IxfHoursV1MoneyMarketScheduleVersionEventTypeRejected {
    reason?: string;
}

export const IXF_HOURS_V1_MONEY_MARKET_SCHEDULE_VERSION_EVENT_TYPE_ONE_OF_VALUES = ['created', 'approved', 'rejected'] as const;

export type IxfHoursV1MoneyMarketScheduleVersionEventTypeOneOfValue = (typeof IXF_HOURS_V1_MONEY_MARKET_SCHEDULE_VERSION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfHoursV1MoneyMarketScheduleVersionKeys {
    // format: id62
    moneyMarketScheduleVersionId: string;
    /* The region whose schedule this version belongs to. */
    region: IxfHoursV1Region;
    /* The exposure of the schedule copy this version belongs to. */
    exposure: IxfHoursV1ScheduleExposure;
}

export interface IxfHoursV1MoneyMarketScheduleVersionQueryServiceMoneyMarketScheduleVersionEventsMoneyMarketScheduleVersionEventsRequest {
    // format: id62
    moneyMarketScheduleVersionId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfHoursV1MoneyMarketScheduleVersionQueryServiceMoneyMarketScheduleVersionEventsSortableFields, IxfHoursV1MoneyMarketScheduleVersionQueryServiceMoneyMarketScheduleVersionEventsFilterableFields>;
}

export enum IxfHoursV1MoneyMarketScheduleVersionQueryServiceMoneyMarketScheduleVersionEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    MoneyMarketScheduleVersionId = 'moneyMarketScheduleVersionId',
    Region = 'region',
    Exposure = 'exposure',
    EventType = 'event.!type'
}

export enum IxfHoursV1MoneyMarketScheduleVersionQueryServiceMoneyMarketScheduleVersionEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxfHoursV1MoneyMarketScheduleVersionQueryServiceMoneyMarketScheduleVersionGetMoneyMarketScheduleVersionGetRequest {
    // format: id62
    moneyMarketScheduleVersionId: string;
}

export interface IxfHoursV1MoneyMarketScheduleVersionQueryServiceMoneyMarketScheduleVersionListMoneyMarketScheduleVersionListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfHoursV1MoneyMarketScheduleVersionQueryServiceMoneyMarketScheduleVersionListSortableFields, IxfHoursV1MoneyMarketScheduleVersionQueryServiceMoneyMarketScheduleVersionListFilterableFields>;
}

export enum IxfHoursV1MoneyMarketScheduleVersionQueryServiceMoneyMarketScheduleVersionListFilterableFields {
    MoneyMarketScheduleVersionId = 'moneyMarketScheduleVersionId',
    Region = 'region',
    Exposure = 'exposure',
    Status = 'status'
}

export enum IxfHoursV1MoneyMarketScheduleVersionQueryServiceMoneyMarketScheduleVersionListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxfHoursV1MoneyMarketScheduleVersionState extends IxfHoursV1MoneyMarketScheduleVersionKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfHoursV1MoneyMarketScheduleVersionData;
    status: IxfHoursV1MoneyMarketScheduleVersionStatus;
}

export enum IxfHoursV1MoneyMarketScheduleVersionStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
    Approved = 'APPROVED'
}

export interface IxfHoursV1MoneyMarketSessions {
    /* The money market fund order-taking session. */
    orders: IxfHoursV1Hours;
}

export interface IxfHoursV1MoneyMarketSessionsException {
    orders?: IxfHoursV1HoursException;
}

export interface IxfHoursV1MoneyMarketWeek {
    /* The IANA timezone the times are expressed in, e.g., "America/New_York" */
    timezone: string;
    sunday: IxfHoursV1MoneyMarketDay;
    monday: IxfHoursV1MoneyMarketDay;
    tuesday: IxfHoursV1MoneyMarketDay;
    wednesday: IxfHoursV1MoneyMarketDay;
    thursday: IxfHoursV1MoneyMarketDay;
    friday: IxfHoursV1MoneyMarketDay;
    saturday: IxfHoursV1MoneyMarketDay;
}

export interface IxfHoursV1OpenClose {
    // format: date-time
    opensAt: string;
    // format: date-time
    closesAt: string;
}

export interface IxfHoursV1OperatingDay {
    // format: YYYY-MM-DD
    date: string;
    /* The exception that patched this date, if any */
    exception?: IxfHoursV1ExceptionRef;
    trading?: IxfHoursV1TradingHours;
    transfers?: IxfHoursV1TransferHours;
    moneyMarket?: IxfHoursV1MoneyMarketHours;
}

export type IxfHoursV1OperatingHours = {
    '!type'?: 'closed';
    closed: boolean;
} | {
    '!type'?: 'open';
    open: IxfHoursV1OpenClose;
};

export const IXF_HOURS_V1_OPERATING_HOURS_ONE_OF_VALUES = ['closed', 'open'] as const;

export type IxfHoursV1OperatingHoursOneOfValue = (typeof IXF_HOURS_V1_OPERATING_HOURS_ONE_OF_VALUES)[number];

export interface IxfHoursV1OperatingHoursServiceGetOperatingHoursGetOperatingHoursRequest {
    /* The calendar date to resolve, YYYY-MM-DD, read in timezone. */
    // pattern: ^[0-9]{4}-[0-9]{2}-[0-9]{2}$
    date: string;
    /* IANA timezone the date is read in and the instants are converted
    to, e.g., "America/New_York". */
    timezone: string;
    /* The region whose schedules to resolve */
    key: IxfHoursV1Region;
    /* The schedule copy to resolve */
    exposure?: IxfHoursV1ScheduleExposure;
}

export enum IxfHoursV1Region {
    Unspecified = 'UNSPECIFIED',
    Us = 'US'
}

export enum IxfHoursV1ScheduleExposure {
    Unspecified = 'UNSPECIFIED',
    Internal = 'INTERNAL',
    External = 'EXTERNAL'
}

export interface IxfHoursV1SessionHours {
    /* The window in effect on the date */
    effective: IxfHoursV1OperatingHours;
    /* The weekly state. Present only when an exception applies. */
    default?: IxfHoursV1OperatingHours;
}

export interface IxfHoursV1T1MoneyMarketDay {
    // format: YYYY-MM-DD
    date: string;
    /* The exception that patched money market on the date, if any */
    exception?: IxfHoursV1ExceptionRef;
    hours: IxfHoursV1MoneyMarketHours;
}

export interface IxfHoursV1T1OperatingDays {
    trading?: IxfHoursV1T1TradingDay;
    transfers?: IxfHoursV1T1TransferDay;
    moneyMarket?: IxfHoursV1T1MoneyMarketDay;
}

export interface IxfHoursV1T1TradingDay {
    // format: YYYY-MM-DD
    date: string;
    /* The exception that patched trading on the date, if any */
    exception?: IxfHoursV1ExceptionRef;
    hours: IxfHoursV1TradingHours;
}

export interface IxfHoursV1T1TransferDay {
    // format: YYYY-MM-DD
    date: string;
    /* The exception that patched transfers on the date, if any */
    exception?: IxfHoursV1ExceptionRef;
    hours: IxfHoursV1TransferHours;
}

export interface IxfHoursV1TimeWindow {
    /* The time of day in HH:MM, in the owning schedule's timezone. */
    // pattern: ^[0-9]{2}:[0-9]{2}$
    starts: string;
    /* The time of day in HH:MM, in the owning schedule's timezone. */
    // pattern: ^[0-9]{2}:[0-9]{2}$
    stops: string;
}

export type IxfHoursV1TradingDay = {
    '!type'?: 'closed';
    closed: boolean;
} | {
    '!type'?: 'open';
    open: IxfHoursV1TradingSessions;
};

export type IxfHoursV1TradingDayException = {
    '!type'?: 'closed';
    closed: boolean;
} | {
    '!type'?: 'open';
    open: IxfHoursV1TradingSessionsException;
};

export const IXF_HOURS_V1_TRADING_DAY_EXCEPTION_ONE_OF_VALUES = ['closed', 'open'] as const;

export type IxfHoursV1TradingDayExceptionOneOfValue = (typeof IXF_HOURS_V1_TRADING_DAY_EXCEPTION_ONE_OF_VALUES)[number];

export const IXF_HOURS_V1_TRADING_DAY_ONE_OF_VALUES = ['closed', 'open'] as const;

export type IxfHoursV1TradingDayOneOfValue = (typeof IXF_HOURS_V1_TRADING_DAY_ONE_OF_VALUES)[number];

export interface IxfHoursV1TradingHours {
    early: IxfHoursV1SessionHours;
    core: IxfHoursV1SessionHours;
    late: IxfHoursV1SessionHours;
}

export interface IxfHoursV1TradingScheduleData {
    /* ID of the active schedule version */
    // format: id62
    currentVersionId?: string;
    /* ID of the schedule version under review */
    // format: id62
    pendingVersionId?: string;
}

export interface IxfHoursV1TradingScheduleEvent extends IxfHoursV1TradingScheduleKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfHoursV1TradingScheduleEventType;
}

export type IxfHoursV1TradingScheduleEventType = {
    '!type'?: 'created';
    created: IxfHoursV1TradingScheduleEventTypeCreated;
} | {
    '!type'?: 'updateRequested';
    updateRequested: IxfHoursV1TradingScheduleEventTypeUpdateRequested;
} | {
    '!type'?: 'versionApproved';
    versionApproved: IxfHoursV1TradingScheduleEventTypeVersionApproved;
} | {
    '!type'?: 'versionRejected';
    versionRejected: IxfHoursV1TradingScheduleEventTypeVersionRejected;
};

export interface IxfHoursV1TradingScheduleEventTypeCreated {
    // format: id62
    versionId: string;
    week: IxfHoursV1TradingWeek;
}

export interface IxfHoursV1TradingScheduleEventTypeUpdateRequested {
    // format: id62
    replacesVersionId: string;
    // format: id62
    newVersionId: string;
    week: IxfHoursV1TradingWeek;
}

export interface IxfHoursV1TradingScheduleEventTypeVersionApproved {
    // format: id62
    versionId: string;
    week: IxfHoursV1TradingWeek;
}

export interface IxfHoursV1TradingScheduleEventTypeVersionRejected {
    // format: id62
    versionId: string;
}

export const IXF_HOURS_V1_TRADING_SCHEDULE_EVENT_TYPE_ONE_OF_VALUES = ['created', 'updateRequested', 'versionApproved', 'versionRejected'] as const;

export type IxfHoursV1TradingScheduleEventTypeOneOfValue = (typeof IXF_HOURS_V1_TRADING_SCHEDULE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfHoursV1TradingScheduleKeys {
    region: IxfHoursV1Region;
    /* The readers this copy of the schedule is exposed to. One region may carry
    one copy per exposure, e.g., an EXTERNAL copy limited to core hours. */
    exposure: IxfHoursV1ScheduleExposure;
}

export interface IxfHoursV1TradingScheduleQueryServiceTradingScheduleEventsTradingScheduleEventsRequest {
    region: IxfHoursV1Region;
    /* The readers this copy of the schedule is exposed to. One region may carry
    one copy per exposure, e.g., an EXTERNAL copy limited to core hours. */
    exposure: IxfHoursV1ScheduleExposure;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfHoursV1TradingScheduleQueryServiceTradingScheduleEventsSortableFields, IxfHoursV1TradingScheduleQueryServiceTradingScheduleEventsFilterableFields>;
}

export enum IxfHoursV1TradingScheduleQueryServiceTradingScheduleEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    Exposure = 'exposure',
    EventType = 'event.!type'
}

export enum IxfHoursV1TradingScheduleQueryServiceTradingScheduleEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxfHoursV1TradingScheduleQueryServiceTradingScheduleGetTradingScheduleGetRequest {
    region: IxfHoursV1Region;
    /* The readers this copy of the schedule is exposed to. One region may carry
    one copy per exposure, e.g., an EXTERNAL copy limited to core hours. */
    exposure: IxfHoursV1ScheduleExposure;
}

export interface IxfHoursV1TradingScheduleQueryServiceTradingScheduleListTradingScheduleListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfHoursV1TradingScheduleQueryServiceTradingScheduleListSortableFields, IxfHoursV1TradingScheduleQueryServiceTradingScheduleListFilterableFields>;
}

export enum IxfHoursV1TradingScheduleQueryServiceTradingScheduleListFilterableFields {
    Exposure = 'exposure',
    Status = 'status'
}

export enum IxfHoursV1TradingScheduleQueryServiceTradingScheduleListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxfHoursV1TradingScheduleState extends IxfHoursV1TradingScheduleKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfHoursV1TradingScheduleData;
    status: IxfHoursV1TradingScheduleStatus;
}

export enum IxfHoursV1TradingScheduleStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Active = 'ACTIVE'
}

export enum IxfHoursV1TradingScheduleSummaryName {
    Unspecified = 'UNSPECIFIED',
    TradingScheduleSummary = 'TradingScheduleSummary'
}

export interface IxfHoursV1TradingScheduleVersionData {
    week: IxfHoursV1TradingWeek;
}

export interface IxfHoursV1TradingScheduleVersionEvent extends IxfHoursV1TradingScheduleVersionKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfHoursV1TradingScheduleVersionEventType;
}

export type IxfHoursV1TradingScheduleVersionEventType = {
    '!type'?: 'created';
    created: IxfHoursV1TradingScheduleVersionEventTypeCreated;
} | {
    '!type'?: 'approved';
    approved: EmptyObject;
} | {
    '!type'?: 'rejected';
    rejected: IxfHoursV1TradingScheduleVersionEventTypeRejected;
};

export interface IxfHoursV1TradingScheduleVersionEventTypeCreated {
    week: IxfHoursV1TradingWeek;
}

export interface IxfHoursV1TradingScheduleVersionEventTypeRejected {
    reason?: string;
}

export const IXF_HOURS_V1_TRADING_SCHEDULE_VERSION_EVENT_TYPE_ONE_OF_VALUES = ['created', 'approved', 'rejected'] as const;

export type IxfHoursV1TradingScheduleVersionEventTypeOneOfValue = (typeof IXF_HOURS_V1_TRADING_SCHEDULE_VERSION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfHoursV1TradingScheduleVersionKeys {
    // format: id62
    tradingScheduleVersionId: string;
    /* The region whose schedule this version belongs to. */
    region: IxfHoursV1Region;
    /* The exposure of the schedule copy this version belongs to. */
    exposure: IxfHoursV1ScheduleExposure;
}

export interface IxfHoursV1TradingScheduleVersionQueryServiceTradingScheduleVersionEventsTradingScheduleVersionEventsRequest {
    // format: id62
    tradingScheduleVersionId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfHoursV1TradingScheduleVersionQueryServiceTradingScheduleVersionEventsSortableFields, IxfHoursV1TradingScheduleVersionQueryServiceTradingScheduleVersionEventsFilterableFields>;
}

export enum IxfHoursV1TradingScheduleVersionQueryServiceTradingScheduleVersionEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    TradingScheduleVersionId = 'tradingScheduleVersionId',
    Region = 'region',
    Exposure = 'exposure',
    EventType = 'event.!type'
}

export enum IxfHoursV1TradingScheduleVersionQueryServiceTradingScheduleVersionEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxfHoursV1TradingScheduleVersionQueryServiceTradingScheduleVersionGetTradingScheduleVersionGetRequest {
    // format: id62
    tradingScheduleVersionId: string;
}

export interface IxfHoursV1TradingScheduleVersionQueryServiceTradingScheduleVersionListTradingScheduleVersionListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfHoursV1TradingScheduleVersionQueryServiceTradingScheduleVersionListSortableFields, IxfHoursV1TradingScheduleVersionQueryServiceTradingScheduleVersionListFilterableFields>;
}

export enum IxfHoursV1TradingScheduleVersionQueryServiceTradingScheduleVersionListFilterableFields {
    TradingScheduleVersionId = 'tradingScheduleVersionId',
    Region = 'region',
    Exposure = 'exposure',
    Status = 'status'
}

export enum IxfHoursV1TradingScheduleVersionQueryServiceTradingScheduleVersionListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxfHoursV1TradingScheduleVersionState extends IxfHoursV1TradingScheduleVersionKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfHoursV1TradingScheduleVersionData;
    status: IxfHoursV1TradingScheduleVersionStatus;
}

export enum IxfHoursV1TradingScheduleVersionStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
    Approved = 'APPROVED'
}

export interface IxfHoursV1TradingSessions {
    /* The early trading session. */
    early: IxfHoursV1Hours;
    /* The core market session. */
    core: IxfHoursV1Hours;
    /* The late trading session. */
    late: IxfHoursV1Hours;
}

export interface IxfHoursV1TradingSessionsException {
    early?: IxfHoursV1HoursException;
    core?: IxfHoursV1HoursException;
    late?: IxfHoursV1HoursException;
}

export interface IxfHoursV1TradingWeek {
    /* The IANA timezone the times are expressed in, e.g., "America/New_York" */
    timezone: string;
    sunday: IxfHoursV1TradingDay;
    monday: IxfHoursV1TradingDay;
    tuesday: IxfHoursV1TradingDay;
    wednesday: IxfHoursV1TradingDay;
    thursday: IxfHoursV1TradingDay;
    friday: IxfHoursV1TradingDay;
    saturday: IxfHoursV1TradingDay;
}

export type IxfHoursV1TransferDay = {
    '!type'?: 'closed';
    closed: boolean;
} | {
    '!type'?: 'open';
    open: IxfHoursV1TransferSessions;
};

export type IxfHoursV1TransferDayException = {
    '!type'?: 'closed';
    closed: boolean;
} | {
    '!type'?: 'open';
    open: IxfHoursV1TransferSessionsException;
};

export const IXF_HOURS_V1_TRANSFER_DAY_EXCEPTION_ONE_OF_VALUES = ['closed', 'open'] as const;

export type IxfHoursV1TransferDayExceptionOneOfValue = (typeof IXF_HOURS_V1_TRANSFER_DAY_EXCEPTION_ONE_OF_VALUES)[number];

export const IXF_HOURS_V1_TRANSFER_DAY_ONE_OF_VALUES = ['closed', 'open'] as const;

export type IxfHoursV1TransferDayOneOfValue = (typeof IXF_HOURS_V1_TRANSFER_DAY_ONE_OF_VALUES)[number];

export interface IxfHoursV1TransferHours {
    wire: IxfHoursV1SessionHours;
    achStandard: IxfHoursV1SessionHours;
    achSameDay: IxfHoursV1SessionHours;
}

export interface IxfHoursV1TransferSessions {
    /* The wire session. */
    wire: IxfHoursV1Hours;
    /* The standard ACH session. */
    achStandard: IxfHoursV1Hours;
    /* The same-day ACH session. */
    achSameDay: IxfHoursV1Hours;
}

export interface IxfHoursV1TransferSessionsException {
    wire?: IxfHoursV1HoursException;
    achStandard?: IxfHoursV1HoursException;
    achSameDay?: IxfHoursV1HoursException;
}

export interface IxfHoursV1TransfersScheduleData {
    /* ID of the active schedule version */
    // format: id62
    currentVersionId?: string;
    /* ID of the schedule version under review */
    // format: id62
    pendingVersionId?: string;
}

export interface IxfHoursV1TransfersScheduleEvent extends IxfHoursV1TransfersScheduleKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfHoursV1TransfersScheduleEventType;
}

export type IxfHoursV1TransfersScheduleEventType = {
    '!type'?: 'created';
    created: IxfHoursV1TransfersScheduleEventTypeCreated;
} | {
    '!type'?: 'updateRequested';
    updateRequested: IxfHoursV1TransfersScheduleEventTypeUpdateRequested;
} | {
    '!type'?: 'versionApproved';
    versionApproved: IxfHoursV1TransfersScheduleEventTypeVersionApproved;
} | {
    '!type'?: 'versionRejected';
    versionRejected: IxfHoursV1TransfersScheduleEventTypeVersionRejected;
};

export interface IxfHoursV1TransfersScheduleEventTypeCreated {
    // format: id62
    versionId: string;
    week: IxfHoursV1TransfersWeek;
}

export interface IxfHoursV1TransfersScheduleEventTypeUpdateRequested {
    // format: id62
    replacesVersionId: string;
    // format: id62
    newVersionId: string;
    week: IxfHoursV1TransfersWeek;
}

export interface IxfHoursV1TransfersScheduleEventTypeVersionApproved {
    // format: id62
    versionId: string;
    week: IxfHoursV1TransfersWeek;
}

export interface IxfHoursV1TransfersScheduleEventTypeVersionRejected {
    // format: id62
    versionId: string;
}

export const IXF_HOURS_V1_TRANSFERS_SCHEDULE_EVENT_TYPE_ONE_OF_VALUES = ['created', 'updateRequested', 'versionApproved', 'versionRejected'] as const;

export type IxfHoursV1TransfersScheduleEventTypeOneOfValue = (typeof IXF_HOURS_V1_TRANSFERS_SCHEDULE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfHoursV1TransfersScheduleKeys {
    region: IxfHoursV1Region;
    /* The readers this copy of the schedule is exposed to. One region may carry
    one copy per exposure, e.g., an EXTERNAL copy limited to the wire
    session. */
    exposure: IxfHoursV1ScheduleExposure;
}

export interface IxfHoursV1TransfersScheduleQueryServiceTransfersScheduleEventsTransfersScheduleEventsRequest {
    region: IxfHoursV1Region;
    /* The readers this copy of the schedule is exposed to. One region may carry
    one copy per exposure, e.g., an EXTERNAL copy limited to the wire
    session. */
    exposure: IxfHoursV1ScheduleExposure;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfHoursV1TransfersScheduleQueryServiceTransfersScheduleEventsSortableFields, IxfHoursV1TransfersScheduleQueryServiceTransfersScheduleEventsFilterableFields>;
}

export enum IxfHoursV1TransfersScheduleQueryServiceTransfersScheduleEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    Exposure = 'exposure',
    EventType = 'event.!type'
}

export enum IxfHoursV1TransfersScheduleQueryServiceTransfersScheduleEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxfHoursV1TransfersScheduleQueryServiceTransfersScheduleGetTransfersScheduleGetRequest {
    region: IxfHoursV1Region;
    /* The readers this copy of the schedule is exposed to. One region may carry
    one copy per exposure, e.g., an EXTERNAL copy limited to the wire
    session. */
    exposure: IxfHoursV1ScheduleExposure;
}

export interface IxfHoursV1TransfersScheduleQueryServiceTransfersScheduleListTransfersScheduleListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfHoursV1TransfersScheduleQueryServiceTransfersScheduleListSortableFields, IxfHoursV1TransfersScheduleQueryServiceTransfersScheduleListFilterableFields>;
}

export enum IxfHoursV1TransfersScheduleQueryServiceTransfersScheduleListFilterableFields {
    Exposure = 'exposure',
    Status = 'status'
}

export enum IxfHoursV1TransfersScheduleQueryServiceTransfersScheduleListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxfHoursV1TransfersScheduleState extends IxfHoursV1TransfersScheduleKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfHoursV1TransfersScheduleData;
    status: IxfHoursV1TransfersScheduleStatus;
}

export enum IxfHoursV1TransfersScheduleStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Active = 'ACTIVE'
}

export enum IxfHoursV1TransfersScheduleSummaryName {
    Unspecified = 'UNSPECIFIED',
    TransfersScheduleSummary = 'TransfersScheduleSummary'
}

export interface IxfHoursV1TransfersScheduleVersionData {
    week: IxfHoursV1TransfersWeek;
}

export interface IxfHoursV1TransfersScheduleVersionEvent extends IxfHoursV1TransfersScheduleVersionKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfHoursV1TransfersScheduleVersionEventType;
}

export type IxfHoursV1TransfersScheduleVersionEventType = {
    '!type'?: 'created';
    created: IxfHoursV1TransfersScheduleVersionEventTypeCreated;
} | {
    '!type'?: 'approved';
    approved: EmptyObject;
} | {
    '!type'?: 'rejected';
    rejected: IxfHoursV1TransfersScheduleVersionEventTypeRejected;
};

export interface IxfHoursV1TransfersScheduleVersionEventTypeCreated {
    week: IxfHoursV1TransfersWeek;
}

export interface IxfHoursV1TransfersScheduleVersionEventTypeRejected {
    reason?: string;
}

export const IXF_HOURS_V1_TRANSFERS_SCHEDULE_VERSION_EVENT_TYPE_ONE_OF_VALUES = ['created', 'approved', 'rejected'] as const;

export type IxfHoursV1TransfersScheduleVersionEventTypeOneOfValue = (typeof IXF_HOURS_V1_TRANSFERS_SCHEDULE_VERSION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfHoursV1TransfersScheduleVersionKeys {
    // format: id62
    transfersScheduleVersionId: string;
    /* The region whose schedule this version belongs to. */
    region: IxfHoursV1Region;
    /* The exposure of the schedule copy this version belongs to. */
    exposure: IxfHoursV1ScheduleExposure;
}

export interface IxfHoursV1TransfersScheduleVersionQueryServiceTransfersScheduleVersionEventsTransfersScheduleVersionEventsRequest {
    // format: id62
    transfersScheduleVersionId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfHoursV1TransfersScheduleVersionQueryServiceTransfersScheduleVersionEventsSortableFields, IxfHoursV1TransfersScheduleVersionQueryServiceTransfersScheduleVersionEventsFilterableFields>;
}

export enum IxfHoursV1TransfersScheduleVersionQueryServiceTransfersScheduleVersionEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    TransfersScheduleVersionId = 'transfersScheduleVersionId',
    Region = 'region',
    Exposure = 'exposure',
    EventType = 'event.!type'
}

export enum IxfHoursV1TransfersScheduleVersionQueryServiceTransfersScheduleVersionEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxfHoursV1TransfersScheduleVersionQueryServiceTransfersScheduleVersionGetTransfersScheduleVersionGetRequest {
    // format: id62
    transfersScheduleVersionId: string;
}

export interface IxfHoursV1TransfersScheduleVersionQueryServiceTransfersScheduleVersionListTransfersScheduleVersionListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfHoursV1TransfersScheduleVersionQueryServiceTransfersScheduleVersionListSortableFields, IxfHoursV1TransfersScheduleVersionQueryServiceTransfersScheduleVersionListFilterableFields>;
}

export enum IxfHoursV1TransfersScheduleVersionQueryServiceTransfersScheduleVersionListFilterableFields {
    TransfersScheduleVersionId = 'transfersScheduleVersionId',
    Region = 'region',
    Exposure = 'exposure',
    Status = 'status'
}

export enum IxfHoursV1TransfersScheduleVersionQueryServiceTransfersScheduleVersionListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxfHoursV1TransfersScheduleVersionState extends IxfHoursV1TransfersScheduleVersionKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfHoursV1TransfersScheduleVersionData;
    status: IxfHoursV1TransfersScheduleVersionStatus;
}

export enum IxfHoursV1TransfersScheduleVersionStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
    Approved = 'APPROVED'
}

export interface IxfHoursV1TransfersWeek {
    /* The IANA timezone the times are expressed in, e.g., "America/New_York" */
    timezone: string;
    sunday: IxfHoursV1TransferDay;
    monday: IxfHoursV1TransferDay;
    tuesday: IxfHoursV1TransferDay;
    wednesday: IxfHoursV1TransferDay;
    thursday: IxfHoursV1TransferDay;
    friday: IxfHoursV1TransferDay;
    saturday: IxfHoursV1TransferDay;
}

export enum IxfHoursV1WeekOfMonth {
    Unspecified = 'UNSPECIFIED',
    First = 'FIRST',
    Second = 'SECOND',
    Third = 'THIRD',
    Fourth = 'FOURTH',
    Last = 'LAST'
}

export interface IxfReportsV1ReportCommandServiceReportDownloadReportDownloadRequest {
    /* The ID of the report to download */
    // format: id62
    reportId: string;
}

export interface IxfReportsV1ReportData {
    /* The specification for the report. */
    spec?: IxfReportsV1ReportSpec;
    /* The ID of the report that replaces this report, if replaced */
    // format: id62
    replacedBy?: string;
}

export interface IxfReportsV1ReportEvent extends IxfReportsV1ReportKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfReportsV1ReportEventType;
}

export type IxfReportsV1ReportEventType = {
    '!type'?: 'uploaded';
    uploaded: IxfReportsV1ReportEventTypeUploaded;
} | {
    '!type'?: 'replaced';
    replaced: IxfReportsV1ReportEventTypeReplaced;
};

export interface IxfReportsV1ReportEventTypeReplaced {
    /* The ID of the report that this report replaces */
    // format: id62
    replacedBy: string;
}

export interface IxfReportsV1ReportEventTypeUploaded {
    /* The specification of the uploaded report */
    spec?: IxfReportsV1ReportSpec;
}

export const IXF_REPORTS_V1_REPORT_EVENT_TYPE_ONE_OF_VALUES = ['uploaded', 'replaced'] as const;

export type IxfReportsV1ReportEventTypeOneOfValue = (typeof IXF_REPORTS_V1_REPORT_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfReportsV1ReportKeys {
    // format: id62
    reportId: string;
}

export interface IxfReportsV1ReportQueryServiceReportEventsReportEventsRequest {
    // format: id62
    reportId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfReportsV1ReportQueryServiceReportEventsSortableFields, IxfReportsV1ReportQueryServiceReportEventsFilterableFields>;
}

export enum IxfReportsV1ReportQueryServiceReportEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    ReportId = 'reportId',
    EventUploadedSpecType = 'event.uploaded.spec.type',
    EventUploadedSpecStartDate = 'event.uploaded.spec.startDate',
    EventUploadedSpecEndDate = 'event.uploaded.spec.endDate',
    EventType = 'event.!type'
}

export enum IxfReportsV1ReportQueryServiceReportEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EventUploadedSpecStartDate = 'event.uploaded.spec.startDate',
    EventUploadedSpecEndDate = 'event.uploaded.spec.endDate'
}

export interface IxfReportsV1ReportQueryServiceReportGetReportGetRequest {
    // format: id62
    reportId: string;
}

export interface IxfReportsV1ReportQueryServiceReportListReportListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfReportsV1ReportQueryServiceReportListSortableFields, IxfReportsV1ReportQueryServiceReportListFilterableFields>;
}

export enum IxfReportsV1ReportQueryServiceReportListFilterableFields {
    ReportId = 'reportId',
    DataSpecType = 'data.spec.type',
    DataSpecStartDate = 'data.spec.startDate',
    DataSpecEndDate = 'data.spec.endDate',
    Status = 'status'
}

export enum IxfReportsV1ReportQueryServiceReportListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataSpecStartDate = 'data.spec.startDate',
    DataSpecEndDate = 'data.spec.endDate'
}

export interface IxfReportsV1ReportSpec {
    /* The type of the report */
    // format: custom - pattern: ^[a-zA-Z0-9_-]+$
    type?: string;
    /* The start date of the report */
    // format: YYYY-MM-DD
    startDate: string;
    /* The end date of the report. */
    // format: YYYY-MM-DD
    endDate: string;
    /* If this report replaces another, this field contains the ID of the replaced report */
    // format: id62
    replaces?: string;
    /* The storage bucket where the report is stored */
    storageBucket: string;
    /* The storage key for accessing the report */
    storageKey: string;
}

export interface IxfReportsV1ReportState extends IxfReportsV1ReportKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfReportsV1ReportData;
    status: IxfReportsV1ReportStatus;
}

export enum IxfReportsV1ReportStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Archived = 'ARCHIVED'
}

export interface IxfWatchlistV1Address {
    street1?: string;
    street2?: string;
    street3?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: IsoV1Country;
}

export interface IxfWatchlistV1AkaIndividual {
    akaType?: string;
    weight?: string;
    firstName?: string;
    lastName?: string;
}

export interface IxfWatchlistV1AkaOrganization {
    akaType?: string;
    weight?: string;
    name?: string;
}

export interface IxfWatchlistV1Birthdate {
    // format: YYYY-MM-DD
    startDate?: string;
    // format: YYYY-MM-DD
    endDate?: string;
    src?: string;
    mainEntry?: boolean;
}

export interface IxfWatchlistV1Citizenship {
    country?: IsoV1Country;
    mainEntry?: boolean;
}

export interface IxfWatchlistV1ElectronicContact {
    type?: IxfWatchlistV1ElectronicContactType;
    value?: string;
}

export enum IxfWatchlistV1ElectronicContactType {
    Unspecified = 'UNSPECIFIED',
    EmailAddress = 'EMAIL_ADDRESS',
    WebSiteAddress = 'WEB_SITE_ADDRESS'
}

export enum IxfWatchlistV1EntryTypeEnum {
    Unspecified = 'UNSPECIFIED',
    Individual = 'INDIVIDUAL',
    Organization = 'ORGANIZATION'
}

export interface IxfWatchlistV1Fincen314EntryData {
    /* The FinCEN tracking number */
    trackingNumber: string;
    type: IxfWatchlistV1EntryTypeEnum;
    /* Subjects can be individuals or organizations. */
    spec?: IxfWatchlistV1Fincen314EntrySpec;
}

export interface IxfWatchlistV1Fincen314EntryEvent extends IxfWatchlistV1Fincen314EntryKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfWatchlistV1Fincen314EntryEventType;
}

export type IxfWatchlistV1Fincen314EntryEventType = {
    '!type'?: 'created';
    created: IxfWatchlistV1Fincen314EntryEventTypeCreated;
};

export interface IxfWatchlistV1Fincen314EntryEventTypeCreated {
    // format: id62
    fileId: string;
    trackingNumber: string;
    spec: IxfWatchlistV1Fincen314EntrySpec;
}

export const IXF_WATCHLIST_V1_FINCEN314_ENTRY_EVENT_TYPE_ONE_OF_VALUES = ['created'] as const;

export type IxfWatchlistV1Fincen314EntryEventTypeOneOfValue = (typeof IXF_WATCHLIST_V1_FINCEN314_ENTRY_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfWatchlistV1Fincen314EntryKeys {
    // format: id62
    fincen314EntryId: string;
    // format: id62, entity: ixf.watchlist.v1.Fincen314File
    fincen314FileId: string;
}

export interface IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryEventsFincen314EntryEventsRequest {
    // format: id62
    fincen314EntryId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryEventsSearchableFields, IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryEventsSortableFields, IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryEventsFilterableFields>;
}

export enum IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    Fincen314EntryId = 'fincen314EntryId',
    Fincen314FileId = 'fincen314FileId',
    EventCreatedSpecIndividualIdentificationsType = 'event.created.spec.individual.identifications.type',
    EventCreatedSpecIndividualElectronicContactsType = 'event.created.spec.individual.electronicContacts.type',
    EventCreatedSpecOrganizationIdentificationsType = 'event.created.spec.organization.identifications.type',
    EventCreatedSpecOrganizationElectronicContactsType = 'event.created.spec.organization.electronicContacts.type',
    EventType = 'event.!type'
}

export enum IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryEventsSearchableFields {
    EventCreatedSpecIndividualNameLastName = 'event.created.spec.individual.name.lastName',
    EventCreatedSpecIndividualNameFirstName = 'event.created.spec.individual.name.firstName',
    EventCreatedSpecIndividualNameMiddleName = 'event.created.spec.individual.name.middleName',
    EventCreatedSpecIndividualNameSuffix = 'event.created.spec.individual.name.suffix',
    EventCreatedSpecIndividualAliasesLastName = 'event.created.spec.individual.aliases.lastName',
    EventCreatedSpecIndividualAliasesFirstName = 'event.created.spec.individual.aliases.firstName',
    EventCreatedSpecIndividualAliasesMiddleName = 'event.created.spec.individual.aliases.middleName',
    EventCreatedSpecIndividualAliasesSuffix = 'event.created.spec.individual.aliases.suffix',
    EventCreatedSpecIndividualIdentificationsId = 'event.created.spec.individual.identifications.id',
    EventCreatedSpecIndividualElectronicContactsValue = 'event.created.spec.individual.electronicContacts.value',
    EventCreatedSpecOrganizationNameBusinessName = 'event.created.spec.organization.name.businessName',
    EventCreatedSpecOrganizationDbaDbaName = 'event.created.spec.organization.dba.dbaName',
    EventCreatedSpecOrganizationIdentificationsId = 'event.created.spec.organization.identifications.id',
    EventCreatedSpecOrganizationElectronicContactsValue = 'event.created.spec.organization.electronicContacts.value'
}

export enum IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryGetFincen314EntryGetRequest {
    // format: id62
    fincen314EntryId: string;
}

export interface IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryListFincen314EntryListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryListSearchableFields, IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryListSortableFields, IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryListFilterableFields>;
}

export enum IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryListFilterableFields {
    Fincen314EntryId = 'fincen314EntryId',
    Fincen314FileId = 'fincen314FileId',
    DataType = 'data.type',
    DataSpecIndividualIdentificationsType = 'data.spec.individual.identifications.type',
    DataSpecIndividualElectronicContactsType = 'data.spec.individual.electronicContacts.type',
    DataSpecOrganizationIdentificationsType = 'data.spec.organization.identifications.type',
    DataSpecOrganizationElectronicContactsType = 'data.spec.organization.electronicContacts.type',
    Status = 'status'
}

export enum IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryListSearchableFields {
    DataTrackingNumber = 'data.trackingNumber',
    DataSpecIndividualNameLastName = 'data.spec.individual.name.lastName',
    DataSpecIndividualNameFirstName = 'data.spec.individual.name.firstName',
    DataSpecIndividualNameMiddleName = 'data.spec.individual.name.middleName',
    DataSpecIndividualNameSuffix = 'data.spec.individual.name.suffix',
    DataSpecIndividualAliasesLastName = 'data.spec.individual.aliases.lastName',
    DataSpecIndividualAliasesFirstName = 'data.spec.individual.aliases.firstName',
    DataSpecIndividualAliasesMiddleName = 'data.spec.individual.aliases.middleName',
    DataSpecIndividualAliasesSuffix = 'data.spec.individual.aliases.suffix',
    DataSpecIndividualIdentificationsId = 'data.spec.individual.identifications.id',
    DataSpecIndividualElectronicContactsValue = 'data.spec.individual.electronicContacts.value',
    DataSpecOrganizationNameBusinessName = 'data.spec.organization.name.businessName',
    DataSpecOrganizationDbaDbaName = 'data.spec.organization.dba.dbaName',
    DataSpecOrganizationIdentificationsId = 'data.spec.organization.identifications.id',
    DataSpecOrganizationElectronicContactsValue = 'data.spec.organization.electronicContacts.value'
}

export enum IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxfWatchlistV1Fincen314EntrySpec {
    individual?: IxfWatchlistV1IndividualSubject;
    organization?: IxfWatchlistV1OrganizationSubject;
}

export interface IxfWatchlistV1Fincen314EntryState extends IxfWatchlistV1Fincen314EntryKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfWatchlistV1Fincen314EntryData;
    status: IxfWatchlistV1Fincen314EntryStatus;
}

export enum IxfWatchlistV1Fincen314EntryStatus {
    Unspecified = 'UNSPECIFIED',
    Created = 'CREATED'
}

export interface IxfWatchlistV1Fincen314FileData {
    documentUrl: string;
    // format: UINT32
    totalEntities?: number;
    uploadedBy?: string;
}

export interface IxfWatchlistV1Fincen314FileEvent extends IxfWatchlistV1Fincen314FileKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfWatchlistV1Fincen314FileEventType;
}

export type IxfWatchlistV1Fincen314FileEventType = {
    '!type'?: 'uploaded';
    uploaded: IxfWatchlistV1Fincen314FileEventTypeUploaded;
} | {
    '!type'?: 'ingest';
    ingest: EmptyObject;
} | {
    '!type'?: 'process';
    process: EmptyObject;
} | {
    '!type'?: 'completed';
    completed: IxfWatchlistV1Fincen314FileEventTypeCompleted;
} | {
    '!type'?: 'errored';
    errored: IxfWatchlistV1Fincen314FileEventTypeErrored;
};

export interface IxfWatchlistV1Fincen314FileEventTypeCompleted {
    // format: UINT32
    totalEntities?: number;
}

export interface IxfWatchlistV1Fincen314FileEventTypeErrored {
    message?: string;
}

export interface IxfWatchlistV1Fincen314FileEventTypeUploaded {
    documentUrl: string;
    uploadedBy?: string;
}

export const IXF_WATCHLIST_V1_FINCEN314_FILE_EVENT_TYPE_ONE_OF_VALUES = ['uploaded', 'ingest', 'process', 'completed', 'errored'] as const;

export type IxfWatchlistV1Fincen314FileEventTypeOneOfValue = (typeof IXF_WATCHLIST_V1_FINCEN314_FILE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfWatchlistV1Fincen314FileKeys {
    // format: id62
    fincen314FileId: string;
}

export interface IxfWatchlistV1Fincen314FileQueryServiceFincen314FileEventsFincen314FileEventsRequest {
    // format: id62
    fincen314FileId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfWatchlistV1Fincen314FileQueryServiceFincen314FileEventsSortableFields, IxfWatchlistV1Fincen314FileQueryServiceFincen314FileEventsFilterableFields>;
}

export enum IxfWatchlistV1Fincen314FileQueryServiceFincen314FileEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    Fincen314FileId = 'fincen314FileId',
    EventType = 'event.!type'
}

export enum IxfWatchlistV1Fincen314FileQueryServiceFincen314FileEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxfWatchlistV1Fincen314FileQueryServiceFincen314FileGetFincen314FileGetRequest {
    // format: id62
    fincen314FileId: string;
}

export interface IxfWatchlistV1Fincen314FileQueryServiceFincen314FileListFincen314FileListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfWatchlistV1Fincen314FileQueryServiceFincen314FileListSortableFields, IxfWatchlistV1Fincen314FileQueryServiceFincen314FileListFilterableFields>;
}

export enum IxfWatchlistV1Fincen314FileQueryServiceFincen314FileListFilterableFields {
    Fincen314FileId = 'fincen314FileId',
    Status = 'status'
}

export enum IxfWatchlistV1Fincen314FileQueryServiceFincen314FileListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxfWatchlistV1Fincen314FileState extends IxfWatchlistV1Fincen314FileKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfWatchlistV1Fincen314FileData;
    status: IxfWatchlistV1Fincen314FileStatus;
}

export enum IxfWatchlistV1Fincen314FileStatus {
    Unspecified = 'UNSPECIFIED',
    Created = 'CREATED',
    Ingesting = 'INGESTING',
    Processing = 'PROCESSING',
    Failed = 'FAILED',
    Done = 'DONE'
}

export interface IxfWatchlistV1Fincen314MatchData {
    spec?: IxfWatchlistV1FincenMatchSpec[];
}

export interface IxfWatchlistV1Fincen314MatchEvent extends IxfWatchlistV1Fincen314MatchKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfWatchlistV1Fincen314MatchEventType;
}

export type IxfWatchlistV1Fincen314MatchEventType = {
    '!type'?: 'open';
    open: IxfWatchlistV1Fincen314MatchEventTypeOpen;
} | {
    '!type'?: 'close';
    close: IxfWatchlistV1Fincen314MatchEventTypeClose;
};

export interface IxfWatchlistV1Fincen314MatchEventTypeClose {
    // format: id62
    closedBy: string;
}

export interface IxfWatchlistV1Fincen314MatchEventTypeOpen {
    spec: IxfWatchlistV1FincenMatchSpec[];
    openedBy: IxfWatchlistV1OpenedBy;
}

export const IXF_WATCHLIST_V1_FINCEN314_MATCH_EVENT_TYPE_ONE_OF_VALUES = ['open', 'close'] as const;

export type IxfWatchlistV1Fincen314MatchEventTypeOneOfValue = (typeof IXF_WATCHLIST_V1_FINCEN314_MATCH_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfWatchlistV1Fincen314MatchKeys {
    // format: id62
    fincen314MatchId: string;
    /* The profile this match rolls up to. Lives in registration, so no foreign
    reference. */
    // format: id62
    profileId: string;
}

export interface IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchEventsFincen314MatchEventsRequest {
    // format: id62
    fincen314MatchId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchEventsSearchableFields, IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchEventsSortableFields, IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchEventsFilterableFields>;
}

export enum IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    Fincen314MatchId = 'fincen314MatchId',
    ProfileId = 'profileId',
    EventOpenSpecMatchValuesIdentificationType = 'event.open.spec.matchValues.identification.type',
    EventOpenSpecMatchValuesElectronicContactType = 'event.open.spec.matchValues.electronicContact.type',
    EventType = 'event.!type'
}

export enum IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchEventsSearchableFields {
    EventOpenSpecMatchValuesIndividualNameLastName = 'event.open.spec.matchValues.individualName.lastName',
    EventOpenSpecMatchValuesIndividualNameFirstName = 'event.open.spec.matchValues.individualName.firstName',
    EventOpenSpecMatchValuesIndividualNameMiddleName = 'event.open.spec.matchValues.individualName.middleName',
    EventOpenSpecMatchValuesIndividualNameSuffix = 'event.open.spec.matchValues.individualName.suffix',
    EventOpenSpecMatchValuesOrganizationNameBusinessName = 'event.open.spec.matchValues.organizationName.businessName',
    EventOpenSpecMatchValuesIdentificationId = 'event.open.spec.matchValues.identification.id',
    EventOpenSpecMatchValuesElectronicContactValue = 'event.open.spec.matchValues.electronicContact.value'
}

export enum IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchGetFincen314MatchGetRequest {
    // format: id62
    fincen314MatchId: string;
}

export interface IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchListFincen314MatchListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchListSearchableFields, IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchListSortableFields, IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchListFilterableFields>;
}

export enum IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchListFilterableFields {
    Fincen314MatchId = 'fincen314MatchId',
    ProfileId = 'profileId',
    DataSpecMatchValuesIdentificationType = 'data.spec.matchValues.identification.type',
    DataSpecMatchValuesElectronicContactType = 'data.spec.matchValues.electronicContact.type',
    Status = 'status'
}

export enum IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchListSearchableFields {
    DataSpecMatchValuesIndividualNameLastName = 'data.spec.matchValues.individualName.lastName',
    DataSpecMatchValuesIndividualNameFirstName = 'data.spec.matchValues.individualName.firstName',
    DataSpecMatchValuesIndividualNameMiddleName = 'data.spec.matchValues.individualName.middleName',
    DataSpecMatchValuesIndividualNameSuffix = 'data.spec.matchValues.individualName.suffix',
    DataSpecMatchValuesOrganizationNameBusinessName = 'data.spec.matchValues.organizationName.businessName',
    DataSpecMatchValuesIdentificationId = 'data.spec.matchValues.identification.id',
    DataSpecMatchValuesElectronicContactValue = 'data.spec.matchValues.electronicContact.value'
}

export enum IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxfWatchlistV1Fincen314MatchState extends IxfWatchlistV1Fincen314MatchKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfWatchlistV1Fincen314MatchData;
    status: IxfWatchlistV1Fincen314MatchStatus;
}

export enum IxfWatchlistV1Fincen314MatchStatus {
    Unspecified = 'UNSPECIFIED',
    Opened = 'OPENED',
    Closed = 'CLOSED'
}

export interface IxfWatchlistV1FincenMatchSpec {
    // format: id62
    fincen314EntryId: string;
    trackingNumber?: string;
    matchValues?: IxfWatchlistV1MatchSpecFields;
}

export interface IxfWatchlistV1Identification {
    /* The id and type of identification presented */
    id?: string;
    type?: IxfWatchlistV1IdentificationType;
}

export enum IxfWatchlistV1IdentificationType {
    Unspecified = 'UNSPECIFIED',
    DriversLicense = 'DRIVERS_LICENSE',
    SsnItin = 'SSN_ITIN',
    Passport = 'PASSPORT',
    AlienRegistration = 'ALIEN_REGISTRATION',
    Tin = 'TIN',
    Ein = 'EIN'
}

export interface IxfWatchlistV1IdList {
    idType?: string;
    idNumber?: string;
    country?: IsoV1Country;
}

export interface IxfWatchlistV1IndividualName {
    lastName?: string;
    firstName?: string;
    middleName?: string;
    suffix?: string;
}

export interface IxfWatchlistV1IndividualSubject {
    name?: IxfWatchlistV1IndividualName;
    aliases?: IxfWatchlistV1IndividualName[];
    // format: YYYY-MM-DD
    dob?: string[];
    addresses?: IxfWatchlistV1Address[];
    phones?: string[];
    identifications?: IxfWatchlistV1Identification[];
    electronicContacts?: IxfWatchlistV1ElectronicContact[];
}

export enum IxfWatchlistV1ListType {
    Unspecified = 'UNSPECIFIED',
    Ofac = 'OFAC',
    Fincen = 'FINCEN'
}

export interface IxfWatchlistV1MatchSpecFields {
    individualName?: IxfWatchlistV1IndividualName;
    organizationName?: IxfWatchlistV1OrganizationName;
    identification?: IxfWatchlistV1Identification;
    electronicContact?: IxfWatchlistV1ElectronicContact;
}

export interface IxfWatchlistV1Nationality {
    country?: IsoV1Country;
    mainEntry?: boolean;
}

export interface IxfWatchlistV1OfacFileData {
    documentUrl: string;
    eTag: string;
    // format: UINT32
    totalRows?: number;
    // format: YYYY-MM-DD
    publishedDate?: string;
}

export interface IxfWatchlistV1OfacFileEvent extends IxfWatchlistV1OfacFileKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfWatchlistV1OfacFileEventType;
}

export type IxfWatchlistV1OfacFileEventType = {
    '!type'?: 'uploaded';
    uploaded: IxfWatchlistV1OfacFileEventTypeUploaded;
} | {
    '!type'?: 'created';
    created: EmptyObject;
} | {
    '!type'?: 'ingest';
    ingest: EmptyObject;
} | {
    '!type'?: 'process';
    process: EmptyObject;
} | {
    '!type'?: 'completed';
    completed: IxfWatchlistV1OfacFileEventTypeCompleted;
} | {
    '!type'?: 'errored';
    errored: IxfWatchlistV1OfacFileEventTypeErrored;
};

export interface IxfWatchlistV1OfacFileEventTypeCompleted {
    // format: UINT32
    totalRows?: number;
}

export interface IxfWatchlistV1OfacFileEventTypeErrored {
    message?: string;
}

export interface IxfWatchlistV1OfacFileEventTypeUploaded {
    documentUrl: string;
    eTag: string;
    // format: YYYY-MM-DD
    publishedDate?: string;
}

export const IXF_WATCHLIST_V1_OFAC_FILE_EVENT_TYPE_ONE_OF_VALUES = ['uploaded', 'created', 'ingest', 'process', 'completed', 'errored'] as const;

export type IxfWatchlistV1OfacFileEventTypeOneOfValue = (typeof IXF_WATCHLIST_V1_OFAC_FILE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfWatchlistV1OfacFileKeys {
    // format: id62
    ofacFileId: string;
}

export interface IxfWatchlistV1OfacFileQueryServiceOfacFileEventsOfacFileEventsRequest {
    // format: id62
    ofacFileId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfWatchlistV1OfacFileQueryServiceOfacFileEventsSortableFields, IxfWatchlistV1OfacFileQueryServiceOfacFileEventsFilterableFields>;
}

export enum IxfWatchlistV1OfacFileQueryServiceOfacFileEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    OfacFileId = 'ofacFileId',
    EventType = 'event.!type'
}

export enum IxfWatchlistV1OfacFileQueryServiceOfacFileEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxfWatchlistV1OfacFileQueryServiceOfacFileGetOfacFileGetRequest {
    // format: id62
    ofacFileId: string;
}

export interface IxfWatchlistV1OfacFileQueryServiceOfacFileListOfacFileListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxfWatchlistV1OfacFileQueryServiceOfacFileListSortableFields, IxfWatchlistV1OfacFileQueryServiceOfacFileListFilterableFields>;
}

export enum IxfWatchlistV1OfacFileQueryServiceOfacFileListFilterableFields {
    OfacFileId = 'ofacFileId',
    Status = 'status'
}

export enum IxfWatchlistV1OfacFileQueryServiceOfacFileListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxfWatchlistV1OfacFileState extends IxfWatchlistV1OfacFileKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfWatchlistV1OfacFileData;
    status: IxfWatchlistV1OfacFileStatus;
}

export enum IxfWatchlistV1OfacFileStatus {
    Unspecified = 'UNSPECIFIED',
    Created = 'CREATED',
    Ingesting = 'INGESTING',
    Processing = 'PROCESSING',
    Failed = 'FAILED',
    Done = 'DONE'
}

export interface IxfWatchlistV1OfacMatchData {
    spec?: IxfWatchlistV1OfacMatchSpec[];
}

export interface IxfWatchlistV1OfacMatchEvent extends IxfWatchlistV1OfacMatchKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfWatchlistV1OfacMatchEventType;
}

export type IxfWatchlistV1OfacMatchEventType = {
    '!type'?: 'open';
    open: IxfWatchlistV1OfacMatchEventTypeOpen;
} | {
    '!type'?: 'close';
    close: IxfWatchlistV1OfacMatchEventTypeClose;
};

export interface IxfWatchlistV1OfacMatchEventTypeClose {
    // format: id62
    closedBy: string;
}

export interface IxfWatchlistV1OfacMatchEventTypeOpen {
    spec: IxfWatchlistV1OfacMatchSpec[];
    openedBy: IxfWatchlistV1OpenedBy;
}

export const IXF_WATCHLIST_V1_OFAC_MATCH_EVENT_TYPE_ONE_OF_VALUES = ['open', 'close'] as const;

export type IxfWatchlistV1OfacMatchEventTypeOneOfValue = (typeof IXF_WATCHLIST_V1_OFAC_MATCH_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfWatchlistV1OfacMatchKeys {
    // format: id62
    ofacMatchId: string;
    /* The profile this match rolls up to. */
    // format: id62
    profileId: string;
}

export interface IxfWatchlistV1OfacMatchQueryServiceOfacMatchEventsOfacMatchEventsRequest {
    // format: id62
    ofacMatchId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxfWatchlistV1OfacMatchQueryServiceOfacMatchEventsSearchableFields, IxfWatchlistV1OfacMatchQueryServiceOfacMatchEventsSortableFields, IxfWatchlistV1OfacMatchQueryServiceOfacMatchEventsFilterableFields>;
}

export enum IxfWatchlistV1OfacMatchQueryServiceOfacMatchEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    OfacMatchId = 'ofacMatchId',
    ProfileId = 'profileId',
    EventOpenSpecMatchValuesIdentificationType = 'event.open.spec.matchValues.identification.type',
    EventOpenSpecMatchValuesElectronicContactType = 'event.open.spec.matchValues.electronicContact.type',
    EventType = 'event.!type'
}

export enum IxfWatchlistV1OfacMatchQueryServiceOfacMatchEventsSearchableFields {
    EventOpenSpecMatchValuesIndividualNameLastName = 'event.open.spec.matchValues.individualName.lastName',
    EventOpenSpecMatchValuesIndividualNameFirstName = 'event.open.spec.matchValues.individualName.firstName',
    EventOpenSpecMatchValuesIndividualNameMiddleName = 'event.open.spec.matchValues.individualName.middleName',
    EventOpenSpecMatchValuesIndividualNameSuffix = 'event.open.spec.matchValues.individualName.suffix',
    EventOpenSpecMatchValuesOrganizationNameBusinessName = 'event.open.spec.matchValues.organizationName.businessName',
    EventOpenSpecMatchValuesIdentificationId = 'event.open.spec.matchValues.identification.id',
    EventOpenSpecMatchValuesElectronicContactValue = 'event.open.spec.matchValues.electronicContact.value'
}

export enum IxfWatchlistV1OfacMatchQueryServiceOfacMatchEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxfWatchlistV1OfacMatchQueryServiceOfacMatchGetOfacMatchGetRequest {
    // format: id62
    ofacMatchId: string;
}

export interface IxfWatchlistV1OfacMatchQueryServiceOfacMatchListOfacMatchListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxfWatchlistV1OfacMatchQueryServiceOfacMatchListSearchableFields, IxfWatchlistV1OfacMatchQueryServiceOfacMatchListSortableFields, IxfWatchlistV1OfacMatchQueryServiceOfacMatchListFilterableFields>;
}

export enum IxfWatchlistV1OfacMatchQueryServiceOfacMatchListFilterableFields {
    OfacMatchId = 'ofacMatchId',
    ProfileId = 'profileId',
    DataSpecMatchValuesIdentificationType = 'data.spec.matchValues.identification.type',
    DataSpecMatchValuesElectronicContactType = 'data.spec.matchValues.electronicContact.type',
    Status = 'status'
}

export enum IxfWatchlistV1OfacMatchQueryServiceOfacMatchListSearchableFields {
    DataSpecMatchValuesIndividualNameLastName = 'data.spec.matchValues.individualName.lastName',
    DataSpecMatchValuesIndividualNameFirstName = 'data.spec.matchValues.individualName.firstName',
    DataSpecMatchValuesIndividualNameMiddleName = 'data.spec.matchValues.individualName.middleName',
    DataSpecMatchValuesIndividualNameSuffix = 'data.spec.matchValues.individualName.suffix',
    DataSpecMatchValuesOrganizationNameBusinessName = 'data.spec.matchValues.organizationName.businessName',
    DataSpecMatchValuesIdentificationId = 'data.spec.matchValues.identification.id',
    DataSpecMatchValuesElectronicContactValue = 'data.spec.matchValues.electronicContact.value'
}

export enum IxfWatchlistV1OfacMatchQueryServiceOfacMatchListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxfWatchlistV1OfacMatchSpec {
    // format: id62
    ofacSdnId: string;
    ofacUid: string;
    matchValues: IxfWatchlistV1MatchSpecFields;
}

export interface IxfWatchlistV1OfacMatchState extends IxfWatchlistV1OfacMatchKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfWatchlistV1OfacMatchData;
    status: IxfWatchlistV1OfacMatchStatus;
}

export enum IxfWatchlistV1OfacMatchStatus {
    Unspecified = 'UNSPECIFIED',
    Opened = 'OPENED',
    Closed = 'CLOSED'
}

export interface IxfWatchlistV1OfacSdnData {
    spec?: IxfWatchlistV1OfacSdnSpec;
}

export interface IxfWatchlistV1OfacSdnEvent extends IxfWatchlistV1OfacSdnKeys {
    metadata: J5StateV1EventMetadata;
    event: IxfWatchlistV1OfacSdnEventType;
}

export type IxfWatchlistV1OfacSdnEventType = {
    '!type'?: 'created';
    created: IxfWatchlistV1OfacSdnEventTypeCreated;
};

export interface IxfWatchlistV1OfacSdnEventTypeCreated {
    spec: IxfWatchlistV1OfacSdnSpec;
    // format: id62
    fileId: string;
}

export const IXF_WATCHLIST_V1_OFAC_SDN_EVENT_TYPE_ONE_OF_VALUES = ['created'] as const;

export type IxfWatchlistV1OfacSdnEventTypeOneOfValue = (typeof IXF_WATCHLIST_V1_OFAC_SDN_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxfWatchlistV1OfacSdnKeys {
    // format: id62
    ofacSdnId: string;
    /* The unique identifier of the ofac file */
    // format: id62, entity: ixf.watchlist.v1.OfacFile
    ofacFileId: string;
}

export interface IxfWatchlistV1OfacSdnQueryServiceOfacSdnEventsOfacSdnEventsRequest {
    // format: id62
    ofacSdnId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxfWatchlistV1OfacSdnQueryServiceOfacSdnEventsSearchableFields, IxfWatchlistV1OfacSdnQueryServiceOfacSdnEventsSortableFields, IxfWatchlistV1OfacSdnQueryServiceOfacSdnEventsFilterableFields>;
}

export enum IxfWatchlistV1OfacSdnQueryServiceOfacSdnEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    OfacSdnId = 'ofacSdnId',
    OfacFileId = 'ofacFileId',
    EventType = 'event.!type'
}

export enum IxfWatchlistV1OfacSdnQueryServiceOfacSdnEventsSearchableFields {
    EventCreatedSpecSdnIndividualFirstName = 'event.created.spec.sdn.individual.firstName',
    EventCreatedSpecSdnIndividualLastName = 'event.created.spec.sdn.individual.lastName',
    EventCreatedSpecSdnIndividualAkasFirstName = 'event.created.spec.sdn.individual.akas.firstName',
    EventCreatedSpecSdnIndividualAkasLastName = 'event.created.spec.sdn.individual.akas.lastName',
    EventCreatedSpecSdnIndividualIdsIdNumber = 'event.created.spec.sdn.individual.ids.idNumber',
    EventCreatedSpecSdnOrganizationName = 'event.created.spec.sdn.organization.name',
    EventCreatedSpecSdnOrganizationIdsIdNumber = 'event.created.spec.sdn.organization.ids.idNumber',
    EventCreatedSpecSdnOrganizationAkasName = 'event.created.spec.sdn.organization.akas.name'
}

export enum IxfWatchlistV1OfacSdnQueryServiceOfacSdnEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxfWatchlistV1OfacSdnQueryServiceOfacSdnGetOfacSdnGetRequest {
    // format: id62
    ofacSdnId: string;
}

export interface IxfWatchlistV1OfacSdnQueryServiceOfacSdnListOfacSdnListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxfWatchlistV1OfacSdnQueryServiceOfacSdnListSearchableFields, IxfWatchlistV1OfacSdnQueryServiceOfacSdnListSortableFields, IxfWatchlistV1OfacSdnQueryServiceOfacSdnListFilterableFields>;
}

export enum IxfWatchlistV1OfacSdnQueryServiceOfacSdnListFilterableFields {
    OfacSdnId = 'ofacSdnId',
    OfacFileId = 'ofacFileId',
    Status = 'status'
}

export enum IxfWatchlistV1OfacSdnQueryServiceOfacSdnListSearchableFields {
    DataSpecSdnIndividualFirstName = 'data.spec.sdn.individual.firstName',
    DataSpecSdnIndividualLastName = 'data.spec.sdn.individual.lastName',
    DataSpecSdnIndividualAkasFirstName = 'data.spec.sdn.individual.akas.firstName',
    DataSpecSdnIndividualAkasLastName = 'data.spec.sdn.individual.akas.lastName',
    DataSpecSdnIndividualIdsIdNumber = 'data.spec.sdn.individual.ids.idNumber',
    DataSpecSdnOrganizationName = 'data.spec.sdn.organization.name',
    DataSpecSdnOrganizationIdsIdNumber = 'data.spec.sdn.organization.ids.idNumber',
    DataSpecSdnOrganizationAkasName = 'data.spec.sdn.organization.akas.name'
}

export enum IxfWatchlistV1OfacSdnQueryServiceOfacSdnListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxfWatchlistV1OfacSdnSpec {
    ofacUid?: string;
    // format: date-time
    fileDate?: string;
    sdn?: IxfWatchlistV1SdnType;
}

export interface IxfWatchlistV1OfacSdnState extends IxfWatchlistV1OfacSdnKeys {
    metadata: J5StateV1StateMetadata;
    data: IxfWatchlistV1OfacSdnData;
    status: IxfWatchlistV1OfacSdnStatus;
}

export enum IxfWatchlistV1OfacSdnStatus {
    Unspecified = 'UNSPECIFIED',
    Created = 'CREATED'
}

export enum IxfWatchlistV1OpenedBy {
    Unspecified = 'UNSPECIFIED',
    ProfileCreated = 'PROFILE_CREATED',
    ProfileUpdated = 'PROFILE_UPDATED',
    ManualScreen = 'MANUAL_SCREEN'
}

export interface IxfWatchlistV1OrganizationDba {
    dbaName?: string;
}

export interface IxfWatchlistV1OrganizationName {
    businessName?: string;
}

export interface IxfWatchlistV1OrganizationSubject {
    name?: IxfWatchlistV1OrganizationName;
    dba?: IxfWatchlistV1OrganizationDba[];
    identifications?: IxfWatchlistV1Identification[];
    // format: YYYY-MM-DD
    incorporatedDate?: string[];
    addresses?: IxfWatchlistV1Address[];
    phones?: string[];
    electronicContacts?: IxfWatchlistV1ElectronicContact[];
}

export type IxfWatchlistV1SdnType = {
    '!type'?: 'individual';
    individual: IxfWatchlistV1SdnTypeIndividual;
} | {
    '!type'?: 'organization';
    organization: IxfWatchlistV1SdnTypeOrganization;
};

export interface IxfWatchlistV1SdnTypeIndividual {
    firstName?: string;
    lastName?: string;
    birthDates?: IxfWatchlistV1Birthdate[];
    addresses?: IxfWatchlistV1Address[];
    programs?: string[];
    akas?: IxfWatchlistV1AkaIndividual[];
    nationalities?: IxfWatchlistV1Nationality[];
    citizenships?: IxfWatchlistV1Citizenship[];
    ids?: IxfWatchlistV1IdList[];
    remarks?: string;
}

export interface IxfWatchlistV1SdnTypeOrganization {
    name?: string;
    addresses?: IxfWatchlistV1Address[];
    programs?: string[];
    ids?: IxfWatchlistV1IdList[];
    akas?: IxfWatchlistV1AkaOrganization[];
    remarks?: string;
}

export const IXF_WATCHLIST_V1_SDN_TYPE_ONE_OF_VALUES = ['individual', 'organization'] as const;

export type IxfWatchlistV1SdnTypeOneOfValue = (typeof IXF_WATCHLIST_V1_SDN_TYPE_ONE_OF_VALUES)[number];

export interface IxmAgentauthOauthV1AgentAuthServiceAuthorizeAuthorizeRequest {
    /* Must be "code". */
    responseType?: string;
    /* https URL of the Client ID Metadata Document, fetched with SSRF guards. */
    clientId?: string;
    /* Must match an entry in the document's redirect_uris; loopback hosts match ignoring the port. */
    redirectUri?: string;
    /* BASE64URL(SHA256(code_verifier)). */
    codeChallenge?: string;
    /* Must be "S256"; "plain" is rejected. */
    codeChallengeMethod?: string;
    /* RFC 8707 target, the MCP path the token is for, e.g. ZONE/mcp. */
    resource?: string;
    /* Opaque client value, echoed on the redirect. */
    state?: string;
    /* Not used; accepted so that clients which send it are not rejected. */
    scope?: string;
    /* Not used; accepted so that clients which send it are not rejected. */
    uiLocales?: string;
}

export interface IxmAgentauthV1AgentKeyData {
    spec: IxmAgentauthV1AgentKeySpec;
    /* The user who created and owns the Agent Key */
    // format: id62, entity: ixm.userauth.v1.User
    userId: string;
}

export interface IxmAgentauthV1AgentKeyEvent extends IxmAgentauthV1AgentKeyKeys {
    metadata: J5StateV1EventMetadata;
    event: IxmAgentauthV1AgentKeyEventType;
}

export type IxmAgentauthV1AgentKeyEventType = {
    '!type'?: 'created';
    created: IxmAgentauthV1AgentKeyEventTypeCreated;
} | {
    '!type'?: 'archived';
    archived: EmptyObject;
} | {
    '!type'?: 'updated';
    updated: IxmAgentauthV1AgentKeyEventTypeUpdated;
} | {
    '!type'?: 'keyUsed';
    keyUsed: IxmAgentauthV1AgentKeyEventTypeKeyUsed;
};

export interface IxmAgentauthV1AgentKeyEventTypeCreated {
    spec: IxmAgentauthV1AgentKeySpec;
    // format: id62
    userId: string;
}

export interface IxmAgentauthV1AgentKeyEventTypeKeyUsed {
    // format: id62
    jti: string;
    clientId: string;
    // format: id62
    userId: string;
    grant: IxmAgentauthV1Grant;
    scopes?: string[];
}

export interface IxmAgentauthV1AgentKeyEventTypeUpdated {
    name?: string;
}

export const IXM_AGENTAUTH_V1_AGENT_KEY_EVENT_TYPE_ONE_OF_VALUES = ['created', 'archived', 'updated', 'keyUsed'] as const;

export type IxmAgentauthV1AgentKeyEventTypeOneOfValue = (typeof IXM_AGENTAUTH_V1_AGENT_KEY_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxmAgentauthV1AgentKeyKeys {
    // format: id62
    agentId: string;
    // format: custom - pattern: ^[a-z0-9_]+$
    tenantType: string;
    // format: id62
    tenantId: string;
}

export interface IxmAgentauthV1AgentKeyQueryServiceAgentKeyEventsAgentKeyEventsRequest {
    // format: id62
    agentId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmAgentauthV1AgentKeyQueryServiceAgentKeyEventsSortableFields, IxmAgentauthV1AgentKeyQueryServiceAgentKeyEventsFilterableFields>;
}

export enum IxmAgentauthV1AgentKeyQueryServiceAgentKeyEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AgentId = 'agentId',
    TenantType = 'tenantType',
    TenantId = 'tenantId',
    EventType = 'event.!type'
}

export enum IxmAgentauthV1AgentKeyQueryServiceAgentKeyEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxmAgentauthV1AgentKeyQueryServiceAgentKeyGetAgentKeyGetRequest {
    // format: id62
    agentId: string;
}

export interface IxmAgentauthV1AgentKeyQueryServiceAgentKeyListAgentKeyListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmAgentauthV1AgentKeyQueryServiceAgentKeyListSortableFields, IxmAgentauthV1AgentKeyQueryServiceAgentKeyListFilterableFields>;
}

export enum IxmAgentauthV1AgentKeyQueryServiceAgentKeyListFilterableFields {
    AgentId = 'agentId',
    TenantType = 'tenantType',
    TenantId = 'tenantId',
    DataUserId = 'data.userId',
    Status = 'status'
}

export enum IxmAgentauthV1AgentKeyQueryServiceAgentKeyListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxmAgentauthV1AgentKeySpec {
    name?: string;
    scopes: string[];
}

export interface IxmAgentauthV1AgentKeyState extends IxmAgentauthV1AgentKeyKeys {
    metadata: J5StateV1StateMetadata;
    data: IxmAgentauthV1AgentKeyData;
    status: IxmAgentauthV1AgentKeyStatus;
}

export enum IxmAgentauthV1AgentKeyStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Archived = 'ARCHIVED'
}

export type IxmAgentauthV1Grant = {
    '!type'?: 'authorizationCode';
    authorizationCode: IxmAgentauthV1GrantAuthorizationCode;
} | {
    '!type'?: 'refreshToken';
    refreshToken: IxmAgentauthV1GrantRefreshToken;
} | {
    '!type'?: 'tokenExchange';
    tokenExchange: IxmAgentauthV1GrantTokenExchange;
};

export interface IxmAgentauthV1GrantAuthorizationCode {
    // format: id62
    familyId: string;
}

export interface IxmAgentauthV1GrantRefreshToken {
    // format: id62
    familyId: string;
}

export interface IxmAgentauthV1GrantTokenExchange {
    // format: id62
    subjectJti: string;
    subjectClientId: string;
    /* The method the client declared it will call, as pkg.Service/Method.
    Not verified. */
    // pattern: ^[a-z][a-z0-9_]*(\.[a-z][a-z0-9_]*)+\.[A-Za-z][A-Za-z0-9_]*/[A-Za-z][A-Za-z0-9_]*$
    targetMethod: string;
}

export const IXM_AGENTAUTH_V1_GRANT_ONE_OF_VALUES = ['authorizationCode', 'refreshToken', 'tokenExchange'] as const;

export type IxmAgentauthV1GrantOneOfValue = (typeof IXM_AGENTAUTH_V1_GRANT_ONE_OF_VALUES)[number];

export interface IxmAuthV1ApiKeyData {
    spec: IxmAuthV1ApiKeySpec;
}

export interface IxmAuthV1ApiKeyEvent extends IxmAuthV1ApiKeyKeys {
    metadata: J5StateV1EventMetadata;
    event: IxmAuthV1ApiKeyEventType;
}

export type IxmAuthV1ApiKeyEventType = {
    '!type'?: 'created';
    created: IxmAuthV1ApiKeyEventTypeCreated;
} | {
    '!type'?: 'archived';
    archived: EmptyObject;
} | {
    '!type'?: 'updated';
    updated: IxmAuthV1ApiKeyEventTypeUpdated;
} | {
    '!type'?: 'keyUsed';
    keyUsed: IxmAuthV1ApiKeyEventTypeKeyUsed;
};

export interface IxmAuthV1ApiKeyEventTypeCreated {
    spec: IxmAuthV1ApiKeySpec;
}

export interface IxmAuthV1ApiKeyEventTypeKeyUsed {
    jti: string;
}

export interface IxmAuthV1ApiKeyEventTypeUpdated {
    spec: IxmAuthV1ApiKeySpec;
}

export const IXM_AUTH_V1_API_KEY_EVENT_TYPE_ONE_OF_VALUES = ['created', 'archived', 'updated', 'keyUsed'] as const;

export type IxmAuthV1ApiKeyEventTypeOneOfValue = (typeof IXM_AUTH_V1_API_KEY_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxmAuthV1ApiKeyKeys {
    // format: id62
    clientId: string;
    // format: custom - pattern: ^[a-z0-9_]+$
    tenantType: string;
    // format: id62
    tenantId: string;
}

export interface IxmAuthV1ApiKeyQueryServiceApiKeyEventsApiKeyEventsRequest {
    // format: id62
    clientId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmAuthV1ApiKeyQueryServiceApiKeyEventsSortableFields, IxmAuthV1ApiKeyQueryServiceApiKeyEventsFilterableFields>;
}

export enum IxmAuthV1ApiKeyQueryServiceApiKeyEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    ClientId = 'clientId',
    TenantType = 'tenantType',
    TenantId = 'tenantId',
    EventType = 'event.!type'
}

export enum IxmAuthV1ApiKeyQueryServiceApiKeyEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxmAuthV1ApiKeyQueryServiceApiKeyGetApiKeyGetRequest {
    // format: id62
    clientId: string;
}

export interface IxmAuthV1ApiKeyQueryServiceApiKeyListApiKeyListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmAuthV1ApiKeyQueryServiceApiKeyListSortableFields, IxmAuthV1ApiKeyQueryServiceApiKeyListFilterableFields>;
}

export enum IxmAuthV1ApiKeyQueryServiceApiKeyListFilterableFields {
    ClientId = 'clientId',
    TenantType = 'tenantType',
    TenantId = 'tenantId',
    Status = 'status'
}

export enum IxmAuthV1ApiKeyQueryServiceApiKeyListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxmAuthV1ApiKeySpec {
    name?: string;
    scopes?: string[];
}

export interface IxmAuthV1ApiKeyState extends IxmAuthV1ApiKeyKeys {
    metadata: J5StateV1StateMetadata;
    data: IxmAuthV1ApiKeyData;
    status: IxmAuthV1ApiKeyStatus;
}

export enum IxmAuthV1ApiKeyStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Archived = 'ARCHIVED'
}

export interface IxmEmailV1Address {
    email?: string;
    name?: string;
}

export interface IxmEmailV1Email {
    // format: id62
    emailId?: string;
    // format: date-time
    createdAt: string;
    request?: IxmEmailV1EmailRequest;
}

export type IxmEmailV1EmailRequest = {
    '!type'?: 'sendEmail';
    sendEmail: IxmEmailV1SendEmail;
} | {
    '!type'?: 'sendTemplatedEmail';
    sendTemplatedEmail: IxmEmailV1SendTemplatedEmail;
};

export const IXM_EMAIL_V1_EMAIL_REQUEST_ONE_OF_VALUES = ['sendEmail', 'sendTemplatedEmail'] as const;

export type IxmEmailV1EmailRequestOneOfValue = (typeof IXM_EMAIL_V1_EMAIL_REQUEST_ONE_OF_VALUES)[number];

export type IxmEmailV1EmailDataType = {
    '!type'?: 'passwordReset';
    /* Sent when a request is entered for a new password, and the user exists in
    the system. */
    passwordReset: IxmEmailV1EmailDataTypePasswordReset;
} | {
    '!type'?: 'userInvite';
    userInvite: IxmEmailV1EmailDataTypeUserInvite;
} | {
    '!type'?: 'passwordChangeNotification';
    passwordChangeNotification: IxmEmailV1EmailDataTypePasswordChangeNotification;
} | {
    '!type'?: 'newAccessRequest';
    newAccessRequest: IxmEmailV1EmailDataTypeNewAccessRequest;
};

export interface IxmEmailV1EmailDataTypeNewAccessRequest {
    name?: string;
    email?: string;
}

export interface IxmEmailV1EmailDataTypePasswordChangeNotification {
    personName?: string;
    ipAddress?: string;
}

export interface IxmEmailV1EmailDataTypePasswordReset {
    resetUrl?: string;
    personName?: string;
}

export interface IxmEmailV1EmailDataTypeUserInvite {
    inviteUrl?: string;
    personName?: string;
    organizationName?: string;
}

export const IXM_EMAIL_V1_EMAIL_DATA_TYPE_ONE_OF_VALUES = ['passwordReset', 'userInvite', 'passwordChangeNotification', 'newAccessRequest'] as const;

export type IxmEmailV1EmailDataTypeOneOfValue = (typeof IXM_EMAIL_V1_EMAIL_DATA_TYPE_ONE_OF_VALUES)[number];

export interface IxmEmailV1EmailSandboxServiceGetEmailGetEmailRequest {
    // format: id62
    emailId: string;
}

export interface IxmEmailV1EmailSandboxServiceListEmailsListEmailsRequest {
    // format: id62
    programId?: string;
    recipientEmail?: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmEmailV1EmailSandboxServiceListEmailsSortableFields>;
}

export enum IxmEmailV1EmailSandboxServiceListEmailsSortableFields {
    CreatedAt = 'createdAt'
}

export interface IxmEmailV1Recipient {
    /* becomes emailId in SendTemplatedEmailMessage, used to correlate the
    invitation with the email in tests */
    emailId: string;
    address: string;
    name?: string;
}

export interface IxmEmailV1SendEmail {
    recipient: IxmEmailV1Recipient;
    sender?: IxmEmailV1Address;
    subject?: string;
    // bytes (base64-encoded)
    htmlBody?: string;
    // bytes (base64-encoded)
    textBody?: string;
}

export interface IxmEmailV1SendTemplatedEmail {
    recipient: IxmEmailV1Recipient;
    sender?: IxmEmailV1Address;
    data: IxmEmailV1EmailDataType;
    // format: id62
    tenantId?: string;
}

export type IxmEventsV1Destination = {
    '!type'?: 'url';
    /* Webhook URL endpoint. */
    url: string;
};

export const IXM_EVENTS_V1_DESTINATION_ONE_OF_VALUES = ['url'] as const;

export type IxmEventsV1DestinationOneOfValue = (typeof IXM_EVENTS_V1_DESTINATION_ONE_OF_VALUES)[number];

export type IxmEventsV1DestinationResponse = {
    '!type'?: 'httpResponse';
    /* Response from a webhook destination. */
    httpResponse: IxmEventsV1DestinationResponseHttpResponse;
};

export interface IxmEventsV1DestinationResponseHttpResponse {
    // format: UINT32
    statusCode: number;
    responseBody?: string;
    responseHeaders: Record<string, string>;
}

export const IXM_EVENTS_V1_DESTINATION_RESPONSE_ONE_OF_VALUES = ['httpResponse'] as const;

export type IxmEventsV1DestinationResponseOneOfValue = (typeof IXM_EVENTS_V1_DESTINATION_RESPONSE_ONE_OF_VALUES)[number];

export interface IxmEventsV1Event {
    id: string;
    entityName: string;
    // format: UINT64
    sequence?: string;
    // format: date-time
    timestamp: string;
    eventType: string;
    cause?: J5StateV1Cause;
    entityKeys: any;
    eventData: any;
    entityState: any;
    entityStatus: string;
}

export interface IxmEventsV1PollServiceReceiveReceiveRequest {
    page?: J5ListV1PageRequest;
    // format: date-time
    since?: string;
    // format: UINT32
    maxWaitTimeSeconds?: number;
}

export interface IxmEventsV1TargetData {
    spec: IxmEventsV1TargetSpec;
}

export interface IxmEventsV1TargetEvent extends IxmEventsV1TargetKeys {
    metadata: J5StateV1EventMetadata;
    event: IxmEventsV1TargetEventType;
}

export type IxmEventsV1TargetEventType = {
    '!type'?: 'created';
    created: IxmEventsV1TargetEventTypeCreated;
} | {
    '!type'?: 'archived';
    archived: EmptyObject;
};

export interface IxmEventsV1TargetEventTypeCreated {
    spec: IxmEventsV1TargetSpec;
}

export const IXM_EVENTS_V1_TARGET_EVENT_TYPE_ONE_OF_VALUES = ['created', 'archived'] as const;

export type IxmEventsV1TargetEventTypeOneOfValue = (typeof IXM_EVENTS_V1_TARGET_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxmEventsV1TargetKeys {
    // format: id62
    targetId: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
}

export interface IxmEventsV1TargetQueryServiceTargetEventsTargetEventsRequest {
    // format: id62
    targetId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmEventsV1TargetQueryServiceTargetEventsSortableFields, IxmEventsV1TargetQueryServiceTargetEventsFilterableFields>;
}

export enum IxmEventsV1TargetQueryServiceTargetEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    TargetId = 'targetId',
    ProgramId = 'programId',
    EventCreatedSpecDestinationType = 'event.created.spec.destination.!type',
    EventType = 'event.!type'
}

export enum IxmEventsV1TargetQueryServiceTargetEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxmEventsV1TargetQueryServiceTargetGetTargetGetRequest {
    // format: id62
    targetId: string;
}

export interface IxmEventsV1TargetQueryServiceTargetListTargetListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmEventsV1TargetQueryServiceTargetListSortableFields, IxmEventsV1TargetQueryServiceTargetListFilterableFields>;
}

export enum IxmEventsV1TargetQueryServiceTargetListFilterableFields {
    TargetId = 'targetId',
    ProgramId = 'programId',
    DataSpecDestinationType = 'data.spec.destination.!type',
    Status = 'status'
}

export enum IxmEventsV1TargetQueryServiceTargetListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxmEventsV1TargetSpec {
    /* Destination where events will be sent. */
    destination: IxmEventsV1Destination;
}

export interface IxmEventsV1TargetState extends IxmEventsV1TargetKeys {
    metadata: J5StateV1StateMetadata;
    data: IxmEventsV1TargetData;
    status: IxmEventsV1TargetStatus;
}

export enum IxmEventsV1TargetStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Archived = 'ARCHIVED'
}

export type IxmTriggerV1Payload = {
    '!type'?: 'static';
    static: string;
};

export const IXM_TRIGGER_V1_PAYLOAD_ONE_OF_VALUES = ['static'] as const;

export type IxmTriggerV1PayloadOneOfValue = (typeof IXM_TRIGGER_V1_PAYLOAD_ONE_OF_VALUES)[number];

export interface IxmTriggerV1TriggerData {
    triggerName: string;
    appName: string;
    cron?: string;
    payload?: IxmTriggerV1Payload;
    target: string;
    // format: date-time
    lastTick: string;
}

export interface IxmTriggerV1TriggerEvent extends IxmTriggerV1TriggerKeys {
    metadata: J5StateV1EventMetadata;
    event: IxmTriggerV1TriggerEventType;
}

export type IxmTriggerV1TriggerEventType = {
    '!type'?: 'upserted';
    upserted: IxmTriggerV1TriggerEventTypeUpserted;
} | {
    '!type'?: 'paused';
    paused: EmptyObject;
} | {
    '!type'?: 'activated';
    activated: EmptyObject;
} | {
    '!type'?: 'manuallyTriggered';
    manuallyTriggered: IxmTriggerV1TriggerEventTypeManuallyTriggered;
} | {
    '!type'?: 'triggered';
    triggered: IxmTriggerV1TriggerEventTypeTriggered;
} | {
    '!type'?: 'archived';
    archived: EmptyObject;
};

export interface IxmTriggerV1TriggerEventTypeManuallyTriggered {
    /* The time the trigger is for */
    // format: date-time
    tickTime: string;
}

export interface IxmTriggerV1TriggerEventTypeTriggered {
    /* The time the trigger is for */
    // format: date-time
    tickTime: string;
}

export interface IxmTriggerV1TriggerEventTypeUpserted {
    triggerName: string;
    appName: string;
    cron: string;
    payload: IxmTriggerV1Payload;
    target: string;
}

export const IXM_TRIGGER_V1_TRIGGER_EVENT_TYPE_ONE_OF_VALUES = ['upserted', 'paused', 'activated', 'manuallyTriggered', 'triggered', 'archived'] as const;

export type IxmTriggerV1TriggerEventTypeOneOfValue = (typeof IXM_TRIGGER_V1_TRIGGER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxmTriggerV1TriggerKeys {
    // format: id62
    triggerId: string;
}

export interface IxmTriggerV1TriggerQueryServiceTriggerEventsTriggerEventsRequest {
    // format: id62
    triggerId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmTriggerV1TriggerQueryServiceTriggerEventsSortableFields, IxmTriggerV1TriggerQueryServiceTriggerEventsFilterableFields>;
}

export enum IxmTriggerV1TriggerQueryServiceTriggerEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    TriggerId = 'triggerId',
    EventType = 'event.!type'
}

export enum IxmTriggerV1TriggerQueryServiceTriggerEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxmTriggerV1TriggerQueryServiceTriggerGetTriggerGetRequest {
    // format: id62
    triggerId: string;
}

export interface IxmTriggerV1TriggerQueryServiceTriggerListTriggerListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmTriggerV1TriggerQueryServiceTriggerListSortableFields, IxmTriggerV1TriggerQueryServiceTriggerListFilterableFields>;
}

export enum IxmTriggerV1TriggerQueryServiceTriggerListFilterableFields {
    TriggerId = 'triggerId',
    Status = 'status'
}

export enum IxmTriggerV1TriggerQueryServiceTriggerListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxmTriggerV1TriggerState extends IxmTriggerV1TriggerKeys {
    metadata: J5StateV1StateMetadata;
    data: IxmTriggerV1TriggerData;
    status: IxmTriggerV1TriggerStatus;
}

export enum IxmTriggerV1TriggerStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Paused = 'PAUSED',
    Archived = 'ARCHIVED'
}

export interface IxmUserauthV1AccessRequestData {
    spec: IxmUserauthV1AccessRequestSpec;
    entities?: IxmUserauthV1AccessRequestEntities;
}

export interface IxmUserauthV1AccessRequestEntities {
    // format: id62, entity: ixm.userauth.v1.OrganizationMemberInvitation
    organizationMemberInvitationId: string;
    // format: id62, entity: ixm.userauth.v1.Organization
    organizationId: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
    // format: id62, entity: ixm.realm.v1.Realm
    realmId: string;
    // format: id62, entity: ixm.userauth.v1.RealmAccess
    realmAccessId: string;
}

export interface IxmUserauthV1AccessRequestEvent extends IxmUserauthV1AccessRequestKeys {
    metadata: J5StateV1EventMetadata;
    event: IxmUserauthV1AccessRequestEventType;
}

export type IxmUserauthV1AccessRequestEventType = {
    '!type'?: 'created';
    created: IxmUserauthV1AccessRequestEventTypeCreated;
} | {
    '!type'?: 'rejected';
    rejected: IxmUserauthV1AccessRequestEventTypeRejected;
} | {
    '!type'?: 'approved';
    approved: IxmUserauthV1AccessRequestEventTypeApproved;
} | {
    '!type'?: 'updated';
    updated: IxmUserauthV1AccessRequestEventTypeUpdated;
};

export interface IxmUserauthV1AccessRequestEventTypeApproved {
    spec: IxmUserauthV1ApproveAccessRequestSpec;
    callbackUrl: string;
}

export interface IxmUserauthV1AccessRequestEventTypeCreated {
    spec: IxmUserauthV1AccessRequestSpec;
}

export interface IxmUserauthV1AccessRequestEventTypeRejected {
    reason?: string;
}

export interface IxmUserauthV1AccessRequestEventTypeUpdated {
    /* The type of resource that was created (e.g., appuser, organization, program, realm_access) */
    resourceType: string;
    /* The ID of the created resource */
    resourceId: string;
}

export const IXM_USERAUTH_V1_ACCESS_REQUEST_EVENT_TYPE_ONE_OF_VALUES = ['created', 'rejected', 'approved', 'updated'] as const;

export type IxmUserauthV1AccessRequestEventTypeOneOfValue = (typeof IXM_USERAUTH_V1_ACCESS_REQUEST_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxmUserauthV1AccessRequestKeys {
    // format: id62
    accessRequestId: string;
}

export interface IxmUserauthV1AccessRequestQueryServiceAccessRequestEventsAccessRequestEventsRequest {
    // format: id62
    accessRequestId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxmUserauthV1AccessRequestQueryServiceAccessRequestEventsSearchableFields, IxmUserauthV1AccessRequestQueryServiceAccessRequestEventsSortableFields, IxmUserauthV1AccessRequestQueryServiceAccessRequestEventsFilterableFields>;
}

export enum IxmUserauthV1AccessRequestQueryServiceAccessRequestEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    AccessRequestId = 'accessRequestId',
    EventApprovedSpecProgramProgramCode = 'event.approved.spec.program.programCode',
    EventType = 'event.!type'
}

export enum IxmUserauthV1AccessRequestQueryServiceAccessRequestEventsSearchableFields {
    EventApprovedSpecProgramSpecDetailsName = 'event.approved.spec.program.spec.details.name',
    EventApprovedSpecInvitationProfileFirstName = 'event.approved.spec.invitation.profile.firstName',
    EventApprovedSpecInvitationProfileLastName = 'event.approved.spec.invitation.profile.lastName'
}

export enum IxmUserauthV1AccessRequestQueryServiceAccessRequestEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxmUserauthV1AccessRequestQueryServiceAccessRequestGetAccessRequestGetRequest {
    // format: id62
    accessRequestId: string;
}

export interface IxmUserauthV1AccessRequestQueryServiceAccessRequestListAccessRequestListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmUserauthV1AccessRequestQueryServiceAccessRequestListSortableFields, IxmUserauthV1AccessRequestQueryServiceAccessRequestListFilterableFields>;
}

export enum IxmUserauthV1AccessRequestQueryServiceAccessRequestListFilterableFields {
    AccessRequestId = 'accessRequestId',
    Status = 'status'
}

export enum IxmUserauthV1AccessRequestQueryServiceAccessRequestListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxmUserauthV1AccessRequestSpec {
    firstName: string;
    lastName: string;
    jobTitle: string;
    companyName: string;
    email: string;
    phone?: string;
}

export interface IxmUserauthV1AccessRequestState extends IxmUserauthV1AccessRequestKeys {
    metadata: J5StateV1StateMetadata;
    data: IxmUserauthV1AccessRequestData;
    status: IxmUserauthV1AccessRequestStatus;
}

export enum IxmUserauthV1AccessRequestStatus {
    Unspecified = 'UNSPECIFIED',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
    Approved = 'APPROVED'
}

export interface IxmUserauthV1ApproveAccessRequestSpec {
    organization?: IxmUserauthV1ApproveAccessRequestSpecOrganization;
    program?: IxmUserauthV1ApproveAccessRequestSpecProgram;
    invitation?: IxmUserauthV1ApproveAccessRequestSpecInvitation;
}

export interface IxmUserauthV1ApproveAccessRequestSpecInvitation {
    /* When set, an invitation will be sent to the specified email address,
    otherwise the response will contain a link to accept the invitation
    The invitation will be valid for AcceptInvitation here, and
    RegisterRequest in the session service, when the system is configured
    for invite-only. The email address which the user actually uses to
    register may be different. */
    email?: string;
    /* When set, will populate email template (if email is provided) and
    pre-fill the fields in the portal's registration form */
    profile?: IxmUserauthV1UserProfile;
    /* The number of days before the invitation expires, and will default to
    30 days if not set */
    // format: INT32
    expiresInDays?: number;
}

export interface IxmUserauthV1ApproveAccessRequestSpecOrganization {
    // format: id62
    organizationId?: string;
    profile: IxmUserauthV1OrganizationProfile;
}

export interface IxmUserauthV1ApproveAccessRequestSpecProgram {
    realmId: string;
    // format: custom - pattern: ^[A-Z]{4}$
    programCode: string;
    spec: IxmUserauthV1ProgramSpec;
}

export interface IxmUserauthV1ArtifactData {
    spec: IxmUserauthV1ArtifactSpec;
}

export interface IxmUserauthV1ArtifactDownloadServiceDownloadBrandingArtifactDownloadBrandingArtifactRequest {
    // format: id62
    programId: string;
    artifactKey: IxmUserauthV1DownloadBrandingArtifactRequestBrandingArtifactKey;
}

export interface IxmUserauthV1ArtifactDownloadServiceRawRawRequest {
    // format: id62
    artifactId: string;
}

export interface IxmUserauthV1ArtifactEvent extends IxmUserauthV1ArtifactKeys {
    metadata: J5StateV1EventMetadata;
    event: IxmUserauthV1ArtifactEventType;
}

export type IxmUserauthV1ArtifactEventType = {
    '!type'?: 'created';
    created: IxmUserauthV1ArtifactEventTypeCreated;
} | {
    '!type'?: 'archived';
    archived: EmptyObject;
};

export interface IxmUserauthV1ArtifactEventTypeCreated {
    spec: IxmUserauthV1ArtifactSpec;
}

export const IXM_USERAUTH_V1_ARTIFACT_EVENT_TYPE_ONE_OF_VALUES = ['created', 'archived'] as const;

export type IxmUserauthV1ArtifactEventTypeOneOfValue = (typeof IXM_USERAUTH_V1_ARTIFACT_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxmUserauthV1ArtifactKeys {
    // format: id62
    artifactId: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
}

export interface IxmUserauthV1ArtifactQueryServiceArtifactEventsArtifactEventsRequest {
    // format: id62
    artifactId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmUserauthV1ArtifactQueryServiceArtifactEventsSortableFields, IxmUserauthV1ArtifactQueryServiceArtifactEventsFilterableFields>;
}

export enum IxmUserauthV1ArtifactQueryServiceArtifactEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    ArtifactId = 'artifactId',
    ProgramId = 'programId',
    EventCreatedSpecType = 'event.created.spec.type',
    EventType = 'event.!type'
}

export enum IxmUserauthV1ArtifactQueryServiceArtifactEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxmUserauthV1ArtifactQueryServiceArtifactGetArtifactGetRequest {
    // format: id62
    artifactId: string;
}

export interface IxmUserauthV1ArtifactQueryServiceArtifactListArtifactListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmUserauthV1ArtifactQueryServiceArtifactListSortableFields, IxmUserauthV1ArtifactQueryServiceArtifactListFilterableFields>;
}

export enum IxmUserauthV1ArtifactQueryServiceArtifactListFilterableFields {
    ArtifactId = 'artifactId',
    ProgramId = 'programId',
    DataSpecType = 'data.spec.type',
    Status = 'status'
}

export enum IxmUserauthV1ArtifactQueryServiceArtifactListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxmUserauthV1ArtifactSpec {
    type: IxmUserauthV1ArtifactType;
    storageBucket: string;
    storageKey: string;
    /* An optional name for the artifact */
    name?: string;
    /* An optional description for the artifact */
    description?: string;
}

export interface IxmUserauthV1ArtifactState extends IxmUserauthV1ArtifactKeys {
    metadata: J5StateV1StateMetadata;
    data: IxmUserauthV1ArtifactData;
    status: IxmUserauthV1ArtifactStatus;
}

export enum IxmUserauthV1ArtifactStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Archived = 'ARCHIVED'
}

export enum IxmUserauthV1ArtifactType {
    Unspecified = 'UNSPECIFIED',
    Other = 'OTHER',
    Logo = 'LOGO',
    Logomark = 'LOGOMARK',
    Font = 'FONT'
}

export enum IxmUserauthV1BankAccountValidation {
    Unspecified = 'UNSPECIFIED',
    Akoya = 'AKOYA',
    Finicity = 'FINICITY',
    Mx = 'MX',
    Plaid = 'PLAID',
    Yodlee = 'YODLEE',
    Fiserv = 'FISERV',
    EwsGiact = 'EWS_GIACT'
}

export interface IxmUserauthV1BrandingSpec {
    /* The artifact ID of the logo */
    // format: id62, entity: ixm.userauth.v1.Artifact
    logoArtifactId?: string;
    /* The artifact ID of the logomark */
    // format: id62, entity: ixm.userauth.v1.Artifact
    logoMarkArtifactId?: string;
    mainFont?: IxmUserauthV1FontType;
    monoFont?: IxmUserauthV1FontType;
    colors?: IxmUserauthV1Colors;
}

export interface IxmUserauthV1BrandingVersion {
    // format: id62
    brandingVersionId: string;
    // format: date-time
    createdAt: string;
    branding: IxmUserauthV1BrandingSpec;
}

export enum IxmUserauthV1BrandingVersionCheckOutcome {
    Unspecified = 'UNSPECIFIED',
    Passed = 'PASSED',
    Failed = 'FAILED',
    Inconclusive = 'INCONCLUSIVE'
}

export interface IxmUserauthV1BrandingVersionCheckResult {
    // format: date-time
    timestamp: string;
    outcome: IxmUserauthV1BrandingVersionCheckOutcome;
}

export interface IxmUserauthV1BrandingVersionCheckStatus {
    // format: uuid
    checkId?: string;
    checkType: string;
    result?: IxmUserauthV1BrandingVersionCheckResult;
}

export interface IxmUserauthV1BrandingVersionData {
    branding: IxmUserauthV1BrandingSpec;
    checks?: IxmUserauthV1BrandingVersionCheckStatus[];
}

export interface IxmUserauthV1BrandingVersionEvent extends IxmUserauthV1BrandingVersionKeys {
    metadata: J5StateV1EventMetadata;
    event: IxmUserauthV1BrandingVersionEventType;
}

export type IxmUserauthV1BrandingVersionEventType = {
    '!type'?: 'created';
    created: IxmUserauthV1BrandingVersionEventTypeCreated;
} | {
    '!type'?: 'submitted';
    submitted: IxmUserauthV1BrandingVersionEventTypeSubmitted;
} | {
    '!type'?: 'checkResult';
    checkResult: IxmUserauthV1BrandingVersionEventTypeCheckResult;
} | {
    '!type'?: 'rejected';
    rejected: IxmUserauthV1BrandingVersionEventTypeRejected;
} | {
    '!type'?: 'checksPassed';
    checksPassed: EmptyObject;
} | {
    '!type'?: 'canceled';
    canceled: IxmUserauthV1BrandingVersionEventTypeCanceled;
};

export interface IxmUserauthV1BrandingVersionEventTypeCanceled {
    reason?: string;
    // format: id62
    replacedBy?: string;
}

export interface IxmUserauthV1BrandingVersionEventTypeCheckResult {
    checkType: string;
    outcome: IxmUserauthV1BrandingVersionCheckOutcome;
}

export interface IxmUserauthV1BrandingVersionEventTypeCreated {
    branding: IxmUserauthV1BrandingSpec;
}

export interface IxmUserauthV1BrandingVersionEventTypeRejected {
    reason?: string;
}

export interface IxmUserauthV1BrandingVersionEventTypeSubmitted {
    requiredChecks?: string[];
}

export const IXM_USERAUTH_V1_BRANDING_VERSION_EVENT_TYPE_ONE_OF_VALUES = ['created', 'submitted', 'checkResult', 'rejected', 'checksPassed', 'canceled'] as const;

export type IxmUserauthV1BrandingVersionEventTypeOneOfValue = (typeof IXM_USERAUTH_V1_BRANDING_VERSION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxmUserauthV1BrandingVersionKeys {
    // format: id62
    brandingVersionId: string;
    // format: id62, entity: ixm.userauth.v1.Program
    programId: string;
}

export interface IxmUserauthV1BrandingVersionQueryServiceBrandingVersionEventsBrandingVersionEventsRequest {
    // format: id62
    brandingVersionId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmUserauthV1BrandingVersionQueryServiceBrandingVersionEventsSortableFields, IxmUserauthV1BrandingVersionQueryServiceBrandingVersionEventsFilterableFields>;
}

export enum IxmUserauthV1BrandingVersionQueryServiceBrandingVersionEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    BrandingVersionId = 'brandingVersionId',
    ProgramId = 'programId',
    EventType = 'event.!type'
}

export enum IxmUserauthV1BrandingVersionQueryServiceBrandingVersionEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxmUserauthV1BrandingVersionQueryServiceBrandingVersionGetBrandingVersionGetRequest {
    // format: id62
    brandingVersionId: string;
}

export interface IxmUserauthV1BrandingVersionQueryServiceBrandingVersionListBrandingVersionListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmUserauthV1BrandingVersionQueryServiceBrandingVersionListSortableFields, IxmUserauthV1BrandingVersionQueryServiceBrandingVersionListFilterableFields>;
}

export enum IxmUserauthV1BrandingVersionQueryServiceBrandingVersionListFilterableFields {
    BrandingVersionId = 'brandingVersionId',
    ProgramId = 'programId',
    Status = 'status'
}

export enum IxmUserauthV1BrandingVersionQueryServiceBrandingVersionListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxmUserauthV1BrandingVersionState extends IxmUserauthV1BrandingVersionKeys {
    metadata: J5StateV1StateMetadata;
    data: IxmUserauthV1BrandingVersionData;
    status: IxmUserauthV1BrandingVersionStatus;
}

export enum IxmUserauthV1BrandingVersionStatus {
    Unspecified = 'UNSPECIFIED',
    Draft = 'DRAFT',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
    Canceled = 'CANCELED',
    Approved = 'APPROVED'
}

export interface IxmUserauthV1ClearingDetails {
    /* Max 16 character name for banking transfers */
    shortName: string;
    // pattern: ^[A-Z]{4}$
    mpid?: string;
    taxVendorId: string;
    proxyVendorId: string;
}

export interface IxmUserauthV1Color {
    standardColor: IxmUserauthV1SrgbColor;
    /* Optional wide-gamut color to take precedence over standard colors if possible. */
    wideGamutColor?: IxmUserauthV1WideGamutColor;
}

export interface IxmUserauthV1Colors {
    /* The primary background color */
    background: IxmUserauthV1Color;
    /* The color of separators (borders, lines, etc.) */
    separator: IxmUserauthV1Color;
    /* The color of light text */
    textLight: IxmUserauthV1Color;
    /* The main body text color */
    textMedium: IxmUserauthV1Color;
    /* The color of text on buttons */
    textButton: IxmUserauthV1Color;
    neutralExtraLight: IxmUserauthV1Color;
    neutralLight: IxmUserauthV1Color;
    neutralMedium: IxmUserauthV1Color;
    neutralDark: IxmUserauthV1Color;
    primaryLight: IxmUserauthV1Color;
    /* The primary color of the brand, used for accents and highlights */
    primaryMedium: IxmUserauthV1Color;
    primaryDark: IxmUserauthV1Color;
    secondaryLight: IxmUserauthV1Color;
    secondaryMedium: IxmUserauthV1Color;
    secondaryDark: IxmUserauthV1Color;
    tertiaryLight: IxmUserauthV1Color;
    tertiaryMedium: IxmUserauthV1Color;
    tertiaryDark: IxmUserauthV1Color;
    quaternaryLight: IxmUserauthV1Color;
    quaternaryMedium: IxmUserauthV1Color;
    quaternaryDark: IxmUserauthV1Color;
    successLight: IxmUserauthV1Color;
    successMedium: IxmUserauthV1Color;
    successDark: IxmUserauthV1Color;
    greenLight: IxmUserauthV1Color;
    greenMedium: IxmUserauthV1Color;
    greenDark: IxmUserauthV1Color;
    dangerLight: IxmUserauthV1Color;
    dangerMedium: IxmUserauthV1Color;
    dangerDark: IxmUserauthV1Color;
}

export interface IxmUserauthV1ContactDetails {
    name: string;
    title: string;
    phone: string;
    email: string;
}

export interface IxmUserauthV1CustomerSupportContacts {
    /* The company’s name displayed on all customer-facing documents. */
    displayName: string;
    /* At least one contact method (website, email, or phone) must be provided for display on statements and trade confirmations. */
    website?: string;
    /* At least one contact method (website, email, or phone) must be provided for display on statements and trade confirmations. */
    emailAddress?: string;
    /* At least one contact method (website, email, or phone) must be provided for display on statements and trade confirmations. */
    phone?: string;
    /* Phone number displayed on all tax forms per IRS rules. */
    phoneTaxDocuments: string;
    mailingAddress: IxcRegistrationV1Address;
}

export type IxmUserauthV1FontType = {
    '!type'?: 'googleFont';
    googleFont: IxmUserauthV1GoogleFont;
} | {
    '!type'?: 'customFont';
    customFont: IxmUserauthV1FontTypeCustomFont;
};

export interface IxmUserauthV1FontTypeCustomFont {
    /* The artifact ID of the font */
    // format: id62, entity: ixm.userauth.v1.Artifact
    artifactId: string;
    family: string;
    weights: IxmUserauthV1FontWeight;
}

export const IXM_USERAUTH_V1_FONT_TYPE_ONE_OF_VALUES = ['googleFont', 'customFont'] as const;

export type IxmUserauthV1FontTypeOneOfValue = (typeof IXM_USERAUTH_V1_FONT_TYPE_ONE_OF_VALUES)[number];

export interface IxmUserauthV1FontWeight {
    // format: UINT32
    regular: number;
    // format: UINT32
    medium: number;
    // format: UINT32
    bold: number;
}

export interface IxmUserauthV1GoogleFont {
    /* The name of the font on Google Web Fonts (e.g., Roboto, Inter) */
    family: string;
    /* The axes of the font to enable (e.g., ital, opsz, slnt, wdth) */
    axes?: IxmUserauthV1GoogleFontAxes;
    /* The weights of the font to enable */
    weights?: IxmUserauthV1FontWeight;
}

export interface IxmUserauthV1GoogleFontAxes {
    /* Whether to enable the italic axis of the font, */
    ital?: boolean;
    /* The optical size of the font (steps of 0.1 are allowed) */
    // format: decimal
    opsz?: string;
    /* The slant of the font (steps of 1 are allowed) */
    // format: INT64
    slnt?: string;
    /* The width of the font (steps of 0.1 are allowed) */
    // format: decimal
    wdth?: string;
}

export interface IxmUserauthV1InvitationServiceCheckOrganizationMemberInvitationCheckOrganizationMemberInvitationRequest {
    token: IxmUserauthV1Token;
}

export interface IxmUserauthV1JoinedOrganizationMember {
    organizationMember?: IxmUserauthV1OrganizationMemberState;
    organization?: IxmUserauthV1OrganizationState;
}

export interface IxmUserauthV1JoinedRealmAccess {
    realm?: IxmUserauthV1RealmState;
    tenant?: IxmUserauthV1TenantState;
    access?: IxmUserauthV1RealmAccessState;
    /* The member's assigned role for this realm access, when one is set. Access
    tokens carry this role's scopes; members without an assignment receive a
    token with no scopes. */
    role?: IxmUserauthV1RoleState;
    /* The program's code when the tenant is a program; unset for every other
    tenant type. */
    // format: custom - pattern: ^[A-Z]{4}$
    programCode?: string;
}

export type IxmUserauthV1JoinOrganizationMethod = {
    '!type'?: 'createdOrganization';
    createdOrganization: EmptyObject;
} | {
    '!type'?: 'invitation';
    invitation: IxmUserauthV1JoinOrganizationMethodInvitation;
};

export interface IxmUserauthV1JoinOrganizationMethodInvitation {
    // format: id62
    invitationId: string;
    invitingActor: J5AuthV1Actor;
}

export const IXM_USERAUTH_V1_JOIN_ORGANIZATION_METHOD_ONE_OF_VALUES = ['createdOrganization', 'invitation'] as const;

export type IxmUserauthV1JoinOrganizationMethodOneOfValue = (typeof IXM_USERAUTH_V1_JOIN_ORGANIZATION_METHOD_ONE_OF_VALUES)[number];

export interface IxmUserauthV1OrganizationControls {
    settings: IxmUserauthV1OrganizationControlsSettings;
}

export interface IxmUserauthV1OrganizationControlsSettings {
    requireMfa?: boolean;
}

export interface IxmUserauthV1OrganizationData {
    profile: IxmUserauthV1OrganizationProfile;
    controls: IxmUserauthV1OrganizationControls;
}

export interface IxmUserauthV1OrganizationEvent extends IxmUserauthV1OrganizationKeys {
    metadata: J5StateV1EventMetadata;
    event: IxmUserauthV1OrganizationEventType;
}

export type IxmUserauthV1OrganizationEventType = {
    '!type'?: 'created';
    created: IxmUserauthV1OrganizationEventTypeCreated;
} | {
    '!type'?: 'updated';
    updated: IxmUserauthV1OrganizationEventTypeUpdated;
};

export interface IxmUserauthV1OrganizationEventTypeCreated {
    profile: IxmUserauthV1OrganizationProfile;
    controls: IxmUserauthV1OrganizationControls;
    initialUsers?: IxmUserauthV1OrganizationEventTypeCreatedInitialUsers[];
}

export interface IxmUserauthV1OrganizationEventTypeCreatedInitialUsers {
    userId: string;
    user: IxmUserauthV1UserSummary;
    permissions: IxmUserauthV1OrganizationMemberPermissions;
}

export interface IxmUserauthV1OrganizationEventTypeUpdated {
    update: IxmUserauthV1OrganizationUpdate;
}

export const IXM_USERAUTH_V1_ORGANIZATION_EVENT_TYPE_ONE_OF_VALUES = ['created', 'updated'] as const;

export type IxmUserauthV1OrganizationEventTypeOneOfValue = (typeof IXM_USERAUTH_V1_ORGANIZATION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxmUserauthV1OrganizationKeys {
    // format: id62
    organizationId: string;
}

export interface IxmUserauthV1OrganizationMemberData {
    permissions?: IxmUserauthV1OrganizationMemberPermissions;
    designations?: IxmUserauthV1OrganizationMemberDesignations;
    user: IxmUserauthV1UserSummary;
    organization: IxmUserauthV1OrganizationSummary;
    // format: date-time
    lastSignInAt?: string;
}

export interface IxmUserauthV1OrganizationMemberDesignations {
    isFinraPrincipal?: boolean;
}

export interface IxmUserauthV1OrganizationMemberEvent extends IxmUserauthV1OrganizationMemberKeys {
    metadata: J5StateV1EventMetadata;
    event: IxmUserauthV1OrganizationMemberEventType;
}

export type IxmUserauthV1OrganizationMemberEventType = {
    '!type'?: 'joined';
    joined: IxmUserauthV1OrganizationMemberEventTypeJoined;
} | {
    '!type'?: 'permissionsModified';
    permissionsModified: IxmUserauthV1OrganizationMemberEventTypePermissionsModified;
} | {
    '!type'?: 'setDesignations';
    setDesignations: IxmUserauthV1OrganizationMemberEventTypeSetDesignations;
} | {
    '!type'?: 'userUpdated';
    userUpdated: IxmUserauthV1OrganizationMemberEventTypeUserUpdated;
} | {
    '!type'?: 'organizationUpdated';
    organizationUpdated: IxmUserauthV1OrganizationMemberEventTypeOrganizationUpdated;
} | {
    '!type'?: 'removed';
    removed: EmptyObject;
} | {
    '!type'?: 'sessionInitiated';
    sessionInitiated: IxmUserauthV1OrganizationMemberEventTypeSessionInitiated;
} | {
    '!type'?: 'sessionTerminated';
    sessionTerminated: IxmUserauthV1OrganizationMemberEventTypeSessionTerminated;
};

export interface IxmUserauthV1OrganizationMemberEventTypeJoined {
    permissions?: IxmUserauthV1OrganizationMemberPermissions;
    method: IxmUserauthV1JoinOrganizationMethod;
    user: IxmUserauthV1UserSummary;
    organization: IxmUserauthV1OrganizationSummary;
}

export interface IxmUserauthV1OrganizationMemberEventTypeOrganizationUpdated {
    organization: IxmUserauthV1OrganizationSummary;
}

export interface IxmUserauthV1OrganizationMemberEventTypePermissionsModified {
    permissions?: IxmUserauthV1OrganizationMemberPermissions;
}

export interface IxmUserauthV1OrganizationMemberEventTypeSessionInitiated {
    // format: id62, entity: ixm.userauth.v1.Session
    sessionId: string;
}

export interface IxmUserauthV1OrganizationMemberEventTypeSessionTerminated {
    // format: id62, entity: ixm.userauth.v1.Session
    sessionId: string;
}

export interface IxmUserauthV1OrganizationMemberEventTypeSetDesignations {
    // format: id62
    programIds?: string[];
    designations?: IxmUserauthV1OrganizationMemberDesignations;
}

export interface IxmUserauthV1OrganizationMemberEventTypeUserUpdated {
    user: IxmUserauthV1UserSummary;
}

export const IXM_USERAUTH_V1_ORGANIZATION_MEMBER_EVENT_TYPE_ONE_OF_VALUES = ['joined', 'permissionsModified', 'setDesignations', 'userUpdated', 'organizationUpdated', 'removed', 'sessionInitiated', 'sessionTerminated'] as const;

export type IxmUserauthV1OrganizationMemberEventTypeOneOfValue = (typeof IXM_USERAUTH_V1_ORGANIZATION_MEMBER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxmUserauthV1OrganizationMemberInvitationData {
    // format: date-time
    expiresAt?: string;
    permissions?: IxmUserauthV1OrganizationMemberPermissions;
    profile?: IxmUserauthV1UserProfile;
    email?: IxmEmailV1Recipient;
    invitingActor?: J5AuthV1Actor;
    organization: IxmUserauthV1OrganizationSummary;
}

export interface IxmUserauthV1OrganizationMemberInvitationEvent extends IxmUserauthV1OrganizationMemberInvitationKeys {
    metadata: J5StateV1EventMetadata;
    event: IxmUserauthV1OrganizationMemberInvitationEventType;
}

export type IxmUserauthV1OrganizationMemberInvitationEventType = {
    '!type'?: 'created';
    created: IxmUserauthV1OrganizationMemberInvitationEventTypeCreated;
} | {
    '!type'?: 'accepted';
    accepted: IxmUserauthV1OrganizationMemberInvitationEventTypeAccepted;
} | {
    '!type'?: 'revoked';
    revoked: EmptyObject;
} | {
    '!type'?: 'declined';
    declined: EmptyObject;
} | {
    '!type'?: 'organizationUpdated';
    organizationUpdated: IxmUserauthV1OrganizationMemberInvitationEventTypeOrganizationUpdated;
};

export interface IxmUserauthV1OrganizationMemberInvitationEventTypeAccepted {
    // format: id62
    userId?: string;
    user: IxmUserauthV1UserSummary;
}

export interface IxmUserauthV1OrganizationMemberInvitationEventTypeCreated {
    permissions: IxmUserauthV1OrganizationMemberPermissions;
    profile?: IxmUserauthV1UserProfile;
    invitingActor: J5AuthV1Actor;
    organization: IxmUserauthV1OrganizationSummary;
    // format: date-time
    expiresAt: string;
    /* An email address to send the secret to */
    email: IxmEmailV1Recipient;
    /* The URL of the portal page which will decode the query-string and
    send the accept or decline command. e.g.
    https://foo.com/accept-invitation. The worker will add the required
    query parameters, this identifies the page. */
    callbackUrl?: string;
}

export interface IxmUserauthV1OrganizationMemberInvitationEventTypeOrganizationUpdated {
    organization: IxmUserauthV1OrganizationSummary;
}

export const IXM_USERAUTH_V1_ORGANIZATION_MEMBER_INVITATION_EVENT_TYPE_ONE_OF_VALUES = ['created', 'accepted', 'revoked', 'declined', 'organizationUpdated'] as const;

export type IxmUserauthV1OrganizationMemberInvitationEventTypeOneOfValue = (typeof IXM_USERAUTH_V1_ORGANIZATION_MEMBER_INVITATION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxmUserauthV1OrganizationMemberInvitationKeys {
    // format: id62
    invitationId: string;
    // format: id62, entity: ixm.userauth.v1.Organization
    organizationId?: string;
}

export interface IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationEventsOrganizationMemberInvitationEventsRequest {
    // format: id62
    invitationId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationEventsSearchableFields, IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationEventsSortableFields, IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationEventsFilterableFields>;
}

export enum IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    InvitationId = 'invitationId',
    OrganizationId = 'organizationId',
    EventAcceptedUserKeysUserId = 'event.accepted.user.keys.userId',
    EventAcceptedUserAdditionalMfaEnabled = 'event.accepted.user.additional.mfaEnabled',
    EventType = 'event.!type'
}

export enum IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationEventsSearchableFields {
    EventCreatedProfileFirstName = 'event.created.profile.firstName',
    EventCreatedProfileLastName = 'event.created.profile.lastName',
    EventAcceptedUserKeysEmail = 'event.accepted.user.keys.email',
    EventAcceptedUserProfileFirstName = 'event.accepted.user.profile.firstName',
    EventAcceptedUserProfileLastName = 'event.accepted.user.profile.lastName'
}

export enum IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationGetOrganizationMemberInvitationGetRequest {
    // format: id62
    invitationId: string;
}

export interface IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationListOrganizationMemberInvitationListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationListSearchableFields, IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationListSortableFields, IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationListFilterableFields>;
}

export enum IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationListFilterableFields {
    InvitationId = 'invitationId',
    OrganizationId = 'organizationId',
    DataExpiresAt = 'data.expiresAt',
    Status = 'status'
}

export enum IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationListSearchableFields {
    DataProfileFirstName = 'data.profile.firstName',
    DataProfileLastName = 'data.profile.lastName'
}

export enum IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataExpiresAt = 'data.expiresAt'
}

export interface IxmUserauthV1OrganizationMemberInvitationState extends IxmUserauthV1OrganizationMemberInvitationKeys {
    metadata: J5StateV1StateMetadata;
    data: IxmUserauthV1OrganizationMemberInvitationData;
    status: IxmUserauthV1OrganizationMemberInvitationStatus;
}

export enum IxmUserauthV1OrganizationMemberInvitationStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Accepted = 'ACCEPTED',
    Revoked = 'REVOKED',
    Declined = 'DECLINED'
}

export interface IxmUserauthV1OrganizationMemberKeys {
    // format: id62
    userId: string;
    // format: id62, entity: ixm.userauth.v1.Organization
    organizationId: string;
}

export interface IxmUserauthV1OrganizationMemberPermissions {
    isAdmin?: boolean;
    /* Role assignments for specific realm accesses. Access tokens issued for a
    realm access listed here carry the scopes of the listed role. Members
    with no entry for a realm access receive a token with no scopes. */
    realmRoles?: IxmUserauthV1RealmAccessRole[];
}

export interface IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberEventsOrganizationMemberEventsRequest {
    // format: id62
    userId: string;
    // format: id62, entity: ixm.userauth.v1.Organization
    organizationId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberEventsSearchableFields, IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberEventsSortableFields, IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberEventsFilterableFields>;
}

export enum IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    UserId = 'userId',
    OrganizationId = 'organizationId',
    EventJoinedUserKeysUserId = 'event.joined.user.keys.userId',
    EventJoinedUserAdditionalMfaEnabled = 'event.joined.user.additional.mfaEnabled',
    EventUserUpdatedUserKeysUserId = 'event.userUpdated.user.keys.userId',
    EventUserUpdatedUserAdditionalMfaEnabled = 'event.userUpdated.user.additional.mfaEnabled',
    EventType = 'event.!type'
}

export enum IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberEventsSearchableFields {
    EventJoinedUserKeysEmail = 'event.joined.user.keys.email',
    EventJoinedUserProfileFirstName = 'event.joined.user.profile.firstName',
    EventJoinedUserProfileLastName = 'event.joined.user.profile.lastName',
    EventUserUpdatedUserKeysEmail = 'event.userUpdated.user.keys.email',
    EventUserUpdatedUserProfileFirstName = 'event.userUpdated.user.profile.firstName',
    EventUserUpdatedUserProfileLastName = 'event.userUpdated.user.profile.lastName'
}

export enum IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberGetOrganizationMemberGetRequest {
    // format: id62
    userId: string;
    // format: id62, entity: ixm.userauth.v1.Organization
    organizationId: string;
}

export interface IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberListOrganizationMemberListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberListSearchableFields, IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberListSortableFields, IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberListFilterableFields>;
}

export enum IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberListFilterableFields {
    UserId = 'userId',
    OrganizationId = 'organizationId',
    DataUserKeysUserId = 'data.user.keys.userId',
    DataUserAdditionalMfaEnabled = 'data.user.additional.mfaEnabled',
    DataLastSignInAt = 'data.lastSignInAt',
    Status = 'status'
}

export enum IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberListSearchableFields {
    DataUserKeysEmail = 'data.user.keys.email',
    DataUserProfileFirstName = 'data.user.profile.firstName',
    DataUserProfileLastName = 'data.user.profile.lastName'
}

export enum IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataLastSignInAt = 'data.lastSignInAt'
}

export interface IxmUserauthV1OrganizationMemberState extends IxmUserauthV1OrganizationMemberKeys {
    metadata: J5StateV1StateMetadata;
    data: IxmUserauthV1OrganizationMemberData;
    status: IxmUserauthV1OrganizationMemberStatus;
}

export enum IxmUserauthV1OrganizationMemberStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Deleted = 'DELETED'
}

export interface IxmUserauthV1OrganizationProfile {
    name: string;
}

export interface IxmUserauthV1OrganizationQueryServiceOrganizationEventsOrganizationEventsRequest {
    // format: id62
    organizationId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxmUserauthV1OrganizationQueryServiceOrganizationEventsSearchableFields, IxmUserauthV1OrganizationQueryServiceOrganizationEventsSortableFields, IxmUserauthV1OrganizationQueryServiceOrganizationEventsFilterableFields>;
}

export enum IxmUserauthV1OrganizationQueryServiceOrganizationEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    OrganizationId = 'organizationId',
    EventCreatedInitialUsersUserKeysUserId = 'event.created.initialUsers.user.keys.userId',
    EventCreatedInitialUsersUserAdditionalMfaEnabled = 'event.created.initialUsers.user.additional.mfaEnabled',
    EventType = 'event.!type'
}

export enum IxmUserauthV1OrganizationQueryServiceOrganizationEventsSearchableFields {
    EventCreatedInitialUsersUserKeysEmail = 'event.created.initialUsers.user.keys.email',
    EventCreatedInitialUsersUserProfileFirstName = 'event.created.initialUsers.user.profile.firstName',
    EventCreatedInitialUsersUserProfileLastName = 'event.created.initialUsers.user.profile.lastName'
}

export enum IxmUserauthV1OrganizationQueryServiceOrganizationEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxmUserauthV1OrganizationQueryServiceOrganizationGetOrganizationGetRequest {
    // format: id62
    organizationId: string;
}

export interface IxmUserauthV1OrganizationQueryServiceOrganizationListOrganizationListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmUserauthV1OrganizationQueryServiceOrganizationListSortableFields, IxmUserauthV1OrganizationQueryServiceOrganizationListFilterableFields>;
}

export enum IxmUserauthV1OrganizationQueryServiceOrganizationListFilterableFields {
    OrganizationId = 'organizationId',
    Status = 'status'
}

export enum IxmUserauthV1OrganizationQueryServiceOrganizationListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxmUserauthV1OrganizationState extends IxmUserauthV1OrganizationKeys {
    metadata: J5StateV1StateMetadata;
    data: IxmUserauthV1OrganizationData;
    status: IxmUserauthV1OrganizationStatus;
}

export enum IxmUserauthV1OrganizationStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE'
}

export interface IxmUserauthV1OrganizationSummary {
    name: string;
}

export type IxmUserauthV1OrganizationUpdate = {
    '!type'?: 'profile';
    profile: IxmUserauthV1OrganizationProfile;
} | {
    '!type'?: 'controls';
    controls: IxmUserauthV1OrganizationControls;
};

export const IXM_USERAUTH_V1_ORGANIZATION_UPDATE_ONE_OF_VALUES = ['profile', 'controls'] as const;

export type IxmUserauthV1OrganizationUpdateOneOfValue = (typeof IXM_USERAUTH_V1_ORGANIZATION_UPDATE_ONE_OF_VALUES)[number];

export interface IxmUserauthV1ProgramBrandingInput {
    logo?: IxmUserauthV1SetArtifact;
    logoMark?: IxmUserauthV1SetArtifact;
    colors?: IxmUserauthV1Colors;
    mainFont?: IxmUserauthV1SetFontType;
    monoFont?: IxmUserauthV1SetFontType;
}

export interface IxmUserauthV1ProgramContacts {
    executive: IxmUserauthV1ContactDetails[];
    technical: IxmUserauthV1ContactDetails[];
    billing: IxmUserauthV1ContactDetails[];
    operations: IxmUserauthV1ContactDetails[];
    compliance?: IxmUserauthV1ContactDetails[];
    disasterRecovery?: IxmUserauthV1ContactDetails[];
    aml?: IxmUserauthV1ContactDetails[];
    cat?: IxmUserauthV1ContactDetails[];
}

export interface IxmUserauthV1ProgramControls {
    apiAuth?: IxmUserauthV1ProgramControlsApiAuth;
    funding?: IxcFundingV1FundingControls;
    batchFunding?: IxcFundingV1BatchFundingControls;
    books?: IxcPortfolioV1BooksControls;
    order?: IxcOrdersV1OrderControls;
    registration?: IxcRegistrationV1ClearingControls;
    sweeps?: IxcPortfolioV1SweepsControls;
    instantDeposit?: IxcPortfolioV1InstantDepositControls;
    batchOrder?: IxcOrdersV1BatchOrderControls;
    accountNumbers?: IxcFundingV1AccountNumbersControls;
}

export interface IxmUserauthV1ProgramControlsApiAuth {
    limits?: IxmUserauthV1ProgramControlsApiAuthLimits;
    settings?: IxmUserauthV1ProgramControlsApiAuthSettings;
}

export interface IxmUserauthV1ProgramControlsApiAuthLimits {
    /* The maximum number of API keys that can be created. If unset, the program's accounts create Unlimited API keys. */
    // format: UINT32
    apiKeysMax?: number;
}

export interface IxmUserauthV1ProgramControlsApiAuthSettings {
    canCreateApiKeys?: boolean;
    /* Can enable API keys to authenticate. */
    canGetToken?: boolean;
    canRevokeApiKeys?: boolean;
}

export interface IxmUserauthV1ProgramData {
    controls: IxmUserauthV1ProgramControls;
    details: IxmUserauthV1ProgramDetails;
    clearingDetails: IxmUserauthV1ClearingDetails;
    /* The most recently approved branding version, which is currently in use */
    currentBrandingVersion?: IxmUserauthV1BrandingVersion;
    /* The most recent branding version, which is pending approval */
    pendingBrandingVersion?: IxmUserauthV1BrandingVersion;
}

export interface IxmUserauthV1ProgramDetails {
    registrationType: IxmUserauthV1ProgramRegistrationType;
    /* The name of this object. Example use case is if a correspondent has
    different programs this will be used to differentiate them. */
    name: string;
    /* The official name of the company as registered with government
    authorities.  For broker-dealers, this is typically the name listed on
    BrokerCheck. */
    legalName: string;
    /* The trade name the company conducts business under that differs from its
    legal name. */
    dba?: string;
    webDomains?: string[];
    // pattern: ^\d{2}-\d{7}$
    taxIdentifier: string;
    mainOfficeAddress: IxcRegistrationV1Address;
    mailingAddress?: IxcRegistrationV1Address;
    customerSupportContacts: IxmUserauthV1CustomerSupportContacts;
    vendors: IxmUserauthV1Vendors;
    contacts: IxmUserauthV1ProgramContacts;
}

export interface IxmUserauthV1ProgramEvent extends IxmUserauthV1ProgramKeys {
    metadata: J5StateV1EventMetadata;
    event: IxmUserauthV1ProgramEventType;
}

export type IxmUserauthV1ProgramEventType = {
    '!type'?: 'created';
    created: IxmUserauthV1ProgramEventTypeCreated;
} | {
    '!type'?: 'programDetailsUpdated';
    programDetailsUpdated: IxmUserauthV1ProgramEventTypeProgramDetailsUpdated;
} | {
    '!type'?: 'clearingDetailsUpdated';
    clearingDetailsUpdated: IxmUserauthV1ProgramEventTypeClearingDetailsUpdated;
} | {
    '!type'?: 'controlsUpdated';
    controlsUpdated: IxmUserauthV1ProgramEventTypeControlsUpdated;
} | {
    '!type'?: 'brandingUpdateRequested';
    brandingUpdateRequested: IxmUserauthV1ProgramEventTypeBrandingUpdateRequested;
} | {
    '!type'?: 'brandingVersionApproved';
    brandingVersionApproved: IxmUserauthV1ProgramEventTypeBrandingVersionApproved;
} | {
    '!type'?: 'brandingVersionRejected';
    brandingVersionRejected: IxmUserauthV1ProgramEventTypeBrandingVersionRejected;
} | {
    '!type'?: 'brandingVersionArchived';
    brandingVersionArchived: IxmUserauthV1ProgramEventTypeBrandingVersionArchived;
} | {
    '!type'?: 'artifactArchived';
    artifactArchived: IxmUserauthV1ProgramEventTypeArtifactArchived;
};

export interface IxmUserauthV1ProgramEventTypeArtifactArchived {
    // format: id62
    artifactId: string;
}

export interface IxmUserauthV1ProgramEventTypeBrandingUpdateRequested {
    // format: id62
    brandingVersionId: string;
    /* Required if a branding version is being updated instead of created */
    // format: id62
    replacesBrandingVersionId?: string;
    spec: IxmUserauthV1BrandingSpec;
}

export interface IxmUserauthV1ProgramEventTypeBrandingVersionApproved {
    // format: id62
    brandingVersionId: string;
    spec: IxmUserauthV1BrandingSpec;
}

export interface IxmUserauthV1ProgramEventTypeBrandingVersionArchived {
    // format: id62
    brandingVersionId: string;
}

export interface IxmUserauthV1ProgramEventTypeBrandingVersionRejected {
    // format: id62
    brandingVersionId: string;
    reason?: string;
}

export interface IxmUserauthV1ProgramEventTypeClearingDetailsUpdated {
    clearingDetails: IxmUserauthV1ClearingDetails;
}

export interface IxmUserauthV1ProgramEventTypeControlsUpdated {
    controls: IxmUserauthV1ProgramControls;
}

export interface IxmUserauthV1ProgramEventTypeCreated {
    spec: IxmUserauthV1ProgramSpec;
}

export interface IxmUserauthV1ProgramEventTypeProgramDetailsUpdated {
    details: IxmUserauthV1ProgramDetails;
}

export const IXM_USERAUTH_V1_PROGRAM_EVENT_TYPE_ONE_OF_VALUES = ['created', 'programDetailsUpdated', 'clearingDetailsUpdated', 'controlsUpdated', 'brandingUpdateRequested', 'brandingVersionApproved', 'brandingVersionRejected', 'brandingVersionArchived', 'artifactArchived'] as const;

export type IxmUserauthV1ProgramEventTypeOneOfValue = (typeof IXM_USERAUTH_V1_PROGRAM_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxmUserauthV1ProgramKeys {
    // format: id62
    programId: string;
    // format: id62, entity: ixm.userauth.v1.Realm
    realmId: string;
    // format: custom - pattern: ^[A-Z]{4}$
    programCode: string;
}

export interface IxmUserauthV1ProgramQueryServiceProgramEventsProgramEventsRequest {
    // format: id62
    programId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxmUserauthV1ProgramQueryServiceProgramEventsSearchableFields, IxmUserauthV1ProgramQueryServiceProgramEventsSortableFields, IxmUserauthV1ProgramQueryServiceProgramEventsFilterableFields>;
}

export enum IxmUserauthV1ProgramQueryServiceProgramEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    ProgramId = 'programId',
    RealmId = 'realmId',
    ProgramCode = 'programCode',
    EventType = 'event.!type'
}

export enum IxmUserauthV1ProgramQueryServiceProgramEventsSearchableFields {
    EventCreatedSpecDetailsName = 'event.created.spec.details.name',
    EventProgramDetailsUpdatedDetailsName = 'event.programDetailsUpdated.details.name'
}

export enum IxmUserauthV1ProgramQueryServiceProgramEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxmUserauthV1ProgramQueryServiceProgramGetProgramGetRequest {
    // format: id62
    programId: string;
}

export interface IxmUserauthV1ProgramQueryServiceProgramListProgramListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxmUserauthV1ProgramQueryServiceProgramListSearchableFields, IxmUserauthV1ProgramQueryServiceProgramListSortableFields, IxmUserauthV1ProgramQueryServiceProgramListFilterableFields>;
}

export enum IxmUserauthV1ProgramQueryServiceProgramListFilterableFields {
    ProgramId = 'programId',
    RealmId = 'realmId',
    ProgramCode = 'programCode',
    Status = 'status'
}

export enum IxmUserauthV1ProgramQueryServiceProgramListSearchableFields {
    DataDetailsName = 'data.details.name'
}

export enum IxmUserauthV1ProgramQueryServiceProgramListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export type IxmUserauthV1ProgramRegistrationType = {
    '!type'?: 'brokerDealer';
    brokerDealer: IxmUserauthV1ProgramRegistrationTypeBrokerDealer;
} | {
    '!type'?: 'investmentAdviser';
    investmentAdviser: IxmUserauthV1ProgramRegistrationTypeInvestmentAdviser;
} | {
    '!type'?: 'none';
    none: EmptyObject;
};

export interface IxmUserauthV1ProgramRegistrationTypeBrokerDealer {
    // pattern: ^[0-9]{2,6}$
    crdNumber: string;
    // pattern: ^[0-9]{1,3}-[0-9]{5,6}$
    secRegistrationNumber: string;
}

export interface IxmUserauthV1ProgramRegistrationTypeInvestmentAdviser {
    // pattern: ^[0-9]{2,6}$
    crdNumber: string;
    // pattern: ^[0-9]{1,3}-[0-9]{5,6}$
    secRegistrationNumber?: string;
}

export const IXM_USERAUTH_V1_PROGRAM_REGISTRATION_TYPE_ONE_OF_VALUES = ['brokerDealer', 'investmentAdviser', 'none'] as const;

export type IxmUserauthV1ProgramRegistrationTypeOneOfValue = (typeof IXM_USERAUTH_V1_PROGRAM_REGISTRATION_TYPE_ONE_OF_VALUES)[number];

export interface IxmUserauthV1ProgramSpec {
    details: IxmUserauthV1ProgramDetails;
    clearingDetails: IxmUserauthV1ClearingDetails;
    controls: IxmUserauthV1ProgramControls;
}

export interface IxmUserauthV1ProgramState extends IxmUserauthV1ProgramKeys {
    metadata: J5StateV1StateMetadata;
    data: IxmUserauthV1ProgramData;
    status: IxmUserauthV1ProgramStatus;
}

export enum IxmUserauthV1ProgramStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE'
}

export interface IxmUserauthV1RealmAccessData {
    spec: IxmUserauthV1RealmAccessSpec;
}

export interface IxmUserauthV1RealmAccessEvent extends IxmUserauthV1RealmAccessKeys {
    metadata: J5StateV1EventMetadata;
    event: IxmUserauthV1RealmAccessEventType;
}

export type IxmUserauthV1RealmAccessEventType = {
    '!type'?: 'setAccess';
    setAccess: IxmUserauthV1RealmAccessEventTypeSetAccess;
} | {
    '!type'?: 'removeAccess';
    removeAccess: EmptyObject;
};

export interface IxmUserauthV1RealmAccessEventTypeSetAccess {
    spec?: IxmUserauthV1RealmAccessSpec;
}

export const IXM_USERAUTH_V1_REALM_ACCESS_EVENT_TYPE_ONE_OF_VALUES = ['setAccess', 'removeAccess'] as const;

export type IxmUserauthV1RealmAccessEventTypeOneOfValue = (typeof IXM_USERAUTH_V1_REALM_ACCESS_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxmUserauthV1RealmAccessKeys {
    // format: id62
    realmAccessId: string;
    // format: id62, entity: ixm.userauth.v1.Realm
    realmId: string;
    // format: id62, entity: ixm.userauth.v1.Tenant
    tenantId: string;
    // format: id62, entity: ixm.userauth.v1.Organization
    organizationId: string;
}

export interface IxmUserauthV1RealmAccessQueryServiceRealmAccessEventsRealmAccessEventsRequest {
    // format: id62
    realmAccessId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmUserauthV1RealmAccessQueryServiceRealmAccessEventsSortableFields, IxmUserauthV1RealmAccessQueryServiceRealmAccessEventsFilterableFields>;
}

export enum IxmUserauthV1RealmAccessQueryServiceRealmAccessEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    RealmAccessId = 'realmAccessId',
    RealmId = 'realmId',
    TenantId = 'tenantId',
    OrganizationId = 'organizationId',
    EventType = 'event.!type'
}

export enum IxmUserauthV1RealmAccessQueryServiceRealmAccessEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxmUserauthV1RealmAccessQueryServiceRealmAccessGetRealmAccessGetRequest {
    // format: id62
    realmAccessId: string;
}

export interface IxmUserauthV1RealmAccessQueryServiceRealmAccessListRealmAccessListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmUserauthV1RealmAccessQueryServiceRealmAccessListSortableFields, IxmUserauthV1RealmAccessQueryServiceRealmAccessListFilterableFields>;
}

export enum IxmUserauthV1RealmAccessQueryServiceRealmAccessListFilterableFields {
    RealmAccessId = 'realmAccessId',
    RealmId = 'realmId',
    TenantId = 'tenantId',
    OrganizationId = 'organizationId',
    Status = 'status'
}

export enum IxmUserauthV1RealmAccessQueryServiceRealmAccessListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxmUserauthV1RealmAccessRole {
    // format: id62, entity: ixm.userauth.v1.RealmAccess
    realmAccessId: string;
    // format: id62, entity: ixm.userauth.v1.Role
    roleId: string;
}

export interface IxmUserauthV1RealmAccessSpec {
    isAdmin?: boolean;
}

export interface IxmUserauthV1RealmAccessState extends IxmUserauthV1RealmAccessKeys {
    metadata: J5StateV1StateMetadata;
    data: IxmUserauthV1RealmAccessData;
    status: IxmUserauthV1RealmAccessStatus;
}

export enum IxmUserauthV1RealmAccessStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Removed = 'REMOVED'
}

export interface IxmUserauthV1RealmAccessTokenServiceGetRealmAccessTokenGetRealmAccessTokenRequest {
    // format: id62
    realmAccessId: string;
}

export interface IxmUserauthV1RealmData {
    spec: IxmUserauthV1RealmSpec;
}

export interface IxmUserauthV1RealmEvent extends IxmUserauthV1RealmKeys {
    metadata: J5StateV1EventMetadata;
    event: IxmUserauthV1RealmEventType;
}

export type IxmUserauthV1RealmEventType = {
    '!type'?: 'created';
    created: IxmUserauthV1RealmEventTypeCreated;
} | {
    '!type'?: 'updated';
    updated: IxmUserauthV1RealmEventTypeUpdated;
};

export interface IxmUserauthV1RealmEventTypeCreated {
    spec?: IxmUserauthV1RealmSpec;
}

export interface IxmUserauthV1RealmEventTypeUpdated {
    spec?: IxmUserauthV1RealmSpec;
}

export const IXM_USERAUTH_V1_REALM_EVENT_TYPE_ONE_OF_VALUES = ['created', 'updated'] as const;

export type IxmUserauthV1RealmEventTypeOneOfValue = (typeof IXM_USERAUTH_V1_REALM_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxmUserauthV1RealmKeys {
    // format: id62
    realmId: string;
    // format: custom - pattern: ^[a-z0-9-]+$
    realmCode: string;
}

export interface IxmUserauthV1RealmQueryServiceRealmEventsRealmEventsRequest {
    // format: id62
    realmId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmUserauthV1RealmQueryServiceRealmEventsSortableFields, IxmUserauthV1RealmQueryServiceRealmEventsFilterableFields>;
}

export enum IxmUserauthV1RealmQueryServiceRealmEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    RealmId = 'realmId',
    RealmCode = 'realmCode',
    EventType = 'event.!type'
}

export enum IxmUserauthV1RealmQueryServiceRealmEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxmUserauthV1RealmQueryServiceRealmGetRealmGetRequest {
    // format: id62
    realmId: string;
}

export interface IxmUserauthV1RealmQueryServiceRealmListRealmListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmUserauthV1RealmQueryServiceRealmListSortableFields, IxmUserauthV1RealmQueryServiceRealmListFilterableFields>;
}

export enum IxmUserauthV1RealmQueryServiceRealmListFilterableFields {
    RealmId = 'realmId',
    RealmCode = 'realmCode',
    Status = 'status'
}

export enum IxmUserauthV1RealmQueryServiceRealmListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxmUserauthV1RealmSpec {
    name: string;
    // pattern: ^[a-z0-9-]+$
    type?: string;
    baseUrl?: string;
    tenantTypes?: IxmUserauthV1TenantType[];
    metadata?: Record<string, string>;
}

export interface IxmUserauthV1RealmState extends IxmUserauthV1RealmKeys {
    metadata: J5StateV1StateMetadata;
    data: IxmUserauthV1RealmData;
    status: IxmUserauthV1RealmStatus;
}

export enum IxmUserauthV1RealmStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE'
}

export interface IxmUserauthV1RoleData {
    spec?: IxmUserauthV1RoleSpec;
}

export interface IxmUserauthV1RoleEvent extends IxmUserauthV1RoleKeys {
    metadata: J5StateV1EventMetadata;
    event: IxmUserauthV1RoleEventType;
}

export type IxmUserauthV1RoleEventType = {
    '!type'?: 'created';
    created: IxmUserauthV1RoleEventTypeCreated;
} | {
    '!type'?: 'updated';
    updated: IxmUserauthV1RoleEventTypeUpdated;
} | {
    '!type'?: 'archived';
    archived: EmptyObject;
};

export interface IxmUserauthV1RoleEventTypeCreated {
    spec?: IxmUserauthV1RoleSpec;
}

export interface IxmUserauthV1RoleEventTypeUpdated {
    spec?: IxmUserauthV1RoleSpec;
}

export const IXM_USERAUTH_V1_ROLE_EVENT_TYPE_ONE_OF_VALUES = ['created', 'updated', 'archived'] as const;

export type IxmUserauthV1RoleEventTypeOneOfValue = (typeof IXM_USERAUTH_V1_ROLE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxmUserauthV1RoleKeys {
    // format: id62
    roleId: string;
    // format: id62, entity: ixm.userauth.v1.Organization
    organizationId?: string;
}

export interface IxmUserauthV1RoleQueryServiceRoleEventsRoleEventsRequest {
    // format: id62
    roleId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmUserauthV1RoleQueryServiceRoleEventsSortableFields, IxmUserauthV1RoleQueryServiceRoleEventsFilterableFields>;
}

export enum IxmUserauthV1RoleQueryServiceRoleEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    RoleId = 'roleId',
    OrganizationId = 'organizationId',
    EventType = 'event.!type'
}

export enum IxmUserauthV1RoleQueryServiceRoleEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxmUserauthV1RoleQueryServiceRoleGetRoleGetRequest {
    // format: id62
    roleId: string;
}

export interface IxmUserauthV1RoleQueryServiceRoleListRoleListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmUserauthV1RoleQueryServiceRoleListSortableFields, IxmUserauthV1RoleQueryServiceRoleListFilterableFields>;
}

export enum IxmUserauthV1RoleQueryServiceRoleListFilterableFields {
    RoleId = 'roleId',
    OrganizationId = 'organizationId',
    Status = 'status'
}

export enum IxmUserauthV1RoleQueryServiceRoleListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxmUserauthV1RoleSpec {
    label?: string;
    scopes?: string[];
}

export interface IxmUserauthV1RoleState extends IxmUserauthV1RoleKeys {
    metadata: J5StateV1StateMetadata;
    data: IxmUserauthV1RoleData;
    status: IxmUserauthV1RoleStatus;
}

export enum IxmUserauthV1RoleStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE',
    Archived = 'ARCHIVED'
}

export interface IxmUserauthV1DownloadArtifactBundleResponseArtifacts {
    // format: id62
    artifactId: string;
    /* An optional name for the artifact */
    name?: string;
    /* An optional description for the artifact */
    description?: string;
    /* The file to be downloaded, sent as base64-encoded bytes */
    // bytes (base64-encoded)
    file: string;
}

export enum IxmUserauthV1DownloadBrandingArtifactRequestBrandingArtifactKey {
    Unspecified = 'UNSPECIFIED',
    Logo = 'LOGO',
    Logomark = 'LOGOMARK',
    MainFont = 'MAIN_FONT',
    MonoFont = 'MONO_FONT'
}

export type IxmUserauthV1LoginRequestCredentials = {
    '!type'?: 'basicAuth';
    basicAuth: IxmUserauthV1LoginRequestCredentialsBasicAuth;
};

export interface IxmUserauthV1LoginRequestCredentialsBasicAuth {
    email?: string;
    password?: string;
    otp?: string;
}

export const IXM_USERAUTH_V1_LOGIN_REQUEST_CREDENTIALS_ONE_OF_VALUES = ['basicAuth'] as const;

export type IxmUserauthV1LoginRequestCredentialsOneOfValue = (typeof IXM_USERAUTH_V1_LOGIN_REQUEST_CREDENTIALS_ONE_OF_VALUES)[number];

export type IxmUserauthV1SetPasswordRequestMethod = {
    '!type'?: 'forgotPasswordToken';
    forgotPasswordToken: IxmUserauthV1Token;
} | {
    '!type'?: 'basicAuth';
    basicAuth: IxmUserauthV1SetPasswordRequestMethodBasicAuth;
};

export interface IxmUserauthV1SetPasswordRequestMethodBasicAuth {
    previousPassword?: string;
    otp?: string;
}

export const IXM_USERAUTH_V1_SET_PASSWORD_REQUEST_METHOD_ONE_OF_VALUES = ['forgotPasswordToken', 'basicAuth'] as const;

export type IxmUserauthV1SetPasswordRequestMethodOneOfValue = (typeof IXM_USERAUTH_V1_SET_PASSWORD_REQUEST_METHOD_ONE_OF_VALUES)[number];

export type IxmUserauthV1UpdateProgramRequestUpdate = {
    '!type'?: 'controls';
    controls: IxmUserauthV1UpdateProgramRequestUpdateControls;
} | {
    '!type'?: 'details';
    details: IxmUserauthV1UpdateProgramRequestUpdateDetails;
} | {
    '!type'?: 'clearingDetails';
    clearingDetails: IxmUserauthV1UpdateProgramRequestUpdateClearingDetails;
};

export interface IxmUserauthV1UpdateProgramRequestUpdateClearingDetails {
    clearingDetails: IxmUserauthV1ClearingDetails;
}

export interface IxmUserauthV1UpdateProgramRequestUpdateControls {
    controls: IxmUserauthV1ProgramControls;
}

export interface IxmUserauthV1UpdateProgramRequestUpdateDetails {
    details: IxmUserauthV1ProgramDetails;
}

export const IXM_USERAUTH_V1_UPDATE_PROGRAM_REQUEST_UPDATE_ONE_OF_VALUES = ['controls', 'details', 'clearingDetails'] as const;

export type IxmUserauthV1UpdateProgramRequestUpdateOneOfValue = (typeof IXM_USERAUTH_V1_UPDATE_PROGRAM_REQUEST_UPDATE_ONE_OF_VALUES)[number];

export type IxmUserauthV1SetArtifact = {
    '!type'?: 'artifactId';
    // format: id62
    artifactId: string;
} | {
    '!type'?: 'file';
    // bytes (base64-encoded)
    file: string;
};

export const IXM_USERAUTH_V1_SET_ARTIFACT_ONE_OF_VALUES = ['artifactId', 'file'] as const;

export type IxmUserauthV1SetArtifactOneOfValue = (typeof IXM_USERAUTH_V1_SET_ARTIFACT_ONE_OF_VALUES)[number];

export type IxmUserauthV1SetFontType = {
    '!type'?: 'googleFont';
    googleFont: IxmUserauthV1GoogleFont;
} | {
    '!type'?: 'customFont';
    customFont: IxmUserauthV1SetFontTypeCustomFont;
};

export interface IxmUserauthV1SetFontTypeCustomFont {
    source: IxmUserauthV1SetArtifact;
    /* The name of the font family */
    family: string;
    /* The weights of the font to enable */
    weights?: IxmUserauthV1FontWeight;
}

export const IXM_USERAUTH_V1_SET_FONT_TYPE_ONE_OF_VALUES = ['googleFont', 'customFont'] as const;

export type IxmUserauthV1SetFontTypeOneOfValue = (typeof IXM_USERAUTH_V1_SET_FONT_TYPE_ONE_OF_VALUES)[number];

export type IxmUserauthV1SrgbColor = {
    '!type'?: 'hex';
    /* A color in hex format */
    // pattern: ^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$
    hex: string;
} | {
    '!type'?: 'hsla';
    hsla: IxmUserauthV1SrgbColorHsla;
} | {
    '!type'?: 'rgba';
    rgba: IxmUserauthV1SrgbColorRgba;
};

export interface IxmUserauthV1SrgbColorHsla {
    /* The hue of the color */
    // format: decimal
    h: string;
    /* The saturation of the color, where 0 is grayscale and 100 is
    fully saturated. */
    // format: decimal
    s: string;
    /* The lightness of the color, where 0 is black and 100 is white. */
    // format: decimal
    l: string;
    /* The alpha channel of the color, where 0 is fully transparent and
    1 is fully opaque. */
    // format: decimal
    a: string;
}

export interface IxmUserauthV1SrgbColorRgba {
    /* The red channel of the color, where 0 contains no red and 255
    provides the maximum amount of red. */
    // format: decimal
    r: string;
    /* The green channel of the color, where 0 contains no green and 255
    provides the maximum amount of green. */
    // format: decimal
    g: string;
    /* The blue channel of the color, where 0 contains no blue and 255
    provides the maximum amount of blue. */
    // format: decimal
    b: string;
    /* The alpha channel of the color, where 0 is fully transparent and
    1 is fully opaque. */
    // format: decimal
    a: string;
}

export const IXM_USERAUTH_V1_SRGB_COLOR_ONE_OF_VALUES = ['hex', 'hsla', 'rgba'] as const;

export type IxmUserauthV1SrgbColorOneOfValue = (typeof IXM_USERAUTH_V1_SRGB_COLOR_ONE_OF_VALUES)[number];

export interface IxmUserauthV1TenantData {
    spec: IxmUserauthV1TenantSpec;
}

export interface IxmUserauthV1TenantEvent extends IxmUserauthV1TenantKeys {
    metadata: J5StateV1EventMetadata;
    event: IxmUserauthV1TenantEventType;
}

export type IxmUserauthV1TenantEventType = {
    '!type'?: 'created';
    created: IxmUserauthV1TenantEventTypeCreated;
} | {
    '!type'?: 'updated';
    updated: IxmUserauthV1TenantEventTypeUpdated;
};

export interface IxmUserauthV1TenantEventTypeCreated {
    spec?: IxmUserauthV1TenantSpec;
}

export interface IxmUserauthV1TenantEventTypeUpdated {
    spec?: IxmUserauthV1TenantSpec;
}

export const IXM_USERAUTH_V1_TENANT_EVENT_TYPE_ONE_OF_VALUES = ['created', 'updated'] as const;

export type IxmUserauthV1TenantEventTypeOneOfValue = (typeof IXM_USERAUTH_V1_TENANT_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxmUserauthV1TenantKeys {
    // format: id62
    tenantId: string;
    // format: id62, entity: ixm.userauth.v1.Realm
    realmId: string;
    // format: custom - pattern: ^[a-z0-9-]+$
    tenantType?: string;
}

export interface IxmUserauthV1TenantQueryServiceTenantEventsTenantEventsRequest {
    // format: id62
    tenantId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmUserauthV1TenantQueryServiceTenantEventsSortableFields, IxmUserauthV1TenantQueryServiceTenantEventsFilterableFields>;
}

export enum IxmUserauthV1TenantQueryServiceTenantEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    TenantId = 'tenantId',
    RealmId = 'realmId',
    TenantType = 'tenantType',
    EventType = 'event.!type'
}

export enum IxmUserauthV1TenantQueryServiceTenantEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxmUserauthV1TenantQueryServiceTenantGetTenantGetRequest {
    // format: id62
    tenantId: string;
}

export interface IxmUserauthV1TenantQueryServiceTenantListTenantListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmUserauthV1TenantQueryServiceTenantListSortableFields, IxmUserauthV1TenantQueryServiceTenantListFilterableFields>;
}

export enum IxmUserauthV1TenantQueryServiceTenantListFilterableFields {
    TenantId = 'tenantId',
    RealmId = 'realmId',
    TenantType = 'tenantType',
    Status = 'status'
}

export enum IxmUserauthV1TenantQueryServiceTenantListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxmUserauthV1TenantSpec {
    name?: string;
    /* Key-value pairs of metadata interpreted in the context of the realm and
    tenant-type within the realm */
    metadata?: Record<string, string>;
}

export interface IxmUserauthV1TenantState extends IxmUserauthV1TenantKeys {
    metadata: J5StateV1StateMetadata;
    data: IxmUserauthV1TenantData;
    status: IxmUserauthV1TenantStatus;
}

export enum IxmUserauthV1TenantStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE'
}

export interface IxmUserauthV1TenantType {
    // pattern: ^[a-z0-9-]+$
    name?: string;
    label?: string;
    /* the tenant-type has exactly one tenant ID in the realm. In multi-tenant
    environments, this tenant type is has global access across all tenants If
    this is the only tenant-type in the realm, the realm itself is
    single-tenant. */
    singular?: boolean;
}

export enum IxmUserauthV1Theme {
    Unspecified = 'UNSPECIFIED',
    System = 'SYSTEM',
    Light = 'LIGHT',
    Dark = 'DARK'
}

export interface IxmUserauthV1Token {
    // format: id62
    id: string;
    secret: string;
}

export interface IxmUserauthV1UserAdditional {
    mfaEnabled?: boolean;
}

export interface IxmUserauthV1UserData {
    profile?: IxmUserauthV1UserProfile;
    additional?: IxmUserauthV1UserAdditional;
    preferences?: IxmUserauthV1UserPreferences;
    // format: date-time
    lastSignedInAt?: string;
}

export interface IxmUserauthV1UserEvent extends IxmUserauthV1UserKeys {
    metadata: J5StateV1EventMetadata;
    event: IxmUserauthV1UserEventType;
}

export type IxmUserauthV1UserEventType = {
    '!type'?: 'created';
    created: IxmUserauthV1UserEventTypeCreated;
} | {
    '!type'?: 'setProfile';
    setProfile: IxmUserauthV1UserEventTypeSetProfile;
} | {
    '!type'?: 'setPreferences';
    setPreferences: IxmUserauthV1UserEventTypeSetPreferences;
} | {
    '!type'?: 'additonalUpdated';
    additonalUpdated: IxmUserauthV1UserEventTypeAdditonalUpdated;
} | {
    '!type'?: 'sessionInitiated';
    sessionInitiated: IxmUserauthV1UserEventTypeSessionInitiated;
} | {
    '!type'?: 'sessionTerminated';
    sessionTerminated: IxmUserauthV1UserEventTypeSessionTerminated;
};

export interface IxmUserauthV1UserEventTypeAdditonalUpdated {
    additional?: IxmUserauthV1UserAdditional;
}

export interface IxmUserauthV1UserEventTypeCreated {
    profile?: IxmUserauthV1UserProfile;
    preferences?: IxmUserauthV1UserPreferences;
}

export interface IxmUserauthV1UserEventTypeSessionInitiated {
    // format: id62, entity: ixm.userauth.v1.Session
    sessionId: string;
}

export interface IxmUserauthV1UserEventTypeSessionTerminated {
    // format: id62, entity: ixm.userauth.v1.Session
    sessionId: string;
}

export interface IxmUserauthV1UserEventTypeSetPreferences {
    preferences?: IxmUserauthV1UserPreferences;
}

export interface IxmUserauthV1UserEventTypeSetProfile {
    profile?: IxmUserauthV1UserProfile;
}

export const IXM_USERAUTH_V1_USER_EVENT_TYPE_ONE_OF_VALUES = ['created', 'setProfile', 'setPreferences', 'additonalUpdated', 'sessionInitiated', 'sessionTerminated'] as const;

export type IxmUserauthV1UserEventTypeOneOfValue = (typeof IXM_USERAUTH_V1_USER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxmUserauthV1UserKeys {
    // format: id62
    userId: string;
    // format: custom - pattern: ^.*$
    email?: string;
}

export interface IxmUserauthV1UserPreferences {
    // format: id62
    defaultRealmAccessId?: string;
    theme?: IxmUserauthV1Theme;
    prefersExpandedNavigation?: boolean;
    /* IANA Time Zone database name, e.g. "America/New_York" (empty for system
    default) */
    timeZone?: string;
}

export interface IxmUserauthV1UserProfile {
    firstName: string;
    lastName: string;
}

export interface IxmUserauthV1UserQueryServiceUserEventsUserEventsRequest {
    // format: id62
    userId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxmUserauthV1UserQueryServiceUserEventsSearchableFields, IxmUserauthV1UserQueryServiceUserEventsSortableFields, IxmUserauthV1UserQueryServiceUserEventsFilterableFields>;
}

export enum IxmUserauthV1UserQueryServiceUserEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    UserId = 'userId',
    EventAdditonalUpdatedAdditionalMfaEnabled = 'event.additonalUpdated.additional.mfaEnabled',
    EventType = 'event.!type'
}

export enum IxmUserauthV1UserQueryServiceUserEventsSearchableFields {
    Email = 'email',
    EventCreatedProfileFirstName = 'event.created.profile.firstName',
    EventCreatedProfileLastName = 'event.created.profile.lastName',
    EventSetProfileProfileFirstName = 'event.setProfile.profile.firstName',
    EventSetProfileProfileLastName = 'event.setProfile.profile.lastName'
}

export enum IxmUserauthV1UserQueryServiceUserEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxmUserauthV1UserQueryServiceUserGetUserGetRequest {
    // format: id62
    userId: string;
}

export interface IxmUserauthV1UserQueryServiceUserListUserListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<IxmUserauthV1UserQueryServiceUserListSearchableFields, IxmUserauthV1UserQueryServiceUserListSortableFields, IxmUserauthV1UserQueryServiceUserListFilterableFields>;
}

export enum IxmUserauthV1UserQueryServiceUserListFilterableFields {
    UserId = 'userId',
    DataAdditionalMfaEnabled = 'data.additional.mfaEnabled',
    DataLastSignedInAt = 'data.lastSignedInAt',
    Status = 'status'
}

export enum IxmUserauthV1UserQueryServiceUserListSearchableFields {
    Email = 'email',
    DataProfileFirstName = 'data.profile.firstName',
    DataProfileLastName = 'data.profile.lastName'
}

export enum IxmUserauthV1UserQueryServiceUserListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataLastSignedInAt = 'data.lastSignedInAt'
}

export interface IxmUserauthV1UserSessionData {
    ipAddress?: string;
    userAgent?: string;
    // format: date-time
    expiresAt?: string;
    secret?: string;
}

export interface IxmUserauthV1UserSessionEvent extends IxmUserauthV1UserSessionKeys {
    metadata: J5StateV1EventMetadata;
    event: IxmUserauthV1UserSessionEventType;
}

export type IxmUserauthV1UserSessionEventType = {
    '!type'?: 'initiated';
    initiated: IxmUserauthV1UserSessionEventTypeInitiated;
} | {
    '!type'?: 'refreshed';
    refreshed: IxmUserauthV1UserSessionEventTypeRefreshed;
};

export interface IxmUserauthV1UserSessionEventTypeInitiated {
    ipAddress?: string;
    userAgent?: string;
    // format: date-time
    expiresAt?: string;
    secret?: string;
}

export interface IxmUserauthV1UserSessionEventTypeRefreshed {
    // format: date-time
    expiresAt?: string;
}

export const IXM_USERAUTH_V1_USER_SESSION_EVENT_TYPE_ONE_OF_VALUES = ['initiated', 'refreshed'] as const;

export type IxmUserauthV1UserSessionEventTypeOneOfValue = (typeof IXM_USERAUTH_V1_USER_SESSION_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxmUserauthV1UserSessionKeys {
    // format: id62
    sessionId: string;
    // format: id62, entity: ixm.userauth.v1.User
    userId?: string;
}

export interface IxmUserauthV1UserSessionQueryServiceUserSessionEventsUserSessionEventsRequest {
    // format: id62
    sessionId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmUserauthV1UserSessionQueryServiceUserSessionEventsSortableFields, IxmUserauthV1UserSessionQueryServiceUserSessionEventsFilterableFields>;
}

export enum IxmUserauthV1UserSessionQueryServiceUserSessionEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    SessionId = 'sessionId',
    UserId = 'userId',
    EventType = 'event.!type'
}

export enum IxmUserauthV1UserSessionQueryServiceUserSessionEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxmUserauthV1UserSessionQueryServiceUserSessionGetUserSessionGetRequest {
    // format: id62
    sessionId: string;
}

export interface IxmUserauthV1UserSessionQueryServiceUserSessionListUserSessionListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxmUserauthV1UserSessionQueryServiceUserSessionListSortableFields, IxmUserauthV1UserSessionQueryServiceUserSessionListFilterableFields>;
}

export enum IxmUserauthV1UserSessionQueryServiceUserSessionListFilterableFields {
    SessionId = 'sessionId',
    UserId = 'userId',
    Status = 'status'
}

export enum IxmUserauthV1UserSessionQueryServiceUserSessionListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxmUserauthV1UserSessionState extends IxmUserauthV1UserSessionKeys {
    metadata: J5StateV1StateMetadata;
    data: IxmUserauthV1UserSessionData;
    status: IxmUserauthV1UserSessionStatus;
}

export enum IxmUserauthV1UserSessionStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE'
}

export interface IxmUserauthV1UserState extends IxmUserauthV1UserKeys {
    metadata: J5StateV1StateMetadata;
    data: IxmUserauthV1UserData;
    status: IxmUserauthV1UserStatus;
}

export enum IxmUserauthV1UserStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE'
}

export interface IxmUserauthV1UserSummary {
    keys?: IxmUserauthV1UserKeys;
    profile?: IxmUserauthV1UserProfile;
    additional?: IxmUserauthV1UserAdditional;
}

export interface IxmUserauthV1Vendors {
    cipIdentity?: IxcRegistrationV1CipVendor;
    cipOfac?: IxcRegistrationV1CipOfac;
    bankAccountValidation?: IxmUserauthV1BankAccountValidation;
}

export type IxmUserauthV1WideGamutColor = {
    '!type'?: 'displayP3';
    displayP3: IxmUserauthV1WideGamutColorDisplayP3;
};

export interface IxmUserauthV1WideGamutColorDisplayP3 {
    /* The red channel of the color, where 0 contains no red and 1 provides
    the maximum amount of red. */
    // format: decimal
    r: string;
    /* The green channel of the color, where 0 contains no green and 1
    provides the maximum amount of green. */
    // format: decimal
    g: string;
    /* The blue channel of the color, where 0 contains no blue and 1
    provides the maximum amount of blue. */
    // format: decimal
    b: string;
    /* The alpha channel of the color, where 0 is fully transparent and 1 is
    fully opaque. */
    // format: decimal
    a: string;
}

export const IXM_USERAUTH_V1_WIDE_GAMUT_COLOR_ONE_OF_VALUES = ['displayP3'] as const;

export type IxmUserauthV1WideGamutColorOneOfValue = (typeof IXM_USERAUTH_V1_WIDE_GAMUT_COLOR_ONE_OF_VALUES)[number];

export type IxtBuildsV1Action = {
    '!type'?: 'j5Build';
    /* Trigger a J5 build and publish its artifacts */
    j5Build: EmptyObject;
} | {
    '!type'?: 'o5Build';
    /* Trigger an O5 build and deploy its artifacts */
    o5Build: IxtBuildsV1O5Build;
};

export const IXT_BUILDS_V1_ACTION_ONE_OF_VALUES = ['j5Build', 'o5Build'] as const;

export type IxtBuildsV1ActionOneOfValue = (typeof IXT_BUILDS_V1_ACTION_ONE_OF_VALUES)[number];

export type IxtBuildsV1Condition = {
    '!type'?: 'branch';
    /* Branch name (supports globbing) */
    branch: string;
} | {
    '!type'?: 'tag';
    /* Tag prefix (supports globbing) */
    tag: string;
};

export const IXT_BUILDS_V1_CONDITION_ONE_OF_VALUES = ['branch', 'tag'] as const;

export type IxtBuildsV1ConditionOneOfValue = (typeof IXT_BUILDS_V1_CONDITION_ONE_OF_VALUES)[number];

export interface IxtBuildsV1Hook {
    /* The condition required to trigger the action */
    condition: IxtBuildsV1Condition;
    /* The actions to perform when the condition is met */
    actions: IxtBuildsV1Action[];
}

export interface IxtBuildsV1O5Build {
    /* The environment to deploy to */
    environment: string;
}

export interface IxtBuildsV1RepoData {
    /* Enables Github Build Check Runs for the repo */
    checksEnabled?: boolean;
    /* The hooks configured for the repo */
    hooks?: IxtBuildsV1Hook[];
    /* Git ref to alias this build as 'latest' */
    latest?: string;
}

export interface IxtBuildsV1RepoEvent extends IxtBuildsV1RepoKeys {
    metadata: J5StateV1EventMetadata;
    event: IxtBuildsV1RepoEventType;
}

export type IxtBuildsV1RepoEventType = {
    '!type'?: 'configure';
    configure: IxtBuildsV1RepoEventTypeConfigure;
};

export interface IxtBuildsV1RepoEventTypeConfigure {
    checksEnabled?: boolean;
    hooks?: IxtBuildsV1Hook[];
    latest?: string;
}

export const IXT_BUILDS_V1_REPO_EVENT_TYPE_ONE_OF_VALUES = ['configure'] as const;

export type IxtBuildsV1RepoEventTypeOneOfValue = (typeof IXT_BUILDS_V1_REPO_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxtBuildsV1RepoKeys {
    /* The repository owner */
    // format: informal
    owner: string;
    /* The repository name */
    // format: informal
    name: string;
}

export interface IxtBuildsV1RepoQueryServiceRepoEventsRepoEventsRequest {
    /* The repository owner */
    // format: informal
    owner: string;
    /* The repository name */
    // format: informal
    name: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxtBuildsV1RepoQueryServiceRepoEventsSortableFields, IxtBuildsV1RepoQueryServiceRepoEventsFilterableFields>;
}

export enum IxtBuildsV1RepoQueryServiceRepoEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    Owner = 'owner',
    Name = 'name',
    EventType = 'event.!type'
}

export enum IxtBuildsV1RepoQueryServiceRepoEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxtBuildsV1RepoQueryServiceRepoGetRepoGetRequest {
    /* The repository owner */
    // format: informal
    owner: string;
    /* The repository name */
    // format: informal
    name: string;
}

export interface IxtBuildsV1RepoQueryServiceRepoListRepoListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxtBuildsV1RepoQueryServiceRepoListSortableFields, IxtBuildsV1RepoQueryServiceRepoListFilterableFields>;
}

export enum IxtBuildsV1RepoQueryServiceRepoListFilterableFields {
    Owner = 'owner',
    Name = 'name',
    Status = 'status'
}

export enum IxtBuildsV1RepoQueryServiceRepoListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxtBuildsV1RepoState extends IxtBuildsV1RepoKeys {
    metadata: J5StateV1StateMetadata;
    data: IxtBuildsV1RepoData;
    status: IxtBuildsV1RepoStatus;
}

export enum IxtBuildsV1RepoStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE'
}

export interface IxtE2eV1TestRunData {
    /* The timestamp when the test run was submitted */
    // format: date-time
    submittedAt: string;
    /* The timestamp when the test run completed */
    // format: date-time
    stoppedAt?: string;
    /* Error message generated during the test run */
    errorMessage?: string;
}

export interface IxtE2eV1TestRunEvent extends IxtE2eV1TestRunKeys {
    metadata: J5StateV1EventMetadata;
    event: IxtE2eV1TestRunEventType;
}

export type IxtE2eV1TestRunEventType = {
    '!type'?: 'submitted';
    submitted: IxtE2eV1TestRunEventTypeSubmitted;
} | {
    '!type'?: 'succeeded';
    succeeded: IxtE2eV1TestRunEventTypeSucceeded;
} | {
    '!type'?: 'failed';
    failed: IxtE2eV1TestRunEventTypeFailed;
} | {
    '!type'?: 'canceled';
    canceled: IxtE2eV1TestRunEventTypeCanceled;
};

export interface IxtE2eV1TestRunEventTypeCanceled {
    // format: date-time
    stoppedAt?: string;
    /* Reason for canceling the test run */
    errorMessage?: string;
}

export interface IxtE2eV1TestRunEventTypeFailed {
    // format: date-time
    stoppedAt?: string;
    /* Error message associated with the failure */
    errorMessage?: string;
}

export interface IxtE2eV1TestRunEventTypeSubmitted {
    // format: date-time
    submittedAt?: string;
}

export interface IxtE2eV1TestRunEventTypeSucceeded {
    // format: date-time
    stoppedAt?: string;
}

export const IXT_E2E_V1_TEST_RUN_EVENT_TYPE_ONE_OF_VALUES = ['submitted', 'succeeded', 'failed', 'canceled'] as const;

export type IxtE2eV1TestRunEventTypeOneOfValue = (typeof IXT_E2E_V1_TEST_RUN_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface IxtE2eV1TestRunKeys {
    /* Unique identifier for the test run */
    // format: id62
    testRunId: string;
    /* The environment in which the test is run (e.g., "devcore-cc",
    "devcore-intg") */
    // format: informal
    environment: string;
}

export interface IxtE2eV1TestRunQueryServiceTestRunEventsTestRunEventsRequest {
    /* Unique identifier for the test run */
    // format: id62
    testRunId: string;
    /* The environment in which the test is run (e.g., "devcore-cc",
    "devcore-intg") */
    // format: informal
    environment: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxtE2eV1TestRunQueryServiceTestRunEventsSortableFields, IxtE2eV1TestRunQueryServiceTestRunEventsFilterableFields>;
}

export enum IxtE2eV1TestRunQueryServiceTestRunEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    TestRunId = 'testRunId',
    Environment = 'environment',
    EventType = 'event.!type'
}

export enum IxtE2eV1TestRunQueryServiceTestRunEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface IxtE2eV1TestRunQueryServiceTestRunGetTestRunGetRequest {
    /* Unique identifier for the test run */
    // format: id62
    testRunId: string;
    /* The environment in which the test is run (e.g., "devcore-cc",
    "devcore-intg") */
    // format: informal
    environment: string;
}

export interface IxtE2eV1TestRunQueryServiceTestRunListTestRunListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, IxtE2eV1TestRunQueryServiceTestRunListSortableFields, IxtE2eV1TestRunQueryServiceTestRunListFilterableFields>;
}

export enum IxtE2eV1TestRunQueryServiceTestRunListFilterableFields {
    TestRunId = 'testRunId',
    Environment = 'environment',
    Status = 'status'
}

export enum IxtE2eV1TestRunQueryServiceTestRunListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface IxtE2eV1TestRunState extends IxtE2eV1TestRunKeys {
    metadata: J5StateV1StateMetadata;
    data: IxtE2eV1TestRunData;
    status: IxtE2eV1TestRunStatus;
}

export enum IxtE2eV1TestRunStatus {
    Unspecified = 'UNSPECIFIED',
    Running = 'RUNNING',
    Success = 'SUCCESS',
    Failure = 'FAILURE',
    Canceled = 'CANCELED'
}

export interface J5AuthV1Action {
    method: string;
    actor: J5AuthV1Actor;
    fingerprint?: J5AuthV1Fingerprint;
    idempotencyKey?: string;
}

export interface J5AuthV1Actor {
    subjectId?: string;
    subjectType?: string;
    authenticationMethod?: J5AuthV1AuthenticationMethod;
    claim: J5AuthV1Claim;
    actorTags?: Record<string, string>;
}

export type J5AuthV1AuthenticationMethod = {
    '!type'?: 'jwt';
    jwt: J5AuthV1AuthenticationMethodJwt;
} | {
    '!type'?: 'session';
    session: J5AuthV1AuthenticationMethodSession;
} | {
    '!type'?: 'external';
    external: J5AuthV1AuthenticationMethodExternal;
};

export interface J5AuthV1AuthenticationMethodExternal {
    systemName?: string;
    metadata?: Record<string, string>;
}

export interface J5AuthV1AuthenticationMethodJwt {
    jwtId?: string;
    issuer?: string;
    // format: date-time
    issuedAt?: string;
}

export interface J5AuthV1AuthenticationMethodSession {
    sessionManager?: string;
    sessionId?: string;
    // format: date-time
    verifiedAt?: string;
    // format: date-time
    authenticatedAt?: string;
}

export const J5_AUTH_V1_AUTHENTICATION_METHOD_ONE_OF_VALUES = ['jwt', 'session', 'external'] as const;

export type J5AuthV1AuthenticationMethodOneOfValue = (typeof J5_AUTH_V1_AUTHENTICATION_METHOD_ONE_OF_VALUES)[number];

export interface J5AuthV1Claim {
    realmId?: string;
    // pattern: ^[a-z0-9_]+$
    tenantType?: string;
    tenantId?: string;
    scopes?: string[];
}

export interface J5AuthV1Fingerprint {
    ipAddress?: string;
    userAgent?: string;
}

export type J5AuthV1MethodAuthType = {
    '!type'?: 'none';
    none: EmptyObject;
} | {
    '!type'?: 'jwtBearer';
    jwtBearer: J5AuthV1MethodAuthTypeJwtBearer;
} | {
    '!type'?: 'custom';
    custom: J5AuthV1MethodAuthTypeCustom;
} | {
    '!type'?: 'cookie';
    cookie: EmptyObject;
};

export interface J5AuthV1MethodAuthTypeCustom {
    passThroughHeaders?: string[];
}

export interface J5AuthV1MethodAuthTypeJwtBearer {
    audience: string[];
}

export const J5_AUTH_V1_METHOD_AUTH_TYPE_ONE_OF_VALUES = ['none', 'jwtBearer', 'custom', 'cookie'] as const;

export type J5AuthV1MethodAuthTypeOneOfValue = (typeof J5_AUTH_V1_METHOD_AUTH_TYPE_ONE_OF_VALUES)[number];

export interface J5BclV1Alias {
    name?: string;
    path?: string[];
}

export interface J5BclV1Block {
    schemaName?: string;
    name?: J5BclV1Tag;
    typeSelect?: J5BclV1Tag;
    qualifier?: J5BclV1Tag;
    descriptionField?: string;
    alias?: J5BclV1Alias[];
    scalarSplit?: J5BclV1ScalarSplit;
    onlyExplicit?: boolean;
}

export interface J5BclV1Path {
    path?: string[];
}

export interface J5BclV1ScalarSplit {
    delimiter?: string;
    rightToLeft?: boolean;
    requiredFields?: J5BclV1Path[];
    optionalFields?: J5BclV1Path[];
    remainderField?: J5BclV1Path;
}

export interface J5BclV1Tag {
    fieldName?: string;
    isBlock?: boolean;
    optional?: boolean;
    bangBool?: string;
    questionBool?: string;
}

export interface J5ClientV1Api {
    packages?: J5ClientV1Package[];
    metadata?: J5ClientV1Metadata;
}

export interface J5ClientV1ApiSummary {
    packages?: J5ClientV1PackageSummary[];
    metadata?: J5ClientV1Metadata;
}

export interface J5ClientV1Diagram {
    type?: string;
    variant?: J5ClientV1DiagramVariant;
    artifactName?: string;
}

export enum J5ClientV1DiagramVariant {
    Unspecified = 'UNSPECIFIED',
    Light = 'LIGHT',
    Dark = 'DARK'
}

export interface J5ClientV1ListRequest {
    searchableFields?: J5ClientV1ListRequestSearchField[];
    sortableFields?: J5ClientV1ListRequestSortField[];
    filterableFields?: J5ClientV1ListRequestFilterField[];
}

export interface J5ClientV1ListRequestFilterField {
    name?: string;
    defaultFilters?: string[];
}

export interface J5ClientV1ListRequestSearchField {
    name?: string;
}

export interface J5ClientV1ListRequestSortField {
    name?: string;
    defaultSort?: J5ClientV1ListRequestSortFieldDirection;
}

export enum J5ClientV1ListRequestSortFieldDirection {
    Unspecified = 'UNSPECIFIED',
    Asc = 'ASC',
    Desc = 'DESC'
}

export interface J5ClientV1Metadata {
    // format: date-time
    builtAt?: string;
}

export interface J5ClientV1Method {
    // pattern: ^[a-z][a-zA-Z0-9]*$
    name?: string;
    fullGrpcName?: string;
    httpMethod?: J5SchemaV1HttpMethod;
    // pattern: ^(\/:?[a-z0-9_]+)+$
    httpPath?: string;
    requestSchema: string;
    responseSchema: string;
    auth?: J5AuthV1MethodAuthType;
    methodType?: J5SchemaV1MethodType;
    description?: string;
    listRequest?: J5ListV1ListRequestMessage;
    request: J5ClientV1MethodRequest;
    responseBody: J5SchemaV1Object;
}

export interface J5ClientV1MethodRequest {
    body?: J5SchemaV1Object;
    pathParameters?: J5SchemaV1ObjectProperty[];
    queryParameters?: J5SchemaV1ObjectProperty[];
    list?: J5ClientV1ListRequest;
}

export interface J5ClientV1Package {
    label?: string;
    // pattern: ^([a-z0-9_]+\.)v[0-9]+$
    name?: string;
    prose?: string;
    indirect?: boolean;
    services?: J5ClientV1[];
    stateEntities?: J5ClientV1StateEntity[];
    schemas?: Record<string, J5SchemaV1RootSchema>;
    source?: J5ClientV1PackageSource;
}

export interface J5ClientV1PackageSource {
    owner: string;
    repo: string;
    version: string;
}

export interface J5ClientV1PackageSummary {
    label?: string;
    // pattern: ^([a-z0-9_]+\.)v[0-9]+$
    name?: string;
}

export interface J5ClientV1 {
    // pattern: ^[A-Z][a-zA-Z0-9]*$
    name?: string;
    methods?: J5ClientV1Method[];
}

export interface J5ClientV1StateEntity {
    // pattern: ^[A-Z][a-zA-Z0-9_]*$
    name?: string;
    fullName: string;
    schemaName: string;
    overview?: string;
    primaryKey?: string[];
    queryService?: J5ClientV1;
    commandServices?: J5ClientV1[];
    events?: J5ClientV1StateEvent[];
    diagrams?: J5ClientV1Diagram[];
    summarySchemas?: string[];
}

export interface J5ClientV1StateEvent {
    // pattern: ^[a-z][a-z0-9_]+$
    name?: string;
    fullName: string;
    description?: string;
}

export interface J5DrssV1StepMeta {
    stepId?: string;
    name?: string;
    status?: J5DrssV1StepStatus;
    error?: string;
    dependsOn?: string[];
}

export interface J5DrssV1StepResult {
    stepId?: string;
    status?: J5DrssV1StepStatus;
    error?: string;
}

export enum J5DrssV1StepStatus {
    Unspecified = 'UNSPECIFIED',
    Blocked = 'BLOCKED',
    Ready = 'READY',
    Active = 'ACTIVE',
    Done = 'DONE',
    Failed = 'FAILED'
}

export interface J5ListV1And<TFilterField extends string = never> {
    filters?: J5ListV1Filter<TFilterField>[];
}

export interface J5ListV1AnyRules {
    filtering?: J5ListV1FilteringConstraint;
}

export interface J5ListV1BoolRules {
    filtering?: J5ListV1FilteringConstraint;
}

export interface J5ListV1DateRules {
    filtering?: J5ListV1FilteringConstraint;
    sorting?: J5ListV1SortingConstraint;
}

export interface J5ListV1DecimalRules {
    filtering?: J5ListV1FilteringConstraint;
    sorting?: J5ListV1SortingConstraint;
}

export interface J5ListV1EnumRules {
    filtering?: J5ListV1FilteringConstraint;
}

export interface J5ListV1Field<TFilterField extends string = never> {
    name?: TFilterField;
    type: J5ListV1FieldType;
}

export type J5ListV1FieldType = {
    '!type'?: 'value';
    value: string;
} | {
    '!type'?: 'range';
    range: J5ListV1Range;
} | {
    '!type'?: 'in';
    in: J5ListV1Values;
};

export const J5_LIST_V1_FIELD_TYPE_ONE_OF_VALUES = ['value', 'range', 'in'] as const;

export type J5ListV1FieldTypeOneOfValue = (typeof J5_LIST_V1_FIELD_TYPE_ONE_OF_VALUES)[number];

export type J5ListV1Filter<TFilterField extends string = never> = {
    '!type'?: 'field';
    field: J5ListV1Field<TFilterField>;
} | {
    '!type'?: 'and';
    and: J5ListV1And<TFilterField>;
} | {
    '!type'?: 'or';
    or: J5ListV1Or<TFilterField>;
};

export interface J5ListV1FilteringConstraint {
    filterable?: boolean;
    defaultFilters?: string[];
    indexed?: boolean;
}

export const J5_LIST_V1_FILTER_ONE_OF_VALUES = ['field', 'and', 'or'] as const;

export type J5ListV1FilterOneOfValue = (typeof J5_LIST_V1_FILTER_ONE_OF_VALUES)[number];

export interface J5ListV1FloatRules {
    filtering?: J5ListV1FilteringConstraint;
    sorting?: J5ListV1SortingConstraint;
}

export interface J5ListV1IntegerRules {
    filtering?: J5ListV1FilteringConstraint;
    sorting?: J5ListV1SortingConstraint;
}

export interface J5ListV1KeyRules {
    filtering?: J5ListV1FilteringConstraint;
    searching?: J5ListV1SearchingConstraint;
}

export interface J5ListV1ListRequestMessage {
    defaultSort?: string[];
    sortTiebreaker?: string[];
}

export interface J5ListV1OneofRules {
    filtering?: J5ListV1FilteringConstraint;
}

export interface J5ListV1OpenTextRules {
    searching?: J5ListV1SearchingConstraint;
}

export interface J5ListV1Or<TFilterField extends string = never> {
    filters?: J5ListV1Filter<TFilterField>[];
}

export interface J5ListV1PageRequest {
    token?: string;
    // format: INT64
    pageSize?: string;
}

export interface J5ListV1PageResponse {
    nextToken?: string;
}

export interface J5ListV1PolymorphRules {
    filtering?: J5ListV1FilteringConstraint;
}

export interface J5ListV1QueryRequest<TSearchField extends string = never, TSortField extends string = never, TFilterField extends string = never> {
    searches?: J5ListV1Search<TSearchField>[];
    sorts?: J5ListV1Sort<TSortField>[];
    filters?: J5ListV1Filter<TFilterField>[];
}

export interface J5ListV1Range {
    min?: string;
    max?: string;
}

export interface J5ListV1Search<TSearchField extends string = never> {
    field?: TSearchField;
    value?: string;
    wholeWord?: boolean;
}

export interface J5ListV1SearchingConstraint {
    searchable?: boolean;
    fieldIdentifier?: string;
}

export interface J5ListV1Sort<TSortField extends string = never> {
    field?: TSortField;
    descending?: boolean;
}

export interface J5ListV1SortingConstraint {
    sortable?: boolean;
}

export interface J5ListV1TimestampRules {
    filtering?: J5ListV1FilteringConstraint;
    sorting?: J5ListV1SortingConstraint;
}

export interface J5ListV1Values {
    values?: string[];
}

export interface J5MessagingV1MessageCause {
    method: string;
    messageId?: string;
    sourceApp?: string;
    sourceEnv?: string;
}

export interface J5MessagingV1RequestMetadata {
    replyTo?: string;
    // bytes (base64-encoded)
    context?: string;
}

export interface J5RegistryV1ArtifactCommandServiceArtifactDownloadArtifactDownloadRequest {
    owner: string;
    version: string;
    bundle: string;
    name: string;
}

export interface J5RegistryV1ArtifactData {
    /* The type of artifact */
    type: J5RegistryV1Type;
    /* The MIME type of the artifact */
    contentType: string;
    /* The human-readable identifier for the artifact */
    label: string;
    /* The storage key of the artifact */
    storageKey: string;
    /* The index of the artifact within the bundle */
    // format: UINT32
    bundleIndex?: number;
}

export interface J5RegistryV1ArtifactEvent extends IxmUserauthV1ArtifactKeys {
    metadata: J5StateV1EventMetadata;
    /* The owner of the artifact */
    // format: custom - pattern: ^[0-9A-Za-z_.-]+$
    owner: string;
    /* The version of the artifact */
    // format: custom - pattern: ^[0-9a-f]{40}$
    version: string;
    /* The bundle this artifact belongs to. (e.g. guides,
    getting-started) */
    // format: custom - pattern: ^[0-9A-Za-z_.-]+$
    bundle: string;
    /* The unique identifier for the artifact within the bundle */
    // format: custom - pattern: ^[0-9A-Za-z_.-]+$
    name: string;
    event: J5RegistryV1ArtifactEventType;
}

export type J5RegistryV1ArtifactEventType = {
    '!type'?: 'uploaded';
    uploaded: J5RegistryV1ArtifactEventTypeUploaded;
};

export interface J5RegistryV1ArtifactEventTypeUploaded {
    type: J5RegistryV1Type;
    contentType: string;
    label: string;
    storageKey: string;
    // format: UINT32
    bundleIndex?: number;
}

export const J5_REGISTRY_V1_ARTIFACT_EVENT_TYPE_ONE_OF_VALUES = ['uploaded'] as const;

export type J5RegistryV1ArtifactEventTypeOneOfValue = (typeof J5_REGISTRY_V1_ARTIFACT_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface J5RegistryV1ArtifactKeys {
    /* The owner of the artifact */
    // format: custom - pattern: ^[0-9A-Za-z_.-]+$
    owner: string;
    /* The version of the artifact */
    // format: custom - pattern: ^[0-9a-f]{40}$
    version: string;
    /* The bundle this artifact belongs to. (e.g. guides,
    getting-started) */
    // format: custom - pattern: ^[0-9A-Za-z_.-]+$
    bundle: string;
    /* The unique identifier for the artifact within the bundle */
    // format: custom - pattern: ^[0-9A-Za-z_.-]+$
    name: string;
}

export interface J5RegistryV1ArtifactQueryServiceArtifactEventsArtifactEventsRequest {
    /* The owner of the artifact */
    // format: custom - pattern: ^[0-9A-Za-z_.-]+$
    owner: string;
    /* The version of the artifact */
    // format: custom - pattern: ^[0-9a-f]{40}$
    version: string;
    /* The bundle this artifact belongs to. (e.g. guides,
    getting-started) */
    // format: custom - pattern: ^[0-9A-Za-z_.-]+$
    bundle: string;
    /* The unique identifier for the artifact within the bundle */
    // format: custom - pattern: ^[0-9A-Za-z_.-]+$
    name: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, J5RegistryV1ArtifactQueryServiceArtifactEventsSortableFields, J5RegistryV1ArtifactQueryServiceArtifactEventsFilterableFields>;
}

export enum J5RegistryV1ArtifactQueryServiceArtifactEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    Owner = 'owner',
    Version = 'version',
    Bundle = 'bundle',
    Name = 'name',
    EventType = 'event.!type'
}

export enum J5RegistryV1ArtifactQueryServiceArtifactEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface J5RegistryV1ArtifactQueryServiceArtifactGetArtifactGetRequest {
    /* The owner of the artifact */
    // format: custom - pattern: ^[0-9A-Za-z_.-]+$
    owner: string;
    /* The version of the artifact */
    // format: custom - pattern: ^[0-9a-f]{40}$
    version: string;
    /* The bundle this artifact belongs to. (e.g. guides,
    getting-started) */
    // format: custom - pattern: ^[0-9A-Za-z_.-]+$
    bundle: string;
    /* The unique identifier for the artifact within the bundle */
    // format: custom - pattern: ^[0-9A-Za-z_.-]+$
    name: string;
}

export interface J5RegistryV1ArtifactQueryServiceArtifactListArtifactListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<J5RegistryV1ArtifactQueryServiceArtifactListSearchableFields, J5RegistryV1ArtifactQueryServiceArtifactListSortableFields, J5RegistryV1ArtifactQueryServiceArtifactListFilterableFields>;
}

export enum J5RegistryV1ArtifactQueryServiceArtifactListFilterableFields {
    Owner = 'owner',
    Version = 'version',
    Bundle = 'bundle',
    Name = 'name',
    DataType = 'data.type',
    Status = 'status'
}

export enum J5RegistryV1ArtifactQueryServiceArtifactListSearchableFields {
    DataContentType = 'data.contentType'
}

export enum J5RegistryV1ArtifactQueryServiceArtifactListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt',
    DataBundleIndex = 'data.bundleIndex'
}

export interface J5RegistryV1ArtifactState extends J5RegistryV1ArtifactKeys {
    metadata: J5StateV1StateMetadata;
    data: J5RegistryV1ArtifactData;
    status: J5RegistryV1ArtifactStatus;
}

export enum J5RegistryV1ArtifactStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE'
}

export interface J5RegistryV1DownloadServiceDownloadClientApiDownloadClientApiRequest {
    owner: string;
    name: string;
    version: string;
}

export interface J5RegistryV1DownloadServiceDownloadClientApiPackageDownloadClientApiPackageRequest {
    owner: string;
    name: string;
    version: string;
    package: string;
}

export interface J5RegistryV1DownloadServiceDownloadImageDownloadImageRequest {
    owner: string;
    name: string;
    version: string;
}

export interface J5RegistryV1DownloadServiceDownloadSwaggerDownloadSwaggerRequest {
    owner: string;
    name: string;
    version: string;
}

export interface J5RegistryV1DownloadServiceListPackagesListPackagesRequest {
    version: string;
    owner: string;
    name: string;
}

export enum J5RegistryV1Type {
    Unspecified = 'UNSPECIFIED',
    Document = 'DOCUMENT',
    Diagram = 'DIAGRAM'
}

export interface J5SchemaV1AnyField {
    listRules?: J5ListV1AnyRules;
}

export interface J5SchemaV1ArrayField {
    rules?: J5SchemaV1ArrayFieldRules;
    items?: J5SchemaV1Field;
    ext?: J5SchemaV1ArrayFieldExt;
}

export interface J5SchemaV1ArrayFieldExt {
    singleForm?: string;
    preserveWhitespace?: boolean;
}

export interface J5SchemaV1ArrayFieldRules {
    // format: UINT64
    minItems?: string;
    // format: UINT64
    maxItems?: string;
    uniqueItems?: boolean;
}

export interface J5SchemaV1BoolField {
    rules?: J5SchemaV1BoolFieldRules;
    listRules?: J5ListV1BoolRules;
    ext?: EmptyObject;
}

export interface J5SchemaV1BoolFieldRules {
    const?: boolean;
}

export interface J5SchemaV1BytesField {
    rules?: J5SchemaV1BytesFieldRules;
    ext?: EmptyObject;
}

export interface J5SchemaV1BytesFieldRules {
    // format: UINT64
    minLength?: string;
    // format: UINT64
    maxLength?: string;
}

export interface J5SchemaV1DateField {
    rules?: J5SchemaV1DateFieldRules;
    listRules?: J5ListV1DateRules;
    ext?: EmptyObject;
}

export interface J5SchemaV1DateFieldRules {
    minimum?: string;
    maximum?: string;
    exclusiveMinimum?: boolean;
    exclusiveMaximum?: boolean;
}

export interface J5SchemaV1DecimalField {
    rules?: J5SchemaV1DecimalFieldRules;
    listRules?: J5ListV1DecimalRules;
    ext?: EmptyObject;
}

export interface J5SchemaV1DecimalFieldRules {
    minimum?: string;
    maximum?: string;
    exclusiveMinimum?: boolean;
    exclusiveMaximum?: boolean;
}

export interface J5SchemaV1EntityKey {
    primary?: boolean;
    shardKey?: boolean;
    tenant?: string;
}

export interface J5SchemaV1EntityObject {
    // pattern: ^[A-Z][a-zA-Z0-9]*$
    entity?: string;
    part?: J5SchemaV1EntityPart;
}

export enum J5SchemaV1EntityPart {
    Unspecified = 'UNSPECIFIED',
    Keys = 'KEYS',
    State = 'STATE',
    Event = 'EVENT',
    Data = 'DATA',
    References = 'REFERENCES',
    Derived = 'DERIVED',
    Status = 'STATUS',
    Summary = 'SUMMARY'
}

export interface J5SchemaV1EntityRef {
    package?: string;
    entity?: string;
}

export interface J5SchemaV1Enum {
    // pattern: ^[A-Z][a-zA-Z0-9]*$
    name?: string;
    description?: string;
    prefix?: string;
    options?: J5SchemaV1EnumOption[];
    info?: J5SchemaV1EnumOptionInfoField[];
    entity?: J5SchemaV1EntityObject;
}

export interface J5SchemaV1EnumOption {
    name?: string;
    // format: INT32
    number?: number;
    description?: string;
    info?: Record<string, string>;
}

export interface J5SchemaV1EnumOptionInfoField {
    name?: string;
    label?: string;
    description?: string;
}

export interface J5SchemaV1EnumField {
    ref?: J5SchemaV1Ref;
    enum?: J5SchemaV1Enum;
    rules?: J5SchemaV1EnumFieldRules;
    listRules?: J5ListV1EnumRules;
    ext?: EmptyObject;
}

export interface J5SchemaV1EnumFieldRules {
    in?: string[];
    notIn?: string[];
}

export type J5SchemaV1Field = {
    '!type'?: 'any';
    any: J5SchemaV1AnyField;
} | {
    '!type'?: 'oneof';
    oneof: J5SchemaV1OneofField;
} | {
    '!type'?: 'object';
    object: J5SchemaV1ObjectField;
} | {
    '!type'?: 'polymorph';
    polymorph: J5SchemaV1PolymorphField;
} | {
    '!type'?: 'enum';
    enum: J5SchemaV1EnumField;
} | {
    '!type'?: 'array';
    array: J5SchemaV1ArrayField;
} | {
    '!type'?: 'map';
    map: J5SchemaV1MapField;
} | {
    '!type'?: 'string';
    string: J5SchemaV1StringField;
} | {
    '!type'?: 'integer';
    integer: J5SchemaV1IntegerField;
} | {
    '!type'?: 'float';
    float: J5SchemaV1FloatField;
} | {
    '!type'?: 'bool';
    bool: J5SchemaV1BoolField;
} | {
    '!type'?: 'bytes';
    bytes: J5SchemaV1BytesField;
} | {
    '!type'?: 'decimal';
    decimal: J5SchemaV1DecimalField;
} | {
    '!type'?: 'date';
    date: J5SchemaV1DateField;
} | {
    '!type'?: 'timestamp';
    timestamp: J5SchemaV1TimestampField;
} | {
    '!type'?: 'key';
    key: J5SchemaV1KeyField;
};

export const J5_SCHEMA_V1_FIELD_ONE_OF_VALUES = ['any', 'oneof', 'object', 'polymorph', 'enum', 'array', 'map', 'string', 'integer', 'float', 'bool', 'bytes', 'decimal', 'date', 'timestamp', 'key'] as const;

export type J5SchemaV1FieldOneOfValue = (typeof J5_SCHEMA_V1_FIELD_ONE_OF_VALUES)[number];

export interface J5SchemaV1FloatField {
    format?: J5SchemaV1FloatFieldFormat;
    rules?: J5SchemaV1FloatFieldRules;
    listRules?: J5ListV1FloatRules;
    ext?: EmptyObject;
}

export enum J5SchemaV1FloatFieldFormat {
    Unspecified = 'UNSPECIFIED',
    Float32 = 'FLOAT32',
    Float64 = 'FLOAT64'
}

export interface J5SchemaV1FloatFieldRules {
    exclusiveMaximum?: boolean;
    exclusiveMinimum?: boolean;
    // format: FLOAT64
    minimum?: number;
    // format: FLOAT64
    maximum?: number;
    // format: FLOAT64
    multipleOf?: number;
}

export enum J5SchemaV1HttpMethod {
    Unspecified = 'UNSPECIFIED',
    Get = 'GET',
    Post = 'POST',
    Put = 'PUT',
    Delete = 'DELETE',
    Patch = 'PATCH'
}

export interface J5SchemaV1IntegerField {
    format: J5SchemaV1IntegerFieldFormat;
    rules?: J5SchemaV1IntegerFieldRules;
    listRules?: J5ListV1IntegerRules;
    ext?: EmptyObject;
}

export enum J5SchemaV1IntegerFieldFormat {
    Unspecified = 'UNSPECIFIED',
    Int32 = 'INT32',
    Int64 = 'INT64',
    Uint32 = 'UINT32',
    Uint64 = 'UINT64'
}

export interface J5SchemaV1IntegerFieldRules {
    exclusiveMaximum?: boolean;
    exclusiveMinimum?: boolean;
    // format: INT64
    minimum?: string;
    // format: INT64
    maximum?: string;
    // format: INT64
    multipleOf?: string;
}

export interface J5SchemaV1KeyField {
    rules?: EmptyObject;
    format?: J5SchemaV1KeyFormat;
    listRules?: J5ListV1KeyRules;
    ext?: J5SchemaV1KeyFieldExt;
    entity?: J5SchemaV1KeyFieldDeprecatedEntityKey;
}

export type J5SchemaV1KeyFieldDeprecatedEntityKey = {
    '!type'?: 'primaryKey';
    primaryKey: boolean;
} | {
    '!type'?: 'foreignKey';
    foreignKey: J5SchemaV1EntityRef;
};

export const J5_SCHEMA_V1_KEY_FIELD_DEPRECATED_ENTITY_KEY_ONE_OF_VALUES = ['primaryKey', 'foreignKey'] as const;

export type J5SchemaV1KeyFieldDeprecatedEntityKeyOneOfValue = (typeof J5_SCHEMA_V1_KEY_FIELD_DEPRECATED_ENTITY_KEY_ONE_OF_VALUES)[number];

export interface J5SchemaV1KeyFieldExt {
    foreign?: J5SchemaV1EntityRef;
}

export type J5SchemaV1KeyFormat = {
    '!type'?: 'informal';
    informal: EmptyObject;
} | {
    '!type'?: 'custom';
    custom: J5SchemaV1KeyFormatCustom;
} | {
    '!type'?: 'uuid';
    uuid: EmptyObject;
} | {
    '!type'?: 'id62';
    id62: EmptyObject;
} | {
    '!type'?: 'named';
    named: J5SchemaV1KeyFormatNamed;
};

export interface J5SchemaV1KeyFormatCustom {
    pattern: string;
    description?: string;
}

export interface J5SchemaV1KeyFormatNamed {
    ref?: J5SchemaV1Ref;
}

export const J5_SCHEMA_V1_KEY_FORMAT_ONE_OF_VALUES = ['informal', 'custom', 'uuid', 'id62', 'named'] as const;

export type J5SchemaV1KeyFormatOneOfValue = (typeof J5_SCHEMA_V1_KEY_FORMAT_ONE_OF_VALUES)[number];

export interface J5SchemaV1MapField {
    itemSchema?: J5SchemaV1Field;
    keySchema?: J5SchemaV1Field;
    rules?: J5SchemaV1MapFieldRules;
    ext?: J5SchemaV1MapFieldExt;
}

export interface J5SchemaV1MapFieldExt {
    singleForm?: string;
}

export interface J5SchemaV1MapFieldRules {
    // format: UINT64
    minPairs?: string;
    // format: UINT64
    maxPairs?: string;
}

export type J5SchemaV1MethodType = {
    '!type'?: 'stateQuery';
    stateQuery: J5SchemaV1MethodTypeStateQuery;
};

export interface J5SchemaV1MethodTypeStateQuery {
    entityName?: string;
    queryPart?: J5SchemaV1StateQueryPart;
}

export const J5_SCHEMA_V1_METHOD_TYPE_ONE_OF_VALUES = ['stateQuery'] as const;

export type J5SchemaV1MethodTypeOneOfValue = (typeof J5_SCHEMA_V1_METHOD_TYPE_ONE_OF_VALUES)[number];

export interface J5SchemaV1Object {
    // pattern: ^(|[A-Z][a-zA-Z0-9]*)$
    name?: string;
    description?: string;
    entity?: J5SchemaV1EntityObject;
    properties?: J5SchemaV1ObjectProperty[];
    polymorphMember?: string[];
    bcl?: J5BclV1Block;
}

export interface J5SchemaV1ObjectField {
    ref?: J5SchemaV1Ref;
    object?: J5SchemaV1Object;
    rules?: J5SchemaV1ObjectFieldRules;
    ext?: EmptyObject;
    flatten?: boolean;
    entity?: J5SchemaV1ObjectFieldEntityJoin;
}

export interface J5SchemaV1ObjectFieldEntityJoin {
    entity?: J5SchemaV1EntityRef;
    entityPart?: J5SchemaV1EntityPart;
}

export interface J5SchemaV1ObjectFieldRules {
    // format: UINT64
    minProperties?: string;
    // format: UINT64
    maxProperties?: string;
}

export interface J5SchemaV1ObjectProperty {
    schema?: J5SchemaV1Field;
    // pattern: ^[a-z][a-zA-Z0-9]*$
    name?: string;
    required?: boolean;
    explicitlyOptional?: boolean;
    description?: string;
    entityKey?: J5SchemaV1EntityKey;
}

export interface J5SchemaV1Oneof {
    // pattern: ^(|[A-Z][a-zA-Z0-9]*)$
    name?: string;
    description?: string;
    bcl?: J5BclV1Block;
    properties?: J5SchemaV1ObjectProperty[];
}

export interface J5SchemaV1OneofField {
    ref?: J5SchemaV1Ref;
    oneof?: J5SchemaV1Oneof;
    rules?: EmptyObject;
    listRules?: J5ListV1OneofRules;
    ext?: EmptyObject;
}

export interface J5SchemaV1Polymorph {
    name?: string;
    description?: string;
    members?: string[];
}

export interface J5SchemaV1PolymorphField {
    ref?: J5SchemaV1Ref;
    polymorph?: J5SchemaV1Polymorph;
    rules?: EmptyObject;
    listRules?: J5ListV1PolymorphRules;
    ext?: EmptyObject;
}

export interface J5SchemaV1Ref {
    package?: string;
    schema?: string;
}

export type J5SchemaV1RootSchema = {
    '!type'?: 'oneof';
    oneof: J5SchemaV1Oneof;
} | {
    '!type'?: 'object';
    object: J5SchemaV1Object;
} | {
    '!type'?: 'enum';
    enum: J5SchemaV1Enum;
} | {
    '!type'?: 'polymorph';
    polymorph: J5SchemaV1Polymorph;
};

export const J5_SCHEMA_V1_ROOT_SCHEMA_ONE_OF_VALUES = ['oneof', 'object', 'enum', 'polymorph'] as const;

export type J5SchemaV1RootSchemaOneOfValue = (typeof J5_SCHEMA_V1_ROOT_SCHEMA_ONE_OF_VALUES)[number];

export enum J5SchemaV1StateQueryPart {
    Unspecified = 'UNSPECIFIED',
    Get = 'GET',
    List = 'LIST',
    ListEvents = 'LIST_EVENTS'
}

export interface J5SchemaV1StringField {
    format?: string;
    rules?: J5SchemaV1StringFieldRules;
    listRules?: J5ListV1OpenTextRules;
    ext?: J5SchemaV1StringFieldExt;
}

export interface J5SchemaV1StringFieldExt {
    preserveWhitespace?: boolean;
}

export interface J5SchemaV1StringFieldRules {
    pattern?: string;
    // format: UINT64
    minLength?: string;
    // format: UINT64
    maxLength?: string;
}

export interface J5SchemaV1TimestampField {
    rules?: J5SchemaV1TimestampFieldRules;
    listRules?: J5ListV1TimestampRules;
    ext?: EmptyObject;
}

export interface J5SchemaV1TimestampFieldRules {
    // format: date-time
    minimum?: string;
    // format: date-time
    maximum?: string;
    exclusiveMinimum?: boolean;
    exclusiveMaximum?: boolean;
}

export type J5StateV1Cause = {
    '!type'?: 'psmEvent';
    psmEvent: J5StateV1PsmEventCause;
} | {
    '!type'?: 'command';
    command: J5AuthV1Action;
} | {
    '!type'?: 'message';
    message: J5MessagingV1MessageCause;
} | {
    '!type'?: 'externalEvent';
    externalEvent: J5StateV1ExternalEventCause;
} | {
    '!type'?: 'init';
    init: EmptyObject;
};

export const J5_STATE_V1_CAUSE_ONE_OF_VALUES = ['psmEvent', 'command', 'message', 'externalEvent', 'init'] as const;

export type J5StateV1CauseOneOfValue = (typeof J5_STATE_V1_CAUSE_ONE_OF_VALUES)[number];

export interface J5StateV1EventMetadata {
    eventId?: string;
    // format: UINT64
    sequence?: string;
    // format: date-time
    timestamp: string;
    cause?: J5StateV1Cause;
}

export interface J5StateV1ExternalEventCause {
    systemName?: string;
    eventName?: string;
    externalId?: string;
}

export interface J5StateV1PsmEventCause {
    eventId?: string;
    stateMachine?: string;
}

export interface J5StateV1StateMetadata {
    // format: date-time
    createdAt?: string;
    // format: date-time
    updatedAt?: string;
    // format: UINT64
    lastSequence?: string;
}

export interface O5ApplicationV1Application {
    // pattern: ^[a-z][a-z0-9]+$
    name?: string;
    targets?: O5ApplicationV1Target[];
    blobstores?: O5ApplicationV1Blobstore[];
    databases?: O5ApplicationV1Database[];
    runtimes?: O5ApplicationV1Runtime[];
    secrets?: O5ApplicationV1Secret[];
    serviceDiscovery?: O5ApplicationV1ServiceDiscovery;
}

export interface O5ApplicationV1Blobstore {
    name?: string;
    grants?: O5ApplicationV1Grant[];
    /* The blobstore is a reference to a one owned by another application, it
    will not be created in the stack for the current application, but
    permissions will be granted. */
    ref?: O5ApplicationV1BlobstoreRef;
    /* Specifies whether the bucket is configured to emit events to the default
    event bus. Will have no impact if the blobstore is a reference. */
    emitEvents?: boolean;
    /* Blobstore should expose an SFTP endpoint. Will not make changes if the
    blobstore is a reference. */
    sftpSettings?: O5ApplicationV1SftpSettings;
}

export interface O5ApplicationV1BlobstoreEnvVar {
    name?: string;
    subPath?: string;
    format: O5ApplicationV1BlobstoreEnvVarFormat;
}

export type O5ApplicationV1BlobstoreEnvVarFormat = {
    '!type'?: 's3Direct';
    /* Sets the variable as s3://<bucket>/<?sub_path> TODO: Deprecate this
    and build a wrapper through the sidecar */
    s3Direct: boolean;
};

export const O5_APPLICATION_V1_BLOBSTORE_ENV_VAR_FORMAT_ONE_OF_VALUES = ['s3Direct'] as const;

export type O5ApplicationV1BlobstoreEnvVarFormatOneOfValue = (typeof O5_APPLICATION_V1_BLOBSTORE_ENV_VAR_FORMAT_ONE_OF_VALUES)[number];

export interface O5ApplicationV1BlobstoreRef {
    /* This application is allowed to read from the bucket. Default is true
    unless write_permission is true. */
    readPermission?: boolean;
    /* This application is allowed to write to the bucket. Does not imply
    read_permissions. Default is false. */
    writePermission?: boolean;
    source: O5ApplicationV1BlobstoreRefSource;
}

export type O5ApplicationV1BlobstoreRefSource = {
    '!type'?: 'bucketName';
    /* Full name of the 'bucket' for the blobstore, does not follow any
    patterns. */
    bucketName: string;
} | {
    '!type'?: 'application';
    application: O5ApplicationV1BlobstoreRefSourceApplication;
};

export interface O5ApplicationV1BlobstoreRefSourceApplication {
    /* `application.name` for an app in the specified environment (if
    unspecified, defaults to the application's environment) */
    name: string;
    /* The 'lookupName' of the environment the blobstore is in, if
    different from the application's environment. Note, the
    environment must have a `lookupName` set in its links for this to
    work. Default is current environment. */
    env?: string;
}

export const O5_APPLICATION_V1_BLOBSTORE_REF_SOURCE_ONE_OF_VALUES = ['bucketName', 'application'] as const;

export type O5ApplicationV1BlobstoreRefSourceOneOfValue = (typeof O5_APPLICATION_V1_BLOBSTORE_REF_SOURCE_ONE_OF_VALUES)[number];

export interface O5ApplicationV1Container {
    name?: string;
    source?: O5ApplicationV1ContainerSource;
    command?: string[];
    /* The amount of Memory and CPU to allocate to the container */
    demand?: O5ApplicationV1Demand;
    envVars?: O5ApplicationV1EnvironmentVariable[];
    /* gives access to /var/run/docker.sock in the container */
    mountDockerSocket?: boolean;
    // format: UINT32
    ports?: number[];
}

export interface O5ApplicationV1ContainerImage {
    name?: string;
    /* Defaults to the full git hash being deployed (or passed in
    --version parameter) */
    tag?: string;
    /* Defaults to the environment's registry, set here to override */
    registry?: string;
}

export type O5ApplicationV1ContainerSource = {
    '!type'?: 'imageUrl';
    imageUrl: string;
} | {
    '!type'?: 'image';
    image: O5ApplicationV1ContainerImage;
};

export const O5_APPLICATION_V1_CONTAINER_SOURCE_ONE_OF_VALUES = ['imageUrl', 'image'] as const;

export type O5ApplicationV1ContainerSourceOneOfValue = (typeof O5_APPLICATION_V1_CONTAINER_SOURCE_ONE_OF_VALUES)[number];

export interface O5ApplicationV1Database {
    name?: string;
    engine?: O5ApplicationV1DatabaseEngine;
}

export type O5ApplicationV1DatabaseEngine = {
    '!type'?: 'postgres';
    postgres: O5ApplicationV1DatabasePostgres;
};

export const O5_APPLICATION_V1_DATABASE_ENGINE_ONE_OF_VALUES = ['postgres'] as const;

export type O5ApplicationV1DatabaseEngineOneOfValue = (typeof O5_APPLICATION_V1_DATABASE_ENGINE_ONE_OF_VALUES)[number];

export interface O5ApplicationV1DatabasePostgres {
    /* The name of the database within the postgres instance, default is the
    name in the parent message. This is prefixed with
    {env_name}_{app_name}_ in all cases. */
    dbNameSuffix?: string;
    /* DEPRECATED: use db_name_suffix */
    dbName?: string;
    /* default is 'default' - identifies which database server from the
    environment config this belongs with. Matches
    o5.environment.v1.RDSHost.server_group_name */
    serverGroup?: string;
    dbExtensions?: string[];
    migrateContainer?: O5ApplicationV1Container;
    runOutbox?: boolean;
    runInbox?: boolean;
}

export interface O5ApplicationV1DatabaseEnvVar {
    /* references a database in the top level array */
    databaseName?: string;
}

export enum O5ApplicationV1Demand {
    Unspecified = 'UNSPECIFIED',
    Light = 'LIGHT',
    Medium = 'MEDIUM',
    Heavy = 'HEAVY'
}

export enum O5ApplicationV1DiscoveryRecordType {
    Unspecified = 'UNSPECIFIED',
    Srv = 'SRV',
    A = 'A'
}

export interface O5ApplicationV1DiscoveryRuntime {
    name?: string;
    container?: string;
    // format: UINT32
    port?: number;
    /* DNS record type for Cloud Map registration. SRV (default): bridge
    networking, dynamic host port — requires ContainerPort+ContainerName in
    ServiceRegistries. A: awsvpc networking, fixed container port — task
    gets its own ENI and Cloud Map registers a plain A record (low TTL).
    ServiceRegistries uses RegistryArn only. */
    recordType?: O5ApplicationV1DiscoveryRecordType;
}

export interface O5ApplicationV1EnvironmentVariable {
    name?: string;
    spec?: O5ApplicationV1EnvironmentVariableSpec;
}

export type O5ApplicationV1EnvironmentVariableSpec = {
    '!type'?: 'value';
    value: string;
} | {
    '!type'?: 'database';
    database: O5ApplicationV1DatabaseEnvVar;
} | {
    '!type'?: 'blobstore';
    blobstore: O5ApplicationV1BlobstoreEnvVar;
} | {
    '!type'?: 'envMap';
    envMap: EmptyObject;
} | {
    '!type'?: 'fromEnv';
    fromEnv: O5ApplicationV1EnvironmentVariableSpecFromEnv;
} | {
    '!type'?: 'secret';
    secret: O5ApplicationV1SecretEnvVar;
} | {
    '!type'?: 'o5';
    o5: O5ApplicationV1O5Var;
};

export interface O5ApplicationV1EnvironmentVariableSpecFromEnv {
    name?: string;
}

export const O5_APPLICATION_V1_ENVIRONMENT_VARIABLE_SPEC_ONE_OF_VALUES = ['value', 'database', 'blobstore', 'envMap', 'fromEnv', 'secret', 'o5'] as const;

export type O5ApplicationV1EnvironmentVariableSpecOneOfValue = (typeof O5_APPLICATION_V1_ENVIRONMENT_VARIABLE_SPEC_ONE_OF_VALUES)[number];

export interface O5ApplicationV1Grant {
    /* This is a lookup in the env file */
    principal?: string;
}

export interface O5ApplicationV1MetricsConfig {
    /* Enables the sidecar metrics scrape and push loop */
    enabled?: boolean;
    /* Port on which the app container exposes /metrics. Default: 9090 */
    // format: UINT32
    port?: number;
    /* Name of the container to scrape. Default: first container in the runtime */
    container?: string;
}

export enum O5ApplicationV1O5Var {
    Unspecified = 'UNSPECIFIED',
    AdapterEndpoint = 'ADAPTER_ENDPOINT'
}

export interface O5ApplicationV1Route {
    /* Default is not to filter, but requires the route_group to be FALLBACK */
    prefix?: string;
    /* For envifonments which support subdomains, this becomes the prefix on the
    domain filter. Wildcards are supported. */
    subdomains?: string[];
    protocol: O5ApplicationV1RouteProtocol;
    /* Default: first defined container */
    targetContainer?: string;
    /* Default: false */
    bypassIngress?: boolean;
    /* Default: 8080 */
    // format: UINT32
    port?: number;
    /* Default: NORMAL */
    routeGroup?: O5ApplicationV1RouteGroup;
}

export enum O5ApplicationV1RouteGroup {
    Unspecified = 'UNSPECIFIED',
    First = 'FIRST',
    Normal = 'NORMAL',
    Fallback = 'FALLBACK'
}

export enum O5ApplicationV1RouteProtocol {
    Unspecified = 'UNSPECIFIED',
    Http = 'HTTP',
    Grpc = 'GRPC'
}

export interface O5ApplicationV1Runtime {
    // pattern: ^[a-z][a-z0-9]+$
    name?: string;
    /* When true, HTTP and gRPC requests will be routed directly to the runtime
    container, not via the ingress sidecar. The runtime container is
    responsible for all security, throttling etc. */
    directIngress?: boolean;
    containers?: O5ApplicationV1Container[];
    routes?: O5ApplicationV1Route[];
    subscriptions?: O5ApplicationV1Subscription[];
    triggers?: O5ApplicationV1Trigger[];
    workerConfig?: O5ApplicationV1WorkerConfig;
    metricsConfig?: O5ApplicationV1MetricsConfig;
    /* Attaches predefined policies to the runtime role which are defined by the
    platform-specific environment config (e.g.
    o5.environment.v1.NamedIAMPolicy for AWS) */
    namedEnvPolicies?: string[];
    /* Optional environment variables to set on the o5 sidecar container */
    sidecarConfig?: Record<string, string>;
}

export interface O5ApplicationV1Secret {
    name?: string;
}

export interface O5ApplicationV1SecretEnvVar {
    secretName?: string;
    jsonKey?: string;
}

export interface O5ApplicationV1ServiceDiscovery {
    enabled?: boolean;
    namespaceArnReference?: string;
    discoveryRuntimes?: Record<string, O5ApplicationV1DiscoveryRuntime>;
}

export interface O5ApplicationV1SftpSettings {
    users?: O5ApplicationV1SftpUser[];
}

export interface O5ApplicationV1SftpUser {
    username?: string;
    publicSshKey?: string;
}

export interface O5ApplicationV1Subscription {
    /* Filters the subscription.
    - `/{package}.{Service}` subscribes to a full gRPC service
    - `/{package}.{Service}/{Method}`  subscribes to the single method only
    - `o5-infra/{topic}` prefix subscribes to SNS directly.
    - `/global/{type}` subscribes to all messages of a given type
    -   type = 'event' - PSM State Transition events
    -   type = 'upsert' - Upsert messages
    - `s3://{blobstore_name}` subscribes to S3 events of all supported types
    - `s3://{blobstore_name}/{type}` subscribes to S3 events
    -   type = 'Object Created' - S3 Object Created events
    -   type = 'Object Deleted' - S3 Object Deleted events */
    name?: string;
    /* The 'lookupName' of the environment to subscribe to
    (o5.environment.v1.AWSLink.lookupName). Default is the current
    environment '*' means all environments in the deployment cluster. */
    envName?: string;
    /* Default: first defined container */
    targetContainer?: string;
    /* Default: 8080 */
    // format: UINT32
    port?: number;
    /* The payload is not the standard messaging payload It should be parsed
    into a o5.messaging.v1.topic.RawMessage Used for infrastructure messages,
    e.g. AWS EventBridge or CloudWatch events. Setting this in AWS will set
    'rawMessageDelivery' to *false*, i.e., the SNS wrapper will be included. */
    rawMessage?: boolean;
}

export interface O5ApplicationV1Target {
    name?: string;
}

export interface O5ApplicationV1Trigger {
    name: string;
    cron: string;
    messageData?: O5ApplicationV1TriggerMessageData;
    archived?: boolean;
}

export type O5ApplicationV1TriggerMessageData = {
    '!type'?: 'static';
    static: string;
};

export const O5_APPLICATION_V1_TRIGGER_MESSAGE_DATA_ONE_OF_VALUES = ['static'] as const;

export type O5ApplicationV1TriggerMessageDataOneOfValue = (typeof O5_APPLICATION_V1_TRIGGER_MESSAGE_DATA_ONE_OF_VALUES)[number];

export interface O5ApplicationV1WorkerConfig {
    /* chance percentage of sidecar behavior: replay message or process then
    treat as a deadletter */
    // format: INT64
    replayChance?: string;
    // format: INT64
    deadletterChance?: string;
    /* if true, sidecar will not send dead letter messages, should only be used
    for dead-letter handlers (e.g. dante) */
    noDeadletters?: boolean;
}

export interface O5AwsDeployerV1AuroraConnection {
    /* AWS API: 'Endpoint' - hostname without port. Used for connection and
    authentication tokens. */
    endpoint?: string;
    /* AWS API: 'Port' The port that the database engine is listening on. */
    // format: INT32
    port?: number;
    /* A username to use getting the token, which then also matches the user
    implementation of the engine. For root access, this could be the
    master_user but it only needs to be a user with the correct permissions. */
    dbUser?: string;
    /* defaults to the user's name. Used when accessing, not required for the
    token. */
    dbName?: string;
    identifier?: string;
}

export enum O5AwsDeployerV1CfChangesetLifecycle {
    Unspecified = 'UNSPECIFIED',
    Unavailable = 'UNAVAILABLE',
    Available = 'AVAILABLE',
    Execution = 'EXECUTION',
    Terminal = 'TERMINAL'
}

export enum O5AwsDeployerV1CfLifecycle {
    Unspecified = 'UNSPECIFIED',
    Progress = 'PROGRESS',
    Complete = 'COMPLETE',
    RollingBack = 'ROLLING_BACK',
    CreateFailed = 'CREATE_FAILED',
    Terminal = 'TERMINAL',
    RolledBack = 'ROLLED_BACK',
    Missing = 'MISSING'
}

export interface O5AwsDeployerV1CfStackInput {
    stackName?: string;
    template?: O5AwsDeployerV1TemplateType;
    parameters?: O5AwsDeployerV1CloudFormationStackParameter[];
    snsTopics?: string[];
    region?: string;
}

export interface O5AwsDeployerV1CfStackOutput {
    lifecycle?: O5AwsDeployerV1CfLifecycle;
    outputs?: O5AwsDeployerV1KeyValue[];
}

export interface O5AwsDeployerV1CloudFormationStackParameter {
    name?: string;
    source?: O5AwsDeployerV1CloudFormationStackParameterSource;
}

export type O5AwsDeployerV1CloudFormationStackParameterSource = {
    '!type'?: 'value';
    value: string;
} | {
    '!type'?: 'resolve';
    resolve: O5AwsDeployerV1CloudFormationStackParameterType;
};

export const O5_AWS_DEPLOYER_V1_CLOUD_FORMATION_STACK_PARAMETER_SOURCE_ONE_OF_VALUES = ['value', 'resolve'] as const;

export type O5AwsDeployerV1CloudFormationStackParameterSourceOneOfValue = (typeof O5_AWS_DEPLOYER_V1_CLOUD_FORMATION_STACK_PARAMETER_SOURCE_ONE_OF_VALUES)[number];

export type O5AwsDeployerV1CloudFormationStackParameterType = {
    '!type'?: 'rulePriority';
    rulePriority: O5AwsDeployerV1CloudFormationStackParameterTypeRulePriority;
};

export interface O5AwsDeployerV1CloudFormationStackParameterTypeRulePriority {
    routeGroup?: O5ApplicationV1RouteGroup;
}

export const O5_AWS_DEPLOYER_V1_CLOUD_FORMATION_STACK_PARAMETER_TYPE_ONE_OF_VALUES = ['rulePriority'] as const;

export type O5AwsDeployerV1CloudFormationStackParameterTypeOneOfValue = (typeof O5_AWS_DEPLOYER_V1_CLOUD_FORMATION_STACK_PARAMETER_TYPE_ONE_OF_VALUES)[number];

export interface O5AwsDeployerV1ClusterData {
    baseConfig?: O5EnvironmentV1Cluster;
    overrides?: O5AwsDeployerV1ParameterOverride[];
    /* config = baseConfig + overrides */
    config?: O5EnvironmentV1Cluster;
}

export interface O5AwsDeployerV1ClusterEvent extends O5AwsDeployerV1ClusterKeys {
    metadata: J5StateV1EventMetadata;
    event: O5AwsDeployerV1ClusterEventType;
}

export type O5AwsDeployerV1ClusterEventType = {
    '!type'?: 'configured';
    configured: O5AwsDeployerV1ClusterEventTypeConfigured;
} | {
    '!type'?: 'override';
    override: O5AwsDeployerV1ClusterEventTypeOverride;
};

export interface O5AwsDeployerV1ClusterEventTypeConfigured {
    config?: O5EnvironmentV1Cluster;
}

export interface O5AwsDeployerV1ClusterEventTypeOverride {
    overrides?: O5AwsDeployerV1ParameterOverride[];
}

export const O5_AWS_DEPLOYER_V1_CLUSTER_EVENT_TYPE_ONE_OF_VALUES = ['configured', 'override'] as const;

export type O5AwsDeployerV1ClusterEventTypeOneOfValue = (typeof O5_AWS_DEPLOYER_V1_CLUSTER_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface O5AwsDeployerV1ClusterKeys {
    // format: uuid
    clusterId: string;
}

export interface O5AwsDeployerV1ClusterQueryServiceClusterEventsClusterEventsRequest {
    // format: uuid
    clusterId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, O5AwsDeployerV1ClusterQueryServiceClusterEventsSortableFields, O5AwsDeployerV1ClusterQueryServiceClusterEventsFilterableFields>;
}

export enum O5AwsDeployerV1ClusterQueryServiceClusterEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    ClusterId = 'clusterId',
    EventType = 'event.!type'
}

export enum O5AwsDeployerV1ClusterQueryServiceClusterEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface O5AwsDeployerV1ClusterQueryServiceClusterGetClusterGetRequest {
    // format: uuid
    clusterId: string;
}

export interface O5AwsDeployerV1ClusterQueryServiceClusterListClusterListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, O5AwsDeployerV1ClusterQueryServiceClusterListSortableFields, O5AwsDeployerV1ClusterQueryServiceClusterListFilterableFields>;
}

export enum O5AwsDeployerV1ClusterQueryServiceClusterListFilterableFields {
    ClusterId = 'clusterId',
    Status = 'status'
}

export enum O5AwsDeployerV1ClusterQueryServiceClusterListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface O5AwsDeployerV1ClusterState extends O5AwsDeployerV1ClusterKeys {
    metadata: J5StateV1StateMetadata;
    data: O5AwsDeployerV1ClusterData;
    status: O5AwsDeployerV1ClusterStatus;
}

export enum O5AwsDeployerV1ClusterStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE'
}

export interface O5AwsDeployerV1DeploymentData {
    /* when set, publishes deployment events back to the requester */
    request?: J5MessagingV1RequestMetadata;
    spec: O5AwsDeployerV1DeploymentSpec;
    steps?: O5AwsDeployerV1DeploymentStep[];
}

export interface O5AwsDeployerV1DeploymentEvent extends O5AwsDeployerV1DeploymentKeys {
    metadata: J5StateV1EventMetadata;
    event: O5AwsDeployerV1DeploymentEventType;
}

export type O5AwsDeployerV1DeploymentEventType = {
    '!type'?: 'created';
    created: O5AwsDeployerV1DeploymentEventTypeCreated;
} | {
    '!type'?: 'triggered';
    triggered: EmptyObject;
} | {
    '!type'?: 'stackCreate';
    stackCreate: EmptyObject;
} | {
    '!type'?: 'stackWait';
    stackWait: EmptyObject;
} | {
    '!type'?: 'stackWaitFailure';
    stackWaitFailure: O5AwsDeployerV1DeploymentEventTypeStackWaitFailure;
} | {
    '!type'?: 'stackAvailable';
    stackAvailable: O5AwsDeployerV1DeploymentEventTypeStackAvailable;
} | {
    '!type'?: 'runSteps';
    runSteps: O5AwsDeployerV1DeploymentEventTypeRunSteps;
} | {
    '!type'?: 'stepResult';
    stepResult: O5AwsDeployerV1DeploymentEventTypeStepResult;
} | {
    '!type'?: 'runStep';
    runStep: O5AwsDeployerV1DeploymentEventTypeRunStep;
} | {
    '!type'?: 'error';
    error: O5AwsDeployerV1DeploymentEventTypeError;
} | {
    '!type'?: 'done';
    done: EmptyObject;
} | {
    '!type'?: 'terminated';
    terminated: EmptyObject;
};

export interface O5AwsDeployerV1DeploymentEventTypeCreated {
    request?: J5MessagingV1RequestMetadata;
    spec?: O5AwsDeployerV1DeploymentSpec;
}

export interface O5AwsDeployerV1DeploymentEventTypeError {
    error?: string;
}

export interface O5AwsDeployerV1DeploymentEventTypeRunStep {
    stepId?: string;
}

export interface O5AwsDeployerV1DeploymentEventTypeRunSteps {
    steps?: O5AwsDeployerV1DeploymentStep[];
}

export interface O5AwsDeployerV1DeploymentEventTypeStackAvailable {
    /* nil when no stack exists */
    stackOutput?: O5AwsDeployerV1CfStackOutput;
}

export interface O5AwsDeployerV1DeploymentEventTypeStackWaitFailure {
    error?: string;
}

export interface O5AwsDeployerV1DeploymentEventTypeStepResult {
    result?: J5DrssV1StepResult;
    output?: O5AwsDeployerV1StepOutputType;
}

export const O5_AWS_DEPLOYER_V1_DEPLOYMENT_EVENT_TYPE_ONE_OF_VALUES = ['created', 'triggered', 'stackCreate', 'stackWait', 'stackWaitFailure', 'stackAvailable', 'runSteps', 'stepResult', 'runStep', 'error', 'done', 'terminated'] as const;

export type O5AwsDeployerV1DeploymentEventTypeOneOfValue = (typeof O5_AWS_DEPLOYER_V1_DEPLOYMENT_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface O5AwsDeployerV1DeploymentFlags {
    cancelUpdates?: boolean;
    importResources?: boolean;
    /* Destory and recreate the database */
    recreateDatabase?: boolean;
}

export interface O5AwsDeployerV1DeploymentKeys {
    // format: uuid
    deploymentId: string;
    // format: uuid, entity: o5.aws.deployer.v1.Stack
    stackId: string;
    // format: uuid, entity: o5.aws.deployer.v1.Environment
    environmentId: string;
    // format: uuid, entity: o5.aws.deployer.v1.Cluster
    clusterId: string;
}

export interface O5AwsDeployerV1DeploymentQueryServiceDeploymentEventsDeploymentEventsRequest {
    // format: uuid
    deploymentId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, O5AwsDeployerV1DeploymentQueryServiceDeploymentEventsSortableFields, O5AwsDeployerV1DeploymentQueryServiceDeploymentEventsFilterableFields>;
}

export enum O5AwsDeployerV1DeploymentQueryServiceDeploymentEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    DeploymentId = 'deploymentId',
    StackId = 'stackId',
    EnvironmentId = 'environmentId',
    ClusterId = 'clusterId',
    EventCreatedSpecAppName = 'event.created.spec.appName',
    EventCreatedSpecSourceInlineApplicationDatabasesEnginePostgresMigrateContainerSourceType = 'event.created.spec.source.inline.application.databases.engine.postgres.migrateContainer.source.!type',
    EventCreatedSpecSourceInlineApplicationDatabasesEnginePostgresMigrateContainerDemand = 'event.created.spec.source.inline.application.databases.engine.postgres.migrateContainer.demand',
    EventCreatedSpecSourceInlineApplicationDatabasesEnginePostgresMigrateContainerEnvVarsSpecBlobstoreFormatType = 'event.created.spec.source.inline.application.databases.engine.postgres.migrateContainer.envVars.spec.blobstore.format.!type',
    EventCreatedSpecSourceInlineApplicationDatabasesEnginePostgresMigrateContainerEnvVarsSpecType = 'event.created.spec.source.inline.application.databases.engine.postgres.migrateContainer.envVars.spec.!type',
    EventCreatedSpecSourceInlineApplicationDatabasesEnginePostgresRunOutbox = 'event.created.spec.source.inline.application.databases.engine.postgres.runOutbox',
    EventCreatedSpecSourceInlineApplicationDatabasesEnginePostgresRunInbox = 'event.created.spec.source.inline.application.databases.engine.postgres.runInbox',
    EventCreatedSpecSourceInlineApplicationDatabasesEngineType = 'event.created.spec.source.inline.application.databases.engine.!type',
    EventCreatedSpecSourceInlineApplicationRuntimesContainersSourceType = 'event.created.spec.source.inline.application.runtimes.containers.source.!type',
    EventCreatedSpecSourceInlineApplicationRuntimesContainersDemand = 'event.created.spec.source.inline.application.runtimes.containers.demand',
    EventCreatedSpecSourceInlineApplicationRuntimesContainersEnvVarsSpecBlobstoreFormatType = 'event.created.spec.source.inline.application.runtimes.containers.envVars.spec.blobstore.format.!type',
    EventCreatedSpecSourceInlineApplicationRuntimesContainersEnvVarsSpecType = 'event.created.spec.source.inline.application.runtimes.containers.envVars.spec.!type',
    EventCreatedSpecVersion = 'event.created.spec.version',
    EventCreatedSpecEnvironmentName = 'event.created.spec.environmentName',
    EventCreatedSpecEnvironmentId = 'event.created.spec.environmentId',
    EventCreatedSpecEcsCluster = 'event.created.spec.ecsCluster',
    EventCreatedSpecCfStackName = 'event.created.spec.cfStackName',
    EventType = 'event.!type'
}

export enum O5AwsDeployerV1DeploymentQueryServiceDeploymentEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface O5AwsDeployerV1DeploymentQueryServiceDeploymentGetDeploymentGetRequest {
    // format: uuid
    deploymentId: string;
}

export interface O5AwsDeployerV1DeploymentQueryServiceDeploymentListDeploymentListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, O5AwsDeployerV1DeploymentQueryServiceDeploymentListSortableFields, O5AwsDeployerV1DeploymentQueryServiceDeploymentListFilterableFields>;
}

export enum O5AwsDeployerV1DeploymentQueryServiceDeploymentListFilterableFields {
    DeploymentId = 'deploymentId',
    StackId = 'stackId',
    EnvironmentId = 'environmentId',
    ClusterId = 'clusterId',
    DataSpecAppName = 'data.spec.appName',
    DataSpecSourceInlineApplicationDatabasesEnginePostgresMigrateContainerSourceType = 'data.spec.source.inline.application.databases.engine.postgres.migrateContainer.source.!type',
    DataSpecSourceInlineApplicationDatabasesEnginePostgresMigrateContainerDemand = 'data.spec.source.inline.application.databases.engine.postgres.migrateContainer.demand',
    DataSpecSourceInlineApplicationDatabasesEnginePostgresMigrateContainerEnvVarsSpecBlobstoreFormatType = 'data.spec.source.inline.application.databases.engine.postgres.migrateContainer.envVars.spec.blobstore.format.!type',
    DataSpecSourceInlineApplicationDatabasesEnginePostgresMigrateContainerEnvVarsSpecType = 'data.spec.source.inline.application.databases.engine.postgres.migrateContainer.envVars.spec.!type',
    DataSpecSourceInlineApplicationDatabasesEnginePostgresRunOutbox = 'data.spec.source.inline.application.databases.engine.postgres.runOutbox',
    DataSpecSourceInlineApplicationDatabasesEnginePostgresRunInbox = 'data.spec.source.inline.application.databases.engine.postgres.runInbox',
    DataSpecSourceInlineApplicationDatabasesEngineType = 'data.spec.source.inline.application.databases.engine.!type',
    DataSpecSourceInlineApplicationRuntimesContainersSourceType = 'data.spec.source.inline.application.runtimes.containers.source.!type',
    DataSpecSourceInlineApplicationRuntimesContainersDemand = 'data.spec.source.inline.application.runtimes.containers.demand',
    DataSpecSourceInlineApplicationRuntimesContainersEnvVarsSpecBlobstoreFormatType = 'data.spec.source.inline.application.runtimes.containers.envVars.spec.blobstore.format.!type',
    DataSpecSourceInlineApplicationRuntimesContainersEnvVarsSpecType = 'data.spec.source.inline.application.runtimes.containers.envVars.spec.!type',
    DataSpecVersion = 'data.spec.version',
    DataSpecEnvironmentName = 'data.spec.environmentName',
    DataSpecEnvironmentId = 'data.spec.environmentId',
    DataSpecEcsCluster = 'data.spec.ecsCluster',
    DataSpecCfStackName = 'data.spec.cfStackName',
    Status = 'status'
}

export enum O5AwsDeployerV1DeploymentQueryServiceDeploymentListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface O5AwsDeployerV1DeploymentSpec {
    // format: custom - pattern: ^[a-z0-9-]+$
    appName?: string;
    source?: O5AwsDeployerV1Source;
    // format: informal
    version?: string;
    // format: informal
    environmentName?: string;
    // format: uuid
    environmentId?: string;
    template?: O5AwsDeployerV1S3Template;
    // format: informal
    ecsCluster?: string;
    // format: informal
    cfStackName?: string;
    flags?: O5AwsDeployerV1DeploymentFlags;
    databases?: O5AwsDeployerV1PostgresSpec[];
    parameters?: O5AwsDeployerV1CloudFormationStackParameter[];
    snsTopics?: string[];
    triggers?: O5AwsDeployerV1TriggerManage[];
    /* Container images the deployment's task definitions reference, to be
    confirmed available before the stack update begins. */
    images?: O5AwsDeployerV1ImageSpec[];
    region?: string;
    kubernetesManifestsInput?: O5AwsDeployerV1S3Template;
}

export interface O5AwsDeployerV1DeploymentState extends O5AwsDeployerV1DeploymentKeys {
    metadata: J5StateV1StateMetadata;
    data: O5AwsDeployerV1DeploymentData;
    status: O5AwsDeployerV1DeploymentStatus;
}

export enum O5AwsDeployerV1DeploymentStatus {
    Unspecified = 'UNSPECIFIED',
    Queued = 'QUEUED',
    Triggered = 'TRIGGERED',
    Waiting = 'WAITING',
    Available = 'AVAILABLE',
    Running = 'RUNNING',
    Done = 'DONE',
    Failed = 'FAILED',
    Terminated = 'TERMINATED'
}

export interface O5AwsDeployerV1DeploymentStep {
    meta?: J5DrssV1StepMeta;
    step?: O5AwsDeployerV1DeploymentStepType;
    output?: O5AwsDeployerV1StepOutputType;
}

export type O5AwsDeployerV1DeploymentStepType = {
    '!type'?: 'evalJoin';
    evalJoin: O5AwsDeployerV1DeploymentStepTypeEvalJoin;
} | {
    '!type'?: 'cfCreate';
    cfCreate: O5AwsDeployerV1DeploymentStepTypeCfCreate;
} | {
    '!type'?: 'cfPlan';
    cfPlan: O5AwsDeployerV1DeploymentStepTypeCfPlan;
} | {
    '!type'?: 'cfUpdate';
    cfUpdate: O5AwsDeployerV1DeploymentStepTypeCfUpdate;
} | {
    '!type'?: 'cfScale';
    cfScale: O5AwsDeployerV1DeploymentStepTypeCfScale;
} | {
    '!type'?: 'pgUpsert';
    pgUpsert: O5AwsDeployerV1DeploymentStepTypePgUpsert;
} | {
    '!type'?: 'pgDestroy';
    pgDestroy: O5AwsDeployerV1DeploymentStepTypePgDestroy;
} | {
    '!type'?: 'pgEvaluate';
    pgEvaluate: O5AwsDeployerV1DeploymentStepTypePgEvaluate;
} | {
    '!type'?: 'awaitImages';
    awaitImages: O5AwsDeployerV1DeploymentStepTypeAwaitImages;
} | {
    '!type'?: 'publishKubernetesManifests';
    publishKubernetesManifests: O5AwsDeployerV1DeploymentStepTypePublishKubernetesManifests;
};

export interface O5AwsDeployerV1DeploymentStepTypeAwaitImages {
    images?: O5AwsDeployerV1ImageSpec[];
}

export interface O5AwsDeployerV1DeploymentStepTypeCfCreate {
    spec?: O5AwsDeployerV1CfStackInput;
    emptyStack?: boolean;
}

export interface O5AwsDeployerV1DeploymentStepTypeCfPlan {
    spec?: O5AwsDeployerV1CfStackInput;
    importResources?: boolean;
}

export interface O5AwsDeployerV1DeploymentStepTypeCfScale {
    stackName?: string;
}

export interface O5AwsDeployerV1DeploymentStepTypeCfUpdate {
    spec?: O5AwsDeployerV1CfStackInput;
}

export interface O5AwsDeployerV1DeploymentStepTypeEvalJoin {
    stackOutput?: O5AwsDeployerV1CfStackOutput;
}

export interface O5AwsDeployerV1DeploymentStepTypePgDestroy {
    spec?: O5AwsDeployerV1PostgresSpec;
}

export interface O5AwsDeployerV1DeploymentStepTypePgEvaluate {
    dbName?: string;
}

export interface O5AwsDeployerV1DeploymentStepTypePgUpsert {
    spec?: O5AwsDeployerV1PostgresSpec;
}

export interface O5AwsDeployerV1DeploymentStepTypePublishKubernetesManifests {
    input?: O5AwsDeployerV1S3Template;
}

export const O5_AWS_DEPLOYER_V1_DEPLOYMENT_STEP_TYPE_ONE_OF_VALUES = ['evalJoin', 'cfCreate', 'cfPlan', 'cfUpdate', 'cfScale', 'pgUpsert', 'pgDestroy', 'pgEvaluate', 'awaitImages', 'publishKubernetesManifests'] as const;

export type O5AwsDeployerV1DeploymentStepTypeOneOfValue = (typeof O5_AWS_DEPLOYER_V1_DEPLOYMENT_STEP_TYPE_ONE_OF_VALUES)[number];

export interface O5AwsDeployerV1EnvironmentData {
    config?: O5EnvironmentV1Environment;
}

export interface O5AwsDeployerV1EnvironmentEvent extends O5AwsDeployerV1EnvironmentKeys {
    metadata: J5StateV1EventMetadata;
    event: O5AwsDeployerV1EnvironmentEventType;
}

export type O5AwsDeployerV1EnvironmentEventType = {
    '!type'?: 'configured';
    configured: O5AwsDeployerV1EnvironmentEventTypeConfigured;
};

export interface O5AwsDeployerV1EnvironmentEventTypeConfigured {
    config?: O5EnvironmentV1Environment;
}

export const O5_AWS_DEPLOYER_V1_ENVIRONMENT_EVENT_TYPE_ONE_OF_VALUES = ['configured'] as const;

export type O5AwsDeployerV1EnvironmentEventTypeOneOfValue = (typeof O5_AWS_DEPLOYER_V1_ENVIRONMENT_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface O5AwsDeployerV1EnvironmentKeys {
    // format: uuid
    environmentId: string;
    // format: uuid, entity: o5.aws.deployer.v1.Cluster
    clusterId: string;
}

export interface O5AwsDeployerV1EnvironmentQueryServiceEnvironmentEventsEnvironmentEventsRequest {
    // format: uuid
    environmentId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<O5AwsDeployerV1EnvironmentQueryServiceEnvironmentEventsSearchableFields, O5AwsDeployerV1EnvironmentQueryServiceEnvironmentEventsSortableFields, O5AwsDeployerV1EnvironmentQueryServiceEnvironmentEventsFilterableFields>;
}

export enum O5AwsDeployerV1EnvironmentQueryServiceEnvironmentEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    EnvironmentId = 'environmentId',
    ClusterId = 'clusterId',
    EventType = 'event.!type'
}

export enum O5AwsDeployerV1EnvironmentQueryServiceEnvironmentEventsSearchableFields {
    EventConfiguredConfigFullName = 'event.configured.config.fullName'
}

export enum O5AwsDeployerV1EnvironmentQueryServiceEnvironmentEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface O5AwsDeployerV1EnvironmentQueryServiceEnvironmentGetEnvironmentGetRequest {
    // format: uuid
    environmentId: string;
}

export interface O5AwsDeployerV1EnvironmentQueryServiceEnvironmentListEnvironmentListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<O5AwsDeployerV1EnvironmentQueryServiceEnvironmentListSearchableFields, O5AwsDeployerV1EnvironmentQueryServiceEnvironmentListSortableFields, O5AwsDeployerV1EnvironmentQueryServiceEnvironmentListFilterableFields>;
}

export enum O5AwsDeployerV1EnvironmentQueryServiceEnvironmentListFilterableFields {
    EnvironmentId = 'environmentId',
    ClusterId = 'clusterId',
    Status = 'status'
}

export enum O5AwsDeployerV1EnvironmentQueryServiceEnvironmentListSearchableFields {
    DataConfigFullName = 'data.config.fullName'
}

export enum O5AwsDeployerV1EnvironmentQueryServiceEnvironmentListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface O5AwsDeployerV1EnvironmentState extends O5AwsDeployerV1EnvironmentKeys {
    metadata: J5StateV1StateMetadata;
    data: O5AwsDeployerV1EnvironmentData;
    status: O5AwsDeployerV1EnvironmentStatus;
}

export enum O5AwsDeployerV1EnvironmentStatus {
    Unspecified = 'UNSPECIFIED',
    Active = 'ACTIVE'
}

export interface O5AwsDeployerV1ImageSpec {
    /* Registry host, e.g. 000000000000.dkr.ecr.us-west-2.amazonaws.com */
    registry?: string;
    /* Repository path within the registry, e.g. team/org/service */
    repository?: string;
    /* Image tag, usually the commit hash being deployed */
    tag?: string;
}

export interface O5AwsDeployerV1KeyValue {
    name?: string;
    value?: string;
}

export interface O5AwsDeployerV1ParameterOverride {
    key: string;
    /* set to nil to remove the parameter */
    value?: string;
}

export type O5AwsDeployerV1PostgresConnectionType = {
    '!type'?: 'aurora';
    aurora: O5AwsDeployerV1PostgresConnectionTypeAurora;
};

export interface O5AwsDeployerV1PostgresConnectionTypeAurora {
    conn?: O5AwsDeployerV1AuroraConnection;
}

export const O5_AWS_DEPLOYER_V1_POSTGRES_CONNECTION_TYPE_ONE_OF_VALUES = ['aurora'] as const;

export type O5AwsDeployerV1PostgresConnectionTypeOneOfValue = (typeof O5_AWS_DEPLOYER_V1_POSTGRES_CONNECTION_TYPE_ONE_OF_VALUES)[number];

export interface O5AwsDeployerV1PostgresSpec {
    /* Key as specified in the app config file */
    appKey?: string;
    fullDbName?: string;
    dbExtensions?: string[];
    adminConnection?: O5AwsDeployerV1RdsHostType;
    appConnection?: O5AwsDeployerV1PostgresConnectionType;
    clientSecurityGroupId?: string;
}

export type O5AwsDeployerV1RdsHostType = {
    '!type'?: 'aurora';
    aurora: O5AwsDeployerV1RdsHostTypeAurora;
};

export interface O5AwsDeployerV1RdsHostTypeAurora {
    conn?: O5AwsDeployerV1AuroraConnection;
}

export const O5_AWS_DEPLOYER_V1_RDS_HOST_TYPE_ONE_OF_VALUES = ['aurora'] as const;

export type O5AwsDeployerV1RdsHostTypeOneOfValue = (typeof O5_AWS_DEPLOYER_V1_RDS_HOST_TYPE_ONE_OF_VALUES)[number];

export interface O5AwsDeployerV1S3Template {
    bucket?: string;
    key?: string;
    region?: string;
}

export type O5AwsDeployerV1UpsertClusterRequestSrc = {
    '!type'?: 'config';
    config: O5EnvironmentV1CombinedConfig;
} | {
    '!type'?: 'configYaml';
    // bytes (base64-encoded)
    configYaml: string;
} | {
    '!type'?: 'configJson';
    // bytes (base64-encoded)
    configJson: string;
};

export const O5_AWS_DEPLOYER_V1_UPSERT_CLUSTER_REQUEST_SRC_ONE_OF_VALUES = ['config', 'configYaml', 'configJson'] as const;

export type O5AwsDeployerV1UpsertClusterRequestSrcOneOfValue = (typeof O5_AWS_DEPLOYER_V1_UPSERT_CLUSTER_REQUEST_SRC_ONE_OF_VALUES)[number];

export type O5AwsDeployerV1UpsertEnvironmentRequestSrc = {
    '!type'?: 'config';
    config: O5EnvironmentV1Environment;
} | {
    '!type'?: 'configYaml';
    // bytes (base64-encoded)
    configYaml: string;
} | {
    '!type'?: 'configJson';
    // bytes (base64-encoded)
    configJson: string;
};

export const O5_AWS_DEPLOYER_V1_UPSERT_ENVIRONMENT_REQUEST_SRC_ONE_OF_VALUES = ['config', 'configYaml', 'configJson'] as const;

export type O5AwsDeployerV1UpsertEnvironmentRequestSrcOneOfValue = (typeof O5_AWS_DEPLOYER_V1_UPSERT_ENVIRONMENT_REQUEST_SRC_ONE_OF_VALUES)[number];

export type O5AwsDeployerV1Source = {
    '!type'?: 'github';
    github: O5AwsDeployerV1SourceGithub;
} | {
    '!type'?: 'inline';
    inline: O5AwsDeployerV1SourceInline;
};

export interface O5AwsDeployerV1SourceGithub {
    owner: string;
    repo: string;
    ref?: O5AwsDeployerV1SourceGithubRef;
}

export type O5AwsDeployerV1SourceGithubRef = {
    '!type'?: 'branch';
    branch: string;
} | {
    '!type'?: 'tag';
    tag: string;
} | {
    '!type'?: 'commit';
    commit: string;
};

export const O5_AWS_DEPLOYER_V1_SOURCE_GITHUB_REF_ONE_OF_VALUES = ['branch', 'tag', 'commit'] as const;

export type O5AwsDeployerV1SourceGithubRefOneOfValue = (typeof O5_AWS_DEPLOYER_V1_SOURCE_GITHUB_REF_ONE_OF_VALUES)[number];

export interface O5AwsDeployerV1SourceInline {
    version: string;
    application: O5ApplicationV1Application;
}

export const O5_AWS_DEPLOYER_V1_SOURCE_ONE_OF_VALUES = ['github', 'inline'] as const;

export type O5AwsDeployerV1SourceOneOfValue = (typeof O5_AWS_DEPLOYER_V1_SOURCE_ONE_OF_VALUES)[number];

export interface O5AwsDeployerV1StackData {
    currentDeployment?: O5AwsDeployerV1StackDeployment;
    // pattern: ^[a-z][a-z0-9-]+-[a-z][a-z0-9]+$
    stackName?: string;
    // pattern: ^[a-z][a-z0-9-]+$
    applicationName?: string;
    // pattern: ^[a-z][a-z0-9-]+$
    environmentName?: string;
    // format: uuid
    environmentId?: string;
    queuedDeployments?: O5AwsDeployerV1StackDeployment[];
}

export interface O5AwsDeployerV1StackDeployment {
    // format: uuid
    deploymentId?: string;
    version?: string;
}

export interface O5AwsDeployerV1StackEvent extends O5AwsDeployerV1StackKeys {
    metadata: J5StateV1EventMetadata;
    event: O5AwsDeployerV1StackEventType;
}

export type O5AwsDeployerV1StackEventType = {
    '!type'?: 'configured';
    configured: O5AwsDeployerV1StackEventTypeConfigured;
} | {
    '!type'?: 'deploymentRequested';
    deploymentRequested: O5AwsDeployerV1StackEventTypeDeploymentRequested;
} | {
    '!type'?: 'deploymentCompleted';
    deploymentCompleted: O5AwsDeployerV1StackEventTypeDeploymentCompleted;
} | {
    '!type'?: 'deploymentFailed';
    deploymentFailed: O5AwsDeployerV1StackEventTypeDeploymentFailed;
} | {
    '!type'?: 'runDeployment';
    runDeployment: O5AwsDeployerV1StackEventTypeRunDeployment;
};

export interface O5AwsDeployerV1StackEventTypeConfigured {
    applicationName?: string;
    environmentId?: string;
    environmentName?: string;
}

export interface O5AwsDeployerV1StackEventTypeDeploymentCompleted {
    deployment?: O5AwsDeployerV1StackDeployment;
}

export interface O5AwsDeployerV1StackEventTypeDeploymentFailed {
    deployment?: O5AwsDeployerV1StackDeployment;
    error?: string;
}

export interface O5AwsDeployerV1StackEventTypeDeploymentRequested {
    deployment?: O5AwsDeployerV1StackDeployment;
    // pattern: ^[a-z][a-z0-9-]+$
    applicationName?: string;
    // pattern: ^[a-z][a-z0-9-]+$
    environmentName?: string;
    environmentId?: string;
}

export interface O5AwsDeployerV1StackEventTypeRunDeployment {
    deploymentId?: string;
}

export const O5_AWS_DEPLOYER_V1_STACK_EVENT_TYPE_ONE_OF_VALUES = ['configured', 'deploymentRequested', 'deploymentCompleted', 'deploymentFailed', 'runDeployment'] as const;

export type O5AwsDeployerV1StackEventTypeOneOfValue = (typeof O5_AWS_DEPLOYER_V1_STACK_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface O5AwsDeployerV1StackKeys {
    // format: uuid
    stackId: string;
    // format: uuid, entity: o5.aws.deployer.v1.Environment
    environmentId: string;
    // format: uuid, entity: o5.aws.deployer.v1.Cluster
    clusterId: string;
}

export interface O5AwsDeployerV1StackQueryServiceStackEventsStackEventsRequest {
    // format: uuid
    stackId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<never, O5AwsDeployerV1StackQueryServiceStackEventsSortableFields, O5AwsDeployerV1StackQueryServiceStackEventsFilterableFields>;
}

export enum O5AwsDeployerV1StackQueryServiceStackEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    StackId = 'stackId',
    EnvironmentId = 'environmentId',
    ClusterId = 'clusterId',
    EventType = 'event.!type'
}

export enum O5AwsDeployerV1StackQueryServiceStackEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface O5AwsDeployerV1StackQueryServiceStackGetStackGetRequest {
    // format: uuid
    stackId: string;
}

export interface O5AwsDeployerV1StackQueryServiceStackListStackListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<O5AwsDeployerV1StackQueryServiceStackListSearchableFields, O5AwsDeployerV1StackQueryServiceStackListSortableFields, O5AwsDeployerV1StackQueryServiceStackListFilterableFields>;
}

export enum O5AwsDeployerV1StackQueryServiceStackListFilterableFields {
    StackId = 'stackId',
    EnvironmentId = 'environmentId',
    ClusterId = 'clusterId',
    Status = 'status'
}

export enum O5AwsDeployerV1StackQueryServiceStackListSearchableFields {
    DataStackName = 'data.stackName',
    DataApplicationName = 'data.applicationName',
    DataEnvironmentName = 'data.environmentName'
}

export enum O5AwsDeployerV1StackQueryServiceStackListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface O5AwsDeployerV1StackState extends O5AwsDeployerV1StackKeys {
    metadata: J5StateV1StateMetadata;
    data: O5AwsDeployerV1StackData;
    status: O5AwsDeployerV1StackStatus;
}

export enum O5AwsDeployerV1StackStatus {
    Unspecified = 'UNSPECIFIED',
    Migrating = 'MIGRATING',
    Available = 'AVAILABLE'
}

export type O5AwsDeployerV1StepOutputType = {
    '!type'?: 'cfStackStatus';
    cfStackStatus: O5AwsDeployerV1StepOutputTypeCfStackStatus;
} | {
    '!type'?: 'cfChangesetStatus';
    cfChangesetStatus: O5AwsDeployerV1StepOutputTypeCfChangesetStatus;
} | {
    '!type'?: 'publishKubernetesManifests';
    publishKubernetesManifests: O5AwsDeployerV1StepOutputTypePublishKubernetesManifests;
};

export interface O5AwsDeployerV1StepOutputTypeCfChangesetStatus {
    lifecycle?: O5AwsDeployerV1CfChangesetLifecycle;
}

export interface O5AwsDeployerV1StepOutputTypeCfStackStatus {
    lifecycle?: O5AwsDeployerV1CfLifecycle;
    outputs?: O5AwsDeployerV1KeyValue[];
}

export interface O5AwsDeployerV1StepOutputTypePublishKubernetesManifests {
    digest?: string;
}

export const O5_AWS_DEPLOYER_V1_STEP_OUTPUT_TYPE_ONE_OF_VALUES = ['cfStackStatus', 'cfChangesetStatus', 'publishKubernetesManifests'] as const;

export type O5AwsDeployerV1StepOutputTypeOneOfValue = (typeof O5_AWS_DEPLOYER_V1_STEP_OUTPUT_TYPE_ONE_OF_VALUES)[number];

export type O5AwsDeployerV1TemplateType = {
    '!type'?: 's3Template';
    s3Template: O5AwsDeployerV1S3Template;
} | {
    '!type'?: 'templateBody';
    templateBody: O5AwsDeployerV1TemplateTypeTemplateBody;
} | {
    '!type'?: 'emptyStack';
    emptyStack: EmptyObject;
};

export interface O5AwsDeployerV1TemplateTypeTemplateBody {
    body?: string;
}

export const O5_AWS_DEPLOYER_V1_TEMPLATE_TYPE_ONE_OF_VALUES = ['s3Template', 'templateBody', 'emptyStack'] as const;

export type O5AwsDeployerV1TemplateTypeOneOfValue = (typeof O5_AWS_DEPLOYER_V1_TEMPLATE_TYPE_ONE_OF_VALUES)[number];

export interface O5AwsDeployerV1TriggerManage {
    environmentName?: string;
    action?: O5AwsDeployerV1TriggerManageAction;
}

export type O5AwsDeployerV1TriggerManageAction = {
    '!type'?: 'upsert';
    upsert: O5AwsDeployerV1TriggerManageActionUpsert;
} | {
    '!type'?: 'archive';
    archive: O5AwsDeployerV1TriggerManageActionArchive;
};

export interface O5AwsDeployerV1TriggerManageActionArchive {
    triggerId: string;
}

export interface O5AwsDeployerV1TriggerManageActionUpsert {
    // format: id62
    triggerId: string;
    triggerName: string;
    appName: string;
    cron?: string;
    payload: O5AwsDeployerV1TriggerManageActionUpsertPayload;
    target: string;
}

export type O5AwsDeployerV1TriggerManageActionUpsertPayload = {
    '!type'?: 'static';
    static: string;
};

export const O5_AWS_DEPLOYER_V1_TRIGGER_MANAGE_ACTION_UPSERT_PAYLOAD_ONE_OF_VALUES = ['static'] as const;

export type O5AwsDeployerV1TriggerManageActionUpsertPayloadOneOfValue = (typeof O5_AWS_DEPLOYER_V1_TRIGGER_MANAGE_ACTION_UPSERT_PAYLOAD_ONE_OF_VALUES)[number];

export const O5_AWS_DEPLOYER_V1_TRIGGER_MANAGE_ACTION_ONE_OF_VALUES = ['upsert', 'archive'] as const;

export type O5AwsDeployerV1TriggerManageActionOneOfValue = (typeof O5_AWS_DEPLOYER_V1_TRIGGER_MANAGE_ACTION_ONE_OF_VALUES)[number];

export interface O5DanteV1DeadMessageData {
    notification?: O5MessagingV1DeadMessage;
    currentVersion?: O5DanteV1DeadMessageVersion;
}

export interface O5DanteV1DeadMessageEvent extends O5DanteV1DeadMessageKeys {
    metadata: J5StateV1EventMetadata;
    event: O5DanteV1DeadMessageEventType;
}

export type O5DanteV1DeadMessageEventType = {
    '!type'?: 'notified';
    notified: O5DanteV1DeadMessageEventTypeNotified;
} | {
    '!type'?: 'updated';
    updated: O5DanteV1DeadMessageEventTypeUpdated;
} | {
    '!type'?: 'replayed';
    replayed: EmptyObject;
} | {
    '!type'?: 'rejected';
    rejected: O5DanteV1DeadMessageEventTypeRejected;
};

export interface O5DanteV1DeadMessageEventTypeNotified {
    notification?: O5MessagingV1DeadMessage;
}

export interface O5DanteV1DeadMessageEventTypeRejected {
    reason?: string;
}

export interface O5DanteV1DeadMessageEventTypeUpdated {
    spec?: O5DanteV1DeadMessageVersion;
}

export const O5_DANTE_V1_DEAD_MESSAGE_EVENT_TYPE_ONE_OF_VALUES = ['notified', 'updated', 'replayed', 'rejected'] as const;

export type O5DanteV1DeadMessageEventTypeOneOfValue = (typeof O5_DANTE_V1_DEAD_MESSAGE_EVENT_TYPE_ONE_OF_VALUES)[number];

export interface O5DanteV1DeadMessageKeys {
    // format: uuid
    messageId: string;
}

export interface O5DanteV1DeadMessageQueryServiceDeadMessageEventsDeadMessageEventsRequest {
    // format: uuid
    messageId: string;
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<O5DanteV1DeadMessageQueryServiceDeadMessageEventsSearchableFields, O5DanteV1DeadMessageQueryServiceDeadMessageEventsSortableFields, O5DanteV1DeadMessageQueryServiceDeadMessageEventsFilterableFields>;
}

export enum O5DanteV1DeadMessageQueryServiceDeadMessageEventsFilterableFields {
    MetadataTimestamp = 'metadata.timestamp',
    MessageId = 'messageId',
    EventNotifiedNotificationHandlerApp = 'event.notified.notification.handlerApp',
    EventNotifiedNotificationHandlerEnv = 'event.notified.notification.handlerEnv',
    EventType = 'event.!type'
}

export enum O5DanteV1DeadMessageQueryServiceDeadMessageEventsSearchableFields {
    EventNotifiedNotificationProblemUnhandledErrorError = 'event.notified.notification.problem.unhandledError.error'
}

export enum O5DanteV1DeadMessageQueryServiceDeadMessageEventsSortableFields {
    MetadataTimestamp = 'metadata.timestamp'
}

export interface O5DanteV1DeadMessageQueryServiceDeadMessageGetDeadMessageGetRequest {
    // format: uuid
    messageId: string;
}

export interface O5DanteV1DeadMessageQueryServiceDeadMessageListDeadMessageListRequest {
    page?: J5ListV1PageRequest;
    query?: J5ListV1QueryRequest<O5DanteV1DeadMessageQueryServiceDeadMessageListSearchableFields, O5DanteV1DeadMessageQueryServiceDeadMessageListSortableFields, O5DanteV1DeadMessageQueryServiceDeadMessageListFilterableFields>;
}

export enum O5DanteV1DeadMessageQueryServiceDeadMessageListFilterableFields {
    MessageId = 'messageId',
    DataNotificationHandlerApp = 'data.notification.handlerApp',
    DataNotificationHandlerEnv = 'data.notification.handlerEnv',
    Status = 'status'
}

export enum O5DanteV1DeadMessageQueryServiceDeadMessageListSearchableFields {
    DataNotificationProblemUnhandledErrorError = 'data.notification.problem.unhandledError.error'
}

export enum O5DanteV1DeadMessageQueryServiceDeadMessageListSortableFields {
    MetadataCreatedAt = 'metadata.createdAt',
    MetadataUpdatedAt = 'metadata.updatedAt'
}

export interface O5DanteV1DeadMessageState extends O5DanteV1DeadMessageKeys {
    metadata: J5StateV1StateMetadata;
    data: O5DanteV1DeadMessageData;
    status: O5DanteV1DeadMessageStatus;
}

export enum O5DanteV1DeadMessageStatus {
    Unspecified = 'UNSPECIFIED',
    Created = 'CREATED',
    Updated = 'UPDATED',
    Replayed = 'REPLAYED',
    Rejected = 'REJECTED'
}

export interface O5DanteV1DeadMessageVersion {
    // format: uuid
    versionId?: string;
    message?: O5MessagingV1Message;
    sqsMessage?: O5DanteV1SqsMessage;
}

export interface O5DanteV1SqsMessage {
    queueUrl?: string;
    attributes?: Record<string, string>;
}

export interface O5EnvironmentV1AlbIngress {
    listenerArn?: string;
    securityGroupId?: string;
}

export interface O5EnvironmentV1AwsCluster {
    vpcId?: string;
    awsAccount?: string;
    awsRegion?: string;
    /* S3 buckets (and others?) must be globally unique for all AWS accounts and
    regions, buckets are named
    {name}-{app}-{environment}-{region}-{global_namespace} */
    globalNamespace?: string;
    o5Deployer?: O5EnvironmentV1O5Deployer;
    albIngress?: O5EnvironmentV1AlbIngress;
    o5Sidecar?: O5EnvironmentV1O5Sidecar;
    eventBridge?: O5EnvironmentV1EventBridge;
    compute?: O5EnvironmentV1AwsClusterCompute;
    rdsHosts?: O5EnvironmentV1RdsHost[];
    s3AccessLogBucket?: string;
}

export type O5EnvironmentV1AwsClusterCompute = {
    '!type'?: 'ecs';
    ecs: O5EnvironmentV1EcsCluster;
} | {
    '!type'?: 'eks';
    eks: O5EnvironmentV1EksCluster;
};

export const O5_ENVIRONMENT_V1_AWS_CLUSTER_COMPUTE_ONE_OF_VALUES = ['ecs', 'eks'] as const;

export type O5EnvironmentV1AwsClusterComputeOneOfValue = (typeof O5_ENVIRONMENT_V1_AWS_CLUSTER_COMPUTE_ONE_OF_VALUES)[number];

export interface O5EnvironmentV1AwsEnvironment {
    /* when set, adds a host header rule to all listener rules. For routes with
    specified subdomains, the subdomain value is added as a prefix to this
    value. This allows re-use of the same listener for multiple (related)
    environments. */
    hostHeader?: string;
    environmentLinks?: O5EnvironmentV1AwsLink[];
    iamPolicies?: O5EnvironmentV1NamedIamPolicy[];
}

export interface O5EnvironmentV1AwsLink {
    /* used to match in application configs */
    lookupName?: string;
    fullName?: string;
    snsPrefix?: string;
}

export interface O5EnvironmentV1Cluster {
    name?: string;
    provider?: O5EnvironmentV1ClusterProvider;
}

export type O5EnvironmentV1ClusterProvider = {
    '!type'?: 'aws';
    aws: O5EnvironmentV1AwsCluster;
};

export const O5_ENVIRONMENT_V1_CLUSTER_PROVIDER_ONE_OF_VALUES = ['aws'] as const;

export type O5EnvironmentV1ClusterProviderOneOfValue = (typeof O5_ENVIRONMENT_V1_CLUSTER_PROVIDER_ONE_OF_VALUES)[number];

export interface O5EnvironmentV1CombinedConfig {
    name?: string;
    provider?: O5EnvironmentV1CombinedConfigProvider;
    environments?: O5EnvironmentV1Environment[];
}

export type O5EnvironmentV1CombinedConfigProvider = {
    '!type'?: 'aws';
    aws: O5EnvironmentV1AwsCluster;
};

export const O5_ENVIRONMENT_V1_COMBINED_CONFIG_PROVIDER_ONE_OF_VALUES = ['aws'] as const;

export type O5EnvironmentV1CombinedConfigProviderOneOfValue = (typeof O5_ENVIRONMENT_V1_COMBINED_CONFIG_PROVIDER_ONE_OF_VALUES)[number];

export interface O5EnvironmentV1CustomVariable {
    name?: string;
    /* oneof, but logically, because repeated oneof isn't a thing */
    src?: O5EnvironmentV1CustomVariableSrc;
}

export interface O5EnvironmentV1CustomVariableJoin {
    delimiter?: string;
    values?: string[];
}

export type O5EnvironmentV1CustomVariableSrc = {
    '!type'?: 'value';
    value: string;
} | {
    '!type'?: 'join';
    join: O5EnvironmentV1CustomVariableJoin;
};

export const O5_ENVIRONMENT_V1_CUSTOM_VARIABLE_SRC_ONE_OF_VALUES = ['value', 'join'] as const;

export type O5EnvironmentV1CustomVariableSrcOneOfValue = (typeof O5_ENVIRONMENT_V1_CUSTOM_VARIABLE_SRC_ONE_OF_VALUES)[number];

export interface O5EnvironmentV1EcsCluster {
    clusterName?: string;
    taskExecutionRole?: string;
    /* Default value for o5.application.v1.Container.Image.registry */
    defaultRegistry?: string;
    subnetIds?: string[];
    baseSecurityGroupId?: string;
}

export interface O5EnvironmentV1EksCluster {
    clusterName?: string;
    defaultRegistry?: string;
    manifests?: O5EnvironmentV1KubernetesManifests;
}

export interface O5EnvironmentV1Environment {
    // pattern: ^[a-z][a-z0-9-]+$
    fullName?: string;
    clusterName?: string;
    trustJwks?: string[];
    vars?: O5EnvironmentV1CustomVariable[];
    /* allowed cors origins, with wildcard support, e.g. https://*.example.com
    other cors settings are implicit, or set via proto extensions in the
    endpoints */
    corsOrigins?: string[];
    provider?: O5EnvironmentV1EnvironmentProvider;
    /* added solely to migrate from ECS->EKS, will be removed once that
    migration is finished. */
    // pattern: ^[a-z][a-z0-9-]+$
    eventSourceAliases?: string[];
}

export type O5EnvironmentV1EnvironmentProvider = {
    '!type'?: 'aws';
    aws: O5EnvironmentV1AwsEnvironment;
};

export const O5_ENVIRONMENT_V1_ENVIRONMENT_PROVIDER_ONE_OF_VALUES = ['aws'] as const;

export type O5EnvironmentV1EnvironmentProviderOneOfValue = (typeof O5_ENVIRONMENT_V1_ENVIRONMENT_PROVIDER_ONE_OF_VALUES)[number];

export interface O5EnvironmentV1EventBridge {
    eventBusArn?: string;
}

export interface O5EnvironmentV1KubernetesManifests {
    repository: string;
    chart: string;
    ingressClassName: string;
    // format: UINT32
    predeployTimeout: number;
}

export interface O5EnvironmentV1NamedIamPolicy {
    /* lookup val used in o5.application.v1.Runtime.named_env_policies */
    name?: string;
    policyArn?: string;
}

export interface O5EnvironmentV1O5Deployer {
    /* The role O5 assumes when deploying to this environment */
    assumeRoleArn?: string;
}

export interface O5EnvironmentV1O5Sidecar {
    /* Must be set, no default. */
    imageVersion?: string;
    /* defaults to interxfi/o5-runtime-sidecar */
    imageRepo?: string;
}

export type O5EnvironmentV1RdsAuthType = {
    '!type'?: 'iam';
    iam: O5EnvironmentV1RdsAuthTypeIam;
};

export interface O5EnvironmentV1RdsAuthTypeIam {
    /* A username to use getting the token, which then also matches the user
    implementation of the engine. For root access, this could be the
    master_user but it only needs to be a user with the correct
    permissions. */
    dbUser?: string;
    /* defaults to the user's name. Used when accessing, not required for
    the token. */
    dbName?: string;
}

export const O5_ENVIRONMENT_V1_RDS_AUTH_TYPE_ONE_OF_VALUES = ['iam'] as const;

export type O5EnvironmentV1RdsAuthTypeOneOfValue = (typeof O5_ENVIRONMENT_V1_RDS_AUTH_TYPE_ONE_OF_VALUES)[number];

export interface O5EnvironmentV1RdsHost {
    /* Matches o5.application.v1.Database.Postgres.server_group */
    serverGroupName?: string;
    /* ID of the Security Group which is allowed to connect to the server */
    clientSecurityGroupId?: string;
    /* AWS API: 'DBInstanceIdentifier' */
    identifier?: string;
    /* AWS API: 'Endpoint' - hostname without port. Used for connection and
    authentication tokens. */
    endpoint?: string;
    /* AWS API: 'Port' The port that the database engine is listening on. */
    // format: INT32
    port?: number;
    auth?: O5EnvironmentV1RdsAuthType;
}

export interface O5MessagingV1Any {
    typeUrl?: string;
    // bytes (base64-encoded)
    value?: string;
    encoding?: O5MessagingV1WireEncoding;
}

export interface O5MessagingV1Message {
    messageId?: string;
    /* The 'full_name' of the gRPC service <package>.<service> */
    // pattern: ^([a-z0-9_]+\.)+([A-Z][a-zA-Z0-9_]+)$
    grpcService?: string;
    /* The short name of the method in the gRPC service */
    // pattern: ^([A-Za-z0-9_]+)$
    grpcMethod?: string;
    body?: O5MessagingV1Any;
    /* Then o5.application.name which sent the message */
    sourceApp?: string;
    /* The o5.environment.full_name which sent the message */
    sourceEnv?: string;
    /* Deprecated. For compatibility with named topic messaging, specifies the destination name */
    destinationTopic?: string;
    /* Timestamp when producing or replaying the message. */
    // format: date-time
    timestamp?: string;
    headers?: Record<string, string>;
    /* Delay in seconds before the message should be delivered, with a maximum of
    15 mins. */
    // format: INT32
    delaySeconds?: number;
    request?: O5MessagingV1MessageRequest;
    reply?: O5MessagingV1MessageReply;
    event?: O5MessagingV1MessageEvent;
    upsert?: O5MessagingV1MessageUpsert;
}

export interface O5MessagingV1MessageEvent {
    /* full name of the state machine publishing the event, as package.v1.name */
    entityName?: string;
}

export interface O5MessagingV1MessageReply {
    /* Copied from the Request's reply_to field when replying. */
    replyTo?: string;
}

export interface O5MessagingV1MessageRequest {
    /* In the reply to a request/reply message, Identifies the service or instance
    which first sent the request to which the reply should be routed. */
    replyTo?: string;
}

export interface O5MessagingV1MessageUpsert {
    /* full name of the state machine causing the upsert, as package.v1.name */
    entityName?: string;
}

export interface O5MessagingV1DeadMessage {
    /* Generated by the handler on failure, so that multiple failures of the same
    message (either through replay or multiple services working on the same
    cause) are not de-duplicated. This is used as the message_id on the wire
    message when sent, the original message_id is in the message field. */
    // format: uuid
    deathId?: string;
    /* The o5.application.name which attepmted to handle the message */
    // format: custom - pattern: ^[a-z0-9]+$
    handlerApp?: string;
    /* The o5.environment.full_name which attepmted to handle the message */
    // format: custom - pattern: ^[a-z0-9-]+$
    handlerEnv?: string;
    /* The message which was not able to be handled */
    message?: O5MessagingV1Message;
    /* The problem which caused the message to die */
    problem?: O5MessagingV1Problem;
    infra?: O5MessagingV1Infra;
}

export interface O5MessagingV1Infra {
    type?: string;
    metadata?: Record<string, string>;
}

export type O5MessagingV1Problem = {
    '!type'?: 'unhandledError';
    unhandledError: O5MessagingV1ProblemUnhandledError;
};

export interface O5MessagingV1ProblemUnhandledError {
    error?: string;
}

export const O5_MESSAGING_V1_PROBLEM_ONE_OF_VALUES = ['unhandledError'] as const;

export type O5MessagingV1ProblemOneOfValue = (typeof O5_MESSAGING_V1_PROBLEM_ONE_OF_VALUES)[number];

export enum O5MessagingV1WireEncoding {
    Unspecified = 'UNSPECIFIED',
    Protojson = 'PROTOJSON',
    Raw = 'RAW',
    J5Json = 'J5_JSON'
}

export const ApiEntityValues = ['exc.dtc.files.v1.FileRequest', 'exc.dtc.files.v1.File', 'exc.dtcc.utc.v1.UtcFixSession', 'exc.ice.corpactions.v1.Action', 'exc.ice.gsm.v1.Instrument', 'exc.ice.job.v1.Job', 'exc.ice.job.v1.Task', 'exc.increase.v1.AccountNumber', 'exc.increase.v1.Ach', 'exc.increase.v1.Wire', 'exc.jane_street.v1.PfofJob', 'exc.jpmam.v1.Destination', 'exc.jpmam.v1.JpmamJob', 'exc.jpmam.v1.JpmamOrder', 'exc.jpmam.v1.JpmamTask', 'exc.jpmam.v1.NetOrder', 'exc.plaid.v1.ProcessorToken', 'exc.quotemedia.v1.EodPriceJob', 'exc.quotemedia.v1.EodPriceTask', 'exc.quotemedia.v1.Sp_500List', 'exc.route.v1.FixMessage', 'exc.route.v1.FixOrder', 'exc.route.v1.FixSession', 'exc.route.v1.RoutingRule', 'exf.ofac.emulator.v1.OfacEmulator', 'ixc.assets.clearing.v1.MoneyMarketInternalStats', 'ixc.assets.v1.AssetException', 'ixc.assets.v1.Asset', 'ixc.assets.v1.EodPrice', 'ixc.assets.v1.MoneyMarketStats', 'ixc.billing.v1.Charge', 'ixc.cases.v1.Case', 'ixc.clearing.v1.ClosingPosition', 'ixc.corpactions.caadmin.v1.Action', 'ixc.corpactions.caadmin.v1.Payment', 'ixc.costbasis.v1.Realization', 'ixc.costbasis.v1.TaxLot', 'ixc.dtcc.cns.v1.AssetDay', 'ixc.dtcc.dreco.v1.Asset', 'ixc.dtcc.dtc.v1.AssetDay', 'ixc.fees.v1.FeeRate', 'ixc.funding.v1.AccountNumber', 'ixc.funding.v1.BatchAllocation', 'ixc.funding.v1.BatchTransfer', 'ixc.funding.v1.Source', 'ixc.funding.v1.Transfer', 'ixc.generate.v1.MonthlyStatementsJob', 'ixc.generate.v1.MonthlyStatementsTask', 'ixc.generate.v1.TradeConfirmationsJob', 'ixc.generate.v1.TradeConfirmationsTask', 'ixc.inventory.v1.BooksOrder', 'ixc.inventory.v1.FirmOrder', 'ixc.inventory.v1.SecurityDay', 'ixc.inventory.v1.TradingDay', 'ixc.mfreco.v1.PositionDay', 'ixc.mutualfunds.v1.DividendAccrual', 'ixc.mutualfunds.v1.FundOrder', 'ixc.mutualfunds.v1.MutualFundsJob', 'ixc.mutualfunds.v1.MutualFundsTask', 'ixc.mutualfunds.v1.VenueOrder', 'ixc.orders.v1.BatchAllocation', 'ixc.orders.v1.BatchOrder', 'ixc.orders.v1.Order', 'ixc.payments.v1.AccountNumber', 'ixc.payments.v1.Ach', 'ixc.payments.v1.IncomingAch', 'ixc.payments.v1.IncomingWire', 'ixc.payments.v1.Wire', 'ixc.portfolio.v1.AssetBalance', 'ixc.portfolio.v1.BalanceSnapshot', 'ixc.portfolio.v1.CashBalance', 'ixc.portfolio.v1.DepositAdvance', 'ixc.portfolio.v1.Hold', 'ixc.portfolio.v1.SweepBalance', 'ixc.portfolio.v1.Transaction', 'ixc.prospectus.v1.ProspectusJob', 'ixc.prospectus.v1.ProspectusTask', 'ixc.proxyvote.v1.ProxyJob', 'ixc.proxyvote.v1.ProxyTask', 'ixc.ragl.v1.ManualEntry', 'ixc.ragl.v1.Transaction', 'ixc.registration.v1.Account', 'ixc.registration.v1.Principal', 'ixc.registration.v1.Profile', 'ixc.registration.v1.ProfileVersion', 'ixc.sweeps.clearing.v1.SweepOrder', 'ixc.sweeps.clearing.v1.SweepParticipant', 'ixc.sweeps.clearing.v1.SweepParticipantStats', 'ixc.sweeps.clearing.v1.SweepsJob', 'ixc.sweeps.clearing.v1.SweepsTask', 'ixc.sweeps.clearing.v1.SweepTargetStats', 'ixc.sweeps.v1.SweepPlan', 'ixc.sweeps.v1.SweepTarget', 'ixc.trade.v1.Trade', 'ixc.tradereporting.v1.BlueSheet', 'ixc.tradereporting.v1.CaisReport', 'ixc.tradereporting.v1.CatReport', 'ixc.tradereporting.v1.Sec_606AReport', 'ixc.trf.v1.TrfReport', 'ixc.trf.v1.TrfSession', 'ixf.accounting.v1.Account', 'ixf.accounting.v1.Config', 'ixf.accounting.v1.ManualEntry', 'ixf.accounting.v1.Transaction', 'ixf.documents.v1.Document', 'ixf.hours.v1.Exception', 'ixf.hours.v1.MoneyMarketSchedule', 'ixf.hours.v1.MoneyMarketScheduleVersion', 'ixf.hours.v1.TradingSchedule', 'ixf.hours.v1.TradingScheduleVersion', 'ixf.hours.v1.TransfersSchedule', 'ixf.hours.v1.TransfersScheduleVersion', 'ixf.reports.v1.Report', 'ixf.watchlist.v1.Fincen_314Entry', 'ixf.watchlist.v1.Fincen_314File', 'ixf.watchlist.v1.Fincen_314Match', 'ixf.watchlist.v1.OfacFile', 'ixf.watchlist.v1.OfacMatch', 'ixf.watchlist.v1.OfacSdn', 'ixm.agentauth.v1.AgentKey', 'ixm.auth.v1.ApiKey', 'ixm.events.v1.Target', 'ixm.trigger.v1.Trigger', 'ixm.userauth.v1.AccessRequest', 'ixm.userauth.v1.Artifact', 'ixm.userauth.v1.BrandingVersion', 'ixm.userauth.v1.OrganizationMemberInvitation', 'ixm.userauth.v1.OrganizationMember', 'ixm.userauth.v1.Organization', 'ixm.userauth.v1.Program', 'ixm.userauth.v1.RealmAccess', 'ixm.userauth.v1.Realm', 'ixm.userauth.v1.Role', 'ixm.userauth.v1.Tenant', 'ixm.userauth.v1.UserSession', 'ixm.userauth.v1.User', 'ixt.builds.v1.Repo', 'ixt.e2e.v1.TestRun', 'j5.registry.v1.Artifact', 'o5.aws.deployer.v1.Cluster', 'o5.aws.deployer.v1.Deployment', 'o5.aws.deployer.v1.Environment', 'o5.aws.deployer.v1.Stack', 'o5.dante.v1.DeadMessage'] as const;

export type ApiEntity = (typeof ApiEntityValues)[number];

